import "./app-frontend.5e6cff43.js";
import "./app.c6c153ad.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fD6Fb", function(module, exports) {
"use strict";
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
/**
 * Colors.
 */ exports.colors = [
    '#0000CC',
    '#0000FF',
    '#0033CC',
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3300CC',
    '#3300FF',
    '#3333CC',
    '#3333FF',
    '#3366CC',
    '#3366FF',
    '#3399CC',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) return true;
     // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
     // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if (match === '%%') return;
        index++;
        if (match === '%c') // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    var _console;
    // This hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem('debug', namespaces);
        else exports.storage.removeItem('debug');
    } catch (error) {
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.getItem('debug');
    } catch (error) {} // Swallow
    // XXX (@Qix-) should we be logging these?
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    r;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("bu3u4"))(exports);
var formatters = module.exports.formatters;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return '[UnexpectedJSONParseError]: ' + error.message;
    }
};

});
parcelRegister("bu3u4", function(module, exports) {
"use strict";

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ function $85c532ecf7e26574$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("3pRq5"));
    Object.keys(env).forEach(function(key) {
        createDebug[key] = env[key];
    });
    /**
  * Active `debug` instances.
  */ createDebug.instances = [];
    /**
  * The currently active debug mode names, and names to skip.
  */ createDebug.names = [];
    createDebug.skips = [];
    /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */ createDebug.formatters = {};
    /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */ function selectColor(namespace) {
        var hash = 0;
        for(var i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */ function createDebug(namespace) {
        var prevTime;
        function debug() {
            // Disabled?
            if (!debug.enabled) return;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var self = debug; // Set `diff` timestamp
            var curr = Number(new Date());
            var ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== 'string') // Anything else let's inspect with %O
            args.unshift('%O');
             // Apply any `formatters` transformations
            var index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
                // If we encounter an escaped % then don't increase the array index
                if (match === '%%') return match;
                index++;
                var formatter = createDebug.formatters[format];
                if (typeof formatter === 'function') {
                    var val = args[index];
                    match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            }); // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            var logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.enabled = createDebug.enabled(namespace);
        debug.useColors = createDebug.useColors();
        debug.color = selectColor(namespace);
        debug.destroy = destroy;
        debug.extend = extend; // Debug.formatArgs = formatArgs;
        // debug.rawLog = rawLog;
        // env-specific initialization logic for debug instances
        if (typeof createDebug.init === 'function') createDebug.init(debug);
        createDebug.instances.push(debug);
        return debug;
    }
    function destroy() {
        var index = createDebug.instances.indexOf(this);
        if (index !== -1) {
            createDebug.instances.splice(index, 1);
            return true;
        }
        return false;
    }
    function extend(namespace, delimiter) {
        return createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
    }
    /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.names = [];
        createDebug.skips = [];
        var i;
        var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
        var len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, '.*?');
            if (namespaces[0] === '-') createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
            else createDebug.names.push(new RegExp('^' + namespaces + '$'));
        }
        for(i = 0; i < createDebug.instances.length; i++){
            var instance = createDebug.instances[i];
            instance.enabled = createDebug.enabled(instance.namespace);
        }
    }
    /**
  * Disable debug output.
  *
  * @api public
  */ function disable() {
        createDebug.enable('');
    }
    /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */ function enabled(name) {
        if (name[name.length - 1] === '*') return true;
        var i;
        var len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $85c532ecf7e26574$var$setup;

});


parcelRegister("loTax", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $f946a244e03c8374$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $f946a244e03c8374$var$DefaultVideoStreamIdSet_1 = $f946a244e03c8374$var$__importDefault((parcelRequire("gVZQM")));
/**
 * [[AllHighestVideoBandwidthPolicy]] implements is a rudimentary policy that simply
 * always subscribes to the highest quality video stream available
 * for all non-self participants.
 */ class $f946a244e03c8374$var$AllHighestVideoBandwidthPolicy {
    constructor(selfAttendeeId){
        this.selfAttendeeId = selfAttendeeId;
        this.reset();
    }
    reset() {
        this.optimalReceiveSet = new $f946a244e03c8374$var$DefaultVideoStreamIdSet_1.default();
        this.subscribedReceiveSet = new $f946a244e03c8374$var$DefaultVideoStreamIdSet_1.default();
        this.videoSources = undefined;
    }
    updateIndex(videoIndex) {
        this.videoIndex = videoIndex;
        this.optimalReceiveSet = this.calculateOptimalReceiveSet(videoIndex);
    }
    updateMetrics(_clientMetricReport) {}
    wantsResubscribe() {
        return !this.subscribedReceiveSet.equal(this.optimalReceiveSet);
    }
    chooseSubscriptions() {
        this.subscribedReceiveSet = this.optimalReceiveSet.clone();
        return this.subscribedReceiveSet.clone();
    }
    chooseRemoteVideoSources(videoSources) {
        this.videoSources = videoSources;
        this.optimalReceiveSet = this.calculateOptimalReceiveSet(this.videoIndex).clone();
    }
    calculateOptimalReceiveSet(videoIndex) {
        const streamSelectionSet = new $f946a244e03c8374$var$DefaultVideoStreamIdSet_1.default();
        if (!this.videoIndex || this.videoIndex.allStreams().empty()) return streamSelectionSet;
        const receiveSet = videoIndex.highestQualityStreamFromEachGroupExcludingSelf(this.selfAttendeeId);
        // If video sources are not chosen, then use all of them.
        const videoSources = this.videoSources ? this.videoSources : this.videoIndex.allVideoSendingSourcesExcludingSelf(this.selfAttendeeId);
        // Get the list of all the remote stream information
        const remoteInfos = this.videoIndex.remoteStreamDescriptions();
        const mapOfAttendeeIdToRemoteDescriptions = new Map();
        for (const info of remoteInfos)if (receiveSet.contain(info.streamId)) mapOfAttendeeIdToRemoteDescriptions.set(info.attendeeId, info);
        let totalBitrateKbps = 0;
        for (const videoSource of videoSources){
            const attendeeId = videoSource.attendee.attendeeId;
            if (mapOfAttendeeIdToRemoteDescriptions.has(attendeeId)) {
                const info = mapOfAttendeeIdToRemoteDescriptions.get(attendeeId);
                if (totalBitrateKbps + info.maxBitrateKbps <= $f946a244e03c8374$var$AllHighestVideoBandwidthPolicy.maxReceiveBitrateKbps) {
                    streamSelectionSet.add(info.streamId);
                    totalBitrateKbps += info.maxBitrateKbps;
                } else {
                    console.warn('total bitrate ' + (totalBitrateKbps + info.maxBitrateKbps) + ' exceeds maximum limit (15000). Use chooseRemoteVideoSources to select a subset of participants to avoid this.');
                    break;
                }
            }
        }
        return streamSelectionSet;
    }
}
// Cap total receive bitrate at 15000 kbps to avoid hitting per client connection limits
$f946a244e03c8374$var$AllHighestVideoBandwidthPolicy.maxReceiveBitrateKbps = 15000;
module.exports.default = $f946a244e03c8374$var$AllHighestVideoBandwidthPolicy;

});
parcelRegister("gVZQM", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[DefaultVideoStreamIdSet]] implements [[VideoStreamIdSet]].
 */ class $c541f268d47a90d3$var$DefaultVideoStreamIdSet {
    constructor(ids){
        this.ids = new Set(ids);
    }
    add(streamId) {
        this.ids.add(streamId);
    }
    array() {
        const values = Array.from(this.ids.values());
        return values.sort((a, b)=>a - b);
    }
    contain(streamId) {
        return this.ids.has(streamId);
    }
    forEach(callbackFn) {
        this.ids.forEach(callbackFn);
    }
    empty() {
        return this.ids.size === 0;
    }
    size() {
        return this.ids.size;
    }
    equal(other) {
        if (!other) return this.ids.size === 0;
        const x = this.array();
        const y = other.array();
        if (x.length !== y.length) return false;
        for(let i = 0; i < x.length; i++){
            if (x[i] !== y[i]) return false;
        }
        return true;
    }
    clone() {
        return new $c541f268d47a90d3$var$DefaultVideoStreamIdSet(this.array());
    }
    remove(streamId) {
        this.ids.delete(streamId);
    }
    toJSON() {
        return this.array();
    }
    truncate(length) {
        const x = this.array();
        return new $c541f268d47a90d3$var$DefaultVideoStreamIdSet(x.splice(0, length));
    }
}
module.exports.default = $c541f268d47a90d3$var$DefaultVideoStreamIdSet;

});


parcelRegister("izoj0", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 *
 * [[ApplicationMetadata]] contains application metadata such as application name and version.
 * Amazon Chime SDK for JavaScript allows builders to provide application metadata in
 * the meeting session configuration. This field is optional. Amazon Chime uses application metadata to
 * analyze meeting health trends or identify common failures to improve your meeting experience.
 *
 * Do not pass any Personal Identifiable Information (PII).
 *
 * ```js
 * import { MeetingSessionConfiguration, ApplicationMetadata } from 'amazon-chime-sdk-js';
 *
 * const createMeetingResponse = // CreateMeeting API response.
 * const createAttendeeResponse = // CreateAttendee API response.
 * const meetingSessionConfiguration = new MeetingSessionConfiguration(
 *  createMeetingResponse,
 *  createAttendeeResponse
 * );
 *
 * meetingSessionConfiguration.applicationMetadata = ApplicationMetadata.create({
 *  appName: 'AppName',
 *  appVersion: '1.0.0'
 * });
 *
 * ```
 */ class $d84e59790a5b79c5$var$ApplicationMetadata {
    constructor(appName, appVersion){
        this.appName = appName;
        this.appVersion = appVersion;
    }
    /**
     *
     * @param appName Builder's application name.
     * The app name must satisfy following regular expression:
     * `/^[a-zA-Z0-9]+[a-zA-Z0-9_-]*[a-zA-Z0-9]+$/g`
     *
     * @param appVersion Builder's application version.
     * The app version must follow the [Semantic Versioning](https://semver.org/) format.
     *
     * @returns [[ApplicationMetadata]]
     */ static create(appName, appVersion) {
        const APP_NAME_REGEX = /^[a-zA-Z0-9]+[a-zA-Z0-9_-]*[a-zA-Z0-9]+$/g;
        if (!appName || appName.length > 32) throw new Error(`appName should be a valid string and 1 to 32 characters in length`);
        if (!APP_NAME_REGEX.test(appName)) throw new Error(`appName must satisfy ${APP_NAME_REGEX} regular expression`);
        const APP_VERSION_REGEX = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/gm;
        if (!appVersion || appVersion.length > 32) throw new Error(`appVersion should be a valid string and 1 to 32 characters in length`);
        if (!APP_VERSION_REGEX.test(appVersion)) throw new Error(`appVersion must satisfy Semantic Versioning format`);
        return new $d84e59790a5b79c5$var$ApplicationMetadata(appName, appVersion);
    }
}
module.exports.default = $d84e59790a5b79c5$var$ApplicationMetadata;

});

parcelRegister("4mLYP", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $32de6f5a25a576e8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $32de6f5a25a576e8$var$TimeoutScheduler_1 = $32de6f5a25a576e8$var$__importDefault((parcelRequire("gcRqk")));
/**
 * [[AsyncScheduler]] enqueues the callback for the soonest available run of the
 * event loop.
 */ class $32de6f5a25a576e8$var$AsyncScheduler extends $32de6f5a25a576e8$var$TimeoutScheduler_1.default {
    constructor(){
        super(0);
    }
    /**
     * Execute the provided callback on the next tick of the event loop.
     * This is semantically equivalent to
     *
     * ```typescript
     * new AsyncScheduler(callback).start();
     * ```
     *
     * but with less overhead.
     *
     * @param callback the code to run.
     */ static nextTick(callback) {
        setTimeout(callback, 0);
    }
}
module.exports.default = $32de6f5a25a576e8$var$AsyncScheduler;

});
parcelRegister("gcRqk", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[TimeoutScheduler]] calls the callback once after timeoutMs milliseconds.
 */ class $bcc735265b8a1665$var$TimeoutScheduler {
    constructor(timeoutMs){
        this.timeoutMs = timeoutMs;
        // eslint-disable-next-line
        this.timer = null;
    }
    start(callback) {
        this.stop();
        this.timer = setTimeout(()=>{
            clearTimeout(this.timer);
            callback();
        }, this.timeoutMs);
    }
    stop() {
        if (this.timer !== null) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }
}
module.exports.default = $bcc735265b8a1665$var$TimeoutScheduler;

});


parcelRegister("4u2O2", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $343c23fa752f2533$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $343c23fa752f2533$var$VideoLogEvent_1 = $343c23fa752f2533$var$__importDefault((parcelRequire("7Ydw6")));

const $343c23fa752f2533$var$BaseTask_1 = $343c23fa752f2533$var$__importDefault((parcelRequire("9wPDz")));
/*
 * [[AttachMediaInputTask]] adds audio and video input to peer connection.
 */ class $343c23fa752f2533$var$AttachMediaInputTask extends $343c23fa752f2533$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'AttachMediaInputTask';
    }
    async run() {
        const transceiverController = this.context.transceiverController;
        transceiverController.setPeer(this.context.peer);
        transceiverController.setupLocalTransceivers();
        const audioInput = this.context.activeAudioInput;
        if (audioInput) {
            const audioTracks = audioInput.getAudioTracks();
            this.context.logger.info('attaching audio track to peer connection');
            await transceiverController.setAudioInput(audioTracks.length ? audioTracks[0] : null);
        } else {
            await transceiverController.setAudioInput(null);
            this.context.logger.info('no audio track');
        }
        this.setAudioCodecPreferences();
        const videoInput = this.context.activeVideoInput;
        if (videoInput) {
            const videoTracks = videoInput.getVideoTracks();
            const videoTrack = videoTracks.length ? videoTracks[0] : null;
            this.context.logger.info('attaching video track to peer connection');
            await transceiverController.setVideoInput(videoTrack);
            if (this.context.enableSimulcast && this.context.videoUplinkBandwidthPolicy) {
                const encodingParam = this.context.videoUplinkBandwidthPolicy.chooseEncodingParameters();
                transceiverController.setEncodingParameters(encodingParam);
            }
            if (videoTrack) this.context.statsCollector.logVideoEvent($343c23fa752f2533$var$VideoLogEvent_1.default.InputAttached, this.context.videoDeviceInformation);
        } else {
            await transceiverController.setVideoInput(null);
            this.context.logger.info('no video track');
        }
        this.context.videoSubscriptions = transceiverController.updateVideoTransceivers(this.context.videoStreamIndex, this.context.videosToReceive);
        // This will cache the current index so that we maintain the values over the course of the subscribe.
        this.context.videoStreamIndex.subscribeFrameSent();
    }
    setAudioCodecPreferences() {
        const supportsSetCodecPreferences = window.RTCRtpTransceiver && 'setCodecPreferences' in window.RTCRtpTransceiver.prototype;
        /* istanbul ignore if */ if (!supportsSetCodecPreferences) {
            this.context.logger.warn(`Setting codec preferences not supported`);
            return;
        }
        const audioTransceiver = this.context.transceiverController.localAudioTransceiver();
        const { codecs: codecs } = RTCRtpSender.getCapabilities('audio');
        this.context.logger.debug(`Available audio codecs ${JSON.stringify(codecs, null, 4)}`);
        const redCodecIndex = codecs.findIndex((c)=>c.mimeType === 'audio/red');
        /* istanbul ignore if */ if (!audioTransceiver) {
            this.context.logger.error(`audio transceiver is null`);
            return;
        }
        if (redCodecIndex >= 0) {
            const redCodec = codecs[redCodecIndex];
            codecs.splice(redCodecIndex, 1);
            if (this.context.enableAudioRedundancy()) {
                // Add to the beginning of the codec list to
                // signify that this is the preferred codec.
                // Media backend enables RED only if the preference
                // for RED is highest.
                codecs.unshift(redCodec);
                this.context.logger.info('audio/red set as preferred codec');
            } else this.context.logger.info('audio/red removed from preferred codec');
            audioTransceiver.setCodecPreferences(codecs);
            return;
        }
        this.context.logger.info('audio/red codec not supported');
    }
}
module.exports.default = $343c23fa752f2533$var$AttachMediaInputTask;

});
parcelRegister("7Ydw6", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VideoLogEvent = void 0;
var $5cd89f26c790be26$var$VideoLogEvent;
(function(VideoLogEvent) {
    VideoLogEvent[VideoLogEvent["InputAttached"] = 0] = "InputAttached";
    VideoLogEvent[VideoLogEvent["SendingFailed"] = 1] = "SendingFailed";
    VideoLogEvent[VideoLogEvent["SendingSuccess"] = 2] = "SendingSuccess";
})($5cd89f26c790be26$var$VideoLogEvent || (module.exports.VideoLogEvent = $5cd89f26c790be26$var$VideoLogEvent = {}));
module.exports.default = $5cd89f26c790be26$var$VideoLogEvent;

});

parcelRegister("9wPDz", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $6eff284c49488835$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $6eff284c49488835$var$OnceTask_1 = $6eff284c49488835$var$__importDefault((parcelRequire("57JcA")));

const $6eff284c49488835$var$TaskStatus_1 = $6eff284c49488835$var$__importDefault((parcelRequire("8wEjJ")));
/*
 * [[BaseTask]] provides common utilities for task implementations.
 */ class $6eff284c49488835$var$BaseTask {
    constructor(logger){
        this.logger = logger;
        this.taskName = 'BaseTask';
        this.parentTask = null;
        this.status = $6eff284c49488835$var$TaskStatus_1.default.IDLE;
        this.run = this.baseRun.bind(this, this.run);
        this.cancel = this.baseCancel.bind(this, this.cancel);
    }
    once(...dependencies) {
        return new $6eff284c49488835$var$OnceTask_1.default(this.logger, this, dependencies);
    }
    cancel() {}
    name() {
        return this.parentTask ? `${this.parentTask.name()}/${this.taskName}` : this.taskName;
    }
    setParent(parentTask) {
        this.parentTask = parentTask;
    }
    getStatus() {
        return this.status;
    }
    logAndThrow(message) {
        this.logger.info(message);
        throw new Error(message);
    }
    async baseRun(originalRun) {
        try {
            const startTime = Date.now();
            this.logger.info(`running task ${this.name()}`);
            switch(this.status){
                case $6eff284c49488835$var$TaskStatus_1.default.RUNNING:
                    this.logAndThrow(`${this.name()} is already running`);
                case $6eff284c49488835$var$TaskStatus_1.default.CANCELED:
                    this.logAndThrow(`${this.name()} was canceled before running`);
                case $6eff284c49488835$var$TaskStatus_1.default.FINISHED:
                    this.logAndThrow(`${this.name()} was already finished`);
            }
            this.status = $6eff284c49488835$var$TaskStatus_1.default.RUNNING;
            await originalRun.call(this);
            this.logger.info(`${this.name()} took ${Math.round(Date.now() - startTime)} ms`);
        } catch (err) {
            throw err;
        } finally{
            if (this.status !== $6eff284c49488835$var$TaskStatus_1.default.CANCELED) this.status = $6eff284c49488835$var$TaskStatus_1.default.FINISHED;
        }
    }
    baseCancel(originalCancel) {
        if (this.status === $6eff284c49488835$var$TaskStatus_1.default.CANCELED || this.status === $6eff284c49488835$var$TaskStatus_1.default.FINISHED) {
            this.logger.info(`Not canceling ${this.name()}: state is ${this.status}`);
            return;
        }
        this.logger.info(`canceling task ${this.name()}`);
        this.status = $6eff284c49488835$var$TaskStatus_1.default.CANCELED;
        originalCancel.call(this);
    }
}
module.exports.default = $6eff284c49488835$var$BaseTask;

});
parcelRegister("57JcA", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $3bb0ab5dbbad4eec$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $3bb0ab5dbbad4eec$var$LogLevel_1 = $3bb0ab5dbbad4eec$var$__importDefault((parcelRequire("aSYjG")));

const $3bb0ab5dbbad4eec$var$AsyncScheduler_1 = $3bb0ab5dbbad4eec$var$__importDefault((parcelRequire("4mLYP")));
/**
 * A task that wraps another task and ensures it is run only once,
 * regardless of how many times `run` is called.
 *
 * This allows you to implement a kind of barrier synchronization.
 */ class $3bb0ab5dbbad4eec$var$OnceTask {
    constructor(logger, task, dependencies){
        this.logger = logger;
        this.task = task;
        this.dependencies = dependencies;
        // Whether we have canceled.
        this.canceled = false;
    }
    name() {
        return `${this.task.name()} (once)`;
    }
    cancel() {
        // We want to preserve one interesting property: the deepest dependency that hasn't
        // already finished or been canceled is the first to be canceled, and its failure
        // will propagate back up the promise chain.
        //
        // We can't just cancel ourselves with cancelPromise -- we will cut off the rest of
        // the tree. Nor can we necessarily do it on the same event loop tick, because the
        // cancelation might be subtly async.
        //
        // Instead, we immediately cancel each dependency, and then we cancel the current
        // task (if it's running), and then we cancel via our promise escape hatch if needed.
        /* istanbul ignore if */ if (this.canceled) return;
        if (this.dependencies) for (const dep of this.dependencies)dep.cancel();
        // Do this on the next tick so that our canceled dependencies cascade.
        this.logger.info(`Canceling ${this.name()}`);
        $3bb0ab5dbbad4eec$var$AsyncScheduler_1.default.nextTick(()=>this.task.cancel());
        this.canceled = true;
        if (this.cancelPromise) $3bb0ab5dbbad4eec$var$AsyncScheduler_1.default.nextTick(()=>this.cancelPromise(new Error(`canceling ${this.name()}`)));
    }
    logDependencies() {
        if (this.logger.getLogLevel() > $3bb0ab5dbbad4eec$var$LogLevel_1.default.INFO) return;
        if (!this.dependencies) return;
        const names = this.dependencies.filter((d)=>d).map((d)=>d.name()).join(', ');
        this.logger.info(`${this.task.name()} waiting for dependencies: ${names}`);
    }
    run() {
        if (this.promise) return this.promise;
        const dependencies = this.dependencies ? Promise.all(this.dependencies.map((d)=>d === null || d === void 0 ? void 0 : d.run())) : Promise.resolve();
        this.logDependencies();
        this.ongoing = dependencies.then(()=>this.task.run());
        return this.promise = new Promise((resolve, reject)=>{
            this.cancelPromise = reject;
            this.ongoing.then(resolve).catch(reject);
        });
    }
    setParent(parentTask) {
        this.task.setParent(parentTask);
    }
}
module.exports.default = $3bb0ab5dbbad4eec$var$OnceTask;

});
parcelRegister("aSYjG", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogLevel = void 0;
var $7ecdbc226508bd46$var$LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
    LogLevel[LogLevel["OFF"] = 4] = "OFF";
})($7ecdbc226508bd46$var$LogLevel || (module.exports.LogLevel = $7ecdbc226508bd46$var$LogLevel = {}));
module.exports.default = $7ecdbc226508bd46$var$LogLevel;

});


parcelRegister("8wEjJ", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6350961292ef605d$var$TaskStatus;
(function(TaskStatus) {
    TaskStatus["IDLE"] = "IDLE";
    TaskStatus["RUNNING"] = "RUNNING";
    TaskStatus["CANCELED"] = "CANCELED";
    TaskStatus["FINISHED"] = "FINISHED";
})($6350961292ef605d$var$TaskStatus || ($6350961292ef605d$var$TaskStatus = {}));
module.exports.default = $6350961292ef605d$var$TaskStatus;

});



parcelRegister("brRyw", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[Attendee]] contains the information of an attendee.
 */ class $855bc26a5a18f17d$var$Attendee {
}
module.exports.default = $855bc26a5a18f17d$var$Attendee;

});

parcelRegister("2R7XG", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioLogEvent = void 0;
var $2146b501e6e5b314$var$AudioLogEvent;
(function(AudioLogEvent) {
    AudioLogEvent[AudioLogEvent["DeviceChanged"] = 0] = "DeviceChanged";
    AudioLogEvent[AudioLogEvent["MutedLocal"] = 1] = "MutedLocal";
    AudioLogEvent[AudioLogEvent["UnmutedLocal"] = 2] = "UnmutedLocal";
    AudioLogEvent[AudioLogEvent["Connected"] = 3] = "Connected";
    AudioLogEvent[AudioLogEvent["ConnectFailed"] = 4] = "ConnectFailed";
    AudioLogEvent[AudioLogEvent["RedmicStartLoss"] = 5] = "RedmicStartLoss";
    AudioLogEvent[AudioLogEvent["RedmicEndLoss"] = 6] = "RedmicEndLoss";
})($2146b501e6e5b314$var$AudioLogEvent || (module.exports.AudioLogEvent = $2146b501e6e5b314$var$AudioLogEvent = {}));
module.exports.default = $2146b501e6e5b314$var$AudioLogEvent;

});

parcelRegister("as61y", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $79c1312d8b7e59e1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $79c1312d8b7e59e1$var$DefaultBrowserBehavior_1 = $79c1312d8b7e59e1$var$__importDefault((parcelRequire("e2TuV")));
/**
 * AudioProfile defines settings for audio quality.
 */ class $79c1312d8b7e59e1$var$AudioProfile {
    /**
     * Constructs an AudioProfile. If no audio bitrate is supplied then the AudioProfile
     * does not adjust the browser's internal bitrate setting. If the enableAudioRedundancy
     * flag is not supplied then the AudioProfile enables it by default.
     */ constructor(audioBitrateBps = null, enableAudioRedundancy = true){
        this.audioBitrateBps = audioBitrateBps;
        this.enableAudioRedundancy = new $79c1312d8b7e59e1$var$DefaultBrowserBehavior_1.default().supportsAudioRedundancy() && enableAudioRedundancy;
    }
    /**
     * Creates an AudioProfile optimized for fullband speech (40 kbit/s mono).
     */ static fullbandSpeechMono(enableAudioRedundancy = true) {
        return new $79c1312d8b7e59e1$var$AudioProfile(40000, enableAudioRedundancy);
    }
    /**
     * Creates an AudioProfile optimized for fullband music (64 kbit/s mono).
     */ static fullbandMusicMono(enableAudioRedundancy = true) {
        return new $79c1312d8b7e59e1$var$AudioProfile(64000, enableAudioRedundancy);
    }
    /**
     * Creates an AudioProfile optimized for fullband stereo music (128 kbit/s stereo).
     */ static fullbandMusicStereo(enableAudioRedundancy = true) {
        return new $79c1312d8b7e59e1$var$AudioProfile(128000, enableAudioRedundancy);
    }
    /**
     * Returns true if audio profile is set to stereo mode.
     */ isStereo() {
        return this.audioBitrateBps === 128000;
    }
    /**
     * Returns true if redundancy is supported and enabled.
     */ hasRedundancyEnabled() {
        return this.enableAudioRedundancy;
    }
}
module.exports.default = $79c1312d8b7e59e1$var$AudioProfile;

});
parcelRegister("e2TuV", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $a39c4d468d443a5f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6enPC = parcelRequire("6enPC");

const $a39c4d468d443a5f$var$NoOpLogger_1 = $a39c4d468d443a5f$var$__importDefault((parcelRequire("a39G0")));

const $a39c4d468d443a5f$var$DefaultUserAgentParser_1 = $a39c4d468d443a5f$var$__importDefault((parcelRequire("lV7ga")));

var $1fVgb = parcelRequire("1fVgb");
class $a39c4d468d443a5f$var$DefaultBrowserBehavior {
    constructor(userAgentParser){
        this.FALLBACK_BROWSER = {
            type: 'browser',
            name: 'unknown',
            version: 'unknown',
            os: 'unknown'
        };
        this.browser = (0, $6enPC.detect)() || this.FALLBACK_BROWSER;
        this.browserSupport = {
            chrome: 78,
            'edge-chromium': 79,
            electron: 7,
            firefox: 75,
            ios: 13,
            safari: 13,
            opera: 66,
            samsung: 12,
            crios: 86,
            fxios: 23,
            'ios-webview': 605,
            'chromium-webview': 92
        };
        this.browserName = {
            chrome: 'Google Chrome',
            'edge-chromium': 'Microsoft Edge',
            electron: 'Electron',
            firefox: 'Mozilla Firefox',
            ios: 'Safari iOS',
            safari: 'Safari',
            opera: 'Opera',
            samsung: 'Samsung Internet',
            crios: 'Chrome iOS',
            fxios: 'Firefox iOS',
            'ios-webview': 'WKWebView iOS',
            'chromium-webview': 'Chrome WebView'
        };
        this.chromeLike = [
            'chrome',
            'edge-chromium',
            'chromium-webview',
            'opera',
            'samsung'
        ];
        this.webkitBrowsers = [
            'crios',
            'fxios',
            'safari',
            'ios',
            'ios-webview',
            'edge-ios'
        ];
        this.userAgentParser = userAgentParser !== null && userAgentParser !== void 0 ? userAgentParser : new $a39c4d468d443a5f$var$DefaultUserAgentParser_1.default(new $a39c4d468d443a5f$var$NoOpLogger_1.default());
    }
    version() {
        const ver = this.userAgentParser.getParserResult().browserVersion;
        return ver === $1fVgb.USER_AGENT_PARSER_UNAVAILABLE ? '' : ver;
    }
    majorVersion() {
        return parseInt(this.userAgentParser.getParserResult().browserMajorVersion);
    }
    osMajorVersion() {
        return parseInt(this.osVersion().split('.')[0]);
    }
    deviceName() {
        const name = this.userAgentParser.getParserResult().deviceName;
        return name === $1fVgb.USER_AGENT_PARSER_UNAVAILABLE ? '' : name;
    }
    osName() {
        const name = this.userAgentParser.getParserResult().osName;
        return name === $1fVgb.USER_AGENT_PARSER_UNAVAILABLE ? '' : name;
    }
    osVersion() {
        const ver = this.userAgentParser.getParserResult().osVersion;
        return ver === $1fVgb.USER_AGENT_PARSER_UNAVAILABLE ? '' : ver;
    }
    engine() {
        var _a;
        return (_a = this.userAgentParser.getParserResult().engineName) !== null && _a !== void 0 ? _a : '';
    }
    engineMajorVersion() {
        var _a;
        return parseInt((_a = this.userAgentParser.getParserResult().engineMajorVersion) !== null && _a !== void 0 ? _a : '0');
    }
    name() {
        return this.browser.name;
    }
    hasChromiumWebRTC() {
        for (const browser of this.chromeLike){
            if (browser === this.browser.name) return true;
        }
        return false;
    }
    hasWebKitWebRTC() {
        for (const browser of this.webkitBrowsers){
            if (browser === this.browser.name) return true;
        }
        return false;
    }
    hasFirefoxWebRTC() {
        return this.isFirefox();
    }
    requiresPlaybackLatencyHintForAudioContext() {
        return navigator.userAgent.indexOf('Windows') !== -1;
    }
    supportsCanvasCapturedStreamPlayback() {
        return(// Desktop browser
        !this.isIOSSafari() && !this.isIOSChrome() && !this.isIOSFirefox() && !this.isIOSEdge() || // iOS Safari (Firefox on iOS with desktop view will be identified as iOS Safari
        this.isIOSSafari() && this.majorVersion() >= $a39c4d468d443a5f$var$DefaultBrowserBehavior.MIN_IOS_SUPPORT_CANVAS_STREAM_PLAYBACK || // Chrome, Edge, or Firefox (mobile view) on iOS
        this.majorVersion() >= $a39c4d468d443a5f$var$DefaultBrowserBehavior.MIN_IOS_NON_SAFARI_SUPPORT_CANVAS_STREAM_PLAYBACK);
    }
    supportsBackgroundFilter() {
        // disable Safari 15
        // see: https://github.com/aws/amazon-chime-sdk-js/issues/1059
        if (this.name() === 'safari' && this.majorVersion() === 15) return false;
        if (!this.supportsCanvasCapturedStreamPlayback()) return false;
        return true;
    }
    supportsVideoLayersAllocationRtpHeaderExtension() {
        return this.hasChromiumWebRTC();
    }
    supportsDependencyDescriptorRtpHeaderExtension() {
        return this.hasChromiumWebRTC();
    }
    supportsScalableVideoCoding() {
        return(// Currently `this.hasChromiumWebRTC() && this.engine() === 'Blink'` completely
        // overlaps but we keep both just in case that changes in the future.
        this.hasChromiumWebRTC() && this.engine() === 'Blink' && this.engineMajorVersion() >= 111);
    }
    supportsAudioRedundancy() {
        if (this.hasChromiumWebRTC()) // Audio redundancy may cause video decoding failure for Chromium version 106 and
        // earlier. Marking such Chromium versions as not supporting audio redundancy.
        return this.engineMajorVersion() >= 107;
        return !this.hasFirefoxWebRTC();
    }
    requiresResolutionAlignment(width, height) {
        if (this.isAndroid() && this.isPixel3()) return [
            Math.ceil(width / 64) * 64,
            Math.ceil(height / 64) * 64
        ];
        return [
            width,
            height
        ];
    }
    requiresCheckForSdpConnectionAttributes() {
        return !this.isIOSSafari() && !this.isIOSChrome() && !this.isIOSFirefox();
    }
    requiresIceCandidateGatheringTimeoutWorkaround() {
        return this.hasChromiumWebRTC();
    }
    requiresBundlePolicy() {
        return 'max-bundle';
    }
    requiresNoExactMediaStreamConstraints() {
        return this.isSamsungInternet();
    }
    requiresGroupIdMediaStreamConstraints() {
        return this.isSamsungInternet();
    }
    getDisplayMediaAudioCaptureSupport() {
        return this.isChrome() || this.isEdge();
    }
    // There's a issue in Chormium WebView that causes enumerate devices to return empty labels, this is a check for this issue.
    // https://bugs.chromium.org/p/chromium/issues/detail?id=669492
    doesNotSupportMediaDeviceLabels() {
        return this.browser.name === 'chromium-webview';
    }
    isSupported() {
        if (!this.browserSupport[this.browser.name] || this.majorVersion() < this.browserSupport[this.browser.name]) return false;
        if (this.browser.name === 'firefox' && this.isAndroid()) return false;
        return true;
    }
    isSimulcastSupported() {
        return this.hasChromiumWebRTC();
    }
    supportDownlinkBandwidthEstimation() {
        return !this.isFirefox();
    }
    supportString() {
        if (this.isAndroid()) return `${this.browserName['chrome']} ${this.browserSupport['chrome']}+, ${this.browserName['samsung']} ${this.browserSupport['samsung']}+`;
        const s = [];
        for(const k in this.browserSupport)s.push(`${this.browserName[k]} ${this.browserSupport[k]}+`);
        return s.join(', ');
    }
    async supportedVideoCodecs() {
        const pc = new RTCPeerConnection();
        pc.addTransceiver('video', {
            direction: 'inactive',
            streams: []
        });
        return (await pc.createOffer({
            offerToReceiveVideo: true
        })).sdp.split('\r\n').filter((x)=>{
            return x.includes('a=rtpmap:');
        }).map((x)=>{
            return x.replace(/.* /, '').replace(/\/.*/, '');
        }).filter((v, i, a)=>{
            return a.indexOf(v) === i;
        }).filter((x)=>{
            return x !== 'rtx' && x !== 'red' && x !== 'ulpfec';
        });
    }
    supportsSetSinkId() {
        return 'setSinkId' in HTMLAudioElement.prototype;
    }
    disableResolutionScaleDown() {
        return this.isAndroid();
    }
    disable480pResolutionScaleDown() {
        return /( Chrome\/98\.)/i.test(navigator.userAgent) && this.browser.os.startsWith('Windows');
    }
    requiresDisablingH264Encoding() {
        return this.isIOS() && (this.version() === '15.1.0' || this.version() === '15.1' || /( OS 15_1)/i.test(navigator.userAgent));
    }
    // In Safari, a hidden video element can show a black screen.
    // See https://bugs.webkit.org/show_bug.cgi?id=241152 for more information.
    requiresVideoPlayWorkaround() {
        return this.isSafari();
    }
    requiresAudioContextResetOnDeviceFailureForWebAudio() {
        // In iOS Safari, when an audio media stream fails (i.e. in the case of being
        // unplugged), the audio context becomes broken, and e.g. stops transmitting
        // audio. This can be mitigated by suspending and resuming the context.
        //
        // The WebKit bug is https://bugs.webkit.org/show_bug.cgi?id=232640
        return this.isIOS();
    }
    /**
     * Check if the current browser supports the [[VideoFxProcessor]].
     * @returns boolean representing if browser supports [[VideoFxProcessor]].
     */ isVideoFxSupportedBrowser() {
        // Not supported on safari 15 and on environments without canvas capture playback
        return this.supportsBackgroundFilter();
    }
    async updateWithHighEntropyValues(alwaysOverride = false) {
        var _a, _b;
        await ((_b = (_a = this.userAgentParser).updateWithHighEntropyValues) === null || _b === void 0 ? void 0 : _b.call(_a, alwaysOverride));
    }
    // These helpers should be kept private to encourage
    // feature detection instead of browser detection.
    isIOSSafari() {
        return this.browser.name === 'ios' || this.browser.name === 'ios-webview' || this.browser.name === 'safari' && /( Mac )/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1 //Ipad
        ;
    }
    isSafari() {
        return this.browser.name === 'safari' || this.isIOSSafari();
    }
    isFirefox() {
        return this.browser.name === 'firefox';
    }
    isIOSFirefox() {
        return this.browser.name === 'fxios';
    }
    isIOSChrome() {
        return this.browser.name === 'crios';
    }
    isChrome() {
        return this.browser.name === 'chrome';
    }
    isEdge() {
        return this.browser.name === 'edge-chromium';
    }
    isIOSEdge() {
        return this.browser.name === 'edge-ios';
    }
    isSamsungInternet() {
        return this.browser.name === 'samsung';
    }
    isAndroid() {
        return /(android)/i.test(navigator.userAgent);
    }
    isPixel3() {
        return /( pixel 3)/i.test(navigator.userAgent);
    }
    isIOS() {
        // Is one of the supported iOS browsers
        return this.isIOSSafari() || this.isIOSChrome() || this.isIOSFirefox();
    }
}
$a39c4d468d443a5f$var$DefaultBrowserBehavior.MIN_IOS_SUPPORT_CANVAS_STREAM_PLAYBACK = 16;
$a39c4d468d443a5f$var$DefaultBrowserBehavior.MIN_IOS_NON_SAFARI_SUPPORT_CANVAS_STREAM_PLAYBACK = 106;
module.exports.default = $a39c4d468d443a5f$var$DefaultBrowserBehavior;

});
parcelRegister("6enPC", function(module, exports) {

$parcel$export(module.exports, "detect", () => $48968958eb8b72e8$export$17b446b869dad473);

var $hPtJY = parcelRequire("hPtJY");
var $48968958eb8b72e8$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $48968958eb8b72e8$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = 'browser';
    }
    return BrowserInfo;
}();
var $48968958eb8b72e8$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = 'node';
        this.name = 'node';
        this.os = $hPtJY.platform;
    }
    return NodeInfo;
}();
var $48968958eb8b72e8$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = 'bot-device';
    }
    return SearchBotDeviceInfo;
}();
var $48968958eb8b72e8$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = 'bot';
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $48968958eb8b72e8$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = 'react-native';
        this.name = 'react-native';
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS = 3;
var $48968958eb8b72e8$var$userAgentRules = [
    [
        'aol',
        /AOLShield\/([0-9\._]+)/
    ],
    [
        'edge',
        /Edge\/([0-9\._]+)/
    ],
    [
        'edge-ios',
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        'yandexbrowser',
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        'kakaotalk',
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        'samsung',
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        'silk',
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        'miui',
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        'beaker',
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        'edge-chromium',
        /EdgA?\/([0-9\.]+)/
    ],
    [
        'chromium-webview',
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'chrome',
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'phantomjs',
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'crios',
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'firefox',
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        'fxios',
        /FxiOS\/([0-9\.]+)/
    ],
    [
        'opera-mini',
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        'opera',
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        'opera',
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'pie',
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        'pie',
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        'netfront',
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        'ie',
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        'ie',
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        'ie',
        /MSIE\s(7\.0)/
    ],
    [
        'bb10',
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        'android',
        /Android\s([0-9\.]+)/
    ],
    [
        'ios',
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        'safari',
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        'facebook',
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        'instagram',
        /Instagram\s([0-9\.]+)/
    ],
    [
        'ios-webview',
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        'ios-webview',
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        'curl',
        /^curl\/([0-9\.]+)$/
    ],
    [
        'searchbot',
        $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX
    ]
];
var $48968958eb8b72e8$var$operatingSystemRules = [
    [
        'iOS',
        /iP(hone|od|ad)/
    ],
    [
        'Android OS',
        /Android/
    ],
    [
        'BlackBerry OS',
        /BlackBerry|BB10/
    ],
    [
        'Windows Mobile',
        /IEMobile/
    ],
    [
        'Amazon OS',
        /Kindle/
    ],
    [
        'Windows 3.11',
        /Win16/
    ],
    [
        'Windows 95',
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        'Windows 98',
        /(Windows 98)|(Win98)/
    ],
    [
        'Windows 2000',
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        'Windows XP',
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        'Windows Server 2003',
        /(Windows NT 5.2)/
    ],
    [
        'Windows Vista',
        /(Windows NT 6.0)/
    ],
    [
        'Windows 7',
        /(Windows NT 6.1)/
    ],
    [
        'Windows 8',
        /(Windows NT 6.2)/
    ],
    [
        'Windows 8.1',
        /(Windows NT 6.3)/
    ],
    [
        'Windows 10',
        /(Windows NT 10.0)/
    ],
    [
        'Windows ME',
        /Windows ME/
    ],
    [
        'Windows CE',
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        'Open BSD',
        /OpenBSD/
    ],
    [
        'Sun OS',
        /SunOS/
    ],
    [
        'Chrome OS',
        /CrOS/
    ],
    [
        'Linux',
        /(Linux)|(X11)/
    ],
    [
        'Mac OS',
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        'QNX',
        /QNX/
    ],
    [
        'BeOS',
        /BeOS/
    ],
    [
        'OS/2',
        /OS\/2/
    ]
];
function $48968958eb8b72e8$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $48968958eb8b72e8$export$1184956100eddc3c(userAgent);
    if (typeof document === 'undefined' && typeof navigator !== 'undefined' && navigator.product === 'ReactNative') return new $48968958eb8b72e8$export$7c78fe95a9d9b03e();
    if (typeof navigator !== 'undefined') return $48968958eb8b72e8$export$1184956100eddc3c(navigator.userAgent);
    return $48968958eb8b72e8$export$bf2c6630ab904918();
}
function $48968958eb8b72e8$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== '' && $48968958eb8b72e8$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $48968958eb8b72e8$export$89ca9f8ca1a50fd5(ua) {
    var data = $48968958eb8b72e8$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $48968958eb8b72e8$export$1184956100eddc3c(ua) {
    var matchedRule = $48968958eb8b72e8$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') return new $48968958eb8b72e8$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split('.').join('_').split('_').slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS) versionParts = $48968958eb8b72e8$var$__spreadArray($48968958eb8b72e8$var$__spreadArray([], versionParts, true), $48968958eb8b72e8$var$createVersionParts($48968958eb8b72e8$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join('.');
    var os = $48968958eb8b72e8$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $48968958eb8b72e8$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $48968958eb8b72e8$export$8fa985da04a86f0(name, version, os);
}
function $48968958eb8b72e8$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $48968958eb8b72e8$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $48968958eb8b72e8$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $48968958eb8b72e8$export$bf2c6630ab904918() {
    var isNode = false;
    return isNode ? new $48968958eb8b72e8$export$62457c674e0167c0($hPtJY.version.slice(1)) : null;
}
function $48968958eb8b72e8$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push('0');
    return output;
}

});

parcelRegister("a39G0", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $7511b0c5b8f1c9e5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $7511b0c5b8f1c9e5$var$LogLevel_1 = $7511b0c5b8f1c9e5$var$__importDefault((parcelRequire("aSYjG")));
/**
 * [[NoOpLogger]] does not log any message.
 */ class $7511b0c5b8f1c9e5$var$NoOpLogger {
    constructor(level = $7511b0c5b8f1c9e5$var$LogLevel_1.default.OFF){
        this.level = level;
    }
    info(_msg) {}
    warn(_msg) {}
    error(_msg) {}
    debug(debugFunction) {
        if ($7511b0c5b8f1c9e5$var$LogLevel_1.default.DEBUG < this.level) return;
        if (typeof debugFunction !== 'string') debugFunction();
    }
    setLogLevel(level) {
        this.level = level;
    }
    getLogLevel() {
        return this.level;
    }
}
module.exports.default = $7511b0c5b8f1c9e5$var$NoOpLogger;

});

parcelRegister("lV7ga", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $ff548d78e9bd3a61$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $86Wyx = parcelRequire("86Wyx");

const $ff548d78e9bd3a61$var$Versioning_1 = $ff548d78e9bd3a61$var$__importDefault((parcelRequire("c0dn0")));

var $1fVgb = parcelRequire("1fVgb");
/**
 * [[DefaultUserAgentParser]] uses UAParser to parse the browser's user agent.
 * It is responsible to hold and provide browser, OS and device specific information.
 */ class $ff548d78e9bd3a61$var$DefaultUserAgentParser {
    constructor(logger){
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.logger = logger;
        try {
            this.parserResult = navigator && navigator.userAgent ? new $86Wyx.UAParser(navigator.userAgent).getResult() : undefined;
        } catch (error) {
            /* istanbul ignore next */ logger.error(error.message);
        }
        this.browserMajorVersion = ((_c = (_b = (_a = this.parserResult) === null || _a === void 0 ? void 0 : _a.browser) === null || _b === void 0 ? void 0 : _b.version) === null || _c === void 0 ? void 0 : _c.split('.')[0]) || $1fVgb.USER_AGENT_PARSER_UNAVAILABLE;
        this.browserName = ((_d = this.parserResult) === null || _d === void 0 ? void 0 : _d.browser.name) || $1fVgb.USER_AGENT_PARSER_UNAVAILABLE;
        this.browserVersion = ((_e = this.parserResult) === null || _e === void 0 ? void 0 : _e.browser.version) || $1fVgb.USER_AGENT_PARSER_UNAVAILABLE;
        this.deviceName = [
            ((_f = this.parserResult) === null || _f === void 0 ? void 0 : _f.device.vendor) || '',
            ((_g = this.parserResult) === null || _g === void 0 ? void 0 : _g.device.model) || ''
        ].join(' ').trim() || $1fVgb.USER_AGENT_PARSER_UNAVAILABLE;
        this.osName = ((_h = this.parserResult) === null || _h === void 0 ? void 0 : _h.os.name) || $1fVgb.USER_AGENT_PARSER_UNAVAILABLE;
        this.osVersion = ((_j = this.parserResult) === null || _j === void 0 ? void 0 : _j.os.version) || $1fVgb.USER_AGENT_PARSER_UNAVAILABLE;
        this.engineName = ((_l = (_k = this.parserResult) === null || _k === void 0 ? void 0 : _k.engine) === null || _l === void 0 ? void 0 : _l.name) || '';
        this.engineMajorVersion = parseInt(((_p = (_o = (_m = this.parserResult) === null || _m === void 0 ? void 0 : _m.engine) === null || _o === void 0 ? void 0 : _o.version) === null || _p === void 0 ? void 0 : _p.split('.')[0]) || '0');
    }
    getParserResult() {
        return {
            browserMajorVersion: this.browserMajorVersion,
            browserName: this.browserName,
            browserVersion: this.browserVersion,
            deviceName: this.deviceName,
            osName: this.osName,
            osVersion: this.osVersion,
            sdkVersion: $ff548d78e9bd3a61$var$Versioning_1.default.sdkVersion,
            sdkName: $ff548d78e9bd3a61$var$Versioning_1.default.sdkName,
            engineName: this.engineName,
            engineMajorVersion: String(this.engineMajorVersion)
        };
    }
    getEngineName() {
        return this.engineName;
    }
    getEngineMajorVersion() {
        return this.engineMajorVersion;
    }
    async updateWithHighEntropyValues(alwaysOverride = false) {
        var _a, _b, _c, _d;
        /* istanbul ignore next */ // @ts-ignore - navigator.userAgentData is not yet in TypeScript's lib.dom.d.ts
        if (!((_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.getHighEntropyValues)) {
            (_b = this.logger) === null || _b === void 0 || _b.debug('User-Agent Client Hints API not available');
            return;
        }
        try {
            // @ts-ignore - navigator.userAgentData is not yet in TypeScript's lib.dom.d.ts
            const hints = await navigator.userAgentData.getHighEntropyValues([
                'fullVersionList',
                'model',
                'platform',
                'platformVersion'
            ]);
            const shouldUpdate = (field)=>alwaysOverride || field === $1fVgb.USER_AGENT_PARSER_UNAVAILABLE;
            if (hints.platform && shouldUpdate(this.osName)) this.osName = hints.platform;
            if (hints.platformVersion && shouldUpdate(this.osVersion)) this.osVersion = hints.platformVersion;
            if (hints.model !== undefined && shouldUpdate(this.deviceName)) this.deviceName = hints.model || $1fVgb.USER_AGENT_PARSER_UNAVAILABLE;
            if ((_c = hints.fullVersionList) === null || _c === void 0 ? void 0 : _c.length) {
                const browser = this.selectPrimaryBrowser(hints.fullVersionList);
                if (browser) {
                    if (shouldUpdate(this.browserName)) this.browserName = browser.brand;
                    this.browserVersion = browser.version;
                    this.browserMajorVersion = browser.version.split('.')[0];
                }
            }
        } catch (error) {
            (_d = this.logger) === null || _d === void 0 || _d.error(`Failed to get high entropy values: ${error}`);
        }
    }
    /**
     * Selects the primary browser from a list of brand/version pairs.
     * Filters out placeholder brands (starting with "Not") and prefers
     * specific browser brands over generic "Chromium".
     */ selectPrimaryBrowser(brands) {
        // Filter out placeholder brands (start with "Not")
        const validBrands = brands.filter((b)=>!b.brand.startsWith('Not'));
        // Prefer specific browsers over Chromium
        const preferredBrands = [
            'Google Chrome',
            'Microsoft Edge',
            'Opera',
            'Brave',
            'Vivaldi'
        ];
        for (const preferred of preferredBrands){
            const found = validBrands.find((b)=>b.brand === preferred);
            if (found) return found;
        }
        // Fall back to first non-Chromium brand, or Chromium if that's all we have
        return validBrands.find((b)=>b.brand !== 'Chromium') || validBrands[0] || null;
    }
}
module.exports.default = $ff548d78e9bd3a61$var$DefaultUserAgentParser;

});
parcelRegister("86Wyx", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    'use strict';
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '1.0.41', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 500;
    var AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', BROWSER = 'Browser', CHROME = 'Chrome', EDGE = 'Edge', FIREFOX = 'Firefox', GOOGLE = 'Google', HONOR = 'Honor', HUAWEI = 'Huawei', LENOVO = 'Lenovo', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', NVIDIA = 'Nvidia', ONEPLUS = 'OnePlus', OPERA = 'Opera', OPPO = 'OPPO', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', FACEBOOK = 'Facebook', CHROMIUM_OS = 'Chromium OS', MAC_OS = 'Mac OS', SUFFIX_BROWSER = ' Browser';
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty('*') ? map['*'] : str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
    }, windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': [
            'NT 5.1',
            'NT 5.2'
        ],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': [
            'NT 6.4',
            'NT 10.0'
        ],
        'RT': 'ARM'
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'Chrome'
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    'Edge'
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Mini'
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' GX'
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    'Baidu'
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i // Maxthon
            ],
            [
                VERSION,
                [
                    NAME,
                    'Maxthon'
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                // Trident based
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i // Quark
            ],
            [
                VERSION,
                [
                    NAME,
                    'Quark'
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    'DuckDuckGo'
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    'UC' + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    'WeChat'
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    'Konqueror'
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    'IE'
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    'Yandex'
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Smart Lenovo ' + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Secure ' + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Focus'
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Touch'
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Coc Coc'
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    'Dolphin'
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Coast'
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'MIUI' + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i // 360
            ],
            [
                VERSION,
                [
                    NAME,
                    '360'
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i // QQ
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1Browser'
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1' + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + ' Internet'
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    'Sogou Explorer'
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    'Sogou Mobile'
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i // QQ/2345
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i // 360
            ],
            [
                VERSION,
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'GSA'
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    'TikTok'
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + ' Headless'
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + ' WebView'
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Android ' + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    'Mobile Safari'
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    'Netscape'
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i // Wolvic/LibreWolf
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Reality'
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
                /\b(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    'amd64'
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    'ia32'
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    'arm64'
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    'armhf'
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    ARCHITECTURE,
                    'arm'
                ]
            ],
            [
                /((ppc|powerpc)(64)?)( mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                / sun4\w[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    'sparc'
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Honor
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    strMapper,
                    {
                        'OnePlus': [
                            '304',
                            '403',
                            '203'
                        ],
                        '*': OPPO
                    }
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Vivo'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Realme'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LENOVO
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(nokia) (t[12][01])/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ],
                [
                    VENDOR,
                    'Nokia'
                ]
            ],
            [
                // Google
                /(pixel (c|tablet))\b/i // Google Pixel C/Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    'Xperia Tablet'
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    'Fire Phone $1'
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'HTC'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // TCL
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'TCL'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // itel
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        'tablet': [
                            'p10001l',
                            'w7001'
                        ],
                        '*': 'mobile'
                    }
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Acer'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Meizu'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Ulefone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Energizer
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Energizer'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Cat
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Cat'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Smartfren
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Smartfren'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Nothing
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nothing'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Archos
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Archos'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Archos'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(imo) (tab \w+)/i,
                /(infinix) (x1101b?)/i // Infinix XPad
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
                /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Fairphone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'AT&T'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Siemens'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'RCA'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Dell'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Verizon'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Barnes & Noble'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NuVision'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Zeki'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    'Dragon Touch'
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Insignia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NextBook'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    'Voice'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    'LvTel'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Essential'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Envizen'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'MachSpeed'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Rotor'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i // Nvidia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    ' '
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    'SmartTV'
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + ' TV'
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + 'cast'
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(shield \w+ tv)/i // Nvidia Shield TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                // SmartTV from Unidentified Vendors
                /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i // Nvidia Portable
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation \w+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i // Samsung Galaxy Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i // Asus ZenWatch / LG Watch / Pixel Watch
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i // Oppo Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(opwwe\d{3})/i // OnePlus Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(moto 360)/i // Motorola 360
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(smartwatch 3)/i // Sony SmartWatch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(g watch r)/i // LG G Watch R
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // XR
                ///////////////////
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i // Pico
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(homepod).+mac os/i // Apple HomePod
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Generic'
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + 'HTML'
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i // ArkWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    'Blink'
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i // LibWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    NAME,
                    'LibWeb'
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    'Windows'
                ]
            ],
            [
                // iOS/macOS
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    '.'
                ],
                [
                    NAME,
                    'iOS'
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i // Ubuntu Touch
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Touch'
                ],
                VERSION
            ],
            [
                // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    'Symbian'
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' OS'
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'webOS'
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'watchOS'
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + 'cast'
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    'Solaris'
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = 'Brave';
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === 'object' ? window : this);

});

parcelRegister("c0dn0", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $8bcfdb263e580179$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $8bcfdb263e580179$var$DefaultBrowserBehavior_1 = $8bcfdb263e580179$var$__importDefault((parcelRequire("e2TuV")));

const $8bcfdb263e580179$var$version_1 = $8bcfdb263e580179$var$__importDefault((parcelRequire("k5FL2")));
class $8bcfdb263e580179$var$Versioning {
    /**
     * Return string representation of SDK name
     */ static get sdkName() {
        return 'amazon-chime-sdk-js';
    }
    /**
     * Return string representation of SDK version
     */ static get sdkVersion() {
        return $8bcfdb263e580179$var$version_1.default.semverString;
    }
    /**
     * Returns the parts of the semver, so major/minor/patch can be extracted individually.
     */ static get sdkVersionSemVer() {
        var _a, _b, _c, _d;
        const v = $8bcfdb263e580179$var$version_1.default.semverString.match(/^(?<major>[0-9]+)\.(?<minor>[0-9]+)((?:\.(?<patch>[0-9]+))(?:-(?<preRelease>[a-zA-Z]+(\.[0-9])*))?)?/);
        return {
            major: (_a = v === null || v === void 0 ? void 0 : v.groups) === null || _a === void 0 ? void 0 : _a.major,
            minor: (_b = v === null || v === void 0 ? void 0 : v.groups) === null || _b === void 0 ? void 0 : _b.minor,
            patch: (_c = v === null || v === void 0 ? void 0 : v.groups) === null || _c === void 0 ? void 0 : _c.patch,
            preRelease: (_d = v === null || v === void 0 ? void 0 : v.groups) === null || _d === void 0 ? void 0 : _d.preRelease
        };
    }
    /**
     * Return the SHA-1 of the Git commit from which this build was created.
     */ static get buildSHA() {
        // Skip the leading 'g'.
        return $8bcfdb263e580179$var$version_1.default.hash.substring(1);
    }
    /**
     * Return low-resolution string representation of SDK user agent (e.g. `chrome-78`)
     */ static get sdkUserAgentLowResolution() {
        const browserBehavior = new $8bcfdb263e580179$var$DefaultBrowserBehavior_1.default();
        return `${browserBehavior.name()}-${browserBehavior.majorVersion()}`;
    }
    /**
     * Return URL with versioning information appended
     */ static urlWithVersion(url) {
        const urlWithVersion = new URL(url);
        urlWithVersion.searchParams.append($8bcfdb263e580179$var$Versioning.X_AMZN_VERSION, $8bcfdb263e580179$var$Versioning.sdkVersion);
        urlWithVersion.searchParams.append($8bcfdb263e580179$var$Versioning.X_AMZN_USER_AGENT, $8bcfdb263e580179$var$Versioning.sdkUserAgentLowResolution);
        return urlWithVersion.toString();
    }
}
$8bcfdb263e580179$var$Versioning.X_AMZN_VERSION = 'X-Amzn-Version';
$8bcfdb263e580179$var$Versioning.X_AMZN_USER_AGENT = 'X-Amzn-User-Agent';
module.exports.default = $8bcfdb263e580179$var$Versioning;

});
parcelRegister("k5FL2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    "hash": "dea69d2",
    "raw": "v3.31.0",
    "semverString": "3.31.0"
};

});


parcelRegister("1fVgb", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.USER_AGENT_PARSER_UNAVAILABLE = void 0;
/**
 * Constant for unavailable values in parser results.
 */ module.exports.USER_AGENT_PARSER_UNAVAILABLE = 'Unavailable';

});




parcelRegister("lpXGX", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $f97a3c5b7f1c23d8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_VIDEO_SUBSCRIPTION_LIMIT = void 0;

const $f97a3c5b7f1c23d8$var$DefaultVideoStreamIdSet_1 = $f97a3c5b7f1c23d8$var$__importDefault((parcelRequire("gVZQM")));
module.exports.DEFAULT_VIDEO_SUBSCRIPTION_LIMIT = 25;
/**
 * [[AudioVideoControllerState]] includes the compute resources shared by [[DefaultAudioVideoController]] and any running [[Task]].
 *
 * **Note**: Any additions to this class need to consider whether they need to be reset in `resetConnectionSpecificState`, `CleanStoppedSessionTask`, or
 * `CleanRestartedSessionTask`, e.g. if it is relies on backend state and will go stale across reconnections.  Failing
 * to reset state may lead to unexpected behavior.
 */ class $f97a3c5b7f1c23d8$var$AudioVideoControllerState {
    constructor(){
        this.logger = null;
        this.browserBehavior = null;
        this.meetingSessionConfiguration = null;
        this.signalingClient = null;
        this.peer = null;
        this.previousSdpOffer = null;
        this.sdpOfferInit = null;
        this.audioVideoController = null;
        this.realtimeController = null;
        this.videoTileController = null;
        this.mediaStreamBroker = null;
        this.activeAudioInput = undefined;
        this.activeVideoInput = undefined;
        this.audioMixController = null;
        this.transceiverController = null;
        this.encodedTransformWorkerManager = null;
        this.meetingSessionTimingManager = null;
        this.indexFrame = null;
        this.iceCandidates = [];
        this.iceCandidateHandler = null;
        this.iceGatheringStateEventHandler = null;
        this.sdpAnswer = null;
        this.turnCredentials = null;
        this.reconnectController = null;
        this.removableObservers = [];
        this.audioProfile = null;
        this.videoStreamIndex = null;
        this.videoDownlinkBandwidthPolicy = null;
        this.videoUplinkBandwidthPolicy = null;
        this.lastKnownVideoAvailability = null;
        this.videoCaptureAndEncodeParameter = null;
        // An unordered list of IDs provided by the downlink policy that
        // we will eventually subscribe to.
        this.videosToReceive = null;
        // The last processed set of IDs provided by the policy, so that we can
        // compare what changes were additions, stream switches, or removals.
        this.lastVideosToReceive = null;
        // An ordered list corresponding to `videosToReceive` where the order
        // itself correspond to transceivers; 0 in this list corresponds to an inactive tranceiver.
        this.videoSubscriptions = null;
        // The last calculated list of subscription configuration used to send a remote video
        // update (i.e. not necessarily related to what is in subscribe). This is used to make the remote
        // video update a differential message (i.e. only sending changes)
        //
        // This is stored as a map keyed by group ID for convenience
        this.lastVideoSubscriptionConfiguration = new Map();
        // The video subscription limit is set by the backend and is subject to change in future.
        // This value is set in the `JoinAndReceiveIndexTask` when we process the `SdkJoinAckFrame`
        // and is used in the `ReceiveVideoStreamIndexTask` to limit the total number of streams
        // that we include in the `videosToReceive`.
        this.videoSubscriptionLimit = module.exports.DEFAULT_VIDEO_SUBSCRIPTION_LIMIT;
        // The previous SDP answer will be used as a dictionary to seed the compression library
        // during decompressing the compressed SDP answer.
        this.previousSdpAnswerAsString = '';
        // This flag indicates if the backend supports compression for the client.
        this.serverSupportsCompression = false;
        // Values set by `setVideoCodecSendPreferences`.
        this.videoSendCodecPreferences = [];
        // Calculated as the highest priority available codec set in the (possibly munged) SDP answer
        // that is provide to the peer connection, which will be what is sent.
        this.currentVideoSendCodec = undefined;
        // Intersection of `videoSendCodecPreferences` and the supported receive codecs of
        // all the other clients in the meeting.
        this.meetingSupportedVideoSendCodecPreferences = undefined;
        // Calculated as the list of available codec set in the (possibly munged) SDP answer
        // that is provided to the peer connection, which will be ordered by priority.
        this.prioritizedSendVideoCodecCapabilities = [];
        // Video codecs that we have detected encoding issues with that we will
        // avoid using even if they are provided in `videoSendCodecPreferences`
        this.degradedVideoSendCodecs = [];
        this.videosPaused = null;
        this.videoDuplexMode = null;
        this.volumeIndicatorAdapter = null;
        this.statsCollector = null;
        this.connectionMonitor = null;
        // This state is deprecated and unused.
        this.videoInputAttachedTimestampMs = 0;
        // This state is deprecated and unused.
        this.audioDeviceInformation = {};
        // This state is deprecated and unused.
        this.videoDeviceInformation = {};
        this.enableSimulcast = false;
        // If set to true, the client will actively try to use Scalable Video Coding (SVC) features
        // if possible. The availability of these features depends dynamically on the video codec used;
        // static browser availability and any competing features (e.g. simulcast) should
        // have already been checked before this is set to true.
        this.enableSVC = false;
        this.eventController = null;
        // The following values are currently used solely as attributes on
        // reported events.
        this.signalingOpenDurationMs = null;
        this.iceGatheringDurationMs = null;
        this.startAudioVideoTimestamp = null;
        this.attendeePresenceDurationMs = null;
        this.meetingStartDurationMs = null;
        this.poorConnectionCount = 0;
        this.maxVideoTileCount = 0;
        this.startTimeMs = null;
        this.retryCount = 0;
        // Indicates whether the session has completed initial connection (i.e. signal channel open and first subscribe
        // and subscribe-ack)
        this.isSessionConnected = false;
    }
    /**
     * Helper method to determine if audio redundancy should be enabled.
     * Audio redundancy requires both the audio profile to have redundancy enabled
     * and the encoded transform worker manager to be enabled.
     */ enableAudioRedundancy() {
        var _a, _b;
        return !!(((_a = this.audioProfile) === null || _a === void 0 ? void 0 : _a.hasRedundancyEnabled()) && ((_b = this.encodedTransformWorkerManager) === null || _b === void 0 ? void 0 : _b.isEnabled()));
    }
    /*
     * Reset state corresponding to state that is dependent on a individual connection
     * and may not be valid for others, e.g. on a reconnection.
     */ resetConnectionSpecificState() {
        // Note that `CleanStoppedSessionTask` will reset additional
        // state in the case of a client that is stopped and possibly intended for reuse.
        // `signalingClient` can be reused from a failed/disconnected state.
        // `videoStreamIndex` will be updated by the first index
        if (this.peer) this.peer.close();
        this.peer = null;
        this.previousSdpOffer = null;
        this.sdpOfferInit = null;
        // `audioVideoController` members should either be reusable, or moved to `AudioVideoControllerState` and
        // cleaned up here.
        // We don't want to mutate `videoTileController` as most video tiles will still be there on reconnect. We can remove tiles on the
        // first index we receive if they no longer exist
        // `mediaStreamBroker`, `activeAudioInput`, and `activeVideoInput` are cleaned up seperately in `DefaultAudioVideoController.cleanUpMediaStreamsAfterStop`
        // but only on `stop` or non-reconnectable failures. They are also set to cached `DefaultAudioVideoController` members on restart.
        if (this.transceiverController !== undefined) this.transceiverController.reset();
        this.indexFrame = null;
        this.iceCandidates = [];
        this.iceCandidateHandler = null;
        this.sdpAnswer = null;
        this.turnCredentials = null;
        this.videoDownlinkBandwidthPolicy.reset();
        if (this.videoUplinkBandwidthPolicy.reset) this.videoUplinkBandwidthPolicy.reset();
        this.lastVideosToReceive = null;
        this.lastVideoSubscriptionConfiguration = new Map();
        this.videoSubscriptions = null;
        this.videoSubscriptionLimit = module.exports.DEFAULT_VIDEO_SUBSCRIPTION_LIMIT;
        this.previousSdpAnswerAsString = '';
        this.serverSupportsCompression = false;
        this.videosToReceive = new $f97a3c5b7f1c23d8$var$DefaultVideoStreamIdSet_1.default();
        this.videosPaused = new $f97a3c5b7f1c23d8$var$DefaultVideoStreamIdSet_1.default();
        // `videoSendCodecPreferences` is set by builder and needs to stay consistent.
        this.currentVideoSendCodec = undefined;
        this.meetingSupportedVideoSendCodecPreferences = undefined;
        this.videoDuplexMode = null;
        // `poorConnectionCount`and `maxVideoTileCount` is intentionally not set to 0 across reconnections.
        this.isSessionConnected = false;
    }
}
module.exports.default = $f97a3c5b7f1c23d8$var$AudioVideoControllerState;

});

parcelRegister("fzQa8", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlurStrengthMapper = void 0;
/**
 * The numbers below indicate the amount of blur to apply. Larger numbers will produce
 * more blur.
 */ const $b572964c13b8ec1d$var$BlurStrength = {
    LOW: 7,
    MEDIUM: 15,
    HIGH: 30
};
/** @internal */ class $b572964c13b8ec1d$var$BlurStrengthMapper {
    static getBlurAmount(bstrength, options) {
        if (bstrength <= 0) throw new Error(`invalid value for blur strength: ${bstrength}`);
        return Math.round(bstrength * options.height / this.BLUR_STRENGTH_DIVISOR);
    }
}
module.exports.BlurStrengthMapper = $b572964c13b8ec1d$var$BlurStrengthMapper;
$b572964c13b8ec1d$var$BlurStrengthMapper.BLUR_STRENGTH_DIVISOR = 540; // use 540P as baseline blur strength
module.exports.default = $b572964c13b8ec1d$var$BlurStrength;

});

parcelRegister("hYwBJ", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $d1615572ca1b3af8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $d1615572ca1b3af8$var$BackgroundFilterVideoFrameProcessor_1 = $d1615572ca1b3af8$var$__importDefault((parcelRequire("5nMOz")));

const $d1615572ca1b3af8$var$ConsoleLogger_1 = $d1615572ca1b3af8$var$__importDefault((parcelRequire("3dGmS")));

const $d1615572ca1b3af8$var$LogLevel_1 = $d1615572ca1b3af8$var$__importDefault((parcelRequire("aSYjG")));

const $d1615572ca1b3af8$var$NoOpVideoFrameProcessor_1 = $d1615572ca1b3af8$var$__importDefault((parcelRequire("8btv2")));

const $d1615572ca1b3af8$var$BackgroundBlurProcessorBuiltIn_1 = $d1615572ca1b3af8$var$__importDefault((parcelRequire("3gcvF")));

const $d1615572ca1b3af8$var$BackgroundBlurProcessorProvided_1 = $d1615572ca1b3af8$var$__importDefault((parcelRequire("iY5UT")));

const $d1615572ca1b3af8$var$BackgroundBlurStrength_1 = $d1615572ca1b3af8$var$__importDefault((parcelRequire("fzQa8")));
/**
 * No-op implementation of the blur processor. An instance of this class will be returned when a user attempts
 * to create a blur processor when it is not supported.
 */ /** @internal */ class $d1615572ca1b3af8$var$NoOpBackgroundBlurProcessor extends $d1615572ca1b3af8$var$NoOpVideoFrameProcessor_1.default {
    /**
     * no-op
     */ setBlurStrength() {}
    /**
     * no-op
     * @returns
     */ async loadAssets() {
        return;
    }
    /**
     * no-op
     */ addObserver() {}
    /**
     * no-op
     */ removeObserver() {}
}
/**
 * [[BackgroundBlurVideoFrameProcessor]]
 * Creates a background blur processor which identifies the foreground person and blurs the background.
 */ class $d1615572ca1b3af8$var$BackgroundBlurVideoFrameProcessor extends $d1615572ca1b3af8$var$BackgroundFilterVideoFrameProcessor_1.default {
    /**
     * A factory method that will call the private constructor to instantiate the processor and asynchronously
     * initialize the worker, wasm, and ML models. Upon completion of the initialization the promise will either
     * be resolved or rejected.
     * @param spec The spec defines the assets that will be used for adding background blur to a frame
     * @param options Background blur options including blur strength
     * @returns
     */ static async create(spec, options) {
        spec = $d1615572ca1b3af8$var$BackgroundBlurVideoFrameProcessor.resolveSpec(spec);
        options = $d1615572ca1b3af8$var$BackgroundBlurVideoFrameProcessor.resolveOptions(options);
        const { logger: logger } = options;
        const supported = await $d1615572ca1b3af8$var$BackgroundBlurVideoFrameProcessor.isSupported(spec, options);
        // if blur is not supported do not initialize. The processor will become a no op if not supported.
        logger.info(`processor is ${supported ? '' : 'not'} supported`);
        if (!supported) {
            logger.warn('Using no-op processor because background blur is not supported');
            return new $d1615572ca1b3af8$var$NoOpBackgroundBlurProcessor();
        }
        let processor;
        if (await $d1615572ca1b3af8$var$BackgroundBlurProcessorProvided_1.default.isSupported()) {
            logger.info('Using browser-provided background blur');
            processor = new $d1615572ca1b3af8$var$BackgroundBlurProcessorProvided_1.default(spec, options);
        } else {
            logger.info('Using built-in background blur');
            processor = new $d1615572ca1b3af8$var$BackgroundBlurProcessorBuiltIn_1.default(spec, options);
        }
        await processor.loadAssets();
        return processor;
    }
    /**
     * Based on the options that are passed in set defaults for options
     * @param options  the options that are passed in
     * @returns An updated set of options with defaults set
     */ static resolveOptions(options = {}) {
        let processorOptions = {
            ...options
        };
        if (!processorOptions.blurStrength) processorOptions.blurStrength = $d1615572ca1b3af8$var$BackgroundBlurStrength_1.default.MEDIUM;
        if (!processorOptions.logger) processorOptions.logger = new $d1615572ca1b3af8$var$ConsoleLogger_1.default('BackgroundBlurProcessor', $d1615572ca1b3af8$var$LogLevel_1.default.INFO);
        processorOptions = super.resolveOptions(processorOptions);
        return processorOptions;
    }
    /**
     * This method will detect the environment in which it is being used and determine if background
     * blur can be used.
     * @param spec The {@link BackgroundFilterSpec} spec that will be used to initialize assets
     * @param options options such as logger
     * @returns a boolean promise that will resolve to true if supported and false if not
     */ static isSupported(spec, options) {
        spec = $d1615572ca1b3af8$var$BackgroundBlurVideoFrameProcessor.resolveSpec(spec);
        options = $d1615572ca1b3af8$var$BackgroundBlurVideoFrameProcessor.resolveOptions(options);
        return super.isSupported(spec, options);
    }
}
module.exports.default = $d1615572ca1b3af8$var$BackgroundBlurVideoFrameProcessor;

});
parcelRegister("5nMOz", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $3eb4f74b112342d2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aJA5z = parcelRequire("aJA5z");

var $euItc = parcelRequire("euItc");

const $3eb4f74b112342d2$var$ModelSpecBuilder_1 = $3eb4f74b112342d2$var$__importDefault((parcelRequire("OchoQ")));

const $3eb4f74b112342d2$var$DefaultBrowserBehavior_1 = $3eb4f74b112342d2$var$__importDefault((parcelRequire("e2TuV")));

const $3eb4f74b112342d2$var$Versioning_1 = $3eb4f74b112342d2$var$__importDefault((parcelRequire("c0dn0")));
/** @internal */ const $3eb4f74b112342d2$var$CREATE_DEFAULT_MODEL_SPEC = ()=>$3eb4f74b112342d2$var$ModelSpecBuilder_1.default.builder().withSelfieSegmentationDefaults().build();
/** @internal */ const $3eb4f74b112342d2$var$DEFAULT_CDN = 'https://static.sdkassets.chime.aws';
/** @internal */ const $3eb4f74b112342d2$var$DEFAULT_PATHS = {
    worker: `${$3eb4f74b112342d2$var$DEFAULT_CDN}/bgblur/workers/worker.js`,
    wasm: `${$3eb4f74b112342d2$var$DEFAULT_CDN}/bgblur/wasm/_cwt-wasm.wasm`,
    simd: `${$3eb4f74b112342d2$var$DEFAULT_CDN}/bgblur/wasm/_cwt-wasm-simd.wasm`
};
class $3eb4f74b112342d2$var$BackgroundFilterVideoFrameProcessor {
    /**
     * Based on the SDK version, return an asset group.
     *
     * @returns the default asset spec, based on the SDK version.
     */ static defaultAssetSpec() {
        const version = $3eb4f74b112342d2$var$Versioning_1.default.sdkVersionSemVer;
        return {
            assetGroup: `sdk-${version.major}.${version.minor}`
        };
    }
    /**
     * Set the given parameters to the url. Existing parameters in the url are preserved.
     * If duplicate parameters exist, they are overwritten, so it's safe to call this method multiple
     * times on the same url.
     *
     * @param url the initial url, can include query parameters
     * @param queryParams the query parameters to set
     * @returns a new url with the given query parameters.
     */ static createUrlWithParams(url, queryParams) {
        const u = new URL(url);
        const keys = Object.keys(queryParams);
        for (const key of keys)if (queryParams[key] !== undefined) u.searchParams.set(key, queryParams[key]);
        return u.toString();
    }
    /**
     * Based on the spec that is passed in set defaults for spec
     * @param spec the spec that was passed in
     * @returns An updated spec with defaults set
     */ static resolveSpec(spec) {
        const { paths: paths = $3eb4f74b112342d2$var$DEFAULT_PATHS, model: model = $3eb4f74b112342d2$var$CREATE_DEFAULT_MODEL_SPEC(), assetGroup: assetGroup = this.defaultAssetSpec().assetGroup, revisionID: revisionID = this.defaultAssetSpec().revisionID } = spec || {};
        const params = {
            assetGroup: assetGroup,
            revisionID: revisionID,
            sdk: encodeURIComponent($3eb4f74b112342d2$var$Versioning_1.default.sdkVersion),
            ua: encodeURIComponent($3eb4f74b112342d2$var$Versioning_1.default.sdkUserAgentLowResolution)
        };
        paths.worker = this.createUrlWithParams(paths.worker, params);
        paths.wasm = this.createUrlWithParams(paths.wasm, params);
        paths.simd = this.createUrlWithParams(paths.simd, params);
        model.path = this.createUrlWithParams(model.path, params);
        return {
            paths: paths,
            model: model,
            assetGroup: assetGroup,
            revisionID: revisionID
        };
    }
    /**
     * Based on the options that are passed in set defaults for options
     * @param options  the options that are passed in
     * @returns An updated set of options with defaults set
     */ static resolveOptions(options) {
        if (!options.reportingPeriodMillis) options.reportingPeriodMillis = 1000;
        const DEFAULT_FILTER_CPU_UTILIZATION = 30;
        if (!options.filterCPUUtilization) options.filterCPUUtilization = DEFAULT_FILTER_CPU_UTILIZATION;
        else if (options.filterCPUUtilization < 0 || options.filterCPUUtilization > 100) {
            options.logger.warn(`filterCPUUtilization must be set to a range between 0 and 100 percent. Falling back to default of ${DEFAULT_FILTER_CPU_UTILIZATION} percent`);
            options.filterCPUUtilization = DEFAULT_FILTER_CPU_UTILIZATION;
        }
        return options;
    }
    /**
     * This method will detect the environment in which it is being used and determine if background
     * blur/replacement can be used.
     * @param spec The {@link BackgroundFilterSpec} spec that will be used to initialize assets
     * @param options options such as logger
     * @returns a boolean promise that will resolve to true if supported and false if not
     */ static isSupported(spec, options) {
        const { logger: logger } = options;
        // could not figure out how to remove globalThis to test failure case
        /* istanbul ignore next */ if (typeof globalThis === 'undefined') {
            logger.info('Browser does not have globalThis.');
            return Promise.resolve(false);
        }
        const browser = new $3eb4f74b112342d2$var$DefaultBrowserBehavior_1.default();
        if (!browser.supportsBackgroundFilter()) {
            logger.info('Browser is not supported.');
            return Promise.resolve(false);
        }
        if (!(0, $euItc.supportsWASM)(globalThis, logger)) {
            logger.info('Browser does not support WASM.');
            return Promise.resolve(false);
        }
        return this.supportsBackgroundFilter(globalThis, spec, logger);
    }
    static async supportsBackgroundFilter(/* istanbul ignore next */ scope = globalThis, spec, logger) {
        if (!(0, $euItc.supportsWorker)(scope, logger)) {
            logger.info('Browser does not support web workers.');
            return false;
        }
        // Use the actual worker path -- it's only 20KB, and it'll get the cache warm.
        const workerURL = spec.paths.worker;
        try {
            const worker = await (0, $aJA5z.loadWorker)(workerURL, 'BackgroundFilterWorker', {}, null);
            try {
                worker.terminate();
            } catch (e) {
                logger.info(`Failed to terminate worker. ${e.message}`);
            }
            return true;
        } catch (e) {
            logger.info(`Failed to fetch and instantiate test worker ${e.message}`);
            return false;
        }
    }
}
module.exports.default = $3eb4f74b112342d2$var$BackgroundFilterVideoFrameProcessor;

});
parcelRegister("aJA5z", function(module, exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.loadWorker = void 0;

var $59RLu = parcelRequire("59RLu");
const $7d0a19da5d3b9a24$var$WORKER_FETCH_OPTIONS = {
    method: 'GET',
    mode: 'cors',
    credentials: 'omit',
    redirect: 'follow',
    referrerPolicy: 'no-referrer'
};
const $7d0a19da5d3b9a24$var$loadWorker = (workerURL, name, fetchBehavior, logger)=>{
    logger === null || logger === void 0 || logger.debug(`Loading ${name} worker from ${workerURL}.`);
    let workerURLIsSameOrigin = false;
    try {
        workerURLIsSameOrigin = self.origin === new URL(workerURL).origin;
    } catch (e) {
        logger === null || logger === void 0 || logger.error('Could not compare origins.', e);
    }
    if (workerURLIsSameOrigin) {
        const workerURLWithQuery = (0, $59RLu.withQueryString)(workerURL, fetchBehavior);
        return Promise.resolve(new Worker(workerURLWithQuery, {
            name: name
        }));
    }
    return (0, $59RLu.fetchWithBehavior)(workerURL, $7d0a19da5d3b9a24$var$WORKER_FETCH_OPTIONS, fetchBehavior).then((res)=>{
        if (res.ok) return res.blob().then((blob)=>new Worker(window.URL.createObjectURL(blob)));
        throw new Error('Fetch failed.');
    });
};
module.exports.loadWorker = $7d0a19da5d3b9a24$var$loadWorker;

});
parcelRegister("59RLu", function(module, exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidRevisionID = module.exports.isValidAssetGroup = module.exports.resolveURL = module.exports.addQueryParams = module.exports.withQueryString = module.exports.withRequestHeaders = module.exports.fetchWithBehavior = void 0;
function $3c177fa396c5bb83$var$fetchWithBehavior(url, init, fetchBehavior) {
    if (!fetchBehavior) return fetch(url, init);
    const withQuery = $3c177fa396c5bb83$var$withQueryString(url, fetchBehavior);
    const withHeaders = $3c177fa396c5bb83$var$withRequestHeaders(init, fetchBehavior);
    return fetch(withQuery, withHeaders);
}
module.exports.fetchWithBehavior = $3c177fa396c5bb83$var$fetchWithBehavior;
function $3c177fa396c5bb83$var$withRequestHeaders(init, fetchBehavior) {
    if (!(fetchBehavior === null || fetchBehavior === void 0 ? void 0 : fetchBehavior.headers)) return init;
    if (!init) return {
        headers: fetchBehavior.headers
    };
    return Object.assign(Object.assign({}, init), {
        headers: Object.assign(Object.assign({}, init.headers || {}), fetchBehavior.headers)
    });
}
module.exports.withRequestHeaders = $3c177fa396c5bb83$var$withRequestHeaders;
function $3c177fa396c5bb83$var$withQueryString(url, fetchBehavior) {
    if (!(fetchBehavior === null || fetchBehavior === void 0 ? void 0 : fetchBehavior.escapedQueryString)) return url;
    const hasQuery = url.lastIndexOf('?') !== -1;
    return `${url}${hasQuery ? '&' : '?'}${fetchBehavior.escapedQueryString}`;
}
module.exports.withQueryString = $3c177fa396c5bb83$var$withQueryString;
function $3c177fa396c5bb83$var$addQueryParams(fetchBehavior, queryParams) {
    const keys = Object.keys(queryParams);
    if (!keys.length) return fetchBehavior;
    const params = new URLSearchParams(fetchBehavior === null || fetchBehavior === void 0 ? void 0 : fetchBehavior.escapedQueryString);
    for (const key of keys)params.append(key, queryParams[key]);
    return Object.assign(Object.assign({}, fetchBehavior), {
        escapedQueryString: params.toString()
    });
}
module.exports.addQueryParams = $3c177fa396c5bb83$var$addQueryParams;
const $3c177fa396c5bb83$var$HEAD_OPTIONS = {
    method: 'HEAD',
    mode: 'cors',
    credentials: 'omit',
    redirect: 'follow',
    referrerPolicy: 'origin'
};
function $3c177fa396c5bb83$var$resolveURL(url, fetchBehavior) {
    return $3c177fa396c5bb83$var$fetchWithBehavior(url, $3c177fa396c5bb83$var$HEAD_OPTIONS, fetchBehavior).then((response)=>response.redirected ? response.url : url);
}
module.exports.resolveURL = $3c177fa396c5bb83$var$resolveURL;
function $3c177fa396c5bb83$var$isValidAssetGroup(assetGroup) {
    return !!assetGroup && /^[-.a-zA-Z0-9]+$/.test(assetGroup);
}
module.exports.isValidAssetGroup = $3c177fa396c5bb83$var$isValidAssetGroup;
function $3c177fa396c5bb83$var$isValidRevisionID(revisionID) {
    return !!revisionID && /^[123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ]{22}$/.test(revisionID);
}
module.exports.isValidRevisionID = $3c177fa396c5bb83$var$isValidRevisionID;

});


parcelRegister("euItc", function(module, exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
"use strict";
var $a8d65cd4853eeac2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isOldChrome = module.exports.supportsWASMStreaming = module.exports.supportsSharedArrayBuffer = module.exports.supportsWASM = module.exports.supportsAudioWorklet = module.exports.supportsWorker = module.exports.supportsVoiceFocusWorker = module.exports.supportsWASMPostMessage = module.exports.isSafari = void 0;

var $aJA5z = parcelRequire("aJA5z");
const $a8d65cd4853eeac2$var$isChrome = (global = globalThis)=>{
    const ua = global.navigator.userAgent;
    return !!ua.match(/Chrom(?:e|ium)\/([0-9]+)/);
};
const $a8d65cd4853eeac2$var$isSafari = (global = globalThis)=>{
    const ua = global.navigator.userAgent;
    const hasSafari = ua.match(/Safari\//);
    const hasChrome = ua.match(/Chrom(?:e|ium)\//);
    return !!(hasSafari && !hasChrome);
};
module.exports.isSafari = $a8d65cd4853eeac2$var$isSafari;
const $a8d65cd4853eeac2$var$supportsWASMPostMessage = (global = globalThis)=>{
    if ((0, module.exports.isSafari)(global)) return false;
    if ($a8d65cd4853eeac2$var$isChrome(global)) {
        const version = $a8d65cd4853eeac2$var$chromeVersion(global) || 0;
        return version < 95;
    }
    return true;
};
module.exports.supportsWASMPostMessage = $a8d65cd4853eeac2$var$supportsWASMPostMessage;
const $a8d65cd4853eeac2$var$supportsVoiceFocusWorker = (scope = globalThis, fetchConfig, logger)=>$a8d65cd4853eeac2$var$__awaiter(void 0, void 0, void 0, function*() {
        if (!(0, module.exports.supportsWorker)(scope, logger)) return false;
        const workerURL = `${fetchConfig.paths.workers}worker-v1.js`;
        try {
            const worker = yield (0, $aJA5z.loadWorker)(workerURL, 'VoiceFocusTestWorker', fetchConfig, logger);
            try {
                worker.terminate();
            } catch (e) {
                logger === null || logger === void 0 || logger.debug('Failed to terminate worker.', e);
            }
            return true;
        } catch (e) {
            logger === null || logger === void 0 || logger.info('Failed to fetch and instantiate test worker', e);
            return false;
        }
    });
module.exports.supportsVoiceFocusWorker = $a8d65cd4853eeac2$var$supportsVoiceFocusWorker;
const $a8d65cd4853eeac2$var$supportsWorker = (scope = globalThis, logger)=>{
    try {
        return !!scope.Worker;
    } catch (e) {
        logger === null || logger === void 0 || logger.info('Does not support Worker', e);
        return false;
    }
};
module.exports.supportsWorker = $a8d65cd4853eeac2$var$supportsWorker;
const $a8d65cd4853eeac2$var$supportsAudioWorklet = (scope = globalThis, logger)=>{
    try {
        return !!scope.AudioWorklet && !!scope.AudioWorkletNode;
    } catch (e) {
        logger === null || logger === void 0 || logger.info('Does not support Audio Worklet', e);
        return false;
    }
};
module.exports.supportsAudioWorklet = $a8d65cd4853eeac2$var$supportsAudioWorklet;
const $a8d65cd4853eeac2$var$supportsWASM = (scope = globalThis, logger)=>{
    try {
        return !!scope.WebAssembly && (!!scope.WebAssembly.compile || !!scope.WebAssembly.compileStreaming);
    } catch (e) {
        logger === null || logger === void 0 || logger.info('Does not support WASM', e);
        return false;
    }
};
module.exports.supportsWASM = $a8d65cd4853eeac2$var$supportsWASM;
const $a8d65cd4853eeac2$var$supportsSharedArrayBuffer = (scope = globalThis, window = globalThis, logger)=>{
    try {
        return !!scope.SharedArrayBuffer && (!!window.chrome || !!scope.crossOriginIsolated);
    } catch (e) {
        logger === null || logger === void 0 || logger.info('Does not support SharedArrayBuffer.');
        return false;
    }
};
module.exports.supportsSharedArrayBuffer = $a8d65cd4853eeac2$var$supportsSharedArrayBuffer;
const $a8d65cd4853eeac2$var$supportsWASMStreaming = (scope = globalThis, logger)=>{
    var _a;
    try {
        return !!((_a = scope.WebAssembly) === null || _a === void 0 ? void 0 : _a.compileStreaming);
    } catch (e) {
        logger === null || logger === void 0 || logger.info('Does not support WASM streaming compilation', e);
        return false;
    }
};
module.exports.supportsWASMStreaming = $a8d65cd4853eeac2$var$supportsWASMStreaming;
const $a8d65cd4853eeac2$var$SUPPORTED_CHROME_VERSION = 90;
const $a8d65cd4853eeac2$var$chromeVersion = (global = globalThis)=>{
    try {
        if (!global.chrome) return undefined;
    } catch (e) {}
    const versionCheck = global.navigator.userAgent.match(/Chrom(?:e|ium)\/([0-9]+)/);
    if (!versionCheck) return undefined;
    return parseInt(versionCheck[1], 10);
};
const $a8d65cd4853eeac2$var$isOldChrome = (global = globalThis, logger)=>{
    const version = $a8d65cd4853eeac2$var$chromeVersion(global);
    if (!version) return false;
    if (version < $a8d65cd4853eeac2$var$SUPPORTED_CHROME_VERSION) {
        logger === null || logger === void 0 || logger.debug(`Chrome ${version} has incomplete SIMD support.`);
        return true;
    }
    return false;
};
module.exports.isOldChrome = $a8d65cd4853eeac2$var$isOldChrome;

});

parcelRegister("OchoQ", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * A builder class to instantiate a model spec.
 */ class $096e321b7e3f5907$var$ModelSpecBuilder {
    constructor(){
        this.path = null;
        this.input = null;
        this.output = null;
    }
    static builder() {
        return new $096e321b7e3f5907$var$ModelSpecBuilder();
    }
    /**
     * Set up the builder to use the default model implementation.
     *
     * Members of this interface can change without a major version bump to accommodate new browser
     * bugs and capabilities. If you extend this type, you might need to rework your code for new minor
     * versions of this library.
     * @returns a reference to the current builder.
     */ withDefaultModel() {
        return this.withSelfieSegmentationDefaults();
    }
    /**
     * Set up the builder to use the defaults for selfie segmentation model.
     * @returns the builder to allow for fluent API (e.g., ModelSpecBuilder.withSelfieSegmentationDefaults().build()).
     */ withSelfieSegmentationDefaults() {
        const SELFIE_MODEL_INPUT_SHAPE = {
            height: 144,
            width: 256,
            range: [
                0,
                1
            ],
            channels: 3
        };
        const SELFIE_MODEL_OUTPUT_SHAPE = {
            height: 144,
            width: 256,
            range: [
                0,
                1
            ],
            channels: 1
        };
        const DEFAULT_SELFIE_MODEL_PATH = 'https://static.sdkassets.chime.aws/bgblur/models/selfie_segmentation_landscape.tflite';
        this.path = DEFAULT_SELFIE_MODEL_PATH;
        this.input = SELFIE_MODEL_INPUT_SHAPE;
        this.output = SELFIE_MODEL_OUTPUT_SHAPE;
        return this;
    }
    /**
     * A method to override the path to the segmentation model.
     * @param path A function that returns the path to the segmentation model.
     * @returns the builder to allow for fluent API (e.g., ModelSpecBuilder.builder().withPath("some path").build()).
     */ withPath(path) {
        this.path = path;
        return this;
    }
    /**
     * A method to override the input shape to the segmentation model.
     * @param input An object that defines input shape of the segmentation model.
     * @returns the builder to allow for fluent API (e.g., ModelSpecBuilder.builder().withInput({}).build()).
     */ withInput(input) {
        this.input = input;
        return this;
    }
    /**
     * A method to override the output shape to the segmentation model.
     * @param output An object that defines output shape of the segmentation model.
     * @returns the builder to allow for fluent API (e.g., ModelSpecBuilder.builder().withOutput({}).build()).
     */ withOutput(output) {
        this.output = output;
        return this;
    }
    /**
     * Validate that inputs to the model spec are valid.
     */ validate() {
        if (!this.path) throw new Error('model spec path is not set');
        if (!this.input) throw new Error('model spec input is not set');
        if (!this.output) throw new Error('model spec output is not set');
    }
    /**
     * A method that returns an instantiated object that implements the ModelSpec interface with values set for
     * the use of the selfie segmentation model.
     * @returns an object that implements the ModelSpec interface.
     */ build() {
        this.validate();
        return {
            path: this.path,
            input: this.input,
            output: this.output
        };
    }
}
module.exports.default = $096e321b7e3f5907$var$ModelSpecBuilder;

});


parcelRegister("3dGmS", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $2583735fe38e1e92$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $2583735fe38e1e92$var$LogLevel_1 = $2583735fe38e1e92$var$__importDefault((parcelRequire("aSYjG")));
/**
 * ConsoleLogger writes logs with console
 *
 * ```typescript
 *   // working with the ConsoleLogger
 *   const logger = new ConsoleLogger('demo'); //default level is LogLevel.WARN
 *   logger.info('info');
 *   logger.debug('debug');
 *   logger.warn('warn');
 *   logger.error('error');
 *
 *   // setting logging levels
 *   const logger = new ConsoleLogger('demo', LogLevel.INFO)
 *   logger.debug(debugFunc()); // this will not show up
 *   logger.setLogLevel(LogLevel.DEBUG)
 *   logger.debug(debugFunc()); // this will show up
 *
 * ```
 */ class $2583735fe38e1e92$var$ConsoleLogger {
    constructor(name, level = $2583735fe38e1e92$var$LogLevel_1.default.WARN){
        this.name = name;
        this.level = level;
    }
    info(msg) {
        this.log($2583735fe38e1e92$var$LogLevel_1.default.INFO, msg);
    }
    warn(msg) {
        this.log($2583735fe38e1e92$var$LogLevel_1.default.WARN, msg);
    }
    error(msg) {
        this.log($2583735fe38e1e92$var$LogLevel_1.default.ERROR, msg);
    }
    debug(debugFunction) {
        if ($2583735fe38e1e92$var$LogLevel_1.default.DEBUG < this.level) return;
        if (typeof debugFunction === 'string') this.log($2583735fe38e1e92$var$LogLevel_1.default.DEBUG, debugFunction);
        else if (debugFunction) this.log($2583735fe38e1e92$var$LogLevel_1.default.DEBUG, debugFunction());
        else this.log($2583735fe38e1e92$var$LogLevel_1.default.DEBUG, '' + debugFunction);
    }
    setLogLevel(level) {
        this.level = level;
    }
    getLogLevel() {
        return this.level;
    }
    log(type, msg) {
        if (type < this.level) return;
        const timestamp = new Date().toISOString();
        const logMessage = `${timestamp} [${$2583735fe38e1e92$var$LogLevel_1.default[type]}] ${this.name} - ${msg}`;
        switch(type){
            case $2583735fe38e1e92$var$LogLevel_1.default.ERROR:
                console.error(logMessage);
                break;
            case $2583735fe38e1e92$var$LogLevel_1.default.WARN:
                console.warn(logMessage);
                break;
            case $2583735fe38e1e92$var$LogLevel_1.default.DEBUG:
                console.debug(logMessage.replace(/\\r\\n/g, '\n'));
                break;
            case $2583735fe38e1e92$var$LogLevel_1.default.INFO:
                console.info(logMessage);
                break;
        }
    }
}
module.exports.default = $2583735fe38e1e92$var$ConsoleLogger;

});

parcelRegister("8btv2", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[NoOpVideoFrameProcessor]] implements [[VideoFrameProcessor]].
 * It's a no-op processor and input is passed to output directly.
 */ class $5f563bd571ca0720$var$NoOpVideoFrameProcessor {
    async process(buffers) {
        return buffers;
    }
    async destroy() {
        return;
    }
}
module.exports.default = $5f563bd571ca0720$var$NoOpVideoFrameProcessor;

});

parcelRegister("3gcvF", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $25fc91e66d2bafab$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $25fc91e66d2bafab$var$BackgroundBlurProcessorProvided_1 = $25fc91e66d2bafab$var$__importDefault((parcelRequire("iY5UT")));

var $fzQa8 = parcelRequire("fzQa8");
/**
 * The [[BackgroundBlurProcessorBuiltIn]] uses the browser's built-in capability to apply blurring to
 * the background image as apposed to [[BackgroundBlurProcessorProvided]] that uses WASM and
 * TensorFlow Lite to apply the blur.
 */ /** @internal */ class $25fc91e66d2bafab$var$BackgroundBlurProcessorBuiltIn extends $25fc91e66d2bafab$var$BackgroundBlurProcessorProvided_1.default {
    /**
     * A constructor that will apply default values if spec and strength are not provided.
     * If no spec is provided the selfie segmentation model is used with default paths to CDN for the
     * worker and wasm files used to process each frame.
     * @param spec The spec defines the assets that will be used for adding background blur to a frame.
     * @param options How much blur to apply to a frame.
     */ constructor(spec, options){
        super(spec, options);
        this.blurCanvas = document.createElement('canvas');
        this.blurCanvasCtx = this.blurCanvas.getContext('2d');
        this.blurCanvas.width = this.spec.model.input.width;
        this.blurCanvas.height = this.spec.model.input.height;
        this.logger.info('BackgroundBlur processor using builtin blur');
    }
    drawImageWithMask(inputCanvas, mask) {
        // Mask will not be set until the worker has completed handling the predict event. Until the first frame is processed,
        // the whole frame will be blurred.
        const blurredImage = this.blurredImage;
        const { canvasCtx: canvasCtx, targetCanvas: targetCanvas } = this;
        const { width: width, height: height } = targetCanvas;
        if (!mask || !blurredImage) {
            canvasCtx.clearRect(0, 0, width, height);
            return;
        }
        const scaledCtx = this.scaledCanvas.getContext('2d');
        scaledCtx.putImageData(mask, 0, 0);
        this.blurCanvasCtx.putImageData(this.blurredImage, 0, 0);
        // draw the mask
        canvasCtx.save();
        canvasCtx.clearRect(0, 0, width, height);
        canvasCtx.drawImage(this.scaledCanvas, 0, 0, width, height);
        // Only overwrite existing pixels.
        canvasCtx.globalCompositeOperation = 'source-in';
        // draw image over mask...
        canvasCtx.drawImage(inputCanvas, 0, 0, width, height);
        // draw under person
        canvasCtx.globalCompositeOperation = 'destination-over';
        canvasCtx.drawImage(this.blurCanvas, 0, 0, width, height);
        canvasCtx.restore();
    }
    setBlurStrength(blurStrength) {
        super.setBlurStrength(blurStrength);
        if (this.worker) {
            // live update
            this.modelInitialized = false;
            this.worker.postMessage({
                msg: 'destroy'
            });
            const model = this.spec.model;
            this.worker.postMessage({
                msg: 'loadModel',
                payload: {
                    modelUrl: model.path,
                    inputHeight: model.input.height,
                    inputWidth: model.input.width,
                    inputChannels: 4,
                    modelRangeMin: model.input.range[0],
                    modelRangeMax: model.input.range[1],
                    blurPixels: this.blurAmount
                }
            });
        }
    }
    setBlurPixels() {
        // the blurred image is sized down to 144, regardless of what the canvas size is, so
        // we use the default blur strengths (540p)
        this.blurAmount = $fzQa8.BlurStrengthMapper.getBlurAmount(this._blurStrength, {
            height: 540
        });
        this.logger.info(`background blur amount set to ${this.blurAmount}`);
    }
    handleInitialize(msg) {
        this.logger.info(`received initialize message: ${this.stringify(msg)}`);
        if (!msg.payload) {
            this.logger.error('failed to initialize module');
            this.initWorkerPromise.reject(new Error('failed to initialize the module'));
            return;
        }
        const model = this.spec.model;
        this.worker.postMessage({
            msg: 'loadModel',
            payload: {
                modelUrl: model.path,
                inputHeight: model.input.height,
                inputWidth: model.input.width,
                inputChannels: 4,
                modelRangeMin: model.input.range[0],
                modelRangeMax: model.input.range[1],
                blurPixels: this.blurAmount
            }
        });
        this.initWorkerPromise.resolve({});
    }
    handlePredict(msg) {
        this.blurredImage = msg.payload.blurOutput;
        super.handlePredict(msg);
    }
    async destroy() {
        var _a;
        super.destroy();
        (_a = this.blurCanvas) === null || _a === void 0 || _a.remove();
        this.blurCanvas = undefined;
    }
}
module.exports.default = $25fc91e66d2bafab$var$BackgroundBlurProcessorBuiltIn;

});
parcelRegister("iY5UT", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $dcf26b8256a75625$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $dcf26b8256a75625$var$BackgroundFilterProcessor_1 = $dcf26b8256a75625$var$__importDefault((parcelRequire("3Ffqq")));

var $fzQa8 = parcelRequire("fzQa8");

const $dcf26b8256a75625$var$BackgroundBlurVideoFrameProcessorDelegate_1 = $dcf26b8256a75625$var$__importDefault((parcelRequire("5WjJU")));
/**
 * [[BackgroundBlurProcessorProvided]] implements [[BackgroundBlurProcessor]].
 * It's a background blur processor and input is passed into a worker that will apply a segmentation
 * to separate the foreground from the background. Then the background will have a blur applied.
 *
 * The [[BackgroundBlurProcessorProvided]] uses WASM and TensorFlow Lite to apply the blurring of the
 * background image as apposed to [[BackgroundBlurProcessorBuiltIn]] that uses the browser's built-in
 * capability to apply the blur.
 */ /** @internal */ class $dcf26b8256a75625$var$BackgroundBlurProcessorProvided extends $dcf26b8256a75625$var$BackgroundFilterProcessor_1.default {
    validateOptions(options) {
        super.validateOptions(options);
        if (!options.blurStrength) throw new Error('processor has null options - blurStrength');
    }
    /**
     * A constructor that will apply default values if spec and strength are not provided.
     * If no spec is provided the selfie segmentation model is used with default paths to CDN for the
     * worker and wasm files used to process each frame.
     * @param spec The spec defines the assets that will be used for adding background blur to a frame
     * @param options How much blur to apply to a frame
     */ constructor(spec, options){
        super('background blur', spec, options, new $dcf26b8256a75625$var$BackgroundBlurVideoFrameProcessorDelegate_1.default());
        this.blurAmount = 0;
        this.setBlurStrength(options.blurStrength);
        this.logger.info('BackgroundBlur processor successfully created');
        this.logger.info(`BackgroundBlur spec: ${this.stringify(this.spec)}`);
        this.logger.info(`BackgroundBlur options: { blurStrength: ${options.blurStrength}, filterCPUUtilization: ${options.filterCPUUtilization}, reportingPeriodMillis: ${options.reportingPeriodMillis}}`);
    }
    initOnFirstExecution() {
        this.setBlurPixels();
    }
    drawImageWithMask(inputCanvas, mask) {
        // Mask will not be set until the worker has completed handling the predict event. Until the first frame is processed,
        // the whole frame will be blurred.
        if (!mask) mask = new ImageData(this.spec.model.input.width, this.spec.model.input.height);
        const scaledCtx = this.scaledCanvas.getContext('2d');
        scaledCtx.putImageData(mask, 0, 0);
        const { canvasCtx: canvasCtx, targetCanvas: targetCanvas } = this;
        const { width: width, height: height } = targetCanvas;
        // draw the mask
        canvasCtx.save();
        canvasCtx.clearRect(0, 0, width, height);
        canvasCtx.drawImage(this.scaledCanvas, 0, 0, width, height);
        // Only overwrite existing pixels.
        canvasCtx.globalCompositeOperation = 'source-in';
        // draw image over mask...
        canvasCtx.drawImage(inputCanvas, 0, 0, width, height);
        // draw under person
        canvasCtx.globalCompositeOperation = 'destination-over';
        canvasCtx.filter = `blur(${this.blurAmount}px)`;
        canvasCtx.drawImage(inputCanvas, 0, 0, targetCanvas.width, targetCanvas.height);
        canvasCtx.restore();
    }
    setBlurStrength(blurStrength) {
        this._blurStrength = blurStrength;
        this.logger.info(`blur strength set to ${this._blurStrength}`);
        this.setBlurPixels();
    }
    /**
     * Calculate the blur amount based on the blur strength passed in and height of the image being blurred.
     */ setBlurPixels() {
        this.blurAmount = $fzQa8.BlurStrengthMapper.getBlurAmount(this._blurStrength, {
            height: this.sourceHeight
        });
        this.logger.info(`background blur amount set to ${this.blurAmount}`);
    }
    addObserver(observer) {
        this.delegate.addObserver(observer);
    }
    removeObserver(observer) {
        this.delegate.removeObserver(observer);
    }
    static async isSupported() {
        const canvas = document.createElement('canvas');
        const supportsBlurFilter = canvas.getContext('2d').filter !== undefined;
        canvas.remove();
        return supportsBlurFilter;
    }
    /** @internal */ setEventController(eventController) {
        /*
        if this is a first time we set the eventController, need to publish the current BackgroundFilterConfig.
        Otherwise, just set the eventController.
        */ if (this.eventController) this.eventController = eventController;
        else {
            this.eventController = eventController;
            this.publishBackgroundFilterEvent();
        }
    }
    publishBackgroundFilterEvent() {
        const backgroundFilterEventAttributes = {
            backgroundBlurEnabled: 'true',
            backgroundBlurStrength: this._blurStrength,
            backgroundReplacementEnabled: 'false',
            backgroundFilterVersion: 1
        };
        this.eventController.publishEvent('backgroundFilterConfigSelected', backgroundFilterEventAttributes);
    }
}
module.exports.default = $dcf26b8256a75625$var$BackgroundBlurProcessorProvided;

});
parcelRegister("3Ffqq", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $2ab12a929ed4298c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BackgroundFilterMonitor = void 0;

var $aJA5z = parcelRequire("aJA5z");

const $2ab12a929ed4298c$var$CanvasVideoFrameBuffer_1 = $2ab12a929ed4298c$var$__importDefault((parcelRequire("ag7ui")));

const $2ab12a929ed4298c$var$BackgroundFilterFrameCounter_1 = $2ab12a929ed4298c$var$__importDefault((parcelRequire("8pFWY")));
/** @internal */ class $2ab12a929ed4298c$var$DeferredObservable {
    constructor(){
        /** Access the last-resolved value of next()
         */ this.value = undefined;
        this.resolve = null;
    }
    /** Create a promise that resolves once next() is called
     */ whenNext() {
        /* istanbul ignore else */ if (!this.promise) // externally-resolvable promise
        this.promise = new Promise((resolve)=>this.resolve = resolve);
        return this.promise;
    }
    /** Update the value and resolve
     */ next(value) {
        // store the value, for sync access
        this.value = value;
        // resolve the promise so anyone awaiting whenNext resolves
        this.resolve(value);
        // delete the promise so future whenNext calls get a new promise
        delete this.promise;
    }
}
/**
 * The [[BackgroundFilterProcessor]] uses WASM and TensorFlow Lite to apply changes to the
 * background image.
 */ /** @internal */ class $2ab12a929ed4298c$var$BackgroundFilterProcessor {
    static createWorkerPromise() {
        const resolver = {
            resolve: null,
            reject: null,
            promise: null
        };
        resolver.promise = new Promise((resolve, reject)=>{
            resolver.resolve = resolve;
            resolver.reject = reject;
        });
        return resolver;
    }
    /** Check if the input spec are not null
     */ validateSpec(spec) {
        if (!spec) throw new Error('processor has null spec');
        if (!spec.model) throw new Error('processor spec has null model');
        if (!spec.paths) throw new Error('processor spec has null paths');
    }
    validateOptions(options) {
        if (!options) throw new Error('processor has null options');
        if (!options.logger) throw new Error('processor has null options - logger');
        if (!options.reportingPeriodMillis) throw new Error('processor has null options - reportingPeriodMillis');
        if (!options.filterCPUUtilization) throw new Error('processor has null options - filterCPUUtilization');
    }
    constructor(filterType, spec, options, delegate, eventController){
        this.targetCanvas = document.createElement('canvas');
        this.canvasCtx = this.targetCanvas.getContext('2d');
        this.canvasVideoFrameBuffer = new $2ab12a929ed4298c$var$CanvasVideoFrameBuffer_1.default(this.targetCanvas);
        this.mask$ = new $2ab12a929ed4298c$var$DeferredObservable();
        this.sourceWidth = 0;
        this.sourceHeight = 0;
        this.frameNumber = 0;
        this.videoFramesPerFilterUpdate = 1;
        this.initWorkerPromise = $2ab12a929ed4298c$var$BackgroundFilterProcessor.createWorkerPromise();
        this.loadModelPromise = $2ab12a929ed4298c$var$BackgroundFilterProcessor.createWorkerPromise();
        this.modelInitialized = false;
        this.destroyed = false;
        this.filterType = filterType;
        this.validateSpec(spec);
        this.validateOptions(options);
        this.spec = spec;
        this.logger = options.logger;
        this.delegate = delegate;
        this.initCPUMonitor(options);
        this.eventController = eventController;
    }
    initCPUMonitor(options) {
        const CPU_MONITORING_PERIOD_MILLIS = 5000;
        const MAX_SEGMENTATION_SKIP_RATE = 10;
        const MIN_SEGMENTATION_SKIP_RATE = 1;
        this.videoFramesPerFilterUpdate = 1;
        this.frameCounter = new $2ab12a929ed4298c$var$BackgroundFilterFrameCounter_1.default(this.delegate, options.reportingPeriodMillis, options.filterCPUUtilization, this.logger);
        this.cpuMonitor = new $2ab12a929ed4298c$var$BackgroundFilterMonitor(CPU_MONITORING_PERIOD_MILLIS, {
            reduceCPUUtilization: ()=>{
                this.updateVideoFramesPerFilterUpdate(Math.min(this.videoFramesPerFilterUpdate + 1, MAX_SEGMENTATION_SKIP_RATE));
            },
            increaseCPUUtilization: ()=>{
                this.updateVideoFramesPerFilterUpdate(Math.max(this.videoFramesPerFilterUpdate - 1, MIN_SEGMENTATION_SKIP_RATE));
            }
        });
        this.delegate.addObserver(this.cpuMonitor);
    }
    /** Converts a value to a JSON string
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    stringify(value) {
        return JSON.stringify(value, null, 2);
    }
    /**
     * Sends a message to worker and resolves promise in response to worker's initialize event
     */ handleInitialize(msg) {
        this.logger.info(`received initialize message: ${this.stringify(msg)}`);
        if (!msg.payload) {
            this.logger.error('failed to initialize module');
            this.initWorkerPromise.reject(new Error('failed to initialize the module'));
            return;
        }
        const model = this.spec.model;
        this.worker.postMessage({
            msg: 'loadModel',
            payload: {
                modelUrl: model.path,
                inputHeight: model.input.height,
                inputWidth: model.input.width,
                inputChannels: 4,
                modelRangeMin: model.input.range[0],
                modelRangeMax: model.input.range[1],
                blurPixels: 0
            }
        });
        this.initWorkerPromise.resolve({});
    }
    /**
     * Resolves promise in response to worker's loadModel event
     */ handleLoadModel(msg) {
        this.logger.info(`received load model message: ${this.stringify(msg)}`);
        if (msg.payload !== 2) {
            this.logger.error('failed to load model! status: ' + msg.payload);
            /** Rejects model promise
             */ this.loadModelPromise.reject(new Error('failed to load model! status: ' + msg.payload));
            return;
        }
        this.modelInitialized = true;
        this.loadModelPromise.resolve({});
    }
    /** Updates the payload output value in response to worker's predict event
     */ handlePredict(msg) {
        this.mask$.next(msg.payload.output);
    }
    /**
     * This method will handle the asynchronous messaging between the main JS thread
     * and the worker thread.
     * @param evt An event that was sent from the worker to the JS thread.
     * @returns
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleWorkerEvent(evt) {
        const msg = evt.data;
        switch(msg.msg){
            case 'initialize':
                this.handleInitialize(msg);
                break;
            case 'loadModel':
                this.handleLoadModel(msg);
                break;
            case 'predict':
                this.handlePredict(msg);
                break;
            default:
                this.logger.info(`unexpected event msg: ${this.stringify(msg)}`);
                break;
        }
    }
    /**
     * This method initializes all of the resource necessary to processs background filter. It returns
     * a promise and resolves or rejects the promise once the initialization is complete.
     * @returns
     * @throws An error will be thrown
     */ async loadAssets() {
        this.logger.info('start initializing the processor');
        try {
            this.worker = await (0, $aJA5z.loadWorker)(this.spec.paths.worker, 'BackgroundFilterWorker', {}, null);
            this.worker.addEventListener('message', (ev)=>this.handleWorkerEvent(ev));
            this.worker.postMessage({
                msg: 'initialize',
                payload: {
                    wasmPath: this.spec.paths.wasm,
                    simdPath: this.spec.paths.simd
                }
            });
            await this.initWorkerPromise.promise;
            this.logger.info(`successfully initialized the ${this.filterType} worker`);
            await this.loadModelPromise.promise;
            this.logger.info(`successfully loaded ${this.filterType} worker segmentation model`);
        } catch (error) {
            throw new Error(`could not initialize the ${this.filterType} video frame processor due to '${error.message}'`);
        }
        this.logger.info(`successfully initialized the ${this.filterType} processor`);
    }
    /**
     * Processes the VideoFrameBuffer by applying a segmentation mask and replacing the background.
     * @param buffers object that contains the canvas element that will be used to obtain the image data to process
     * @returns the updated buffer that contains the image with the background replaced.
     */ async process(buffers) {
        if (this.destroyed) return buffers;
        this.frameCounter.frameReceived(buffers[0].framerate);
        this.cpuMonitor.frameReceived();
        const inputCanvas = buffers[0].asCanvasElement();
        if (!inputCanvas) return buffers;
        if (!this.modelInitialized) {
            // return existing buffer, if any
            buffers[0] = this.canvasVideoFrameBuffer;
            return buffers;
        }
        const frameWidth = inputCanvas.width;
        const frameHeight = inputCanvas.height;
        if (frameWidth === 0 || frameHeight === 0) return buffers;
        // on first execution of process the source width will be zero
        if (this.sourceWidth === 0) {
            this.sourceWidth = frameWidth;
            this.sourceHeight = frameHeight;
            // update target canvas size to match the frame size
            this.targetCanvas.width = this.sourceWidth;
            this.targetCanvas.height = this.sourceHeight;
            this.logger.info(`${this.filterType} source width: ${this.sourceWidth}`);
            this.logger.info(`${this.filterType} source height: ${this.sourceHeight}`);
            this.initOnFirstExecution();
        }
        if (this.sourceWidth !== frameWidth || this.sourceHeight !== frameHeight) {
            this.sourceWidth = frameWidth;
            this.sourceHeight = frameHeight;
            // update target canvas size to match the frame size
            this.targetCanvas.width = this.sourceWidth;
            this.targetCanvas.height = this.sourceHeight;
        }
        try {
            this.frameCounter.filterSubmitted();
            let mask = this.mask$.value;
            const hscale = this.spec.model.input.width / inputCanvas.width;
            const vscale = this.spec.model.input.height / inputCanvas.height;
            if (this.scaledCanvas === undefined) {
                this.scaledCanvas = document.createElement('canvas');
                this.scaledCanvas.width = this.spec.model.input.width;
                this.scaledCanvas.height = this.spec.model.input.height;
            }
            const scaledCtx = this.scaledCanvas.getContext('2d');
            scaledCtx.save();
            scaledCtx.scale(hscale, vscale);
            scaledCtx.drawImage(inputCanvas, 0, 0);
            scaledCtx.restore();
            const imageData = scaledCtx.getImageData(0, 0, this.scaledCanvas.width, this.scaledCanvas.height);
            // update the filter mask based on the filter update rate
            if (this.frameNumber % this.videoFramesPerFilterUpdate === 0) {
                // process frame...
                const maskPromise = this.mask$.whenNext();
                this.worker.postMessage({
                    msg: 'predict',
                    payload: imageData
                }, [
                    imageData.data.buffer
                ]);
                mask = await maskPromise;
            }
            // It's possible that while waiting for the predict to complete the processor was destroyed.
            // adding a destroyed check here to ensure the implementation of drawImageWithMask does not throw
            // an error due to destroyed processor.
            if (!this.destroyed) this.drawImageWithMask(inputCanvas, mask);
        } catch (error) {
            this.logger.error(`could not process ${this.filterType} frame buffer due to ${error}`);
            return buffers;
        } finally{
            this.frameCounter.filterComplete();
            this.frameNumber++;
        }
        buffers[0] = this.canvasVideoFrameBuffer;
        return buffers;
    }
    updateVideoFramesPerFilterUpdate(newRate) {
        if (newRate !== this.videoFramesPerFilterUpdate) {
            this.videoFramesPerFilterUpdate = newRate;
            this.logger.info(`Adjusting filter rate to compensate for CPU utilization. ` + `Filter rate is ${this.videoFramesPerFilterUpdate} video frames per filter.`);
        }
    }
    /**
     * Clean up processor resources
     */ async destroy() {
        var _a, _b, _c, _d;
        this.destroyed = true;
        this.delegate.removeObserver(this.cpuMonitor);
        this.canvasVideoFrameBuffer.destroy();
        (_a = this.worker) === null || _a === void 0 || _a.postMessage({
            msg: 'destroy'
        });
        (_b = this.worker) === null || _b === void 0 || _b.postMessage({
            msg: 'stop'
        });
        (_c = this.targetCanvas) === null || _c === void 0 || _c.remove();
        this.targetCanvas = undefined;
        (_d = this.scaledCanvas) === null || _d === void 0 || _d.remove();
        this.scaledCanvas = undefined;
        this.logger.info(`${this.filterType} frame process destroyed`);
    }
}
module.exports.default = $2ab12a929ed4298c$var$BackgroundFilterProcessor;
/** @internal */ class $2ab12a929ed4298c$var$BackgroundFilterMonitor {
    constructor(monitoringPeriodMillis, observer){
        this.monitoringPeriodMillis = monitoringPeriodMillis;
        this.observer = observer;
        this.lastCPUChangeTimestamp = 0;
    }
    filterCPUUtilizationHigh() {
        const timestamp = Date.now();
        // Allow some time to pass before we check CPU utilization.
        if (timestamp - this.lastCPUChangeTimestamp >= this.monitoringPeriodMillis) {
            this.lastCPUChangeTimestamp = timestamp;
            this.observer.reduceCPUUtilization();
        }
    }
    frameReceived() {
        const timestamp = Date.now();
        // If a enough time has passed, reset the processor and continue to monitor
        if (timestamp - this.lastCPUChangeTimestamp >= this.monitoringPeriodMillis * 2) {
            this.lastCPUChangeTimestamp = timestamp;
            this.observer.increaseCPUUtilization();
        }
    }
}
module.exports.BackgroundFilterMonitor = $2ab12a929ed4298c$var$BackgroundFilterMonitor;

});
parcelRegister("ag7ui", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[CanvasVideoFrameBuffer]] implements [[VideoFrameBuffer]]. It internally holds an `HTMLCanvasElement`.
 */ class $778134ea9d148b7b$var$CanvasVideoFrameBuffer {
    constructor(canvas){
        this.canvas = canvas;
        this.destroyed = false;
    }
    destroy() {
        this.canvas = null;
        this.destroyed = true;
    }
    async asCanvasImageSource() {
        if (this.destroyed) return Promise.reject('canvas buffer is destroyed');
        return Promise.resolve(this.canvas);
    }
    asCanvasElement() {
        return this.canvas;
    }
}
module.exports.default = $778134ea9d148b7b$var$CanvasVideoFrameBuffer;

});

parcelRegister("8pFWY", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $620132f91348b172$var$FILTER_DURATION_FACTOR = 0.8;
/**
 * The frame counter tracks frame rates of video and segmentation.
 */ /** @internal */ class $620132f91348b172$var$BackgroundFilterFrameCounter {
    constructor(delegate, reportingPeriodMillis, filterCPUUtilization, logger){
        this.delegate = delegate;
        this.reportingPeriodMillis = reportingPeriodMillis;
        this.filterCPUUtilization = filterCPUUtilization;
        this.logger = logger;
        this._processingFilter = true;
        this.lastReportedEventTimestamp = 0;
        this.lastFilterCompleteTimestamp = 0;
        this.filterTotalMillis = 0;
        this.filterCount = 0;
        this.framerate = 0;
        this.filterDurationNotifyMillis = 0;
        this.setSegmentationDuration();
    }
    /**
     * Report events once per period.
     */ reportEvent(timestamp) {
        const timeDiff = timestamp - this.lastReportedEventTimestamp;
        if (timeDiff >= this.reportingPeriodMillis) {
            const currentFilterCount = this.filterCount;
            const currentFilterTotalMillis = this.filterTotalMillis;
            this.filterCount = 0;
            this.filterTotalMillis = 0;
            this.lastReportedEventTimestamp = timestamp;
            // Do not send notification unless a valid framerate or segment count is set.
            if (this.framerate === 0 || currentFilterCount === 0) return;
            const avgFilterDurationMillis = Math.round(currentFilterTotalMillis / currentFilterCount);
            const framesDropped = Math.round(this.framerate * (timeDiff / 1000)) - currentFilterCount;
            const cpuUtilization = Math.round(100 * currentFilterTotalMillis / timeDiff);
            if (avgFilterDurationMillis >= this.filterDurationNotifyMillis) this.delegate.filterFrameDurationHigh({
                framesDropped: framesDropped,
                avgFilterDurationMillis: avgFilterDurationMillis,
                framerate: this.framerate,
                periodMillis: timeDiff
            });
            if (cpuUtilization >= this.filterCPUUtilization) this.delegate.filterCPUUtilizationHigh({
                cpuUtilization: cpuUtilization,
                filterMillis: currentFilterTotalMillis,
                periodMillis: timeDiff
            });
        }
    }
    setSegmentationDuration() {
        // allow filtering to take up to 80% of the expected frame duration
        this.filterDurationNotifyMillis = Math.round(1000 / this.framerate * $620132f91348b172$var$FILTER_DURATION_FACTOR);
    }
    frameReceived(framerate) {
        if (framerate !== this.framerate) {
            this.framerate = framerate;
            this.logger.info(`frame counter setting frame rate to ${this.framerate}`);
            this.setSegmentationDuration();
        }
        const timestamp = Date.now();
        this.reportEvent(timestamp);
    }
    filterSubmitted() {
        this._processingFilter = true;
        this.lastFilterCompleteTimestamp = Date.now();
    }
    filterComplete() {
        this.filterTotalMillis += Date.now() - this.lastFilterCompleteTimestamp;
        this._processingFilter = false;
        this.filterCount++;
    }
    get processingSegment() {
        return this._processingFilter;
    }
}
module.exports.default = $620132f91348b172$var$BackgroundFilterFrameCounter;

});


parcelRegister("5WjJU", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $011db45c643a7622$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $011db45c643a7622$var$BackgroundFilterVideoFrameProcessorDelegate_1 = $011db45c643a7622$var$__importDefault((parcelRequire("3Hnjm")));
/**
 * This class adds the functionality to allow for a set of unique observers to be added to the
 * video frame processor.
 */ /** @internal */ class $011db45c643a7622$var$BackgroundBlurVideoFrameProcessorDelegate extends $011db45c643a7622$var$BackgroundFilterVideoFrameProcessorDelegate_1.default {
}
module.exports.default = $011db45c643a7622$var$BackgroundBlurVideoFrameProcessorDelegate;

});
parcelRegister("3Hnjm", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * This class adds the functionality to allow for a set of unique observers to be added to the
 * video frame processor.
 */ /** @internal */ class $2b17785fc13467aa$var$BackgroundFilterVideoFrameProcessorDelegate {
    constructor(){
        this.observers = new Set();
    }
    /**
     * Add an observer to the unique set. If a duplicate observer cannot be added.
     * @param observer An implementation of the observer interface.
     */ addObserver(observer) {
        this.observers.add(observer);
    }
    /**
     * Remove the observer from the set of observers.
     * @param observer An implementation of the observer interface.
     */ removeObserver(observer) {
        this.observers.delete(observer);
    }
    /**
     * Call the observer method with the event information. See [[BackgroundFilterVideoFrameProcessorObserver]]
     * for detailed info on this event.
     * @param event
     */ filterFrameDurationHigh(event) {
        var _a;
        for (const observer of this.observers)(_a = observer.filterFrameDurationHigh) === null || _a === void 0 || _a.call(observer, event);
    }
    filterCPUUtilizationHigh(event) {
        var _a;
        for (const observer of this.observers)(_a = observer.filterCPUUtilizationHigh) === null || _a === void 0 || _a.call(observer, event);
    }
}
module.exports.default = $2b17785fc13467aa$var$BackgroundFilterVideoFrameProcessorDelegate;

});





parcelRegister("5LciV", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $431ae2e858a0e5d8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $431ae2e858a0e5d8$var$BackgroundFilterVideoFrameProcessor_1 = $431ae2e858a0e5d8$var$__importDefault((parcelRequire("5nMOz")));

const $431ae2e858a0e5d8$var$ConsoleLogger_1 = $431ae2e858a0e5d8$var$__importDefault((parcelRequire("3dGmS")));

const $431ae2e858a0e5d8$var$LogLevel_1 = $431ae2e858a0e5d8$var$__importDefault((parcelRequire("aSYjG")));

const $431ae2e858a0e5d8$var$NoOpVideoFrameProcessor_1 = $431ae2e858a0e5d8$var$__importDefault((parcelRequire("8btv2")));

const $431ae2e858a0e5d8$var$BackgroundReplacementFilter_1 = $431ae2e858a0e5d8$var$__importDefault((parcelRequire("4ApXR")));
/**
 * No-op implementation of the background replacement processor. An instance of this class will be returned when a user attempts
 * to create a background replacement processor when it is not supported.
 */ /** @internal */ class $431ae2e858a0e5d8$var$NoOpBackgroundReplacementProcessor extends $431ae2e858a0e5d8$var$NoOpVideoFrameProcessor_1.default {
    /**
     * no-op
     * @returns
     */ async loadAssets() {
        return;
    }
    /**
     * no-op
     */ addObserver() {}
    /**
     * no-op
     */ removeObserver() {}
    /**
     * no-op
     */ async setImageBlob() {
        return;
    }
}
/**
 * [[BackgroundReplacementVideoFrameProcessor]]
 * Creates a background replacement processor which identifies the foreground person and replaces the background.
 */ class $431ae2e858a0e5d8$var$BackgroundReplacementVideoFrameProcessor extends $431ae2e858a0e5d8$var$BackgroundFilterVideoFrameProcessor_1.default {
    /**
     * A factory method that will call the private constructor to instantiate the processor and asynchronously
     * initialize the worker, wasm, and ML models. Upon completion of the initialization the promise will either
     * be resolved or rejected.
     * @param spec The spec defines the assets that will be used for adding background filter to a frame
     * @param options Background replacement options including image path
     */ static async create(spec, options) {
        spec = this.resolveSpec(spec);
        options = this.resolveOptions(options);
        await this.resolveOptionsAsync(options);
        const { logger: logger } = options;
        const supported = await $431ae2e858a0e5d8$var$BackgroundReplacementVideoFrameProcessor.isSupported(spec, options);
        // if background replacement is not supported do not initialize. The processor will become a no op if not supported.
        if (!supported) {
            logger.warn('Using no-op processor because background replacement is not supported');
            return new $431ae2e858a0e5d8$var$NoOpBackgroundReplacementProcessor();
        }
        logger.info('Using background replacement filter');
        const processor = new $431ae2e858a0e5d8$var$BackgroundReplacementFilter_1.default(spec, options);
        await processor.loadAssets();
        return processor;
    }
    /**
     * Based on the options that are passed in set defaults for options
     * @param options  the options that are passed in
     * @returns An updated set of options with defaults set
     */ static resolveOptions(options = {}) {
        const processorOptions = {
            ...options
        };
        if (!processorOptions.logger) processorOptions.logger = new $431ae2e858a0e5d8$var$ConsoleLogger_1.default('BackgroundReplacementProcessor', $431ae2e858a0e5d8$var$LogLevel_1.default.INFO);
        return super.resolveOptions(processorOptions);
    }
    static async resolveOptionsAsync(options) {
        if (!options.imageBlob) {
            const canvas = document.createElement('canvas');
            canvas.width = 100;
            canvas.height = 100;
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = 'blue';
            ctx.fillRect(0, 0, 100, 100);
            const blob = await new Promise((resolve)=>{
                canvas.toBlob(resolve);
            });
            options.imageBlob = blob;
        }
        return;
    }
    /**
     * This method will detect the environment in which it is being used and determine if background
     * replacement can be used.
     * @param spec The {@link BackgroundFilterSpec} spec that will be used to initialize assets
     * @param options options such as logger and imagePath
     * @returns a boolean promise that will resolve to true if supported and false if not
     */ static async isSupported(spec, options) {
        spec = this.resolveSpec(spec);
        options = this.resolveOptions(options);
        await this.resolveOptionsAsync(options);
        const imageBlob = options.imageBlob;
        const imageUrl = URL.createObjectURL(imageBlob);
        try {
            await $431ae2e858a0e5d8$var$BackgroundReplacementFilter_1.default.loadImage(imageUrl);
        } catch (e) {
            options.logger.info(`Failed to fetch load replacement image ${e.message}`);
            return false;
        } finally{
            URL.revokeObjectURL(imageUrl);
        }
        return super.isSupported(spec, options);
    }
}
module.exports.default = $431ae2e858a0e5d8$var$BackgroundReplacementVideoFrameProcessor;

});
parcelRegister("4ApXR", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $356eaa346c65c78e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $356eaa346c65c78e$var$BackgroundFilterProcessor_1 = $356eaa346c65c78e$var$__importDefault((parcelRequire("3Ffqq")));

const $356eaa346c65c78e$var$BackgroundReplacementVideoFrameProcessorDelegate_1 = $356eaa346c65c78e$var$__importDefault((parcelRequire("fFVDu")));
/**
 * [[BackgroundReplacementFilter]] implements [[BackgroundReplacementProcessor]].
 * It's a background replacement processor and input is passed into a worker that will apply a segmentation
 * to separate the foreground from the background. Then the background will have a replacement applied.
 *
 * The [[BackgroundReplacementProcessorProvided]] uses WASM and TensorFlow Lite to apply replacement of the
 * background image.
 */ /** @internal */ class $356eaa346c65c78e$var$BackgroundReplacementFilter extends $356eaa346c65c78e$var$BackgroundFilterProcessor_1.default {
    /**
     * A constructor that will apply default values if spec and strength are not provided.
     * If no spec is provided the selfie segmentation model is used with default paths to CDN for the
     * worker and wasm files used to process each frame.
     * @param spec The spec defines the assets that will be used for adding background filter to a frame
     * @param options The background replacement image path
     */ constructor(spec, options){
        super('background replacement', spec, options, new $356eaa346c65c78e$var$BackgroundReplacementVideoFrameProcessorDelegate_1.default());
        this.replacementBlob = options.imageBlob;
        this.logger.info('BackgroundReplacement processor successfully created');
        this.logger.info(`BackgroundReplacement spec: ${this.stringify(this.spec)}`);
        this.logger.info(`BackgroundReplacement options: { filterCPUUtilization: ${options.filterCPUUtilization}, reportingPeriodMillis: ${options.reportingPeriodMillis}}`);
    }
    async setImageBlob(blob) {
        this.replacementBlob = blob;
        this.replacementImage = await $356eaa346c65c78e$var$BackgroundReplacementFilter.loadImage(this.createReplacementObjectUrl());
    }
    initOnFirstExecution() {}
    drawImageWithMask(inputCanvas, mask) {
        // Mask will not be set until the worker has completed handling the predict event. Until the first frame is processed,
        // the whole frame will be replaced.
        if (!mask) mask = new ImageData(this.spec.model.input.width, this.spec.model.input.height);
        const scaledCtx = this.scaledCanvas.getContext('2d');
        scaledCtx.putImageData(mask, 0, 0);
        const { canvasCtx: canvasCtx, targetCanvas: targetCanvas } = this;
        const { width: width, height: height } = targetCanvas;
        // draw the mask
        canvasCtx.save();
        canvasCtx.clearRect(0, 0, width, height);
        canvasCtx.drawImage(this.scaledCanvas, 0, 0, width, height);
        // Only overwrite existing pixels.
        canvasCtx.globalCompositeOperation = 'source-in';
        // draw image over mask...
        canvasCtx.drawImage(inputCanvas, 0, 0, width, height);
        // draw under person
        canvasCtx.globalCompositeOperation = 'destination-over';
        canvasCtx.drawImage(this.replacementImage, 0, 0, targetCanvas.width, targetCanvas.height);
        canvasCtx.restore();
    }
    /* istanbul ignore next */ static loadImageExecutor(resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reject, imageUrl) {
        const image = new Image();
        image.crossOrigin = 'Anonymous';
        image.addEventListener('load', ()=>{
            resolve(image);
        }, false);
        image.addEventListener('error', (error)=>{
            reject(new Error(`Could not load replacement image ${image.src}: ${error.message}`));
        }, false);
        image.src = imageUrl;
    }
    /** @internal */ static async loadImage(imageUrl) {
        return new Promise((resolve, reject)=>this.loadImageExecutor(resolve, reject, imageUrl));
    }
    revokeReplacementObjectUrl() {
        if (this.replacementObjectUrl) URL.revokeObjectURL(this.replacementObjectUrl);
    }
    createReplacementObjectUrl() {
        this.revokeReplacementObjectUrl();
        this.replacementObjectUrl = URL.createObjectURL(this.replacementBlob);
        return this.replacementObjectUrl;
    }
    /**
     * This method initializes all of the resource necessary to process background replacement. It returns
     * a promise and resolves or rejects the promise once the initialization is complete.
     * @returns
     * @throws An error will be thrown
     */ async loadAssets() {
        this.replacementImage = await $356eaa346c65c78e$var$BackgroundReplacementFilter.loadImage(this.createReplacementObjectUrl());
        super.loadAssets();
        return;
    }
    addObserver(observer) {
        this.delegate.addObserver(observer);
    }
    removeObserver(observer) {
        this.delegate.removeObserver(observer);
    }
    async destroy() {
        super.destroy();
        this.revokeReplacementObjectUrl();
    }
    /** @internal */ setEventController(eventController) {
        /*
        if this is a first time we set the eventController, need to publish the current BackgroundFilterConfig.
        Otherwise, just set the eventController.
        */ if (this.eventController) this.eventController = eventController;
        else {
            this.eventController = eventController;
            this.publishBackgroundFilterEvent();
        }
    }
    publishBackgroundFilterEvent() {
        const backgroundFilterEventAttributes = {
            backgroundBlurEnabled: 'false',
            backgroundBlurStrength: 'low',
            backgroundReplacementEnabled: 'true',
            backgroundFilterVersion: 1
        };
        this.eventController.publishEvent('backgroundFilterConfigSelected', backgroundFilterEventAttributes);
    }
}
module.exports.default = $356eaa346c65c78e$var$BackgroundReplacementFilter;

});
parcelRegister("fFVDu", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $b69764abb84e9f50$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $b69764abb84e9f50$var$BackgroundFilterVideoFrameProcessorDelegate_1 = $b69764abb84e9f50$var$__importDefault((parcelRequire("3Hnjm")));
/**
 * This class adds the functionality to allow for a set of unique observers to be added to the
 * video frame processor.
 */ /** @internal */ class $b69764abb84e9f50$var$BackgroundReplacementVideoFrameProcessorDelegate extends $b69764abb84e9f50$var$BackgroundFilterVideoFrameProcessorDelegate_1.default {
}
module.exports.default = $b69764abb84e9f50$var$BackgroundReplacementVideoFrameProcessorDelegate;

});



parcelRegister("j8TgN", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $def9a31ebd214b7d$var$BaseConnectionHealthPolicy {
    constructor(configuration, data, name){
        this.minHealth = configuration.minHealth;
        this.maxHealth = configuration.maxHealth;
        this.currentHealth = configuration.initialHealth;
        this.currentData = data.clone();
        this.name = name;
    }
    minimumHealth() {
        return this.minHealth;
    }
    maximumHealth() {
        return this.maxHealth;
    }
    health() {
        return this.maximumHealth();
    }
    update(connectionHealthData) {
        this.currentData = connectionHealthData;
    }
    getConnectionHealthData() {
        return this.currentData.clone();
    }
    healthy() {
        return this.health() > this.minimumHealth();
    }
    healthIfChanged() {
        const newHealth = this.health();
        if (newHealth !== this.currentHealth) {
            this.currentHealth = newHealth;
            return newHealth;
        }
        return null;
    }
}
module.exports.default = $def9a31ebd214b7d$var$BaseConnectionHealthPolicy;

});

parcelRegister("la1Bs", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $f67bc68312ba7b5b$var$BitrateParameters {
}
module.exports.default = $f67bc68312ba7b5b$var$BitrateParameters;

});

parcelRegister("6l4nm", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $49d81928ace85b65$var$CSPMonitor {
    /* istanbul ignore next */ static register() {
        if (!('document' in $parcel$global) || !document.addEventListener) return;
        if ($49d81928ace85b65$var$CSPMonitor.shouldRegisterCSPMonitor) {
            if (!$49d81928ace85b65$var$CSPMonitor.added) {
                document.addEventListener('securitypolicyviolation', $49d81928ace85b65$var$CSPMonitor.listener);
                $49d81928ace85b65$var$CSPMonitor.added = true;
            }
        }
    }
    /* istanbul ignore next */ static unregister() {
        if (!('document' in $parcel$global) || !document.removeEventListener) return;
        document.removeEventListener('securitypolicyviolation', $49d81928ace85b65$var$CSPMonitor.listener);
        $49d81928ace85b65$var$CSPMonitor.loggers = new Set();
        $49d81928ace85b65$var$CSPMonitor.added = false;
    }
    static disable() {
        $49d81928ace85b65$var$CSPMonitor.shouldRegisterCSPMonitor = false;
        $49d81928ace85b65$var$CSPMonitor.unregister();
    }
    static addLogger(logger) {
        if (logger) $49d81928ace85b65$var$CSPMonitor.loggers.add(logger);
    }
    static removeLogger(logger) {
        if (logger) $49d81928ace85b65$var$CSPMonitor.loggers.delete(logger);
    }
}
$49d81928ace85b65$var$CSPMonitor.loggers = new Set();
$49d81928ace85b65$var$CSPMonitor.shouldRegisterCSPMonitor = true;
$49d81928ace85b65$var$CSPMonitor.added = false;
/* istanbul ignore next */ $49d81928ace85b65$var$CSPMonitor.listener = (event)=>{
    const message = 'Security Policy Violation\n' + `Blocked URI: ${event.blockedURI}\n` + `Violated Directive: ${event.violatedDirective}\n` + `Original Policy: ${event.originalPolicy}\n` + `Document URI: ${event.documentURI}\n` + `Source File: ${event.sourceFile}\n` + `Line No.: ${event.lineNumber}\n`;
    for (const logger of $49d81928ace85b65$var$CSPMonitor.loggers)logger.error(message);
    if ($49d81928ace85b65$var$CSPMonitor.loggers.size === 0) console.error(message);
};
module.exports.default = $49d81928ace85b65$var$CSPMonitor;

});

parcelRegister("6J1Iy", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CheckAudioConnectivityFeedback = void 0;
var $4e584722f9b21e22$var$CheckAudioConnectivityFeedback;
(function(CheckAudioConnectivityFeedback) {
    CheckAudioConnectivityFeedback[CheckAudioConnectivityFeedback["Succeeded"] = 0] = "Succeeded";
    CheckAudioConnectivityFeedback[CheckAudioConnectivityFeedback["AudioInputRequestFailed"] = 1] = "AudioInputRequestFailed";
    CheckAudioConnectivityFeedback[CheckAudioConnectivityFeedback["AudioInputPermissionDenied"] = 2] = "AudioInputPermissionDenied";
    CheckAudioConnectivityFeedback[CheckAudioConnectivityFeedback["ConnectionFailed"] = 3] = "ConnectionFailed";
    CheckAudioConnectivityFeedback[CheckAudioConnectivityFeedback["AudioNotReceived"] = 4] = "AudioNotReceived";
})($4e584722f9b21e22$var$CheckAudioConnectivityFeedback || (module.exports.CheckAudioConnectivityFeedback = $4e584722f9b21e22$var$CheckAudioConnectivityFeedback = {}));
module.exports.default = $4e584722f9b21e22$var$CheckAudioConnectivityFeedback;

});

parcelRegister("foAfi", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CheckAudioInputFeedback = void 0;
var $b3553691a1b19f76$var$CheckAudioInputFeedback;
(function(CheckAudioInputFeedback) {
    CheckAudioInputFeedback[CheckAudioInputFeedback["Succeeded"] = 0] = "Succeeded";
    CheckAudioInputFeedback[CheckAudioInputFeedback["Failed"] = 1] = "Failed";
    CheckAudioInputFeedback[CheckAudioInputFeedback["PermissionDenied"] = 2] = "PermissionDenied";
})($b3553691a1b19f76$var$CheckAudioInputFeedback || (module.exports.CheckAudioInputFeedback = $b3553691a1b19f76$var$CheckAudioInputFeedback = {}));
module.exports.default = $b3553691a1b19f76$var$CheckAudioInputFeedback;

});

parcelRegister("bbZBv", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CheckAudioOutputFeedback = void 0;
var $8260820d14f8b293$var$CheckAudioOutputFeedback;
(function(CheckAudioOutputFeedback) {
    CheckAudioOutputFeedback[CheckAudioOutputFeedback["Succeeded"] = 0] = "Succeeded";
    CheckAudioOutputFeedback[CheckAudioOutputFeedback["Failed"] = 1] = "Failed";
})($8260820d14f8b293$var$CheckAudioOutputFeedback || (module.exports.CheckAudioOutputFeedback = $8260820d14f8b293$var$CheckAudioOutputFeedback = {}));
module.exports.default = $8260820d14f8b293$var$CheckAudioOutputFeedback;

});

parcelRegister("iMyKq", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CheckCameraResolutionFeedback = void 0;
var $dac7a9e275f0431e$var$CheckCameraResolutionFeedback;
(function(CheckCameraResolutionFeedback) {
    CheckCameraResolutionFeedback[CheckCameraResolutionFeedback["Succeeded"] = 0] = "Succeeded";
    CheckCameraResolutionFeedback[CheckCameraResolutionFeedback["Failed"] = 1] = "Failed";
    CheckCameraResolutionFeedback[CheckCameraResolutionFeedback["ResolutionNotSupported"] = 2] = "ResolutionNotSupported";
    CheckCameraResolutionFeedback[CheckCameraResolutionFeedback["PermissionDenied"] = 3] = "PermissionDenied";
})($dac7a9e275f0431e$var$CheckCameraResolutionFeedback || (module.exports.CheckCameraResolutionFeedback = $dac7a9e275f0431e$var$CheckCameraResolutionFeedback = {}));
module.exports.default = $dac7a9e275f0431e$var$CheckCameraResolutionFeedback;

});

parcelRegister("iqEpI", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CheckContentShareConnectivityFeedback = void 0;
var $d6aa0106819fb2ae$var$CheckContentShareConnectivityFeedback;
(function(CheckContentShareConnectivityFeedback) {
    CheckContentShareConnectivityFeedback[CheckContentShareConnectivityFeedback["Succeeded"] = 0] = "Succeeded";
    CheckContentShareConnectivityFeedback[CheckContentShareConnectivityFeedback["Failed"] = 1] = "Failed";
    CheckContentShareConnectivityFeedback[CheckContentShareConnectivityFeedback["PermissionDenied"] = 2] = "PermissionDenied";
    CheckContentShareConnectivityFeedback[CheckContentShareConnectivityFeedback["TimedOut"] = 3] = "TimedOut";
    CheckContentShareConnectivityFeedback[CheckContentShareConnectivityFeedback["ConnectionFailed"] = 4] = "ConnectionFailed";
})($d6aa0106819fb2ae$var$CheckContentShareConnectivityFeedback || (module.exports.CheckContentShareConnectivityFeedback = $d6aa0106819fb2ae$var$CheckContentShareConnectivityFeedback = {}));
module.exports.default = $d6aa0106819fb2ae$var$CheckContentShareConnectivityFeedback;

});

parcelRegister("cDrWL", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CheckNetworkTCPConnectivityFeedback = void 0;
var $932ece3004eb04b9$var$CheckNetworkTCPConnectivityFeedback;
(function(CheckNetworkTCPConnectivityFeedback) {
    CheckNetworkTCPConnectivityFeedback[CheckNetworkTCPConnectivityFeedback["Succeeded"] = 0] = "Succeeded";
    CheckNetworkTCPConnectivityFeedback[CheckNetworkTCPConnectivityFeedback["MeetingSessionURLsNotInitialized"] = 1] = "MeetingSessionURLsNotInitialized";
    CheckNetworkTCPConnectivityFeedback[CheckNetworkTCPConnectivityFeedback["ConnectionFailed"] = 2] = "ConnectionFailed";
    CheckNetworkTCPConnectivityFeedback[CheckNetworkTCPConnectivityFeedback["ICENegotiationFailed"] = 3] = "ICENegotiationFailed";
})($932ece3004eb04b9$var$CheckNetworkTCPConnectivityFeedback || (module.exports.CheckNetworkTCPConnectivityFeedback = $932ece3004eb04b9$var$CheckNetworkTCPConnectivityFeedback = {}));
module.exports.default = $932ece3004eb04b9$var$CheckNetworkTCPConnectivityFeedback;

});

parcelRegister("1boZv", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CheckNetworkUDPConnectivityFeedback = void 0;
var $0dca3434bd3bc0a9$var$CheckNetworkUDPConnectivityFeedback;
(function(CheckNetworkUDPConnectivityFeedback) {
    CheckNetworkUDPConnectivityFeedback[CheckNetworkUDPConnectivityFeedback["Succeeded"] = 0] = "Succeeded";
    CheckNetworkUDPConnectivityFeedback[CheckNetworkUDPConnectivityFeedback["MeetingSessionURLsNotInitialized"] = 1] = "MeetingSessionURLsNotInitialized";
    CheckNetworkUDPConnectivityFeedback[CheckNetworkUDPConnectivityFeedback["ConnectionFailed"] = 2] = "ConnectionFailed";
    CheckNetworkUDPConnectivityFeedback[CheckNetworkUDPConnectivityFeedback["ICENegotiationFailed"] = 3] = "ICENegotiationFailed";
})($0dca3434bd3bc0a9$var$CheckNetworkUDPConnectivityFeedback || (module.exports.CheckNetworkUDPConnectivityFeedback = $0dca3434bd3bc0a9$var$CheckNetworkUDPConnectivityFeedback = {}));
module.exports.default = $0dca3434bd3bc0a9$var$CheckNetworkUDPConnectivityFeedback;

});

parcelRegister("9wJVi", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CheckVideoConnectivityFeedback = void 0;
var $6efab994597badb6$var$CheckVideoConnectivityFeedback;
(function(CheckVideoConnectivityFeedback) {
    CheckVideoConnectivityFeedback[CheckVideoConnectivityFeedback["Succeeded"] = 0] = "Succeeded";
    CheckVideoConnectivityFeedback[CheckVideoConnectivityFeedback["VideoInputRequestFailed"] = 1] = "VideoInputRequestFailed";
    CheckVideoConnectivityFeedback[CheckVideoConnectivityFeedback["VideoInputPermissionDenied"] = 2] = "VideoInputPermissionDenied";
    CheckVideoConnectivityFeedback[CheckVideoConnectivityFeedback["ConnectionFailed"] = 3] = "ConnectionFailed";
    CheckVideoConnectivityFeedback[CheckVideoConnectivityFeedback["VideoNotSent"] = 4] = "VideoNotSent";
})($6efab994597badb6$var$CheckVideoConnectivityFeedback || (module.exports.CheckVideoConnectivityFeedback = $6efab994597badb6$var$CheckVideoConnectivityFeedback = {}));
module.exports.default = $6efab994597badb6$var$CheckVideoConnectivityFeedback;

});

parcelRegister("fXIZN", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CheckVideoInputFeedback = void 0;
var $b9ef44e6b5195321$var$CheckVideoInputFeedback;
(function(CheckVideoInputFeedback) {
    CheckVideoInputFeedback[CheckVideoInputFeedback["Succeeded"] = 0] = "Succeeded";
    CheckVideoInputFeedback[CheckVideoInputFeedback["Failed"] = 1] = "Failed";
    CheckVideoInputFeedback[CheckVideoInputFeedback["PermissionDenied"] = 2] = "PermissionDenied";
})($b9ef44e6b5195321$var$CheckVideoInputFeedback || (module.exports.CheckVideoInputFeedback = $b9ef44e6b5195321$var$CheckVideoInputFeedback = {}));
module.exports.default = $b9ef44e6b5195321$var$CheckVideoInputFeedback;

});

parcelRegister("9zRCJ", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $6f90fa804f3df3d9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $6f90fa804f3df3d9$var$BaseTask_1 = $6f90fa804f3df3d9$var$__importDefault((parcelRequire("9wPDz")));
class $6f90fa804f3df3d9$var$CleanRestartedSessionTask extends $6f90fa804f3df3d9$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'CleanRestartedSessionTask';
    }
    async run() {
        this.context.resetConnectionSpecificState();
    }
}
module.exports.default = $6f90fa804f3df3d9$var$CleanRestartedSessionTask;

});

parcelRegister("8uHHj", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $62f3057aa59fc91f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $62f3057aa59fc91f$var$SignalingClientEventType_1 = $62f3057aa59fc91f$var$__importDefault((parcelRequire("1lA8I")));

const $62f3057aa59fc91f$var$BaseTask_1 = $62f3057aa59fc91f$var$__importDefault((parcelRequire("9wPDz")));
/*
 * `CleanStoppedSessionTask` permenently cleans up all components of `AudioVideoControllerState` after a stop call.
 */ class $62f3057aa59fc91f$var$CleanStoppedSessionTask extends $62f3057aa59fc91f$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'CleanStoppedSessionTask';
        this.taskCanceler = null;
    }
    cancel() {
        if (this.taskCanceler) {
            this.taskCanceler.cancel();
            this.taskCanceler = null;
        }
    }
    async run() {
        try {
            if (this.context.signalingClient.ready()) {
                this.context.signalingClient.closeConnection();
                await this.receiveWebSocketClosedEvent();
            }
        } catch (error) {
            throw error;
        } finally{
            for (const observer of this.context.removableObservers)observer.removeObserver();
            this.context.resetConnectionSpecificState();
            this.context.statsCollector.stop();
            this.context.statsCollector = null;
            this.context.connectionMonitor.stop();
            this.context.connectionMonitor = null;
            if (this.context.videoUplinkBandwidthPolicy.setTransceiverController) this.context.videoUplinkBandwidthPolicy.setTransceiverController(undefined);
            if (this.context.videoDownlinkBandwidthPolicy.bindToTileController) this.context.videoDownlinkBandwidthPolicy.bindToTileController(undefined);
            // This state may be reused to join another conference, so clear out all the existing video tiles
            const tile = this.context.videoTileController.getLocalVideoTile();
            if (tile) tile.bindVideoStream('', true, null, null, null, null);
            this.context.videoTileController.removeAllVideoTiles();
        }
    }
    receiveWebSocketClosedEvent() {
        return new Promise((resolve, reject)=>{
            class Interceptor {
                constructor(signalingClient){
                    this.signalingClient = signalingClient;
                }
                cancel() {
                    this.signalingClient.removeObserver(this);
                    reject(new Error(`CleanStoppedSessionTask got canceled while waiting for the WebSocket closed event`));
                }
                handleSignalingClientEvent(event) {
                    if (event.type === $62f3057aa59fc91f$var$SignalingClientEventType_1.default.WebSocketClosed) {
                        this.signalingClient.removeObserver(this);
                        resolve();
                    }
                }
            }
            const interceptor = new Interceptor(this.context.signalingClient);
            this.taskCanceler = interceptor;
            this.context.signalingClient.registerObserver(interceptor);
        });
    }
}
module.exports.default = $62f3057aa59fc91f$var$CleanStoppedSessionTask;

});
parcelRegister("1lA8I", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignalingClientEventType = void 0;
/** Defines the event types generated by SignalingClient and the underlying WebSocket connection. */ var $0fb3c92f2810f677$var$SignalingClientEventType;
(function(SignalingClientEventType) {
    SignalingClientEventType[SignalingClientEventType["WebSocketConnecting"] = 0] = "WebSocketConnecting";
    SignalingClientEventType[SignalingClientEventType["WebSocketOpen"] = 1] = "WebSocketOpen";
    SignalingClientEventType[SignalingClientEventType["WebSocketError"] = 2] = "WebSocketError";
    SignalingClientEventType[SignalingClientEventType["WebSocketClosing"] = 3] = "WebSocketClosing";
    SignalingClientEventType[SignalingClientEventType["WebSocketClosed"] = 4] = "WebSocketClosed";
    SignalingClientEventType[SignalingClientEventType["WebSocketFailed"] = 5] = "WebSocketFailed";
    SignalingClientEventType[SignalingClientEventType["WebSocketMessage"] = 6] = "WebSocketMessage";
    SignalingClientEventType[SignalingClientEventType["WebSocketSendMessageFailure"] = 7] = "WebSocketSendMessageFailure";
    SignalingClientEventType[SignalingClientEventType["WebSocketSentMessage"] = 8] = "WebSocketSentMessage";
    SignalingClientEventType[SignalingClientEventType["ProtocolDecodeFailure"] = 9] = "ProtocolDecodeFailure";
    SignalingClientEventType[SignalingClientEventType["ReceivedSignalFrame"] = 10] = "ReceivedSignalFrame";
    SignalingClientEventType[SignalingClientEventType["WebSocketSkippedMessage"] = 11] = "WebSocketSkippedMessage";
})($0fb3c92f2810f677$var$SignalingClientEventType || (module.exports.SignalingClientEventType = $0fb3c92f2810f677$var$SignalingClientEventType = {}));
module.exports.default = $0fb3c92f2810f677$var$SignalingClientEventType;

});


parcelRegister("dyoZi", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $9de1d55e7e88da6e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4huDn = parcelRequire("4huDn");

const $9de1d55e7e88da6e$var$ClientMetricReportDirection_1 = $9de1d55e7e88da6e$var$__importDefault((parcelRequire("hRU3k")));

const $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1 = $9de1d55e7e88da6e$var$__importDefault((parcelRequire("aU8Oy")));

const $9de1d55e7e88da6e$var$GlobalMetricReport_1 = $9de1d55e7e88da6e$var$__importDefault((parcelRequire("9ySID")));
/**
 * [[ClientMetricReport]] gets the media metrics used by ConnectionMonitor to
 * update connection health data.
 */ class $9de1d55e7e88da6e$var$ClientMetricReport {
    constructor(logger, videoStreamIndex, selfAttendeeId){
        this.logger = logger;
        this.videoStreamIndex = videoStreamIndex;
        this.selfAttendeeId = selfAttendeeId;
        this.globalMetricReport = new $9de1d55e7e88da6e$var$GlobalMetricReport_1.default();
        this.streamMetricReports = {};
        // Will contain the raw RTCStatsReport from RTCPeerConnection.getStats() API.
        this.rtcStatsReport = {};
        // Will contain any custom metric reports generated by the SDK.
        this.customStatsReports = [];
        this.currentTimestampMs = 0;
        this.previousTimestampMs = 0;
        this.currentSsrcs = {};
        this.overriddenObservableMetrics = new Map();
        /**
         *  Metric transform functions
         */ this.identityValue = (metricName, ssrc)=>{
            const metricReport = ssrc ? this.streamMetricReports[ssrc] : this.globalMetricReport;
            return Number(metricReport.currentMetrics[metricName]);
        };
        this.decoderLossPercent = (metricName, ssrc)=>{
            const metricReport = this.streamMetricReports[ssrc];
            const concealedSamples = metricReport.currentMetrics['concealedSamples'] - (metricReport.previousMetrics['concealedSamples'] || 0);
            const totalSamplesReceived = metricReport.currentMetrics['totalSamplesReceived'] - (metricReport.previousMetrics['totalSamplesReceived'] || 0);
            if (totalSamplesReceived <= 0) return 0;
            const decoderAbnormal = totalSamplesReceived - concealedSamples;
            if (decoderAbnormal <= 0) return 0;
            return concealedSamples / totalSamplesReceived * 100;
        };
        this.packetLossPercent = (sourceMetricName, ssrc)=>{
            const metricReport = this.streamMetricReports[ssrc];
            const sentOrReceived = metricReport.currentMetrics[sourceMetricName] - (metricReport.previousMetrics[sourceMetricName] || 0);
            const lost = metricReport.currentMetrics['packetsLost'] - (metricReport.previousMetrics['packetsLost'] || 0);
            const total = sentOrReceived + lost;
            if (total <= 0 || lost <= 0) return 0;
            return lost * 100 / total;
        };
        this.jitterBufferMs = (metricName, ssrc)=>{
            const metricReport = this.streamMetricReports[ssrc];
            const jitterBufferDelay = metricReport.currentMetrics['jitterBufferDelay'] - (metricReport.previousMetrics['jitterBufferDelay'] || 0);
            const jitterBufferEmittedCount = metricReport.currentMetrics['jitterBufferEmittedCount'] - (metricReport.previousMetrics['jitterBufferEmittedCount'] || 0);
            if (jitterBufferDelay <= 0) return 0;
            if (jitterBufferEmittedCount <= 0) return 0;
            return jitterBufferDelay / jitterBufferEmittedCount * 1000;
        };
        this.countPerSecond = (metricName, ssrc)=>{
            const metricReport = ssrc ? this.streamMetricReports[ssrc] : this.globalMetricReport;
            let intervalSeconds = (this.currentTimestampMs - this.previousTimestampMs) / 1000;
            if (intervalSeconds <= 0) return 0;
            if (this.previousTimestampMs <= 0) intervalSeconds = 1;
            const diff = metricReport.currentMetrics[metricName] - (metricReport.previousMetrics[metricName] || 0);
            if (diff <= 0) return 0;
            return Math.trunc(diff / intervalSeconds);
        };
        this.bitsPerSecond = (metricName, ssrc)=>{
            const metricReport = ssrc ? this.streamMetricReports[ssrc] : this.globalMetricReport;
            let intervalSeconds = (this.currentTimestampMs - this.previousTimestampMs) / 1000;
            if (intervalSeconds <= 0) return 0;
            if (this.previousTimestampMs <= 0) intervalSeconds = 1;
            const diff = (metricReport.currentMetrics[metricName] - (metricReport.previousMetrics[metricName] || 0)) * 8;
            if (diff <= 0) return 0;
            return Math.trunc(diff / intervalSeconds);
        };
        this.secondsToMilliseconds = (metricName, ssrc)=>{
            const metricReport = ssrc ? this.streamMetricReports[ssrc] : this.globalMetricReport;
            return Number(metricReport.currentMetrics[metricName] * 1000);
        };
        this.averageTimeSpentPerSecondInMilliseconds = (metricName, ssrc)=>{
            const metricReport = ssrc ? this.streamMetricReports[ssrc] : this.globalMetricReport;
            let intervalSeconds = (this.currentTimestampMs - this.previousTimestampMs) / 1000;
            if (intervalSeconds <= 0) return 0;
            if (this.previousTimestampMs <= 0) intervalSeconds = 1;
            const diff = metricReport.currentMetrics[metricName] - (metricReport.previousMetrics[metricName] || 0);
            if (diff <= 0) return 0;
            return diff * 1000 / intervalSeconds;
        };
        this.averageCpuQualityLimitationDurationPerSecondInMilliseconds = (metricName, ssrc)=>{
            const metricReport = this.streamMetricReports[ssrc];
            if (metricReport.previousObjectMetrics[metricName] === undefined || metricReport.currentObjectMetrics[metricName] === undefined) return NaN;
            let intervalSeconds = (this.currentTimestampMs - this.previousTimestampMs) / 1000;
            if (intervalSeconds <= 0) return 0;
            if (this.previousTimestampMs <= 0) intervalSeconds = 1;
            let previousValue = 0;
            let currentValue = 0;
            for (const [key, value] of Object.entries(metricReport.previousObjectMetrics[metricName]))if (key === 'cpu') previousValue = value;
            for (const [key, value] of Object.entries(metricReport.currentObjectMetrics[metricName]))if (key === 'cpu') currentValue = value;
            const diff = currentValue - previousValue;
            if (diff <= 0) return 0;
            return diff * 1000 / intervalSeconds;
        };
        this.isHardwareImplementation = (metricName, ssrc)=>{
            const metricReport = this.streamMetricReports[ssrc];
            if (metricReport.currentStringMetrics[metricName] === undefined) return NaN;
            const implName = String(metricReport.currentStringMetrics[metricName]);
            const hasHwName = implName.includes('ExternalDecoder') || implName.includes('ExternalEncoder') || implName.includes('EncodeAccelerator') || implName.includes('DecodeAccelerator');
            const isFallback = implName.includes('fallback from');
            return hasHwName && !isFallback ? 1 : 0;
        };
        /**
         *  Canonical and derived metric maps
         */ this.globalMetricMap = {
            retransmittedBytesSent: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_RETRANSMIT_BITRATE
            },
            totalEncodedBytesTarget: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_TARGET_ENCODER_BITRATE
            },
            totalPacketSendDelay: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_BUCKET_DELAY_MS
            },
            packetsDiscardedOnSend: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.SOCKET_DISCARDED_PPS
            },
            availableIncomingBitrate: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_AVAILABLE_RECEIVE_BANDWIDTH
            },
            availableOutgoingBitrate: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_AVAILABLE_SEND_BANDWIDTH
            },
            currentRoundTripTime: {
                transform: this.secondsToMilliseconds,
                type: $4huDn.SdkMetric.Type.STUN_RTT_MS
            },
            // Upstream AudioLevel is collected through RTCAudioSourceStats
            // (https://developer.mozilla.org/en-US/docs/Web/API/RTCAudioSourceStats)
            // That one doesn't have ssrc field so we must collect it through Global Metric Report
            audioLevel: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.RTC_MIC_AUDIO_LEVEL,
                source: 'audioLevel'
            }
        };
        this.audioUpstreamMetricMap = {
            jitter: {
                transform: this.secondsToMilliseconds,
                type: $4huDn.SdkMetric.Type.RTC_MIC_JITTER_MS
            },
            packetsSent: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.RTC_MIC_PPS
            },
            bytesSent: {
                transform: this.bitsPerSecond,
                type: $4huDn.SdkMetric.Type.RTC_MIC_BITRATE
            },
            roundTripTime: {
                transform: this.secondsToMilliseconds,
                type: $4huDn.SdkMetric.Type.RTC_MIC_RTT_MS
            },
            packetsLost: {
                transform: this.packetLossPercent,
                type: $4huDn.SdkMetric.Type.RTC_MIC_FRACTION_PACKET_LOST_PERCENT,
                source: 'packetsSent'
            },
            audioSentTransformPps: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.AUDIO_SENT_TRANSFORM_PPS
            }
        };
        this.audioDownstreamMetricMap = {
            concealedSamples: {
                transform: this.countPerSecond
            },
            totalSamplesReceived: {
                transform: this.countPerSecond
            },
            decoderLoss: {
                transform: this.decoderLossPercent,
                type: $4huDn.SdkMetric.Type.RTC_SPK_FRACTION_DECODER_LOSS_PERCENT
            },
            packetsReceived: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.RTC_SPK_PPS
            },
            packetsLost: {
                transform: this.packetLossPercent,
                type: $4huDn.SdkMetric.Type.RTC_SPK_FRACTION_PACKET_LOST_PERCENT,
                source: 'packetsReceived'
            },
            jitter: {
                transform: this.secondsToMilliseconds,
                type: $4huDn.SdkMetric.Type.RTC_SPK_JITTER_MS
            },
            jitterBufferDelay: {
                transform: this.countPerSecond
            },
            jitterBufferEmittedCount: {
                transform: this.countPerSecond
            },
            jitterBufferMs: {
                transform: this.jitterBufferMs,
                type: $4huDn.SdkMetric.Type.RTC_SPK_JITTER_BUFFER_MS
            },
            bytesReceived: {
                transform: this.bitsPerSecond,
                type: $4huDn.SdkMetric.Type.RTC_SPK_BITRATE
            },
            audioLevel: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.RTC_SPK_AUDIO_LEVEL
            },
            totalAudioPacketsLost: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.RTC_SPK_TOTAL_LOST
            },
            totalAudioPacketsExpected: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.RTC_SPK_TOTAL_EXPECTED
            },
            totalAudioPacketsRecoveredRed: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.RTC_SPK_TOTAL_RECOVERED_RED
            },
            totalAudioPacketsRecoveredFec: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.RTC_SPK_TOTAL_RECOVERED_FEC
            },
            audioReceivedTransformPps: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.AUDIO_RECEIVED_TRANSFORM_PPS
            }
        };
        this.videoUpstreamMetricMap = {
            roundTripTime: {
                transform: this.secondsToMilliseconds,
                type: $4huDn.SdkMetric.Type.VIDEO_SENT_RTT_MS
            },
            nackCount: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_NACKS_RECEIVED
            },
            pliCount: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_PLIS_RECEIVED
            },
            firCount: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_FIRS_RECEIVED
            },
            framesPerSecond: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_INPUT_FPS
            },
            framesEncoded: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_ENCODE_FPS
            },
            packetsSent: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_SENT_PPS
            },
            packetsLost: {
                transform: this.packetLossPercent,
                type: $4huDn.SdkMetric.Type.VIDEO_SENT_FRACTION_PACKET_LOST_PERCENT,
                source: 'packetsSent'
            },
            bytesSent: {
                transform: this.bitsPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_SENT_BITRATE
            },
            qpSum: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_SENT_QP_SUM
            },
            frameHeight: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_ENCODE_HEIGHT
            },
            frameWidth: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_ENCODE_WIDTH
            },
            jitter: {
                transform: this.secondsToMilliseconds,
                type: $4huDn.SdkMetric.Type.VIDEO_SENT_JITTER_MS
            },
            totalEncodeTime: {
                transform: this.averageTimeSpentPerSecondInMilliseconds,
                type: $4huDn.SdkMetric.Type.VIDEO_ENCODE_MS
            },
            encoderImplementation: {
                transform: this.isHardwareImplementation,
                type: $4huDn.SdkMetric.Type.VIDEO_ENCODER_IS_HARDWARE
            },
            qualityLimitationDurations: {
                transform: this.averageCpuQualityLimitationDurationPerSecondInMilliseconds,
                type: $4huDn.SdkMetric.Type.VIDEO_QUALITY_LIMITATION_DURATION_CPU
            },
            videoCodecDegradationHighEncodeCpu: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_CODEC_DEGRADATION_HIGH_ENCODE_CPU
            },
            videoCodecDegradationEncodeFailure: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_CODEC_DEGRADATION_ENCODE_FAILURE
            },
            videoInputWidth: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_INPUT_WIDTH
            },
            videoInputHeight: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_INPUT_HEIGHT
            },
            videoSentTransformPps: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_SENT_TRANSFORM_PPS
            }
        };
        this.videoDownstreamMetricMap = {
            packetsReceived: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_RECEIVED_PPS
            },
            packetsLost: {
                transform: this.packetLossPercent,
                type: $4huDn.SdkMetric.Type.VIDEO_RECEIVED_FRACTION_PACKET_LOST_PERCENT,
                source: 'packetsReceived'
            },
            framesReceived: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_RECEIVED_FPS
            },
            framesDecoded: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_DECODE_FPS
            },
            nackCount: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_NACKS_SENT
            },
            firCount: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_FIRS_SENT
            },
            pliCount: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_PLIS_SENT
            },
            bytesReceived: {
                transform: this.bitsPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_RECEIVED_BITRATE
            },
            jitter: {
                transform: this.secondsToMilliseconds,
                type: $4huDn.SdkMetric.Type.VIDEO_RECEIVED_JITTER_MS
            },
            jitterBufferDelay: {
                transform: this.countPerSecond
            },
            jitterBufferEmittedCount: {
                transform: this.countPerSecond
            },
            jitterBufferMs: {
                transform: this.jitterBufferMs,
                type: $4huDn.SdkMetric.Type.VIDEO_JITTER_BUFFER_MS
            },
            qpSum: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_RECEIVED_QP_SUM
            },
            frameHeight: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_DECODE_HEIGHT
            },
            frameWidth: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_DECODE_WIDTH
            },
            totalDecodeTime: {
                transform: this.averageTimeSpentPerSecondInMilliseconds,
                type: $4huDn.SdkMetric.Type.VIDEO_DECODE_MS
            },
            decoderImplementation: {
                transform: this.isHardwareImplementation,
                type: $4huDn.SdkMetric.Type.VIDEO_DECODER_IS_HARDWARE
            },
            totalFreezesDuration: {
                transform: this.averageTimeSpentPerSecondInMilliseconds,
                type: $4huDn.SdkMetric.Type.VIDEO_FREEZE_DURATION
            },
            freezeCount: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_FREEZE_COUNT
            },
            totalPausesDuration: {
                transform: this.averageTimeSpentPerSecondInMilliseconds,
                type: $4huDn.SdkMetric.Type.VIDEO_PAUSE_DURATION
            },
            pauseCount: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_PAUSE_COUNT
            },
            framesDropped: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_DROPPED_FPS
            },
            videoRenderWidth: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_RENDER_WIDTH
            },
            videoRenderHeight: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_RENDER_HEIGHT
            },
            videoReceivedTransformPps: {
                transform: this.countPerSecond,
                type: $4huDn.SdkMetric.Type.VIDEO_RECEIVED_TRANSFORM_PPS
            },
            videoRemoteRenderFps: {
                transform: this.identityValue,
                type: $4huDn.SdkMetric.Type.VIDEO_REMOTE_RENDER_FPS
            }
        };
        /**
         *  Dimensions derived from metric
         */ this.streamDimensionMap = {
            encoderImplementation: $4huDn.SdkStreamDimension.Type.VIDEO_ENCODER_NAME,
            decoderImplementation: $4huDn.SdkStreamDimension.Type.VIDEO_DECODER_NAME
        };
        /**
         *  media Stream metrics
         */ this.observableVideoMetricSpec = {
            videoUpstreamBitrate: {
                source: 'bytesSent',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoUpstreamPacketsSent: {
                source: 'packetsSent',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoUpstreamPacketLossPercent: {
                source: 'packetsLost',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoUpstreamFramesEncodedPerSecond: {
                source: 'framesEncoded',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoUpstreamFramesInputPerSecond: {
                source: 'framesPerSecond',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoUpstreamFrameHeight: {
                source: 'frameHeight',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoUpstreamFrameWidth: {
                source: 'frameWidth',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoUpstreamJitterMs: {
                source: 'jitter',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoUpstreamRoundTripTimeMs: {
                source: 'roundTripTime',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoUpstreamEncoderImplementation: {
                source: 'encoderImplementation',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoUpstreamTotalEncodeTimePerSecond: {
                source: 'totalEncodeTime',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoUpstreamCpuQualityLimitationDurationPerSecond: {
                source: 'qualityLimitationDurations',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoDownstreamBitrate: {
                source: 'bytesReceived',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            },
            videoDownstreamPacketLossPercent: {
                source: 'packetsLost',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            },
            videoDownstreamPacketsReceived: {
                source: 'packetsReceived',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            },
            videoDownstreamFramesDecodedPerSecond: {
                source: 'framesDecoded',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            },
            videoDownstreamFrameHeight: {
                source: 'frameHeight',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            },
            videoDownstreamFrameWidth: {
                source: 'frameWidth',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            },
            videoDownstreamJitterMs: {
                source: 'jitter',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            },
            videoDownstreamDelayMs: {
                source: 'jitterBufferMs',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            }
        };
        /**
         * Observable metrics and related APIs
         */ this.observableMetricSpec = {
            audioPacketsReceived: {
                source: 'packetsReceived',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.AUDIO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            },
            audioPacketsReceivedFractionLoss: {
                source: 'packetsLost',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.AUDIO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            },
            audioDecoderLoss: {
                source: 'decoderLoss',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.AUDIO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            },
            audioPacketsSent: {
                source: 'packetsSent',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.AUDIO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            audioPacketLossPercent: {
                source: 'packetsLost',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.AUDIO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            audioUpstreamRoundTripTimeMs: {
                source: 'roundTripTime',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.AUDIO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoUpstreamBitrate: {
                source: 'bytesSent',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            videoPacketSentPerSecond: {
                source: 'packetsSent',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            audioSpeakerDelayMs: {
                source: 'jitterBufferMs',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.AUDIO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            },
            audioUpstreamJitterMs: {
                source: 'jitter',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.AUDIO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            audioDownstreamJitterMs: {
                source: 'jitter',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.AUDIO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            },
            nackCountReceivedPerSecond: {
                source: 'nackCount',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM
            },
            availableOutgoingBitrate: {
                source: 'availableOutgoingBitrate'
            },
            availableIncomingBitrate: {
                source: 'availableIncomingBitrate'
            },
            currentRoundTripTimeMs: {
                source: 'currentRoundTripTime'
            },
            // Downstream AudioLevel is collected through RTCInboundRtpStreamStats
            // (https://developer.mozilla.org/en-US/docs/Web/API/RTCInboundRtpStreamStats)
            audioDownstreamLevel: {
                source: 'audioLevel',
                media: $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.AUDIO,
                dir: $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM
            },
            // Upstream AudioLevel is collected through RTCAudioSourceStats
            // (https://developer.mozilla.org/en-US/docs/Web/API/RTCAudioSourceStats)
            // That one doesn't have ssrc field so we must collect it through Global Metric Report
            audioUpstreamLevel: {
                source: 'audioLevel'
            }
        };
    }
    getMetricMap(mediaType, direction) {
        switch(mediaType){
            case $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.AUDIO:
                switch(direction){
                    case $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM:
                        return this.audioUpstreamMetricMap;
                    case $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM:
                        return this.audioDownstreamMetricMap;
                }
            case $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO:
                switch(direction){
                    case $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM:
                        return this.videoUpstreamMetricMap;
                    case $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.DOWNSTREAM:
                        return this.videoDownstreamMetricMap;
                }
            default:
                return this.globalMetricMap;
        }
    }
    getStreamDimensionMap() {
        return this.streamDimensionMap;
    }
    /**
     * Returns the value of the specific metric in observableMetricSpec.
     */ getObservableMetricValue(metricName) {
        if (this.overriddenObservableMetrics.has(metricName)) return this.overriddenObservableMetrics.get(metricName);
        const observableMetricSpec = this.observableMetricSpec[metricName];
        const metricMap = this.getMetricMap(observableMetricSpec.media, observableMetricSpec.dir);
        const metricSpec = metricMap[observableMetricSpec.source];
        const { transform: transform, source: source } = metricSpec;
        if (observableMetricSpec.hasOwnProperty('media')) for(const ssrc in this.streamMetricReports){
            const streamMetricReport = this.streamMetricReports[ssrc];
            if (streamMetricReport.direction === observableMetricSpec.dir && streamMetricReport.mediaType === observableMetricSpec.media) return source ? transform(source, Number(ssrc)) : transform(observableMetricSpec.source, Number(ssrc));
        }
        else return source ? transform(source) : transform(observableMetricSpec.source);
        return 0;
    }
    /**
     * Returns the value of the specific metric in observableVideoMetricSpec.
     */ getObservableVideoMetricValue(metricName, ssrcNum) {
        const observableVideoMetricSpec = this.observableVideoMetricSpec[metricName];
        const metricMap = this.getMetricMap(observableVideoMetricSpec.media, observableVideoMetricSpec.dir);
        const metricSpec = metricMap[observableVideoMetricSpec.source];
        const { transform: transform, source: source } = metricSpec;
        return source ? transform(source, ssrcNum) : transform(observableVideoMetricSpec.source, ssrcNum);
    }
    /**
     * Get ssrcs of upstream video streams
     * @returns ssrcs of video upstream streams
     */ getVideoUpstreamSsrcs() {
        const ssrcs = [];
        for(const ssrc in this.streamMetricReports)if (this.streamMetricReports[ssrc].mediaType === $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO && this.streamMetricReports[ssrc].direction === $9de1d55e7e88da6e$var$ClientMetricReportDirection_1.default.UPSTREAM) ssrcs.push(Number(ssrc));
        return ssrcs;
    }
    /**
     * Returns the value of metrics in observableMetricSpec.
     */ getObservableMetrics() {
        const metric = {};
        for(const metricName in this.observableMetricSpec)metric[metricName] = this.getObservableMetricValue(metricName);
        return metric;
    }
    /**
     * Returns the value of metrics in observableVideoMetricSpec for each SSRC.
     */ getObservableVideoMetrics() {
        const videoStreamMetrics = {};
        if (!this.videoStreamIndex || !this.selfAttendeeId) {
            this.logger.error('Need to define VideoStreamIndex and selfAttendeeId if using getObservableVideoMetrics API');
            return videoStreamMetrics;
        }
        for(const ssrc in this.streamMetricReports)if (this.streamMetricReports[ssrc].mediaType === $9de1d55e7e88da6e$var$ClientMetricReportMediaType_1.default.VIDEO) {
            const metric = {};
            for(const metricName in this.observableVideoMetricSpec)if (this.observableVideoMetricSpec[metricName].dir === this.streamMetricReports[ssrc].direction) {
                const metricValue = this.getObservableVideoMetricValue(metricName, Number(ssrc));
                if (!isNaN(metricValue)) metric[metricName] = metricValue;
            }
            const groupId = this.streamMetricReports[ssrc].groupId;
            const streamId = this.streamMetricReports[ssrc].streamId;
            let attendeeId = '';
            /* istanbul ignore else */ if (this.videoStreamIndex.attendeeIdForGroupId !== undefined) attendeeId = groupId ? this.videoStreamIndex.attendeeIdForGroupId(groupId) : this.selfAttendeeId;
            else // This usage may be inaccurate if server side network adaptation (SSNA) is enabled,
            // and a simulcast sender has dropped their originally highest stream.
            //
            // We are ok with this given the unlikeliness of someone reimplmententing the entire
            // audio video controller (no way otherwise to inject your own index impl.), implementing
            // both simulcast and SSNA, but reusing this class :) .
            attendeeId = streamId ? this.videoStreamIndex.attendeeIdForStreamId(streamId) : this.selfAttendeeId;
            videoStreamMetrics[attendeeId] = videoStreamMetrics[attendeeId] ? videoStreamMetrics[attendeeId] : {};
            videoStreamMetrics[attendeeId][ssrc] = metric;
        }
        return videoStreamMetrics;
    }
    /**
     * Returns the raw RTCStatsReport from RTCPeerConnection.getStats() API.
     */ getRTCStatsReport() {
        return this.rtcStatsReport;
    }
    /**
     * Clones the ClientMetricReport and returns it.
     */ clone() {
        const cloned = new $9de1d55e7e88da6e$var$ClientMetricReport(this.logger, this.videoStreamIndex, this.selfAttendeeId);
        cloned.globalMetricReport = this.globalMetricReport;
        cloned.streamMetricReports = this.streamMetricReports;
        cloned.rtcStatsReport = this.rtcStatsReport;
        cloned.customStatsReports = this.customStatsReports;
        cloned.currentTimestampMs = this.currentTimestampMs;
        cloned.previousTimestampMs = this.previousTimestampMs;
        cloned.overriddenObservableMetrics = this.overriddenObservableMetrics;
        return cloned;
    }
    /**
     * Prints out the globalMetricReport, streamMetricReports and the corresponding timestamps from the current ClientMetricReport.
     */ print() {
        const clientMetricReport = {
            globalMetricReport: this.globalMetricReport,
            streamMetricReports: this.streamMetricReports,
            currentTimestampMs: this.currentTimestampMs,
            previousTimestampMs: this.previousTimestampMs
        };
        this.logger.debug(()=>{
            return `Client Metric Report: ${JSON.stringify(clientMetricReport)}`;
        });
    }
    /**
     * Removes the SSRCs that are no longer valid.
     */ removeDestroyedSsrcs() {
        for(const ssrc in this.streamMetricReports)if (!this.currentSsrcs[ssrc]) delete this.streamMetricReports[ssrc];
    }
    /**
     * Overrides a specific observable metric value (e.g. with one that didn't come from the WebRTC report)
     */ overrideObservableMetric(name, value) {
        this.overriddenObservableMetrics.set(name, value);
    }
}
module.exports.default = $9de1d55e7e88da6e$var$ClientMetricReport;

});
parcelRegister("4huDn", function(module, exports) {
/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/ "use strict";

var $jiz4j = parcelRequire("jiz4j");
// Common aliases
var $31e083413a0a3833$var$$Reader = $jiz4j.Reader, $31e083413a0a3833$var$$Writer = $jiz4j.Writer, $31e083413a0a3833$var$$util = $jiz4j.util;
// Exported root namespace
var $31e083413a0a3833$var$$root = $jiz4j.roots["default"] || ($jiz4j.roots["default"] = {});
$31e083413a0a3833$var$$root.SdkSignalFrame = function() {
    /**
     * Properties of a SdkSignalFrame.
     * @name ISdkSignalFrame
     * @interface ISdkSignalFrame
     * @property {number|Long} timestampMs SdkSignalFrame timestampMs
     * @property {SdkSignalFrame.Type} type SdkSignalFrame type
     * @property {ISdkErrorFrame|null} [error] SdkSignalFrame error
     * @property {ISdkJoinFrame|null} [join] SdkSignalFrame join
     * @property {ISdkJoinAckFrame|null} [joinack] SdkSignalFrame joinack
     * @property {ISdkSubscribeFrame|null} [sub] SdkSignalFrame sub
     * @property {ISdkSubscribeAckFrame|null} [suback] SdkSignalFrame suback
     * @property {ISdkIndexFrame|null} [index] SdkSignalFrame index
     * @property {ISdkPauseResumeFrame|null} [pause] SdkSignalFrame pause
     * @property {ISdkLeaveFrame|null} [leave] SdkSignalFrame leave
     * @property {ISdkLeaveAckFrame|null} [leaveAck] SdkSignalFrame leaveAck
     * @property {ISdkBitrateFrame|null} [bitrates] SdkSignalFrame bitrates
     * @property {ISdkAudioControlFrame|null} [audioControl] SdkSignalFrame audioControl
     * @property {ISdkAudioMetadataFrame|null} [audioMetadata] SdkSignalFrame audioMetadata
     * @property {ISdkAudioStreamIdInfoFrame|null} [audioStreamIdInfo] SdkSignalFrame audioStreamIdInfo
     * @property {ISdkPingPongFrame|null} [pingPong] SdkSignalFrame pingPong
     * @property {ISdkAudioStatusFrame|null} [audioStatus] SdkSignalFrame audioStatus
     * @property {ISdkClientMetricFrame|null} [clientMetric] SdkSignalFrame clientMetric
     * @property {ISdkDataMessageFrame|null} [dataMessage] SdkSignalFrame dataMessage
     * @property {ISdkRemoteVideoUpdateFrame|null} [remoteVideoUpdate] SdkSignalFrame remoteVideoUpdate
     * @property {ISdkPrimaryMeetingJoinFrame|null} [primaryMeetingJoin] SdkSignalFrame primaryMeetingJoin
     * @property {ISdkPrimaryMeetingJoinAckFrame|null} [primaryMeetingJoinAck] SdkSignalFrame primaryMeetingJoinAck
     * @property {ISdkPrimaryMeetingLeaveFrame|null} [primaryMeetingLeave] SdkSignalFrame primaryMeetingLeave
     * @property {ISdkNotificationFrame|null} [notification] SdkSignalFrame notification
     * @property {ISdkMeetingSessionTimingFrame|null} [meetingSessionTiming] SdkSignalFrame meetingSessionTiming
     */ /**
     * Constructs a new SdkSignalFrame.
     * @name SdkSignalFrame
     * @classdesc Represents a SdkSignalFrame.
     * @implements ISdkSignalFrame
     * @constructor
     * @param {ISdkSignalFrame=} [properties] Properties to set
     */ function SdkSignalFrame(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkSignalFrame timestampMs.
     * @member {number|Long} timestampMs
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.timestampMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, true) : 0;
    /**
     * SdkSignalFrame type.
     * @member {SdkSignalFrame.Type} type
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.type = 1;
    /**
     * SdkSignalFrame error.
     * @member {ISdkErrorFrame|null|undefined} error
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.error = null;
    /**
     * SdkSignalFrame join.
     * @member {ISdkJoinFrame|null|undefined} join
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.join = null;
    /**
     * SdkSignalFrame joinack.
     * @member {ISdkJoinAckFrame|null|undefined} joinack
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.joinack = null;
    /**
     * SdkSignalFrame sub.
     * @member {ISdkSubscribeFrame|null|undefined} sub
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.sub = null;
    /**
     * SdkSignalFrame suback.
     * @member {ISdkSubscribeAckFrame|null|undefined} suback
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.suback = null;
    /**
     * SdkSignalFrame index.
     * @member {ISdkIndexFrame|null|undefined} index
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.index = null;
    /**
     * SdkSignalFrame pause.
     * @member {ISdkPauseResumeFrame|null|undefined} pause
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.pause = null;
    /**
     * SdkSignalFrame leave.
     * @member {ISdkLeaveFrame|null|undefined} leave
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.leave = null;
    /**
     * SdkSignalFrame leaveAck.
     * @member {ISdkLeaveAckFrame|null|undefined} leaveAck
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.leaveAck = null;
    /**
     * SdkSignalFrame bitrates.
     * @member {ISdkBitrateFrame|null|undefined} bitrates
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.bitrates = null;
    /**
     * SdkSignalFrame audioControl.
     * @member {ISdkAudioControlFrame|null|undefined} audioControl
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.audioControl = null;
    /**
     * SdkSignalFrame audioMetadata.
     * @member {ISdkAudioMetadataFrame|null|undefined} audioMetadata
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.audioMetadata = null;
    /**
     * SdkSignalFrame audioStreamIdInfo.
     * @member {ISdkAudioStreamIdInfoFrame|null|undefined} audioStreamIdInfo
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.audioStreamIdInfo = null;
    /**
     * SdkSignalFrame pingPong.
     * @member {ISdkPingPongFrame|null|undefined} pingPong
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.pingPong = null;
    /**
     * SdkSignalFrame audioStatus.
     * @member {ISdkAudioStatusFrame|null|undefined} audioStatus
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.audioStatus = null;
    /**
     * SdkSignalFrame clientMetric.
     * @member {ISdkClientMetricFrame|null|undefined} clientMetric
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.clientMetric = null;
    /**
     * SdkSignalFrame dataMessage.
     * @member {ISdkDataMessageFrame|null|undefined} dataMessage
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.dataMessage = null;
    /**
     * SdkSignalFrame remoteVideoUpdate.
     * @member {ISdkRemoteVideoUpdateFrame|null|undefined} remoteVideoUpdate
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.remoteVideoUpdate = null;
    /**
     * SdkSignalFrame primaryMeetingJoin.
     * @member {ISdkPrimaryMeetingJoinFrame|null|undefined} primaryMeetingJoin
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.primaryMeetingJoin = null;
    /**
     * SdkSignalFrame primaryMeetingJoinAck.
     * @member {ISdkPrimaryMeetingJoinAckFrame|null|undefined} primaryMeetingJoinAck
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.primaryMeetingJoinAck = null;
    /**
     * SdkSignalFrame primaryMeetingLeave.
     * @member {ISdkPrimaryMeetingLeaveFrame|null|undefined} primaryMeetingLeave
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.primaryMeetingLeave = null;
    /**
     * SdkSignalFrame notification.
     * @member {ISdkNotificationFrame|null|undefined} notification
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.notification = null;
    /**
     * SdkSignalFrame meetingSessionTiming.
     * @member {ISdkMeetingSessionTimingFrame|null|undefined} meetingSessionTiming
     * @memberof SdkSignalFrame
     * @instance
     */ SdkSignalFrame.prototype.meetingSessionTiming = null;
    /**
     * Creates a new SdkSignalFrame instance using the specified properties.
     * @function create
     * @memberof SdkSignalFrame
     * @static
     * @param {ISdkSignalFrame=} [properties] Properties to set
     * @returns {SdkSignalFrame} SdkSignalFrame instance
     */ SdkSignalFrame.create = function create(properties) {
        return new SdkSignalFrame(properties);
    };
    /**
     * Encodes the specified SdkSignalFrame message. Does not implicitly {@link SdkSignalFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkSignalFrame
     * @static
     * @param {ISdkSignalFrame} message SdkSignalFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkSignalFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/ 8).uint64(message.timestampMs);
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.type);
        if (message.error != null && Object.hasOwnProperty.call(message, "error")) $31e083413a0a3833$var$$root.SdkErrorFrame.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
        if (message.join != null && Object.hasOwnProperty.call(message, "join")) $31e083413a0a3833$var$$root.SdkJoinFrame.encode(message.join, writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
        if (message.joinack != null && Object.hasOwnProperty.call(message, "joinack")) $31e083413a0a3833$var$$root.SdkJoinAckFrame.encode(message.joinack, writer.uint32(/* id 5, wireType 2 =*/ 42).fork()).ldelim();
        if (message.sub != null && Object.hasOwnProperty.call(message, "sub")) $31e083413a0a3833$var$$root.SdkSubscribeFrame.encode(message.sub, writer.uint32(/* id 6, wireType 2 =*/ 50).fork()).ldelim();
        if (message.suback != null && Object.hasOwnProperty.call(message, "suback")) $31e083413a0a3833$var$$root.SdkSubscribeAckFrame.encode(message.suback, writer.uint32(/* id 7, wireType 2 =*/ 58).fork()).ldelim();
        if (message.index != null && Object.hasOwnProperty.call(message, "index")) $31e083413a0a3833$var$$root.SdkIndexFrame.encode(message.index, writer.uint32(/* id 8, wireType 2 =*/ 66).fork()).ldelim();
        if (message.pause != null && Object.hasOwnProperty.call(message, "pause")) $31e083413a0a3833$var$$root.SdkPauseResumeFrame.encode(message.pause, writer.uint32(/* id 10, wireType 2 =*/ 82).fork()).ldelim();
        if (message.leave != null && Object.hasOwnProperty.call(message, "leave")) $31e083413a0a3833$var$$root.SdkLeaveFrame.encode(message.leave, writer.uint32(/* id 11, wireType 2 =*/ 90).fork()).ldelim();
        if (message.leaveAck != null && Object.hasOwnProperty.call(message, "leaveAck")) $31e083413a0a3833$var$$root.SdkLeaveAckFrame.encode(message.leaveAck, writer.uint32(/* id 12, wireType 2 =*/ 98).fork()).ldelim();
        if (message.bitrates != null && Object.hasOwnProperty.call(message, "bitrates")) $31e083413a0a3833$var$$root.SdkBitrateFrame.encode(message.bitrates, writer.uint32(/* id 14, wireType 2 =*/ 114).fork()).ldelim();
        if (message.audioControl != null && Object.hasOwnProperty.call(message, "audioControl")) $31e083413a0a3833$var$$root.SdkAudioControlFrame.encode(message.audioControl, writer.uint32(/* id 17, wireType 2 =*/ 138).fork()).ldelim();
        if (message.audioMetadata != null && Object.hasOwnProperty.call(message, "audioMetadata")) $31e083413a0a3833$var$$root.SdkAudioMetadataFrame.encode(message.audioMetadata, writer.uint32(/* id 18, wireType 2 =*/ 146).fork()).ldelim();
        if (message.audioStreamIdInfo != null && Object.hasOwnProperty.call(message, "audioStreamIdInfo")) $31e083413a0a3833$var$$root.SdkAudioStreamIdInfoFrame.encode(message.audioStreamIdInfo, writer.uint32(/* id 19, wireType 2 =*/ 154).fork()).ldelim();
        if (message.pingPong != null && Object.hasOwnProperty.call(message, "pingPong")) $31e083413a0a3833$var$$root.SdkPingPongFrame.encode(message.pingPong, writer.uint32(/* id 20, wireType 2 =*/ 162).fork()).ldelim();
        if (message.audioStatus != null && Object.hasOwnProperty.call(message, "audioStatus")) $31e083413a0a3833$var$$root.SdkAudioStatusFrame.encode(message.audioStatus, writer.uint32(/* id 21, wireType 2 =*/ 170).fork()).ldelim();
        if (message.clientMetric != null && Object.hasOwnProperty.call(message, "clientMetric")) $31e083413a0a3833$var$$root.SdkClientMetricFrame.encode(message.clientMetric, writer.uint32(/* id 22, wireType 2 =*/ 178).fork()).ldelim();
        if (message.dataMessage != null && Object.hasOwnProperty.call(message, "dataMessage")) $31e083413a0a3833$var$$root.SdkDataMessageFrame.encode(message.dataMessage, writer.uint32(/* id 23, wireType 2 =*/ 186).fork()).ldelim();
        if (message.remoteVideoUpdate != null && Object.hasOwnProperty.call(message, "remoteVideoUpdate")) $31e083413a0a3833$var$$root.SdkRemoteVideoUpdateFrame.encode(message.remoteVideoUpdate, writer.uint32(/* id 25, wireType 2 =*/ 202).fork()).ldelim();
        if (message.primaryMeetingJoin != null && Object.hasOwnProperty.call(message, "primaryMeetingJoin")) $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinFrame.encode(message.primaryMeetingJoin, writer.uint32(/* id 26, wireType 2 =*/ 210).fork()).ldelim();
        if (message.primaryMeetingJoinAck != null && Object.hasOwnProperty.call(message, "primaryMeetingJoinAck")) $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinAckFrame.encode(message.primaryMeetingJoinAck, writer.uint32(/* id 27, wireType 2 =*/ 218).fork()).ldelim();
        if (message.primaryMeetingLeave != null && Object.hasOwnProperty.call(message, "primaryMeetingLeave")) $31e083413a0a3833$var$$root.SdkPrimaryMeetingLeaveFrame.encode(message.primaryMeetingLeave, writer.uint32(/* id 28, wireType 2 =*/ 226).fork()).ldelim();
        if (message.notification != null && Object.hasOwnProperty.call(message, "notification")) $31e083413a0a3833$var$$root.SdkNotificationFrame.encode(message.notification, writer.uint32(/* id 35, wireType 2 =*/ 282).fork()).ldelim();
        if (message.meetingSessionTiming != null && Object.hasOwnProperty.call(message, "meetingSessionTiming")) $31e083413a0a3833$var$$root.SdkMeetingSessionTimingFrame.encode(message.meetingSessionTiming, writer.uint32(/* id 44, wireType 2 =*/ 354).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkSignalFrame message, length delimited. Does not implicitly {@link SdkSignalFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkSignalFrame
     * @static
     * @param {ISdkSignalFrame} message SdkSignalFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkSignalFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkSignalFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkSignalFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkSignalFrame} SdkSignalFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkSignalFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkSignalFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.timestampMs = reader.uint64();
                    break;
                case 2:
                    message.type = reader.int32();
                    break;
                case 3:
                    message.error = $31e083413a0a3833$var$$root.SdkErrorFrame.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.join = $31e083413a0a3833$var$$root.SdkJoinFrame.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.joinack = $31e083413a0a3833$var$$root.SdkJoinAckFrame.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.sub = $31e083413a0a3833$var$$root.SdkSubscribeFrame.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.suback = $31e083413a0a3833$var$$root.SdkSubscribeAckFrame.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.index = $31e083413a0a3833$var$$root.SdkIndexFrame.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.pause = $31e083413a0a3833$var$$root.SdkPauseResumeFrame.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.leave = $31e083413a0a3833$var$$root.SdkLeaveFrame.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.leaveAck = $31e083413a0a3833$var$$root.SdkLeaveAckFrame.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.bitrates = $31e083413a0a3833$var$$root.SdkBitrateFrame.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.audioControl = $31e083413a0a3833$var$$root.SdkAudioControlFrame.decode(reader, reader.uint32());
                    break;
                case 18:
                    message.audioMetadata = $31e083413a0a3833$var$$root.SdkAudioMetadataFrame.decode(reader, reader.uint32());
                    break;
                case 19:
                    message.audioStreamIdInfo = $31e083413a0a3833$var$$root.SdkAudioStreamIdInfoFrame.decode(reader, reader.uint32());
                    break;
                case 20:
                    message.pingPong = $31e083413a0a3833$var$$root.SdkPingPongFrame.decode(reader, reader.uint32());
                    break;
                case 21:
                    message.audioStatus = $31e083413a0a3833$var$$root.SdkAudioStatusFrame.decode(reader, reader.uint32());
                    break;
                case 22:
                    message.clientMetric = $31e083413a0a3833$var$$root.SdkClientMetricFrame.decode(reader, reader.uint32());
                    break;
                case 23:
                    message.dataMessage = $31e083413a0a3833$var$$root.SdkDataMessageFrame.decode(reader, reader.uint32());
                    break;
                case 25:
                    message.remoteVideoUpdate = $31e083413a0a3833$var$$root.SdkRemoteVideoUpdateFrame.decode(reader, reader.uint32());
                    break;
                case 26:
                    message.primaryMeetingJoin = $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinFrame.decode(reader, reader.uint32());
                    break;
                case 27:
                    message.primaryMeetingJoinAck = $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinAckFrame.decode(reader, reader.uint32());
                    break;
                case 28:
                    message.primaryMeetingLeave = $31e083413a0a3833$var$$root.SdkPrimaryMeetingLeaveFrame.decode(reader, reader.uint32());
                    break;
                case 35:
                    message.notification = $31e083413a0a3833$var$$root.SdkNotificationFrame.decode(reader, reader.uint32());
                    break;
                case 44:
                    message.meetingSessionTiming = $31e083413a0a3833$var$$root.SdkMeetingSessionTimingFrame.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        if (!message.hasOwnProperty("timestampMs")) throw $31e083413a0a3833$var$$util.ProtocolError("missing required 'timestampMs'", {
            instance: message
        });
        if (!message.hasOwnProperty("type")) throw $31e083413a0a3833$var$$util.ProtocolError("missing required 'type'", {
            instance: message
        });
        return message;
    };
    /**
     * Decodes a SdkSignalFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkSignalFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkSignalFrame} SdkSignalFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkSignalFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkSignalFrame message.
     * @function verify
     * @memberof SdkSignalFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkSignalFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (!$31e083413a0a3833$var$$util.isInteger(message.timestampMs) && !(message.timestampMs && $31e083413a0a3833$var$$util.isInteger(message.timestampMs.low) && $31e083413a0a3833$var$$util.isInteger(message.timestampMs.high))) return "timestampMs: integer|Long expected";
        switch(message.type){
            default:
                return "type: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 7:
            case 8:
            case 9:
            case 10:
            case 13:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 21:
            case 22:
            case 24:
            case 25:
            case 26:
            case 27:
            case 34:
            case 43:
                break;
        }
        if (message.error != null && message.hasOwnProperty("error")) {
            var error = $31e083413a0a3833$var$$root.SdkErrorFrame.verify(message.error);
            if (error) return "error." + error;
        }
        if (message.join != null && message.hasOwnProperty("join")) {
            var error = $31e083413a0a3833$var$$root.SdkJoinFrame.verify(message.join);
            if (error) return "join." + error;
        }
        if (message.joinack != null && message.hasOwnProperty("joinack")) {
            var error = $31e083413a0a3833$var$$root.SdkJoinAckFrame.verify(message.joinack);
            if (error) return "joinack." + error;
        }
        if (message.sub != null && message.hasOwnProperty("sub")) {
            var error = $31e083413a0a3833$var$$root.SdkSubscribeFrame.verify(message.sub);
            if (error) return "sub." + error;
        }
        if (message.suback != null && message.hasOwnProperty("suback")) {
            var error = $31e083413a0a3833$var$$root.SdkSubscribeAckFrame.verify(message.suback);
            if (error) return "suback." + error;
        }
        if (message.index != null && message.hasOwnProperty("index")) {
            var error = $31e083413a0a3833$var$$root.SdkIndexFrame.verify(message.index);
            if (error) return "index." + error;
        }
        if (message.pause != null && message.hasOwnProperty("pause")) {
            var error = $31e083413a0a3833$var$$root.SdkPauseResumeFrame.verify(message.pause);
            if (error) return "pause." + error;
        }
        if (message.leave != null && message.hasOwnProperty("leave")) {
            var error = $31e083413a0a3833$var$$root.SdkLeaveFrame.verify(message.leave);
            if (error) return "leave." + error;
        }
        if (message.leaveAck != null && message.hasOwnProperty("leaveAck")) {
            var error = $31e083413a0a3833$var$$root.SdkLeaveAckFrame.verify(message.leaveAck);
            if (error) return "leaveAck." + error;
        }
        if (message.bitrates != null && message.hasOwnProperty("bitrates")) {
            var error = $31e083413a0a3833$var$$root.SdkBitrateFrame.verify(message.bitrates);
            if (error) return "bitrates." + error;
        }
        if (message.audioControl != null && message.hasOwnProperty("audioControl")) {
            var error = $31e083413a0a3833$var$$root.SdkAudioControlFrame.verify(message.audioControl);
            if (error) return "audioControl." + error;
        }
        if (message.audioMetadata != null && message.hasOwnProperty("audioMetadata")) {
            var error = $31e083413a0a3833$var$$root.SdkAudioMetadataFrame.verify(message.audioMetadata);
            if (error) return "audioMetadata." + error;
        }
        if (message.audioStreamIdInfo != null && message.hasOwnProperty("audioStreamIdInfo")) {
            var error = $31e083413a0a3833$var$$root.SdkAudioStreamIdInfoFrame.verify(message.audioStreamIdInfo);
            if (error) return "audioStreamIdInfo." + error;
        }
        if (message.pingPong != null && message.hasOwnProperty("pingPong")) {
            var error = $31e083413a0a3833$var$$root.SdkPingPongFrame.verify(message.pingPong);
            if (error) return "pingPong." + error;
        }
        if (message.audioStatus != null && message.hasOwnProperty("audioStatus")) {
            var error = $31e083413a0a3833$var$$root.SdkAudioStatusFrame.verify(message.audioStatus);
            if (error) return "audioStatus." + error;
        }
        if (message.clientMetric != null && message.hasOwnProperty("clientMetric")) {
            var error = $31e083413a0a3833$var$$root.SdkClientMetricFrame.verify(message.clientMetric);
            if (error) return "clientMetric." + error;
        }
        if (message.dataMessage != null && message.hasOwnProperty("dataMessage")) {
            var error = $31e083413a0a3833$var$$root.SdkDataMessageFrame.verify(message.dataMessage);
            if (error) return "dataMessage." + error;
        }
        if (message.remoteVideoUpdate != null && message.hasOwnProperty("remoteVideoUpdate")) {
            var error = $31e083413a0a3833$var$$root.SdkRemoteVideoUpdateFrame.verify(message.remoteVideoUpdate);
            if (error) return "remoteVideoUpdate." + error;
        }
        if (message.primaryMeetingJoin != null && message.hasOwnProperty("primaryMeetingJoin")) {
            var error = $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinFrame.verify(message.primaryMeetingJoin);
            if (error) return "primaryMeetingJoin." + error;
        }
        if (message.primaryMeetingJoinAck != null && message.hasOwnProperty("primaryMeetingJoinAck")) {
            var error = $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinAckFrame.verify(message.primaryMeetingJoinAck);
            if (error) return "primaryMeetingJoinAck." + error;
        }
        if (message.primaryMeetingLeave != null && message.hasOwnProperty("primaryMeetingLeave")) {
            var error = $31e083413a0a3833$var$$root.SdkPrimaryMeetingLeaveFrame.verify(message.primaryMeetingLeave);
            if (error) return "primaryMeetingLeave." + error;
        }
        if (message.notification != null && message.hasOwnProperty("notification")) {
            var error = $31e083413a0a3833$var$$root.SdkNotificationFrame.verify(message.notification);
            if (error) return "notification." + error;
        }
        if (message.meetingSessionTiming != null && message.hasOwnProperty("meetingSessionTiming")) {
            var error = $31e083413a0a3833$var$$root.SdkMeetingSessionTimingFrame.verify(message.meetingSessionTiming);
            if (error) return "meetingSessionTiming." + error;
        }
        return null;
    };
    /**
     * Creates a SdkSignalFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkSignalFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkSignalFrame} SdkSignalFrame
     */ SdkSignalFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkSignalFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkSignalFrame();
        if (object.timestampMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.timestampMs = $31e083413a0a3833$var$$util.Long.fromValue(object.timestampMs)).unsigned = true;
            else if (typeof object.timestampMs === "string") message.timestampMs = parseInt(object.timestampMs, 10);
            else if (typeof object.timestampMs === "number") message.timestampMs = object.timestampMs;
            else if (typeof object.timestampMs === "object") message.timestampMs = new $31e083413a0a3833$var$$util.LongBits(object.timestampMs.low >>> 0, object.timestampMs.high >>> 0).toNumber(true);
        }
        switch(object.type){
            default:
                if (typeof object.type === "number") {
                    message.type = object.type;
                    break;
                }
                break;
            case "JOIN":
            case 1:
                message.type = 1;
                break;
            case "JOIN_ACK":
            case 2:
                message.type = 2;
                break;
            case "SUBSCRIBE":
            case 3:
                message.type = 3;
                break;
            case "SUBSCRIBE_ACK":
            case 4:
                message.type = 4;
                break;
            case "INDEX":
            case 5:
                message.type = 5;
                break;
            case "PAUSE":
            case 7:
                message.type = 7;
                break;
            case "RESUME":
            case 8:
                message.type = 8;
                break;
            case "LEAVE":
            case 9:
                message.type = 9;
                break;
            case "LEAVE_ACK":
            case 10:
                message.type = 10;
                break;
            case "BITRATES":
            case 13:
                message.type = 13;
                break;
            case "AUDIO_CONTROL":
            case 16:
                message.type = 16;
                break;
            case "AUDIO_METADATA":
            case 17:
                message.type = 17;
                break;
            case "AUDIO_STREAM_ID_INFO":
            case 18:
                message.type = 18;
                break;
            case "PING_PONG":
            case 19:
                message.type = 19;
                break;
            case "AUDIO_STATUS":
            case 20:
                message.type = 20;
                break;
            case "CLIENT_METRIC":
            case 21:
                message.type = 21;
                break;
            case "DATA_MESSAGE":
            case 22:
                message.type = 22;
                break;
            case "REMOTE_VIDEO_UPDATE":
            case 24:
                message.type = 24;
                break;
            case "PRIMARY_MEETING_JOIN":
            case 25:
                message.type = 25;
                break;
            case "PRIMARY_MEETING_JOIN_ACK":
            case 26:
                message.type = 26;
                break;
            case "PRIMARY_MEETING_LEAVE":
            case 27:
                message.type = 27;
                break;
            case "NOTIFICATION":
            case 34:
                message.type = 34;
                break;
            case "MEETING_SESSION_TIMING":
            case 43:
                message.type = 43;
                break;
        }
        if (object.error != null) {
            if (typeof object.error !== "object") throw TypeError(".SdkSignalFrame.error: object expected");
            message.error = $31e083413a0a3833$var$$root.SdkErrorFrame.fromObject(object.error);
        }
        if (object.join != null) {
            if (typeof object.join !== "object") throw TypeError(".SdkSignalFrame.join: object expected");
            message.join = $31e083413a0a3833$var$$root.SdkJoinFrame.fromObject(object.join);
        }
        if (object.joinack != null) {
            if (typeof object.joinack !== "object") throw TypeError(".SdkSignalFrame.joinack: object expected");
            message.joinack = $31e083413a0a3833$var$$root.SdkJoinAckFrame.fromObject(object.joinack);
        }
        if (object.sub != null) {
            if (typeof object.sub !== "object") throw TypeError(".SdkSignalFrame.sub: object expected");
            message.sub = $31e083413a0a3833$var$$root.SdkSubscribeFrame.fromObject(object.sub);
        }
        if (object.suback != null) {
            if (typeof object.suback !== "object") throw TypeError(".SdkSignalFrame.suback: object expected");
            message.suback = $31e083413a0a3833$var$$root.SdkSubscribeAckFrame.fromObject(object.suback);
        }
        if (object.index != null) {
            if (typeof object.index !== "object") throw TypeError(".SdkSignalFrame.index: object expected");
            message.index = $31e083413a0a3833$var$$root.SdkIndexFrame.fromObject(object.index);
        }
        if (object.pause != null) {
            if (typeof object.pause !== "object") throw TypeError(".SdkSignalFrame.pause: object expected");
            message.pause = $31e083413a0a3833$var$$root.SdkPauseResumeFrame.fromObject(object.pause);
        }
        if (object.leave != null) {
            if (typeof object.leave !== "object") throw TypeError(".SdkSignalFrame.leave: object expected");
            message.leave = $31e083413a0a3833$var$$root.SdkLeaveFrame.fromObject(object.leave);
        }
        if (object.leaveAck != null) {
            if (typeof object.leaveAck !== "object") throw TypeError(".SdkSignalFrame.leaveAck: object expected");
            message.leaveAck = $31e083413a0a3833$var$$root.SdkLeaveAckFrame.fromObject(object.leaveAck);
        }
        if (object.bitrates != null) {
            if (typeof object.bitrates !== "object") throw TypeError(".SdkSignalFrame.bitrates: object expected");
            message.bitrates = $31e083413a0a3833$var$$root.SdkBitrateFrame.fromObject(object.bitrates);
        }
        if (object.audioControl != null) {
            if (typeof object.audioControl !== "object") throw TypeError(".SdkSignalFrame.audioControl: object expected");
            message.audioControl = $31e083413a0a3833$var$$root.SdkAudioControlFrame.fromObject(object.audioControl);
        }
        if (object.audioMetadata != null) {
            if (typeof object.audioMetadata !== "object") throw TypeError(".SdkSignalFrame.audioMetadata: object expected");
            message.audioMetadata = $31e083413a0a3833$var$$root.SdkAudioMetadataFrame.fromObject(object.audioMetadata);
        }
        if (object.audioStreamIdInfo != null) {
            if (typeof object.audioStreamIdInfo !== "object") throw TypeError(".SdkSignalFrame.audioStreamIdInfo: object expected");
            message.audioStreamIdInfo = $31e083413a0a3833$var$$root.SdkAudioStreamIdInfoFrame.fromObject(object.audioStreamIdInfo);
        }
        if (object.pingPong != null) {
            if (typeof object.pingPong !== "object") throw TypeError(".SdkSignalFrame.pingPong: object expected");
            message.pingPong = $31e083413a0a3833$var$$root.SdkPingPongFrame.fromObject(object.pingPong);
        }
        if (object.audioStatus != null) {
            if (typeof object.audioStatus !== "object") throw TypeError(".SdkSignalFrame.audioStatus: object expected");
            message.audioStatus = $31e083413a0a3833$var$$root.SdkAudioStatusFrame.fromObject(object.audioStatus);
        }
        if (object.clientMetric != null) {
            if (typeof object.clientMetric !== "object") throw TypeError(".SdkSignalFrame.clientMetric: object expected");
            message.clientMetric = $31e083413a0a3833$var$$root.SdkClientMetricFrame.fromObject(object.clientMetric);
        }
        if (object.dataMessage != null) {
            if (typeof object.dataMessage !== "object") throw TypeError(".SdkSignalFrame.dataMessage: object expected");
            message.dataMessage = $31e083413a0a3833$var$$root.SdkDataMessageFrame.fromObject(object.dataMessage);
        }
        if (object.remoteVideoUpdate != null) {
            if (typeof object.remoteVideoUpdate !== "object") throw TypeError(".SdkSignalFrame.remoteVideoUpdate: object expected");
            message.remoteVideoUpdate = $31e083413a0a3833$var$$root.SdkRemoteVideoUpdateFrame.fromObject(object.remoteVideoUpdate);
        }
        if (object.primaryMeetingJoin != null) {
            if (typeof object.primaryMeetingJoin !== "object") throw TypeError(".SdkSignalFrame.primaryMeetingJoin: object expected");
            message.primaryMeetingJoin = $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinFrame.fromObject(object.primaryMeetingJoin);
        }
        if (object.primaryMeetingJoinAck != null) {
            if (typeof object.primaryMeetingJoinAck !== "object") throw TypeError(".SdkSignalFrame.primaryMeetingJoinAck: object expected");
            message.primaryMeetingJoinAck = $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinAckFrame.fromObject(object.primaryMeetingJoinAck);
        }
        if (object.primaryMeetingLeave != null) {
            if (typeof object.primaryMeetingLeave !== "object") throw TypeError(".SdkSignalFrame.primaryMeetingLeave: object expected");
            message.primaryMeetingLeave = $31e083413a0a3833$var$$root.SdkPrimaryMeetingLeaveFrame.fromObject(object.primaryMeetingLeave);
        }
        if (object.notification != null) {
            if (typeof object.notification !== "object") throw TypeError(".SdkSignalFrame.notification: object expected");
            message.notification = $31e083413a0a3833$var$$root.SdkNotificationFrame.fromObject(object.notification);
        }
        if (object.meetingSessionTiming != null) {
            if (typeof object.meetingSessionTiming !== "object") throw TypeError(".SdkSignalFrame.meetingSessionTiming: object expected");
            message.meetingSessionTiming = $31e083413a0a3833$var$$root.SdkMeetingSessionTimingFrame.fromObject(object.meetingSessionTiming);
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkSignalFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkSignalFrame
     * @static
     * @param {SdkSignalFrame} message SdkSignalFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkSignalFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, true);
                object.timestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.timestampMs = options.longs === String ? "0" : 0;
            object.type = options.enums === String ? "JOIN" : 1;
            object.error = null;
            object.join = null;
            object.joinack = null;
            object.sub = null;
            object.suback = null;
            object.index = null;
            object.pause = null;
            object.leave = null;
            object.leaveAck = null;
            object.bitrates = null;
            object.audioControl = null;
            object.audioMetadata = null;
            object.audioStreamIdInfo = null;
            object.pingPong = null;
            object.audioStatus = null;
            object.clientMetric = null;
            object.dataMessage = null;
            object.remoteVideoUpdate = null;
            object.primaryMeetingJoin = null;
            object.primaryMeetingJoinAck = null;
            object.primaryMeetingLeave = null;
            object.notification = null;
            object.meetingSessionTiming = null;
        }
        if (message.timestampMs != null && message.hasOwnProperty("timestampMs")) {
            if (typeof message.timestampMs === "number") object.timestampMs = options.longs === String ? String(message.timestampMs) : message.timestampMs;
            else object.timestampMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.timestampMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.timestampMs.low >>> 0, message.timestampMs.high >>> 0).toNumber(true) : message.timestampMs;
        }
        if (message.type != null && message.hasOwnProperty("type")) object.type = options.enums === String ? $31e083413a0a3833$var$$root.SdkSignalFrame.Type[message.type] === undefined ? message.type : $31e083413a0a3833$var$$root.SdkSignalFrame.Type[message.type] : message.type;
        if (message.error != null && message.hasOwnProperty("error")) object.error = $31e083413a0a3833$var$$root.SdkErrorFrame.toObject(message.error, options);
        if (message.join != null && message.hasOwnProperty("join")) object.join = $31e083413a0a3833$var$$root.SdkJoinFrame.toObject(message.join, options);
        if (message.joinack != null && message.hasOwnProperty("joinack")) object.joinack = $31e083413a0a3833$var$$root.SdkJoinAckFrame.toObject(message.joinack, options);
        if (message.sub != null && message.hasOwnProperty("sub")) object.sub = $31e083413a0a3833$var$$root.SdkSubscribeFrame.toObject(message.sub, options);
        if (message.suback != null && message.hasOwnProperty("suback")) object.suback = $31e083413a0a3833$var$$root.SdkSubscribeAckFrame.toObject(message.suback, options);
        if (message.index != null && message.hasOwnProperty("index")) object.index = $31e083413a0a3833$var$$root.SdkIndexFrame.toObject(message.index, options);
        if (message.pause != null && message.hasOwnProperty("pause")) object.pause = $31e083413a0a3833$var$$root.SdkPauseResumeFrame.toObject(message.pause, options);
        if (message.leave != null && message.hasOwnProperty("leave")) object.leave = $31e083413a0a3833$var$$root.SdkLeaveFrame.toObject(message.leave, options);
        if (message.leaveAck != null && message.hasOwnProperty("leaveAck")) object.leaveAck = $31e083413a0a3833$var$$root.SdkLeaveAckFrame.toObject(message.leaveAck, options);
        if (message.bitrates != null && message.hasOwnProperty("bitrates")) object.bitrates = $31e083413a0a3833$var$$root.SdkBitrateFrame.toObject(message.bitrates, options);
        if (message.audioControl != null && message.hasOwnProperty("audioControl")) object.audioControl = $31e083413a0a3833$var$$root.SdkAudioControlFrame.toObject(message.audioControl, options);
        if (message.audioMetadata != null && message.hasOwnProperty("audioMetadata")) object.audioMetadata = $31e083413a0a3833$var$$root.SdkAudioMetadataFrame.toObject(message.audioMetadata, options);
        if (message.audioStreamIdInfo != null && message.hasOwnProperty("audioStreamIdInfo")) object.audioStreamIdInfo = $31e083413a0a3833$var$$root.SdkAudioStreamIdInfoFrame.toObject(message.audioStreamIdInfo, options);
        if (message.pingPong != null && message.hasOwnProperty("pingPong")) object.pingPong = $31e083413a0a3833$var$$root.SdkPingPongFrame.toObject(message.pingPong, options);
        if (message.audioStatus != null && message.hasOwnProperty("audioStatus")) object.audioStatus = $31e083413a0a3833$var$$root.SdkAudioStatusFrame.toObject(message.audioStatus, options);
        if (message.clientMetric != null && message.hasOwnProperty("clientMetric")) object.clientMetric = $31e083413a0a3833$var$$root.SdkClientMetricFrame.toObject(message.clientMetric, options);
        if (message.dataMessage != null && message.hasOwnProperty("dataMessage")) object.dataMessage = $31e083413a0a3833$var$$root.SdkDataMessageFrame.toObject(message.dataMessage, options);
        if (message.remoteVideoUpdate != null && message.hasOwnProperty("remoteVideoUpdate")) object.remoteVideoUpdate = $31e083413a0a3833$var$$root.SdkRemoteVideoUpdateFrame.toObject(message.remoteVideoUpdate, options);
        if (message.primaryMeetingJoin != null && message.hasOwnProperty("primaryMeetingJoin")) object.primaryMeetingJoin = $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinFrame.toObject(message.primaryMeetingJoin, options);
        if (message.primaryMeetingJoinAck != null && message.hasOwnProperty("primaryMeetingJoinAck")) object.primaryMeetingJoinAck = $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinAckFrame.toObject(message.primaryMeetingJoinAck, options);
        if (message.primaryMeetingLeave != null && message.hasOwnProperty("primaryMeetingLeave")) object.primaryMeetingLeave = $31e083413a0a3833$var$$root.SdkPrimaryMeetingLeaveFrame.toObject(message.primaryMeetingLeave, options);
        if (message.notification != null && message.hasOwnProperty("notification")) object.notification = $31e083413a0a3833$var$$root.SdkNotificationFrame.toObject(message.notification, options);
        if (message.meetingSessionTiming != null && message.hasOwnProperty("meetingSessionTiming")) object.meetingSessionTiming = $31e083413a0a3833$var$$root.SdkMeetingSessionTimingFrame.toObject(message.meetingSessionTiming, options);
        return object;
    };
    /**
     * Converts this SdkSignalFrame to JSON.
     * @function toJSON
     * @memberof SdkSignalFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkSignalFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkSignalFrame
     * @function getTypeUrl
     * @memberof SdkSignalFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkSignalFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkSignalFrame";
    };
    /**
     * Type enum.
     * @name SdkSignalFrame.Type
     * @enum {number}
     * @property {number} JOIN=1 JOIN value
     * @property {number} JOIN_ACK=2 JOIN_ACK value
     * @property {number} SUBSCRIBE=3 SUBSCRIBE value
     * @property {number} SUBSCRIBE_ACK=4 SUBSCRIBE_ACK value
     * @property {number} INDEX=5 INDEX value
     * @property {number} PAUSE=7 PAUSE value
     * @property {number} RESUME=8 RESUME value
     * @property {number} LEAVE=9 LEAVE value
     * @property {number} LEAVE_ACK=10 LEAVE_ACK value
     * @property {number} BITRATES=13 BITRATES value
     * @property {number} AUDIO_CONTROL=16 AUDIO_CONTROL value
     * @property {number} AUDIO_METADATA=17 AUDIO_METADATA value
     * @property {number} AUDIO_STREAM_ID_INFO=18 AUDIO_STREAM_ID_INFO value
     * @property {number} PING_PONG=19 PING_PONG value
     * @property {number} AUDIO_STATUS=20 AUDIO_STATUS value
     * @property {number} CLIENT_METRIC=21 CLIENT_METRIC value
     * @property {number} DATA_MESSAGE=22 DATA_MESSAGE value
     * @property {number} REMOTE_VIDEO_UPDATE=24 REMOTE_VIDEO_UPDATE value
     * @property {number} PRIMARY_MEETING_JOIN=25 PRIMARY_MEETING_JOIN value
     * @property {number} PRIMARY_MEETING_JOIN_ACK=26 PRIMARY_MEETING_JOIN_ACK value
     * @property {number} PRIMARY_MEETING_LEAVE=27 PRIMARY_MEETING_LEAVE value
     * @property {number} NOTIFICATION=34 NOTIFICATION value
     * @property {number} MEETING_SESSION_TIMING=43 MEETING_SESSION_TIMING value
     */ SdkSignalFrame.Type = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "JOIN"] = 1;
        values[valuesById[2] = "JOIN_ACK"] = 2;
        values[valuesById[3] = "SUBSCRIBE"] = 3;
        values[valuesById[4] = "SUBSCRIBE_ACK"] = 4;
        values[valuesById[5] = "INDEX"] = 5;
        values[valuesById[7] = "PAUSE"] = 7;
        values[valuesById[8] = "RESUME"] = 8;
        values[valuesById[9] = "LEAVE"] = 9;
        values[valuesById[10] = "LEAVE_ACK"] = 10;
        values[valuesById[13] = "BITRATES"] = 13;
        values[valuesById[16] = "AUDIO_CONTROL"] = 16;
        values[valuesById[17] = "AUDIO_METADATA"] = 17;
        values[valuesById[18] = "AUDIO_STREAM_ID_INFO"] = 18;
        values[valuesById[19] = "PING_PONG"] = 19;
        values[valuesById[20] = "AUDIO_STATUS"] = 20;
        values[valuesById[21] = "CLIENT_METRIC"] = 21;
        values[valuesById[22] = "DATA_MESSAGE"] = 22;
        values[valuesById[24] = "REMOTE_VIDEO_UPDATE"] = 24;
        values[valuesById[25] = "PRIMARY_MEETING_JOIN"] = 25;
        values[valuesById[26] = "PRIMARY_MEETING_JOIN_ACK"] = 26;
        values[valuesById[27] = "PRIMARY_MEETING_LEAVE"] = 27;
        values[valuesById[34] = "NOTIFICATION"] = 34;
        values[valuesById[43] = "MEETING_SESSION_TIMING"] = 43;
        return values;
    }();
    return SdkSignalFrame;
}();
$31e083413a0a3833$var$$root.SdkErrorFrame = function() {
    /**
     * Properties of a SdkErrorFrame.
     * @name ISdkErrorFrame
     * @interface ISdkErrorFrame
     * @property {number|null} [status] SdkErrorFrame status
     * @property {string|null} [description] SdkErrorFrame description
     */ /**
     * Constructs a new SdkErrorFrame.
     * @name SdkErrorFrame
     * @classdesc Represents a SdkErrorFrame.
     * @implements ISdkErrorFrame
     * @constructor
     * @param {ISdkErrorFrame=} [properties] Properties to set
     */ function SdkErrorFrame(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkErrorFrame status.
     * @member {number} status
     * @memberof SdkErrorFrame
     * @instance
     */ SdkErrorFrame.prototype.status = 0;
    /**
     * SdkErrorFrame description.
     * @member {string} description
     * @memberof SdkErrorFrame
     * @instance
     */ SdkErrorFrame.prototype.description = "";
    /**
     * Creates a new SdkErrorFrame instance using the specified properties.
     * @function create
     * @memberof SdkErrorFrame
     * @static
     * @param {ISdkErrorFrame=} [properties] Properties to set
     * @returns {SdkErrorFrame} SdkErrorFrame instance
     */ SdkErrorFrame.create = function create(properties) {
        return new SdkErrorFrame(properties);
    };
    /**
     * Encodes the specified SdkErrorFrame message. Does not implicitly {@link SdkErrorFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkErrorFrame
     * @static
     * @param {ISdkErrorFrame} message SdkErrorFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkErrorFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.status != null && Object.hasOwnProperty.call(message, "status")) writer.uint32(/* id 1, wireType 0 =*/ 8).uint32(message.status);
        if (message.description != null && Object.hasOwnProperty.call(message, "description")) writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.description);
        return writer;
    };
    /**
     * Encodes the specified SdkErrorFrame message, length delimited. Does not implicitly {@link SdkErrorFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkErrorFrame
     * @static
     * @param {ISdkErrorFrame} message SdkErrorFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkErrorFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkErrorFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkErrorFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkErrorFrame} SdkErrorFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkErrorFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkErrorFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.uint32();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkErrorFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkErrorFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkErrorFrame} SdkErrorFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkErrorFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkErrorFrame message.
     * @function verify
     * @memberof SdkErrorFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkErrorFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.status != null && message.hasOwnProperty("status")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.status)) return "status: integer expected";
        }
        if (message.description != null && message.hasOwnProperty("description")) {
            if (!$31e083413a0a3833$var$$util.isString(message.description)) return "description: string expected";
        }
        return null;
    };
    /**
     * Creates a SdkErrorFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkErrorFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkErrorFrame} SdkErrorFrame
     */ SdkErrorFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkErrorFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkErrorFrame();
        if (object.status != null) message.status = object.status >>> 0;
        if (object.description != null) message.description = String(object.description);
        return message;
    };
    /**
     * Creates a plain object from a SdkErrorFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkErrorFrame
     * @static
     * @param {SdkErrorFrame} message SdkErrorFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkErrorFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.status = 0;
            object.description = "";
        }
        if (message.status != null && message.hasOwnProperty("status")) object.status = message.status;
        if (message.description != null && message.hasOwnProperty("description")) object.description = message.description;
        return object;
    };
    /**
     * Converts this SdkErrorFrame to JSON.
     * @function toJSON
     * @memberof SdkErrorFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkErrorFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkErrorFrame
     * @function getTypeUrl
     * @memberof SdkErrorFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkErrorFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkErrorFrame";
    };
    return SdkErrorFrame;
}();
/**
 * SdkJoinFlags enum.
 * @name SdkJoinFlags
 * @enum {number}
 * @property {number} HAS_STREAM_UPDATE=2 HAS_STREAM_UPDATE value
 * @property {number} COMPLETE_VIDEO_SOURCES_LIST=16 COMPLETE_VIDEO_SOURCES_LIST value
 * @property {number} EXCLUDE_SELF_CONTENT_IN_INDEX=32 EXCLUDE_SELF_CONTENT_IN_INDEX value
 */ $31e083413a0a3833$var$$root.SdkJoinFlags = function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[2] = "HAS_STREAM_UPDATE"] = 2;
    values[valuesById[16] = "COMPLETE_VIDEO_SOURCES_LIST"] = 16;
    values[valuesById[32] = "EXCLUDE_SELF_CONTENT_IN_INDEX"] = 32;
    return values;
}();
$31e083413a0a3833$var$$root.SdkClientDetails = function() {
    /**
     * Properties of a SdkClientDetails.
     * @name ISdkClientDetails
     * @interface ISdkClientDetails
     * @property {string|null} [appName] SdkClientDetails appName
     * @property {string|null} [appVersion] SdkClientDetails appVersion
     * @property {string|null} [deviceModel] SdkClientDetails deviceModel
     * @property {string|null} [deviceMake] SdkClientDetails deviceMake
     * @property {string|null} [platformName] SdkClientDetails platformName
     * @property {string|null} [platformVersion] SdkClientDetails platformVersion
     * @property {string|null} [clientSource] SdkClientDetails clientSource
     * @property {string|null} [chimeSdkVersion] SdkClientDetails chimeSdkVersion
     * @property {string|null} [clientUtcOffset] SdkClientDetails clientUtcOffset
     * @property {string|null} [osName] SdkClientDetails osName
     * @property {string|null} [osVersion] SdkClientDetails osVersion
     */ /**
     * Constructs a new SdkClientDetails.
     * @name SdkClientDetails
     * @classdesc Represents a SdkClientDetails.
     * @implements ISdkClientDetails
     * @constructor
     * @param {ISdkClientDetails=} [properties] Properties to set
     */ function SdkClientDetails(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkClientDetails appName.
     * @member {string} appName
     * @memberof SdkClientDetails
     * @instance
     */ SdkClientDetails.prototype.appName = "";
    /**
     * SdkClientDetails appVersion.
     * @member {string} appVersion
     * @memberof SdkClientDetails
     * @instance
     */ SdkClientDetails.prototype.appVersion = "";
    /**
     * SdkClientDetails deviceModel.
     * @member {string} deviceModel
     * @memberof SdkClientDetails
     * @instance
     */ SdkClientDetails.prototype.deviceModel = "";
    /**
     * SdkClientDetails deviceMake.
     * @member {string} deviceMake
     * @memberof SdkClientDetails
     * @instance
     */ SdkClientDetails.prototype.deviceMake = "";
    /**
     * SdkClientDetails platformName.
     * @member {string} platformName
     * @memberof SdkClientDetails
     * @instance
     */ SdkClientDetails.prototype.platformName = "";
    /**
     * SdkClientDetails platformVersion.
     * @member {string} platformVersion
     * @memberof SdkClientDetails
     * @instance
     */ SdkClientDetails.prototype.platformVersion = "";
    /**
     * SdkClientDetails clientSource.
     * @member {string} clientSource
     * @memberof SdkClientDetails
     * @instance
     */ SdkClientDetails.prototype.clientSource = "";
    /**
     * SdkClientDetails chimeSdkVersion.
     * @member {string} chimeSdkVersion
     * @memberof SdkClientDetails
     * @instance
     */ SdkClientDetails.prototype.chimeSdkVersion = "";
    /**
     * SdkClientDetails clientUtcOffset.
     * @member {string} clientUtcOffset
     * @memberof SdkClientDetails
     * @instance
     */ SdkClientDetails.prototype.clientUtcOffset = "";
    /**
     * SdkClientDetails osName.
     * @member {string} osName
     * @memberof SdkClientDetails
     * @instance
     */ SdkClientDetails.prototype.osName = "";
    /**
     * SdkClientDetails osVersion.
     * @member {string} osVersion
     * @memberof SdkClientDetails
     * @instance
     */ SdkClientDetails.prototype.osVersion = "";
    /**
     * Creates a new SdkClientDetails instance using the specified properties.
     * @function create
     * @memberof SdkClientDetails
     * @static
     * @param {ISdkClientDetails=} [properties] Properties to set
     * @returns {SdkClientDetails} SdkClientDetails instance
     */ SdkClientDetails.create = function create(properties) {
        return new SdkClientDetails(properties);
    };
    /**
     * Encodes the specified SdkClientDetails message. Does not implicitly {@link SdkClientDetails.verify|verify} messages.
     * @function encode
     * @memberof SdkClientDetails
     * @static
     * @param {ISdkClientDetails} message SdkClientDetails message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkClientDetails.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.appName != null && Object.hasOwnProperty.call(message, "appName")) writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.appName);
        if (message.appVersion != null && Object.hasOwnProperty.call(message, "appVersion")) writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.appVersion);
        if (message.deviceModel != null && Object.hasOwnProperty.call(message, "deviceModel")) writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.deviceModel);
        if (message.deviceMake != null && Object.hasOwnProperty.call(message, "deviceMake")) writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.deviceMake);
        if (message.platformName != null && Object.hasOwnProperty.call(message, "platformName")) writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.platformName);
        if (message.platformVersion != null && Object.hasOwnProperty.call(message, "platformVersion")) writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.platformVersion);
        if (message.clientSource != null && Object.hasOwnProperty.call(message, "clientSource")) writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.clientSource);
        if (message.chimeSdkVersion != null && Object.hasOwnProperty.call(message, "chimeSdkVersion")) writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.chimeSdkVersion);
        if (message.clientUtcOffset != null && Object.hasOwnProperty.call(message, "clientUtcOffset")) writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.clientUtcOffset);
        if (message.osName != null && Object.hasOwnProperty.call(message, "osName")) writer.uint32(/* id 10, wireType 2 =*/ 82).string(message.osName);
        if (message.osVersion != null && Object.hasOwnProperty.call(message, "osVersion")) writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.osVersion);
        return writer;
    };
    /**
     * Encodes the specified SdkClientDetails message, length delimited. Does not implicitly {@link SdkClientDetails.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkClientDetails
     * @static
     * @param {ISdkClientDetails} message SdkClientDetails message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkClientDetails.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkClientDetails message from the specified reader or buffer.
     * @function decode
     * @memberof SdkClientDetails
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkClientDetails} SdkClientDetails
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkClientDetails.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkClientDetails();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.appName = reader.string();
                    break;
                case 2:
                    message.appVersion = reader.string();
                    break;
                case 3:
                    message.deviceModel = reader.string();
                    break;
                case 4:
                    message.deviceMake = reader.string();
                    break;
                case 5:
                    message.platformName = reader.string();
                    break;
                case 6:
                    message.platformVersion = reader.string();
                    break;
                case 7:
                    message.clientSource = reader.string();
                    break;
                case 8:
                    message.chimeSdkVersion = reader.string();
                    break;
                case 9:
                    message.clientUtcOffset = reader.string();
                    break;
                case 10:
                    message.osName = reader.string();
                    break;
                case 11:
                    message.osVersion = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkClientDetails message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkClientDetails
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkClientDetails} SdkClientDetails
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkClientDetails.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkClientDetails message.
     * @function verify
     * @memberof SdkClientDetails
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkClientDetails.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.appName != null && message.hasOwnProperty("appName")) {
            if (!$31e083413a0a3833$var$$util.isString(message.appName)) return "appName: string expected";
        }
        if (message.appVersion != null && message.hasOwnProperty("appVersion")) {
            if (!$31e083413a0a3833$var$$util.isString(message.appVersion)) return "appVersion: string expected";
        }
        if (message.deviceModel != null && message.hasOwnProperty("deviceModel")) {
            if (!$31e083413a0a3833$var$$util.isString(message.deviceModel)) return "deviceModel: string expected";
        }
        if (message.deviceMake != null && message.hasOwnProperty("deviceMake")) {
            if (!$31e083413a0a3833$var$$util.isString(message.deviceMake)) return "deviceMake: string expected";
        }
        if (message.platformName != null && message.hasOwnProperty("platformName")) {
            if (!$31e083413a0a3833$var$$util.isString(message.platformName)) return "platformName: string expected";
        }
        if (message.platformVersion != null && message.hasOwnProperty("platformVersion")) {
            if (!$31e083413a0a3833$var$$util.isString(message.platformVersion)) return "platformVersion: string expected";
        }
        if (message.clientSource != null && message.hasOwnProperty("clientSource")) {
            if (!$31e083413a0a3833$var$$util.isString(message.clientSource)) return "clientSource: string expected";
        }
        if (message.chimeSdkVersion != null && message.hasOwnProperty("chimeSdkVersion")) {
            if (!$31e083413a0a3833$var$$util.isString(message.chimeSdkVersion)) return "chimeSdkVersion: string expected";
        }
        if (message.clientUtcOffset != null && message.hasOwnProperty("clientUtcOffset")) {
            if (!$31e083413a0a3833$var$$util.isString(message.clientUtcOffset)) return "clientUtcOffset: string expected";
        }
        if (message.osName != null && message.hasOwnProperty("osName")) {
            if (!$31e083413a0a3833$var$$util.isString(message.osName)) return "osName: string expected";
        }
        if (message.osVersion != null && message.hasOwnProperty("osVersion")) {
            if (!$31e083413a0a3833$var$$util.isString(message.osVersion)) return "osVersion: string expected";
        }
        return null;
    };
    /**
     * Creates a SdkClientDetails message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkClientDetails
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkClientDetails} SdkClientDetails
     */ SdkClientDetails.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkClientDetails) return object;
        var message = new $31e083413a0a3833$var$$root.SdkClientDetails();
        if (object.appName != null) message.appName = String(object.appName);
        if (object.appVersion != null) message.appVersion = String(object.appVersion);
        if (object.deviceModel != null) message.deviceModel = String(object.deviceModel);
        if (object.deviceMake != null) message.deviceMake = String(object.deviceMake);
        if (object.platformName != null) message.platformName = String(object.platformName);
        if (object.platformVersion != null) message.platformVersion = String(object.platformVersion);
        if (object.clientSource != null) message.clientSource = String(object.clientSource);
        if (object.chimeSdkVersion != null) message.chimeSdkVersion = String(object.chimeSdkVersion);
        if (object.clientUtcOffset != null) message.clientUtcOffset = String(object.clientUtcOffset);
        if (object.osName != null) message.osName = String(object.osName);
        if (object.osVersion != null) message.osVersion = String(object.osVersion);
        return message;
    };
    /**
     * Creates a plain object from a SdkClientDetails message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkClientDetails
     * @static
     * @param {SdkClientDetails} message SdkClientDetails
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkClientDetails.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.appName = "";
            object.appVersion = "";
            object.deviceModel = "";
            object.deviceMake = "";
            object.platformName = "";
            object.platformVersion = "";
            object.clientSource = "";
            object.chimeSdkVersion = "";
            object.clientUtcOffset = "";
            object.osName = "";
            object.osVersion = "";
        }
        if (message.appName != null && message.hasOwnProperty("appName")) object.appName = message.appName;
        if (message.appVersion != null && message.hasOwnProperty("appVersion")) object.appVersion = message.appVersion;
        if (message.deviceModel != null && message.hasOwnProperty("deviceModel")) object.deviceModel = message.deviceModel;
        if (message.deviceMake != null && message.hasOwnProperty("deviceMake")) object.deviceMake = message.deviceMake;
        if (message.platformName != null && message.hasOwnProperty("platformName")) object.platformName = message.platformName;
        if (message.platformVersion != null && message.hasOwnProperty("platformVersion")) object.platformVersion = message.platformVersion;
        if (message.clientSource != null && message.hasOwnProperty("clientSource")) object.clientSource = message.clientSource;
        if (message.chimeSdkVersion != null && message.hasOwnProperty("chimeSdkVersion")) object.chimeSdkVersion = message.chimeSdkVersion;
        if (message.clientUtcOffset != null && message.hasOwnProperty("clientUtcOffset")) object.clientUtcOffset = message.clientUtcOffset;
        if (message.osName != null && message.hasOwnProperty("osName")) object.osName = message.osName;
        if (message.osVersion != null && message.hasOwnProperty("osVersion")) object.osVersion = message.osVersion;
        return object;
    };
    /**
     * Converts this SdkClientDetails to JSON.
     * @function toJSON
     * @memberof SdkClientDetails
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkClientDetails.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkClientDetails
     * @function getTypeUrl
     * @memberof SdkClientDetails
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkClientDetails.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkClientDetails";
    };
    return SdkClientDetails;
}();
/**
 * SdkServerSideNetworkAdaption enum.
 * @name SdkServerSideNetworkAdaption
 * @enum {number}
 * @property {number} DEFAULT=1 DEFAULT value
 * @property {number} NONE=2 NONE value
 * @property {number} BANDWIDTH_PROBING=3 BANDWIDTH_PROBING value
 * @property {number} BANDWIDTH_PROBING_AND_VIDEO_QUALITY_ADAPTION=4 BANDWIDTH_PROBING_AND_VIDEO_QUALITY_ADAPTION value
 */ $31e083413a0a3833$var$$root.SdkServerSideNetworkAdaption = function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "DEFAULT"] = 1;
    values[valuesById[2] = "NONE"] = 2;
    values[valuesById[3] = "BANDWIDTH_PROBING"] = 3;
    values[valuesById[4] = "BANDWIDTH_PROBING_AND_VIDEO_QUALITY_ADAPTION"] = 4;
    return values;
}();
$31e083413a0a3833$var$$root.SdkJoinFrame = function() {
    /**
     * Properties of a SdkJoinFrame.
     * @name ISdkJoinFrame
     * @interface ISdkJoinFrame
     * @property {number|null} [protocolVersion] SdkJoinFrame protocolVersion
     * @property {number|null} [maxNumOfVideos] SdkJoinFrame maxNumOfVideos
     * @property {number|null} [flags] SdkJoinFrame flags
     * @property {ISdkClientDetails|null} [clientDetails] SdkJoinFrame clientDetails
     * @property {number|Long|null} [audioSessionId] SdkJoinFrame audioSessionId
     * @property {boolean|null} [wantsCompressedSdp] SdkJoinFrame wantsCompressedSdp
     * @property {SdkServerSideNetworkAdaption|null} [serverSideNetworkAdaption] SdkJoinFrame serverSideNetworkAdaption
     * @property {Array.<SdkServerSideNetworkAdaption>|null} [supportedServerSideNetworkAdaptions] SdkJoinFrame supportedServerSideNetworkAdaptions
     * @property {boolean|null} [wantsAllTemporalLayersInIndex] SdkJoinFrame wantsAllTemporalLayersInIndex
     * @property {boolean|null} [disablePeriodicKeyframeRequestOnContentSender] SdkJoinFrame disablePeriodicKeyframeRequestOnContentSender
     */ /**
     * Constructs a new SdkJoinFrame.
     * @name SdkJoinFrame
     * @classdesc Represents a SdkJoinFrame.
     * @implements ISdkJoinFrame
     * @constructor
     * @param {ISdkJoinFrame=} [properties] Properties to set
     */ function SdkJoinFrame(properties) {
        this.supportedServerSideNetworkAdaptions = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkJoinFrame protocolVersion.
     * @member {number} protocolVersion
     * @memberof SdkJoinFrame
     * @instance
     */ SdkJoinFrame.prototype.protocolVersion = 2;
    /**
     * SdkJoinFrame maxNumOfVideos.
     * @member {number} maxNumOfVideos
     * @memberof SdkJoinFrame
     * @instance
     */ SdkJoinFrame.prototype.maxNumOfVideos = 0;
    /**
     * SdkJoinFrame flags.
     * @member {number} flags
     * @memberof SdkJoinFrame
     * @instance
     */ SdkJoinFrame.prototype.flags = 0;
    /**
     * SdkJoinFrame clientDetails.
     * @member {ISdkClientDetails|null|undefined} clientDetails
     * @memberof SdkJoinFrame
     * @instance
     */ SdkJoinFrame.prototype.clientDetails = null;
    /**
     * SdkJoinFrame audioSessionId.
     * @member {number|Long} audioSessionId
     * @memberof SdkJoinFrame
     * @instance
     */ SdkJoinFrame.prototype.audioSessionId = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, true) : 0;
    /**
     * SdkJoinFrame wantsCompressedSdp.
     * @member {boolean} wantsCompressedSdp
     * @memberof SdkJoinFrame
     * @instance
     */ SdkJoinFrame.prototype.wantsCompressedSdp = false;
    /**
     * SdkJoinFrame serverSideNetworkAdaption.
     * @member {SdkServerSideNetworkAdaption} serverSideNetworkAdaption
     * @memberof SdkJoinFrame
     * @instance
     */ SdkJoinFrame.prototype.serverSideNetworkAdaption = 1;
    /**
     * SdkJoinFrame supportedServerSideNetworkAdaptions.
     * @member {Array.<SdkServerSideNetworkAdaption>} supportedServerSideNetworkAdaptions
     * @memberof SdkJoinFrame
     * @instance
     */ SdkJoinFrame.prototype.supportedServerSideNetworkAdaptions = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkJoinFrame wantsAllTemporalLayersInIndex.
     * @member {boolean} wantsAllTemporalLayersInIndex
     * @memberof SdkJoinFrame
     * @instance
     */ SdkJoinFrame.prototype.wantsAllTemporalLayersInIndex = false;
    /**
     * SdkJoinFrame disablePeriodicKeyframeRequestOnContentSender.
     * @member {boolean} disablePeriodicKeyframeRequestOnContentSender
     * @memberof SdkJoinFrame
     * @instance
     */ SdkJoinFrame.prototype.disablePeriodicKeyframeRequestOnContentSender = false;
    /**
     * Creates a new SdkJoinFrame instance using the specified properties.
     * @function create
     * @memberof SdkJoinFrame
     * @static
     * @param {ISdkJoinFrame=} [properties] Properties to set
     * @returns {SdkJoinFrame} SdkJoinFrame instance
     */ SdkJoinFrame.create = function create(properties) {
        return new SdkJoinFrame(properties);
    };
    /**
     * Encodes the specified SdkJoinFrame message. Does not implicitly {@link SdkJoinFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkJoinFrame
     * @static
     * @param {ISdkJoinFrame} message SdkJoinFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkJoinFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.protocolVersion != null && Object.hasOwnProperty.call(message, "protocolVersion")) writer.uint32(/* id 1, wireType 0 =*/ 8).uint32(message.protocolVersion);
        if (message.maxNumOfVideos != null && Object.hasOwnProperty.call(message, "maxNumOfVideos")) writer.uint32(/* id 2, wireType 0 =*/ 16).uint32(message.maxNumOfVideos);
        if (message.flags != null && Object.hasOwnProperty.call(message, "flags")) writer.uint32(/* id 3, wireType 0 =*/ 24).uint32(message.flags);
        if (message.clientDetails != null && Object.hasOwnProperty.call(message, "clientDetails")) $31e083413a0a3833$var$$root.SdkClientDetails.encode(message.clientDetails, writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
        if (message.audioSessionId != null && Object.hasOwnProperty.call(message, "audioSessionId")) writer.uint32(/* id 6, wireType 0 =*/ 48).uint64(message.audioSessionId);
        if (message.wantsCompressedSdp != null && Object.hasOwnProperty.call(message, "wantsCompressedSdp")) writer.uint32(/* id 7, wireType 0 =*/ 56).bool(message.wantsCompressedSdp);
        if (message.serverSideNetworkAdaption != null && Object.hasOwnProperty.call(message, "serverSideNetworkAdaption")) writer.uint32(/* id 10, wireType 0 =*/ 80).int32(message.serverSideNetworkAdaption);
        if (message.supportedServerSideNetworkAdaptions != null && message.supportedServerSideNetworkAdaptions.length) for(var i = 0; i < message.supportedServerSideNetworkAdaptions.length; ++i)writer.uint32(/* id 11, wireType 0 =*/ 88).int32(message.supportedServerSideNetworkAdaptions[i]);
        if (message.wantsAllTemporalLayersInIndex != null && Object.hasOwnProperty.call(message, "wantsAllTemporalLayersInIndex")) writer.uint32(/* id 12, wireType 0 =*/ 96).bool(message.wantsAllTemporalLayersInIndex);
        if (message.disablePeriodicKeyframeRequestOnContentSender != null && Object.hasOwnProperty.call(message, "disablePeriodicKeyframeRequestOnContentSender")) writer.uint32(/* id 13, wireType 0 =*/ 104).bool(message.disablePeriodicKeyframeRequestOnContentSender);
        return writer;
    };
    /**
     * Encodes the specified SdkJoinFrame message, length delimited. Does not implicitly {@link SdkJoinFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkJoinFrame
     * @static
     * @param {ISdkJoinFrame} message SdkJoinFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkJoinFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkJoinFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkJoinFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkJoinFrame} SdkJoinFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkJoinFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkJoinFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.protocolVersion = reader.uint32();
                    break;
                case 2:
                    message.maxNumOfVideos = reader.uint32();
                    break;
                case 3:
                    message.flags = reader.uint32();
                    break;
                case 4:
                    message.clientDetails = $31e083413a0a3833$var$$root.SdkClientDetails.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.audioSessionId = reader.uint64();
                    break;
                case 7:
                    message.wantsCompressedSdp = reader.bool();
                    break;
                case 10:
                    message.serverSideNetworkAdaption = reader.int32();
                    break;
                case 11:
                    if (!(message.supportedServerSideNetworkAdaptions && message.supportedServerSideNetworkAdaptions.length)) message.supportedServerSideNetworkAdaptions = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.supportedServerSideNetworkAdaptions.push(reader.int32());
                    } else message.supportedServerSideNetworkAdaptions.push(reader.int32());
                    break;
                case 12:
                    message.wantsAllTemporalLayersInIndex = reader.bool();
                    break;
                case 13:
                    message.disablePeriodicKeyframeRequestOnContentSender = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkJoinFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkJoinFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkJoinFrame} SdkJoinFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkJoinFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkJoinFrame message.
     * @function verify
     * @memberof SdkJoinFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkJoinFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.protocolVersion != null && message.hasOwnProperty("protocolVersion")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.protocolVersion)) return "protocolVersion: integer expected";
        }
        if (message.maxNumOfVideos != null && message.hasOwnProperty("maxNumOfVideos")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.maxNumOfVideos)) return "maxNumOfVideos: integer expected";
        }
        if (message.flags != null && message.hasOwnProperty("flags")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.flags)) return "flags: integer expected";
        }
        if (message.clientDetails != null && message.hasOwnProperty("clientDetails")) {
            var error = $31e083413a0a3833$var$$root.SdkClientDetails.verify(message.clientDetails);
            if (error) return "clientDetails." + error;
        }
        if (message.audioSessionId != null && message.hasOwnProperty("audioSessionId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.audioSessionId) && !(message.audioSessionId && $31e083413a0a3833$var$$util.isInteger(message.audioSessionId.low) && $31e083413a0a3833$var$$util.isInteger(message.audioSessionId.high))) return "audioSessionId: integer|Long expected";
        }
        if (message.wantsCompressedSdp != null && message.hasOwnProperty("wantsCompressedSdp")) {
            if (typeof message.wantsCompressedSdp !== "boolean") return "wantsCompressedSdp: boolean expected";
        }
        if (message.serverSideNetworkAdaption != null && message.hasOwnProperty("serverSideNetworkAdaption")) switch(message.serverSideNetworkAdaption){
            default:
                return "serverSideNetworkAdaption: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
                break;
        }
        if (message.supportedServerSideNetworkAdaptions != null && message.hasOwnProperty("supportedServerSideNetworkAdaptions")) {
            if (!Array.isArray(message.supportedServerSideNetworkAdaptions)) return "supportedServerSideNetworkAdaptions: array expected";
            for(var i = 0; i < message.supportedServerSideNetworkAdaptions.length; ++i)switch(message.supportedServerSideNetworkAdaptions[i]){
                default:
                    return "supportedServerSideNetworkAdaptions: enum value[] expected";
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
            }
        }
        if (message.wantsAllTemporalLayersInIndex != null && message.hasOwnProperty("wantsAllTemporalLayersInIndex")) {
            if (typeof message.wantsAllTemporalLayersInIndex !== "boolean") return "wantsAllTemporalLayersInIndex: boolean expected";
        }
        if (message.disablePeriodicKeyframeRequestOnContentSender != null && message.hasOwnProperty("disablePeriodicKeyframeRequestOnContentSender")) {
            if (typeof message.disablePeriodicKeyframeRequestOnContentSender !== "boolean") return "disablePeriodicKeyframeRequestOnContentSender: boolean expected";
        }
        return null;
    };
    /**
     * Creates a SdkJoinFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkJoinFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkJoinFrame} SdkJoinFrame
     */ SdkJoinFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkJoinFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkJoinFrame();
        if (object.protocolVersion != null) message.protocolVersion = object.protocolVersion >>> 0;
        if (object.maxNumOfVideos != null) message.maxNumOfVideos = object.maxNumOfVideos >>> 0;
        if (object.flags != null) message.flags = object.flags >>> 0;
        if (object.clientDetails != null) {
            if (typeof object.clientDetails !== "object") throw TypeError(".SdkJoinFrame.clientDetails: object expected");
            message.clientDetails = $31e083413a0a3833$var$$root.SdkClientDetails.fromObject(object.clientDetails);
        }
        if (object.audioSessionId != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.audioSessionId = $31e083413a0a3833$var$$util.Long.fromValue(object.audioSessionId)).unsigned = true;
            else if (typeof object.audioSessionId === "string") message.audioSessionId = parseInt(object.audioSessionId, 10);
            else if (typeof object.audioSessionId === "number") message.audioSessionId = object.audioSessionId;
            else if (typeof object.audioSessionId === "object") message.audioSessionId = new $31e083413a0a3833$var$$util.LongBits(object.audioSessionId.low >>> 0, object.audioSessionId.high >>> 0).toNumber(true);
        }
        if (object.wantsCompressedSdp != null) message.wantsCompressedSdp = Boolean(object.wantsCompressedSdp);
        switch(object.serverSideNetworkAdaption){
            default:
                if (typeof object.serverSideNetworkAdaption === "number") {
                    message.serverSideNetworkAdaption = object.serverSideNetworkAdaption;
                    break;
                }
                break;
            case "DEFAULT":
            case 1:
                message.serverSideNetworkAdaption = 1;
                break;
            case "NONE":
            case 2:
                message.serverSideNetworkAdaption = 2;
                break;
            case "BANDWIDTH_PROBING":
            case 3:
                message.serverSideNetworkAdaption = 3;
                break;
            case "BANDWIDTH_PROBING_AND_VIDEO_QUALITY_ADAPTION":
            case 4:
                message.serverSideNetworkAdaption = 4;
                break;
        }
        if (object.supportedServerSideNetworkAdaptions) {
            if (!Array.isArray(object.supportedServerSideNetworkAdaptions)) throw TypeError(".SdkJoinFrame.supportedServerSideNetworkAdaptions: array expected");
            message.supportedServerSideNetworkAdaptions = [];
            for(var i = 0; i < object.supportedServerSideNetworkAdaptions.length; ++i)switch(object.supportedServerSideNetworkAdaptions[i]){
                default:
                    if (typeof object.supportedServerSideNetworkAdaptions[i] === "number") {
                        message.supportedServerSideNetworkAdaptions[i] = object.supportedServerSideNetworkAdaptions[i];
                        break;
                    }
                case "DEFAULT":
                case 1:
                    message.supportedServerSideNetworkAdaptions[i] = 1;
                    break;
                case "NONE":
                case 2:
                    message.supportedServerSideNetworkAdaptions[i] = 2;
                    break;
                case "BANDWIDTH_PROBING":
                case 3:
                    message.supportedServerSideNetworkAdaptions[i] = 3;
                    break;
                case "BANDWIDTH_PROBING_AND_VIDEO_QUALITY_ADAPTION":
                case 4:
                    message.supportedServerSideNetworkAdaptions[i] = 4;
                    break;
            }
        }
        if (object.wantsAllTemporalLayersInIndex != null) message.wantsAllTemporalLayersInIndex = Boolean(object.wantsAllTemporalLayersInIndex);
        if (object.disablePeriodicKeyframeRequestOnContentSender != null) message.disablePeriodicKeyframeRequestOnContentSender = Boolean(object.disablePeriodicKeyframeRequestOnContentSender);
        return message;
    };
    /**
     * Creates a plain object from a SdkJoinFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkJoinFrame
     * @static
     * @param {SdkJoinFrame} message SdkJoinFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkJoinFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.supportedServerSideNetworkAdaptions = [];
        if (options.defaults) {
            object.protocolVersion = 2;
            object.maxNumOfVideos = 0;
            object.flags = 0;
            object.clientDetails = null;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, true);
                object.audioSessionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.audioSessionId = options.longs === String ? "0" : 0;
            object.wantsCompressedSdp = false;
            object.serverSideNetworkAdaption = options.enums === String ? "DEFAULT" : 1;
            object.wantsAllTemporalLayersInIndex = false;
            object.disablePeriodicKeyframeRequestOnContentSender = false;
        }
        if (message.protocolVersion != null && message.hasOwnProperty("protocolVersion")) object.protocolVersion = message.protocolVersion;
        if (message.maxNumOfVideos != null && message.hasOwnProperty("maxNumOfVideos")) object.maxNumOfVideos = message.maxNumOfVideos;
        if (message.flags != null && message.hasOwnProperty("flags")) object.flags = message.flags;
        if (message.clientDetails != null && message.hasOwnProperty("clientDetails")) object.clientDetails = $31e083413a0a3833$var$$root.SdkClientDetails.toObject(message.clientDetails, options);
        if (message.audioSessionId != null && message.hasOwnProperty("audioSessionId")) {
            if (typeof message.audioSessionId === "number") object.audioSessionId = options.longs === String ? String(message.audioSessionId) : message.audioSessionId;
            else object.audioSessionId = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.audioSessionId) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.audioSessionId.low >>> 0, message.audioSessionId.high >>> 0).toNumber(true) : message.audioSessionId;
        }
        if (message.wantsCompressedSdp != null && message.hasOwnProperty("wantsCompressedSdp")) object.wantsCompressedSdp = message.wantsCompressedSdp;
        if (message.serverSideNetworkAdaption != null && message.hasOwnProperty("serverSideNetworkAdaption")) object.serverSideNetworkAdaption = options.enums === String ? $31e083413a0a3833$var$$root.SdkServerSideNetworkAdaption[message.serverSideNetworkAdaption] === undefined ? message.serverSideNetworkAdaption : $31e083413a0a3833$var$$root.SdkServerSideNetworkAdaption[message.serverSideNetworkAdaption] : message.serverSideNetworkAdaption;
        if (message.supportedServerSideNetworkAdaptions && message.supportedServerSideNetworkAdaptions.length) {
            object.supportedServerSideNetworkAdaptions = [];
            for(var j = 0; j < message.supportedServerSideNetworkAdaptions.length; ++j)object.supportedServerSideNetworkAdaptions[j] = options.enums === String ? $31e083413a0a3833$var$$root.SdkServerSideNetworkAdaption[message.supportedServerSideNetworkAdaptions[j]] === undefined ? message.supportedServerSideNetworkAdaptions[j] : $31e083413a0a3833$var$$root.SdkServerSideNetworkAdaption[message.supportedServerSideNetworkAdaptions[j]] : message.supportedServerSideNetworkAdaptions[j];
        }
        if (message.wantsAllTemporalLayersInIndex != null && message.hasOwnProperty("wantsAllTemporalLayersInIndex")) object.wantsAllTemporalLayersInIndex = message.wantsAllTemporalLayersInIndex;
        if (message.disablePeriodicKeyframeRequestOnContentSender != null && message.hasOwnProperty("disablePeriodicKeyframeRequestOnContentSender")) object.disablePeriodicKeyframeRequestOnContentSender = message.disablePeriodicKeyframeRequestOnContentSender;
        return object;
    };
    /**
     * Converts this SdkJoinFrame to JSON.
     * @function toJSON
     * @memberof SdkJoinFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkJoinFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkJoinFrame
     * @function getTypeUrl
     * @memberof SdkJoinFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkJoinFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkJoinFrame";
    };
    return SdkJoinFrame;
}();
$31e083413a0a3833$var$$root.SdkJoinAckFrame = function() {
    /**
     * Properties of a SdkJoinAckFrame.
     * @name ISdkJoinAckFrame
     * @interface ISdkJoinAckFrame
     * @property {ISdkTurnCredentials|null} [turnCredentials] SdkJoinAckFrame turnCredentials
     * @property {number|null} [videoSubscriptionLimit] SdkJoinAckFrame videoSubscriptionLimit
     * @property {boolean|null} [wantsCompressedSdp] SdkJoinAckFrame wantsCompressedSdp
     * @property {SdkServerSideNetworkAdaption|null} [defaultServerSideNetworkAdaption] SdkJoinAckFrame defaultServerSideNetworkAdaption
     */ /**
     * Constructs a new SdkJoinAckFrame.
     * @name SdkJoinAckFrame
     * @classdesc Represents a SdkJoinAckFrame.
     * @implements ISdkJoinAckFrame
     * @constructor
     * @param {ISdkJoinAckFrame=} [properties] Properties to set
     */ function SdkJoinAckFrame(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkJoinAckFrame turnCredentials.
     * @member {ISdkTurnCredentials|null|undefined} turnCredentials
     * @memberof SdkJoinAckFrame
     * @instance
     */ SdkJoinAckFrame.prototype.turnCredentials = null;
    /**
     * SdkJoinAckFrame videoSubscriptionLimit.
     * @member {number} videoSubscriptionLimit
     * @memberof SdkJoinAckFrame
     * @instance
     */ SdkJoinAckFrame.prototype.videoSubscriptionLimit = 0;
    /**
     * SdkJoinAckFrame wantsCompressedSdp.
     * @member {boolean} wantsCompressedSdp
     * @memberof SdkJoinAckFrame
     * @instance
     */ SdkJoinAckFrame.prototype.wantsCompressedSdp = false;
    /**
     * SdkJoinAckFrame defaultServerSideNetworkAdaption.
     * @member {SdkServerSideNetworkAdaption} defaultServerSideNetworkAdaption
     * @memberof SdkJoinAckFrame
     * @instance
     */ SdkJoinAckFrame.prototype.defaultServerSideNetworkAdaption = 1;
    /**
     * Creates a new SdkJoinAckFrame instance using the specified properties.
     * @function create
     * @memberof SdkJoinAckFrame
     * @static
     * @param {ISdkJoinAckFrame=} [properties] Properties to set
     * @returns {SdkJoinAckFrame} SdkJoinAckFrame instance
     */ SdkJoinAckFrame.create = function create(properties) {
        return new SdkJoinAckFrame(properties);
    };
    /**
     * Encodes the specified SdkJoinAckFrame message. Does not implicitly {@link SdkJoinAckFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkJoinAckFrame
     * @static
     * @param {ISdkJoinAckFrame} message SdkJoinAckFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkJoinAckFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.turnCredentials != null && Object.hasOwnProperty.call(message, "turnCredentials")) $31e083413a0a3833$var$$root.SdkTurnCredentials.encode(message.turnCredentials, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.videoSubscriptionLimit != null && Object.hasOwnProperty.call(message, "videoSubscriptionLimit")) writer.uint32(/* id 2, wireType 0 =*/ 16).uint32(message.videoSubscriptionLimit);
        if (message.wantsCompressedSdp != null && Object.hasOwnProperty.call(message, "wantsCompressedSdp")) writer.uint32(/* id 3, wireType 0 =*/ 24).bool(message.wantsCompressedSdp);
        if (message.defaultServerSideNetworkAdaption != null && Object.hasOwnProperty.call(message, "defaultServerSideNetworkAdaption")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.defaultServerSideNetworkAdaption);
        return writer;
    };
    /**
     * Encodes the specified SdkJoinAckFrame message, length delimited. Does not implicitly {@link SdkJoinAckFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkJoinAckFrame
     * @static
     * @param {ISdkJoinAckFrame} message SdkJoinAckFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkJoinAckFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkJoinAckFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkJoinAckFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkJoinAckFrame} SdkJoinAckFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkJoinAckFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkJoinAckFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.turnCredentials = $31e083413a0a3833$var$$root.SdkTurnCredentials.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.videoSubscriptionLimit = reader.uint32();
                    break;
                case 3:
                    message.wantsCompressedSdp = reader.bool();
                    break;
                case 4:
                    message.defaultServerSideNetworkAdaption = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkJoinAckFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkJoinAckFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkJoinAckFrame} SdkJoinAckFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkJoinAckFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkJoinAckFrame message.
     * @function verify
     * @memberof SdkJoinAckFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkJoinAckFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.turnCredentials != null && message.hasOwnProperty("turnCredentials")) {
            var error = $31e083413a0a3833$var$$root.SdkTurnCredentials.verify(message.turnCredentials);
            if (error) return "turnCredentials." + error;
        }
        if (message.videoSubscriptionLimit != null && message.hasOwnProperty("videoSubscriptionLimit")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.videoSubscriptionLimit)) return "videoSubscriptionLimit: integer expected";
        }
        if (message.wantsCompressedSdp != null && message.hasOwnProperty("wantsCompressedSdp")) {
            if (typeof message.wantsCompressedSdp !== "boolean") return "wantsCompressedSdp: boolean expected";
        }
        if (message.defaultServerSideNetworkAdaption != null && message.hasOwnProperty("defaultServerSideNetworkAdaption")) switch(message.defaultServerSideNetworkAdaption){
            default:
                return "defaultServerSideNetworkAdaption: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
                break;
        }
        return null;
    };
    /**
     * Creates a SdkJoinAckFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkJoinAckFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkJoinAckFrame} SdkJoinAckFrame
     */ SdkJoinAckFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkJoinAckFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkJoinAckFrame();
        if (object.turnCredentials != null) {
            if (typeof object.turnCredentials !== "object") throw TypeError(".SdkJoinAckFrame.turnCredentials: object expected");
            message.turnCredentials = $31e083413a0a3833$var$$root.SdkTurnCredentials.fromObject(object.turnCredentials);
        }
        if (object.videoSubscriptionLimit != null) message.videoSubscriptionLimit = object.videoSubscriptionLimit >>> 0;
        if (object.wantsCompressedSdp != null) message.wantsCompressedSdp = Boolean(object.wantsCompressedSdp);
        switch(object.defaultServerSideNetworkAdaption){
            default:
                if (typeof object.defaultServerSideNetworkAdaption === "number") {
                    message.defaultServerSideNetworkAdaption = object.defaultServerSideNetworkAdaption;
                    break;
                }
                break;
            case "DEFAULT":
            case 1:
                message.defaultServerSideNetworkAdaption = 1;
                break;
            case "NONE":
            case 2:
                message.defaultServerSideNetworkAdaption = 2;
                break;
            case "BANDWIDTH_PROBING":
            case 3:
                message.defaultServerSideNetworkAdaption = 3;
                break;
            case "BANDWIDTH_PROBING_AND_VIDEO_QUALITY_ADAPTION":
            case 4:
                message.defaultServerSideNetworkAdaption = 4;
                break;
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkJoinAckFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkJoinAckFrame
     * @static
     * @param {SdkJoinAckFrame} message SdkJoinAckFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkJoinAckFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.turnCredentials = null;
            object.videoSubscriptionLimit = 0;
            object.wantsCompressedSdp = false;
            object.defaultServerSideNetworkAdaption = options.enums === String ? "DEFAULT" : 1;
        }
        if (message.turnCredentials != null && message.hasOwnProperty("turnCredentials")) object.turnCredentials = $31e083413a0a3833$var$$root.SdkTurnCredentials.toObject(message.turnCredentials, options);
        if (message.videoSubscriptionLimit != null && message.hasOwnProperty("videoSubscriptionLimit")) object.videoSubscriptionLimit = message.videoSubscriptionLimit;
        if (message.wantsCompressedSdp != null && message.hasOwnProperty("wantsCompressedSdp")) object.wantsCompressedSdp = message.wantsCompressedSdp;
        if (message.defaultServerSideNetworkAdaption != null && message.hasOwnProperty("defaultServerSideNetworkAdaption")) object.defaultServerSideNetworkAdaption = options.enums === String ? $31e083413a0a3833$var$$root.SdkServerSideNetworkAdaption[message.defaultServerSideNetworkAdaption] === undefined ? message.defaultServerSideNetworkAdaption : $31e083413a0a3833$var$$root.SdkServerSideNetworkAdaption[message.defaultServerSideNetworkAdaption] : message.defaultServerSideNetworkAdaption;
        return object;
    };
    /**
     * Converts this SdkJoinAckFrame to JSON.
     * @function toJSON
     * @memberof SdkJoinAckFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkJoinAckFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkJoinAckFrame
     * @function getTypeUrl
     * @memberof SdkJoinAckFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkJoinAckFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkJoinAckFrame";
    };
    return SdkJoinAckFrame;
}();
$31e083413a0a3833$var$$root.SdkLeaveFrame = function() {
    /**
     * Properties of a SdkLeaveFrame.
     * @name ISdkLeaveFrame
     * @interface ISdkLeaveFrame
     */ /**
     * Constructs a new SdkLeaveFrame.
     * @name SdkLeaveFrame
     * @classdesc Represents a SdkLeaveFrame.
     * @implements ISdkLeaveFrame
     * @constructor
     * @param {ISdkLeaveFrame=} [properties] Properties to set
     */ function SdkLeaveFrame(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * Creates a new SdkLeaveFrame instance using the specified properties.
     * @function create
     * @memberof SdkLeaveFrame
     * @static
     * @param {ISdkLeaveFrame=} [properties] Properties to set
     * @returns {SdkLeaveFrame} SdkLeaveFrame instance
     */ SdkLeaveFrame.create = function create(properties) {
        return new SdkLeaveFrame(properties);
    };
    /**
     * Encodes the specified SdkLeaveFrame message. Does not implicitly {@link SdkLeaveFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkLeaveFrame
     * @static
     * @param {ISdkLeaveFrame} message SdkLeaveFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkLeaveFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        return writer;
    };
    /**
     * Encodes the specified SdkLeaveFrame message, length delimited. Does not implicitly {@link SdkLeaveFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkLeaveFrame
     * @static
     * @param {ISdkLeaveFrame} message SdkLeaveFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkLeaveFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkLeaveFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkLeaveFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkLeaveFrame} SdkLeaveFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkLeaveFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkLeaveFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    };
    /**
     * Decodes a SdkLeaveFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkLeaveFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkLeaveFrame} SdkLeaveFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkLeaveFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkLeaveFrame message.
     * @function verify
     * @memberof SdkLeaveFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkLeaveFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        return null;
    };
    /**
     * Creates a SdkLeaveFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkLeaveFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkLeaveFrame} SdkLeaveFrame
     */ SdkLeaveFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkLeaveFrame) return object;
        return new $31e083413a0a3833$var$$root.SdkLeaveFrame();
    };
    /**
     * Creates a plain object from a SdkLeaveFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkLeaveFrame
     * @static
     * @param {SdkLeaveFrame} message SdkLeaveFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkLeaveFrame.toObject = function toObject() {
        return {};
    };
    /**
     * Converts this SdkLeaveFrame to JSON.
     * @function toJSON
     * @memberof SdkLeaveFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkLeaveFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkLeaveFrame
     * @function getTypeUrl
     * @memberof SdkLeaveFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkLeaveFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkLeaveFrame";
    };
    return SdkLeaveFrame;
}();
$31e083413a0a3833$var$$root.SdkLeaveAckFrame = function() {
    /**
     * Properties of a SdkLeaveAckFrame.
     * @name ISdkLeaveAckFrame
     * @interface ISdkLeaveAckFrame
     */ /**
     * Constructs a new SdkLeaveAckFrame.
     * @name SdkLeaveAckFrame
     * @classdesc Represents a SdkLeaveAckFrame.
     * @implements ISdkLeaveAckFrame
     * @constructor
     * @param {ISdkLeaveAckFrame=} [properties] Properties to set
     */ function SdkLeaveAckFrame(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * Creates a new SdkLeaveAckFrame instance using the specified properties.
     * @function create
     * @memberof SdkLeaveAckFrame
     * @static
     * @param {ISdkLeaveAckFrame=} [properties] Properties to set
     * @returns {SdkLeaveAckFrame} SdkLeaveAckFrame instance
     */ SdkLeaveAckFrame.create = function create(properties) {
        return new SdkLeaveAckFrame(properties);
    };
    /**
     * Encodes the specified SdkLeaveAckFrame message. Does not implicitly {@link SdkLeaveAckFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkLeaveAckFrame
     * @static
     * @param {ISdkLeaveAckFrame} message SdkLeaveAckFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkLeaveAckFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        return writer;
    };
    /**
     * Encodes the specified SdkLeaveAckFrame message, length delimited. Does not implicitly {@link SdkLeaveAckFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkLeaveAckFrame
     * @static
     * @param {ISdkLeaveAckFrame} message SdkLeaveAckFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkLeaveAckFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkLeaveAckFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkLeaveAckFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkLeaveAckFrame} SdkLeaveAckFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkLeaveAckFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkLeaveAckFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    };
    /**
     * Decodes a SdkLeaveAckFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkLeaveAckFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkLeaveAckFrame} SdkLeaveAckFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkLeaveAckFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkLeaveAckFrame message.
     * @function verify
     * @memberof SdkLeaveAckFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkLeaveAckFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        return null;
    };
    /**
     * Creates a SdkLeaveAckFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkLeaveAckFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkLeaveAckFrame} SdkLeaveAckFrame
     */ SdkLeaveAckFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkLeaveAckFrame) return object;
        return new $31e083413a0a3833$var$$root.SdkLeaveAckFrame();
    };
    /**
     * Creates a plain object from a SdkLeaveAckFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkLeaveAckFrame
     * @static
     * @param {SdkLeaveAckFrame} message SdkLeaveAckFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkLeaveAckFrame.toObject = function toObject() {
        return {};
    };
    /**
     * Converts this SdkLeaveAckFrame to JSON.
     * @function toJSON
     * @memberof SdkLeaveAckFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkLeaveAckFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkLeaveAckFrame
     * @function getTypeUrl
     * @memberof SdkLeaveAckFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkLeaveAckFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkLeaveAckFrame";
    };
    return SdkLeaveAckFrame;
}();
/**
 * SdkStreamServiceType enum.
 * @name SdkStreamServiceType
 * @enum {number}
 * @property {number} RX=1 RX value
 * @property {number} TX=2 TX value
 * @property {number} DUPLEX=3 DUPLEX value
 */ $31e083413a0a3833$var$$root.SdkStreamServiceType = function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "RX"] = 1;
    values[valuesById[2] = "TX"] = 2;
    values[valuesById[3] = "DUPLEX"] = 3;
    return values;
}();
/**
 * SdkStreamMediaType enum.
 * @name SdkStreamMediaType
 * @enum {number}
 * @property {number} AUDIO=1 AUDIO value
 * @property {number} VIDEO=2 VIDEO value
 */ $31e083413a0a3833$var$$root.SdkStreamMediaType = function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "AUDIO"] = 1;
    values[valuesById[2] = "VIDEO"] = 2;
    return values;
}();
$31e083413a0a3833$var$$root.SdkSubscribeFrame = function() {
    /**
     * Properties of a SdkSubscribeFrame.
     * @name ISdkSubscribeFrame
     * @interface ISdkSubscribeFrame
     * @property {SdkStreamServiceType|null} [duplex] SdkSubscribeFrame duplex
     * @property {Array.<ISdkStreamDescriptor>|null} [sendStreams] SdkSubscribeFrame sendStreams
     * @property {Array.<number>|null} [receiveStreamIds] SdkSubscribeFrame receiveStreamIds
     * @property {string|null} [sdpOffer] SdkSubscribeFrame sdpOffer
     * @property {string|null} [audioHost] SdkSubscribeFrame audioHost
     * @property {boolean|null} [audioCheckin] SdkSubscribeFrame audioCheckin
     * @property {boolean|null} [audioMuted] SdkSubscribeFrame audioMuted
     * @property {Uint8Array|null} [compressedSdpOffer] SdkSubscribeFrame compressedSdpOffer
     * @property {Array.<ISdkVideoSubscriptionConfiguration>|null} [videoSubscriptionConfiguration] SdkSubscribeFrame videoSubscriptionConfiguration
     */ /**
     * Constructs a new SdkSubscribeFrame.
     * @name SdkSubscribeFrame
     * @classdesc Represents a SdkSubscribeFrame.
     * @implements ISdkSubscribeFrame
     * @constructor
     * @param {ISdkSubscribeFrame=} [properties] Properties to set
     */ function SdkSubscribeFrame(properties) {
        this.sendStreams = [];
        this.receiveStreamIds = [];
        this.videoSubscriptionConfiguration = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkSubscribeFrame duplex.
     * @member {SdkStreamServiceType} duplex
     * @memberof SdkSubscribeFrame
     * @instance
     */ SdkSubscribeFrame.prototype.duplex = 1;
    /**
     * SdkSubscribeFrame sendStreams.
     * @member {Array.<ISdkStreamDescriptor>} sendStreams
     * @memberof SdkSubscribeFrame
     * @instance
     */ SdkSubscribeFrame.prototype.sendStreams = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkSubscribeFrame receiveStreamIds.
     * @member {Array.<number>} receiveStreamIds
     * @memberof SdkSubscribeFrame
     * @instance
     */ SdkSubscribeFrame.prototype.receiveStreamIds = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkSubscribeFrame sdpOffer.
     * @member {string} sdpOffer
     * @memberof SdkSubscribeFrame
     * @instance
     */ SdkSubscribeFrame.prototype.sdpOffer = "";
    /**
     * SdkSubscribeFrame audioHost.
     * @member {string} audioHost
     * @memberof SdkSubscribeFrame
     * @instance
     */ SdkSubscribeFrame.prototype.audioHost = "";
    /**
     * SdkSubscribeFrame audioCheckin.
     * @member {boolean} audioCheckin
     * @memberof SdkSubscribeFrame
     * @instance
     */ SdkSubscribeFrame.prototype.audioCheckin = false;
    /**
     * SdkSubscribeFrame audioMuted.
     * @member {boolean} audioMuted
     * @memberof SdkSubscribeFrame
     * @instance
     */ SdkSubscribeFrame.prototype.audioMuted = false;
    /**
     * SdkSubscribeFrame compressedSdpOffer.
     * @member {Uint8Array} compressedSdpOffer
     * @memberof SdkSubscribeFrame
     * @instance
     */ SdkSubscribeFrame.prototype.compressedSdpOffer = $31e083413a0a3833$var$$util.newBuffer([]);
    /**
     * SdkSubscribeFrame videoSubscriptionConfiguration.
     * @member {Array.<ISdkVideoSubscriptionConfiguration>} videoSubscriptionConfiguration
     * @memberof SdkSubscribeFrame
     * @instance
     */ SdkSubscribeFrame.prototype.videoSubscriptionConfiguration = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkSubscribeFrame instance using the specified properties.
     * @function create
     * @memberof SdkSubscribeFrame
     * @static
     * @param {ISdkSubscribeFrame=} [properties] Properties to set
     * @returns {SdkSubscribeFrame} SdkSubscribeFrame instance
     */ SdkSubscribeFrame.create = function create(properties) {
        return new SdkSubscribeFrame(properties);
    };
    /**
     * Encodes the specified SdkSubscribeFrame message. Does not implicitly {@link SdkSubscribeFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkSubscribeFrame
     * @static
     * @param {ISdkSubscribeFrame} message SdkSubscribeFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkSubscribeFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.duplex != null && Object.hasOwnProperty.call(message, "duplex")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.duplex);
        if (message.sendStreams != null && message.sendStreams.length) for(var i = 0; i < message.sendStreams.length; ++i)$31e083413a0a3833$var$$root.SdkStreamDescriptor.encode(message.sendStreams[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
        if (message.receiveStreamIds != null && message.receiveStreamIds.length) for(var i = 0; i < message.receiveStreamIds.length; ++i)writer.uint32(/* id 3, wireType 0 =*/ 24).uint32(message.receiveStreamIds[i]);
        if (message.sdpOffer != null && Object.hasOwnProperty.call(message, "sdpOffer")) writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.sdpOffer);
        if (message.audioHost != null && Object.hasOwnProperty.call(message, "audioHost")) writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.audioHost);
        if (message.audioCheckin != null && Object.hasOwnProperty.call(message, "audioCheckin")) writer.uint32(/* id 6, wireType 0 =*/ 48).bool(message.audioCheckin);
        if (message.audioMuted != null && Object.hasOwnProperty.call(message, "audioMuted")) writer.uint32(/* id 7, wireType 0 =*/ 56).bool(message.audioMuted);
        if (message.compressedSdpOffer != null && Object.hasOwnProperty.call(message, "compressedSdpOffer")) writer.uint32(/* id 8, wireType 2 =*/ 66).bytes(message.compressedSdpOffer);
        if (message.videoSubscriptionConfiguration != null && message.videoSubscriptionConfiguration.length) for(var i = 0; i < message.videoSubscriptionConfiguration.length; ++i)$31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration.encode(message.videoSubscriptionConfiguration[i], writer.uint32(/* id 9, wireType 2 =*/ 74).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkSubscribeFrame message, length delimited. Does not implicitly {@link SdkSubscribeFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkSubscribeFrame
     * @static
     * @param {ISdkSubscribeFrame} message SdkSubscribeFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkSubscribeFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkSubscribeFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkSubscribeFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkSubscribeFrame} SdkSubscribeFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkSubscribeFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkSubscribeFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.duplex = reader.int32();
                    break;
                case 2:
                    if (!(message.sendStreams && message.sendStreams.length)) message.sendStreams = [];
                    message.sendStreams.push($31e083413a0a3833$var$$root.SdkStreamDescriptor.decode(reader, reader.uint32()));
                    break;
                case 3:
                    if (!(message.receiveStreamIds && message.receiveStreamIds.length)) message.receiveStreamIds = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.receiveStreamIds.push(reader.uint32());
                    } else message.receiveStreamIds.push(reader.uint32());
                    break;
                case 4:
                    message.sdpOffer = reader.string();
                    break;
                case 5:
                    message.audioHost = reader.string();
                    break;
                case 6:
                    message.audioCheckin = reader.bool();
                    break;
                case 7:
                    message.audioMuted = reader.bool();
                    break;
                case 8:
                    message.compressedSdpOffer = reader.bytes();
                    break;
                case 9:
                    if (!(message.videoSubscriptionConfiguration && message.videoSubscriptionConfiguration.length)) message.videoSubscriptionConfiguration = [];
                    message.videoSubscriptionConfiguration.push($31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkSubscribeFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkSubscribeFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkSubscribeFrame} SdkSubscribeFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkSubscribeFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkSubscribeFrame message.
     * @function verify
     * @memberof SdkSubscribeFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkSubscribeFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.duplex != null && message.hasOwnProperty("duplex")) switch(message.duplex){
            default:
                return "duplex: enum value expected";
            case 1:
            case 2:
            case 3:
                break;
        }
        if (message.sendStreams != null && message.hasOwnProperty("sendStreams")) {
            if (!Array.isArray(message.sendStreams)) return "sendStreams: array expected";
            for(var i = 0; i < message.sendStreams.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkStreamDescriptor.verify(message.sendStreams[i]);
                if (error) return "sendStreams." + error;
            }
        }
        if (message.receiveStreamIds != null && message.hasOwnProperty("receiveStreamIds")) {
            if (!Array.isArray(message.receiveStreamIds)) return "receiveStreamIds: array expected";
            for(var i = 0; i < message.receiveStreamIds.length; ++i)if (!$31e083413a0a3833$var$$util.isInteger(message.receiveStreamIds[i])) return "receiveStreamIds: integer[] expected";
        }
        if (message.sdpOffer != null && message.hasOwnProperty("sdpOffer")) {
            if (!$31e083413a0a3833$var$$util.isString(message.sdpOffer)) return "sdpOffer: string expected";
        }
        if (message.audioHost != null && message.hasOwnProperty("audioHost")) {
            if (!$31e083413a0a3833$var$$util.isString(message.audioHost)) return "audioHost: string expected";
        }
        if (message.audioCheckin != null && message.hasOwnProperty("audioCheckin")) {
            if (typeof message.audioCheckin !== "boolean") return "audioCheckin: boolean expected";
        }
        if (message.audioMuted != null && message.hasOwnProperty("audioMuted")) {
            if (typeof message.audioMuted !== "boolean") return "audioMuted: boolean expected";
        }
        if (message.compressedSdpOffer != null && message.hasOwnProperty("compressedSdpOffer")) {
            if (!(message.compressedSdpOffer && typeof message.compressedSdpOffer.length === "number" || $31e083413a0a3833$var$$util.isString(message.compressedSdpOffer))) return "compressedSdpOffer: buffer expected";
        }
        if (message.videoSubscriptionConfiguration != null && message.hasOwnProperty("videoSubscriptionConfiguration")) {
            if (!Array.isArray(message.videoSubscriptionConfiguration)) return "videoSubscriptionConfiguration: array expected";
            for(var i = 0; i < message.videoSubscriptionConfiguration.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration.verify(message.videoSubscriptionConfiguration[i]);
                if (error) return "videoSubscriptionConfiguration." + error;
            }
        }
        return null;
    };
    /**
     * Creates a SdkSubscribeFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkSubscribeFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkSubscribeFrame} SdkSubscribeFrame
     */ SdkSubscribeFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkSubscribeFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkSubscribeFrame();
        switch(object.duplex){
            default:
                if (typeof object.duplex === "number") {
                    message.duplex = object.duplex;
                    break;
                }
                break;
            case "RX":
            case 1:
                message.duplex = 1;
                break;
            case "TX":
            case 2:
                message.duplex = 2;
                break;
            case "DUPLEX":
            case 3:
                message.duplex = 3;
                break;
        }
        if (object.sendStreams) {
            if (!Array.isArray(object.sendStreams)) throw TypeError(".SdkSubscribeFrame.sendStreams: array expected");
            message.sendStreams = [];
            for(var i = 0; i < object.sendStreams.length; ++i){
                if (typeof object.sendStreams[i] !== "object") throw TypeError(".SdkSubscribeFrame.sendStreams: object expected");
                message.sendStreams[i] = $31e083413a0a3833$var$$root.SdkStreamDescriptor.fromObject(object.sendStreams[i]);
            }
        }
        if (object.receiveStreamIds) {
            if (!Array.isArray(object.receiveStreamIds)) throw TypeError(".SdkSubscribeFrame.receiveStreamIds: array expected");
            message.receiveStreamIds = [];
            for(var i = 0; i < object.receiveStreamIds.length; ++i)message.receiveStreamIds[i] = object.receiveStreamIds[i] >>> 0;
        }
        if (object.sdpOffer != null) message.sdpOffer = String(object.sdpOffer);
        if (object.audioHost != null) message.audioHost = String(object.audioHost);
        if (object.audioCheckin != null) message.audioCheckin = Boolean(object.audioCheckin);
        if (object.audioMuted != null) message.audioMuted = Boolean(object.audioMuted);
        if (object.compressedSdpOffer != null) {
            if (typeof object.compressedSdpOffer === "string") $31e083413a0a3833$var$$util.base64.decode(object.compressedSdpOffer, message.compressedSdpOffer = $31e083413a0a3833$var$$util.newBuffer($31e083413a0a3833$var$$util.base64.length(object.compressedSdpOffer)), 0);
            else if (object.compressedSdpOffer.length >= 0) message.compressedSdpOffer = object.compressedSdpOffer;
        }
        if (object.videoSubscriptionConfiguration) {
            if (!Array.isArray(object.videoSubscriptionConfiguration)) throw TypeError(".SdkSubscribeFrame.videoSubscriptionConfiguration: array expected");
            message.videoSubscriptionConfiguration = [];
            for(var i = 0; i < object.videoSubscriptionConfiguration.length; ++i){
                if (typeof object.videoSubscriptionConfiguration[i] !== "object") throw TypeError(".SdkSubscribeFrame.videoSubscriptionConfiguration: object expected");
                message.videoSubscriptionConfiguration[i] = $31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration.fromObject(object.videoSubscriptionConfiguration[i]);
            }
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkSubscribeFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkSubscribeFrame
     * @static
     * @param {SdkSubscribeFrame} message SdkSubscribeFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkSubscribeFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.sendStreams = [];
            object.receiveStreamIds = [];
            object.videoSubscriptionConfiguration = [];
        }
        if (options.defaults) {
            object.duplex = options.enums === String ? "RX" : 1;
            object.sdpOffer = "";
            object.audioHost = "";
            object.audioCheckin = false;
            object.audioMuted = false;
            if (options.bytes === String) object.compressedSdpOffer = "";
            else {
                object.compressedSdpOffer = [];
                if (options.bytes !== Array) object.compressedSdpOffer = $31e083413a0a3833$var$$util.newBuffer(object.compressedSdpOffer);
            }
        }
        if (message.duplex != null && message.hasOwnProperty("duplex")) object.duplex = options.enums === String ? $31e083413a0a3833$var$$root.SdkStreamServiceType[message.duplex] === undefined ? message.duplex : $31e083413a0a3833$var$$root.SdkStreamServiceType[message.duplex] : message.duplex;
        if (message.sendStreams && message.sendStreams.length) {
            object.sendStreams = [];
            for(var j = 0; j < message.sendStreams.length; ++j)object.sendStreams[j] = $31e083413a0a3833$var$$root.SdkStreamDescriptor.toObject(message.sendStreams[j], options);
        }
        if (message.receiveStreamIds && message.receiveStreamIds.length) {
            object.receiveStreamIds = [];
            for(var j = 0; j < message.receiveStreamIds.length; ++j)object.receiveStreamIds[j] = message.receiveStreamIds[j];
        }
        if (message.sdpOffer != null && message.hasOwnProperty("sdpOffer")) object.sdpOffer = message.sdpOffer;
        if (message.audioHost != null && message.hasOwnProperty("audioHost")) object.audioHost = message.audioHost;
        if (message.audioCheckin != null && message.hasOwnProperty("audioCheckin")) object.audioCheckin = message.audioCheckin;
        if (message.audioMuted != null && message.hasOwnProperty("audioMuted")) object.audioMuted = message.audioMuted;
        if (message.compressedSdpOffer != null && message.hasOwnProperty("compressedSdpOffer")) object.compressedSdpOffer = options.bytes === String ? $31e083413a0a3833$var$$util.base64.encode(message.compressedSdpOffer, 0, message.compressedSdpOffer.length) : options.bytes === Array ? Array.prototype.slice.call(message.compressedSdpOffer) : message.compressedSdpOffer;
        if (message.videoSubscriptionConfiguration && message.videoSubscriptionConfiguration.length) {
            object.videoSubscriptionConfiguration = [];
            for(var j = 0; j < message.videoSubscriptionConfiguration.length; ++j)object.videoSubscriptionConfiguration[j] = $31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration.toObject(message.videoSubscriptionConfiguration[j], options);
        }
        return object;
    };
    /**
     * Converts this SdkSubscribeFrame to JSON.
     * @function toJSON
     * @memberof SdkSubscribeFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkSubscribeFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkSubscribeFrame
     * @function getTypeUrl
     * @memberof SdkSubscribeFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkSubscribeFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkSubscribeFrame";
    };
    return SdkSubscribeFrame;
}();
$31e083413a0a3833$var$$root.SdkSubscribeAckFrame = function() {
    /**
     * Properties of a SdkSubscribeAckFrame.
     * @name ISdkSubscribeAckFrame
     * @interface ISdkSubscribeAckFrame
     * @property {SdkStreamServiceType|null} [duplex] SdkSubscribeAckFrame duplex
     * @property {Array.<ISdkStreamAllocation>|null} [allocations] SdkSubscribeAckFrame allocations
     * @property {string|null} [sdpAnswer] SdkSubscribeAckFrame sdpAnswer
     * @property {Array.<ISdkTrackMapping>|null} [tracks] SdkSubscribeAckFrame tracks
     * @property {Uint8Array|null} [compressedSdpAnswer] SdkSubscribeAckFrame compressedSdpAnswer
     */ /**
     * Constructs a new SdkSubscribeAckFrame.
     * @name SdkSubscribeAckFrame
     * @classdesc Represents a SdkSubscribeAckFrame.
     * @implements ISdkSubscribeAckFrame
     * @constructor
     * @param {ISdkSubscribeAckFrame=} [properties] Properties to set
     */ function SdkSubscribeAckFrame(properties) {
        this.allocations = [];
        this.tracks = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkSubscribeAckFrame duplex.
     * @member {SdkStreamServiceType} duplex
     * @memberof SdkSubscribeAckFrame
     * @instance
     */ SdkSubscribeAckFrame.prototype.duplex = 1;
    /**
     * SdkSubscribeAckFrame allocations.
     * @member {Array.<ISdkStreamAllocation>} allocations
     * @memberof SdkSubscribeAckFrame
     * @instance
     */ SdkSubscribeAckFrame.prototype.allocations = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkSubscribeAckFrame sdpAnswer.
     * @member {string} sdpAnswer
     * @memberof SdkSubscribeAckFrame
     * @instance
     */ SdkSubscribeAckFrame.prototype.sdpAnswer = "";
    /**
     * SdkSubscribeAckFrame tracks.
     * @member {Array.<ISdkTrackMapping>} tracks
     * @memberof SdkSubscribeAckFrame
     * @instance
     */ SdkSubscribeAckFrame.prototype.tracks = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkSubscribeAckFrame compressedSdpAnswer.
     * @member {Uint8Array} compressedSdpAnswer
     * @memberof SdkSubscribeAckFrame
     * @instance
     */ SdkSubscribeAckFrame.prototype.compressedSdpAnswer = $31e083413a0a3833$var$$util.newBuffer([]);
    /**
     * Creates a new SdkSubscribeAckFrame instance using the specified properties.
     * @function create
     * @memberof SdkSubscribeAckFrame
     * @static
     * @param {ISdkSubscribeAckFrame=} [properties] Properties to set
     * @returns {SdkSubscribeAckFrame} SdkSubscribeAckFrame instance
     */ SdkSubscribeAckFrame.create = function create(properties) {
        return new SdkSubscribeAckFrame(properties);
    };
    /**
     * Encodes the specified SdkSubscribeAckFrame message. Does not implicitly {@link SdkSubscribeAckFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkSubscribeAckFrame
     * @static
     * @param {ISdkSubscribeAckFrame} message SdkSubscribeAckFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkSubscribeAckFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.duplex != null && Object.hasOwnProperty.call(message, "duplex")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.duplex);
        if (message.allocations != null && message.allocations.length) for(var i = 0; i < message.allocations.length; ++i)$31e083413a0a3833$var$$root.SdkStreamAllocation.encode(message.allocations[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
        if (message.sdpAnswer != null && Object.hasOwnProperty.call(message, "sdpAnswer")) writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.sdpAnswer);
        if (message.tracks != null && message.tracks.length) for(var i = 0; i < message.tracks.length; ++i)$31e083413a0a3833$var$$root.SdkTrackMapping.encode(message.tracks[i], writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
        if (message.compressedSdpAnswer != null && Object.hasOwnProperty.call(message, "compressedSdpAnswer")) writer.uint32(/* id 5, wireType 2 =*/ 42).bytes(message.compressedSdpAnswer);
        return writer;
    };
    /**
     * Encodes the specified SdkSubscribeAckFrame message, length delimited. Does not implicitly {@link SdkSubscribeAckFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkSubscribeAckFrame
     * @static
     * @param {ISdkSubscribeAckFrame} message SdkSubscribeAckFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkSubscribeAckFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkSubscribeAckFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkSubscribeAckFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkSubscribeAckFrame} SdkSubscribeAckFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkSubscribeAckFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkSubscribeAckFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.duplex = reader.int32();
                    break;
                case 2:
                    if (!(message.allocations && message.allocations.length)) message.allocations = [];
                    message.allocations.push($31e083413a0a3833$var$$root.SdkStreamAllocation.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.sdpAnswer = reader.string();
                    break;
                case 4:
                    if (!(message.tracks && message.tracks.length)) message.tracks = [];
                    message.tracks.push($31e083413a0a3833$var$$root.SdkTrackMapping.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.compressedSdpAnswer = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkSubscribeAckFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkSubscribeAckFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkSubscribeAckFrame} SdkSubscribeAckFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkSubscribeAckFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkSubscribeAckFrame message.
     * @function verify
     * @memberof SdkSubscribeAckFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkSubscribeAckFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.duplex != null && message.hasOwnProperty("duplex")) switch(message.duplex){
            default:
                return "duplex: enum value expected";
            case 1:
            case 2:
            case 3:
                break;
        }
        if (message.allocations != null && message.hasOwnProperty("allocations")) {
            if (!Array.isArray(message.allocations)) return "allocations: array expected";
            for(var i = 0; i < message.allocations.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkStreamAllocation.verify(message.allocations[i]);
                if (error) return "allocations." + error;
            }
        }
        if (message.sdpAnswer != null && message.hasOwnProperty("sdpAnswer")) {
            if (!$31e083413a0a3833$var$$util.isString(message.sdpAnswer)) return "sdpAnswer: string expected";
        }
        if (message.tracks != null && message.hasOwnProperty("tracks")) {
            if (!Array.isArray(message.tracks)) return "tracks: array expected";
            for(var i = 0; i < message.tracks.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkTrackMapping.verify(message.tracks[i]);
                if (error) return "tracks." + error;
            }
        }
        if (message.compressedSdpAnswer != null && message.hasOwnProperty("compressedSdpAnswer")) {
            if (!(message.compressedSdpAnswer && typeof message.compressedSdpAnswer.length === "number" || $31e083413a0a3833$var$$util.isString(message.compressedSdpAnswer))) return "compressedSdpAnswer: buffer expected";
        }
        return null;
    };
    /**
     * Creates a SdkSubscribeAckFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkSubscribeAckFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkSubscribeAckFrame} SdkSubscribeAckFrame
     */ SdkSubscribeAckFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkSubscribeAckFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkSubscribeAckFrame();
        switch(object.duplex){
            default:
                if (typeof object.duplex === "number") {
                    message.duplex = object.duplex;
                    break;
                }
                break;
            case "RX":
            case 1:
                message.duplex = 1;
                break;
            case "TX":
            case 2:
                message.duplex = 2;
                break;
            case "DUPLEX":
            case 3:
                message.duplex = 3;
                break;
        }
        if (object.allocations) {
            if (!Array.isArray(object.allocations)) throw TypeError(".SdkSubscribeAckFrame.allocations: array expected");
            message.allocations = [];
            for(var i = 0; i < object.allocations.length; ++i){
                if (typeof object.allocations[i] !== "object") throw TypeError(".SdkSubscribeAckFrame.allocations: object expected");
                message.allocations[i] = $31e083413a0a3833$var$$root.SdkStreamAllocation.fromObject(object.allocations[i]);
            }
        }
        if (object.sdpAnswer != null) message.sdpAnswer = String(object.sdpAnswer);
        if (object.tracks) {
            if (!Array.isArray(object.tracks)) throw TypeError(".SdkSubscribeAckFrame.tracks: array expected");
            message.tracks = [];
            for(var i = 0; i < object.tracks.length; ++i){
                if (typeof object.tracks[i] !== "object") throw TypeError(".SdkSubscribeAckFrame.tracks: object expected");
                message.tracks[i] = $31e083413a0a3833$var$$root.SdkTrackMapping.fromObject(object.tracks[i]);
            }
        }
        if (object.compressedSdpAnswer != null) {
            if (typeof object.compressedSdpAnswer === "string") $31e083413a0a3833$var$$util.base64.decode(object.compressedSdpAnswer, message.compressedSdpAnswer = $31e083413a0a3833$var$$util.newBuffer($31e083413a0a3833$var$$util.base64.length(object.compressedSdpAnswer)), 0);
            else if (object.compressedSdpAnswer.length >= 0) message.compressedSdpAnswer = object.compressedSdpAnswer;
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkSubscribeAckFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkSubscribeAckFrame
     * @static
     * @param {SdkSubscribeAckFrame} message SdkSubscribeAckFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkSubscribeAckFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.allocations = [];
            object.tracks = [];
        }
        if (options.defaults) {
            object.duplex = options.enums === String ? "RX" : 1;
            object.sdpAnswer = "";
            if (options.bytes === String) object.compressedSdpAnswer = "";
            else {
                object.compressedSdpAnswer = [];
                if (options.bytes !== Array) object.compressedSdpAnswer = $31e083413a0a3833$var$$util.newBuffer(object.compressedSdpAnswer);
            }
        }
        if (message.duplex != null && message.hasOwnProperty("duplex")) object.duplex = options.enums === String ? $31e083413a0a3833$var$$root.SdkStreamServiceType[message.duplex] === undefined ? message.duplex : $31e083413a0a3833$var$$root.SdkStreamServiceType[message.duplex] : message.duplex;
        if (message.allocations && message.allocations.length) {
            object.allocations = [];
            for(var j = 0; j < message.allocations.length; ++j)object.allocations[j] = $31e083413a0a3833$var$$root.SdkStreamAllocation.toObject(message.allocations[j], options);
        }
        if (message.sdpAnswer != null && message.hasOwnProperty("sdpAnswer")) object.sdpAnswer = message.sdpAnswer;
        if (message.tracks && message.tracks.length) {
            object.tracks = [];
            for(var j = 0; j < message.tracks.length; ++j)object.tracks[j] = $31e083413a0a3833$var$$root.SdkTrackMapping.toObject(message.tracks[j], options);
        }
        if (message.compressedSdpAnswer != null && message.hasOwnProperty("compressedSdpAnswer")) object.compressedSdpAnswer = options.bytes === String ? $31e083413a0a3833$var$$util.base64.encode(message.compressedSdpAnswer, 0, message.compressedSdpAnswer.length) : options.bytes === Array ? Array.prototype.slice.call(message.compressedSdpAnswer) : message.compressedSdpAnswer;
        return object;
    };
    /**
     * Converts this SdkSubscribeAckFrame to JSON.
     * @function toJSON
     * @memberof SdkSubscribeAckFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkSubscribeAckFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkSubscribeAckFrame
     * @function getTypeUrl
     * @memberof SdkSubscribeAckFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkSubscribeAckFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkSubscribeAckFrame";
    };
    return SdkSubscribeAckFrame;
}();
$31e083413a0a3833$var$$root.SdkIndexFrame = function() {
    /**
     * Properties of a SdkIndexFrame.
     * @name ISdkIndexFrame
     * @interface ISdkIndexFrame
     * @property {boolean|null} [atCapacity] SdkIndexFrame atCapacity
     * @property {Array.<ISdkStreamDescriptor>|null} [sources] SdkIndexFrame sources
     * @property {Array.<number>|null} [pausedAtSourceIds] SdkIndexFrame pausedAtSourceIds
     * @property {number|null} [numParticipants] SdkIndexFrame numParticipants
     * @property {Array.<SdkVideoCodecCapability>|null} [supportedReceiveCodecIntersection] SdkIndexFrame supportedReceiveCodecIntersection
     */ /**
     * Constructs a new SdkIndexFrame.
     * @name SdkIndexFrame
     * @classdesc Represents a SdkIndexFrame.
     * @implements ISdkIndexFrame
     * @constructor
     * @param {ISdkIndexFrame=} [properties] Properties to set
     */ function SdkIndexFrame(properties) {
        this.sources = [];
        this.pausedAtSourceIds = [];
        this.supportedReceiveCodecIntersection = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkIndexFrame atCapacity.
     * @member {boolean} atCapacity
     * @memberof SdkIndexFrame
     * @instance
     */ SdkIndexFrame.prototype.atCapacity = false;
    /**
     * SdkIndexFrame sources.
     * @member {Array.<ISdkStreamDescriptor>} sources
     * @memberof SdkIndexFrame
     * @instance
     */ SdkIndexFrame.prototype.sources = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkIndexFrame pausedAtSourceIds.
     * @member {Array.<number>} pausedAtSourceIds
     * @memberof SdkIndexFrame
     * @instance
     */ SdkIndexFrame.prototype.pausedAtSourceIds = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkIndexFrame numParticipants.
     * @member {number} numParticipants
     * @memberof SdkIndexFrame
     * @instance
     */ SdkIndexFrame.prototype.numParticipants = 0;
    /**
     * SdkIndexFrame supportedReceiveCodecIntersection.
     * @member {Array.<SdkVideoCodecCapability>} supportedReceiveCodecIntersection
     * @memberof SdkIndexFrame
     * @instance
     */ SdkIndexFrame.prototype.supportedReceiveCodecIntersection = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkIndexFrame instance using the specified properties.
     * @function create
     * @memberof SdkIndexFrame
     * @static
     * @param {ISdkIndexFrame=} [properties] Properties to set
     * @returns {SdkIndexFrame} SdkIndexFrame instance
     */ SdkIndexFrame.create = function create(properties) {
        return new SdkIndexFrame(properties);
    };
    /**
     * Encodes the specified SdkIndexFrame message. Does not implicitly {@link SdkIndexFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkIndexFrame
     * @static
     * @param {ISdkIndexFrame} message SdkIndexFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkIndexFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.atCapacity != null && Object.hasOwnProperty.call(message, "atCapacity")) writer.uint32(/* id 1, wireType 0 =*/ 8).bool(message.atCapacity);
        if (message.sources != null && message.sources.length) for(var i = 0; i < message.sources.length; ++i)$31e083413a0a3833$var$$root.SdkStreamDescriptor.encode(message.sources[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
        if (message.pausedAtSourceIds != null && message.pausedAtSourceIds.length) for(var i = 0; i < message.pausedAtSourceIds.length; ++i)writer.uint32(/* id 3, wireType 0 =*/ 24).uint32(message.pausedAtSourceIds[i]);
        if (message.numParticipants != null && Object.hasOwnProperty.call(message, "numParticipants")) writer.uint32(/* id 4, wireType 0 =*/ 32).uint32(message.numParticipants);
        if (message.supportedReceiveCodecIntersection != null && message.supportedReceiveCodecIntersection.length) for(var i = 0; i < message.supportedReceiveCodecIntersection.length; ++i)writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.supportedReceiveCodecIntersection[i]);
        return writer;
    };
    /**
     * Encodes the specified SdkIndexFrame message, length delimited. Does not implicitly {@link SdkIndexFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkIndexFrame
     * @static
     * @param {ISdkIndexFrame} message SdkIndexFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkIndexFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkIndexFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkIndexFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkIndexFrame} SdkIndexFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkIndexFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkIndexFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.atCapacity = reader.bool();
                    break;
                case 2:
                    if (!(message.sources && message.sources.length)) message.sources = [];
                    message.sources.push($31e083413a0a3833$var$$root.SdkStreamDescriptor.decode(reader, reader.uint32()));
                    break;
                case 3:
                    if (!(message.pausedAtSourceIds && message.pausedAtSourceIds.length)) message.pausedAtSourceIds = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.pausedAtSourceIds.push(reader.uint32());
                    } else message.pausedAtSourceIds.push(reader.uint32());
                    break;
                case 4:
                    message.numParticipants = reader.uint32();
                    break;
                case 5:
                    if (!(message.supportedReceiveCodecIntersection && message.supportedReceiveCodecIntersection.length)) message.supportedReceiveCodecIntersection = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.supportedReceiveCodecIntersection.push(reader.int32());
                    } else message.supportedReceiveCodecIntersection.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkIndexFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkIndexFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkIndexFrame} SdkIndexFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkIndexFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkIndexFrame message.
     * @function verify
     * @memberof SdkIndexFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkIndexFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.atCapacity != null && message.hasOwnProperty("atCapacity")) {
            if (typeof message.atCapacity !== "boolean") return "atCapacity: boolean expected";
        }
        if (message.sources != null && message.hasOwnProperty("sources")) {
            if (!Array.isArray(message.sources)) return "sources: array expected";
            for(var i = 0; i < message.sources.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkStreamDescriptor.verify(message.sources[i]);
                if (error) return "sources." + error;
            }
        }
        if (message.pausedAtSourceIds != null && message.hasOwnProperty("pausedAtSourceIds")) {
            if (!Array.isArray(message.pausedAtSourceIds)) return "pausedAtSourceIds: array expected";
            for(var i = 0; i < message.pausedAtSourceIds.length; ++i)if (!$31e083413a0a3833$var$$util.isInteger(message.pausedAtSourceIds[i])) return "pausedAtSourceIds: integer[] expected";
        }
        if (message.numParticipants != null && message.hasOwnProperty("numParticipants")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.numParticipants)) return "numParticipants: integer expected";
        }
        if (message.supportedReceiveCodecIntersection != null && message.hasOwnProperty("supportedReceiveCodecIntersection")) {
            if (!Array.isArray(message.supportedReceiveCodecIntersection)) return "supportedReceiveCodecIntersection: array expected";
            for(var i = 0; i < message.supportedReceiveCodecIntersection.length; ++i)switch(message.supportedReceiveCodecIntersection[i]){
                default:
                    return "supportedReceiveCodecIntersection: enum value[] expected";
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 8:
                case 11:
                    break;
            }
        }
        return null;
    };
    /**
     * Creates a SdkIndexFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkIndexFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkIndexFrame} SdkIndexFrame
     */ SdkIndexFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkIndexFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkIndexFrame();
        if (object.atCapacity != null) message.atCapacity = Boolean(object.atCapacity);
        if (object.sources) {
            if (!Array.isArray(object.sources)) throw TypeError(".SdkIndexFrame.sources: array expected");
            message.sources = [];
            for(var i = 0; i < object.sources.length; ++i){
                if (typeof object.sources[i] !== "object") throw TypeError(".SdkIndexFrame.sources: object expected");
                message.sources[i] = $31e083413a0a3833$var$$root.SdkStreamDescriptor.fromObject(object.sources[i]);
            }
        }
        if (object.pausedAtSourceIds) {
            if (!Array.isArray(object.pausedAtSourceIds)) throw TypeError(".SdkIndexFrame.pausedAtSourceIds: array expected");
            message.pausedAtSourceIds = [];
            for(var i = 0; i < object.pausedAtSourceIds.length; ++i)message.pausedAtSourceIds[i] = object.pausedAtSourceIds[i] >>> 0;
        }
        if (object.numParticipants != null) message.numParticipants = object.numParticipants >>> 0;
        if (object.supportedReceiveCodecIntersection) {
            if (!Array.isArray(object.supportedReceiveCodecIntersection)) throw TypeError(".SdkIndexFrame.supportedReceiveCodecIntersection: array expected");
            message.supportedReceiveCodecIntersection = [];
            for(var i = 0; i < object.supportedReceiveCodecIntersection.length; ++i)switch(object.supportedReceiveCodecIntersection[i]){
                default:
                    if (typeof object.supportedReceiveCodecIntersection[i] === "number") {
                        message.supportedReceiveCodecIntersection[i] = object.supportedReceiveCodecIntersection[i];
                        break;
                    }
                case "VP8":
                case 1:
                    message.supportedReceiveCodecIntersection[i] = 1;
                    break;
                case "H264_BASELINE_PROFILE":
                case 2:
                    message.supportedReceiveCodecIntersection[i] = 2;
                    break;
                case "H264_CONSTRAINED_BASELINE_PROFILE":
                case 3:
                    message.supportedReceiveCodecIntersection[i] = 3;
                    break;
                case "H264_MAIN_PROFILE":
                case 4:
                    message.supportedReceiveCodecIntersection[i] = 4;
                    break;
                case "H264_HIGH_PROFILE":
                case 5:
                    message.supportedReceiveCodecIntersection[i] = 5;
                    break;
                case "H264_CONSTRAINED_HIGH_PROFILE":
                case 6:
                    message.supportedReceiveCodecIntersection[i] = 6;
                    break;
                case "VP9_PROFILE_0":
                case 8:
                    message.supportedReceiveCodecIntersection[i] = 8;
                    break;
                case "AV1_MAIN_PROFILE":
                case 11:
                    message.supportedReceiveCodecIntersection[i] = 11;
                    break;
            }
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkIndexFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkIndexFrame
     * @static
     * @param {SdkIndexFrame} message SdkIndexFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkIndexFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.sources = [];
            object.pausedAtSourceIds = [];
            object.supportedReceiveCodecIntersection = [];
        }
        if (options.defaults) {
            object.atCapacity = false;
            object.numParticipants = 0;
        }
        if (message.atCapacity != null && message.hasOwnProperty("atCapacity")) object.atCapacity = message.atCapacity;
        if (message.sources && message.sources.length) {
            object.sources = [];
            for(var j = 0; j < message.sources.length; ++j)object.sources[j] = $31e083413a0a3833$var$$root.SdkStreamDescriptor.toObject(message.sources[j], options);
        }
        if (message.pausedAtSourceIds && message.pausedAtSourceIds.length) {
            object.pausedAtSourceIds = [];
            for(var j = 0; j < message.pausedAtSourceIds.length; ++j)object.pausedAtSourceIds[j] = message.pausedAtSourceIds[j];
        }
        if (message.numParticipants != null && message.hasOwnProperty("numParticipants")) object.numParticipants = message.numParticipants;
        if (message.supportedReceiveCodecIntersection && message.supportedReceiveCodecIntersection.length) {
            object.supportedReceiveCodecIntersection = [];
            for(var j = 0; j < message.supportedReceiveCodecIntersection.length; ++j)object.supportedReceiveCodecIntersection[j] = options.enums === String ? $31e083413a0a3833$var$$root.SdkVideoCodecCapability[message.supportedReceiveCodecIntersection[j]] === undefined ? message.supportedReceiveCodecIntersection[j] : $31e083413a0a3833$var$$root.SdkVideoCodecCapability[message.supportedReceiveCodecIntersection[j]] : message.supportedReceiveCodecIntersection[j];
        }
        return object;
    };
    /**
     * Converts this SdkIndexFrame to JSON.
     * @function toJSON
     * @memberof SdkIndexFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkIndexFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkIndexFrame
     * @function getTypeUrl
     * @memberof SdkIndexFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkIndexFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkIndexFrame";
    };
    return SdkIndexFrame;
}();
$31e083413a0a3833$var$$root.SdkPauseResumeFrame = function() {
    /**
     * Properties of a SdkPauseResumeFrame.
     * @name ISdkPauseResumeFrame
     * @interface ISdkPauseResumeFrame
     * @property {Array.<number>|null} [streamIds] SdkPauseResumeFrame streamIds
     * @property {Array.<number>|null} [groupIds] SdkPauseResumeFrame groupIds
     */ /**
     * Constructs a new SdkPauseResumeFrame.
     * @name SdkPauseResumeFrame
     * @classdesc Represents a SdkPauseResumeFrame.
     * @implements ISdkPauseResumeFrame
     * @constructor
     * @param {ISdkPauseResumeFrame=} [properties] Properties to set
     */ function SdkPauseResumeFrame(properties) {
        this.streamIds = [];
        this.groupIds = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkPauseResumeFrame streamIds.
     * @member {Array.<number>} streamIds
     * @memberof SdkPauseResumeFrame
     * @instance
     */ SdkPauseResumeFrame.prototype.streamIds = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkPauseResumeFrame groupIds.
     * @member {Array.<number>} groupIds
     * @memberof SdkPauseResumeFrame
     * @instance
     */ SdkPauseResumeFrame.prototype.groupIds = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkPauseResumeFrame instance using the specified properties.
     * @function create
     * @memberof SdkPauseResumeFrame
     * @static
     * @param {ISdkPauseResumeFrame=} [properties] Properties to set
     * @returns {SdkPauseResumeFrame} SdkPauseResumeFrame instance
     */ SdkPauseResumeFrame.create = function create(properties) {
        return new SdkPauseResumeFrame(properties);
    };
    /**
     * Encodes the specified SdkPauseResumeFrame message. Does not implicitly {@link SdkPauseResumeFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkPauseResumeFrame
     * @static
     * @param {ISdkPauseResumeFrame} message SdkPauseResumeFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkPauseResumeFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.streamIds != null && message.streamIds.length) for(var i = 0; i < message.streamIds.length; ++i)writer.uint32(/* id 1, wireType 0 =*/ 8).uint32(message.streamIds[i]);
        if (message.groupIds != null && message.groupIds.length) for(var i = 0; i < message.groupIds.length; ++i)writer.uint32(/* id 2, wireType 0 =*/ 16).uint32(message.groupIds[i]);
        return writer;
    };
    /**
     * Encodes the specified SdkPauseResumeFrame message, length delimited. Does not implicitly {@link SdkPauseResumeFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkPauseResumeFrame
     * @static
     * @param {ISdkPauseResumeFrame} message SdkPauseResumeFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkPauseResumeFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkPauseResumeFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkPauseResumeFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkPauseResumeFrame} SdkPauseResumeFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkPauseResumeFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkPauseResumeFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (!(message.streamIds && message.streamIds.length)) message.streamIds = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.streamIds.push(reader.uint32());
                    } else message.streamIds.push(reader.uint32());
                    break;
                case 2:
                    if (!(message.groupIds && message.groupIds.length)) message.groupIds = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.groupIds.push(reader.uint32());
                    } else message.groupIds.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkPauseResumeFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkPauseResumeFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkPauseResumeFrame} SdkPauseResumeFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkPauseResumeFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkPauseResumeFrame message.
     * @function verify
     * @memberof SdkPauseResumeFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkPauseResumeFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.streamIds != null && message.hasOwnProperty("streamIds")) {
            if (!Array.isArray(message.streamIds)) return "streamIds: array expected";
            for(var i = 0; i < message.streamIds.length; ++i)if (!$31e083413a0a3833$var$$util.isInteger(message.streamIds[i])) return "streamIds: integer[] expected";
        }
        if (message.groupIds != null && message.hasOwnProperty("groupIds")) {
            if (!Array.isArray(message.groupIds)) return "groupIds: array expected";
            for(var i = 0; i < message.groupIds.length; ++i)if (!$31e083413a0a3833$var$$util.isInteger(message.groupIds[i])) return "groupIds: integer[] expected";
        }
        return null;
    };
    /**
     * Creates a SdkPauseResumeFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkPauseResumeFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkPauseResumeFrame} SdkPauseResumeFrame
     */ SdkPauseResumeFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkPauseResumeFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkPauseResumeFrame();
        if (object.streamIds) {
            if (!Array.isArray(object.streamIds)) throw TypeError(".SdkPauseResumeFrame.streamIds: array expected");
            message.streamIds = [];
            for(var i = 0; i < object.streamIds.length; ++i)message.streamIds[i] = object.streamIds[i] >>> 0;
        }
        if (object.groupIds) {
            if (!Array.isArray(object.groupIds)) throw TypeError(".SdkPauseResumeFrame.groupIds: array expected");
            message.groupIds = [];
            for(var i = 0; i < object.groupIds.length; ++i)message.groupIds[i] = object.groupIds[i] >>> 0;
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkPauseResumeFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkPauseResumeFrame
     * @static
     * @param {SdkPauseResumeFrame} message SdkPauseResumeFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkPauseResumeFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.streamIds = [];
            object.groupIds = [];
        }
        if (message.streamIds && message.streamIds.length) {
            object.streamIds = [];
            for(var j = 0; j < message.streamIds.length; ++j)object.streamIds[j] = message.streamIds[j];
        }
        if (message.groupIds && message.groupIds.length) {
            object.groupIds = [];
            for(var j = 0; j < message.groupIds.length; ++j)object.groupIds[j] = message.groupIds[j];
        }
        return object;
    };
    /**
     * Converts this SdkPauseResumeFrame to JSON.
     * @function toJSON
     * @memberof SdkPauseResumeFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkPauseResumeFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkPauseResumeFrame
     * @function getTypeUrl
     * @memberof SdkPauseResumeFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkPauseResumeFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkPauseResumeFrame";
    };
    return SdkPauseResumeFrame;
}();
$31e083413a0a3833$var$$root.SdkBitrateFrame = function() {
    /**
     * Properties of a SdkBitrateFrame.
     * @name ISdkBitrateFrame
     * @interface ISdkBitrateFrame
     * @property {Array.<ISdkBitrate>|null} [bitrates] SdkBitrateFrame bitrates
     * @property {number|null} [serverAvailableOutgoingBitrate] SdkBitrateFrame serverAvailableOutgoingBitrate
     */ /**
     * Constructs a new SdkBitrateFrame.
     * @name SdkBitrateFrame
     * @classdesc Represents a SdkBitrateFrame.
     * @implements ISdkBitrateFrame
     * @constructor
     * @param {ISdkBitrateFrame=} [properties] Properties to set
     */ function SdkBitrateFrame(properties) {
        this.bitrates = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkBitrateFrame bitrates.
     * @member {Array.<ISdkBitrate>} bitrates
     * @memberof SdkBitrateFrame
     * @instance
     */ SdkBitrateFrame.prototype.bitrates = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkBitrateFrame serverAvailableOutgoingBitrate.
     * @member {number} serverAvailableOutgoingBitrate
     * @memberof SdkBitrateFrame
     * @instance
     */ SdkBitrateFrame.prototype.serverAvailableOutgoingBitrate = 0;
    /**
     * Creates a new SdkBitrateFrame instance using the specified properties.
     * @function create
     * @memberof SdkBitrateFrame
     * @static
     * @param {ISdkBitrateFrame=} [properties] Properties to set
     * @returns {SdkBitrateFrame} SdkBitrateFrame instance
     */ SdkBitrateFrame.create = function create(properties) {
        return new SdkBitrateFrame(properties);
    };
    /**
     * Encodes the specified SdkBitrateFrame message. Does not implicitly {@link SdkBitrateFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkBitrateFrame
     * @static
     * @param {ISdkBitrateFrame} message SdkBitrateFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkBitrateFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.bitrates != null && message.bitrates.length) for(var i = 0; i < message.bitrates.length; ++i)$31e083413a0a3833$var$$root.SdkBitrate.encode(message.bitrates[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.serverAvailableOutgoingBitrate != null && Object.hasOwnProperty.call(message, "serverAvailableOutgoingBitrate")) writer.uint32(/* id 2, wireType 0 =*/ 16).uint32(message.serverAvailableOutgoingBitrate);
        return writer;
    };
    /**
     * Encodes the specified SdkBitrateFrame message, length delimited. Does not implicitly {@link SdkBitrateFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkBitrateFrame
     * @static
     * @param {ISdkBitrateFrame} message SdkBitrateFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkBitrateFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkBitrateFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkBitrateFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkBitrateFrame} SdkBitrateFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkBitrateFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkBitrateFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (!(message.bitrates && message.bitrates.length)) message.bitrates = [];
                    message.bitrates.push($31e083413a0a3833$var$$root.SdkBitrate.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.serverAvailableOutgoingBitrate = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkBitrateFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkBitrateFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkBitrateFrame} SdkBitrateFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkBitrateFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkBitrateFrame message.
     * @function verify
     * @memberof SdkBitrateFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkBitrateFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.bitrates != null && message.hasOwnProperty("bitrates")) {
            if (!Array.isArray(message.bitrates)) return "bitrates: array expected";
            for(var i = 0; i < message.bitrates.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkBitrate.verify(message.bitrates[i]);
                if (error) return "bitrates." + error;
            }
        }
        if (message.serverAvailableOutgoingBitrate != null && message.hasOwnProperty("serverAvailableOutgoingBitrate")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.serverAvailableOutgoingBitrate)) return "serverAvailableOutgoingBitrate: integer expected";
        }
        return null;
    };
    /**
     * Creates a SdkBitrateFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkBitrateFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkBitrateFrame} SdkBitrateFrame
     */ SdkBitrateFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkBitrateFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkBitrateFrame();
        if (object.bitrates) {
            if (!Array.isArray(object.bitrates)) throw TypeError(".SdkBitrateFrame.bitrates: array expected");
            message.bitrates = [];
            for(var i = 0; i < object.bitrates.length; ++i){
                if (typeof object.bitrates[i] !== "object") throw TypeError(".SdkBitrateFrame.bitrates: object expected");
                message.bitrates[i] = $31e083413a0a3833$var$$root.SdkBitrate.fromObject(object.bitrates[i]);
            }
        }
        if (object.serverAvailableOutgoingBitrate != null) message.serverAvailableOutgoingBitrate = object.serverAvailableOutgoingBitrate >>> 0;
        return message;
    };
    /**
     * Creates a plain object from a SdkBitrateFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkBitrateFrame
     * @static
     * @param {SdkBitrateFrame} message SdkBitrateFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkBitrateFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.bitrates = [];
        if (options.defaults) object.serverAvailableOutgoingBitrate = 0;
        if (message.bitrates && message.bitrates.length) {
            object.bitrates = [];
            for(var j = 0; j < message.bitrates.length; ++j)object.bitrates[j] = $31e083413a0a3833$var$$root.SdkBitrate.toObject(message.bitrates[j], options);
        }
        if (message.serverAvailableOutgoingBitrate != null && message.hasOwnProperty("serverAvailableOutgoingBitrate")) object.serverAvailableOutgoingBitrate = message.serverAvailableOutgoingBitrate;
        return object;
    };
    /**
     * Converts this SdkBitrateFrame to JSON.
     * @function toJSON
     * @memberof SdkBitrateFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkBitrateFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkBitrateFrame
     * @function getTypeUrl
     * @memberof SdkBitrateFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkBitrateFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkBitrateFrame";
    };
    return SdkBitrateFrame;
}();
$31e083413a0a3833$var$$root.SdkStreamDescriptor = function() {
    /**
     * Properties of a SdkStreamDescriptor.
     * @name ISdkStreamDescriptor
     * @interface ISdkStreamDescriptor
     * @property {number|null} [streamId] SdkStreamDescriptor streamId
     * @property {number|null} [framerate] SdkStreamDescriptor framerate
     * @property {number|null} [maxBitrateKbps] SdkStreamDescriptor maxBitrateKbps
     * @property {string|null} [trackLabel] SdkStreamDescriptor trackLabel
     * @property {number|null} [groupId] SdkStreamDescriptor groupId
     * @property {number|null} [avgBitrateBps] SdkStreamDescriptor avgBitrateBps
     * @property {string|null} [attendeeId] SdkStreamDescriptor attendeeId
     * @property {SdkStreamMediaType|null} [mediaType] SdkStreamDescriptor mediaType
     * @property {string|null} [externalUserId] SdkStreamDescriptor externalUserId
     * @property {number|null} [width] SdkStreamDescriptor width
     * @property {number|null} [height] SdkStreamDescriptor height
     */ /**
     * Constructs a new SdkStreamDescriptor.
     * @name SdkStreamDescriptor
     * @classdesc Represents a SdkStreamDescriptor.
     * @implements ISdkStreamDescriptor
     * @constructor
     * @param {ISdkStreamDescriptor=} [properties] Properties to set
     */ function SdkStreamDescriptor(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkStreamDescriptor streamId.
     * @member {number} streamId
     * @memberof SdkStreamDescriptor
     * @instance
     */ SdkStreamDescriptor.prototype.streamId = 0;
    /**
     * SdkStreamDescriptor framerate.
     * @member {number} framerate
     * @memberof SdkStreamDescriptor
     * @instance
     */ SdkStreamDescriptor.prototype.framerate = 0;
    /**
     * SdkStreamDescriptor maxBitrateKbps.
     * @member {number} maxBitrateKbps
     * @memberof SdkStreamDescriptor
     * @instance
     */ SdkStreamDescriptor.prototype.maxBitrateKbps = 0;
    /**
     * SdkStreamDescriptor trackLabel.
     * @member {string} trackLabel
     * @memberof SdkStreamDescriptor
     * @instance
     */ SdkStreamDescriptor.prototype.trackLabel = "";
    /**
     * SdkStreamDescriptor groupId.
     * @member {number} groupId
     * @memberof SdkStreamDescriptor
     * @instance
     */ SdkStreamDescriptor.prototype.groupId = 0;
    /**
     * SdkStreamDescriptor avgBitrateBps.
     * @member {number} avgBitrateBps
     * @memberof SdkStreamDescriptor
     * @instance
     */ SdkStreamDescriptor.prototype.avgBitrateBps = 0;
    /**
     * SdkStreamDescriptor attendeeId.
     * @member {string} attendeeId
     * @memberof SdkStreamDescriptor
     * @instance
     */ SdkStreamDescriptor.prototype.attendeeId = "";
    /**
     * SdkStreamDescriptor mediaType.
     * @member {SdkStreamMediaType} mediaType
     * @memberof SdkStreamDescriptor
     * @instance
     */ SdkStreamDescriptor.prototype.mediaType = 1;
    /**
     * SdkStreamDescriptor externalUserId.
     * @member {string} externalUserId
     * @memberof SdkStreamDescriptor
     * @instance
     */ SdkStreamDescriptor.prototype.externalUserId = "";
    /**
     * SdkStreamDescriptor width.
     * @member {number} width
     * @memberof SdkStreamDescriptor
     * @instance
     */ SdkStreamDescriptor.prototype.width = 0;
    /**
     * SdkStreamDescriptor height.
     * @member {number} height
     * @memberof SdkStreamDescriptor
     * @instance
     */ SdkStreamDescriptor.prototype.height = 0;
    /**
     * Creates a new SdkStreamDescriptor instance using the specified properties.
     * @function create
     * @memberof SdkStreamDescriptor
     * @static
     * @param {ISdkStreamDescriptor=} [properties] Properties to set
     * @returns {SdkStreamDescriptor} SdkStreamDescriptor instance
     */ SdkStreamDescriptor.create = function create(properties) {
        return new SdkStreamDescriptor(properties);
    };
    /**
     * Encodes the specified SdkStreamDescriptor message. Does not implicitly {@link SdkStreamDescriptor.verify|verify} messages.
     * @function encode
     * @memberof SdkStreamDescriptor
     * @static
     * @param {ISdkStreamDescriptor} message SdkStreamDescriptor message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkStreamDescriptor.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.streamId != null && Object.hasOwnProperty.call(message, "streamId")) writer.uint32(/* id 1, wireType 0 =*/ 8).uint32(message.streamId);
        if (message.framerate != null && Object.hasOwnProperty.call(message, "framerate")) writer.uint32(/* id 2, wireType 0 =*/ 16).uint32(message.framerate);
        if (message.maxBitrateKbps != null && Object.hasOwnProperty.call(message, "maxBitrateKbps")) writer.uint32(/* id 3, wireType 0 =*/ 24).uint32(message.maxBitrateKbps);
        if (message.trackLabel != null && Object.hasOwnProperty.call(message, "trackLabel")) writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.trackLabel);
        if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId")) writer.uint32(/* id 6, wireType 0 =*/ 48).uint32(message.groupId);
        if (message.avgBitrateBps != null && Object.hasOwnProperty.call(message, "avgBitrateBps")) writer.uint32(/* id 7, wireType 0 =*/ 56).uint32(message.avgBitrateBps);
        if (message.attendeeId != null && Object.hasOwnProperty.call(message, "attendeeId")) writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.attendeeId);
        if (message.mediaType != null && Object.hasOwnProperty.call(message, "mediaType")) writer.uint32(/* id 9, wireType 0 =*/ 72).int32(message.mediaType);
        if (message.externalUserId != null && Object.hasOwnProperty.call(message, "externalUserId")) writer.uint32(/* id 10, wireType 2 =*/ 82).string(message.externalUserId);
        if (message.width != null && Object.hasOwnProperty.call(message, "width")) writer.uint32(/* id 11, wireType 0 =*/ 88).uint32(message.width);
        if (message.height != null && Object.hasOwnProperty.call(message, "height")) writer.uint32(/* id 12, wireType 0 =*/ 96).uint32(message.height);
        return writer;
    };
    /**
     * Encodes the specified SdkStreamDescriptor message, length delimited. Does not implicitly {@link SdkStreamDescriptor.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkStreamDescriptor
     * @static
     * @param {ISdkStreamDescriptor} message SdkStreamDescriptor message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkStreamDescriptor.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkStreamDescriptor message from the specified reader or buffer.
     * @function decode
     * @memberof SdkStreamDescriptor
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkStreamDescriptor} SdkStreamDescriptor
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkStreamDescriptor.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkStreamDescriptor();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.streamId = reader.uint32();
                    break;
                case 2:
                    message.framerate = reader.uint32();
                    break;
                case 3:
                    message.maxBitrateKbps = reader.uint32();
                    break;
                case 4:
                    message.trackLabel = reader.string();
                    break;
                case 6:
                    message.groupId = reader.uint32();
                    break;
                case 7:
                    message.avgBitrateBps = reader.uint32();
                    break;
                case 8:
                    message.attendeeId = reader.string();
                    break;
                case 9:
                    message.mediaType = reader.int32();
                    break;
                case 10:
                    message.externalUserId = reader.string();
                    break;
                case 11:
                    message.width = reader.uint32();
                    break;
                case 12:
                    message.height = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkStreamDescriptor message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkStreamDescriptor
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkStreamDescriptor} SdkStreamDescriptor
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkStreamDescriptor.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkStreamDescriptor message.
     * @function verify
     * @memberof SdkStreamDescriptor
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkStreamDescriptor.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.streamId != null && message.hasOwnProperty("streamId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.streamId)) return "streamId: integer expected";
        }
        if (message.framerate != null && message.hasOwnProperty("framerate")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.framerate)) return "framerate: integer expected";
        }
        if (message.maxBitrateKbps != null && message.hasOwnProperty("maxBitrateKbps")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.maxBitrateKbps)) return "maxBitrateKbps: integer expected";
        }
        if (message.trackLabel != null && message.hasOwnProperty("trackLabel")) {
            if (!$31e083413a0a3833$var$$util.isString(message.trackLabel)) return "trackLabel: string expected";
        }
        if (message.groupId != null && message.hasOwnProperty("groupId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.groupId)) return "groupId: integer expected";
        }
        if (message.avgBitrateBps != null && message.hasOwnProperty("avgBitrateBps")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.avgBitrateBps)) return "avgBitrateBps: integer expected";
        }
        if (message.attendeeId != null && message.hasOwnProperty("attendeeId")) {
            if (!$31e083413a0a3833$var$$util.isString(message.attendeeId)) return "attendeeId: string expected";
        }
        if (message.mediaType != null && message.hasOwnProperty("mediaType")) switch(message.mediaType){
            default:
                return "mediaType: enum value expected";
            case 1:
            case 2:
                break;
        }
        if (message.externalUserId != null && message.hasOwnProperty("externalUserId")) {
            if (!$31e083413a0a3833$var$$util.isString(message.externalUserId)) return "externalUserId: string expected";
        }
        if (message.width != null && message.hasOwnProperty("width")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.width)) return "width: integer expected";
        }
        if (message.height != null && message.hasOwnProperty("height")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.height)) return "height: integer expected";
        }
        return null;
    };
    /**
     * Creates a SdkStreamDescriptor message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkStreamDescriptor
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkStreamDescriptor} SdkStreamDescriptor
     */ SdkStreamDescriptor.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkStreamDescriptor) return object;
        var message = new $31e083413a0a3833$var$$root.SdkStreamDescriptor();
        if (object.streamId != null) message.streamId = object.streamId >>> 0;
        if (object.framerate != null) message.framerate = object.framerate >>> 0;
        if (object.maxBitrateKbps != null) message.maxBitrateKbps = object.maxBitrateKbps >>> 0;
        if (object.trackLabel != null) message.trackLabel = String(object.trackLabel);
        if (object.groupId != null) message.groupId = object.groupId >>> 0;
        if (object.avgBitrateBps != null) message.avgBitrateBps = object.avgBitrateBps >>> 0;
        if (object.attendeeId != null) message.attendeeId = String(object.attendeeId);
        switch(object.mediaType){
            default:
                if (typeof object.mediaType === "number") {
                    message.mediaType = object.mediaType;
                    break;
                }
                break;
            case "AUDIO":
            case 1:
                message.mediaType = 1;
                break;
            case "VIDEO":
            case 2:
                message.mediaType = 2;
                break;
        }
        if (object.externalUserId != null) message.externalUserId = String(object.externalUserId);
        if (object.width != null) message.width = object.width >>> 0;
        if (object.height != null) message.height = object.height >>> 0;
        return message;
    };
    /**
     * Creates a plain object from a SdkStreamDescriptor message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkStreamDescriptor
     * @static
     * @param {SdkStreamDescriptor} message SdkStreamDescriptor
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkStreamDescriptor.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.streamId = 0;
            object.framerate = 0;
            object.maxBitrateKbps = 0;
            object.trackLabel = "";
            object.groupId = 0;
            object.avgBitrateBps = 0;
            object.attendeeId = "";
            object.mediaType = options.enums === String ? "AUDIO" : 1;
            object.externalUserId = "";
            object.width = 0;
            object.height = 0;
        }
        if (message.streamId != null && message.hasOwnProperty("streamId")) object.streamId = message.streamId;
        if (message.framerate != null && message.hasOwnProperty("framerate")) object.framerate = message.framerate;
        if (message.maxBitrateKbps != null && message.hasOwnProperty("maxBitrateKbps")) object.maxBitrateKbps = message.maxBitrateKbps;
        if (message.trackLabel != null && message.hasOwnProperty("trackLabel")) object.trackLabel = message.trackLabel;
        if (message.groupId != null && message.hasOwnProperty("groupId")) object.groupId = message.groupId;
        if (message.avgBitrateBps != null && message.hasOwnProperty("avgBitrateBps")) object.avgBitrateBps = message.avgBitrateBps;
        if (message.attendeeId != null && message.hasOwnProperty("attendeeId")) object.attendeeId = message.attendeeId;
        if (message.mediaType != null && message.hasOwnProperty("mediaType")) object.mediaType = options.enums === String ? $31e083413a0a3833$var$$root.SdkStreamMediaType[message.mediaType] === undefined ? message.mediaType : $31e083413a0a3833$var$$root.SdkStreamMediaType[message.mediaType] : message.mediaType;
        if (message.externalUserId != null && message.hasOwnProperty("externalUserId")) object.externalUserId = message.externalUserId;
        if (message.width != null && message.hasOwnProperty("width")) object.width = message.width;
        if (message.height != null && message.hasOwnProperty("height")) object.height = message.height;
        return object;
    };
    /**
     * Converts this SdkStreamDescriptor to JSON.
     * @function toJSON
     * @memberof SdkStreamDescriptor
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkStreamDescriptor.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkStreamDescriptor
     * @function getTypeUrl
     * @memberof SdkStreamDescriptor
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkStreamDescriptor.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkStreamDescriptor";
    };
    return SdkStreamDescriptor;
}();
$31e083413a0a3833$var$$root.SdkStreamAllocation = function() {
    /**
     * Properties of a SdkStreamAllocation.
     * @name ISdkStreamAllocation
     * @interface ISdkStreamAllocation
     * @property {string|null} [trackLabel] SdkStreamAllocation trackLabel
     * @property {number|null} [streamId] SdkStreamAllocation streamId
     * @property {number|null} [groupId] SdkStreamAllocation groupId
     */ /**
     * Constructs a new SdkStreamAllocation.
     * @name SdkStreamAllocation
     * @classdesc Represents a SdkStreamAllocation.
     * @implements ISdkStreamAllocation
     * @constructor
     * @param {ISdkStreamAllocation=} [properties] Properties to set
     */ function SdkStreamAllocation(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkStreamAllocation trackLabel.
     * @member {string} trackLabel
     * @memberof SdkStreamAllocation
     * @instance
     */ SdkStreamAllocation.prototype.trackLabel = "";
    /**
     * SdkStreamAllocation streamId.
     * @member {number} streamId
     * @memberof SdkStreamAllocation
     * @instance
     */ SdkStreamAllocation.prototype.streamId = 0;
    /**
     * SdkStreamAllocation groupId.
     * @member {number} groupId
     * @memberof SdkStreamAllocation
     * @instance
     */ SdkStreamAllocation.prototype.groupId = 0;
    /**
     * Creates a new SdkStreamAllocation instance using the specified properties.
     * @function create
     * @memberof SdkStreamAllocation
     * @static
     * @param {ISdkStreamAllocation=} [properties] Properties to set
     * @returns {SdkStreamAllocation} SdkStreamAllocation instance
     */ SdkStreamAllocation.create = function create(properties) {
        return new SdkStreamAllocation(properties);
    };
    /**
     * Encodes the specified SdkStreamAllocation message. Does not implicitly {@link SdkStreamAllocation.verify|verify} messages.
     * @function encode
     * @memberof SdkStreamAllocation
     * @static
     * @param {ISdkStreamAllocation} message SdkStreamAllocation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkStreamAllocation.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.trackLabel != null && Object.hasOwnProperty.call(message, "trackLabel")) writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.trackLabel);
        if (message.streamId != null && Object.hasOwnProperty.call(message, "streamId")) writer.uint32(/* id 2, wireType 0 =*/ 16).uint32(message.streamId);
        if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId")) writer.uint32(/* id 3, wireType 0 =*/ 24).uint32(message.groupId);
        return writer;
    };
    /**
     * Encodes the specified SdkStreamAllocation message, length delimited. Does not implicitly {@link SdkStreamAllocation.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkStreamAllocation
     * @static
     * @param {ISdkStreamAllocation} message SdkStreamAllocation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkStreamAllocation.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkStreamAllocation message from the specified reader or buffer.
     * @function decode
     * @memberof SdkStreamAllocation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkStreamAllocation} SdkStreamAllocation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkStreamAllocation.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkStreamAllocation();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.trackLabel = reader.string();
                    break;
                case 2:
                    message.streamId = reader.uint32();
                    break;
                case 3:
                    message.groupId = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkStreamAllocation message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkStreamAllocation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkStreamAllocation} SdkStreamAllocation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkStreamAllocation.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkStreamAllocation message.
     * @function verify
     * @memberof SdkStreamAllocation
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkStreamAllocation.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.trackLabel != null && message.hasOwnProperty("trackLabel")) {
            if (!$31e083413a0a3833$var$$util.isString(message.trackLabel)) return "trackLabel: string expected";
        }
        if (message.streamId != null && message.hasOwnProperty("streamId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.streamId)) return "streamId: integer expected";
        }
        if (message.groupId != null && message.hasOwnProperty("groupId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.groupId)) return "groupId: integer expected";
        }
        return null;
    };
    /**
     * Creates a SdkStreamAllocation message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkStreamAllocation
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkStreamAllocation} SdkStreamAllocation
     */ SdkStreamAllocation.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkStreamAllocation) return object;
        var message = new $31e083413a0a3833$var$$root.SdkStreamAllocation();
        if (object.trackLabel != null) message.trackLabel = String(object.trackLabel);
        if (object.streamId != null) message.streamId = object.streamId >>> 0;
        if (object.groupId != null) message.groupId = object.groupId >>> 0;
        return message;
    };
    /**
     * Creates a plain object from a SdkStreamAllocation message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkStreamAllocation
     * @static
     * @param {SdkStreamAllocation} message SdkStreamAllocation
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkStreamAllocation.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.trackLabel = "";
            object.streamId = 0;
            object.groupId = 0;
        }
        if (message.trackLabel != null && message.hasOwnProperty("trackLabel")) object.trackLabel = message.trackLabel;
        if (message.streamId != null && message.hasOwnProperty("streamId")) object.streamId = message.streamId;
        if (message.groupId != null && message.hasOwnProperty("groupId")) object.groupId = message.groupId;
        return object;
    };
    /**
     * Converts this SdkStreamAllocation to JSON.
     * @function toJSON
     * @memberof SdkStreamAllocation
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkStreamAllocation.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkStreamAllocation
     * @function getTypeUrl
     * @memberof SdkStreamAllocation
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkStreamAllocation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkStreamAllocation";
    };
    return SdkStreamAllocation;
}();
$31e083413a0a3833$var$$root.SdkTrackMapping = function() {
    /**
     * Properties of a SdkTrackMapping.
     * @name ISdkTrackMapping
     * @interface ISdkTrackMapping
     * @property {number|null} [streamId] SdkTrackMapping streamId
     * @property {number|null} [ssrc] SdkTrackMapping ssrc
     * @property {string|null} [trackLabel] SdkTrackMapping trackLabel
     */ /**
     * Constructs a new SdkTrackMapping.
     * @name SdkTrackMapping
     * @classdesc Represents a SdkTrackMapping.
     * @implements ISdkTrackMapping
     * @constructor
     * @param {ISdkTrackMapping=} [properties] Properties to set
     */ function SdkTrackMapping(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkTrackMapping streamId.
     * @member {number} streamId
     * @memberof SdkTrackMapping
     * @instance
     */ SdkTrackMapping.prototype.streamId = 0;
    /**
     * SdkTrackMapping ssrc.
     * @member {number} ssrc
     * @memberof SdkTrackMapping
     * @instance
     */ SdkTrackMapping.prototype.ssrc = 0;
    /**
     * SdkTrackMapping trackLabel.
     * @member {string} trackLabel
     * @memberof SdkTrackMapping
     * @instance
     */ SdkTrackMapping.prototype.trackLabel = "";
    /**
     * Creates a new SdkTrackMapping instance using the specified properties.
     * @function create
     * @memberof SdkTrackMapping
     * @static
     * @param {ISdkTrackMapping=} [properties] Properties to set
     * @returns {SdkTrackMapping} SdkTrackMapping instance
     */ SdkTrackMapping.create = function create(properties) {
        return new SdkTrackMapping(properties);
    };
    /**
     * Encodes the specified SdkTrackMapping message. Does not implicitly {@link SdkTrackMapping.verify|verify} messages.
     * @function encode
     * @memberof SdkTrackMapping
     * @static
     * @param {ISdkTrackMapping} message SdkTrackMapping message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTrackMapping.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.streamId != null && Object.hasOwnProperty.call(message, "streamId")) writer.uint32(/* id 1, wireType 0 =*/ 8).uint32(message.streamId);
        if (message.ssrc != null && Object.hasOwnProperty.call(message, "ssrc")) writer.uint32(/* id 2, wireType 0 =*/ 16).uint32(message.ssrc);
        if (message.trackLabel != null && Object.hasOwnProperty.call(message, "trackLabel")) writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.trackLabel);
        return writer;
    };
    /**
     * Encodes the specified SdkTrackMapping message, length delimited. Does not implicitly {@link SdkTrackMapping.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkTrackMapping
     * @static
     * @param {ISdkTrackMapping} message SdkTrackMapping message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTrackMapping.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkTrackMapping message from the specified reader or buffer.
     * @function decode
     * @memberof SdkTrackMapping
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkTrackMapping} SdkTrackMapping
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTrackMapping.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkTrackMapping();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.streamId = reader.uint32();
                    break;
                case 2:
                    message.ssrc = reader.uint32();
                    break;
                case 3:
                    message.trackLabel = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkTrackMapping message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkTrackMapping
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkTrackMapping} SdkTrackMapping
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTrackMapping.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkTrackMapping message.
     * @function verify
     * @memberof SdkTrackMapping
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkTrackMapping.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.streamId != null && message.hasOwnProperty("streamId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.streamId)) return "streamId: integer expected";
        }
        if (message.ssrc != null && message.hasOwnProperty("ssrc")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.ssrc)) return "ssrc: integer expected";
        }
        if (message.trackLabel != null && message.hasOwnProperty("trackLabel")) {
            if (!$31e083413a0a3833$var$$util.isString(message.trackLabel)) return "trackLabel: string expected";
        }
        return null;
    };
    /**
     * Creates a SdkTrackMapping message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkTrackMapping
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkTrackMapping} SdkTrackMapping
     */ SdkTrackMapping.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkTrackMapping) return object;
        var message = new $31e083413a0a3833$var$$root.SdkTrackMapping();
        if (object.streamId != null) message.streamId = object.streamId >>> 0;
        if (object.ssrc != null) message.ssrc = object.ssrc >>> 0;
        if (object.trackLabel != null) message.trackLabel = String(object.trackLabel);
        return message;
    };
    /**
     * Creates a plain object from a SdkTrackMapping message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkTrackMapping
     * @static
     * @param {SdkTrackMapping} message SdkTrackMapping
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkTrackMapping.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.streamId = 0;
            object.ssrc = 0;
            object.trackLabel = "";
        }
        if (message.streamId != null && message.hasOwnProperty("streamId")) object.streamId = message.streamId;
        if (message.ssrc != null && message.hasOwnProperty("ssrc")) object.ssrc = message.ssrc;
        if (message.trackLabel != null && message.hasOwnProperty("trackLabel")) object.trackLabel = message.trackLabel;
        return object;
    };
    /**
     * Converts this SdkTrackMapping to JSON.
     * @function toJSON
     * @memberof SdkTrackMapping
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkTrackMapping.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkTrackMapping
     * @function getTypeUrl
     * @memberof SdkTrackMapping
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkTrackMapping.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkTrackMapping";
    };
    return SdkTrackMapping;
}();
$31e083413a0a3833$var$$root.SdkBitrate = function() {
    /**
     * Properties of a SdkBitrate.
     * @name ISdkBitrate
     * @interface ISdkBitrate
     * @property {number|null} [sourceStreamId] SdkBitrate sourceStreamId
     * @property {number|null} [avgBitrateBps] SdkBitrate avgBitrateBps
     */ /**
     * Constructs a new SdkBitrate.
     * @name SdkBitrate
     * @classdesc Represents a SdkBitrate.
     * @implements ISdkBitrate
     * @constructor
     * @param {ISdkBitrate=} [properties] Properties to set
     */ function SdkBitrate(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkBitrate sourceStreamId.
     * @member {number} sourceStreamId
     * @memberof SdkBitrate
     * @instance
     */ SdkBitrate.prototype.sourceStreamId = 0;
    /**
     * SdkBitrate avgBitrateBps.
     * @member {number} avgBitrateBps
     * @memberof SdkBitrate
     * @instance
     */ SdkBitrate.prototype.avgBitrateBps = 0;
    /**
     * Creates a new SdkBitrate instance using the specified properties.
     * @function create
     * @memberof SdkBitrate
     * @static
     * @param {ISdkBitrate=} [properties] Properties to set
     * @returns {SdkBitrate} SdkBitrate instance
     */ SdkBitrate.create = function create(properties) {
        return new SdkBitrate(properties);
    };
    /**
     * Encodes the specified SdkBitrate message. Does not implicitly {@link SdkBitrate.verify|verify} messages.
     * @function encode
     * @memberof SdkBitrate
     * @static
     * @param {ISdkBitrate} message SdkBitrate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkBitrate.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.sourceStreamId != null && Object.hasOwnProperty.call(message, "sourceStreamId")) writer.uint32(/* id 1, wireType 0 =*/ 8).uint32(message.sourceStreamId);
        if (message.avgBitrateBps != null && Object.hasOwnProperty.call(message, "avgBitrateBps")) writer.uint32(/* id 2, wireType 0 =*/ 16).uint32(message.avgBitrateBps);
        return writer;
    };
    /**
     * Encodes the specified SdkBitrate message, length delimited. Does not implicitly {@link SdkBitrate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkBitrate
     * @static
     * @param {ISdkBitrate} message SdkBitrate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkBitrate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkBitrate message from the specified reader or buffer.
     * @function decode
     * @memberof SdkBitrate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkBitrate} SdkBitrate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkBitrate.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkBitrate();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sourceStreamId = reader.uint32();
                    break;
                case 2:
                    message.avgBitrateBps = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkBitrate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkBitrate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkBitrate} SdkBitrate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkBitrate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkBitrate message.
     * @function verify
     * @memberof SdkBitrate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkBitrate.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.sourceStreamId != null && message.hasOwnProperty("sourceStreamId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.sourceStreamId)) return "sourceStreamId: integer expected";
        }
        if (message.avgBitrateBps != null && message.hasOwnProperty("avgBitrateBps")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.avgBitrateBps)) return "avgBitrateBps: integer expected";
        }
        return null;
    };
    /**
     * Creates a SdkBitrate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkBitrate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkBitrate} SdkBitrate
     */ SdkBitrate.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkBitrate) return object;
        var message = new $31e083413a0a3833$var$$root.SdkBitrate();
        if (object.sourceStreamId != null) message.sourceStreamId = object.sourceStreamId >>> 0;
        if (object.avgBitrateBps != null) message.avgBitrateBps = object.avgBitrateBps >>> 0;
        return message;
    };
    /**
     * Creates a plain object from a SdkBitrate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkBitrate
     * @static
     * @param {SdkBitrate} message SdkBitrate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkBitrate.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.sourceStreamId = 0;
            object.avgBitrateBps = 0;
        }
        if (message.sourceStreamId != null && message.hasOwnProperty("sourceStreamId")) object.sourceStreamId = message.sourceStreamId;
        if (message.avgBitrateBps != null && message.hasOwnProperty("avgBitrateBps")) object.avgBitrateBps = message.avgBitrateBps;
        return object;
    };
    /**
     * Converts this SdkBitrate to JSON.
     * @function toJSON
     * @memberof SdkBitrate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkBitrate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkBitrate
     * @function getTypeUrl
     * @memberof SdkBitrate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkBitrate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkBitrate";
    };
    return SdkBitrate;
}();
$31e083413a0a3833$var$$root.SdkAudioControlFrame = function() {
    /**
     * Properties of a SdkAudioControlFrame.
     * @name ISdkAudioControlFrame
     * @interface ISdkAudioControlFrame
     * @property {boolean|null} [muted] SdkAudioControlFrame muted
     */ /**
     * Constructs a new SdkAudioControlFrame.
     * @name SdkAudioControlFrame
     * @classdesc Represents a SdkAudioControlFrame.
     * @implements ISdkAudioControlFrame
     * @constructor
     * @param {ISdkAudioControlFrame=} [properties] Properties to set
     */ function SdkAudioControlFrame(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkAudioControlFrame muted.
     * @member {boolean} muted
     * @memberof SdkAudioControlFrame
     * @instance
     */ SdkAudioControlFrame.prototype.muted = false;
    /**
     * Creates a new SdkAudioControlFrame instance using the specified properties.
     * @function create
     * @memberof SdkAudioControlFrame
     * @static
     * @param {ISdkAudioControlFrame=} [properties] Properties to set
     * @returns {SdkAudioControlFrame} SdkAudioControlFrame instance
     */ SdkAudioControlFrame.create = function create(properties) {
        return new SdkAudioControlFrame(properties);
    };
    /**
     * Encodes the specified SdkAudioControlFrame message. Does not implicitly {@link SdkAudioControlFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkAudioControlFrame
     * @static
     * @param {ISdkAudioControlFrame} message SdkAudioControlFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkAudioControlFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.muted != null && Object.hasOwnProperty.call(message, "muted")) writer.uint32(/* id 1, wireType 0 =*/ 8).bool(message.muted);
        return writer;
    };
    /**
     * Encodes the specified SdkAudioControlFrame message, length delimited. Does not implicitly {@link SdkAudioControlFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkAudioControlFrame
     * @static
     * @param {ISdkAudioControlFrame} message SdkAudioControlFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkAudioControlFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkAudioControlFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkAudioControlFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkAudioControlFrame} SdkAudioControlFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkAudioControlFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkAudioControlFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.muted = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkAudioControlFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkAudioControlFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkAudioControlFrame} SdkAudioControlFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkAudioControlFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkAudioControlFrame message.
     * @function verify
     * @memberof SdkAudioControlFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkAudioControlFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.muted != null && message.hasOwnProperty("muted")) {
            if (typeof message.muted !== "boolean") return "muted: boolean expected";
        }
        return null;
    };
    /**
     * Creates a SdkAudioControlFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkAudioControlFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkAudioControlFrame} SdkAudioControlFrame
     */ SdkAudioControlFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkAudioControlFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkAudioControlFrame();
        if (object.muted != null) message.muted = Boolean(object.muted);
        return message;
    };
    /**
     * Creates a plain object from a SdkAudioControlFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkAudioControlFrame
     * @static
     * @param {SdkAudioControlFrame} message SdkAudioControlFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkAudioControlFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.muted = false;
        if (message.muted != null && message.hasOwnProperty("muted")) object.muted = message.muted;
        return object;
    };
    /**
     * Converts this SdkAudioControlFrame to JSON.
     * @function toJSON
     * @memberof SdkAudioControlFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkAudioControlFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkAudioControlFrame
     * @function getTypeUrl
     * @memberof SdkAudioControlFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkAudioControlFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkAudioControlFrame";
    };
    return SdkAudioControlFrame;
}();
$31e083413a0a3833$var$$root.SdkAudioMetadataFrame = function() {
    /**
     * Properties of a SdkAudioMetadataFrame.
     * @name ISdkAudioMetadataFrame
     * @interface ISdkAudioMetadataFrame
     * @property {Array.<ISdkAudioAttendeeState>|null} [attendeeStates] SdkAudioMetadataFrame attendeeStates
     */ /**
     * Constructs a new SdkAudioMetadataFrame.
     * @name SdkAudioMetadataFrame
     * @classdesc Represents a SdkAudioMetadataFrame.
     * @implements ISdkAudioMetadataFrame
     * @constructor
     * @param {ISdkAudioMetadataFrame=} [properties] Properties to set
     */ function SdkAudioMetadataFrame(properties) {
        this.attendeeStates = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkAudioMetadataFrame attendeeStates.
     * @member {Array.<ISdkAudioAttendeeState>} attendeeStates
     * @memberof SdkAudioMetadataFrame
     * @instance
     */ SdkAudioMetadataFrame.prototype.attendeeStates = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkAudioMetadataFrame instance using the specified properties.
     * @function create
     * @memberof SdkAudioMetadataFrame
     * @static
     * @param {ISdkAudioMetadataFrame=} [properties] Properties to set
     * @returns {SdkAudioMetadataFrame} SdkAudioMetadataFrame instance
     */ SdkAudioMetadataFrame.create = function create(properties) {
        return new SdkAudioMetadataFrame(properties);
    };
    /**
     * Encodes the specified SdkAudioMetadataFrame message. Does not implicitly {@link SdkAudioMetadataFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkAudioMetadataFrame
     * @static
     * @param {ISdkAudioMetadataFrame} message SdkAudioMetadataFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkAudioMetadataFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.attendeeStates != null && message.attendeeStates.length) for(var i = 0; i < message.attendeeStates.length; ++i)$31e083413a0a3833$var$$root.SdkAudioAttendeeState.encode(message.attendeeStates[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkAudioMetadataFrame message, length delimited. Does not implicitly {@link SdkAudioMetadataFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkAudioMetadataFrame
     * @static
     * @param {ISdkAudioMetadataFrame} message SdkAudioMetadataFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkAudioMetadataFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkAudioMetadataFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkAudioMetadataFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkAudioMetadataFrame} SdkAudioMetadataFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkAudioMetadataFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkAudioMetadataFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (!(message.attendeeStates && message.attendeeStates.length)) message.attendeeStates = [];
                    message.attendeeStates.push($31e083413a0a3833$var$$root.SdkAudioAttendeeState.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkAudioMetadataFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkAudioMetadataFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkAudioMetadataFrame} SdkAudioMetadataFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkAudioMetadataFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkAudioMetadataFrame message.
     * @function verify
     * @memberof SdkAudioMetadataFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkAudioMetadataFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.attendeeStates != null && message.hasOwnProperty("attendeeStates")) {
            if (!Array.isArray(message.attendeeStates)) return "attendeeStates: array expected";
            for(var i = 0; i < message.attendeeStates.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkAudioAttendeeState.verify(message.attendeeStates[i]);
                if (error) return "attendeeStates." + error;
            }
        }
        return null;
    };
    /**
     * Creates a SdkAudioMetadataFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkAudioMetadataFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkAudioMetadataFrame} SdkAudioMetadataFrame
     */ SdkAudioMetadataFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkAudioMetadataFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkAudioMetadataFrame();
        if (object.attendeeStates) {
            if (!Array.isArray(object.attendeeStates)) throw TypeError(".SdkAudioMetadataFrame.attendeeStates: array expected");
            message.attendeeStates = [];
            for(var i = 0; i < object.attendeeStates.length; ++i){
                if (typeof object.attendeeStates[i] !== "object") throw TypeError(".SdkAudioMetadataFrame.attendeeStates: object expected");
                message.attendeeStates[i] = $31e083413a0a3833$var$$root.SdkAudioAttendeeState.fromObject(object.attendeeStates[i]);
            }
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkAudioMetadataFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkAudioMetadataFrame
     * @static
     * @param {SdkAudioMetadataFrame} message SdkAudioMetadataFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkAudioMetadataFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.attendeeStates = [];
        if (message.attendeeStates && message.attendeeStates.length) {
            object.attendeeStates = [];
            for(var j = 0; j < message.attendeeStates.length; ++j)object.attendeeStates[j] = $31e083413a0a3833$var$$root.SdkAudioAttendeeState.toObject(message.attendeeStates[j], options);
        }
        return object;
    };
    /**
     * Converts this SdkAudioMetadataFrame to JSON.
     * @function toJSON
     * @memberof SdkAudioMetadataFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkAudioMetadataFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkAudioMetadataFrame
     * @function getTypeUrl
     * @memberof SdkAudioMetadataFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkAudioMetadataFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkAudioMetadataFrame";
    };
    return SdkAudioMetadataFrame;
}();
$31e083413a0a3833$var$$root.SdkAudioAttendeeState = function() {
    /**
     * Properties of a SdkAudioAttendeeState.
     * @name ISdkAudioAttendeeState
     * @interface ISdkAudioAttendeeState
     * @property {number|null} [audioStreamId] SdkAudioAttendeeState audioStreamId
     * @property {number|null} [volume] SdkAudioAttendeeState volume
     * @property {boolean|null} [muted] SdkAudioAttendeeState muted
     * @property {number|null} [signalStrength] SdkAudioAttendeeState signalStrength
     */ /**
     * Constructs a new SdkAudioAttendeeState.
     * @name SdkAudioAttendeeState
     * @classdesc Represents a SdkAudioAttendeeState.
     * @implements ISdkAudioAttendeeState
     * @constructor
     * @param {ISdkAudioAttendeeState=} [properties] Properties to set
     */ function SdkAudioAttendeeState(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkAudioAttendeeState audioStreamId.
     * @member {number} audioStreamId
     * @memberof SdkAudioAttendeeState
     * @instance
     */ SdkAudioAttendeeState.prototype.audioStreamId = 0;
    /**
     * SdkAudioAttendeeState volume.
     * @member {number} volume
     * @memberof SdkAudioAttendeeState
     * @instance
     */ SdkAudioAttendeeState.prototype.volume = 0;
    /**
     * SdkAudioAttendeeState muted.
     * @member {boolean} muted
     * @memberof SdkAudioAttendeeState
     * @instance
     */ SdkAudioAttendeeState.prototype.muted = false;
    /**
     * SdkAudioAttendeeState signalStrength.
     * @member {number} signalStrength
     * @memberof SdkAudioAttendeeState
     * @instance
     */ SdkAudioAttendeeState.prototype.signalStrength = 0;
    /**
     * Creates a new SdkAudioAttendeeState instance using the specified properties.
     * @function create
     * @memberof SdkAudioAttendeeState
     * @static
     * @param {ISdkAudioAttendeeState=} [properties] Properties to set
     * @returns {SdkAudioAttendeeState} SdkAudioAttendeeState instance
     */ SdkAudioAttendeeState.create = function create(properties) {
        return new SdkAudioAttendeeState(properties);
    };
    /**
     * Encodes the specified SdkAudioAttendeeState message. Does not implicitly {@link SdkAudioAttendeeState.verify|verify} messages.
     * @function encode
     * @memberof SdkAudioAttendeeState
     * @static
     * @param {ISdkAudioAttendeeState} message SdkAudioAttendeeState message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkAudioAttendeeState.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.audioStreamId != null && Object.hasOwnProperty.call(message, "audioStreamId")) writer.uint32(/* id 1, wireType 0 =*/ 8).uint32(message.audioStreamId);
        if (message.volume != null && Object.hasOwnProperty.call(message, "volume")) writer.uint32(/* id 2, wireType 0 =*/ 16).uint32(message.volume);
        if (message.muted != null && Object.hasOwnProperty.call(message, "muted")) writer.uint32(/* id 3, wireType 0 =*/ 24).bool(message.muted);
        if (message.signalStrength != null && Object.hasOwnProperty.call(message, "signalStrength")) writer.uint32(/* id 4, wireType 0 =*/ 32).uint32(message.signalStrength);
        return writer;
    };
    /**
     * Encodes the specified SdkAudioAttendeeState message, length delimited. Does not implicitly {@link SdkAudioAttendeeState.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkAudioAttendeeState
     * @static
     * @param {ISdkAudioAttendeeState} message SdkAudioAttendeeState message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkAudioAttendeeState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkAudioAttendeeState message from the specified reader or buffer.
     * @function decode
     * @memberof SdkAudioAttendeeState
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkAudioAttendeeState} SdkAudioAttendeeState
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkAudioAttendeeState.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkAudioAttendeeState();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.audioStreamId = reader.uint32();
                    break;
                case 2:
                    message.volume = reader.uint32();
                    break;
                case 3:
                    message.muted = reader.bool();
                    break;
                case 4:
                    message.signalStrength = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkAudioAttendeeState message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkAudioAttendeeState
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkAudioAttendeeState} SdkAudioAttendeeState
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkAudioAttendeeState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkAudioAttendeeState message.
     * @function verify
     * @memberof SdkAudioAttendeeState
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkAudioAttendeeState.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.audioStreamId != null && message.hasOwnProperty("audioStreamId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.audioStreamId)) return "audioStreamId: integer expected";
        }
        if (message.volume != null && message.hasOwnProperty("volume")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.volume)) return "volume: integer expected";
        }
        if (message.muted != null && message.hasOwnProperty("muted")) {
            if (typeof message.muted !== "boolean") return "muted: boolean expected";
        }
        if (message.signalStrength != null && message.hasOwnProperty("signalStrength")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.signalStrength)) return "signalStrength: integer expected";
        }
        return null;
    };
    /**
     * Creates a SdkAudioAttendeeState message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkAudioAttendeeState
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkAudioAttendeeState} SdkAudioAttendeeState
     */ SdkAudioAttendeeState.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkAudioAttendeeState) return object;
        var message = new $31e083413a0a3833$var$$root.SdkAudioAttendeeState();
        if (object.audioStreamId != null) message.audioStreamId = object.audioStreamId >>> 0;
        if (object.volume != null) message.volume = object.volume >>> 0;
        if (object.muted != null) message.muted = Boolean(object.muted);
        if (object.signalStrength != null) message.signalStrength = object.signalStrength >>> 0;
        return message;
    };
    /**
     * Creates a plain object from a SdkAudioAttendeeState message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkAudioAttendeeState
     * @static
     * @param {SdkAudioAttendeeState} message SdkAudioAttendeeState
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkAudioAttendeeState.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.audioStreamId = 0;
            object.volume = 0;
            object.muted = false;
            object.signalStrength = 0;
        }
        if (message.audioStreamId != null && message.hasOwnProperty("audioStreamId")) object.audioStreamId = message.audioStreamId;
        if (message.volume != null && message.hasOwnProperty("volume")) object.volume = message.volume;
        if (message.muted != null && message.hasOwnProperty("muted")) object.muted = message.muted;
        if (message.signalStrength != null && message.hasOwnProperty("signalStrength")) object.signalStrength = message.signalStrength;
        return object;
    };
    /**
     * Converts this SdkAudioAttendeeState to JSON.
     * @function toJSON
     * @memberof SdkAudioAttendeeState
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkAudioAttendeeState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkAudioAttendeeState
     * @function getTypeUrl
     * @memberof SdkAudioAttendeeState
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkAudioAttendeeState.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkAudioAttendeeState";
    };
    return SdkAudioAttendeeState;
}();
$31e083413a0a3833$var$$root.SdkAudioStreamIdInfoFrame = function() {
    /**
     * Properties of a SdkAudioStreamIdInfoFrame.
     * @name ISdkAudioStreamIdInfoFrame
     * @interface ISdkAudioStreamIdInfoFrame
     * @property {Array.<ISdkAudioStreamIdInfo>|null} [streams] SdkAudioStreamIdInfoFrame streams
     */ /**
     * Constructs a new SdkAudioStreamIdInfoFrame.
     * @name SdkAudioStreamIdInfoFrame
     * @classdesc Represents a SdkAudioStreamIdInfoFrame.
     * @implements ISdkAudioStreamIdInfoFrame
     * @constructor
     * @param {ISdkAudioStreamIdInfoFrame=} [properties] Properties to set
     */ function SdkAudioStreamIdInfoFrame(properties) {
        this.streams = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkAudioStreamIdInfoFrame streams.
     * @member {Array.<ISdkAudioStreamIdInfo>} streams
     * @memberof SdkAudioStreamIdInfoFrame
     * @instance
     */ SdkAudioStreamIdInfoFrame.prototype.streams = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkAudioStreamIdInfoFrame instance using the specified properties.
     * @function create
     * @memberof SdkAudioStreamIdInfoFrame
     * @static
     * @param {ISdkAudioStreamIdInfoFrame=} [properties] Properties to set
     * @returns {SdkAudioStreamIdInfoFrame} SdkAudioStreamIdInfoFrame instance
     */ SdkAudioStreamIdInfoFrame.create = function create(properties) {
        return new SdkAudioStreamIdInfoFrame(properties);
    };
    /**
     * Encodes the specified SdkAudioStreamIdInfoFrame message. Does not implicitly {@link SdkAudioStreamIdInfoFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkAudioStreamIdInfoFrame
     * @static
     * @param {ISdkAudioStreamIdInfoFrame} message SdkAudioStreamIdInfoFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkAudioStreamIdInfoFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.streams != null && message.streams.length) for(var i = 0; i < message.streams.length; ++i)$31e083413a0a3833$var$$root.SdkAudioStreamIdInfo.encode(message.streams[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkAudioStreamIdInfoFrame message, length delimited. Does not implicitly {@link SdkAudioStreamIdInfoFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkAudioStreamIdInfoFrame
     * @static
     * @param {ISdkAudioStreamIdInfoFrame} message SdkAudioStreamIdInfoFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkAudioStreamIdInfoFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkAudioStreamIdInfoFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkAudioStreamIdInfoFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkAudioStreamIdInfoFrame} SdkAudioStreamIdInfoFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkAudioStreamIdInfoFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkAudioStreamIdInfoFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (!(message.streams && message.streams.length)) message.streams = [];
                    message.streams.push($31e083413a0a3833$var$$root.SdkAudioStreamIdInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkAudioStreamIdInfoFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkAudioStreamIdInfoFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkAudioStreamIdInfoFrame} SdkAudioStreamIdInfoFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkAudioStreamIdInfoFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkAudioStreamIdInfoFrame message.
     * @function verify
     * @memberof SdkAudioStreamIdInfoFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkAudioStreamIdInfoFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.streams != null && message.hasOwnProperty("streams")) {
            if (!Array.isArray(message.streams)) return "streams: array expected";
            for(var i = 0; i < message.streams.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkAudioStreamIdInfo.verify(message.streams[i]);
                if (error) return "streams." + error;
            }
        }
        return null;
    };
    /**
     * Creates a SdkAudioStreamIdInfoFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkAudioStreamIdInfoFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkAudioStreamIdInfoFrame} SdkAudioStreamIdInfoFrame
     */ SdkAudioStreamIdInfoFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkAudioStreamIdInfoFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkAudioStreamIdInfoFrame();
        if (object.streams) {
            if (!Array.isArray(object.streams)) throw TypeError(".SdkAudioStreamIdInfoFrame.streams: array expected");
            message.streams = [];
            for(var i = 0; i < object.streams.length; ++i){
                if (typeof object.streams[i] !== "object") throw TypeError(".SdkAudioStreamIdInfoFrame.streams: object expected");
                message.streams[i] = $31e083413a0a3833$var$$root.SdkAudioStreamIdInfo.fromObject(object.streams[i]);
            }
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkAudioStreamIdInfoFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkAudioStreamIdInfoFrame
     * @static
     * @param {SdkAudioStreamIdInfoFrame} message SdkAudioStreamIdInfoFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkAudioStreamIdInfoFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.streams = [];
        if (message.streams && message.streams.length) {
            object.streams = [];
            for(var j = 0; j < message.streams.length; ++j)object.streams[j] = $31e083413a0a3833$var$$root.SdkAudioStreamIdInfo.toObject(message.streams[j], options);
        }
        return object;
    };
    /**
     * Converts this SdkAudioStreamIdInfoFrame to JSON.
     * @function toJSON
     * @memberof SdkAudioStreamIdInfoFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkAudioStreamIdInfoFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkAudioStreamIdInfoFrame
     * @function getTypeUrl
     * @memberof SdkAudioStreamIdInfoFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkAudioStreamIdInfoFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkAudioStreamIdInfoFrame";
    };
    return SdkAudioStreamIdInfoFrame;
}();
$31e083413a0a3833$var$$root.SdkAudioStreamIdInfo = function() {
    /**
     * Properties of a SdkAudioStreamIdInfo.
     * @name ISdkAudioStreamIdInfo
     * @interface ISdkAudioStreamIdInfo
     * @property {number|null} [audioStreamId] SdkAudioStreamIdInfo audioStreamId
     * @property {string|null} [attendeeId] SdkAudioStreamIdInfo attendeeId
     * @property {boolean|null} [muted] SdkAudioStreamIdInfo muted
     * @property {string|null} [externalUserId] SdkAudioStreamIdInfo externalUserId
     * @property {boolean|null} [dropped] SdkAudioStreamIdInfo dropped
     */ /**
     * Constructs a new SdkAudioStreamIdInfo.
     * @name SdkAudioStreamIdInfo
     * @classdesc Represents a SdkAudioStreamIdInfo.
     * @implements ISdkAudioStreamIdInfo
     * @constructor
     * @param {ISdkAudioStreamIdInfo=} [properties] Properties to set
     */ function SdkAudioStreamIdInfo(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkAudioStreamIdInfo audioStreamId.
     * @member {number} audioStreamId
     * @memberof SdkAudioStreamIdInfo
     * @instance
     */ SdkAudioStreamIdInfo.prototype.audioStreamId = 0;
    /**
     * SdkAudioStreamIdInfo attendeeId.
     * @member {string} attendeeId
     * @memberof SdkAudioStreamIdInfo
     * @instance
     */ SdkAudioStreamIdInfo.prototype.attendeeId = "";
    /**
     * SdkAudioStreamIdInfo muted.
     * @member {boolean} muted
     * @memberof SdkAudioStreamIdInfo
     * @instance
     */ SdkAudioStreamIdInfo.prototype.muted = false;
    /**
     * SdkAudioStreamIdInfo externalUserId.
     * @member {string} externalUserId
     * @memberof SdkAudioStreamIdInfo
     * @instance
     */ SdkAudioStreamIdInfo.prototype.externalUserId = "";
    /**
     * SdkAudioStreamIdInfo dropped.
     * @member {boolean} dropped
     * @memberof SdkAudioStreamIdInfo
     * @instance
     */ SdkAudioStreamIdInfo.prototype.dropped = false;
    /**
     * Creates a new SdkAudioStreamIdInfo instance using the specified properties.
     * @function create
     * @memberof SdkAudioStreamIdInfo
     * @static
     * @param {ISdkAudioStreamIdInfo=} [properties] Properties to set
     * @returns {SdkAudioStreamIdInfo} SdkAudioStreamIdInfo instance
     */ SdkAudioStreamIdInfo.create = function create(properties) {
        return new SdkAudioStreamIdInfo(properties);
    };
    /**
     * Encodes the specified SdkAudioStreamIdInfo message. Does not implicitly {@link SdkAudioStreamIdInfo.verify|verify} messages.
     * @function encode
     * @memberof SdkAudioStreamIdInfo
     * @static
     * @param {ISdkAudioStreamIdInfo} message SdkAudioStreamIdInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkAudioStreamIdInfo.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.audioStreamId != null && Object.hasOwnProperty.call(message, "audioStreamId")) writer.uint32(/* id 1, wireType 0 =*/ 8).uint32(message.audioStreamId);
        if (message.attendeeId != null && Object.hasOwnProperty.call(message, "attendeeId")) writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.attendeeId);
        if (message.muted != null && Object.hasOwnProperty.call(message, "muted")) writer.uint32(/* id 3, wireType 0 =*/ 24).bool(message.muted);
        if (message.externalUserId != null && Object.hasOwnProperty.call(message, "externalUserId")) writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.externalUserId);
        if (message.dropped != null && Object.hasOwnProperty.call(message, "dropped")) writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.dropped);
        return writer;
    };
    /**
     * Encodes the specified SdkAudioStreamIdInfo message, length delimited. Does not implicitly {@link SdkAudioStreamIdInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkAudioStreamIdInfo
     * @static
     * @param {ISdkAudioStreamIdInfo} message SdkAudioStreamIdInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkAudioStreamIdInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkAudioStreamIdInfo message from the specified reader or buffer.
     * @function decode
     * @memberof SdkAudioStreamIdInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkAudioStreamIdInfo} SdkAudioStreamIdInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkAudioStreamIdInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkAudioStreamIdInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.audioStreamId = reader.uint32();
                    break;
                case 2:
                    message.attendeeId = reader.string();
                    break;
                case 3:
                    message.muted = reader.bool();
                    break;
                case 4:
                    message.externalUserId = reader.string();
                    break;
                case 5:
                    message.dropped = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkAudioStreamIdInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkAudioStreamIdInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkAudioStreamIdInfo} SdkAudioStreamIdInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkAudioStreamIdInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkAudioStreamIdInfo message.
     * @function verify
     * @memberof SdkAudioStreamIdInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkAudioStreamIdInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.audioStreamId != null && message.hasOwnProperty("audioStreamId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.audioStreamId)) return "audioStreamId: integer expected";
        }
        if (message.attendeeId != null && message.hasOwnProperty("attendeeId")) {
            if (!$31e083413a0a3833$var$$util.isString(message.attendeeId)) return "attendeeId: string expected";
        }
        if (message.muted != null && message.hasOwnProperty("muted")) {
            if (typeof message.muted !== "boolean") return "muted: boolean expected";
        }
        if (message.externalUserId != null && message.hasOwnProperty("externalUserId")) {
            if (!$31e083413a0a3833$var$$util.isString(message.externalUserId)) return "externalUserId: string expected";
        }
        if (message.dropped != null && message.hasOwnProperty("dropped")) {
            if (typeof message.dropped !== "boolean") return "dropped: boolean expected";
        }
        return null;
    };
    /**
     * Creates a SdkAudioStreamIdInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkAudioStreamIdInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkAudioStreamIdInfo} SdkAudioStreamIdInfo
     */ SdkAudioStreamIdInfo.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkAudioStreamIdInfo) return object;
        var message = new $31e083413a0a3833$var$$root.SdkAudioStreamIdInfo();
        if (object.audioStreamId != null) message.audioStreamId = object.audioStreamId >>> 0;
        if (object.attendeeId != null) message.attendeeId = String(object.attendeeId);
        if (object.muted != null) message.muted = Boolean(object.muted);
        if (object.externalUserId != null) message.externalUserId = String(object.externalUserId);
        if (object.dropped != null) message.dropped = Boolean(object.dropped);
        return message;
    };
    /**
     * Creates a plain object from a SdkAudioStreamIdInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkAudioStreamIdInfo
     * @static
     * @param {SdkAudioStreamIdInfo} message SdkAudioStreamIdInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkAudioStreamIdInfo.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.audioStreamId = 0;
            object.attendeeId = "";
            object.muted = false;
            object.externalUserId = "";
            object.dropped = false;
        }
        if (message.audioStreamId != null && message.hasOwnProperty("audioStreamId")) object.audioStreamId = message.audioStreamId;
        if (message.attendeeId != null && message.hasOwnProperty("attendeeId")) object.attendeeId = message.attendeeId;
        if (message.muted != null && message.hasOwnProperty("muted")) object.muted = message.muted;
        if (message.externalUserId != null && message.hasOwnProperty("externalUserId")) object.externalUserId = message.externalUserId;
        if (message.dropped != null && message.hasOwnProperty("dropped")) object.dropped = message.dropped;
        return object;
    };
    /**
     * Converts this SdkAudioStreamIdInfo to JSON.
     * @function toJSON
     * @memberof SdkAudioStreamIdInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkAudioStreamIdInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkAudioStreamIdInfo
     * @function getTypeUrl
     * @memberof SdkAudioStreamIdInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkAudioStreamIdInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkAudioStreamIdInfo";
    };
    return SdkAudioStreamIdInfo;
}();
/**
 * SdkPingPongType enum.
 * @name SdkPingPongType
 * @enum {number}
 * @property {number} PING=1 PING value
 * @property {number} PONG=2 PONG value
 */ $31e083413a0a3833$var$$root.SdkPingPongType = function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "PING"] = 1;
    values[valuesById[2] = "PONG"] = 2;
    return values;
}();
$31e083413a0a3833$var$$root.SdkPingPongFrame = function() {
    /**
     * Properties of a SdkPingPongFrame.
     * @name ISdkPingPongFrame
     * @interface ISdkPingPongFrame
     * @property {SdkPingPongType} type SdkPingPongFrame type
     * @property {number} pingId SdkPingPongFrame pingId
     */ /**
     * Constructs a new SdkPingPongFrame.
     * @name SdkPingPongFrame
     * @classdesc Represents a SdkPingPongFrame.
     * @implements ISdkPingPongFrame
     * @constructor
     * @param {ISdkPingPongFrame=} [properties] Properties to set
     */ function SdkPingPongFrame(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkPingPongFrame type.
     * @member {SdkPingPongType} type
     * @memberof SdkPingPongFrame
     * @instance
     */ SdkPingPongFrame.prototype.type = 1;
    /**
     * SdkPingPongFrame pingId.
     * @member {number} pingId
     * @memberof SdkPingPongFrame
     * @instance
     */ SdkPingPongFrame.prototype.pingId = 0;
    /**
     * Creates a new SdkPingPongFrame instance using the specified properties.
     * @function create
     * @memberof SdkPingPongFrame
     * @static
     * @param {ISdkPingPongFrame=} [properties] Properties to set
     * @returns {SdkPingPongFrame} SdkPingPongFrame instance
     */ SdkPingPongFrame.create = function create(properties) {
        return new SdkPingPongFrame(properties);
    };
    /**
     * Encodes the specified SdkPingPongFrame message. Does not implicitly {@link SdkPingPongFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkPingPongFrame
     * @static
     * @param {ISdkPingPongFrame} message SdkPingPongFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkPingPongFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.type);
        writer.uint32(/* id 2, wireType 0 =*/ 16).uint32(message.pingId);
        return writer;
    };
    /**
     * Encodes the specified SdkPingPongFrame message, length delimited. Does not implicitly {@link SdkPingPongFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkPingPongFrame
     * @static
     * @param {ISdkPingPongFrame} message SdkPingPongFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkPingPongFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkPingPongFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkPingPongFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkPingPongFrame} SdkPingPongFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkPingPongFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkPingPongFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.pingId = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        if (!message.hasOwnProperty("type")) throw $31e083413a0a3833$var$$util.ProtocolError("missing required 'type'", {
            instance: message
        });
        if (!message.hasOwnProperty("pingId")) throw $31e083413a0a3833$var$$util.ProtocolError("missing required 'pingId'", {
            instance: message
        });
        return message;
    };
    /**
     * Decodes a SdkPingPongFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkPingPongFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkPingPongFrame} SdkPingPongFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkPingPongFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkPingPongFrame message.
     * @function verify
     * @memberof SdkPingPongFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkPingPongFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        switch(message.type){
            default:
                return "type: enum value expected";
            case 1:
            case 2:
                break;
        }
        if (!$31e083413a0a3833$var$$util.isInteger(message.pingId)) return "pingId: integer expected";
        return null;
    };
    /**
     * Creates a SdkPingPongFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkPingPongFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkPingPongFrame} SdkPingPongFrame
     */ SdkPingPongFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkPingPongFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkPingPongFrame();
        switch(object.type){
            default:
                if (typeof object.type === "number") {
                    message.type = object.type;
                    break;
                }
                break;
            case "PING":
            case 1:
                message.type = 1;
                break;
            case "PONG":
            case 2:
                message.type = 2;
                break;
        }
        if (object.pingId != null) message.pingId = object.pingId >>> 0;
        return message;
    };
    /**
     * Creates a plain object from a SdkPingPongFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkPingPongFrame
     * @static
     * @param {SdkPingPongFrame} message SdkPingPongFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkPingPongFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "PING" : 1;
            object.pingId = 0;
        }
        if (message.type != null && message.hasOwnProperty("type")) object.type = options.enums === String ? $31e083413a0a3833$var$$root.SdkPingPongType[message.type] === undefined ? message.type : $31e083413a0a3833$var$$root.SdkPingPongType[message.type] : message.type;
        if (message.pingId != null && message.hasOwnProperty("pingId")) object.pingId = message.pingId;
        return object;
    };
    /**
     * Converts this SdkPingPongFrame to JSON.
     * @function toJSON
     * @memberof SdkPingPongFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkPingPongFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkPingPongFrame
     * @function getTypeUrl
     * @memberof SdkPingPongFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkPingPongFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkPingPongFrame";
    };
    return SdkPingPongFrame;
}();
$31e083413a0a3833$var$$root.SdkAudioStatusFrame = function() {
    /**
     * Properties of a SdkAudioStatusFrame.
     * @name ISdkAudioStatusFrame
     * @interface ISdkAudioStatusFrame
     * @property {number|null} [audioStatus] SdkAudioStatusFrame audioStatus
     */ /**
     * Constructs a new SdkAudioStatusFrame.
     * @name SdkAudioStatusFrame
     * @classdesc Represents a SdkAudioStatusFrame.
     * @implements ISdkAudioStatusFrame
     * @constructor
     * @param {ISdkAudioStatusFrame=} [properties] Properties to set
     */ function SdkAudioStatusFrame(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkAudioStatusFrame audioStatus.
     * @member {number} audioStatus
     * @memberof SdkAudioStatusFrame
     * @instance
     */ SdkAudioStatusFrame.prototype.audioStatus = 0;
    /**
     * Creates a new SdkAudioStatusFrame instance using the specified properties.
     * @function create
     * @memberof SdkAudioStatusFrame
     * @static
     * @param {ISdkAudioStatusFrame=} [properties] Properties to set
     * @returns {SdkAudioStatusFrame} SdkAudioStatusFrame instance
     */ SdkAudioStatusFrame.create = function create(properties) {
        return new SdkAudioStatusFrame(properties);
    };
    /**
     * Encodes the specified SdkAudioStatusFrame message. Does not implicitly {@link SdkAudioStatusFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkAudioStatusFrame
     * @static
     * @param {ISdkAudioStatusFrame} message SdkAudioStatusFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkAudioStatusFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.audioStatus != null && Object.hasOwnProperty.call(message, "audioStatus")) writer.uint32(/* id 1, wireType 0 =*/ 8).uint32(message.audioStatus);
        return writer;
    };
    /**
     * Encodes the specified SdkAudioStatusFrame message, length delimited. Does not implicitly {@link SdkAudioStatusFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkAudioStatusFrame
     * @static
     * @param {ISdkAudioStatusFrame} message SdkAudioStatusFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkAudioStatusFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkAudioStatusFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkAudioStatusFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkAudioStatusFrame} SdkAudioStatusFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkAudioStatusFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkAudioStatusFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.audioStatus = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkAudioStatusFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkAudioStatusFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkAudioStatusFrame} SdkAudioStatusFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkAudioStatusFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkAudioStatusFrame message.
     * @function verify
     * @memberof SdkAudioStatusFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkAudioStatusFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.audioStatus != null && message.hasOwnProperty("audioStatus")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.audioStatus)) return "audioStatus: integer expected";
        }
        return null;
    };
    /**
     * Creates a SdkAudioStatusFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkAudioStatusFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkAudioStatusFrame} SdkAudioStatusFrame
     */ SdkAudioStatusFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkAudioStatusFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkAudioStatusFrame();
        if (object.audioStatus != null) message.audioStatus = object.audioStatus >>> 0;
        return message;
    };
    /**
     * Creates a plain object from a SdkAudioStatusFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkAudioStatusFrame
     * @static
     * @param {SdkAudioStatusFrame} message SdkAudioStatusFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkAudioStatusFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.audioStatus = 0;
        if (message.audioStatus != null && message.hasOwnProperty("audioStatus")) object.audioStatus = message.audioStatus;
        return object;
    };
    /**
     * Converts this SdkAudioStatusFrame to JSON.
     * @function toJSON
     * @memberof SdkAudioStatusFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkAudioStatusFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkAudioStatusFrame
     * @function getTypeUrl
     * @memberof SdkAudioStatusFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkAudioStatusFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkAudioStatusFrame";
    };
    return SdkAudioStatusFrame;
}();
$31e083413a0a3833$var$$root.SdkMetric = function() {
    /**
     * Properties of a SdkMetric.
     * @name ISdkMetric
     * @interface ISdkMetric
     * @property {SdkMetric.Type|null} [type] SdkMetric type
     * @property {number|null} [value] SdkMetric value
     */ /**
     * Constructs a new SdkMetric.
     * @name SdkMetric
     * @classdesc Represents a SdkMetric.
     * @implements ISdkMetric
     * @constructor
     * @param {ISdkMetric=} [properties] Properties to set
     */ function SdkMetric(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkMetric type.
     * @member {SdkMetric.Type} type
     * @memberof SdkMetric
     * @instance
     */ SdkMetric.prototype.type = 1;
    /**
     * SdkMetric value.
     * @member {number} value
     * @memberof SdkMetric
     * @instance
     */ SdkMetric.prototype.value = 0;
    /**
     * Creates a new SdkMetric instance using the specified properties.
     * @function create
     * @memberof SdkMetric
     * @static
     * @param {ISdkMetric=} [properties] Properties to set
     * @returns {SdkMetric} SdkMetric instance
     */ SdkMetric.create = function create(properties) {
        return new SdkMetric(properties);
    };
    /**
     * Encodes the specified SdkMetric message. Does not implicitly {@link SdkMetric.verify|verify} messages.
     * @function encode
     * @memberof SdkMetric
     * @static
     * @param {ISdkMetric} message SdkMetric message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMetric.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.type);
        if (message.value != null && Object.hasOwnProperty.call(message, "value")) writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.value);
        return writer;
    };
    /**
     * Encodes the specified SdkMetric message, length delimited. Does not implicitly {@link SdkMetric.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkMetric
     * @static
     * @param {ISdkMetric} message SdkMetric message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMetric.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkMetric message from the specified reader or buffer.
     * @function decode
     * @memberof SdkMetric
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkMetric} SdkMetric
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMetric.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkMetric();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.value = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkMetric message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkMetric
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkMetric} SdkMetric
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMetric.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkMetric message.
     * @function verify
     * @memberof SdkMetric
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkMetric.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.type != null && message.hasOwnProperty("type")) switch(message.type){
            default:
                return "type: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 21:
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
            case 28:
            case 29:
            case 30:
            case 31:
            case 32:
            case 33:
            case 34:
            case 35:
            case 36:
            case 37:
            case 38:
            case 39:
            case 40:
            case 41:
            case 42:
            case 43:
            case 44:
            case 45:
            case 46:
            case 47:
            case 48:
            case 49:
            case 52:
            case 56:
            case 60:
            case 64:
            case 66:
            case 69:
            case 72:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 91:
            case 92:
            case 93:
            case 94:
            case 95:
            case 96:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
                break;
        }
        if (message.value != null && message.hasOwnProperty("value")) {
            if (typeof message.value !== "number") return "value: number expected";
        }
        return null;
    };
    /**
     * Creates a SdkMetric message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkMetric
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkMetric} SdkMetric
     */ SdkMetric.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkMetric) return object;
        var message = new $31e083413a0a3833$var$$root.SdkMetric();
        switch(object.type){
            default:
                if (typeof object.type === "number") {
                    message.type = object.type;
                    break;
                }
                break;
            case "VIDEO_ACTUAL_ENCODER_BITRATE":
            case 1:
                message.type = 1;
                break;
            case "VIDEO_AVAILABLE_SEND_BANDWIDTH":
            case 2:
                message.type = 2;
                break;
            case "VIDEO_RETRANSMIT_BITRATE":
            case 3:
                message.type = 3;
                break;
            case "VIDEO_AVAILABLE_RECEIVE_BANDWIDTH":
            case 4:
                message.type = 4;
                break;
            case "VIDEO_TARGET_ENCODER_BITRATE":
            case 5:
                message.type = 5;
                break;
            case "VIDEO_BUCKET_DELAY_MS":
            case 6:
                message.type = 6;
                break;
            case "STUN_RTT_MS":
            case 7:
                message.type = 7;
                break;
            case "SOCKET_DISCARDED_PPS":
            case 8:
                message.type = 8;
                break;
            case "RTC_MIC_JITTER_MS":
            case 9:
                message.type = 9;
                break;
            case "RTC_MIC_PPS":
            case 10:
                message.type = 10;
                break;
            case "RTC_MIC_FRACTION_PACKET_LOST_PERCENT":
            case 11:
                message.type = 11;
                break;
            case "RTC_MIC_BITRATE":
            case 12:
                message.type = 12;
                break;
            case "RTC_MIC_RTT_MS":
            case 13:
                message.type = 13;
                break;
            case "RTC_SPK_PPS":
            case 14:
                message.type = 14;
                break;
            case "RTC_SPK_FRACTION_PACKET_LOST_PERCENT":
            case 15:
                message.type = 15;
                break;
            case "RTC_SPK_JITTER_MS":
            case 16:
                message.type = 16;
                break;
            case "RTC_SPK_FRACTION_DECODER_LOSS_PERCENT":
            case 17:
                message.type = 17;
                break;
            case "RTC_SPK_BITRATE":
            case 18:
                message.type = 18;
                break;
            case "RTC_SPK_CURRENT_DELAY_MS":
            case 19:
                message.type = 19;
                break;
            case "RTC_SPK_JITTER_BUFFER_MS":
            case 20:
                message.type = 20;
                break;
            case "VIDEO_SENT_RTT_MS":
            case 21:
                message.type = 21;
                break;
            case "VIDEO_ENCODE_USAGE_PERCENT":
            case 22:
                message.type = 22;
                break;
            case "VIDEO_NACKS_RECEIVED":
            case 23:
                message.type = 23;
                break;
            case "VIDEO_PLIS_RECEIVED":
            case 24:
                message.type = 24;
                break;
            case "VIDEO_ENCODE_MS":
            case 25:
                message.type = 25;
                break;
            case "VIDEO_INPUT_FPS":
            case 26:
                message.type = 26;
                break;
            case "VIDEO_ENCODE_FPS":
            case 27:
                message.type = 27;
                break;
            case "VIDEO_SENT_FPS":
            case 28:
                message.type = 28;
                break;
            case "VIDEO_FIRS_RECEIVED":
            case 29:
                message.type = 29;
                break;
            case "VIDEO_SENT_PPS":
            case 30:
                message.type = 30;
                break;
            case "VIDEO_SENT_FRACTION_PACKET_LOST_PERCENT":
            case 31:
                message.type = 31;
                break;
            case "VIDEO_SENT_BITRATE":
            case 32:
                message.type = 32;
                break;
            case "VIDEO_DROPPED_FPS":
            case 33:
                message.type = 33;
                break;
            case "VIDEO_TARGET_DELAY_MS":
            case 34:
                message.type = 34;
                break;
            case "VIDEO_DECODE_MS":
            case 35:
                message.type = 35;
                break;
            case "VIDEO_OUTPUT_FPS":
            case 36:
                message.type = 36;
                break;
            case "VIDEO_RECEIVED_PPS":
            case 37:
                message.type = 37;
                break;
            case "VIDEO_RECEIVED_FRACTION_PACKET_LOST_PERCENT":
            case 38:
                message.type = 38;
                break;
            case "VIDEO_RENDER_DELAY_MS":
            case 39:
                message.type = 39;
                break;
            case "VIDEO_RECEIVED_FPS":
            case 40:
                message.type = 40;
                break;
            case "VIDEO_DECODE_FPS":
            case 41:
                message.type = 41;
                break;
            case "VIDEO_NACKS_SENT":
            case 42:
                message.type = 42;
                break;
            case "VIDEO_FIRS_SENT":
            case 43:
                message.type = 43;
                break;
            case "VIDEO_RECEIVED_BITRATE":
            case 44:
                message.type = 44;
                break;
            case "VIDEO_CURRENT_DELAY_MS":
            case 45:
                message.type = 45;
                break;
            case "VIDEO_JITTER_BUFFER_MS":
            case 46:
                message.type = 46;
                break;
            case "VIDEO_DISCARDED_PPS":
            case 47:
                message.type = 47;
                break;
            case "VIDEO_PLIS_SENT":
            case 48:
                message.type = 48;
                break;
            case "VIDEO_RECEIVED_JITTER_MS":
            case 49:
                message.type = 49;
                break;
            case "VIDEO_LOCAL_RENDER_FPS":
            case 52:
                message.type = 52;
                break;
            case "VIDEO_REMOTE_RENDER_FPS":
            case 56:
                message.type = 56;
                break;
            case "VIDEO_INPUT_HEIGHT":
            case 60:
                message.type = 60;
                break;
            case "VIDEO_ENCODE_HEIGHT":
            case 64:
                message.type = 64;
                break;
            case "VIDEO_SENT_QP_SUM":
            case 66:
                message.type = 66;
                break;
            case "VIDEO_DECODE_HEIGHT":
            case 69:
                message.type = 69;
                break;
            case "VIDEO_RECEIVED_QP_SUM":
            case 72:
                message.type = 72;
                break;
            case "VIDEO_ENCODE_WIDTH":
            case 86:
                message.type = 86;
                break;
            case "VIDEO_DECODE_WIDTH":
            case 87:
                message.type = 87;
                break;
            case "VIDEO_ENCODER_IS_HARDWARE":
            case 88:
                message.type = 88;
                break;
            case "VIDEO_DECODER_IS_HARDWARE":
            case 89:
                message.type = 89;
                break;
            case "VIDEO_FREEZE_COUNT":
            case 90:
                message.type = 90;
                break;
            case "VIDEO_FREEZE_DURATION":
            case 91:
                message.type = 91;
                break;
            case "VIDEO_PAUSE_COUNT":
            case 92:
                message.type = 92;
                break;
            case "VIDEO_PAUSE_DURATION":
            case 93:
                message.type = 93;
                break;
            case "VIDEO_QUALITY_REASON":
            case 94:
                message.type = 94;
                break;
            case "VIDEO_PROCESSING_TIME":
            case 95:
                message.type = 95;
                break;
            case "RTC_SPK_AUDIO_LEVEL":
            case 96:
                message.type = 96;
                break;
            case "RTC_MIC_AUDIO_LEVEL":
            case 97:
                message.type = 97;
                break;
            case "RTC_SPK_TOTAL_LOST":
            case 98:
                message.type = 98;
                break;
            case "RTC_SPK_TOTAL_EXPECTED":
            case 99:
                message.type = 99;
                break;
            case "RTC_SPK_TOTAL_RECOVERED_RED":
            case 100:
                message.type = 100;
                break;
            case "RTC_SPK_TOTAL_RECOVERED_FEC":
            case 101:
                message.type = 101;
                break;
            case "VIDEO_QUALITY_LIMITATION_DURATION_CPU":
            case 102:
                message.type = 102;
                break;
            case "VIDEO_CODEC_DEGRADATION_HIGH_ENCODE_CPU":
            case 103:
                message.type = 103;
                break;
            case "VIDEO_CODEC_DEGRADATION_ENCODE_FAILURE":
            case 104:
                message.type = 104;
                break;
            case "VIDEO_RENDER_HEIGHT":
            case 105:
                message.type = 105;
                break;
            case "VIDEO_RENDER_WIDTH":
            case 106:
                message.type = 106;
                break;
            case "VIDEO_INPUT_WIDTH":
            case 107:
                message.type = 107;
                break;
            case "VIDEO_SENT_JITTER_MS":
            case 108:
                message.type = 108;
                break;
            case "AUDIO_SENT_TRANSFORM_PPS":
            case 109:
                message.type = 109;
                break;
            case "AUDIO_RECEIVED_TRANSFORM_PPS":
            case 110:
                message.type = 110;
                break;
            case "VIDEO_SENT_TRANSFORM_PPS":
            case 111:
                message.type = 111;
                break;
            case "VIDEO_RECEIVED_TRANSFORM_PPS":
            case 112:
                message.type = 112;
                break;
        }
        if (object.value != null) message.value = Number(object.value);
        return message;
    };
    /**
     * Creates a plain object from a SdkMetric message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkMetric
     * @static
     * @param {SdkMetric} message SdkMetric
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkMetric.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "VIDEO_ACTUAL_ENCODER_BITRATE" : 1;
            object.value = 0;
        }
        if (message.type != null && message.hasOwnProperty("type")) object.type = options.enums === String ? $31e083413a0a3833$var$$root.SdkMetric.Type[message.type] === undefined ? message.type : $31e083413a0a3833$var$$root.SdkMetric.Type[message.type] : message.type;
        if (message.value != null && message.hasOwnProperty("value")) object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
        return object;
    };
    /**
     * Converts this SdkMetric to JSON.
     * @function toJSON
     * @memberof SdkMetric
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkMetric.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkMetric
     * @function getTypeUrl
     * @memberof SdkMetric
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkMetric.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkMetric";
    };
    /**
     * Type enum.
     * @name SdkMetric.Type
     * @enum {number}
     * @property {number} VIDEO_ACTUAL_ENCODER_BITRATE=1 VIDEO_ACTUAL_ENCODER_BITRATE value
     * @property {number} VIDEO_AVAILABLE_SEND_BANDWIDTH=2 VIDEO_AVAILABLE_SEND_BANDWIDTH value
     * @property {number} VIDEO_RETRANSMIT_BITRATE=3 VIDEO_RETRANSMIT_BITRATE value
     * @property {number} VIDEO_AVAILABLE_RECEIVE_BANDWIDTH=4 VIDEO_AVAILABLE_RECEIVE_BANDWIDTH value
     * @property {number} VIDEO_TARGET_ENCODER_BITRATE=5 VIDEO_TARGET_ENCODER_BITRATE value
     * @property {number} VIDEO_BUCKET_DELAY_MS=6 VIDEO_BUCKET_DELAY_MS value
     * @property {number} STUN_RTT_MS=7 STUN_RTT_MS value
     * @property {number} SOCKET_DISCARDED_PPS=8 SOCKET_DISCARDED_PPS value
     * @property {number} RTC_MIC_JITTER_MS=9 RTC_MIC_JITTER_MS value
     * @property {number} RTC_MIC_PPS=10 RTC_MIC_PPS value
     * @property {number} RTC_MIC_FRACTION_PACKET_LOST_PERCENT=11 RTC_MIC_FRACTION_PACKET_LOST_PERCENT value
     * @property {number} RTC_MIC_BITRATE=12 RTC_MIC_BITRATE value
     * @property {number} RTC_MIC_RTT_MS=13 RTC_MIC_RTT_MS value
     * @property {number} RTC_SPK_PPS=14 RTC_SPK_PPS value
     * @property {number} RTC_SPK_FRACTION_PACKET_LOST_PERCENT=15 RTC_SPK_FRACTION_PACKET_LOST_PERCENT value
     * @property {number} RTC_SPK_JITTER_MS=16 RTC_SPK_JITTER_MS value
     * @property {number} RTC_SPK_FRACTION_DECODER_LOSS_PERCENT=17 RTC_SPK_FRACTION_DECODER_LOSS_PERCENT value
     * @property {number} RTC_SPK_BITRATE=18 RTC_SPK_BITRATE value
     * @property {number} RTC_SPK_CURRENT_DELAY_MS=19 RTC_SPK_CURRENT_DELAY_MS value
     * @property {number} RTC_SPK_JITTER_BUFFER_MS=20 RTC_SPK_JITTER_BUFFER_MS value
     * @property {number} VIDEO_SENT_RTT_MS=21 VIDEO_SENT_RTT_MS value
     * @property {number} VIDEO_ENCODE_USAGE_PERCENT=22 VIDEO_ENCODE_USAGE_PERCENT value
     * @property {number} VIDEO_NACKS_RECEIVED=23 VIDEO_NACKS_RECEIVED value
     * @property {number} VIDEO_PLIS_RECEIVED=24 VIDEO_PLIS_RECEIVED value
     * @property {number} VIDEO_ENCODE_MS=25 VIDEO_ENCODE_MS value
     * @property {number} VIDEO_INPUT_FPS=26 VIDEO_INPUT_FPS value
     * @property {number} VIDEO_ENCODE_FPS=27 VIDEO_ENCODE_FPS value
     * @property {number} VIDEO_SENT_FPS=28 VIDEO_SENT_FPS value
     * @property {number} VIDEO_FIRS_RECEIVED=29 VIDEO_FIRS_RECEIVED value
     * @property {number} VIDEO_SENT_PPS=30 VIDEO_SENT_PPS value
     * @property {number} VIDEO_SENT_FRACTION_PACKET_LOST_PERCENT=31 VIDEO_SENT_FRACTION_PACKET_LOST_PERCENT value
     * @property {number} VIDEO_SENT_BITRATE=32 VIDEO_SENT_BITRATE value
     * @property {number} VIDEO_DROPPED_FPS=33 VIDEO_DROPPED_FPS value
     * @property {number} VIDEO_TARGET_DELAY_MS=34 VIDEO_TARGET_DELAY_MS value
     * @property {number} VIDEO_DECODE_MS=35 VIDEO_DECODE_MS value
     * @property {number} VIDEO_OUTPUT_FPS=36 VIDEO_OUTPUT_FPS value
     * @property {number} VIDEO_RECEIVED_PPS=37 VIDEO_RECEIVED_PPS value
     * @property {number} VIDEO_RECEIVED_FRACTION_PACKET_LOST_PERCENT=38 VIDEO_RECEIVED_FRACTION_PACKET_LOST_PERCENT value
     * @property {number} VIDEO_RENDER_DELAY_MS=39 VIDEO_RENDER_DELAY_MS value
     * @property {number} VIDEO_RECEIVED_FPS=40 VIDEO_RECEIVED_FPS value
     * @property {number} VIDEO_DECODE_FPS=41 VIDEO_DECODE_FPS value
     * @property {number} VIDEO_NACKS_SENT=42 VIDEO_NACKS_SENT value
     * @property {number} VIDEO_FIRS_SENT=43 VIDEO_FIRS_SENT value
     * @property {number} VIDEO_RECEIVED_BITRATE=44 VIDEO_RECEIVED_BITRATE value
     * @property {number} VIDEO_CURRENT_DELAY_MS=45 VIDEO_CURRENT_DELAY_MS value
     * @property {number} VIDEO_JITTER_BUFFER_MS=46 VIDEO_JITTER_BUFFER_MS value
     * @property {number} VIDEO_DISCARDED_PPS=47 VIDEO_DISCARDED_PPS value
     * @property {number} VIDEO_PLIS_SENT=48 VIDEO_PLIS_SENT value
     * @property {number} VIDEO_RECEIVED_JITTER_MS=49 VIDEO_RECEIVED_JITTER_MS value
     * @property {number} VIDEO_LOCAL_RENDER_FPS=52 VIDEO_LOCAL_RENDER_FPS value
     * @property {number} VIDEO_REMOTE_RENDER_FPS=56 VIDEO_REMOTE_RENDER_FPS value
     * @property {number} VIDEO_INPUT_HEIGHT=60 VIDEO_INPUT_HEIGHT value
     * @property {number} VIDEO_ENCODE_HEIGHT=64 VIDEO_ENCODE_HEIGHT value
     * @property {number} VIDEO_SENT_QP_SUM=66 VIDEO_SENT_QP_SUM value
     * @property {number} VIDEO_DECODE_HEIGHT=69 VIDEO_DECODE_HEIGHT value
     * @property {number} VIDEO_RECEIVED_QP_SUM=72 VIDEO_RECEIVED_QP_SUM value
     * @property {number} VIDEO_ENCODE_WIDTH=86 VIDEO_ENCODE_WIDTH value
     * @property {number} VIDEO_DECODE_WIDTH=87 VIDEO_DECODE_WIDTH value
     * @property {number} VIDEO_ENCODER_IS_HARDWARE=88 VIDEO_ENCODER_IS_HARDWARE value
     * @property {number} VIDEO_DECODER_IS_HARDWARE=89 VIDEO_DECODER_IS_HARDWARE value
     * @property {number} VIDEO_FREEZE_COUNT=90 VIDEO_FREEZE_COUNT value
     * @property {number} VIDEO_FREEZE_DURATION=91 VIDEO_FREEZE_DURATION value
     * @property {number} VIDEO_PAUSE_COUNT=92 VIDEO_PAUSE_COUNT value
     * @property {number} VIDEO_PAUSE_DURATION=93 VIDEO_PAUSE_DURATION value
     * @property {number} VIDEO_QUALITY_REASON=94 VIDEO_QUALITY_REASON value
     * @property {number} VIDEO_PROCESSING_TIME=95 VIDEO_PROCESSING_TIME value
     * @property {number} RTC_SPK_AUDIO_LEVEL=96 RTC_SPK_AUDIO_LEVEL value
     * @property {number} RTC_MIC_AUDIO_LEVEL=97 RTC_MIC_AUDIO_LEVEL value
     * @property {number} RTC_SPK_TOTAL_LOST=98 RTC_SPK_TOTAL_LOST value
     * @property {number} RTC_SPK_TOTAL_EXPECTED=99 RTC_SPK_TOTAL_EXPECTED value
     * @property {number} RTC_SPK_TOTAL_RECOVERED_RED=100 RTC_SPK_TOTAL_RECOVERED_RED value
     * @property {number} RTC_SPK_TOTAL_RECOVERED_FEC=101 RTC_SPK_TOTAL_RECOVERED_FEC value
     * @property {number} VIDEO_QUALITY_LIMITATION_DURATION_CPU=102 VIDEO_QUALITY_LIMITATION_DURATION_CPU value
     * @property {number} VIDEO_CODEC_DEGRADATION_HIGH_ENCODE_CPU=103 VIDEO_CODEC_DEGRADATION_HIGH_ENCODE_CPU value
     * @property {number} VIDEO_CODEC_DEGRADATION_ENCODE_FAILURE=104 VIDEO_CODEC_DEGRADATION_ENCODE_FAILURE value
     * @property {number} VIDEO_RENDER_HEIGHT=105 VIDEO_RENDER_HEIGHT value
     * @property {number} VIDEO_RENDER_WIDTH=106 VIDEO_RENDER_WIDTH value
     * @property {number} VIDEO_INPUT_WIDTH=107 VIDEO_INPUT_WIDTH value
     * @property {number} VIDEO_SENT_JITTER_MS=108 VIDEO_SENT_JITTER_MS value
     * @property {number} AUDIO_SENT_TRANSFORM_PPS=109 AUDIO_SENT_TRANSFORM_PPS value
     * @property {number} AUDIO_RECEIVED_TRANSFORM_PPS=110 AUDIO_RECEIVED_TRANSFORM_PPS value
     * @property {number} VIDEO_SENT_TRANSFORM_PPS=111 VIDEO_SENT_TRANSFORM_PPS value
     * @property {number} VIDEO_RECEIVED_TRANSFORM_PPS=112 VIDEO_RECEIVED_TRANSFORM_PPS value
     */ SdkMetric.Type = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "VIDEO_ACTUAL_ENCODER_BITRATE"] = 1;
        values[valuesById[2] = "VIDEO_AVAILABLE_SEND_BANDWIDTH"] = 2;
        values[valuesById[3] = "VIDEO_RETRANSMIT_BITRATE"] = 3;
        values[valuesById[4] = "VIDEO_AVAILABLE_RECEIVE_BANDWIDTH"] = 4;
        values[valuesById[5] = "VIDEO_TARGET_ENCODER_BITRATE"] = 5;
        values[valuesById[6] = "VIDEO_BUCKET_DELAY_MS"] = 6;
        values[valuesById[7] = "STUN_RTT_MS"] = 7;
        values[valuesById[8] = "SOCKET_DISCARDED_PPS"] = 8;
        values[valuesById[9] = "RTC_MIC_JITTER_MS"] = 9;
        values[valuesById[10] = "RTC_MIC_PPS"] = 10;
        values[valuesById[11] = "RTC_MIC_FRACTION_PACKET_LOST_PERCENT"] = 11;
        values[valuesById[12] = "RTC_MIC_BITRATE"] = 12;
        values[valuesById[13] = "RTC_MIC_RTT_MS"] = 13;
        values[valuesById[14] = "RTC_SPK_PPS"] = 14;
        values[valuesById[15] = "RTC_SPK_FRACTION_PACKET_LOST_PERCENT"] = 15;
        values[valuesById[16] = "RTC_SPK_JITTER_MS"] = 16;
        values[valuesById[17] = "RTC_SPK_FRACTION_DECODER_LOSS_PERCENT"] = 17;
        values[valuesById[18] = "RTC_SPK_BITRATE"] = 18;
        values[valuesById[19] = "RTC_SPK_CURRENT_DELAY_MS"] = 19;
        values[valuesById[20] = "RTC_SPK_JITTER_BUFFER_MS"] = 20;
        values[valuesById[21] = "VIDEO_SENT_RTT_MS"] = 21;
        values[valuesById[22] = "VIDEO_ENCODE_USAGE_PERCENT"] = 22;
        values[valuesById[23] = "VIDEO_NACKS_RECEIVED"] = 23;
        values[valuesById[24] = "VIDEO_PLIS_RECEIVED"] = 24;
        values[valuesById[25] = "VIDEO_ENCODE_MS"] = 25;
        values[valuesById[26] = "VIDEO_INPUT_FPS"] = 26;
        values[valuesById[27] = "VIDEO_ENCODE_FPS"] = 27;
        values[valuesById[28] = "VIDEO_SENT_FPS"] = 28;
        values[valuesById[29] = "VIDEO_FIRS_RECEIVED"] = 29;
        values[valuesById[30] = "VIDEO_SENT_PPS"] = 30;
        values[valuesById[31] = "VIDEO_SENT_FRACTION_PACKET_LOST_PERCENT"] = 31;
        values[valuesById[32] = "VIDEO_SENT_BITRATE"] = 32;
        values[valuesById[33] = "VIDEO_DROPPED_FPS"] = 33;
        values[valuesById[34] = "VIDEO_TARGET_DELAY_MS"] = 34;
        values[valuesById[35] = "VIDEO_DECODE_MS"] = 35;
        values[valuesById[36] = "VIDEO_OUTPUT_FPS"] = 36;
        values[valuesById[37] = "VIDEO_RECEIVED_PPS"] = 37;
        values[valuesById[38] = "VIDEO_RECEIVED_FRACTION_PACKET_LOST_PERCENT"] = 38;
        values[valuesById[39] = "VIDEO_RENDER_DELAY_MS"] = 39;
        values[valuesById[40] = "VIDEO_RECEIVED_FPS"] = 40;
        values[valuesById[41] = "VIDEO_DECODE_FPS"] = 41;
        values[valuesById[42] = "VIDEO_NACKS_SENT"] = 42;
        values[valuesById[43] = "VIDEO_FIRS_SENT"] = 43;
        values[valuesById[44] = "VIDEO_RECEIVED_BITRATE"] = 44;
        values[valuesById[45] = "VIDEO_CURRENT_DELAY_MS"] = 45;
        values[valuesById[46] = "VIDEO_JITTER_BUFFER_MS"] = 46;
        values[valuesById[47] = "VIDEO_DISCARDED_PPS"] = 47;
        values[valuesById[48] = "VIDEO_PLIS_SENT"] = 48;
        values[valuesById[49] = "VIDEO_RECEIVED_JITTER_MS"] = 49;
        values[valuesById[52] = "VIDEO_LOCAL_RENDER_FPS"] = 52;
        values[valuesById[56] = "VIDEO_REMOTE_RENDER_FPS"] = 56;
        values[valuesById[60] = "VIDEO_INPUT_HEIGHT"] = 60;
        values[valuesById[64] = "VIDEO_ENCODE_HEIGHT"] = 64;
        values[valuesById[66] = "VIDEO_SENT_QP_SUM"] = 66;
        values[valuesById[69] = "VIDEO_DECODE_HEIGHT"] = 69;
        values[valuesById[72] = "VIDEO_RECEIVED_QP_SUM"] = 72;
        values[valuesById[86] = "VIDEO_ENCODE_WIDTH"] = 86;
        values[valuesById[87] = "VIDEO_DECODE_WIDTH"] = 87;
        values[valuesById[88] = "VIDEO_ENCODER_IS_HARDWARE"] = 88;
        values[valuesById[89] = "VIDEO_DECODER_IS_HARDWARE"] = 89;
        values[valuesById[90] = "VIDEO_FREEZE_COUNT"] = 90;
        values[valuesById[91] = "VIDEO_FREEZE_DURATION"] = 91;
        values[valuesById[92] = "VIDEO_PAUSE_COUNT"] = 92;
        values[valuesById[93] = "VIDEO_PAUSE_DURATION"] = 93;
        values[valuesById[94] = "VIDEO_QUALITY_REASON"] = 94;
        values[valuesById[95] = "VIDEO_PROCESSING_TIME"] = 95;
        values[valuesById[96] = "RTC_SPK_AUDIO_LEVEL"] = 96;
        values[valuesById[97] = "RTC_MIC_AUDIO_LEVEL"] = 97;
        values[valuesById[98] = "RTC_SPK_TOTAL_LOST"] = 98;
        values[valuesById[99] = "RTC_SPK_TOTAL_EXPECTED"] = 99;
        values[valuesById[100] = "RTC_SPK_TOTAL_RECOVERED_RED"] = 100;
        values[valuesById[101] = "RTC_SPK_TOTAL_RECOVERED_FEC"] = 101;
        values[valuesById[102] = "VIDEO_QUALITY_LIMITATION_DURATION_CPU"] = 102;
        values[valuesById[103] = "VIDEO_CODEC_DEGRADATION_HIGH_ENCODE_CPU"] = 103;
        values[valuesById[104] = "VIDEO_CODEC_DEGRADATION_ENCODE_FAILURE"] = 104;
        values[valuesById[105] = "VIDEO_RENDER_HEIGHT"] = 105;
        values[valuesById[106] = "VIDEO_RENDER_WIDTH"] = 106;
        values[valuesById[107] = "VIDEO_INPUT_WIDTH"] = 107;
        values[valuesById[108] = "VIDEO_SENT_JITTER_MS"] = 108;
        values[valuesById[109] = "AUDIO_SENT_TRANSFORM_PPS"] = 109;
        values[valuesById[110] = "AUDIO_RECEIVED_TRANSFORM_PPS"] = 110;
        values[valuesById[111] = "VIDEO_SENT_TRANSFORM_PPS"] = 111;
        values[valuesById[112] = "VIDEO_RECEIVED_TRANSFORM_PPS"] = 112;
        return values;
    }();
    return SdkMetric;
}();
$31e083413a0a3833$var$$root.SdkStreamMetricFrame = function() {
    /**
     * Properties of a SdkStreamMetricFrame.
     * @name ISdkStreamMetricFrame
     * @interface ISdkStreamMetricFrame
     * @property {number|null} [streamId] SdkStreamMetricFrame streamId
     * @property {number|null} [groupId] SdkStreamMetricFrame groupId
     * @property {Array.<ISdkMetric>|null} [metrics] SdkStreamMetricFrame metrics
     * @property {Array.<ISdkStreamDimension>|null} [dimensions] SdkStreamMetricFrame dimensions
     * @property {SdkStreamMediaType|null} [mediaType] SdkStreamMetricFrame mediaType
     */ /**
     * Constructs a new SdkStreamMetricFrame.
     * @name SdkStreamMetricFrame
     * @classdesc Represents a SdkStreamMetricFrame.
     * @implements ISdkStreamMetricFrame
     * @constructor
     * @param {ISdkStreamMetricFrame=} [properties] Properties to set
     */ function SdkStreamMetricFrame(properties) {
        this.metrics = [];
        this.dimensions = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkStreamMetricFrame streamId.
     * @member {number} streamId
     * @memberof SdkStreamMetricFrame
     * @instance
     */ SdkStreamMetricFrame.prototype.streamId = 0;
    /**
     * SdkStreamMetricFrame groupId.
     * @member {number} groupId
     * @memberof SdkStreamMetricFrame
     * @instance
     */ SdkStreamMetricFrame.prototype.groupId = 0;
    /**
     * SdkStreamMetricFrame metrics.
     * @member {Array.<ISdkMetric>} metrics
     * @memberof SdkStreamMetricFrame
     * @instance
     */ SdkStreamMetricFrame.prototype.metrics = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkStreamMetricFrame dimensions.
     * @member {Array.<ISdkStreamDimension>} dimensions
     * @memberof SdkStreamMetricFrame
     * @instance
     */ SdkStreamMetricFrame.prototype.dimensions = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkStreamMetricFrame mediaType.
     * @member {SdkStreamMediaType} mediaType
     * @memberof SdkStreamMetricFrame
     * @instance
     */ SdkStreamMetricFrame.prototype.mediaType = 1;
    /**
     * Creates a new SdkStreamMetricFrame instance using the specified properties.
     * @function create
     * @memberof SdkStreamMetricFrame
     * @static
     * @param {ISdkStreamMetricFrame=} [properties] Properties to set
     * @returns {SdkStreamMetricFrame} SdkStreamMetricFrame instance
     */ SdkStreamMetricFrame.create = function create(properties) {
        return new SdkStreamMetricFrame(properties);
    };
    /**
     * Encodes the specified SdkStreamMetricFrame message. Does not implicitly {@link SdkStreamMetricFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkStreamMetricFrame
     * @static
     * @param {ISdkStreamMetricFrame} message SdkStreamMetricFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkStreamMetricFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.streamId != null && Object.hasOwnProperty.call(message, "streamId")) writer.uint32(/* id 3, wireType 0 =*/ 24).uint32(message.streamId);
        if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId")) writer.uint32(/* id 4, wireType 0 =*/ 32).uint32(message.groupId);
        if (message.metrics != null && message.metrics.length) for(var i = 0; i < message.metrics.length; ++i)$31e083413a0a3833$var$$root.SdkMetric.encode(message.metrics[i], writer.uint32(/* id 5, wireType 2 =*/ 42).fork()).ldelim();
        if (message.dimensions != null && message.dimensions.length) for(var i = 0; i < message.dimensions.length; ++i)$31e083413a0a3833$var$$root.SdkStreamDimension.encode(message.dimensions[i], writer.uint32(/* id 6, wireType 2 =*/ 50).fork()).ldelim();
        if (message.mediaType != null && Object.hasOwnProperty.call(message, "mediaType")) writer.uint32(/* id 7, wireType 0 =*/ 56).int32(message.mediaType);
        return writer;
    };
    /**
     * Encodes the specified SdkStreamMetricFrame message, length delimited. Does not implicitly {@link SdkStreamMetricFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkStreamMetricFrame
     * @static
     * @param {ISdkStreamMetricFrame} message SdkStreamMetricFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkStreamMetricFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkStreamMetricFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkStreamMetricFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkStreamMetricFrame} SdkStreamMetricFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkStreamMetricFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkStreamMetricFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 3:
                    message.streamId = reader.uint32();
                    break;
                case 4:
                    message.groupId = reader.uint32();
                    break;
                case 5:
                    if (!(message.metrics && message.metrics.length)) message.metrics = [];
                    message.metrics.push($31e083413a0a3833$var$$root.SdkMetric.decode(reader, reader.uint32()));
                    break;
                case 6:
                    if (!(message.dimensions && message.dimensions.length)) message.dimensions = [];
                    message.dimensions.push($31e083413a0a3833$var$$root.SdkStreamDimension.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.mediaType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkStreamMetricFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkStreamMetricFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkStreamMetricFrame} SdkStreamMetricFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkStreamMetricFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkStreamMetricFrame message.
     * @function verify
     * @memberof SdkStreamMetricFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkStreamMetricFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.streamId != null && message.hasOwnProperty("streamId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.streamId)) return "streamId: integer expected";
        }
        if (message.groupId != null && message.hasOwnProperty("groupId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.groupId)) return "groupId: integer expected";
        }
        if (message.metrics != null && message.hasOwnProperty("metrics")) {
            if (!Array.isArray(message.metrics)) return "metrics: array expected";
            for(var i = 0; i < message.metrics.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkMetric.verify(message.metrics[i]);
                if (error) return "metrics." + error;
            }
        }
        if (message.dimensions != null && message.hasOwnProperty("dimensions")) {
            if (!Array.isArray(message.dimensions)) return "dimensions: array expected";
            for(var i = 0; i < message.dimensions.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkStreamDimension.verify(message.dimensions[i]);
                if (error) return "dimensions." + error;
            }
        }
        if (message.mediaType != null && message.hasOwnProperty("mediaType")) switch(message.mediaType){
            default:
                return "mediaType: enum value expected";
            case 1:
            case 2:
                break;
        }
        return null;
    };
    /**
     * Creates a SdkStreamMetricFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkStreamMetricFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkStreamMetricFrame} SdkStreamMetricFrame
     */ SdkStreamMetricFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkStreamMetricFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkStreamMetricFrame();
        if (object.streamId != null) message.streamId = object.streamId >>> 0;
        if (object.groupId != null) message.groupId = object.groupId >>> 0;
        if (object.metrics) {
            if (!Array.isArray(object.metrics)) throw TypeError(".SdkStreamMetricFrame.metrics: array expected");
            message.metrics = [];
            for(var i = 0; i < object.metrics.length; ++i){
                if (typeof object.metrics[i] !== "object") throw TypeError(".SdkStreamMetricFrame.metrics: object expected");
                message.metrics[i] = $31e083413a0a3833$var$$root.SdkMetric.fromObject(object.metrics[i]);
            }
        }
        if (object.dimensions) {
            if (!Array.isArray(object.dimensions)) throw TypeError(".SdkStreamMetricFrame.dimensions: array expected");
            message.dimensions = [];
            for(var i = 0; i < object.dimensions.length; ++i){
                if (typeof object.dimensions[i] !== "object") throw TypeError(".SdkStreamMetricFrame.dimensions: object expected");
                message.dimensions[i] = $31e083413a0a3833$var$$root.SdkStreamDimension.fromObject(object.dimensions[i]);
            }
        }
        switch(object.mediaType){
            default:
                if (typeof object.mediaType === "number") {
                    message.mediaType = object.mediaType;
                    break;
                }
                break;
            case "AUDIO":
            case 1:
                message.mediaType = 1;
                break;
            case "VIDEO":
            case 2:
                message.mediaType = 2;
                break;
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkStreamMetricFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkStreamMetricFrame
     * @static
     * @param {SdkStreamMetricFrame} message SdkStreamMetricFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkStreamMetricFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.metrics = [];
            object.dimensions = [];
        }
        if (options.defaults) {
            object.streamId = 0;
            object.groupId = 0;
            object.mediaType = options.enums === String ? "AUDIO" : 1;
        }
        if (message.streamId != null && message.hasOwnProperty("streamId")) object.streamId = message.streamId;
        if (message.groupId != null && message.hasOwnProperty("groupId")) object.groupId = message.groupId;
        if (message.metrics && message.metrics.length) {
            object.metrics = [];
            for(var j = 0; j < message.metrics.length; ++j)object.metrics[j] = $31e083413a0a3833$var$$root.SdkMetric.toObject(message.metrics[j], options);
        }
        if (message.dimensions && message.dimensions.length) {
            object.dimensions = [];
            for(var j = 0; j < message.dimensions.length; ++j)object.dimensions[j] = $31e083413a0a3833$var$$root.SdkStreamDimension.toObject(message.dimensions[j], options);
        }
        if (message.mediaType != null && message.hasOwnProperty("mediaType")) object.mediaType = options.enums === String ? $31e083413a0a3833$var$$root.SdkStreamMediaType[message.mediaType] === undefined ? message.mediaType : $31e083413a0a3833$var$$root.SdkStreamMediaType[message.mediaType] : message.mediaType;
        return object;
    };
    /**
     * Converts this SdkStreamMetricFrame to JSON.
     * @function toJSON
     * @memberof SdkStreamMetricFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkStreamMetricFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkStreamMetricFrame
     * @function getTypeUrl
     * @memberof SdkStreamMetricFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkStreamMetricFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkStreamMetricFrame";
    };
    return SdkStreamMetricFrame;
}();
$31e083413a0a3833$var$$root.SdkClientMetricFrame = function() {
    /**
     * Properties of a SdkClientMetricFrame.
     * @name ISdkClientMetricFrame
     * @interface ISdkClientMetricFrame
     * @property {Array.<ISdkMetric>|null} [globalMetrics] SdkClientMetricFrame globalMetrics
     * @property {Array.<ISdkStreamMetricFrame>|null} [streamMetricFrames] SdkClientMetricFrame streamMetricFrames
     */ /**
     * Constructs a new SdkClientMetricFrame.
     * @name SdkClientMetricFrame
     * @classdesc Represents a SdkClientMetricFrame.
     * @implements ISdkClientMetricFrame
     * @constructor
     * @param {ISdkClientMetricFrame=} [properties] Properties to set
     */ function SdkClientMetricFrame(properties) {
        this.globalMetrics = [];
        this.streamMetricFrames = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkClientMetricFrame globalMetrics.
     * @member {Array.<ISdkMetric>} globalMetrics
     * @memberof SdkClientMetricFrame
     * @instance
     */ SdkClientMetricFrame.prototype.globalMetrics = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkClientMetricFrame streamMetricFrames.
     * @member {Array.<ISdkStreamMetricFrame>} streamMetricFrames
     * @memberof SdkClientMetricFrame
     * @instance
     */ SdkClientMetricFrame.prototype.streamMetricFrames = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkClientMetricFrame instance using the specified properties.
     * @function create
     * @memberof SdkClientMetricFrame
     * @static
     * @param {ISdkClientMetricFrame=} [properties] Properties to set
     * @returns {SdkClientMetricFrame} SdkClientMetricFrame instance
     */ SdkClientMetricFrame.create = function create(properties) {
        return new SdkClientMetricFrame(properties);
    };
    /**
     * Encodes the specified SdkClientMetricFrame message. Does not implicitly {@link SdkClientMetricFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkClientMetricFrame
     * @static
     * @param {ISdkClientMetricFrame} message SdkClientMetricFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkClientMetricFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.globalMetrics != null && message.globalMetrics.length) for(var i = 0; i < message.globalMetrics.length; ++i)$31e083413a0a3833$var$$root.SdkMetric.encode(message.globalMetrics[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.streamMetricFrames != null && message.streamMetricFrames.length) for(var i = 0; i < message.streamMetricFrames.length; ++i)$31e083413a0a3833$var$$root.SdkStreamMetricFrame.encode(message.streamMetricFrames[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkClientMetricFrame message, length delimited. Does not implicitly {@link SdkClientMetricFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkClientMetricFrame
     * @static
     * @param {ISdkClientMetricFrame} message SdkClientMetricFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkClientMetricFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkClientMetricFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkClientMetricFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkClientMetricFrame} SdkClientMetricFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkClientMetricFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkClientMetricFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (!(message.globalMetrics && message.globalMetrics.length)) message.globalMetrics = [];
                    message.globalMetrics.push($31e083413a0a3833$var$$root.SdkMetric.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.streamMetricFrames && message.streamMetricFrames.length)) message.streamMetricFrames = [];
                    message.streamMetricFrames.push($31e083413a0a3833$var$$root.SdkStreamMetricFrame.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkClientMetricFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkClientMetricFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkClientMetricFrame} SdkClientMetricFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkClientMetricFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkClientMetricFrame message.
     * @function verify
     * @memberof SdkClientMetricFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkClientMetricFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.globalMetrics != null && message.hasOwnProperty("globalMetrics")) {
            if (!Array.isArray(message.globalMetrics)) return "globalMetrics: array expected";
            for(var i = 0; i < message.globalMetrics.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkMetric.verify(message.globalMetrics[i]);
                if (error) return "globalMetrics." + error;
            }
        }
        if (message.streamMetricFrames != null && message.hasOwnProperty("streamMetricFrames")) {
            if (!Array.isArray(message.streamMetricFrames)) return "streamMetricFrames: array expected";
            for(var i = 0; i < message.streamMetricFrames.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkStreamMetricFrame.verify(message.streamMetricFrames[i]);
                if (error) return "streamMetricFrames." + error;
            }
        }
        return null;
    };
    /**
     * Creates a SdkClientMetricFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkClientMetricFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkClientMetricFrame} SdkClientMetricFrame
     */ SdkClientMetricFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkClientMetricFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkClientMetricFrame();
        if (object.globalMetrics) {
            if (!Array.isArray(object.globalMetrics)) throw TypeError(".SdkClientMetricFrame.globalMetrics: array expected");
            message.globalMetrics = [];
            for(var i = 0; i < object.globalMetrics.length; ++i){
                if (typeof object.globalMetrics[i] !== "object") throw TypeError(".SdkClientMetricFrame.globalMetrics: object expected");
                message.globalMetrics[i] = $31e083413a0a3833$var$$root.SdkMetric.fromObject(object.globalMetrics[i]);
            }
        }
        if (object.streamMetricFrames) {
            if (!Array.isArray(object.streamMetricFrames)) throw TypeError(".SdkClientMetricFrame.streamMetricFrames: array expected");
            message.streamMetricFrames = [];
            for(var i = 0; i < object.streamMetricFrames.length; ++i){
                if (typeof object.streamMetricFrames[i] !== "object") throw TypeError(".SdkClientMetricFrame.streamMetricFrames: object expected");
                message.streamMetricFrames[i] = $31e083413a0a3833$var$$root.SdkStreamMetricFrame.fromObject(object.streamMetricFrames[i]);
            }
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkClientMetricFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkClientMetricFrame
     * @static
     * @param {SdkClientMetricFrame} message SdkClientMetricFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkClientMetricFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.globalMetrics = [];
            object.streamMetricFrames = [];
        }
        if (message.globalMetrics && message.globalMetrics.length) {
            object.globalMetrics = [];
            for(var j = 0; j < message.globalMetrics.length; ++j)object.globalMetrics[j] = $31e083413a0a3833$var$$root.SdkMetric.toObject(message.globalMetrics[j], options);
        }
        if (message.streamMetricFrames && message.streamMetricFrames.length) {
            object.streamMetricFrames = [];
            for(var j = 0; j < message.streamMetricFrames.length; ++j)object.streamMetricFrames[j] = $31e083413a0a3833$var$$root.SdkStreamMetricFrame.toObject(message.streamMetricFrames[j], options);
        }
        return object;
    };
    /**
     * Converts this SdkClientMetricFrame to JSON.
     * @function toJSON
     * @memberof SdkClientMetricFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkClientMetricFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkClientMetricFrame
     * @function getTypeUrl
     * @memberof SdkClientMetricFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkClientMetricFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkClientMetricFrame";
    };
    return SdkClientMetricFrame;
}();
$31e083413a0a3833$var$$root.SdkStreamDimension = function() {
    /**
     * Properties of a SdkStreamDimension.
     * @name ISdkStreamDimension
     * @interface ISdkStreamDimension
     * @property {SdkStreamDimension.Type|null} [type] SdkStreamDimension type
     * @property {ISdkDimensionValue|null} [value] SdkStreamDimension value
     */ /**
     * Constructs a new SdkStreamDimension.
     * @name SdkStreamDimension
     * @classdesc Represents a SdkStreamDimension.
     * @implements ISdkStreamDimension
     * @constructor
     * @param {ISdkStreamDimension=} [properties] Properties to set
     */ function SdkStreamDimension(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkStreamDimension type.
     * @member {SdkStreamDimension.Type} type
     * @memberof SdkStreamDimension
     * @instance
     */ SdkStreamDimension.prototype.type = 1;
    /**
     * SdkStreamDimension value.
     * @member {ISdkDimensionValue|null|undefined} value
     * @memberof SdkStreamDimension
     * @instance
     */ SdkStreamDimension.prototype.value = null;
    /**
     * Creates a new SdkStreamDimension instance using the specified properties.
     * @function create
     * @memberof SdkStreamDimension
     * @static
     * @param {ISdkStreamDimension=} [properties] Properties to set
     * @returns {SdkStreamDimension} SdkStreamDimension instance
     */ SdkStreamDimension.create = function create(properties) {
        return new SdkStreamDimension(properties);
    };
    /**
     * Encodes the specified SdkStreamDimension message. Does not implicitly {@link SdkStreamDimension.verify|verify} messages.
     * @function encode
     * @memberof SdkStreamDimension
     * @static
     * @param {ISdkStreamDimension} message SdkStreamDimension message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkStreamDimension.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.type);
        if (message.value != null && Object.hasOwnProperty.call(message, "value")) $31e083413a0a3833$var$$root.SdkDimensionValue.encode(message.value, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkStreamDimension message, length delimited. Does not implicitly {@link SdkStreamDimension.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkStreamDimension
     * @static
     * @param {ISdkStreamDimension} message SdkStreamDimension message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkStreamDimension.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkStreamDimension message from the specified reader or buffer.
     * @function decode
     * @memberof SdkStreamDimension
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkStreamDimension} SdkStreamDimension
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkStreamDimension.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkStreamDimension();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.value = $31e083413a0a3833$var$$root.SdkDimensionValue.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkStreamDimension message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkStreamDimension
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkStreamDimension} SdkStreamDimension
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkStreamDimension.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkStreamDimension message.
     * @function verify
     * @memberof SdkStreamDimension
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkStreamDimension.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.type != null && message.hasOwnProperty("type")) switch(message.type){
            default:
                return "type: enum value expected";
            case 1:
            case 2:
                break;
        }
        if (message.value != null && message.hasOwnProperty("value")) {
            var error = $31e083413a0a3833$var$$root.SdkDimensionValue.verify(message.value);
            if (error) return "value." + error;
        }
        return null;
    };
    /**
     * Creates a SdkStreamDimension message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkStreamDimension
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkStreamDimension} SdkStreamDimension
     */ SdkStreamDimension.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkStreamDimension) return object;
        var message = new $31e083413a0a3833$var$$root.SdkStreamDimension();
        switch(object.type){
            default:
                if (typeof object.type === "number") {
                    message.type = object.type;
                    break;
                }
                break;
            case "VIDEO_ENCODER_NAME":
            case 1:
                message.type = 1;
                break;
            case "VIDEO_DECODER_NAME":
            case 2:
                message.type = 2;
                break;
        }
        if (object.value != null) {
            if (typeof object.value !== "object") throw TypeError(".SdkStreamDimension.value: object expected");
            message.value = $31e083413a0a3833$var$$root.SdkDimensionValue.fromObject(object.value);
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkStreamDimension message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkStreamDimension
     * @static
     * @param {SdkStreamDimension} message SdkStreamDimension
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkStreamDimension.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "VIDEO_ENCODER_NAME" : 1;
            object.value = null;
        }
        if (message.type != null && message.hasOwnProperty("type")) object.type = options.enums === String ? $31e083413a0a3833$var$$root.SdkStreamDimension.Type[message.type] === undefined ? message.type : $31e083413a0a3833$var$$root.SdkStreamDimension.Type[message.type] : message.type;
        if (message.value != null && message.hasOwnProperty("value")) object.value = $31e083413a0a3833$var$$root.SdkDimensionValue.toObject(message.value, options);
        return object;
    };
    /**
     * Converts this SdkStreamDimension to JSON.
     * @function toJSON
     * @memberof SdkStreamDimension
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkStreamDimension.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkStreamDimension
     * @function getTypeUrl
     * @memberof SdkStreamDimension
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkStreamDimension.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkStreamDimension";
    };
    /**
     * Type enum.
     * @name SdkStreamDimension.Type
     * @enum {number}
     * @property {number} VIDEO_ENCODER_NAME=1 VIDEO_ENCODER_NAME value
     * @property {number} VIDEO_DECODER_NAME=2 VIDEO_DECODER_NAME value
     */ SdkStreamDimension.Type = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "VIDEO_ENCODER_NAME"] = 1;
        values[valuesById[2] = "VIDEO_DECODER_NAME"] = 2;
        return values;
    }();
    return SdkStreamDimension;
}();
$31e083413a0a3833$var$$root.SdkDimensionValue = function() {
    /**
     * Properties of a SdkDimensionValue.
     * @name ISdkDimensionValue
     * @interface ISdkDimensionValue
     * @property {string|null} [stringValue] SdkDimensionValue stringValue
     * @property {boolean|null} [boolValue] SdkDimensionValue boolValue
     * @property {number|Long|null} [uintValue] SdkDimensionValue uintValue
     */ /**
     * Constructs a new SdkDimensionValue.
     * @name SdkDimensionValue
     * @classdesc Represents a SdkDimensionValue.
     * @implements ISdkDimensionValue
     * @constructor
     * @param {ISdkDimensionValue=} [properties] Properties to set
     */ function SdkDimensionValue(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkDimensionValue stringValue.
     * @member {string} stringValue
     * @memberof SdkDimensionValue
     * @instance
     */ SdkDimensionValue.prototype.stringValue = "";
    /**
     * SdkDimensionValue boolValue.
     * @member {boolean} boolValue
     * @memberof SdkDimensionValue
     * @instance
     */ SdkDimensionValue.prototype.boolValue = false;
    /**
     * SdkDimensionValue uintValue.
     * @member {number|Long} uintValue
     * @memberof SdkDimensionValue
     * @instance
     */ SdkDimensionValue.prototype.uintValue = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, true) : 0;
    /**
     * Creates a new SdkDimensionValue instance using the specified properties.
     * @function create
     * @memberof SdkDimensionValue
     * @static
     * @param {ISdkDimensionValue=} [properties] Properties to set
     * @returns {SdkDimensionValue} SdkDimensionValue instance
     */ SdkDimensionValue.create = function create(properties) {
        return new SdkDimensionValue(properties);
    };
    /**
     * Encodes the specified SdkDimensionValue message. Does not implicitly {@link SdkDimensionValue.verify|verify} messages.
     * @function encode
     * @memberof SdkDimensionValue
     * @static
     * @param {ISdkDimensionValue} message SdkDimensionValue message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkDimensionValue.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.stringValue != null && Object.hasOwnProperty.call(message, "stringValue")) writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.stringValue);
        if (message.boolValue != null && Object.hasOwnProperty.call(message, "boolValue")) writer.uint32(/* id 2, wireType 0 =*/ 16).bool(message.boolValue);
        if (message.uintValue != null && Object.hasOwnProperty.call(message, "uintValue")) writer.uint32(/* id 3, wireType 0 =*/ 24).uint64(message.uintValue);
        return writer;
    };
    /**
     * Encodes the specified SdkDimensionValue message, length delimited. Does not implicitly {@link SdkDimensionValue.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkDimensionValue
     * @static
     * @param {ISdkDimensionValue} message SdkDimensionValue message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkDimensionValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkDimensionValue message from the specified reader or buffer.
     * @function decode
     * @memberof SdkDimensionValue
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkDimensionValue} SdkDimensionValue
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkDimensionValue.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkDimensionValue();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.stringValue = reader.string();
                    break;
                case 2:
                    message.boolValue = reader.bool();
                    break;
                case 3:
                    message.uintValue = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkDimensionValue message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkDimensionValue
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkDimensionValue} SdkDimensionValue
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkDimensionValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkDimensionValue message.
     * @function verify
     * @memberof SdkDimensionValue
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkDimensionValue.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
            if (!$31e083413a0a3833$var$$util.isString(message.stringValue)) return "stringValue: string expected";
        }
        if (message.boolValue != null && message.hasOwnProperty("boolValue")) {
            if (typeof message.boolValue !== "boolean") return "boolValue: boolean expected";
        }
        if (message.uintValue != null && message.hasOwnProperty("uintValue")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.uintValue) && !(message.uintValue && $31e083413a0a3833$var$$util.isInteger(message.uintValue.low) && $31e083413a0a3833$var$$util.isInteger(message.uintValue.high))) return "uintValue: integer|Long expected";
        }
        return null;
    };
    /**
     * Creates a SdkDimensionValue message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkDimensionValue
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkDimensionValue} SdkDimensionValue
     */ SdkDimensionValue.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkDimensionValue) return object;
        var message = new $31e083413a0a3833$var$$root.SdkDimensionValue();
        if (object.stringValue != null) message.stringValue = String(object.stringValue);
        if (object.boolValue != null) message.boolValue = Boolean(object.boolValue);
        if (object.uintValue != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.uintValue = $31e083413a0a3833$var$$util.Long.fromValue(object.uintValue)).unsigned = true;
            else if (typeof object.uintValue === "string") message.uintValue = parseInt(object.uintValue, 10);
            else if (typeof object.uintValue === "number") message.uintValue = object.uintValue;
            else if (typeof object.uintValue === "object") message.uintValue = new $31e083413a0a3833$var$$util.LongBits(object.uintValue.low >>> 0, object.uintValue.high >>> 0).toNumber(true);
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkDimensionValue message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkDimensionValue
     * @static
     * @param {SdkDimensionValue} message SdkDimensionValue
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkDimensionValue.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.stringValue = "";
            object.boolValue = false;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, true);
                object.uintValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.uintValue = options.longs === String ? "0" : 0;
        }
        if (message.stringValue != null && message.hasOwnProperty("stringValue")) object.stringValue = message.stringValue;
        if (message.boolValue != null && message.hasOwnProperty("boolValue")) object.boolValue = message.boolValue;
        if (message.uintValue != null && message.hasOwnProperty("uintValue")) {
            if (typeof message.uintValue === "number") object.uintValue = options.longs === String ? String(message.uintValue) : message.uintValue;
            else object.uintValue = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.uintValue) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.uintValue.low >>> 0, message.uintValue.high >>> 0).toNumber(true) : message.uintValue;
        }
        return object;
    };
    /**
     * Converts this SdkDimensionValue to JSON.
     * @function toJSON
     * @memberof SdkDimensionValue
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkDimensionValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkDimensionValue
     * @function getTypeUrl
     * @memberof SdkDimensionValue
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkDimensionValue.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkDimensionValue";
    };
    return SdkDimensionValue;
}();
$31e083413a0a3833$var$$root.SdkDataMessageFrame = function() {
    /**
     * Properties of a SdkDataMessageFrame.
     * @name ISdkDataMessageFrame
     * @interface ISdkDataMessageFrame
     * @property {Array.<ISdkDataMessagePayload>|null} [messages] SdkDataMessageFrame messages
     */ /**
     * Constructs a new SdkDataMessageFrame.
     * @name SdkDataMessageFrame
     * @classdesc Represents a SdkDataMessageFrame.
     * @implements ISdkDataMessageFrame
     * @constructor
     * @param {ISdkDataMessageFrame=} [properties] Properties to set
     */ function SdkDataMessageFrame(properties) {
        this.messages = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkDataMessageFrame messages.
     * @member {Array.<ISdkDataMessagePayload>} messages
     * @memberof SdkDataMessageFrame
     * @instance
     */ SdkDataMessageFrame.prototype.messages = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkDataMessageFrame instance using the specified properties.
     * @function create
     * @memberof SdkDataMessageFrame
     * @static
     * @param {ISdkDataMessageFrame=} [properties] Properties to set
     * @returns {SdkDataMessageFrame} SdkDataMessageFrame instance
     */ SdkDataMessageFrame.create = function create(properties) {
        return new SdkDataMessageFrame(properties);
    };
    /**
     * Encodes the specified SdkDataMessageFrame message. Does not implicitly {@link SdkDataMessageFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkDataMessageFrame
     * @static
     * @param {ISdkDataMessageFrame} message SdkDataMessageFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkDataMessageFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.messages != null && message.messages.length) for(var i = 0; i < message.messages.length; ++i)$31e083413a0a3833$var$$root.SdkDataMessagePayload.encode(message.messages[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkDataMessageFrame message, length delimited. Does not implicitly {@link SdkDataMessageFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkDataMessageFrame
     * @static
     * @param {ISdkDataMessageFrame} message SdkDataMessageFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkDataMessageFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkDataMessageFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkDataMessageFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkDataMessageFrame} SdkDataMessageFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkDataMessageFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkDataMessageFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (!(message.messages && message.messages.length)) message.messages = [];
                    message.messages.push($31e083413a0a3833$var$$root.SdkDataMessagePayload.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkDataMessageFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkDataMessageFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkDataMessageFrame} SdkDataMessageFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkDataMessageFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkDataMessageFrame message.
     * @function verify
     * @memberof SdkDataMessageFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkDataMessageFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.messages != null && message.hasOwnProperty("messages")) {
            if (!Array.isArray(message.messages)) return "messages: array expected";
            for(var i = 0; i < message.messages.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkDataMessagePayload.verify(message.messages[i]);
                if (error) return "messages." + error;
            }
        }
        return null;
    };
    /**
     * Creates a SdkDataMessageFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkDataMessageFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkDataMessageFrame} SdkDataMessageFrame
     */ SdkDataMessageFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkDataMessageFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkDataMessageFrame();
        if (object.messages) {
            if (!Array.isArray(object.messages)) throw TypeError(".SdkDataMessageFrame.messages: array expected");
            message.messages = [];
            for(var i = 0; i < object.messages.length; ++i){
                if (typeof object.messages[i] !== "object") throw TypeError(".SdkDataMessageFrame.messages: object expected");
                message.messages[i] = $31e083413a0a3833$var$$root.SdkDataMessagePayload.fromObject(object.messages[i]);
            }
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkDataMessageFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkDataMessageFrame
     * @static
     * @param {SdkDataMessageFrame} message SdkDataMessageFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkDataMessageFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.messages = [];
        if (message.messages && message.messages.length) {
            object.messages = [];
            for(var j = 0; j < message.messages.length; ++j)object.messages[j] = $31e083413a0a3833$var$$root.SdkDataMessagePayload.toObject(message.messages[j], options);
        }
        return object;
    };
    /**
     * Converts this SdkDataMessageFrame to JSON.
     * @function toJSON
     * @memberof SdkDataMessageFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkDataMessageFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkDataMessageFrame
     * @function getTypeUrl
     * @memberof SdkDataMessageFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkDataMessageFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkDataMessageFrame";
    };
    return SdkDataMessageFrame;
}();
$31e083413a0a3833$var$$root.SdkDataMessagePayload = function() {
    /**
     * Properties of a SdkDataMessagePayload.
     * @name ISdkDataMessagePayload
     * @interface ISdkDataMessagePayload
     * @property {string|null} [topic] SdkDataMessagePayload topic
     * @property {Uint8Array|null} [data] SdkDataMessagePayload data
     * @property {number|null} [lifetimeMs] SdkDataMessagePayload lifetimeMs
     * @property {string|null} [senderAttendeeId] SdkDataMessagePayload senderAttendeeId
     * @property {number|Long|null} [ingestTimeNs] SdkDataMessagePayload ingestTimeNs
     * @property {string|null} [senderExternalUserId] SdkDataMessagePayload senderExternalUserId
     */ /**
     * Constructs a new SdkDataMessagePayload.
     * @name SdkDataMessagePayload
     * @classdesc Represents a SdkDataMessagePayload.
     * @implements ISdkDataMessagePayload
     * @constructor
     * @param {ISdkDataMessagePayload=} [properties] Properties to set
     */ function SdkDataMessagePayload(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkDataMessagePayload topic.
     * @member {string} topic
     * @memberof SdkDataMessagePayload
     * @instance
     */ SdkDataMessagePayload.prototype.topic = "";
    /**
     * SdkDataMessagePayload data.
     * @member {Uint8Array} data
     * @memberof SdkDataMessagePayload
     * @instance
     */ SdkDataMessagePayload.prototype.data = $31e083413a0a3833$var$$util.newBuffer([]);
    /**
     * SdkDataMessagePayload lifetimeMs.
     * @member {number} lifetimeMs
     * @memberof SdkDataMessagePayload
     * @instance
     */ SdkDataMessagePayload.prototype.lifetimeMs = 0;
    /**
     * SdkDataMessagePayload senderAttendeeId.
     * @member {string} senderAttendeeId
     * @memberof SdkDataMessagePayload
     * @instance
     */ SdkDataMessagePayload.prototype.senderAttendeeId = "";
    /**
     * SdkDataMessagePayload ingestTimeNs.
     * @member {number|Long} ingestTimeNs
     * @memberof SdkDataMessagePayload
     * @instance
     */ SdkDataMessagePayload.prototype.ingestTimeNs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkDataMessagePayload senderExternalUserId.
     * @member {string} senderExternalUserId
     * @memberof SdkDataMessagePayload
     * @instance
     */ SdkDataMessagePayload.prototype.senderExternalUserId = "";
    /**
     * Creates a new SdkDataMessagePayload instance using the specified properties.
     * @function create
     * @memberof SdkDataMessagePayload
     * @static
     * @param {ISdkDataMessagePayload=} [properties] Properties to set
     * @returns {SdkDataMessagePayload} SdkDataMessagePayload instance
     */ SdkDataMessagePayload.create = function create(properties) {
        return new SdkDataMessagePayload(properties);
    };
    /**
     * Encodes the specified SdkDataMessagePayload message. Does not implicitly {@link SdkDataMessagePayload.verify|verify} messages.
     * @function encode
     * @memberof SdkDataMessagePayload
     * @static
     * @param {ISdkDataMessagePayload} message SdkDataMessagePayload message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkDataMessagePayload.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.topic != null && Object.hasOwnProperty.call(message, "topic")) writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.topic);
        if (message.data != null && Object.hasOwnProperty.call(message, "data")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.data);
        if (message.lifetimeMs != null && Object.hasOwnProperty.call(message, "lifetimeMs")) writer.uint32(/* id 3, wireType 0 =*/ 24).uint32(message.lifetimeMs);
        if (message.senderAttendeeId != null && Object.hasOwnProperty.call(message, "senderAttendeeId")) writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.senderAttendeeId);
        if (message.ingestTimeNs != null && Object.hasOwnProperty.call(message, "ingestTimeNs")) writer.uint32(/* id 5, wireType 0 =*/ 40).int64(message.ingestTimeNs);
        if (message.senderExternalUserId != null && Object.hasOwnProperty.call(message, "senderExternalUserId")) writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.senderExternalUserId);
        return writer;
    };
    /**
     * Encodes the specified SdkDataMessagePayload message, length delimited. Does not implicitly {@link SdkDataMessagePayload.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkDataMessagePayload
     * @static
     * @param {ISdkDataMessagePayload} message SdkDataMessagePayload message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkDataMessagePayload.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkDataMessagePayload message from the specified reader or buffer.
     * @function decode
     * @memberof SdkDataMessagePayload
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkDataMessagePayload} SdkDataMessagePayload
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkDataMessagePayload.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkDataMessagePayload();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.topic = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.lifetimeMs = reader.uint32();
                    break;
                case 4:
                    message.senderAttendeeId = reader.string();
                    break;
                case 5:
                    message.ingestTimeNs = reader.int64();
                    break;
                case 6:
                    message.senderExternalUserId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkDataMessagePayload message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkDataMessagePayload
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkDataMessagePayload} SdkDataMessagePayload
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkDataMessagePayload.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkDataMessagePayload message.
     * @function verify
     * @memberof SdkDataMessagePayload
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkDataMessagePayload.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.topic != null && message.hasOwnProperty("topic")) {
            if (!$31e083413a0a3833$var$$util.isString(message.topic)) return "topic: string expected";
        }
        if (message.data != null && message.hasOwnProperty("data")) {
            if (!(message.data && typeof message.data.length === "number" || $31e083413a0a3833$var$$util.isString(message.data))) return "data: buffer expected";
        }
        if (message.lifetimeMs != null && message.hasOwnProperty("lifetimeMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.lifetimeMs)) return "lifetimeMs: integer expected";
        }
        if (message.senderAttendeeId != null && message.hasOwnProperty("senderAttendeeId")) {
            if (!$31e083413a0a3833$var$$util.isString(message.senderAttendeeId)) return "senderAttendeeId: string expected";
        }
        if (message.ingestTimeNs != null && message.hasOwnProperty("ingestTimeNs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.ingestTimeNs) && !(message.ingestTimeNs && $31e083413a0a3833$var$$util.isInteger(message.ingestTimeNs.low) && $31e083413a0a3833$var$$util.isInteger(message.ingestTimeNs.high))) return "ingestTimeNs: integer|Long expected";
        }
        if (message.senderExternalUserId != null && message.hasOwnProperty("senderExternalUserId")) {
            if (!$31e083413a0a3833$var$$util.isString(message.senderExternalUserId)) return "senderExternalUserId: string expected";
        }
        return null;
    };
    /**
     * Creates a SdkDataMessagePayload message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkDataMessagePayload
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkDataMessagePayload} SdkDataMessagePayload
     */ SdkDataMessagePayload.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkDataMessagePayload) return object;
        var message = new $31e083413a0a3833$var$$root.SdkDataMessagePayload();
        if (object.topic != null) message.topic = String(object.topic);
        if (object.data != null) {
            if (typeof object.data === "string") $31e083413a0a3833$var$$util.base64.decode(object.data, message.data = $31e083413a0a3833$var$$util.newBuffer($31e083413a0a3833$var$$util.base64.length(object.data)), 0);
            else if (object.data.length >= 0) message.data = object.data;
        }
        if (object.lifetimeMs != null) message.lifetimeMs = object.lifetimeMs >>> 0;
        if (object.senderAttendeeId != null) message.senderAttendeeId = String(object.senderAttendeeId);
        if (object.ingestTimeNs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.ingestTimeNs = $31e083413a0a3833$var$$util.Long.fromValue(object.ingestTimeNs)).unsigned = false;
            else if (typeof object.ingestTimeNs === "string") message.ingestTimeNs = parseInt(object.ingestTimeNs, 10);
            else if (typeof object.ingestTimeNs === "number") message.ingestTimeNs = object.ingestTimeNs;
            else if (typeof object.ingestTimeNs === "object") message.ingestTimeNs = new $31e083413a0a3833$var$$util.LongBits(object.ingestTimeNs.low >>> 0, object.ingestTimeNs.high >>> 0).toNumber();
        }
        if (object.senderExternalUserId != null) message.senderExternalUserId = String(object.senderExternalUserId);
        return message;
    };
    /**
     * Creates a plain object from a SdkDataMessagePayload message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkDataMessagePayload
     * @static
     * @param {SdkDataMessagePayload} message SdkDataMessagePayload
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkDataMessagePayload.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.topic = "";
            if (options.bytes === String) object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array) object.data = $31e083413a0a3833$var$$util.newBuffer(object.data);
            }
            object.lifetimeMs = 0;
            object.senderAttendeeId = "";
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.ingestTimeNs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.ingestTimeNs = options.longs === String ? "0" : 0;
            object.senderExternalUserId = "";
        }
        if (message.topic != null && message.hasOwnProperty("topic")) object.topic = message.topic;
        if (message.data != null && message.hasOwnProperty("data")) object.data = options.bytes === String ? $31e083413a0a3833$var$$util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.lifetimeMs != null && message.hasOwnProperty("lifetimeMs")) object.lifetimeMs = message.lifetimeMs;
        if (message.senderAttendeeId != null && message.hasOwnProperty("senderAttendeeId")) object.senderAttendeeId = message.senderAttendeeId;
        if (message.ingestTimeNs != null && message.hasOwnProperty("ingestTimeNs")) {
            if (typeof message.ingestTimeNs === "number") object.ingestTimeNs = options.longs === String ? String(message.ingestTimeNs) : message.ingestTimeNs;
            else object.ingestTimeNs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.ingestTimeNs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.ingestTimeNs.low >>> 0, message.ingestTimeNs.high >>> 0).toNumber() : message.ingestTimeNs;
        }
        if (message.senderExternalUserId != null && message.hasOwnProperty("senderExternalUserId")) object.senderExternalUserId = message.senderExternalUserId;
        return object;
    };
    /**
     * Converts this SdkDataMessagePayload to JSON.
     * @function toJSON
     * @memberof SdkDataMessagePayload
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkDataMessagePayload.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkDataMessagePayload
     * @function getTypeUrl
     * @memberof SdkDataMessagePayload
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkDataMessagePayload.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkDataMessagePayload";
    };
    return SdkDataMessagePayload;
}();
$31e083413a0a3833$var$$root.SdkTurnCredentials = function() {
    /**
     * Properties of a SdkTurnCredentials.
     * @name ISdkTurnCredentials
     * @interface ISdkTurnCredentials
     * @property {string|null} [username] SdkTurnCredentials username
     * @property {string|null} [password] SdkTurnCredentials password
     * @property {number|null} [ttl] SdkTurnCredentials ttl
     * @property {Array.<string>|null} [uris] SdkTurnCredentials uris
     */ /**
     * Constructs a new SdkTurnCredentials.
     * @name SdkTurnCredentials
     * @classdesc Represents a SdkTurnCredentials.
     * @implements ISdkTurnCredentials
     * @constructor
     * @param {ISdkTurnCredentials=} [properties] Properties to set
     */ function SdkTurnCredentials(properties) {
        this.uris = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkTurnCredentials username.
     * @member {string} username
     * @memberof SdkTurnCredentials
     * @instance
     */ SdkTurnCredentials.prototype.username = "";
    /**
     * SdkTurnCredentials password.
     * @member {string} password
     * @memberof SdkTurnCredentials
     * @instance
     */ SdkTurnCredentials.prototype.password = "";
    /**
     * SdkTurnCredentials ttl.
     * @member {number} ttl
     * @memberof SdkTurnCredentials
     * @instance
     */ SdkTurnCredentials.prototype.ttl = 0;
    /**
     * SdkTurnCredentials uris.
     * @member {Array.<string>} uris
     * @memberof SdkTurnCredentials
     * @instance
     */ SdkTurnCredentials.prototype.uris = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkTurnCredentials instance using the specified properties.
     * @function create
     * @memberof SdkTurnCredentials
     * @static
     * @param {ISdkTurnCredentials=} [properties] Properties to set
     * @returns {SdkTurnCredentials} SdkTurnCredentials instance
     */ SdkTurnCredentials.create = function create(properties) {
        return new SdkTurnCredentials(properties);
    };
    /**
     * Encodes the specified SdkTurnCredentials message. Does not implicitly {@link SdkTurnCredentials.verify|verify} messages.
     * @function encode
     * @memberof SdkTurnCredentials
     * @static
     * @param {ISdkTurnCredentials} message SdkTurnCredentials message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTurnCredentials.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.username != null && Object.hasOwnProperty.call(message, "username")) writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.username);
        if (message.password != null && Object.hasOwnProperty.call(message, "password")) writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.password);
        if (message.ttl != null && Object.hasOwnProperty.call(message, "ttl")) writer.uint32(/* id 3, wireType 0 =*/ 24).uint32(message.ttl);
        if (message.uris != null && message.uris.length) for(var i = 0; i < message.uris.length; ++i)writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.uris[i]);
        return writer;
    };
    /**
     * Encodes the specified SdkTurnCredentials message, length delimited. Does not implicitly {@link SdkTurnCredentials.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkTurnCredentials
     * @static
     * @param {ISdkTurnCredentials} message SdkTurnCredentials message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTurnCredentials.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkTurnCredentials message from the specified reader or buffer.
     * @function decode
     * @memberof SdkTurnCredentials
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkTurnCredentials} SdkTurnCredentials
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTurnCredentials.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkTurnCredentials();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.username = reader.string();
                    break;
                case 2:
                    message.password = reader.string();
                    break;
                case 3:
                    message.ttl = reader.uint32();
                    break;
                case 4:
                    if (!(message.uris && message.uris.length)) message.uris = [];
                    message.uris.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkTurnCredentials message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkTurnCredentials
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkTurnCredentials} SdkTurnCredentials
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTurnCredentials.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkTurnCredentials message.
     * @function verify
     * @memberof SdkTurnCredentials
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkTurnCredentials.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.username != null && message.hasOwnProperty("username")) {
            if (!$31e083413a0a3833$var$$util.isString(message.username)) return "username: string expected";
        }
        if (message.password != null && message.hasOwnProperty("password")) {
            if (!$31e083413a0a3833$var$$util.isString(message.password)) return "password: string expected";
        }
        if (message.ttl != null && message.hasOwnProperty("ttl")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.ttl)) return "ttl: integer expected";
        }
        if (message.uris != null && message.hasOwnProperty("uris")) {
            if (!Array.isArray(message.uris)) return "uris: array expected";
            for(var i = 0; i < message.uris.length; ++i)if (!$31e083413a0a3833$var$$util.isString(message.uris[i])) return "uris: string[] expected";
        }
        return null;
    };
    /**
     * Creates a SdkTurnCredentials message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkTurnCredentials
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkTurnCredentials} SdkTurnCredentials
     */ SdkTurnCredentials.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkTurnCredentials) return object;
        var message = new $31e083413a0a3833$var$$root.SdkTurnCredentials();
        if (object.username != null) message.username = String(object.username);
        if (object.password != null) message.password = String(object.password);
        if (object.ttl != null) message.ttl = object.ttl >>> 0;
        if (object.uris) {
            if (!Array.isArray(object.uris)) throw TypeError(".SdkTurnCredentials.uris: array expected");
            message.uris = [];
            for(var i = 0; i < object.uris.length; ++i)message.uris[i] = String(object.uris[i]);
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkTurnCredentials message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkTurnCredentials
     * @static
     * @param {SdkTurnCredentials} message SdkTurnCredentials
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkTurnCredentials.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.uris = [];
        if (options.defaults) {
            object.username = "";
            object.password = "";
            object.ttl = 0;
        }
        if (message.username != null && message.hasOwnProperty("username")) object.username = message.username;
        if (message.password != null && message.hasOwnProperty("password")) object.password = message.password;
        if (message.ttl != null && message.hasOwnProperty("ttl")) object.ttl = message.ttl;
        if (message.uris && message.uris.length) {
            object.uris = [];
            for(var j = 0; j < message.uris.length; ++j)object.uris[j] = message.uris[j];
        }
        return object;
    };
    /**
     * Converts this SdkTurnCredentials to JSON.
     * @function toJSON
     * @memberof SdkTurnCredentials
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkTurnCredentials.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkTurnCredentials
     * @function getTypeUrl
     * @memberof SdkTurnCredentials
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkTurnCredentials.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkTurnCredentials";
    };
    return SdkTurnCredentials;
}();
$31e083413a0a3833$var$$root.SdkTranscriptItem = function() {
    /**
     * Properties of a SdkTranscriptItem.
     * @name ISdkTranscriptItem
     * @interface ISdkTranscriptItem
     * @property {string|null} [content] SdkTranscriptItem content
     * @property {number|Long|null} [endTime] SdkTranscriptItem endTime
     * @property {string|null} [speakerAttendeeId] SdkTranscriptItem speakerAttendeeId
     * @property {string|null} [speakerExternalUserId] SdkTranscriptItem speakerExternalUserId
     * @property {number|Long|null} [startTime] SdkTranscriptItem startTime
     * @property {SdkTranscriptItem.Type|null} [type] SdkTranscriptItem type
     * @property {boolean|null} [vocabularyFilterMatch] SdkTranscriptItem vocabularyFilterMatch
     * @property {number|null} [confidence] SdkTranscriptItem confidence
     * @property {boolean|null} [stable] SdkTranscriptItem stable
     */ /**
     * Constructs a new SdkTranscriptItem.
     * @name SdkTranscriptItem
     * @classdesc Represents a SdkTranscriptItem.
     * @implements ISdkTranscriptItem
     * @constructor
     * @param {ISdkTranscriptItem=} [properties] Properties to set
     */ function SdkTranscriptItem(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkTranscriptItem content.
     * @member {string} content
     * @memberof SdkTranscriptItem
     * @instance
     */ SdkTranscriptItem.prototype.content = "";
    /**
     * SdkTranscriptItem endTime.
     * @member {number|Long} endTime
     * @memberof SdkTranscriptItem
     * @instance
     */ SdkTranscriptItem.prototype.endTime = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkTranscriptItem speakerAttendeeId.
     * @member {string} speakerAttendeeId
     * @memberof SdkTranscriptItem
     * @instance
     */ SdkTranscriptItem.prototype.speakerAttendeeId = "";
    /**
     * SdkTranscriptItem speakerExternalUserId.
     * @member {string} speakerExternalUserId
     * @memberof SdkTranscriptItem
     * @instance
     */ SdkTranscriptItem.prototype.speakerExternalUserId = "";
    /**
     * SdkTranscriptItem startTime.
     * @member {number|Long} startTime
     * @memberof SdkTranscriptItem
     * @instance
     */ SdkTranscriptItem.prototype.startTime = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkTranscriptItem type.
     * @member {SdkTranscriptItem.Type} type
     * @memberof SdkTranscriptItem
     * @instance
     */ SdkTranscriptItem.prototype.type = 1;
    /**
     * SdkTranscriptItem vocabularyFilterMatch.
     * @member {boolean} vocabularyFilterMatch
     * @memberof SdkTranscriptItem
     * @instance
     */ SdkTranscriptItem.prototype.vocabularyFilterMatch = false;
    /**
     * SdkTranscriptItem confidence.
     * @member {number} confidence
     * @memberof SdkTranscriptItem
     * @instance
     */ SdkTranscriptItem.prototype.confidence = 0;
    /**
     * SdkTranscriptItem stable.
     * @member {boolean} stable
     * @memberof SdkTranscriptItem
     * @instance
     */ SdkTranscriptItem.prototype.stable = false;
    /**
     * Creates a new SdkTranscriptItem instance using the specified properties.
     * @function create
     * @memberof SdkTranscriptItem
     * @static
     * @param {ISdkTranscriptItem=} [properties] Properties to set
     * @returns {SdkTranscriptItem} SdkTranscriptItem instance
     */ SdkTranscriptItem.create = function create(properties) {
        return new SdkTranscriptItem(properties);
    };
    /**
     * Encodes the specified SdkTranscriptItem message. Does not implicitly {@link SdkTranscriptItem.verify|verify} messages.
     * @function encode
     * @memberof SdkTranscriptItem
     * @static
     * @param {ISdkTranscriptItem} message SdkTranscriptItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptItem.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.content != null && Object.hasOwnProperty.call(message, "content")) writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.content);
        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime")) writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.endTime);
        if (message.speakerAttendeeId != null && Object.hasOwnProperty.call(message, "speakerAttendeeId")) writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.speakerAttendeeId);
        if (message.speakerExternalUserId != null && Object.hasOwnProperty.call(message, "speakerExternalUserId")) writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.speakerExternalUserId);
        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime")) writer.uint32(/* id 5, wireType 0 =*/ 40).int64(message.startTime);
        if (message.type != null && Object.hasOwnProperty.call(message, "type")) writer.uint32(/* id 6, wireType 0 =*/ 48).int32(message.type);
        if (message.vocabularyFilterMatch != null && Object.hasOwnProperty.call(message, "vocabularyFilterMatch")) writer.uint32(/* id 7, wireType 0 =*/ 56).bool(message.vocabularyFilterMatch);
        if (message.confidence != null && Object.hasOwnProperty.call(message, "confidence")) writer.uint32(/* id 8, wireType 1 =*/ 65).double(message.confidence);
        if (message.stable != null && Object.hasOwnProperty.call(message, "stable")) writer.uint32(/* id 9, wireType 0 =*/ 72).bool(message.stable);
        return writer;
    };
    /**
     * Encodes the specified SdkTranscriptItem message, length delimited. Does not implicitly {@link SdkTranscriptItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkTranscriptItem
     * @static
     * @param {ISdkTranscriptItem} message SdkTranscriptItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkTranscriptItem message from the specified reader or buffer.
     * @function decode
     * @memberof SdkTranscriptItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkTranscriptItem} SdkTranscriptItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptItem.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkTranscriptItem();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.content = reader.string();
                    break;
                case 2:
                    message.endTime = reader.int64();
                    break;
                case 3:
                    message.speakerAttendeeId = reader.string();
                    break;
                case 4:
                    message.speakerExternalUserId = reader.string();
                    break;
                case 5:
                    message.startTime = reader.int64();
                    break;
                case 6:
                    message.type = reader.int32();
                    break;
                case 7:
                    message.vocabularyFilterMatch = reader.bool();
                    break;
                case 8:
                    message.confidence = reader.double();
                    break;
                case 9:
                    message.stable = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkTranscriptItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkTranscriptItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkTranscriptItem} SdkTranscriptItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkTranscriptItem message.
     * @function verify
     * @memberof SdkTranscriptItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkTranscriptItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.content != null && message.hasOwnProperty("content")) {
            if (!$31e083413a0a3833$var$$util.isString(message.content)) return "content: string expected";
        }
        if (message.endTime != null && message.hasOwnProperty("endTime")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.endTime) && !(message.endTime && $31e083413a0a3833$var$$util.isInteger(message.endTime.low) && $31e083413a0a3833$var$$util.isInteger(message.endTime.high))) return "endTime: integer|Long expected";
        }
        if (message.speakerAttendeeId != null && message.hasOwnProperty("speakerAttendeeId")) {
            if (!$31e083413a0a3833$var$$util.isString(message.speakerAttendeeId)) return "speakerAttendeeId: string expected";
        }
        if (message.speakerExternalUserId != null && message.hasOwnProperty("speakerExternalUserId")) {
            if (!$31e083413a0a3833$var$$util.isString(message.speakerExternalUserId)) return "speakerExternalUserId: string expected";
        }
        if (message.startTime != null && message.hasOwnProperty("startTime")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.startTime) && !(message.startTime && $31e083413a0a3833$var$$util.isInteger(message.startTime.low) && $31e083413a0a3833$var$$util.isInteger(message.startTime.high))) return "startTime: integer|Long expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) switch(message.type){
            default:
                return "type: enum value expected";
            case 1:
            case 2:
                break;
        }
        if (message.vocabularyFilterMatch != null && message.hasOwnProperty("vocabularyFilterMatch")) {
            if (typeof message.vocabularyFilterMatch !== "boolean") return "vocabularyFilterMatch: boolean expected";
        }
        if (message.confidence != null && message.hasOwnProperty("confidence")) {
            if (typeof message.confidence !== "number") return "confidence: number expected";
        }
        if (message.stable != null && message.hasOwnProperty("stable")) {
            if (typeof message.stable !== "boolean") return "stable: boolean expected";
        }
        return null;
    };
    /**
     * Creates a SdkTranscriptItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkTranscriptItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkTranscriptItem} SdkTranscriptItem
     */ SdkTranscriptItem.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkTranscriptItem) return object;
        var message = new $31e083413a0a3833$var$$root.SdkTranscriptItem();
        if (object.content != null) message.content = String(object.content);
        if (object.endTime != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.endTime = $31e083413a0a3833$var$$util.Long.fromValue(object.endTime)).unsigned = false;
            else if (typeof object.endTime === "string") message.endTime = parseInt(object.endTime, 10);
            else if (typeof object.endTime === "number") message.endTime = object.endTime;
            else if (typeof object.endTime === "object") message.endTime = new $31e083413a0a3833$var$$util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber();
        }
        if (object.speakerAttendeeId != null) message.speakerAttendeeId = String(object.speakerAttendeeId);
        if (object.speakerExternalUserId != null) message.speakerExternalUserId = String(object.speakerExternalUserId);
        if (object.startTime != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.startTime = $31e083413a0a3833$var$$util.Long.fromValue(object.startTime)).unsigned = false;
            else if (typeof object.startTime === "string") message.startTime = parseInt(object.startTime, 10);
            else if (typeof object.startTime === "number") message.startTime = object.startTime;
            else if (typeof object.startTime === "object") message.startTime = new $31e083413a0a3833$var$$util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber();
        }
        switch(object.type){
            default:
                if (typeof object.type === "number") {
                    message.type = object.type;
                    break;
                }
                break;
            case "PRONUNCIATION":
            case 1:
                message.type = 1;
                break;
            case "PUNCTUATION":
            case 2:
                message.type = 2;
                break;
        }
        if (object.vocabularyFilterMatch != null) message.vocabularyFilterMatch = Boolean(object.vocabularyFilterMatch);
        if (object.confidence != null) message.confidence = Number(object.confidence);
        if (object.stable != null) message.stable = Boolean(object.stable);
        return message;
    };
    /**
     * Creates a plain object from a SdkTranscriptItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkTranscriptItem
     * @static
     * @param {SdkTranscriptItem} message SdkTranscriptItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkTranscriptItem.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.content = "";
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.endTime = options.longs === String ? "0" : 0;
            object.speakerAttendeeId = "";
            object.speakerExternalUserId = "";
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.startTime = options.longs === String ? "0" : 0;
            object.type = options.enums === String ? "PRONUNCIATION" : 1;
            object.vocabularyFilterMatch = false;
            object.confidence = 0;
            object.stable = false;
        }
        if (message.content != null && message.hasOwnProperty("content")) object.content = message.content;
        if (message.endTime != null && message.hasOwnProperty("endTime")) {
            if (typeof message.endTime === "number") object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
            else object.endTime = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber() : message.endTime;
        }
        if (message.speakerAttendeeId != null && message.hasOwnProperty("speakerAttendeeId")) object.speakerAttendeeId = message.speakerAttendeeId;
        if (message.speakerExternalUserId != null && message.hasOwnProperty("speakerExternalUserId")) object.speakerExternalUserId = message.speakerExternalUserId;
        if (message.startTime != null && message.hasOwnProperty("startTime")) {
            if (typeof message.startTime === "number") object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
            else object.startTime = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber() : message.startTime;
        }
        if (message.type != null && message.hasOwnProperty("type")) object.type = options.enums === String ? $31e083413a0a3833$var$$root.SdkTranscriptItem.Type[message.type] === undefined ? message.type : $31e083413a0a3833$var$$root.SdkTranscriptItem.Type[message.type] : message.type;
        if (message.vocabularyFilterMatch != null && message.hasOwnProperty("vocabularyFilterMatch")) object.vocabularyFilterMatch = message.vocabularyFilterMatch;
        if (message.confidence != null && message.hasOwnProperty("confidence")) object.confidence = options.json && !isFinite(message.confidence) ? String(message.confidence) : message.confidence;
        if (message.stable != null && message.hasOwnProperty("stable")) object.stable = message.stable;
        return object;
    };
    /**
     * Converts this SdkTranscriptItem to JSON.
     * @function toJSON
     * @memberof SdkTranscriptItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkTranscriptItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkTranscriptItem
     * @function getTypeUrl
     * @memberof SdkTranscriptItem
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkTranscriptItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkTranscriptItem";
    };
    /**
     * Type enum.
     * @name SdkTranscriptItem.Type
     * @enum {number}
     * @property {number} PRONUNCIATION=1 PRONUNCIATION value
     * @property {number} PUNCTUATION=2 PUNCTUATION value
     */ SdkTranscriptItem.Type = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "PRONUNCIATION"] = 1;
        values[valuesById[2] = "PUNCTUATION"] = 2;
        return values;
    }();
    return SdkTranscriptItem;
}();
$31e083413a0a3833$var$$root.SdkTranscriptEntity = function() {
    /**
     * Properties of a SdkTranscriptEntity.
     * @name ISdkTranscriptEntity
     * @interface ISdkTranscriptEntity
     * @property {string|null} [category] SdkTranscriptEntity category
     * @property {number|null} [confidence] SdkTranscriptEntity confidence
     * @property {string|null} [content] SdkTranscriptEntity content
     * @property {number|Long|null} [endTime] SdkTranscriptEntity endTime
     * @property {number|Long|null} [startTime] SdkTranscriptEntity startTime
     * @property {string|null} [type] SdkTranscriptEntity type
     */ /**
     * Constructs a new SdkTranscriptEntity.
     * @name SdkTranscriptEntity
     * @classdesc Represents a SdkTranscriptEntity.
     * @implements ISdkTranscriptEntity
     * @constructor
     * @param {ISdkTranscriptEntity=} [properties] Properties to set
     */ function SdkTranscriptEntity(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkTranscriptEntity category.
     * @member {string} category
     * @memberof SdkTranscriptEntity
     * @instance
     */ SdkTranscriptEntity.prototype.category = "";
    /**
     * SdkTranscriptEntity confidence.
     * @member {number} confidence
     * @memberof SdkTranscriptEntity
     * @instance
     */ SdkTranscriptEntity.prototype.confidence = 0;
    /**
     * SdkTranscriptEntity content.
     * @member {string} content
     * @memberof SdkTranscriptEntity
     * @instance
     */ SdkTranscriptEntity.prototype.content = "";
    /**
     * SdkTranscriptEntity endTime.
     * @member {number|Long} endTime
     * @memberof SdkTranscriptEntity
     * @instance
     */ SdkTranscriptEntity.prototype.endTime = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkTranscriptEntity startTime.
     * @member {number|Long} startTime
     * @memberof SdkTranscriptEntity
     * @instance
     */ SdkTranscriptEntity.prototype.startTime = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkTranscriptEntity type.
     * @member {string} type
     * @memberof SdkTranscriptEntity
     * @instance
     */ SdkTranscriptEntity.prototype.type = "";
    /**
     * Creates a new SdkTranscriptEntity instance using the specified properties.
     * @function create
     * @memberof SdkTranscriptEntity
     * @static
     * @param {ISdkTranscriptEntity=} [properties] Properties to set
     * @returns {SdkTranscriptEntity} SdkTranscriptEntity instance
     */ SdkTranscriptEntity.create = function create(properties) {
        return new SdkTranscriptEntity(properties);
    };
    /**
     * Encodes the specified SdkTranscriptEntity message. Does not implicitly {@link SdkTranscriptEntity.verify|verify} messages.
     * @function encode
     * @memberof SdkTranscriptEntity
     * @static
     * @param {ISdkTranscriptEntity} message SdkTranscriptEntity message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptEntity.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.category != null && Object.hasOwnProperty.call(message, "category")) writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.category);
        if (message.confidence != null && Object.hasOwnProperty.call(message, "confidence")) writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.confidence);
        if (message.content != null && Object.hasOwnProperty.call(message, "content")) writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.content);
        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime")) writer.uint32(/* id 4, wireType 0 =*/ 32).int64(message.endTime);
        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime")) writer.uint32(/* id 5, wireType 0 =*/ 40).int64(message.startTime);
        if (message.type != null && Object.hasOwnProperty.call(message, "type")) writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.type);
        return writer;
    };
    /**
     * Encodes the specified SdkTranscriptEntity message, length delimited. Does not implicitly {@link SdkTranscriptEntity.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkTranscriptEntity
     * @static
     * @param {ISdkTranscriptEntity} message SdkTranscriptEntity message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptEntity.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkTranscriptEntity message from the specified reader or buffer.
     * @function decode
     * @memberof SdkTranscriptEntity
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkTranscriptEntity} SdkTranscriptEntity
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptEntity.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkTranscriptEntity();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.category = reader.string();
                    break;
                case 2:
                    message.confidence = reader.double();
                    break;
                case 3:
                    message.content = reader.string();
                    break;
                case 4:
                    message.endTime = reader.int64();
                    break;
                case 5:
                    message.startTime = reader.int64();
                    break;
                case 6:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkTranscriptEntity message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkTranscriptEntity
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkTranscriptEntity} SdkTranscriptEntity
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptEntity.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkTranscriptEntity message.
     * @function verify
     * @memberof SdkTranscriptEntity
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkTranscriptEntity.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.category != null && message.hasOwnProperty("category")) {
            if (!$31e083413a0a3833$var$$util.isString(message.category)) return "category: string expected";
        }
        if (message.confidence != null && message.hasOwnProperty("confidence")) {
            if (typeof message.confidence !== "number") return "confidence: number expected";
        }
        if (message.content != null && message.hasOwnProperty("content")) {
            if (!$31e083413a0a3833$var$$util.isString(message.content)) return "content: string expected";
        }
        if (message.endTime != null && message.hasOwnProperty("endTime")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.endTime) && !(message.endTime && $31e083413a0a3833$var$$util.isInteger(message.endTime.low) && $31e083413a0a3833$var$$util.isInteger(message.endTime.high))) return "endTime: integer|Long expected";
        }
        if (message.startTime != null && message.hasOwnProperty("startTime")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.startTime) && !(message.startTime && $31e083413a0a3833$var$$util.isInteger(message.startTime.low) && $31e083413a0a3833$var$$util.isInteger(message.startTime.high))) return "startTime: integer|Long expected";
        }
        if (message.type != null && message.hasOwnProperty("type")) {
            if (!$31e083413a0a3833$var$$util.isString(message.type)) return "type: string expected";
        }
        return null;
    };
    /**
     * Creates a SdkTranscriptEntity message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkTranscriptEntity
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkTranscriptEntity} SdkTranscriptEntity
     */ SdkTranscriptEntity.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkTranscriptEntity) return object;
        var message = new $31e083413a0a3833$var$$root.SdkTranscriptEntity();
        if (object.category != null) message.category = String(object.category);
        if (object.confidence != null) message.confidence = Number(object.confidence);
        if (object.content != null) message.content = String(object.content);
        if (object.endTime != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.endTime = $31e083413a0a3833$var$$util.Long.fromValue(object.endTime)).unsigned = false;
            else if (typeof object.endTime === "string") message.endTime = parseInt(object.endTime, 10);
            else if (typeof object.endTime === "number") message.endTime = object.endTime;
            else if (typeof object.endTime === "object") message.endTime = new $31e083413a0a3833$var$$util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber();
        }
        if (object.startTime != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.startTime = $31e083413a0a3833$var$$util.Long.fromValue(object.startTime)).unsigned = false;
            else if (typeof object.startTime === "string") message.startTime = parseInt(object.startTime, 10);
            else if (typeof object.startTime === "number") message.startTime = object.startTime;
            else if (typeof object.startTime === "object") message.startTime = new $31e083413a0a3833$var$$util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber();
        }
        if (object.type != null) message.type = String(object.type);
        return message;
    };
    /**
     * Creates a plain object from a SdkTranscriptEntity message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkTranscriptEntity
     * @static
     * @param {SdkTranscriptEntity} message SdkTranscriptEntity
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkTranscriptEntity.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.category = "";
            object.confidence = 0;
            object.content = "";
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.endTime = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.startTime = options.longs === String ? "0" : 0;
            object.type = "";
        }
        if (message.category != null && message.hasOwnProperty("category")) object.category = message.category;
        if (message.confidence != null && message.hasOwnProperty("confidence")) object.confidence = options.json && !isFinite(message.confidence) ? String(message.confidence) : message.confidence;
        if (message.content != null && message.hasOwnProperty("content")) object.content = message.content;
        if (message.endTime != null && message.hasOwnProperty("endTime")) {
            if (typeof message.endTime === "number") object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
            else object.endTime = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber() : message.endTime;
        }
        if (message.startTime != null && message.hasOwnProperty("startTime")) {
            if (typeof message.startTime === "number") object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
            else object.startTime = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber() : message.startTime;
        }
        if (message.type != null && message.hasOwnProperty("type")) object.type = message.type;
        return object;
    };
    /**
     * Converts this SdkTranscriptEntity to JSON.
     * @function toJSON
     * @memberof SdkTranscriptEntity
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkTranscriptEntity.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkTranscriptEntity
     * @function getTypeUrl
     * @memberof SdkTranscriptEntity
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkTranscriptEntity.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkTranscriptEntity";
    };
    return SdkTranscriptEntity;
}();
$31e083413a0a3833$var$$root.SdkTranscriptAlternative = function() {
    /**
     * Properties of a SdkTranscriptAlternative.
     * @name ISdkTranscriptAlternative
     * @interface ISdkTranscriptAlternative
     * @property {Array.<ISdkTranscriptItem>|null} [items] SdkTranscriptAlternative items
     * @property {string|null} [transcript] SdkTranscriptAlternative transcript
     * @property {Array.<ISdkTranscriptEntity>|null} [entities] SdkTranscriptAlternative entities
     */ /**
     * Constructs a new SdkTranscriptAlternative.
     * @name SdkTranscriptAlternative
     * @classdesc Represents a SdkTranscriptAlternative.
     * @implements ISdkTranscriptAlternative
     * @constructor
     * @param {ISdkTranscriptAlternative=} [properties] Properties to set
     */ function SdkTranscriptAlternative(properties) {
        this.items = [];
        this.entities = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkTranscriptAlternative items.
     * @member {Array.<ISdkTranscriptItem>} items
     * @memberof SdkTranscriptAlternative
     * @instance
     */ SdkTranscriptAlternative.prototype.items = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkTranscriptAlternative transcript.
     * @member {string} transcript
     * @memberof SdkTranscriptAlternative
     * @instance
     */ SdkTranscriptAlternative.prototype.transcript = "";
    /**
     * SdkTranscriptAlternative entities.
     * @member {Array.<ISdkTranscriptEntity>} entities
     * @memberof SdkTranscriptAlternative
     * @instance
     */ SdkTranscriptAlternative.prototype.entities = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkTranscriptAlternative instance using the specified properties.
     * @function create
     * @memberof SdkTranscriptAlternative
     * @static
     * @param {ISdkTranscriptAlternative=} [properties] Properties to set
     * @returns {SdkTranscriptAlternative} SdkTranscriptAlternative instance
     */ SdkTranscriptAlternative.create = function create(properties) {
        return new SdkTranscriptAlternative(properties);
    };
    /**
     * Encodes the specified SdkTranscriptAlternative message. Does not implicitly {@link SdkTranscriptAlternative.verify|verify} messages.
     * @function encode
     * @memberof SdkTranscriptAlternative
     * @static
     * @param {ISdkTranscriptAlternative} message SdkTranscriptAlternative message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptAlternative.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.items != null && message.items.length) for(var i = 0; i < message.items.length; ++i)$31e083413a0a3833$var$$root.SdkTranscriptItem.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.transcript != null && Object.hasOwnProperty.call(message, "transcript")) writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.transcript);
        if (message.entities != null && message.entities.length) for(var i = 0; i < message.entities.length; ++i)$31e083413a0a3833$var$$root.SdkTranscriptEntity.encode(message.entities[i], writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkTranscriptAlternative message, length delimited. Does not implicitly {@link SdkTranscriptAlternative.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkTranscriptAlternative
     * @static
     * @param {ISdkTranscriptAlternative} message SdkTranscriptAlternative message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptAlternative.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkTranscriptAlternative message from the specified reader or buffer.
     * @function decode
     * @memberof SdkTranscriptAlternative
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkTranscriptAlternative} SdkTranscriptAlternative
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptAlternative.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkTranscriptAlternative();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (!(message.items && message.items.length)) message.items = [];
                    message.items.push($31e083413a0a3833$var$$root.SdkTranscriptItem.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.transcript = reader.string();
                    break;
                case 3:
                    if (!(message.entities && message.entities.length)) message.entities = [];
                    message.entities.push($31e083413a0a3833$var$$root.SdkTranscriptEntity.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkTranscriptAlternative message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkTranscriptAlternative
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkTranscriptAlternative} SdkTranscriptAlternative
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptAlternative.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkTranscriptAlternative message.
     * @function verify
     * @memberof SdkTranscriptAlternative
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkTranscriptAlternative.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.items != null && message.hasOwnProperty("items")) {
            if (!Array.isArray(message.items)) return "items: array expected";
            for(var i = 0; i < message.items.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkTranscriptItem.verify(message.items[i]);
                if (error) return "items." + error;
            }
        }
        if (message.transcript != null && message.hasOwnProperty("transcript")) {
            if (!$31e083413a0a3833$var$$util.isString(message.transcript)) return "transcript: string expected";
        }
        if (message.entities != null && message.hasOwnProperty("entities")) {
            if (!Array.isArray(message.entities)) return "entities: array expected";
            for(var i = 0; i < message.entities.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkTranscriptEntity.verify(message.entities[i]);
                if (error) return "entities." + error;
            }
        }
        return null;
    };
    /**
     * Creates a SdkTranscriptAlternative message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkTranscriptAlternative
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkTranscriptAlternative} SdkTranscriptAlternative
     */ SdkTranscriptAlternative.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkTranscriptAlternative) return object;
        var message = new $31e083413a0a3833$var$$root.SdkTranscriptAlternative();
        if (object.items) {
            if (!Array.isArray(object.items)) throw TypeError(".SdkTranscriptAlternative.items: array expected");
            message.items = [];
            for(var i = 0; i < object.items.length; ++i){
                if (typeof object.items[i] !== "object") throw TypeError(".SdkTranscriptAlternative.items: object expected");
                message.items[i] = $31e083413a0a3833$var$$root.SdkTranscriptItem.fromObject(object.items[i]);
            }
        }
        if (object.transcript != null) message.transcript = String(object.transcript);
        if (object.entities) {
            if (!Array.isArray(object.entities)) throw TypeError(".SdkTranscriptAlternative.entities: array expected");
            message.entities = [];
            for(var i = 0; i < object.entities.length; ++i){
                if (typeof object.entities[i] !== "object") throw TypeError(".SdkTranscriptAlternative.entities: object expected");
                message.entities[i] = $31e083413a0a3833$var$$root.SdkTranscriptEntity.fromObject(object.entities[i]);
            }
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkTranscriptAlternative message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkTranscriptAlternative
     * @static
     * @param {SdkTranscriptAlternative} message SdkTranscriptAlternative
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkTranscriptAlternative.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.items = [];
            object.entities = [];
        }
        if (options.defaults) object.transcript = "";
        if (message.items && message.items.length) {
            object.items = [];
            for(var j = 0; j < message.items.length; ++j)object.items[j] = $31e083413a0a3833$var$$root.SdkTranscriptItem.toObject(message.items[j], options);
        }
        if (message.transcript != null && message.hasOwnProperty("transcript")) object.transcript = message.transcript;
        if (message.entities && message.entities.length) {
            object.entities = [];
            for(var j = 0; j < message.entities.length; ++j)object.entities[j] = $31e083413a0a3833$var$$root.SdkTranscriptEntity.toObject(message.entities[j], options);
        }
        return object;
    };
    /**
     * Converts this SdkTranscriptAlternative to JSON.
     * @function toJSON
     * @memberof SdkTranscriptAlternative
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkTranscriptAlternative.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkTranscriptAlternative
     * @function getTypeUrl
     * @memberof SdkTranscriptAlternative
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkTranscriptAlternative.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkTranscriptAlternative";
    };
    return SdkTranscriptAlternative;
}();
$31e083413a0a3833$var$$root.SdkTranscriptLanguageWithScore = function() {
    /**
     * Properties of a SdkTranscriptLanguageWithScore.
     * @name ISdkTranscriptLanguageWithScore
     * @interface ISdkTranscriptLanguageWithScore
     * @property {string|null} [languageCode] SdkTranscriptLanguageWithScore languageCode
     * @property {number|null} [score] SdkTranscriptLanguageWithScore score
     */ /**
     * Constructs a new SdkTranscriptLanguageWithScore.
     * @name SdkTranscriptLanguageWithScore
     * @classdesc Represents a SdkTranscriptLanguageWithScore.
     * @implements ISdkTranscriptLanguageWithScore
     * @constructor
     * @param {ISdkTranscriptLanguageWithScore=} [properties] Properties to set
     */ function SdkTranscriptLanguageWithScore(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkTranscriptLanguageWithScore languageCode.
     * @member {string} languageCode
     * @memberof SdkTranscriptLanguageWithScore
     * @instance
     */ SdkTranscriptLanguageWithScore.prototype.languageCode = "";
    /**
     * SdkTranscriptLanguageWithScore score.
     * @member {number} score
     * @memberof SdkTranscriptLanguageWithScore
     * @instance
     */ SdkTranscriptLanguageWithScore.prototype.score = 0;
    /**
     * Creates a new SdkTranscriptLanguageWithScore instance using the specified properties.
     * @function create
     * @memberof SdkTranscriptLanguageWithScore
     * @static
     * @param {ISdkTranscriptLanguageWithScore=} [properties] Properties to set
     * @returns {SdkTranscriptLanguageWithScore} SdkTranscriptLanguageWithScore instance
     */ SdkTranscriptLanguageWithScore.create = function create(properties) {
        return new SdkTranscriptLanguageWithScore(properties);
    };
    /**
     * Encodes the specified SdkTranscriptLanguageWithScore message. Does not implicitly {@link SdkTranscriptLanguageWithScore.verify|verify} messages.
     * @function encode
     * @memberof SdkTranscriptLanguageWithScore
     * @static
     * @param {ISdkTranscriptLanguageWithScore} message SdkTranscriptLanguageWithScore message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptLanguageWithScore.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode")) writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.languageCode);
        if (message.score != null && Object.hasOwnProperty.call(message, "score")) writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.score);
        return writer;
    };
    /**
     * Encodes the specified SdkTranscriptLanguageWithScore message, length delimited. Does not implicitly {@link SdkTranscriptLanguageWithScore.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkTranscriptLanguageWithScore
     * @static
     * @param {ISdkTranscriptLanguageWithScore} message SdkTranscriptLanguageWithScore message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptLanguageWithScore.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkTranscriptLanguageWithScore message from the specified reader or buffer.
     * @function decode
     * @memberof SdkTranscriptLanguageWithScore
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkTranscriptLanguageWithScore} SdkTranscriptLanguageWithScore
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptLanguageWithScore.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkTranscriptLanguageWithScore();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.languageCode = reader.string();
                    break;
                case 2:
                    message.score = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkTranscriptLanguageWithScore message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkTranscriptLanguageWithScore
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkTranscriptLanguageWithScore} SdkTranscriptLanguageWithScore
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptLanguageWithScore.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkTranscriptLanguageWithScore message.
     * @function verify
     * @memberof SdkTranscriptLanguageWithScore
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkTranscriptLanguageWithScore.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.languageCode != null && message.hasOwnProperty("languageCode")) {
            if (!$31e083413a0a3833$var$$util.isString(message.languageCode)) return "languageCode: string expected";
        }
        if (message.score != null && message.hasOwnProperty("score")) {
            if (typeof message.score !== "number") return "score: number expected";
        }
        return null;
    };
    /**
     * Creates a SdkTranscriptLanguageWithScore message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkTranscriptLanguageWithScore
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkTranscriptLanguageWithScore} SdkTranscriptLanguageWithScore
     */ SdkTranscriptLanguageWithScore.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkTranscriptLanguageWithScore) return object;
        var message = new $31e083413a0a3833$var$$root.SdkTranscriptLanguageWithScore();
        if (object.languageCode != null) message.languageCode = String(object.languageCode);
        if (object.score != null) message.score = Number(object.score);
        return message;
    };
    /**
     * Creates a plain object from a SdkTranscriptLanguageWithScore message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkTranscriptLanguageWithScore
     * @static
     * @param {SdkTranscriptLanguageWithScore} message SdkTranscriptLanguageWithScore
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkTranscriptLanguageWithScore.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.languageCode = "";
            object.score = 0;
        }
        if (message.languageCode != null && message.hasOwnProperty("languageCode")) object.languageCode = message.languageCode;
        if (message.score != null && message.hasOwnProperty("score")) object.score = options.json && !isFinite(message.score) ? String(message.score) : message.score;
        return object;
    };
    /**
     * Converts this SdkTranscriptLanguageWithScore to JSON.
     * @function toJSON
     * @memberof SdkTranscriptLanguageWithScore
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkTranscriptLanguageWithScore.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkTranscriptLanguageWithScore
     * @function getTypeUrl
     * @memberof SdkTranscriptLanguageWithScore
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkTranscriptLanguageWithScore.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkTranscriptLanguageWithScore";
    };
    return SdkTranscriptLanguageWithScore;
}();
$31e083413a0a3833$var$$root.SdkTranscriptResult = function() {
    /**
     * Properties of a SdkTranscriptResult.
     * @name ISdkTranscriptResult
     * @interface ISdkTranscriptResult
     * @property {Array.<ISdkTranscriptAlternative>|null} [alternatives] SdkTranscriptResult alternatives
     * @property {string|null} [channelId] SdkTranscriptResult channelId
     * @property {number|Long|null} [endTime] SdkTranscriptResult endTime
     * @property {boolean|null} [isPartial] SdkTranscriptResult isPartial
     * @property {string|null} [resultId] SdkTranscriptResult resultId
     * @property {number|Long|null} [startTime] SdkTranscriptResult startTime
     * @property {string|null} [languageCode] SdkTranscriptResult languageCode
     * @property {Array.<ISdkTranscriptLanguageWithScore>|null} [languageIdentification] SdkTranscriptResult languageIdentification
     */ /**
     * Constructs a new SdkTranscriptResult.
     * @name SdkTranscriptResult
     * @classdesc Represents a SdkTranscriptResult.
     * @implements ISdkTranscriptResult
     * @constructor
     * @param {ISdkTranscriptResult=} [properties] Properties to set
     */ function SdkTranscriptResult(properties) {
        this.alternatives = [];
        this.languageIdentification = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkTranscriptResult alternatives.
     * @member {Array.<ISdkTranscriptAlternative>} alternatives
     * @memberof SdkTranscriptResult
     * @instance
     */ SdkTranscriptResult.prototype.alternatives = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkTranscriptResult channelId.
     * @member {string} channelId
     * @memberof SdkTranscriptResult
     * @instance
     */ SdkTranscriptResult.prototype.channelId = "";
    /**
     * SdkTranscriptResult endTime.
     * @member {number|Long} endTime
     * @memberof SdkTranscriptResult
     * @instance
     */ SdkTranscriptResult.prototype.endTime = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkTranscriptResult isPartial.
     * @member {boolean} isPartial
     * @memberof SdkTranscriptResult
     * @instance
     */ SdkTranscriptResult.prototype.isPartial = false;
    /**
     * SdkTranscriptResult resultId.
     * @member {string} resultId
     * @memberof SdkTranscriptResult
     * @instance
     */ SdkTranscriptResult.prototype.resultId = "";
    /**
     * SdkTranscriptResult startTime.
     * @member {number|Long} startTime
     * @memberof SdkTranscriptResult
     * @instance
     */ SdkTranscriptResult.prototype.startTime = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkTranscriptResult languageCode.
     * @member {string} languageCode
     * @memberof SdkTranscriptResult
     * @instance
     */ SdkTranscriptResult.prototype.languageCode = "";
    /**
     * SdkTranscriptResult languageIdentification.
     * @member {Array.<ISdkTranscriptLanguageWithScore>} languageIdentification
     * @memberof SdkTranscriptResult
     * @instance
     */ SdkTranscriptResult.prototype.languageIdentification = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkTranscriptResult instance using the specified properties.
     * @function create
     * @memberof SdkTranscriptResult
     * @static
     * @param {ISdkTranscriptResult=} [properties] Properties to set
     * @returns {SdkTranscriptResult} SdkTranscriptResult instance
     */ SdkTranscriptResult.create = function create(properties) {
        return new SdkTranscriptResult(properties);
    };
    /**
     * Encodes the specified SdkTranscriptResult message. Does not implicitly {@link SdkTranscriptResult.verify|verify} messages.
     * @function encode
     * @memberof SdkTranscriptResult
     * @static
     * @param {ISdkTranscriptResult} message SdkTranscriptResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptResult.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.alternatives != null && message.alternatives.length) for(var i = 0; i < message.alternatives.length; ++i)$31e083413a0a3833$var$$root.SdkTranscriptAlternative.encode(message.alternatives[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.channelId != null && Object.hasOwnProperty.call(message, "channelId")) writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.channelId);
        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime")) writer.uint32(/* id 3, wireType 0 =*/ 24).int64(message.endTime);
        if (message.isPartial != null && Object.hasOwnProperty.call(message, "isPartial")) writer.uint32(/* id 4, wireType 0 =*/ 32).bool(message.isPartial);
        if (message.resultId != null && Object.hasOwnProperty.call(message, "resultId")) writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.resultId);
        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime")) writer.uint32(/* id 6, wireType 0 =*/ 48).int64(message.startTime);
        if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode")) writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.languageCode);
        if (message.languageIdentification != null && message.languageIdentification.length) for(var i = 0; i < message.languageIdentification.length; ++i)$31e083413a0a3833$var$$root.SdkTranscriptLanguageWithScore.encode(message.languageIdentification[i], writer.uint32(/* id 8, wireType 2 =*/ 66).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkTranscriptResult message, length delimited. Does not implicitly {@link SdkTranscriptResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkTranscriptResult
     * @static
     * @param {ISdkTranscriptResult} message SdkTranscriptResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkTranscriptResult message from the specified reader or buffer.
     * @function decode
     * @memberof SdkTranscriptResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkTranscriptResult} SdkTranscriptResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptResult.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkTranscriptResult();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (!(message.alternatives && message.alternatives.length)) message.alternatives = [];
                    message.alternatives.push($31e083413a0a3833$var$$root.SdkTranscriptAlternative.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.endTime = reader.int64();
                    break;
                case 4:
                    message.isPartial = reader.bool();
                    break;
                case 5:
                    message.resultId = reader.string();
                    break;
                case 6:
                    message.startTime = reader.int64();
                    break;
                case 7:
                    message.languageCode = reader.string();
                    break;
                case 8:
                    if (!(message.languageIdentification && message.languageIdentification.length)) message.languageIdentification = [];
                    message.languageIdentification.push($31e083413a0a3833$var$$root.SdkTranscriptLanguageWithScore.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkTranscriptResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkTranscriptResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkTranscriptResult} SdkTranscriptResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkTranscriptResult message.
     * @function verify
     * @memberof SdkTranscriptResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkTranscriptResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.alternatives != null && message.hasOwnProperty("alternatives")) {
            if (!Array.isArray(message.alternatives)) return "alternatives: array expected";
            for(var i = 0; i < message.alternatives.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkTranscriptAlternative.verify(message.alternatives[i]);
                if (error) return "alternatives." + error;
            }
        }
        if (message.channelId != null && message.hasOwnProperty("channelId")) {
            if (!$31e083413a0a3833$var$$util.isString(message.channelId)) return "channelId: string expected";
        }
        if (message.endTime != null && message.hasOwnProperty("endTime")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.endTime) && !(message.endTime && $31e083413a0a3833$var$$util.isInteger(message.endTime.low) && $31e083413a0a3833$var$$util.isInteger(message.endTime.high))) return "endTime: integer|Long expected";
        }
        if (message.isPartial != null && message.hasOwnProperty("isPartial")) {
            if (typeof message.isPartial !== "boolean") return "isPartial: boolean expected";
        }
        if (message.resultId != null && message.hasOwnProperty("resultId")) {
            if (!$31e083413a0a3833$var$$util.isString(message.resultId)) return "resultId: string expected";
        }
        if (message.startTime != null && message.hasOwnProperty("startTime")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.startTime) && !(message.startTime && $31e083413a0a3833$var$$util.isInteger(message.startTime.low) && $31e083413a0a3833$var$$util.isInteger(message.startTime.high))) return "startTime: integer|Long expected";
        }
        if (message.languageCode != null && message.hasOwnProperty("languageCode")) {
            if (!$31e083413a0a3833$var$$util.isString(message.languageCode)) return "languageCode: string expected";
        }
        if (message.languageIdentification != null && message.hasOwnProperty("languageIdentification")) {
            if (!Array.isArray(message.languageIdentification)) return "languageIdentification: array expected";
            for(var i = 0; i < message.languageIdentification.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkTranscriptLanguageWithScore.verify(message.languageIdentification[i]);
                if (error) return "languageIdentification." + error;
            }
        }
        return null;
    };
    /**
     * Creates a SdkTranscriptResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkTranscriptResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkTranscriptResult} SdkTranscriptResult
     */ SdkTranscriptResult.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkTranscriptResult) return object;
        var message = new $31e083413a0a3833$var$$root.SdkTranscriptResult();
        if (object.alternatives) {
            if (!Array.isArray(object.alternatives)) throw TypeError(".SdkTranscriptResult.alternatives: array expected");
            message.alternatives = [];
            for(var i = 0; i < object.alternatives.length; ++i){
                if (typeof object.alternatives[i] !== "object") throw TypeError(".SdkTranscriptResult.alternatives: object expected");
                message.alternatives[i] = $31e083413a0a3833$var$$root.SdkTranscriptAlternative.fromObject(object.alternatives[i]);
            }
        }
        if (object.channelId != null) message.channelId = String(object.channelId);
        if (object.endTime != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.endTime = $31e083413a0a3833$var$$util.Long.fromValue(object.endTime)).unsigned = false;
            else if (typeof object.endTime === "string") message.endTime = parseInt(object.endTime, 10);
            else if (typeof object.endTime === "number") message.endTime = object.endTime;
            else if (typeof object.endTime === "object") message.endTime = new $31e083413a0a3833$var$$util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber();
        }
        if (object.isPartial != null) message.isPartial = Boolean(object.isPartial);
        if (object.resultId != null) message.resultId = String(object.resultId);
        if (object.startTime != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.startTime = $31e083413a0a3833$var$$util.Long.fromValue(object.startTime)).unsigned = false;
            else if (typeof object.startTime === "string") message.startTime = parseInt(object.startTime, 10);
            else if (typeof object.startTime === "number") message.startTime = object.startTime;
            else if (typeof object.startTime === "object") message.startTime = new $31e083413a0a3833$var$$util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber();
        }
        if (object.languageCode != null) message.languageCode = String(object.languageCode);
        if (object.languageIdentification) {
            if (!Array.isArray(object.languageIdentification)) throw TypeError(".SdkTranscriptResult.languageIdentification: array expected");
            message.languageIdentification = [];
            for(var i = 0; i < object.languageIdentification.length; ++i){
                if (typeof object.languageIdentification[i] !== "object") throw TypeError(".SdkTranscriptResult.languageIdentification: object expected");
                message.languageIdentification[i] = $31e083413a0a3833$var$$root.SdkTranscriptLanguageWithScore.fromObject(object.languageIdentification[i]);
            }
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkTranscriptResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkTranscriptResult
     * @static
     * @param {SdkTranscriptResult} message SdkTranscriptResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkTranscriptResult.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.alternatives = [];
            object.languageIdentification = [];
        }
        if (options.defaults) {
            object.channelId = "";
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.endTime = options.longs === String ? "0" : 0;
            object.isPartial = false;
            object.resultId = "";
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.startTime = options.longs === String ? "0" : 0;
            object.languageCode = "";
        }
        if (message.alternatives && message.alternatives.length) {
            object.alternatives = [];
            for(var j = 0; j < message.alternatives.length; ++j)object.alternatives[j] = $31e083413a0a3833$var$$root.SdkTranscriptAlternative.toObject(message.alternatives[j], options);
        }
        if (message.channelId != null && message.hasOwnProperty("channelId")) object.channelId = message.channelId;
        if (message.endTime != null && message.hasOwnProperty("endTime")) {
            if (typeof message.endTime === "number") object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
            else object.endTime = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber() : message.endTime;
        }
        if (message.isPartial != null && message.hasOwnProperty("isPartial")) object.isPartial = message.isPartial;
        if (message.resultId != null && message.hasOwnProperty("resultId")) object.resultId = message.resultId;
        if (message.startTime != null && message.hasOwnProperty("startTime")) {
            if (typeof message.startTime === "number") object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
            else object.startTime = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber() : message.startTime;
        }
        if (message.languageCode != null && message.hasOwnProperty("languageCode")) object.languageCode = message.languageCode;
        if (message.languageIdentification && message.languageIdentification.length) {
            object.languageIdentification = [];
            for(var j = 0; j < message.languageIdentification.length; ++j)object.languageIdentification[j] = $31e083413a0a3833$var$$root.SdkTranscriptLanguageWithScore.toObject(message.languageIdentification[j], options);
        }
        return object;
    };
    /**
     * Converts this SdkTranscriptResult to JSON.
     * @function toJSON
     * @memberof SdkTranscriptResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkTranscriptResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkTranscriptResult
     * @function getTypeUrl
     * @memberof SdkTranscriptResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkTranscriptResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkTranscriptResult";
    };
    return SdkTranscriptResult;
}();
$31e083413a0a3833$var$$root.SdkTranscript = function() {
    /**
     * Properties of a SdkTranscript.
     * @name ISdkTranscript
     * @interface ISdkTranscript
     * @property {Array.<ISdkTranscriptResult>|null} [results] SdkTranscript results
     */ /**
     * Constructs a new SdkTranscript.
     * @name SdkTranscript
     * @classdesc Represents a SdkTranscript.
     * @implements ISdkTranscript
     * @constructor
     * @param {ISdkTranscript=} [properties] Properties to set
     */ function SdkTranscript(properties) {
        this.results = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkTranscript results.
     * @member {Array.<ISdkTranscriptResult>} results
     * @memberof SdkTranscript
     * @instance
     */ SdkTranscript.prototype.results = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkTranscript instance using the specified properties.
     * @function create
     * @memberof SdkTranscript
     * @static
     * @param {ISdkTranscript=} [properties] Properties to set
     * @returns {SdkTranscript} SdkTranscript instance
     */ SdkTranscript.create = function create(properties) {
        return new SdkTranscript(properties);
    };
    /**
     * Encodes the specified SdkTranscript message. Does not implicitly {@link SdkTranscript.verify|verify} messages.
     * @function encode
     * @memberof SdkTranscript
     * @static
     * @param {ISdkTranscript} message SdkTranscript message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscript.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.results != null && message.results.length) for(var i = 0; i < message.results.length; ++i)$31e083413a0a3833$var$$root.SdkTranscriptResult.encode(message.results[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkTranscript message, length delimited. Does not implicitly {@link SdkTranscript.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkTranscript
     * @static
     * @param {ISdkTranscript} message SdkTranscript message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscript.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkTranscript message from the specified reader or buffer.
     * @function decode
     * @memberof SdkTranscript
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkTranscript} SdkTranscript
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscript.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkTranscript();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (!(message.results && message.results.length)) message.results = [];
                    message.results.push($31e083413a0a3833$var$$root.SdkTranscriptResult.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkTranscript message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkTranscript
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkTranscript} SdkTranscript
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscript.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkTranscript message.
     * @function verify
     * @memberof SdkTranscript
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkTranscript.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.results != null && message.hasOwnProperty("results")) {
            if (!Array.isArray(message.results)) return "results: array expected";
            for(var i = 0; i < message.results.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkTranscriptResult.verify(message.results[i]);
                if (error) return "results." + error;
            }
        }
        return null;
    };
    /**
     * Creates a SdkTranscript message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkTranscript
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkTranscript} SdkTranscript
     */ SdkTranscript.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkTranscript) return object;
        var message = new $31e083413a0a3833$var$$root.SdkTranscript();
        if (object.results) {
            if (!Array.isArray(object.results)) throw TypeError(".SdkTranscript.results: array expected");
            message.results = [];
            for(var i = 0; i < object.results.length; ++i){
                if (typeof object.results[i] !== "object") throw TypeError(".SdkTranscript.results: object expected");
                message.results[i] = $31e083413a0a3833$var$$root.SdkTranscriptResult.fromObject(object.results[i]);
            }
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkTranscript message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkTranscript
     * @static
     * @param {SdkTranscript} message SdkTranscript
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkTranscript.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.results = [];
        if (message.results && message.results.length) {
            object.results = [];
            for(var j = 0; j < message.results.length; ++j)object.results[j] = $31e083413a0a3833$var$$root.SdkTranscriptResult.toObject(message.results[j], options);
        }
        return object;
    };
    /**
     * Converts this SdkTranscript to JSON.
     * @function toJSON
     * @memberof SdkTranscript
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkTranscript.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkTranscript
     * @function getTypeUrl
     * @memberof SdkTranscript
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkTranscript.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkTranscript";
    };
    return SdkTranscript;
}();
$31e083413a0a3833$var$$root.SdkTranscriptionStatus = function() {
    /**
     * Properties of a SdkTranscriptionStatus.
     * @name ISdkTranscriptionStatus
     * @interface ISdkTranscriptionStatus
     * @property {SdkTranscriptionStatus.Type|null} [type] SdkTranscriptionStatus type
     * @property {number|Long|null} [eventTime] SdkTranscriptionStatus eventTime
     * @property {string|null} [transcriptionRegion] SdkTranscriptionStatus transcriptionRegion
     * @property {string|null} [transcriptionConfiguration] SdkTranscriptionStatus transcriptionConfiguration
     * @property {string|null} [message] SdkTranscriptionStatus message
     */ /**
     * Constructs a new SdkTranscriptionStatus.
     * @name SdkTranscriptionStatus
     * @classdesc Represents a SdkTranscriptionStatus.
     * @implements ISdkTranscriptionStatus
     * @constructor
     * @param {ISdkTranscriptionStatus=} [properties] Properties to set
     */ function SdkTranscriptionStatus(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkTranscriptionStatus type.
     * @member {SdkTranscriptionStatus.Type} type
     * @memberof SdkTranscriptionStatus
     * @instance
     */ SdkTranscriptionStatus.prototype.type = 1;
    /**
     * SdkTranscriptionStatus eventTime.
     * @member {number|Long} eventTime
     * @memberof SdkTranscriptionStatus
     * @instance
     */ SdkTranscriptionStatus.prototype.eventTime = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkTranscriptionStatus transcriptionRegion.
     * @member {string} transcriptionRegion
     * @memberof SdkTranscriptionStatus
     * @instance
     */ SdkTranscriptionStatus.prototype.transcriptionRegion = "";
    /**
     * SdkTranscriptionStatus transcriptionConfiguration.
     * @member {string} transcriptionConfiguration
     * @memberof SdkTranscriptionStatus
     * @instance
     */ SdkTranscriptionStatus.prototype.transcriptionConfiguration = "";
    /**
     * SdkTranscriptionStatus message.
     * @member {string} message
     * @memberof SdkTranscriptionStatus
     * @instance
     */ SdkTranscriptionStatus.prototype.message = "";
    /**
     * Creates a new SdkTranscriptionStatus instance using the specified properties.
     * @function create
     * @memberof SdkTranscriptionStatus
     * @static
     * @param {ISdkTranscriptionStatus=} [properties] Properties to set
     * @returns {SdkTranscriptionStatus} SdkTranscriptionStatus instance
     */ SdkTranscriptionStatus.create = function create(properties) {
        return new SdkTranscriptionStatus(properties);
    };
    /**
     * Encodes the specified SdkTranscriptionStatus message. Does not implicitly {@link SdkTranscriptionStatus.verify|verify} messages.
     * @function encode
     * @memberof SdkTranscriptionStatus
     * @static
     * @param {ISdkTranscriptionStatus} message SdkTranscriptionStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptionStatus.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.type);
        if (message.eventTime != null && Object.hasOwnProperty.call(message, "eventTime")) writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.eventTime);
        if (message.transcriptionRegion != null && Object.hasOwnProperty.call(message, "transcriptionRegion")) writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.transcriptionRegion);
        if (message.transcriptionConfiguration != null && Object.hasOwnProperty.call(message, "transcriptionConfiguration")) writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.transcriptionConfiguration);
        if (message.message != null && Object.hasOwnProperty.call(message, "message")) writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.message);
        return writer;
    };
    /**
     * Encodes the specified SdkTranscriptionStatus message, length delimited. Does not implicitly {@link SdkTranscriptionStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkTranscriptionStatus
     * @static
     * @param {ISdkTranscriptionStatus} message SdkTranscriptionStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptionStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkTranscriptionStatus message from the specified reader or buffer.
     * @function decode
     * @memberof SdkTranscriptionStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkTranscriptionStatus} SdkTranscriptionStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptionStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkTranscriptionStatus();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.eventTime = reader.int64();
                    break;
                case 3:
                    message.transcriptionRegion = reader.string();
                    break;
                case 4:
                    message.transcriptionConfiguration = reader.string();
                    break;
                case 5:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkTranscriptionStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkTranscriptionStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkTranscriptionStatus} SdkTranscriptionStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptionStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkTranscriptionStatus message.
     * @function verify
     * @memberof SdkTranscriptionStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkTranscriptionStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.type != null && message.hasOwnProperty("type")) switch(message.type){
            default:
                return "type: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
        }
        if (message.eventTime != null && message.hasOwnProperty("eventTime")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.eventTime) && !(message.eventTime && $31e083413a0a3833$var$$util.isInteger(message.eventTime.low) && $31e083413a0a3833$var$$util.isInteger(message.eventTime.high))) return "eventTime: integer|Long expected";
        }
        if (message.transcriptionRegion != null && message.hasOwnProperty("transcriptionRegion")) {
            if (!$31e083413a0a3833$var$$util.isString(message.transcriptionRegion)) return "transcriptionRegion: string expected";
        }
        if (message.transcriptionConfiguration != null && message.hasOwnProperty("transcriptionConfiguration")) {
            if (!$31e083413a0a3833$var$$util.isString(message.transcriptionConfiguration)) return "transcriptionConfiguration: string expected";
        }
        if (message.message != null && message.hasOwnProperty("message")) {
            if (!$31e083413a0a3833$var$$util.isString(message.message)) return "message: string expected";
        }
        return null;
    };
    /**
     * Creates a SdkTranscriptionStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkTranscriptionStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkTranscriptionStatus} SdkTranscriptionStatus
     */ SdkTranscriptionStatus.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkTranscriptionStatus) return object;
        var message = new $31e083413a0a3833$var$$root.SdkTranscriptionStatus();
        switch(object.type){
            default:
                if (typeof object.type === "number") {
                    message.type = object.type;
                    break;
                }
                break;
            case "STARTED":
            case 1:
                message.type = 1;
                break;
            case "INTERRUPTED":
            case 2:
                message.type = 2;
                break;
            case "RESUMED":
            case 3:
                message.type = 3;
                break;
            case "STOPPED":
            case 4:
                message.type = 4;
                break;
            case "FAILED":
            case 5:
                message.type = 5;
                break;
        }
        if (object.eventTime != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.eventTime = $31e083413a0a3833$var$$util.Long.fromValue(object.eventTime)).unsigned = false;
            else if (typeof object.eventTime === "string") message.eventTime = parseInt(object.eventTime, 10);
            else if (typeof object.eventTime === "number") message.eventTime = object.eventTime;
            else if (typeof object.eventTime === "object") message.eventTime = new $31e083413a0a3833$var$$util.LongBits(object.eventTime.low >>> 0, object.eventTime.high >>> 0).toNumber();
        }
        if (object.transcriptionRegion != null) message.transcriptionRegion = String(object.transcriptionRegion);
        if (object.transcriptionConfiguration != null) message.transcriptionConfiguration = String(object.transcriptionConfiguration);
        if (object.message != null) message.message = String(object.message);
        return message;
    };
    /**
     * Creates a plain object from a SdkTranscriptionStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkTranscriptionStatus
     * @static
     * @param {SdkTranscriptionStatus} message SdkTranscriptionStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkTranscriptionStatus.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "STARTED" : 1;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.eventTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.eventTime = options.longs === String ? "0" : 0;
            object.transcriptionRegion = "";
            object.transcriptionConfiguration = "";
            object.message = "";
        }
        if (message.type != null && message.hasOwnProperty("type")) object.type = options.enums === String ? $31e083413a0a3833$var$$root.SdkTranscriptionStatus.Type[message.type] === undefined ? message.type : $31e083413a0a3833$var$$root.SdkTranscriptionStatus.Type[message.type] : message.type;
        if (message.eventTime != null && message.hasOwnProperty("eventTime")) {
            if (typeof message.eventTime === "number") object.eventTime = options.longs === String ? String(message.eventTime) : message.eventTime;
            else object.eventTime = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.eventTime) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.eventTime.low >>> 0, message.eventTime.high >>> 0).toNumber() : message.eventTime;
        }
        if (message.transcriptionRegion != null && message.hasOwnProperty("transcriptionRegion")) object.transcriptionRegion = message.transcriptionRegion;
        if (message.transcriptionConfiguration != null && message.hasOwnProperty("transcriptionConfiguration")) object.transcriptionConfiguration = message.transcriptionConfiguration;
        if (message.message != null && message.hasOwnProperty("message")) object.message = message.message;
        return object;
    };
    /**
     * Converts this SdkTranscriptionStatus to JSON.
     * @function toJSON
     * @memberof SdkTranscriptionStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkTranscriptionStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkTranscriptionStatus
     * @function getTypeUrl
     * @memberof SdkTranscriptionStatus
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkTranscriptionStatus.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkTranscriptionStatus";
    };
    /**
     * Type enum.
     * @name SdkTranscriptionStatus.Type
     * @enum {number}
     * @property {number} STARTED=1 STARTED value
     * @property {number} INTERRUPTED=2 INTERRUPTED value
     * @property {number} RESUMED=3 RESUMED value
     * @property {number} STOPPED=4 STOPPED value
     * @property {number} FAILED=5 FAILED value
     */ SdkTranscriptionStatus.Type = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "STARTED"] = 1;
        values[valuesById[2] = "INTERRUPTED"] = 2;
        values[valuesById[3] = "RESUMED"] = 3;
        values[valuesById[4] = "STOPPED"] = 4;
        values[valuesById[5] = "FAILED"] = 5;
        return values;
    }();
    return SdkTranscriptionStatus;
}();
$31e083413a0a3833$var$$root.SdkTranscriptEvent = function() {
    /**
     * Properties of a SdkTranscriptEvent.
     * @name ISdkTranscriptEvent
     * @interface ISdkTranscriptEvent
     * @property {ISdkTranscriptionStatus|null} [status] SdkTranscriptEvent status
     * @property {ISdkTranscript|null} [transcript] SdkTranscriptEvent transcript
     */ /**
     * Constructs a new SdkTranscriptEvent.
     * @name SdkTranscriptEvent
     * @classdesc Represents a SdkTranscriptEvent.
     * @implements ISdkTranscriptEvent
     * @constructor
     * @param {ISdkTranscriptEvent=} [properties] Properties to set
     */ function SdkTranscriptEvent(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkTranscriptEvent status.
     * @member {ISdkTranscriptionStatus|null|undefined} status
     * @memberof SdkTranscriptEvent
     * @instance
     */ SdkTranscriptEvent.prototype.status = null;
    /**
     * SdkTranscriptEvent transcript.
     * @member {ISdkTranscript|null|undefined} transcript
     * @memberof SdkTranscriptEvent
     * @instance
     */ SdkTranscriptEvent.prototype.transcript = null;
    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;
    /**
     * SdkTranscriptEvent Event.
     * @member {"status"|"transcript"|undefined} Event
     * @memberof SdkTranscriptEvent
     * @instance
     */ Object.defineProperty(SdkTranscriptEvent.prototype, "Event", {
        get: $31e083413a0a3833$var$$util.oneOfGetter($oneOfFields = [
            "status",
            "transcript"
        ]),
        set: $31e083413a0a3833$var$$util.oneOfSetter($oneOfFields)
    });
    /**
     * Creates a new SdkTranscriptEvent instance using the specified properties.
     * @function create
     * @memberof SdkTranscriptEvent
     * @static
     * @param {ISdkTranscriptEvent=} [properties] Properties to set
     * @returns {SdkTranscriptEvent} SdkTranscriptEvent instance
     */ SdkTranscriptEvent.create = function create(properties) {
        return new SdkTranscriptEvent(properties);
    };
    /**
     * Encodes the specified SdkTranscriptEvent message. Does not implicitly {@link SdkTranscriptEvent.verify|verify} messages.
     * @function encode
     * @memberof SdkTranscriptEvent
     * @static
     * @param {ISdkTranscriptEvent} message SdkTranscriptEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptEvent.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.status != null && Object.hasOwnProperty.call(message, "status")) $31e083413a0a3833$var$$root.SdkTranscriptionStatus.encode(message.status, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.transcript != null && Object.hasOwnProperty.call(message, "transcript")) $31e083413a0a3833$var$$root.SdkTranscript.encode(message.transcript, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkTranscriptEvent message, length delimited. Does not implicitly {@link SdkTranscriptEvent.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkTranscriptEvent
     * @static
     * @param {ISdkTranscriptEvent} message SdkTranscriptEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkTranscriptEvent message from the specified reader or buffer.
     * @function decode
     * @memberof SdkTranscriptEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkTranscriptEvent} SdkTranscriptEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkTranscriptEvent();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = $31e083413a0a3833$var$$root.SdkTranscriptionStatus.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.transcript = $31e083413a0a3833$var$$root.SdkTranscript.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkTranscriptEvent message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkTranscriptEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkTranscriptEvent} SdkTranscriptEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkTranscriptEvent message.
     * @function verify
     * @memberof SdkTranscriptEvent
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkTranscriptEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        var properties = {};
        if (message.status != null && message.hasOwnProperty("status")) {
            properties.Event = 1;
            var error = $31e083413a0a3833$var$$root.SdkTranscriptionStatus.verify(message.status);
            if (error) return "status." + error;
        }
        if (message.transcript != null && message.hasOwnProperty("transcript")) {
            if (properties.Event === 1) return "Event: multiple values";
            properties.Event = 1;
            var error = $31e083413a0a3833$var$$root.SdkTranscript.verify(message.transcript);
            if (error) return "transcript." + error;
        }
        return null;
    };
    /**
     * Creates a SdkTranscriptEvent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkTranscriptEvent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkTranscriptEvent} SdkTranscriptEvent
     */ SdkTranscriptEvent.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkTranscriptEvent) return object;
        var message = new $31e083413a0a3833$var$$root.SdkTranscriptEvent();
        if (object.status != null) {
            if (typeof object.status !== "object") throw TypeError(".SdkTranscriptEvent.status: object expected");
            message.status = $31e083413a0a3833$var$$root.SdkTranscriptionStatus.fromObject(object.status);
        }
        if (object.transcript != null) {
            if (typeof object.transcript !== "object") throw TypeError(".SdkTranscriptEvent.transcript: object expected");
            message.transcript = $31e083413a0a3833$var$$root.SdkTranscript.fromObject(object.transcript);
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkTranscriptEvent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkTranscriptEvent
     * @static
     * @param {SdkTranscriptEvent} message SdkTranscriptEvent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkTranscriptEvent.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (message.status != null && message.hasOwnProperty("status")) {
            object.status = $31e083413a0a3833$var$$root.SdkTranscriptionStatus.toObject(message.status, options);
            if (options.oneofs) object.Event = "status";
        }
        if (message.transcript != null && message.hasOwnProperty("transcript")) {
            object.transcript = $31e083413a0a3833$var$$root.SdkTranscript.toObject(message.transcript, options);
            if (options.oneofs) object.Event = "transcript";
        }
        return object;
    };
    /**
     * Converts this SdkTranscriptEvent to JSON.
     * @function toJSON
     * @memberof SdkTranscriptEvent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkTranscriptEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkTranscriptEvent
     * @function getTypeUrl
     * @memberof SdkTranscriptEvent
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkTranscriptEvent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkTranscriptEvent";
    };
    return SdkTranscriptEvent;
}();
$31e083413a0a3833$var$$root.SdkTranscriptFrame = function() {
    /**
     * Properties of a SdkTranscriptFrame.
     * @name ISdkTranscriptFrame
     * @interface ISdkTranscriptFrame
     * @property {Array.<ISdkTranscriptEvent>|null} [events] SdkTranscriptFrame events
     */ /**
     * Constructs a new SdkTranscriptFrame.
     * @name SdkTranscriptFrame
     * @classdesc Represents a SdkTranscriptFrame.
     * @implements ISdkTranscriptFrame
     * @constructor
     * @param {ISdkTranscriptFrame=} [properties] Properties to set
     */ function SdkTranscriptFrame(properties) {
        this.events = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkTranscriptFrame events.
     * @member {Array.<ISdkTranscriptEvent>} events
     * @memberof SdkTranscriptFrame
     * @instance
     */ SdkTranscriptFrame.prototype.events = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkTranscriptFrame instance using the specified properties.
     * @function create
     * @memberof SdkTranscriptFrame
     * @static
     * @param {ISdkTranscriptFrame=} [properties] Properties to set
     * @returns {SdkTranscriptFrame} SdkTranscriptFrame instance
     */ SdkTranscriptFrame.create = function create(properties) {
        return new SdkTranscriptFrame(properties);
    };
    /**
     * Encodes the specified SdkTranscriptFrame message. Does not implicitly {@link SdkTranscriptFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkTranscriptFrame
     * @static
     * @param {ISdkTranscriptFrame} message SdkTranscriptFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.events != null && message.events.length) for(var i = 0; i < message.events.length; ++i)$31e083413a0a3833$var$$root.SdkTranscriptEvent.encode(message.events[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkTranscriptFrame message, length delimited. Does not implicitly {@link SdkTranscriptFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkTranscriptFrame
     * @static
     * @param {ISdkTranscriptFrame} message SdkTranscriptFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkTranscriptFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkTranscriptFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkTranscriptFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkTranscriptFrame} SdkTranscriptFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkTranscriptFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (!(message.events && message.events.length)) message.events = [];
                    message.events.push($31e083413a0a3833$var$$root.SdkTranscriptEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkTranscriptFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkTranscriptFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkTranscriptFrame} SdkTranscriptFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkTranscriptFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkTranscriptFrame message.
     * @function verify
     * @memberof SdkTranscriptFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkTranscriptFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.events != null && message.hasOwnProperty("events")) {
            if (!Array.isArray(message.events)) return "events: array expected";
            for(var i = 0; i < message.events.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkTranscriptEvent.verify(message.events[i]);
                if (error) return "events." + error;
            }
        }
        return null;
    };
    /**
     * Creates a SdkTranscriptFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkTranscriptFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkTranscriptFrame} SdkTranscriptFrame
     */ SdkTranscriptFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkTranscriptFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkTranscriptFrame();
        if (object.events) {
            if (!Array.isArray(object.events)) throw TypeError(".SdkTranscriptFrame.events: array expected");
            message.events = [];
            for(var i = 0; i < object.events.length; ++i){
                if (typeof object.events[i] !== "object") throw TypeError(".SdkTranscriptFrame.events: object expected");
                message.events[i] = $31e083413a0a3833$var$$root.SdkTranscriptEvent.fromObject(object.events[i]);
            }
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkTranscriptFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkTranscriptFrame
     * @static
     * @param {SdkTranscriptFrame} message SdkTranscriptFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkTranscriptFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.events = [];
        if (message.events && message.events.length) {
            object.events = [];
            for(var j = 0; j < message.events.length; ++j)object.events[j] = $31e083413a0a3833$var$$root.SdkTranscriptEvent.toObject(message.events[j], options);
        }
        return object;
    };
    /**
     * Converts this SdkTranscriptFrame to JSON.
     * @function toJSON
     * @memberof SdkTranscriptFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkTranscriptFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkTranscriptFrame
     * @function getTypeUrl
     * @memberof SdkTranscriptFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkTranscriptFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkTranscriptFrame";
    };
    return SdkTranscriptFrame;
}();
$31e083413a0a3833$var$$root.SdkRemoteVideoUpdateFrame = function() {
    /**
     * Properties of a SdkRemoteVideoUpdateFrame.
     * @name ISdkRemoteVideoUpdateFrame
     * @interface ISdkRemoteVideoUpdateFrame
     * @property {Array.<ISdkVideoSubscriptionConfiguration>|null} [addedOrUpdatedVideoSubscriptions] SdkRemoteVideoUpdateFrame addedOrUpdatedVideoSubscriptions
     * @property {Array.<string>|null} [removedVideoSubscriptionMids] SdkRemoteVideoUpdateFrame removedVideoSubscriptionMids
     */ /**
     * Constructs a new SdkRemoteVideoUpdateFrame.
     * @name SdkRemoteVideoUpdateFrame
     * @classdesc Represents a SdkRemoteVideoUpdateFrame.
     * @implements ISdkRemoteVideoUpdateFrame
     * @constructor
     * @param {ISdkRemoteVideoUpdateFrame=} [properties] Properties to set
     */ function SdkRemoteVideoUpdateFrame(properties) {
        this.addedOrUpdatedVideoSubscriptions = [];
        this.removedVideoSubscriptionMids = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkRemoteVideoUpdateFrame addedOrUpdatedVideoSubscriptions.
     * @member {Array.<ISdkVideoSubscriptionConfiguration>} addedOrUpdatedVideoSubscriptions
     * @memberof SdkRemoteVideoUpdateFrame
     * @instance
     */ SdkRemoteVideoUpdateFrame.prototype.addedOrUpdatedVideoSubscriptions = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkRemoteVideoUpdateFrame removedVideoSubscriptionMids.
     * @member {Array.<string>} removedVideoSubscriptionMids
     * @memberof SdkRemoteVideoUpdateFrame
     * @instance
     */ SdkRemoteVideoUpdateFrame.prototype.removedVideoSubscriptionMids = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkRemoteVideoUpdateFrame instance using the specified properties.
     * @function create
     * @memberof SdkRemoteVideoUpdateFrame
     * @static
     * @param {ISdkRemoteVideoUpdateFrame=} [properties] Properties to set
     * @returns {SdkRemoteVideoUpdateFrame} SdkRemoteVideoUpdateFrame instance
     */ SdkRemoteVideoUpdateFrame.create = function create(properties) {
        return new SdkRemoteVideoUpdateFrame(properties);
    };
    /**
     * Encodes the specified SdkRemoteVideoUpdateFrame message. Does not implicitly {@link SdkRemoteVideoUpdateFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkRemoteVideoUpdateFrame
     * @static
     * @param {ISdkRemoteVideoUpdateFrame} message SdkRemoteVideoUpdateFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkRemoteVideoUpdateFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.addedOrUpdatedVideoSubscriptions != null && message.addedOrUpdatedVideoSubscriptions.length) for(var i = 0; i < message.addedOrUpdatedVideoSubscriptions.length; ++i)$31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration.encode(message.addedOrUpdatedVideoSubscriptions[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.removedVideoSubscriptionMids != null && message.removedVideoSubscriptionMids.length) for(var i = 0; i < message.removedVideoSubscriptionMids.length; ++i)writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.removedVideoSubscriptionMids[i]);
        return writer;
    };
    /**
     * Encodes the specified SdkRemoteVideoUpdateFrame message, length delimited. Does not implicitly {@link SdkRemoteVideoUpdateFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkRemoteVideoUpdateFrame
     * @static
     * @param {ISdkRemoteVideoUpdateFrame} message SdkRemoteVideoUpdateFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkRemoteVideoUpdateFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkRemoteVideoUpdateFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkRemoteVideoUpdateFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkRemoteVideoUpdateFrame} SdkRemoteVideoUpdateFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkRemoteVideoUpdateFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkRemoteVideoUpdateFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (!(message.addedOrUpdatedVideoSubscriptions && message.addedOrUpdatedVideoSubscriptions.length)) message.addedOrUpdatedVideoSubscriptions = [];
                    message.addedOrUpdatedVideoSubscriptions.push($31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.removedVideoSubscriptionMids && message.removedVideoSubscriptionMids.length)) message.removedVideoSubscriptionMids = [];
                    message.removedVideoSubscriptionMids.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkRemoteVideoUpdateFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkRemoteVideoUpdateFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkRemoteVideoUpdateFrame} SdkRemoteVideoUpdateFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkRemoteVideoUpdateFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkRemoteVideoUpdateFrame message.
     * @function verify
     * @memberof SdkRemoteVideoUpdateFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkRemoteVideoUpdateFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.addedOrUpdatedVideoSubscriptions != null && message.hasOwnProperty("addedOrUpdatedVideoSubscriptions")) {
            if (!Array.isArray(message.addedOrUpdatedVideoSubscriptions)) return "addedOrUpdatedVideoSubscriptions: array expected";
            for(var i = 0; i < message.addedOrUpdatedVideoSubscriptions.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration.verify(message.addedOrUpdatedVideoSubscriptions[i]);
                if (error) return "addedOrUpdatedVideoSubscriptions." + error;
            }
        }
        if (message.removedVideoSubscriptionMids != null && message.hasOwnProperty("removedVideoSubscriptionMids")) {
            if (!Array.isArray(message.removedVideoSubscriptionMids)) return "removedVideoSubscriptionMids: array expected";
            for(var i = 0; i < message.removedVideoSubscriptionMids.length; ++i)if (!$31e083413a0a3833$var$$util.isString(message.removedVideoSubscriptionMids[i])) return "removedVideoSubscriptionMids: string[] expected";
        }
        return null;
    };
    /**
     * Creates a SdkRemoteVideoUpdateFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkRemoteVideoUpdateFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkRemoteVideoUpdateFrame} SdkRemoteVideoUpdateFrame
     */ SdkRemoteVideoUpdateFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkRemoteVideoUpdateFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkRemoteVideoUpdateFrame();
        if (object.addedOrUpdatedVideoSubscriptions) {
            if (!Array.isArray(object.addedOrUpdatedVideoSubscriptions)) throw TypeError(".SdkRemoteVideoUpdateFrame.addedOrUpdatedVideoSubscriptions: array expected");
            message.addedOrUpdatedVideoSubscriptions = [];
            for(var i = 0; i < object.addedOrUpdatedVideoSubscriptions.length; ++i){
                if (typeof object.addedOrUpdatedVideoSubscriptions[i] !== "object") throw TypeError(".SdkRemoteVideoUpdateFrame.addedOrUpdatedVideoSubscriptions: object expected");
                message.addedOrUpdatedVideoSubscriptions[i] = $31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration.fromObject(object.addedOrUpdatedVideoSubscriptions[i]);
            }
        }
        if (object.removedVideoSubscriptionMids) {
            if (!Array.isArray(object.removedVideoSubscriptionMids)) throw TypeError(".SdkRemoteVideoUpdateFrame.removedVideoSubscriptionMids: array expected");
            message.removedVideoSubscriptionMids = [];
            for(var i = 0; i < object.removedVideoSubscriptionMids.length; ++i)message.removedVideoSubscriptionMids[i] = String(object.removedVideoSubscriptionMids[i]);
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkRemoteVideoUpdateFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkRemoteVideoUpdateFrame
     * @static
     * @param {SdkRemoteVideoUpdateFrame} message SdkRemoteVideoUpdateFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkRemoteVideoUpdateFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.addedOrUpdatedVideoSubscriptions = [];
            object.removedVideoSubscriptionMids = [];
        }
        if (message.addedOrUpdatedVideoSubscriptions && message.addedOrUpdatedVideoSubscriptions.length) {
            object.addedOrUpdatedVideoSubscriptions = [];
            for(var j = 0; j < message.addedOrUpdatedVideoSubscriptions.length; ++j)object.addedOrUpdatedVideoSubscriptions[j] = $31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration.toObject(message.addedOrUpdatedVideoSubscriptions[j], options);
        }
        if (message.removedVideoSubscriptionMids && message.removedVideoSubscriptionMids.length) {
            object.removedVideoSubscriptionMids = [];
            for(var j = 0; j < message.removedVideoSubscriptionMids.length; ++j)object.removedVideoSubscriptionMids[j] = message.removedVideoSubscriptionMids[j];
        }
        return object;
    };
    /**
     * Converts this SdkRemoteVideoUpdateFrame to JSON.
     * @function toJSON
     * @memberof SdkRemoteVideoUpdateFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkRemoteVideoUpdateFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkRemoteVideoUpdateFrame
     * @function getTypeUrl
     * @memberof SdkRemoteVideoUpdateFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkRemoteVideoUpdateFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkRemoteVideoUpdateFrame";
    };
    return SdkRemoteVideoUpdateFrame;
}();
/**
 * SdkVideoQualityAdaptationPreference enum.
 * @name SdkVideoQualityAdaptationPreference
 * @enum {number}
 * @property {number} BALANCED=1 BALANCED value
 * @property {number} MAINTAIN_FRAMERATE=2 MAINTAIN_FRAMERATE value
 * @property {number} MAINTAIN_RESOLUTION=3 MAINTAIN_RESOLUTION value
 */ $31e083413a0a3833$var$$root.SdkVideoQualityAdaptationPreference = function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "BALANCED"] = 1;
    values[valuesById[2] = "MAINTAIN_FRAMERATE"] = 2;
    values[valuesById[3] = "MAINTAIN_RESOLUTION"] = 3;
    return values;
}();
$31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration = function() {
    /**
     * Properties of a SdkVideoSubscriptionConfiguration.
     * @name ISdkVideoSubscriptionConfiguration
     * @interface ISdkVideoSubscriptionConfiguration
     * @property {string} mid SdkVideoSubscriptionConfiguration mid
     * @property {string|null} [attendeeId] SdkVideoSubscriptionConfiguration attendeeId
     * @property {number|null} [streamId] SdkVideoSubscriptionConfiguration streamId
     * @property {number|null} [priority] SdkVideoSubscriptionConfiguration priority
     * @property {number|null} [targetBitrateKbps] SdkVideoSubscriptionConfiguration targetBitrateKbps
     * @property {number|null} [groupId] SdkVideoSubscriptionConfiguration groupId
     * @property {SdkVideoQualityAdaptationPreference|null} [qualityAdaptationPreference] SdkVideoSubscriptionConfiguration qualityAdaptationPreference
     */ /**
     * Constructs a new SdkVideoSubscriptionConfiguration.
     * @name SdkVideoSubscriptionConfiguration
     * @classdesc Represents a SdkVideoSubscriptionConfiguration.
     * @implements ISdkVideoSubscriptionConfiguration
     * @constructor
     * @param {ISdkVideoSubscriptionConfiguration=} [properties] Properties to set
     */ function SdkVideoSubscriptionConfiguration(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkVideoSubscriptionConfiguration mid.
     * @member {string} mid
     * @memberof SdkVideoSubscriptionConfiguration
     * @instance
     */ SdkVideoSubscriptionConfiguration.prototype.mid = "";
    /**
     * SdkVideoSubscriptionConfiguration attendeeId.
     * @member {string} attendeeId
     * @memberof SdkVideoSubscriptionConfiguration
     * @instance
     */ SdkVideoSubscriptionConfiguration.prototype.attendeeId = "";
    /**
     * SdkVideoSubscriptionConfiguration streamId.
     * @member {number} streamId
     * @memberof SdkVideoSubscriptionConfiguration
     * @instance
     */ SdkVideoSubscriptionConfiguration.prototype.streamId = 0;
    /**
     * SdkVideoSubscriptionConfiguration priority.
     * @member {number} priority
     * @memberof SdkVideoSubscriptionConfiguration
     * @instance
     */ SdkVideoSubscriptionConfiguration.prototype.priority = 0;
    /**
     * SdkVideoSubscriptionConfiguration targetBitrateKbps.
     * @member {number} targetBitrateKbps
     * @memberof SdkVideoSubscriptionConfiguration
     * @instance
     */ SdkVideoSubscriptionConfiguration.prototype.targetBitrateKbps = 0;
    /**
     * SdkVideoSubscriptionConfiguration groupId.
     * @member {number} groupId
     * @memberof SdkVideoSubscriptionConfiguration
     * @instance
     */ SdkVideoSubscriptionConfiguration.prototype.groupId = 0;
    /**
     * SdkVideoSubscriptionConfiguration qualityAdaptationPreference.
     * @member {SdkVideoQualityAdaptationPreference} qualityAdaptationPreference
     * @memberof SdkVideoSubscriptionConfiguration
     * @instance
     */ SdkVideoSubscriptionConfiguration.prototype.qualityAdaptationPreference = 1;
    /**
     * Creates a new SdkVideoSubscriptionConfiguration instance using the specified properties.
     * @function create
     * @memberof SdkVideoSubscriptionConfiguration
     * @static
     * @param {ISdkVideoSubscriptionConfiguration=} [properties] Properties to set
     * @returns {SdkVideoSubscriptionConfiguration} SdkVideoSubscriptionConfiguration instance
     */ SdkVideoSubscriptionConfiguration.create = function create(properties) {
        return new SdkVideoSubscriptionConfiguration(properties);
    };
    /**
     * Encodes the specified SdkVideoSubscriptionConfiguration message. Does not implicitly {@link SdkVideoSubscriptionConfiguration.verify|verify} messages.
     * @function encode
     * @memberof SdkVideoSubscriptionConfiguration
     * @static
     * @param {ISdkVideoSubscriptionConfiguration} message SdkVideoSubscriptionConfiguration message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkVideoSubscriptionConfiguration.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.mid);
        if (message.attendeeId != null && Object.hasOwnProperty.call(message, "attendeeId")) writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.attendeeId);
        if (message.streamId != null && Object.hasOwnProperty.call(message, "streamId")) writer.uint32(/* id 3, wireType 0 =*/ 24).uint32(message.streamId);
        if (message.priority != null && Object.hasOwnProperty.call(message, "priority")) writer.uint32(/* id 4, wireType 0 =*/ 32).uint32(message.priority);
        if (message.targetBitrateKbps != null && Object.hasOwnProperty.call(message, "targetBitrateKbps")) writer.uint32(/* id 5, wireType 0 =*/ 40).uint32(message.targetBitrateKbps);
        if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId")) writer.uint32(/* id 6, wireType 0 =*/ 48).uint32(message.groupId);
        if (message.qualityAdaptationPreference != null && Object.hasOwnProperty.call(message, "qualityAdaptationPreference")) writer.uint32(/* id 7, wireType 0 =*/ 56).int32(message.qualityAdaptationPreference);
        return writer;
    };
    /**
     * Encodes the specified SdkVideoSubscriptionConfiguration message, length delimited. Does not implicitly {@link SdkVideoSubscriptionConfiguration.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkVideoSubscriptionConfiguration
     * @static
     * @param {ISdkVideoSubscriptionConfiguration} message SdkVideoSubscriptionConfiguration message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkVideoSubscriptionConfiguration.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkVideoSubscriptionConfiguration message from the specified reader or buffer.
     * @function decode
     * @memberof SdkVideoSubscriptionConfiguration
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkVideoSubscriptionConfiguration} SdkVideoSubscriptionConfiguration
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkVideoSubscriptionConfiguration.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mid = reader.string();
                    break;
                case 2:
                    message.attendeeId = reader.string();
                    break;
                case 3:
                    message.streamId = reader.uint32();
                    break;
                case 4:
                    message.priority = reader.uint32();
                    break;
                case 5:
                    message.targetBitrateKbps = reader.uint32();
                    break;
                case 6:
                    message.groupId = reader.uint32();
                    break;
                case 7:
                    message.qualityAdaptationPreference = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        if (!message.hasOwnProperty("mid")) throw $31e083413a0a3833$var$$util.ProtocolError("missing required 'mid'", {
            instance: message
        });
        return message;
    };
    /**
     * Decodes a SdkVideoSubscriptionConfiguration message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkVideoSubscriptionConfiguration
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkVideoSubscriptionConfiguration} SdkVideoSubscriptionConfiguration
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkVideoSubscriptionConfiguration.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkVideoSubscriptionConfiguration message.
     * @function verify
     * @memberof SdkVideoSubscriptionConfiguration
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkVideoSubscriptionConfiguration.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (!$31e083413a0a3833$var$$util.isString(message.mid)) return "mid: string expected";
        if (message.attendeeId != null && message.hasOwnProperty("attendeeId")) {
            if (!$31e083413a0a3833$var$$util.isString(message.attendeeId)) return "attendeeId: string expected";
        }
        if (message.streamId != null && message.hasOwnProperty("streamId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.streamId)) return "streamId: integer expected";
        }
        if (message.priority != null && message.hasOwnProperty("priority")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.priority)) return "priority: integer expected";
        }
        if (message.targetBitrateKbps != null && message.hasOwnProperty("targetBitrateKbps")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.targetBitrateKbps)) return "targetBitrateKbps: integer expected";
        }
        if (message.groupId != null && message.hasOwnProperty("groupId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.groupId)) return "groupId: integer expected";
        }
        if (message.qualityAdaptationPreference != null && message.hasOwnProperty("qualityAdaptationPreference")) switch(message.qualityAdaptationPreference){
            default:
                return "qualityAdaptationPreference: enum value expected";
            case 1:
            case 2:
            case 3:
                break;
        }
        return null;
    };
    /**
     * Creates a SdkVideoSubscriptionConfiguration message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkVideoSubscriptionConfiguration
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkVideoSubscriptionConfiguration} SdkVideoSubscriptionConfiguration
     */ SdkVideoSubscriptionConfiguration.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration) return object;
        var message = new $31e083413a0a3833$var$$root.SdkVideoSubscriptionConfiguration();
        if (object.mid != null) message.mid = String(object.mid);
        if (object.attendeeId != null) message.attendeeId = String(object.attendeeId);
        if (object.streamId != null) message.streamId = object.streamId >>> 0;
        if (object.priority != null) message.priority = object.priority >>> 0;
        if (object.targetBitrateKbps != null) message.targetBitrateKbps = object.targetBitrateKbps >>> 0;
        if (object.groupId != null) message.groupId = object.groupId >>> 0;
        switch(object.qualityAdaptationPreference){
            default:
                if (typeof object.qualityAdaptationPreference === "number") {
                    message.qualityAdaptationPreference = object.qualityAdaptationPreference;
                    break;
                }
                break;
            case "BALANCED":
            case 1:
                message.qualityAdaptationPreference = 1;
                break;
            case "MAINTAIN_FRAMERATE":
            case 2:
                message.qualityAdaptationPreference = 2;
                break;
            case "MAINTAIN_RESOLUTION":
            case 3:
                message.qualityAdaptationPreference = 3;
                break;
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkVideoSubscriptionConfiguration message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkVideoSubscriptionConfiguration
     * @static
     * @param {SdkVideoSubscriptionConfiguration} message SdkVideoSubscriptionConfiguration
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkVideoSubscriptionConfiguration.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.mid = "";
            object.attendeeId = "";
            object.streamId = 0;
            object.priority = 0;
            object.targetBitrateKbps = 0;
            object.groupId = 0;
            object.qualityAdaptationPreference = options.enums === String ? "BALANCED" : 1;
        }
        if (message.mid != null && message.hasOwnProperty("mid")) object.mid = message.mid;
        if (message.attendeeId != null && message.hasOwnProperty("attendeeId")) object.attendeeId = message.attendeeId;
        if (message.streamId != null && message.hasOwnProperty("streamId")) object.streamId = message.streamId;
        if (message.priority != null && message.hasOwnProperty("priority")) object.priority = message.priority;
        if (message.targetBitrateKbps != null && message.hasOwnProperty("targetBitrateKbps")) object.targetBitrateKbps = message.targetBitrateKbps;
        if (message.groupId != null && message.hasOwnProperty("groupId")) object.groupId = message.groupId;
        if (message.qualityAdaptationPreference != null && message.hasOwnProperty("qualityAdaptationPreference")) object.qualityAdaptationPreference = options.enums === String ? $31e083413a0a3833$var$$root.SdkVideoQualityAdaptationPreference[message.qualityAdaptationPreference] === undefined ? message.qualityAdaptationPreference : $31e083413a0a3833$var$$root.SdkVideoQualityAdaptationPreference[message.qualityAdaptationPreference] : message.qualityAdaptationPreference;
        return object;
    };
    /**
     * Converts this SdkVideoSubscriptionConfiguration to JSON.
     * @function toJSON
     * @memberof SdkVideoSubscriptionConfiguration
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkVideoSubscriptionConfiguration.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkVideoSubscriptionConfiguration
     * @function getTypeUrl
     * @memberof SdkVideoSubscriptionConfiguration
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkVideoSubscriptionConfiguration.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkVideoSubscriptionConfiguration";
    };
    return SdkVideoSubscriptionConfiguration;
}();
$31e083413a0a3833$var$$root.SdkNotificationFrame = function() {
    /**
     * Properties of a SdkNotificationFrame.
     * @name ISdkNotificationFrame
     * @interface ISdkNotificationFrame
     * @property {SdkNotificationFrame.NotificationLevel|null} [level] SdkNotificationFrame level
     * @property {string|null} [message] SdkNotificationFrame message
     */ /**
     * Constructs a new SdkNotificationFrame.
     * @name SdkNotificationFrame
     * @classdesc Represents a SdkNotificationFrame.
     * @implements ISdkNotificationFrame
     * @constructor
     * @param {ISdkNotificationFrame=} [properties] Properties to set
     */ function SdkNotificationFrame(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkNotificationFrame level.
     * @member {SdkNotificationFrame.NotificationLevel} level
     * @memberof SdkNotificationFrame
     * @instance
     */ SdkNotificationFrame.prototype.level = 3;
    /**
     * SdkNotificationFrame message.
     * @member {string} message
     * @memberof SdkNotificationFrame
     * @instance
     */ SdkNotificationFrame.prototype.message = "";
    /**
     * Creates a new SdkNotificationFrame instance using the specified properties.
     * @function create
     * @memberof SdkNotificationFrame
     * @static
     * @param {ISdkNotificationFrame=} [properties] Properties to set
     * @returns {SdkNotificationFrame} SdkNotificationFrame instance
     */ SdkNotificationFrame.create = function create(properties) {
        return new SdkNotificationFrame(properties);
    };
    /**
     * Encodes the specified SdkNotificationFrame message. Does not implicitly {@link SdkNotificationFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkNotificationFrame
     * @static
     * @param {ISdkNotificationFrame} message SdkNotificationFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkNotificationFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.level != null && Object.hasOwnProperty.call(message, "level")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.level);
        if (message.message != null && Object.hasOwnProperty.call(message, "message")) writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.message);
        return writer;
    };
    /**
     * Encodes the specified SdkNotificationFrame message, length delimited. Does not implicitly {@link SdkNotificationFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkNotificationFrame
     * @static
     * @param {ISdkNotificationFrame} message SdkNotificationFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkNotificationFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkNotificationFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkNotificationFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkNotificationFrame} SdkNotificationFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkNotificationFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkNotificationFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.level = reader.int32();
                    break;
                case 2:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkNotificationFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkNotificationFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkNotificationFrame} SdkNotificationFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkNotificationFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkNotificationFrame message.
     * @function verify
     * @memberof SdkNotificationFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkNotificationFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.level != null && message.hasOwnProperty("level")) switch(message.level){
            default:
                return "level: enum value expected";
            case 1:
            case 2:
            case 3:
                break;
        }
        if (message.message != null && message.hasOwnProperty("message")) {
            if (!$31e083413a0a3833$var$$util.isString(message.message)) return "message: string expected";
        }
        return null;
    };
    /**
     * Creates a SdkNotificationFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkNotificationFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkNotificationFrame} SdkNotificationFrame
     */ SdkNotificationFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkNotificationFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkNotificationFrame();
        switch(object.level){
            case "INFO":
            case 1:
                message.level = 1;
                break;
            case "WARNING":
            case 2:
                message.level = 2;
                break;
            default:
                if (typeof object.level === "number") {
                    message.level = object.level;
                    break;
                }
                break;
            case "ERROR":
            case 3:
                message.level = 3;
                break;
        }
        if (object.message != null) message.message = String(object.message);
        return message;
    };
    /**
     * Creates a plain object from a SdkNotificationFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkNotificationFrame
     * @static
     * @param {SdkNotificationFrame} message SdkNotificationFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkNotificationFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.level = options.enums === String ? "ERROR" : 3;
            object.message = "";
        }
        if (message.level != null && message.hasOwnProperty("level")) object.level = options.enums === String ? $31e083413a0a3833$var$$root.SdkNotificationFrame.NotificationLevel[message.level] === undefined ? message.level : $31e083413a0a3833$var$$root.SdkNotificationFrame.NotificationLevel[message.level] : message.level;
        if (message.message != null && message.hasOwnProperty("message")) object.message = message.message;
        return object;
    };
    /**
     * Converts this SdkNotificationFrame to JSON.
     * @function toJSON
     * @memberof SdkNotificationFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkNotificationFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkNotificationFrame
     * @function getTypeUrl
     * @memberof SdkNotificationFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkNotificationFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkNotificationFrame";
    };
    /**
     * NotificationLevel enum.
     * @name SdkNotificationFrame.NotificationLevel
     * @enum {number}
     * @property {number} INFO=1 INFO value
     * @property {number} WARNING=2 WARNING value
     * @property {number} ERROR=3 ERROR value
     */ SdkNotificationFrame.NotificationLevel = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "INFO"] = 1;
        values[valuesById[2] = "WARNING"] = 2;
        values[valuesById[3] = "ERROR"] = 3;
        return values;
    }();
    return SdkNotificationFrame;
}();
$31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinFrame = function() {
    /**
     * Properties of a SdkPrimaryMeetingJoinFrame.
     * @name ISdkPrimaryMeetingJoinFrame
     * @interface ISdkPrimaryMeetingJoinFrame
     * @property {ISdkMeetingSessionCredentials|null} [credentials] SdkPrimaryMeetingJoinFrame credentials
     */ /**
     * Constructs a new SdkPrimaryMeetingJoinFrame.
     * @name SdkPrimaryMeetingJoinFrame
     * @classdesc Represents a SdkPrimaryMeetingJoinFrame.
     * @implements ISdkPrimaryMeetingJoinFrame
     * @constructor
     * @param {ISdkPrimaryMeetingJoinFrame=} [properties] Properties to set
     */ function SdkPrimaryMeetingJoinFrame(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkPrimaryMeetingJoinFrame credentials.
     * @member {ISdkMeetingSessionCredentials|null|undefined} credentials
     * @memberof SdkPrimaryMeetingJoinFrame
     * @instance
     */ SdkPrimaryMeetingJoinFrame.prototype.credentials = null;
    /**
     * Creates a new SdkPrimaryMeetingJoinFrame instance using the specified properties.
     * @function create
     * @memberof SdkPrimaryMeetingJoinFrame
     * @static
     * @param {ISdkPrimaryMeetingJoinFrame=} [properties] Properties to set
     * @returns {SdkPrimaryMeetingJoinFrame} SdkPrimaryMeetingJoinFrame instance
     */ SdkPrimaryMeetingJoinFrame.create = function create(properties) {
        return new SdkPrimaryMeetingJoinFrame(properties);
    };
    /**
     * Encodes the specified SdkPrimaryMeetingJoinFrame message. Does not implicitly {@link SdkPrimaryMeetingJoinFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkPrimaryMeetingJoinFrame
     * @static
     * @param {ISdkPrimaryMeetingJoinFrame} message SdkPrimaryMeetingJoinFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkPrimaryMeetingJoinFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.credentials != null && Object.hasOwnProperty.call(message, "credentials")) $31e083413a0a3833$var$$root.SdkMeetingSessionCredentials.encode(message.credentials, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkPrimaryMeetingJoinFrame message, length delimited. Does not implicitly {@link SdkPrimaryMeetingJoinFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkPrimaryMeetingJoinFrame
     * @static
     * @param {ISdkPrimaryMeetingJoinFrame} message SdkPrimaryMeetingJoinFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkPrimaryMeetingJoinFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkPrimaryMeetingJoinFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkPrimaryMeetingJoinFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkPrimaryMeetingJoinFrame} SdkPrimaryMeetingJoinFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkPrimaryMeetingJoinFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.credentials = $31e083413a0a3833$var$$root.SdkMeetingSessionCredentials.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkPrimaryMeetingJoinFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkPrimaryMeetingJoinFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkPrimaryMeetingJoinFrame} SdkPrimaryMeetingJoinFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkPrimaryMeetingJoinFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkPrimaryMeetingJoinFrame message.
     * @function verify
     * @memberof SdkPrimaryMeetingJoinFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkPrimaryMeetingJoinFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.credentials != null && message.hasOwnProperty("credentials")) {
            var error = $31e083413a0a3833$var$$root.SdkMeetingSessionCredentials.verify(message.credentials);
            if (error) return "credentials." + error;
        }
        return null;
    };
    /**
     * Creates a SdkPrimaryMeetingJoinFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkPrimaryMeetingJoinFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkPrimaryMeetingJoinFrame} SdkPrimaryMeetingJoinFrame
     */ SdkPrimaryMeetingJoinFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinFrame();
        if (object.credentials != null) {
            if (typeof object.credentials !== "object") throw TypeError(".SdkPrimaryMeetingJoinFrame.credentials: object expected");
            message.credentials = $31e083413a0a3833$var$$root.SdkMeetingSessionCredentials.fromObject(object.credentials);
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkPrimaryMeetingJoinFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkPrimaryMeetingJoinFrame
     * @static
     * @param {SdkPrimaryMeetingJoinFrame} message SdkPrimaryMeetingJoinFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkPrimaryMeetingJoinFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.credentials = null;
        if (message.credentials != null && message.hasOwnProperty("credentials")) object.credentials = $31e083413a0a3833$var$$root.SdkMeetingSessionCredentials.toObject(message.credentials, options);
        return object;
    };
    /**
     * Converts this SdkPrimaryMeetingJoinFrame to JSON.
     * @function toJSON
     * @memberof SdkPrimaryMeetingJoinFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkPrimaryMeetingJoinFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkPrimaryMeetingJoinFrame
     * @function getTypeUrl
     * @memberof SdkPrimaryMeetingJoinFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkPrimaryMeetingJoinFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkPrimaryMeetingJoinFrame";
    };
    return SdkPrimaryMeetingJoinFrame;
}();
$31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinAckFrame = function() {
    /**
     * Properties of a SdkPrimaryMeetingJoinAckFrame.
     * @name ISdkPrimaryMeetingJoinAckFrame
     * @interface ISdkPrimaryMeetingJoinAckFrame
     */ /**
     * Constructs a new SdkPrimaryMeetingJoinAckFrame.
     * @name SdkPrimaryMeetingJoinAckFrame
     * @classdesc Represents a SdkPrimaryMeetingJoinAckFrame.
     * @implements ISdkPrimaryMeetingJoinAckFrame
     * @constructor
     * @param {ISdkPrimaryMeetingJoinAckFrame=} [properties] Properties to set
     */ function SdkPrimaryMeetingJoinAckFrame(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * Creates a new SdkPrimaryMeetingJoinAckFrame instance using the specified properties.
     * @function create
     * @memberof SdkPrimaryMeetingJoinAckFrame
     * @static
     * @param {ISdkPrimaryMeetingJoinAckFrame=} [properties] Properties to set
     * @returns {SdkPrimaryMeetingJoinAckFrame} SdkPrimaryMeetingJoinAckFrame instance
     */ SdkPrimaryMeetingJoinAckFrame.create = function create(properties) {
        return new SdkPrimaryMeetingJoinAckFrame(properties);
    };
    /**
     * Encodes the specified SdkPrimaryMeetingJoinAckFrame message. Does not implicitly {@link SdkPrimaryMeetingJoinAckFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkPrimaryMeetingJoinAckFrame
     * @static
     * @param {ISdkPrimaryMeetingJoinAckFrame} message SdkPrimaryMeetingJoinAckFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkPrimaryMeetingJoinAckFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        return writer;
    };
    /**
     * Encodes the specified SdkPrimaryMeetingJoinAckFrame message, length delimited. Does not implicitly {@link SdkPrimaryMeetingJoinAckFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkPrimaryMeetingJoinAckFrame
     * @static
     * @param {ISdkPrimaryMeetingJoinAckFrame} message SdkPrimaryMeetingJoinAckFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkPrimaryMeetingJoinAckFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkPrimaryMeetingJoinAckFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkPrimaryMeetingJoinAckFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkPrimaryMeetingJoinAckFrame} SdkPrimaryMeetingJoinAckFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkPrimaryMeetingJoinAckFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinAckFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    };
    /**
     * Decodes a SdkPrimaryMeetingJoinAckFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkPrimaryMeetingJoinAckFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkPrimaryMeetingJoinAckFrame} SdkPrimaryMeetingJoinAckFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkPrimaryMeetingJoinAckFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkPrimaryMeetingJoinAckFrame message.
     * @function verify
     * @memberof SdkPrimaryMeetingJoinAckFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkPrimaryMeetingJoinAckFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        return null;
    };
    /**
     * Creates a SdkPrimaryMeetingJoinAckFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkPrimaryMeetingJoinAckFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkPrimaryMeetingJoinAckFrame} SdkPrimaryMeetingJoinAckFrame
     */ SdkPrimaryMeetingJoinAckFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinAckFrame) return object;
        return new $31e083413a0a3833$var$$root.SdkPrimaryMeetingJoinAckFrame();
    };
    /**
     * Creates a plain object from a SdkPrimaryMeetingJoinAckFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkPrimaryMeetingJoinAckFrame
     * @static
     * @param {SdkPrimaryMeetingJoinAckFrame} message SdkPrimaryMeetingJoinAckFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkPrimaryMeetingJoinAckFrame.toObject = function toObject() {
        return {};
    };
    /**
     * Converts this SdkPrimaryMeetingJoinAckFrame to JSON.
     * @function toJSON
     * @memberof SdkPrimaryMeetingJoinAckFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkPrimaryMeetingJoinAckFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkPrimaryMeetingJoinAckFrame
     * @function getTypeUrl
     * @memberof SdkPrimaryMeetingJoinAckFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkPrimaryMeetingJoinAckFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkPrimaryMeetingJoinAckFrame";
    };
    return SdkPrimaryMeetingJoinAckFrame;
}();
$31e083413a0a3833$var$$root.SdkPrimaryMeetingLeaveFrame = function() {
    /**
     * Properties of a SdkPrimaryMeetingLeaveFrame.
     * @name ISdkPrimaryMeetingLeaveFrame
     * @interface ISdkPrimaryMeetingLeaveFrame
     */ /**
     * Constructs a new SdkPrimaryMeetingLeaveFrame.
     * @name SdkPrimaryMeetingLeaveFrame
     * @classdesc Represents a SdkPrimaryMeetingLeaveFrame.
     * @implements ISdkPrimaryMeetingLeaveFrame
     * @constructor
     * @param {ISdkPrimaryMeetingLeaveFrame=} [properties] Properties to set
     */ function SdkPrimaryMeetingLeaveFrame(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * Creates a new SdkPrimaryMeetingLeaveFrame instance using the specified properties.
     * @function create
     * @memberof SdkPrimaryMeetingLeaveFrame
     * @static
     * @param {ISdkPrimaryMeetingLeaveFrame=} [properties] Properties to set
     * @returns {SdkPrimaryMeetingLeaveFrame} SdkPrimaryMeetingLeaveFrame instance
     */ SdkPrimaryMeetingLeaveFrame.create = function create(properties) {
        return new SdkPrimaryMeetingLeaveFrame(properties);
    };
    /**
     * Encodes the specified SdkPrimaryMeetingLeaveFrame message. Does not implicitly {@link SdkPrimaryMeetingLeaveFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkPrimaryMeetingLeaveFrame
     * @static
     * @param {ISdkPrimaryMeetingLeaveFrame} message SdkPrimaryMeetingLeaveFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkPrimaryMeetingLeaveFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        return writer;
    };
    /**
     * Encodes the specified SdkPrimaryMeetingLeaveFrame message, length delimited. Does not implicitly {@link SdkPrimaryMeetingLeaveFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkPrimaryMeetingLeaveFrame
     * @static
     * @param {ISdkPrimaryMeetingLeaveFrame} message SdkPrimaryMeetingLeaveFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkPrimaryMeetingLeaveFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkPrimaryMeetingLeaveFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkPrimaryMeetingLeaveFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkPrimaryMeetingLeaveFrame} SdkPrimaryMeetingLeaveFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkPrimaryMeetingLeaveFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkPrimaryMeetingLeaveFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    };
    /**
     * Decodes a SdkPrimaryMeetingLeaveFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkPrimaryMeetingLeaveFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkPrimaryMeetingLeaveFrame} SdkPrimaryMeetingLeaveFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkPrimaryMeetingLeaveFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkPrimaryMeetingLeaveFrame message.
     * @function verify
     * @memberof SdkPrimaryMeetingLeaveFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkPrimaryMeetingLeaveFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        return null;
    };
    /**
     * Creates a SdkPrimaryMeetingLeaveFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkPrimaryMeetingLeaveFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkPrimaryMeetingLeaveFrame} SdkPrimaryMeetingLeaveFrame
     */ SdkPrimaryMeetingLeaveFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkPrimaryMeetingLeaveFrame) return object;
        return new $31e083413a0a3833$var$$root.SdkPrimaryMeetingLeaveFrame();
    };
    /**
     * Creates a plain object from a SdkPrimaryMeetingLeaveFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkPrimaryMeetingLeaveFrame
     * @static
     * @param {SdkPrimaryMeetingLeaveFrame} message SdkPrimaryMeetingLeaveFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkPrimaryMeetingLeaveFrame.toObject = function toObject() {
        return {};
    };
    /**
     * Converts this SdkPrimaryMeetingLeaveFrame to JSON.
     * @function toJSON
     * @memberof SdkPrimaryMeetingLeaveFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkPrimaryMeetingLeaveFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkPrimaryMeetingLeaveFrame
     * @function getTypeUrl
     * @memberof SdkPrimaryMeetingLeaveFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkPrimaryMeetingLeaveFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkPrimaryMeetingLeaveFrame";
    };
    return SdkPrimaryMeetingLeaveFrame;
}();
$31e083413a0a3833$var$$root.SdkMeetingSessionCredentials = function() {
    /**
     * Properties of a SdkMeetingSessionCredentials.
     * @name ISdkMeetingSessionCredentials
     * @interface ISdkMeetingSessionCredentials
     * @property {string|null} [attendeeId] SdkMeetingSessionCredentials attendeeId
     * @property {string|null} [externalUserId] SdkMeetingSessionCredentials externalUserId
     * @property {string|null} [joinToken] SdkMeetingSessionCredentials joinToken
     */ /**
     * Constructs a new SdkMeetingSessionCredentials.
     * @name SdkMeetingSessionCredentials
     * @classdesc Represents a SdkMeetingSessionCredentials.
     * @implements ISdkMeetingSessionCredentials
     * @constructor
     * @param {ISdkMeetingSessionCredentials=} [properties] Properties to set
     */ function SdkMeetingSessionCredentials(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkMeetingSessionCredentials attendeeId.
     * @member {string} attendeeId
     * @memberof SdkMeetingSessionCredentials
     * @instance
     */ SdkMeetingSessionCredentials.prototype.attendeeId = "";
    /**
     * SdkMeetingSessionCredentials externalUserId.
     * @member {string} externalUserId
     * @memberof SdkMeetingSessionCredentials
     * @instance
     */ SdkMeetingSessionCredentials.prototype.externalUserId = "";
    /**
     * SdkMeetingSessionCredentials joinToken.
     * @member {string} joinToken
     * @memberof SdkMeetingSessionCredentials
     * @instance
     */ SdkMeetingSessionCredentials.prototype.joinToken = "";
    /**
     * Creates a new SdkMeetingSessionCredentials instance using the specified properties.
     * @function create
     * @memberof SdkMeetingSessionCredentials
     * @static
     * @param {ISdkMeetingSessionCredentials=} [properties] Properties to set
     * @returns {SdkMeetingSessionCredentials} SdkMeetingSessionCredentials instance
     */ SdkMeetingSessionCredentials.create = function create(properties) {
        return new SdkMeetingSessionCredentials(properties);
    };
    /**
     * Encodes the specified SdkMeetingSessionCredentials message. Does not implicitly {@link SdkMeetingSessionCredentials.verify|verify} messages.
     * @function encode
     * @memberof SdkMeetingSessionCredentials
     * @static
     * @param {ISdkMeetingSessionCredentials} message SdkMeetingSessionCredentials message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionCredentials.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.attendeeId != null && Object.hasOwnProperty.call(message, "attendeeId")) writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.attendeeId);
        if (message.externalUserId != null && Object.hasOwnProperty.call(message, "externalUserId")) writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.externalUserId);
        if (message.joinToken != null && Object.hasOwnProperty.call(message, "joinToken")) writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.joinToken);
        return writer;
    };
    /**
     * Encodes the specified SdkMeetingSessionCredentials message, length delimited. Does not implicitly {@link SdkMeetingSessionCredentials.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkMeetingSessionCredentials
     * @static
     * @param {ISdkMeetingSessionCredentials} message SdkMeetingSessionCredentials message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionCredentials.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkMeetingSessionCredentials message from the specified reader or buffer.
     * @function decode
     * @memberof SdkMeetingSessionCredentials
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkMeetingSessionCredentials} SdkMeetingSessionCredentials
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionCredentials.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkMeetingSessionCredentials();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.attendeeId = reader.string();
                    break;
                case 2:
                    message.externalUserId = reader.string();
                    break;
                case 3:
                    message.joinToken = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkMeetingSessionCredentials message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkMeetingSessionCredentials
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkMeetingSessionCredentials} SdkMeetingSessionCredentials
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionCredentials.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkMeetingSessionCredentials message.
     * @function verify
     * @memberof SdkMeetingSessionCredentials
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkMeetingSessionCredentials.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.attendeeId != null && message.hasOwnProperty("attendeeId")) {
            if (!$31e083413a0a3833$var$$util.isString(message.attendeeId)) return "attendeeId: string expected";
        }
        if (message.externalUserId != null && message.hasOwnProperty("externalUserId")) {
            if (!$31e083413a0a3833$var$$util.isString(message.externalUserId)) return "externalUserId: string expected";
        }
        if (message.joinToken != null && message.hasOwnProperty("joinToken")) {
            if (!$31e083413a0a3833$var$$util.isString(message.joinToken)) return "joinToken: string expected";
        }
        return null;
    };
    /**
     * Creates a SdkMeetingSessionCredentials message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkMeetingSessionCredentials
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkMeetingSessionCredentials} SdkMeetingSessionCredentials
     */ SdkMeetingSessionCredentials.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkMeetingSessionCredentials) return object;
        var message = new $31e083413a0a3833$var$$root.SdkMeetingSessionCredentials();
        if (object.attendeeId != null) message.attendeeId = String(object.attendeeId);
        if (object.externalUserId != null) message.externalUserId = String(object.externalUserId);
        if (object.joinToken != null) message.joinToken = String(object.joinToken);
        return message;
    };
    /**
     * Creates a plain object from a SdkMeetingSessionCredentials message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkMeetingSessionCredentials
     * @static
     * @param {SdkMeetingSessionCredentials} message SdkMeetingSessionCredentials
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkMeetingSessionCredentials.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.attendeeId = "";
            object.externalUserId = "";
            object.joinToken = "";
        }
        if (message.attendeeId != null && message.hasOwnProperty("attendeeId")) object.attendeeId = message.attendeeId;
        if (message.externalUserId != null && message.hasOwnProperty("externalUserId")) object.externalUserId = message.externalUserId;
        if (message.joinToken != null && message.hasOwnProperty("joinToken")) object.joinToken = message.joinToken;
        return object;
    };
    /**
     * Converts this SdkMeetingSessionCredentials to JSON.
     * @function toJSON
     * @memberof SdkMeetingSessionCredentials
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkMeetingSessionCredentials.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkMeetingSessionCredentials
     * @function getTypeUrl
     * @memberof SdkMeetingSessionCredentials
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkMeetingSessionCredentials.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkMeetingSessionCredentials";
    };
    return SdkMeetingSessionCredentials;
}();
/**
 * SdkVideoCodecCapability enum.
 * @name SdkVideoCodecCapability
 * @enum {number}
 * @property {number} VP8=1 VP8 value
 * @property {number} H264_BASELINE_PROFILE=2 H264_BASELINE_PROFILE value
 * @property {number} H264_CONSTRAINED_BASELINE_PROFILE=3 H264_CONSTRAINED_BASELINE_PROFILE value
 * @property {number} H264_MAIN_PROFILE=4 H264_MAIN_PROFILE value
 * @property {number} H264_HIGH_PROFILE=5 H264_HIGH_PROFILE value
 * @property {number} H264_CONSTRAINED_HIGH_PROFILE=6 H264_CONSTRAINED_HIGH_PROFILE value
 * @property {number} VP9_PROFILE_0=8 VP9_PROFILE_0 value
 * @property {number} AV1_MAIN_PROFILE=11 AV1_MAIN_PROFILE value
 */ $31e083413a0a3833$var$$root.SdkVideoCodecCapability = function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "VP8"] = 1;
    values[valuesById[2] = "H264_BASELINE_PROFILE"] = 2;
    values[valuesById[3] = "H264_CONSTRAINED_BASELINE_PROFILE"] = 3;
    values[valuesById[4] = "H264_MAIN_PROFILE"] = 4;
    values[valuesById[5] = "H264_HIGH_PROFILE"] = 5;
    values[valuesById[6] = "H264_CONSTRAINED_HIGH_PROFILE"] = 6;
    values[valuesById[8] = "VP9_PROFILE_0"] = 8;
    values[valuesById[11] = "AV1_MAIN_PROFILE"] = 11;
    return values;
}();
$31e083413a0a3833$var$$root.SdkMeetingSessionTimingFrame = function() {
    /**
     * Properties of a SdkMeetingSessionTimingFrame.
     * @name ISdkMeetingSessionTimingFrame
     * @interface ISdkMeetingSessionTimingFrame
     * @property {Array.<ISdkMeetingSessionSignalingTiming>|null} [signaling] SdkMeetingSessionTimingFrame signaling
     * @property {Array.<ISdkMeetingSessionRemoteAudioTiming>|null} [remoteAudio] SdkMeetingSessionTimingFrame remoteAudio
     * @property {Array.<ISdkMeetingSessionLocalAudioTiming>|null} [localAudio] SdkMeetingSessionTimingFrame localAudio
     * @property {Array.<ISdkMeetingSessionLocalVideoTiming>|null} [localVideo] SdkMeetingSessionTimingFrame localVideo
     * @property {Array.<ISdkMeetingSessionRemoteVideoTiming>|null} [remoteVideos] SdkMeetingSessionTimingFrame remoteVideos
     */ /**
     * Constructs a new SdkMeetingSessionTimingFrame.
     * @name SdkMeetingSessionTimingFrame
     * @classdesc Represents a SdkMeetingSessionTimingFrame.
     * @implements ISdkMeetingSessionTimingFrame
     * @constructor
     * @param {ISdkMeetingSessionTimingFrame=} [properties] Properties to set
     */ function SdkMeetingSessionTimingFrame(properties) {
        this.signaling = [];
        this.remoteAudio = [];
        this.localAudio = [];
        this.localVideo = [];
        this.remoteVideos = [];
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkMeetingSessionTimingFrame signaling.
     * @member {Array.<ISdkMeetingSessionSignalingTiming>} signaling
     * @memberof SdkMeetingSessionTimingFrame
     * @instance
     */ SdkMeetingSessionTimingFrame.prototype.signaling = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkMeetingSessionTimingFrame remoteAudio.
     * @member {Array.<ISdkMeetingSessionRemoteAudioTiming>} remoteAudio
     * @memberof SdkMeetingSessionTimingFrame
     * @instance
     */ SdkMeetingSessionTimingFrame.prototype.remoteAudio = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkMeetingSessionTimingFrame localAudio.
     * @member {Array.<ISdkMeetingSessionLocalAudioTiming>} localAudio
     * @memberof SdkMeetingSessionTimingFrame
     * @instance
     */ SdkMeetingSessionTimingFrame.prototype.localAudio = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkMeetingSessionTimingFrame localVideo.
     * @member {Array.<ISdkMeetingSessionLocalVideoTiming>} localVideo
     * @memberof SdkMeetingSessionTimingFrame
     * @instance
     */ SdkMeetingSessionTimingFrame.prototype.localVideo = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * SdkMeetingSessionTimingFrame remoteVideos.
     * @member {Array.<ISdkMeetingSessionRemoteVideoTiming>} remoteVideos
     * @memberof SdkMeetingSessionTimingFrame
     * @instance
     */ SdkMeetingSessionTimingFrame.prototype.remoteVideos = $31e083413a0a3833$var$$util.emptyArray;
    /**
     * Creates a new SdkMeetingSessionTimingFrame instance using the specified properties.
     * @function create
     * @memberof SdkMeetingSessionTimingFrame
     * @static
     * @param {ISdkMeetingSessionTimingFrame=} [properties] Properties to set
     * @returns {SdkMeetingSessionTimingFrame} SdkMeetingSessionTimingFrame instance
     */ SdkMeetingSessionTimingFrame.create = function create(properties) {
        return new SdkMeetingSessionTimingFrame(properties);
    };
    /**
     * Encodes the specified SdkMeetingSessionTimingFrame message. Does not implicitly {@link SdkMeetingSessionTimingFrame.verify|verify} messages.
     * @function encode
     * @memberof SdkMeetingSessionTimingFrame
     * @static
     * @param {ISdkMeetingSessionTimingFrame} message SdkMeetingSessionTimingFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionTimingFrame.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.signaling != null && message.signaling.length) for(var i = 0; i < message.signaling.length; ++i)$31e083413a0a3833$var$$root.SdkMeetingSessionSignalingTiming.encode(message.signaling[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.remoteAudio != null && message.remoteAudio.length) for(var i = 0; i < message.remoteAudio.length; ++i)$31e083413a0a3833$var$$root.SdkMeetingSessionRemoteAudioTiming.encode(message.remoteAudio[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
        if (message.localAudio != null && message.localAudio.length) for(var i = 0; i < message.localAudio.length; ++i)$31e083413a0a3833$var$$root.SdkMeetingSessionLocalAudioTiming.encode(message.localAudio[i], writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
        if (message.localVideo != null && message.localVideo.length) for(var i = 0; i < message.localVideo.length; ++i)$31e083413a0a3833$var$$root.SdkMeetingSessionLocalVideoTiming.encode(message.localVideo[i], writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
        if (message.remoteVideos != null && message.remoteVideos.length) for(var i = 0; i < message.remoteVideos.length; ++i)$31e083413a0a3833$var$$root.SdkMeetingSessionRemoteVideoTiming.encode(message.remoteVideos[i], writer.uint32(/* id 5, wireType 2 =*/ 42).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified SdkMeetingSessionTimingFrame message, length delimited. Does not implicitly {@link SdkMeetingSessionTimingFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkMeetingSessionTimingFrame
     * @static
     * @param {ISdkMeetingSessionTimingFrame} message SdkMeetingSessionTimingFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionTimingFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkMeetingSessionTimingFrame message from the specified reader or buffer.
     * @function decode
     * @memberof SdkMeetingSessionTimingFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkMeetingSessionTimingFrame} SdkMeetingSessionTimingFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionTimingFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkMeetingSessionTimingFrame();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (!(message.signaling && message.signaling.length)) message.signaling = [];
                    message.signaling.push($31e083413a0a3833$var$$root.SdkMeetingSessionSignalingTiming.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.remoteAudio && message.remoteAudio.length)) message.remoteAudio = [];
                    message.remoteAudio.push($31e083413a0a3833$var$$root.SdkMeetingSessionRemoteAudioTiming.decode(reader, reader.uint32()));
                    break;
                case 3:
                    if (!(message.localAudio && message.localAudio.length)) message.localAudio = [];
                    message.localAudio.push($31e083413a0a3833$var$$root.SdkMeetingSessionLocalAudioTiming.decode(reader, reader.uint32()));
                    break;
                case 4:
                    if (!(message.localVideo && message.localVideo.length)) message.localVideo = [];
                    message.localVideo.push($31e083413a0a3833$var$$root.SdkMeetingSessionLocalVideoTiming.decode(reader, reader.uint32()));
                    break;
                case 5:
                    if (!(message.remoteVideos && message.remoteVideos.length)) message.remoteVideos = [];
                    message.remoteVideos.push($31e083413a0a3833$var$$root.SdkMeetingSessionRemoteVideoTiming.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkMeetingSessionTimingFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkMeetingSessionTimingFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkMeetingSessionTimingFrame} SdkMeetingSessionTimingFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionTimingFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkMeetingSessionTimingFrame message.
     * @function verify
     * @memberof SdkMeetingSessionTimingFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkMeetingSessionTimingFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.signaling != null && message.hasOwnProperty("signaling")) {
            if (!Array.isArray(message.signaling)) return "signaling: array expected";
            for(var i = 0; i < message.signaling.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkMeetingSessionSignalingTiming.verify(message.signaling[i]);
                if (error) return "signaling." + error;
            }
        }
        if (message.remoteAudio != null && message.hasOwnProperty("remoteAudio")) {
            if (!Array.isArray(message.remoteAudio)) return "remoteAudio: array expected";
            for(var i = 0; i < message.remoteAudio.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkMeetingSessionRemoteAudioTiming.verify(message.remoteAudio[i]);
                if (error) return "remoteAudio." + error;
            }
        }
        if (message.localAudio != null && message.hasOwnProperty("localAudio")) {
            if (!Array.isArray(message.localAudio)) return "localAudio: array expected";
            for(var i = 0; i < message.localAudio.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkMeetingSessionLocalAudioTiming.verify(message.localAudio[i]);
                if (error) return "localAudio." + error;
            }
        }
        if (message.localVideo != null && message.hasOwnProperty("localVideo")) {
            if (!Array.isArray(message.localVideo)) return "localVideo: array expected";
            for(var i = 0; i < message.localVideo.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkMeetingSessionLocalVideoTiming.verify(message.localVideo[i]);
                if (error) return "localVideo." + error;
            }
        }
        if (message.remoteVideos != null && message.hasOwnProperty("remoteVideos")) {
            if (!Array.isArray(message.remoteVideos)) return "remoteVideos: array expected";
            for(var i = 0; i < message.remoteVideos.length; ++i){
                var error = $31e083413a0a3833$var$$root.SdkMeetingSessionRemoteVideoTiming.verify(message.remoteVideos[i]);
                if (error) return "remoteVideos." + error;
            }
        }
        return null;
    };
    /**
     * Creates a SdkMeetingSessionTimingFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkMeetingSessionTimingFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkMeetingSessionTimingFrame} SdkMeetingSessionTimingFrame
     */ SdkMeetingSessionTimingFrame.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkMeetingSessionTimingFrame) return object;
        var message = new $31e083413a0a3833$var$$root.SdkMeetingSessionTimingFrame();
        if (object.signaling) {
            if (!Array.isArray(object.signaling)) throw TypeError(".SdkMeetingSessionTimingFrame.signaling: array expected");
            message.signaling = [];
            for(var i = 0; i < object.signaling.length; ++i){
                if (typeof object.signaling[i] !== "object") throw TypeError(".SdkMeetingSessionTimingFrame.signaling: object expected");
                message.signaling[i] = $31e083413a0a3833$var$$root.SdkMeetingSessionSignalingTiming.fromObject(object.signaling[i]);
            }
        }
        if (object.remoteAudio) {
            if (!Array.isArray(object.remoteAudio)) throw TypeError(".SdkMeetingSessionTimingFrame.remoteAudio: array expected");
            message.remoteAudio = [];
            for(var i = 0; i < object.remoteAudio.length; ++i){
                if (typeof object.remoteAudio[i] !== "object") throw TypeError(".SdkMeetingSessionTimingFrame.remoteAudio: object expected");
                message.remoteAudio[i] = $31e083413a0a3833$var$$root.SdkMeetingSessionRemoteAudioTiming.fromObject(object.remoteAudio[i]);
            }
        }
        if (object.localAudio) {
            if (!Array.isArray(object.localAudio)) throw TypeError(".SdkMeetingSessionTimingFrame.localAudio: array expected");
            message.localAudio = [];
            for(var i = 0; i < object.localAudio.length; ++i){
                if (typeof object.localAudio[i] !== "object") throw TypeError(".SdkMeetingSessionTimingFrame.localAudio: object expected");
                message.localAudio[i] = $31e083413a0a3833$var$$root.SdkMeetingSessionLocalAudioTiming.fromObject(object.localAudio[i]);
            }
        }
        if (object.localVideo) {
            if (!Array.isArray(object.localVideo)) throw TypeError(".SdkMeetingSessionTimingFrame.localVideo: array expected");
            message.localVideo = [];
            for(var i = 0; i < object.localVideo.length; ++i){
                if (typeof object.localVideo[i] !== "object") throw TypeError(".SdkMeetingSessionTimingFrame.localVideo: object expected");
                message.localVideo[i] = $31e083413a0a3833$var$$root.SdkMeetingSessionLocalVideoTiming.fromObject(object.localVideo[i]);
            }
        }
        if (object.remoteVideos) {
            if (!Array.isArray(object.remoteVideos)) throw TypeError(".SdkMeetingSessionTimingFrame.remoteVideos: array expected");
            message.remoteVideos = [];
            for(var i = 0; i < object.remoteVideos.length; ++i){
                if (typeof object.remoteVideos[i] !== "object") throw TypeError(".SdkMeetingSessionTimingFrame.remoteVideos: object expected");
                message.remoteVideos[i] = $31e083413a0a3833$var$$root.SdkMeetingSessionRemoteVideoTiming.fromObject(object.remoteVideos[i]);
            }
        }
        return message;
    };
    /**
     * Creates a plain object from a SdkMeetingSessionTimingFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkMeetingSessionTimingFrame
     * @static
     * @param {SdkMeetingSessionTimingFrame} message SdkMeetingSessionTimingFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkMeetingSessionTimingFrame.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.signaling = [];
            object.remoteAudio = [];
            object.localAudio = [];
            object.localVideo = [];
            object.remoteVideos = [];
        }
        if (message.signaling && message.signaling.length) {
            object.signaling = [];
            for(var j = 0; j < message.signaling.length; ++j)object.signaling[j] = $31e083413a0a3833$var$$root.SdkMeetingSessionSignalingTiming.toObject(message.signaling[j], options);
        }
        if (message.remoteAudio && message.remoteAudio.length) {
            object.remoteAudio = [];
            for(var j = 0; j < message.remoteAudio.length; ++j)object.remoteAudio[j] = $31e083413a0a3833$var$$root.SdkMeetingSessionRemoteAudioTiming.toObject(message.remoteAudio[j], options);
        }
        if (message.localAudio && message.localAudio.length) {
            object.localAudio = [];
            for(var j = 0; j < message.localAudio.length; ++j)object.localAudio[j] = $31e083413a0a3833$var$$root.SdkMeetingSessionLocalAudioTiming.toObject(message.localAudio[j], options);
        }
        if (message.localVideo && message.localVideo.length) {
            object.localVideo = [];
            for(var j = 0; j < message.localVideo.length; ++j)object.localVideo[j] = $31e083413a0a3833$var$$root.SdkMeetingSessionLocalVideoTiming.toObject(message.localVideo[j], options);
        }
        if (message.remoteVideos && message.remoteVideos.length) {
            object.remoteVideos = [];
            for(var j = 0; j < message.remoteVideos.length; ++j)object.remoteVideos[j] = $31e083413a0a3833$var$$root.SdkMeetingSessionRemoteVideoTiming.toObject(message.remoteVideos[j], options);
        }
        return object;
    };
    /**
     * Converts this SdkMeetingSessionTimingFrame to JSON.
     * @function toJSON
     * @memberof SdkMeetingSessionTimingFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkMeetingSessionTimingFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkMeetingSessionTimingFrame
     * @function getTypeUrl
     * @memberof SdkMeetingSessionTimingFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkMeetingSessionTimingFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkMeetingSessionTimingFrame";
    };
    return SdkMeetingSessionTimingFrame;
}();
$31e083413a0a3833$var$$root.SdkMeetingSessionSignalingTiming = function() {
    /**
     * Properties of a SdkMeetingSessionSignalingTiming.
     * @name ISdkMeetingSessionSignalingTiming
     * @interface ISdkMeetingSessionSignalingTiming
     * @property {number|Long|null} [startMs] SdkMeetingSessionSignalingTiming startMs
     * @property {number|Long|null} [joinSentMs] SdkMeetingSessionSignalingTiming joinSentMs
     * @property {number|Long|null} [joinAckReceivedMs] SdkMeetingSessionSignalingTiming joinAckReceivedMs
     * @property {number|Long|null} [transportConnectedMs] SdkMeetingSessionSignalingTiming transportConnectedMs
     * @property {number|Long|null} [createOfferMs] SdkMeetingSessionSignalingTiming createOfferMs
     * @property {number|Long|null} [setLocalDescriptionMs] SdkMeetingSessionSignalingTiming setLocalDescriptionMs
     * @property {number|Long|null} [setRemoteDescriptionMs] SdkMeetingSessionSignalingTiming setRemoteDescriptionMs
     * @property {number|Long|null} [iceGatheringStartMs] SdkMeetingSessionSignalingTiming iceGatheringStartMs
     * @property {number|Long|null} [iceGatheringCompleteMs] SdkMeetingSessionSignalingTiming iceGatheringCompleteMs
     * @property {number|Long|null} [iceConnectedMs] SdkMeetingSessionSignalingTiming iceConnectedMs
     * @property {number|Long|null} [subscribeSentMs] SdkMeetingSessionSignalingTiming subscribeSentMs
     * @property {number|Long|null} [subscribeAckMs] SdkMeetingSessionSignalingTiming subscribeAckMs
     * @property {boolean|null} [timedOut] SdkMeetingSessionSignalingTiming timedOut
     */ /**
     * Constructs a new SdkMeetingSessionSignalingTiming.
     * @name SdkMeetingSessionSignalingTiming
     * @classdesc Represents a SdkMeetingSessionSignalingTiming.
     * @implements ISdkMeetingSessionSignalingTiming
     * @constructor
     * @param {ISdkMeetingSessionSignalingTiming=} [properties] Properties to set
     */ function SdkMeetingSessionSignalingTiming(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkMeetingSessionSignalingTiming startMs.
     * @member {number|Long} startMs
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     */ SdkMeetingSessionSignalingTiming.prototype.startMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionSignalingTiming joinSentMs.
     * @member {number|Long} joinSentMs
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     */ SdkMeetingSessionSignalingTiming.prototype.joinSentMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionSignalingTiming joinAckReceivedMs.
     * @member {number|Long} joinAckReceivedMs
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     */ SdkMeetingSessionSignalingTiming.prototype.joinAckReceivedMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionSignalingTiming transportConnectedMs.
     * @member {number|Long} transportConnectedMs
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     */ SdkMeetingSessionSignalingTiming.prototype.transportConnectedMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionSignalingTiming createOfferMs.
     * @member {number|Long} createOfferMs
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     */ SdkMeetingSessionSignalingTiming.prototype.createOfferMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionSignalingTiming setLocalDescriptionMs.
     * @member {number|Long} setLocalDescriptionMs
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     */ SdkMeetingSessionSignalingTiming.prototype.setLocalDescriptionMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionSignalingTiming setRemoteDescriptionMs.
     * @member {number|Long} setRemoteDescriptionMs
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     */ SdkMeetingSessionSignalingTiming.prototype.setRemoteDescriptionMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionSignalingTiming iceGatheringStartMs.
     * @member {number|Long} iceGatheringStartMs
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     */ SdkMeetingSessionSignalingTiming.prototype.iceGatheringStartMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionSignalingTiming iceGatheringCompleteMs.
     * @member {number|Long} iceGatheringCompleteMs
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     */ SdkMeetingSessionSignalingTiming.prototype.iceGatheringCompleteMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionSignalingTiming iceConnectedMs.
     * @member {number|Long} iceConnectedMs
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     */ SdkMeetingSessionSignalingTiming.prototype.iceConnectedMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionSignalingTiming subscribeSentMs.
     * @member {number|Long} subscribeSentMs
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     */ SdkMeetingSessionSignalingTiming.prototype.subscribeSentMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionSignalingTiming subscribeAckMs.
     * @member {number|Long} subscribeAckMs
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     */ SdkMeetingSessionSignalingTiming.prototype.subscribeAckMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionSignalingTiming timedOut.
     * @member {boolean} timedOut
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     */ SdkMeetingSessionSignalingTiming.prototype.timedOut = false;
    /**
     * Creates a new SdkMeetingSessionSignalingTiming instance using the specified properties.
     * @function create
     * @memberof SdkMeetingSessionSignalingTiming
     * @static
     * @param {ISdkMeetingSessionSignalingTiming=} [properties] Properties to set
     * @returns {SdkMeetingSessionSignalingTiming} SdkMeetingSessionSignalingTiming instance
     */ SdkMeetingSessionSignalingTiming.create = function create(properties) {
        return new SdkMeetingSessionSignalingTiming(properties);
    };
    /**
     * Encodes the specified SdkMeetingSessionSignalingTiming message. Does not implicitly {@link SdkMeetingSessionSignalingTiming.verify|verify} messages.
     * @function encode
     * @memberof SdkMeetingSessionSignalingTiming
     * @static
     * @param {ISdkMeetingSessionSignalingTiming} message SdkMeetingSessionSignalingTiming message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionSignalingTiming.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.startMs != null && Object.hasOwnProperty.call(message, "startMs")) writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.startMs);
        if (message.joinSentMs != null && Object.hasOwnProperty.call(message, "joinSentMs")) writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.joinSentMs);
        if (message.joinAckReceivedMs != null && Object.hasOwnProperty.call(message, "joinAckReceivedMs")) writer.uint32(/* id 3, wireType 0 =*/ 24).int64(message.joinAckReceivedMs);
        if (message.transportConnectedMs != null && Object.hasOwnProperty.call(message, "transportConnectedMs")) writer.uint32(/* id 4, wireType 0 =*/ 32).int64(message.transportConnectedMs);
        if (message.createOfferMs != null && Object.hasOwnProperty.call(message, "createOfferMs")) writer.uint32(/* id 5, wireType 0 =*/ 40).int64(message.createOfferMs);
        if (message.setLocalDescriptionMs != null && Object.hasOwnProperty.call(message, "setLocalDescriptionMs")) writer.uint32(/* id 6, wireType 0 =*/ 48).int64(message.setLocalDescriptionMs);
        if (message.setRemoteDescriptionMs != null && Object.hasOwnProperty.call(message, "setRemoteDescriptionMs")) writer.uint32(/* id 7, wireType 0 =*/ 56).int64(message.setRemoteDescriptionMs);
        if (message.iceGatheringStartMs != null && Object.hasOwnProperty.call(message, "iceGatheringStartMs")) writer.uint32(/* id 8, wireType 0 =*/ 64).int64(message.iceGatheringStartMs);
        if (message.iceGatheringCompleteMs != null && Object.hasOwnProperty.call(message, "iceGatheringCompleteMs")) writer.uint32(/* id 9, wireType 0 =*/ 72).int64(message.iceGatheringCompleteMs);
        if (message.iceConnectedMs != null && Object.hasOwnProperty.call(message, "iceConnectedMs")) writer.uint32(/* id 10, wireType 0 =*/ 80).int64(message.iceConnectedMs);
        if (message.subscribeSentMs != null && Object.hasOwnProperty.call(message, "subscribeSentMs")) writer.uint32(/* id 11, wireType 0 =*/ 88).int64(message.subscribeSentMs);
        if (message.subscribeAckMs != null && Object.hasOwnProperty.call(message, "subscribeAckMs")) writer.uint32(/* id 12, wireType 0 =*/ 96).int64(message.subscribeAckMs);
        if (message.timedOut != null && Object.hasOwnProperty.call(message, "timedOut")) writer.uint32(/* id 13, wireType 0 =*/ 104).bool(message.timedOut);
        return writer;
    };
    /**
     * Encodes the specified SdkMeetingSessionSignalingTiming message, length delimited. Does not implicitly {@link SdkMeetingSessionSignalingTiming.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkMeetingSessionSignalingTiming
     * @static
     * @param {ISdkMeetingSessionSignalingTiming} message SdkMeetingSessionSignalingTiming message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionSignalingTiming.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkMeetingSessionSignalingTiming message from the specified reader or buffer.
     * @function decode
     * @memberof SdkMeetingSessionSignalingTiming
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkMeetingSessionSignalingTiming} SdkMeetingSessionSignalingTiming
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionSignalingTiming.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkMeetingSessionSignalingTiming();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.startMs = reader.int64();
                    break;
                case 2:
                    message.joinSentMs = reader.int64();
                    break;
                case 3:
                    message.joinAckReceivedMs = reader.int64();
                    break;
                case 4:
                    message.transportConnectedMs = reader.int64();
                    break;
                case 5:
                    message.createOfferMs = reader.int64();
                    break;
                case 6:
                    message.setLocalDescriptionMs = reader.int64();
                    break;
                case 7:
                    message.setRemoteDescriptionMs = reader.int64();
                    break;
                case 8:
                    message.iceGatheringStartMs = reader.int64();
                    break;
                case 9:
                    message.iceGatheringCompleteMs = reader.int64();
                    break;
                case 10:
                    message.iceConnectedMs = reader.int64();
                    break;
                case 11:
                    message.subscribeSentMs = reader.int64();
                    break;
                case 12:
                    message.subscribeAckMs = reader.int64();
                    break;
                case 13:
                    message.timedOut = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkMeetingSessionSignalingTiming message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkMeetingSessionSignalingTiming
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkMeetingSessionSignalingTiming} SdkMeetingSessionSignalingTiming
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionSignalingTiming.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkMeetingSessionSignalingTiming message.
     * @function verify
     * @memberof SdkMeetingSessionSignalingTiming
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkMeetingSessionSignalingTiming.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.startMs != null && message.hasOwnProperty("startMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.startMs) && !(message.startMs && $31e083413a0a3833$var$$util.isInteger(message.startMs.low) && $31e083413a0a3833$var$$util.isInteger(message.startMs.high))) return "startMs: integer|Long expected";
        }
        if (message.joinSentMs != null && message.hasOwnProperty("joinSentMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.joinSentMs) && !(message.joinSentMs && $31e083413a0a3833$var$$util.isInteger(message.joinSentMs.low) && $31e083413a0a3833$var$$util.isInteger(message.joinSentMs.high))) return "joinSentMs: integer|Long expected";
        }
        if (message.joinAckReceivedMs != null && message.hasOwnProperty("joinAckReceivedMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.joinAckReceivedMs) && !(message.joinAckReceivedMs && $31e083413a0a3833$var$$util.isInteger(message.joinAckReceivedMs.low) && $31e083413a0a3833$var$$util.isInteger(message.joinAckReceivedMs.high))) return "joinAckReceivedMs: integer|Long expected";
        }
        if (message.transportConnectedMs != null && message.hasOwnProperty("transportConnectedMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.transportConnectedMs) && !(message.transportConnectedMs && $31e083413a0a3833$var$$util.isInteger(message.transportConnectedMs.low) && $31e083413a0a3833$var$$util.isInteger(message.transportConnectedMs.high))) return "transportConnectedMs: integer|Long expected";
        }
        if (message.createOfferMs != null && message.hasOwnProperty("createOfferMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.createOfferMs) && !(message.createOfferMs && $31e083413a0a3833$var$$util.isInteger(message.createOfferMs.low) && $31e083413a0a3833$var$$util.isInteger(message.createOfferMs.high))) return "createOfferMs: integer|Long expected";
        }
        if (message.setLocalDescriptionMs != null && message.hasOwnProperty("setLocalDescriptionMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.setLocalDescriptionMs) && !(message.setLocalDescriptionMs && $31e083413a0a3833$var$$util.isInteger(message.setLocalDescriptionMs.low) && $31e083413a0a3833$var$$util.isInteger(message.setLocalDescriptionMs.high))) return "setLocalDescriptionMs: integer|Long expected";
        }
        if (message.setRemoteDescriptionMs != null && message.hasOwnProperty("setRemoteDescriptionMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.setRemoteDescriptionMs) && !(message.setRemoteDescriptionMs && $31e083413a0a3833$var$$util.isInteger(message.setRemoteDescriptionMs.low) && $31e083413a0a3833$var$$util.isInteger(message.setRemoteDescriptionMs.high))) return "setRemoteDescriptionMs: integer|Long expected";
        }
        if (message.iceGatheringStartMs != null && message.hasOwnProperty("iceGatheringStartMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.iceGatheringStartMs) && !(message.iceGatheringStartMs && $31e083413a0a3833$var$$util.isInteger(message.iceGatheringStartMs.low) && $31e083413a0a3833$var$$util.isInteger(message.iceGatheringStartMs.high))) return "iceGatheringStartMs: integer|Long expected";
        }
        if (message.iceGatheringCompleteMs != null && message.hasOwnProperty("iceGatheringCompleteMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.iceGatheringCompleteMs) && !(message.iceGatheringCompleteMs && $31e083413a0a3833$var$$util.isInteger(message.iceGatheringCompleteMs.low) && $31e083413a0a3833$var$$util.isInteger(message.iceGatheringCompleteMs.high))) return "iceGatheringCompleteMs: integer|Long expected";
        }
        if (message.iceConnectedMs != null && message.hasOwnProperty("iceConnectedMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.iceConnectedMs) && !(message.iceConnectedMs && $31e083413a0a3833$var$$util.isInteger(message.iceConnectedMs.low) && $31e083413a0a3833$var$$util.isInteger(message.iceConnectedMs.high))) return "iceConnectedMs: integer|Long expected";
        }
        if (message.subscribeSentMs != null && message.hasOwnProperty("subscribeSentMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.subscribeSentMs) && !(message.subscribeSentMs && $31e083413a0a3833$var$$util.isInteger(message.subscribeSentMs.low) && $31e083413a0a3833$var$$util.isInteger(message.subscribeSentMs.high))) return "subscribeSentMs: integer|Long expected";
        }
        if (message.subscribeAckMs != null && message.hasOwnProperty("subscribeAckMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.subscribeAckMs) && !(message.subscribeAckMs && $31e083413a0a3833$var$$util.isInteger(message.subscribeAckMs.low) && $31e083413a0a3833$var$$util.isInteger(message.subscribeAckMs.high))) return "subscribeAckMs: integer|Long expected";
        }
        if (message.timedOut != null && message.hasOwnProperty("timedOut")) {
            if (typeof message.timedOut !== "boolean") return "timedOut: boolean expected";
        }
        return null;
    };
    /**
     * Creates a SdkMeetingSessionSignalingTiming message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkMeetingSessionSignalingTiming
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkMeetingSessionSignalingTiming} SdkMeetingSessionSignalingTiming
     */ SdkMeetingSessionSignalingTiming.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkMeetingSessionSignalingTiming) return object;
        var message = new $31e083413a0a3833$var$$root.SdkMeetingSessionSignalingTiming();
        if (object.startMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.startMs = $31e083413a0a3833$var$$util.Long.fromValue(object.startMs)).unsigned = false;
            else if (typeof object.startMs === "string") message.startMs = parseInt(object.startMs, 10);
            else if (typeof object.startMs === "number") message.startMs = object.startMs;
            else if (typeof object.startMs === "object") message.startMs = new $31e083413a0a3833$var$$util.LongBits(object.startMs.low >>> 0, object.startMs.high >>> 0).toNumber();
        }
        if (object.joinSentMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.joinSentMs = $31e083413a0a3833$var$$util.Long.fromValue(object.joinSentMs)).unsigned = false;
            else if (typeof object.joinSentMs === "string") message.joinSentMs = parseInt(object.joinSentMs, 10);
            else if (typeof object.joinSentMs === "number") message.joinSentMs = object.joinSentMs;
            else if (typeof object.joinSentMs === "object") message.joinSentMs = new $31e083413a0a3833$var$$util.LongBits(object.joinSentMs.low >>> 0, object.joinSentMs.high >>> 0).toNumber();
        }
        if (object.joinAckReceivedMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.joinAckReceivedMs = $31e083413a0a3833$var$$util.Long.fromValue(object.joinAckReceivedMs)).unsigned = false;
            else if (typeof object.joinAckReceivedMs === "string") message.joinAckReceivedMs = parseInt(object.joinAckReceivedMs, 10);
            else if (typeof object.joinAckReceivedMs === "number") message.joinAckReceivedMs = object.joinAckReceivedMs;
            else if (typeof object.joinAckReceivedMs === "object") message.joinAckReceivedMs = new $31e083413a0a3833$var$$util.LongBits(object.joinAckReceivedMs.low >>> 0, object.joinAckReceivedMs.high >>> 0).toNumber();
        }
        if (object.transportConnectedMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.transportConnectedMs = $31e083413a0a3833$var$$util.Long.fromValue(object.transportConnectedMs)).unsigned = false;
            else if (typeof object.transportConnectedMs === "string") message.transportConnectedMs = parseInt(object.transportConnectedMs, 10);
            else if (typeof object.transportConnectedMs === "number") message.transportConnectedMs = object.transportConnectedMs;
            else if (typeof object.transportConnectedMs === "object") message.transportConnectedMs = new $31e083413a0a3833$var$$util.LongBits(object.transportConnectedMs.low >>> 0, object.transportConnectedMs.high >>> 0).toNumber();
        }
        if (object.createOfferMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.createOfferMs = $31e083413a0a3833$var$$util.Long.fromValue(object.createOfferMs)).unsigned = false;
            else if (typeof object.createOfferMs === "string") message.createOfferMs = parseInt(object.createOfferMs, 10);
            else if (typeof object.createOfferMs === "number") message.createOfferMs = object.createOfferMs;
            else if (typeof object.createOfferMs === "object") message.createOfferMs = new $31e083413a0a3833$var$$util.LongBits(object.createOfferMs.low >>> 0, object.createOfferMs.high >>> 0).toNumber();
        }
        if (object.setLocalDescriptionMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.setLocalDescriptionMs = $31e083413a0a3833$var$$util.Long.fromValue(object.setLocalDescriptionMs)).unsigned = false;
            else if (typeof object.setLocalDescriptionMs === "string") message.setLocalDescriptionMs = parseInt(object.setLocalDescriptionMs, 10);
            else if (typeof object.setLocalDescriptionMs === "number") message.setLocalDescriptionMs = object.setLocalDescriptionMs;
            else if (typeof object.setLocalDescriptionMs === "object") message.setLocalDescriptionMs = new $31e083413a0a3833$var$$util.LongBits(object.setLocalDescriptionMs.low >>> 0, object.setLocalDescriptionMs.high >>> 0).toNumber();
        }
        if (object.setRemoteDescriptionMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.setRemoteDescriptionMs = $31e083413a0a3833$var$$util.Long.fromValue(object.setRemoteDescriptionMs)).unsigned = false;
            else if (typeof object.setRemoteDescriptionMs === "string") message.setRemoteDescriptionMs = parseInt(object.setRemoteDescriptionMs, 10);
            else if (typeof object.setRemoteDescriptionMs === "number") message.setRemoteDescriptionMs = object.setRemoteDescriptionMs;
            else if (typeof object.setRemoteDescriptionMs === "object") message.setRemoteDescriptionMs = new $31e083413a0a3833$var$$util.LongBits(object.setRemoteDescriptionMs.low >>> 0, object.setRemoteDescriptionMs.high >>> 0).toNumber();
        }
        if (object.iceGatheringStartMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.iceGatheringStartMs = $31e083413a0a3833$var$$util.Long.fromValue(object.iceGatheringStartMs)).unsigned = false;
            else if (typeof object.iceGatheringStartMs === "string") message.iceGatheringStartMs = parseInt(object.iceGatheringStartMs, 10);
            else if (typeof object.iceGatheringStartMs === "number") message.iceGatheringStartMs = object.iceGatheringStartMs;
            else if (typeof object.iceGatheringStartMs === "object") message.iceGatheringStartMs = new $31e083413a0a3833$var$$util.LongBits(object.iceGatheringStartMs.low >>> 0, object.iceGatheringStartMs.high >>> 0).toNumber();
        }
        if (object.iceGatheringCompleteMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.iceGatheringCompleteMs = $31e083413a0a3833$var$$util.Long.fromValue(object.iceGatheringCompleteMs)).unsigned = false;
            else if (typeof object.iceGatheringCompleteMs === "string") message.iceGatheringCompleteMs = parseInt(object.iceGatheringCompleteMs, 10);
            else if (typeof object.iceGatheringCompleteMs === "number") message.iceGatheringCompleteMs = object.iceGatheringCompleteMs;
            else if (typeof object.iceGatheringCompleteMs === "object") message.iceGatheringCompleteMs = new $31e083413a0a3833$var$$util.LongBits(object.iceGatheringCompleteMs.low >>> 0, object.iceGatheringCompleteMs.high >>> 0).toNumber();
        }
        if (object.iceConnectedMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.iceConnectedMs = $31e083413a0a3833$var$$util.Long.fromValue(object.iceConnectedMs)).unsigned = false;
            else if (typeof object.iceConnectedMs === "string") message.iceConnectedMs = parseInt(object.iceConnectedMs, 10);
            else if (typeof object.iceConnectedMs === "number") message.iceConnectedMs = object.iceConnectedMs;
            else if (typeof object.iceConnectedMs === "object") message.iceConnectedMs = new $31e083413a0a3833$var$$util.LongBits(object.iceConnectedMs.low >>> 0, object.iceConnectedMs.high >>> 0).toNumber();
        }
        if (object.subscribeSentMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.subscribeSentMs = $31e083413a0a3833$var$$util.Long.fromValue(object.subscribeSentMs)).unsigned = false;
            else if (typeof object.subscribeSentMs === "string") message.subscribeSentMs = parseInt(object.subscribeSentMs, 10);
            else if (typeof object.subscribeSentMs === "number") message.subscribeSentMs = object.subscribeSentMs;
            else if (typeof object.subscribeSentMs === "object") message.subscribeSentMs = new $31e083413a0a3833$var$$util.LongBits(object.subscribeSentMs.low >>> 0, object.subscribeSentMs.high >>> 0).toNumber();
        }
        if (object.subscribeAckMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.subscribeAckMs = $31e083413a0a3833$var$$util.Long.fromValue(object.subscribeAckMs)).unsigned = false;
            else if (typeof object.subscribeAckMs === "string") message.subscribeAckMs = parseInt(object.subscribeAckMs, 10);
            else if (typeof object.subscribeAckMs === "number") message.subscribeAckMs = object.subscribeAckMs;
            else if (typeof object.subscribeAckMs === "object") message.subscribeAckMs = new $31e083413a0a3833$var$$util.LongBits(object.subscribeAckMs.low >>> 0, object.subscribeAckMs.high >>> 0).toNumber();
        }
        if (object.timedOut != null) message.timedOut = Boolean(object.timedOut);
        return message;
    };
    /**
     * Creates a plain object from a SdkMeetingSessionSignalingTiming message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkMeetingSessionSignalingTiming
     * @static
     * @param {SdkMeetingSessionSignalingTiming} message SdkMeetingSessionSignalingTiming
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkMeetingSessionSignalingTiming.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.startMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.startMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.joinSentMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.joinSentMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.joinAckReceivedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.joinAckReceivedMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.transportConnectedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.transportConnectedMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.createOfferMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.createOfferMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.setLocalDescriptionMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.setLocalDescriptionMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.setRemoteDescriptionMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.setRemoteDescriptionMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.iceGatheringStartMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.iceGatheringStartMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.iceGatheringCompleteMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.iceGatheringCompleteMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.iceConnectedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.iceConnectedMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.subscribeSentMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.subscribeSentMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.subscribeAckMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.subscribeAckMs = options.longs === String ? "0" : 0;
            object.timedOut = false;
        }
        if (message.startMs != null && message.hasOwnProperty("startMs")) {
            if (typeof message.startMs === "number") object.startMs = options.longs === String ? String(message.startMs) : message.startMs;
            else object.startMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.startMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.startMs.low >>> 0, message.startMs.high >>> 0).toNumber() : message.startMs;
        }
        if (message.joinSentMs != null && message.hasOwnProperty("joinSentMs")) {
            if (typeof message.joinSentMs === "number") object.joinSentMs = options.longs === String ? String(message.joinSentMs) : message.joinSentMs;
            else object.joinSentMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.joinSentMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.joinSentMs.low >>> 0, message.joinSentMs.high >>> 0).toNumber() : message.joinSentMs;
        }
        if (message.joinAckReceivedMs != null && message.hasOwnProperty("joinAckReceivedMs")) {
            if (typeof message.joinAckReceivedMs === "number") object.joinAckReceivedMs = options.longs === String ? String(message.joinAckReceivedMs) : message.joinAckReceivedMs;
            else object.joinAckReceivedMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.joinAckReceivedMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.joinAckReceivedMs.low >>> 0, message.joinAckReceivedMs.high >>> 0).toNumber() : message.joinAckReceivedMs;
        }
        if (message.transportConnectedMs != null && message.hasOwnProperty("transportConnectedMs")) {
            if (typeof message.transportConnectedMs === "number") object.transportConnectedMs = options.longs === String ? String(message.transportConnectedMs) : message.transportConnectedMs;
            else object.transportConnectedMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.transportConnectedMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.transportConnectedMs.low >>> 0, message.transportConnectedMs.high >>> 0).toNumber() : message.transportConnectedMs;
        }
        if (message.createOfferMs != null && message.hasOwnProperty("createOfferMs")) {
            if (typeof message.createOfferMs === "number") object.createOfferMs = options.longs === String ? String(message.createOfferMs) : message.createOfferMs;
            else object.createOfferMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.createOfferMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.createOfferMs.low >>> 0, message.createOfferMs.high >>> 0).toNumber() : message.createOfferMs;
        }
        if (message.setLocalDescriptionMs != null && message.hasOwnProperty("setLocalDescriptionMs")) {
            if (typeof message.setLocalDescriptionMs === "number") object.setLocalDescriptionMs = options.longs === String ? String(message.setLocalDescriptionMs) : message.setLocalDescriptionMs;
            else object.setLocalDescriptionMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.setLocalDescriptionMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.setLocalDescriptionMs.low >>> 0, message.setLocalDescriptionMs.high >>> 0).toNumber() : message.setLocalDescriptionMs;
        }
        if (message.setRemoteDescriptionMs != null && message.hasOwnProperty("setRemoteDescriptionMs")) {
            if (typeof message.setRemoteDescriptionMs === "number") object.setRemoteDescriptionMs = options.longs === String ? String(message.setRemoteDescriptionMs) : message.setRemoteDescriptionMs;
            else object.setRemoteDescriptionMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.setRemoteDescriptionMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.setRemoteDescriptionMs.low >>> 0, message.setRemoteDescriptionMs.high >>> 0).toNumber() : message.setRemoteDescriptionMs;
        }
        if (message.iceGatheringStartMs != null && message.hasOwnProperty("iceGatheringStartMs")) {
            if (typeof message.iceGatheringStartMs === "number") object.iceGatheringStartMs = options.longs === String ? String(message.iceGatheringStartMs) : message.iceGatheringStartMs;
            else object.iceGatheringStartMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.iceGatheringStartMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.iceGatheringStartMs.low >>> 0, message.iceGatheringStartMs.high >>> 0).toNumber() : message.iceGatheringStartMs;
        }
        if (message.iceGatheringCompleteMs != null && message.hasOwnProperty("iceGatheringCompleteMs")) {
            if (typeof message.iceGatheringCompleteMs === "number") object.iceGatheringCompleteMs = options.longs === String ? String(message.iceGatheringCompleteMs) : message.iceGatheringCompleteMs;
            else object.iceGatheringCompleteMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.iceGatheringCompleteMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.iceGatheringCompleteMs.low >>> 0, message.iceGatheringCompleteMs.high >>> 0).toNumber() : message.iceGatheringCompleteMs;
        }
        if (message.iceConnectedMs != null && message.hasOwnProperty("iceConnectedMs")) {
            if (typeof message.iceConnectedMs === "number") object.iceConnectedMs = options.longs === String ? String(message.iceConnectedMs) : message.iceConnectedMs;
            else object.iceConnectedMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.iceConnectedMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.iceConnectedMs.low >>> 0, message.iceConnectedMs.high >>> 0).toNumber() : message.iceConnectedMs;
        }
        if (message.subscribeSentMs != null && message.hasOwnProperty("subscribeSentMs")) {
            if (typeof message.subscribeSentMs === "number") object.subscribeSentMs = options.longs === String ? String(message.subscribeSentMs) : message.subscribeSentMs;
            else object.subscribeSentMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.subscribeSentMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.subscribeSentMs.low >>> 0, message.subscribeSentMs.high >>> 0).toNumber() : message.subscribeSentMs;
        }
        if (message.subscribeAckMs != null && message.hasOwnProperty("subscribeAckMs")) {
            if (typeof message.subscribeAckMs === "number") object.subscribeAckMs = options.longs === String ? String(message.subscribeAckMs) : message.subscribeAckMs;
            else object.subscribeAckMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.subscribeAckMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.subscribeAckMs.low >>> 0, message.subscribeAckMs.high >>> 0).toNumber() : message.subscribeAckMs;
        }
        if (message.timedOut != null && message.hasOwnProperty("timedOut")) object.timedOut = message.timedOut;
        return object;
    };
    /**
     * Converts this SdkMeetingSessionSignalingTiming to JSON.
     * @function toJSON
     * @memberof SdkMeetingSessionSignalingTiming
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkMeetingSessionSignalingTiming.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkMeetingSessionSignalingTiming
     * @function getTypeUrl
     * @memberof SdkMeetingSessionSignalingTiming
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkMeetingSessionSignalingTiming.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkMeetingSessionSignalingTiming";
    };
    return SdkMeetingSessionSignalingTiming;
}();
$31e083413a0a3833$var$$root.SdkMeetingSessionRemoteAudioTiming = function() {
    /**
     * Properties of a SdkMeetingSessionRemoteAudioTiming.
     * @name ISdkMeetingSessionRemoteAudioTiming
     * @interface ISdkMeetingSessionRemoteAudioTiming
     * @property {number|Long|null} [addedMs] SdkMeetingSessionRemoteAudioTiming addedMs
     * @property {number|Long|null} [firstPacketReceivedMs] SdkMeetingSessionRemoteAudioTiming firstPacketReceivedMs
     * @property {number|Long|null} [firstFrameRenderedMs] SdkMeetingSessionRemoteAudioTiming firstFrameRenderedMs
     * @property {boolean|null} [timedOut] SdkMeetingSessionRemoteAudioTiming timedOut
     * @property {boolean|null} [removed] SdkMeetingSessionRemoteAudioTiming removed
     */ /**
     * Constructs a new SdkMeetingSessionRemoteAudioTiming.
     * @name SdkMeetingSessionRemoteAudioTiming
     * @classdesc Represents a SdkMeetingSessionRemoteAudioTiming.
     * @implements ISdkMeetingSessionRemoteAudioTiming
     * @constructor
     * @param {ISdkMeetingSessionRemoteAudioTiming=} [properties] Properties to set
     */ function SdkMeetingSessionRemoteAudioTiming(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkMeetingSessionRemoteAudioTiming addedMs.
     * @member {number|Long} addedMs
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @instance
     */ SdkMeetingSessionRemoteAudioTiming.prototype.addedMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionRemoteAudioTiming firstPacketReceivedMs.
     * @member {number|Long} firstPacketReceivedMs
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @instance
     */ SdkMeetingSessionRemoteAudioTiming.prototype.firstPacketReceivedMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionRemoteAudioTiming firstFrameRenderedMs.
     * @member {number|Long} firstFrameRenderedMs
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @instance
     */ SdkMeetingSessionRemoteAudioTiming.prototype.firstFrameRenderedMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionRemoteAudioTiming timedOut.
     * @member {boolean} timedOut
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @instance
     */ SdkMeetingSessionRemoteAudioTiming.prototype.timedOut = false;
    /**
     * SdkMeetingSessionRemoteAudioTiming removed.
     * @member {boolean} removed
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @instance
     */ SdkMeetingSessionRemoteAudioTiming.prototype.removed = false;
    /**
     * Creates a new SdkMeetingSessionRemoteAudioTiming instance using the specified properties.
     * @function create
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @static
     * @param {ISdkMeetingSessionRemoteAudioTiming=} [properties] Properties to set
     * @returns {SdkMeetingSessionRemoteAudioTiming} SdkMeetingSessionRemoteAudioTiming instance
     */ SdkMeetingSessionRemoteAudioTiming.create = function create(properties) {
        return new SdkMeetingSessionRemoteAudioTiming(properties);
    };
    /**
     * Encodes the specified SdkMeetingSessionRemoteAudioTiming message. Does not implicitly {@link SdkMeetingSessionRemoteAudioTiming.verify|verify} messages.
     * @function encode
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @static
     * @param {ISdkMeetingSessionRemoteAudioTiming} message SdkMeetingSessionRemoteAudioTiming message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionRemoteAudioTiming.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.addedMs != null && Object.hasOwnProperty.call(message, "addedMs")) writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.addedMs);
        if (message.firstPacketReceivedMs != null && Object.hasOwnProperty.call(message, "firstPacketReceivedMs")) writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.firstPacketReceivedMs);
        if (message.firstFrameRenderedMs != null && Object.hasOwnProperty.call(message, "firstFrameRenderedMs")) writer.uint32(/* id 3, wireType 0 =*/ 24).int64(message.firstFrameRenderedMs);
        if (message.timedOut != null && Object.hasOwnProperty.call(message, "timedOut")) writer.uint32(/* id 4, wireType 0 =*/ 32).bool(message.timedOut);
        if (message.removed != null && Object.hasOwnProperty.call(message, "removed")) writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.removed);
        return writer;
    };
    /**
     * Encodes the specified SdkMeetingSessionRemoteAudioTiming message, length delimited. Does not implicitly {@link SdkMeetingSessionRemoteAudioTiming.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @static
     * @param {ISdkMeetingSessionRemoteAudioTiming} message SdkMeetingSessionRemoteAudioTiming message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionRemoteAudioTiming.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkMeetingSessionRemoteAudioTiming message from the specified reader or buffer.
     * @function decode
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkMeetingSessionRemoteAudioTiming} SdkMeetingSessionRemoteAudioTiming
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionRemoteAudioTiming.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkMeetingSessionRemoteAudioTiming();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addedMs = reader.int64();
                    break;
                case 2:
                    message.firstPacketReceivedMs = reader.int64();
                    break;
                case 3:
                    message.firstFrameRenderedMs = reader.int64();
                    break;
                case 4:
                    message.timedOut = reader.bool();
                    break;
                case 5:
                    message.removed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkMeetingSessionRemoteAudioTiming message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkMeetingSessionRemoteAudioTiming} SdkMeetingSessionRemoteAudioTiming
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionRemoteAudioTiming.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkMeetingSessionRemoteAudioTiming message.
     * @function verify
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkMeetingSessionRemoteAudioTiming.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.addedMs != null && message.hasOwnProperty("addedMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.addedMs) && !(message.addedMs && $31e083413a0a3833$var$$util.isInteger(message.addedMs.low) && $31e083413a0a3833$var$$util.isInteger(message.addedMs.high))) return "addedMs: integer|Long expected";
        }
        if (message.firstPacketReceivedMs != null && message.hasOwnProperty("firstPacketReceivedMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.firstPacketReceivedMs) && !(message.firstPacketReceivedMs && $31e083413a0a3833$var$$util.isInteger(message.firstPacketReceivedMs.low) && $31e083413a0a3833$var$$util.isInteger(message.firstPacketReceivedMs.high))) return "firstPacketReceivedMs: integer|Long expected";
        }
        if (message.firstFrameRenderedMs != null && message.hasOwnProperty("firstFrameRenderedMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.firstFrameRenderedMs) && !(message.firstFrameRenderedMs && $31e083413a0a3833$var$$util.isInteger(message.firstFrameRenderedMs.low) && $31e083413a0a3833$var$$util.isInteger(message.firstFrameRenderedMs.high))) return "firstFrameRenderedMs: integer|Long expected";
        }
        if (message.timedOut != null && message.hasOwnProperty("timedOut")) {
            if (typeof message.timedOut !== "boolean") return "timedOut: boolean expected";
        }
        if (message.removed != null && message.hasOwnProperty("removed")) {
            if (typeof message.removed !== "boolean") return "removed: boolean expected";
        }
        return null;
    };
    /**
     * Creates a SdkMeetingSessionRemoteAudioTiming message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkMeetingSessionRemoteAudioTiming} SdkMeetingSessionRemoteAudioTiming
     */ SdkMeetingSessionRemoteAudioTiming.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkMeetingSessionRemoteAudioTiming) return object;
        var message = new $31e083413a0a3833$var$$root.SdkMeetingSessionRemoteAudioTiming();
        if (object.addedMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.addedMs = $31e083413a0a3833$var$$util.Long.fromValue(object.addedMs)).unsigned = false;
            else if (typeof object.addedMs === "string") message.addedMs = parseInt(object.addedMs, 10);
            else if (typeof object.addedMs === "number") message.addedMs = object.addedMs;
            else if (typeof object.addedMs === "object") message.addedMs = new $31e083413a0a3833$var$$util.LongBits(object.addedMs.low >>> 0, object.addedMs.high >>> 0).toNumber();
        }
        if (object.firstPacketReceivedMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.firstPacketReceivedMs = $31e083413a0a3833$var$$util.Long.fromValue(object.firstPacketReceivedMs)).unsigned = false;
            else if (typeof object.firstPacketReceivedMs === "string") message.firstPacketReceivedMs = parseInt(object.firstPacketReceivedMs, 10);
            else if (typeof object.firstPacketReceivedMs === "number") message.firstPacketReceivedMs = object.firstPacketReceivedMs;
            else if (typeof object.firstPacketReceivedMs === "object") message.firstPacketReceivedMs = new $31e083413a0a3833$var$$util.LongBits(object.firstPacketReceivedMs.low >>> 0, object.firstPacketReceivedMs.high >>> 0).toNumber();
        }
        if (object.firstFrameRenderedMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.firstFrameRenderedMs = $31e083413a0a3833$var$$util.Long.fromValue(object.firstFrameRenderedMs)).unsigned = false;
            else if (typeof object.firstFrameRenderedMs === "string") message.firstFrameRenderedMs = parseInt(object.firstFrameRenderedMs, 10);
            else if (typeof object.firstFrameRenderedMs === "number") message.firstFrameRenderedMs = object.firstFrameRenderedMs;
            else if (typeof object.firstFrameRenderedMs === "object") message.firstFrameRenderedMs = new $31e083413a0a3833$var$$util.LongBits(object.firstFrameRenderedMs.low >>> 0, object.firstFrameRenderedMs.high >>> 0).toNumber();
        }
        if (object.timedOut != null) message.timedOut = Boolean(object.timedOut);
        if (object.removed != null) message.removed = Boolean(object.removed);
        return message;
    };
    /**
     * Creates a plain object from a SdkMeetingSessionRemoteAudioTiming message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @static
     * @param {SdkMeetingSessionRemoteAudioTiming} message SdkMeetingSessionRemoteAudioTiming
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkMeetingSessionRemoteAudioTiming.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.addedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.addedMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.firstPacketReceivedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.firstPacketReceivedMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.firstFrameRenderedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.firstFrameRenderedMs = options.longs === String ? "0" : 0;
            object.timedOut = false;
            object.removed = false;
        }
        if (message.addedMs != null && message.hasOwnProperty("addedMs")) {
            if (typeof message.addedMs === "number") object.addedMs = options.longs === String ? String(message.addedMs) : message.addedMs;
            else object.addedMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.addedMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.addedMs.low >>> 0, message.addedMs.high >>> 0).toNumber() : message.addedMs;
        }
        if (message.firstPacketReceivedMs != null && message.hasOwnProperty("firstPacketReceivedMs")) {
            if (typeof message.firstPacketReceivedMs === "number") object.firstPacketReceivedMs = options.longs === String ? String(message.firstPacketReceivedMs) : message.firstPacketReceivedMs;
            else object.firstPacketReceivedMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.firstPacketReceivedMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.firstPacketReceivedMs.low >>> 0, message.firstPacketReceivedMs.high >>> 0).toNumber() : message.firstPacketReceivedMs;
        }
        if (message.firstFrameRenderedMs != null && message.hasOwnProperty("firstFrameRenderedMs")) {
            if (typeof message.firstFrameRenderedMs === "number") object.firstFrameRenderedMs = options.longs === String ? String(message.firstFrameRenderedMs) : message.firstFrameRenderedMs;
            else object.firstFrameRenderedMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.firstFrameRenderedMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.firstFrameRenderedMs.low >>> 0, message.firstFrameRenderedMs.high >>> 0).toNumber() : message.firstFrameRenderedMs;
        }
        if (message.timedOut != null && message.hasOwnProperty("timedOut")) object.timedOut = message.timedOut;
        if (message.removed != null && message.hasOwnProperty("removed")) object.removed = message.removed;
        return object;
    };
    /**
     * Converts this SdkMeetingSessionRemoteAudioTiming to JSON.
     * @function toJSON
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkMeetingSessionRemoteAudioTiming.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkMeetingSessionRemoteAudioTiming
     * @function getTypeUrl
     * @memberof SdkMeetingSessionRemoteAudioTiming
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkMeetingSessionRemoteAudioTiming.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkMeetingSessionRemoteAudioTiming";
    };
    return SdkMeetingSessionRemoteAudioTiming;
}();
$31e083413a0a3833$var$$root.SdkMeetingSessionLocalAudioTiming = function() {
    /**
     * Properties of a SdkMeetingSessionLocalAudioTiming.
     * @name ISdkMeetingSessionLocalAudioTiming
     * @interface ISdkMeetingSessionLocalAudioTiming
     * @property {number|Long|null} [addedMs] SdkMeetingSessionLocalAudioTiming addedMs
     * @property {number|Long|null} [firstFrameCapturedMs] SdkMeetingSessionLocalAudioTiming firstFrameCapturedMs
     * @property {number|Long|null} [firstPacketSentMs] SdkMeetingSessionLocalAudioTiming firstPacketSentMs
     * @property {boolean|null} [timedOut] SdkMeetingSessionLocalAudioTiming timedOut
     * @property {boolean|null} [removed] SdkMeetingSessionLocalAudioTiming removed
     */ /**
     * Constructs a new SdkMeetingSessionLocalAudioTiming.
     * @name SdkMeetingSessionLocalAudioTiming
     * @classdesc Represents a SdkMeetingSessionLocalAudioTiming.
     * @implements ISdkMeetingSessionLocalAudioTiming
     * @constructor
     * @param {ISdkMeetingSessionLocalAudioTiming=} [properties] Properties to set
     */ function SdkMeetingSessionLocalAudioTiming(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkMeetingSessionLocalAudioTiming addedMs.
     * @member {number|Long} addedMs
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @instance
     */ SdkMeetingSessionLocalAudioTiming.prototype.addedMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionLocalAudioTiming firstFrameCapturedMs.
     * @member {number|Long} firstFrameCapturedMs
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @instance
     */ SdkMeetingSessionLocalAudioTiming.prototype.firstFrameCapturedMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionLocalAudioTiming firstPacketSentMs.
     * @member {number|Long} firstPacketSentMs
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @instance
     */ SdkMeetingSessionLocalAudioTiming.prototype.firstPacketSentMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionLocalAudioTiming timedOut.
     * @member {boolean} timedOut
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @instance
     */ SdkMeetingSessionLocalAudioTiming.prototype.timedOut = false;
    /**
     * SdkMeetingSessionLocalAudioTiming removed.
     * @member {boolean} removed
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @instance
     */ SdkMeetingSessionLocalAudioTiming.prototype.removed = false;
    /**
     * Creates a new SdkMeetingSessionLocalAudioTiming instance using the specified properties.
     * @function create
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @static
     * @param {ISdkMeetingSessionLocalAudioTiming=} [properties] Properties to set
     * @returns {SdkMeetingSessionLocalAudioTiming} SdkMeetingSessionLocalAudioTiming instance
     */ SdkMeetingSessionLocalAudioTiming.create = function create(properties) {
        return new SdkMeetingSessionLocalAudioTiming(properties);
    };
    /**
     * Encodes the specified SdkMeetingSessionLocalAudioTiming message. Does not implicitly {@link SdkMeetingSessionLocalAudioTiming.verify|verify} messages.
     * @function encode
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @static
     * @param {ISdkMeetingSessionLocalAudioTiming} message SdkMeetingSessionLocalAudioTiming message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionLocalAudioTiming.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.addedMs != null && Object.hasOwnProperty.call(message, "addedMs")) writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.addedMs);
        if (message.firstFrameCapturedMs != null && Object.hasOwnProperty.call(message, "firstFrameCapturedMs")) writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.firstFrameCapturedMs);
        if (message.firstPacketSentMs != null && Object.hasOwnProperty.call(message, "firstPacketSentMs")) writer.uint32(/* id 3, wireType 0 =*/ 24).int64(message.firstPacketSentMs);
        if (message.timedOut != null && Object.hasOwnProperty.call(message, "timedOut")) writer.uint32(/* id 4, wireType 0 =*/ 32).bool(message.timedOut);
        if (message.removed != null && Object.hasOwnProperty.call(message, "removed")) writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.removed);
        return writer;
    };
    /**
     * Encodes the specified SdkMeetingSessionLocalAudioTiming message, length delimited. Does not implicitly {@link SdkMeetingSessionLocalAudioTiming.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @static
     * @param {ISdkMeetingSessionLocalAudioTiming} message SdkMeetingSessionLocalAudioTiming message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionLocalAudioTiming.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkMeetingSessionLocalAudioTiming message from the specified reader or buffer.
     * @function decode
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkMeetingSessionLocalAudioTiming} SdkMeetingSessionLocalAudioTiming
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionLocalAudioTiming.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkMeetingSessionLocalAudioTiming();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addedMs = reader.int64();
                    break;
                case 2:
                    message.firstFrameCapturedMs = reader.int64();
                    break;
                case 3:
                    message.firstPacketSentMs = reader.int64();
                    break;
                case 4:
                    message.timedOut = reader.bool();
                    break;
                case 5:
                    message.removed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkMeetingSessionLocalAudioTiming message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkMeetingSessionLocalAudioTiming} SdkMeetingSessionLocalAudioTiming
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionLocalAudioTiming.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkMeetingSessionLocalAudioTiming message.
     * @function verify
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkMeetingSessionLocalAudioTiming.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.addedMs != null && message.hasOwnProperty("addedMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.addedMs) && !(message.addedMs && $31e083413a0a3833$var$$util.isInteger(message.addedMs.low) && $31e083413a0a3833$var$$util.isInteger(message.addedMs.high))) return "addedMs: integer|Long expected";
        }
        if (message.firstFrameCapturedMs != null && message.hasOwnProperty("firstFrameCapturedMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.firstFrameCapturedMs) && !(message.firstFrameCapturedMs && $31e083413a0a3833$var$$util.isInteger(message.firstFrameCapturedMs.low) && $31e083413a0a3833$var$$util.isInteger(message.firstFrameCapturedMs.high))) return "firstFrameCapturedMs: integer|Long expected";
        }
        if (message.firstPacketSentMs != null && message.hasOwnProperty("firstPacketSentMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.firstPacketSentMs) && !(message.firstPacketSentMs && $31e083413a0a3833$var$$util.isInteger(message.firstPacketSentMs.low) && $31e083413a0a3833$var$$util.isInteger(message.firstPacketSentMs.high))) return "firstPacketSentMs: integer|Long expected";
        }
        if (message.timedOut != null && message.hasOwnProperty("timedOut")) {
            if (typeof message.timedOut !== "boolean") return "timedOut: boolean expected";
        }
        if (message.removed != null && message.hasOwnProperty("removed")) {
            if (typeof message.removed !== "boolean") return "removed: boolean expected";
        }
        return null;
    };
    /**
     * Creates a SdkMeetingSessionLocalAudioTiming message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkMeetingSessionLocalAudioTiming} SdkMeetingSessionLocalAudioTiming
     */ SdkMeetingSessionLocalAudioTiming.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkMeetingSessionLocalAudioTiming) return object;
        var message = new $31e083413a0a3833$var$$root.SdkMeetingSessionLocalAudioTiming();
        if (object.addedMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.addedMs = $31e083413a0a3833$var$$util.Long.fromValue(object.addedMs)).unsigned = false;
            else if (typeof object.addedMs === "string") message.addedMs = parseInt(object.addedMs, 10);
            else if (typeof object.addedMs === "number") message.addedMs = object.addedMs;
            else if (typeof object.addedMs === "object") message.addedMs = new $31e083413a0a3833$var$$util.LongBits(object.addedMs.low >>> 0, object.addedMs.high >>> 0).toNumber();
        }
        if (object.firstFrameCapturedMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.firstFrameCapturedMs = $31e083413a0a3833$var$$util.Long.fromValue(object.firstFrameCapturedMs)).unsigned = false;
            else if (typeof object.firstFrameCapturedMs === "string") message.firstFrameCapturedMs = parseInt(object.firstFrameCapturedMs, 10);
            else if (typeof object.firstFrameCapturedMs === "number") message.firstFrameCapturedMs = object.firstFrameCapturedMs;
            else if (typeof object.firstFrameCapturedMs === "object") message.firstFrameCapturedMs = new $31e083413a0a3833$var$$util.LongBits(object.firstFrameCapturedMs.low >>> 0, object.firstFrameCapturedMs.high >>> 0).toNumber();
        }
        if (object.firstPacketSentMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.firstPacketSentMs = $31e083413a0a3833$var$$util.Long.fromValue(object.firstPacketSentMs)).unsigned = false;
            else if (typeof object.firstPacketSentMs === "string") message.firstPacketSentMs = parseInt(object.firstPacketSentMs, 10);
            else if (typeof object.firstPacketSentMs === "number") message.firstPacketSentMs = object.firstPacketSentMs;
            else if (typeof object.firstPacketSentMs === "object") message.firstPacketSentMs = new $31e083413a0a3833$var$$util.LongBits(object.firstPacketSentMs.low >>> 0, object.firstPacketSentMs.high >>> 0).toNumber();
        }
        if (object.timedOut != null) message.timedOut = Boolean(object.timedOut);
        if (object.removed != null) message.removed = Boolean(object.removed);
        return message;
    };
    /**
     * Creates a plain object from a SdkMeetingSessionLocalAudioTiming message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @static
     * @param {SdkMeetingSessionLocalAudioTiming} message SdkMeetingSessionLocalAudioTiming
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkMeetingSessionLocalAudioTiming.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.addedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.addedMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.firstFrameCapturedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.firstFrameCapturedMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.firstPacketSentMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.firstPacketSentMs = options.longs === String ? "0" : 0;
            object.timedOut = false;
            object.removed = false;
        }
        if (message.addedMs != null && message.hasOwnProperty("addedMs")) {
            if (typeof message.addedMs === "number") object.addedMs = options.longs === String ? String(message.addedMs) : message.addedMs;
            else object.addedMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.addedMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.addedMs.low >>> 0, message.addedMs.high >>> 0).toNumber() : message.addedMs;
        }
        if (message.firstFrameCapturedMs != null && message.hasOwnProperty("firstFrameCapturedMs")) {
            if (typeof message.firstFrameCapturedMs === "number") object.firstFrameCapturedMs = options.longs === String ? String(message.firstFrameCapturedMs) : message.firstFrameCapturedMs;
            else object.firstFrameCapturedMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.firstFrameCapturedMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.firstFrameCapturedMs.low >>> 0, message.firstFrameCapturedMs.high >>> 0).toNumber() : message.firstFrameCapturedMs;
        }
        if (message.firstPacketSentMs != null && message.hasOwnProperty("firstPacketSentMs")) {
            if (typeof message.firstPacketSentMs === "number") object.firstPacketSentMs = options.longs === String ? String(message.firstPacketSentMs) : message.firstPacketSentMs;
            else object.firstPacketSentMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.firstPacketSentMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.firstPacketSentMs.low >>> 0, message.firstPacketSentMs.high >>> 0).toNumber() : message.firstPacketSentMs;
        }
        if (message.timedOut != null && message.hasOwnProperty("timedOut")) object.timedOut = message.timedOut;
        if (message.removed != null && message.hasOwnProperty("removed")) object.removed = message.removed;
        return object;
    };
    /**
     * Converts this SdkMeetingSessionLocalAudioTiming to JSON.
     * @function toJSON
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkMeetingSessionLocalAudioTiming.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkMeetingSessionLocalAudioTiming
     * @function getTypeUrl
     * @memberof SdkMeetingSessionLocalAudioTiming
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkMeetingSessionLocalAudioTiming.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkMeetingSessionLocalAudioTiming";
    };
    return SdkMeetingSessionLocalAudioTiming;
}();
$31e083413a0a3833$var$$root.SdkMeetingSessionLocalVideoTiming = function() {
    /**
     * Properties of a SdkMeetingSessionLocalVideoTiming.
     * @name ISdkMeetingSessionLocalVideoTiming
     * @interface ISdkMeetingSessionLocalVideoTiming
     * @property {number|Long|null} [addedMs] SdkMeetingSessionLocalVideoTiming addedMs
     * @property {number|Long|null} [firstFrameCapturedMs] SdkMeetingSessionLocalVideoTiming firstFrameCapturedMs
     * @property {number|Long|null} [firstFrameSentMs] SdkMeetingSessionLocalVideoTiming firstFrameSentMs
     * @property {boolean|null} [timedOut] SdkMeetingSessionLocalVideoTiming timedOut
     * @property {boolean|null} [removed] SdkMeetingSessionLocalVideoTiming removed
     */ /**
     * Constructs a new SdkMeetingSessionLocalVideoTiming.
     * @name SdkMeetingSessionLocalVideoTiming
     * @classdesc Represents a SdkMeetingSessionLocalVideoTiming.
     * @implements ISdkMeetingSessionLocalVideoTiming
     * @constructor
     * @param {ISdkMeetingSessionLocalVideoTiming=} [properties] Properties to set
     */ function SdkMeetingSessionLocalVideoTiming(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkMeetingSessionLocalVideoTiming addedMs.
     * @member {number|Long} addedMs
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @instance
     */ SdkMeetingSessionLocalVideoTiming.prototype.addedMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionLocalVideoTiming firstFrameCapturedMs.
     * @member {number|Long} firstFrameCapturedMs
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @instance
     */ SdkMeetingSessionLocalVideoTiming.prototype.firstFrameCapturedMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionLocalVideoTiming firstFrameSentMs.
     * @member {number|Long} firstFrameSentMs
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @instance
     */ SdkMeetingSessionLocalVideoTiming.prototype.firstFrameSentMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionLocalVideoTiming timedOut.
     * @member {boolean} timedOut
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @instance
     */ SdkMeetingSessionLocalVideoTiming.prototype.timedOut = false;
    /**
     * SdkMeetingSessionLocalVideoTiming removed.
     * @member {boolean} removed
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @instance
     */ SdkMeetingSessionLocalVideoTiming.prototype.removed = false;
    /**
     * Creates a new SdkMeetingSessionLocalVideoTiming instance using the specified properties.
     * @function create
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @static
     * @param {ISdkMeetingSessionLocalVideoTiming=} [properties] Properties to set
     * @returns {SdkMeetingSessionLocalVideoTiming} SdkMeetingSessionLocalVideoTiming instance
     */ SdkMeetingSessionLocalVideoTiming.create = function create(properties) {
        return new SdkMeetingSessionLocalVideoTiming(properties);
    };
    /**
     * Encodes the specified SdkMeetingSessionLocalVideoTiming message. Does not implicitly {@link SdkMeetingSessionLocalVideoTiming.verify|verify} messages.
     * @function encode
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @static
     * @param {ISdkMeetingSessionLocalVideoTiming} message SdkMeetingSessionLocalVideoTiming message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionLocalVideoTiming.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.addedMs != null && Object.hasOwnProperty.call(message, "addedMs")) writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.addedMs);
        if (message.firstFrameCapturedMs != null && Object.hasOwnProperty.call(message, "firstFrameCapturedMs")) writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.firstFrameCapturedMs);
        if (message.firstFrameSentMs != null && Object.hasOwnProperty.call(message, "firstFrameSentMs")) writer.uint32(/* id 3, wireType 0 =*/ 24).int64(message.firstFrameSentMs);
        if (message.timedOut != null && Object.hasOwnProperty.call(message, "timedOut")) writer.uint32(/* id 4, wireType 0 =*/ 32).bool(message.timedOut);
        if (message.removed != null && Object.hasOwnProperty.call(message, "removed")) writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.removed);
        return writer;
    };
    /**
     * Encodes the specified SdkMeetingSessionLocalVideoTiming message, length delimited. Does not implicitly {@link SdkMeetingSessionLocalVideoTiming.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @static
     * @param {ISdkMeetingSessionLocalVideoTiming} message SdkMeetingSessionLocalVideoTiming message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionLocalVideoTiming.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkMeetingSessionLocalVideoTiming message from the specified reader or buffer.
     * @function decode
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkMeetingSessionLocalVideoTiming} SdkMeetingSessionLocalVideoTiming
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionLocalVideoTiming.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkMeetingSessionLocalVideoTiming();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addedMs = reader.int64();
                    break;
                case 2:
                    message.firstFrameCapturedMs = reader.int64();
                    break;
                case 3:
                    message.firstFrameSentMs = reader.int64();
                    break;
                case 4:
                    message.timedOut = reader.bool();
                    break;
                case 5:
                    message.removed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkMeetingSessionLocalVideoTiming message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkMeetingSessionLocalVideoTiming} SdkMeetingSessionLocalVideoTiming
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionLocalVideoTiming.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkMeetingSessionLocalVideoTiming message.
     * @function verify
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkMeetingSessionLocalVideoTiming.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.addedMs != null && message.hasOwnProperty("addedMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.addedMs) && !(message.addedMs && $31e083413a0a3833$var$$util.isInteger(message.addedMs.low) && $31e083413a0a3833$var$$util.isInteger(message.addedMs.high))) return "addedMs: integer|Long expected";
        }
        if (message.firstFrameCapturedMs != null && message.hasOwnProperty("firstFrameCapturedMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.firstFrameCapturedMs) && !(message.firstFrameCapturedMs && $31e083413a0a3833$var$$util.isInteger(message.firstFrameCapturedMs.low) && $31e083413a0a3833$var$$util.isInteger(message.firstFrameCapturedMs.high))) return "firstFrameCapturedMs: integer|Long expected";
        }
        if (message.firstFrameSentMs != null && message.hasOwnProperty("firstFrameSentMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.firstFrameSentMs) && !(message.firstFrameSentMs && $31e083413a0a3833$var$$util.isInteger(message.firstFrameSentMs.low) && $31e083413a0a3833$var$$util.isInteger(message.firstFrameSentMs.high))) return "firstFrameSentMs: integer|Long expected";
        }
        if (message.timedOut != null && message.hasOwnProperty("timedOut")) {
            if (typeof message.timedOut !== "boolean") return "timedOut: boolean expected";
        }
        if (message.removed != null && message.hasOwnProperty("removed")) {
            if (typeof message.removed !== "boolean") return "removed: boolean expected";
        }
        return null;
    };
    /**
     * Creates a SdkMeetingSessionLocalVideoTiming message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkMeetingSessionLocalVideoTiming} SdkMeetingSessionLocalVideoTiming
     */ SdkMeetingSessionLocalVideoTiming.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkMeetingSessionLocalVideoTiming) return object;
        var message = new $31e083413a0a3833$var$$root.SdkMeetingSessionLocalVideoTiming();
        if (object.addedMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.addedMs = $31e083413a0a3833$var$$util.Long.fromValue(object.addedMs)).unsigned = false;
            else if (typeof object.addedMs === "string") message.addedMs = parseInt(object.addedMs, 10);
            else if (typeof object.addedMs === "number") message.addedMs = object.addedMs;
            else if (typeof object.addedMs === "object") message.addedMs = new $31e083413a0a3833$var$$util.LongBits(object.addedMs.low >>> 0, object.addedMs.high >>> 0).toNumber();
        }
        if (object.firstFrameCapturedMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.firstFrameCapturedMs = $31e083413a0a3833$var$$util.Long.fromValue(object.firstFrameCapturedMs)).unsigned = false;
            else if (typeof object.firstFrameCapturedMs === "string") message.firstFrameCapturedMs = parseInt(object.firstFrameCapturedMs, 10);
            else if (typeof object.firstFrameCapturedMs === "number") message.firstFrameCapturedMs = object.firstFrameCapturedMs;
            else if (typeof object.firstFrameCapturedMs === "object") message.firstFrameCapturedMs = new $31e083413a0a3833$var$$util.LongBits(object.firstFrameCapturedMs.low >>> 0, object.firstFrameCapturedMs.high >>> 0).toNumber();
        }
        if (object.firstFrameSentMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.firstFrameSentMs = $31e083413a0a3833$var$$util.Long.fromValue(object.firstFrameSentMs)).unsigned = false;
            else if (typeof object.firstFrameSentMs === "string") message.firstFrameSentMs = parseInt(object.firstFrameSentMs, 10);
            else if (typeof object.firstFrameSentMs === "number") message.firstFrameSentMs = object.firstFrameSentMs;
            else if (typeof object.firstFrameSentMs === "object") message.firstFrameSentMs = new $31e083413a0a3833$var$$util.LongBits(object.firstFrameSentMs.low >>> 0, object.firstFrameSentMs.high >>> 0).toNumber();
        }
        if (object.timedOut != null) message.timedOut = Boolean(object.timedOut);
        if (object.removed != null) message.removed = Boolean(object.removed);
        return message;
    };
    /**
     * Creates a plain object from a SdkMeetingSessionLocalVideoTiming message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @static
     * @param {SdkMeetingSessionLocalVideoTiming} message SdkMeetingSessionLocalVideoTiming
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkMeetingSessionLocalVideoTiming.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.addedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.addedMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.firstFrameCapturedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.firstFrameCapturedMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.firstFrameSentMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.firstFrameSentMs = options.longs === String ? "0" : 0;
            object.timedOut = false;
            object.removed = false;
        }
        if (message.addedMs != null && message.hasOwnProperty("addedMs")) {
            if (typeof message.addedMs === "number") object.addedMs = options.longs === String ? String(message.addedMs) : message.addedMs;
            else object.addedMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.addedMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.addedMs.low >>> 0, message.addedMs.high >>> 0).toNumber() : message.addedMs;
        }
        if (message.firstFrameCapturedMs != null && message.hasOwnProperty("firstFrameCapturedMs")) {
            if (typeof message.firstFrameCapturedMs === "number") object.firstFrameCapturedMs = options.longs === String ? String(message.firstFrameCapturedMs) : message.firstFrameCapturedMs;
            else object.firstFrameCapturedMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.firstFrameCapturedMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.firstFrameCapturedMs.low >>> 0, message.firstFrameCapturedMs.high >>> 0).toNumber() : message.firstFrameCapturedMs;
        }
        if (message.firstFrameSentMs != null && message.hasOwnProperty("firstFrameSentMs")) {
            if (typeof message.firstFrameSentMs === "number") object.firstFrameSentMs = options.longs === String ? String(message.firstFrameSentMs) : message.firstFrameSentMs;
            else object.firstFrameSentMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.firstFrameSentMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.firstFrameSentMs.low >>> 0, message.firstFrameSentMs.high >>> 0).toNumber() : message.firstFrameSentMs;
        }
        if (message.timedOut != null && message.hasOwnProperty("timedOut")) object.timedOut = message.timedOut;
        if (message.removed != null && message.hasOwnProperty("removed")) object.removed = message.removed;
        return object;
    };
    /**
     * Converts this SdkMeetingSessionLocalVideoTiming to JSON.
     * @function toJSON
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkMeetingSessionLocalVideoTiming.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkMeetingSessionLocalVideoTiming
     * @function getTypeUrl
     * @memberof SdkMeetingSessionLocalVideoTiming
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkMeetingSessionLocalVideoTiming.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkMeetingSessionLocalVideoTiming";
    };
    return SdkMeetingSessionLocalVideoTiming;
}();
$31e083413a0a3833$var$$root.SdkMeetingSessionRemoteVideoTiming = function() {
    /**
     * Properties of a SdkMeetingSessionRemoteVideoTiming.
     * @name ISdkMeetingSessionRemoteVideoTiming
     * @interface ISdkMeetingSessionRemoteVideoTiming
     * @property {number|null} [groupId] SdkMeetingSessionRemoteVideoTiming groupId
     * @property {number|Long|null} [addedMs] SdkMeetingSessionRemoteVideoTiming addedMs
     * @property {number|Long|null} [firstPacketReceivedMs] SdkMeetingSessionRemoteVideoTiming firstPacketReceivedMs
     * @property {number|Long|null} [firstFrameRenderedMs] SdkMeetingSessionRemoteVideoTiming firstFrameRenderedMs
     * @property {boolean|null} [timedOut] SdkMeetingSessionRemoteVideoTiming timedOut
     * @property {boolean|null} [removed] SdkMeetingSessionRemoteVideoTiming removed
     */ /**
     * Constructs a new SdkMeetingSessionRemoteVideoTiming.
     * @name SdkMeetingSessionRemoteVideoTiming
     * @classdesc Represents a SdkMeetingSessionRemoteVideoTiming.
     * @implements ISdkMeetingSessionRemoteVideoTiming
     * @constructor
     * @param {ISdkMeetingSessionRemoteVideoTiming=} [properties] Properties to set
     */ function SdkMeetingSessionRemoteVideoTiming(properties) {
        if (properties) {
            for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }
    }
    /**
     * SdkMeetingSessionRemoteVideoTiming groupId.
     * @member {number} groupId
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @instance
     */ SdkMeetingSessionRemoteVideoTiming.prototype.groupId = 0;
    /**
     * SdkMeetingSessionRemoteVideoTiming addedMs.
     * @member {number|Long} addedMs
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @instance
     */ SdkMeetingSessionRemoteVideoTiming.prototype.addedMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionRemoteVideoTiming firstPacketReceivedMs.
     * @member {number|Long} firstPacketReceivedMs
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @instance
     */ SdkMeetingSessionRemoteVideoTiming.prototype.firstPacketReceivedMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionRemoteVideoTiming firstFrameRenderedMs.
     * @member {number|Long} firstFrameRenderedMs
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @instance
     */ SdkMeetingSessionRemoteVideoTiming.prototype.firstFrameRenderedMs = $31e083413a0a3833$var$$util.Long ? $31e083413a0a3833$var$$util.Long.fromBits(0, 0, false) : 0;
    /**
     * SdkMeetingSessionRemoteVideoTiming timedOut.
     * @member {boolean} timedOut
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @instance
     */ SdkMeetingSessionRemoteVideoTiming.prototype.timedOut = false;
    /**
     * SdkMeetingSessionRemoteVideoTiming removed.
     * @member {boolean} removed
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @instance
     */ SdkMeetingSessionRemoteVideoTiming.prototype.removed = false;
    /**
     * Creates a new SdkMeetingSessionRemoteVideoTiming instance using the specified properties.
     * @function create
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @static
     * @param {ISdkMeetingSessionRemoteVideoTiming=} [properties] Properties to set
     * @returns {SdkMeetingSessionRemoteVideoTiming} SdkMeetingSessionRemoteVideoTiming instance
     */ SdkMeetingSessionRemoteVideoTiming.create = function create(properties) {
        return new SdkMeetingSessionRemoteVideoTiming(properties);
    };
    /**
     * Encodes the specified SdkMeetingSessionRemoteVideoTiming message. Does not implicitly {@link SdkMeetingSessionRemoteVideoTiming.verify|verify} messages.
     * @function encode
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @static
     * @param {ISdkMeetingSessionRemoteVideoTiming} message SdkMeetingSessionRemoteVideoTiming message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionRemoteVideoTiming.encode = function encode(message, writer) {
        if (!writer) writer = $31e083413a0a3833$var$$Writer.create();
        if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId")) writer.uint32(/* id 1, wireType 0 =*/ 8).uint32(message.groupId);
        if (message.addedMs != null && Object.hasOwnProperty.call(message, "addedMs")) writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.addedMs);
        if (message.firstPacketReceivedMs != null && Object.hasOwnProperty.call(message, "firstPacketReceivedMs")) writer.uint32(/* id 3, wireType 0 =*/ 24).int64(message.firstPacketReceivedMs);
        if (message.firstFrameRenderedMs != null && Object.hasOwnProperty.call(message, "firstFrameRenderedMs")) writer.uint32(/* id 4, wireType 0 =*/ 32).int64(message.firstFrameRenderedMs);
        if (message.timedOut != null && Object.hasOwnProperty.call(message, "timedOut")) writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.timedOut);
        if (message.removed != null && Object.hasOwnProperty.call(message, "removed")) writer.uint32(/* id 6, wireType 0 =*/ 48).bool(message.removed);
        return writer;
    };
    /**
     * Encodes the specified SdkMeetingSessionRemoteVideoTiming message, length delimited. Does not implicitly {@link SdkMeetingSessionRemoteVideoTiming.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @static
     * @param {ISdkMeetingSessionRemoteVideoTiming} message SdkMeetingSessionRemoteVideoTiming message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ SdkMeetingSessionRemoteVideoTiming.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a SdkMeetingSessionRemoteVideoTiming message from the specified reader or buffer.
     * @function decode
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SdkMeetingSessionRemoteVideoTiming} SdkMeetingSessionRemoteVideoTiming
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionRemoteVideoTiming.decode = function decode(reader, length) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = $31e083413a0a3833$var$$Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $31e083413a0a3833$var$$root.SdkMeetingSessionRemoteVideoTiming();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupId = reader.uint32();
                    break;
                case 2:
                    message.addedMs = reader.int64();
                    break;
                case 3:
                    message.firstPacketReceivedMs = reader.int64();
                    break;
                case 4:
                    message.firstFrameRenderedMs = reader.int64();
                    break;
                case 5:
                    message.timedOut = reader.bool();
                    break;
                case 6:
                    message.removed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a SdkMeetingSessionRemoteVideoTiming message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SdkMeetingSessionRemoteVideoTiming} SdkMeetingSessionRemoteVideoTiming
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ SdkMeetingSessionRemoteVideoTiming.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $31e083413a0a3833$var$$Reader)) reader = new $31e083413a0a3833$var$$Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a SdkMeetingSessionRemoteVideoTiming message.
     * @function verify
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */ SdkMeetingSessionRemoteVideoTiming.verify = function verify(message) {
        if (typeof message !== "object" || message === null) return "object expected";
        if (message.groupId != null && message.hasOwnProperty("groupId")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.groupId)) return "groupId: integer expected";
        }
        if (message.addedMs != null && message.hasOwnProperty("addedMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.addedMs) && !(message.addedMs && $31e083413a0a3833$var$$util.isInteger(message.addedMs.low) && $31e083413a0a3833$var$$util.isInteger(message.addedMs.high))) return "addedMs: integer|Long expected";
        }
        if (message.firstPacketReceivedMs != null && message.hasOwnProperty("firstPacketReceivedMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.firstPacketReceivedMs) && !(message.firstPacketReceivedMs && $31e083413a0a3833$var$$util.isInteger(message.firstPacketReceivedMs.low) && $31e083413a0a3833$var$$util.isInteger(message.firstPacketReceivedMs.high))) return "firstPacketReceivedMs: integer|Long expected";
        }
        if (message.firstFrameRenderedMs != null && message.hasOwnProperty("firstFrameRenderedMs")) {
            if (!$31e083413a0a3833$var$$util.isInteger(message.firstFrameRenderedMs) && !(message.firstFrameRenderedMs && $31e083413a0a3833$var$$util.isInteger(message.firstFrameRenderedMs.low) && $31e083413a0a3833$var$$util.isInteger(message.firstFrameRenderedMs.high))) return "firstFrameRenderedMs: integer|Long expected";
        }
        if (message.timedOut != null && message.hasOwnProperty("timedOut")) {
            if (typeof message.timedOut !== "boolean") return "timedOut: boolean expected";
        }
        if (message.removed != null && message.hasOwnProperty("removed")) {
            if (typeof message.removed !== "boolean") return "removed: boolean expected";
        }
        return null;
    };
    /**
     * Creates a SdkMeetingSessionRemoteVideoTiming message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SdkMeetingSessionRemoteVideoTiming} SdkMeetingSessionRemoteVideoTiming
     */ SdkMeetingSessionRemoteVideoTiming.fromObject = function fromObject(object) {
        if (object instanceof $31e083413a0a3833$var$$root.SdkMeetingSessionRemoteVideoTiming) return object;
        var message = new $31e083413a0a3833$var$$root.SdkMeetingSessionRemoteVideoTiming();
        if (object.groupId != null) message.groupId = object.groupId >>> 0;
        if (object.addedMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.addedMs = $31e083413a0a3833$var$$util.Long.fromValue(object.addedMs)).unsigned = false;
            else if (typeof object.addedMs === "string") message.addedMs = parseInt(object.addedMs, 10);
            else if (typeof object.addedMs === "number") message.addedMs = object.addedMs;
            else if (typeof object.addedMs === "object") message.addedMs = new $31e083413a0a3833$var$$util.LongBits(object.addedMs.low >>> 0, object.addedMs.high >>> 0).toNumber();
        }
        if (object.firstPacketReceivedMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.firstPacketReceivedMs = $31e083413a0a3833$var$$util.Long.fromValue(object.firstPacketReceivedMs)).unsigned = false;
            else if (typeof object.firstPacketReceivedMs === "string") message.firstPacketReceivedMs = parseInt(object.firstPacketReceivedMs, 10);
            else if (typeof object.firstPacketReceivedMs === "number") message.firstPacketReceivedMs = object.firstPacketReceivedMs;
            else if (typeof object.firstPacketReceivedMs === "object") message.firstPacketReceivedMs = new $31e083413a0a3833$var$$util.LongBits(object.firstPacketReceivedMs.low >>> 0, object.firstPacketReceivedMs.high >>> 0).toNumber();
        }
        if (object.firstFrameRenderedMs != null) {
            if ($31e083413a0a3833$var$$util.Long) (message.firstFrameRenderedMs = $31e083413a0a3833$var$$util.Long.fromValue(object.firstFrameRenderedMs)).unsigned = false;
            else if (typeof object.firstFrameRenderedMs === "string") message.firstFrameRenderedMs = parseInt(object.firstFrameRenderedMs, 10);
            else if (typeof object.firstFrameRenderedMs === "number") message.firstFrameRenderedMs = object.firstFrameRenderedMs;
            else if (typeof object.firstFrameRenderedMs === "object") message.firstFrameRenderedMs = new $31e083413a0a3833$var$$util.LongBits(object.firstFrameRenderedMs.low >>> 0, object.firstFrameRenderedMs.high >>> 0).toNumber();
        }
        if (object.timedOut != null) message.timedOut = Boolean(object.timedOut);
        if (object.removed != null) message.removed = Boolean(object.removed);
        return message;
    };
    /**
     * Creates a plain object from a SdkMeetingSessionRemoteVideoTiming message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @static
     * @param {SdkMeetingSessionRemoteVideoTiming} message SdkMeetingSessionRemoteVideoTiming
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ SdkMeetingSessionRemoteVideoTiming.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
            object.groupId = 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.addedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.addedMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.firstPacketReceivedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.firstPacketReceivedMs = options.longs === String ? "0" : 0;
            if ($31e083413a0a3833$var$$util.Long) {
                var long = new $31e083413a0a3833$var$$util.Long(0, 0, false);
                object.firstFrameRenderedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else object.firstFrameRenderedMs = options.longs === String ? "0" : 0;
            object.timedOut = false;
            object.removed = false;
        }
        if (message.groupId != null && message.hasOwnProperty("groupId")) object.groupId = message.groupId;
        if (message.addedMs != null && message.hasOwnProperty("addedMs")) {
            if (typeof message.addedMs === "number") object.addedMs = options.longs === String ? String(message.addedMs) : message.addedMs;
            else object.addedMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.addedMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.addedMs.low >>> 0, message.addedMs.high >>> 0).toNumber() : message.addedMs;
        }
        if (message.firstPacketReceivedMs != null && message.hasOwnProperty("firstPacketReceivedMs")) {
            if (typeof message.firstPacketReceivedMs === "number") object.firstPacketReceivedMs = options.longs === String ? String(message.firstPacketReceivedMs) : message.firstPacketReceivedMs;
            else object.firstPacketReceivedMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.firstPacketReceivedMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.firstPacketReceivedMs.low >>> 0, message.firstPacketReceivedMs.high >>> 0).toNumber() : message.firstPacketReceivedMs;
        }
        if (message.firstFrameRenderedMs != null && message.hasOwnProperty("firstFrameRenderedMs")) {
            if (typeof message.firstFrameRenderedMs === "number") object.firstFrameRenderedMs = options.longs === String ? String(message.firstFrameRenderedMs) : message.firstFrameRenderedMs;
            else object.firstFrameRenderedMs = options.longs === String ? $31e083413a0a3833$var$$util.Long.prototype.toString.call(message.firstFrameRenderedMs) : options.longs === Number ? new $31e083413a0a3833$var$$util.LongBits(message.firstFrameRenderedMs.low >>> 0, message.firstFrameRenderedMs.high >>> 0).toNumber() : message.firstFrameRenderedMs;
        }
        if (message.timedOut != null && message.hasOwnProperty("timedOut")) object.timedOut = message.timedOut;
        if (message.removed != null && message.hasOwnProperty("removed")) object.removed = message.removed;
        return object;
    };
    /**
     * Converts this SdkMeetingSessionRemoteVideoTiming to JSON.
     * @function toJSON
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ SdkMeetingSessionRemoteVideoTiming.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $jiz4j.util.toJSONOptions);
    };
    /**
     * Gets the default type url for SdkMeetingSessionRemoteVideoTiming
     * @function getTypeUrl
     * @memberof SdkMeetingSessionRemoteVideoTiming
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */ SdkMeetingSessionRemoteVideoTiming.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
        return typeUrlPrefix + "/SdkMeetingSessionRemoteVideoTiming";
    };
    return SdkMeetingSessionRemoteVideoTiming;
}();
module.exports = $31e083413a0a3833$var$$root;
$31e083413a0a3833$var$$util.Long = undefined;
$jiz4j.configure();

});
parcelRegister("jiz4j", function(module, exports) {
// minimal library entry point.
"use strict";

module.exports = (parcelRequire("8MpkV"));

});
parcelRegister("8MpkV", function(module, exports) {
"use strict";
var $664675b82ee8df1a$var$protobuf = module.exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ $664675b82ee8df1a$var$protobuf.build = "minimal";

// Serialization
$664675b82ee8df1a$var$protobuf.Writer = (parcelRequire("3KUVy"));

$664675b82ee8df1a$var$protobuf.BufferWriter = (parcelRequire("axYUT"));

$664675b82ee8df1a$var$protobuf.Reader = (parcelRequire("hP5zC"));

$664675b82ee8df1a$var$protobuf.BufferReader = (parcelRequire("hVbTm"));

// Utility
$664675b82ee8df1a$var$protobuf.util = (parcelRequire("hf2LF"));

$664675b82ee8df1a$var$protobuf.rpc = (parcelRequire("kPAIY"));

$664675b82ee8df1a$var$protobuf.roots = (parcelRequire("38hgC"));
$664675b82ee8df1a$var$protobuf.configure = $664675b82ee8df1a$var$configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function $664675b82ee8df1a$var$configure() {
    $664675b82ee8df1a$var$protobuf.util._configure();
    $664675b82ee8df1a$var$protobuf.Writer._configure($664675b82ee8df1a$var$protobuf.BufferWriter);
    $664675b82ee8df1a$var$protobuf.Reader._configure($664675b82ee8df1a$var$protobuf.BufferReader);
}
// Set up buffer utility according to the environment
$664675b82ee8df1a$var$configure();

});
parcelRegister("3KUVy", function(module, exports) {
"use strict";
module.exports = $2bc1d392757dc2c2$var$Writer;

var $hf2LF = parcelRequire("hf2LF");
var $2bc1d392757dc2c2$var$BufferWriter; // cyclic
var $2bc1d392757dc2c2$var$LongBits = $hf2LF.LongBits, $2bc1d392757dc2c2$var$base64 = $hf2LF.base64, $2bc1d392757dc2c2$var$utf8 = $hf2LF.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function $2bc1d392757dc2c2$var$Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function $2bc1d392757dc2c2$var$noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function $2bc1d392757dc2c2$var$State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function $2bc1d392757dc2c2$var$Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new $2bc1d392757dc2c2$var$Op($2bc1d392757dc2c2$var$noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var $2bc1d392757dc2c2$var$create = function create() {
    return $hf2LF.Buffer ? function create_buffer_setup() {
        return ($2bc1d392757dc2c2$var$Writer.create = function create_buffer() {
            return new $2bc1d392757dc2c2$var$BufferWriter();
        })();
    } : function create_array() {
        return new $2bc1d392757dc2c2$var$Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ $2bc1d392757dc2c2$var$Writer.create = $2bc1d392757dc2c2$var$create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ $2bc1d392757dc2c2$var$Writer.alloc = function alloc(size) {
    return new $hf2LF.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if ($hf2LF.Array !== Array) $2bc1d392757dc2c2$var$Writer.alloc = $hf2LF.pool($2bc1d392757dc2c2$var$Writer.alloc, $hf2LF.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ $2bc1d392757dc2c2$var$Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new $2bc1d392757dc2c2$var$Op(fn, len, val);
    this.len += len;
    return this;
};
function $2bc1d392757dc2c2$var$writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function $2bc1d392757dc2c2$var$writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function $2bc1d392757dc2c2$var$VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
$2bc1d392757dc2c2$var$VarintOp.prototype = Object.create($2bc1d392757dc2c2$var$Op.prototype);
$2bc1d392757dc2c2$var$VarintOp.prototype.fn = $2bc1d392757dc2c2$var$writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new $2bc1d392757dc2c2$var$VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.int32 = function write_int32(value) {
    return (value |= 0) < 0 ? this._push($2bc1d392757dc2c2$var$writeVarint64, 10, $2bc1d392757dc2c2$var$LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function $2bc1d392757dc2c2$var$writeVarint64(val, buf, pos) {
    var lo = val.lo, hi = val.hi;
    while(hi){
        buf[pos++] = lo & 127 | 128;
        lo = (lo >>> 7 | hi << 25) >>> 0;
        hi >>>= 7;
    }
    while(lo > 127){
        buf[pos++] = lo & 127 | 128;
        lo = lo >>> 7;
    }
    buf[pos++] = lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.uint64 = function write_uint64(value) {
    var bits = $2bc1d392757dc2c2$var$LongBits.from(value);
    return this._push($2bc1d392757dc2c2$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.int64 = $2bc1d392757dc2c2$var$Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.sint64 = function write_sint64(value) {
    var bits = $2bc1d392757dc2c2$var$LongBits.from(value).zzEncode();
    return this._push($2bc1d392757dc2c2$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.bool = function write_bool(value) {
    return this._push($2bc1d392757dc2c2$var$writeByte, 1, value ? 1 : 0);
};
function $2bc1d392757dc2c2$var$writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push($2bc1d392757dc2c2$var$writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.sfixed32 = $2bc1d392757dc2c2$var$Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = $2bc1d392757dc2c2$var$LongBits.from(value);
    return this._push($2bc1d392757dc2c2$var$writeFixed32, 4, bits.lo)._push($2bc1d392757dc2c2$var$writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.sfixed64 = $2bc1d392757dc2c2$var$Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.float = function write_float(value) {
    return this._push($hf2LF.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.double = function write_double(value) {
    return this._push($hf2LF.float.writeDoubleLE, 8, value);
};
var $2bc1d392757dc2c2$var$writeBytes = $hf2LF.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push($2bc1d392757dc2c2$var$writeByte, 1, 0);
    if ($hf2LF.isString(value)) {
        var buf = $2bc1d392757dc2c2$var$Writer.alloc(len = $2bc1d392757dc2c2$var$base64.length(value));
        $2bc1d392757dc2c2$var$base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push($2bc1d392757dc2c2$var$writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.string = function write_string(value) {
    var len = $2bc1d392757dc2c2$var$utf8.length(value);
    return len ? this.uint32(len)._push($2bc1d392757dc2c2$var$utf8.write, len, value) : this._push($2bc1d392757dc2c2$var$writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.fork = function fork() {
    this.states = new $2bc1d392757dc2c2$var$State(this);
    this.head = this.tail = new $2bc1d392757dc2c2$var$Op($2bc1d392757dc2c2$var$noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new $2bc1d392757dc2c2$var$Op($2bc1d392757dc2c2$var$noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ $2bc1d392757dc2c2$var$Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
$2bc1d392757dc2c2$var$Writer._configure = function(BufferWriter_) {
    $2bc1d392757dc2c2$var$BufferWriter = BufferWriter_;
    $2bc1d392757dc2c2$var$Writer.create = $2bc1d392757dc2c2$var$create();
    $2bc1d392757dc2c2$var$BufferWriter._configure();
};

});
parcelRegister("hf2LF", function(module, exports) {
"use strict";
var $c8d5fc00154f529a$var$util = module.exports;

// used to return a Promise where callback is omitted
$c8d5fc00154f529a$var$util.asPromise = (parcelRequire("6TUyK"));

// converts to / from base64 encoded strings
$c8d5fc00154f529a$var$util.base64 = (parcelRequire("ljrw7"));

// base class of rpc.Service
$c8d5fc00154f529a$var$util.EventEmitter = (parcelRequire("cTpsI"));

// float handling accross browsers
$c8d5fc00154f529a$var$util.float = (parcelRequire("b8LQB"));

// converts to / from utf8 encoded strings
$c8d5fc00154f529a$var$util.utf8 = (parcelRequire("1x6UU"));

// provides a node-like buffer pool in the browser
$c8d5fc00154f529a$var$util.pool = (parcelRequire("hU2wx"));

// utility to work with the low and high bits of a 64 bit value
$c8d5fc00154f529a$var$util.LongBits = (parcelRequire("5S9hy"));
/**
 * Tests if the specified key can affect object prototypes.
 * @memberof util
 * @param {string} key Key to test
 * @returns {boolean} `true` if the key is unsafe
 */ function $c8d5fc00154f529a$var$isUnsafeProperty(key) {
    return key === "__proto__" || key === "prototype" || key === "constructor";
}
$c8d5fc00154f529a$var$util.isUnsafeProperty = $c8d5fc00154f529a$var$isUnsafeProperty;
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ $c8d5fc00154f529a$var$util.isNode = Boolean(typeof $parcel$global !== "undefined" && $parcel$global && $parcel$global.process && $parcel$global.process.versions && $parcel$global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ $c8d5fc00154f529a$var$util.global = $c8d5fc00154f529a$var$util.isNode && $parcel$global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || module.exports; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ $c8d5fc00154f529a$var$util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ $c8d5fc00154f529a$var$util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ $c8d5fc00154f529a$var$util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ $c8d5fc00154f529a$var$util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ $c8d5fc00154f529a$var$util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $c8d5fc00154f529a$var$util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $c8d5fc00154f529a$var$util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && Object.hasOwnProperty.call(obj, prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ $c8d5fc00154f529a$var$util.Buffer = function() {
    try {
        var Buffer = $c8d5fc00154f529a$var$util.global.Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
$c8d5fc00154f529a$var$util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
$c8d5fc00154f529a$var$util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ $c8d5fc00154f529a$var$util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? $c8d5fc00154f529a$var$util.Buffer ? $c8d5fc00154f529a$var$util._Buffer_allocUnsafe(sizeOrArray) : new $c8d5fc00154f529a$var$util.Array(sizeOrArray) : $c8d5fc00154f529a$var$util.Buffer ? $c8d5fc00154f529a$var$util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ $c8d5fc00154f529a$var$util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;

/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ $c8d5fc00154f529a$var$util.Long = /* istanbul ignore next */ $c8d5fc00154f529a$var$util.global.dcodeIO && /* istanbul ignore next */ $c8d5fc00154f529a$var$util.global.dcodeIO.Long || /* istanbul ignore next */ $c8d5fc00154f529a$var$util.global.Long || function() {
    try {
        var Long = (parcelRequire("lkntF"));
        return Long && Long.isLong ? Long : null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ $c8d5fc00154f529a$var$util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $c8d5fc00154f529a$var$util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $c8d5fc00154f529a$var$util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ $c8d5fc00154f529a$var$util.longToHash = function longToHash(value) {
    return value ? $c8d5fc00154f529a$var$util.LongBits.from(value).toHash() : $c8d5fc00154f529a$var$util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ $c8d5fc00154f529a$var$util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = $c8d5fc00154f529a$var$util.LongBits.fromHash(hash);
    if ($c8d5fc00154f529a$var$util.Long) return $c8d5fc00154f529a$var$util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {...(Object.<string,*>|boolean)} src Source objects, optionally followed by an `ifNotSet` flag
 * @returns {Object.<string,*>} Destination object
 */ function $c8d5fc00154f529a$var$merge(dst) {
    var ifNotSet = typeof arguments[arguments.length - 1] === "boolean", limit = ifNotSet ? arguments.length - 1 : arguments.length;
    ifNotSet = ifNotSet && arguments[arguments.length - 1];
    for(var a = 1; a < limit; ++a){
        var src = arguments[a];
        if (!src) continue;
        for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (!$c8d5fc00154f529a$var$isUnsafeProperty(keys[i]) && (dst[keys[i]] === undefined || !ifNotSet)) dst[keys[i]] = src[keys[i]];
    }
    return dst;
}
$c8d5fc00154f529a$var$util.merge = $c8d5fc00154f529a$var$merge;
/**
 * Schema declaration nesting limit.
 * @memberof util
 * @type {number}
 */ $c8d5fc00154f529a$var$util.nestingLimit = 32; // protoc: MaxMessageDeclarationNestingDepth
/**
 * Recursion limit.
 * @memberof util
 * @type {number}
 */ $c8d5fc00154f529a$var$util.recursionLimit = 100; // protoc: CodedInputStream::default_recursion_limit_
/**
 * Makes a property safe for assignment as an own property.
 * @memberof util
 * @param {Object.<string,*>} obj Object
 * @param {string} key Property key
 * @returns {undefined}
 */ $c8d5fc00154f529a$var$util.makeProp = function makeProp(obj, key) {
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true
    });
};
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $c8d5fc00154f529a$var$util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function $c8d5fc00154f529a$var$newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) $c8d5fc00154f529a$var$merge(this, properties);
    }
    CustomError.prototype = Object.create(Error.prototype, {
        constructor: {
            value: CustomError,
            writable: true,
            enumerable: false,
            configurable: true
        },
        name: {
            get: function get() {
                return name;
            },
            set: undefined,
            enumerable: false,
            // configurable: false would accurately preserve the behavior of
            // the original, but I'm guessing that was not intentional.
            // For an actual error subclass, this property would
            // be configurable.
            configurable: true
        },
        toString: {
            value: function value() {
                return this.name + ": " + this.message;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    return CustomError;
}
$c8d5fc00154f529a$var$util.newError = $c8d5fc00154f529a$var$newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ $c8d5fc00154f529a$var$util.ProtocolError = $c8d5fc00154f529a$var$newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ $c8d5fc00154f529a$var$util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ $c8d5fc00154f529a$var$util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ $c8d5fc00154f529a$var$util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
$c8d5fc00154f529a$var$util._configure = function() {
    var Buffer = $c8d5fc00154f529a$var$util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        $c8d5fc00154f529a$var$util._Buffer_from = $c8d5fc00154f529a$var$util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    $c8d5fc00154f529a$var$util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    $c8d5fc00154f529a$var$util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

});
parcelRegister("6TUyK", function(module, exports) {
"use strict";
module.exports = $5063c0aab3220c21$var$asPromise;
/**
 * Callback as used by {@link util.asPromise}.
 * @typedef asPromiseCallback
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {...*} params Additional arguments
 * @returns {undefined}
 */ /**
 * Returns a promise from a node-style callback function.
 * @memberof util
 * @param {asPromiseCallback} fn Function to call
 * @param {*} ctx Function context
 * @param {...*} params Function arguments
 * @returns {Promise<*>} Promisified function
 */ function $5063c0aab3220c21$var$asPromise(fn, ctx /*, varargs */ ) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while(index < arguments.length)params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err /*, varargs */ ) {
            if (pending) {
                pending = false;
                if (err) reject(err);
                else {
                    var params = new Array(arguments.length - 1), offset = 0;
                    while(offset < params.length)params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}

});

parcelRegister("ljrw7", function(module, exports) {
"use strict";
/**
 * A minimal base64 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $f840b7a2526f15a0$var$base64 = module.exports;
/**
 * Calculates the byte length of a base64 encoded string.
 * @param {string} string Base64 encoded string
 * @returns {number} Byte length
 */ $f840b7a2526f15a0$var$base64.length = function length(string) {
    var p = string.length;
    if (!p) return 0;
    var n = 0;
    while(--p % 4 > 1 && string.charAt(p) === "=")++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
// Base64 encoding table
var $f840b7a2526f15a0$var$b64 = new Array(64);
// Base64 decoding table
var $f840b7a2526f15a0$var$s64 = new Array(123);
// 65..90, 97..122, 48..57, 43, 47
for(var $f840b7a2526f15a0$var$i = 0; $f840b7a2526f15a0$var$i < 64;)$f840b7a2526f15a0$var$s64[$f840b7a2526f15a0$var$b64[$f840b7a2526f15a0$var$i] = $f840b7a2526f15a0$var$i < 26 ? $f840b7a2526f15a0$var$i + 65 : $f840b7a2526f15a0$var$i < 52 ? $f840b7a2526f15a0$var$i + 71 : $f840b7a2526f15a0$var$i < 62 ? $f840b7a2526f15a0$var$i - 4 : $f840b7a2526f15a0$var$i - 59 | 43] = $f840b7a2526f15a0$var$i++;
/**
 * Encodes a buffer to a base64 encoded string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} Base64 encoded string
 */ $f840b7a2526f15a0$var$base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i = 0, j = 0, t; // temporary
    while(start < end){
        var b = buffer[start++];
        switch(j){
            case 0:
                chunk[i++] = $f840b7a2526f15a0$var$b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = $f840b7a2526f15a0$var$b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = $f840b7a2526f15a0$var$b64[t | b >> 6];
                chunk[i++] = $f840b7a2526f15a0$var$b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = $f840b7a2526f15a0$var$b64[t];
        chunk[i++] = 61;
        if (j === 1) chunk[i++] = 61;
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var $f840b7a2526f15a0$var$invalidEncoding = "invalid encoding";
/**
 * Decodes a base64 encoded string to a buffer.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Number of bytes written
 * @throws {Error} If encoding is invalid
 */ $f840b7a2526f15a0$var$base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t; // temporary
    for(var i = 0; i < string.length;){
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1) break;
        if ((c = $f840b7a2526f15a0$var$s64[c]) === undefined) throw Error($f840b7a2526f15a0$var$invalidEncoding);
        switch(j){
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1) throw Error($f840b7a2526f15a0$var$invalidEncoding);
    return offset - start;
};
/**
 * Tests if the specified string appears to be base64 encoded.
 * @param {string} string String to test
 * @returns {boolean} `true` if probably base64 encoded, otherwise false
 */ $f840b7a2526f15a0$var$base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};

});

parcelRegister("cTpsI", function(module, exports) {
"use strict";
module.exports = $962e5f58319de5e6$var$EventEmitter;
/**
 * Constructs a new event emitter instance.
 * @classdesc A minimal event emitter.
 * @memberof util
 * @constructor
 */ function $962e5f58319de5e6$var$EventEmitter() {
    /**
     * Registered listeners.
     * @type {Object.<string,*>}
     * @private
     */ this._listeners = Object.create(null);
}
/**
 * Event listener as used by {@link util.EventEmitter}.
 * @typedef EventEmitterListener
 * @type {function}
 * @param {...*} args Arguments
 * @returns {undefined}
 */ /**
 * Registers an event listener.
 * @param {string} evt Event name
 * @param {EventEmitterListener} fn Listener
 * @param {*} [ctx] Listener context
 * @returns {this} `this`
 */ $962e5f58319de5e6$var$EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn: fn,
        ctx: ctx || this
    });
    return this;
};
/**
 * Removes an event listener or any matching listeners if arguments are omitted.
 * @param {string} [evt] Event name. Removes all listeners if omitted.
 * @param {EventEmitterListener} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
 * @returns {this} `this`
 */ $962e5f58319de5e6$var$EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined) this._listeners = Object.create(null);
    else if (fn === undefined) this._listeners[evt] = [];
    else {
        var listeners = this._listeners[evt];
        if (!listeners) return this;
        for(var i = 0; i < listeners.length;)if (listeners[i].fn === fn) listeners.splice(i, 1);
        else ++i;
    }
    return this;
};
/**
 * Emits an event by calling its listeners with the specified arguments.
 * @param {string} evt Event name
 * @param {...*} args Arguments
 * @returns {this} `this`
 */ $962e5f58319de5e6$var$EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [], i = 1;
        for(; i < arguments.length;)args.push(arguments[i++]);
        for(i = 0; i < listeners.length;)listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};

});

parcelRegister("b8LQB", function(module, exports) {
"use strict";
module.exports = $81c58e96688a18b7$var$factory($81c58e96688a18b7$var$factory);
/**
 * Reads / writes floats / doubles from / to buffers.
 * @name util.float
 * @namespace
 */ /**
 * Writes a 32 bit float to a buffer using little endian byte order.
 * @name util.float.writeFloatLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 32 bit float to a buffer using big endian byte order.
 * @name util.float.writeFloatBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 32 bit float from a buffer using little endian byte order.
 * @name util.float.readFloatLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 32 bit float from a buffer using big endian byte order.
 * @name util.float.readFloatBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Writes a 64 bit double to a buffer using little endian byte order.
 * @name util.float.writeDoubleLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 64 bit double to a buffer using big endian byte order.
 * @name util.float.writeDoubleBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 64 bit double from a buffer using little endian byte order.
 * @name util.float.readDoubleLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 64 bit double from a buffer using big endian byte order.
 * @name util.float.readDoubleBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ // Factory function for the purpose of node-based testing in modified global environments
function $81c58e96688a18b7$var$factory(exports) {
    // float: typed array
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([
            -0
        ]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        /* istanbul ignore next */ exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        /* istanbul ignore next */ exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        /* istanbul ignore next */ exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    // float: ieee754
    })();
    else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
            else if (isNaN(val)) writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38) writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38) writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, $81c58e96688a18b7$var$writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, $81c58e96688a18b7$var$writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
            return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 1.401298464324817e-45 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, $81c58e96688a18b7$var$readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, $81c58e96688a18b7$var$readUintBE);
    })();
    // double: typed array
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([
            -0
        ]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        /* istanbul ignore next */ exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        /* istanbul ignore next */ exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        /* istanbul ignore next */ exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    // double: ieee754
    })();
    else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024) exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, $81c58e96688a18b7$var$writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, $81c58e96688a18b7$var$writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 5e-324 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, $81c58e96688a18b7$var$readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, $81c58e96688a18b7$var$readUintBE, 4, 0);
    })();
    return exports;
}
// uint helpers
function $81c58e96688a18b7$var$writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
function $81c58e96688a18b7$var$writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
}
function $81c58e96688a18b7$var$readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
}
function $81c58e96688a18b7$var$readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
}

});

parcelRegister("1x6UU", function(module, exports) {
"use strict";
/**
 * A minimal UTF8 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $11de3d165fc704f0$var$utf8 = module.exports, $11de3d165fc704f0$var$replacementChar = "\ufffd";
/**
 * Calculates the UTF8 byte length of a string.
 * @param {string} string String
 * @returns {number} Byte length
 */ $11de3d165fc704f0$var$utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for(var i = 0; i < string.length; ++i){
        c = string.charCodeAt(i);
        if (c < 128) len += 1;
        else if (c < 2048) len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else len += 3;
    }
    return len;
};
/**
 * Reads UTF8 bytes as a string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} String read
 */ $11de3d165fc704f0$var$utf8.read = function utf8_read(buffer, start, end) {
    if (end - start < 1) return "";
    var str = "";
    for(var i = start; i < end;){
        var t = buffer[i++];
        if (t <= 0x7F) str += String.fromCharCode(t);
        else if (t >= 0xC0 && t < 0xE0) {
            var c2 = (t & 0x1F) << 6 | buffer[i++] & 0x3F;
            str += c2 >= 0x80 ? String.fromCharCode(c2) : $11de3d165fc704f0$var$replacementChar;
        } else if (t >= 0xE0 && t < 0xF0) {
            var c3 = (t & 0xF) << 12 | (buffer[i++] & 0x3F) << 6 | buffer[i++] & 0x3F;
            str += c3 >= 0x800 ? String.fromCharCode(c3) : $11de3d165fc704f0$var$replacementChar;
        } else if (t >= 0xF0) {
            var t2 = (t & 7) << 18 | (buffer[i++] & 0x3F) << 12 | (buffer[i++] & 0x3F) << 6 | buffer[i++] & 0x3F;
            if (t2 < 0x10000 || t2 > 0x10FFFF) str += $11de3d165fc704f0$var$replacementChar;
            else {
                t2 -= 0x10000;
                str += String.fromCharCode(0xD800 + (t2 >> 10));
                str += String.fromCharCode(0xDC00 + (t2 & 0x3FF));
            }
        }
    }
    return str;
};
/**
 * Writes a string as UTF8 bytes.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Bytes written
 */ $11de3d165fc704f0$var$utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2; // character 2
    for(var i = 0; i < string.length; ++i){
        c1 = string.charCodeAt(i);
        if (c1 < 128) buffer[offset++] = c1;
        else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6 | 192;
            buffer[offset++] = c1 & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18 | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12 | 224;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        }
    }
    return offset - start;
};

});

parcelRegister("hU2wx", function(module, exports) {
"use strict";
module.exports = $d0899fc8295f4c1e$var$pool;
/**
 * An allocator as used by {@link util.pool}.
 * @typedef PoolAllocator
 * @type {function}
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ /**
 * A slicer as used by {@link util.pool}.
 * @typedef PoolSlicer
 * @type {function}
 * @param {number} start Start offset
 * @param {number} end End offset
 * @returns {Uint8Array} Buffer slice
 * @this {Uint8Array}
 */ /**
 * A general purpose buffer pool.
 * @memberof util
 * @function
 * @param {PoolAllocator} alloc Allocator
 * @param {PoolSlicer} slice Slicer
 * @param {number} [size=8192] Slab size
 * @returns {PoolAllocator} Pooled allocator
 */ function $d0899fc8295f4c1e$var$pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX) return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7) offset = (offset | 7) + 1;
        return buf;
    };
}

});

parcelRegister("5S9hy", function(module, exports) {
"use strict";
module.exports = $44693224ff456c0c$var$LongBits;

var $hf2LF = parcelRequire("hf2LF");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function $44693224ff456c0c$var$LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var $44693224ff456c0c$var$zero = $44693224ff456c0c$var$LongBits.zero = new $44693224ff456c0c$var$LongBits(0, 0);
$44693224ff456c0c$var$zero.toNumber = function() {
    return 0;
};
$44693224ff456c0c$var$zero.zzEncode = $44693224ff456c0c$var$zero.zzDecode = function() {
    return this;
};
$44693224ff456c0c$var$zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var $44693224ff456c0c$var$zeroHash = $44693224ff456c0c$var$LongBits.zeroHash = "\0\0\0\0\0\0\0\0";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ $44693224ff456c0c$var$LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return $44693224ff456c0c$var$zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new $44693224ff456c0c$var$LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ $44693224ff456c0c$var$LongBits.from = function from(value) {
    if (typeof value === "number") return $44693224ff456c0c$var$LongBits.fromNumber(value);
    if ($hf2LF.isString(value)) {
        /* istanbul ignore else */ if ($hf2LF.Long) value = $hf2LF.Long.fromString(value);
        else return $44693224ff456c0c$var$LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new $44693224ff456c0c$var$LongBits(value.low >>> 0, value.high >>> 0) : $44693224ff456c0c$var$zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ $44693224ff456c0c$var$LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ $44693224ff456c0c$var$LongBits.prototype.toLong = function toLong(unsigned) {
    return $hf2LF.Long ? new $hf2LF.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var $44693224ff456c0c$var$charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ $44693224ff456c0c$var$LongBits.fromHash = function fromHash(hash) {
    if (hash === $44693224ff456c0c$var$zeroHash) return $44693224ff456c0c$var$zero;
    return new $44693224ff456c0c$var$LongBits(($44693224ff456c0c$var$charCodeAt.call(hash, 0) | $44693224ff456c0c$var$charCodeAt.call(hash, 1) << 8 | $44693224ff456c0c$var$charCodeAt.call(hash, 2) << 16 | $44693224ff456c0c$var$charCodeAt.call(hash, 3) << 24) >>> 0, ($44693224ff456c0c$var$charCodeAt.call(hash, 4) | $44693224ff456c0c$var$charCodeAt.call(hash, 5) << 8 | $44693224ff456c0c$var$charCodeAt.call(hash, 6) << 16 | $44693224ff456c0c$var$charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ $44693224ff456c0c$var$LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ $44693224ff456c0c$var$LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ $44693224ff456c0c$var$LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ $44693224ff456c0c$var$LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

});

parcelRegister("lkntF", function(module, exports) {
// GENERATED FILE. DO NOT EDIT.
(function(global, factory) {
    function preferDefault(exports1) {
        return exports1.default || exports1;
    }
    if (typeof define === "function" && define.amd) define([], function() {
        var exports1 = {};
        factory(exports1);
        return preferDefault(exports1);
    });
    else {
        factory(module.exports);
        module.exports = preferDefault(module.exports);
    }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : module.exports, function(_exports) {
    "use strict";
    Object.defineProperty(_exports, "__esModule", {
        value: true
    });
    _exports.default = void 0;
    /**
     * @license
     * Copyright 2009 The Closure Library Authors
     * Copyright 2020 Daniel Wirtz / The long.js Authors.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *     http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * SPDX-License-Identifier: Apache-2.0
     */ // WebAssembly optimizations to do native i64 multiplication and divide
    var wasm = null;
    try {
        wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
            // \0asm
            0,
            97,
            115,
            109,
            // version 1
            1,
            0,
            0,
            0,
            // section "type"
            1,
            13,
            2,
            // 0, () => i32
            96,
            0,
            1,
            127,
            // 1, (i32, i32, i32, i32) => i32
            96,
            4,
            127,
            127,
            127,
            127,
            1,
            127,
            // section "function"
            3,
            7,
            6,
            // 0, type 0
            0,
            // 1, type 1
            1,
            // 2, type 1
            1,
            // 3, type 1
            1,
            // 4, type 1
            1,
            // 5, type 1
            1,
            // section "global"
            6,
            6,
            1,
            // 0, "high", mutable i32
            127,
            1,
            65,
            0,
            11,
            // section "export"
            7,
            50,
            6,
            // 0, "mul"
            3,
            109,
            117,
            108,
            0,
            1,
            // 1, "div_s"
            5,
            100,
            105,
            118,
            95,
            115,
            0,
            2,
            // 2, "div_u"
            5,
            100,
            105,
            118,
            95,
            117,
            0,
            3,
            // 3, "rem_s"
            5,
            114,
            101,
            109,
            95,
            115,
            0,
            4,
            // 4, "rem_u"
            5,
            114,
            101,
            109,
            95,
            117,
            0,
            5,
            // 5, "get_high"
            8,
            103,
            101,
            116,
            95,
            104,
            105,
            103,
            104,
            0,
            0,
            // section "code"
            10,
            191,
            1,
            6,
            // 0, "get_high"
            4,
            0,
            35,
            0,
            11,
            // 1, "mul"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            126,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            // 2, "div_s"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            127,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            // 3, "div_u"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            128,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            // 4, "rem_s"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            129,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            // 5, "rem_u"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            130,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11
        ])), {}).exports;
    } catch  {
    // no wasm support :(
    }
    /**
     * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
     *  See the from* functions below for more convenient ways of constructing Longs.
     * @exports Long
     * @class A Long class for representing a 64 bit two's-complement integer value.
     * @param {number} low The low (signed) 32 bits of the long
     * @param {number} high The high (signed) 32 bits of the long
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @constructor
     */ function Long(low, high, unsigned) {
        /**
       * The low 32 bits as a signed value.
       * @type {number}
       */ this.low = low | 0;
        /**
       * The high 32 bits as a signed value.
       * @type {number}
       */ this.high = high | 0;
        /**
       * Whether unsigned or not.
       * @type {boolean}
       */ this.unsigned = !!unsigned;
    }
    // The internal representation of a long is the two given signed, 32-bit values.
    // We use 32-bit pieces because these are the size of integers on which
    // Javascript performs bit-operations.  For operations like addition and
    // multiplication, we split each number into 16 bit pieces, which can easily be
    // multiplied within Javascript's floating-point representation without overflow
    // or change in sign.
    //
    // In the algorithms below, we frequently reduce the negative case to the
    // positive case by negating the input(s) and then post-processing the result.
    // Note that we must ALWAYS check specially whether those values are MIN_VALUE
    // (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
    // a positive number, it overflows back into a negative).  Not handling this
    // case would often result in infinite recursion.
    //
    // Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
    // methods on which they depend.
    /**
     * An indicator used to reliably determine if an object is a Long or not.
     * @type {boolean}
     * @const
     * @private
     */ Long.prototype.__isLong__;
    Object.defineProperty(Long.prototype, "__isLong__", {
        value: true
    });
    /**
     * @function
     * @param {*} obj Object
     * @returns {boolean}
     * @inner
     */ function isLong(obj) {
        return (obj && obj["__isLong__"]) === true;
    }
    /**
     * @function
     * @param {*} value number
     * @returns {number}
     * @inner
     */ function ctz32(value) {
        var c = Math.clz32(value & -value);
        return value ? 31 - c : c;
    }
    /**
     * Tests if the specified object is a Long.
     * @function
     * @param {*} obj Object
     * @returns {boolean}
     */ Long.isLong = isLong;
    /**
     * A cache of the Long representations of small integer values.
     * @type {!Object}
     * @inner
     */ var INT_CACHE = {};
    /**
     * A cache of the Long representations of small unsigned integer values.
     * @type {!Object}
     * @inner
     */ var UINT_CACHE = {};
    /**
     * @param {number} value
     * @param {boolean=} unsigned
     * @returns {!Long}
     * @inner
     */ function fromInt(value, unsigned) {
        var obj, cachedObj, cache;
        if (unsigned) {
            value >>>= 0;
            if (cache = 0 <= value && value < 256) {
                cachedObj = UINT_CACHE[value];
                if (cachedObj) return cachedObj;
            }
            obj = fromBits(value, 0, true);
            if (cache) UINT_CACHE[value] = obj;
            return obj;
        } else {
            value |= 0;
            if (cache = -128 <= value && value < 128) {
                cachedObj = INT_CACHE[value];
                if (cachedObj) return cachedObj;
            }
            obj = fromBits(value, value < 0 ? -1 : 0, false);
            if (cache) INT_CACHE[value] = obj;
            return obj;
        }
    }
    /**
     * Returns a Long representing the given 32 bit integer value.
     * @function
     * @param {number} value The 32 bit integer in question
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {!Long} The corresponding Long value
     */ Long.fromInt = fromInt;
    /**
     * @param {number} value
     * @param {boolean=} unsigned
     * @returns {!Long}
     * @inner
     */ function fromNumber(value, unsigned) {
        if (isNaN(value)) return unsigned ? UZERO : ZERO;
        if (unsigned) {
            if (value < 0) return UZERO;
            if (value >= TWO_PWR_64_DBL) return MAX_UNSIGNED_VALUE;
        } else {
            if (value <= -TWO_PWR_63_DBL) return MIN_VALUE;
            if (value + 1 >= TWO_PWR_63_DBL) return MAX_VALUE;
        }
        if (value < 0) return fromNumber(-value, unsigned).neg();
        return fromBits(value % TWO_PWR_32_DBL | 0, value / TWO_PWR_32_DBL | 0, unsigned);
    }
    /**
     * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
     * @function
     * @param {number} value The number in question
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {!Long} The corresponding Long value
     */ Long.fromNumber = fromNumber;
    /**
     * @param {number} lowBits
     * @param {number} highBits
     * @param {boolean=} unsigned
     * @returns {!Long}
     * @inner
     */ function fromBits(lowBits, highBits, unsigned) {
        return new Long(lowBits, highBits, unsigned);
    }
    /**
     * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
     *  assumed to use 32 bits.
     * @function
     * @param {number} lowBits The low 32 bits
     * @param {number} highBits The high 32 bits
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {!Long} The corresponding Long value
     */ Long.fromBits = fromBits;
    /**
     * @function
     * @param {number} base
     * @param {number} exponent
     * @returns {number}
     * @inner
     */ var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
    /**
     * @param {string} str
     * @param {(boolean|number)=} unsigned
     * @param {number=} radix
     * @returns {!Long}
     * @inner
     */ function fromString(str, unsigned, radix) {
        if (str.length === 0) throw Error("empty string");
        if (typeof unsigned === "number") {
            // For goog.math.long compatibility
            radix = unsigned;
            unsigned = false;
        } else unsigned = !!unsigned;
        if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return unsigned ? UZERO : ZERO;
        radix = radix || 10;
        if (radix < 2 || 36 < radix) throw RangeError("radix");
        var p;
        if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
        else if (p === 0) return fromString(str.substring(1), unsigned, radix).neg();
        // Do several (8) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = fromNumber(pow_dbl(radix, 8));
        var result = ZERO;
        for(var i = 0; i < str.length; i += 8){
            var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
            if (size < 8) {
                var power = fromNumber(pow_dbl(radix, size));
                result = result.mul(power).add(fromNumber(value));
            } else {
                result = result.mul(radixToPower);
                result = result.add(fromNumber(value));
            }
        }
        result.unsigned = unsigned;
        return result;
    }
    /**
     * Returns a Long representation of the given string, written using the specified radix.
     * @function
     * @param {string} str The textual representation of the Long
     * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
     * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
     * @returns {!Long} The corresponding Long value
     */ Long.fromString = fromString;
    /**
     * @function
     * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
     * @param {boolean=} unsigned
     * @returns {!Long}
     * @inner
     */ function fromValue(val, unsigned) {
        if (typeof val === "number") return fromNumber(val, unsigned);
        if (typeof val === "string") return fromString(val, unsigned);
        // Throws for non-objects, converts non-instanceof Long:
        return fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
    }
    /**
     * Converts the specified value to a Long using the appropriate from* function for its type.
     * @function
     * @param {!Long|number|bigint|string|!{low: number, high: number, unsigned: boolean}} val Value
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {!Long}
     */ Long.fromValue = fromValue;
    // NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
    // no runtime penalty for these.
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_16_DBL = 65536;
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_24_DBL = 16777216;
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;
    /**
     * @type {!Long}
     * @const
     * @inner
     */ var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);
    /**
     * @type {!Long}
     * @inner
     */ var ZERO = fromInt(0);
    /**
     * Signed zero.
     * @type {!Long}
     */ Long.ZERO = ZERO;
    /**
     * @type {!Long}
     * @inner
     */ var UZERO = fromInt(0, true);
    /**
     * Unsigned zero.
     * @type {!Long}
     */ Long.UZERO = UZERO;
    /**
     * @type {!Long}
     * @inner
     */ var ONE = fromInt(1);
    /**
     * Signed one.
     * @type {!Long}
     */ Long.ONE = ONE;
    /**
     * @type {!Long}
     * @inner
     */ var UONE = fromInt(1, true);
    /**
     * Unsigned one.
     * @type {!Long}
     */ Long.UONE = UONE;
    /**
     * @type {!Long}
     * @inner
     */ var NEG_ONE = fromInt(-1);
    /**
     * Signed negative one.
     * @type {!Long}
     */ Long.NEG_ONE = NEG_ONE;
    /**
     * @type {!Long}
     * @inner
     */ var MAX_VALUE = fromBits(-1, 2147483647, false);
    /**
     * Maximum signed value.
     * @type {!Long}
     */ Long.MAX_VALUE = MAX_VALUE;
    /**
     * @type {!Long}
     * @inner
     */ var MAX_UNSIGNED_VALUE = fromBits(-1, -1, true);
    /**
     * Maximum unsigned value.
     * @type {!Long}
     */ Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
    /**
     * @type {!Long}
     * @inner
     */ var MIN_VALUE = fromBits(0, -2147483648, false);
    /**
     * Minimum signed value.
     * @type {!Long}
     */ Long.MIN_VALUE = MIN_VALUE;
    /**
     * @alias Long.prototype
     * @inner
     */ var LongPrototype = Long.prototype;
    /**
     * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
     * @this {!Long}
     * @returns {number}
     */ LongPrototype.toInt = function toInt() {
        return this.unsigned ? this.low >>> 0 : this.low;
    };
    /**
     * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
     * @this {!Long}
     * @returns {number}
     */ LongPrototype.toNumber = function toNumber() {
        if (this.unsigned) return (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0);
        return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
    };
    /**
     * Converts the Long to a string written in the specified radix.
     * @this {!Long}
     * @param {number=} radix Radix (2-36), defaults to 10
     * @returns {string}
     * @override
     * @throws {RangeError} If `radix` is out of range
     */ LongPrototype.toString = function toString(radix) {
        radix = radix || 10;
        if (radix < 2 || 36 < radix) throw RangeError("radix");
        if (this.isZero()) return "0";
        if (this.isNegative()) {
            // Unsigned Longs are never negative
            if (this.eq(MIN_VALUE)) {
                // We need to change the Long value before it can be negated, so we remove
                // the bottom-most digit in this base and then recurse to do the rest.
                var radixLong = fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
                return div.toString(radix) + rem1.toInt().toString(radix);
            } else return "-" + this.neg().toString(radix);
        }
        // Do several (6) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned), rem = this;
        var result = "";
        while(true){
            var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
            rem = remDiv;
            if (rem.isZero()) return digits + result;
            else {
                while(digits.length < 6)digits = "0" + digits;
                result = "" + digits + result;
            }
        }
    };
    /**
     * Gets the high 32 bits as a signed integer.
     * @this {!Long}
     * @returns {number} Signed high bits
     */ LongPrototype.getHighBits = function getHighBits() {
        return this.high;
    };
    /**
     * Gets the high 32 bits as an unsigned integer.
     * @this {!Long}
     * @returns {number} Unsigned high bits
     */ LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
        return this.high >>> 0;
    };
    /**
     * Gets the low 32 bits as a signed integer.
     * @this {!Long}
     * @returns {number} Signed low bits
     */ LongPrototype.getLowBits = function getLowBits() {
        return this.low;
    };
    /**
     * Gets the low 32 bits as an unsigned integer.
     * @this {!Long}
     * @returns {number} Unsigned low bits
     */ LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
        return this.low >>> 0;
    };
    /**
     * Gets the number of bits needed to represent the absolute value of this Long.
     * @this {!Long}
     * @returns {number}
     */ LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
        if (this.isNegative()) // Unsigned Longs are never negative
        return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
        var val = this.high != 0 ? this.high : this.low;
        for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
        return this.high != 0 ? bit + 33 : bit + 1;
    };
    /**
     * Tests if this Long can be safely represented as a JavaScript number.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isSafeInteger = function isSafeInteger() {
        // 2^53-1 is the maximum safe value
        var top11Bits = this.high >> 21;
        // [0, 2^53-1]
        if (!top11Bits) return true;
        // > 2^53-1
        if (this.unsigned) return false;
        // [-2^53, -1] except -2^53
        return top11Bits === -1 && !(this.low === 0 && this.high === -2097152);
    };
    /**
     * Tests if this Long's value equals zero.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isZero = function isZero() {
        return this.high === 0 && this.low === 0;
    };
    /**
     * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
     * @returns {boolean}
     */ LongPrototype.eqz = LongPrototype.isZero;
    /**
     * Tests if this Long's value is negative.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isNegative = function isNegative() {
        return !this.unsigned && this.high < 0;
    };
    /**
     * Tests if this Long's value is positive or zero.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isPositive = function isPositive() {
        return this.unsigned || this.high >= 0;
    };
    /**
     * Tests if this Long's value is odd.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isOdd = function isOdd() {
        return (this.low & 1) === 1;
    };
    /**
     * Tests if this Long's value is even.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isEven = function isEven() {
        return (this.low & 1) === 0;
    };
    /**
     * Tests if this Long's value equals the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.equals = function equals(other) {
        if (!isLong(other)) other = fromValue(other);
        if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
        return this.high === other.high && this.low === other.low;
    };
    /**
     * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.eq = LongPrototype.equals;
    /**
     * Tests if this Long's value differs from the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.notEquals = function notEquals(other) {
        return !this.eq(/* validates */ other);
    };
    /**
     * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.neq = LongPrototype.notEquals;
    /**
     * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.ne = LongPrototype.notEquals;
    /**
     * Tests if this Long's value is less than the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.lessThan = function lessThan(other) {
        return this.comp(/* validates */ other) < 0;
    };
    /**
     * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.lt = LongPrototype.lessThan;
    /**
     * Tests if this Long's value is less than or equal the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
        return this.comp(/* validates */ other) <= 0;
    };
    /**
     * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.lte = LongPrototype.lessThanOrEqual;
    /**
     * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.le = LongPrototype.lessThanOrEqual;
    /**
     * Tests if this Long's value is greater than the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.greaterThan = function greaterThan(other) {
        return this.comp(/* validates */ other) > 0;
    };
    /**
     * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.gt = LongPrototype.greaterThan;
    /**
     * Tests if this Long's value is greater than or equal the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
        return this.comp(/* validates */ other) >= 0;
    };
    /**
     * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.gte = LongPrototype.greaterThanOrEqual;
    /**
     * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.ge = LongPrototype.greaterThanOrEqual;
    /**
     * Compares this Long's value with the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {number} 0 if they are the same, 1 if the this is greater and -1
     *  if the given one is greater
     */ LongPrototype.compare = function compare(other) {
        if (!isLong(other)) other = fromValue(other);
        if (this.eq(other)) return 0;
        var thisNeg = this.isNegative(), otherNeg = other.isNegative();
        if (thisNeg && !otherNeg) return -1;
        if (!thisNeg && otherNeg) return 1;
        // At this point the sign bits are the same
        if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
        // Both are positive if at least one is unsigned
        return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
    };
    /**
     * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {number} 0 if they are the same, 1 if the this is greater and -1
     *  if the given one is greater
     */ LongPrototype.comp = LongPrototype.compare;
    /**
     * Negates this Long's value.
     * @this {!Long}
     * @returns {!Long} Negated Long
     */ LongPrototype.negate = function negate() {
        if (!this.unsigned && this.eq(MIN_VALUE)) return MIN_VALUE;
        return this.not().add(ONE);
    };
    /**
     * Negates this Long's value. This is an alias of {@link Long#negate}.
     * @function
     * @returns {!Long} Negated Long
     */ LongPrototype.neg = LongPrototype.negate;
    /**
     * Returns the sum of this and the specified Long.
     * @this {!Long}
     * @param {!Long|number|bigint|string} addend Addend
     * @returns {!Long} Sum
     */ LongPrototype.add = function add(addend) {
        if (!isLong(addend)) addend = fromValue(addend);
        // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
        var a48 = this.high >>> 16;
        var a32 = this.high & 0xffff;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xffff;
        var b48 = addend.high >>> 16;
        var b32 = addend.high & 0xffff;
        var b16 = addend.low >>> 16;
        var b00 = addend.low & 0xffff;
        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 + b00;
        c16 += c00 >>> 16;
        c00 &= 0xffff;
        c16 += a16 + b16;
        c32 += c16 >>> 16;
        c16 &= 0xffff;
        c32 += a32 + b32;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c48 += a48 + b48;
        c48 &= 0xffff;
        return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
    };
    /**
     * Returns the difference of this and the specified Long.
     * @this {!Long}
     * @param {!Long|number|bigint|string} subtrahend Subtrahend
     * @returns {!Long} Difference
     */ LongPrototype.subtract = function subtract(subtrahend) {
        if (!isLong(subtrahend)) subtrahend = fromValue(subtrahend);
        return this.add(subtrahend.neg());
    };
    /**
     * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
     * @function
     * @param {!Long|number|bigint|string} subtrahend Subtrahend
     * @returns {!Long} Difference
     */ LongPrototype.sub = LongPrototype.subtract;
    /**
     * Returns the product of this and the specified Long.
     * @this {!Long}
     * @param {!Long|number|bigint|string} multiplier Multiplier
     * @returns {!Long} Product
     */ LongPrototype.multiply = function multiply(multiplier) {
        if (this.isZero()) return this;
        if (!isLong(multiplier)) multiplier = fromValue(multiplier);
        // use wasm support if present
        if (wasm) {
            var low = wasm["mul"](this.low, this.high, multiplier.low, multiplier.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        if (multiplier.isZero()) return this.unsigned ? UZERO : ZERO;
        if (this.eq(MIN_VALUE)) return multiplier.isOdd() ? MIN_VALUE : ZERO;
        if (multiplier.eq(MIN_VALUE)) return this.isOdd() ? MIN_VALUE : ZERO;
        if (this.isNegative()) {
            if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
            else return this.neg().mul(multiplier).neg();
        } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
        // If both longs are small, use float multiplication
        if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24)) return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
        // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
        // We can skip products that would overflow.
        var a48 = this.high >>> 16;
        var a32 = this.high & 0xffff;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xffff;
        var b48 = multiplier.high >>> 16;
        var b32 = multiplier.high & 0xffff;
        var b16 = multiplier.low >>> 16;
        var b00 = multiplier.low & 0xffff;
        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 * b00;
        c16 += c00 >>> 16;
        c00 &= 0xffff;
        c16 += a16 * b00;
        c32 += c16 >>> 16;
        c16 &= 0xffff;
        c16 += a00 * b16;
        c32 += c16 >>> 16;
        c16 &= 0xffff;
        c32 += a32 * b00;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c32 += a16 * b16;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c32 += a00 * b32;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
        c48 &= 0xffff;
        return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
    };
    /**
     * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
     * @function
     * @param {!Long|number|bigint|string} multiplier Multiplier
     * @returns {!Long} Product
     */ LongPrototype.mul = LongPrototype.multiply;
    /**
     * Returns this Long divided by the specified. The result is signed if this Long is signed or
     *  unsigned if this Long is unsigned.
     * @this {!Long}
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Quotient
     */ LongPrototype.divide = function divide(divisor) {
        if (!isLong(divisor)) divisor = fromValue(divisor);
        if (divisor.isZero()) throw Error("division by zero");
        // use wasm support if present
        if (wasm) {
            // guard against signed division overflow: the largest
            // negative number / -1 would be 1 larger than the largest
            // positive number, due to two's complement.
            if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
            return this;
            var low = (this.unsigned ? wasm["div_u"] : wasm["div_s"])(this.low, this.high, divisor.low, divisor.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        if (this.isZero()) return this.unsigned ? UZERO : ZERO;
        var approx, rem, res;
        if (!this.unsigned) {
            // This section is only relevant for signed longs and is derived from the
            // closure library as a whole.
            if (this.eq(MIN_VALUE)) {
                if (divisor.eq(ONE) || divisor.eq(NEG_ONE)) return MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
                else if (divisor.eq(MIN_VALUE)) return ONE;
                else {
                    // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                    var halfThis = this.shr(1);
                    approx = halfThis.div(divisor).shl(1);
                    if (approx.eq(ZERO)) return divisor.isNegative() ? ONE : NEG_ONE;
                    else {
                        rem = this.sub(divisor.mul(approx));
                        res = approx.add(rem.div(divisor));
                        return res;
                    }
                }
            } else if (divisor.eq(MIN_VALUE)) return this.unsigned ? UZERO : ZERO;
            if (this.isNegative()) {
                if (divisor.isNegative()) return this.neg().div(divisor.neg());
                return this.neg().div(divisor).neg();
            } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
            res = ZERO;
        } else {
            // The algorithm below has not been made for unsigned longs. It's therefore
            // required to take special care of the MSB prior to running it.
            if (!divisor.unsigned) divisor = divisor.toUnsigned();
            if (divisor.gt(this)) return UZERO;
            if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
            return UONE;
            res = UZERO;
        }
        // Repeat the following until the remainder is less than other:  find a
        // floating-point that approximates remainder / other *from below*, add this
        // into the result, and subtract it from the remainder.  It is critical that
        // the approximate value is less than or equal to the real value so that the
        // remainder never becomes negative.
        rem = this;
        while(rem.gte(divisor)){
            // Approximate the result of division. This may be a little greater or
            // smaller than the actual value.
            approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
            // We will tweak the approximate result by changing it in the 48-th digit or
            // the smallest non-fractional digit, whichever is larger.
            var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
            // that if it is too large, the product overflows and is negative.
            approxRes = fromNumber(approx), approxRem = approxRes.mul(divisor);
            while(approxRem.isNegative() || approxRem.gt(rem)){
                approx -= delta;
                approxRes = fromNumber(approx, this.unsigned);
                approxRem = approxRes.mul(divisor);
            }
            // We know the answer can't be zero... and actually, zero would cause
            // infinite recursion since we would make no progress.
            if (approxRes.isZero()) approxRes = ONE;
            res = res.add(approxRes);
            rem = rem.sub(approxRem);
        }
        return res;
    };
    /**
     * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
     * @function
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Quotient
     */ LongPrototype.div = LongPrototype.divide;
    /**
     * Returns this Long modulo the specified.
     * @this {!Long}
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Remainder
     */ LongPrototype.modulo = function modulo(divisor) {
        if (!isLong(divisor)) divisor = fromValue(divisor);
        // use wasm support if present
        if (wasm) {
            var low = (this.unsigned ? wasm["rem_u"] : wasm["rem_s"])(this.low, this.high, divisor.low, divisor.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        return this.sub(this.div(divisor).mul(divisor));
    };
    /**
     * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
     * @function
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Remainder
     */ LongPrototype.mod = LongPrototype.modulo;
    /**
     * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
     * @function
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Remainder
     */ LongPrototype.rem = LongPrototype.modulo;
    /**
     * Returns the bitwise NOT of this Long.
     * @this {!Long}
     * @returns {!Long}
     */ LongPrototype.not = function not() {
        return fromBits(~this.low, ~this.high, this.unsigned);
    };
    /**
     * Returns count leading zeros of this Long.
     * @this {!Long}
     * @returns {!number}
     */ LongPrototype.countLeadingZeros = function countLeadingZeros() {
        return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
    };
    /**
     * Returns count leading zeros. This is an alias of {@link Long#countLeadingZeros}.
     * @function
     * @param {!Long}
     * @returns {!number}
     */ LongPrototype.clz = LongPrototype.countLeadingZeros;
    /**
     * Returns count trailing zeros of this Long.
     * @this {!Long}
     * @returns {!number}
     */ LongPrototype.countTrailingZeros = function countTrailingZeros() {
        return this.low ? ctz32(this.low) : ctz32(this.high) + 32;
    };
    /**
     * Returns count trailing zeros. This is an alias of {@link Long#countTrailingZeros}.
     * @function
     * @param {!Long}
     * @returns {!number}
     */ LongPrototype.ctz = LongPrototype.countTrailingZeros;
    /**
     * Returns the bitwise AND of this Long and the specified.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other Long
     * @returns {!Long}
     */ LongPrototype.and = function and(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
    };
    /**
     * Returns the bitwise OR of this Long and the specified.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other Long
     * @returns {!Long}
     */ LongPrototype.or = function or(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
    };
    /**
     * Returns the bitwise XOR of this Long and the given one.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other Long
     * @returns {!Long}
     */ LongPrototype.xor = function xor(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
    };
    /**
     * Returns this Long with bits shifted to the left by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shiftLeft = function shiftLeft(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        else if (numBits < 32) return fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
        else return fromBits(0, this.low << numBits - 32, this.unsigned);
    };
    /**
     * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shl = LongPrototype.shiftLeft;
    /**
     * Returns this Long with bits arithmetically shifted to the right by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shiftRight = function shiftRight(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        else if (numBits < 32) return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
        else return fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
    };
    /**
     * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shr = LongPrototype.shiftRight;
    /**
     * Returns this Long with bits logically shifted to the right by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits < 32) return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >>> numBits, this.unsigned);
        if (numBits === 32) return fromBits(this.high, 0, this.unsigned);
        return fromBits(this.high >>> numBits - 32, 0, this.unsigned);
    };
    /**
     * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shru = LongPrototype.shiftRightUnsigned;
    /**
     * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
    /**
     * Returns this Long with bits rotated to the left by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Rotated Long
     */ LongPrototype.rotateLeft = function rotateLeft(numBits) {
        var b;
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits === 32) return fromBits(this.high, this.low, this.unsigned);
        if (numBits < 32) {
            b = 32 - numBits;
            return fromBits(this.low << numBits | this.high >>> b, this.high << numBits | this.low >>> b, this.unsigned);
        }
        numBits -= 32;
        b = 32 - numBits;
        return fromBits(this.high << numBits | this.low >>> b, this.low << numBits | this.high >>> b, this.unsigned);
    };
    /**
     * Returns this Long with bits rotated to the left by the given amount. This is an alias of {@link Long#rotateLeft}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Rotated Long
     */ LongPrototype.rotl = LongPrototype.rotateLeft;
    /**
     * Returns this Long with bits rotated to the right by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Rotated Long
     */ LongPrototype.rotateRight = function rotateRight(numBits) {
        var b;
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits === 32) return fromBits(this.high, this.low, this.unsigned);
        if (numBits < 32) {
            b = 32 - numBits;
            return fromBits(this.high << b | this.low >>> numBits, this.low << b | this.high >>> numBits, this.unsigned);
        }
        numBits -= 32;
        b = 32 - numBits;
        return fromBits(this.low << b | this.high >>> numBits, this.high << b | this.low >>> numBits, this.unsigned);
    };
    /**
     * Returns this Long with bits rotated to the right by the given amount. This is an alias of {@link Long#rotateRight}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Rotated Long
     */ LongPrototype.rotr = LongPrototype.rotateRight;
    /**
     * Converts this Long to signed.
     * @this {!Long}
     * @returns {!Long} Signed long
     */ LongPrototype.toSigned = function toSigned() {
        if (!this.unsigned) return this;
        return fromBits(this.low, this.high, false);
    };
    /**
     * Converts this Long to unsigned.
     * @this {!Long}
     * @returns {!Long} Unsigned long
     */ LongPrototype.toUnsigned = function toUnsigned() {
        if (this.unsigned) return this;
        return fromBits(this.low, this.high, true);
    };
    /**
     * Converts this Long to its byte representation.
     * @param {boolean=} le Whether little or big endian, defaults to big endian
     * @this {!Long}
     * @returns {!Array.<number>} Byte representation
     */ LongPrototype.toBytes = function toBytes(le) {
        return le ? this.toBytesLE() : this.toBytesBE();
    };
    /**
     * Converts this Long to its little endian byte representation.
     * @this {!Long}
     * @returns {!Array.<number>} Little endian byte representation
     */ LongPrototype.toBytesLE = function toBytesLE() {
        var hi = this.high, lo = this.low;
        return [
            lo & 0xff,
            lo >>> 8 & 0xff,
            lo >>> 16 & 0xff,
            lo >>> 24,
            hi & 0xff,
            hi >>> 8 & 0xff,
            hi >>> 16 & 0xff,
            hi >>> 24
        ];
    };
    /**
     * Converts this Long to its big endian byte representation.
     * @this {!Long}
     * @returns {!Array.<number>} Big endian byte representation
     */ LongPrototype.toBytesBE = function toBytesBE() {
        var hi = this.high, lo = this.low;
        return [
            hi >>> 24,
            hi >>> 16 & 0xff,
            hi >>> 8 & 0xff,
            hi & 0xff,
            lo >>> 24,
            lo >>> 16 & 0xff,
            lo >>> 8 & 0xff,
            lo & 0xff
        ];
    };
    /**
     * Creates a Long from its byte representation.
     * @param {!Array.<number>} bytes Byte representation
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @param {boolean=} le Whether little or big endian, defaults to big endian
     * @returns {Long} The corresponding Long value
     */ Long.fromBytes = function fromBytes(bytes, unsigned, le) {
        return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
    };
    /**
     * Creates a Long from its little endian byte representation.
     * @param {!Array.<number>} bytes Little endian byte representation
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {Long} The corresponding Long value
     */ Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
        return new Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
    };
    /**
     * Creates a Long from its big endian byte representation.
     * @param {!Array.<number>} bytes Big endian byte representation
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {Long} The corresponding Long value
     */ Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
        return new Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
    };
    // Support conversion to/from BigInt where available
    if (typeof BigInt === "function") {
        /**
       * Returns a Long representing the given big integer.
       * @function
       * @param {number} value The big integer value
       * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
       * @returns {!Long} The corresponding Long value
       */ Long.fromBigInt = function fromBigInt(value, unsigned) {
            var lowBits = Number(BigInt.asIntN(32, value));
            var highBits = Number(BigInt.asIntN(32, value >> BigInt(32)));
            return fromBits(lowBits, highBits, unsigned);
        };
        // Override
        Long.fromValue = function fromValueWithBigInt(value, unsigned) {
            if (typeof value === "bigint") return Long.fromBigInt(value, unsigned);
            return fromValue(value, unsigned);
        };
        /**
       * Converts the Long to its big integer representation.
       * @this {!Long}
       * @returns {bigint}
       */ LongPrototype.toBigInt = function toBigInt() {
            var lowBigInt = BigInt(this.low >>> 0);
            var highBigInt = BigInt(this.unsigned ? this.high >>> 0 : this.high);
            return highBigInt << BigInt(32) | lowBigInt;
        };
    }
    var _default = _exports.default = Long;
});

});



parcelRegister("axYUT", function(module, exports) {
"use strict";
module.exports = $7adc3d3bb0285adb$var$BufferWriter;

var $3KUVy = parcelRequire("3KUVy");
($7adc3d3bb0285adb$var$BufferWriter.prototype = Object.create($3KUVy.prototype)).constructor = $7adc3d3bb0285adb$var$BufferWriter;

var $hf2LF = parcelRequire("hf2LF");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function $7adc3d3bb0285adb$var$BufferWriter() {
    $3KUVy.call(this);
}
$7adc3d3bb0285adb$var$BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ $7adc3d3bb0285adb$var$BufferWriter.alloc = $hf2LF._Buffer_allocUnsafe;
    $7adc3d3bb0285adb$var$BufferWriter.writeBytesBuffer = $hf2LF.Buffer && $hf2LF.Buffer.prototype instanceof Uint8Array && $hf2LF.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ $7adc3d3bb0285adb$var$BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if ($hf2LF.isString(value)) value = $hf2LF._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push($7adc3d3bb0285adb$var$BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function $7adc3d3bb0285adb$var$writeStringBuffer(val, buf, pos) {
    if (val.length < 40) $hf2LF.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ $7adc3d3bb0285adb$var$BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = $hf2LF.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push($7adc3d3bb0285adb$var$writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ $7adc3d3bb0285adb$var$BufferWriter._configure();

});

parcelRegister("hP5zC", function(module, exports) {
"use strict";
module.exports = $cf9b85d8c65bf523$var$Reader;

var $hf2LF = parcelRequire("hf2LF");
var $cf9b85d8c65bf523$var$BufferReader; // cyclic
var $cf9b85d8c65bf523$var$LongBits = $hf2LF.LongBits, $cf9b85d8c65bf523$var$utf8 = $hf2LF.utf8;
/* istanbul ignore next */ function $cf9b85d8c65bf523$var$indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function $cf9b85d8c65bf523$var$Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var $cf9b85d8c65bf523$var$create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new $cf9b85d8c65bf523$var$Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new $cf9b85d8c65bf523$var$Reader(buffer);
    throw Error("illegal buffer");
};
var $cf9b85d8c65bf523$var$create = function create() {
    return $hf2LF.Buffer ? function create_buffer_setup(buffer) {
        return ($cf9b85d8c65bf523$var$Reader.create = function create_buffer(buffer) {
            return $hf2LF.Buffer.isBuffer(buffer) ? new $cf9b85d8c65bf523$var$BufferReader(buffer) : $cf9b85d8c65bf523$var$create_array(buffer);
        })(buffer);
    } : $cf9b85d8c65bf523$var$create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ $cf9b85d8c65bf523$var$Reader.create = $cf9b85d8c65bf523$var$create();
$cf9b85d8c65bf523$var$Reader.prototype._slice = $hf2LF.Array.prototype.subarray || /* istanbul ignore next */ $hf2LF.Array.prototype.slice;
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function $cf9b85d8c65bf523$var$readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new $cf9b85d8c65bf523$var$LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function $cf9b85d8c65bf523$var$readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 4);
    return $cf9b85d8c65bf523$var$readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 4);
    return $cf9b85d8c65bf523$var$readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function $cf9b85d8c65bf523$var$readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 8);
    return new $cf9b85d8c65bf523$var$LongBits($cf9b85d8c65bf523$var$readFixed32_end(this.buf, this.pos += 4), $cf9b85d8c65bf523$var$readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 4);
    var value = $hf2LF.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 4);
    var value = $hf2LF.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    if (start === end) {
        var nativeBuffer = $hf2LF.Buffer;
        return nativeBuffer ? nativeBuffer.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return $cf9b85d8c65bf523$var$utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ $cf9b85d8c65bf523$var$Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Recursion limit.
 * @type {number}
 */ $cf9b85d8c65bf523$var$Reader.recursionLimit = $hf2LF.recursionLimit;
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @param {number} [depth] Depth of recursion to control nested calls; 0 if omitted
 * @returns {Reader} `this`
 */ $cf9b85d8c65bf523$var$Reader.prototype.skipType = function(wireType, depth) {
    if (depth === undefined) depth = 0;
    if (depth > $cf9b85d8c65bf523$var$Reader.recursionLimit) throw Error("maximum nesting depth exceeded");
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType, depth + 1);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
$cf9b85d8c65bf523$var$Reader._configure = function(BufferReader_) {
    $cf9b85d8c65bf523$var$BufferReader = BufferReader_;
    $cf9b85d8c65bf523$var$Reader.create = $cf9b85d8c65bf523$var$create();
    $cf9b85d8c65bf523$var$BufferReader._configure();
    var fn = $hf2LF.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    $hf2LF.merge($cf9b85d8c65bf523$var$Reader.prototype, {
        int64: function read_int64() {
            return $cf9b85d8c65bf523$var$readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return $cf9b85d8c65bf523$var$readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return $cf9b85d8c65bf523$var$readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return $cf9b85d8c65bf523$var$readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return $cf9b85d8c65bf523$var$readFixed64.call(this)[fn](false);
        }
    });
};

});

parcelRegister("hVbTm", function(module, exports) {
"use strict";
module.exports = $d0c0fc09890ced56$var$BufferReader;

var $hP5zC = parcelRequire("hP5zC");
($d0c0fc09890ced56$var$BufferReader.prototype = Object.create($hP5zC.prototype)).constructor = $d0c0fc09890ced56$var$BufferReader;

var $hf2LF = parcelRequire("hf2LF");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function $d0c0fc09890ced56$var$BufferReader(buffer) {
    $hP5zC.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
$d0c0fc09890ced56$var$BufferReader._configure = function() {
    /* istanbul ignore else */ if ($hf2LF.Buffer) $d0c0fc09890ced56$var$BufferReader.prototype._slice = $hf2LF.Buffer.prototype.slice;
};
/**
 * @override
 */ $d0c0fc09890ced56$var$BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ $d0c0fc09890ced56$var$BufferReader._configure();

});

parcelRegister("kPAIY", function(module, exports) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var $f2a50ebf117c2427$var$rpc = module.exports;

/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ $f2a50ebf117c2427$var$rpc.Service = (parcelRequire("9qfRI"));

});
parcelRegister("9qfRI", function(module, exports) {
"use strict";
module.exports = $6dc2d94c097e90b5$var$Service;

var $hf2LF = parcelRequire("hf2LF");
// Extends EventEmitter
($6dc2d94c097e90b5$var$Service.prototype = Object.create($hf2LF.EventEmitter.prototype)).constructor = $6dc2d94c097e90b5$var$Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function $6dc2d94c097e90b5$var$Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    $hf2LF.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ $6dc2d94c097e90b5$var$Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return $hf2LF.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ $6dc2d94c097e90b5$var$Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

});


parcelRegister("38hgC", function(module, exports) {
"use strict";
module.exports = Object.create(null); /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available across modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

});




parcelRegister("hRU3k", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientMetricReportDirection = void 0;
var $d022ddca8e441e6d$var$ClientMetricReportDirection;
(function(ClientMetricReportDirection) {
    ClientMetricReportDirection[ClientMetricReportDirection["UPSTREAM"] = 0] = "UPSTREAM";
    ClientMetricReportDirection[ClientMetricReportDirection["DOWNSTREAM"] = 1] = "DOWNSTREAM";
})($d022ddca8e441e6d$var$ClientMetricReportDirection || (module.exports.ClientMetricReportDirection = $d022ddca8e441e6d$var$ClientMetricReportDirection = {}));
module.exports.default = $d022ddca8e441e6d$var$ClientMetricReportDirection;

});

parcelRegister("aU8Oy", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientMetricReportMediaType = void 0;
var $7f05f8b19c750ca2$var$ClientMetricReportMediaType;
(function(ClientMetricReportMediaType) {
    ClientMetricReportMediaType[ClientMetricReportMediaType["AUDIO"] = 0] = "AUDIO";
    ClientMetricReportMediaType[ClientMetricReportMediaType["VIDEO"] = 1] = "VIDEO";
})($7f05f8b19c750ca2$var$ClientMetricReportMediaType || (module.exports.ClientMetricReportMediaType = $7f05f8b19c750ca2$var$ClientMetricReportMediaType = {}));
module.exports.default = $7f05f8b19c750ca2$var$ClientMetricReportMediaType;

});

parcelRegister("9ySID", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $6f61bc1231568ac0$var$GlobalMetricReport {
    constructor(){
        this.previousMetrics = {};
        this.currentMetrics = {};
        // As metric values do not necessarily be number, this is a workaround in case metric value is string
        this.currentStringMetrics = {};
        this.previousObjectMetrics = {};
        this.currentObjectMetrics = {};
    }
}
module.exports.default = $6f61bc1231568ac0$var$GlobalMetricReport;

});


parcelRegister("l8Suu", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $f6449d13b9930a66$var$ClientVideoStreamReceivingReport {
}
module.exports.default = $f6449d13b9930a66$var$ClientVideoStreamReceivingReport;

});

parcelRegister("5TTTN", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $44bd732c402879fd$var$ConnectionHealthData {
    constructor(){
        this.connectionStartTimestampMs = 0;
        this.consecutiveStatsWithNoPackets = 0;
        this.consecutiveStatsWithNoAudioPacketsSent = 0;
        this.lastPacketLossInboundTimestampMs = 0;
        this.lastGoodSignalTimestampMs = 0;
        this.lastWeakSignalTimestampMs = 0;
        this.lastNoSignalTimestampMs = 0;
        this.consecutiveMissedPongs = 0;
        this.packetsReceivedInLastMinute = [];
        this.fractionPacketsLostInboundInLastMinute = [];
        this.audioSpeakerDelayMs = 0;
        this.isVideoEncoderHardware = false;
        this.videoEncodingTimeInMs = 0;
        this.videoEncodingTimePerFrameInMs = 0;
        this.cpuLimitationDuration = 0;
        this.videoInputFps = 0;
        this.videoEncodeFps = 0;
        this.isContentShare = false;
        this.numberOfPublishedVideoSources = 0;
        this.connectionStartTimestampMs = Date.now();
        this.lastGoodSignalTimestampMs = Date.now();
    }
    static isTimestampRecent(timestampMs, recentDurationMs) {
        return Date.now() < timestampMs + recentDurationMs;
    }
    setConnectionStartTime() {
        this.connectionStartTimestampMs = Date.now();
        this.lastGoodSignalTimestampMs = Date.now();
    }
    reset() {
        this.connectionStartTimestampMs = 0;
        this.consecutiveStatsWithNoPackets = 0;
        this.consecutiveStatsWithNoAudioPacketsSent = 0;
        this.lastPacketLossInboundTimestampMs = 0;
        this.lastGoodSignalTimestampMs = 0;
        this.lastWeakSignalTimestampMs = 0;
        this.lastNoSignalTimestampMs = 0;
        this.consecutiveMissedPongs = 0;
        this.packetsReceivedInLastMinute = [];
        this.fractionPacketsLostInboundInLastMinute = [];
        this.audioSpeakerDelayMs = 0;
        this.connectionStartTimestampMs = Date.now();
        this.lastGoodSignalTimestampMs = Date.now();
        this.isVideoEncoderHardware = false;
        this.videoEncodingTimeInMs = 0;
        this.videoEncodingTimePerFrameInMs = 0;
        this.cpuLimitationDuration = 0;
        this.videoInputFps = 0;
        this.videoEncodeFps = 0;
        this.isContentShare = false;
        this.numberOfPublishedVideoSources = 0;
    }
    isConnectionStartRecent(recentDurationMs) {
        return $44bd732c402879fd$var$ConnectionHealthData.isTimestampRecent(this.connectionStartTimestampMs, recentDurationMs);
    }
    isLastPacketLossRecent(recentDurationMs) {
        return $44bd732c402879fd$var$ConnectionHealthData.isTimestampRecent(this.lastPacketLossInboundTimestampMs, recentDurationMs);
    }
    isGoodSignalRecent(recentDurationMs) {
        return $44bd732c402879fd$var$ConnectionHealthData.isTimestampRecent(this.lastGoodSignalTimestampMs, recentDurationMs);
    }
    isWeakSignalRecent(recentDurationMs) {
        return $44bd732c402879fd$var$ConnectionHealthData.isTimestampRecent(this.lastWeakSignalTimestampMs, recentDurationMs);
    }
    isNoSignalRecent(recentDurationMs) {
        return $44bd732c402879fd$var$ConnectionHealthData.isTimestampRecent(this.lastNoSignalTimestampMs, recentDurationMs);
    }
    clone() {
        const cloned = new $44bd732c402879fd$var$ConnectionHealthData();
        cloned.connectionStartTimestampMs = this.connectionStartTimestampMs;
        cloned.consecutiveStatsWithNoPackets = this.consecutiveStatsWithNoPackets;
        cloned.consecutiveStatsWithNoAudioPacketsSent = this.consecutiveStatsWithNoAudioPacketsSent;
        cloned.lastPacketLossInboundTimestampMs = this.lastPacketLossInboundTimestampMs;
        cloned.lastGoodSignalTimestampMs = this.lastGoodSignalTimestampMs;
        cloned.lastWeakSignalTimestampMs = this.lastWeakSignalTimestampMs;
        cloned.lastNoSignalTimestampMs = this.lastNoSignalTimestampMs;
        cloned.consecutiveMissedPongs = this.consecutiveMissedPongs;
        cloned.packetsReceivedInLastMinute = this.packetsReceivedInLastMinute.slice(0);
        cloned.fractionPacketsLostInboundInLastMinute = this.fractionPacketsLostInboundInLastMinute.slice(0);
        cloned.audioSpeakerDelayMs = this.audioSpeakerDelayMs;
        cloned.isVideoEncoderHardware = this.isVideoEncoderHardware;
        cloned.videoEncodingTimeInMs = this.videoEncodingTimeInMs;
        cloned.videoEncodingTimePerFrameInMs = this.videoEncodingTimePerFrameInMs;
        cloned.cpuLimitationDuration = this.cpuLimitationDuration;
        cloned.videoInputFps = this.videoInputFps;
        cloned.videoEncodeFps = this.videoEncodeFps;
        cloned.isContentShare = this.isContentShare;
        cloned.numberOfPublishedVideoSources = this.numberOfPublishedVideoSources;
        return cloned;
    }
    setConsecutiveMissedPongs(pongs) {
        this.consecutiveMissedPongs = pongs;
    }
    setConsecutiveStatsWithNoPackets(stats) {
        this.consecutiveStatsWithNoPackets = stats;
    }
    setConsecutiveStatsWithNoAudioPacketsSent(stats) {
        this.consecutiveStatsWithNoAudioPacketsSent = stats;
    }
    setLastPacketLossInboundTimestampMs(timeStamp) {
        this.lastPacketLossInboundTimestampMs = timeStamp;
    }
    setLastNoSignalTimestampMs(timeStamp) {
        this.lastNoSignalTimestampMs = timeStamp;
    }
    setLastWeakSignalTimestampMs(timeStamp) {
        this.lastWeakSignalTimestampMs = timeStamp;
    }
    setLastGoodSignalTimestampMs(timeStamp) {
        this.lastGoodSignalTimestampMs = timeStamp;
    }
    setAudioSpeakerDelayMs(delayMs) {
        this.audioSpeakerDelayMs = delayMs;
    }
    setIsVideoEncoderHardware(isHardware) {
        this.isVideoEncoderHardware = isHardware;
    }
    setVideoEncodingTimeInMs(stats) {
        this.videoEncodingTimeInMs = stats;
    }
    setVideoEncodingTimePerFrameInMs(stats) {
        this.videoEncodingTimePerFrameInMs = stats;
    }
    setCpuLimitationDuration(stats) {
        this.cpuLimitationDuration = stats;
    }
    setVideoInputFps(stats) {
        this.videoInputFps = stats;
    }
    setVideoEncodeFps(stats) {
        this.videoEncodeFps = stats;
    }
    setIsContentShare(isContentShare) {
        this.isContentShare = isContentShare;
    }
    setNumberOfPublishedVideoSources(stats) {
        this.numberOfPublishedVideoSources = stats;
    }
}
module.exports.default = $44bd732c402879fd$var$ConnectionHealthData;

});

parcelRegister("gCpm1", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c193dcc207cebbd3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $c193dcc207cebbd3$var$VideoEncodingConcurrentSendersHealthPolicy_1 = $c193dcc207cebbd3$var$__importDefault((parcelRequire("jk9DA")));

const $c193dcc207cebbd3$var$VideoEncodingCpuConnectionHealthPolicy_1 = $c193dcc207cebbd3$var$__importDefault((parcelRequire("iv6ge")));

const $c193dcc207cebbd3$var$VideoEncodingFramerateConnectionHealthPolicy_1 = $c193dcc207cebbd3$var$__importDefault((parcelRequire("eLe4C")));
class $c193dcc207cebbd3$var$ConnectionHealthPolicyConfiguration {
    constructor(){
        this.minHealth = 0;
        this.maxHealth = 1;
        this.initialHealth = 1;
        this.connectionUnhealthyThreshold = 25;
        this.noSignalThresholdTimeMs = 10000;
        this.connectionWaitTimeMs = 10000;
        this.zeroBarsNoSignalTimeMs = 5000;
        this.oneBarWeakSignalTimeMs = 5000;
        this.twoBarsTimeMs = 5000;
        this.threeBarsTimeMs = 10000;
        this.fourBarsTimeMs = 20000;
        this.fiveBarsTimeMs = 60000;
        this.cooldownTimeMs = 60000;
        this.pastSamplesToConsider = 15;
        this.goodSignalTimeMs = 15000;
        this.fractionalLoss = 0.5;
        this.packetsExpected = 50;
        this.maximumTimesToWarn = 2;
        this.missedPongsLowerThreshold = 1;
        this.missedPongsUpperThreshold = 4;
        this.maximumAudioDelayMs = 60000;
        this.maximumAudioDelayDataPoints = 10;
        /**
         * The number of samples required to consider sending-audio to be unhealthy
         *
         * The default value is derived from the median for time taken for receiving an attendee presence message from the
         * server after joining. Attendee presence is only received when the client sends audio packets to the server, so
         * this metric is used as a proxy.
         */ this.sendingAudioFailureSamplesToConsider = 2;
        /**
         * The purpose of this field is to add a wait time/delay to our evaluation of sending audio health
         * as the microphone may sometimes cause a delay in sending audio packets during the initial stages of a connection.
         */ this.sendingAudioFailureInitialWaitTimeMs = 3000;
        /**
         * Policies and parameters related to video encoding health montoring
         */ this.videoEncodingHealthPolicies = [
            $c193dcc207cebbd3$var$VideoEncodingConcurrentSendersHealthPolicy_1.default,
            $c193dcc207cebbd3$var$VideoEncodingCpuConnectionHealthPolicy_1.default,
            $c193dcc207cebbd3$var$VideoEncodingFramerateConnectionHealthPolicy_1.default
        ];
        /**
         * Consecutive seconds of high encode CPU to trigger video codec degradation in video encoding health monitoring.
         * Increasing the value results in less sensitive video codec degradaion and vice versa.
         */ this.consecutiveHighEncodeCpuThreshold = 10;
        /**
         * Encode time threshold to determine high CPU usage of software encoders in video encoding health monitoring.
         * Recuding the value results in video codec degradation due to high CPU usage software encoder to be triggered
         * at a lower CPU usage.
         */ this.highEncodeCpuMsThreshold = 500;
        /**
         * Encode time per frame threshold to determine high CPU usage of software encoders in video encoding health
         * monitoring. Recuding the value results in video codec degradation due to high CPU usage software encoder to
         * be triggered at a lower CPU usage. Note that encoder counts each SVC spatial layer of a frame as an encoded
         * frame. The magnification in framerate should be considered when configuring this parameter with SVC enabled.
         */ this.highEncodeCpuMsPerFrameThreshold = 15;
        /**
         * Consecutive seconds of zero encoded framerate to trigger video codec degradation in video encoding health monitoring.
         * Increasing the value results in less sensitive video codec degradaion and vice versa.
         */ this.consecutiveVideoEncodingFailureThreshold = 5;
        /**
         * Number of concurrent video senders to trigger video codec degradation from VP9/AV1 in video encoding health monitoring.
         */ this.concurrentVideoSendersThreshold = 15;
    }
}
module.exports.default = $c193dcc207cebbd3$var$ConnectionHealthPolicyConfiguration;

});
parcelRegister("jk9DA", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $e1175c5c47ec7519$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $e1175c5c47ec7519$var$BaseConnectionHealthPolicy_1 = $e1175c5c47ec7519$var$__importDefault((parcelRequire("j8TgN")));

const $e1175c5c47ec7519$var$VideoEncodingConnectionHealthPolicyName_1 = $e1175c5c47ec7519$var$__importDefault((parcelRequire("k4S8T")));
class $e1175c5c47ec7519$var$VideoEncodingConcurrentSendersHealthPolicy extends $e1175c5c47ec7519$var$BaseConnectionHealthPolicy_1.default {
    constructor(configuration, data){
        super(configuration, data, $e1175c5c47ec7519$var$VideoEncodingConnectionHealthPolicyName_1.default.VideoConcurrentSendersHealth);
        this.concurrentVideoSendersThreshold = configuration.concurrentVideoSendersThreshold;
    }
    health() {
        if (this.currentData.isContentShare) // Do not degrade content share as the number of content share senders is limited
        return this.maximumHealth();
        if (this.currentData.numberOfPublishedVideoSources > this.concurrentVideoSendersThreshold) return this.minimumHealth();
        return this.maximumHealth();
    }
}
module.exports.default = $e1175c5c47ec7519$var$VideoEncodingConcurrentSendersHealthPolicy;

});
parcelRegister("k4S8T", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VideoEncodingConnectionHealthPolicyName = void 0;
/**
 * Video encoding connection policy names. The policy name is used in MonitorTask
 * to determine video codec degradation reason and report metrics accordingly.
 */ var $e9de2df1fbb94811$var$VideoEncodingConnectionHealthPolicyName;
(function(VideoEncodingConnectionHealthPolicyName) {
    VideoEncodingConnectionHealthPolicyName["VideoEncodingCpuHealth"] = "Video Encoding CPU Health";
    VideoEncodingConnectionHealthPolicyName["VideoEncodingFramerateHealth"] = "Video Encoding framerate Health";
    VideoEncodingConnectionHealthPolicyName["VideoConcurrentSendersHealth"] = "Video Concurrent Senders Health";
})($e9de2df1fbb94811$var$VideoEncodingConnectionHealthPolicyName || (module.exports.VideoEncodingConnectionHealthPolicyName = $e9de2df1fbb94811$var$VideoEncodingConnectionHealthPolicyName = {}));
module.exports.default = $e9de2df1fbb94811$var$VideoEncodingConnectionHealthPolicyName;

});


parcelRegister("iv6ge", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $d77ffa861d7435cb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $d77ffa861d7435cb$var$BaseConnectionHealthPolicy_1 = $d77ffa861d7435cb$var$__importDefault((parcelRequire("j8TgN")));

const $d77ffa861d7435cb$var$VideoEncodingConnectionHealthPolicyName_1 = $d77ffa861d7435cb$var$__importDefault((parcelRequire("k4S8T")));
class $d77ffa861d7435cb$var$VideoEncodingCpuConnectionHealthPolicy extends $d77ffa861d7435cb$var$BaseConnectionHealthPolicy_1.default {
    constructor(configuration, data){
        super(configuration, data, $d77ffa861d7435cb$var$VideoEncodingConnectionHealthPolicyName_1.default.VideoEncodingCpuHealth);
        this.consecutiveHighEncodeCpuCnt = 0;
        this.consecutiveHighEncodeCpuThreshold = configuration.consecutiveHighEncodeCpuThreshold;
        this.highEncodeCpuMsThreshold = configuration.highEncodeCpuMsThreshold;
        this.highEncodeCpuMsPerFrameThreshold = configuration.highEncodeCpuMsPerFrameThreshold;
    }
    health() {
        // Checking both per-frame and total encode time as we do not want video codec fallback in two conditions:
        // 1. High per-frame encode time with low framerate (e.g., high resolution, low framerate content share)
        // 2. High framerate with low per-frame encode time (e.g., high framerate SVC)
        const videoEncodingTimeIsHigh = this.currentData.videoEncodingTimeInMs >= this.highEncodeCpuMsThreshold && this.currentData.videoEncodingTimePerFrameInMs >= this.highEncodeCpuMsPerFrameThreshold;
        const cpuUsageIsHigh = !this.currentData.isVideoEncoderHardware && (videoEncodingTimeIsHigh || this.currentData.cpuLimitationDuration > 0);
        if (cpuUsageIsHigh) {
            this.consecutiveHighEncodeCpuCnt++;
            if (this.consecutiveHighEncodeCpuCnt > this.consecutiveHighEncodeCpuThreshold) {
                this.consecutiveHighEncodeCpuCnt = 0;
                return this.minimumHealth();
            }
        } else this.consecutiveHighEncodeCpuCnt = 0;
        return this.maximumHealth();
    }
}
module.exports.default = $d77ffa861d7435cb$var$VideoEncodingCpuConnectionHealthPolicy;

});

parcelRegister("eLe4C", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $abf05f32ccb83ba4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $abf05f32ccb83ba4$var$BaseConnectionHealthPolicy_1 = $abf05f32ccb83ba4$var$__importDefault((parcelRequire("j8TgN")));

const $abf05f32ccb83ba4$var$VideoEncodingConnectionHealthPolicyName_1 = $abf05f32ccb83ba4$var$__importDefault((parcelRequire("k4S8T")));
class $abf05f32ccb83ba4$var$VideoEncodingFramerateConnectionHealthPolicy extends $abf05f32ccb83ba4$var$BaseConnectionHealthPolicy_1.default {
    constructor(configuration, data){
        super(configuration, data, $abf05f32ccb83ba4$var$VideoEncodingConnectionHealthPolicyName_1.default.VideoEncodingFramerateHealth);
        this.consecutiveEncodeFailureCnt = 0;
        this.consecutiveVideoEncodingFailureThreshold = configuration.consecutiveVideoEncodingFailureThreshold;
    }
    health() {
        const videoEncoderFailed = this.currentData.videoEncodeFps === 0 && this.currentData.videoInputFps > 0;
        if (videoEncoderFailed) {
            this.consecutiveEncodeFailureCnt++;
            if (this.consecutiveEncodeFailureCnt > this.consecutiveVideoEncodingFailureThreshold) {
                this.consecutiveEncodeFailureCnt = 0;
                return this.minimumHealth();
            }
        } else this.consecutiveEncodeFailureCnt = 0;
        return this.maximumHealth();
    }
}
module.exports.default = $abf05f32ccb83ba4$var$VideoEncodingFramerateConnectionHealthPolicy;

});


parcelRegister("g6nnJ", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bb8f5800f5638e54$var$ContentShareConstants;
(function(ContentShareConstants) {
    ContentShareConstants["Modality"] = "#content";
})($bb8f5800f5638e54$var$ContentShareConstants || ($bb8f5800f5638e54$var$ContentShareConstants = {}));
module.exports.default = $bb8f5800f5638e54$var$ContentShareConstants;

});

parcelRegister("fpi9L", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $b3774651f522e400$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $b3774651f522e400$var$DefaultBrowserBehavior_1 = $b3774651f522e400$var$__importDefault((parcelRequire("e2TuV")));

const $b3774651f522e400$var$DefaultDeviceController_1 = $b3774651f522e400$var$__importDefault((parcelRequire("d5Rye")));
class $b3774651f522e400$var$ContentShareMediaStreamBroker {
    constructor(logger){
        this.logger = logger;
    }
    get mediaStream() {
        return this._mediaStream;
    }
    set mediaStream(mediaStream) {
        this._mediaStream = mediaStream;
    }
    async acquireAudioInputStream() {
        if (this._mediaStream.getAudioTracks().length === 0) {
            this.logger.info('No audio stream available. Synthesizing an audio stream.');
            return $b3774651f522e400$var$DefaultDeviceController_1.default.synthesizeAudioDevice(0);
        }
        return this._mediaStream;
    }
    async acquireVideoInputStream() {
        return this._mediaStream;
    }
    async acquireDisplayInputStream(streamConstraints) {
        if (streamConstraints && streamConstraints.video && // @ts-ignore
        streamConstraints.video.mandatory && // @ts-ignore
        streamConstraints.video.mandatory.chromeMediaSource && // @ts-ignore
        streamConstraints.video.mandatory.chromeMediaSourceId) return navigator.mediaDevices.getUserMedia(streamConstraints);
        // @ts-ignore https://github.com/microsoft/TypeScript/issues/31821
        return navigator.mediaDevices.getDisplayMedia(streamConstraints);
    }
    async acquireScreenCaptureDisplayInputStream(sourceId, frameRate) {
        return this.acquireDisplayInputStream(this.screenCaptureDisplayMediaConstraints(sourceId, frameRate));
    }
    screenCaptureDisplayMediaConstraints(sourceId, frameRate) {
        return {
            audio: !sourceId && new $b3774651f522e400$var$DefaultBrowserBehavior_1.default().getDisplayMediaAudioCaptureSupport() ? true : false,
            video: {
                ...!sourceId && {
                    frameRate: {
                        max: frameRate ? frameRate : $b3774651f522e400$var$ContentShareMediaStreamBroker.defaultFrameRate
                    }
                },
                ...sourceId && {
                    mandatory: {
                        chromeMediaSource: 'desktop',
                        chromeMediaSourceId: sourceId,
                        maxFrameRate: frameRate ? frameRate : $b3774651f522e400$var$ContentShareMediaStreamBroker.defaultFrameRate
                    }
                }
            }
        };
    }
    toggleMediaStream(enable) {
        let changed = false;
        if (this.mediaStream) {
            for(let i = 0; i < this.mediaStream.getTracks().length; i++)if (this.mediaStream.getTracks()[i].enabled !== enable) {
                this.mediaStream.getTracks()[i].enabled = enable;
                changed = true;
            }
        }
        return changed;
    }
    cleanup() {
        if (this.mediaStream) for(let i = 0; i < this.mediaStream.getTracks().length; i++){
            const track = this.mediaStream.getTracks()[i];
            track.stop();
        }
        this.mediaStream = null;
    }
    muteLocalAudioInputStream() {
        throw new Error('unsupported');
    }
    unmuteLocalAudioInputStream() {
        throw new Error('unsupported');
    }
    addMediaStreamBrokerObserver(_observer) {}
    removeMediaStreamBrokerObserver(_observer) {}
}
$b3774651f522e400$var$ContentShareMediaStreamBroker.defaultFrameRate = 15;
module.exports.default = $b3774651f522e400$var$ContentShareMediaStreamBroker;

});
parcelRegister("d5Rye", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $9885482503f939b4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $9885482503f939b4$var$DefaultBrowserBehavior_1 = $9885482503f939b4$var$__importDefault((parcelRequire("e2TuV")));

const $9885482503f939b4$var$DefaultMediaDeviceFactory_1 = $9885482503f939b4$var$__importDefault((parcelRequire("9WXGW")));

const $9885482503f939b4$var$AsyncScheduler_1 = $9885482503f939b4$var$__importDefault((parcelRequire("4mLYP")));

const $9885482503f939b4$var$PromiseQueue_1 = $9885482503f939b4$var$__importDefault((parcelRequire("8nZPg")));

var $jfpqH = parcelRequire("jfpqH");

const $9885482503f939b4$var$DefaultVideoTransformDevice_1 = $9885482503f939b4$var$__importDefault((parcelRequire("3oXre")));

const $9885482503f939b4$var$DefaultVideoTile_1 = $9885482503f939b4$var$__importDefault((parcelRequire("dBfpS")));

var $34lc7 = parcelRequire("34lc7");

const $9885482503f939b4$var$DeviceSelection_1 = $9885482503f939b4$var$__importDefault((parcelRequire("8vrvX")));

const $9885482503f939b4$var$GetUserMediaError_1 = $9885482503f939b4$var$__importDefault((parcelRequire("5XVIS")));

const $9885482503f939b4$var$NotFoundError_1 = $9885482503f939b4$var$__importDefault((parcelRequire("9RUp9")));

const $9885482503f939b4$var$NotReadableError_1 = $9885482503f939b4$var$__importDefault((parcelRequire("34WPe")));

const $9885482503f939b4$var$OverconstrainedError_1 = $9885482503f939b4$var$__importDefault((parcelRequire("8y2VG")));

const $9885482503f939b4$var$PermissionDeniedError_1 = $9885482503f939b4$var$__importDefault((parcelRequire("3JsdE")));

const $9885482503f939b4$var$TypeError_1 = $9885482503f939b4$var$__importDefault((parcelRequire("9j05g")));

const $9885482503f939b4$var$VideoQualitySettings_1 = $9885482503f939b4$var$__importDefault((parcelRequire("3C9sO")));

var $6ukw3 = parcelRequire("6ukw3");
class $9885482503f939b4$var$DefaultDeviceController {
    constructor(logger, options, browserBehavior = new $9885482503f939b4$var$DefaultBrowserBehavior_1.default(), eventController){
        this.logger = logger;
        this.browserBehavior = browserBehavior;
        this.eventController = eventController;
        this.deviceInfoCache = null;
        this.activeDevices = {
            audio: null,
            video: null
        };
        // `chosenVideoTransformDevice` is tracked and owned by device controller.
        // It is saved when `chooseVideoInputDevice` is called with VideoTransformDevice object.
        this.chosenVideoTransformDevice = null;
        this.audioOutputDeviceId = undefined;
        this.deviceChangeObservers = new Set();
        this.mediaStreamBrokerObservers = new Set();
        this.deviceLabelTrigger = ()=>{
            return navigator.mediaDevices.getUserMedia({
                audio: true,
                video: true
            });
        };
        this.audioInputDestinationNode = null;
        this.audioInputSourceNode = null;
        this.videoInputQualitySettings = null;
        this.useWebAudio = false;
        this.useMediaConstraintsFallback = true;
        this.audioInputTaskQueue = new $9885482503f939b4$var$PromiseQueue_1.default();
        this.videoInputTaskQueue = new $9885482503f939b4$var$PromiseQueue_1.default();
        this.muted = false;
        // This handles the dispatch of `mute` and `unmute` events from audio tracks.
        // There's a bit of a semantic mismatch here if input streams allow individual component tracks to be muted,
        // but addressing that gap is not feasible in our stream-oriented world.
        this.mediaStreamMuteObserver = (id, muted)=>{
            for (const observer of this.deviceChangeObservers)$9885482503f939b4$var$AsyncScheduler_1.default.nextTick(()=>{
                /* istanbul ignore else */ if (this.deviceChangeObservers.has(observer) && observer.audioInputMuteStateChanged) observer.audioInputMuteStateChanged(id, muted);
            });
        };
        this.alreadyHandlingDeviceChange = false;
        const { enableWebAudio: enableWebAudio = false, useMediaConstraintsFallback: useMediaConstraintsFallback = true } = options || {};
        this.useWebAudio = enableWebAudio;
        this.useMediaConstraintsFallback = useMediaConstraintsFallback;
        this.videoInputQualitySettings = new $9885482503f939b4$var$VideoQualitySettings_1.default($9885482503f939b4$var$DefaultDeviceController.defaultVideoWidth, $9885482503f939b4$var$DefaultDeviceController.defaultVideoHeight, $9885482503f939b4$var$DefaultDeviceController.defaultVideoFrameRate);
        const dimension = this.browserBehavior.requiresResolutionAlignment(this.videoInputQualitySettings.videoWidth, this.videoInputQualitySettings.videoHeight);
        this.videoInputQualitySettings.videoWidth = dimension[0];
        this.videoInputQualitySettings.videoHeight = dimension[1];
        this.logger.info(`DefaultDeviceController video dimension ${this.videoInputQualitySettings.videoWidth} x ${this.videoInputQualitySettings.videoHeight}`);
        try {
            this.mediaDeviceWrapper = new $9885482503f939b4$var$DefaultMediaDeviceFactory_1.default().create();
            const supportedConstraints = navigator.mediaDevices.getSupportedConstraints();
            this.logger.info(`Supported Constraints in this browser ${JSON.stringify(supportedConstraints)}`);
        } catch (error) {
            logger.error(error.message);
        }
    }
    isWatchingForDeviceChanges() {
        return !!this.onDeviceChangeCallback;
    }
    ensureWatchingDeviceChanges() {
        var _a;
        if (this.isWatchingForDeviceChanges()) return;
        this.logger.info('Starting devicechange listener.');
        this.onDeviceChangeCallback = ()=>{
            this.logger.info('Device change event callback is triggered');
            this.handleDeviceChange();
        };
        (_a = this.mediaDeviceWrapper) === null || _a === void 0 || _a.addEventListener('devicechange', this.onDeviceChangeCallback);
    }
    /**
     * Unsubscribe from the `devicechange` event, which allows the device controller to
     * update its device cache.
     */ stopWatchingDeviceChanges() {
        var _a;
        if (!this.isWatchingForDeviceChanges()) return;
        this.logger.info('Stopping devicechange listener.');
        (_a = this.mediaDeviceWrapper) === null || _a === void 0 || _a.removeEventListener('devicechange', this.onDeviceChangeCallback);
        this.onDeviceChangeCallback = undefined;
    }
    shouldObserveDeviceChanges() {
        if (this.deviceChangeObservers.size) return true;
        const hasActiveDevices = this.activeDevices['audio'] && this.activeDevices['audio'].constraints !== null || this.activeDevices['video'] && this.activeDevices['video'].constraints !== null || !!this.audioOutputDeviceId;
        return hasActiveDevices;
    }
    watchForDeviceChangesIfNecessary() {
        if (this.shouldObserveDeviceChanges()) this.ensureWatchingDeviceChanges();
        else this.stopWatchingDeviceChanges();
    }
    async destroy() {
        // Remove device change callbacks.
        this.stopWatchingDeviceChanges();
        // Deselect any audio input devices and throw away the streams.
        // Discard the current video device, if there is one.
        // Discard any audio or video transforms.
        await this.stopAudioInput();
        await this.stopVideoInput();
    }
    async listAudioInputDevices(forceUpdate = false) {
        const result = await this.listDevicesOfKind('audioinput', forceUpdate);
        this.trace('listAudioInputDevices', forceUpdate, result);
        return result;
    }
    async listVideoInputDevices(forceUpdate = false) {
        const result = await this.listDevicesOfKind('videoinput', forceUpdate);
        this.trace('listVideoInputDevices', forceUpdate, result);
        return result;
    }
    async listAudioOutputDevices(forceUpdate = false) {
        const result = await this.listDevicesOfKind('audiooutput', forceUpdate);
        this.trace('listAudioOutputDevices', forceUpdate, result);
        return result;
    }
    pushAudioMeetingStateForPermissions(audioStream) {
        var _a;
        (_a = this.eventController) === null || _a === void 0 || _a.publishEvent(audioStream === undefined ? 'audioInputUnselected' : 'audioInputSelected');
    }
    pushVideoMeetingStateForPermissions(videoStream) {
        var _a;
        (_a = this.eventController) === null || _a === void 0 || _a.publishEvent(videoStream === undefined ? 'videoInputUnselected' : 'videoInputSelected');
    }
    async startAudioInput(device) {
        return await this.audioInputTaskQueue.add(()=>this.startAudioInputTask(device));
    }
    async startAudioInputTask(device) {
        var _a;
        if (device === undefined) {
            this.logger.error('Audio input device cannot be undefined');
            return undefined;
        }
        try {
            if ((0, $34lc7.isAudioTransformDevice)(device)) {
                // N.B., do not JSON.stringify here — for some kinds of devices this
                // will cause a cyclic object reference error.
                this.logger.info(`Choosing transform input device ${device}`);
                await this.chooseAudioTransformInputDevice(device);
            } else {
                this.logger.info(`Choosing intrinsic audio input device ${device}`);
                this.removeTransform();
                await this.chooseInputIntrinsicDevice('audio', device);
            }
            this.trace('startAudioInputDevice', device, `success`);
            // For web audio, the audio destination stream stays the same so audio input did not change
            if (this.useWebAudio) {
                this.attachAudioInputStreamToAudioContext(this.activeDevices['audio'].stream);
                this.pushAudioMeetingStateForPermissions(this.getMediaStreamDestinationNode().stream);
                await ((_a = this.transform) === null || _a === void 0 ? void 0 : _a.device.mute(this.muted));
                return this.getMediaStreamDestinationNode().stream;
            } else {
                this.publishAudioInputDidChangeEvent(this.activeDevices['audio'].stream);
                return this.activeDevices['audio'].stream;
            }
        } catch (error) {
            throw error;
        }
    }
    async stopAudioInput() {
        return this.audioInputTaskQueue.add(()=>this.stopAudioInputTask());
    }
    async stopAudioInputTask() {
        try {
            if (this.useWebAudio) {
                this.releaseAudioTransformStream();
                return;
            }
            this.stopTracksAndRemoveCallbacks('audio');
        } finally{
            this.watchForDeviceChangesIfNecessary();
            this.publishAudioInputDidChangeEvent(undefined);
        }
    }
    async chooseAudioTransformInputDevice(device) {
        var _a;
        if (((_a = this.transform) === null || _a === void 0 ? void 0 : _a.device) === device) return;
        if (!this.useWebAudio) throw new Error('Cannot apply transform device without enabling Web Audio.');
        const context = $9885482503f939b4$var$DefaultDeviceController.getAudioContext();
        if (context instanceof OfflineAudioContext) ;
        else switch(context.state){
            case 'running':
                break;
            case 'closed':
                // A closed context cannot be used for creating nodes, so the correct
                // thing to do is to raise a descriptive error sooner.
                throw new Error('Cannot choose a transform device with a closed audio context.');
            case 'suspended':
                // A context might be suspended after page load. We try to resume it
                // here, otherwise audio won't work.
                await context.resume();
        }
        let nodes;
        try {
            nodes = await device.createAudioNode(context);
        } catch (e) {
            this.logger.error(`Unable to create transform device node: ${e}.`);
            throw e;
        }
        // Pick the plain ol' inner device as the source. It will be
        // connected to the node.
        const inner = await device.intrinsicDevice();
        await this.chooseInputIntrinsicDevice('audio', inner);
        this.logger.debug(`Got inner stream: ${inner}.`);
        // Otherwise, continue: hook up the new node.
        this.setTransform(device, nodes);
    }
    async chooseVideoTransformInputDevice(device) {
        var _a;
        if (this.eventController && device instanceof $9885482503f939b4$var$DefaultVideoTransformDevice_1.default) device.passEventControllerToProcessors(this.eventController);
        if (device === this.chosenVideoTransformDevice) {
            this.logger.info('Reselecting same VideoTransformDevice');
            return;
        }
        const prevVideoTransformDevice = this.chosenVideoTransformDevice;
        if (prevVideoTransformDevice) this.logger.info('Switched from previous VideoTransformDevice');
        const wasUsingTransformDevice = !!prevVideoTransformDevice;
        const inner = await device.intrinsicDevice();
        const canReuseMediaStream = this.isMediaStreamReusableByDeviceId((_a = this.activeDevices['video']) === null || _a === void 0 ? void 0 : _a.stream, inner);
        if (!canReuseMediaStream) {
            this.logger.info('video transform device needs new intrinsic device');
            if (wasUsingTransformDevice) // detach input media stream - turn off the camera or leave it be if inner is media stream
            prevVideoTransformDevice.onOutputStreamDisconnect();
            this.chosenVideoTransformDevice = device;
            // VideoTransformDevice owns input MediaStream
            this.activeDevices['video'] = null;
            await this.chooseInputIntrinsicDevice('video', inner);
            this.logger.info('apply processors to transform');
            await this.chosenVideoTransformDevice.transformStream(this.activeDevices['video'].stream);
            return;
        }
        // When saved stream is reusable, only switch the saved stream to filtered stream for sending
        // but keep the saved stream intact.
        // Note: to keep the chosen media stream intact, it is important to avoid a full stop
        // because videoTileUpdate can be called when video is stopped and user might call `bindVideoElement` to disconnect the element.
        // In current implementation, disconnecting the element will `hard` stop the media stream.
        // Update device and stream
        this.chosenVideoTransformDevice = device;
        this.logger.info('video transform device uses previous stream');
        // `transformStream` will start processing.
        this.logger.info('apply processors to transform');
        await device.transformStream(this.activeDevices['video'].stream);
    }
    async startVideoInput(device) {
        return await this.videoInputTaskQueue.add(()=>this.startVideoInputTask(device));
    }
    async startVideoInputTask(device) {
        if (!device) {
            this.logger.error('Invalid video input device');
            return undefined;
        }
        try {
            if ((0, $6ukw3.isVideoTransformDevice)(device)) {
                this.logger.info(`Choosing video transform device ${device}`);
                await this.chooseVideoTransformInputDevice(device);
                this.publishVideoInputDidChangeEvent(this.chosenVideoTransformDevice.outputMediaStream);
                return this.chosenVideoTransformDevice.outputMediaStream;
            }
            // handle direct switching from VideoTransformDevice to Device
            // From WebRTC point, it is a device switching.
            if (this.chosenVideoInputIsTransformDevice()) {
                // disconnect old stream
                this.chosenVideoTransformDevice.onOutputStreamDisconnect();
                this.chosenVideoTransformDevice = null;
            }
            await this.chooseInputIntrinsicDevice('video', device);
            this.trace('startVideoInputDevice', device);
            this.publishVideoInputDidChangeEvent(this.activeDevices['video'].stream);
            return this.activeDevices['video'].stream;
        } catch (error) {
            throw error;
        }
    }
    async stopVideoInput() {
        return this.videoInputTaskQueue.add(()=>this.stopVideoInputTask());
    }
    async stopVideoInputTask() {
        try {
            if (this.chosenVideoInputIsTransformDevice()) {
                this.releaseVideoTransformStream();
                return;
            }
            this.stopTracksAndRemoveCallbacks('video');
        } finally{
            this.watchForDeviceChangesIfNecessary();
            this.publishVideoInputDidChangeEvent(undefined);
        }
    }
    async chooseAudioOutput(deviceId) {
        this.audioOutputDeviceId = deviceId;
        this.watchForDeviceChangesIfNecessary();
        const deviceInfo = this.deviceInfoFromDeviceId('audiooutput', this.audioOutputDeviceId);
        this.publishAudioOutputDidChangeEvent(deviceInfo);
        this.trace('chooseAudioOutput', deviceId, null);
        return;
    }
    addDeviceChangeObserver(observer) {
        this.logger.info('adding device change observer');
        this.deviceChangeObservers.add(observer);
        this.watchForDeviceChangesIfNecessary();
        this.trace('addDeviceChangeObserver');
    }
    removeDeviceChangeObserver(observer) {
        this.logger.info('removing device change observer');
        this.deviceChangeObservers.delete(observer);
        this.watchForDeviceChangesIfNecessary();
        this.trace('removeDeviceChangeObserver');
    }
    createAnalyserNodeForAudioInput() {
        var _a, _b;
        if (!this.activeDevices['audio']) return null;
        // If there is a WebAudio node in the graph, we use that as the source instead of the stream.
        const node = (_b = (_a = this.transform) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.end;
        if (node) {
            const analyser = node.context.createAnalyser();
            analyser.removeOriginalInputs = ()=>{
                try {
                    node.disconnect(analyser);
                } catch (e) {
                // This can fail in some unusual cases, but this is best-effort.
                }
            };
            node.connect(analyser);
            return analyser;
        }
        return this.createAnalyserNodeForRawAudioInput();
    }
    //
    // N.B., this bypasses any applied transform node.
    //
    createAnalyserNodeForRawAudioInput() {
        if (!this.activeDevices['audio']) return null;
        return this.createAnalyserNodeForStream(this.activeDevices['audio'].stream);
    }
    createAnalyserNodeForStream(stream) {
        const audioContext = $9885482503f939b4$var$DefaultDeviceController.getAudioContext();
        const analyser = audioContext.createAnalyser();
        const source = audioContext.createMediaStreamSource(stream);
        source.connect(analyser);
        this.trace('createAnalyserNodeForAudioInput');
        analyser.removeOriginalInputs = ()=>{
            try {
                source.disconnect(analyser);
            } catch (e) {
            // This can fail in some unusual cases, but this is best-effort.
            }
        };
        return analyser;
    }
    startVideoPreviewForVideoInput(element) {
        if (!this.activeDevices['video']) {
            this.logger.warn('cannot bind video preview since video input device has not been chosen');
            this.trace('startVideoPreviewForVideoInput', element.id);
            return;
        }
        $9885482503f939b4$var$DefaultVideoTile_1.default.connectVideoStreamToVideoElement(this.chosenVideoTransformDevice ? this.chosenVideoTransformDevice.outputMediaStream : this.activeDevices['video'].stream, element, true);
        this.trace('startVideoPreviewForVideoInput', element.id);
    }
    stopVideoPreviewForVideoInput(element) {
        $9885482503f939b4$var$DefaultVideoTile_1.default.disconnectVideoStreamFromVideoElement(element, false);
        this.trace('stopVideoPreviewForVideoInput', element.id);
    }
    setDeviceLabelTrigger(trigger) {
        // Discard the cache if it was populated with unlabeled devices.
        if (this.deviceInfoCache) {
            for (const device of this.deviceInfoCache)if (!device.label) {
                this.deviceInfoCache = null;
                break;
            }
        }
        this.deviceLabelTrigger = trigger;
        this.trace('setDeviceLabelTrigger');
    }
    mixIntoAudioInput(stream) {
        let node = null;
        if (this.useWebAudio) {
            node = $9885482503f939b4$var$DefaultDeviceController.getAudioContext().createMediaStreamSource(stream);
            node.connect(this.getMediaStreamOutputNode());
        } else this.logger.warn('WebAudio is not enabled, mixIntoAudioInput will not work');
        this.trace('mixIntoAudioInput', stream.id);
        return node;
    }
    chooseVideoInputQuality(width, height, frameRate) {
        const dimension = this.browserBehavior.requiresResolutionAlignment(width, height);
        this.videoInputQualitySettings = new $9885482503f939b4$var$VideoQualitySettings_1.default(dimension[0], dimension[1], frameRate);
    }
    getVideoInputQualitySettings() {
        return this.videoInputQualitySettings;
    }
    async acquireAudioInputStream() {
        if (!this.activeDevices['audio']) {
            this.logger.info(`No audio device chosen, creating empty audio device`);
            await this.startAudioInput(null);
        }
        if (this.useWebAudio) {
            const dest = this.getMediaStreamDestinationNode();
            return dest.stream;
        }
        return this.activeDevices['audio'].stream;
    }
    async acquireVideoInputStream() {
        if (!this.activeDevices['video']) throw new Error(`No video device chosen`);
        if (this.chosenVideoInputIsTransformDevice()) return this.chosenVideoTransformDevice.outputMediaStream;
        return this.activeDevices['video'].stream;
    }
    async acquireDisplayInputStream(_streamConstraints) {
        throw new Error('unsupported');
    }
    /**
     *
     * We need to do three things to clean up audio input
     *
     * * Close the tracks of the source stream.
     * * Remove the transform.
     * * Clean up the intrinsic stream's callback -- that's the stream that's tracked in
     *   `activeDevices` and needs to have its callbacks removed.
     */ releaseAudioTransformStream() {
        this.logger.info('Stopping audio track for Web Audio graph');
        this.stopTracksAndRemoveCallbacks('audio');
        this.logger.info('Removing audio transform, if there is one.');
        this.removeTransform();
        // Remove the input and output nodes. They will be recreated later if
        // needed.
        /* istanbul ignore else */ if (this.audioInputSourceNode) {
            this.audioInputSourceNode.disconnect();
            this.audioInputSourceNode = undefined;
        }
        /* istanbul ignore else */ if (this.audioInputDestinationNode) {
            this.audioInputDestinationNode.disconnect();
            this.audioInputDestinationNode = undefined;
        }
    }
    /**
     *
     * We need to do three things to clean up video input
     *
     * * Close the tracks of the source stream.
     * * Remove the transform.
     * * Clean up the intrinsic stream's callback -- that's the stream that's tracked in
     *   `activeDevices` and needs to have its callbacks removed.
     */ releaseVideoTransformStream() {
        this.logger.info('Stopping video track for transform');
        this.stopTracksAndRemoveCallbacks('video');
        this.logger.info('Disconnecting video transform');
        this.chosenVideoTransformDevice.onOutputStreamDisconnect();
        this.chosenVideoTransformDevice = null;
    }
    stopTracksAndRemoveCallbacks(kind) {
        const activeDevice = this.activeDevices[kind];
        // Just-in-case error handling.
        /* istanbul ignore if */ if (!activeDevice) return;
        /* istanbul ignore next */ const endedCallback = activeDevice.endedCallback;
        const trackMuteCallback = activeDevice.trackMuteCallback;
        const trackUnmuteCallback = activeDevice.trackUnmuteCallback;
        for (const track of activeDevice.stream.getTracks()){
            track.stop();
            /* istanbul ignore else */ if (endedCallback) track.removeEventListener('ended', endedCallback);
            /* istanbul ignore else */ if (trackMuteCallback) track.removeEventListener('mute', trackMuteCallback);
            /* istanbul ignore else */ if (trackUnmuteCallback) track.removeEventListener('unmute', trackUnmuteCallback);
            delete activeDevice.endedCallback;
            delete activeDevice.trackMuteCallback;
            delete activeDevice.trackUnmuteCallback;
            delete this.activeDevices[kind];
        }
    }
    chosenVideoInputIsTransformDevice() {
        return !!this.chosenVideoTransformDevice;
    }
    muteLocalAudioInputStream() {
        this.toggleLocalAudioInputStream(false);
    }
    unmuteLocalAudioInputStream() {
        this.toggleLocalAudioInputStream(true);
    }
    toggleLocalAudioInputStream(enabled) {
        var _a;
        let audioDevice = this.activeDevices['audio'];
        if (this.useWebAudio) audioDevice = this.getMediaStreamDestinationNode();
        if (!audioDevice) return;
        for (const track of audioDevice.stream.getTracks()){
            if (track.enabled === enabled) continue;
            track.enabled = enabled;
        }
        if (this.muted !== !enabled) {
            this.muted = !enabled;
            (_a = this.transform) === null || _a === void 0 || _a.device.mute(this.muted);
        }
    }
    static getIntrinsicDeviceId(device) {
        if (!device) return undefined;
        if (typeof device === 'string') return device;
        if (device.id) return device.id;
        const constraints = device;
        const deviceIdConstraints = constraints.deviceId;
        if (!deviceIdConstraints) return undefined;
        if (typeof deviceIdConstraints === 'string' || Array.isArray(deviceIdConstraints)) return deviceIdConstraints;
        const constraintStringParams = deviceIdConstraints;
        if (typeof constraintStringParams.exact === 'string' || Array.isArray(constraintStringParams.exact)) return constraintStringParams.exact;
        return undefined;
    }
    static createEmptyAudioDevice() {
        return $9885482503f939b4$var$DefaultDeviceController.synthesizeAudioDevice(0);
    }
    static synthesizeAudioDevice(toneHz) {
        const audioContext = $9885482503f939b4$var$DefaultDeviceController.getAudioContext();
        const outputNode = audioContext.createMediaStreamDestination();
        if (!toneHz) {
            const source = audioContext.createBufferSource();
            // The AudioContext object uses the sample rate of the default output device
            // if not specified. Creating an AudioBuffer object with the output device's
            // sample rate fails in some browsers, e.g. Safari with a Bluetooth headphone.
            try {
                source.buffer = audioContext.createBuffer(1, audioContext.sampleRate * 5, audioContext.sampleRate);
            } catch (error) {
                if (error && error.name === 'NotSupportedError') source.buffer = audioContext.createBuffer(1, $9885482503f939b4$var$DefaultDeviceController.defaultSampleRate * 5, $9885482503f939b4$var$DefaultDeviceController.defaultSampleRate);
                else throw error;
            }
            // Some browsers will not play audio out the MediaStreamDestination
            // unless there is actually audio to play, so we add a small amount of
            // noise here to ensure that audio is played out.
            source.buffer.getChannelData(0)[0] = 0.0003;
            source.loop = true;
            source.connect(outputNode);
            source.start();
        } else {
            const gainNode = audioContext.createGain();
            gainNode.gain.value = 0.1;
            gainNode.connect(outputNode);
            const oscillatorNode = audioContext.createOscillator();
            oscillatorNode.frequency.value = toneHz;
            oscillatorNode.connect(gainNode);
            oscillatorNode.start();
        }
        return outputNode.stream;
    }
    async listDevicesOfKind(deviceKind, forceUpdate) {
        if (forceUpdate || this.deviceInfoCache === null || !this.isWatchingForDeviceChanges()) await this.updateDeviceInfoCacheFromBrowser();
        return this.listCachedDevicesOfKind(deviceKind);
    }
    async updateDeviceInfoCacheFromBrowser() {
        var _a;
        const doesNotHaveAccessToMediaDevices = typeof MediaDeviceInfo === 'undefined';
        if (doesNotHaveAccessToMediaDevices) {
            this.deviceInfoCache = [];
            return;
        }
        let devices = await navigator.mediaDevices.enumerateDevices();
        let hasDeviceLabels = true;
        for (const device of devices)if (!device.label) {
            hasDeviceLabels = false;
            break;
        }
        if (!hasDeviceLabels) try {
            this.logger.info('attempting to trigger media device labels since they are hidden');
            const triggerStream = await this.deviceLabelTrigger();
            devices = await navigator.mediaDevices.enumerateDevices();
            for (const track of triggerStream.getTracks())track.stop();
        } catch (error) {
            this.logger.info('unable to get media device labels');
            (_a = this.eventController) === null || _a === void 0 || _a.publishEvent('deviceLabelTriggerFailed', {
                deviceLabelTriggerErrorMessage: this.getErrorMessage(error)
            });
        }
        this.logger.debug(`Update device info cache with devices: ${JSON.stringify(devices)}`);
        this.deviceInfoCache = devices;
    }
    listCachedDevicesOfKind(deviceKind) {
        const devicesOfKind = [];
        if (this.deviceInfoCache) {
            for (const device of this.deviceInfoCache)if (device.kind === deviceKind) devicesOfKind.push(device);
        }
        return devicesOfKind;
    }
    async handleDeviceChange() {
        if (this.deviceInfoCache === null) return;
        if (this.alreadyHandlingDeviceChange) {
            $9885482503f939b4$var$AsyncScheduler_1.default.nextTick(()=>{
                this.handleDeviceChange();
            });
            return;
        }
        this.alreadyHandlingDeviceChange = true;
        const oldAudioInputDevices = this.listCachedDevicesOfKind('audioinput');
        const oldVideoInputDevices = this.listCachedDevicesOfKind('videoinput');
        const oldAudioOutputDevices = this.listCachedDevicesOfKind('audiooutput');
        await this.updateDeviceInfoCacheFromBrowser();
        const newAudioInputDevices = this.listCachedDevicesOfKind('audioinput');
        const newVideoInputDevices = this.listCachedDevicesOfKind('videoinput');
        const newAudioOutputDevices = this.listCachedDevicesOfKind('audiooutput');
        this.forEachObserver((observer)=>{
            if (!this.areDeviceListsEqual(oldAudioInputDevices, newAudioInputDevices)) $jfpqH.Maybe.of(observer.audioInputsChanged).map((f)=>f.bind(observer)(newAudioInputDevices));
            if (!this.areDeviceListsEqual(oldVideoInputDevices, newVideoInputDevices)) $jfpqH.Maybe.of(observer.videoInputsChanged).map((f)=>f.bind(observer)(newVideoInputDevices));
            if (!this.areDeviceListsEqual(oldAudioOutputDevices, newAudioOutputDevices)) $jfpqH.Maybe.of(observer.audioOutputsChanged).map((f)=>f.bind(observer)(newAudioOutputDevices));
        });
        this.alreadyHandlingDeviceChange = false;
    }
    async handleDeviceStreamEnded(kind, deviceId) {
        try {
            if (kind === 'audio') {
                if (this.useWebAudio && this.browserBehavior.requiresAudioContextResetOnDeviceFailureForWebAudio()) {
                    this.logger.warn('Audio input device which was active is no longer available, suspending and resuming audio context before resetting to empty device to ensure packets are sent');
                    await this.stopAudioInput();
                    $9885482503f939b4$var$DefaultDeviceController.suspendAudioContext();
                    $9885482503f939b4$var$DefaultDeviceController.resumeAudioContext();
                } else this.logger.warn('Audio input device which was active is no longer available, resetting to empty device to ensure packets are sent');
                await this.startAudioInput(null);
            } else {
                this.logger.warn(`Video input device which was active is no longer available, stopping video`);
                await this.stopVideoInput();
            }
        } catch (e) {
            /* istanbul ignore next */ this.logger.error('Failed to choose null device after stream ended.');
        }
        if (kind === 'audio') this.forEachObserver((observer)=>{
            $jfpqH.Maybe.of(observer.audioInputStreamEnded).map((f)=>f.bind(observer)(deviceId));
        });
        else this.forEachObserver((observer)=>{
            $jfpqH.Maybe.of(observer.videoInputStreamEnded).map((f)=>f.bind(observer)(deviceId));
        });
    }
    forEachObserver(observerFunc) {
        for (const observer of this.deviceChangeObservers)$9885482503f939b4$var$AsyncScheduler_1.default.nextTick(()=>{
            /* istanbul ignore else */ if (this.deviceChangeObservers.has(observer)) observerFunc(observer);
        });
    }
    forEachMediaStreamBrokerObserver(observerFunc) {
        for (const observer of this.mediaStreamBrokerObservers)$9885482503f939b4$var$AsyncScheduler_1.default.nextTick(()=>{
            /* istanbul ignore else */ if (this.mediaStreamBrokerObservers.has(observer)) observerFunc(observer);
        });
    }
    areDeviceListsEqual(a, b) {
        return JSON.stringify(a.map((device)=>JSON.stringify(device)).sort()) === JSON.stringify(b.map((device)=>JSON.stringify(device)).sort());
    }
    intrinsicDeviceAsMediaStream(device) {
        // @ts-ignore
        return device && device.id ? device : null;
    }
    hasSameMediaStreamId(kind, selection, proposedConstraints) {
        var _a, _b, _c, _d;
        // Checking for stream using the fake constraint created in getMediaStreamConstraints
        let streamId;
        if (kind === 'audio') {
            // @ts-ignore
            streamId = proposedConstraints === null || proposedConstraints === void 0 ? void 0 : proposedConstraints.audio.streamId;
            /* istanbul ignore next */ // @ts-ignore
            return !!streamId && streamId === ((_b = (_a = selection.constraints) === null || _a === void 0 ? void 0 : _a.audio) === null || _b === void 0 ? void 0 : _b.streamId);
        }
        /* istanbul ignore next */ // @ts-ignore
        streamId = proposedConstraints === null || proposedConstraints === void 0 ? void 0 : proposedConstraints.video.streamId;
        /* istanbul ignore next */ // @ts-ignore
        return !!streamId && streamId === ((_d = (_c = selection === null || selection === void 0 ? void 0 : selection.constraints) === null || _c === void 0 ? void 0 : _c.video) === null || _d === void 0 ? void 0 : _d.streamId);
    }
    hasSameGroupId(groupId, kind, device) {
        if (groupId === '') return true;
        const deviceIds = $9885482503f939b4$var$DefaultDeviceController.getIntrinsicDeviceId(device);
        this.logger.debug(`Checking deviceIds ${deviceIds} of type ${typeof deviceIds} with groupId ${groupId}`);
        if (typeof deviceIds === 'string' && groupId === this.getGroupIdFromDeviceId(kind, deviceIds)) return true;
        return false;
    }
    getGroupIdFromDeviceId(kind, deviceId) {
        if (this.deviceInfoCache !== null) {
            const cachedDeviceInfo = this.listCachedDevicesOfKind(`${kind}input`).find((cachedDevice)=>cachedDevice.deviceId === deviceId);
            if (cachedDeviceInfo && cachedDeviceInfo.groupId) {
                this.logger.debug(`GroupId of deviceId ${deviceId} found in cache is ${cachedDeviceInfo.groupId}`);
                return cachedDeviceInfo.groupId;
            }
        }
        this.logger.debug(`GroupId of deviceId ${deviceId} found in cache is empty`);
        return '';
    }
    handleGetUserMediaError(error, errorTimeMs) {
        if (!error) throw new $9885482503f939b4$var$GetUserMediaError_1.default(error);
        switch(error.name){
            case 'NotReadableError':
            case 'TrackStartError':
                throw new $9885482503f939b4$var$NotReadableError_1.default(error);
            case 'NotFoundError':
            case 'DevicesNotFoundError':
                throw new $9885482503f939b4$var$NotFoundError_1.default(error);
            case 'NotAllowedError':
            case 'PermissionDeniedError':
            case 'SecurityError':
                if (errorTimeMs && errorTimeMs < $9885482503f939b4$var$DefaultDeviceController.permissionDeniedOriginDetectionThresholdMs) throw new $9885482503f939b4$var$PermissionDeniedError_1.default(error, 'Permission denied by browser');
                else throw new $9885482503f939b4$var$PermissionDeniedError_1.default(error, 'Permission denied by user');
            case 'OverconstrainedError':
            case 'ConstraintNotSatisfiedError':
                throw new $9885482503f939b4$var$OverconstrainedError_1.default(error);
            case 'TypeError':
                throw new $9885482503f939b4$var$TypeError_1.default(error);
            case 'AbortError':
            default:
                throw new $9885482503f939b4$var$GetUserMediaError_1.default(error);
        }
    }
    /**
     * Check whether a device is already selected.
     *
     * @param kind typically 'audio' or 'video'.
     * @param device the device about to be selected.
     * @param selection the existing device selection of this kind.
     * @param proposedConstraints the constraints that will be used when this device is selected.
     * @returns whether `device` matches `selection` — that is, whether this device is already selected.
     */ matchesDeviceSelection(kind, device, selection, proposedConstraints) {
        if (selection && selection.stream.active && (this.hasSameMediaStreamId(kind, selection, proposedConstraints) || selection.groupId !== null && this.hasSameGroupId(selection.groupId, kind, device))) {
            // TODO: this should be computed within this function.
            this.logger.debug(`Compare current device constraint ${JSON.stringify(selection.constraints)} to proposed constraints ${JSON.stringify(proposedConstraints)}`);
            return selection.matchesConstraints(proposedConstraints);
        }
        return false;
    }
    async chooseInputIntrinsicDevice(kind, device) {
        var _a, _b;
        // N.B.,: the input device might already have augmented constraints supplied
        // by an `AudioTransformDevice`. `getMediaStreamConstraints` will respect
        // settings supplied by the device.
        const proposedConstraints = this.getMediaStreamConstraints(kind, device);
        // TODO: `matchesConstraints` should really return compatible/incompatible/exact --
        // `applyConstraints` can be used to reuse the active device while changing the
        // requested constraints.
        if (this.matchesDeviceSelection(kind, device, this.activeDevices[kind], proposedConstraints)) {
            this.logger.info(`reusing existing ${kind} input device`);
            return;
        }
        if (this.activeDevices[kind] && this.activeDevices[kind].stream) this.stopTracksAndRemoveCallbacks(kind);
        const startTimeMs = Date.now();
        const newDevice = new $9885482503f939b4$var$DeviceSelection_1.default();
        try {
            this.logger.info(`requesting new ${kind} device with constraint ${JSON.stringify(proposedConstraints)}`);
            const stream = this.intrinsicDeviceAsMediaStream(device);
            if (kind === 'audio' && device === null) {
                newDevice.stream = $9885482503f939b4$var$DefaultDeviceController.createEmptyAudioDevice();
                newDevice.constraints = null;
            } else if (stream) {
                this.logger.info(`using media stream ${stream.id} for ${kind} device`);
                newDevice.stream = stream;
                newDevice.constraints = proposedConstraints;
            } else {
                newDevice.stream = await navigator.mediaDevices.getUserMedia(proposedConstraints);
                newDevice.constraints = proposedConstraints;
            }
            await this.handleNewInputDevice(kind, newDevice);
        } catch (error) {
            const errorMessage = this.getErrorMessage(error);
            if (kind === 'audio') (_a = this.eventController) === null || _a === void 0 || _a.publishEvent('audioInputFailed', {
                audioInputErrorMessage: errorMessage
            });
            else (_b = this.eventController) === null || _b === void 0 || _b.publishEvent('videoInputFailed', {
                videoInputErrorMessage: errorMessage
            });
            this.logger.error(`failed to get ${kind} device for constraints ${JSON.stringify(proposedConstraints)}: ${errorMessage}`);
            let hasError = true;
            // This is effectively `error instanceof OverconstrainedError` but works in Node.
            if (error && 'constraint' in error) {
                this.logger.error(`Over-constrained by constraint: ${error.constraint}`);
                // Try to reduce the constraints if over-constraints
                if (this.useMediaConstraintsFallback) {
                    const fallbackConstraints = this.getMediaStreamConstraints(kind, device, true);
                    const fallbackConstraintsJSON = JSON.stringify(fallbackConstraints);
                    if (fallbackConstraintsJSON !== JSON.stringify(proposedConstraints)) {
                        this.logger.info(`retry requesting new ${kind} device with minimal constraint ${fallbackConstraintsJSON}`);
                        try {
                            newDevice.stream = await navigator.mediaDevices.getUserMedia(fallbackConstraints);
                            newDevice.constraints = fallbackConstraints;
                            await this.handleNewInputDevice(kind, newDevice);
                            hasError = false;
                        } catch (e) {
                            this.logger.error(`failed to get ${kind} device for constraints ${fallbackConstraintsJSON}: ${this.getErrorMessage(e)}`);
                        }
                    }
                }
            }
            if (hasError) {
                /*
                 * If there is any error while acquiring the audio device, we fall back to null device.
                 * Reason: If device selection fails (e.g. NotReadableError), the peer connection is left hanging
                 * with no active audio track since we release the previously attached track.
                 * If no audio packet has yet been sent to the server, the server will not emit the joined event.
                 */ if (kind === 'audio') {
                    this.logger.info(`choosing null ${kind} device instead`);
                    try {
                        newDevice.stream = $9885482503f939b4$var$DefaultDeviceController.createEmptyAudioDevice();
                        newDevice.constraints = null;
                        await this.handleNewInputDevice(kind, newDevice);
                    } catch (error) {
                        this.logger.error(`failed to choose null ${kind} device. ${error.name}: ${error.message}`);
                    }
                }
                this.handleGetUserMediaError(error, Date.now() - startTimeMs);
            }
        } finally{
            this.watchForDeviceChangesIfNecessary();
        }
    }
    getErrorMessage(error) {
        if (!error) return 'UnknownError';
        if (error.name && error.message) return `${error.name}: ${error.message}`;
        if (error.name) return error.name;
        if (error.message) return error.message;
        return 'UnknownError';
    }
    async handleNewInputDevice(kind, newDevice) {
        var _a;
        this.logger.info(`got ${kind} device for constraints ${JSON.stringify(newDevice.constraints)}`);
        const newDeviceId = (_a = this.getMediaTrackSettings(newDevice.stream)) === null || _a === void 0 ? void 0 : _a.deviceId;
        newDevice.groupId = newDeviceId ? this.getGroupIdFromDeviceId(kind, newDeviceId) : '';
        this.activeDevices[kind] = newDevice;
        this.logger.debug(`Set activeDevice to ${JSON.stringify(newDevice)}`);
        this.watchForDeviceChangesIfNecessary();
        // Add event listener to detect ended event of media track
        // We only monitor the first track, and use its device ID for observer notifications.
        const track = newDevice.stream.getTracks()[0];
        if (track) {
            newDevice.endedCallback = ()=>{
                // Hard to test, but the safety check is worthwhile.
                /* istanbul ignore else */ if (this.activeDevices[kind] && this.activeDevices[kind].stream === newDevice.stream) {
                    this.handleDeviceStreamEnded(kind, newDeviceId);
                    delete newDevice.endedCallback;
                }
            };
            track.addEventListener('ended', newDevice.endedCallback, {
                once: true
            });
        }
        // Add event listener to mute/unmute event for audio
        if (kind === 'audio') {
            // We only monitor the first track, and use its device ID for observer notifications.
            const track = newDevice.stream.getAudioTracks()[0];
            if (track) {
                const id = track.getSettings().deviceId || newDevice.stream;
                newDevice.trackMuteCallback = ()=>{
                    this.mediaStreamMuteObserver(id, true);
                };
                newDevice.trackUnmuteCallback = ()=>{
                    this.mediaStreamMuteObserver(id, false);
                };
                track.addEventListener('mute', newDevice.trackMuteCallback, {
                    once: false
                });
                track.addEventListener('unmute', newDevice.trackUnmuteCallback, {
                    once: false
                });
                this.logger.debug('Notifying mute state after selection');
                if (track.muted) newDevice.trackMuteCallback();
                else newDevice.trackUnmuteCallback();
            }
        }
    }
    calculateMediaStreamConstraints(kind, deviceId, groupId, minimal) {
        // No need for any constraints if we want minimal constraint and there is only one device
        if (minimal && this.listCachedDevicesOfKind(`${kind}input`).length === 1) return true;
        const trackConstraints = {};
        // In Samsung Internet browser, navigator.mediaDevices.enumerateDevices()
        // returns same deviceId but different groupdId for some audioinput and videoinput devices.
        // To handle this, we select appropriate device using deviceId + groupId.
        if (this.browserBehavior.requiresNoExactMediaStreamConstraints()) trackConstraints.deviceId = deviceId;
        else trackConstraints.deviceId = {
            exact: deviceId
        };
        if (groupId) trackConstraints.groupId = groupId;
        if (minimal) return trackConstraints;
        // Video additional constraints
        if (kind === 'video') {
            trackConstraints.width = {
                ideal: this.videoInputQualitySettings.videoWidth
            };
            trackConstraints.height = {
                ideal: this.videoInputQualitySettings.videoHeight
            };
            trackConstraints.frameRate = {
                ideal: this.videoInputQualitySettings.videoFrameRate
            };
            return trackConstraints;
        }
        // Audio additional constraints
        if (this.supportSampleRateConstraint()) trackConstraints.sampleRate = {
            ideal: $9885482503f939b4$var$DefaultDeviceController.defaultSampleRate
        };
        if (this.supportSampleSizeConstraint()) trackConstraints.sampleSize = {
            ideal: $9885482503f939b4$var$DefaultDeviceController.defaultSampleSize
        };
        if (this.supportChannelCountConstraint()) trackConstraints.channelCount = {
            ideal: $9885482503f939b4$var$DefaultDeviceController.defaultChannelCount
        };
        const augmented = {
            echoCancellation: true,
            googEchoCancellation: true,
            googEchoCancellation2: true,
            googAutoGainControl: true,
            googAutoGainControl2: true,
            googNoiseSuppression: true,
            googNoiseSuppression2: true,
            googHighpassFilter: true,
            ...trackConstraints
        };
        return augmented;
    }
    getMediaStreamConstraintsFromTrackConstraints(kind, trackConstraints) {
        return kind === 'audio' ? {
            audio: trackConstraints
        } : {
            video: trackConstraints
        };
    }
    getMediaStreamConstraints(kind, device, minimal = false) {
        let trackConstraints = {};
        if (!device) return null;
        const stream = this.intrinsicDeviceAsMediaStream(device);
        if (stream) {
            // @ts-ignore - create a fake track constraint using the stream id
            trackConstraints.streamId = stream.id;
            return this.getMediaStreamConstraintsFromTrackConstraints(kind, trackConstraints);
        }
        if (typeof device === 'string') {
            let groupId = '';
            if (this.browserBehavior.requiresGroupIdMediaStreamConstraints()) {
                if (this.deviceInfoCache !== null) groupId = this.getGroupIdFromDeviceId(kind, device);
                else this.logger.error('Device cache is not populated. Please make sure to call list devices first');
            }
            trackConstraints = this.calculateMediaStreamConstraints(kind, device, groupId, minimal);
            return this.getMediaStreamConstraintsFromTrackConstraints(kind, trackConstraints);
        }
        if ($9885482503f939b4$var$isMediaDeviceInfo(device)) {
            trackConstraints = this.calculateMediaStreamConstraints(kind, device.deviceId, device.groupId, minimal);
            return this.getMediaStreamConstraintsFromTrackConstraints(kind, trackConstraints);
        }
        // Take the input set of constraints.
        // In this case, we just use the constraints as-is.
        // @ts-ignore - device is a MediaTrackConstraints
        trackConstraints = device;
        return this.getMediaStreamConstraintsFromTrackConstraints(kind, trackConstraints);
    }
    deviceInfoFromDeviceId(deviceKind, deviceId) {
        if (this.deviceInfoCache === null) return null;
        for (const device of this.deviceInfoCache){
            if (device.kind === deviceKind && device.deviceId === deviceId) return device;
        }
        return null;
    }
    hasAppliedTransform() {
        return !!this.transform;
    }
    isMediaStreamReusableByDeviceId(stream, device) {
        // for null device, assume the stream is not reusable
        if (!stream || !stream.active || !device) return false;
        if (device.id) return stream.id === device.id;
        const settings = this.getMediaTrackSettings(stream);
        // If a device does not specify deviceId, we have to assume the stream is not reusable.
        if (!settings.deviceId) return false;
        const deviceIds = $9885482503f939b4$var$DefaultDeviceController.getIntrinsicDeviceId(device);
        if (typeof deviceIds === 'string') return settings.deviceId === deviceIds;
        return false;
    }
    getMediaTrackSettings(stream) {
        var _a;
        return (_a = stream.getTracks()[0]) === null || _a === void 0 ? void 0 : _a.getSettings();
    }
    reconnectAudioInputs() {
        if (!this.audioInputSourceNode) return;
        this.audioInputSourceNode.disconnect();
        const output = this.getMediaStreamOutputNode();
        this.audioInputSourceNode.connect(output);
    }
    setTransform(device, nodes) {
        var _a, _b;
        (_b = (_a = this.transform) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 || _b.end.disconnect();
        this.transform = {
            nodes: nodes,
            device: device
        };
        const proc = nodes === null || nodes === void 0 ? void 0 : nodes.end;
        const dest = this.getMediaStreamDestinationNode();
        this.logger.debug(`Connecting transform node ${proc} to destination ${dest}.`);
        proc === null || proc === void 0 || proc.connect(dest);
        this.reconnectAudioInputs();
    }
    removeTransform() {
        var _a;
        const previous = this.transform;
        if (!previous) return undefined;
        (_a = this.transform.nodes) === null || _a === void 0 || _a.end.disconnect();
        this.transform = undefined;
        this.reconnectAudioInputs();
        return previous;
    }
    attachAudioInputStreamToAudioContext(stream) {
        var _a;
        (_a = this.audioInputSourceNode) === null || _a === void 0 || _a.disconnect();
        this.audioInputSourceNode = $9885482503f939b4$var$DefaultDeviceController.getAudioContext().createMediaStreamSource(stream);
        const output = this.getMediaStreamOutputNode();
        this.audioInputSourceNode.connect(output);
    }
    /**
     * Return the end of the Web Audio graph: post-transform audio.
     */ getMediaStreamDestinationNode() {
        if (!this.audioInputDestinationNode) this.audioInputDestinationNode = $9885482503f939b4$var$DefaultDeviceController.getAudioContext().createMediaStreamDestination();
        return this.audioInputDestinationNode;
    }
    /**
     * Return the start of the Web Audio graph: pre-transform audio.
     * If there's no transform node, this is the destination node.
     */ getMediaStreamOutputNode() {
        var _a, _b;
        return ((_b = (_a = this.transform) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.start) || this.getMediaStreamDestinationNode();
    }
    /**
     * Overrides the default latency hint used by the user agent when creating the `AudioContext`. By default,
     * user agents will choose "interactive" which opts for the smallest possible audio buffer. This can
     * cause choppy audio in some cases on Windows. Therefore, "playback" will be chosen on Windows unless
     * this value is overridden with this function.
     * @param latencyHint The latency hint to be used when creating the Web Audio `AudioContext`
     */ static setDefaultLatencyHint(latencyHint) {
        $9885482503f939b4$var$DefaultDeviceController.defaultLatencyHint = latencyHint;
    }
    /**
     * Returns the Web Audio `AudioContext` used by the {@link DefaultDeviceController}. The `AudioContext`
     * is created lazily the first time this function is called.
     *
     * This function will not attempt to recreate a stopped context, or resume a suspended one.
     *
     * @returns a Web Audio `AudioContext`
     */ static getAudioContext() {
        if (!$9885482503f939b4$var$DefaultDeviceController.audioContext) {
            const options = {};
            if (navigator.mediaDevices.getSupportedConstraints().sampleRate) options.sampleRate = $9885482503f939b4$var$DefaultDeviceController.defaultSampleRate;
            const browserBehavior = new $9885482503f939b4$var$DefaultBrowserBehavior_1.default();
            if (browserBehavior.requiresPlaybackLatencyHintForAudioContext()) options.latencyHint = 'playback'; // 'playback' is equivalent to 0.02s (20ms) on Windows
            if ($9885482503f939b4$var$DefaultDeviceController.defaultLatencyHint) options.latencyHint = $9885482503f939b4$var$DefaultDeviceController.defaultLatencyHint;
            $9885482503f939b4$var$DefaultDeviceController.audioContext = new (window.AudioContext || // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.webkitAudioContext)(options);
        }
        return $9885482503f939b4$var$DefaultDeviceController.audioContext;
    }
    /**
     * Calls [suspend](https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/suspend)
     * on reusable audio context. This is useful if you want an application to power down the
     * audio hardware when it will not be using an audio context for a while (i.e. if you
     * have an application that isn't always running a Chime SDK meeting). This is preferrable
     * to calling [[closeAudioContext]]
     */ static async suspendAudioContext() {
        if ($9885482503f939b4$var$DefaultDeviceController.audioContext) return $9885482503f939b4$var$DefaultDeviceController.audioContext.suspend();
        return Promise.resolve();
    }
    /**
     * Calls [resume](https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/resume)
     * on reusable audio context.
     */ static async resumeAudioContext() {
        if ($9885482503f939b4$var$DefaultDeviceController.audioContext) return $9885482503f939b4$var$DefaultDeviceController.audioContext.resume();
        return Promise.resolve();
    }
    /**
     * Calls [close](https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/close)
     * on reusable audio context. This more forceful the suspend and is not recommended
     * if you plan on reusing the Chime SDK, as it may lead to audio glitches (e.g. due to
     * https://issues.chromium.org/issues/40282750).
     */ static closeAudioContext() {
        if ($9885482503f939b4$var$DefaultDeviceController.audioContext) try {
            $9885482503f939b4$var$DefaultDeviceController.audioContext.close();
        } catch (e) {
        // Nothing we can do.
        }
        $9885482503f939b4$var$DefaultDeviceController.audioContext = null;
    }
    addMediaStreamBrokerObserver(observer) {
        this.mediaStreamBrokerObservers.add(observer);
    }
    removeMediaStreamBrokerObserver(observer) {
        this.mediaStreamBrokerObservers.delete(observer);
    }
    publishVideoInputDidChangeEvent(videoStream) {
        this.forEachMediaStreamBrokerObserver((observer)=>{
            if (observer.videoInputDidChange) observer.videoInputDidChange(videoStream);
        });
        this.pushVideoMeetingStateForPermissions(videoStream);
    }
    publishAudioInputDidChangeEvent(audioStream) {
        this.forEachMediaStreamBrokerObserver((observer)=>{
            if (observer.audioInputDidChange) observer.audioInputDidChange(audioStream);
        });
        this.pushAudioMeetingStateForPermissions(audioStream);
    }
    publishAudioOutputDidChangeEvent(device) {
        this.forEachMediaStreamBrokerObserver((observer)=>{
            if (observer.audioOutputDidChange) observer.audioOutputDidChange(device);
        });
    }
    supportSampleRateConstraint() {
        return this.useWebAudio && !!navigator.mediaDevices.getSupportedConstraints().sampleRate;
    }
    supportSampleSizeConstraint() {
        return this.useWebAudio && !!navigator.mediaDevices.getSupportedConstraints().sampleSize;
    }
    supportChannelCountConstraint() {
        return this.useWebAudio && !!navigator.mediaDevices.getSupportedConstraints().channelCount;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    trace(name, input, output) {
        let s = `API/DefaultDeviceController/${name}`;
        if (typeof input !== 'undefined') s += ` ${JSON.stringify(input)}`;
        if (typeof output !== 'undefined') s += ` -> ${JSON.stringify(output)}`;
        this.logger.info(s);
    }
}
$9885482503f939b4$var$DefaultDeviceController.permissionDeniedOriginDetectionThresholdMs = 500;
$9885482503f939b4$var$DefaultDeviceController.defaultVideoWidth = 960;
$9885482503f939b4$var$DefaultDeviceController.defaultVideoHeight = 540;
$9885482503f939b4$var$DefaultDeviceController.defaultVideoFrameRate = 15;
$9885482503f939b4$var$DefaultDeviceController.defaultSampleRate = 48000;
$9885482503f939b4$var$DefaultDeviceController.defaultSampleSize = 16;
$9885482503f939b4$var$DefaultDeviceController.defaultChannelCount = 1;
$9885482503f939b4$var$DefaultDeviceController.audioContext = null;
module.exports.default = $9885482503f939b4$var$DefaultDeviceController;
function $9885482503f939b4$var$isMediaDeviceInfo(device) {
    return typeof device === 'object' && 'deviceId' in device && 'groupId' in device && 'kind' in device && 'label' in device;
}

});
parcelRegister("9WXGW", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $73e7d559b227072e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $73e7d559b227072e$var$MediaDeviceProxyHandler_1 = $73e7d559b227072e$var$__importDefault((parcelRequire("6KG0U")));
class $73e7d559b227072e$var$DefaultMediaDeviceFactory {
    constructor(){
        this.isMediaDevicesSupported = typeof navigator !== 'undefined' && !!navigator.mediaDevices;
    }
    create() {
        if (!this.isMediaDevicesSupported) throw new Error(`navigator.mediaDevices is not supported`);
        else return new Proxy(navigator.mediaDevices, new $73e7d559b227072e$var$MediaDeviceProxyHandler_1.default());
    }
}
module.exports.default = $73e7d559b227072e$var$DefaultMediaDeviceFactory;

});
parcelRegister("6KG0U", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $4ea7a0fe3e980040$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $4ea7a0fe3e980040$var$AsyncScheduler_1 = $4ea7a0fe3e980040$var$__importDefault((parcelRequire("4mLYP")));

const $4ea7a0fe3e980040$var$IntervalScheduler_1 = $4ea7a0fe3e980040$var$__importDefault((parcelRequire("4wGp7")));
class $4ea7a0fe3e980040$var$MediaDeviceProxyHandler {
    constructor(){
        this.scheduler = null;
        this.devices = null;
        this.deviceChangeListeners = new Set();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
        this.get = (target, property, receiver)=>{
            if (!Reflect.has(target, property)) return undefined;
            if (!('ondevicechange' in navigator.mediaDevices)) {
                if (property === 'addEventListener') return this.patchAddEventListener(target, property, receiver);
                else if (property === 'removeEventListener') return this.patchRemoveEventListener(target, property, receiver);
            }
            const value = Reflect.get(target, property, receiver);
            return typeof value === 'function' ? value.bind(target) : value;
        };
        this.patchAddEventListener = (target, property, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        receiver)=>{
            const value = Reflect.get(target, property, receiver);
            return (type, listener, options)=>{
                if (type === 'devicechange') {
                    this.deviceChangeListeners.add(listener);
                    if (!this.scheduler) {
                        this.scheduler = new $4ea7a0fe3e980040$var$IntervalScheduler_1.default($4ea7a0fe3e980040$var$MediaDeviceProxyHandler.INTERVAL_MS);
                        this.scheduler.start(this.pollDeviceLists);
                    }
                } else return Reflect.apply(value, target, [
                    type,
                    listener,
                    options
                ]);
            };
        };
        this.patchRemoveEventListener = (target, property, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        receiver)=>{
            const value = Reflect.get(target, property, receiver);
            return (type, listener, options)=>{
                if (type === 'devicechange') {
                    this.deviceChangeListeners.delete(listener);
                    if (this.deviceChangeListeners.size === 0 && this.scheduler) {
                        this.scheduler.stop();
                        this.scheduler = null;
                    }
                } else return Reflect.apply(value, target, [
                    type,
                    listener,
                    options
                ]);
            };
        };
        this.pollDeviceLists = async ()=>{
            const newDevices = await this.sortedDeviceList();
            if (this.devices) {
                const changed = newDevices.length !== this.devices.length || newDevices.some((device, index)=>{
                    return device.deviceId !== this.devices[index].deviceId;
                });
                if (changed) this.handleDeviceChangeEvent();
            }
            this.devices = newDevices;
        };
    }
    async sortedDeviceList() {
        // @ts-ignore
        const newDevices = await navigator.mediaDevices.enumerateDevices();
        return newDevices.sort((device1, device2)=>{
            if (device1.deviceId < device2.deviceId) return 1;
            if (device1.deviceId > device2.deviceId) return -1;
            return 0;
        });
    }
    handleDeviceChangeEvent() {
        for (const listener of this.deviceChangeListeners)$4ea7a0fe3e980040$var$AsyncScheduler_1.default.nextTick(()=>{
            /* istanbul ignore else */ if (this.deviceChangeListeners.has(listener)) {
                const event = new Event('devicechange');
                if (typeof listener === 'function') listener(event);
                else listener.handleEvent(event);
            }
        });
    }
}
$4ea7a0fe3e980040$var$MediaDeviceProxyHandler.INTERVAL_MS = 1000;
module.exports.default = $4ea7a0fe3e980040$var$MediaDeviceProxyHandler;

});
parcelRegister("4wGp7", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[IntervalScheduler]] calls the callback every intervalMs milliseconds.
 */ class $34bb0b2769a7137d$var$IntervalScheduler {
    constructor(intervalMs){
        this.intervalMs = intervalMs;
    }
    start(callback) {
        this.stop();
        this.timer = setInterval(callback, this.intervalMs);
    }
    stop() {
        if (this.timer === undefined) return;
        clearInterval(this.timer);
        this.timer = undefined;
    }
    running() {
        return this.timer !== undefined;
    }
}
module.exports.default = $34bb0b2769a7137d$var$IntervalScheduler;

});



parcelRegister("8nZPg", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * A simple promise queue to enforce the order of async APIs for example, start/stop video/audio input.
 */ class $61b06e070bcc414c$var$PromiseQueue {
    constructor(){
        this.queue = Promise.resolve();
    }
    // eslint-disable-next-line
    add(func) {
        return new Promise((resolve, reject)=>{
            this.queue = this.queue.then(func).then(resolve).catch(reject);
        });
    }
}
module.exports.default = $61b06e070bcc414c$var$PromiseQueue;

});

parcelRegister("jfpqH", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.None = module.exports.Some = module.exports.Maybe = void 0;
class $e03324d547aebf53$var$Maybe {
    static of(value) {
        return value === undefined || value === null ? $e03324d547aebf53$var$None.of() : $e03324d547aebf53$var$Some.of(value);
    }
}
module.exports.Maybe = $e03324d547aebf53$var$Maybe;
class $e03324d547aebf53$var$Some {
    constructor(value){
        this.value = value;
        this.isSome = true;
        this.isNone = false;
    }
    map(f) {
        return $e03324d547aebf53$var$Maybe.of(f(this.value));
    }
    flatMap(f) {
        return f(this.value);
    }
    get() {
        return this.value;
    }
    getOrElse(_value) {
        return this.value;
    }
    defaulting(value) {
        return $e03324d547aebf53$var$Maybe.of(this.getOrElse(value));
    }
    static of(value) {
        if (value === null || value === undefined) throw new Error('value is ${value}');
        return new $e03324d547aebf53$var$Some(value);
    }
}
module.exports.Some = $e03324d547aebf53$var$Some;
class $e03324d547aebf53$var$None {
    constructor(){
        this.isSome = false;
        this.isNone = true;
    }
    get() {
        throw new Error('value is null');
    }
    getOrElse(value) {
        return value;
    }
    map(_f) {
        return new $e03324d547aebf53$var$None();
    }
    flatMap(_f) {
        return new $e03324d547aebf53$var$None();
    }
    defaulting(value) {
        return $e03324d547aebf53$var$Maybe.of(this.getOrElse(value));
    }
    static of() {
        return new $e03324d547aebf53$var$None();
    }
}
module.exports.None = $e03324d547aebf53$var$None;

});

parcelRegister("3oXre", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $27a1b8295a1afa2b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $27a1b8295a1afa2b$var$DefaultBrowserBehavior_1 = $27a1b8295a1afa2b$var$__importDefault((parcelRequire("e2TuV")));

const $27a1b8295a1afa2b$var$DefaultVideoFrameProcessorPipeline_1 = $27a1b8295a1afa2b$var$__importDefault((parcelRequire("01WSM")));
/**
 * [[DefaultVideoTransformDevice]] is an augmented [[VideoInputDevice]].
 * It transform the input {@link Device} with an array of {@link VideoFrameProcessor} to produce a `MediaStream`.
 */ class $27a1b8295a1afa2b$var$DefaultVideoTransformDevice {
    constructor(logger, device, processors, browserBehavior = new $27a1b8295a1afa2b$var$DefaultBrowserBehavior_1.default()){
        this.logger = logger;
        this.device = device;
        this.processors = processors;
        this.browserBehavior = browserBehavior;
        this.observers = new Set();
        this.pipe = new $27a1b8295a1afa2b$var$DefaultVideoFrameProcessorPipeline_1.default(this.logger, this.processors);
        this.pipe.addObserver(this);
    }
    /**
     * getter for `outputMediaStream`.
     * `outputMediaStream` is returned by internal {@link VideoFrameProcessorPipeline}.
     * It is possible, but unlikely, that this accessor will throw.
     */ get outputMediaStream() {
        return this.pipe.outputMediaStream;
    }
    /** @internal */ passEventControllerToProcessors(eventController) {
        /* istanbul ignore else */ if (this.pipe.processors) {
            for (const processor of this.pipe.processors)// Only certain processors are configured to provide event reporting,
            // so here will confirm that the processor has event controller capablility
            if (typeof processor.setEventController === 'function') processor.setEventController(eventController);
        }
    }
    /**
     * `chooseNewInnerDevice` preserves the inner pipeline and processing state and switches
     * the inner device. Since the pipeline and processors are shared with the new transform device
     * only one transform device can be used.
     */ chooseNewInnerDevice(newDevice) {
        const newTransformDevice = new $27a1b8295a1afa2b$var$DefaultVideoTransformDevice(this.logger, newDevice, this.processors, this.browserBehavior);
        newTransformDevice.pipe = this.pipe;
        return newTransformDevice;
    }
    /**
     * Return the inner device as provided during construction.
     */ getInnerDevice() {
        return this.device;
    }
    async intrinsicDevice() {
        return this.device;
    }
    /**
     * Create {@link VideoFrameProcessorPipeline} if there is not a existing one and start video processors.
     * Returns output `MediaStream` produced by {@link VideoFrameProcessorPipeline}.
     */ async transformStream(mediaStream) {
        await this.pipe.setInputMediaStream(mediaStream);
        this.inputMediaStream = mediaStream;
        return this.pipe.getActiveOutputMediaStream();
    }
    /**
     * onOutputStreamDisconnect is called when device controller wants to detach
     * the transform device. The default behavior is to stop the output
     * media stream and release the input the media stream. If the input media stream
     * is the provided device, it will not be released.
     */ onOutputStreamDisconnect() {
        this.logger.info('DefaultVideoTransformDevice: detach stopping input media stream');
        const deviceIsMediaStream = this.device && this.device.id;
        // Stop processing but keep the pipe and processors
        this.pipe.stop();
        // Turn off the camera, unless device is a MediaStream
        if (!deviceIsMediaStream) {
            if (this.inputMediaStream) for (const track of this.inputMediaStream.getVideoTracks())track.stop();
        }
    }
    /**
     * Dispose of the inner workings of the transform device, including pipeline and processors.
     * `stop` can only be called when the transform device is not used by device controller anymore.
     * After `stop` is called, all transform devices which share the pipeline must be discarded.
     */ async stop() {
        if (this.inputMediaStream) for (const track of this.inputMediaStream.getVideoTracks())track.stop();
        this.pipe.destroy();
        this.inputMediaStream = null;
    }
    /**
     * Add an observer to receive notifications about lifecycle events.
     * See {@link DefaultVideoTransformDeviceObserver} for details.
     * If the observer has already been added, this method call has no effect.
     */ addObserver(observer) {
        this.observers.add(observer);
    }
    /**
     * Remove an existing observer. If the observer has not been previously. this method call has no effect.
     */ removeObserver(observer) {
        this.observers.delete(observer);
    }
    processingDidStart() {
        this.logger.info('video transform device processing started');
        this.forEachObserver((observer)=>{
            if (observer.processingDidStart) observer.processingDidStart();
        });
    }
    processingLatencyTooHigh(latencyMs) {
        this.forEachObserver((observer)=>{
            if (observer.processingLatencyTooHigh) observer.processingLatencyTooHigh(latencyMs);
        });
    }
    processingDidFailToStart() {
        this.logger.info('video transform device processing failed to start');
        this.forEachObserver((observer)=>{
            if (observer.processingDidFailToStart) observer.processingDidFailToStart();
        });
    }
    processingDidStop() {
        this.logger.info('video transform device processing stopped');
        this.forEachObserver((observer)=>{
            if (observer.processingDidStop) observer.processingDidStop();
        });
    }
    forEachObserver(observerFunc) {
        for (const observer of this.observers)setTimeout(()=>{
            observerFunc(observer);
        }, 0);
    }
    get framerate() {
        return this.pipe.framerate;
    }
    set framerate(value) {
        this.pipe.framerate = value;
    }
}
module.exports.default = $27a1b8295a1afa2b$var$DefaultVideoTransformDevice;

});
parcelRegister("01WSM", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $005dc4f8578b6814$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $005dc4f8578b6814$var$CanvasVideoFrameBuffer_1 = $005dc4f8578b6814$var$__importDefault((parcelRequire("ag7ui")));

const $005dc4f8578b6814$var$DefaultVideoFrameProcessorTimer_1 = $005dc4f8578b6814$var$__importDefault((parcelRequire("Zhlnq")));
const $005dc4f8578b6814$var$DEFAULT_FRAMERATE = 15;
/**
 * [[DefaultVideoFrameProcessorPipeline]] implements {@link VideoFrameProcessorPipeline}.
 * It constructs a buffer {@link CanvasVideoFrameBuffer} as source by default and invokes processor based on `framerate`.
 * The default output type is `MediaStream`.
 */ class $005dc4f8578b6814$var$DefaultVideoFrameProcessorPipeline {
    constructor(logger, stages, timer = new $005dc4f8578b6814$var$DefaultVideoFrameProcessorTimer_1.default()){
        this.logger = logger;
        this.stages = stages;
        this.fr = $005dc4f8578b6814$var$DEFAULT_FRAMERATE;
        // initialize with dummy inactive MediaStream to keep strict type
        this.outputMediaStream = new MediaStream();
        this.videoInput = document.createElement('video');
        this.canvasOutput = document.createElement('canvas');
        this.outputCtx = this.canvasOutput.getContext('2d');
        this.canvasInput = document.createElement('canvas');
        this.inputCtx = this.canvasInput.getContext('2d');
        this.inputVideoStream = null;
        this.sourceBuffers = [];
        this.destBuffers = [];
        this.observers = new Set();
        this.hasStarted = false;
        this.process = async (_event)=>{
            if (!this.inputVideoStream) return;
            const processVideoStart = performance.now();
            // videoWidth is intrinsic video width
            if (this.videoInput.videoWidth) {
                if (this.canvasInput.width !== this.videoInput.videoWidth) {
                    this.canvasInput.width = this.videoInput.videoWidth;
                    this.canvasInput.height = this.videoInput.videoHeight;
                    this.sourceBuffers[0].height = this.canvasInput.height;
                    this.sourceBuffers[0].width = this.canvasInput.width;
                    this.sourceBuffers[0].framerate = this.framerate;
                }
                this.inputCtx.drawImage(this.videoInput, 0, 0);
            }
            // processes input buffers
            let buffers = [];
            buffers.push(this.sourceBuffers[0]);
            try {
                for (const proc of this.processors)buffers = await proc.process(buffers);
            } catch (_error) {
                this.forEachObserver((obs)=>{
                    if (obs.processingDidFailToStart) obs.processingDidFailToStart();
                });
                return;
            }
            this.destBuffers = buffers;
            let imageSource;
            try {
                imageSource = await this.destBuffers[0].asCanvasImageSource();
            } catch (error) {
                /* istanbul ignore else: Check exists incase stop is interleaved with async function calls; hard to mock */ if (this.inputVideoStream) {
                    this.logger.info('buffers are destroyed and pipeline could not start');
                    this.forEachObserver((obs)=>{
                        if (obs.processingDidFailToStart) obs.processingDidFailToStart();
                    });
                }
                return;
            }
            // finally draws the image
            const frameWidth = imageSource.width;
            const frameHeight = imageSource.height;
            if (frameWidth !== 0 && frameHeight !== 0) {
                if (this.canvasOutput.width !== frameWidth && this.canvasOutput.height !== frameHeight) {
                    this.canvasOutput.width = frameWidth;
                    this.canvasOutput.height = frameHeight;
                }
                this.outputCtx.drawImage(imageSource, 0, 0, frameWidth, frameHeight, 0, 0, frameWidth, frameHeight);
                if (!this.hasStarted) {
                    this.hasStarted = true;
                    this.forEachObserver((observer)=>{
                        if (observer.processingDidStart) observer.processingDidStart();
                    });
                }
            }
            // measures time
            const processVideoLatency = performance.now() - processVideoStart;
            const leave = 2000 / this.framerate - processVideoLatency; // half fps
            const nextFrameDelay = Math.max(0, 1000 / this.framerate - processVideoLatency);
            if (leave <= 0) this.forEachObserver((obs)=>{
                if (obs.processingLatencyTooHigh) obs.processingLatencyTooHigh(processVideoLatency);
            });
            await this.timer.start(nextFrameDelay, this.process.bind(this));
        };
        this.timer = timer;
    }
    destroy() {
        this.stop();
        if (this.stages) for (const stage of this.stages)stage.destroy();
        this.timer.destroy();
    }
    get framerate() {
        return this.fr;
    }
    // A negative framerate will cause `captureStream` to throw `NotSupportedError`.
    // The setter prevents this by switching to the default framerate if less than 0.
    set framerate(value) {
        this.fr = value < 0 || value === undefined ? $005dc4f8578b6814$var$DEFAULT_FRAMERATE : value;
    }
    stop() {
        // empty stream, stop pipeline
        // null input media stream stops the pipeline.
        this.videoInput.removeEventListener('loadedmetadata', this.process);
        this.videoInput.srcObject = null;
        // Clean the input stream and buffers.
        this.destroyInputMediaStreamAndBuffers();
        // Stop all the output tracks, but don't discard the media stream,
        // because it's how other parts of the codebase recognize when
        // a selected stream is part of this transform device.
        if (this.outputMediaStream) for (const track of this.outputMediaStream.getVideoTracks())track.stop();
        if (this.hasStarted) {
            this.hasStarted = false;
            this.forEachObserver((observer)=>{
                if (observer.processingDidStop) observer.processingDidStop();
            });
        }
    }
    addObserver(observer) {
        this.observers.add(observer);
    }
    removeObserver(observer) {
        this.observers.delete(observer);
    }
    async getInputMediaStream() {
        return this.inputVideoStream;
    }
    getActiveOutputMediaStream() {
        if (this.isOutputMediaStreamActive()) return this.outputMediaStream;
        this.outputMediaStream = this.canvasOutput.captureStream(this.framerate);
        this.cloneInputAudioTracksToOutput();
        return this.outputMediaStream;
    }
    /**
     * `inputMediaStream` is by default used to construct one {@link CanvasVideoFrameBuffer}
     * The buffer will be fed into the first {@link VideoFrameProcessor}.
     */ async setInputMediaStream(inputMediaStream) {
        if (!inputMediaStream) {
            this.stop();
            return;
        }
        if (inputMediaStream.getVideoTracks().length === 0) {
            this.logger.error('No video tracks in input media stream, ignoring');
            return;
        }
        this.inputVideoStream = inputMediaStream;
        const settings = this.inputVideoStream.getVideoTracks()[0].getSettings();
        this.logger.info(`processing pipeline input stream settings ${JSON.stringify(settings)}`);
        this.framerate = settings.frameRate;
        this.canvasOutput.width = settings.width;
        this.canvasOutput.height = settings.height;
        this.videoInput.addEventListener('loadedmetadata', this.process);
        this.videoInput.srcObject = this.inputVideoStream;
        // avoid iOS safari full screen video
        this.videoInput.setAttribute('playsinline', 'true');
        // create sources
        const canvasBuffer = new $005dc4f8578b6814$var$CanvasVideoFrameBuffer_1.default(this.canvasInput);
        this.sourceBuffers.push(canvasBuffer);
        this.videoInput.load();
        try {
            await this.videoInput.play();
        } catch (_a) {
            this.logger.warn('Video element play() overrided by another load().');
        }
        this.cloneInputAudioTracksToOutput();
    }
    cloneInputAudioTracksToOutput() {
        if (!this.isOutputMediaStreamActive() || this.inputVideoStream === null) {
            this.logger.info('Not cloning input audio tracks to output, do not have media streams ready');
            return; // Just wait for `getActiveOutputMediaStream`
        }
        // Remove current audio tracks from output
        for (const audioTrack of this.outputMediaStream.getAudioTracks()){
            this.logger.info(`Removing audio track ${audioTrack.id} from output stream`);
            this.outputMediaStream.removeTrack(audioTrack);
        }
        for (const audioTrack of this.inputVideoStream.getAudioTracks()){
            this.logger.info(`Adding audio track ${audioTrack.id} to output stream`);
            this.outputMediaStream.addTrack(audioTrack);
        }
    }
    isOutputMediaStreamActive() {
        return this.outputMediaStream && this.outputMediaStream.active;
    }
    set processors(stages) {
        this.stages = stages;
    }
    get processors() {
        return this.stages;
    }
    forEachObserver(observerFunc) {
        for (const observer of this.observers)setTimeout(()=>{
            observerFunc(observer);
        }, 0);
    }
    destroyInputMediaStreamAndBuffers() {
        if (this.inputVideoStream) for (const track of this.inputVideoStream.getTracks())track.stop();
        this.inputVideoStream = null;
        for (const buffer of this.sourceBuffers)buffer.destroy();
        this.sourceBuffers = [];
    }
}
module.exports.default = $005dc4f8578b6814$var$DefaultVideoFrameProcessorPipeline;

});
parcelRegister("Zhlnq", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $0b8326bc2cf711a1$var$DefaultVideoFrameProcessorTimer {
    constructor(){
        this.workerTimer = undefined;
        this.callback = undefined;
        this.workerTimer = this.createWorkerTimer();
    }
    // Create a timer that exists within a web worker. This timer will be used to
    // retrigger the process call whenever time expires.
    createWorkerTimer() {
        try {
            // Blob representing a script that will start a timer for the length
            // of the message posted to it. After timer expiration, it will post
            // a message back to the main thread holding the timerID
            const timerBlob = new Blob([
                `self.onmessage = async function(e){ 
            var timerID = null;
            const awaitTimeout = delay => new Promise( resolve => {
              timerID = setTimeout(resolve, delay);
            })
            await awaitTimeout(e.data);
            postMessage(timerID);
          }`
            ], {
                type: 'application/javascript'
            });
            // Create the worker and link our process call to execute on
            // every message it posts
            const worker = new Worker(window.URL.createObjectURL(timerBlob));
            return worker;
        } catch (error) {
        // If blob: is not passed as a worker-src to csp, then the
        // worker timer will fail... therefore no support
        }
    }
    async start(delay, callback) {
        this.callback = callback;
        if (this.workerTimer) {
            this.workerTimer.onmessage = (event)=>{
                this.lastTimeout = event.data;
                this.callback();
            };
            this.workerTimer.postMessage(delay);
        } else this.lastTimeout = setTimeout(()=>{
            this.callback();
        }, delay);
    }
    async destroy() {
        this.callback = undefined;
        if (this.lastTimeout) {
            clearTimeout(this.lastTimeout);
            this.lastTimeout = undefined;
        }
        if (this.workerTimer) {
            this.workerTimer.terminate();
            this.workerTimer = undefined;
        }
    }
}
module.exports.default = $0b8326bc2cf711a1$var$DefaultVideoFrameProcessorTimer;

});



parcelRegister("dBfpS", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $9e6ab06becf1774c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $9e6ab06becf1774c$var$DefaultBrowserBehavior_1 = $9e6ab06becf1774c$var$__importDefault((parcelRequire("e2TuV")));

const $9e6ab06becf1774c$var$DefaultModality_1 = $9e6ab06becf1774c$var$__importDefault((parcelRequire("4Zce1")));

const $9e6ab06becf1774c$var$VideoTileState_1 = $9e6ab06becf1774c$var$__importDefault((parcelRequire("EBnSl")));
class $9e6ab06becf1774c$var$DefaultVideoTile {
    /**
     * Connect a video stream to a video element by setting the srcObject of the video element to the video stream.
     * @param videoStream The video stream input.
     * @param videoElement The video element input.
     * @param localTile Flag to indicate whether this is a local video.
     */ static connectVideoStreamToVideoElement(videoStream, videoElement, localTile) {
        const transform = localTile && videoStream.getVideoTracks()[0].getSettings().facingMode !== 'environment' ? 'rotateY(180deg)' : '';
        $9e6ab06becf1774c$var$DefaultVideoTile.setVideoElementFlag(videoElement, 'disablePictureInPicture', localTile);
        $9e6ab06becf1774c$var$DefaultVideoTile.setVideoElementFlag(videoElement, 'disableRemotePlayback', localTile);
        if (videoElement.style.transform !== transform) videoElement.style.transform = transform;
        if (videoElement.hasAttribute('controls')) videoElement.removeAttribute('controls');
        if (!videoElement.hasAttribute('autoplay')) videoElement.setAttribute('autoplay', 'true');
        // playsinline is needed for video to play in iPhone in non-fullscreen mode.
        // See https://developer.apple.com/documentation/webkit/safari_tools_and_features/delivering_video_content_for_safari#3030250
        if (!videoElement.hasAttribute('playsinline')) videoElement.setAttribute('playsinline', 'true');
        // Note that setting the *attribute* 'muted' affects whether the element
        // is muted *by default* (`.defaultMuted`), not whether it is currently muted (`.muted`).
        // https://html.spec.whatwg.org/#dom-media-defaultmuted
        if (!videoElement.hasAttribute('muted')) {
            // The default value…
            videoElement.setAttribute('muted', 'true');
            // … and the value right now.
            videoElement.muted = true;
        }
        if (videoElement.srcObject !== videoStream) {
            videoElement.srcObject = videoStream;
            // In Safari, a hidden video element can show a black screen.
            // See https://bugs.webkit.org/show_bug.cgi?id=241152 for more information.
            if (new $9e6ab06becf1774c$var$DefaultBrowserBehavior_1.default().requiresVideoPlayWorkaround() && videoElement.paused) {
                const promise = videoElement.play();
                // See https://bugs.webkit.org/show_bug.cgi?id=243519 for more information.
                // https://webkit.org/blog/7734/auto-play-policy-changes-for-macos/
                /* istanbul ignore else */ if (promise !== undefined) promise.catch((error)=>{
                    console.warn('Error playing video in Safari', error);
                }).then(()=>{
                    // `then` block is needed, without it we run into black tile issue even though we catch the error.
                    console.debug('Video played successfully in Safari');
                });
            }
        }
    }
    /**
     * Disconnect a video stream from a video element by setting `HTMLVideoElement.srcObject` to `null`.
     * @param videoElement The video element input.
     * @param dueToPause A flag to indicate whether this function is called due to pausing video tile.
     * Based on `keepLastFrameWhenPaused`, it sets `HTMLVideoElement.srcObject` to `null`.
     * @param keepLastFrameWhenPaused If `true` and `dueToPause` is also `true`, then we will not set `HTMLVideoElement.srcObject` of the
     * video element to `null` when it is paused and therefore, the last frame of the stream will be shown.
     */ static disconnectVideoStreamFromVideoElement(videoElement, dueToPause, keepLastFrameWhenPaused = false) {
        if (!videoElement) return;
        if (dueToPause) {
            if (!keepLastFrameWhenPaused) {
                videoElement.srcObject = null;
                videoElement.style.transform = '';
            }
        } else {
            if (!videoElement.srcObject) return;
            videoElement.pause();
            videoElement.style.transform = '';
            $9e6ab06becf1774c$var$DefaultVideoTile.setVideoElementFlag(videoElement, 'disablePictureInPicture', false);
            $9e6ab06becf1774c$var$DefaultVideoTile.setVideoElementFlag(videoElement, 'disableRemotePlayback', false);
            videoElement.srcObject = null;
        }
    }
    constructor(tileId, localTile, tileController, devicePixelRatioMonitor, resolutionMonitor){
        this.tileController = tileController;
        this.devicePixelRatioMonitor = devicePixelRatioMonitor;
        this.resolutionMonitor = resolutionMonitor;
        this.tileState = new $9e6ab06becf1774c$var$VideoTileState_1.default();
        this.tileState.tileId = tileId;
        this.tileState.localTile = localTile;
        this.devicePixelRatioMonitor.registerObserver(this);
    }
    destroy() {
        this.devicePixelRatioMonitor.removeObserver(this);
        if (this.tileState.boundVideoElement && this.tileState.boundVideoElement.srcObject === this.tileState.boundVideoStream) $9e6ab06becf1774c$var$DefaultVideoTile.disconnectVideoStreamFromVideoElement(this.tileState.boundVideoElement, false);
        this.tileState = new $9e6ab06becf1774c$var$VideoTileState_1.default();
    }
    devicePixelRatioChanged(newDevicePixelRatio) {
        this.tileState.devicePixelRatio = newDevicePixelRatio;
        this.sendTileStateUpdate();
    }
    id() {
        return this.tileState.tileId;
    }
    state() {
        return this.tileState.clone();
    }
    stateRef() {
        return this.tileState;
    }
    bindVideoStream(attendeeId, localTile, mediaStream, contentWidth, contentHeight, streamId, externalUserId, groupId) {
        let tileUpdated = false;
        if (this.tileState.boundAttendeeId !== attendeeId) {
            this.tileState.boundAttendeeId = attendeeId;
            if (new $9e6ab06becf1774c$var$DefaultModality_1.default(attendeeId).hasModality($9e6ab06becf1774c$var$DefaultModality_1.default.MODALITY_CONTENT)) this.tileState.isContent = true;
            tileUpdated = true;
        }
        if (this.tileState.boundExternalUserId !== externalUserId) {
            this.tileState.boundExternalUserId = externalUserId;
            tileUpdated = true;
        }
        if (this.tileState.localTile !== localTile) {
            this.tileState.localTile = localTile;
            tileUpdated = true;
        }
        if (this.tileState.boundVideoStream !== mediaStream) {
            this.tileState.boundVideoStream = mediaStream;
            tileUpdated = true;
        }
        if (this.tileState.videoStreamContentWidth !== contentWidth) {
            this.tileState.videoStreamContentWidth = contentWidth;
            tileUpdated = true;
        }
        if (this.tileState.videoStreamContentHeight !== contentHeight) {
            this.tileState.videoStreamContentHeight = contentHeight;
            tileUpdated = true;
        }
        if (this.tileState.streamId !== streamId) {
            this.tileState.streamId = streamId;
            tileUpdated = true;
        }
        if (this.tileState.groupId !== groupId) {
            this.tileState.groupId = groupId;
            tileUpdated = true;
        }
        if (tileUpdated) this.sendTileStateUpdate();
    }
    bindVideoElement(videoElement) {
        var _a;
        let tileUpdated = false;
        if (this.tileState.boundVideoElement !== videoElement) {
            this.tileState.boundVideoElement = videoElement;
            (_a = this.resolutionMonitor) === null || _a === void 0 || _a.bindVideoElement(this.tileState.boundVideoElement);
            tileUpdated = true;
        }
        if (this.tileState.boundVideoElement !== null) {
            if (this.tileState.videoElementCSSWidthPixels !== videoElement.clientWidth) {
                this.tileState.videoElementCSSWidthPixels = videoElement.clientWidth;
                tileUpdated = true;
            }
            if (this.tileState.videoElementCSSHeightPixels !== videoElement.clientHeight) {
                this.tileState.videoElementCSSHeightPixels = videoElement.clientHeight;
                tileUpdated = true;
            }
        } else {
            this.tileState.videoElementCSSWidthPixels = null;
            this.tileState.videoElementCSSHeightPixels = null;
        }
        if (tileUpdated) this.sendTileStateUpdate();
    }
    pause() {
        if (!this.tileState.paused) {
            this.tileState.paused = true;
            this.sendTileStateUpdate();
        }
    }
    unpause() {
        if (this.tileState.paused) {
            this.tileState.paused = false;
            this.sendTileStateUpdate();
        }
    }
    markPoorConnection() {
        if (this.tileState.poorConnection) return false;
        this.tileState.poorConnection = true;
        this.sendTileStateUpdate();
        return true;
    }
    unmarkPoorConnection() {
        if (!this.tileState.poorConnection) return false;
        this.tileState.poorConnection = false;
        this.sendTileStateUpdate();
        return true;
    }
    capture() {
        if (!this.tileState.active) return null;
        const canvas = document.createElement('canvas');
        const video = this.tileState.boundVideoElement;
        canvas.width = video.videoWidth || video.width;
        canvas.height = video.videoHeight || video.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        return ctx.getImageData(0, 0, canvas.width, canvas.height);
    }
    setStreamId(id) {
        this.tileState.streamId = id;
        // `streamId` is not likely used by builders but we can't
        // be sure so send a tile state update just in case.
        this.tileController.sendTileStateUpdate(this.state());
    }
    sendTileStateUpdate() {
        this.updateActiveState();
        this.updateVideoStreamOnVideoElement();
        this.updateVideoElementPhysicalPixels();
        this.tileController.sendTileStateUpdate(this.state());
    }
    updateActiveState() {
        this.tileState.active = !!(!this.tileState.paused && !this.tileState.poorConnection && this.tileState.boundAttendeeId && this.tileState.boundVideoElement && this.tileState.boundVideoStream);
    }
    updateVideoElementPhysicalPixels() {
        if (typeof this.tileState.videoElementCSSWidthPixels === 'number' && typeof this.tileState.videoElementCSSHeightPixels === 'number') {
            this.tileState.videoElementPhysicalWidthPixels = this.tileState.devicePixelRatio * this.tileState.videoElementCSSWidthPixels;
            this.tileState.videoElementPhysicalHeightPixels = this.tileState.devicePixelRatio * this.tileState.videoElementCSSHeightPixels;
        } else {
            this.tileState.videoElementPhysicalWidthPixels = null;
            this.tileState.videoElementPhysicalHeightPixels = null;
        }
    }
    updateVideoStreamOnVideoElement() {
        if (this.tileState.active) $9e6ab06becf1774c$var$DefaultVideoTile.connectVideoStreamToVideoElement(this.tileState.boundVideoStream, this.tileState.boundVideoElement, this.tileState.localTile);
        else $9e6ab06becf1774c$var$DefaultVideoTile.disconnectVideoStreamFromVideoElement(this.tileState.boundVideoElement, this.tileState.paused, this.tileController.keepLastFrameWhenPaused);
    }
    static setVideoElementFlag(videoElement, flag, value) {
        if (flag in videoElement) // @ts-ignore
        videoElement[flag] = value;
    }
}
module.exports.default = $9e6ab06becf1774c$var$DefaultVideoTile;

});
parcelRegister("4Zce1", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $3a16579133c88ebe$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $3a16579133c88ebe$var$ContentShareConstants_1 = $3a16579133c88ebe$var$__importDefault((parcelRequire("g6nnJ")));
class $3a16579133c88ebe$var$DefaultModality {
    constructor(_id){
        this._id = _id;
    }
    id() {
        return this._id;
    }
    base() {
        if (!this._id) return '';
        return this._id.split($3a16579133c88ebe$var$DefaultModality.MODALITY_SEPARATOR)[0];
    }
    modality() {
        if (!this._id) return '';
        const components = this._id.split($3a16579133c88ebe$var$DefaultModality.MODALITY_SEPARATOR);
        if (components.length === 2) return components[1];
        return '';
    }
    hasModality(modality) {
        return modality !== '' && this.modality() === modality;
    }
    withModality(modality) {
        const m = new $3a16579133c88ebe$var$DefaultModality(this.base() + $3a16579133c88ebe$var$DefaultModality.MODALITY_SEPARATOR + modality);
        if (modality === '' || this.base() === '' || new $3a16579133c88ebe$var$DefaultModality(m._id).modality() !== modality) return new $3a16579133c88ebe$var$DefaultModality(this.base());
        return m;
    }
}
$3a16579133c88ebe$var$DefaultModality.MODALITY_SEPARATOR = $3a16579133c88ebe$var$ContentShareConstants_1.default.Modality[0];
$3a16579133c88ebe$var$DefaultModality.MODALITY_CONTENT = $3a16579133c88ebe$var$ContentShareConstants_1.default.Modality.substring(1);
module.exports.default = $3a16579133c88ebe$var$DefaultModality;

});

parcelRegister("EBnSl", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[VideoTileState]] encapsulates the state of a [[VideoTile]]
 */ class $07a0bc3e218f8a95$var$VideoTileState {
    constructor(){
        /**
         * The unique identifier for the [[VideoTile]] managed by [[VideoTileController]]. Each attendee can have at most one tileId.
         */ this.tileId = null;
        /**
         * Indication of whether tile is associated with local video.
         */ this.localTile = false;
        /**
         * Indication of whether the tile associated with the local attendee has started to play.
         */ this.localTileStarted = false;
        /**
         * Indication of whether the tile has content-sharing video.
         */ this.isContent = false;
        /**
         * Indication of whether the tile has active video stream. This value may be somewhat arbitrary in how it is calculated,
         * it is recommended to use the more specific values (e.g. `paused`, `boundVideoElement`, and `boundVideoStream`) to
         * determine activity as appropriate for your application.
         */ this.active = false;
        /**
         * Indication of whether the tile has paused video stream.
         */ this.paused = false;
        /**
         * Indication of whether the remote video is paused at publishing attendee. This field is not supported.
         */ this.poorConnection = false;
        /**
         * The attendee id associated with the [[VideoTile]].
         */ this.boundAttendeeId = null;
        /**
         * The user id associated with the [[VideoTile]].
         */ this.boundExternalUserId = null;
        /**
         * The video stream bound with the [[VideoTile]].
         */ this.boundVideoStream = null;
        /**
         * The HTMLVideoElement bound with the [[VideoTile]].
         */ this.boundVideoElement = null;
        /**
         * The nameplate for the [[VideoTile]]. SDK users should use boundExternalUserId for user id instead of this field.
         */ this.nameplate = null;
        /**
         * The intrinsic width of the video stream upon binding with the [[VideoTile]].
         * Video stream intrinsic width could change and developers should use HTMLVideoElement listener for actual intrinsic width.
         */ this.videoStreamContentWidth = null;
        /**
         * The intrinsic height of the video stream upon binding with the [[VideoTile]]
         * Video stream intrinsic height could change and developers should use HTMLVideoElement listener for actual intrinsic height.
         */ this.videoStreamContentHeight = null;
        /**
         * The CSS width in pixel of the HTMLVideoElement upon binding with the [[VideoTile]].
         */ this.videoElementCSSWidthPixels = null;
        /**
         * The CSS height in pixel of the HTMLVideoElement upon binding with the [[VideoTile]].
         */ this.videoElementCSSHeightPixels = null;
        /**
         * The device pixel ratio of the current display monitor.
         */ this.devicePixelRatio = 0;
        /**
         * The physical width in pixel of the HTMLVideoElement upon binding with the [[VideoTile]].
         */ this.videoElementPhysicalWidthPixels = null;
        /**
         * The physical height in pixel of the HTMLVideoElement upon binding with the [[VideoTile]].
         */ this.videoElementPhysicalHeightPixels = null;
        /**
         * The unique identifier published by server to associate with bound video stream. It is defined in [[SignalingProtocol.proto]].
         * Developers should avoid using this field directly.
         */ this.streamId = null;
        /**
         * The unique identifier published by server to associate with remote video source. It is defined in [[SignalingProtocol.proto]].
         * Developers should avoid using this field directly.
         */ this.groupId = null;
    }
    clone() {
        const cloned = new $07a0bc3e218f8a95$var$VideoTileState();
        cloned.tileId = this.tileId;
        cloned.localTile = this.localTile;
        cloned.isContent = this.isContent;
        cloned.active = this.active;
        cloned.paused = this.paused;
        cloned.poorConnection = this.poorConnection;
        cloned.boundAttendeeId = this.boundAttendeeId;
        cloned.boundExternalUserId = this.boundExternalUserId;
        cloned.boundVideoStream = this.boundVideoStream;
        cloned.boundVideoElement = this.boundVideoElement;
        cloned.nameplate = this.nameplate;
        cloned.videoStreamContentWidth = this.videoStreamContentWidth;
        cloned.videoStreamContentHeight = this.videoStreamContentHeight;
        cloned.videoElementCSSWidthPixels = this.videoElementCSSWidthPixels;
        cloned.videoElementCSSHeightPixels = this.videoElementCSSHeightPixels;
        cloned.devicePixelRatio = this.devicePixelRatio;
        cloned.videoElementPhysicalWidthPixels = this.videoElementPhysicalWidthPixels;
        cloned.videoElementPhysicalHeightPixels = this.videoElementPhysicalHeightPixels;
        cloned.streamId = this.streamId;
        cloned.groupId = this.groupId;
        return cloned;
    }
}
module.exports.default = $07a0bc3e218f8a95$var$VideoTileState;

});


parcelRegister("34lc7", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isAudioTransformDevice = $23c22f94eee56593$var$isAudioTransformDevice;
/**
 * `isAudioTransformDevice` is a type guard for {@link AudioTransformDevice}.
 *
 * @param device the value to check.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
function $23c22f94eee56593$var$isAudioTransformDevice(device) {
    return !!device && typeof device === 'object' && 'mute' in device && 'stop' in device && 'intrinsicDevice' in device;
}

});

parcelRegister("8vrvX", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $63168fc04c36ebc4$var$DeviceSelection {
    constructor(){
        this.groupId = '';
    }
    matchesConstraints(constraints) {
        return JSON.stringify(this.constraints) === JSON.stringify(constraints);
    }
}
module.exports.default = $63168fc04c36ebc4$var$DeviceSelection;

});

parcelRegister("5XVIS", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $457f3cfea66cc995$var$GetUserMediaError extends Error {
    constructor(cause, message){
        super(message || 'Error fetching device.');
        this.cause = cause;
        this.name = 'GetUserMediaError';
    }
}
module.exports.default = $457f3cfea66cc995$var$GetUserMediaError;

});

parcelRegister("9RUp9", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $72f4d119fe881498$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $72f4d119fe881498$var$GetUserMediaError_1 = $72f4d119fe881498$var$__importDefault((parcelRequire("5XVIS")));
class $72f4d119fe881498$var$NotFoundError extends $72f4d119fe881498$var$GetUserMediaError_1.default {
    constructor(cause){
        super(cause);
        this.name = 'NotFoundError';
    }
}
module.exports.default = $72f4d119fe881498$var$NotFoundError;

});

parcelRegister("34WPe", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $23df604874a52b84$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $23df604874a52b84$var$GetUserMediaError_1 = $23df604874a52b84$var$__importDefault((parcelRequire("5XVIS")));
class $23df604874a52b84$var$NotReadableError extends $23df604874a52b84$var$GetUserMediaError_1.default {
    constructor(cause){
        super(cause);
        this.name = 'NotReadableError';
    }
}
module.exports.default = $23df604874a52b84$var$NotReadableError;

});

parcelRegister("8y2VG", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $6393c56a217d526c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $6393c56a217d526c$var$GetUserMediaError_1 = $6393c56a217d526c$var$__importDefault((parcelRequire("5XVIS")));
class $6393c56a217d526c$var$OverconstrainedError extends $6393c56a217d526c$var$GetUserMediaError_1.default {
    constructor(cause, constraint){
        super(cause);
        this.constraint = constraint;
        this.name = 'OverconstrainedError';
    }
}
module.exports.default = $6393c56a217d526c$var$OverconstrainedError;

});

parcelRegister("3JsdE", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $2b7b76cacec286c6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $2b7b76cacec286c6$var$GetUserMediaError_1 = $2b7b76cacec286c6$var$__importDefault((parcelRequire("5XVIS")));
class $2b7b76cacec286c6$var$PermissionDeniedError extends $2b7b76cacec286c6$var$GetUserMediaError_1.default {
    constructor(cause, message){
        super(cause, message);
        this.name = 'PermissionDeniedError';
    }
}
module.exports.default = $2b7b76cacec286c6$var$PermissionDeniedError;

});

parcelRegister("9j05g", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $6c65f4129fd5fb42$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $6c65f4129fd5fb42$var$GetUserMediaError_1 = $6c65f4129fd5fb42$var$__importDefault((parcelRequire("5XVIS")));
class $6c65f4129fd5fb42$var$TypeError extends $6c65f4129fd5fb42$var$GetUserMediaError_1.default {
    constructor(cause){
        super(cause);
        this.name = 'TypeError';
    }
}
module.exports.default = $6c65f4129fd5fb42$var$TypeError;

});

parcelRegister("3C9sO", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $2a1c43004c5966b2$var$VideoQualitySettings {
    constructor(videoWidth, videoHeight, videoFrameRate){
        this.videoWidth = videoWidth;
        this.videoHeight = videoHeight;
        this.videoFrameRate = videoFrameRate;
    }
    equals(other) {
        return this.videoWidth === other.videoWidth && this.videoHeight === other.videoHeight && this.videoFrameRate === other.videoFrameRate;
    }
}
$2a1c43004c5966b2$var$VideoQualitySettings.VideoDisabled = new $2a1c43004c5966b2$var$VideoQualitySettings(0, 0, 0);
$2a1c43004c5966b2$var$VideoQualitySettings.VideoResolutionHD = new $2a1c43004c5966b2$var$VideoQualitySettings(1280, 720, 30);
$2a1c43004c5966b2$var$VideoQualitySettings.VideoResolutionFHD = new $2a1c43004c5966b2$var$VideoQualitySettings(1920, 1080, 30);
$2a1c43004c5966b2$var$VideoQualitySettings.VideoResolutionUHD = new $2a1c43004c5966b2$var$VideoQualitySettings(3840, 2160, 30);
module.exports.default = $2a1c43004c5966b2$var$VideoQualitySettings;

});

parcelRegister("6ukw3", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isVideoTransformDevice = $4b957577c9fcd228$var$isVideoTransformDevice;
/**
 * `isVideoTransformDevice` is a type guard for {@link VideoTransformDevice}.
 *
 * @param device the value to check.
 */ function $4b957577c9fcd228$var$isVideoTransformDevice(device) {
    return !!device && typeof device === 'object' && 'transformStream' in device && 'stop' in device && 'intrinsicDevice' in device;
}

});



parcelRegister("gijOb", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $bdcdb1579f754815$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $bdcdb1579f754815$var$BaseTask_1 = $bdcdb1579f754815$var$__importDefault((parcelRequire("9wPDz")));
/*
 * [[CreatePeerConnectionTask]] sets up the peer connection object.
 */ class $bdcdb1579f754815$var$CreatePeerConnectionTask extends $bdcdb1579f754815$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'CreatePeerConnectionTask';
        this.removeTrackAddedEventListener = null;
        this.removeTrackRemovedEventListeners = {};
        this.trackEvents = [
            'ended',
            'mute',
            'unmute',
            'isolationchange',
            'overconstrained'
        ];
        this.removeVideoTrackEventListeners = {};
        this.trackAddedHandler = (event)=>{
            const track = event.track;
            this.context.logger.info(`received track event: kind=${track.kind} id=${track.id} label=${track.label}`);
            if (event.transceiver && event.transceiver.currentDirection === 'inactive') return;
            if (event.streams.length === 0) {
                this.context.logger.warn(`Track event but no stream`);
                return;
            }
            const stream = event.streams[0];
            if (track.kind === 'audio') this.context.audioMixController.bindAudioStream(stream);
            else if (track.kind === 'video' && !this.trackIsVideoInput(track)) this.addRemoteVideoTrack(track, stream);
        };
    }
    removeObserver() {
        this.removeTrackAddedEventListener && this.removeTrackAddedEventListener();
        for(const trackId in this.removeTrackRemovedEventListeners)this.removeTrackRemovedEventListeners[trackId]();
    }
    addPeerConnectionEventLogger() {
        const peer = this.context.peer;
        peer.addEventListener('connectionstatechange', ()=>{
            this.context.logger.info(`peer connection state changed: ${peer.connectionState}`);
        });
        peer.addEventListener('negotiationneeded', ()=>{
            this.context.logger.info('peer connection negotiation is needed');
        });
        peer.addEventListener('icegatheringstatechange', ()=>{
            this.context.logger.info(`peer connection ice gathering state changed: ${peer.iceGatheringState}`);
        });
        peer.addEventListener('icecandidate', (event)=>{
            this.context.logger.info(`peer connection ice candidate: ${event.candidate ? event.candidate.candidate : '(null)'}`);
        });
        peer.addEventListener('iceconnectionstatechange', ()=>{
            var _a;
            this.context.logger.info(`peer connection ice connection state changed: ${peer.iceConnectionState}`);
            if (peer.iceConnectionState === 'connected') /* istanbul ignore next */ (_a = this.context.meetingSessionTimingManager) === null || _a === void 0 || _a.onIceConnected();
        });
    }
    async run() {
        this.context.removableObservers.push(this);
        const hasTurnCredentials = this.context.turnCredentials && this.context.turnCredentials.uris.length > 0;
        const configuration = hasTurnCredentials ? {
            iceServers: [
                {
                    urls: this.context.turnCredentials.uris,
                    username: this.context.turnCredentials.username,
                    credential: this.context.turnCredentials.password
                }
            ],
            iceTransportPolicy: 'relay'
        } : {};
        configuration.bundlePolicy = this.context.browserBehavior.requiresBundlePolicy();
        // @ts-ignore
        configuration.sdpSemantics = 'unified-plan';
        // @ts-ignore
        const supportsRTCScriptTransform = !!window.RTCRtpScriptTransform;
        if (!supportsRTCScriptTransform) // If the WebRTC Encoded Streams API is not supported, attempt to use the legacy pre-M141 release
        // version of the API on chromium based browsers.
        // @ts-ignore
        configuration.encodedInsertableStreams = this.context.enableAudioRedundancy();
        if (this.context.peer) this.context.logger.info('reusing peer connection');
        else {
            this.context.logger.info('creating new peer connection');
            // @ts-ignore
            this.context.peer = new RTCPeerConnection(configuration);
            this.addPeerConnectionEventLogger();
        }
        this.removeTrackAddedEventListener = ()=>{
            if (this.context.peer) this.context.peer.removeEventListener('track', this.trackAddedHandler);
            this.removeTrackAddedEventListener = null;
        };
        this.context.peer.addEventListener('track', this.trackAddedHandler);
    }
    trackIsVideoInput(track) {
        if (this.context.transceiverController.useTransceivers()) {
            this.logger.debug(()=>{
                return `getting video track type`;
            });
            return this.context.transceiverController.trackIsVideoInput(track);
        }
        return false;
    }
    addRemoteVideoTrack(track, stream) {
        var _a;
        const trackId = stream.id;
        const attendeeId = this.context.videoStreamIndex.attendeeIdForTrack(trackId);
        let skipAdding;
        let tile;
        if (this.context.videoTileController.getVideoTileForAttendeeId) {
            tile = this.context.videoTileController.getVideoTileForAttendeeId(attendeeId);
            skipAdding = !!((_a = tile === null || tile === void 0 ? void 0 : tile.state()) === null || _a === void 0 ? void 0 : _a.boundVideoStream);
        } else skipAdding = this.context.videoTileController.haveVideoTileForAttendeeId(attendeeId);
        if (skipAdding) {
            this.context.logger.info(`Not adding remote track. Already have tile for attendeeId:  ${attendeeId}`);
            return;
        }
        if (!tile) {
            tile = this.context.videoTileController.addVideoTile();
            this.logger.info(`Created video tile ${tile.id()}`);
        }
        let streamId = this.context.videoStreamIndex.streamIdForTrack(trackId);
        if (typeof streamId === 'undefined') {
            this.logger.warn(`stream not found for tile=${tile.id()} track=${trackId}`);
            streamId = null;
        }
        let groupId = this.context.videoStreamIndex.groupIdForStreamId(streamId);
        if (groupId === undefined) groupId = null;
        for(let i = 0; i < this.trackEvents.length; i++){
            const trackEvent = this.trackEvents[i];
            const videoTracks = stream.getVideoTracks();
            if (videoTracks && videoTracks.length) {
                const videoTrack = videoTracks[0];
                const callback = ()=>{
                    this.context.logger.info(`received the ${trackEvent} event for tile=${tile.id()} id=${track.id} streamId=${streamId}`);
                    if (trackEvent === 'ended') this.removeRemoteVideoTrack(track, tile.state());
                };
                videoTrack.addEventListener(trackEvent, callback);
                if (!this.removeVideoTrackEventListeners[track.id]) this.removeVideoTrackEventListeners[track.id] = [];
                this.removeVideoTrackEventListeners[track.id].push(()=>{
                    videoTrack.removeEventListener(trackEvent, callback);
                });
            }
        }
        let width;
        let height;
        if (track.getSettings) {
            const cap = track.getSettings();
            width = cap.width;
            height = cap.height;
        } else {
            const cap = track.getCapabilities();
            width = cap.width;
            height = cap.height;
        }
        const externalUserId = this.context.videoStreamIndex.externalUserIdForTrack(trackId);
        tile.bindVideoStream(attendeeId, false, stream, width, height, streamId, externalUserId, groupId);
        this.logger.info(`video track added, use tile=${tile.id()} track=${trackId} streamId=${streamId} groupId=${groupId}`);
        const endEvent = 'removetrack';
        const target = stream;
        const trackRemovedHandler = ()=>this.removeRemoteVideoTrack(track, tile.state());
        this.removeTrackRemovedEventListeners[track.id] = ()=>{
            target.removeEventListener(endEvent, trackRemovedHandler);
            delete this.removeTrackRemovedEventListeners[track.id];
        };
        target.addEventListener(endEvent, trackRemovedHandler);
    }
    removeRemoteVideoTrack(track, tileState) {
        var _a;
        if (this.removeTrackRemovedEventListeners.hasOwnProperty(track.id)) {
            this.removeTrackRemovedEventListeners[track.id]();
            for (const removeVideoTrackEventListener of this.removeVideoTrackEventListeners[track.id])removeVideoTrackEventListener();
            delete this.removeVideoTrackEventListeners[track.id];
        }
        this.logger.info(`video track ended, removing tile=${tileState.tileId} id=${track.id} stream=${tileState.streamId}`);
        if (tileState.streamId) this.context.videosPaused.remove(tileState.streamId);
        else this.logger.warn(`no stream found for tile=${tileState.tileId}`);
        if (tileState.groupId !== null) /* istanbul ignore next */ (_a = this.context.meetingSessionTimingManager) === null || _a === void 0 || _a.onRemoteVideoRemoved(tileState.groupId);
        this.context.videoTileController.removeVideoTile(tileState.tileId);
    }
}
$bdcdb1579f754815$var$CreatePeerConnectionTask.REMOVE_HANDLER_INTERVAL_MS = 10000;
module.exports.default = $bdcdb1579f754815$var$CreatePeerConnectionTask;

});

parcelRegister("h2Cf2", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c6804987a69285d4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $c6804987a69285d4$var$MeetingSessionStatusCode_1 = $c6804987a69285d4$var$__importDefault((parcelRequire("9zYoz")));

const $c6804987a69285d4$var$SDP_1 = $c6804987a69285d4$var$__importDefault((parcelRequire("bry62")));

const $c6804987a69285d4$var$BaseTask_1 = $c6804987a69285d4$var$__importDefault((parcelRequire("9wPDz")));
/*
 * [[CreateSDPTask]] asynchronously calls [[createOffer]] on peer connection.
 */ class $c6804987a69285d4$var$CreateSDPTask extends $c6804987a69285d4$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'CreateSDPTask';
    }
    cancel() {
        // Just in case. The baseCancel behavior should prevent this.
        /* istanbul ignore else */ if (this.cancelPromise) {
            const error = new Error(`canceling ${this.name()}`);
            this.cancelPromise(error);
            delete this.cancelPromise;
        }
    }
    sessionUsesAudio() {
        var _a, _b;
        return !!((_b = (_a = this.context.meetingSessionConfiguration) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.audioHostURL);
    }
    sessionUsesVideo() {
        const enabled = true;
        let sending;
        if (this.context.transceiverController.useTransceivers()) sending = this.context.transceiverController.hasVideoInput();
        else sending = this.context.videoTileController.hasStartedLocalVideoTile();
        const receiving = !!this.context.videosToReceive && !this.context.videosToReceive.empty();
        const usesVideo = enabled && (sending || receiving);
        this.context.logger.info(`uses video: ${usesVideo} (enabled: ${enabled}, sending: ${sending}, receiving: ${receiving})`);
        return usesVideo;
    }
    async run() {
        const offerOptions = {
            offerToReceiveAudio: this.sessionUsesAudio(),
            offerToReceiveVideo: this.sessionUsesVideo()
        };
        this.logger.info(`peer connection offerOptions: ${JSON.stringify(offerOptions)}`);
        await new Promise(async (resolve, reject)=>{
            var _a;
            this.cancelPromise = (error)=>{
                reject(error);
            };
            try {
                this.context.sdpOfferInit = await this.context.peer.createOffer(offerOptions);
                (_a = this.context.meetingSessionTimingManager) === null || _a === void 0 || _a.onCreateOfferCalled();
                this.context.logger.info('peer connection created offer');
                if (this.context.previousSdpOffer) {
                    if (new $c6804987a69285d4$var$SDP_1.default(this.context.sdpOfferInit.sdp).videoSendSectionHasDifferentSSRC(this.context.previousSdpOffer)) {
                        const error = new Error(`canceling ${this.name()} due to the meeting status code: ${$c6804987a69285d4$var$MeetingSessionStatusCode_1.default.IncompatibleSDP}`);
                        this.context.previousSdpOffer = null;
                        reject(error);
                        return;
                    }
                }
                resolve();
            } catch (error) {
                reject(error);
            } finally{
                delete this.cancelPromise;
            }
        });
    }
}
module.exports.default = $c6804987a69285d4$var$CreateSDPTask;

});
parcelRegister("9zYoz", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingSessionStatusCode = void 0;
/**
 * [[MeetingSessionStatusCode]] gives the underlying reason for a given [[MeetingSessionStatus]]. Though some codes are used for
 * [[MeetingSessionStatus]] internally, the primary use of these is in `AudioVideoObserver.audioVideoDidStop`, and their docstrings
 * will be specific to that usage. Other functions that use [[MeetingSessionStatus]] (mainly
 * `AudioVideoControllerFacade.promoteToPrimaryMeeting` and `AudioVideoObserver.audioVideoWasDemotedFromPrimaryMeeting` will document
 * their usage separately).
 *
 * These status codes can be used for logging, debugging, and notification to end users, but in most cases should not
 * be used for any retry behavior, as the audio video controller will already be retrying non-terminal errors (i.e. regardless
 * of `MeetingSessionStatus.isTerminal`, your application should not try to immediately restart or recreate the
 * audio video controller). For error codes that indicate issues with the Chime service, please create a github issue
 * with browser logs if they occur frequently.
 *
 * If `MeetingSessionStatus.isTerminal` returns `true`, you should remove any meeting UX in addition to notifying the user,
 * as the audio video controller will not be retrying the connection. When notifying users, more general failure messages are
 * recommended unless otherwise noted.
 */ var $6f963b2a441c232e$var$MeetingSessionStatusCode;
(function(MeetingSessionStatusCode) {
    /**
     * There is no error. This code is used internally but will never be returned by `audioVideoDidStop`
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["OK"] = 0] = "OK";
    /**
     * The attendee left the meeting normally via `AudioVideoConftrollerFacade.stop`
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["Left"] = 1] = "Left";
    /**
     * The attendee joined from another device (e.g. another browser window/tab or on mobile) using the
     * same credentials. `Audio` prefix is irrelevant. The end-user may want to be notified of this
     * type of error.
     *
     * This also can occur if your application unintentionally creates two meeting sessions.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["AudioJoinedFromAnotherDevice"] = 2] = "AudioJoinedFromAnotherDevice";
    /**
     * Authentication was rejected as the attendee information in `MeetingSessionCredentials` did
     * not match that of an attendee created via `chime::CreateAttendee`.
     *
     * This error may imply an issue with your credential providing service. The `Audio` prefix is irrelevant.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["AudioAuthenticationRejected"] = 3] = "AudioAuthenticationRejected";
    /**
     * The client can not join because the meeting is at capacity. The service supports up to 250 attendees. The
     * end user may want to be notified of this type of error. The `Audio` prefix is irrelevant.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["AudioCallAtCapacity"] = 4] = "AudioCallAtCapacity";
    /**
     * The attendee attempted to join a meeting that has already ended. See
     * [this FAQ](https://aws.github.io/amazon-chime-sdk-js/modules/faqs.html#when-does-an-amazon-chime-sdk-meeting-end)
     * for more information. The end user may want to be notified of this type of error.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["MeetingEnded"] = 5] = "MeetingEnded";
    /**
     * There was an internal server error related to audio. This may indicate some issue with the audio device, or an issue with
     * the Amazon Chime SDK service itself.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["AudioInternalServerError"] = 6] = "AudioInternalServerError";
    /**
     * There was an internal server error related to audio. This may indicate some issue with the audio device, or an issue with
     * the Amazon Chime SDK service itself.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["AudioServiceUnavailable"] = 7] = "AudioServiceUnavailable";
    /**
     * There was an internal server error related to audio. This may indicate some issue with the audio device, or an issue with
     * the Amazon Chime SDK service itself.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["AudioDisconnected"] = 8] = "AudioDisconnected";
    /**
     * This is only used internally and will not be provided in any `audioVideoDidStop` calls.
     *
     * The client has asked to send and receive video, but it is only possible to
     * continue in view-only mode (receiving video). This should be handled by
     * explicitly switching to view-only mode.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["VideoCallSwitchToViewOnly"] = 9] = "VideoCallSwitchToViewOnly";
    /**
     * This is only used internally and will not be provided in any `audioVideoDidStop` calls.
     *
     * This can happen when you attempt to join a video meeting in "send only" mode
     * (transmitting your camera, but not receiving anything -- this isn't something
     * we ever do in practice, but it is supported on the server). It should be
     * treated as "fatal" and probably should not be retried (despite the 5xx nature).
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["VideoCallAtSourceCapacity"] = 10] = "VideoCallAtSourceCapacity";
    /**
     * The Amazon Chime SDK for JavaScript failed to establish a signaling connection because
     * you or someone else deleted the attendee using the
     * [DeleteAttendee](https://docs.aws.amazon.com/chime-sdk/latest/APIReference/API_meeting-chime_DeleteAttendee.html)
     * API action in your server application. You also should not use the attendee response from
     * the ended meeting that you created with the same ClientRequestToken parameter
     * before.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["SignalingBadRequest"] = 11] = "SignalingBadRequest";
    /**
     * The Chime SDK for JavaScript either failed to establish a signaling connection to the Chime
     * backend due to an internal server error or the connection was lost mid-call.
     *
     * This may indicate an issue with the Chime service, but also often indicates a network issue impacting the end user,
     * who may want to be notified of their unstable network during the reconnection.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["SignalingInternalServerError"] = 12] = "SignalingInternalServerError";
    /**
     * Received unknown signaling error frame without a status. This code is nearly impossible to occur
     * and indicates an issue with the Chime service.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["SignalingRequestFailed"] = 13] = "SignalingRequestFailed";
    /**
     * The websocket signalling channel was closed unexpectedly mid-meeting. This may be due to:
     * * A client side network change, e.g. switching WiFi networks (most typical).
     * * A backend detecting client side issues (e.g. decryption issues), and snapping
     *   the connection to force a reconnection.
     * * Unexpected backend issues, e.g. AWS networking issues.
     * The latter two are less common.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["SignalingChannelClosedUnexpectedly"] = 14] = "SignalingChannelClosedUnexpectedly";
    /**
     * Timed out gathering ICE candidates. If in Chrome, this could be an
     * indication that the browser is in a bad state due to a VPN reconnect and
     * the user should try quitting and relaunching the app. See:
     * https://bugs.chromium.org/p/webrtc/issues/detail?id=9097
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["ICEGatheringTimeoutWorkaround"] = 15] = "ICEGatheringTimeoutWorkaround";
    /**
     * Due to connection health as determined by [[ConnectionHealthPolicyConfiguration]], a reconnect has been triggered.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["ConnectionHealthReconnect"] = 16] = "ConnectionHealthReconnect";
    /**
     * The [[RealtimeController]] failed in some way. This indicates an issue with the callback function provided to RealtimeController APIs (e.g. a callback is throwing an error).
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["RealtimeApiFailed"] = 17] = "RealtimeApiFailed";
    /**
     * A step in the connection to the Amazon Chime SDK backends failed without a more specific reason. This may indicate end-user connection issues
     * and should be retried.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["TaskFailed"] = 18] = "TaskFailed";
    /**
     * There was an issue with media negotiation. This may indicate an issue with Amazon Chime SDK, or that the end user is using an unsupported
     * browser. Please use `new DefaultBrowserBehavior().isSupported()` pre-call to check the support of end-user browsers
     * and warn them of possible issues.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["IncompatibleSDP"] = 19] = "IncompatibleSDP";
    /**
     * This can happen when you attempt to join a meeting which has ended or attendee got removed. This is analogous to `MeetingEnded` except
     * determined through the media channel rather then the signaling channel.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["TURNCredentialsForbidden"] = 20] = "TURNCredentialsForbidden";
    /**
     * The attendee did not show up on the roster. This may indicate an issue with the end user audio device or and issue with Amazon Chime SDK.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["NoAttendeePresent"] = 21] = "NoAttendeePresent";
    /**
     * The session was ended because the attendee has been removed via `chime::DeleteAttendee`. The end user may want to be notified
     * of this error.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["AudioAttendeeRemoved"] = 22] = "AudioAttendeeRemoved";
    /**
     * This is only used in promotion functions and will not be provided in any `audioVideoDidStop` calls.
     *
     * The attendees Primary meeting credentials have been revoked or deleted.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["AudioVideoWasRemovedFromPrimaryMeeting"] = 23] = "AudioVideoWasRemovedFromPrimaryMeeting";
    /**
     * This is only used in promotion functions and will not be provided in any `audioVideoDidStop` calls.
     *
     * The attendee was automatically demoted following a disconnection. The attendee must re-premote itself to the
     * primary meeting.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["AudioVideoDisconnectedWhilePromoted"] = 24] = "AudioVideoDisconnectedWhilePromoted";
    /**
     * This is only used internally and will not be provided in any `audioVideoDidStop` calls.
     *
     * Reserved.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["AudioDisconnectAudio"] = 25] = "AudioDisconnectAudio";
    /**
     * The encoded transform worker manager failed during the meeting. This may indicate an issue with
     * media processing or browser compatibility with encoded transforms. The audio video controller
     * will attempt to reconnect without transforms.
     */ MeetingSessionStatusCode[MeetingSessionStatusCode["EncodedTransformManagerFailed"] = 26] = "EncodedTransformManagerFailed";
})($6f963b2a441c232e$var$MeetingSessionStatusCode || (module.exports.MeetingSessionStatusCode = $6f963b2a441c232e$var$MeetingSessionStatusCode = {}));
module.exports.default = $6f963b2a441c232e$var$MeetingSessionStatusCode;

});

parcelRegister("bry62", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $854caa2cb6e7293f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $854caa2cb6e7293f$var$SDPCandidateType_1 = $854caa2cb6e7293f$var$__importDefault((parcelRequire("dVDT1")));

const $854caa2cb6e7293f$var$SDPMediaSection_1 = $854caa2cb6e7293f$var$__importDefault((parcelRequire("ji2zS")));

const $854caa2cb6e7293f$var$VideoCodecCapability_1 = $854caa2cb6e7293f$var$__importDefault((parcelRequire("4C1Yl")));
/**
 * [[SDP]] includes a few helper functions for parsing sdp string.
 */ class $854caa2cb6e7293f$var$SDP {
    /**
     * Construts a new [[SDP]] object
     */ constructor(sdp){
        this.sdp = sdp;
    }
    /**
     * Clones an SDP
     */ clone() {
        return new $854caa2cb6e7293f$var$SDP(this.sdp);
    }
    /**
     * Checks if the candidate is a valid RTP candidate
     */ static isRTPCandidate(candidate) {
        const match = /candidate[:](\S+) (\d+)/g.exec(candidate);
        if (match === null || match[2] !== '1') return false;
        return true;
    }
    /**
     * Constructs a new SDP with the given set of SDP lines.
     */ static linesToSDP(lines) {
        return new $854caa2cb6e7293f$var$SDP(lines.join($854caa2cb6e7293f$var$SDP.CRLF));
    }
    /**
     * Returns an enum of [[candidateType]] for the given string.
     */ static candidateTypeFromString(candidateType) {
        switch(candidateType){
            case $854caa2cb6e7293f$var$SDPCandidateType_1.default.Host:
                return $854caa2cb6e7293f$var$SDPCandidateType_1.default.Host;
            case $854caa2cb6e7293f$var$SDPCandidateType_1.default.ServerReflexive:
                return $854caa2cb6e7293f$var$SDPCandidateType_1.default.ServerReflexive;
            case $854caa2cb6e7293f$var$SDPCandidateType_1.default.PeerReflexive:
                return $854caa2cb6e7293f$var$SDPCandidateType_1.default.PeerReflexive;
            case $854caa2cb6e7293f$var$SDPCandidateType_1.default.Relay:
                return $854caa2cb6e7293f$var$SDPCandidateType_1.default.Relay;
        }
        return null;
    }
    /**
     * Returns the candidate type assocaited with the sdpline.
     */ static candidateType(sdpLine) {
        const match = /a[=]candidate[:].* typ ([a-z]+) /g.exec(sdpLine);
        if (match === null) return null;
        return $854caa2cb6e7293f$var$SDP.candidateTypeFromString(match[1]);
    }
    /**
     * Returns the media type associated with the sdp line.
     */ static mediaType(sdpLine) {
        const match = /m=(audio|video)/g.exec(sdpLine);
        if (match === null) return undefined;
        return match[1];
    }
    /**
     * Erase out "a=mid"  from the sdp line.
     */ static mid(sdpLine) {
        if (!sdpLine.includes('a=mid:')) return undefined;
        return sdpLine.replace(/^(a=mid:)/, '');
    }
    /**
     * Return the direction associated with the sdp line.
     */ static direction(sdpLine) {
        const match = /a=(sendrecv|sendonly|recvonly|inactive)/g.exec(sdpLine);
        if (match === null) return undefined;
        return match[1];
    }
    /**
     * Format the sdp string into separate lines.
     */ static splitLines(blob) {
        return blob.trim().split('\n').map((line)=>{
            return line.trim();
        });
    }
    /**
     * split the different sdp sections
     */ static splitSections(sdp) {
        // each section starts with "m="
        const sections = sdp.split('\nm=');
        return sections.map((section, index)=>{
            return (index > 0 ? 'm=' + section : section).trim() + $854caa2cb6e7293f$var$SDP.CRLF;
        });
    }
    /**
     * split the different sdp sections
     */ static findActiveCameraSection(sections) {
        let cameraLineIndex = 0;
        let hasCamera = false;
        for (const sec of sections){
            if (/^m=video/.test(sec)) {
                if (sec.indexOf('sendrecv') > -1 || // RFC 4566: If none of the attributes "sendonly", "recvonly", "inactive",
                // and "sendrecv" is present, "sendrecv" SHOULD be assumed as the
                // default for sessions
                sec.indexOf('sendonly') === -1 && sec.indexOf('recvonly') === -1 && sec.indexOf('inactive') === -1) {
                    hasCamera = true;
                    break;
                }
            }
            cameraLineIndex++;
        }
        if (hasCamera === false) cameraLineIndex = -1;
        return cameraLineIndex;
    }
    /**
     * Extract the SSRCs from the group line.
     *
     * a=ssrc-group:<semantics> <ssrc-id> ...
     */ static extractSSRCsFromFIDGroupLine(figGroupLine) {
        const ssrcStringMatch = /^a=ssrc-group:FID\s(.+)/.exec(figGroupLine);
        return ssrcStringMatch[1];
    }
    /**
     * Extracts the lines from the sdp blob that matches the given prefix.
     */ static matchPrefix(blob, prefix) {
        return $854caa2cb6e7293f$var$SDP.splitLines(blob).filter((line)=>{
            return line.indexOf(prefix) === 0;
        });
    }
    /**
     * Splits SDP string into lines
     */ lines() {
        return this.sdp.split($854caa2cb6e7293f$var$SDP.CRLF);
    }
    /**
     * Checks if SDP has a video section.
     */ hasVideo() {
        return /^m=video/gm.exec(this.sdp) !== null;
    }
    /**
     * Checks whether the SDP has candidates for any m-line
     */ hasCandidates() {
        const match = /a[=]candidate[:]/g.exec(this.sdp);
        if (match === null) return false;
        return true;
    }
    /**
     * Checks whether the SDP has candidates for all m-lines
     */ hasCandidatesForAllMLines() {
        const isAnyCLineUsingLocalHost = this.sdp.indexOf('c=IN IP4 0.0.0.0') > -1;
        const mLinesHaveCandidates = !isAnyCLineUsingLocalHost;
        return mLinesHaveCandidates;
    }
    /**
     * Removes candidates of a given type from SDP
     */ withoutCandidateType(candidateTypeToExclude) {
        return $854caa2cb6e7293f$var$SDP.linesToSDP(this.lines().filter((line)=>$854caa2cb6e7293f$var$SDP.candidateType(line) !== candidateTypeToExclude));
    }
    /**
     * Removes server reflexive candidate from SDP
     */ withoutServerReflexiveCandidates() {
        return this.withoutCandidateType($854caa2cb6e7293f$var$SDPCandidateType_1.default.ServerReflexive);
    }
    /**
     * Inserts a parameter to the SDP local offer setting the desired average audio bitrate
     */ withAudioMaxAverageBitrate(maxAverageBitrate) {
        if (!maxAverageBitrate) return this.clone();
        maxAverageBitrate = Math.trunc(Math.min(Math.max(maxAverageBitrate, $854caa2cb6e7293f$var$SDP.rfc7587LowestBitrate), $854caa2cb6e7293f$var$SDP.rfc7587HighestBitrate));
        const srcLines = this.lines();
        const fmtpAttributes = $854caa2cb6e7293f$var$SDP.findOpusFmtpAttributes(srcLines);
        const dstLines = $854caa2cb6e7293f$var$SDP.updateOpusFmtpAttributes(srcLines, fmtpAttributes, [
            `maxaveragebitrate=${maxAverageBitrate}`
        ]);
        return $854caa2cb6e7293f$var$SDP.linesToSDP(dstLines);
    }
    /**
     * Update the SDP to include stereo
     */ withStereoAudio() {
        const srcLines = this.lines();
        const fmtpAttributes = $854caa2cb6e7293f$var$SDP.findOpusFmtpAttributes(srcLines);
        const dstLines = $854caa2cb6e7293f$var$SDP.updateOpusFmtpAttributes(srcLines, fmtpAttributes, [
            'stereo=1',
            'sprop-stereo=1'
        ]);
        return $854caa2cb6e7293f$var$SDP.linesToSDP(dstLines);
    }
    /**
     * Here we loop through each line in the SDP
     * and construct an array containing the fmtp
     * attribute for all the audio m lines that use
     * the opus codec. If it doesn't use opus codec
     * we add null to the array which tells
     * updateOpusFmtpAttributes that no update is
     * needed for that particular fmtp attribute line
     */ static findOpusFmtpAttributes(sdpLines) {
        const opusRtpMapRegex = /^a=rtpmap:\s*(\d+)\s+opus\/48000/;
        let lookingForOpusRtpMap = false;
        const fmtpAttributes = [];
        for (const line of sdpLines){
            if (line.startsWith('m=audio')) {
                fmtpAttributes.push(null);
                lookingForOpusRtpMap = true;
            }
            if (line.startsWith('m=video')) // Opus rtpmap is only part of audio m lines section
            // Set this to false as we don't need to perform regex
            // matches for video section
            lookingForOpusRtpMap = false;
            if (lookingForOpusRtpMap) {
                const match = opusRtpMapRegex.exec(line);
                if (match !== null) fmtpAttributes[fmtpAttributes.length - 1] = `a=fmtp:${match[1]} `;
            }
        }
        return fmtpAttributes;
    }
    /**
     * Update the fmtp lines in each audio m section
     * that correspond to the opus codec with the parameters
     * specifief in additionalParams
     */ static updateOpusFmtpAttributes(srcLines, fmtpAttributes, additionalParams) {
        const dstLines = [];
        let fmtpIndex = 0;
        let currFmtpAttribute = null;
        for (const line of srcLines){
            if (line.startsWith('m=audio')) {
                currFmtpAttribute = fmtpAttributes[fmtpIndex];
                fmtpIndex++;
            }
            if (line.startsWith('m=video')) currFmtpAttribute = null;
            if (currFmtpAttribute && line.startsWith(currFmtpAttribute)) {
                const oldParameters = line.slice(currFmtpAttribute.length).split(';');
                const newParameters = [];
                // If an existing parameter is in additionalParams
                // dont add it to newParameters as it will be replaced
                for (const parameter of oldParameters){
                    const index = additionalParams.findIndex((element)=>element.startsWith(parameter.split('=')[0]));
                    if (index < 0) newParameters.push(parameter);
                }
                for (const parameter of additionalParams)newParameters.push(parameter);
                dstLines.push(currFmtpAttribute + newParameters.join(';'));
            } else dstLines.push(line);
        }
        return dstLines;
    }
    /**
     * Munges Unified-Plan SDP from different browsers to conform to one format
     * TODO: will remove this soon.
     */ withUnifiedPlanFormat() {
        let originalSdp = this.sdp;
        if (originalSdp.includes('mozilla')) return this.clone();
        else originalSdp = originalSdp.replace('o=-', 'o=mozilla-chrome');
        return new $854caa2cb6e7293f$var$SDP(originalSdp);
    }
    /**
     * Returns the total number of unique Rtp header extensions.
     */ getUniqueRtpHeaderExtensionId(srcLines) {
        const headerExtensionIds = [];
        for (const line of srcLines)if (/^a=extmap:/.test(line.trim())) {
            const headerExtension = line.split('a=extmap:')[1].split(' ');
            const id = +headerExtension[0];
            if (!headerExtensionIds.includes(id)) headerExtensionIds.push(id);
        }
        headerExtensionIds.sort((a, b)=>a - b);
        let previousId = 0; // header extension cannot be 0, refer https://datatracker.ietf.org/doc/html/rfc5285
        for (const id of headerExtensionIds){
            if (id - previousId > 1) return previousId + 1;
            previousId = id;
        }
        // One-Byte Header header extension cannot be bigger than 14, refer https://datatracker.ietf.org/doc/html/rfc5285
        return previousId === 14 ? -1 : previousId + 1;
    }
    /**
     * To avoid resubscribing to preemptively turn off simulcast streams or to switch layers
     * negotiate with the back end to determine whether to use layers allocation header extension
     * this will not add the packet overhead unless negotiated to avoid waste
     */ withVideoLayersAllocationRtpHeaderExtension(previousSdp) {
        return this.withRtpHeaderExtension(previousSdp, $854caa2cb6e7293f$var$SDP.videoLayersAllocationRtpHeaderExtensionUrl);
    }
    /**
     * Dependency descriptors can be used by the backend to designate spatial or temporal layers
     * on a single encoding. Along with the video layers allocation exension this will
     * result in the ability for remote attendees to subscribe to individual layers below the top.
     */ withDependencyDescriptorRtpHeaderExtension(previousSdp) {
        return this.withRtpHeaderExtension(previousSdp, $854caa2cb6e7293f$var$SDP.dependencyDescriptorRtpHeaderExtensionUrl);
    }
    /**
     * If the send transceiver is in a state where the layers allocation extension is not matching up with
     * the dependency descriptor extension, or we simply don't want to allow for the seperation of spatial
     * or temporal layers, we can remove the dependency descriptor from the SDP.
     *
     * Note: Care should be taken when calling this function since `withDependencyDescriptorRtpHeaderExtension`
     * if called again will require an accurate ID value. Thus it is recommended to only call `withoutDependencyDescriptorRtpHeaderExtension`
     * after setting the local description.
     */ withoutDependencyDescriptorRtpHeaderExtension() {
        const srcLines = $854caa2cb6e7293f$var$SDP.splitLines(this.sdp).filter((line)=>!line.includes($854caa2cb6e7293f$var$SDP.dependencyDescriptorRtpHeaderExtensionUrl));
        return new $854caa2cb6e7293f$var$SDP(srcLines.join($854caa2cb6e7293f$var$SDP.CRLF) + $854caa2cb6e7293f$var$SDP.CRLF);
    }
    withRtpHeaderExtension(previousSdp, url) {
        // According to https://webrtc.googlesource.com/src/+/b62ee8ce94e5f10e0a94d6f112e715cc4d0cd9dc,
        // RTP header extension ID change would result in a hard failure. Therefore if the extension exists
        // in the previous SDP, use the same extension ID to avoid the failure. Otherwise use a new ID
        const previousId = previousSdp ? previousSdp.getRtpHeaderExtensionId(url) : -1;
        const id = previousId === -1 ? this.getUniqueRtpHeaderExtensionId($854caa2cb6e7293f$var$SDP.splitLines(this.sdp)) : previousId;
        const sections = $854caa2cb6e7293f$var$SDP.splitSections(this.sdp);
        const newSections = [];
        for (let section of sections){
            if (/^m=video/.test(section) && $854caa2cb6e7293f$var$SDP.getRtpHeaderExtensionIdInSection(section, url) === -1) {
                // Add RTP header extension when it does not already exist
                const srcLines = $854caa2cb6e7293f$var$SDP.splitLines(section);
                const dstLines = [];
                if (id === -1 || this.hasRtpHeaderExtensionId(id)) {
                    // if all ids are used or the id is already used, we won't add new line to it
                    newSections.push(section);
                    continue;
                }
                for (const line of srcLines){
                    dstLines.push(line);
                    if (/^a=sendrecv/.test(line.trim())) {
                        const targetLine = `a=extmap:` + id + ` ` + url;
                        dstLines.push(targetLine);
                    }
                }
                section = dstLines.join($854caa2cb6e7293f$var$SDP.CRLF) + $854caa2cb6e7293f$var$SDP.CRLF;
            } else if (previousId !== -1 && /^m=video/.test(section) && $854caa2cb6e7293f$var$SDP.getRtpHeaderExtensionIdInSection(section, url) !== previousId) {
                // Override extension ID if it does not match previous SDP
                const srcLines = $854caa2cb6e7293f$var$SDP.splitLines(section);
                const dstLines = [];
                for (const line of srcLines){
                    if (/^a=extmap:/.test(line.trim())) {
                        const headerExtension = line.split('a=extmap:')[1].split(' ');
                        if (headerExtension[1] === url) {
                            if (!this.hasRtpHeaderExtensionId(previousId)) {
                                // If previous ID is used by another extension, remove it from this SDP
                                const targetLine = `a=extmap:` + previousId + ` ` + url;
                                dstLines.push(targetLine);
                            }
                            continue;
                        }
                    }
                    dstLines.push(line);
                }
                section = dstLines.join($854caa2cb6e7293f$var$SDP.CRLF) + $854caa2cb6e7293f$var$SDP.CRLF;
            }
            newSections.push(section);
        }
        const newSdp = newSections.join('');
        return new $854caa2cb6e7293f$var$SDP(newSdp);
    }
    /**
     * Extracts the ssrc for the sendrecv video media section in SDP
     */ ssrcForVideoSendingSection() {
        const srcSDP = this.sdp;
        const sections = $854caa2cb6e7293f$var$SDP.splitSections(srcSDP);
        if (sections.length < 2) return '';
        const cameraLineIndex = $854caa2cb6e7293f$var$SDP.findActiveCameraSection(sections);
        if (cameraLineIndex === -1) return '';
        // TODO: match for Firefox. Currently all failures are not Firefox induced.
        const fidGroupMatch = $854caa2cb6e7293f$var$SDP.matchPrefix(sections[cameraLineIndex], 'a=ssrc-group:FID ');
        if (fidGroupMatch.length < 1) return '';
        const fidGroup = $854caa2cb6e7293f$var$SDP.extractSSRCsFromFIDGroupLine(fidGroupMatch[0]);
        const [videoSSRC1] = fidGroup.split(' ').map((ssrc)=>parseInt(ssrc, 10));
        return videoSSRC1.toString();
    }
    /**
     * Returns whether the sendrecv video sections if exist have two different SSRCs in SDPs
     */ videoSendSectionHasDifferentSSRC(prevSdp) {
        const ssrc1 = this.ssrcForVideoSendingSection();
        const ssrc2 = prevSdp.ssrcForVideoSendingSection();
        if (ssrc1 === '' || ssrc2 === '') return false;
        const ssrc1InNumber = parseInt(ssrc1, 10);
        const ssrc2InNumber = parseInt(ssrc2, 10);
        if (ssrc1InNumber === ssrc2InNumber) return false;
        return true;
    }
    /**
     * Removes H.264 from the send section.
     */ removeH264SupportFromSendSection() {
        const srcSDP = this.sdp;
        const sections = $854caa2cb6e7293f$var$SDP.splitSections(srcSDP);
        const cameraLineIndex = $854caa2cb6e7293f$var$SDP.findActiveCameraSection(sections);
        if (cameraLineIndex === -1) return new $854caa2cb6e7293f$var$SDP(this.sdp);
        const cameraSection = sections[cameraLineIndex];
        const cameraSectionLines = $854caa2cb6e7293f$var$SDP.splitLines(cameraSection);
        const payloadTypesForH264 = [];
        const primaryPayloadTypeToFeedbackPayloadTypes = new Map();
        // Loop through camera section (m=video)
        cameraSectionLines.forEach((attribute)=>{
            // Find the payload type with H264 codec line (e.g., a=rtpmap:<payload> H264/90000)
            if (/^a=rtpmap:/.test(attribute)) {
                const payloadMatch = /^a=rtpmap:([0-9]+)\s/.exec(attribute);
                if (payloadMatch && attribute.toLowerCase().includes('h264')) payloadTypesForH264.push(parseInt(payloadMatch[1], 10));
            }
            // Loop through the rtx payload and create a mapping between it and the primary payload.
            // a=fmtp:<rtx payload> apt=<primary payload>
            if (/^a=fmtp:/.test(attribute)) {
                const feedbackMatches = /^a=fmtp:([0-9]+) apt=([0-9]+)/.exec(attribute);
                if (feedbackMatches && feedbackMatches.length === 3) {
                    const feedbackPayloadType = parseInt(feedbackMatches[1], 10);
                    const primaryPayloadType = parseInt(feedbackMatches[2], 10);
                    if (primaryPayloadTypeToFeedbackPayloadTypes.has(primaryPayloadType)) primaryPayloadTypeToFeedbackPayloadTypes.get(primaryPayloadType).push(feedbackPayloadType);
                    else primaryPayloadTypeToFeedbackPayloadTypes.set(primaryPayloadType, [
                        feedbackPayloadType
                    ]);
                }
            }
        });
        // Add the rtx payloads corresponding to the H264 codec to the remove list
        const payloadTypesToRemove = new Set();
        for (const type of payloadTypesForH264){
            payloadTypesToRemove.add(type);
            const feedbackTypes = primaryPayloadTypeToFeedbackPayloadTypes.get(type);
            if (feedbackTypes) for (const feedbackType of feedbackTypes)payloadTypesToRemove.add(feedbackType);
        }
        // Remove H264 payload from the media line. m=video 9 UDP/+++ <payload> <payload> <payload>
        if (payloadTypesForH264.length > 0) {
            const mline = cameraSectionLines[0].split(' ');
            cameraSectionLines[0] = mline.filter((text)=>!payloadTypesToRemove.has(parseInt(text))).join(' ');
        }
        // Filter out lines with H264 payload
        const filteredLines = cameraSectionLines.filter((line)=>{
            if (!line.includes('rtpmap') && !line.includes('rtcp-fb') && !line.includes('fmtp')) return true;
            for (const type of payloadTypesToRemove){
                if (line.includes(type.toString())) return false;
            }
            return true;
        });
        sections[cameraLineIndex] = filteredLines.join($854caa2cb6e7293f$var$SDP.CRLF) + $854caa2cb6e7293f$var$SDP.CRLF;
        const newSDP = sections.join('');
        return new $854caa2cb6e7293f$var$SDP(newSDP);
    }
    /**
     * List of parsed media sections sections in order they occur on SDP.
     */ mediaSections() {
        const sections = $854caa2cb6e7293f$var$SDP.splitSections(this.sdp);
        if (sections.length < 2) return [];
        const parsedMediaSections = [];
        for(let i = 1; i < sections.length; i++){
            const section = new $854caa2cb6e7293f$var$SDPMediaSection_1.default();
            const lines = $854caa2cb6e7293f$var$SDP.splitLines(sections[i]);
            for (const line of lines){
                const mediaType = $854caa2cb6e7293f$var$SDP.mediaType(line);
                if (mediaType !== undefined) {
                    section.mediaType = mediaType;
                    continue;
                }
                const direction = $854caa2cb6e7293f$var$SDP.direction(line);
                if (direction !== undefined) {
                    section.direction = direction;
                    continue;
                }
                const mid = $854caa2cb6e7293f$var$SDP.mid(line);
                if (mid !== undefined) {
                    section.mid = mid;
                    continue;
                }
            }
            parsedMediaSections.push(section);
        }
        return parsedMediaSections;
    }
    /**
     * Return RTP header extension ID if the extension exists in section. Return -1 otherwise
     */ static getRtpHeaderExtensionIdInSection(section, url) {
        const lines = $854caa2cb6e7293f$var$SDP.splitLines(section);
        for (const line of lines)if (/^a=extmap:/.test(line.trim())) {
            const headerExtension = line.split('a=extmap:')[1].split(' ');
            const id = +headerExtension[0];
            if (headerExtension[1] === url) return id;
        }
        return -1;
    }
    /**
     * Return RTP header extension ID if the extension exists in SDP. Return -1 otherwise
     */ getRtpHeaderExtensionId(url) {
        const sections = $854caa2cb6e7293f$var$SDP.splitSections(this.sdp);
        for (const section of sections)if (/^m=video/.test(section)) {
            const id = $854caa2cb6e7293f$var$SDP.getRtpHeaderExtensionIdInSection(section, url);
            if (id !== -1) return id;
        }
        return -1;
    }
    /**
     * Return if extension ID exists in the SDP
     */ hasRtpHeaderExtensionId(targetId) {
        const lines = $854caa2cb6e7293f$var$SDP.splitLines(this.sdp);
        for (const line of lines)if (/^a=extmap:/.test(line.trim())) {
            const headerExtension = line.split('a=extmap:')[1].split(' ');
            const id = +headerExtension[0];
            if (id === targetId) return true;
        }
        return false;
    }
    /**
     * Based off the provided preferences, this function will reorder the payload types listed in the `m=video` line.
     *
     * This will be applied to the `a=sendrecv` section so it can be applied on either local or remote SDPs. It can be used to
     * 'polyfill' `RTCRtpSender.setCodecPreferences' on the offer, but it can also be used on remote SDPs to force the
     * codec actually being send, since the send codec is currently dependent on the remote answer (i.e. `setCodecPreferences` doesn't actually
     * have any impact unless the remote side respects the order of codecs which is not true of the Chime SDK media backends).
     */ withVideoSendCodecPreferences(preferences) {
        const srcSDP = this.sdp;
        const sections = $854caa2cb6e7293f$var$SDP.splitSections(srcSDP);
        // Note `findActiveCameraSection` looks for `sendrecv` video sections so it
        // works on both local and remote SDPs.
        const cameraLineIndex = $854caa2cb6e7293f$var$SDP.findActiveCameraSection(sections);
        if (cameraLineIndex === -1) return new $854caa2cb6e7293f$var$SDP(this.sdp);
        sections[cameraLineIndex] = this.sectionWithCodecPreferences(sections[cameraLineIndex], preferences);
        const newSDP = sections.join('');
        return new $854caa2cb6e7293f$var$SDP(newSDP);
    }
    // Based off the provided preferences, this function will reorder the payload types listed in the `m=video` line.
    sectionWithCodecPreferences(section, preferences) {
        const payloadTypeToCodec = new Map();
        const lines = $854caa2cb6e7293f$var$SDP.splitLines(section);
        // Process each line to map payload types to their respective codecs
        lines.forEach((line)=>{
            if (!line.startsWith('a=rtpmap:')) return;
            const payloadMatch = /^a=rtpmap:(\d+)\s/.exec(line);
            if (!payloadMatch) return;
            const payloadTypeString = payloadMatch[1];
            for (const preference of preferences){
                if (!line.includes(`${preference.codecName}/${preference.codecCapability.clockRate}`)) continue;
                let codecMatches = false;
                if (preference.codecCapability.sdpFmtpLine !== undefined) {
                    let hasVp9ProfileId = false;
                    for (const prospectiveFmtpLine of lines){
                        if (preference.fmtpLineMatches(prospectiveFmtpLine, parseInt(payloadTypeString))) {
                            codecMatches = true;
                            break;
                        }
                        hasVp9ProfileId || (hasVp9ProfileId = prospectiveFmtpLine.startsWith(`a=fmtp:${payloadTypeString} profile-id=`));
                    }
                    if (preference.equals($854caa2cb6e7293f$var$VideoCodecCapability_1.default.vp9Profile0()) && !hasVp9ProfileId) codecMatches = true;
                } else codecMatches = true;
                if (codecMatches) {
                    payloadTypeToCodec.set(payloadTypeString, preference);
                    break;
                }
            }
        });
        const payloadTypesToRemove = new Set(payloadTypeToCodec.keys());
        const mline = lines[0].split(' ').filter((text)=>!payloadTypesToRemove.has(text));
        const orderedPreferedPayloadTypes = Array.from(payloadTypeToCodec.entries()).sort(([_payloadType1, codec1], [_payloadType2, codec2])=>{
            const priority1 = preferences.indexOf(codec1);
            const priority2 = preferences.indexOf(codec2);
            return priority1 - priority2;
        }).map(([payloadType, _])=>payloadType);
        mline.splice(3, 0, ...orderedPreferedPayloadTypes);
        lines[0] = mline.join(' ');
        return lines.join($854caa2cb6e7293f$var$SDP.CRLF) + $854caa2cb6e7293f$var$SDP.CRLF;
    }
    /**
     * Returns the `VideoCodecCapability` which corresponds to the first payload type in the
     * m-line (e.g. `m=video 9 UDP/+++ <highest priority payload type> <payload type> <payload type> ...`),
     * parsing the rest of the SDP for relevant information to construct it.
     *
     * Returns undefined if there is no video send section or no codecs in the send section
     *
     * This function is currently unused/deprecated and will be removed in a future PR.
     */ highestPriorityVideoSendCodec() {
        const prioritizedSendVideoCodecCapabilities = this.prioritizedSendVideoCodecCapabilities();
        return prioritizedSendVideoCodecCapabilities.length > 0 ? prioritizedSendVideoCodecCapabilities[0] : undefined;
    }
    /**
     * Returns all `VideoCodecCapability` that can be found in the camera section, in order of priority as defined in
     * m-line (e.g. `m=video 9 UDP/+++ <highest priority payload type> <payload type> <payload type> ...`),
     * parsing the rest of the SDP for relevant information to construct it.
     *
     * Returns an empty list if there is no video send section or no codecs in the send section
     */ prioritizedSendVideoCodecCapabilities() {
        const srcSDP = this.sdp;
        const sections = $854caa2cb6e7293f$var$SDP.splitSections(srcSDP);
        // Note `findActiveCameraSection` looks for `sendrecv` video sections so it
        // works on both local and remote SDPs.
        const cameraLineIndex = $854caa2cb6e7293f$var$SDP.findActiveCameraSection(sections);
        if (cameraLineIndex === -1) return [];
        const lines = $854caa2cb6e7293f$var$SDP.splitLines(sections[cameraLineIndex]);
        // m=video 9 UDP/+++ <payload> <payload> <payload> ...
        const mlineTokens = lines[0].split(' ');
        if (mlineTokens.length < 4) return [];
        // Extract payload types from the m-line
        const payloadTypes = mlineTokens.slice(3);
        // Get VideoCodecCapability for each payload type
        const capabilities = payloadTypes.map((payloadType)=>this.videoCodecCapabilityForPayloadType(lines, payloadType)).filter((capability)=>{
            // Filter out capabilities that failed to parse or are not codecs (e.g. RTX payload types)
            return capability !== undefined && [
                'VP8',
                'H264',
                'VP9',
                'AV1'
            ].includes(capability.codecName);
        });
        return capabilities;
    }
    videoCodecCapabilityForPayloadType(sectionLines, payloadType) {
        let codecName = undefined;
        let clockRate = undefined;
        let fmtpLine = undefined;
        for (const line of sectionLines){
            // Match the payload type in rtpmap lines
            const payloadMatch = /^a=rtpmap:([0-9]+)\s/.exec(line);
            if (payloadMatch && payloadMatch[1] === payloadType) {
                const lineTokens = line.split(' ');
                const nameAndClockRate = lineTokens[1].split('/');
                if (nameAndClockRate.length >= 2) {
                    codecName = nameAndClockRate[0];
                    clockRate = nameAndClockRate[1];
                }
            }
            // Match fmtp lines for the payload type
            if (line.startsWith(`a=fmtp:${payloadType} `)) // `split` will always return 2 items given we have trailing whitespace in check above
            fmtpLine = line.split(' ')[1];
        }
        if (codecName !== undefined) return new $854caa2cb6e7293f$var$VideoCodecCapability_1.default(codecName, {
            clockRate: parseInt(clockRate),
            mimeType: `video/${codecName}`,
            sdpFmtpLine: fmtpLine
        });
        return undefined;
    }
    getAudioPayloadTypes() {
        const payloadTypeMap = new Map();
        const srcSDP = this.sdp;
        const sections = $854caa2cb6e7293f$var$SDP.splitSections(srcSDP);
        payloadTypeMap.set('opus', $854caa2cb6e7293f$var$SDP.findAudioPayloadType('opus', sections));
        payloadTypeMap.set('red', $854caa2cb6e7293f$var$SDP.findAudioPayloadType('red', sections));
        return payloadTypeMap;
    }
    static findAudioPayloadType(codecName, sections) {
        const codecRegex = `a=rtpmap:\\s*(\\d+)\\s+${codecName}\\/48000`;
        const rtpMapRegex = new RegExp(codecRegex);
        for (const sec of sections)if (/^m=audio/.test(sec)) {
            const match = rtpMapRegex.exec(sec);
            if (match !== null) return Number(match[1]);
        }
        return 0;
    }
    /**
     * Modifies the active camera section to include a specified starting bitrate
     * for video sending by adding a 'x-google-start-bitrate' fmtp line paramter for
     * each non-RTX/FEC payload type associated with video.
     *
     * Note that this updates all video sections regardless of direction, as
     * https://www.rfc-editor.org/rfc/rfc8843#name-payload-type-pt-value-reuse states that
     * "...all codecs associated with the payload type number MUST share an identical codec configuration.
     * This means that the codecs MUST share the same media type, encoding name,
     * clock rate, and any parameter that can affect the codec configuration and packetization."
     *
     * WebRTC maintainers may eventual enforce this (https://issues.webrtc.org/issues/42224689),
     * though it just logs an error for now.
     *
     * If no active video sections are found in the SDP, returns the original SDP object.
     */ withStartingVideoSendBitrate(bitrateKbps) {
        const sections = $854caa2cb6e7293f$var$SDP.splitSections(this.sdp);
        for(let i = 0; i < sections.length; i++){
            if (!/^m=video/.test(sections[i])) continue;
            const srcLines = $854caa2cb6e7293f$var$SDP.splitLines(sections[i]);
            const dstLines = [];
            let hasFmtp = false;
            let payloadType;
            // First pass: check if fmtp exists and get payload type
            for (const line of srcLines){
                if (/^a=fmtp:\d*/.test(line) && !/apt=/.test(line)) hasFmtp = true;
                // Extract payload type from rtpmap line (e.g., "a=rtpmap:96 VP8/90000")
                const rtpmapMatch = line.match(/^a=rtpmap:(\d+)/);
                if (rtpmapMatch) payloadType = rtpmapMatch[1];
            }
            // Second pass: add bitrate parameter. We avoid adding this to retransmission payload types since it
            // is not relevant to those.
            for (const line of srcLines)if (/^a=fmtp:\d*/.test(line) && !/apt=/.test(line) && !/x-google-start-bitrate=/.test(line)) {
                // `x-google-start-bitrate` is an unofficial flag that has existed in libwebrtc since its release and is unlikely
                // to be removed without notification.
                //
                // libwebrtc constant: https://webrtc.googlesource.com/src/+/b6ef1a736ee94d97cc28f3bd59b826c716a3278f/media/base/media_constants.cc#97
                // libwebrtc parsing:  https://webrtc.googlesource.com/src/+/61c5e86dca59b0ac8240444e7df5c31da27ee40f/media/engine/webrtc_media_engine.cc#172
                const newLine = line + `;x-google-start-bitrate=${bitrateKbps}`;
                dstLines.push(newLine);
            } else dstLines.push(line);
            // If no fmtp line exists, add one after the rtpmap line
            if (!hasFmtp && payloadType) {
                const rtpmapIndex = dstLines.findIndex((line)=>line.match(/^a=rtpmap:\d+/));
                if (rtpmapIndex !== -1) dstLines.splice(rtpmapIndex + 1, 0, `a=fmtp:${payloadType} x-google-start-bitrate=${bitrateKbps}`);
            }
            sections[i] = dstLines.join($854caa2cb6e7293f$var$SDP.CRLF) + $854caa2cb6e7293f$var$SDP.CRLF;
        }
        const newSdp = sections.join('');
        return new $854caa2cb6e7293f$var$SDP(newSdp);
    }
}
$854caa2cb6e7293f$var$SDP.CRLF = '\r\n';
$854caa2cb6e7293f$var$SDP.rfc7587LowestBitrate = 6000;
$854caa2cb6e7293f$var$SDP.rfc7587HighestBitrate = 510000;
$854caa2cb6e7293f$var$SDP.dependencyDescriptorRtpHeaderExtensionUrl = `https://aomediacodec.github.io/av1-rtp-spec/#dependency-descriptor-rtp-header-extension`;
$854caa2cb6e7293f$var$SDP.videoLayersAllocationRtpHeaderExtensionUrl = `http://www.webrtc.org/experiments/rtp-hdrext/video-layers-allocation00`;
module.exports.default = $854caa2cb6e7293f$var$SDP;

});
parcelRegister("dVDT1", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDPCandidateType = void 0;
var $a23f89d848560e97$var$SDPCandidateType;
(function(SDPCandidateType) {
    SDPCandidateType["Host"] = "host";
    SDPCandidateType["ServerReflexive"] = "srflx";
    SDPCandidateType["PeerReflexive"] = "prflx";
    SDPCandidateType["Relay"] = "relay";
})($a23f89d848560e97$var$SDPCandidateType || (module.exports.SDPCandidateType = $a23f89d848560e97$var$SDPCandidateType = {}));
module.exports.default = $a23f89d848560e97$var$SDPCandidateType;

});

parcelRegister("ji2zS", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Represents parsed attributes of a media section (i.e. associated with a single m-line)
 */ class $e0b1b2a230d61857$var$SDPMediaSection {
}
module.exports.default = $e0b1b2a230d61857$var$SDPMediaSection;

});

parcelRegister("4C1Yl", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4huDn = parcelRequire("4huDn");
/**
 * `VideoCodecCapability` represents a higher level type to wrap `RTCRtpCodec`
 * and the codec name used in the SDP, while also namespacing static create functions
 * for codecs supported in the SDK.
 *
 * Note that `codecName` is different then `codecCapability.mimeType`
 */ class $35bc3db46ecb8da6$var$VideoCodecCapability {
    constructor(codecName, codecCapability){
        this.codecName = codecName;
        this.codecCapability = codecCapability;
    }
    equals(other) {
        if (other === undefined) return false;
        if (this.codecName !== other.codecName || this.codecCapability.mimeType !== other.codecCapability.mimeType || this.codecCapability.clockRate !== other.codecCapability.clockRate) return false;
        const thisFmtpLine = this.codecCapability.sdpFmtpLine ? this.cleanupFmtpLine(this.codecCapability.sdpFmtpLine, this.codecName) : '';
        const otherFmtpLine = other.codecCapability.sdpFmtpLine ? this.cleanupFmtpLine(other.codecCapability.sdpFmtpLine, other.codecName) : '';
        return thisFmtpLine === otherFmtpLine;
    }
    /**
     * Returns whether the codec capability fmtp line matches. This will not
     * attempt to match H.264 profile levels (e.g. 5.2, 3.1), see internal comments for
     * more detailed information. This function takes care of checking for an
     * expected payload type as well.
     *
     * This function is meant to only be used internally.
     */ fmtpLineMatches(line, expectedPayloadType) {
        const codecCapabilityFmtpLine = this.codecCapability.sdpFmtpLine;
        if (!codecCapabilityFmtpLine) return false;
        const prefix = `a=fmtp:${expectedPayloadType} `;
        if (!line.startsWith(prefix)) return false;
        const fmtpLineFromSdp = line.substring(prefix.length);
        return this.cleanupFmtpLine(fmtpLineFromSdp, this.codecName) === this.cleanupFmtpLine(codecCapabilityFmtpLine, this.codecName);
    }
    /**
     * Helper function to clean up the FMTP line by removing unnecessary parameters
     * and normalizing certain codec-specific attributes.
     */ cleanupFmtpLine(fmtpLine, codecName) {
        // Remove starting bitrate parameter which isn't relevant to matching.
        const bitrateRegex = /;x-google-start-bitrate=\d+/g;
        let cleanedLine = fmtpLine.replace(bitrateRegex, '');
        if (codecName === 'H264') {
            // Given that most H.264 decoders for the past decade can support level 5.2, we do not bother checking the Profile Level
            // with regards to canonically defined, meeting wide, H.264 profile options (i.e. we intentionally do not split up `h264HighProfile`
            // into `h264HighProfileLevel52, `h264HighProfileLevel31`, etc.).
            //
            // Additionally, Chrome bundles FFmpeg software decoders which while advertised as 3.1, will happily decode any bitrate/resolution.
            //
            // If maximum compatability with H.264 is desired by a builder they should stick to H.264 Constrained Baseline Profile.
            const profileLevelIdRegex = /profile-level-id=([0-9a-f]{4})[0-9a-f]{2}/i;
            cleanedLine = cleanedLine.replace(profileLevelIdRegex, 'profile-level-id=$1');
        }
        return cleanedLine;
    }
    /**
     * Returns the configuration of VP8 supported by the SDK
     */ static vp8() {
        return new $35bc3db46ecb8da6$var$VideoCodecCapability('VP8', {
            clockRate: 90000,
            mimeType: 'video/VP8'
        });
    }
    /**
     * Returns the configuration of H.264 Baseline Profile supported by the SDK.
     *
     * This profile is more likely to use hardware for encode on most browsers
     * then constrained baseline profile.
     */ static h264BaselineProfile() {
        return new $35bc3db46ecb8da6$var$VideoCodecCapability('H264', {
            clockRate: 90000,
            mimeType: 'video/H264',
            sdpFmtpLine: 'level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=42001f'
        });
    }
    /**
     * Returns the configuration of H.264 CBP supported by the SDK.
     *
     * This profile is required in all WebRTC implementations and typically
     * uses software for the encode for stability. Hardware decode is common.
     */ static h264ConstrainedBaselineProfile() {
        return new $35bc3db46ecb8da6$var$VideoCodecCapability('H264', {
            clockRate: 90000,
            mimeType: 'video/H264',
            sdpFmtpLine: 'level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=42e01f'
        });
    }
    /**
     * Returns the configuration of H.264 Main Profile supported by the SDK
     *
     * This profile is more likely to use hardware for encode on most browsers
     * then constrained baseline profile. It may have modest quality/bitrate improvements
     * over baseline/constrained baseline profile.
     */ static h264MainProfile() {
        return new $35bc3db46ecb8da6$var$VideoCodecCapability('H264', {
            clockRate: 90000,
            mimeType: 'video/H264',
            sdpFmtpLine: 'level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=4d001f'
        });
    }
    /**
     * Returns the configuration of H.264 High Profile supported by the SDK.
     *
     * Currently most browsers do not have software fallback for high profile
     * which may impact stability. Its usage should be done with caution.
     *
     * On MacOS, until https://bugs.chromium.org/p/chromium/issues/detail?id=1520287 is
     * resolved, receivers will fail to allocate the decoder for this profile if the sender switches away and back
     * to this codec (e.g. fallback for a Firefox receiver, and then recovery when the Firefox
     * receiver leaves).
     *
     * If you expect a decent amount of iOS safari traffic, you should include `h264ConstrainedHighProfile` in your
     * preferences as well. It will be forwarded as High profile to receivers that negotiated High but not Constrained
     * High
     */ static h264HighProfile() {
        return new $35bc3db46ecb8da6$var$VideoCodecCapability('H264', {
            clockRate: 90000,
            mimeType: 'video/H264',
            sdpFmtpLine: 'level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=64001f'
        });
    }
    /**
     * Returns the configuration of H.264 Constrained High Profile supported by the SDK
     *
     * This is currently only used on Safari. The same notes on H.264 High Profile apply to this
     * codec.
     */ static h264ConstrainedHighProfile() {
        return new $35bc3db46ecb8da6$var$VideoCodecCapability('H264', {
            clockRate: 90000,
            mimeType: 'video/H264',
            sdpFmtpLine: 'level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=640c1f'
        });
    }
    /**
     * Returns the configuration of H.264 recommended by the SDK for maximum compatability.
     */ static h264() {
        return $35bc3db46ecb8da6$var$VideoCodecCapability.h264ConstrainedBaselineProfile();
    }
    /**
     * Returns the configuration of VP9 profile 0 supported by the SDK.
     * Profile 0 is for use with 8-bit source content.
     */ static vp9Profile0() {
        return new $35bc3db46ecb8da6$var$VideoCodecCapability('VP9', {
            clockRate: 90000,
            mimeType: 'video/VP9',
            sdpFmtpLine: 'profile-id=0'
        });
    }
    /**
     * Returns the configuration of AV1 recommended by the SDK
     */ static vp9() {
        return $35bc3db46ecb8da6$var$VideoCodecCapability.vp9Profile0();
    }
    /**
     * Returns the configuration of AV1 main profile used by the SDK
     */ static av1Main() {
        return new $35bc3db46ecb8da6$var$VideoCodecCapability('AV1', {
            clockRate: 90000,
            mimeType: 'video/AV1'
        });
    }
    /**
     * Returns the configuration of AV1 recommended by the SDK
     */ static av1() {
        return $35bc3db46ecb8da6$var$VideoCodecCapability.av1Main();
    }
    /**
     * Returns the configuration of codec corresponding to the signaled capability
     */ static fromSignaled(capability) {
        switch(capability){
            case $4huDn.SdkVideoCodecCapability.VP8:
                return $35bc3db46ecb8da6$var$VideoCodecCapability.vp8();
            case $4huDn.SdkVideoCodecCapability.H264_BASELINE_PROFILE:
                return $35bc3db46ecb8da6$var$VideoCodecCapability.h264BaselineProfile();
            case $4huDn.SdkVideoCodecCapability.H264_CONSTRAINED_BASELINE_PROFILE:
                return $35bc3db46ecb8da6$var$VideoCodecCapability.h264ConstrainedBaselineProfile();
            case $4huDn.SdkVideoCodecCapability.H264_MAIN_PROFILE:
                return $35bc3db46ecb8da6$var$VideoCodecCapability.h264MainProfile();
            case $4huDn.SdkVideoCodecCapability.H264_HIGH_PROFILE:
                return $35bc3db46ecb8da6$var$VideoCodecCapability.h264HighProfile();
            case $4huDn.SdkVideoCodecCapability.H264_CONSTRAINED_HIGH_PROFILE:
                return $35bc3db46ecb8da6$var$VideoCodecCapability.h264ConstrainedHighProfile();
            case $4huDn.SdkVideoCodecCapability.VP9_PROFILE_0:
                return $35bc3db46ecb8da6$var$VideoCodecCapability.vp9Profile0();
            case $4huDn.SdkVideoCodecCapability.AV1_MAIN_PROFILE:
                return $35bc3db46ecb8da6$var$VideoCodecCapability.av1Main();
            default:
                return undefined;
        }
    }
}
module.exports.default = $35bc3db46ecb8da6$var$VideoCodecCapability;

});



parcelRegister("bBKjs", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/* eslint @typescript-eslint/no-explicit-any: 0 */ class $8737132e9e5fcdfa$var$DataMessage {
    constructor(timestampMs, topic, data, senderAttendeeId, senderExternalUserId, throttled){
        this.timestampMs = timestampMs;
        this.topic = topic;
        this.data = data;
        this.senderAttendeeId = senderAttendeeId;
        this.senderExternalUserId = senderExternalUserId;
        this.throttled = !!throttled;
    }
    /**
     * Helper conversion method to convert `Uint8Array` data to string
     */ text() {
        return new TextDecoder().decode(this.data);
    }
    /**
     * Helper conversion method to convert `Uint8Array` data to JSON
     */ json() {
        return JSON.parse(new TextDecoder().decode(this.data));
    }
}
module.exports.default = $8737132e9e5fcdfa$var$DataMessage;

});

parcelRegister("ep2G0", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $a7c579fc3ba2116a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $a7c579fc3ba2116a$var$IntervalScheduler_1 = $a7c579fc3ba2116a$var$__importDefault((parcelRequire("4wGp7")));
class $a7c579fc3ba2116a$var$DefaultActiveSpeakerDetector {
    constructor(realtimeController, selfAttendeeId, hasBandwidthPriorityCallback, waitIntervalMs = 1000, updateIntervalMs = 200){
        this.realtimeController = realtimeController;
        this.selfAttendeeId = selfAttendeeId;
        this.hasBandwidthPriorityCallback = hasBandwidthPriorityCallback;
        this.waitIntervalMs = waitIntervalMs;
        this.updateIntervalMs = updateIntervalMs;
        this.speakerScores = {};
        this.speakerMuteState = {};
        this.detectorCallbackToHandler = new Map();
        this.detectorCallbackToScoresTimer = new Map();
        this.detectorCallbackToActivityTimer = new Map();
        this.hasBandwidthPriority = false;
        this.mostRecentUpdateTimestamp = {};
    }
    needUpdate(attendeeId) {
        if (!this.activeSpeakers) return true;
        return this.speakerScores[attendeeId] === 0 && this.activeSpeakers.includes(attendeeId) || this.speakerScores[attendeeId] > 0 && !this.activeSpeakers.includes(attendeeId);
    }
    updateActiveSpeakers(policy, callback, attendeeId) {
        if (!this.needUpdate(attendeeId)) return;
        const sortedSpeakers = [];
        const attendeeIds = Object.keys(this.speakerScores);
        for(let i = 0; i < attendeeIds.length; i++){
            const attendeeId = attendeeIds[i];
            sortedSpeakers.push({
                attendeeId: attendeeId,
                activeScore: this.speakerScores[attendeeId]
            });
        }
        const sortedAttendeeIds = sortedSpeakers.sort((s1, s2)=>s2.activeScore - s1.activeScore).filter(function(s) {
            return s.activeScore > 0;
        }).map(function(s) {
            return s.attendeeId;
        });
        this.activeSpeakers = sortedAttendeeIds;
        callback(sortedAttendeeIds);
        const selfIsActive = sortedAttendeeIds.length > 0 && sortedAttendeeIds[0] === this.selfAttendeeId;
        const hasBandwidthPriority = selfIsActive && policy.prioritizeVideoSendBandwidthForActiveSpeaker();
        const hasBandwidthPriorityDidChange = this.hasBandwidthPriority !== hasBandwidthPriority;
        if (hasBandwidthPriorityDidChange) {
            this.hasBandwidthPriority = hasBandwidthPriority;
            this.hasBandwidthPriorityCallback(hasBandwidthPriority);
        }
    }
    updateScore(policy, callback, attendeeId, volume, muted) {
        const activeScore = policy.calculateScore(attendeeId, volume, muted);
        if (this.speakerScores[attendeeId] !== activeScore) {
            this.speakerScores[attendeeId] = activeScore;
            this.mostRecentUpdateTimestamp[attendeeId] = Date.now();
            this.updateActiveSpeakers(policy, callback, attendeeId);
        }
    }
    subscribe(policy, callback, scoresCallback, scoresCallbackIntervalMs) {
        const handler = (attendeeId, present)=>{
            if (!present) {
                this.speakerScores[attendeeId] = 0;
                this.mostRecentUpdateTimestamp[attendeeId] = Date.now();
                this.updateActiveSpeakers(policy, callback, attendeeId);
                return;
            }
            this.realtimeController.realtimeSubscribeToVolumeIndicator(attendeeId, (attendeeId, volume, muted, _signalStrength)=>{
                this.mostRecentUpdateTimestamp[attendeeId] = Date.now();
                if (muted !== null) this.speakerMuteState[attendeeId] = muted;
                this.updateScore(policy, callback, attendeeId, volume, muted);
            });
        };
        this.detectorCallbackToHandler.set(callback, handler);
        const activityTimer = new $a7c579fc3ba2116a$var$IntervalScheduler_1.default(this.updateIntervalMs);
        activityTimer.start(()=>{
            for(const attendeeId in this.speakerScores)if (Date.now() - this.mostRecentUpdateTimestamp[attendeeId] > this.waitIntervalMs) this.updateScore(policy, callback, attendeeId, 0, this.speakerMuteState[attendeeId]);
        });
        this.detectorCallbackToActivityTimer.set(callback, activityTimer);
        if (scoresCallback && scoresCallbackIntervalMs) {
            const scoresTimer = new $a7c579fc3ba2116a$var$IntervalScheduler_1.default(scoresCallbackIntervalMs);
            scoresTimer.start(()=>{
                scoresCallback(this.speakerScores);
            });
            this.detectorCallbackToScoresTimer.set(callback, scoresTimer);
        }
        this.realtimeController.realtimeSubscribeToAttendeeIdPresence(handler);
    }
    unsubscribe(callback) {
        const handler = this.detectorCallbackToHandler.get(callback);
        this.detectorCallbackToHandler.delete(callback);
        if (handler) this.realtimeController.realtimeUnsubscribeToAttendeeIdPresence(handler);
        const activityTimer = this.detectorCallbackToActivityTimer.get(callback);
        if (activityTimer) {
            activityTimer.stop();
            this.detectorCallbackToActivityTimer.delete(callback);
        }
        const scoresTimer = this.detectorCallbackToScoresTimer.get(callback);
        if (scoresTimer) {
            scoresTimer.stop();
            this.detectorCallbackToHandler.delete(callback);
        }
    }
    async destroy() {
        for (const handler of this.detectorCallbackToHandler.values())this.realtimeController.realtimeUnsubscribeToAttendeeIdPresence(handler);
        for (const activityTimer of this.detectorCallbackToActivityTimer.values())activityTimer.stop();
        for (const scoresTimer of this.detectorCallbackToScoresTimer.values())scoresTimer.stop();
        this.detectorCallbackToHandler.clear();
        this.detectorCallbackToActivityTimer.clear();
        this.detectorCallbackToScoresTimer.clear();
    }
}
module.exports.default = $a7c579fc3ba2116a$var$DefaultActiveSpeakerDetector;

});

parcelRegister("5ulwq", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $3ff072edede948c1$var$DefaultActiveSpeakerPolicy {
    /** Creates active speaker policy with speakerWeight, cutoffThreshold, silenceThreshold, and takeoverRate.
     *
     * @param speakerWeight
     * The number used to calculate new active speaker score for current attendee.
     * ```js
     * Formula:
     * updatedCurrentAttendeeScore = currentAttendeeExistingScore * speakerWeight + currentReceivedVolume * (1 - speakerWeight)
     * ```
     *
     * @param cutoffThreshold
     * The threshold number compared with updated active speaker score.
     * If the updated active speaker score is less than this threshold value,
     * the updated score is returned as 0, else the updated score is returned.
     *
     * @param silenceThreshold
     * The threshold number compared with current received volume.
     * While calculating the new active speaker score, if the current received
     * volume is less than this threshold value, the current received volume is considered as 0,
     * else 1.
     *
     * @param takeoverRate
     * The number used to calculate other attendee's active speaker score, other than the current attendee.
     * ```js
     * Formula:
     *  updatedOtherAttendeeActiveSpeakerScore = Math.max(
     *    existingOtherAttendeeActiveSpeakerScore - takeoverRate * currentReceivedVolume,
     *    0
     *  );
     * ```
     */ constructor(speakerWeight = 0.9, cutoffThreshold = 0.01, silenceThreshold = 0.2, takeoverRate = 0.2){
        this.speakerWeight = speakerWeight;
        this.cutoffThreshold = cutoffThreshold;
        this.silenceThreshold = silenceThreshold;
        this.takeoverRate = takeoverRate;
        /**
         * The map of attendeeIds to their active speaker score values
         */ this.volumes = {};
    }
    calculateScore(attendeeId, volume, muted) {
        if (muted || volume === null) volume = 0;
        if (!this.volumes.hasOwnProperty(attendeeId)) this.volumes[attendeeId] = 0;
        if (volume > this.silenceThreshold) volume = 1.0;
        else volume = 0.0;
        const score = this.volumes[attendeeId] * this.speakerWeight + volume * (1 - this.speakerWeight);
        this.volumes[attendeeId] = score;
        for(const otherAttendeeId in this.volumes)if (otherAttendeeId !== attendeeId) this.volumes[otherAttendeeId] = Math.max(this.volumes[otherAttendeeId] - this.takeoverRate * volume, 0);
        if (score < this.cutoffThreshold) return 0;
        return score;
    }
    prioritizeVideoSendBandwidthForActiveSpeaker() {
        return true;
    }
}
module.exports.default = $3ff072edede948c1$var$DefaultActiveSpeakerPolicy;

});

parcelRegister("3An1L", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $29c698ade09974ff$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $29c698ade09974ff$var$DefaultBrowserBehavior_1 = $29c698ade09974ff$var$__importDefault((parcelRequire("e2TuV")));

const $29c698ade09974ff$var$AsyncScheduler_1 = $29c698ade09974ff$var$__importDefault((parcelRequire("4mLYP")));
class $29c698ade09974ff$var$DefaultAudioMixController {
    constructor(logger){
        this.logger = logger;
        this.audioDevice = null;
        this.audioElement = null;
        this.audioStream = null;
        this.browserBehavior = new $29c698ade09974ff$var$DefaultBrowserBehavior_1.default();
        this.observers = new Set();
    }
    async bindAudioElement(element) {
        if (!element) throw new Error(`Cannot bind audio element: ${element}`);
        this.audioElement = element;
        this.audioElement.autoplay = true;
        return this.bindAudioMix();
    }
    unbindAudioElement() {
        if (!this.audioElement) return;
        this.audioElement.srcObject = null;
        this.audioElement = null;
        this.forEachObserver((observer)=>{
            if (this.audioStream) observer.meetingAudioStreamBecameInactive(this.audioStream);
        });
    }
    async bindAudioStream(stream) {
        if (!stream) return;
        this.audioStream = stream;
        try {
            await this.bindAudioMix();
        } catch (error) {
            /* istanbul ignore else */ if (this.logger) this.logger.warn(`Failed to bind audio stream: ${error}`);
        }
    }
    async bindAudioDevice(device) {
        /**
         * Throw error if browser doesn't even support setSinkId
         * Read more: https://caniuse.com/?search=setSinkId
         */ if (device && !this.browserBehavior.supportsSetSinkId()) throw new Error('Cannot select audio output device. This browser does not support setSinkId.');
        // Always set device -- we might be setting it back to `null` to reselect
        // the default, and even in that case we need to call `bindAudioMix` in
        // order to update the sink ID to the empty string.
        this.audioDevice = device;
        return this.bindAudioMix();
    }
    forEachObserver(observerFunc) {
        for (const observer of this.observers)$29c698ade09974ff$var$AsyncScheduler_1.default.nextTick(()=>{
            observerFunc(observer);
        });
    }
    async bindAudioMix() {
        var _a, _b;
        if (!this.audioElement) return;
        const previousStream = this.audioElement.srcObject;
        if (this.audioStream) this.audioElement.srcObject = this.audioStream;
        if (previousStream !== this.audioStream) this.forEachObserver((observer)=>{
            if (previousStream) observer.meetingAudioStreamBecameInactive(previousStream);
            if (this.audioStream) observer.meetingAudioStreamBecameActive(this.audioStream);
        });
        // In usual operation, the output device is undefined, and so is the element
        // sink ID. In this case, don't throw an error -- we're being called as a side
        // effect of just binding the audio element, not choosing an output device.
        const shouldSetSinkId = ((_a = this.audioDevice) === null || _a === void 0 ? void 0 : _a.deviceId) !== this.audioElement.sinkId;
        if (shouldSetSinkId && typeof this.audioElement.sinkId === 'undefined') throw new Error('Cannot select audio output device. This browser does not support setSinkId.');
        const newSinkId = this.audioDevice ? this.audioDevice.deviceId : '';
        const oldSinkId = this.audioElement.sinkId;
        if (newSinkId === oldSinkId) return;
        // Take the existing stream and temporarily unbind it while we change
        // the sink ID.
        const existingAudioElement = this.audioElement;
        const existingStream = this.audioStream;
        if (this.browserBehavior.hasChromiumWebRTC()) existingAudioElement.srcObject = null;
        if (shouldSetSinkId) try {
            await existingAudioElement.setSinkId(newSinkId);
        } catch (error) {
            (_b = this.logger) === null || _b === void 0 || _b.error(`Failed to set sinkId for audio element: ${error}`);
            throw error;
        }
        if (this.browserBehavior.hasChromiumWebRTC()) existingAudioElement.srcObject = existingStream;
    }
    async getCurrentMeetingAudioStream() {
        return this.audioStream;
    }
    async addAudioMixObserver(observer) {
        this.observers.add(observer);
    }
    async removeAudioMixObserver(observer) {
        this.observers.delete(observer);
    }
    async audioOutputDidChange(device) {
        this.logger.info('Receive an audio output change event');
        return this.bindAudioDevice(device);
    }
}
module.exports.default = $29c698ade09974ff$var$DefaultAudioMixController;

});

parcelRegister("cJkH6", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $9449bd6d0250362d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9449bd6d0250362d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9449bd6d0250362d$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $9449bd6d0250362d$var$__createBinding(result, mod, k[i]);
        }
        $9449bd6d0250362d$var$__setModuleDefault(result, mod);
        return result;
    };
}();
var $9449bd6d0250362d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $9449bd6d0250362d$var$DefaultActiveSpeakerDetector_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("ep2G0")));

const $9449bd6d0250362d$var$DefaultAudioMixController_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("3An1L")));

const $9449bd6d0250362d$var$AudioProfile_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("as61y")));

const $9449bd6d0250362d$var$DefaultBrowserBehavior_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("e2TuV")));

const $9449bd6d0250362d$var$ConnectionHealthData_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("5TTTN")));

const $9449bd6d0250362d$var$SignalingAndMetricsConnectionMonitor_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("jUS1b")));

const $9449bd6d0250362d$var$VideoQualitySettings_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("3C9sO")));

var $byDbS = parcelRequire("byDbS");

const $9449bd6d0250362d$var$MeetingSessionStatus_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("jbMe2")));

const $9449bd6d0250362d$var$MeetingSessionStatusCode_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("9zYoz")));

const $9449bd6d0250362d$var$MeetingSessionVideoAvailability_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("98lxz")));

const $9449bd6d0250362d$var$MeetingSessionTimingManager_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("7yFRY")));

const $9449bd6d0250362d$var$DefaultModality_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("4Zce1")));

const $9449bd6d0250362d$var$DefaultPingPong_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("1IGkK")));

const $9449bd6d0250362d$var$DefaultRealtimeController_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("epAu8")));

const $9449bd6d0250362d$var$AsyncScheduler_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("4mLYP")));

const $9449bd6d0250362d$var$VideoCodecCapability_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("4C1Yl")));

const $9449bd6d0250362d$var$DefaultSessionStateController_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("3MoWE")));

const $9449bd6d0250362d$var$SessionStateControllerAction_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("k20WH")));

const $9449bd6d0250362d$var$SessionStateControllerState_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("hhMm7")));

const $9449bd6d0250362d$var$SessionStateControllerTransitionResult_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("jl8zM")));

const $9449bd6d0250362d$var$DefaultSignalingClient_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("hBJoS")));

const $9449bd6d0250362d$var$ServerSideNetworkAdaption_1 = $9449bd6d0250362d$var$__importStar((parcelRequire("bRvcN")));

const $9449bd6d0250362d$var$SignalingClientEventType_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("1lA8I")));

const $9449bd6d0250362d$var$SignalingClientVideoSubscriptionConfiguration_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("ei9ii")));

var $4huDn = parcelRequire("4huDn");

const $9449bd6d0250362d$var$StatsCollector_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("7r1KG")));

const $9449bd6d0250362d$var$AttachMediaInputTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("4u2O2")));

const $9449bd6d0250362d$var$CleanRestartedSessionTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("9zRCJ")));

const $9449bd6d0250362d$var$CleanStoppedSessionTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("8uHHj")));

const $9449bd6d0250362d$var$CreatePeerConnectionTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("gijOb")));

const $9449bd6d0250362d$var$CreateSDPTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("h2Cf2")));

const $9449bd6d0250362d$var$FinishGatheringICECandidatesTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("f5dpO")));

const $9449bd6d0250362d$var$JoinAndReceiveIndexTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("7m5jF")));

const $9449bd6d0250362d$var$LeaveAndReceiveLeaveAckTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("boLjf")));

const $9449bd6d0250362d$var$ListenForVolumeIndicatorsTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("lvAt6")));

const $9449bd6d0250362d$var$MonitorTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("fpAHb")));

const $9449bd6d0250362d$var$OpenSignalingConnectionTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("agKJo")));

const $9449bd6d0250362d$var$ParallelGroupTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("aaIQX")));

const $9449bd6d0250362d$var$PromoteToPrimaryMeetingTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("ik076")));

const $9449bd6d0250362d$var$ReceiveAudioInputTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("4Q8vW")));

const $9449bd6d0250362d$var$ReceiveRemoteVideoPauseResumeTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("1Bypi")));

const $9449bd6d0250362d$var$ReceiveVideoInputTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("e991n")));

const $9449bd6d0250362d$var$ReceiveVideoStreamIndexTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("eBlvb")));

const $9449bd6d0250362d$var$SendAndReceiveDataMessagesTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("iOlwL")));

const $9449bd6d0250362d$var$SerialGroupTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("7gEAZ")));

const $9449bd6d0250362d$var$SetLocalDescriptionTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("bDOog")));

const $9449bd6d0250362d$var$SetRemoteDescriptionTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("1k1g9")));

const $9449bd6d0250362d$var$StartEncodedTransformWorkerTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("34pQj")));

const $9449bd6d0250362d$var$SubscribeAndReceiveSubscribeAckTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("lVbsX")));

const $9449bd6d0250362d$var$TimeoutTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("aiqTT")));

const $9449bd6d0250362d$var$WaitForAttendeePresenceTask_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("hVjEt")));

const $9449bd6d0250362d$var$DefaultTransceiverController_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("itul0")));

const $9449bd6d0250362d$var$SimulcastContentShareTransceiverController_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("5IW3c")));

const $9449bd6d0250362d$var$SimulcastTransceiverController_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("hl0rE")));

const $9449bd6d0250362d$var$VideoOnlyTransceiverController_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("787PM")));

var $jfpqH = parcelRequire("jfpqH");

const $9449bd6d0250362d$var$DefaultVideoCaptureAndEncodeParameter_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("68tZD")));

const $9449bd6d0250362d$var$AllHighestVideoBandwidthPolicy_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("loTax")));

var $3orkO = parcelRequire("3orkO");

const $9449bd6d0250362d$var$VideoPriorityBasedPolicy_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("i3DJs")));

const $9449bd6d0250362d$var$DefaultVideoStreamIdSet_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("gVZQM")));

const $9449bd6d0250362d$var$DefaultVideoStreamIndex_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("a9cGZ")));

const $9449bd6d0250362d$var$SimulcastVideoStreamIndex_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("h4kXy")));

const $9449bd6d0250362d$var$DefaultVideoTileController_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("1dk1T")));

const $9449bd6d0250362d$var$DefaultVideoTileFactory_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("8tr2c")));

const $9449bd6d0250362d$var$DefaultSimulcastUplinkPolicy_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("gqzKG")));

const $9449bd6d0250362d$var$NScaleVideoUplinkBandwidthPolicy_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("lHgMc")));

const $9449bd6d0250362d$var$DefaultVolumeIndicatorAdapter_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("gfunK")));

const $9449bd6d0250362d$var$AudioVideoControllerState_1 = $9449bd6d0250362d$var$__importDefault((parcelRequire("lpXGX")));
class $9449bd6d0250362d$var$DefaultAudioVideoController {
    constructor(configuration, logger, webSocketAdapter, mediaStreamBroker, reconnectController, eventController, encodedTransformWorkerManager){
        this._audioProfile = new $9449bd6d0250362d$var$AudioProfile_1.default();
        this._timingResolutionObserver = null;
        this.connectionHealthData = new $9449bd6d0250362d$var$ConnectionHealthData_1.default();
        this.observerQueue = new Set();
        this.meetingSessionContext = new $9449bd6d0250362d$var$AudioVideoControllerState_1.default();
        this.enableSimulcast = false;
        this.enableSVC = false;
        this.useUpdateTransceiverControllerForUplink = false;
        this.startAudioVideoTimestamp = 0;
        this.mayNeedRenegotiationForSimulcastLayerChange = false;
        // Stored solely to trigger demotion callback on disconnection (expected behavior).
        //
        // We otherwise intentionally do not use this for any other behavior to avoid the complexity
        // of the added state.
        this.promotedToPrimaryMeeting = false;
        this.hasGetRTCPeerConnectionStatsDeprecationMessageBeenSent = false;
        // `connectWithPromises`, and `actionUpdateWithRenegotiation` all
        // contains a significant portion of asynchronous tasks, so we need to explicitly defer
        // any task operation which may be performed on the event queue that may modify
        // mutable state in `MeetingSessionContext`, as this mutable state needs to be consistent over the course of the update.
        //
        // Currently this includes
        // * `ReceiveVideoStreamIndexTask` which updates `videosToReceive` and `videoCaptureAndEncodeParameter`
        // * `MonitorTask` which updates `videosToReceive`
        this.receiveIndexTask = undefined;
        this.monitorTask = undefined;
        this.receiveRemotePauseResumeTask = undefined;
        this.destroyed = false;
        this._logger = logger;
        this.sessionStateController = new $9449bd6d0250362d$var$DefaultSessionStateController_1.default(this._logger);
        this._configuration = configuration;
        this._encodedTransformWorkerManager = encodedTransformWorkerManager;
        this._meetingSessionTimingManager = new $9449bd6d0250362d$var$MeetingSessionTimingManager_1.default(logger);
        this._webSocketAdapter = webSocketAdapter;
        this._realtimeController = new $9449bd6d0250362d$var$DefaultRealtimeController_1.default(mediaStreamBroker);
        this._realtimeController.realtimeSetLocalAttendeeId(configuration.credentials.attendeeId, configuration.credentials.externalUserId);
        this._mediaStreamBroker = mediaStreamBroker;
        this._reconnectController = reconnectController;
        this._videoTileController = new $9449bd6d0250362d$var$DefaultVideoTileController_1.default(new $9449bd6d0250362d$var$DefaultVideoTileFactory_1.default(), this, this._logger);
        this._audioMixController = new $9449bd6d0250362d$var$DefaultAudioMixController_1.default(this._logger);
        this._mediaStreamBroker.addMediaStreamBrokerObserver(this._audioMixController);
        this.meetingSessionContext.logger = this._logger;
        this._eventController = eventController;
        if (!this.configuration.enableSimulcastForUnifiedPlanChromiumBasedBrowsers) {
            // We do not set default video codec for simulcast until simulcast support for VP9/AV1 is added
            const isContentShare = new $9449bd6d0250362d$var$DefaultModality_1.default(this.configuration.credentials.attendeeId).hasModality($9449bd6d0250362d$var$DefaultModality_1.default.MODALITY_CONTENT);
            if (isContentShare && new $9449bd6d0250362d$var$DefaultBrowserBehavior_1.default().hasChromiumWebRTC()) this.videoSendCodecPreferences = [
                $9449bd6d0250362d$var$VideoCodecCapability_1.default.av1Main(),
                $9449bd6d0250362d$var$VideoCodecCapability_1.default.vp9Profile0(),
                $9449bd6d0250362d$var$VideoCodecCapability_1.default.h264ConstrainedBaselineProfile(),
                $9449bd6d0250362d$var$VideoCodecCapability_1.default.vp8()
            ];
            else this.videoSendCodecPreferences = [
                $9449bd6d0250362d$var$VideoCodecCapability_1.default.vp9Profile0(),
                $9449bd6d0250362d$var$VideoCodecCapability_1.default.h264ConstrainedBaselineProfile(),
                $9449bd6d0250362d$var$VideoCodecCapability_1.default.vp8()
            ];
        }
    }
    async destroy() {
        var _a;
        this.observerQueue.clear();
        this._mediaStreamBroker.removeMediaStreamBrokerObserver(this._audioMixController);
        this._meetingSessionTimingManager.removeObserver(this);
        this._meetingSessionTimingManager.destroy();
        (_a = this._encodedTransformWorkerManager) === null || _a === void 0 || _a.removeObserver(this);
        this.destroyed = true;
    }
    get configuration() {
        return this._configuration;
    }
    get realtimeController() {
        return this._realtimeController;
    }
    get activeSpeakerDetector() {
        // Lazy init.
        if (!this._activeSpeakerDetector) this._activeSpeakerDetector = new $9449bd6d0250362d$var$DefaultActiveSpeakerDetector_1.default(this._realtimeController, this._configuration.credentials.attendeeId, this.handleHasBandwidthPriority.bind(this));
        return this._activeSpeakerDetector;
    }
    get videoTileController() {
        return this._videoTileController;
    }
    get audioMixController() {
        return this._audioMixController;
    }
    get logger() {
        return this._logger;
    }
    get rtcPeerConnection() {
        return this.meetingSessionContext && this.meetingSessionContext.peer || null;
    }
    get mediaStreamBroker() {
        return this._mediaStreamBroker;
    }
    get eventController() {
        return this._eventController;
    }
    /**
     * This API will be deprecated in favor of `ClientMetricReport.getRTCStatsReport()`.
     *
     * It makes an additional call to the `getStats` API and therefore may cause slight performance degradation.
     *
     * Please subscribe to `metricsDidReceive(clientMetricReport: ClientMetricReport)` callback,
     * and get the raw `RTCStatsReport` via `clientMetricReport.getRTCStatsReport()`.
     */ getRTCPeerConnectionStats(selector) {
        /* istanbul ignore else */ if (!this.hasGetRTCPeerConnectionStatsDeprecationMessageBeenSent) {
            this.logger.warn('The `getRTCPeerConnectionStats()` is on its way to be deprecated. It makes an additional call to the `getStats` API and therefore may cause slight performance degradation. Please use the new API `clientMetricReport.getRTCStatsReport()` returned by `metricsDidReceive(clientMetricReport)` callback instead.');
            this.hasGetRTCPeerConnectionStatsDeprecationMessageBeenSent = true;
        }
        if (!this.rtcPeerConnection) return null;
        return this.rtcPeerConnection.getStats(selector);
    }
    setAudioProfile(audioProfile) {
        this._audioProfile = audioProfile;
    }
    addObserver(observer) {
        this.logger.info('adding meeting observer');
        this.observerQueue.add(observer);
    }
    removeObserver(observer) {
        this.logger.info('removing meeting observer');
        this.observerQueue.delete(observer);
    }
    forEachObserver(observerFunc) {
        for (const observer of this.observerQueue)$9449bd6d0250362d$var$AsyncScheduler_1.default.nextTick(()=>{
            if (this.observerQueue.has(observer)) observerFunc(observer);
        });
    }
    initSignalingClient() {
        var _a;
        this.connectionHealthData.reset();
        if (this.meetingSessionContext.signalingClient) return;
        this.meetingSessionContext = new $9449bd6d0250362d$var$AudioVideoControllerState_1.default();
        this.meetingSessionContext.logger = this.logger;
        this.meetingSessionContext.eventController = this.eventController;
        this.meetingSessionContext.browserBehavior = new $9449bd6d0250362d$var$DefaultBrowserBehavior_1.default();
        this.meetingSessionContext.videoSendCodecPreferences = this.videoSendCodecPreferences;
        this.meetingSessionContext.audioProfile = this._audioProfile;
        this.meetingSessionContext.encodedTransformWorkerManager = this._encodedTransformWorkerManager;
        (_a = this._encodedTransformWorkerManager) === null || _a === void 0 || _a.addObserver(this);
        this.meetingSessionContext.meetingSessionConfiguration = this.configuration;
        this.meetingSessionContext.signalingClient = new $9449bd6d0250362d$var$DefaultSignalingClient_1.default(this._webSocketAdapter, this.logger, this._meetingSessionTimingManager);
        this._meetingSessionTimingManager.reset();
        this.meetingSessionContext.meetingSessionTimingManager = this._meetingSessionTimingManager;
        this._meetingSessionTimingManager.addObserver(this);
    }
    uninstallPreStartObserver() {
        this.meetingSessionContext.signalingClient.removeObserver(this.preStartObserver);
        this.preStartObserver = undefined;
    }
    prestart() {
        this.logger.info('Pre-connecting signaling connection.');
        return this.createOrReuseSignalingTask().run().then(()=>{
            const handleClosed = async ()=>{
                this.logger.info('Early connection closed; discarding signaling task.');
                this.signalingTask = undefined;
                this.uninstallPreStartObserver();
            };
            this.preStartObserver = {
                handleSignalingClientEvent (event) {
                    if (event.type === $9449bd6d0250362d$var$SignalingClientEventType_1.default.WebSocketClosed) handleClosed();
                }
            };
            this.meetingSessionContext.signalingClient.registerObserver(this.preStartObserver);
        }).catch((e)=>{
            this.logger.error(`Signaling task pre-start failed: ${e}`);
            // Clean up just in case a subsequent attempt will succeed.
            this.signalingTask = undefined;
        });
    }
    start(options) {
        this.startReturningPromise(options).then(()=>{
            this.logger.info('start completed');
        })// Just-in-case error handling.
        .catch(/* istanbul ignore next */ (e)=>{
            this.logger.error(`start failed: ${e}`);
        });
    }
    // This is public (albeit marked internal) for tests only.
    /* @internal */ startReturningPromise(options) {
        if ((options === null || options === void 0 ? void 0 : options.signalingOnly) === true) return this.prestart();
        // For side-effects: lazy getter.
        this.activeSpeakerDetector;
        return new Promise((resolve, reject)=>{
            this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.Connect, ()=>{
                this.actionConnect(false).then(resolve).catch(reject);
            });
        });
    }
    // @ts-ignore
    connectWithPromises(needsToWaitForAttendeePresence) {
        const context = this.meetingSessionContext;
        // Syntactic sugar.
        const timeout = (timeoutMs, task)=>{
            return new $9449bd6d0250362d$var$TimeoutTask_1.default(this.logger, task, timeoutMs);
        };
        // First layer.
        this.monitorTask = new $9449bd6d0250362d$var$MonitorTask_1.default(context, this.configuration.connectionHealthPolicyConfiguration, this.connectionHealthData);
        const monitor = this.monitorTask.once();
        // Second layer.
        const receiveAudioInput = new $9449bd6d0250362d$var$ReceiveAudioInputTask_1.default(context).once();
        const startEncodedTransformWorker = new $9449bd6d0250362d$var$StartEncodedTransformWorkerTask_1.default(context).once();
        this.receiveIndexTask = new $9449bd6d0250362d$var$ReceiveVideoStreamIndexTask_1.default(context);
        // See declaration (unpaused in actionFinishConnecting)
        this.monitorTask.pauseResubscribeCheck();
        this.receiveIndexTask.pauseIngestion();
        const signaling = new $9449bd6d0250362d$var$SerialGroupTask_1.default(this.logger, 'Signaling', [
            // If pre-connecting, this will be an existing task that has already been run.
            this.createOrReuseSignalingTask(),
            new $9449bd6d0250362d$var$ListenForVolumeIndicatorsTask_1.default(context),
            new $9449bd6d0250362d$var$SendAndReceiveDataMessagesTask_1.default(context),
            new $9449bd6d0250362d$var$JoinAndReceiveIndexTask_1.default(context),
            this.receiveIndexTask
        ]).once();
        // Third layer.
        const createPeerConnection = new $9449bd6d0250362d$var$CreatePeerConnectionTask_1.default(context).once(signaling, startEncodedTransformWorker);
        const attachMediaInput = new $9449bd6d0250362d$var$AttachMediaInputTask_1.default(context).once(createPeerConnection, receiveAudioInput);
        // Mostly serial section -- kept as promises to allow for finer-grained breakdown.
        const createSDP = new $9449bd6d0250362d$var$CreateSDPTask_1.default(context).once(attachMediaInput);
        const setLocalDescription = new $9449bd6d0250362d$var$SetLocalDescriptionTask_1.default(context).once(createSDP);
        const ice = new $9449bd6d0250362d$var$FinishGatheringICECandidatesTask_1.default(context).once(setLocalDescription);
        const subscribeAck = new $9449bd6d0250362d$var$SubscribeAndReceiveSubscribeAckTask_1.default(context).once(ice);
        this.receiveRemotePauseResumeTask = new $9449bd6d0250362d$var$ReceiveRemoteVideoPauseResumeTask_1.default(context);
        this.receiveRemotePauseResumeTask.once(subscribeAck);
        // The ending is a delicate time: we need the connection as a whole to have a timeout,
        // and for the attendee presence timer to not start ticking until after the subscribe/ack.
        return new $9449bd6d0250362d$var$SerialGroupTask_1.default(this.logger, this.wrapTaskName('AudioVideoStart'), [
            monitor,
            timeout(this.configuration.connectionTimeoutMs, new $9449bd6d0250362d$var$SerialGroupTask_1.default(this.logger, 'Peer', [
                // The order of these two matters. If canceled, the first one that's still running
                // will contribute any special rejection, and we don't want that to be "attendee not found"!
                subscribeAck,
                this.receiveRemotePauseResumeTask,
                needsToWaitForAttendeePresence ? new $9449bd6d0250362d$var$TimeoutTask_1.default(this.logger, new $9449bd6d0250362d$var$ParallelGroupTask_1.default(this.logger, 'FinalizeConnection', [
                    new $9449bd6d0250362d$var$WaitForAttendeePresenceTask_1.default(context),
                    new $9449bd6d0250362d$var$SetRemoteDescriptionTask_1.default(context)
                ]), this.meetingSessionContext.meetingSessionConfiguration.attendeePresenceTimeoutMs) : /* istanbul ignore next */ new $9449bd6d0250362d$var$SetRemoteDescriptionTask_1.default(context)
            ]))
        ]);
    }
    async actionConnect(reconnecting) {
        var _a;
        this.initSignalingClient();
        // We no longer need to watch for the early connection dropping; we're back where
        // we otherwise would have been had we not pre-started.
        this.uninstallPreStartObserver();
        // Update browser behavior with high entropy values for more accurate device/OS info
        if (this.meetingSessionContext.browserBehavior) await this.meetingSessionContext.browserBehavior.updateWithHighEntropyValues(true);
        // Note that some of the assignments in this function exist to clean up previous connections.
        // All future 'clean up' assignments should go in `AudioVideoControllerState.resetConnectionSpecificState`
        // for consolidation purposes.
        this.meetingSessionContext.mediaStreamBroker = this._mediaStreamBroker;
        this.meetingSessionContext.realtimeController = this._realtimeController;
        this.meetingSessionContext.audioMixController = this._audioMixController;
        this.meetingSessionContext.audioVideoController = this;
        this.enableSimulcast = this.configuration.enableSimulcastForUnifiedPlanChromiumBasedBrowsers && new $9449bd6d0250362d$var$DefaultBrowserBehavior_1.default().hasChromiumWebRTC();
        if (this.enableSimulcast && this.configuration.enableSVC) this.logger.warn('SVC cannot be enabled at the same time as simulcast. Disabling SVC, using simulcast.');
        this.enableSVC = !this.enableSimulcast && this.configuration.enableSVC && new $9449bd6d0250362d$var$DefaultBrowserBehavior_1.default().supportsScalableVideoCoding();
        const useAudioConnection = !!this.configuration.urls.audioHostURL;
        this._meetingSessionTimingManager.onStart();
        if (useAudioConnection) {
            // Audio always negotiates sendrecv so local and remote are added together
            this._meetingSessionTimingManager.onLocalAudioAdded();
            this._meetingSessionTimingManager.onRemoteAudioAdded();
        }
        if (!useAudioConnection) {
            this.logger.info(`Using video only transceiver controller`);
            this.meetingSessionContext.transceiverController = new $9449bd6d0250362d$var$VideoOnlyTransceiverController_1.default(this.logger, this.meetingSessionContext.browserBehavior, this.meetingSessionContext, this._encodedTransformWorkerManager);
        } else if (this.enableSimulcast) {
            this.logger.info(`Using transceiver controller with simulcast support`);
            if (new $9449bd6d0250362d$var$DefaultModality_1.default(this.configuration.credentials.attendeeId).hasModality($9449bd6d0250362d$var$DefaultModality_1.default.MODALITY_CONTENT)) this.meetingSessionContext.transceiverController = new $9449bd6d0250362d$var$SimulcastContentShareTransceiverController_1.default(this.logger, this.meetingSessionContext.browserBehavior, this.meetingSessionContext, this._encodedTransformWorkerManager);
            else this.meetingSessionContext.transceiverController = new $9449bd6d0250362d$var$SimulcastTransceiverController_1.default(this.logger, this.meetingSessionContext.browserBehavior, this.meetingSessionContext, this._encodedTransformWorkerManager);
        } else {
            this.logger.info(`Using default transceiver controller`);
            this.meetingSessionContext.transceiverController = new $9449bd6d0250362d$var$DefaultTransceiverController_1.default(this.logger, this.meetingSessionContext.browserBehavior, this.meetingSessionContext, this._encodedTransformWorkerManager);
        }
        this.meetingSessionContext.volumeIndicatorAdapter = new $9449bd6d0250362d$var$DefaultVolumeIndicatorAdapter_1.default(this.logger, this._realtimeController, $9449bd6d0250362d$var$DefaultAudioVideoController.MIN_VOLUME_DECIBELS, $9449bd6d0250362d$var$DefaultAudioVideoController.MAX_VOLUME_DECIBELS, this.configuration.credentials.attendeeId);
        this.meetingSessionContext.videoTileController = this._videoTileController;
        this.meetingSessionContext.videoDownlinkBandwidthPolicy = this.configuration.videoDownlinkBandwidthPolicy;
        this.meetingSessionContext.videoUplinkBandwidthPolicy = this.configuration.videoUplinkBandwidthPolicy;
        this.meetingSessionContext.enableSimulcast = this.enableSimulcast;
        this.meetingSessionContext.enableSVC = this.enableSVC;
        if (this.enableSimulcast) {
            let simulcastPolicy = this.meetingSessionContext.videoUplinkBandwidthPolicy;
            if (!simulcastPolicy) {
                simulcastPolicy = new $9449bd6d0250362d$var$DefaultSimulcastUplinkPolicy_1.default(this.configuration.credentials.attendeeId, this.meetingSessionContext.logger);
                this.meetingSessionContext.videoUplinkBandwidthPolicy = simulcastPolicy;
            }
            simulcastPolicy.addObserver(this);
            this.meetingSessionContext.videoStreamIndex = new $9449bd6d0250362d$var$SimulcastVideoStreamIndex_1.default(this.logger);
        } else {
            this.meetingSessionContext.enableSimulcast = false;
            this.meetingSessionContext.videoStreamIndex = new $9449bd6d0250362d$var$DefaultVideoStreamIndex_1.default(this.logger);
            if (!this.meetingSessionContext.videoUplinkBandwidthPolicy) {
                this.meetingSessionContext.videoUplinkBandwidthPolicy = new $9449bd6d0250362d$var$NScaleVideoUplinkBandwidthPolicy_1.default(this.configuration.credentials.attendeeId, !this.meetingSessionContext.browserBehavior.disableResolutionScaleDown(), this.meetingSessionContext.logger, this.meetingSessionContext.browserBehavior);
                this.meetingSessionContext.videoUplinkBandwidthPolicy.setSVCEnabled(this.enableSVC);
            }
            if (this.meetingSessionContext.videoUplinkBandwidthPolicy.setTransceiverController && this.meetingSessionContext.videoUplinkBandwidthPolicy.updateTransceiverController) {
                this.useUpdateTransceiverControllerForUplink = true;
                this.meetingSessionContext.videoUplinkBandwidthPolicy.setTransceiverController(this.meetingSessionContext.transceiverController);
            }
            this.meetingSessionContext.audioProfile = this._audioProfile;
        }
        if (!this.meetingSessionContext.videoDownlinkBandwidthPolicy) this.meetingSessionContext.videoDownlinkBandwidthPolicy = this.enableSVC || this.enableSimulcast ? new $9449bd6d0250362d$var$VideoPriorityBasedPolicy_1.default(this.meetingSessionContext.logger) : new $9449bd6d0250362d$var$AllHighestVideoBandwidthPolicy_1.default(this.configuration.credentials.attendeeId);
        if (new $9449bd6d0250362d$var$DefaultModality_1.default(this.configuration.credentials.attendeeId).hasModality($9449bd6d0250362d$var$DefaultModality_1.default.MODALITY_CONTENT)) {
            const enableUhdContent = this.configuration.meetingFeatures.contentMaxResolution === $9449bd6d0250362d$var$VideoQualitySettings_1.default.VideoResolutionUHD;
            if (enableUhdContent) // Increase default bandwidth for content share since this is not yet configuration that can be exposed
            // without using simulcast
            this.setVideoMaxBandwidthKbps(2500);
            this.meetingSessionContext.videoUplinkBandwidthPolicy.setHighResolutionFeatureEnabled(enableUhdContent);
        } else {
            const enableFhdVideo = this.configuration.meetingFeatures.videoMaxResolution === $9449bd6d0250362d$var$VideoQualitySettings_1.default.VideoResolutionFHD;
            this.meetingSessionContext.videoUplinkBandwidthPolicy.setHighResolutionFeatureEnabled(enableFhdVideo);
        }
        if (this.meetingSessionContext.videoUplinkBandwidthPolicy && this.maxUplinkBandwidthKbps) this.meetingSessionContext.videoUplinkBandwidthPolicy.setIdealMaxBandwidthKbps(this.maxUplinkBandwidthKbps);
        if (this.meetingSessionContext.videoDownlinkBandwidthPolicy.bindToTileController) this.meetingSessionContext.videoDownlinkBandwidthPolicy.bindToTileController(this._videoTileController);
        if (this.meetingSessionContext.videoDownlinkBandwidthPolicy.setWantsResubscribeObserver) this.meetingSessionContext.videoDownlinkBandwidthPolicy.setWantsResubscribeObserver(()=>this.update({
                needsRenegotiation: false
            }));
        this.meetingSessionContext.lastKnownVideoAvailability = new $9449bd6d0250362d$var$MeetingSessionVideoAvailability_1.default();
        this.meetingSessionContext.videoCaptureAndEncodeParameter = new $9449bd6d0250362d$var$DefaultVideoCaptureAndEncodeParameter_1.default(0, 0, 0, 0, false);
        this.meetingSessionContext.videosToReceive = new $9449bd6d0250362d$var$DefaultVideoStreamIdSet_1.default();
        this.meetingSessionContext.videosPaused = new $9449bd6d0250362d$var$DefaultVideoStreamIdSet_1.default();
        this.meetingSessionContext.statsCollector = new $9449bd6d0250362d$var$StatsCollector_1.default(this, this.logger);
        this.meetingSessionContext.connectionMonitor = new $9449bd6d0250362d$var$SignalingAndMetricsConnectionMonitor_1.default(this, this._realtimeController, this.connectionHealthData, new $9449bd6d0250362d$var$DefaultPingPong_1.default(this.meetingSessionContext.signalingClient, $9449bd6d0250362d$var$DefaultAudioVideoController.PING_PONG_INTERVAL_MS, this.logger), this.meetingSessionContext.statsCollector);
        this.meetingSessionContext.reconnectController = this._reconnectController;
        this.meetingSessionContext.videoDeviceInformation = {};
        this._videoTileController.registerVideoTileResolutionObserver(this.meetingSessionContext.statsCollector);
        this._timingResolutionObserver = {
            videoTileResolutionDidChange: ()=>{},
            videoTileUnbound: (_attendeeId, groupId)=>{
                if (groupId !== undefined) this._meetingSessionTimingManager.onRemoteVideoUnbound(groupId);
            },
            videoTileBound: (groupId)=>{
                this._meetingSessionTimingManager.onRemoteVideoBound(groupId);
            },
            videoTileFirstFrameDidRender: (groupId, metadata)=>{
                this._meetingSessionTimingManager.onRemoteVideoFirstFrameRendered(groupId, metadata);
            }
        };
        this._videoTileController.registerVideoTileResolutionObserver(this._timingResolutionObserver);
        if (!reconnecting) {
            this.meetingSessionContext.retryCount = 0;
            this._reconnectController.reset();
            this.startAudioVideoTimestamp = Date.now();
            this.forEachObserver((observer)=>{
                $jfpqH.Maybe.of(observer.audioVideoDidStartConnecting).map((f)=>f.bind(observer)(false));
            });
            (_a = this.eventController) === null || _a === void 0 || _a.publishEvent('meetingStartRequested');
        }
        this.meetingSessionContext.startAudioVideoTimestamp = this.startAudioVideoTimestamp;
        if (this._reconnectController.hasStartedConnectionAttempt()) // This does not reset the reconnect deadline, but declare it's not the first connection.
        this._reconnectController.startedConnectionAttempt(false);
        else this._reconnectController.startedConnectionAttempt(true);
        // No attendee presence event will be triggered if there is no audio connection.
        // Waiting for attendee presence is explicitly executed
        // if `attendeePresenceTimeoutMs` is configured to larger than 0.
        const needsToWaitForAttendeePresence = useAudioConnection && this.meetingSessionContext.meetingSessionConfiguration.attendeePresenceTimeoutMs > 0;
        this.logger.info('Needs to wait for attendee presence? ' + needsToWaitForAttendeePresence);
        const connect = this.connectWithPromises(needsToWaitForAttendeePresence);
        // The rest.
        try {
            await connect.run();
            this.connectionHealthData.setConnectionStartTime();
            const isContentShare = new $9449bd6d0250362d$var$DefaultModality_1.default(this.configuration.credentials.attendeeId).hasModality($9449bd6d0250362d$var$DefaultModality_1.default.MODALITY_CONTENT);
            this.connectionHealthData.setIsContentShare(isContentShare);
            this._mediaStreamBroker.addMediaStreamBrokerObserver(this);
            this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.FinishConnecting, ()=>{
                var _a;
                this.meetingSessionContext.meetingStartDurationMs = Date.now() - this.startAudioVideoTimestamp;
                /* istanbul ignore else */ (_a = this.eventController) === null || _a === void 0 || _a.publishEvent('meetingStartSucceeded', (0, $byDbS.audioVideoEventAttributesFromState)(this.meetingSessionContext));
                this.meetingSessionContext.startTimeMs = Date.now();
                this.actionFinishConnecting();
            });
        } catch (error) {
            this.signalingTask = undefined;
            const status = new $9449bd6d0250362d$var$MeetingSessionStatus_1.default(this.getMeetingStatusCode(error) || $9449bd6d0250362d$var$MeetingSessionStatusCode_1.default.TaskFailed);
            this.logger.info(`Start failed: ${status} due to error ${error}.`);
            // I am not able to successfully reach this state in the test suite with mock
            // websockets -- it always ends up in 'Disconnecting' instead. As such, this
            // has to be marked for Istanbul.
            /* istanbul ignore if */ if (this.sessionStateController.state() === $9449bd6d0250362d$var$SessionStateControllerState_1.default.NotConnected) {
                // There's no point trying to 'disconnect', because we're not connected.
                // The session state controller will bail.
                this.logger.info('Start failed and not connected. Not cleaning up.');
                return;
            }
            this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.Fail, async ()=>{
                await this.actionDisconnect(status, true, error);
                if (!this.handleMeetingSessionStatus(status, error)) this.notifyStop(status, error);
            });
        }
    }
    createOrReuseSignalingTask() {
        if (!this.signalingTask) {
            this.initSignalingClient();
            this.signalingTask = new $9449bd6d0250362d$var$TimeoutTask_1.default(this.logger, new $9449bd6d0250362d$var$OpenSignalingConnectionTask_1.default(this.meetingSessionContext), this.configuration.connectionTimeoutMs).once();
        }
        return this.signalingTask;
    }
    actionFinishConnecting() {
        this.signalingTask = undefined;
        this.meetingSessionContext.videoDuplexMode = $4huDn.SdkStreamServiceType.RX;
        if (!this.meetingSessionContext.enableSimulcast) {
            if (this.useUpdateTransceiverControllerForUplink) this.meetingSessionContext.videoUplinkBandwidthPolicy.updateTransceiverController();
            else this.enforceBandwidthLimitationForSender(this.meetingSessionContext.videoCaptureAndEncodeParameter.encodeBitrates()[0]);
        }
        this.meetingSessionContext.isSessionConnected = true;
        this.forEachObserver((observer)=>{
            $jfpqH.Maybe.of(observer.audioVideoDidStart).map((f)=>f.bind(observer)());
        });
        this._reconnectController.reset();
        // `receiveIndexTask` needs to be resumed first so it can set `remoteStreamDescriptions`
        this.receiveIndexTask.resumeIngestion();
        this.monitorTask.resumeResubscribeCheck();
    }
    /* @internal */ stopReturningPromise() {
        var _a;
        // We need to ensure this disables reconnection before any other steps are taken,
        // in case something during close is triggering a reconnection (e.g. websocket
        // close)
        this._reconnectController.disableReconnect();
        // In order to avoid breaking backward compatibility, when only the
        // signaling connection is established we appear to not be connected.
        // We handle this by simply disconnecting the websocket directly.
        if (this.sessionStateController.state() === $9449bd6d0250362d$var$SessionStateControllerState_1.default.NotConnected) {
            // Unfortunately, this does not return a promise.
            (_a = this.meetingSessionContext.signalingClient) === null || _a === void 0 || _a.closeConnection();
            this.cleanUpMediaStreamsAfterStop();
            return Promise.resolve();
        }
        /*
          Stops the current audio video meeting session.
          The stop method execution is deferred and executed after
          the current reconnection attempt completes.
          It disables any further reconnection attempts.
          Upon completion, AudioVideoObserver's `audioVideoDidStop`
          callback function is called with `MeetingSessionStatusCode.Left`.
        */ return new Promise((resolve, reject)=>{
            this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.Disconnect, ()=>{
                this.logger.info('attendee left meeting, session will not be reconnected');
                this.actionDisconnect(new $9449bd6d0250362d$var$MeetingSessionStatus_1.default($9449bd6d0250362d$var$MeetingSessionStatusCode_1.default.Left), false, null).then(resolve).catch(reject);
            });
        });
    }
    stop() {
        this.stopReturningPromise();
    }
    async actionDisconnect(status, reconnecting, error) {
        var _a;
        try {
            await new $9449bd6d0250362d$var$SerialGroupTask_1.default(this.logger, this.wrapTaskName('AudioVideoStop'), [
                new $9449bd6d0250362d$var$TimeoutTask_1.default(this.logger, new $9449bd6d0250362d$var$LeaveAndReceiveLeaveAckTask_1.default(this.meetingSessionContext), this.configuration.connectionTimeoutMs)
            ]).run();
        } catch (stopError) {
            this.logger.info('fail to stop');
        }
        try {
            const subtasks = [
                new $9449bd6d0250362d$var$TimeoutTask_1.default(this.logger, new $9449bd6d0250362d$var$CleanStoppedSessionTask_1.default(this.meetingSessionContext), this.configuration.connectionTimeoutMs)
            ];
            this.cleanUpMediaStreamsAfterStop();
            await new $9449bd6d0250362d$var$SerialGroupTask_1.default(this.logger, this.wrapTaskName('AudioVideoClean'), subtasks).run();
        } catch (cleanError) {
            /* istanbul ignore next */ this.logger.info('fail to clean');
        }
        await ((_a = this._encodedTransformWorkerManager) === null || _a === void 0 ? void 0 : _a.stop());
        this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.FinishDisconnecting, ()=>{
            if (!reconnecting) this.notifyStop(status, error);
        });
        this._videoTileController.removeVideoTileResolutionObserver(this.meetingSessionContext.statsCollector);
        if (this._timingResolutionObserver) {
            this._videoTileController.removeVideoTileResolutionObserver(this._timingResolutionObserver);
            this._timingResolutionObserver = null;
        }
    }
    update(options = {
        needsRenegotiation: true
    }) {
        let needsRenegotiation = options.needsRenegotiation;
        // Check in case this function has been called before peer connection is set up
        // since that is necessary to try to update remote videos without the full resubscribe path
        needsRenegotiation || (needsRenegotiation = this.meetingSessionContext.peer === undefined);
        needsRenegotiation || (needsRenegotiation = !this.updateRemoteVideosFromPolicy());
        needsRenegotiation || (needsRenegotiation = !this.updateLocalVideoFromPolicy());
        // `MeetingSessionContext.lastVideosToReceive` needs to be updated regardless
        this.meetingSessionContext.lastVideosToReceive = this.meetingSessionContext.videosToReceive;
        if (!needsRenegotiation) {
            this.logger.info('Update request does not require resubscribe');
            // Call `actionFinishUpdating` to apply the new encoding parameters that may have been set in `updateLocalVideoFromPolicy`.
            this.actionFinishUpdating();
            return true; // Skip the subscribe!
        }
        this.logger.info('Update request requires resubscribe');
        this.updateNumberOfPublishedVideoSources();
        const result = this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.Update, ()=>{
            this.actionUpdateWithRenegotiation(true);
        });
        return result === $9449bd6d0250362d$var$SessionStateControllerTransitionResult_1.default.Transitioned || result === $9449bd6d0250362d$var$SessionStateControllerTransitionResult_1.default.DeferredTransition;
    }
    updateNumberOfPublishedVideoSources() {
        const selfAttendeeId = this.configuration.credentials.attendeeId;
        const hasLocalVideo = this._videoTileController.hasStartedLocalVideoTile();
        if (this.meetingSessionContext.videoStreamIndex !== null) {
            const videoCount = this.meetingSessionContext.videoStreamIndex.numberOfVideoPublishingParticipantsExcludingSelf(selfAttendeeId) + (hasLocalVideo ? 1 : 0);
            this.connectionHealthData.setNumberOfPublishedVideoSources(videoCount);
        }
    }
    // Depending on if using server-side bandwidth probing and if using server-side quality adaption,
    // decide if needs to send necessary updates, and if send through full renegotiaton.
    // It returns true if downlink policy took care of everything and no renegotiation needed.
    updateRemoteVideosFromPolicy() {
        if (this.meetingSessionContext.videoDownlinkBandwidthPolicy && this.meetingSessionContext.videoDownlinkBandwidthPolicy.getVideoPreferences !== undefined && this.meetingSessionContext.videoDownlinkBandwidthPolicy.getServerSideNetworkAdaption !== undefined && !(0, $9449bd6d0250362d$var$ServerSideNetworkAdaption_1.serverSideNetworkAdaptionIsNoneOrDefault)(this.meetingSessionContext.videoDownlinkBandwidthPolicy.getServerSideNetworkAdaption())) {
            // Send up-to-date video preferences to server. This is fine if it includes remote sources/MIDs we need a full renegotiation for (i.e.
            // ones that were added or removed). We will re-include these updates in the subscribe.
            /* istanbul ignore if: Extremely unlikely that `videosToReceive` is null */ if (!this.sendRemoteVideoUpdate()) return false;
            if (this.meetingSessionContext.videoDownlinkBandwidthPolicy.getServerSideNetworkAdaption() === $9449bd6d0250362d$var$ServerSideNetworkAdaption_1.default.BandwidthProbingAndRemoteVideoQualityAdaption) // If using server side remote video quality adaption (i.e. server is picking the encoding to send), we don't need
            // to do anything after sending the update, as long as we are not adding or removing streams, in which case
            // we need to complete a full renegotiation.
            return this.isNotAddingOrRemovingStreams();
        }
        // If using client-side network adaptation, try skipping renegotitaiton if only simulcast stream swicth.
        return this.updateRemoteVideosIfNotAddingOrRemovingStreams();
    }
    // When `ServerSideNetworkAdaption.BandwidthProbingAndRemoteVideoQualityAdaption` has been signalled,
    // trigger server side video quality adaption logic through `SignalingClient.remoteVideoUpdate` and skip full subscribe.
    //
    // This function also tries to use the diff between `this.meetingSessionContext.lastVideosToReceive`
    // and `this.meetingSessionContext.videosToReceive` to determine if update is only simulcast stream switch,
    // which is accomplished through `SignalingClient.remoteVideoUpdate` rather than the full subscribe.
    //
    // It requires the caller to manage `this.meetingSessionContext.lastVideosToReceive`
    // and `this.meetingSessionContext.videosToReceive` so that `this.meetingSessionContext.lastVideosToReceive`
    // contains the stream IDs from either last time a subscribe was set, or last time this function was set.
    //
    // It will return true if successful, if false the caller must fall back to a full renegotiation
    updateRemoteVideosIfNotAddingOrRemovingStreams() {
        const streamChanges = this.detectChangesInVideosToReceive();
        /* istanbul ignore if: Extremely unlikely that `videosToReceive` is null or missing requisite functions and made it this far */ if (streamChanges === undefined) return false;
        const added = streamChanges.added;
        const simulcastStreamUpdates = streamChanges.simulcastStreamUpdates;
        const removed = streamChanges.removed;
        const context = this.meetingSessionContext;
        const updatedVideoSubscriptionConfigurations = [];
        for (const [previousId, currentId] of simulcastStreamUpdates.entries()){
            const updatedConfig = new $9449bd6d0250362d$var$SignalingClientVideoSubscriptionConfiguration_1.default();
            updatedConfig.streamId = currentId;
            updatedConfig.attendeeId = context.videoStreamIndex.attendeeIdForStreamId(currentId);
            updatedConfig.mid = context.transceiverController.getMidForStreamId(previousId);
            if (updatedConfig.mid === undefined) {
                this.logger.info(`No MID found for stream ID ${previousId}, cannot update stream without renegotiation`);
                return false;
            }
            updatedVideoSubscriptionConfigurations.push(updatedConfig);
            // We need to override some other components dependent on the subscribe paths for certain functionality
            context.transceiverController.setStreamIdForMid(updatedConfig.mid, currentId);
            context.videoStreamIndex.overrideStreamIdMappings(previousId, currentId);
            if (context.videoTileController.haveVideoTileForAttendeeId(updatedConfig.attendeeId)) {
                const tile = context.videoTileController.getVideoTileForAttendeeId(updatedConfig.attendeeId);
                if (!tile.setStreamId) // Required function
                return false;
                tile.setStreamId(currentId);
            }
        }
        // accomplish simulcast stream switches by sending removeVideoUpdate signaling frame instead of full renegotiation
        if (updatedVideoSubscriptionConfigurations.length !== 0) context.signalingClient.remoteVideoUpdate(updatedVideoSubscriptionConfigurations, []);
        // but cannot skip renegotiation if there are more changes than simulcast stream switch (i.e. add/remove/source switches)
        if (added.length !== 0 || removed.length !== 0) return false;
        // We use `remoteVideoUpdateSent` to cache the previous index so that we are able to do switches (not add/removes)
        // for simulcast stream layer changes. See `subscribeFrameSent` for more details.
        context.videoStreamIndex.remoteVideoUpdateSent();
        return true;
    }
    detectChangesInVideosToReceive() {
        const context = this.meetingSessionContext;
        /* istanbul ignore next: Extremely unlikely that `videosToReceive` is null */ if (context.videosToReceive === null) return undefined;
        // Check existence of all required dependencies and requisite functions
        if (!context.transceiverController || !context.transceiverController.getMidForStreamId || !context.transceiverController.setStreamIdForMid || !context.videosToReceive.forEach || !context.signalingClient.remoteVideoUpdate || !context.videoStreamIndex.overrideStreamIdMappings) return undefined;
        let added = [];
        const simulcastStreamUpdates = new Map();
        let removed = [];
        if (context.lastVideosToReceive === null) added = context.videosToReceive.array();
        else {
            const index = context.videoStreamIndex;
            context.videosToReceive.forEach((currentId)=>{
                if (context.lastVideosToReceive.contain(currentId)) return;
                // Check if group ID exists in previous set (i.e. simulcast stream switch)
                let foundUpdatedPreviousStreamId = false;
                context.lastVideosToReceive.forEach((previousId)=>{
                    if (foundUpdatedPreviousStreamId) return; // Short circuit since we have already found it
                    if (index.StreamIdsInSameGroup(previousId, currentId)) {
                        simulcastStreamUpdates.set(previousId, currentId);
                        foundUpdatedPreviousStreamId = true;
                    }
                });
                if (!foundUpdatedPreviousStreamId) // Otherwise this must be a new stream
                added.push(currentId);
            });
            removed = context.lastVideosToReceive.array().filter((idFromPrevious)=>{
                const stillReceiving = context.videosToReceive.contain(idFromPrevious);
                const isUpdated = simulcastStreamUpdates.has(idFromPrevious);
                return !stillReceiving && !isUpdated;
            });
        }
        this.logger.info(`Request to update remote videos with added: [${added}], updated: [${Array.from(simulcastStreamUpdates.entries()).map(([key, value])=>`${key}->${value}`).join(',')}], removed: [${removed}]`);
        return {
            added: added,
            removed: removed,
            simulcastStreamUpdates: simulcastStreamUpdates
        };
    }
    isNotAddingOrRemovingStreams() {
        const streamChanges = this.detectChangesInVideosToReceive();
        /* istanbul ignore if: Extremely unlikely that `videosToReceive` is null or missing requisite functions and made it this far */ if (streamChanges === undefined) return false;
        const added = streamChanges.added;
        const removed = streamChanges.removed;
        // but cannot skip renegotiation if there are more changes than simulcast stream switch (i.e. add/remove/source switches)
        if (added.length !== 0 || removed.length !== 0) return false;
        // Similar to `updateRemoteVideosFromLastVideosToReceive`, we use `remoteVideoUpdateSent` to cache the previous
        // index so that we don't incorrectly mark a simulcast stream change (e.g. a sender switching from publishing [1, 3] to [2] to [1, 3])
        // as the add or removal of a source
        this.meetingSessionContext.videoStreamIndex.remoteVideoUpdateSent();
        return true;
    }
    // This funtion should be called only when any server side network adaption feature is enabled.
    // It sends `RemoteVideoUpdate` frame to server to update remote video preferences, which is needed for server side bandwidth probing.
    // The `RemoteVideoUpdate` signaling frame maybe also trigger server side video quality adaption if such feature has been signalled.
    //
    // It requires the caller to manage `this.meetingSessionContext.lastVideosToReceive`
    // and `this.meetingSessionContext.videosToReceive` so that `this.meetingSessionContext.lastVideosToReceive`
    // contains the stream IDs from either last time a subscribe was set, or last time this function was set.
    //
    // It will return false if not receiving any remote videos or found new video sources with MID not set yet.
    // It will return true if sent current preferences to server. It maybe also triggered server side quality adaption..
    sendRemoteVideoUpdate() {
        const context = this.meetingSessionContext;
        /* istanbul ignore next: Extremely unlikely that `videosToReceive` is null */ if (context.videosToReceive === null) return false;
        const groupIdsToReceive = context.videosToReceive.array().map((streamId)=>{
            return context.videoStreamIndex.groupIdForStreamId(streamId);
        });
        this.receiveRemotePauseResumeTask.updateSubscribedGroupdIds(new Set(groupIdsToReceive));
        const currentConfigs = (0, $3orkO.convertVideoPreferencesToSignalingClientVideoSubscriptionConfiguration)(context, groupIdsToReceive, context.videoDownlinkBandwidthPolicy.getVideoPreferences());
        const newVideoSubscriptionConfigurationsMap = new Map();
        const addedOrUpdated = [];
        for (const config of currentConfigs){
            let shouldIncludeInUpdate = false;
            if (!context.lastVideoSubscriptionConfiguration.has(config.groupId)) shouldIncludeInUpdate = true;
            else {
                const lastConfig = context.lastVideoSubscriptionConfiguration.get(config.groupId);
                if (!config.equals(lastConfig)) {
                    this.logger.debug(`${JSON.stringify(config)} does not equal ${JSON.stringify(lastConfig)}, sending update`);
                    shouldIncludeInUpdate = true;
                }
            }
            newVideoSubscriptionConfigurationsMap.set(config.groupId, config);
            if (shouldIncludeInUpdate) addedOrUpdated.push(config);
        }
        context.lastVideoSubscriptionConfiguration = newVideoSubscriptionConfigurationsMap;
        const removedMids = [];
        if (context.lastVideosToReceive !== null) {
            const groupIdsToReceiveSet = new Set(groupIdsToReceive);
            for (const streamId of context.lastVideosToReceive.array()){
                const groupId = context.videoStreamIndex.groupIdForStreamId(streamId);
                if (!groupIdsToReceiveSet.has(groupId)) {
                    const mid = context.transceiverController.getMidForGroupId(groupId);
                    if (mid === undefined) {
                        context.logger.warn(`Could not find MID for group ID to remove: ${groupId}`);
                        continue;
                    }
                    removedMids.push(mid);
                }
            }
        }
        // pass updated preference configurations to server for server-side bandwdith padding/probing
        // additionally, trigger server-side video quality adaption if enabed
        if (addedOrUpdated.length !== 0 || removedMids.length !== 0) context.signalingClient.remoteVideoUpdate(addedOrUpdated, removedMids);
        return true;
    }
    updateLocalVideoFromPolicy() {
        // Try updating parameters without renegotiation
        if (this.meetingSessionContext.enableSimulcast) {
            // The following may result in `this.mayNeedRenegotiationForSimulcastLayerChange` being switched on
            const encodingParam = this.meetingSessionContext.videoUplinkBandwidthPolicy.chooseEncodingParameters();
            if (this.mayNeedRenegotiationForSimulcastLayerChange && this.meetingSessionContext.transceiverController.hasVideoInput() && !this.negotiatedBitrateLayersAllocationRtpHeaderExtension()) {
                this.logger.info('Needs regenotiation for local video simulcast layer change');
                this.mayNeedRenegotiationForSimulcastLayerChange = false;
                return false;
            }
            this.meetingSessionContext.transceiverController.setEncodingParameters(encodingParam);
        } else this.meetingSessionContext.videoCaptureAndEncodeParameter = this.meetingSessionContext.videoUplinkBandwidthPolicy.chooseCaptureAndEncodeParameters();
        this.logger.info('Updated local video from policy without renegotiation');
        return true;
    }
    negotiatedBitrateLayersAllocationRtpHeaderExtension() {
        if (!this.meetingSessionContext.transceiverController.localVideoTransceiver()) return false;
        const parameters = this.meetingSessionContext.transceiverController.localVideoTransceiver().sender.getParameters();
        if (!parameters || !parameters.headerExtensions) return false;
        return parameters.headerExtensions.some((extension)=>extension.uri === 'http://www.webrtc.org/experiments/rtp-hdrext/video-layers-allocation00');
    }
    restartLocalVideo(callback) {
        const restartVideo = async ()=>{
            if (this._videoTileController.hasStartedLocalVideoTile()) {
                this.logger.info('stopping local video tile prior to local video restart');
                this._videoTileController.stopLocalVideoTile();
                this.logger.info('preparing local video restart update');
                await this.actionUpdateWithRenegotiation(false);
                this.logger.info('starting local video tile for local video restart');
                this._videoTileController.startLocalVideoTile();
            }
            this.logger.info('finalizing local video restart update');
            await this.actionUpdateWithRenegotiation(true);
            callback();
        };
        const result = this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.Update, ()=>{
            restartVideo();
        });
        return result === $9449bd6d0250362d$var$SessionStateControllerTransitionResult_1.default.Transitioned || result === $9449bd6d0250362d$var$SessionStateControllerTransitionResult_1.default.DeferredTransition;
    }
    async replaceLocalVideo(videoStream) {
        if (!videoStream || videoStream.getVideoTracks().length < 1) throw new Error('could not acquire video track');
        if (!this.meetingSessionContext || !this.meetingSessionContext.peer) throw new Error('no active meeting and peer connection');
        // if there is a local tile, a video tile update event should be fired.
        const localTile = this.meetingSessionContext.videoTileController.getLocalVideoTile();
        if (localTile) {
            const state = localTile.state();
            const settings = videoStream.getVideoTracks()[0].getSettings();
            // so tile update wil be fired.
            localTile.bindVideoStream(state.boundAttendeeId, true, videoStream, settings.width, settings.height, state.streamId, state.boundExternalUserId);
        }
        await this.meetingSessionContext.transceiverController.setVideoInput(videoStream.getVideoTracks()[0]);
        // Update the active video input on subscription context to match what we just changed
        // so that subsequent meeting actions can reuse and destroy it.
        this.meetingSessionContext.activeVideoInput = videoStream;
        this.logger.info('Local video input is updated');
    }
    async replaceLocalAudio(audioStream) {
        if (!audioStream || audioStream.getAudioTracks().length < 1) throw new Error('could not acquire audio track');
        if (!this.meetingSessionContext || !this.meetingSessionContext.peer) throw new Error('no active meeting and peer connection');
        this.connectionHealthData.reset();
        this.connectionHealthData.setConnectionStartTime();
        const replaceTrackSuccess = await this.meetingSessionContext.transceiverController.replaceAudioTrack(audioStream.getAudioTracks()[0]);
        if (!replaceTrackSuccess) throw new Error('Failed to replace audio track');
        this.meetingSessionContext.activeAudioInput = audioStream;
        this.logger.info('Local audio input is updated');
    }
    async actionUpdateWithRenegotiation(notify) {
        // See declaration (unpaused in actionFinishUpdating)
        // The operations in `update` do not need this protection because they are synchronous.
        this.monitorTask.pauseResubscribeCheck();
        this.receiveIndexTask.pauseIngestion();
        // TODO: do not block other updates while waiting for video input
        try {
            await new $9449bd6d0250362d$var$SerialGroupTask_1.default(this.logger, this.wrapTaskName('AudioVideoUpdate'), [
                new $9449bd6d0250362d$var$ReceiveVideoInputTask_1.default(this.meetingSessionContext),
                new $9449bd6d0250362d$var$TimeoutTask_1.default(this.logger, new $9449bd6d0250362d$var$SerialGroupTask_1.default(this.logger, 'UpdateSession', [
                    new $9449bd6d0250362d$var$AttachMediaInputTask_1.default(this.meetingSessionContext),
                    new $9449bd6d0250362d$var$CreateSDPTask_1.default(this.meetingSessionContext),
                    new $9449bd6d0250362d$var$SetLocalDescriptionTask_1.default(this.meetingSessionContext),
                    new $9449bd6d0250362d$var$FinishGatheringICECandidatesTask_1.default(this.meetingSessionContext),
                    new $9449bd6d0250362d$var$SubscribeAndReceiveSubscribeAckTask_1.default(this.meetingSessionContext),
                    new $9449bd6d0250362d$var$SetRemoteDescriptionTask_1.default(this.meetingSessionContext)
                ]), this.configuration.connectionTimeoutMs)
            ]).run();
            if (notify) this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.FinishUpdating, ()=>{
                this.actionFinishUpdating();
            });
        } catch (error) {
            this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.FinishUpdating, ()=>{
                const status = new $9449bd6d0250362d$var$MeetingSessionStatus_1.default(this.getMeetingStatusCode(error) || $9449bd6d0250362d$var$MeetingSessionStatusCode_1.default.TaskFailed);
                if (status.statusCode() !== $9449bd6d0250362d$var$MeetingSessionStatusCode_1.default.IncompatibleSDP) this.logger.info('failed to update audio-video session');
                this.handleMeetingSessionStatus(status, error);
            });
        }
    }
    notifyStop(status, error) {
        var _a;
        this.forEachObserver((observer)=>{
            $jfpqH.Maybe.of(observer.audioVideoDidStop).map((f)=>f.bind(observer)(status));
        });
        /* istanbul ignore else */ if (this.eventController) {
            const attributes = {
                ...(0, $byDbS.audioVideoEventAttributesFromState)(this.meetingSessionContext),
                meetingStatus: $9449bd6d0250362d$var$MeetingSessionStatusCode_1.default[status.statusCode()]
            };
            /* istanbul ignore next: toString is optional */ const meetingErrorMessage = error && error.message || ((_a = status.toString) === null || _a === void 0 ? void 0 : _a.call(status)) || '';
            if (this.meetingSessionContext.startTimeMs === null) {
                attributes.meetingErrorMessage = meetingErrorMessage;
                delete attributes.meetingDurationMs;
                delete attributes.attendeePresenceDurationMs;
                delete attributes.meetingStartDurationMs;
                this.eventController.publishEvent('meetingStartFailed', attributes);
            } else if (status.isFailure() || status.isAudioConnectionFailure()) {
                attributes.meetingErrorMessage = meetingErrorMessage;
                this.eventController.publishEvent('meetingFailed', attributes);
            } else this.eventController.publishEvent('meetingEnded', attributes);
        }
    }
    actionFinishUpdating() {
        // we do not update parameter for simulcast since they are updated in AttachMediaInputTask
        if (!this.meetingSessionContext.enableSimulcast) {
            if (this.useUpdateTransceiverControllerForUplink) this.meetingSessionContext.videoUplinkBandwidthPolicy.updateTransceiverController();
            else {
                const maxBitrateKbps = this.meetingSessionContext.videoCaptureAndEncodeParameter.encodeBitrates()[0];
                this.enforceBandwidthLimitationForSender(maxBitrateKbps);
            }
        }
        this.monitorTask.resumeResubscribeCheck();
        this.receiveIndexTask.resumeIngestion();
        this.logger.info('updated audio-video session');
    }
    reconnect(status, error) {
        if (this.promotedToPrimaryMeeting) {
            // If the client was promoted, we 'demote' them so that we don't get in any
            // unusual or unexpected state on reconnect
            this.promotedToPrimaryMeeting = false;
            this.forEachObserver((observer)=>{
                $jfpqH.Maybe.of(observer.audioVideoWasDemotedFromPrimaryMeeting).map((f)=>f.bind(observer)(new $9449bd6d0250362d$var$MeetingSessionStatus_1.default($9449bd6d0250362d$var$MeetingSessionStatusCode_1.default.AudioVideoDisconnectedWhilePromoted)));
            });
        }
        const willRetry = this._reconnectController.retryWithBackoff(async ()=>{
            if (this.sessionStateController.state() === $9449bd6d0250362d$var$SessionStateControllerState_1.default.NotConnected) this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.Connect, ()=>{
                this.actionConnect(true);
            });
            else this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.Reconnect, ()=>{
                this.actionReconnect(status);
            });
            this.meetingSessionContext.retryCount += 1;
        }, ()=>{
            this.logger.info('canceled retry');
        });
        if (!willRetry) this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.Fail, ()=>{
            this.actionDisconnect(status, false, error);
        });
        return willRetry;
    }
    async actionReconnect(status) {
        if (!this._reconnectController.hasStartedConnectionAttempt()) {
            this._reconnectController.startedConnectionAttempt(false);
            this.forEachObserver((observer)=>{
                $jfpqH.Maybe.of(observer.audioVideoDidStartConnecting).map((f)=>f.bind(observer)(true));
            });
        }
        this.meetingSessionContext.volumeIndicatorAdapter.onReconnect();
        this.connectionHealthData.reset();
        this.receiveRemotePauseResumeTask = new $9449bd6d0250362d$var$ReceiveRemoteVideoPauseResumeTask_1.default(this.meetingSessionContext);
        try {
            await new $9449bd6d0250362d$var$SerialGroupTask_1.default(this.logger, this.wrapTaskName('AudioVideoReconnect'), [
                new $9449bd6d0250362d$var$TimeoutTask_1.default(this.logger, new $9449bd6d0250362d$var$SerialGroupTask_1.default(this.logger, 'Media', [
                    new $9449bd6d0250362d$var$CleanRestartedSessionTask_1.default(this.meetingSessionContext),
                    new $9449bd6d0250362d$var$SerialGroupTask_1.default(this.logger, 'Signaling', [
                        new $9449bd6d0250362d$var$OpenSignalingConnectionTask_1.default(this.meetingSessionContext),
                        new $9449bd6d0250362d$var$JoinAndReceiveIndexTask_1.default(this.meetingSessionContext)
                    ]),
                    new $9449bd6d0250362d$var$CreatePeerConnectionTask_1.default(this.meetingSessionContext)
                ]), this.configuration.connectionTimeoutMs),
                // TODO: Do we need ReceiveVideoInputTask in the reconnect operation?
                new $9449bd6d0250362d$var$ReceiveVideoInputTask_1.default(this.meetingSessionContext),
                new $9449bd6d0250362d$var$TimeoutTask_1.default(this.logger, new $9449bd6d0250362d$var$SerialGroupTask_1.default(this.logger, 'UpdateSession', [
                    new $9449bd6d0250362d$var$AttachMediaInputTask_1.default(this.meetingSessionContext),
                    new $9449bd6d0250362d$var$CreateSDPTask_1.default(this.meetingSessionContext),
                    new $9449bd6d0250362d$var$SetLocalDescriptionTask_1.default(this.meetingSessionContext),
                    new $9449bd6d0250362d$var$FinishGatheringICECandidatesTask_1.default(this.meetingSessionContext),
                    new $9449bd6d0250362d$var$SubscribeAndReceiveSubscribeAckTask_1.default(this.meetingSessionContext),
                    new $9449bd6d0250362d$var$SetRemoteDescriptionTask_1.default(this.meetingSessionContext),
                    this.receiveRemotePauseResumeTask
                ]), this.configuration.connectionTimeoutMs)
            ]).run();
            this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.FinishConnecting, ()=>{
                var _a;
                /* istanbul ignore else */ (_a = this.eventController) === null || _a === void 0 || _a.publishEvent('meetingReconnected', {
                    ...(0, $byDbS.audioVideoEventAttributesFromState)(this.meetingSessionContext),
                    meetingStatus: $9449bd6d0250362d$var$MeetingSessionStatusCode_1.default[status.statusCode()]
                });
                this.actionFinishConnecting();
            });
        } catch (error) {
            // To perform the "Reconnect" action again, the session should be in the "Connected" state.
            this.sessionStateController.perform($9449bd6d0250362d$var$SessionStateControllerAction_1.default.FinishConnecting, ()=>{
                this.logger.info('failed to reconnect audio-video session');
                const status = new $9449bd6d0250362d$var$MeetingSessionStatus_1.default(this.getMeetingStatusCode(error) || $9449bd6d0250362d$var$MeetingSessionStatusCode_1.default.TaskFailed);
                this.handleMeetingSessionStatus(status, error);
            });
        }
        this.connectionHealthData.setConnectionStartTime();
    }
    wrapTaskName(taskName) {
        return `${taskName}/${this.configuration.meetingId}/${this.configuration.credentials.attendeeId}`;
    }
    cleanUpMediaStreamsAfterStop() {
        this._mediaStreamBroker.removeMediaStreamBrokerObserver(this);
        this.meetingSessionContext.activeAudioInput = undefined;
        this.meetingSessionContext.activeVideoInput = undefined;
    }
    // Extract the meeting status from `Error.message`, relying on specific phrasing
    // 'the meeting status code ${CODE}`.
    //
    // e.g. reject(new Error(
    //        `canceling ${this.name()} due to the meeting status code: ${MeetingSessionStatusCode.MeetingEnded}`));
    getMeetingStatusCode(error) {
        const matched = /the meeting status code: (\d+)/.exec(error && error.message);
        if (matched && matched.length > 1) return Number.parseInt(matched[1], 10);
        return null;
    }
    async enforceBandwidthLimitationForSender(maxBitrateKbps) {
        await this.meetingSessionContext.transceiverController.setVideoSendingBitrateKbps(maxBitrateKbps);
    }
    handleMeetingSessionStatus(status, error) {
        this.logger.info(`handling status: ${$9449bd6d0250362d$var$MeetingSessionStatusCode_1.default[status.statusCode()]}`);
        if (!status.isTerminal()) {
            if (this.meetingSessionContext.statsCollector) this.meetingSessionContext.statsCollector.logMeetingSessionStatus(status);
        }
        if (status.statusCode() === $9449bd6d0250362d$var$MeetingSessionStatusCode_1.default.IncompatibleSDP) {
            this.restartLocalVideo(()=>{
                this.logger.info('handled incompatible SDP by attempting to restart video');
            });
            return true;
        }
        if (status.statusCode() === $9449bd6d0250362d$var$MeetingSessionStatusCode_1.default.VideoCallSwitchToViewOnly) {
            this._videoTileController.removeLocalVideoTile();
            this.forEachObserver((observer)=>{
                $jfpqH.Maybe.of(observer.videoSendDidBecomeUnavailable).map((f)=>f.bind(observer)());
            });
            return false;
        }
        if (status.statusCode() === $9449bd6d0250362d$var$MeetingSessionStatusCode_1.default.AudioVideoWasRemovedFromPrimaryMeeting) {
            this.forEachObserver((observer)=>{
                $jfpqH.Maybe.of(observer.audioVideoWasDemotedFromPrimaryMeeting).map((f)=>f.bind(observer)(status));
            });
            return false;
        }
        if (status.isTerminal()) {
            this.logger.error('session will not be reconnected');
            if (this.meetingSessionContext.reconnectController) this.meetingSessionContext.reconnectController.disableReconnect();
        }
        if (status.isFailure() || status.isTerminal()) {
            if (this.meetingSessionContext.reconnectController) {
                const willReconnect = this.reconnect(status, error);
                if (willReconnect) this.logger.warn(`The audio video controller will reconnect due to status code ${$9449bd6d0250362d$var$MeetingSessionStatusCode_1.default[status.statusCode()]}${error ? ` and error: ${error.message}` : ``}`);
                else this.logger.error(`The audio video controller failed with status code ${$9449bd6d0250362d$var$MeetingSessionStatusCode_1.default[status.statusCode()]}${error ? ` and error: ${error.message}` : ``}`);
                return willReconnect;
            }
        }
        return false;
    }
    setVideoMaxBandwidthKbps(maxBandwidthKbps) {
        if (maxBandwidthKbps <= 0) throw new Error('Max bandwidth kbps has to be greater than 0');
        if (this.meetingSessionContext && this.meetingSessionContext.videoUplinkBandwidthPolicy) {
            this.logger.info(`video send has ideal max bandwidth ${maxBandwidthKbps} kbps`);
            this.meetingSessionContext.videoUplinkBandwidthPolicy.setIdealMaxBandwidthKbps(maxBandwidthKbps);
        }
        this.maxUplinkBandwidthKbps = maxBandwidthKbps;
    }
    async handleHasBandwidthPriority(hasBandwidthPriority) {
        if (this.meetingSessionContext && this.meetingSessionContext.videoUplinkBandwidthPolicy && !this.meetingSessionContext.enableSimulcast) {
            if (this.useUpdateTransceiverControllerForUplink) {
                this.meetingSessionContext.videoUplinkBandwidthPolicy.setHasBandwidthPriority(hasBandwidthPriority);
                await this.meetingSessionContext.videoUplinkBandwidthPolicy.updateTransceiverController();
                return;
            }
            const oldMaxBandwidth = this.meetingSessionContext.videoUplinkBandwidthPolicy.maxBandwidthKbps();
            this.meetingSessionContext.videoUplinkBandwidthPolicy.setHasBandwidthPriority(hasBandwidthPriority);
            const newMaxBandwidth = this.meetingSessionContext.videoUplinkBandwidthPolicy.maxBandwidthKbps();
            if (oldMaxBandwidth !== newMaxBandwidth) {
                this.logger.info(`video send bandwidth priority ${hasBandwidthPriority} max has changed from ${oldMaxBandwidth} kbps to ${newMaxBandwidth} kbps`);
                await this.enforceBandwidthLimitationForSender(newMaxBandwidth);
            }
        }
    }
    pauseReceivingStream(streamId) {
        if (!!this.meetingSessionContext && this.meetingSessionContext.signalingClient) this.meetingSessionContext.signalingClient.pause([
            streamId
        ]);
    }
    resumeReceivingStream(streamId) {
        if (!!this.meetingSessionContext && this.meetingSessionContext.signalingClient) this.meetingSessionContext.signalingClient.resume([
            streamId
        ]);
    }
    setVideoCodecSendPreferences(preferences) {
        this.videoSendCodecPreferences = preferences; // In case we haven't called `initSignalingClient` yet
        this.meetingSessionContext.videoSendCodecPreferences = preferences;
        if (this.sessionStateController.state() !== $9449bd6d0250362d$var$SessionStateControllerState_1.default.NotConnected) this.update({
            needsRenegotiation: true
        });
    }
    getRemoteVideoSources() {
        const { videoStreamIndex: videoStreamIndex } = this.meetingSessionContext;
        if (!videoStreamIndex) {
            this.logger.info('meeting has not started');
            return [];
        }
        const selfAttendeeId = this.configuration.credentials.attendeeId;
        return videoStreamIndex.allVideoSendingSourcesExcludingSelf(selfAttendeeId);
    }
    encodingSimulcastLayersDidChange(simulcastLayers) {
        this.mayNeedRenegotiationForSimulcastLayerChange = true;
        this.forEachObserver((observer)=>{
            $jfpqH.Maybe.of(observer.encodingSimulcastLayersDidChange).map((f)=>f.bind(observer)(simulcastLayers));
        });
    }
    promoteToPrimaryMeeting(credentials) {
        return this.actionPromoteToPrimaryMeeting(credentials);
    }
    async actionPromoteToPrimaryMeeting(credentials) {
        let resultingStatus = new $9449bd6d0250362d$var$MeetingSessionStatus_1.default($9449bd6d0250362d$var$MeetingSessionStatusCode_1.default.SignalingRequestFailed);
        await new $9449bd6d0250362d$var$SerialGroupTask_1.default(this.logger, this.wrapTaskName('PromoteToPrimaryMeeting'), [
            new $9449bd6d0250362d$var$TimeoutTask_1.default(this.logger, new $9449bd6d0250362d$var$PromoteToPrimaryMeetingTask_1.default(this.meetingSessionContext, credentials, (status)=>{
                resultingStatus = status;
            }), this.configuration.connectionTimeoutMs)
        ]).run();
        this.promotedToPrimaryMeeting = resultingStatus.statusCode() === $9449bd6d0250362d$var$MeetingSessionStatusCode_1.default.OK;
        return resultingStatus;
    }
    demoteFromPrimaryMeeting() {
        this.meetingSessionContext.signalingClient.demoteFromPrimaryMeeting();
        this.forEachObserver((observer)=>{
            $jfpqH.Maybe.of(observer.audioVideoWasDemotedFromPrimaryMeeting).map((f)=>f.bind(observer)(new $9449bd6d0250362d$var$MeetingSessionStatus_1.default($9449bd6d0250362d$var$MeetingSessionStatusCode_1.default.OK)));
        });
    }
    async videoInputDidChange(videoStream) {
        this.logger.info('Receive a video input change event');
        // No active meeting, there is nothing to do
        if (!this.meetingSessionContext || !this.meetingSessionContext.peer) {
            this.logger.info('Skip updating video input because there is no active meeting and peer connection');
            return;
        }
        if (this._videoTileController.hasStartedLocalVideoTile()) {
            if (videoStream) await this.replaceLocalVideo(videoStream);
            else this._videoTileController.stopLocalVideoTile();
        }
    }
    async audioInputDidChange(audioStream) {
        this.logger.info('Receive an audio input change event');
        // No active meeting, there is nothing to do
        if (!this.meetingSessionContext || !this.meetingSessionContext.peer) {
            this.logger.info('Skip updating audio input because there is no active meeting and peer connection');
            return;
        }
        if (!audioStream) // If audio input stream stopped, try to get empty audio device from media stream broker
        try {
            audioStream = await this.mediaStreamBroker.acquireAudioInputStream();
        } catch (error) {
            this.logger.error('Could not acquire audio track from mediaStreamBroker');
            return;
        }
        await this.replaceLocalAudio(audioStream);
    }
    /**
     * Handle worker failures after initialization by triggering reconnect
     */ onEncodedTransformWorkerManagerFailed(error) {
        this.logger.error(`Encoded transform worker failed: ${error.message}`);
        if (this.sessionStateController.state() !== $9449bd6d0250362d$var$SessionStateControllerState_1.default.Connected) {
            this.logger.info('Skipping reconnect for worker failure - session not connected');
            return;
        }
        // Trigger reconnect to recreate peer connection without transforms
        const status = new $9449bd6d0250362d$var$MeetingSessionStatus_1.default($9449bd6d0250362d$var$MeetingSessionStatusCode_1.default.EncodedTransformManagerFailed);
        this.reconnect(status, error);
    }
    // Routes first-packet events from the encoded transform layer into the timing manager.
    onFirstPacketReceived(mediaType, direction, ssrc) {
        var _a, _b;
        if (mediaType === 'audio') {
            if (direction === 'receive') this._meetingSessionTimingManager.onRemoteAudioFirstPacketReceived();
            else if (direction === 'send') this._meetingSessionTimingManager.onLocalAudioFirstPacketSent();
        } else if (mediaType === 'video') {
            if (direction === 'receive') {
                /* istanbul ignore next */ const streamId = (_a = this.meetingSessionContext.videoStreamIndex) === null || _a === void 0 ? void 0 : _a.streamIdForSSRC(ssrc);
                if (streamId === undefined) {
                    this.logger.warn(`Received first video packet but no stream ID found for ssrc=${ssrc}`);
                    return;
                }
                /* istanbul ignore next */ const groupId = (_b = this.meetingSessionContext.videoStreamIndex) === null || _b === void 0 ? void 0 : _b.groupIdForStreamId(streamId);
                if (groupId === undefined) {
                    this.logger.warn(`Received first video packet but no group ID found for streamId=${streamId} ssrc=${ssrc}`);
                    return;
                }
                this.logger.debug(`Received first video packet for groupId=${groupId} ssrc=${ssrc}`);
                this._meetingSessionTimingManager.onRemoteVideoFirstPacketReceived(groupId);
            } else if (direction === 'send') this._meetingSessionTimingManager.onLocalVideoFirstFrameSent();
        }
    }
    onMeetingSessionTimingReady(timing) {
        if (!this.meetingSessionContext.signalingClient) {
            this.logger.warn('Timing data ready but signaling client is not available, discarding');
            return;
        }
        this.meetingSessionContext.signalingClient.sendMeetingSessionTiming(timing);
    }
}
$9449bd6d0250362d$var$DefaultAudioVideoController.MIN_VOLUME_DECIBELS = -42;
$9449bd6d0250362d$var$DefaultAudioVideoController.MAX_VOLUME_DECIBELS = -14;
$9449bd6d0250362d$var$DefaultAudioVideoController.PING_PONG_INTERVAL_MS = 10000;
module.exports.default = $9449bd6d0250362d$var$DefaultAudioVideoController;

});
parcelRegister("jUS1b", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jfpqH = parcelRequire("jfpqH");
class $e7fd2621804d83a9$var$SignalingAndMetricsConnectionMonitor {
    constructor(audioVideoController, realtimeController, connectionHealthData, pingPong, statsCollector){
        this.audioVideoController = audioVideoController;
        this.realtimeController = realtimeController;
        this.connectionHealthData = connectionHealthData;
        this.pingPong = pingPong;
        this.statsCollector = statsCollector;
        this.isActive = false;
        this.hasSeenValidCandidatePairMetricsBefore = false;
        this.lastTotalBytesReceived = 0;
        this.lastTotalStunMessagesReceived = 0;
        this.realtimeController.realtimeSubscribeToLocalSignalStrengthChange((signalStrength)=>{
            if (this.isActive) this.receiveSignalStrengthChange(signalStrength);
        });
    }
    start() {
        this.isActive = true;
        this.pingPong.addObserver(this);
        this.pingPong.start();
        this.audioVideoController.addObserver(this);
    }
    stop() {
        this.isActive = false;
        this.pingPong.removeObserver(this);
        this.pingPong.stop();
        this.audioVideoController.removeObserver(this);
    }
    receiveSignalStrengthChange(signalStrength) {
        if (signalStrength === 0) this.connectionHealthData.setLastNoSignalTimestampMs(Date.now());
        else if (signalStrength <= 0.5) this.connectionHealthData.setLastWeakSignalTimestampMs(Date.now());
        else this.connectionHealthData.setLastGoodSignalTimestampMs(Date.now());
        this.updateConnectionHealth();
    }
    didReceivePong(_id, latencyMs, clockSkewMs) {
        this.connectionHealthData.setConsecutiveMissedPongs(0);
        this.statsCollector.logLatency('ping_pong', latencyMs);
        this.statsCollector.logLatency('ping_pong_clock_skew', clockSkewMs);
        this.updateConnectionHealth();
    }
    didMissPongs() {
        this.connectionHealthData.setConsecutiveMissedPongs(this.connectionHealthData.consecutiveMissedPongs + 1);
        this.updateConnectionHealth();
    }
    metricsDidReceive(clientMetricReport) {
        let audioPacketsReceived = 0;
        let audiofractionPacketsLostInbound = 0;
        const metricReport = clientMetricReport.getObservableMetrics();
        const potentialAudioPacketsReceived = metricReport.audioPacketsReceived;
        const potentialAudioFractionPacketsLostInbound = metricReport.audioPacketsReceivedFractionLoss;
        const audioSpeakerDelayMs = metricReport.audioSpeakerDelayMs;
        // Firefox does not presently have aggregated bandwidth estimation
        if (typeof audioSpeakerDelayMs === 'number' && !isNaN(audioSpeakerDelayMs)) this.connectionHealthData.setAudioSpeakerDelayMs(audioSpeakerDelayMs);
        // To get the total bytes received, including RTCP, we need to sum up
        // all candidate pair metrics (in case the candidate pair changes).
        //
        // The stats collector currently doesn't account for candidate pair stats
        // so we just use the raw report for now.
        const webrtcReport = clientMetricReport.getRTCStatsReport();
        // We use candidate pair bytes received as a proxy for packets received
        // since not all versions of all browsers have 'packetsReceived' for candidate pairs
        let totalBytesReceived = 0;
        // We additionally check STUN messages received, in case backend is not sending RTP/RTCP
        // which may happen in None attendee capability edge cases.
        let totalStunMessagedReceived = 0;
        webrtcReport.forEach((stat)=>{
            if (stat.type === 'candidate-pair') {
                if (stat.bytesReceived) totalBytesReceived += stat.bytesReceived;
                if (stat.requestsReceived) totalStunMessagedReceived += stat.requestsReceived;
                if (stat.responsesReceived) totalStunMessagedReceived += stat.responsesReceived;
            }
        });
        const bytesReceived = totalBytesReceived - this.lastTotalBytesReceived;
        this.lastTotalBytesReceived = totalBytesReceived;
        const stunMessagesReceived = totalStunMessagedReceived - this.lastTotalStunMessagesReceived;
        this.lastTotalStunMessagesReceived = totalStunMessagedReceived;
        if (typeof potentialAudioPacketsReceived === 'number' && typeof potentialAudioFractionPacketsLostInbound === 'number') {
            audioPacketsReceived = potentialAudioPacketsReceived;
            audiofractionPacketsLostInbound = potentialAudioFractionPacketsLostInbound;
            if (audioPacketsReceived < 0 || audiofractionPacketsLostInbound < 0 || bytesReceived < 0 || stunMessagesReceived < 0) // The stats collector or logic above may emit negative numbers on this metric after reconnect
            // which we should not use.
            return;
        } else return;
        this.addToMinuteWindow(this.connectionHealthData.packetsReceivedInLastMinute, audioPacketsReceived);
        this.addToMinuteWindow(this.connectionHealthData.fractionPacketsLostInboundInLastMinute, audiofractionPacketsLostInbound);
        if (bytesReceived > 0 || stunMessagesReceived > 0) {
            this.hasSeenValidCandidatePairMetricsBefore = true;
            this.connectionHealthData.setConsecutiveStatsWithNoPackets(0);
        } else if (this.hasSeenValidCandidatePairMetricsBefore) this.connectionHealthData.setConsecutiveStatsWithNoPackets(this.connectionHealthData.consecutiveStatsWithNoPackets + 1);
        if (audioPacketsReceived === 0 || audiofractionPacketsLostInbound > 0) this.connectionHealthData.setLastPacketLossInboundTimestampMs(Date.now());
        if (typeof metricReport.audioPacketsSent === 'number') this.updateAudioPacketsSentInConnectionHealth(metricReport.audioPacketsSent);
        this.updateVideoEncodingHealth(clientMetricReport);
        this.updateConnectionHealth();
    }
    updateAudioPacketsSentInConnectionHealth(audioPacketsSent) {
        if (audioPacketsSent > 0) this.connectionHealthData.setConsecutiveStatsWithNoAudioPacketsSent(0);
        else this.connectionHealthData.setConsecutiveStatsWithNoAudioPacketsSent(this.connectionHealthData.consecutiveStatsWithNoAudioPacketsSent + 1);
    }
    updateVideoEncodingHealth(clientMetricReport) {
        const isLocalVideoTileStarted = this.audioVideoController.videoTileController.hasStartedLocalVideoTile();
        const ssrcs = clientMetricReport.getVideoUpstreamSsrcs();
        if (!isLocalVideoTileStarted || ssrcs.length === 0) {
            this.connectionHealthData.setIsVideoEncoderHardware(false);
            this.connectionHealthData.setVideoEncodingTimePerFrameInMs(0);
            this.connectionHealthData.setCpuLimitationDuration(0);
            this.connectionHealthData.setVideoInputFps(0);
            this.connectionHealthData.setVideoEncodeFps(0);
            return;
        }
        let isHardwareEncoder = false;
        let videoEncodingTimeInMs = 0;
        let cpuLimitationDuration = 0;
        let videoInputFps = 0;
        let videoEncodeFps = 0;
        for (const ssrc of ssrcs){
            // There may be multiple video ssrcs for one video when simulcast is enabled.
            // We aggregate the metrics for all these ssrcs to determine encoding health.
            // If any of the ssrcs is using hardware encoder, we consider the encoding is
            // done by hardware (browsers may use software encoder for low resolution
            // streams even if hardware encoding is available).
            isHardwareEncoder || (isHardwareEncoder = Boolean(clientMetricReport.getObservableVideoMetricValue('videoUpstreamEncoderImplementation', ssrc)));
            videoEncodingTimeInMs += clientMetricReport.getObservableVideoMetricValue('videoUpstreamTotalEncodeTimePerSecond', ssrc);
            cpuLimitationDuration += clientMetricReport.getObservableVideoMetricValue('videoUpstreamCpuQualityLimitationDurationPerSecond', ssrc);
            videoInputFps += clientMetricReport.getObservableVideoMetricValue('videoUpstreamFramesInputPerSecond', ssrc);
            videoEncodeFps += clientMetricReport.getObservableVideoMetricValue('videoUpstreamFramesEncodedPerSecond', ssrc);
        }
        const videoEncodingTimePerFrameInMs = videoEncodeFps > 0 ? videoEncodingTimeInMs / videoEncodeFps : 0;
        this.connectionHealthData.setIsVideoEncoderHardware(Boolean(isHardwareEncoder));
        this.connectionHealthData.setVideoEncodingTimeInMs(videoEncodingTimeInMs);
        this.connectionHealthData.setVideoEncodingTimePerFrameInMs(videoEncodingTimePerFrameInMs);
        this.connectionHealthData.setCpuLimitationDuration(cpuLimitationDuration);
        this.connectionHealthData.setVideoInputFps(videoInputFps);
        this.connectionHealthData.setVideoEncodeFps(videoEncodeFps);
    }
    addToMinuteWindow(array, value) {
        array.unshift(value);
        if (array.length > 60) array.pop();
    }
    updateConnectionHealth() {
        this.audioVideoController.forEachObserver((observer)=>{
            $jfpqH.Maybe.of(observer.connectionHealthDidChange).map((f)=>f.bind(observer)(this.connectionHealthData.clone()));
        });
    }
}
module.exports.default = $e7fd2621804d83a9$var$SignalingAndMetricsConnectionMonitor;

});

parcelRegister("byDbS", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.audioVideoEventAttributesFromState = $86a145211d74ee88$var$audioVideoEventAttributesFromState;
/**
 * Helper function to generate AudioVideoEventAttributes from AudioVideoControllerState.
 */ function $86a145211d74ee88$var$audioVideoEventAttributesFromState(state) {
    const attributes = {};
    if (state.startTimeMs !== null) attributes.meetingDurationMs = Math.round(Date.now() - state.startTimeMs);
    if (state.signalingOpenDurationMs !== null) attributes.signalingOpenDurationMs = state.signalingOpenDurationMs;
    if (state.iceGatheringDurationMs !== null) attributes.iceGatheringDurationMs = state.iceGatheringDurationMs;
    if (state.attendeePresenceDurationMs !== null) attributes.attendeePresenceDurationMs = state.attendeePresenceDurationMs;
    if (state.meetingStartDurationMs !== null) attributes.meetingStartDurationMs = state.meetingStartDurationMs;
    if (state.maxVideoTileCount !== undefined) attributes.maxVideoTileCount = state.maxVideoTileCount;
    if (state.poorConnectionCount !== undefined) attributes.poorConnectionCount = state.poorConnectionCount;
    if (state.retryCount !== undefined) attributes.retryCount = state.retryCount;
    return attributes;
}

});

parcelRegister("jbMe2", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $df8473f70928eda9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4huDn = parcelRequire("4huDn");

const $df8473f70928eda9$var$MeetingSessionStatusCode_1 = $df8473f70928eda9$var$__importDefault((parcelRequire("9zYoz")));
/**
 * [[MeetingSessionStatus]] indicates a status received regarding the session.
 */ class $df8473f70928eda9$var$MeetingSessionStatus {
    constructor(_statusCode){
        this._statusCode = _statusCode;
    }
    statusCode() {
        return this._statusCode;
    }
    isFailure() {
        switch(this._statusCode){
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioAuthenticationRejected:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioCallAtCapacity:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioInternalServerError:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioServiceUnavailable:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioDisconnected:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.VideoCallAtSourceCapacity:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingBadRequest:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingInternalServerError:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingRequestFailed:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.ICEGatheringTimeoutWorkaround:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.ConnectionHealthReconnect:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.RealtimeApiFailed:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.TaskFailed:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.NoAttendeePresent:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingChannelClosedUnexpectedly:
                return true;
            default:
                return false;
        }
    }
    isTerminal() {
        switch(this._statusCode){
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.Left:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioJoinedFromAnotherDevice:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioAuthenticationRejected:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioCallAtCapacity:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.MeetingEnded:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioDisconnected:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.TURNCredentialsForbidden:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingBadRequest:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingRequestFailed:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.VideoCallAtSourceCapacity:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.RealtimeApiFailed:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioAttendeeRemoved:
                return true;
            default:
                return false;
        }
    }
    isAudioConnectionFailure() {
        switch(this._statusCode){
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioAuthenticationRejected:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioInternalServerError:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioServiceUnavailable:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.ICEGatheringTimeoutWorkaround:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingBadRequest:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingInternalServerError:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingRequestFailed:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.RealtimeApiFailed:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.NoAttendeePresent:
                return true;
            default:
                return false;
        }
    }
    toString() {
        switch(this._statusCode){
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.OK:
                return 'Everything is OK so far.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.Left:
                return 'The attendee left the meeting.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioJoinedFromAnotherDevice:
                return 'The attendee joined from another device.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioAuthenticationRejected:
                return 'The meeting rejected the attendee.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioCallAtCapacity:
                return "The attendee couldn't join because the meeting was at capacity.";
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.MeetingEnded:
                return 'The meeting ended.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioInternalServerError:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioServiceUnavailable:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioDisconnected:
                return 'The audio connection failed.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.VideoCallSwitchToViewOnly:
                return "The attendee couldn't start the local video because the maximum video capacity was reached.";
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.VideoCallAtSourceCapacity:
                return 'The connection failed due to an internal server error.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingBadRequest:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingInternalServerError:
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingRequestFailed:
                return 'The signaling connection failed.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.ICEGatheringTimeoutWorkaround:
                return 'Gathering ICE candidates timed out. In Chrome, this might indicate that the browser is in a bad state after reconnecting to VPN.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.ConnectionHealthReconnect:
                return 'The meeting was reconnected.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.RealtimeApiFailed:
                return 'The real-time API failed. This status code might indicate that the callback you passed to the real-time API threw an exception.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.TaskFailed:
                return 'The connection failed. See the error message for more details.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.IncompatibleSDP:
                return 'The connection failed due to incompatible SDP.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.TURNCredentialsForbidden:
                return 'The meeting ended, or the attendee was removed.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.NoAttendeePresent:
                return 'The attendee was not present.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioAttendeeRemoved:
                return 'The meeting ended because attendee removed.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioVideoWasRemovedFromPrimaryMeeting:
                return 'The Primary meeting credentials provided are no longer valid. chime::DeleteAttendee may have been called on them.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioVideoDisconnectedWhilePromoted:
                return 'The client disconnected while promoted, which will automatically demote. The attendee must promote again to participate.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioDisconnectAudio:
                return 'The audio connection failed.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingChannelClosedUnexpectedly:
                return 'The signaling channel was closed unexpectedly. This may be due to a network change or backend detected failure.';
            case $df8473f70928eda9$var$MeetingSessionStatusCode_1.default.EncodedTransformManagerFailed:
                return 'The encoded transform worker manager failed. The connection will be reconnected without transforms.';
            /* istanbul ignore next */ default:
                {
                    // You get a compile-time error if you do not handle any status code.
                    const exhaustiveCheck = this._statusCode;
                    throw new Error(`Unhandled case: ${exhaustiveCheck}`);
                }
        }
    }
    static fromSignalFrame(frame) {
        if (frame.error && frame.error.status) return this.fromSignalingStatus(frame.error.status);
        else if (frame.type === $4huDn.SdkSignalFrame.Type.AUDIO_STATUS) {
            if (frame.audioStatus) return this.fromAudioStatus(frame.audioStatus.audioStatus);
            return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingRequestFailed);
        } else if (frame.type === $4huDn.SdkSignalFrame.Type.PRIMARY_MEETING_LEAVE) return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioVideoWasRemovedFromPrimaryMeeting);
        return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.OK);
    }
    static fromAudioStatus(status) {
        // TODO: Add these numbers to proto definition and reference them here.
        switch(status){
            case 200:
                return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.OK);
            case 301:
                return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioJoinedFromAnotherDevice);
            case 302:
                return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioDisconnectAudio);
            case 403:
                return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioAuthenticationRejected);
            case 409:
                return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioCallAtCapacity);
            case 410:
                return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.MeetingEnded);
            case 411:
                return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioAttendeeRemoved);
            case 500:
                return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioInternalServerError);
            case 503:
                return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioServiceUnavailable);
            default:
                switch(Math.floor(status / 100)){
                    case 2:
                        return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.OK);
                    default:
                        return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioDisconnected);
                }
        }
    }
    static fromSignalingStatus(status) {
        // TODO: Add these numbers to proto definition and reference them here.
        //
        // We don't bother adding additional codes with different prefixes, and we probably
        // shouldn't be prefixing all these errors (e.g. `AuthenticationRejected`) with the media type
        // since that doesn't make sense.
        switch(status){
            case 206:
                return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.VideoCallSwitchToViewOnly);
            case 509:
                return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.VideoCallAtSourceCapacity);
            case 403:
                return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioAuthenticationRejected);
            case 409:
                return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.AudioCallAtCapacity);
            default:
                switch(Math.floor(status / 100)){
                    case 2:
                        return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.OK);
                    case 4:
                        return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingBadRequest);
                    case 5:
                        return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingInternalServerError);
                    default:
                        return new $df8473f70928eda9$var$MeetingSessionStatus($df8473f70928eda9$var$MeetingSessionStatusCode_1.default.SignalingRequestFailed);
                }
        }
    }
}
module.exports.default = $df8473f70928eda9$var$MeetingSessionStatus;

});

parcelRegister("98lxz", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[MeetingSessionVideoAvailability]] contains the video availability information.
 */ class $6a6591e2ecbc34fb$var$MeetingSessionVideoAvailability {
    constructor(){
        /**
         * Indicates whether one or more remote video streams
         * are available for streaming. This can be used to decide whether or not to
         * switch the connection type to include video.
         */ this.remoteVideoAvailable = false;
        /**
         * Indicates whether the server has a slot available for
         * this client's local video tile. If the client is already sending a local
         * video tile, then this will be true. This property can be used to decide
         * whether to offer the option to start the local video tile.
         */ this.canStartLocalVideo = false;
    }
    /**
     * Returns whether the fields are the same as that of another availability object.
     */ equal(other) {
        return this.remoteVideoAvailable === other.remoteVideoAvailable && this.canStartLocalVideo === other.canStartLocalVideo;
    }
    /**
     * Returns a deep copy of this object.
     */ clone() {
        const cloned = new $6a6591e2ecbc34fb$var$MeetingSessionVideoAvailability();
        cloned.remoteVideoAvailable = this.remoteVideoAvailable;
        cloned.canStartLocalVideo = this.canStartLocalVideo;
        return cloned;
    }
}
module.exports.default = $6a6591e2ecbc34fb$var$MeetingSessionVideoAvailability;

});

parcelRegister("7yFRY", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * MeetingSessionTimingManager tracks all lifecycle timestamps for a meeting session
 * and emits them in batches via the observer.
 *
 * A batch begins when the first event is recorded (e.g. onStart, onRemoteVideoAdded)
 * and completes when all tracked categories have reached their terminal state
 * (e.g. signaling fully connected, audio first packet received, video first frame
 * rendered). If a batch does not complete within TIMEOUT_THRESHOLD_MS (15 s),
 * it is emitted with per-category timedOut flags.
 *
 * After each emission, already-reported state is cleared so that subsequent events
 * (e.g. a mid-call remote video add) trigger a new batch containing only new data.
 *
 * Categories are only included in a batch if their corresponding on*Added method
 * was called. For example, if local video is never started, the batch will not
 * wait for local video timing. Remote video entries that were never bound to a
 * video element are silently omitted.
 */ class $580c2fced9f9ba44$var$MeetingSessionTimingManager {
    constructor(logger){
        this.observers = new Set();
        this.batchTimeout = null;
        this.signalingTiming = {};
        this.isResubscribe = false;
        this.remoteAudioTiming = {};
        this.localAudioTiming = {};
        this.localVideoTiming = {};
        this.localVideoHasEmitted = false;
        this.expectingRemoteVideo = false;
        this.remoteVideoTiming = new Map();
        this.boundRemoteVideoGroupIds = new Set();
        this.emittedRemoteVideoGroupIds = new Set();
        this.logger = logger;
    }
    /**
     * Adds an observer to receive timing data notifications.
     */ addObserver(observer) {
        this.observers.add(observer);
    }
    removeObserver(observer) {
        this.observers.delete(observer);
    }
    /**
     * Starts the batch timer if not already started.
     * Called by onStart() and any on*Added() method.
     */ startBatchIfNeeded() {
        if (this.batchTimeout === null) this.scheduleBatchTimeout();
    }
    /**
     * Records the timestamp when audioVideo.start() was called.
     */ onStart() {
        if (this.signalingTiming.startMs !== undefined) {
            this.logger.debug('onStart called multiple times, ignoring');
            return;
        }
        this.signalingTiming.startMs = this.getCurrentTimestamp();
        this.startBatchIfNeeded();
        this.logger.info(`MeetingSessionTimingManager: onStart at ${this.signalingTiming.startMs}`);
    }
    /**
     * Starts a resubscribe signaling timing entry.
     * Used for mid-meeting resubscribes (e.g. new remote video joins) to capture
     * the resubscribe latency (subscribe sent → ack → set remote description).
     * Only the resubscribe-relevant signaling fields are required for completion.
     */ onResubscribeStart() {
        if (this.signalingTiming.startMs !== undefined) {
            this.logger.debug('onResubscribeStart: signaling timing already active, ignoring');
            return;
        }
        this.isResubscribe = true;
        this.signalingTiming.startMs = this.getCurrentTimestamp();
        this.startBatchIfNeeded();
        this.logger.debug(`MeetingSessionTimingManager: resubscribe started at ${this.signalingTiming.startMs}`);
    }
    /**
     * Indicates that remote video is expected in the current batch.
     * The batch will not complete until at least one remote video entry
     * has been added and completed (or the batch times out).
     *
     * This method exists because the SDK's initial subscribe does not include
     * remote video — index ingestion is paused during the first subscribe,
     * so the downlink policy cannot select video streams until the connection
     * is established and a second subscribe (resubscribe) is triggered.
     */ setExpectingRemoteVideo() {
        if (this.expectingRemoteVideo) return;
        this.expectingRemoteVideo = true;
        this.logger.debug('MeetingSessionTimingManager: expecting remote video in current batch');
    }
    /**
     * Clears the expectation that remote video will be part of the current batch.
     * Called when the downlink policy decides not to subscribe to any video,
     * so the batch is not held open waiting for remote video that will never arrive.
     */ clearExpectingRemoteVideo() {
        if (!this.expectingRemoteVideo) return;
        this.expectingRemoteVideo = false;
        this.logger.debug('MeetingSessionTimingManager: no longer expecting remote video');
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when join frame was sent.
     */ onJoinSent() {
        if (this.signalingTiming.startMs === undefined) {
            this.logger.debug('Received join sent event after initial batch was sent, ignoring');
            return;
        }
        if (this.signalingTiming.joinSentMs !== undefined) {
            this.logger.debug('onJoinSent called multiple times, ignoring');
            return;
        }
        this.signalingTiming.joinSentMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when join ack was received.
     */ onJoinAckReceived() {
        if (this.signalingTiming.startMs === undefined) {
            this.logger.debug('Received join ack event after initial batch was sent, ignoring');
            return;
        }
        if (this.signalingTiming.joinAckReceivedMs !== undefined) {
            this.logger.debug('onJoinAckReceived called multiple times, ignoring');
            return;
        }
        this.signalingTiming.joinAckReceivedMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when signaling WebSocket connection was established.
     */ onTransportConnected() {
        if (this.signalingTiming.startMs === undefined) {
            this.logger.debug('Received transport connected event after initial batch was sent, ignoring');
            return;
        }
        if (this.signalingTiming.transportConnectedMs !== undefined) {
            this.logger.debug('onTransportConnected called multiple times, ignoring');
            return;
        }
        this.signalingTiming.transportConnectedMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when SDP offer was created.
     */ onCreateOfferCalled() {
        if (this.signalingTiming.startMs === undefined) {
            this.logger.debug('Received create offer event after initial batch was sent, ignoring');
            return;
        }
        if (this.signalingTiming.createOfferMs !== undefined) {
            this.logger.debug('onCreateOfferCalled called multiple times, ignoring');
            return;
        }
        this.signalingTiming.createOfferMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when local description was set.
     */ onSetLocalDescription() {
        if (this.signalingTiming.startMs === undefined) {
            this.logger.debug('Received set local description event after initial batch was sent, ignoring');
            return;
        }
        if (this.signalingTiming.setLocalDescriptionMs !== undefined) {
            this.logger.debug('onSetLocalDescription called multiple times, ignoring');
            return;
        }
        this.signalingTiming.setLocalDescriptionMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when remote description was set.
     */ onSetRemoteDescription() {
        if (this.signalingTiming.startMs === undefined) {
            this.logger.debug('Received set remote description event after initial batch was sent, ignoring');
            return;
        }
        if (this.signalingTiming.setRemoteDescriptionMs !== undefined) {
            this.logger.debug('onSetRemoteDescription called multiple times, ignoring');
            return;
        }
        this.signalingTiming.setRemoteDescriptionMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when ICE gathering started.
     */ onIceGatheringStarted() {
        if (this.signalingTiming.startMs === undefined) {
            this.logger.debug('Received ICE gathering started event after initial batch was sent, ignoring');
            return;
        }
        if (this.signalingTiming.iceGatheringStartMs !== undefined) {
            this.logger.debug('onIceGatheringStarted called multiple times, ignoring');
            return;
        }
        this.signalingTiming.iceGatheringStartMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when ICE gathering completed.
     */ onIceGatheringComplete() {
        if (this.signalingTiming.startMs === undefined) {
            this.logger.debug('Received ICE gathering complete event after initial batch was sent, ignoring');
            return;
        }
        if (this.signalingTiming.iceGatheringCompleteMs !== undefined) {
            this.logger.debug('onIceGatheringComplete called multiple times, ignoring');
            return;
        }
        this.signalingTiming.iceGatheringCompleteMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when ICE connection was established.
     */ onIceConnected() {
        if (this.signalingTiming.startMs === undefined) {
            this.logger.debug('Received ICE connected event after initial batch was sent, ignoring');
            return;
        }
        if (this.signalingTiming.iceConnectedMs !== undefined) {
            this.logger.debug('onIceConnected called multiple times, ignoring');
            return;
        }
        this.signalingTiming.iceConnectedMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when subscribe frame was sent.
     */ onSubscribeSent() {
        if (this.signalingTiming.startMs === undefined) {
            this.logger.debug('Received subscribe sent event after initial batch was sent, ignoring');
            return;
        }
        if (this.signalingTiming.subscribeSentMs !== undefined) {
            this.logger.debug('onSubscribeSent called multiple times, ignoring');
            return;
        }
        this.signalingTiming.subscribeSentMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when subscribe ack was received.
     */ onSubscribeAckReceived() {
        if (this.signalingTiming.startMs === undefined) {
            this.logger.debug('Received subscribe ack event after initial batch was sent, ignoring');
            return;
        }
        if (this.signalingTiming.subscribeAckMs !== undefined) {
            this.logger.debug('onSubscribeAckReceived called multiple times, ignoring');
            return;
        }
        this.signalingTiming.subscribeAckMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when remote audio track was added.
     */ onRemoteAudioAdded() {
        if (this.remoteAudioTiming.addedMs !== undefined) {
            this.logger.debug('onRemoteAudioAdded called multiple times, ignoring');
            return;
        }
        this.remoteAudioTiming.addedMs = this.getCurrentTimestamp();
        this.startBatchIfNeeded();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when first audio packet was received.
     */ onRemoteAudioFirstPacketReceived() {
        if (this.remoteAudioTiming.addedMs === undefined) {
            this.logger.warn('Received remote audio first packet before audio was added, ignoring');
            return;
        }
        if (this.remoteAudioTiming.firstPacketReceivedMs !== undefined) {
            this.logger.debug('onRemoteAudioFirstPacketReceived called multiple times, ignoring');
            return;
        }
        this.remoteAudioTiming.firstPacketReceivedMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when local audio track was added.
     */ onLocalAudioAdded() {
        if (this.localAudioTiming.addedMs !== undefined) {
            this.logger.debug('onLocalAudioAdded called multiple times, ignoring');
            return;
        }
        this.localAudioTiming.addedMs = this.getCurrentTimestamp();
        this.startBatchIfNeeded();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when first audio packet was sent.
     */ onLocalAudioFirstPacketSent() {
        if (this.localAudioTiming.addedMs === undefined) {
            this.logger.warn('Received local audio first packet sent before audio was added, ignoring');
            return;
        }
        if (this.localAudioTiming.firstPacketSentMs !== undefined) {
            this.logger.debug('onLocalAudioFirstPacketSent called multiple times, ignoring');
            return;
        }
        this.localAudioTiming.firstPacketSentMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when local video track was added.
     */ onLocalVideoAdded() {
        if (this.localVideoTiming.addedMs !== undefined || this.localVideoHasEmitted) {
            this.logger.debug('onLocalVideoAdded called multiple times, ignoring');
            return;
        }
        this.localVideoTiming.addedMs = this.getCurrentTimestamp();
        this.startBatchIfNeeded();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when first video frame was sent.
     */ onLocalVideoFirstFrameSent() {
        if (this.localVideoTiming.addedMs === undefined) {
            this.logger.warn('Received local video first frame sent before video was added, ignoring');
            return;
        }
        if (this.localVideoTiming.firstFrameSentMs !== undefined) {
            this.logger.debug('onLocalVideoFirstFrameSent called multiple times, ignoring');
            return;
        }
        this.localVideoTiming.firstFrameSentMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Marks local video timing as removed and triggers batch completion check.
     * This allows the timing data to be emitted with the removed flag.
     */ onLocalVideoRemoved() {
        if (this.localVideoTiming.addedMs === undefined) {
            this.logger.debug('onLocalVideoRemoved called without prior add, ignoring');
            return;
        }
        this.localVideoTiming.removed = true;
        this.localVideoHasEmitted = false;
        this.logger.debug('Local video timing marked as removed');
        this.maybeEmitBatch();
    }
    /**
     * Starts tracking timing for a remote video subscription.
     * Records the added timestamp for the given group_id.
     * If a timer already exists for this group_id, it is replaced.
     *
     * @param groupId The group ID of the remote video subscription
     */ onRemoteVideoAdded(groupId) {
        if (this.emittedRemoteVideoGroupIds.has(groupId)) return;
        this.remoteVideoTiming.set(groupId, {
            addedMs: this.getCurrentTimestamp()
        });
        this.startBatchIfNeeded();
        this.logger.debug(`Remote video timer started for group_id=${groupId}`);
    }
    /**
     * Records that a remote video tile has been bound to a video element.
     * Only bound remote videos are included in timing emissions.
     * Unbound remote videos are silently omitted from the batch.
     *
     * @param groupId The group ID of the remote video subscription
     */ onRemoteVideoBound(groupId) {
        this.boundRemoteVideoGroupIds.add(groupId);
    }
    /**
     * Records that a remote video tile has been unbound from its video element.
     * The group ID is removed from the bound set so it no longer blocks batch emission.
     *
     * @param groupId The group ID of the remote video subscription
     */ onRemoteVideoUnbound(groupId) {
        this.boundRemoteVideoGroupIds.delete(groupId);
        this.emittedRemoteVideoGroupIds.delete(groupId);
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when first video packet was received for a group_id.
     * Only the first call for each group_id records the timestamp.
     * @param groupId The group ID of the remote video subscription
     */ onRemoteVideoFirstPacketReceived(groupId) {
        const state = this.remoteVideoTiming.get(groupId);
        if (!state) {
            this.logger.warn(`onRemoteVideoFirstPacketReceived: No timer found for group_id=${groupId}`);
            return;
        }
        if (state.firstPacketReceivedMs !== undefined) {
            this.logger.debug(`onRemoteVideoFirstPacketReceived called multiple times for group_id=${groupId}, ignoring`);
            return;
        }
        state.firstPacketReceivedMs = this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Records the timestamp when first video frame was rendered for a group_id.
     * @param groupId The group ID of the remote video subscription
     * @param metadata The VideoFrameCallbackMetadata from requestVideoFrameCallback, if available
     */ onRemoteVideoFirstFrameRendered(groupId, metadata) {
        const state = this.remoteVideoTiming.get(groupId);
        if (!state) {
            this.logger.warn(`onRemoteVideoFirstFrameRendered: No timer found for group_id=${groupId}`);
            return;
        }
        if (state.firstFrameRenderedMs !== undefined) {
            this.logger.debug(`onRemoteVideoFirstFrameRendered called multiple times for group_id=${groupId}, ignoring`);
            return;
        }
        // Use expectedDisplayTime from RVFC metadata when available for a more
        // accurate render timestamp; fall back to Date.now().
        state.firstFrameRenderedMs = (metadata === null || metadata === void 0 ? void 0 : metadata.expectedDisplayTime) !== undefined ? Math.round(performance.timeOrigin + metadata.expectedDisplayTime) : this.getCurrentTimestamp();
        this.maybeEmitBatch();
    }
    /**
     * Marks timing state for a remote video subscription as removed.
     * The timing data will be emitted with the removed flag.
     * @param groupId The group ID of the remote video subscription
     */ onRemoteVideoRemoved(groupId) {
        const state = this.remoteVideoTiming.get(groupId);
        if (state) {
            state.removed = true;
            this.emittedRemoteVideoGroupIds.delete(groupId);
            this.logger.debug(`Remote video timing marked as removed for group_id=${groupId}`);
            this.maybeEmitBatch();
        }
    }
    /**
     * Clears all timing state and resets the manager for a new session.
     * This should be called when starting a new meeting session.
     */ reset() {
        this.cancelBatchTimeout();
        this.signalingTiming = {};
        this.isResubscribe = false;
        this.remoteAudioTiming = {};
        this.localAudioTiming = {};
        this.localVideoTiming = {};
        this.localVideoHasEmitted = false;
        this.expectingRemoteVideo = false;
        this.remoteVideoTiming.clear();
        this.boundRemoteVideoGroupIds.clear();
        this.emittedRemoteVideoGroupIds.clear();
        this.logger.info('MeetingSessionTimingManager: reset');
    }
    /**
     * Stops the timeout check interval and cleans up resources.
     * This should be called when the meeting session ends.
     */ destroy() {
        this.cancelBatchTimeout();
        this.observers.clear();
        this.logger.info('MeetingSessionTimingManager: destroyed');
    }
    /**
     * Returns the current timestamp in milliseconds since epoch.
     */ getCurrentTimestamp() {
        return Date.now();
    }
    /**
     * Checks if signaling timing is complete.
     * Complete when all signaling timestamps are set.
     */ isSignalingComplete() {
        const s = this.signalingTiming;
        const resubscribeComplete = s.createOfferMs !== undefined && s.setLocalDescriptionMs !== undefined && s.subscribeSentMs !== undefined && s.subscribeAckMs !== undefined && s.setRemoteDescriptionMs !== undefined;
        /* istanbul ignore next */ if (this.isResubscribe) /* istanbul ignore next */ return resubscribeComplete;
        return resubscribeComplete && s.joinSentMs !== undefined && s.joinAckReceivedMs !== undefined && s.transportConnectedMs !== undefined && s.iceGatheringStartMs !== undefined && s.iceGatheringCompleteMs !== undefined && s.iceConnectedMs !== undefined;
    }
    /**
     * Checks if remote audio timing is complete.
     * Only checks added_ms && first_packet_received_ms.
     * first_frame_rendered_ms is optional (not required for completion).
     */ isRemoteAudioComplete() {
        return this.remoteAudioTiming.removed === true || this.remoteAudioTiming.addedMs !== undefined && this.remoteAudioTiming.firstPacketReceivedMs !== undefined;
    }
    /**
     * Checks if local audio timing is complete.
     * Only checks added_ms && first_packet_sent_ms.
     * first_frame_captured_ms is optional (not required for completion).
     */ isLocalAudioComplete() {
        return this.localAudioTiming.removed === true || this.localAudioTiming.addedMs !== undefined && this.localAudioTiming.firstPacketSentMs !== undefined;
    }
    /**
     * Checks if local video timing is complete.
     * Only checks added_ms && first_frame_sent_ms.
     * first_frame_captured_ms is optional.
     */ isLocalVideoComplete() {
        return this.localVideoTiming.removed === true || this.localVideoTiming.addedMs !== undefined && this.localVideoTiming.firstFrameSentMs !== undefined;
    }
    /**
     * Checks if a remote video timing entry is complete.
     * Complete when all three timestamps are set, or when removed.
     */ isRemoteVideoComplete(state) {
        return state.removed === true || state.addedMs !== undefined && state.firstFrameRenderedMs !== undefined;
    }
    /**
     * Checks if all batch timings are complete.
     * Each category is only required if its corresponding on*Added was called.
     */ areAllBatchTimingsComplete() {
        if (this.signalingTiming.startMs !== undefined && !this.isSignalingComplete()) return false;
        if (this.remoteAudioTiming.addedMs !== undefined && !this.isRemoteAudioComplete()) return false;
        if (this.localAudioTiming.addedMs !== undefined && !this.isLocalAudioComplete()) return false;
        if (this.localVideoTiming.addedMs !== undefined && !this.isLocalVideoComplete()) return false;
        // If we're expecting remote video, hold the batch until at least one
        // bound remote video entry has completed.
        if (this.expectingRemoteVideo) {
            let hasBoundComplete = false;
            for (const [groupId, state] of this.remoteVideoTiming)if (this.boundRemoteVideoGroupIds.has(groupId) && this.isRemoteVideoComplete(state)) {
                hasBoundComplete = true;
                break;
            }
            if (!hasBoundComplete) return false;
        }
        for (const [groupId, state] of this.remoteVideoTiming){
            if (!this.boundRemoteVideoGroupIds.has(groupId)) continue;
            if (!this.isRemoteVideoComplete(state)) return false;
        }
        return true;
    }
    /**
     * Checks if the batch is complete and emits if so.
     */ maybeEmitBatch() {
        if (this.areAllBatchTimingsComplete()) this.emitAndReset(false);
    }
    /**
     * Builds and notifies the observer with timing data, then clears
     * the reported state so future events start a fresh batch.
     */ emitAndReset(batchTimedOut) {
        const timing = this.buildMeetingSessionTiming(batchTimedOut);
        // Track that local video has been emitted so resubscribes don't re-add it
        if (this.localVideoTiming.addedMs !== undefined && this.isLocalVideoComplete() && !this.localVideoTiming.removed) this.localVideoHasEmitted = true;
        // Clear everything that was just reported
        this.clearReportedState();
        if (this.observers.size === 0) {
            this.logger.warn('MeetingSessionTimingManager: No observers set, timing data discarded');
            return;
        }
        for (const observer of this.observers)try {
            observer.onMeetingSessionTimingReady(timing);
        } catch (error) {
            this.logger.error(`MeetingSessionTimingManager: Error notifying observer: ${error}`);
        }
    }
    /**
     * Clears state that was included in the last emission so it is not re-sent.
     * Resets the batch timer so new events can start a fresh batch.
     */ clearReportedState() {
        this.cancelBatchTimeout();
        this.signalingTiming = {};
        this.isResubscribe = false;
        this.remoteAudioTiming = {};
        this.localAudioTiming = {};
        this.localVideoTiming = {};
        this.expectingRemoteVideo = false;
        // Preserve remote video entries that were not included in the emission.
        // An entry is emitted only if it is bound. Unemitted entries carry over
        // to the next batch so they can complete and be emitted later.
        const pendingVideos = new Map();
        const pendingBound = new Set();
        for (const [groupId, state] of this.remoteVideoTiming)if (!this.boundRemoteVideoGroupIds.has(groupId)) pendingVideos.set(groupId, state);
        else this.emittedRemoteVideoGroupIds.add(groupId);
        this.remoteVideoTiming = pendingVideos;
        this.boundRemoteVideoGroupIds = pendingBound;
        if (pendingVideos.size > 0) this.startBatchIfNeeded();
    }
    /**
     * Builds the MeetingSessionTiming structure from current state.
     * Per-struct timedOut flags: a struct is timed out if the batch timed out AND that struct is not complete.
     * @param batchTimedOut Whether the batch timed out
     */ buildMeetingSessionTiming(batchTimedOut) {
        const signaling = [];
        const remoteAudio = [];
        const localAudio = [];
        const localVideo = [];
        const remoteVideos = [];
        if (this.signalingTiming.startMs !== undefined) signaling.push({
            ...this.signalingTiming,
            timedOut: batchTimedOut && !this.isSignalingComplete()
        });
        if (this.remoteAudioTiming.addedMs !== undefined) remoteAudio.push({
            ...this.remoteAudioTiming,
            timedOut: batchTimedOut && !this.isRemoteAudioComplete()
        });
        if (this.localAudioTiming.addedMs !== undefined) localAudio.push({
            ...this.localAudioTiming,
            timedOut: batchTimedOut && !this.isLocalAudioComplete()
        });
        if (this.localVideoTiming.addedMs !== undefined) localVideo.push({
            ...this.localVideoTiming,
            timedOut: batchTimedOut && !this.isLocalVideoComplete()
        });
        for (const [groupId, state] of this.remoteVideoTiming)if (state.addedMs !== undefined && this.boundRemoteVideoGroupIds.has(groupId)) remoteVideos.push({
            ...state,
            groupId: groupId,
            timedOut: batchTimedOut && !this.isRemoteVideoComplete(state)
        });
        return {
            signaling: signaling,
            remoteAudio: remoteAudio,
            localAudio: localAudio,
            localVideo: localVideo,
            remoteVideos: remoteVideos
        };
    }
    scheduleBatchTimeout() {
        this.batchTimeout = setTimeout(()=>{
            this.batchTimeout = null;
            this.logger.warn('Batch timing timeout');
            this.emitAndReset(true);
        }, $580c2fced9f9ba44$var$MeetingSessionTimingManager.TIMEOUT_THRESHOLD_MS);
    }
    cancelBatchTimeout() {
        if (this.batchTimeout !== null) {
            clearTimeout(this.batchTimeout);
            this.batchTimeout = null;
        }
    }
}
$580c2fced9f9ba44$var$MeetingSessionTimingManager.TIMEOUT_THRESHOLD_MS = 15000;
module.exports.default = $580c2fced9f9ba44$var$MeetingSessionTimingManager;

});

parcelRegister("1IGkK", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $140abd1b9552b7aa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $140abd1b9552b7aa$var$AsyncScheduler_1 = $140abd1b9552b7aa$var$__importDefault((parcelRequire("4mLYP")));

const $140abd1b9552b7aa$var$IntervalScheduler_1 = $140abd1b9552b7aa$var$__importDefault((parcelRequire("4wGp7")));

const $140abd1b9552b7aa$var$SignalingClientEventType_1 = $140abd1b9552b7aa$var$__importDefault((parcelRequire("1lA8I")));

var $4huDn = parcelRequire("4huDn");

var $jfpqH = parcelRequire("jfpqH");
/**
 * [[DefaultPingPong]] implements the PingPong and SignalingClientObserver interface.
 */ class $140abd1b9552b7aa$var$DefaultPingPong {
    constructor(signalingClient, intervalMs, logger){
        this.signalingClient = signalingClient;
        this.intervalMs = intervalMs;
        this.logger = logger;
        this.observerQueue = new Set();
        this.consecutivePongsUnaccountedFor = 0;
        this.intervalScheduler = new $140abd1b9552b7aa$var$IntervalScheduler_1.default(this.intervalMs);
        this.pingId = 0;
    }
    addObserver(observer) {
        this.logger.info('adding a ping-pong observer');
        this.observerQueue.add(observer);
    }
    removeObserver(observer) {
        this.logger.info('removing a ping-pong observer');
        this.observerQueue.delete(observer);
    }
    forEachObserver(observerFunc) {
        for (const observer of this.observerQueue)$140abd1b9552b7aa$var$AsyncScheduler_1.default.nextTick(()=>{
            if (this.observerQueue.has(observer)) observerFunc(observer);
        });
    }
    start() {
        this.stop();
        this.signalingClient.registerObserver(this);
        if (this.signalingClient.ready()) this.startPingInterval();
    }
    stop() {
        this.stopPingInterval();
        this.signalingClient.removeObserver(this);
    }
    startPingInterval() {
        this.intervalScheduler.start(()=>{
            this.ping();
        });
        this.ping();
    }
    stopPingInterval() {
        this.intervalScheduler.stop();
        this.pingId = 0;
        this.consecutivePongsUnaccountedFor = 0;
    }
    ping() {
        if (this.consecutivePongsUnaccountedFor > 0) {
            this.logger.warn(`missed pong ${this.consecutivePongsUnaccountedFor} time(s)`);
            this.forEachObserver((observer)=>{
                $jfpqH.Maybe.of(observer.didMissPongs).map((f)=>f.bind(observer)(this.consecutivePongsUnaccountedFor));
            });
        }
        this.consecutivePongsUnaccountedFor += 1;
        this.pingId = this.pingId + 1 & 0xffffffff;
        const ping = $4huDn.SdkPingPongFrame.create();
        ping.pingId = this.pingId;
        ping.type = $4huDn.SdkPingPongType.PING;
        this.pingTimestampLocalMs = this.signalingClient.pingPong(ping);
        this.logger.debug(()=>{
            return `sent ping ${this.pingId}`;
        });
    }
    pong(pingId) {
        const pong = $4huDn.SdkPingPongFrame.create();
        pong.pingId = pingId;
        pong.type = $4huDn.SdkPingPongType.PONG;
        this.signalingClient.pingPong(pong);
    }
    handleSignalingClientEvent(event) {
        switch(event.type){
            case $140abd1b9552b7aa$var$SignalingClientEventType_1.default.WebSocketOpen:
                this.startPingInterval();
                break;
            case $140abd1b9552b7aa$var$SignalingClientEventType_1.default.WebSocketFailed:
            case $140abd1b9552b7aa$var$SignalingClientEventType_1.default.WebSocketError:
                this.logger.warn(`stopped pinging (${$140abd1b9552b7aa$var$SignalingClientEventType_1.default[event.type]})`);
                this.stopPingInterval();
                break;
            case $140abd1b9552b7aa$var$SignalingClientEventType_1.default.WebSocketClosing:
            case $140abd1b9552b7aa$var$SignalingClientEventType_1.default.WebSocketClosed:
                this.logger.info(`stopped pinging (${$140abd1b9552b7aa$var$SignalingClientEventType_1.default[event.type]})`);
                this.stopPingInterval();
                break;
            case $140abd1b9552b7aa$var$SignalingClientEventType_1.default.ReceivedSignalFrame:
                if (event.message.type !== $4huDn.SdkSignalFrame.Type.PING_PONG) break;
                if (event.message.pingPong.type === $4huDn.SdkPingPongType.PONG) {
                    const pingId = event.message.pingPong.pingId;
                    if (pingId !== this.pingId) {
                        this.logger.warn(`unexpected ping id ${pingId} (expected ${this.pingId})`);
                        break;
                    }
                    this.consecutivePongsUnaccountedFor = 0;
                    let pongTimestampRemoteMs;
                    if (typeof event.message.timestampMs === 'number') pongTimestampRemoteMs = event.message.timestampMs;
                    else break;
                    this.logger.debug(()=>{
                        return `received pong ${pingId} with timestamp ${pongTimestampRemoteMs}`;
                    });
                    const pongTimestampLocalMs = event.timestampMs;
                    const pingPongLocalIntervalMs = pongTimestampLocalMs - this.pingTimestampLocalMs;
                    const estimatedPingTimestampRemoteMs = Math.round(pongTimestampRemoteMs - pingPongLocalIntervalMs / 2);
                    const estimatedClockSkewMs = this.pingTimestampLocalMs - estimatedPingTimestampRemoteMs;
                    this.logger.info(`local clock skew estimate=${estimatedClockSkewMs}ms from ping-pong time=${pingPongLocalIntervalMs}ms`);
                    this.forEachObserver((observer)=>{
                        $jfpqH.Maybe.of(observer.didReceivePong).map((f)=>f.bind(observer)(pingId, estimatedClockSkewMs, pingPongLocalIntervalMs));
                    });
                } else this.pong(event.message.pingPong.pingId);
                break;
        }
    }
}
module.exports.default = $140abd1b9552b7aa$var$DefaultPingPong;

});

parcelRegister("epAu8", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $a7dfb3a570ebeeb8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $a7dfb3a570ebeeb8$var$DefaultTranscriptionController_1 = $a7dfb3a570ebeeb8$var$__importDefault((parcelRequire("apXux")));

var $9UH7r = parcelRequire("9UH7r");

const $a7dfb3a570ebeeb8$var$RealtimeState_1 = $a7dfb3a570ebeeb8$var$__importDefault((parcelRequire("8aBsU")));

const $a7dfb3a570ebeeb8$var$RealtimeVolumeIndicator_1 = $a7dfb3a570ebeeb8$var$__importDefault((parcelRequire("gGuUW")));
/**
 * [[DefaultRealtimeController]] is written to adhere to the following tenets to
 * make privacy and performance bugs significantly less likely.
 *
 * 1. Any call to the object is guaranteed to succeed from the caller's
 *    perspective to the maximum extent that this can be ensured. However, all
 *    failures of the object are reported as fatal errors. For example, if local
 *    mute fails, then that is a privacy issue and we must tear down the
 *    connection and try starting over.
 *
 * 2. State is owned by the object and is considered authoritative at all times.
 *    For example, if [[realtimeIsLocalAudioMuted]] is true then the user *is*
 *    muted.
 *
 * 3. Callbacks are fired synchronously and do their work synchronously. Any
 *    unnecessary asynchronous implementation only invites latency and
 *    increases the surface error for potential errors.
 *
 * 4. Mutation only occurs when state changes. All state-changing functions are
 *    idempotent.
 *
 * 5. Every conditional branch gets its own if statement and test coverage is
 *    100% for this object.
 *
 * 6. Function parameters and returns use primitives only (no classes or enums).
 *    This minimizes the number of dependencies that consumers have to take on
 *    and allows the object to be more easily wrapped. Values are normalized
 *    where possible.
 *
 * 7. The object takes no other non-realtime dependencies.
 *
 * 8. Interface functions begin with `realtime` to make boundaries between the
 *    RealtimeController interface and the UI or business logic explicit and
 *    auditable.
 *
 * 9. Local state overrides remote state but not vice-versa. For example, if
 *    locally muted with an active audio input and a remote state indicates the
 *    same user is unmuted because the muted state has not yet propagated, then
 *    the volume indicator update for the user would show the remote mute state
 *    as muted. However, if locally muted without an active audio input and a
 *    remote state indicates the user is unmuted (since they are dialed in), the
 *    remote state persists but does not override the local state so
 *    [[realtimeIsLocalAudioMuted]] still returns true.
 */ class $a7dfb3a570ebeeb8$var$DefaultRealtimeController {
    constructor(mediaStreamBroker, transcriptionController){
        this.mediaStreamBroker = mediaStreamBroker;
        this.state = new $a7dfb3a570ebeeb8$var$RealtimeState_1.default();
        this._transcriptionController = transcriptionController || new $a7dfb3a570ebeeb8$var$DefaultTranscriptionController_1.default(this);
    }
    realtimeSetLocalAttendeeId(attendeeId, externalUserId) {
        this.state.localAttendeeId = attendeeId;
        this.state.localExternalUserId = externalUserId;
    }
    realtimeSetAttendeeIdPresence(attendeeId, present, externalUserId, dropped, posInFrame) {
        try {
            if (present) this.state.attendeeIdToExternalUserId[attendeeId] = externalUserId;
            for (const fn of this.state.attendeeIdChangesCallbacks)fn(attendeeId, present, externalUserId, dropped, posInFrame);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeSubscribeToAttendeeIdPresence(callback) {
        try {
            this.state.attendeeIdChangesCallbacks.push(callback);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeUnsubscribeToAttendeeIdPresence(callback) {
        try {
            const index = this.state.attendeeIdChangesCallbacks.indexOf(callback);
            if (index !== -1) this.state.attendeeIdChangesCallbacks.splice(index, 1);
        } catch (e) {
            this.onError(e);
        }
    }
    // Muting
    realtimeSetCanUnmuteLocalAudio(canUnmute) {
        try {
            if (this.state.canUnmute === canUnmute) return;
            this.state.canUnmute = canUnmute;
            for (const fn of this.state.setCanUnmuteLocalAudioCallbacks)fn(canUnmute);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeSubscribeToSetCanUnmuteLocalAudio(callback) {
        try {
            this.state.setCanUnmuteLocalAudioCallbacks.push(callback);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeUnsubscribeToSetCanUnmuteLocalAudio(callback) {
        try {
            const index = this.state.setCanUnmuteLocalAudioCallbacks.indexOf(callback);
            if (index !== -1) this.state.setCanUnmuteLocalAudioCallbacks.splice(index, 1);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeCanUnmuteLocalAudio() {
        return this.state.canUnmute;
    }
    realtimeMuteLocalAudio() {
        if (this.state.muted) return;
        try {
            this.setAudioInputEnabled(false);
            this.state.muted = true;
            this.realtimeUpdateVolumeIndicator(this.state.localAttendeeId, null, null, null, this.state.localExternalUserId);
            for (const fn of this.state.muteAndUnmuteLocalAudioCallbacks)fn(true);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeUnmuteLocalAudio() {
        if (!this.state.muted) return true;
        if (!this.state.canUnmute) return false;
        try {
            this.setAudioInputEnabled(true);
            this.state.muted = false;
            this.realtimeUpdateVolumeIndicator(this.state.localAttendeeId, null, null, null, this.state.localExternalUserId);
            for (const fn of this.state.muteAndUnmuteLocalAudioCallbacks)fn(false);
            return true;
        } catch (e) {
            this.onError(e);
            return false;
        }
    }
    realtimeSubscribeToMuteAndUnmuteLocalAudio(callback) {
        try {
            this.state.muteAndUnmuteLocalAudioCallbacks.push(callback);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeUnsubscribeToMuteAndUnmuteLocalAudio(callback) {
        try {
            const index = this.state.muteAndUnmuteLocalAudioCallbacks.indexOf(callback);
            if (index !== -1) this.state.muteAndUnmuteLocalAudioCallbacks.splice(index, 1);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeIsLocalAudioMuted() {
        return this.state.muted;
    }
    // Volume Indicators
    realtimeSubscribeToVolumeIndicator(attendeeId, callback) {
        try {
            if (!this.state.volumeIndicatorCallbacks.hasOwnProperty(attendeeId)) this.state.volumeIndicatorCallbacks[attendeeId] = [];
            this.state.volumeIndicatorCallbacks[attendeeId].push(callback);
            this.sendVolumeIndicatorChange(attendeeId, true, true, true, this.state.attendeeIdToExternalUserId[attendeeId]);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeUnsubscribeFromVolumeIndicator(attendeeId, callback) {
        const callbacks = this.state.volumeIndicatorCallbacks[attendeeId];
        if (!callbacks) return;
        if (callback) {
            const index = this.state.volumeIndicatorCallbacks[attendeeId].indexOf(callback);
            if (index >= 0) this.state.volumeIndicatorCallbacks[attendeeId].splice(index, 1);
        } else delete this.state.volumeIndicatorCallbacks[attendeeId];
    }
    realtimeUpdateVolumeIndicator(attendeeId, volume, muted, signalStrength, externalUserId) {
        try {
            muted = this.applyLocalMuteOverride(attendeeId, muted);
            const state = this.getVolumeIndicatorState(attendeeId);
            let volumeUpdated = false;
            let mutedUpdated = false;
            let signalStrengthUpdated = false;
            if (muted !== null) {
                if (state.muted !== muted) {
                    state.muted = muted;
                    mutedUpdated = true;
                    if (state.muted && state.volume !== 0.0) {
                        state.volume = 0.0;
                        volumeUpdated = true;
                    }
                }
            }
            if (!state.muted && volume !== null) {
                if (state.volume !== volume) {
                    state.volume = volume;
                    volumeUpdated = true;
                }
                if (state.muted === null) {
                    state.muted = false;
                    mutedUpdated = true;
                }
            }
            if (signalStrength !== null) {
                if (state.signalStrength !== signalStrength) {
                    state.signalStrength = signalStrength;
                    signalStrengthUpdated = true;
                }
            }
            this.sendVolumeIndicatorChange(attendeeId, volumeUpdated, mutedUpdated, signalStrengthUpdated, externalUserId);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeSubscribeToLocalSignalStrengthChange(callback) {
        try {
            this.state.localSignalStrengthChangeCallbacks.push(callback);
            if (this.state.localAttendeeId === null) return;
            this.sendLocalSignalStrengthChange(this.state.localAttendeeId, true);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeUnsubscribeToLocalSignalStrengthChange(callback) {
        try {
            const index = this.state.localSignalStrengthChangeCallbacks.indexOf(callback);
            if (index !== -1) this.state.localSignalStrengthChangeCallbacks.splice(index, 1);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeSubscribeToSendDataMessage(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback) {
        try {
            this.state.sendDataMessageCallbacks.push(callback);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeUnsubscribeFromSendDataMessage(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback) {
        try {
            const index = this.state.sendDataMessageCallbacks.indexOf(callback);
            if (index !== -1) this.state.sendDataMessageCallbacks.splice(index, 1);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeSendDataMessage(topic, data, lifetimeMs) {
        try {
            for (const fn of this.state.sendDataMessageCallbacks)fn(topic, data, lifetimeMs);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeSubscribeToReceiveDataMessage(topic, callback) {
        try {
            if (this.state.receiveDataMessageCallbacks.has(topic)) this.state.receiveDataMessageCallbacks.get(topic).push(callback);
            else this.state.receiveDataMessageCallbacks.set(topic, [
                callback
            ]);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeUnsubscribeFromReceiveDataMessage(topic) {
        try {
            this.state.receiveDataMessageCallbacks.delete(topic);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeReceiveDataMessage(dataMessage) {
        try {
            (0, $9UH7r.iterateEvery)(this.state.receiveDataMessageCallbacks.get(dataMessage.topic), (fn)=>{
                fn(dataMessage);
            });
        } catch (e) {
            // We don't want to throw to our caller, but we still want to surface the error in the console
            Promise.reject(e);
        }
    }
    // Error Handling
    realtimeSubscribeToFatalError(callback) {
        try {
            this.state.fatalErrorCallbacks.push(callback);
        } catch (e) {
            this.onError(e);
        }
    }
    realtimeUnsubscribeToFatalError(callback) {
        try {
            const index = this.state.fatalErrorCallbacks.indexOf(callback);
            if (index !== -1) this.state.fatalErrorCallbacks.splice(index, 1);
        } catch (e) {
            this.onError(e);
        }
    }
    get transcriptionController() {
        return this._transcriptionController;
    }
    // Internals
    setAudioInputEnabled(enabled) {
        if (enabled) this.mediaStreamBroker.unmuteLocalAudioInputStream();
        else this.mediaStreamBroker.muteLocalAudioInputStream();
    }
    applyLocalMuteOverride(attendeeIdRemote, mutedRemote) {
        const attendeeIdLocal = this.state.localAttendeeId;
        const mutedLocal = this.state.muted;
        if (attendeeIdRemote !== attendeeIdLocal) return mutedRemote;
        // This is a workaround to check if no audio input then just use the remote value
        if (// @ts-ignore
        !('activeDevices' in this.mediaStreamBroker && this.mediaStreamBroker.activeDevices['audio'])) return mutedRemote;
        return mutedLocal;
    }
    sendVolumeIndicatorChange(attendeeId, volumeUpdated, mutedUpdated, signalStrengthUpdated, externalUserId) {
        this.sendLocalSignalStrengthChange(attendeeId, signalStrengthUpdated);
        if (!this.state.volumeIndicatorCallbacks.hasOwnProperty(attendeeId)) return;
        const state = this.getVolumeIndicatorState(attendeeId);
        const updateState = new $a7dfb3a570ebeeb8$var$RealtimeVolumeIndicator_1.default();
        if (volumeUpdated) updateState.volume = state.volume;
        if (mutedUpdated) updateState.muted = state.muted;
        if (signalStrengthUpdated) updateState.signalStrength = state.signalStrength;
        if (this.stateIsEmpty(updateState)) return;
        for (const fn of this.state.volumeIndicatorCallbacks[attendeeId])fn(attendeeId, updateState.volume, updateState.muted, updateState.signalStrength, externalUserId);
    }
    sendLocalSignalStrengthChange(attendeeId, signalStrengthUpdated) {
        if (!signalStrengthUpdated) return;
        if (attendeeId !== this.state.localAttendeeId) return;
        const state = this.getVolumeIndicatorState(attendeeId);
        const signalStrength = state.signalStrength;
        if (signalStrength === null) return;
        for (const fn of this.state.localSignalStrengthChangeCallbacks)fn(signalStrength);
    }
    getVolumeIndicatorState(id) {
        if (!this.state.volumeIndicatorState.hasOwnProperty(id)) this.state.volumeIndicatorState[id] = new $a7dfb3a570ebeeb8$var$RealtimeVolumeIndicator_1.default();
        return this.state.volumeIndicatorState[id];
    }
    stateIsEmpty(state) {
        return state.volume === null && state.muted === null && state.signalStrength === null;
    }
    onError(error) {
        try {
            // 1) try the fatal error callbacks so that the issue is reported in
            //    logs and to give the handler a chance to clean up and reset.
            for (const callback of this.state.fatalErrorCallbacks)callback(error);
        } catch (eventError) {
            try {
                // 2) if the error event fails, fall back to console.error so that
                //    it at least prints out to the console before moving on.
                console.error(error);
                console.error(eventError);
            } catch (consoleError) {
            // 3) if all else fails, swallow the error and give up to guarantee
            //    that the API call returns cleanly.
            }
        }
    }
}
module.exports.default = $a7dfb3a570ebeeb8$var$DefaultRealtimeController;

});
parcelRegister("apXux", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TRANSCRIPTION_DATA_MESSAGE_TOPIC = void 0;

var $jH1g5 = parcelRequire("jH1g5");
module.exports.TRANSCRIPTION_DATA_MESSAGE_TOPIC = 'aws:chime:transcription';
class $795a62fda90835a3$var$DefaultTranscriptionController {
    constructor(realtimeController){
        this.realtimeController = realtimeController;
        this.transcriptEventCallbacks = new Set();
    }
    subscribeToTranscriptEvent(callback) {
        if (this.transcriptEventCallbacks.size === 0) this.realtimeController.realtimeSubscribeToReceiveDataMessage(module.exports.TRANSCRIPTION_DATA_MESSAGE_TOPIC, (dataMessage)=>{
            for (const transcriptEvent of $jH1g5.TranscriptEventConverter.from(dataMessage))for (const transcriptEventCallback of this.transcriptEventCallbacks)transcriptEventCallback(transcriptEvent);
        });
        this.transcriptEventCallbacks.add(callback);
    }
    unsubscribeFromTranscriptEvent(callback) {
        this.transcriptEventCallbacks.delete(callback);
        if (this.transcriptEventCallbacks.size === 0) this.realtimeController.realtimeUnsubscribeFromReceiveDataMessage(module.exports.TRANSCRIPTION_DATA_MESSAGE_TOPIC);
    }
}
module.exports.default = $795a62fda90835a3$var$DefaultTranscriptionController;

});
parcelRegister("jH1g5", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $e5630262b1ae442e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriptEventConverter = void 0;

var $4huDn = parcelRequire("4huDn");

const $e5630262b1ae442e$var$Transcript_1 = $e5630262b1ae442e$var$__importDefault((parcelRequire("cvWJI")));

const $e5630262b1ae442e$var$TranscriptionStatus_1 = $e5630262b1ae442e$var$__importDefault((parcelRequire("yPcOn")));

const $e5630262b1ae442e$var$TranscriptionStatusType_1 = $e5630262b1ae442e$var$__importDefault((parcelRequire("1eK7h")));

const $e5630262b1ae442e$var$TranscriptItemType_1 = $e5630262b1ae442e$var$__importDefault((parcelRequire("6ECAu")));
const $e5630262b1ae442e$var$TranscriptionStatusTypes = {
    [$4huDn.SdkTranscriptionStatus.Type.STARTED]: $e5630262b1ae442e$var$TranscriptionStatusType_1.default.STARTED,
    [$4huDn.SdkTranscriptionStatus.Type.INTERRUPTED]: $e5630262b1ae442e$var$TranscriptionStatusType_1.default.INTERRUPTED,
    [$4huDn.SdkTranscriptionStatus.Type.RESUMED]: $e5630262b1ae442e$var$TranscriptionStatusType_1.default.RESUMED,
    [$4huDn.SdkTranscriptionStatus.Type.STOPPED]: $e5630262b1ae442e$var$TranscriptionStatusType_1.default.STOPPED,
    [$4huDn.SdkTranscriptionStatus.Type.FAILED]: $e5630262b1ae442e$var$TranscriptionStatusType_1.default.FAILED
};
class $e5630262b1ae442e$var$TranscriptEventConverter {
    /**
     * Decodes a list of TranscriptEvent from a data message.
     * @param dataMessage Data message to decode from
     * @returns List of TranscriptEvent
     * @throws {Error} If the data message payload cannot be decoded
     */ static from(dataMessage) {
        let frame;
        try {
            frame = $4huDn.SdkTranscriptFrame.decode(dataMessage.data);
        } catch (e) {
            throw new Error('Cannot decode transcript data message: ' + e);
        }
        const transcriptEvents = [];
        for (const sdkTranscriptEvent of frame.events){
            if (sdkTranscriptEvent.status) {
                const transcriptionStatusType = $e5630262b1ae442e$var$TranscriptionStatusTypes[sdkTranscriptEvent.status.type];
                if (!transcriptionStatusType) continue;
                const transcriptionStatus = new $e5630262b1ae442e$var$TranscriptionStatus_1.default();
                transcriptionStatus.type = transcriptionStatusType;
                transcriptionStatus.eventTimeMs = sdkTranscriptEvent.status.eventTime;
                transcriptionStatus.transcriptionRegion = sdkTranscriptEvent.status.transcriptionRegion;
                transcriptionStatus.transcriptionConfiguration = sdkTranscriptEvent.status.transcriptionConfiguration;
                if (sdkTranscriptEvent.status.message) transcriptionStatus.message = sdkTranscriptEvent.status.message;
                transcriptEvents.push(transcriptionStatus);
            } else if (sdkTranscriptEvent.transcript) {
                const transcript = new $e5630262b1ae442e$var$Transcript_1.default();
                transcript.results = [];
                for (const result of sdkTranscriptEvent.transcript.results){
                    const transcriptResult = {
                        channelId: result.channelId,
                        isPartial: result.isPartial,
                        resultId: result.resultId,
                        startTimeMs: result.startTime,
                        endTimeMs: result.endTime,
                        alternatives: []
                    };
                    if (result.languageCode) transcriptResult.languageCode = result.languageCode;
                    if (result.languageIdentification && result.languageIdentification.length > 0) {
                        transcriptResult.languageIdentification = [];
                        for (const languageIdentification of result.languageIdentification){
                            const transcriptLanguageWithScore = {
                                languageCode: languageIdentification.languageCode,
                                score: languageIdentification.score
                            };
                            transcriptResult.languageIdentification.push(transcriptLanguageWithScore);
                        }
                    }
                    for (const alternative of result.alternatives){
                        const transcriptAlternative = {
                            items: [],
                            transcript: alternative.transcript
                        };
                        for (const item of alternative.items){
                            const transcriptItem = {
                                content: item.content,
                                attendee: {
                                    attendeeId: item.speakerAttendeeId,
                                    externalUserId: item.speakerExternalUserId
                                },
                                startTimeMs: item.startTime,
                                endTimeMs: item.endTime,
                                type: null
                            };
                            if (item.vocabularyFilterMatch) transcriptItem.vocabularyFilterMatch = item.vocabularyFilterMatch;
                            if (item.hasOwnProperty('stable')) transcriptItem.stable = item.stable;
                            if (item.hasOwnProperty('confidence')) transcriptItem.confidence = item.confidence;
                            switch(item.type){
                                case $4huDn.SdkTranscriptItem.Type.PRONUNCIATION:
                                    transcriptItem.type = $e5630262b1ae442e$var$TranscriptItemType_1.default.PRONUNCIATION;
                                    break;
                                case $4huDn.SdkTranscriptItem.Type.PUNCTUATION:
                                    transcriptItem.type = $e5630262b1ae442e$var$TranscriptItemType_1.default.PUNCTUATION;
                                    break;
                            }
                            transcriptAlternative.items.push(transcriptItem);
                        }
                        for (const entity of alternative.entities){
                            if (!transcriptAlternative.entities) transcriptAlternative.entities = [];
                            const transcriptEntity = {
                                category: entity.category,
                                confidence: entity.confidence,
                                content: entity.content,
                                startTimeMs: entity.startTime,
                                endTimeMs: entity.endTime
                            };
                            if (entity.type) transcriptEntity.type = entity.type;
                            transcriptAlternative.entities.push(transcriptEntity);
                        }
                        transcriptResult.alternatives.push(transcriptAlternative);
                    }
                    transcript.results.push(transcriptResult);
                }
                transcriptEvents.push(transcript);
            }
        }
        return transcriptEvents;
    }
}
module.exports.TranscriptEventConverter = $e5630262b1ae442e$var$TranscriptEventConverter;

});
parcelRegister("cvWJI", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $91c5f11fcbb97e32$var$Transcript {
}
module.exports.default = $91c5f11fcbb97e32$var$Transcript;

});

parcelRegister("yPcOn", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $068ae576bf3daff5$var$TranscriptionStatus {
}
module.exports.default = $068ae576bf3daff5$var$TranscriptionStatus;

});

parcelRegister("1eK7h", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0e6adf0219c6d194$var$TranscriptionStatusType;
(function(TranscriptionStatusType) {
    TranscriptionStatusType["STARTED"] = "started";
    TranscriptionStatusType["INTERRUPTED"] = "interrupted";
    TranscriptionStatusType["RESUMED"] = "resumed";
    TranscriptionStatusType["STOPPED"] = "stopped";
    TranscriptionStatusType["FAILED"] = "failed";
})($0e6adf0219c6d194$var$TranscriptionStatusType || ($0e6adf0219c6d194$var$TranscriptionStatusType = {}));
module.exports.default = $0e6adf0219c6d194$var$TranscriptionStatusType;

});

parcelRegister("6ECAu", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4d84692a65d08e88$var$TranscriptItemType;
(function(TranscriptItemType) {
    TranscriptItemType["PRONUNCIATION"] = "pronunciation";
    TranscriptItemType["PUNCTUATION"] = "punctuation";
})($4d84692a65d08e88$var$TranscriptItemType || ($4d84692a65d08e88$var$TranscriptItemType = {}));
module.exports.default = $4d84692a65d08e88$var$TranscriptItemType;

});



parcelRegister("9UH7r", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $737aca94ce80e3e3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SuppressedError = void 0;
module.exports.wait = $737aca94ce80e3e3$var$wait;
module.exports.isIFramed = $737aca94ce80e3e3$var$isIFramed;
module.exports.toLowerCasePropertyNames = $737aca94ce80e3e3$var$toLowerCasePropertyNames;
module.exports.getDefaultAssetSpec = $737aca94ce80e3e3$var$getDefaultAssetSpec;
module.exports.getFormattedOffset = $737aca94ce80e3e3$var$getFormattedOffset;
module.exports.getRandomValues = $737aca94ce80e3e3$var$getRandomValues;
module.exports.iterateEvery = $737aca94ce80e3e3$var$iterateEvery;

const $737aca94ce80e3e3$var$Versioning_1 = $737aca94ce80e3e3$var$__importDefault((parcelRequire("c0dn0")));
function $737aca94ce80e3e3$var$wait(waitTimeMs) {
    return new Promise((resolve)=>setTimeout(resolve, waitTimeMs));
}
// This is impossible to adequately test in Node, so Istanbul ignore.
/* istanbul ignore next */ function $737aca94ce80e3e3$var$isIFramed() {
    var _a;
    // Same-origin iframes can check `nodeName`.
    // We can also check whether the parent window and the top window are the same.
    // Cross-origin iframes will throw on the `parent` check, so catch here.
    try {
        return ((_a = window.frameElement) === null || _a === void 0 ? void 0 : _a.nodeName) === 'IFRAME' || parent !== top;
    } catch (e) {
        // Very likely to be a cross-origin iframe.
        return true;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $737aca94ce80e3e3$var$toLowerCasePropertyNames(input) {
    if (input === null) return null;
    else if (typeof input !== 'object') return input;
    else if (Array.isArray(input)) return input.map($737aca94ce80e3e3$var$toLowerCasePropertyNames);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(input).reduce((result, key)=>{
        const value = input[key];
        const newValue = typeof value === 'object' ? $737aca94ce80e3e3$var$toLowerCasePropertyNames(value) : value;
        result[key.toLowerCase()] = newValue;
        return result;
    }, {});
}
/**
 * Based on the SDK version, return an asset group.
 *
 * @returns the default asset spec, based on the SDK version.
 */ function $737aca94ce80e3e3$var$getDefaultAssetSpec() {
    const version = $737aca94ce80e3e3$var$Versioning_1.default.sdkVersionSemVer;
    return {
        assetGroup: `sdk-${version.major}.${version.minor}`
    };
}
/**
 * Get UTC offset in (+|-)HH:mm format
 * E.g. For Asia/Calcutta timezone, +05:30 UTC offset value is returned
 */ function $737aca94ce80e3e3$var$getFormattedOffset(utcOffset) {
    const offset = Math.abs(utcOffset);
    const offsetOperator = utcOffset <= 0 ? '+' : '-';
    const offsetHours = Math.floor(offset / 60).toString().padStart(2, '0');
    const offsetMinutes = Math.floor(offset % 60).toString().padStart(2, '0');
    return `${offsetOperator}${offsetHours}:${offsetMinutes}`;
}
function $737aca94ce80e3e3$var$getRandomValues(buffer) {
    try {
        // Browser environment
        window.crypto.getRandomValues(buffer);
    } catch (error) {
        // Node environment for unit test
        const view = new DataView(buffer.buffer);
        view.setUint32(0, Math.trunc(Math.random() * 2 ** 32), true);
    }
}
/**
 * Shim for SuppressedError
 * https://github.com/tc39/proposal-explicit-resource-management?tab=readme-ov-file#the-suppressederror-error
 */ class $737aca94ce80e3e3$var$SuppressedError extends Error {
    constructor(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, suppressed, message){
        var _a;
        /* istanbul ignore next -- because coverage can't detect all the branches */ super(message !== null && message !== void 0 ? message : `${(_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : error}`);
        this.error = error;
        this.suppressed = suppressed;
    }
}
module.exports.SuppressedError = $737aca94ce80e3e3$var$SuppressedError;
/**
 * Run a callback over the set of all values, suppress any errors, and only throw after iteration completes.
 * @param iterable - The iterable to iterate over
 * @param callback - The callback to run on each iteration
 * @throws If any of the callbacks throw an error
 */ function $737aca94ce80e3e3$var$iterateEvery(iterable, callback) {
    if (!iterable) return;
    let suppressedError;
    for (const value of iterable)try {
        callback(value);
    } catch (err) {
        suppressedError = new $737aca94ce80e3e3$var$SuppressedError(err, suppressedError);
    }
    if (suppressedError) throw suppressedError;
}

});

parcelRegister("8aBsU", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[RealtimeState]] stores all realtime persistent state.
 */ class $5f2c51b80c86d99e$var$RealtimeState {
    constructor(){
        /**
         * Stores the attendee id of the current user
         */ this.localAttendeeId = null;
        /**
         * Stores the external user id of the current user
         */ this.localExternalUserId = null;
        /**
         * Callbacks to listen for attendee id changes
         */ this.attendeeIdChangesCallbacks = [];
        /**
         * Stores whether the user can transition from muted to unmuted
         */ this.canUnmute = true;
        /**
         * Callbacks to listen for changes to can-unmute local audio state
         */ this.setCanUnmuteLocalAudioCallbacks = [];
        /**
         * Stores whether the user is presently muted
         */ this.muted = false;
        /**
         * Callbacks to listen for local audio mutes and unmutes
         */ this.muteAndUnmuteLocalAudioCallbacks = [];
        /**
         * Stores per-attendee id volume indicator state
         */ this.volumeIndicatorState = {};
        /**
         * Stores attendee id to external user id mappings
         */ this.attendeeIdToExternalUserId = {};
        /**
         * Stores per-attendee id callbacks called when volume indicators change
         */ this.volumeIndicatorCallbacks = {};
        /**
         * Callbacks to listen for changes to local signal strength
         */ this.localSignalStrengthChangeCallbacks = [];
        /**
         * Callbacks to listen for fatal errors
         */ this.fatalErrorCallbacks = [];
        /**
         * Callbacks to trigger when sending message
         */ this.sendDataMessageCallbacks = [];
        /**
         * Callbacks to listen for receiving message from data channel based on given topic
         */ this.receiveDataMessageCallbacks = new Map();
    }
}
module.exports.default = $5f2c51b80c86d99e$var$RealtimeState;

});

parcelRegister("gGuUW", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[RealtimeVolumeIndicator]] stores the current volume, mute, and
 * signal strength for an attendee.
 */ class $c2588d2580cf21c3$var$RealtimeVolumeIndicator {
    constructor(){
        this.volume = null;
        this.muted = null;
        this.signalStrength = null;
    }
}
module.exports.default = $c2588d2580cf21c3$var$RealtimeVolumeIndicator;

});


parcelRegister("3MoWE", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k20WH = parcelRequire("k20WH");

var $d0ryC = parcelRequire("d0ryC");

var $hhMm7 = parcelRequire("hhMm7");

var $jl8zM = parcelRequire("jl8zM");
class $2c09345775364560$var$DefaultSessionStateController {
    constructor(logger){
        this.logger = logger;
        this.currentState = $hhMm7.SessionStateControllerState.NotConnected;
        this.deferredAction = null;
        this.deferredWork = null;
    }
    perform(action, work) {
        const state = this.currentState;
        if (state === $hhMm7.SessionStateControllerState.NotConnected && action === $k20WH.SessionStateControllerAction.Connect) this.transition($hhMm7.SessionStateControllerState.Connecting, action);
        else if (state === $hhMm7.SessionStateControllerState.Connecting && action === $k20WH.SessionStateControllerAction.Fail) this.transition($hhMm7.SessionStateControllerState.Disconnecting, action);
        else if (state === $hhMm7.SessionStateControllerState.Connecting && action === $k20WH.SessionStateControllerAction.FinishConnecting) this.transition($hhMm7.SessionStateControllerState.Connected, action);
        else if (state === $hhMm7.SessionStateControllerState.Connected && action === $k20WH.SessionStateControllerAction.Disconnect) this.transition($hhMm7.SessionStateControllerState.Disconnecting, action);
        else if (state === $hhMm7.SessionStateControllerState.Connected && action === $k20WH.SessionStateControllerAction.Reconnect) this.transition($hhMm7.SessionStateControllerState.Connecting, action);
        else if (state === $hhMm7.SessionStateControllerState.Connected && action === $k20WH.SessionStateControllerAction.Fail) this.transition($hhMm7.SessionStateControllerState.Disconnecting, action);
        else if (state === $hhMm7.SessionStateControllerState.Connected && action === $k20WH.SessionStateControllerAction.Update) this.transition($hhMm7.SessionStateControllerState.Updating, action);
        else if (state === $hhMm7.SessionStateControllerState.Updating && action === $k20WH.SessionStateControllerAction.Fail) this.transition($hhMm7.SessionStateControllerState.Disconnecting, action);
        else if (state === $hhMm7.SessionStateControllerState.Updating && action === $k20WH.SessionStateControllerAction.FinishUpdating) this.transition($hhMm7.SessionStateControllerState.Connected, action);
        else if (state === $hhMm7.SessionStateControllerState.Disconnecting && action === $k20WH.SessionStateControllerAction.FinishDisconnecting) this.transition($hhMm7.SessionStateControllerState.NotConnected, action);
        else if (this.canDefer(action)) {
            this.logger.info(`deferring transition from ${$hhMm7.SessionStateControllerState[this.currentState]} with ${$k20WH.SessionStateControllerAction[action]}`);
            this.deferAction(action, work);
            return $jl8zM.SessionStateControllerTransitionResult.DeferredTransition;
        } else {
            this.logger.warn(`no transition found from ${$hhMm7.SessionStateControllerState[this.currentState]} with ${$k20WH.SessionStateControllerAction[action]}`);
            return $jl8zM.SessionStateControllerTransitionResult.NoTransitionAvailable;
        }
        try {
            work();
        } catch (e) {
            this.logger.error(`error during state ${$hhMm7.SessionStateControllerState[this.currentState]} with action ${$k20WH.SessionStateControllerAction[action]}: ${e}`);
            this.logger.info(`rolling back transition to ${$hhMm7.SessionStateControllerState[state]}`);
            this.currentState = state;
            return $jl8zM.SessionStateControllerTransitionResult.TransitionFailed;
        }
        this.performDeferredAction();
        return $jl8zM.SessionStateControllerTransitionResult.Transitioned;
    }
    state() {
        return this.currentState;
    }
    transition(newState, action) {
        this.logger.info(`transitioning from ${$hhMm7.SessionStateControllerState[this.currentState]} to ${$hhMm7.SessionStateControllerState[newState]} with ${$k20WH.SessionStateControllerAction[action]}`);
        this.currentState = newState;
    }
    deferPriority(action) {
        switch(action){
            case $k20WH.SessionStateControllerAction.Disconnect:
                return $d0ryC.SessionStateControllerDeferPriority.VeryHigh;
            case $k20WH.SessionStateControllerAction.Fail:
                return $d0ryC.SessionStateControllerDeferPriority.High;
            case $k20WH.SessionStateControllerAction.Reconnect:
                return $d0ryC.SessionStateControllerDeferPriority.Medium;
            case $k20WH.SessionStateControllerAction.Update:
                return $d0ryC.SessionStateControllerDeferPriority.Low;
            default:
                return $d0ryC.SessionStateControllerDeferPriority.DoNotDefer;
        }
    }
    deferAction(action, work) {
        if (this.deferredAction !== null && this.deferPriority(this.deferredAction) > this.deferPriority(action)) return;
        this.deferredAction = action;
        this.deferredWork = work;
    }
    canDefer(action) {
        return this.deferPriority(action) !== $d0ryC.SessionStateControllerDeferPriority.DoNotDefer && (this.currentState === $hhMm7.SessionStateControllerState.Connecting || this.currentState === $hhMm7.SessionStateControllerState.Updating);
    }
    performDeferredAction() {
        if (!this.deferredAction) return;
        const deferredAction = this.deferredAction;
        const deferredWork = this.deferredWork;
        this.deferredAction = null;
        this.deferredWork = null;
        this.logger.info(`performing deferred action ${$k20WH.SessionStateControllerAction[deferredAction]}`);
        if (this.perform(deferredAction, deferredWork) !== $jl8zM.SessionStateControllerTransitionResult.Transitioned) this.logger.info(`unable to perform deferred action ${$k20WH.SessionStateControllerAction[deferredAction]} in state ${$hhMm7.SessionStateControllerState[this.currentState]}`);
    }
}
module.exports.default = $2c09345775364560$var$DefaultSessionStateController;

});
parcelRegister("k20WH", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SessionStateControllerAction = void 0;
/**
 * [[SessionStateControllerAction]] is a state-changing action to perform.
 */ var $e954ba569dd9c4a1$var$SessionStateControllerAction;
(function(SessionStateControllerAction) {
    SessionStateControllerAction[SessionStateControllerAction["Connect"] = 0] = "Connect";
    SessionStateControllerAction[SessionStateControllerAction["FinishConnecting"] = 1] = "FinishConnecting";
    SessionStateControllerAction[SessionStateControllerAction["Update"] = 2] = "Update";
    SessionStateControllerAction[SessionStateControllerAction["FinishUpdating"] = 3] = "FinishUpdating";
    SessionStateControllerAction[SessionStateControllerAction["Reconnect"] = 4] = "Reconnect";
    SessionStateControllerAction[SessionStateControllerAction["Disconnect"] = 5] = "Disconnect";
    SessionStateControllerAction[SessionStateControllerAction["Fail"] = 6] = "Fail";
    SessionStateControllerAction[SessionStateControllerAction["FinishDisconnecting"] = 7] = "FinishDisconnecting";
})($e954ba569dd9c4a1$var$SessionStateControllerAction || (module.exports.SessionStateControllerAction = $e954ba569dd9c4a1$var$SessionStateControllerAction = {}));
module.exports.default = $e954ba569dd9c4a1$var$SessionStateControllerAction;

});

parcelRegister("d0ryC", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SessionStateControllerDeferPriority = void 0;
/**
 * [[SessionStateControllerDeferPriority]] indicates the priority level of the action
 * being deferred. For example, stop is more important than update so if forced
 * to pick between the two stop should be chosen.
 */ var $9780a6c008987b30$var$SessionStateControllerDeferPriority;
(function(SessionStateControllerDeferPriority) {
    SessionStateControllerDeferPriority[SessionStateControllerDeferPriority["DoNotDefer"] = 0] = "DoNotDefer";
    SessionStateControllerDeferPriority[SessionStateControllerDeferPriority["Low"] = 1] = "Low";
    SessionStateControllerDeferPriority[SessionStateControllerDeferPriority["Medium"] = 2] = "Medium";
    SessionStateControllerDeferPriority[SessionStateControllerDeferPriority["High"] = 3] = "High";
    SessionStateControllerDeferPriority[SessionStateControllerDeferPriority["VeryHigh"] = 4] = "VeryHigh";
})($9780a6c008987b30$var$SessionStateControllerDeferPriority || (module.exports.SessionStateControllerDeferPriority = $9780a6c008987b30$var$SessionStateControllerDeferPriority = {}));
module.exports.default = $9780a6c008987b30$var$SessionStateControllerDeferPriority;

});

parcelRegister("hhMm7", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SessionStateControllerState = void 0;
/**
 * [[SessionStateControllerState]] reflects the current connection state of the session.
 */ var $c95988a610fe2448$var$SessionStateControllerState;
(function(SessionStateControllerState) {
    SessionStateControllerState[SessionStateControllerState["NotConnected"] = 0] = "NotConnected";
    SessionStateControllerState[SessionStateControllerState["Connecting"] = 1] = "Connecting";
    SessionStateControllerState[SessionStateControllerState["Connected"] = 2] = "Connected";
    SessionStateControllerState[SessionStateControllerState["Updating"] = 3] = "Updating";
    SessionStateControllerState[SessionStateControllerState["Disconnecting"] = 4] = "Disconnecting";
})($c95988a610fe2448$var$SessionStateControllerState || (module.exports.SessionStateControllerState = $c95988a610fe2448$var$SessionStateControllerState = {}));
module.exports.default = $c95988a610fe2448$var$SessionStateControllerState;

});

parcelRegister("jl8zM", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SessionStateControllerTransitionResult = void 0;
/**
 * Indicates the result of an attempted state transition.
 */ var $e146a18794804230$var$SessionStateControllerTransitionResult;
(function(SessionStateControllerTransitionResult) {
    /**
     * The transition was successful.
     */ SessionStateControllerTransitionResult[SessionStateControllerTransitionResult["Transitioned"] = 0] = "Transitioned";
    /**
     * No transition is available from the current state using that action.
     */ SessionStateControllerTransitionResult[SessionStateControllerTransitionResult["NoTransitionAvailable"] = 1] = "NoTransitionAvailable";
    /**
     * The transition will be tried on the next state.
     */ SessionStateControllerTransitionResult[SessionStateControllerTransitionResult["DeferredTransition"] = 2] = "DeferredTransition";
    /**
     * An unexpected error occurred while transitioning to the next state.
     */ SessionStateControllerTransitionResult[SessionStateControllerTransitionResult["TransitionFailed"] = 3] = "TransitionFailed";
})($e146a18794804230$var$SessionStateControllerTransitionResult || (module.exports.SessionStateControllerTransitionResult = $e146a18794804230$var$SessionStateControllerTransitionResult = {}));
module.exports.default = $e146a18794804230$var$SessionStateControllerTransitionResult;

});


parcelRegister("hBJoS", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $cd191be6cefbb8c1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $cd191be6cefbb8c1$var$DefaultBrowserBehavior_1 = $cd191be6cefbb8c1$var$__importDefault((parcelRequire("e2TuV")));

const $cd191be6cefbb8c1$var$TimeoutScheduler_1 = $cd191be6cefbb8c1$var$__importDefault((parcelRequire("gcRqk")));

var $4huDn = parcelRequire("4huDn");

var $9UH7r = parcelRequire("9UH7r");

const $cd191be6cefbb8c1$var$Versioning_1 = $cd191be6cefbb8c1$var$__importDefault((parcelRequire("c0dn0")));

const $cd191be6cefbb8c1$var$VideoQualityAdaptationPreference_1 = $cd191be6cefbb8c1$var$__importDefault((parcelRequire("lGCbE")));

const $cd191be6cefbb8c1$var$WebSocketReadyState_1 = $cd191be6cefbb8c1$var$__importDefault((parcelRequire("jJkQN")));

var $bRvcN = parcelRequire("bRvcN");

const $cd191be6cefbb8c1$var$SignalingClientEvent_1 = $cd191be6cefbb8c1$var$__importDefault((parcelRequire("5kwEl")));

const $cd191be6cefbb8c1$var$SignalingClientEventType_1 = $cd191be6cefbb8c1$var$__importDefault((parcelRequire("1lA8I")));
/**
 * [[DefaultSignalingClient]] implements the SignalingClient interface.
 */ class $cd191be6cefbb8c1$var$DefaultSignalingClient {
    constructor(webSocket, logger, meetingSessionTimingManager){
        this.webSocket = webSocket;
        this.logger = logger;
        this.meetingSessionTimingManager = meetingSessionTimingManager;
        this.closeEventHandler = (event)=>{
            this.resetConnection();
            this.sendEvent(new $cd191be6cefbb8c1$var$SignalingClientEvent_1.default(this, $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketClosed, null, event.code, event.reason, event.wasClean));
            this.serviceConnectionRequestQueue();
        };
        this.observerQueue = new Set();
        this.connectionRequestQueue = [];
        this.resetConnection();
        this.logger.debug(()=>'signaling client init');
        this.audioSessionId = this.generateNewAudioSessionId();
    }
    registerObserver(observer) {
        this.logger.debug(()=>'registering signaling client observer');
        this.observerQueue.add(observer);
    }
    removeObserver(observer) {
        this.logger.debug(()=>'removing signaling client observer');
        this.observerQueue.delete(observer);
    }
    openConnection(request) {
        this.logger.info('adding connection request to queue: ' + request.url());
        this.connectionRequestQueue.push(request);
        this.closeConnection();
    }
    pingPong(pingPongFrame) {
        this.logger.debug(()=>'sending ping');
        const message = $4huDn.SdkSignalFrame.create();
        message.type = $4huDn.SdkSignalFrame.Type.PING_PONG;
        message.pingPong = pingPongFrame;
        this.sendMessage(message);
        return message.timestampMs;
    }
    join(settings) {
        var _a, _b, _c, _d;
        this.logger.info('sending join');
        const joinFrame = $4huDn.SdkJoinFrame.create();
        joinFrame.protocolVersion = 2;
        joinFrame.flags = $4huDn.SdkJoinFlags.HAS_STREAM_UPDATE;
        const browserBehavior = settings.browserBehavior || new $cd191be6cefbb8c1$var$DefaultBrowserBehavior_1.default();
        const sdkClientDetails = {
            platformName: browserBehavior.name(),
            platformVersion: browserBehavior.version(),
            clientSource: $cd191be6cefbb8c1$var$Versioning_1.default.sdkName,
            chimeSdkVersion: $cd191be6cefbb8c1$var$Versioning_1.default.sdkVersion,
            clientUtcOffset: (0, $9UH7r.getFormattedOffset)(new Date().getTimezoneOffset())
        };
        const deviceModel = (_a = browserBehavior.deviceName) === null || _a === void 0 ? void 0 : _a.call(browserBehavior);
        const osName = (_b = browserBehavior.osName) === null || _b === void 0 ? void 0 : _b.call(browserBehavior);
        const osVersion = (_c = browserBehavior.osVersion) === null || _c === void 0 ? void 0 : _c.call(browserBehavior);
        if (deviceModel) sdkClientDetails.deviceModel = deviceModel;
        if (osName) sdkClientDetails.osName = osName;
        if (osVersion) sdkClientDetails.osVersion = osVersion;
        if (settings.applicationMetadata) {
            const { appName: appName, appVersion: appVersion } = settings.applicationMetadata;
            sdkClientDetails.appName = appName;
            sdkClientDetails.appVersion = appVersion;
        }
        joinFrame.clientDetails = $4huDn.SdkClientDetails.create(sdkClientDetails);
        joinFrame.audioSessionId = this.audioSessionId;
        joinFrame.wantsCompressedSdp = $cd191be6cefbb8c1$var$DefaultSignalingClient.CLIENT_SUPPORTS_COMPRESSION;
        joinFrame.disablePeriodicKeyframeRequestOnContentSender = settings.disablePeriodicKeyframeRequestOnContentSender;
        joinFrame.serverSideNetworkAdaption = (0, $bRvcN.convertServerSideNetworkAdaptionEnumToSignaled)(settings.serverSideNetworkAdaption);
        joinFrame.supportedServerSideNetworkAdaptions = settings.supportedServerSideNetworkAdaptions.map($bRvcN.convertServerSideNetworkAdaptionEnumToSignaled);
        joinFrame.wantsAllTemporalLayersInIndex = settings.wantsAllTemporalLayersInIndex;
        const message = $4huDn.SdkSignalFrame.create();
        message.type = $4huDn.SdkSignalFrame.Type.JOIN;
        message.join = joinFrame;
        this.sendMessage(message);
        (_d = this.meetingSessionTimingManager) === null || _d === void 0 || _d.onJoinSent();
    }
    subscribe(settings) {
        var _a;
        const subscribeFrame = $4huDn.SdkSubscribeFrame.create();
        subscribeFrame.sendStreams = [];
        subscribeFrame.sdpOffer = settings.sdpOffer;
        if (settings.connectionTypeHasVideo) subscribeFrame.receiveStreamIds = settings.receiveStreamIds;
        if (settings.audioHost) {
            subscribeFrame.audioCheckin = settings.audioCheckin;
            subscribeFrame.audioHost = settings.audioHost;
            subscribeFrame.audioMuted = settings.audioMuted;
            if (!settings.audioCheckin) {
                const audioStream = $4huDn.SdkStreamDescriptor.create();
                audioStream.mediaType = $4huDn.SdkStreamMediaType.AUDIO;
                audioStream.trackLabel = 'AmazonChimeExpressAudio';
                audioStream.attendeeId = settings.attendeeId;
                audioStream.streamId = 1;
                audioStream.groupId = 1;
                audioStream.framerate = 15;
                audioStream.maxBitrateKbps = 600;
                audioStream.avgBitrateBps = 400000;
                subscribeFrame.sendStreams.push(audioStream);
            }
        }
        subscribeFrame.compressedSdpOffer = settings.compressedSdpOffer;
        subscribeFrame.duplex = $4huDn.SdkStreamServiceType.RX;
        if (settings.localVideoEnabled) {
            subscribeFrame.duplex = $4huDn.SdkStreamServiceType.DUPLEX;
            for(let i = 0; i < settings.videoStreamDescriptions.length; i++){
                // Non-simulcast use DefaultVideoStreamIndex.localStreamDescriptions
                // which is the exact old behavior
                const streamDescription = settings.videoStreamDescriptions[i].clone();
                streamDescription.attendeeId = settings.attendeeId;
                subscribeFrame.sendStreams.push(streamDescription.toStreamDescriptor());
            }
        }
        if (settings.videoSubscriptionConfiguration.length > 0) subscribeFrame.videoSubscriptionConfiguration = settings.videoSubscriptionConfiguration.map(this.convertSignalingClientVideoSubscriptionConfiguration);
        const message = $4huDn.SdkSignalFrame.create();
        message.type = $4huDn.SdkSignalFrame.Type.SUBSCRIBE;
        message.sub = subscribeFrame;
        this.sendMessage(message);
        (_a = this.meetingSessionTimingManager) === null || _a === void 0 || _a.onSubscribeSent();
    }
    remoteVideoUpdate(addedOrUpdated, removed) {
        const remoteVideoUpdate = $4huDn.SdkRemoteVideoUpdateFrame.create();
        remoteVideoUpdate.addedOrUpdatedVideoSubscriptions = addedOrUpdated.map(this.convertSignalingClientVideoSubscriptionConfiguration);
        remoteVideoUpdate.removedVideoSubscriptionMids = removed;
        const message = $4huDn.SdkSignalFrame.create();
        message.type = $4huDn.SdkSignalFrame.Type.REMOTE_VIDEO_UPDATE;
        message.remoteVideoUpdate = remoteVideoUpdate;
        this.sendMessage(message);
    }
    convertSignalingClientVideoSubscriptionConfiguration(config) {
        const signalConfig = new $4huDn.SdkVideoSubscriptionConfiguration();
        signalConfig.mid = config.mid;
        signalConfig.attendeeId = config.attendeeId;
        signalConfig.streamId = config.streamId;
        signalConfig.groupId = config.groupId;
        signalConfig.priority = config.priority;
        signalConfig.targetBitrateKbps = config.targetBitrateKbps;
        switch(config.qualityAdaptationPreference){
            case $cd191be6cefbb8c1$var$VideoQualityAdaptationPreference_1.default.Balanced:
                signalConfig.qualityAdaptationPreference = $4huDn.SdkVideoQualityAdaptationPreference.BALANCED;
                break;
            case $cd191be6cefbb8c1$var$VideoQualityAdaptationPreference_1.default.MaintainFramerate:
                signalConfig.qualityAdaptationPreference = $4huDn.SdkVideoQualityAdaptationPreference.MAINTAIN_FRAMERATE;
                break;
            case $cd191be6cefbb8c1$var$VideoQualityAdaptationPreference_1.default.MaintainResolution:
                signalConfig.qualityAdaptationPreference = $4huDn.SdkVideoQualityAdaptationPreference.MAINTAIN_RESOLUTION;
                break;
            default:
                signalConfig.qualityAdaptationPreference = $4huDn.SdkVideoQualityAdaptationPreference.BALANCED;
        }
        return signalConfig;
    }
    leave() {
        const message = $4huDn.SdkSignalFrame.create();
        message.type = $4huDn.SdkSignalFrame.Type.LEAVE;
        message.leave = $4huDn.SdkLeaveFrame.create();
        this.sendMessage(message);
        this.logger.debug(()=>{
            return 'sent leave';
        });
    }
    sendClientMetrics(clientMetricFrame) {
        const message = $4huDn.SdkSignalFrame.create();
        message.type = $4huDn.SdkSignalFrame.Type.CLIENT_METRIC;
        message.clientMetric = clientMetricFrame;
        this.sendMessage(message);
    }
    sendDataMessage(messageFrame) {
        const message = $4huDn.SdkSignalFrame.create();
        message.type = $4huDn.SdkSignalFrame.Type.DATA_MESSAGE;
        message.dataMessage = messageFrame;
        this.sendMessage(message);
    }
    closeConnection() {
        var _a, _b;
        if (this.webSocket.readyState() !== $cd191be6cefbb8c1$var$WebSocketReadyState_1.default.None && this.webSocket.readyState() !== $cd191be6cefbb8c1$var$WebSocketReadyState_1.default.Closed) {
            this.isClosing = true;
            this.sendEvent(new $cd191be6cefbb8c1$var$SignalingClientEvent_1.default(this, $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketClosing, null));
            // Continue resetting the connection even if SDK does not receive the "close" event.
            const scheduler = new $cd191be6cefbb8c1$var$TimeoutScheduler_1.default($cd191be6cefbb8c1$var$DefaultSignalingClient.CLOSE_EVENT_TIMEOUT_MS);
            const handler = (event)=>{
                var _a, _b;
                /* istanbul ignore next */ (_b = (_a = this.webSocket).removeEventListener) === null || _b === void 0 || _b.call(_a, 'close', handler);
                scheduler.stop();
                this.closeEventHandler(event);
            };
            // Remove the existing close handler to prevent SDK from opening a new connection.
            /* istanbul ignore next */ (_b = (_a = this.webSocket).removeEventListener) === null || _b === void 0 || _b.call(_a, 'close', this.closeEventHandler);
            this.webSocket.addEventListener('close', handler);
            scheduler.start(()=>{
                // SDK has not received the "close" event on WebSocket for two seconds.
                //
                // We report it as a graceful close with no message as there should be no end-user
                // impact of this timeout, and we do not want to trigger any non-graceful disconnection handling
                // like reconnection.
                handler(new CloseEvent('close', {
                    wasClean: false,
                    code: 1005,
                    reason: '',
                    bubbles: false
                }));
            });
            this.webSocket.close();
        } else {
            this.logger.info('no existing signaling client connection needs closing');
            this.serviceConnectionRequestQueue();
        }
    }
    ready() {
        return this.webSocket.readyState() === $cd191be6cefbb8c1$var$WebSocketReadyState_1.default.Open && !this.isClosing && this.wasOpened;
    }
    mute(muted) {
        const message = $4huDn.SdkSignalFrame.create();
        message.type = $4huDn.SdkSignalFrame.Type.AUDIO_CONTROL;
        const audioControl = $4huDn.SdkAudioControlFrame.create();
        audioControl.muted = muted;
        message.audioControl = audioControl;
        this.sendMessage(message);
    }
    pause(streamIds) {
        const message = $4huDn.SdkSignalFrame.create();
        message.type = $4huDn.SdkSignalFrame.Type.PAUSE;
        message.pause = $4huDn.SdkPauseResumeFrame.create();
        message.pause.streamIds = streamIds;
        this.sendMessage(message);
    }
    resume(streamIds) {
        const message = $4huDn.SdkSignalFrame.create();
        message.type = $4huDn.SdkSignalFrame.Type.RESUME;
        message.pause = $4huDn.SdkPauseResumeFrame.create();
        message.pause.streamIds = streamIds;
        this.sendMessage(message);
    }
    resetConnection() {
        this.webSocket.destroy();
        this.wasOpened = false;
    }
    sendMessage(message) {
        message.timestampMs = Date.now();
        this.logger.debug(()=>`sending: ${JSON.stringify(message)}`);
        const buffer = this.prependWithFrameTypeRTC($4huDn.SdkSignalFrame.encode(message).finish());
        if (this.ready()) {
            if (!this.webSocket.send(buffer)) {
                this.sendEvent(new $cd191be6cefbb8c1$var$SignalingClientEvent_1.default(this, $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketSendMessageFailure, null));
                return;
            }
            this.sendEvent(new $cd191be6cefbb8c1$var$SignalingClientEvent_1.default(this, $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketSentMessage, null));
        } else this.sendEvent(new $cd191be6cefbb8c1$var$SignalingClientEvent_1.default(this, $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketSkippedMessage, null));
    }
    receiveMessage(inBuffer) {
        let message;
        try {
            message = $4huDn.SdkSignalFrame.decode(inBuffer);
        } catch (e) {
            this.logger.info(`failed to decode: ${inBuffer}`);
            this.sendEvent(new $cd191be6cefbb8c1$var$SignalingClientEvent_1.default(this, $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.ProtocolDecodeFailure, null));
            return;
        }
        this.logger.debug(()=>`received: ${JSON.stringify(message)}`);
        if (this.webSocket.readyState() === $cd191be6cefbb8c1$var$WebSocketReadyState_1.default.Open) this.sendEvent(new $cd191be6cefbb8c1$var$SignalingClientEvent_1.default(this, $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.ReceivedSignalFrame, message));
        else this.logger.info(`skipping notification of message since WebSocket is not open: ${JSON.stringify(message)}`);
    }
    stripFrameTypeRTC(inBuffer) {
        const frameType = inBuffer[0];
        // TODO: change server frame type to send 0x05
        if (frameType !== $cd191be6cefbb8c1$var$DefaultSignalingClient.FRAME_TYPE_RTC && frameType !== 0x02) this.logger.warn(`expected FrameTypeRTC for message but got ${frameType}`);
        return inBuffer.slice(1);
    }
    prependWithFrameTypeRTC(inBuffer) {
        const outBuffer = new Uint8Array(inBuffer.length + 1);
        outBuffer[0] = $cd191be6cefbb8c1$var$DefaultSignalingClient.FRAME_TYPE_RTC;
        outBuffer.set(inBuffer, 1);
        return outBuffer;
    }
    serviceConnectionRequestQueue() {
        if (this.connectionRequestQueue.length === 0) {
            this.logger.info('no connection requests to service');
            return;
        }
        const request = this.connectionRequestQueue.shift();
        this.logger.info(`opening connection to ${request.url()}`);
        this.isClosing = false;
        this.webSocket.create(request.url(), request.protocols());
        this.setUpEventListeners();
        this.sendEvent(new $cd191be6cefbb8c1$var$SignalingClientEvent_1.default(this, $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketConnecting, null));
    }
    sendEvent(event) {
        switch(event.type){
            case $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketMessage:
            case $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.ReceivedSignalFrame:
            case $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketSentMessage:
                this.logger.debug(()=>`notifying event: ${$cd191be6cefbb8c1$var$SignalingClientEventType_1.default[event.type]}`);
                break;
            case $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketSkippedMessage:
                this.logger.debug(()=>`notifying event: ${$cd191be6cefbb8c1$var$SignalingClientEventType_1.default[event.type]}, websocket state=${$cd191be6cefbb8c1$var$WebSocketReadyState_1.default[this.webSocket.readyState()]}`);
                break;
            case $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketClosed:
                this.logger.info(`Notifying event: ${$cd191be6cefbb8c1$var$SignalingClientEventType_1.default[event.type]}, 
              code: ${event.closeCode} reason: "${event.closeReason}" wasClean ${event.wasClean}`);
                break;
            default:
                this.logger.info(`notifying event: ${$cd191be6cefbb8c1$var$SignalingClientEventType_1.default[event.type]}`);
                break;
        }
        for (const observer of this.observerQueue)observer.handleSignalingClientEvent(event);
    }
    setUpEventListeners() {
        this.webSocket.addEventListener('open', ()=>{
            var _a;
            this.wasOpened = true;
            this.sendEvent(new $cd191be6cefbb8c1$var$SignalingClientEvent_1.default(this, $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketOpen, null));
            (_a = this.meetingSessionTimingManager) === null || _a === void 0 || _a.onTransportConnected();
        });
        this.webSocket.addEventListener('message', (event)=>{
            this.sendEvent(new $cd191be6cefbb8c1$var$SignalingClientEvent_1.default(this, $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketMessage, null));
            this.receiveMessage(this.stripFrameTypeRTC(new Uint8Array(event.data)));
        });
        this.webSocket.addEventListener('close', this.closeEventHandler);
        this.webSocket.addEventListener('error', ()=>{
            if (this.isClosing && !this.wasOpened) {
                this.logger.info('Signaling WebSocket ignoring error closing while connecting');
                return;
            }
            if (this.wasOpened) {
                this.logger.error('Signaling WebSocket received error while connected');
                this.sendEvent(new $cd191be6cefbb8c1$var$SignalingClientEvent_1.default(this, $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketError, null));
            } else {
                this.logger.error('Signaling WebSocket received error while connecting');
                this.sendEvent(new $cd191be6cefbb8c1$var$SignalingClientEvent_1.default(this, $cd191be6cefbb8c1$var$SignalingClientEventType_1.default.WebSocketFailed, null));
            }
        });
    }
    generateNewAudioSessionId() {
        const num = new Uint32Array(1);
        (0, $9UH7r.getRandomValues)(num);
        return num[0];
    }
    sendMeetingSessionTiming(timing) {
        const timingFrame = $4huDn.SdkMeetingSessionTimingFrame.create();
        timingFrame.signaling = timing.signaling.map((s)=>{
            return $4huDn.SdkMeetingSessionSignalingTiming.create({
                startMs: s.startMs,
                joinSentMs: s.joinSentMs,
                joinAckReceivedMs: s.joinAckReceivedMs,
                transportConnectedMs: s.transportConnectedMs,
                createOfferMs: s.createOfferMs,
                setLocalDescriptionMs: s.setLocalDescriptionMs,
                setRemoteDescriptionMs: s.setRemoteDescriptionMs,
                iceGatheringStartMs: s.iceGatheringStartMs,
                iceGatheringCompleteMs: s.iceGatheringCompleteMs,
                iceConnectedMs: s.iceConnectedMs,
                subscribeSentMs: s.subscribeSentMs,
                subscribeAckMs: s.subscribeAckMs,
                timedOut: s.timedOut
            });
        });
        timingFrame.remoteAudio = timing.remoteAudio.map((ra)=>{
            return $4huDn.SdkMeetingSessionRemoteAudioTiming.create({
                addedMs: ra.addedMs,
                firstPacketReceivedMs: ra.firstPacketReceivedMs,
                firstFrameRenderedMs: ra.firstFrameRenderedMs,
                timedOut: ra.timedOut,
                removed: ra.removed
            });
        });
        timingFrame.localAudio = timing.localAudio.map((la)=>{
            return $4huDn.SdkMeetingSessionLocalAudioTiming.create({
                addedMs: la.addedMs,
                firstFrameCapturedMs: la.firstFrameCapturedMs,
                firstPacketSentMs: la.firstPacketSentMs,
                timedOut: la.timedOut,
                removed: la.removed
            });
        });
        timingFrame.localVideo = timing.localVideo.map((lv)=>{
            return $4huDn.SdkMeetingSessionLocalVideoTiming.create({
                addedMs: lv.addedMs,
                firstFrameCapturedMs: lv.firstFrameCapturedMs,
                firstFrameSentMs: lv.firstFrameSentMs,
                timedOut: lv.timedOut,
                removed: lv.removed
            });
        });
        timingFrame.remoteVideos = timing.remoteVideos.map((rv)=>{
            return $4huDn.SdkMeetingSessionRemoteVideoTiming.create({
                groupId: rv.groupId,
                addedMs: rv.addedMs,
                firstPacketReceivedMs: rv.firstPacketReceivedMs,
                firstFrameRenderedMs: rv.firstFrameRenderedMs,
                timedOut: rv.timedOut,
                removed: rv.removed
            });
        });
        const message = $4huDn.SdkSignalFrame.create();
        message.type = $4huDn.SdkSignalFrame.Type.MEETING_SESSION_TIMING;
        message.meetingSessionTiming = timingFrame;
        this.sendMessage(message);
    }
    promoteToPrimaryMeeting(credentials) {
        const signaledCredentials = $4huDn.SdkMeetingSessionCredentials.create();
        signaledCredentials.attendeeId = credentials.attendeeId;
        signaledCredentials.externalUserId = credentials.externalUserId;
        signaledCredentials.joinToken = credentials.joinToken;
        const primaryMeetingJoin = $4huDn.SdkPrimaryMeetingJoinFrame.create();
        primaryMeetingJoin.credentials = signaledCredentials;
        const message = $4huDn.SdkSignalFrame.create();
        message.type = $4huDn.SdkSignalFrame.Type.PRIMARY_MEETING_JOIN;
        message.primaryMeetingJoin = primaryMeetingJoin;
        this.sendMessage(message);
    }
    demoteFromPrimaryMeeting() {
        const primaryMeetingLeave = $4huDn.SdkPrimaryMeetingLeaveFrame.create();
        const message = $4huDn.SdkSignalFrame.create();
        message.type = $4huDn.SdkSignalFrame.Type.PRIMARY_MEETING_LEAVE;
        message.primaryMeetingLeave = primaryMeetingLeave;
        this.sendMessage(message);
    }
}
$cd191be6cefbb8c1$var$DefaultSignalingClient.FRAME_TYPE_RTC = 0x5;
$cd191be6cefbb8c1$var$DefaultSignalingClient.CLOSE_EVENT_TIMEOUT_MS = 2000;
$cd191be6cefbb8c1$var$DefaultSignalingClient.CLIENT_SUPPORTS_COMPRESSION = true;
module.exports.default = $cd191be6cefbb8c1$var$DefaultSignalingClient;

});
parcelRegister("lGCbE", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VideoQualityAdaptationPreference = void 0;
/**
 * [[VideoQualityAdaptationPreference]] represents options in how to degrade/reduce quality when end-users
 * encounter network constraints that limit the bandwidth available to the SDK. Different resolutions and
 * framerates have different but sometimes similar bitrates (e.g. a 480p/30fps stream may have similar bitrate
 * to 720p/15fps), so the prefence selected will impact the visual experience of end-users on impairment and recovery,
 * as not all resolution/framerate combinations will be used.
 *
 * The SDK will follow the same path of resolution/framerate choices in recovery as it will during constraint.
 *
 * This preference will have no effect unless the sender is encoding in a way such that there
 * are both variable framerate and resolution options available. See the
 * [Priority based downlink policy guide](https://aws.github.io/amazon-chime-sdk-js/modules/prioritybased_downlink_policy.html)
 * for more detailed information and diagrams.
 */ var $fc9b2455fd707ec7$var$VideoQualityAdaptationPreference;
(function(VideoQualityAdaptationPreference) {
    /**
     * Compromises between reducing resolution and framerate, with a slight preference towards framerate
     * as framerate changes may be possible without a keyframe request to the sender. This value
     * should be used in most use cases.
     */ VideoQualityAdaptationPreference[VideoQualityAdaptationPreference["Balanced"] = 0] = "Balanced";
    /**
     * Give preference to framerate under network constraint. This can be used, e.g.
     * if the receiver is known to be displaying the video at a low resolution.
     */ VideoQualityAdaptationPreference[VideoQualityAdaptationPreference["MaintainFramerate"] = 1] = "MaintainFramerate";
    /**
     * Give preference to resolution under network constraint. This can be used, e.g.
     * for screen share, or camera feed from a conference room or class room, that
     * is displayed on a large screen
     */ VideoQualityAdaptationPreference[VideoQualityAdaptationPreference["MaintainResolution"] = 2] = "MaintainResolution";
})($fc9b2455fd707ec7$var$VideoQualityAdaptationPreference || (module.exports.VideoQualityAdaptationPreference = $fc9b2455fd707ec7$var$VideoQualityAdaptationPreference = {}));
module.exports.default = $fc9b2455fd707ec7$var$VideoQualityAdaptationPreference;

});

parcelRegister("jJkQN", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebSocketReadyState = void 0;
var $e5d264c1cf2dc37e$var$WebSocketReadyState;
(function(WebSocketReadyState) {
    WebSocketReadyState[WebSocketReadyState["None"] = 0] = "None";
    WebSocketReadyState[WebSocketReadyState["Connecting"] = 1] = "Connecting";
    WebSocketReadyState[WebSocketReadyState["Open"] = 2] = "Open";
    WebSocketReadyState[WebSocketReadyState["Closing"] = 3] = "Closing";
    WebSocketReadyState[WebSocketReadyState["Closed"] = 4] = "Closed";
})($e5d264c1cf2dc37e$var$WebSocketReadyState || (module.exports.WebSocketReadyState = $e5d264c1cf2dc37e$var$WebSocketReadyState = {}));
module.exports.default = $e5d264c1cf2dc37e$var$WebSocketReadyState;

});

parcelRegister("bRvcN", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServerSideNetworkAdaption = void 0;
module.exports.serverSideNetworkAdaptionIsNoneOrDefault = $8a2cd9b4c851df33$var$serverSideNetworkAdaptionIsNoneOrDefault;
module.exports.convertServerSideNetworkAdaptionEnumFromSignaled = $8a2cd9b4c851df33$var$convertServerSideNetworkAdaptionEnumFromSignaled;
module.exports.convertServerSideNetworkAdaptionEnumToSignaled = $8a2cd9b4c851df33$var$convertServerSideNetworkAdaptionEnumToSignaled;

var $4huDn = parcelRequire("4huDn");
/**
 * [[ServerSideNetworkAdaption]] represents additional server side features that can be enabled for network adaption.
 */ var $8a2cd9b4c851df33$var$ServerSideNetworkAdaption;
(function(ServerSideNetworkAdaption) {
    /**
     * This value will currently be overwritten to `BandwidthProbingAndRemoteVideoQualityAdaption`
     */ ServerSideNetworkAdaption[ServerSideNetworkAdaption["Default"] = 0] = "Default";
    /**
     * @deprecated: Please switch to 'BandwidthProbingAndRemoteVideoQualityAdaption'
     */ ServerSideNetworkAdaption[ServerSideNetworkAdaption["None"] = 1] = "None";
    /**
     * @deprecated: Please switch to 'BandwidthProbingAndRemoteVideoQualityAdaption'.
     */ ServerSideNetworkAdaption[ServerSideNetworkAdaption["BandwidthProbing"] = 2] = "BandwidthProbing";
    /**
     * Disable internal policy behavior and proxy priorities to server to automatically
     * switch, pause, or resume streams based on server calculated network constraints. This will
     * significantly improve response times when network constraints occur. This will also support the
     * features covered in `BandwidthProbing` though possibly with different implementation details.
     *
     * End users should overall see reduced video freezes, reduced broken audio, and reduced packet loss.
     * The value impacts response to network events and may lead to remote video pauses/downgrades
     * that did not occur before.
     */ ServerSideNetworkAdaption[ServerSideNetworkAdaption["BandwidthProbingAndRemoteVideoQualityAdaption"] = 3] = "BandwidthProbingAndRemoteVideoQualityAdaption";
})($8a2cd9b4c851df33$var$ServerSideNetworkAdaption || (module.exports.ServerSideNetworkAdaption = $8a2cd9b4c851df33$var$ServerSideNetworkAdaption = {}));
module.exports.default = $8a2cd9b4c851df33$var$ServerSideNetworkAdaption;
function $8a2cd9b4c851df33$var$serverSideNetworkAdaptionIsNoneOrDefault(adaption) {
    return adaption === $8a2cd9b4c851df33$var$ServerSideNetworkAdaption.None || adaption === $8a2cd9b4c851df33$var$ServerSideNetworkAdaption.Default;
}
function $8a2cd9b4c851df33$var$convertServerSideNetworkAdaptionEnumFromSignaled(adaption) {
    switch(adaption){
        case $4huDn.SdkServerSideNetworkAdaption.DEFAULT:
            return $8a2cd9b4c851df33$var$ServerSideNetworkAdaption.Default;
        case $4huDn.SdkServerSideNetworkAdaption.NONE:
            return $8a2cd9b4c851df33$var$ServerSideNetworkAdaption.None;
        case $4huDn.SdkServerSideNetworkAdaption.BANDWIDTH_PROBING:
            return $8a2cd9b4c851df33$var$ServerSideNetworkAdaption.BandwidthProbing;
        case $4huDn.SdkServerSideNetworkAdaption.BANDWIDTH_PROBING_AND_VIDEO_QUALITY_ADAPTION:
            return $8a2cd9b4c851df33$var$ServerSideNetworkAdaption.BandwidthProbingAndRemoteVideoQualityAdaption;
    }
}
function $8a2cd9b4c851df33$var$convertServerSideNetworkAdaptionEnumToSignaled(adaption) {
    switch(adaption){
        case $8a2cd9b4c851df33$var$ServerSideNetworkAdaption.Default:
            return $4huDn.SdkServerSideNetworkAdaption.DEFAULT;
        case $8a2cd9b4c851df33$var$ServerSideNetworkAdaption.None:
            return $4huDn.SdkServerSideNetworkAdaption.NONE;
        case $8a2cd9b4c851df33$var$ServerSideNetworkAdaption.BandwidthProbing:
            return $4huDn.SdkServerSideNetworkAdaption.BANDWIDTH_PROBING;
        case $8a2cd9b4c851df33$var$ServerSideNetworkAdaption.BandwidthProbingAndRemoteVideoQualityAdaption:
            return $4huDn.SdkServerSideNetworkAdaption.BANDWIDTH_PROBING_AND_VIDEO_QUALITY_ADAPTION;
    }
}

});

parcelRegister("5kwEl", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $3e18259492a1ea7b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $3e18259492a1ea7b$var$SignalingClientEventType_1 = $3e18259492a1ea7b$var$__importDefault((parcelRequire("1lA8I")));
/*
 * [[SignalingClientEvent]] stores an event that can be sent to observers of the SignalingClient.
 */ class $3e18259492a1ea7b$var$SignalingClientEvent {
    /** Initializes a SignalingClientEvent with the given SignalingClientEventType.
     *
     * @param client Indicates the SignalingClient associated with the event.
     * @param type Indicates the kind of event.
     * @param message SdkSignalFrame if type is ReceivedSignalFrame
     */ constructor(client, type, message, closeCode, closeReason, wasClean){
        this.client = client;
        this.type = type;
        this.message = message;
        this.closeCode = closeCode;
        this.closeReason = closeReason;
        this.wasClean = wasClean;
        this.timestampMs = Date.now();
    }
    isConnectionTerminated() {
        switch(this.type){
            case $3e18259492a1ea7b$var$SignalingClientEventType_1.default.WebSocketFailed:
            case $3e18259492a1ea7b$var$SignalingClientEventType_1.default.WebSocketError:
            case $3e18259492a1ea7b$var$SignalingClientEventType_1.default.WebSocketClosing:
            case $3e18259492a1ea7b$var$SignalingClientEventType_1.default.WebSocketClosed:
                return true;
            default:
                return false;
        }
    }
}
module.exports.default = $3e18259492a1ea7b$var$SignalingClientEvent;

});


parcelRegister("ei9ii", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[SignalingClientVideoSubscriptionConfiguration]] is an internal representation of
 * `SignalingProtocol.videoSubscriptionConfiguration`
 */ class $a679f4ba0e310e77$var$SignalingClientVideoSubscriptionConfiguration {
    equals(other) {
        return other !== undefined && this.mid === other.mid && this.attendeeId === other.attendeeId && this.streamId === other.streamId && this.groupId === other.groupId && this.priority === other.priority && this.targetBitrateKbps === other.targetBitrateKbps && this.qualityAdaptationPreference === other.qualityAdaptationPreference;
    }
}
module.exports.default = $a679f4ba0e310e77$var$SignalingClientVideoSubscriptionConfiguration;

});

parcelRegister("7r1KG", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $569c69e966d5a998$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $569c69e966d5a998$var$ClientMetricReport_1 = $569c69e966d5a998$var$__importDefault((parcelRequire("dyoZi")));

const $569c69e966d5a998$var$ClientMetricReportDirection_1 = $569c69e966d5a998$var$__importDefault((parcelRequire("hRU3k")));

const $569c69e966d5a998$var$ClientMetricReportMediaType_1 = $569c69e966d5a998$var$__importDefault((parcelRequire("aU8Oy")));

const $569c69e966d5a998$var$RedundantAudioRecoveryMetricReport_1 = $569c69e966d5a998$var$__importDefault((parcelRequire("7dTR6")));

const $569c69e966d5a998$var$StreamMetricReport_1 = $569c69e966d5a998$var$__importDefault((parcelRequire("RnK9Z")));

const $569c69e966d5a998$var$MeetingSessionLifecycleEvent_1 = $569c69e966d5a998$var$__importDefault((parcelRequire("1b1mZ")));

const $569c69e966d5a998$var$MeetingSessionLifecycleEventCondition_1 = $569c69e966d5a998$var$__importDefault((parcelRequire("8wYaz")));

const $569c69e966d5a998$var$IntervalScheduler_1 = $569c69e966d5a998$var$__importDefault((parcelRequire("4wGp7")));

var $4huDn = parcelRequire("4huDn");

var $jfpqH = parcelRequire("jfpqH");

const $569c69e966d5a998$var$AudioLogEvent_1 = $569c69e966d5a998$var$__importDefault((parcelRequire("2R7XG")));

const $569c69e966d5a998$var$VideoLogEvent_1 = $569c69e966d5a998$var$__importDefault((parcelRequire("7Ydw6")));
/**
 * [[StatsCollector]] gathers statistics and sends metrics.
 */ class $569c69e966d5a998$var$StatsCollector {
    constructor(audioVideoController, logger, interval = $569c69e966d5a998$var$StatsCollector.INTERVAL_MS){
        this.audioVideoController = audioVideoController;
        this.logger = logger;
        this.interval = interval;
        this.intervalScheduler = null;
        this.redRecoveryMetricReport = new $569c69e966d5a998$var$RedundantAudioRecoveryMetricReport_1.default();
        this.lastRedRecoveryMetricReportConsumedTimestampMs = 0;
        this.videoCodecDegradationHighEncodeCpuCount = 0;
        this.videoCodecDegradationEncodeFailureCount = 0;
        this.videoCodecDegradationConcurrentSendersCount = 0;
        this.resolutionMap = new Map();
        this.remoteRenderFpsMap = new Map();
        this.encodedTransformMediaMetrics = null;
        this.encodedTransformMediaMetricsTimestamp = 0;
        // TODO: Implement metricsAddTime() and metricsLogEvent().
        this.metricsAddTime = (_name, _duration, _attributes)=>{};
        this.metricsLogEvent = (_name, _attributes)=>{};
    }
    // TODO: Update toAttribute() and toSuffix() methods to convert raw data to a required type.
    /**
     * Converts string to attribute format.
     */ toAttribute(str) {
        return this.toSuffix(str).substring(1);
    }
    /**
     * Converts string to suffix format.
     */ toSuffix(str) {
        if (str.toLowerCase() === str) // e.g. lower_case -> _lower_case
        return `_${str}`;
        else if (str.toUpperCase() === str) // e.g. UPPER_CASE -> _upper_case
        return `_${str.toLowerCase()}`;
        else // e.g. CamelCaseWithCAPS -> _camel_case_with_caps
        return str.replace(/([A-Z][a-z]+)/g, function($1) {
            return `_${$1}`;
        }).replace(/([A-Z][A-Z]+)/g, function($1) {
            return `_${$1}`;
        }).toLowerCase();
    }
    /**
     * Logs the latency.
     */ logLatency(eventName, timeMs, attributes) {
        const event = this.toSuffix(eventName);
        this.logEventTime('meeting' + event, timeMs, attributes);
    }
    /**
     * Logs the state timeout.
     */ logStateTimeout(stateName, attributes) {
        const state = this.toSuffix(stateName);
        this.logEvent('meeting_session_state_timeout', {
            ...attributes,
            state: `state${state}`
        });
    }
    /**
     * Logs the audio event.
     */ logAudioEvent(eventName, attributes) {
        const event = 'audio' + this.toSuffix($569c69e966d5a998$var$AudioLogEvent_1.default[eventName]);
        this.logEvent(event, attributes);
    }
    /**
     * Logs the video event.
     */ logVideoEvent(eventName, attributes) {
        const event = 'video' + this.toSuffix($569c69e966d5a998$var$VideoLogEvent_1.default[eventName]);
        this.logEvent(event, attributes);
    }
    logEventTime(eventName, timeMs, attributes = {}) {
        const finalAttributes = {
            ...attributes,
            call_id: this.audioVideoController.configuration.meetingId,
            client_type: $569c69e966d5a998$var$StatsCollector.CLIENT_TYPE,
            metric_type: 'latency'
        };
        this.logger.debug(()=>{
            return `[StatsCollector] ${eventName}: ${JSON.stringify(finalAttributes)}`;
        });
        this.metricsAddTime(eventName, timeMs, finalAttributes);
    }
    /**
     * Logs the session status.
     */ logMeetingSessionStatus(status) {
        // TODO: Generate the status event name given the status code.
        const statusEventName = `${status.statusCode()}`;
        this.logEvent(statusEventName);
        const statusAttribute = {
            status: statusEventName,
            status_code: `${status.statusCode()}`
        };
        this.logEvent('meeting_session_status', statusAttribute);
        if (status.isTerminal()) this.logEvent('meeting_session_stopped', statusAttribute);
        if (status.isAudioConnectionFailure()) this.logEvent('meeting_session_audio_failed', statusAttribute);
        if (status.isFailure()) this.logEvent('meeting_session_failed', statusAttribute);
    }
    /**
     * Logs the lifecycle event.
     */ logLifecycleEvent(lifecycleEvent, condition) {
        const attributes = {
            lifecycle_event: `lifecycle${this.toSuffix($569c69e966d5a998$var$MeetingSessionLifecycleEvent_1.default[lifecycleEvent])}`,
            lifecycle_event_code: `${lifecycleEvent}`,
            lifecycle_event_condition: `condition${this.toSuffix($569c69e966d5a998$var$MeetingSessionLifecycleEventCondition_1.default[condition])}`,
            lifecycle_event_condition_code: `${condition}`
        };
        this.logEvent('meeting_session_lifecycle', attributes);
    }
    /**
     * Logs the events.
     */ logEvent(eventName, attributes = {}) {
        const finalAttributes = {
            ...attributes,
            call_id: this.audioVideoController.configuration.meetingId,
            client_type: $569c69e966d5a998$var$StatsCollector.CLIENT_TYPE
        };
        this.logger.debug(()=>{
            return `[StatsCollector] ${eventName}: ${JSON.stringify(finalAttributes)}`;
        });
        this.metricsLogEvent(eventName, finalAttributes);
    }
    /**
     * Starts collecting statistics.
     */ start(signalingClient, videoStreamIndex) {
        if (this.intervalScheduler) return false;
        this.logger.info('Starting StatsCollector');
        this.signalingClient = signalingClient;
        this.videoStreamIndex = videoStreamIndex;
        this.clientMetricReport = new $569c69e966d5a998$var$ClientMetricReport_1.default(this.logger, this.videoStreamIndex, this.audioVideoController.configuration.credentials.attendeeId);
        this.intervalScheduler = new $569c69e966d5a998$var$IntervalScheduler_1.default(this.interval);
        this.intervalScheduler.start(async ()=>{
            await this.getStatsWrapper();
        });
        return true;
    }
    /*
     * Stops the stats collector.
     */ stop() {
        this.logger.info('Stopping StatsCollector');
        if (this.intervalScheduler) this.intervalScheduler.stop();
        this.intervalScheduler = null;
    }
    videoTileResolutionDidChange(attendeeId, newWidth, newHeight) {
        this.resolutionMap.set(attendeeId, {
            width: newWidth,
            height: newHeight
        });
    }
    videoTileUnbound(attendeeId, groupId) {
        this.resolutionMap.delete(attendeeId);
        if (groupId !== undefined) this.remoteRenderFpsMap.delete(groupId);
    }
    videoTileRenderMetricsDidReceive(groupId, metrics) {
        if (groupId === 0) return;
        this.remoteRenderFpsMap.set(groupId, metrics.fps);
    }
    /**
     * Convert raw metrics to client metric report.
     */ updateMetricValues(rawMetricReport, isStream) {
        const metricReport = isStream ? this.clientMetricReport.streamMetricReports[Number(rawMetricReport.ssrc)] : this.clientMetricReport.globalMetricReport;
        let metricMap;
        if (isStream) {
            const mediaType = metricReport.mediaType;
            const direction = metricReport.direction;
            metricMap = this.clientMetricReport.getMetricMap(mediaType, direction);
            if (mediaType === $569c69e966d5a998$var$ClientMetricReportMediaType_1.default.VIDEO && direction === $569c69e966d5a998$var$ClientMetricReportDirection_1.default.DOWNSTREAM) this.addRenderResolutionToVideoDownstreamMetrics(metricReport, rawMetricReport.ssrc);
        } else metricMap = this.clientMetricReport.getMetricMap();
        for(const rawMetric in rawMetricReport)if (rawMetric in metricMap) {
            if (typeof rawMetricReport[rawMetric] === 'number') {
                metricReport.previousMetrics[rawMetric] = metricReport.currentMetrics[rawMetric];
                metricReport.currentMetrics[rawMetric] = rawMetricReport[rawMetric];
            } else if (typeof rawMetricReport[rawMetric] === 'string') metricReport.currentStringMetrics[rawMetric] = rawMetricReport[rawMetric];
            else if (typeof rawMetricReport[rawMetric] === 'object') {
                metricReport.previousObjectMetrics[rawMetric] = metricReport.currentObjectMetrics[rawMetric] === undefined ? rawMetricReport[rawMetric] : metricReport.currentObjectMetrics[rawMetric];
                metricReport.currentObjectMetrics[rawMetric] = rawMetricReport[rawMetric];
            } else this.logger.error(`Unknown metric value type ${typeof rawMetricReport[rawMetric]} for metric ${rawMetric}`);
        }
    }
    /**
     * Converts RawMetricReport to StreamMetricReport and GlobalMetricReport and stores them as clientMetricReport.
     */ processRawMetricReports(rawMetricReports) {
        this.clientMetricReport.currentSsrcs = {};
        const timeStamp = Date.now();
        for (const rawMetricReport of rawMetricReports){
            if (this.isVideoSourceMetricReport(rawMetricReport)) continue;
            const isStream = this.isStreamRawMetricReport(rawMetricReport);
            if (isStream) {
                const existingStreamMetricReport = this.clientMetricReport.streamMetricReports[Number(rawMetricReport.ssrc)];
                if (!existingStreamMetricReport) {
                    const streamMetricReport = new $569c69e966d5a998$var$StreamMetricReport_1.default();
                    streamMetricReport.mediaType = this.getMediaType(rawMetricReport);
                    streamMetricReport.direction = this.getDirectionType(rawMetricReport);
                    if (streamMetricReport.mediaType === $569c69e966d5a998$var$ClientMetricReportMediaType_1.default.VIDEO && streamMetricReport.direction === $569c69e966d5a998$var$ClientMetricReportDirection_1.default.UPSTREAM) streamMetricReport.streamId = this.videoStreamIndex.sendVideoStreamIdFromRid(rawMetricReport.rid);
                    else if (!this.videoStreamIndex.allStreams().empty()) {
                        streamMetricReport.streamId = this.videoStreamIndex.streamIdForSSRC(Number(rawMetricReport.ssrc));
                        /* istanbul ignore else */ if (this.videoStreamIndex.groupIdForSSRC !== undefined) streamMetricReport.groupId = this.videoStreamIndex.groupIdForSSRC(Number(rawMetricReport.ssrc));
                    }
                    this.clientMetricReport.streamMetricReports[Number(rawMetricReport.ssrc)] = streamMetricReport;
                } else // Update stream ID in case we have overridden it locally in the case of remote video
                // updates completed without a negotiation
                if (existingStreamMetricReport.mediaType === $569c69e966d5a998$var$ClientMetricReportMediaType_1.default.VIDEO && existingStreamMetricReport.direction === $569c69e966d5a998$var$ClientMetricReportDirection_1.default.UPSTREAM) existingStreamMetricReport.streamId = this.videoStreamIndex.sendVideoStreamIdFromRid(rawMetricReport.rid);
                else existingStreamMetricReport.streamId = this.videoStreamIndex.streamIdForSSRC(Number(rawMetricReport.ssrc));
                this.clientMetricReport.currentSsrcs[Number(rawMetricReport.ssrc)] = 1;
            }
            this.updateMetricValues(rawMetricReport, isStream);
        }
        this.clientMetricReport.removeDestroyedSsrcs();
        this.clientMetricReport.previousTimestampMs = this.clientMetricReport.currentTimestampMs;
        this.clientMetricReport.currentTimestampMs = timeStamp;
        this.clientMetricReport.print();
    }
    /**
     *  Add stream metric dimension frames derived from metrics
     */ addStreamMetricDimensionFrames(streamMetricFrame, streamMetricReport) {
        const streamDimensionMap = this.clientMetricReport.getStreamDimensionMap();
        for(const metricName in streamMetricReport.currentStringMetrics)if (metricName in streamDimensionMap) {
            const dimensionFrame = $4huDn.SdkStreamDimension.create();
            dimensionFrame.type = streamDimensionMap[metricName];
            const dimensionValue = $4huDn.SdkDimensionValue.create();
            dimensionValue.stringValue = streamMetricReport.currentStringMetrics[metricName];
            dimensionFrame.value = dimensionValue;
            streamMetricFrame.dimensions.push(dimensionFrame);
        }
    }
    /**
     * Packages a metric into the MetricFrame.
     */ addMetricFrame(metricName, clientMetricFrame, metricSpec, ssrc) {
        const type = metricSpec.type;
        const transform = metricSpec.transform;
        const sourceMetric = metricSpec.source;
        const streamMetricFramesLength = clientMetricFrame.streamMetricFrames.length;
        const latestStreamMetricFrame = clientMetricFrame.streamMetricFrames[streamMetricFramesLength - 1];
        if (type) {
            const metricFrame = $4huDn.SdkMetric.create();
            metricFrame.type = type;
            metricFrame.value = sourceMetric ? transform(sourceMetric, ssrc) : transform(metricName, ssrc);
            ssrc ? latestStreamMetricFrame.metrics.push(metricFrame) : clientMetricFrame.globalMetrics.push(metricFrame);
        }
    }
    /**
     * Packages metrics in GlobalMetricReport into the MetricFrame.
     */ addGlobalMetricsToProtobuf(clientMetricFrame) {
        const metricMap = this.clientMetricReport.getMetricMap();
        for(const metricName in this.clientMetricReport.globalMetricReport.currentMetrics)this.addMetricFrame(metricName, clientMetricFrame, metricMap[metricName]);
    }
    /**
     * Packages metrics in StreamMetricReport into the MetricFrame.
     */ addStreamMetricsToProtobuf(clientMetricFrame) {
        for(const ssrc in this.clientMetricReport.streamMetricReports){
            const streamMetricReport = this.clientMetricReport.streamMetricReports[ssrc];
            const streamMetricFrame = $4huDn.SdkStreamMetricFrame.create();
            streamMetricFrame.streamId = streamMetricReport.streamId;
            streamMetricFrame.mediaType = streamMetricReport.mediaType === $569c69e966d5a998$var$ClientMetricReportMediaType_1.default.AUDIO ? $4huDn.SdkStreamMediaType.AUDIO : $4huDn.SdkStreamMediaType.VIDEO;
            streamMetricFrame.metrics = [];
            this.addStreamMetricDimensionFrames(streamMetricFrame, streamMetricReport);
            clientMetricFrame.streamMetricFrames.push(streamMetricFrame);
            const metricMap = this.clientMetricReport.getMetricMap(streamMetricReport.mediaType, streamMetricReport.direction);
            // We loop over 'metricMap' instead of the members of 'streamMetricReport' because
            // the latter does not include metrics (e.g. audio downstream 'decoderLoss') that are
            // entirely dependent on other metrics (in this case 'concealedSamples' and 'totalSamplesReceived')
            // for their calculation
            for(const metricName in metricMap)if (this.hasMetricDependenciesInReport(metricName, streamMetricReport)) this.addMetricFrame(metricName, clientMetricFrame, metricMap[metricName], Number(ssrc));
        }
    }
    hasMetricDependenciesInReport(metricName, streamMetricReport) {
        // Unfortunately the metrics maps do not expose their dependencies so we have to manually
        // hard code them for metrics we know have them
        const isSpecialMetricAndHasDependencies = metricName === 'decoderLoss' && streamMetricReport.currentMetrics['concealedSamples'] !== undefined && streamMetricReport.currentMetrics['totalSamplesReceived'] !== undefined || metricName === 'jitterBufferMs' && streamMetricReport.currentMetrics['jitterBufferDelay'] !== undefined && streamMetricReport.currentMetrics['jitterBufferEmittedCount'] !== undefined;
        return isSpecialMetricAndHasDependencies || metricName in streamMetricReport.currentMetrics || metricName in streamMetricReport.currentStringMetrics || metricName in streamMetricReport.currentObjectMetrics;
    }
    /**
     * Packages all metrics into the MetricFrame.
     */ makeClientMetricProtobuf() {
        const clientMetricFrame = $4huDn.SdkClientMetricFrame.create();
        clientMetricFrame.globalMetrics = [];
        clientMetricFrame.streamMetricFrames = [];
        this.addGlobalMetricsToProtobuf(clientMetricFrame);
        this.addStreamMetricsToProtobuf(clientMetricFrame);
        return clientMetricFrame;
    }
    /**
     * Sends the MetricFrame to media backend via ProtoBuf.
     */ sendClientMetricProtobuf(clientMetricFrame) {
        this.signalingClient.sendClientMetrics(clientMetricFrame);
    }
    /**
     * Checks if the type of RawMetricReport is stream related.
     */ isStreamRawMetricReport(rawMetricReport) {
        return [
            'inbound-rtp',
            'inbound-rtp-red',
            'inbound-rtp-transform',
            'outbound-rtp',
            'outbound-rtp-transform',
            'remote-inbound-rtp',
            'remote-outbound-rtp'
        ].includes(rawMetricReport.type) || this.isVideoSourceMetricReport(rawMetricReport);
    }
    /**
     * Returns the MediaType for a RawMetricReport.
     */ getMediaType(rawMetricReport) {
        return rawMetricReport.kind === 'audio' ? $569c69e966d5a998$var$ClientMetricReportMediaType_1.default.AUDIO : $569c69e966d5a998$var$ClientMetricReportMediaType_1.default.VIDEO;
    }
    /**
     * Returns the Direction for a RawMetricReport.
     */ getDirectionType(rawMetricReport) {
        const { type: type } = rawMetricReport;
        return type === 'inbound-rtp' || type === 'remote-outbound-rtp' || type === 'inbound-rtp-red' || type === 'inbound-rtp-transform' ? $569c69e966d5a998$var$ClientMetricReportDirection_1.default.DOWNSTREAM : $569c69e966d5a998$var$ClientMetricReportDirection_1.default.UPSTREAM;
    }
    /**
     * Checks if a RawMetricReport belongs to certain types.
     */ isValidStandardRawMetric(rawMetricReport) {
        return rawMetricReport.type === 'inbound-rtp' || rawMetricReport.type === 'inbound-rtp-red' || rawMetricReport.type === 'outbound-rtp' || rawMetricReport.type === 'remote-inbound-rtp' || rawMetricReport.type === 'remote-outbound-rtp' || rawMetricReport.type === 'candidate-pair' && rawMetricReport.state === 'succeeded' || rawMetricReport.type === 'media-source';
    }
    /**
     * Checks if a RawMetricReport is stream related.
     */ isValidSsrc(rawMetricReport) {
        let validSsrc = true;
        if (this.isStreamRawMetricReport(rawMetricReport) && this.getDirectionType(rawMetricReport) === $569c69e966d5a998$var$ClientMetricReportDirection_1.default.DOWNSTREAM && this.getMediaType(rawMetricReport) === $569c69e966d5a998$var$ClientMetricReportMediaType_1.default.VIDEO) validSsrc = this.videoStreamIndex.streamIdForSSRC(Number(rawMetricReport.ssrc)) > 0;
        return validSsrc;
    }
    /**
     * Checks if a RawMetricReport is valid.
     */ isValidRawMetricReport(rawMetricReport) {
        return this.isValidStandardRawMetric(rawMetricReport) && this.isValidSsrc(rawMetricReport);
    }
    /**
     * Filters RawMetricReports and keeps the required parts.
     */ filterRawMetricReports(rawMetricReports) {
        const filteredRawMetricReports = [];
        for (const rawMetricReport of rawMetricReports)if (this.isValidRawMetricReport(rawMetricReport)) filteredRawMetricReports.push(rawMetricReport);
        return filteredRawMetricReports;
    }
    /**
     * Performs a series operation on RawMetricReport.
     */ handleRawMetricReports(rawMetricReports) {
        const filteredRawMetricReports = this.filterRawMetricReports(rawMetricReports);
        this.logger.debug(()=>{
            return `Filtered raw metrics : ${JSON.stringify(filteredRawMetricReports)}`;
        });
        // Add custom stats for reporting.
        const customStatsReports = [];
        this.maybeAddRedRecoveryMetrics(customStatsReports);
        this.maybeAddTransformMetrics(customStatsReports);
        // We cannot use 'this.clientMetricsReport.getVideoUpstreamSsrc()' because the value
        // is dependent on the call to 'this.processRawMetricReports()' below, i.e. it depends on
        // the previous handling of raw metrics reports. This would lead to the addition of custom metrics
        // for streams that may no longer exist, e.g. after a reconnection, which will then stick around
        // perpetually
        const videoUpstreamSsrc = this.getVideoUpstreamSsrcFromRawMetricReports(filteredRawMetricReports);
        if (videoUpstreamSsrc !== null) this.addVideoCodecDegradationMetrics(customStatsReports, videoUpstreamSsrc);
        this.clientMetricReport.customStatsReports = customStatsReports;
        filteredRawMetricReports.push(...customStatsReports);
        this.processRawMetricReports(filteredRawMetricReports);
        this.updateVideoSourceMetrics(filteredRawMetricReports);
        const clientMetricFrame = this.makeClientMetricProtobuf();
        this.sendClientMetricProtobuf(clientMetricFrame);
        this.audioVideoController.forEachObserver((observer)=>{
            $jfpqH.Maybe.of(observer.metricsDidReceive).map((f)=>f.bind(observer)(this.clientMetricReport.clone()));
        });
    }
    /**
     * Gets raw WebRTC metrics.
     */ async getStatsWrapper() {
        if (!this.audioVideoController.rtcPeerConnection) return;
        const rawMetricReports = [];
        // @ts-ignore
        try {
            const report = await this.audioVideoController.rtcPeerConnection.getStats();
            this.clientMetricReport.rtcStatsReport = report;
            report.forEach((item)=>{
                rawMetricReports.push(item);
            });
            this.handleRawMetricReports(rawMetricReports);
        } catch (error) {
            this.logger.error(error.message);
        }
    }
    overrideObservableMetric(name, value) {
        this.clientMetricReport.overrideObservableMetric(name, value);
    }
    /**
     * Receives the red recovery metrics from DefaultTransceiver.
     */ recoveryMetricsDidReceive(metricReport) {
        this.redRecoveryMetricReport = metricReport;
    }
    /**
     * Receives media metrics from MediaMetricsTransformManager.
     */ encodedTransformMediaMetricsDidReceive(metrics) {
        this.encodedTransformMediaMetrics = metrics;
        this.encodedTransformMediaMetricsTimestamp = Date.now();
    }
    /**
     * Adds RED recovery metrics to the raw webrtc stats report.
     */ maybeAddRedRecoveryMetrics(customStatsReports) {
        if (this.redRecoveryMetricReport.currentTimestampMs === this.lastRedRecoveryMetricReportConsumedTimestampMs) // We have already sent the latest RED metrics.
        return;
        // @ts-ignore
        customStatsReports.push({
            kind: 'audio',
            type: 'inbound-rtp-red',
            ssrc: this.redRecoveryMetricReport.ssrc,
            timestamp: this.redRecoveryMetricReport.currentTimestampMs,
            totalAudioPacketsLost: this.redRecoveryMetricReport.totalAudioPacketsLost,
            totalAudioPacketsExpected: this.redRecoveryMetricReport.totalAudioPacketsExpected,
            totalAudioPacketsRecoveredRed: this.redRecoveryMetricReport.totalAudioPacketsRecoveredRed,
            totalAudioPacketsRecoveredFec: this.redRecoveryMetricReport.totalAudioPacketsRecoveredFec
        });
        this.lastRedRecoveryMetricReportConsumedTimestampMs = this.redRecoveryMetricReport.currentTimestampMs;
    }
    /**
     * Adds transform metrics (PPS) to the raw webrtc stats report.
     */ maybeAddTransformMetrics(customStatsReports) {
        if (!this.encodedTransformMediaMetrics) return;
        const timestamp = this.encodedTransformMediaMetricsTimestamp;
        const metrics = this.encodedTransformMediaMetrics;
        const configs = [
            {
                source: metrics.audioSendMetrics,
                kind: 'audio',
                type: 'outbound-rtp-transform',
                metricKey: 'audioSentTransformPps'
            },
            {
                source: metrics.audioReceiveMetrics,
                kind: 'audio',
                type: 'inbound-rtp-transform',
                metricKey: 'audioReceivedTransformPps'
            },
            {
                source: metrics.videoSendMetrics,
                kind: 'video',
                type: 'outbound-rtp-transform',
                metricKey: 'videoSentTransformPps'
            },
            {
                source: metrics.videoReceiveMetrics,
                kind: 'video',
                type: 'inbound-rtp-transform',
                metricKey: 'videoReceivedTransformPps'
            }
        ];
        for (const { source: source, kind: kind, type: type, metricKey: metricKey } of configs)for (const streamMetrics of Object.values(source))customStatsReports.push({
            kind: kind,
            type: type,
            ssrc: streamMetrics.ssrc,
            timestamp: timestamp,
            [metricKey]: streamMetrics.packetCount
        });
    }
    /**
     * Receive video codec degradation event due to high encode CPU usage
     * from MonitorTask and increment counter
     */ videoCodecDegradationHighEncodeCpuDidReceive() {
        this.videoCodecDegradationHighEncodeCpuCount += 1;
    }
    /**
     * Receive video codec degradation event due to hardware encoder failure
     * from MonitorTask and increment counter
     */ videoCodecDegradationEncodeFailureDidReceive() {
        this.videoCodecDegradationEncodeFailureCount += 1;
    }
    /**
     * Receive video codec degradation event due to concurrent senders
     * from MonitorTask and increment counter
     */ videoCodecDegradationConcurrentSendersDidReceive() {
        this.videoCodecDegradationConcurrentSendersCount += 1;
    }
    addVideoCodecDegradationMetrics(customStatsReports, videoUpstreamSsrc) {
        customStatsReports.push({
            kind: 'video',
            type: 'outbound-rtp',
            ssrc: videoUpstreamSsrc,
            timestamp: Date.now(),
            videoCodecDegradationHighEncodeCpu: this.videoCodecDegradationHighEncodeCpuCount,
            videoCodecDegradationEncodeFailure: this.videoCodecDegradationEncodeFailureCount,
            videoCodecDegradationConcurrentSenders: this.videoCodecDegradationConcurrentSendersCount
        });
        this.videoCodecDegradationHighEncodeCpuCount = 0;
        this.videoCodecDegradationEncodeFailureCount = 0;
        this.videoCodecDegradationConcurrentSendersCount = 0;
    }
    getVideoUpstreamSsrcFromRawMetricReports(rawMetricReports) {
        for (const rawMetricReport of rawMetricReports){
            if (this.isStreamRawMetricReport(rawMetricReport) && this.getMediaType(rawMetricReport) === $569c69e966d5a998$var$ClientMetricReportMediaType_1.default.VIDEO && this.getDirectionType(rawMetricReport) === $569c69e966d5a998$var$ClientMetricReportDirection_1.default.UPSTREAM) return rawMetricReport.ssrc;
        }
        return null;
    }
    isVideoSourceMetricReport(rawMetricReport) {
        return rawMetricReport.type === 'media-source' && rawMetricReport.kind === 'video';
    }
    addRenderResolutionToVideoDownstreamMetrics(metricReport, ssrc) {
        const streamId = this.videoStreamIndex.streamIdForSSRC(Number(ssrc));
        const attendeeId = this.videoStreamIndex.attendeeIdForStreamId(streamId);
        if (streamId === undefined || attendeeId === '') {
            this.logger.warn(`No attendee found for ssrc ${ssrc}`);
            return;
        }
        if (this.resolutionMap.has(attendeeId)) {
            metricReport.currentMetrics['videoRenderWidth'] = this.resolutionMap.get(attendeeId).width;
            metricReport.currentMetrics['videoRenderHeight'] = this.resolutionMap.get(attendeeId).height;
        }
        const groupId = metricReport.groupId;
        if (groupId !== undefined && this.remoteRenderFpsMap.has(groupId)) metricReport.currentMetrics['videoRemoteRenderFps'] = this.remoteRenderFpsMap.get(groupId);
    }
    updateVideoSourceMetrics(rawMetricReports) {
        for (const rawMetricReport of rawMetricReports)if (this.isVideoSourceMetricReport(rawMetricReport)) {
            const videoUpstreamSsrcs = this.clientMetricReport.getVideoUpstreamSsrcs();
            if (videoUpstreamSsrcs.length === 0) {
                this.logger.warn('No video upstream ssrcs found');
                return;
            }
            for (const ssrc of videoUpstreamSsrcs){
                this.clientMetricReport.streamMetricReports[ssrc].currentMetrics['videoInputWidth'] = rawMetricReport['width'];
                this.clientMetricReport.streamMetricReports[ssrc].currentMetrics['videoInputHeight'] = rawMetricReport['height'];
            }
        }
    }
}
$569c69e966d5a998$var$StatsCollector.INTERVAL_MS = 1000;
$569c69e966d5a998$var$StatsCollector.CLIENT_TYPE = 'amazon-chime-sdk-js';
module.exports.default = $569c69e966d5a998$var$StatsCollector;

});
parcelRegister("7dTR6", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[RedundantAudioRecoveryMetricReport]] will contain metrics reported
 * by the [[RedundantAudioEncoder]]
 */ class $5425130612b822e8$var$RedundantAudioRecoveryMetricReport {
    constructor(){
        this.currentTimestampMs = 0;
        this.ssrc = 0;
        this.totalAudioPacketsLost = 0;
        this.totalAudioPacketsExpected = 0;
        this.totalAudioPacketsRecoveredRed = 0;
        this.totalAudioPacketsRecoveredFec = 0;
    }
}
module.exports.default = $5425130612b822e8$var$RedundantAudioRecoveryMetricReport;

});

parcelRegister("RnK9Z", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $0a075e51eb5a7862$var$StreamMetricReport {
    constructor(){
        this.previousMetrics = {};
        this.currentMetrics = {};
        // As metric values do not necessarily be number, this is a workaround in case metric value is string
        this.currentStringMetrics = {};
        this.previousObjectMetrics = {};
        this.currentObjectMetrics = {};
    }
}
module.exports.default = $0a075e51eb5a7862$var$StreamMetricReport;

});

parcelRegister("1b1mZ", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingSessionLifecycleEvent = void 0;
/**
 * [[MeetingSessionLifecycleEvent]] indicates the lifecycle status.
 * Add new enums to the bottom. We depend on these numbers for analytics.
 */ var $0db7e18897eb1730$var$MeetingSessionLifecycleEvent;
(function(MeetingSessionLifecycleEvent) {
    /**
     * The session is connecting, either to start a new call, or reconnect to an existing one.
     */ MeetingSessionLifecycleEvent[MeetingSessionLifecycleEvent["Connecting"] = 0] = "Connecting";
    /**
     * The session successfully arrived in the started state either for the first time or
     * due to a change in connection type.
     */ MeetingSessionLifecycleEvent[MeetingSessionLifecycleEvent["Started"] = 1] = "Started";
    /**
     * The session came to a stop, either from leaving or due to a failure.
     */ MeetingSessionLifecycleEvent[MeetingSessionLifecycleEvent["Stopped"] = 2] = "Stopped";
})($0db7e18897eb1730$var$MeetingSessionLifecycleEvent || (module.exports.MeetingSessionLifecycleEvent = $0db7e18897eb1730$var$MeetingSessionLifecycleEvent = {}));
module.exports.default = $0db7e18897eb1730$var$MeetingSessionLifecycleEvent;

});

parcelRegister("8wYaz", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingSessionLifecycleEventCondition = void 0;
/**
 * [[MeetingSessionLifecycleEventCondition]] indicates the lifecycle event condition.
 * Add new enums to the bottom. We depend on these numbers for analytics.
 */ var $635ffc4d098dbb62$var$MeetingSessionLifecycleEventCondition;
(function(MeetingSessionLifecycleEventCondition) {
    /**
     * The session is connecting for the first time.
     */ MeetingSessionLifecycleEventCondition[MeetingSessionLifecycleEventCondition["ConnectingNew"] = 0] = "ConnectingNew";
    /**
     * The session was connected before and is now reconnecting.
     */ MeetingSessionLifecycleEventCondition[MeetingSessionLifecycleEventCondition["ReconnectingExisting"] = 1] = "ReconnectingExisting";
    /**
     * The session successfully arrived in the started state for the first time.
     */ MeetingSessionLifecycleEventCondition[MeetingSessionLifecycleEventCondition["StartedNew"] = 2] = "StartedNew";
    /**
     * The session successfully arrived in the started state but was connected before.
     * This can happen, for example, when the connection type changes.
     */ MeetingSessionLifecycleEventCondition[MeetingSessionLifecycleEventCondition["StartedExisting"] = 3] = "StartedExisting";
    /**
     * The session successfully arrived in the started state following a reconnect.
     */ MeetingSessionLifecycleEventCondition[MeetingSessionLifecycleEventCondition["StartedAfterReconnect"] = 4] = "StartedAfterReconnect";
    /**
     * The session stopped cleanly, probably due to leaving the call.
     */ MeetingSessionLifecycleEventCondition[MeetingSessionLifecycleEventCondition["StoppedCleanly"] = 5] = "StoppedCleanly";
    /**
     * The session stopped due to a failure. A status code will indicate the cause of
     * the failure.
     */ MeetingSessionLifecycleEventCondition[MeetingSessionLifecycleEventCondition["StoppedWithFailure"] = 6] = "StoppedWithFailure";
})($635ffc4d098dbb62$var$MeetingSessionLifecycleEventCondition || (module.exports.MeetingSessionLifecycleEventCondition = $635ffc4d098dbb62$var$MeetingSessionLifecycleEventCondition = {}));
module.exports.default = $635ffc4d098dbb62$var$MeetingSessionLifecycleEventCondition;

});


parcelRegister("f5dpO", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $afb1baa339e057d1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $afb1baa339e057d1$var$MeetingSessionStatusCode_1 = $afb1baa339e057d1$var$__importDefault((parcelRequire("9zYoz")));

const $afb1baa339e057d1$var$SDP_1 = $afb1baa339e057d1$var$__importDefault((parcelRequire("bry62")));

const $afb1baa339e057d1$var$BaseTask_1 = $afb1baa339e057d1$var$__importDefault((parcelRequire("9wPDz")));
/*
 * [[FinishGatheringICECandidatesTask]] add ice-candidate event handler on peer connection to
 * collect ice candidates and wait for peer connection ice gathering state to complete
 */ class $afb1baa339e057d1$var$FinishGatheringICECandidatesTask extends $afb1baa339e057d1$var$BaseTask_1.default {
    constructor(context, chromeVpnTimeoutMs = $afb1baa339e057d1$var$FinishGatheringICECandidatesTask.CHROME_VPN_TIMEOUT_MS){
        super(context.logger);
        this.context = context;
        this.chromeVpnTimeoutMs = chromeVpnTimeoutMs;
        this.taskName = 'FinishGatheringICECandidatesTask';
    }
    removeEventListener() {
        if (this.context.peer) {
            this.context.peer.removeEventListener('icecandidate', this.context.iceCandidateHandler);
            if (!this.context.turnCredentials) this.context.peer.removeEventListener('icegatheringstatechange', this.context.iceGatheringStateEventHandler);
        }
    }
    cancel() {
        let error;
        // TODO: Remove when the Chrome VPN reconnect bug is fixed.
        // In Chrome, SDK may fail to establish TURN session after VPN reconnect.
        // https://bugs.chromium.org/p/webrtc/issues/detail?id=9097
        if (this.context.browserBehavior.requiresIceCandidateGatheringTimeoutWorkaround()) {
            if (this.chromeVpnTimeoutMs < this.context.meetingSessionConfiguration.connectionTimeoutMs) {
                const duration = Date.now() - this.startTimestampMs;
                if (duration > this.chromeVpnTimeoutMs) error = new Error(`canceling ${this.name()} due to the meeting status code: ${$afb1baa339e057d1$var$MeetingSessionStatusCode_1.default.ICEGatheringTimeoutWorkaround}`);
            }
        }
        // Just in case. The baseCancel behavior should prevent this.
        /* istanbul ignore else */ if (this.cancelPromise) {
            error = error || new Error(`canceling ${this.name()}`);
            this.cancelPromise(error);
            delete this.cancelPromise;
        }
    }
    async run() {
        var _a, _b;
        if (!this.context.peer) this.logAndThrow(`session does not have peer connection; bypass ice gathering`);
        if (this.context.browserBehavior.requiresCheckForSdpConnectionAttributes()) {
            if (new $afb1baa339e057d1$var$SDP_1.default(this.context.peer.localDescription.sdp).hasCandidatesForAllMLines()) {
                this.context.logger.info(`ice gathering already complete; bypass gathering, current local description ${this.context.peer.localDescription.sdp}`);
                return;
            }
        } else this.context.logger.info(`iOS device does not require checking for connection attributes in SDP, current local description ${this.context.peer.localDescription.sdp}`);
        /*
         * To bypass waiting for events, it is required that "icegatheringstate" to be complete and sdp to have candidate
         * For Firefox, it takes long for iceGatheringState === 'complete'
         * Ref: https://github.com/aws/amazon-chime-sdk-js/issues/609
         */ if ((this.context.browserBehavior.hasFirefoxWebRTC() || this.context.peer.iceGatheringState === 'complete') && new $afb1baa339e057d1$var$SDP_1.default(this.context.peer.localDescription.sdp).hasCandidates()) {
            this.context.logger.info('ice gathering state is complete and candidates are in SDP; bypass gathering');
            return;
        }
        (_a = this.context.meetingSessionTimingManager) === null || _a === void 0 || _a.onIceGatheringStarted();
        try {
            await new Promise((resolve, reject)=>{
                this.cancelPromise = (error)=>{
                    this.removeEventListener();
                    reject(error);
                };
                if (!this.context.turnCredentials) {
                    // if one day, we found a case where a FinishGatheringICECandidate did not resolve but ice gathering state is complete and SDP answer has ice candidates
                    // we may need to enable this
                    this.context.iceGatheringStateEventHandler = ()=>{
                        if (this.context.peer.iceGatheringState === 'complete') {
                            this.removeEventListener();
                            resolve();
                            delete this.cancelPromise;
                            return;
                        }
                    };
                    this.context.peer.addEventListener('icegatheringstatechange', this.context.iceGatheringStateEventHandler);
                }
                this.context.iceCandidateHandler = (event)=>{
                    this.context.logger.info(`ice candidate: ${event.candidate ? event.candidate.candidate : '(null)'} state: ${this.context.peer.iceGatheringState}`);
                    // Ice candidate arrives, do not need to wait anymore.
                    // https://webrtcglossary.com/trickle-ice/
                    if (event.candidate) {
                        if ($afb1baa339e057d1$var$SDP_1.default.isRTPCandidate(event.candidate.candidate)) this.context.iceCandidates.push(event.candidate);
                        // Could there be a case the candidate is not written to SDP ?
                        if (this.context.turnCredentials && this.context.iceCandidates.length >= 1) {
                            this.context.logger.info('gathered at least one relay candidate');
                            this.removeEventListener();
                            resolve();
                            delete this.cancelPromise;
                            return;
                        }
                    }
                    // Ice candidate gathering is complete, additional barrier to make sure sdp contain an ice candidate.
                    // TODO: Could there be a race where iceGatheringState is flipped after this task is run ? This could only be handled if ice state is monitored persistently.
                    if (this.context.peer.iceGatheringState === 'complete') {
                        this.context.logger.info('done gathering ice candidates');
                        this.removeEventListener();
                        if (!new $afb1baa339e057d1$var$SDP_1.default(this.context.peer.localDescription.sdp).hasCandidates() || this.context.iceCandidates.length === 0) {
                            reject(new Error('no ice candidates were gathered'));
                            delete this.cancelPromise;
                        } else {
                            resolve();
                            delete this.cancelPromise;
                        }
                    }
                };
                // SDK does not catch candidate itself and send to sever. Rather, WebRTC handles candidate events and writes candidate to SDP.
                this.context.peer.addEventListener('icecandidate', this.context.iceCandidateHandler);
                this.startTimestampMs = Date.now();
            });
        } catch (error) {
            throw error;
        } finally{
            /* istanbul ignore else */ if (this.startTimestampMs) this.context.iceGatheringDurationMs = Math.round(Date.now() - this.startTimestampMs);
            (_b = this.context.meetingSessionTimingManager) === null || _b === void 0 || _b.onIceGatheringComplete();
        }
    }
}
$afb1baa339e057d1$var$FinishGatheringICECandidatesTask.CHROME_VPN_TIMEOUT_MS = 5000;
module.exports.default = $afb1baa339e057d1$var$FinishGatheringICECandidatesTask;

});

parcelRegister("7m5jF", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $55aeb626cc30dca5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $55aeb626cc30dca5$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $55aeb626cc30dca5$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $55aeb626cc30dca5$var$__createBinding(result, mod, k[i]);
        }
        $55aeb626cc30dca5$var$__setModuleDefault(result, mod);
        return result;
    };
}();
var $55aeb626cc30dca5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $55aeb626cc30dca5$var$MeetingSessionStatus_1 = $55aeb626cc30dca5$var$__importDefault((parcelRequire("jbMe2")));

const $55aeb626cc30dca5$var$MeetingSessionStatusCode_1 = $55aeb626cc30dca5$var$__importDefault((parcelRequire("9zYoz")));

const $55aeb626cc30dca5$var$MeetingSessionTURNCredentials_1 = $55aeb626cc30dca5$var$__importDefault((parcelRequire("lEn0X")));

const $55aeb626cc30dca5$var$ServerSideNetworkAdaption_1 = $55aeb626cc30dca5$var$__importStar((parcelRequire("bRvcN")));

const $55aeb626cc30dca5$var$SignalingClientEventType_1 = $55aeb626cc30dca5$var$__importDefault((parcelRequire("1lA8I")));

const $55aeb626cc30dca5$var$SignalingClientJoin_1 = $55aeb626cc30dca5$var$__importDefault((parcelRequire("l5Y18")));

var $4huDn = parcelRequire("4huDn");

const $55aeb626cc30dca5$var$BaseTask_1 = $55aeb626cc30dca5$var$__importDefault((parcelRequire("9wPDz")));
function $55aeb626cc30dca5$var$rewriteTurnUris(uris, urls) {
    const { urlRewriterMulti: urlRewriterMulti, urlRewriter: urlRewriter } = urls;
    return uris.flatMap((uri)=>{
        if (urlRewriterMulti) return urlRewriterMulti(uri) || [];
        const rewritten = urlRewriter(uri);
        return rewritten ? [
            rewritten
        ] : [];
    }).filter((uri)=>!!uri);
}
/*
 * [[JoinAndReceiveIndexTask]] sends the JoinFrame and asynchronously waits for the server to send the [[SdkIndexFrame]].
 * It should run with the [[TimeoutTask]] as the subtask so it can get canceled after timeout.
 */ class $55aeb626cc30dca5$var$JoinAndReceiveIndexTask extends $55aeb626cc30dca5$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'JoinAndReceiveIndexTask';
        this.taskCanceler = null;
    }
    cancel() {
        if (this.taskCanceler) {
            this.taskCanceler.cancel();
            this.taskCanceler = null;
        }
    }
    async run() {
        var _a;
        const indexFrame = await new Promise(async (resolve, reject)=>{
            const context = this.context;
            context.turnCredentials = null;
            class IndexFrameInterceptor {
                constructor(signalingClient){
                    this.signalingClient = signalingClient;
                }
                cancel() {
                    this.signalingClient.removeObserver(this);
                    reject(new Error(`JoinAndReceiveIndexTask got canceled while waiting for SdkIndexFrame`));
                }
                handleSignalingClientEvent(event) {
                    var _a;
                    if (event.type === $55aeb626cc30dca5$var$SignalingClientEventType_1.default.WebSocketClosed) {
                        let message = `The signaling connection was closed with code ${event.closeCode} and reason: ${event.closeReason}`;
                        context.logger.warn(message);
                        let statusCode = $55aeb626cc30dca5$var$MeetingSessionStatusCode_1.default.SignalingBadRequest;
                        if (event.closeCode === 4410) {
                            message = 'The meeting already ended.';
                            context.logger.warn(message);
                            statusCode = $55aeb626cc30dca5$var$MeetingSessionStatusCode_1.default.MeetingEnded;
                        } else if (event.closeCode >= 4500 && event.closeCode < 4600) statusCode = $55aeb626cc30dca5$var$MeetingSessionStatusCode_1.default.SignalingInternalServerError;
                        context.audioVideoController.handleMeetingSessionStatus(new $55aeb626cc30dca5$var$MeetingSessionStatus_1.default(statusCode), new Error(message));
                        return;
                    }
                    if (event.type !== $55aeb626cc30dca5$var$SignalingClientEventType_1.default.ReceivedSignalFrame) return;
                    if (event.message.type === $4huDn.SdkSignalFrame.Type.JOIN_ACK) {
                        (_a = context.meetingSessionTimingManager) === null || _a === void 0 || _a.onJoinAckReceived();
                        // @ts-ignore: force cast to SdkJoinAckFrame
                        const joinAckFrame = event.message.joinack;
                        if (!joinAckFrame) {
                            // This should realistically never happen
                            context.audioVideoController.handleMeetingSessionStatus(new $55aeb626cc30dca5$var$MeetingSessionStatus_1.default($55aeb626cc30dca5$var$MeetingSessionStatusCode_1.default.SignalingRequestFailed), new Error(`Join ACK message did not include expected frame`));
                            return;
                        }
                        if (joinAckFrame.videoSubscriptionLimit) context.videoSubscriptionLimit = joinAckFrame.videoSubscriptionLimit;
                        context.serverSupportsCompression = joinAckFrame.wantsCompressedSdp;
                        if (joinAckFrame.defaultServerSideNetworkAdaption !== undefined && joinAckFrame.defaultServerSideNetworkAdaption !== $55aeb626cc30dca5$var$ServerSideNetworkAdaption_1.default.Default && context.videoDownlinkBandwidthPolicy.setServerSideNetworkAdaption !== undefined) {
                            const defaultServerSideNetworkAdaption = joinAckFrame.defaultServerSideNetworkAdaption;
                            context.logger.info(`Overriding server side network adaption value to ${defaultServerSideNetworkAdaption}`);
                            context.videoDownlinkBandwidthPolicy.setServerSideNetworkAdaption((0, $55aeb626cc30dca5$var$ServerSideNetworkAdaption_1.convertServerSideNetworkAdaptionEnumFromSignaled)(defaultServerSideNetworkAdaption));
                        }
                        if (joinAckFrame && joinAckFrame.turnCredentials) {
                            context.turnCredentials = new $55aeb626cc30dca5$var$MeetingSessionTURNCredentials_1.default();
                            context.turnCredentials.username = joinAckFrame.turnCredentials.username;
                            context.turnCredentials.password = joinAckFrame.turnCredentials.password;
                            context.turnCredentials.ttl = joinAckFrame.turnCredentials.ttl;
                            context.turnCredentials.uris = $55aeb626cc30dca5$var$rewriteTurnUris(joinAckFrame.turnCredentials.uris, context.meetingSessionConfiguration.urls);
                        } else context.logger.error('missing TURN credentials in JoinAckFrame');
                        return;
                    }
                    if (event.message.type !== $4huDn.SdkSignalFrame.Type.INDEX) return;
                    this.signalingClient.removeObserver(this);
                    // @ts-ignore: force cast to SdkIndexFrame
                    const indexFrame = event.message.index;
                    resolve(indexFrame);
                }
            }
            const interceptor = new IndexFrameInterceptor(this.context.signalingClient);
            this.context.signalingClient.registerObserver(interceptor);
            this.taskCanceler = interceptor;
            // reset SDP compression state
            this.context.previousSdpAnswerAsString = '';
            this.context.previousSdpOffer = null;
            this.context.serverSupportsCompression = false;
            const join = new $55aeb626cc30dca5$var$SignalingClientJoin_1.default(this.context.meetingSessionConfiguration.applicationMetadata);
            join.browserBehavior = this.context.browserBehavior;
            if (this.context.videoDownlinkBandwidthPolicy.getServerSideNetworkAdaption !== undefined && this.context.videoDownlinkBandwidthPolicy.supportedServerSideNetworkAdaptions !== undefined) {
                join.serverSideNetworkAdaption = this.context.videoDownlinkBandwidthPolicy.getServerSideNetworkAdaption();
                join.supportedServerSideNetworkAdaptions = this.context.videoDownlinkBandwidthPolicy.supportedServerSideNetworkAdaptions();
            }
            if (this.context.videoDownlinkBandwidthPolicy.wantsAllTemporalLayersInIndex !== undefined) join.wantsAllTemporalLayersInIndex = this.context.videoDownlinkBandwidthPolicy.wantsAllTemporalLayersInIndex();
            join.disablePeriodicKeyframeRequestOnContentSender = this.context.meetingSessionConfiguration.disablePeriodicKeyframeRequestOnContentSender;
            this.context.signalingClient.join(join);
        });
        this.context.logger.info(`received first index ${JSON.stringify(indexFrame)}`);
        // We currently don't bother ingesting this into the same places as `ReceiveVideoStreamIndexTask` as we synchronously attempt a first subscribe
        // after this task completes and the state isn't quite in the right place to make it work without some refactoring. However that
        // means that we will always have an initial subscribe without any received videos.
        this.context.indexFrame = indexFrame;
        // If the first index contains video sources, tell the timing manager to hold
        // the initial batch open until remote video timing completes.
        if (indexFrame.sources && indexFrame.sources.length > 0) /* istanbul ignore next */ (_a = this.context.meetingSessionTimingManager) === null || _a === void 0 || _a.setExpectingRemoteVideo();
    }
}
module.exports.default = $55aeb626cc30dca5$var$JoinAndReceiveIndexTask;

});
parcelRegister("lEn0X", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[MeetingSessionTURNCredentials]] contains TURN credentials from the TURN server.
 */ class $fc2f2f971689b521$var$MeetingSessionTURNCredentials {
    constructor(){
        this.username = null;
        this.password = null;
        this.ttl = null;
        this.uris = null;
    }
}
module.exports.default = $fc2f2f971689b521$var$MeetingSessionTURNCredentials;

});

parcelRegister("l5Y18", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $f5b89ecdf5e2f6c2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $f5b89ecdf5e2f6c2$var$ServerSideNetworkAdaption_1 = $f5b89ecdf5e2f6c2$var$__importDefault((parcelRequire("bRvcN")));
/**
 * [[SignalingClientJoin]] contains settings for the Join SignalFrame.
 */ class $f5b89ecdf5e2f6c2$var$SignalingClientJoin {
    /**
     * Initializes a SignalingClientJoin with the given properties.
     * @param applicationMetadata [[ApplicationMetadata]].
     */ constructor(applicationMetadata){
        this.applicationMetadata = applicationMetadata;
        this.serverSideNetworkAdaption = $f5b89ecdf5e2f6c2$var$ServerSideNetworkAdaption_1.default.Default;
        this.supportedServerSideNetworkAdaptions = [];
        this.wantsAllTemporalLayersInIndex = false;
        this.disablePeriodicKeyframeRequestOnContentSender = false;
    }
}
module.exports.default = $f5b89ecdf5e2f6c2$var$SignalingClientJoin;

});


parcelRegister("boLjf", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $84c6a243ba38311b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $84c6a243ba38311b$var$SignalingClientEventType_1 = $84c6a243ba38311b$var$__importDefault((parcelRequire("1lA8I")));

var $4huDn = parcelRequire("4huDn");

const $84c6a243ba38311b$var$BaseTask_1 = $84c6a243ba38311b$var$__importDefault((parcelRequire("9wPDz")));
/**
 * [[LeaveAndReceiveLeaveAckTask]] sends a Leave frame and waits for a LeaveAck.
 */ class $84c6a243ba38311b$var$LeaveAndReceiveLeaveAckTask extends $84c6a243ba38311b$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'LeaveAndReceiveLeaveAckTask';
        this.taskCanceler = null;
    }
    cancel() {
        if (this.taskCanceler) {
            this.taskCanceler.cancel();
            this.taskCanceler = null;
        }
    }
    async run() {
        if (this.context.signalingClient.ready()) {
            this.context.signalingClient.leave();
            this.context.logger.info('sent leave');
            await this.receiveLeaveAck();
        }
    }
    receiveLeaveAck() {
        return new Promise((resolve, reject)=>{
            class Interceptor {
                constructor(signalingClient, logger){
                    this.signalingClient = signalingClient;
                    this.logger = logger;
                }
                cancel() {
                    this.signalingClient.removeObserver(this);
                    reject(new Error(`LeaveAndReceiveLeaveAckTask got canceled while waiting for IndexFrame`));
                }
                handleSignalingClientEvent(event) {
                    if (event.isConnectionTerminated()) {
                        this.signalingClient.removeObserver(this);
                        this.logger.info('LeaveAndReceiveLeaveAckTask connection terminated');
                        // don't treat this as an error
                        resolve();
                        return;
                    }
                    if (event.type === $84c6a243ba38311b$var$SignalingClientEventType_1.default.ReceivedSignalFrame && event.message.type === $4huDn.SdkSignalFrame.Type.LEAVE_ACK) {
                        this.signalingClient.removeObserver(this);
                        this.logger.info('got leave ack');
                        resolve();
                    }
                }
            }
            const interceptor = new Interceptor(this.context.signalingClient, this.context.logger);
            this.taskCanceler = interceptor;
            this.context.signalingClient.registerObserver(interceptor);
        });
    }
}
module.exports.default = $84c6a243ba38311b$var$LeaveAndReceiveLeaveAckTask;

});

parcelRegister("lvAt6", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $fa88c819196ea03d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $fa88c819196ea03d$var$SignalingClientEventType_1 = $fa88c819196ea03d$var$__importDefault((parcelRequire("1lA8I")));

var $4huDn = parcelRequire("4huDn");

const $fa88c819196ea03d$var$BaseTask_1 = $fa88c819196ea03d$var$__importDefault((parcelRequire("9wPDz")));
class $fa88c819196ea03d$var$ListenForVolumeIndicatorsTask extends $fa88c819196ea03d$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'ListenForVolumeIndicatorsTask';
        this.realtimeMuteAndUnmuteHandler = (muted)=>{
            this.context.signalingClient.mute(muted);
        };
    }
    async run() {
        this.context.removableObservers.push(this);
        this.context.signalingClient.registerObserver(this);
        this.context.realtimeController.realtimeSubscribeToMuteAndUnmuteLocalAudio(this.realtimeMuteAndUnmuteHandler);
    }
    removeObserver() {
        this.context.realtimeController.realtimeUnsubscribeToMuteAndUnmuteLocalAudio(this.realtimeMuteAndUnmuteHandler);
        this.context.signalingClient.removeObserver(this);
    }
    handleSignalingClientEvent(event) {
        if (event.type !== $fa88c819196ea03d$var$SignalingClientEventType_1.default.ReceivedSignalFrame) return;
        if (event.message.type === $4huDn.SdkSignalFrame.Type.AUDIO_STREAM_ID_INFO) {
            // @ts-ignore
            const audioStreamIdInfo = event.message.audioStreamIdInfo;
            this.context.volumeIndicatorAdapter.sendRealtimeUpdatesForAudioStreamIdInfo(audioStreamIdInfo);
        } else if (event.message.type === $4huDn.SdkSignalFrame.Type.AUDIO_METADATA) {
            // @ts-ignore
            const audioMetadata = event.message.audioMetadata;
            this.context.volumeIndicatorAdapter.sendRealtimeUpdatesForAudioMetadata(audioMetadata);
        }
    }
}
module.exports.default = $fa88c819196ea03d$var$ListenForVolumeIndicatorsTask;

});

parcelRegister("fpAHb", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $b385a7c0a93e46fc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $b385a7c0a93e46fc$var$ClientMetricReportDirection_1 = $b385a7c0a93e46fc$var$__importDefault((parcelRequire("hRU3k")));

const $b385a7c0a93e46fc$var$ClientMetricReportMediaType_1 = $b385a7c0a93e46fc$var$__importDefault((parcelRequire("aU8Oy")));

const $b385a7c0a93e46fc$var$ReconnectionHealthPolicy_1 = $b385a7c0a93e46fc$var$__importDefault((parcelRequire("bogAf")));

const $b385a7c0a93e46fc$var$SendingAudioFailureConnectionHealthPolicy_1 = $b385a7c0a93e46fc$var$__importDefault((parcelRequire("53rdn")));

const $b385a7c0a93e46fc$var$UnusableAudioWarningConnectionHealthPolicy_1 = $b385a7c0a93e46fc$var$__importDefault((parcelRequire("aa9Qv")));

const $b385a7c0a93e46fc$var$VideoEncodingConnectionHealthPolicyName_1 = $b385a7c0a93e46fc$var$__importDefault((parcelRequire("k4S8T")));

var $byDbS = parcelRequire("byDbS");

const $b385a7c0a93e46fc$var$MeetingSessionStatus_1 = $b385a7c0a93e46fc$var$__importDefault((parcelRequire("jbMe2")));

const $b385a7c0a93e46fc$var$MeetingSessionStatusCode_1 = $b385a7c0a93e46fc$var$__importDefault((parcelRequire("9zYoz")));

const $b385a7c0a93e46fc$var$VideoCodecCapability_1 = $b385a7c0a93e46fc$var$__importDefault((parcelRequire("4C1Yl")));

const $b385a7c0a93e46fc$var$SignalingClientEventType_1 = $b385a7c0a93e46fc$var$__importDefault((parcelRequire("1lA8I")));

var $4huDn = parcelRequire("4huDn");

const $b385a7c0a93e46fc$var$AudioLogEvent_1 = $b385a7c0a93e46fc$var$__importDefault((parcelRequire("2R7XG")));

var $jfpqH = parcelRequire("jfpqH");

const $b385a7c0a93e46fc$var$BaseTask_1 = $b385a7c0a93e46fc$var$__importDefault((parcelRequire("9wPDz")));
/*
 * [[MonitorTask]] monitors connections using SignalingAndMetricsConnectionMonitor.
 */ class $b385a7c0a93e46fc$var$MonitorTask extends $b385a7c0a93e46fc$var$BaseTask_1.default {
    constructor(context, connectionHealthPolicyConfiguration, initialConnectionHealthData){
        super(context.logger);
        this.context = context;
        this.initialConnectionHealthData = initialConnectionHealthData;
        this.taskName = 'MonitorTask';
        this.prevSignalStrength = 1;
        this.currentAvailableStreamAvgBitrates = null;
        this.hasSignalingError = false;
        this.presenceHandlerCalled = false;
        // See comment above invocation of `pauseResubscribeCheck` in `DefaultAudioVideoController`
        // for explanation.
        this.isResubscribeCheckPaused = false;
        this.pendingMetricsReport = undefined;
        this.videoEncodingHealthPolicies = [];
        this.checkAndSendWeakSignalEvent = (signalStrength)=>{
            const isCurrentSignalBad = signalStrength < 1;
            const isPrevSignalBad = this.prevSignalStrength < 1;
            const signalStrengthEventType = isCurrentSignalBad ? !isPrevSignalBad ? $b385a7c0a93e46fc$var$AudioLogEvent_1.default.RedmicStartLoss : null : isPrevSignalBad ? $b385a7c0a93e46fc$var$AudioLogEvent_1.default.RedmicEndLoss : null;
            if (signalStrengthEventType) this.context.statsCollector.logAudioEvent(signalStrengthEventType);
            this.prevSignalStrength = signalStrength;
        };
        this.realtimeFatalErrorCallback = (error)=>{
            this.logger.error(`realtime error: ${error}: ${error.stack}`);
            this.context.audioVideoController.handleMeetingSessionStatus(new $b385a7c0a93e46fc$var$MeetingSessionStatus_1.default($b385a7c0a93e46fc$var$MeetingSessionStatusCode_1.default.RealtimeApiFailed), error);
        };
        this.realtimeAttendeeIdPresenceHandler = (presentAttendeeId, present)=>{
            var _a;
            const attendeeId = this.context.meetingSessionConfiguration.credentials.attendeeId;
            this.logger.info(`attendeePresenceReceived: ${attendeeId}`);
            if (attendeeId === presentAttendeeId && present && !this.presenceHandlerCalled) {
                this.presenceHandlerCalled = true;
                this.context.attendeePresenceDurationMs = Date.now() - this.context.startAudioVideoTimestamp;
                (_a = this.context.eventController) === null || _a === void 0 || _a.publishEvent('attendeePresenceReceived', {
                    attendeePresenceDurationMs: this.context.attendeePresenceDurationMs,
                    retryCount: this.context.retryCount
                });
            }
        };
        this.reconnectionHealthPolicy = new $b385a7c0a93e46fc$var$ReconnectionHealthPolicy_1.default(context.logger, {
            ...connectionHealthPolicyConfiguration
        }, this.initialConnectionHealthData.clone());
        this.unusableAudioWarningHealthPolicy = new $b385a7c0a93e46fc$var$UnusableAudioWarningConnectionHealthPolicy_1.default({
            ...connectionHealthPolicyConfiguration
        }, this.initialConnectionHealthData.clone());
        this.sendingAudioFailureHealthPolicy = new $b385a7c0a93e46fc$var$SendingAudioFailureConnectionHealthPolicy_1.default(context.logger, {
            ...connectionHealthPolicyConfiguration
        }, this.initialConnectionHealthData.clone());
        for (const policy of connectionHealthPolicyConfiguration.videoEncodingHealthPolicies)this.videoEncodingHealthPolicies.push(new policy({
            ...connectionHealthPolicyConfiguration
        }, this.initialConnectionHealthData.clone()));
    }
    removeObserver() {
        this.context.audioVideoController.removeObserver(this);
        this.context.realtimeController.realtimeUnsubscribeToFatalError(this.realtimeFatalErrorCallback);
        this.context.realtimeController.realtimeUnsubscribeToLocalSignalStrengthChange(this.checkAndSendWeakSignalEvent);
        this.context.realtimeController.realtimeUnsubscribeToAttendeeIdPresence(this.realtimeAttendeeIdPresenceHandler);
        this.context.signalingClient.removeObserver(this);
    }
    async run() {
        this.context.removableObservers.push(this);
        this.context.audioVideoController.addObserver(this);
        this.context.realtimeController.realtimeSubscribeToFatalError(this.realtimeFatalErrorCallback);
        this.context.realtimeController.realtimeSubscribeToLocalSignalStrengthChange(this.checkAndSendWeakSignalEvent);
        this.context.realtimeController.realtimeSubscribeToAttendeeIdPresence(this.realtimeAttendeeIdPresenceHandler);
        this.context.connectionMonitor.start();
        this.context.statsCollector.start(this.context.signalingClient, this.context.videoStreamIndex);
        this.context.signalingClient.registerObserver(this);
    }
    pauseResubscribeCheck() {
        this.isResubscribeCheckPaused = true;
    }
    resumeResubscribeCheck() {
        if (!this.isResubscribeCheckPaused) // Do not recheck subcribe if it wasn't paused to begin with.
        return;
        this.isResubscribeCheckPaused = false;
        if (this.pendingMetricsReport) {
            this.context.logger.info('Resuming resubscribe check with pending metrics report');
            if (this.checkResubscribe(this.pendingMetricsReport)) this.context.audioVideoController.update({
                needsRenegotiation: false
            });
        }
    }
    videoTileDidUpdate(_tileState) {
        this.context.maxVideoTileCount = Math.max(this.context.maxVideoTileCount, this.context.videoTileController.getAllVideoTiles().length);
    }
    checkResubscribe(clientMetricReport) {
        if (this.isResubscribeCheckPaused) {
            this.context.logger.info('Resubscribe check is paused, setting incoming client metric report as pending');
            this.pendingMetricsReport = clientMetricReport;
            return;
        } else this.pendingMetricsReport = undefined;
        const metricReport = clientMetricReport.getObservableMetrics();
        const availableSendBandwidth = metricReport.availableOutgoingBitrate;
        const nackCountPerSecond = metricReport.nackCountReceivedPerSecond;
        let needResubscribe = false;
        this.context.videoDownlinkBandwidthPolicy.updateMetrics(clientMetricReport);
        const resubscribeForDownlink = this.context.videoDownlinkBandwidthPolicy.wantsResubscribe();
        needResubscribe = needResubscribe || resubscribeForDownlink;
        if (resubscribeForDownlink) {
            const videoSubscriptionIdSet = this.context.videoDownlinkBandwidthPolicy.chooseSubscriptions();
            // Same logic as in `ReceiveVideoStreamIndexTask`, immediately truncating rather then truncating on subscribe
            // avoids any issues with components (e.g. transceiver controller) along the way.
            this.context.videosToReceive = videoSubscriptionIdSet.truncate(this.context.videoSubscriptionLimit);
            if (videoSubscriptionIdSet.size() > this.context.videosToReceive.size()) this.logger.warn(`Video receive limit exceeded. Limiting the videos to ${this.context.videosToReceive.size()}. Please consider using AllHighestVideoBandwidthPolicy or VideoPriorityBasedPolicy along with chooseRemoteVideoSources api to select the video sources to be displayed.`);
            this.logger.info(`trigger resubscribe for down=${resubscribeForDownlink}; videosToReceive=[${this.context.videosToReceive.array()}]`);
        }
        if (this.context.videoTileController.hasStartedLocalVideoTile()) {
            this.context.videoUplinkBandwidthPolicy.updateConnectionMetric({
                uplinkKbps: availableSendBandwidth / 1000,
                nackCountPerSecond: nackCountPerSecond
            });
            const resubscribeForUplink = this.context.videoUplinkBandwidthPolicy.wantsResubscribe();
            needResubscribe = needResubscribe || resubscribeForUplink;
            if (resubscribeForUplink) {
                this.logger.info(`trigger resubscribe for up=${resubscribeForUplink}; videosToReceive=[${this.context.videosToReceive.array()}]`);
                this.context.videoUplinkBandwidthPolicy.chooseEncodingParameters();
            }
        }
        return needResubscribe;
    }
    metricsDidReceive(clientMetricReport) {
        if (this.checkResubscribe(clientMetricReport)) this.context.audioVideoController.update({
            needsRenegotiation: false
        });
        if (!this.currentAvailableStreamAvgBitrates) return;
        const streamMetricReport = clientMetricReport.streamMetricReports;
        const downlinkVideoStream = new Map();
        // TODO: move those logic to stats collector.
        for(const ssrc in streamMetricReport)if (streamMetricReport[ssrc].mediaType === $b385a7c0a93e46fc$var$ClientMetricReportMediaType_1.default.VIDEO && streamMetricReport[ssrc].direction === $b385a7c0a93e46fc$var$ClientMetricReportDirection_1.default.DOWNSTREAM) downlinkVideoStream.set(streamMetricReport[ssrc].streamId, streamMetricReport[ssrc]);
    }
    connectionHealthDidChange(connectionHealthData) {
        if (connectionHealthData.consecutiveMissedPongs === 0) {
            if (this.context.reconnectController) this.context.reconnectController.setLastActiveTimestampMs(Date.now());
        }
        this.applyHealthPolicy(this.reconnectionHealthPolicy, connectionHealthData, ()=>{
            this.context.audioVideoController.handleMeetingSessionStatus(new $b385a7c0a93e46fc$var$MeetingSessionStatus_1.default($b385a7c0a93e46fc$var$MeetingSessionStatusCode_1.default.ConnectionHealthReconnect), null);
        });
        this.applyHealthPolicy(this.unusableAudioWarningHealthPolicy, connectionHealthData, ()=>{
            var _a;
            this.context.poorConnectionCount += 1;
            (_a = this.context.eventController) === null || _a === void 0 || _a.publishEvent('receivingAudioDropped', (0, $byDbS.audioVideoEventAttributesFromState)(this.context));
            if (this.context.videoTileController.haveVideoTilesWithStreams()) this.context.audioVideoController.forEachObserver((observer)=>{
                $jfpqH.Maybe.of(observer.connectionDidSuggestStopVideo).map((f)=>f.bind(observer)());
            });
            else this.context.audioVideoController.forEachObserver((observer)=>{
                $jfpqH.Maybe.of(observer.connectionDidBecomePoor).map((f)=>f.bind(observer)());
            });
        }, ()=>{
            this.context.audioVideoController.forEachObserver((observer)=>{
                $jfpqH.Maybe.of(observer.connectionDidBecomeGood).map((f)=>f.bind(observer)());
            });
        });
        for (const policy of this.videoEncodingHealthPolicies)this.applyHealthPolicy(policy, connectionHealthData, ()=>{
            this.degradeVideoEncoding(policy.name);
            switch(policy.name){
                case $b385a7c0a93e46fc$var$VideoEncodingConnectionHealthPolicyName_1.default.VideoEncodingCpuHealth:
                    this.context.statsCollector.videoCodecDegradationHighEncodeCpuDidReceive();
                    break;
                case $b385a7c0a93e46fc$var$VideoEncodingConnectionHealthPolicyName_1.default.VideoEncodingFramerateHealth:
                    this.context.statsCollector.videoCodecDegradationEncodeFailureDidReceive();
                    break;
                case $b385a7c0a93e46fc$var$VideoEncodingConnectionHealthPolicyName_1.default.VideoConcurrentSendersHealth:
                    this.context.statsCollector.videoCodecDegradationConcurrentSendersDidReceive();
                    break;
            }
        });
        if (this.context.isSessionConnected) {
            const publishFilteredEvent = (event)=>{
                var _a;
                const attributes = (0, $byDbS.audioVideoEventAttributesFromState)(this.context);
                (_a = this.context.eventController) === null || _a === void 0 || _a.publishEvent(event, attributes);
            };
            this.applyHealthPolicy(this.sendingAudioFailureHealthPolicy, connectionHealthData, ()=>publishFilteredEvent('sendingAudioFailed'), ()=>publishFilteredEvent('sendingAudioRecovered'));
        }
    }
    applyHealthPolicy(healthPolicy, connectionHealthData, unhealthyCallback, healthyCallback) {
        healthPolicy.update(connectionHealthData);
        const healthValue = healthPolicy.healthIfChanged();
        if (healthValue !== null) {
            this.logger.info(`${healthPolicy.name} value is now ${healthValue}`);
            if (healthValue <= healthPolicy.minimumHealth()) $jfpqH.Maybe.of(unhealthyCallback).map((f)=>f.bind(this)());
            else $jfpqH.Maybe.of(healthyCallback).map((f)=>f.bind(this)());
        }
    }
    handleBitrateFrame(bitrates) {
        this.currentAvailableStreamAvgBitrates = bitrates;
        if (bitrates.serverAvailableOutgoingBitrate > 0) {
            this.logger.info(`Received server side estimation of available incoming bitrate ${bitrates.serverAvailableOutgoingBitrate}kbps`);
            // This value will be included in the 'Bitrates' signaling message if we are using
            // server side remote video quality adaption, since if that is the case we will
            // be using TWCC and will therefore not likely have an estimate on the client
            // for available incoming bitrate
            this.context.statsCollector.overrideObservableMetric('availableIncomingBitrate', bitrates.serverAvailableOutgoingBitrate * 1000);
        }
    }
    handleSignalingClientEvent(event) {
        var _a;
        // Don't add two or more consecutive "signalingDropped" states.
        if (event.type === $b385a7c0a93e46fc$var$SignalingClientEventType_1.default.WebSocketClosed && this.isUnexpectedsignalingCloseCode(event.closeCode) || event.type === $b385a7c0a93e46fc$var$SignalingClientEventType_1.default.WebSocketError || event.type === $b385a7c0a93e46fc$var$SignalingClientEventType_1.default.WebSocketFailed) {
            if (!this.hasSignalingError) {
                (_a = this.context.eventController) === null || _a === void 0 || _a.publishEvent('signalingDropped', {
                    ...(0, $byDbS.audioVideoEventAttributesFromState)(this.context),
                    ...event.closeCode !== undefined && {
                        signalingCloseCode: event.closeCode
                    },
                    ...event.closeReason !== undefined && {
                        signalingCloseReason: event.closeReason
                    },
                    ...event.wasClean !== undefined && {
                        signalingCloseWasClean: event.wasClean
                    }
                });
                this.hasSignalingError = true;
            }
            if (this.context.isSessionConnected) this.context.audioVideoController.handleMeetingSessionStatus(new $b385a7c0a93e46fc$var$MeetingSessionStatus_1.default(this.isInternalServerFailureCloseCode(event.closeCode) ? $b385a7c0a93e46fc$var$MeetingSessionStatusCode_1.default.SignalingInternalServerError : $b385a7c0a93e46fc$var$MeetingSessionStatusCode_1.default.SignalingChannelClosedUnexpectedly), null);
        } else if (event.type === $b385a7c0a93e46fc$var$SignalingClientEventType_1.default.WebSocketOpen) this.hasSignalingError = false;
        if (event.type === $b385a7c0a93e46fc$var$SignalingClientEventType_1.default.ReceivedSignalFrame) {
            if (event.message.type === $4huDn.SdkSignalFrame.Type.NOTIFICATION) {
                switch(event.message.notification.level){
                    case $4huDn.SdkNotificationFrame.NotificationLevel.INFO:
                        this.logger.info(`Received notification from server: ${event.message.notification.message}`);
                        break;
                    case $4huDn.SdkNotificationFrame.NotificationLevel.WARNING:
                        this.logger.warn(`Received warning from server: ${event.message.notification.message}`);
                        break;
                    case $4huDn.SdkNotificationFrame.NotificationLevel.ERROR:
                        this.logger.error(`Received error from server: ${event.message.notification.message}`);
                        break;
                    default:
                        this.logger.error(`Received notification from server with unknown level ${event.message.notification.level}: ${event.message.notification.message}`);
                        break;
                }
                return;
            }
            if (event.message.bitrates) {
                const bitrateFrame = event.message.bitrates;
                this.context.videoStreamIndex.integrateBitratesFrame(bitrateFrame);
                this.context.videoDownlinkBandwidthPolicy.updateIndex(this.context.videoStreamIndex);
                this.handleBitrateFrame(event.message.bitrates);
            }
            const status = $b385a7c0a93e46fc$var$MeetingSessionStatus_1.default.fromSignalFrame(event.message);
            // Primary meeting join ack status will be handled by `PromoteToPrimaryMeetingTask`
            if (event.message.type !== $4huDn.SdkSignalFrame.Type.PRIMARY_MEETING_JOIN_ACK && status.statusCode() !== $b385a7c0a93e46fc$var$MeetingSessionStatusCode_1.default.OK) this.context.audioVideoController.handleMeetingSessionStatus(status, null);
        }
    }
    isUnexpectedsignalingCloseCode(closeCode) {
        return(// Abnormal Closure. This might be expected for unplanned disconnections.
        closeCode === 1006 || this.isInternalServerFailureCloseCode(closeCode));
    }
    isInternalServerFailureCloseCode(closeCode) {
        return(// Custom close codes that may be sent by the backend
        closeCode >= 4500 && closeCode < 4600);
    }
    /**
     * Degrade video Encoding to an alternative scalability mode or codec
     */ degradeVideoEncoding(cause) {
        var _a;
        if (((_a = this.context.videoUplinkBandwidthPolicy) === null || _a === void 0 ? void 0 : _a.degradeScalabilityMode) && this.context.videoUplinkBandwidthPolicy.degradeScalabilityMode()) {
            this.context.audioVideoController.update({
                needsRenegotiation: false
            });
            // No need to degrade video codec if there is an alternative scalability mode
            return;
        }
        // Degrade video codec if there are other codec options and current codec is not H264 CBP or VP8
        if (this.context.meetingSupportedVideoSendCodecPreferences !== undefined && this.context.meetingSupportedVideoSendCodecPreferences.length > 1 && !(this.context.meetingSupportedVideoSendCodecPreferences[0].equals($b385a7c0a93e46fc$var$VideoCodecCapability_1.default.h264ConstrainedBaselineProfile()) || this.context.meetingSupportedVideoSendCodecPreferences[0].equals($b385a7c0a93e46fc$var$VideoCodecCapability_1.default.vp8()))) {
            const newMeetingSupportedVideoSendCodecPreferences = [];
            for (const capability of this.context.videoSendCodecPreferences)if (!capability.equals(this.context.meetingSupportedVideoSendCodecPreferences[0])) newMeetingSupportedVideoSendCodecPreferences.push(capability);
            if (newMeetingSupportedVideoSendCodecPreferences.length > 0) {
                this.context.logger.info(`Downgrading codec from ${this.context.meetingSupportedVideoSendCodecPreferences[0].codecName} to ${newMeetingSupportedVideoSendCodecPreferences[0].codecName} due to ${cause}`);
                this.context.degradedVideoSendCodecs.push(this.context.meetingSupportedVideoSendCodecPreferences[0]);
                this.context.meetingSupportedVideoSendCodecPreferences = newMeetingSupportedVideoSendCodecPreferences;
                if (this.context.videoUplinkBandwidthPolicy.setMeetingSupportedVideoSendCodecs) this.context.videoUplinkBandwidthPolicy.setMeetingSupportedVideoSendCodecs(this.context.meetingSupportedVideoSendCodecPreferences, this.context.videoSendCodecPreferences);
                this.context.audioVideoController.update({
                    needsRenegotiation: true
                });
            } else this.context.logger.warn(`Degrading video codec failed since there is no alternative codec to select. Currently degraded codecs: ${this.context.degradedVideoSendCodecs.map((capability)=>capability.codecName).join(',')}`);
        }
    }
}
module.exports.default = $b385a7c0a93e46fc$var$MonitorTask;

});
parcelRegister("bogAf", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $84aeccc71da7eec1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $84aeccc71da7eec1$var$BaseConnectionHealthPolicy_1 = $84aeccc71da7eec1$var$__importDefault((parcelRequire("j8TgN")));
class $84aeccc71da7eec1$var$ReconnectionHealthPolicy extends $84aeccc71da7eec1$var$BaseConnectionHealthPolicy_1.default {
    constructor(logger, configuration, data){
        super(configuration, data, 'Reconnection Health');
        this.logger = logger;
        this.audioDelayPointsOverMaximum = 0;
        $84aeccc71da7eec1$var$ReconnectionHealthPolicy.CONNECTION_UNHEALTHY_THRESHOLD = configuration.connectionUnhealthyThreshold;
        $84aeccc71da7eec1$var$ReconnectionHealthPolicy.CONNECTION_WAIT_TIME_MS = configuration.connectionWaitTimeMs;
        $84aeccc71da7eec1$var$ReconnectionHealthPolicy.MISSED_PONGS_THRESHOLD = configuration.missedPongsUpperThreshold;
        $84aeccc71da7eec1$var$ReconnectionHealthPolicy.MAXIMUM_AUDIO_DELAY_MS = configuration.maximumAudioDelayMs;
        $84aeccc71da7eec1$var$ReconnectionHealthPolicy.MAXIMUM_AUDIO_DELAY_DATA_POINTS = configuration.maximumAudioDelayDataPoints;
    }
    health() {
        const connectionStartedRecently = this.currentData.isConnectionStartRecent($84aeccc71da7eec1$var$ReconnectionHealthPolicy.CONNECTION_WAIT_TIME_MS);
        if (connectionStartedRecently) return 1;
        const noPacketsReceivedRecently = this.currentData.consecutiveStatsWithNoPackets >= $84aeccc71da7eec1$var$ReconnectionHealthPolicy.CONNECTION_UNHEALTHY_THRESHOLD;
        const missedPongsRecently = this.currentData.consecutiveMissedPongs >= $84aeccc71da7eec1$var$ReconnectionHealthPolicy.MISSED_PONGS_THRESHOLD;
        if (this.currentData.audioSpeakerDelayMs > $84aeccc71da7eec1$var$ReconnectionHealthPolicy.MAXIMUM_AUDIO_DELAY_MS) this.audioDelayPointsOverMaximum += 1;
        else this.audioDelayPointsOverMaximum = 0;
        const hasBadAudioDelay = this.audioDelayPointsOverMaximum > $84aeccc71da7eec1$var$ReconnectionHealthPolicy.MAXIMUM_AUDIO_DELAY_DATA_POINTS;
        if (hasBadAudioDelay) this.audioDelayPointsOverMaximum = 0;
        const needsReconnect = noPacketsReceivedRecently || missedPongsRecently || hasBadAudioDelay;
        if (needsReconnect) {
            this.logger.warn(`reconnection recommended due to: no packets received: ${noPacketsReceivedRecently}, missed pongs: ${missedPongsRecently}, bad audio delay: ${hasBadAudioDelay}`);
            return 0;
        }
        return 1;
    }
}
module.exports.default = $84aeccc71da7eec1$var$ReconnectionHealthPolicy;

});

parcelRegister("53rdn", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $3ae257db39082cf8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $3ae257db39082cf8$var$BaseConnectionHealthPolicy_1 = $3ae257db39082cf8$var$__importDefault((parcelRequire("j8TgN")));
class $3ae257db39082cf8$var$SendingAudioFailureConnectionHealthPolicy extends $3ae257db39082cf8$var$BaseConnectionHealthPolicy_1.default {
    constructor(logger, configuration, data){
        super(configuration, data, 'Sending Audio Health');
        this.logger = logger;
        this.sendingAudioFailureSamplesToConsider = configuration.sendingAudioFailureSamplesToConsider > 0 ? configuration.sendingAudioFailureSamplesToConsider : 1;
        this.sendingAudioFailureInitialWaitTimeMs = configuration.sendingAudioFailureInitialWaitTimeMs;
        this.maximumTimesToWarn = configuration.maximumTimesToWarn;
        this.coolDownTimeMs = configuration.cooldownTimeMs;
        this.lastWarnTimestampMs = 0;
        this.warnCount = 0;
    }
    isSendingAudioUnhealthy() {
        const hasEnoughTimeElapsedToEvaluateStatus = !this.currentData.isConnectionStartRecent(this.sendingAudioFailureInitialWaitTimeMs);
        const areAudioPacketsNotBeingSent = this.currentData.consecutiveStatsWithNoAudioPacketsSent >= this.sendingAudioFailureSamplesToConsider;
        return hasEnoughTimeElapsedToEvaluateStatus && areAudioPacketsNotBeingSent;
    }
    health() {
        if (this.isSendingAudioUnhealthy()) {
            const didWarnRecently = Date.now() - this.lastWarnTimestampMs < this.coolDownTimeMs;
            if (this.currentHealth > this.minimumHealth() && !didWarnRecently) {
                this.logger.warn(`Sending Audio is unhealthy for ${this.sendingAudioFailureSamplesToConsider} seconds consecutively.`);
                this.warnCount++;
                if (this.warnCount > this.maximumTimesToWarn) {
                    this.logger.warn('SendingAudioFailure health policy maximum warnings breached. Falling back to reporting healthy.');
                    return this.maximumHealth();
                }
                this.lastWarnTimestampMs = Date.now();
                return this.minimumHealth();
            } else return this.currentHealth;
        }
        return this.maximumHealth();
    }
}
module.exports.default = $3ae257db39082cf8$var$SendingAudioFailureConnectionHealthPolicy;

});

parcelRegister("aa9Qv", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $766279b947748e48$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $766279b947748e48$var$BaseConnectionHealthPolicy_1 = $766279b947748e48$var$__importDefault((parcelRequire("j8TgN")));
class $766279b947748e48$var$UnusableAudioWarningConnectionHealthPolicy extends $766279b947748e48$var$BaseConnectionHealthPolicy_1.default {
    constructor(configuration, data){
        super(configuration, data, 'Unusable Audio Warning');
        this.coolDownTimeMs = configuration.cooldownTimeMs;
        this.pastSamplesToConsider = configuration.pastSamplesToConsider;
        this.fractionalLoss = configuration.fractionalLoss;
        this.packetsExpected = configuration.packetsExpected;
        this.maximumTimesToWarn = configuration.maximumTimesToWarn;
        this.lastWarnTimestampMs = 0;
        this.warnCount = 0;
    }
    calculateFractionalLoss() {
        if (this.currentData.packetsReceivedInLastMinute.length < this.pastSamplesToConsider) return 0;
        const samplesToConsider = this.pastSamplesToConsider;
        const totalPacketsExpected = samplesToConsider * this.packetsExpected;
        let totalPacketsReceived = 0;
        for(let i = 0; i < samplesToConsider; i++)totalPacketsReceived += this.currentData.packetsReceivedInLastMinute[i];
        return Math.min(Math.max(1 - totalPacketsReceived / totalPacketsExpected, 0), 1);
    }
    health() {
        const warnedRecently = Date.now() - this.lastWarnTimestampMs < this.coolDownTimeMs;
        if (warnedRecently) return this.currentHealth;
        const hasHadHighPacketLoss = this.calculateFractionalLoss() >= this.fractionalLoss;
        if (hasHadHighPacketLoss) {
            if (this.currentHealth !== 0) {
                this.lastWarnTimestampMs = Date.now();
                this.warnCount++;
                if (this.warnCount > this.maximumTimesToWarn) return 1;
            }
            return 0;
        }
        return 1;
    }
}
module.exports.default = $766279b947748e48$var$UnusableAudioWarningConnectionHealthPolicy;

});


parcelRegister("agKJo", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $779fa5d2fd5a3c5c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $779fa5d2fd5a3c5c$var$SignalingClientConnectionRequest_1 = $779fa5d2fd5a3c5c$var$__importDefault((parcelRequire("l831h")));

const $779fa5d2fd5a3c5c$var$SignalingClientEventType_1 = $779fa5d2fd5a3c5c$var$__importDefault((parcelRequire("1lA8I")));

const $779fa5d2fd5a3c5c$var$BaseTask_1 = $779fa5d2fd5a3c5c$var$__importDefault((parcelRequire("9wPDz")));
class $779fa5d2fd5a3c5c$var$OpenSignalingConnectionTask extends $779fa5d2fd5a3c5c$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'OpenSignalingConnectionTask';
        this.taskCanceler = null;
    }
    cancel() {
        if (this.taskCanceler) {
            this.taskCanceler.cancel();
            this.taskCanceler = null;
        }
    }
    async run() {
        const configuration = this.context.meetingSessionConfiguration;
        this.context.signalingClient.openConnection(new $779fa5d2fd5a3c5c$var$SignalingClientConnectionRequest_1.default(configuration.urls.signalingURL, configuration.credentials.joinToken));
        const startTimeMs = Date.now();
        try {
            await new Promise((resolve, reject)=>{
                class WebSocketOpenInterceptor {
                    constructor(signalingClient){
                        this.signalingClient = signalingClient;
                    }
                    cancel() {
                        this.signalingClient.removeObserver(this);
                        reject(new Error(`OpenSignalingConnectionTask got canceled while waiting to open signaling connection`));
                    }
                    handleSignalingClientEvent(event) {
                        switch(event.type){
                            case $779fa5d2fd5a3c5c$var$SignalingClientEventType_1.default.WebSocketOpen:
                                this.signalingClient.removeObserver(this);
                                resolve();
                                break;
                            case $779fa5d2fd5a3c5c$var$SignalingClientEventType_1.default.WebSocketFailed:
                                this.signalingClient.removeObserver(this);
                                reject(new Error('WebSocket connection failed'));
                                break;
                        }
                    }
                }
                const interceptor = new WebSocketOpenInterceptor(this.context.signalingClient);
                this.context.signalingClient.registerObserver(interceptor);
                this.taskCanceler = interceptor;
            });
        } catch (error) {
            throw error;
        } finally{
            this.context.signalingOpenDurationMs = Math.round(Date.now() - startTimeMs);
            this.logger.info(`Opening signaling connection took ${this.context.signalingOpenDurationMs} ms`);
        }
    }
}
module.exports.default = $779fa5d2fd5a3c5c$var$OpenSignalingConnectionTask;

});
parcelRegister("l831h", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/*
 * [[SignalingClientConnectionRequest]] represents an connection request.
 */ class $f61caff1fb1061e4$var$SignalingClientConnectionRequest {
    /** Creates a request with the given URL, conference id, and join token.
     *
     * @param signalingURL The URL of the signaling proxy.
     * @param joinToken The join token that will authenticate the connection.
     */ constructor(signalingURL, joinToken){
        this.signalingURL = signalingURL;
        this.joinToken = joinToken;
    }
    /** Gets the signaling URL representing this request.*/ url() {
        return this.signalingURL + '?X-Chime-Control-Protocol-Version=3&X-Amzn-Chime-Send-Close-On-Error=1';
    }
    /** Gets the protocols associated with this request.*/ protocols() {
        return [
            '_aws_wt_session',
            this.joinToken
        ];
    }
}
module.exports.default = $f61caff1fb1061e4$var$SignalingClientConnectionRequest;

});


parcelRegister("aaIQX", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $767da174e8be655b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $767da174e8be655b$var$BaseTask_1 = $767da174e8be655b$var$__importDefault((parcelRequire("9wPDz")));
/**
 * [[ParallelGroupTask]] runs a set of tasks in parallel. When canceled, it
 * stops any currently running tasks.
 */ class $767da174e8be655b$var$ParallelGroupTask extends $767da174e8be655b$var$BaseTask_1.default {
    constructor(logger, taskName, tasksToRunParallel){
        super(logger);
        this.taskName = taskName;
        this.tasksToRunParallel = tasksToRunParallel;
        for (const task of tasksToRunParallel)task.setParent(this);
    }
    cancel() {
        for (const task of this.tasksToRunParallel){
            this.logger.info(`canceling parallel group task ${this.name()} subtask ${task.name()}`);
            task.cancel();
        }
    }
    async run() {
        const taskResults = [];
        for (const task of this.tasksToRunParallel){
            this.logger.info(`parallel group task ${this.name()} running subtask ${task.name()}`);
            taskResults.push(task.run());
        }
        const failures = [];
        for(let i = 0; i < taskResults.length; i++){
            try {
                await taskResults[i];
            } catch (err) {
                failures.push(`task ${this.tasksToRunParallel[i].name()} failed: ${err.message}`);
            }
            this.logger.info(`parallel group task ${this.name()} completed subtask ${this.tasksToRunParallel[i].name()}`);
        }
        if (failures.length > 0) {
            const failureMessage = failures.join(', ');
            this.logAndThrow(`parallel group task ${this.name()} failed for tasks: ${failureMessage}`);
        }
        this.logger.info(`parallel group task ${this.name()} completed`);
    }
}
module.exports.default = $767da174e8be655b$var$ParallelGroupTask;

});

parcelRegister("ik076", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $d56a2ece88190d4d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lWMVu = parcelRequire("lWMVu");

const $d56a2ece88190d4d$var$SignalingClientEventType_1 = $d56a2ece88190d4d$var$__importDefault((parcelRequire("1lA8I")));

var $4huDn = parcelRequire("4huDn");

const $d56a2ece88190d4d$var$BaseTask_1 = $d56a2ece88190d4d$var$__importDefault((parcelRequire("9wPDz")));
/**
 * [[PromoteToPrimaryMeetingTask]] sends a `SdkSignalFrame.PrimaryMeetingJoin` and waits for
 * a `SdkSignalFrame.PrimaryMeetingJoinAck`  frame.
 */ class $d56a2ece88190d4d$var$PromoteToPrimaryMeetingTask extends $d56a2ece88190d4d$var$BaseTask_1.default {
    constructor(context, credentials, completionCallback){
        super(context.logger);
        this.context = context;
        this.credentials = credentials;
        this.completionCallback = completionCallback;
        this.taskName = 'PromoteToPrimaryMeetingTask';
        this.taskCanceler = null;
    }
    cancel() {
        if (this.taskCanceler) {
            this.taskCanceler.cancel();
            this.taskCanceler = null;
        }
    }
    async run() {
        if (this.context.signalingClient.ready()) {
            this.context.signalingClient.promoteToPrimaryMeeting(this.credentials);
            this.context.logger.info('Sent request to join primary meeting');
            await this.receivePrimaryMeetingJoinAck();
        } else this.completionCallback(new $lWMVu.MeetingSessionStatus($lWMVu.MeetingSessionStatusCode.SignalingRequestFailed));
    }
    receivePrimaryMeetingJoinAck() {
        return new Promise((resolve, _)=>{
            class Interceptor {
                constructor(signalingClient, completionCallback, logger){
                    this.signalingClient = signalingClient;
                    this.completionCallback = completionCallback;
                    this.logger = logger;
                }
                cancel() {
                    this.signalingClient.removeObserver(this);
                    // Currently only cancel would come from timeout.  Should
                    // be rare enough (ignoring bugs) that we don't need to bother
                    // retrying.
                    this.completionCallback(new $lWMVu.MeetingSessionStatus($lWMVu.MeetingSessionStatusCode.SignalingRequestFailed));
                    resolve();
                }
                handleSignalingClientEvent(event) {
                    if (event.isConnectionTerminated()) {
                        this.signalingClient.removeObserver(this);
                        this.logger.info('PromoteToPrimaryMeetingTask connection terminated');
                        // This would happen either in happy or unhappy disconnections.  The
                        // timing here is rare enough (ignoring bugs) that we don't need to bother
                        // retrying the unhappy case.
                        this.completionCallback(new $lWMVu.MeetingSessionStatus($lWMVu.MeetingSessionStatusCode.SignalingRequestFailed));
                        resolve();
                    }
                    if (event.type === $d56a2ece88190d4d$var$SignalingClientEventType_1.default.ReceivedSignalFrame && event.message.type === $4huDn.SdkSignalFrame.Type.PRIMARY_MEETING_JOIN_ACK) {
                        this.signalingClient.removeObserver(this);
                        this.logger.info('Got a primary meeting join ACK');
                        this.completionCallback($lWMVu.MeetingSessionStatus.fromSignalFrame(event.message));
                        resolve();
                    }
                }
            }
            const interceptor = new Interceptor(this.context.signalingClient, this.completionCallback, this.context.logger);
            this.taskCanceler = interceptor;
            this.context.signalingClient.registerObserver(interceptor);
        });
    }
}
module.exports.default = $d56a2ece88190d4d$var$PromoteToPrimaryMeetingTask;

});
parcelRegister("lWMVu", function(module, exports) {
"use strict";
var $ffa4f776a53505dd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultEncodedTransformWorkerManager = module.exports.DefaultDevicePixelRatioMonitor = module.exports.DefaultDeviceController = module.exports.DefaultContentShareController = module.exports.DefaultBrowserBehavior = module.exports.DefaultAudioVideoFacade = module.exports.DefaultAudioVideoController = module.exports.DefaultAudioMixController = module.exports.DefaultActiveSpeakerPolicy = module.exports.DefaultActiveSpeakerDetector = module.exports.DataMessage = module.exports.CreateSDPTask = module.exports.CreatePeerConnectionTask = module.exports.ContentShareMediaStreamBroker = module.exports.ContentShareConstants = module.exports.ConsoleLogger = module.exports.ConnectionHealthPolicyConfiguration = module.exports.ConnectionHealthData = module.exports.ClientVideoStreamReceivingReport = module.exports.ClientMetricReportMediaType = module.exports.ClientMetricReportDirection = module.exports.ClientMetricReport = module.exports.CleanStoppedSessionTask = module.exports.CleanRestartedSessionTask = module.exports.CheckVideoInputFeedback = module.exports.CheckVideoConnectivityFeedback = module.exports.CheckNetworkUDPConnectivityFeedback = module.exports.CheckNetworkTCPConnectivityFeedback = module.exports.CheckContentShareConnectivityFeedback = module.exports.CheckCameraResolutionFeedback = module.exports.CheckAudioOutputFeedback = module.exports.CheckAudioInputFeedback = module.exports.CheckAudioConnectivityFeedback = module.exports.CanvasVideoFrameBuffer = module.exports.CSPMonitor = module.exports.BitrateParameters = module.exports.BaseTask = module.exports.BaseConnectionHealthPolicy = module.exports.BackgroundReplacementVideoFrameProcessor = module.exports.BackgroundFilterVideoFrameProcessor = module.exports.BackgroundBlurVideoFrameProcessor = module.exports.BackgroundBlurStrength = module.exports.AudioVideoControllerState = module.exports.AudioProfile = module.exports.AudioLogEvent = module.exports.Attendee = module.exports.AttachMediaInputTask = module.exports.AsyncScheduler = module.exports.ApplicationMetadata = module.exports.AllHighestVideoBandwidthPolicy = void 0;
module.exports.Maybe = module.exports.LogLevel = module.exports.Log = module.exports.ListenForVolumeIndicatorsTask = module.exports.LeaveAndReceiveLeaveAckTask = module.exports.JoinAndReceiveIndexTask = module.exports.IntervalScheduler = module.exports.InMemoryJSONEventBuffer = module.exports.GlobalMetricReport = module.exports.GetUserMediaError = module.exports.FullJitterLimitedBackoff = module.exports.FullJitterBackoffFactory = module.exports.FullJitterBackoff = module.exports.FinishGatheringICECandidatesTask = module.exports.EventIngestionConfiguration = module.exports.EventBufferConfiguration = module.exports.EncodedTransformWorkerCode = module.exports.EncodedTransformManager = module.exports.DeviceSelection = module.exports.DevicePixelRatioWindowSource = module.exports.DefaultWebSocketAdapter = module.exports.DefaultVolumeIndicatorAdapter = module.exports.DefaultVideoTransformDevice = module.exports.DefaultVideoTileFactory = module.exports.DefaultVideoTileController = module.exports.DefaultVideoTile = module.exports.DefaultVideoStreamIndex = module.exports.DefaultVideoStreamIdSet = module.exports.DefaultVideoFrameProcessorTimer = module.exports.DefaultVideoFrameProcessorPipeline = module.exports.DefaultVideoElementResolutionMonitor = module.exports.DefaultVideoCaptureAndEncodeParameter = module.exports.DefaultUserAgentParser = module.exports.DefaultTranscriptionController = module.exports.DefaultTransceiverController = module.exports.DefaultSimulcastUplinkPolicyForContentShare = module.exports.DefaultSimulcastUplinkPolicy = module.exports.DefaultSignalingClient = module.exports.DefaultSigV4 = module.exports.DefaultSessionStateController = module.exports.DefaultReconnectController = module.exports.DefaultRealtimeController = module.exports.DefaultPingPong = module.exports.DefaultModality = module.exports.DefaultMessagingSession = module.exports.DefaultMeetingSession = module.exports.DefaultMeetingReadinessChecker = module.exports.DefaultMeetingEventReporter = module.exports.DefaultMediaDeviceFactory = module.exports.DefaultEventController = void 0;
module.exports.ReceiveAudioInputTask = module.exports.RealtimeVolumeIndicator = module.exports.RealtimeState = module.exports.RealtimeAttendeePositionInFrame = module.exports.PromoteToPrimaryMeetingTask = module.exports.PromiseQueue = module.exports.PrefetchSortBy = module.exports.PrefetchOn = module.exports.PermissionDeniedError = module.exports.ParallelGroupTask = module.exports.POSTLogger = module.exports.OverconstrainedError = module.exports.OpenSignalingConnectionTask = module.exports.OnceTask = module.exports.NotReadableError = module.exports.NotFoundError = module.exports.None = module.exports.NoVideoUplinkBandwidthPolicy = module.exports.NoVideoDownlinkBandwidthPolicy = module.exports.NoOpVideoFrameProcessor = module.exports.NoOpVideoElementFactory = module.exports.NoOpTask = module.exports.NoOpMediaStreamBroker = module.exports.NoOpLogger = module.exports.NoOpEventReporter = module.exports.NoOpDeviceController = module.exports.NoOpDebugLogger = module.exports.NoOpAudioVideoController = module.exports.NScaleVideoUplinkBandwidthPolicy = module.exports.MutableVideoPreferences = module.exports.MultiLogger = module.exports.MonitorTask = module.exports.ModelSpecBuilder = module.exports.MessagingSessionConfiguration = module.exports.Message = module.exports.MeetingSessionVideoAvailability = module.exports.MeetingSessionURLs = module.exports.MeetingSessionTimingManager = module.exports.MeetingSessionTURNCredentials = module.exports.MeetingSessionStatusCode = module.exports.MeetingSessionStatus = module.exports.MeetingSessionLifecycleEventCondition = module.exports.MeetingSessionLifecycleEvent = module.exports.MeetingSessionCredentials = module.exports.MeetingSessionConfiguration = module.exports.MeetingReadinessCheckerConfiguration = module.exports.MeetingFeatures = module.exports.MeetingEventsClientConfiguration = module.exports.MediaMetricsEncodedTransformManager = module.exports.MediaDeviceProxyHandler = void 0;
module.exports.TranscriptionStatus = module.exports.TranscriptResult = module.exports.TranscriptLanguageWithScore = module.exports.TranscriptItemType = module.exports.TranscriptItem = module.exports.TranscriptEntity = module.exports.TranscriptAlternative = module.exports.Transcript = module.exports.TimeoutTask = module.exports.TimeoutScheduler = module.exports.TaskStatus = module.exports.TargetDisplaySize = module.exports.SubscribeAndReceiveSubscribeAckTask = module.exports.StreamMetricReport = module.exports.StartEncodedTransformWorkerTask = module.exports.Some = module.exports.SingleNodeAudioTransformDevice = module.exports.SimulcastVideoStreamIndex = module.exports.SimulcastTransceiverController = module.exports.SimulcastLayers = module.exports.SimulcastContentShareTransceiverController = module.exports.SignalingClientVideoSubscriptionConfiguration = module.exports.SignalingClientSubscribe = module.exports.SignalingClientJoin = module.exports.SignalingClientEventType = module.exports.SignalingClientEvent = module.exports.SignalingClientConnectionRequest = module.exports.SignalingAndMetricsConnectionMonitor = module.exports.SetRemoteDescriptionTask = module.exports.SetLocalDescriptionTask = module.exports.SessionStateControllerTransitionResult = module.exports.SessionStateControllerState = module.exports.SessionStateControllerDeferPriority = module.exports.SessionStateControllerAction = module.exports.ServerSideNetworkAdaption = module.exports.SerialGroupTask = module.exports.SendingAudioFailureConnectionHealthPolicy = module.exports.SendAndReceiveDataMessagesTask = module.exports.SDPMediaSection = module.exports.SDPCandidateType = module.exports.SDP = module.exports.RunnableTask = module.exports.RedundantAudioRecoveryMetricReport = module.exports.RedundantAudioEncoderWorkerCode = module.exports.RedundantAudioEncodedTransformManager = module.exports.RedundantAudioEncodedTransform = module.exports.ReconnectionHealthPolicy = module.exports.ReceiveVideoStreamIndexTask = module.exports.ReceiveVideoInputTask = module.exports.ReceiveRemoteVideoPauseResumeTask = void 0;
module.exports.isVideoTransformDevice = module.exports.isDestroyable = module.exports.isAudioTransformDevice = module.exports.ZLIBTextCompressor = module.exports.WebSocketReadyState = module.exports.WaitForAttendeePresenceTask = module.exports.VoiceFocusTransformDevice = module.exports.VoiceFocusDeviceTransformer = module.exports.VideoTileState = module.exports.VideoStreamDescription = module.exports.VideoSource = module.exports.VideoQualitySettings = module.exports.VideoQualityAdaptationPreference = module.exports.VideoPriorityBasedPolicyConfig = module.exports.VideoPriorityBasedPolicy = module.exports.VideoPreferences = module.exports.VideoPreference = module.exports.VideoOnlyTransceiverController = module.exports.VideoLogEvent = module.exports.VideoFxProcessor = module.exports.VideoEncodingFramerateConnectionHealthPolicy = module.exports.VideoEncodingCpuConnectionHealthPolicy = module.exports.VideoEncodingConnectionHealthPolicyName = module.exports.VideoEncodingConcurrentSendersHealthPolicy = module.exports.VideoElementFrameMonitor = module.exports.VideoCodecCapability = module.exports.VideoAdaptiveProbePolicy = module.exports.Versioning = module.exports.UnusableAudioWarningConnectionHealthPolicy = module.exports.TypeError = module.exports.TranscriptionStatusType = void 0;

const $ffa4f776a53505dd$var$AllHighestVideoBandwidthPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("loTax")));
module.exports.AllHighestVideoBandwidthPolicy = $ffa4f776a53505dd$var$AllHighestVideoBandwidthPolicy_1.default;

const $ffa4f776a53505dd$var$ApplicationMetadata_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("izoj0")));
module.exports.ApplicationMetadata = $ffa4f776a53505dd$var$ApplicationMetadata_1.default;

const $ffa4f776a53505dd$var$AsyncScheduler_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("4mLYP")));
module.exports.AsyncScheduler = $ffa4f776a53505dd$var$AsyncScheduler_1.default;

const $ffa4f776a53505dd$var$AttachMediaInputTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("4u2O2")));
module.exports.AttachMediaInputTask = $ffa4f776a53505dd$var$AttachMediaInputTask_1.default;

const $ffa4f776a53505dd$var$Attendee_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("brRyw")));
module.exports.Attendee = $ffa4f776a53505dd$var$Attendee_1.default;

const $ffa4f776a53505dd$var$AudioLogEvent_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("2R7XG")));
module.exports.AudioLogEvent = $ffa4f776a53505dd$var$AudioLogEvent_1.default;

const $ffa4f776a53505dd$var$AudioProfile_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("as61y")));
module.exports.AudioProfile = $ffa4f776a53505dd$var$AudioProfile_1.default;

const $ffa4f776a53505dd$var$AudioVideoControllerState_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("lpXGX")));
module.exports.AudioVideoControllerState = $ffa4f776a53505dd$var$AudioVideoControllerState_1.default;

const $ffa4f776a53505dd$var$BackgroundBlurStrength_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("fzQa8")));
module.exports.BackgroundBlurStrength = $ffa4f776a53505dd$var$BackgroundBlurStrength_1.default;

const $ffa4f776a53505dd$var$BackgroundBlurVideoFrameProcessor_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("hYwBJ")));
module.exports.BackgroundBlurVideoFrameProcessor = $ffa4f776a53505dd$var$BackgroundBlurVideoFrameProcessor_1.default;

const $ffa4f776a53505dd$var$BackgroundFilterVideoFrameProcessor_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("5nMOz")));
module.exports.BackgroundFilterVideoFrameProcessor = $ffa4f776a53505dd$var$BackgroundFilterVideoFrameProcessor_1.default;

const $ffa4f776a53505dd$var$BackgroundReplacementVideoFrameProcessor_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("5LciV")));
module.exports.BackgroundReplacementVideoFrameProcessor = $ffa4f776a53505dd$var$BackgroundReplacementVideoFrameProcessor_1.default;

const $ffa4f776a53505dd$var$BaseConnectionHealthPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("j8TgN")));
module.exports.BaseConnectionHealthPolicy = $ffa4f776a53505dd$var$BaseConnectionHealthPolicy_1.default;

const $ffa4f776a53505dd$var$BaseTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("9wPDz")));
module.exports.BaseTask = $ffa4f776a53505dd$var$BaseTask_1.default;

const $ffa4f776a53505dd$var$BitrateParameters_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("la1Bs")));
module.exports.BitrateParameters = $ffa4f776a53505dd$var$BitrateParameters_1.default;

const $ffa4f776a53505dd$var$CSPMonitor_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("6l4nm")));
module.exports.CSPMonitor = $ffa4f776a53505dd$var$CSPMonitor_1.default;

const $ffa4f776a53505dd$var$CanvasVideoFrameBuffer_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("ag7ui")));
module.exports.CanvasVideoFrameBuffer = $ffa4f776a53505dd$var$CanvasVideoFrameBuffer_1.default;

const $ffa4f776a53505dd$var$CheckAudioConnectivityFeedback_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("6J1Iy")));
module.exports.CheckAudioConnectivityFeedback = $ffa4f776a53505dd$var$CheckAudioConnectivityFeedback_1.default;

const $ffa4f776a53505dd$var$CheckAudioInputFeedback_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("foAfi")));
module.exports.CheckAudioInputFeedback = $ffa4f776a53505dd$var$CheckAudioInputFeedback_1.default;

const $ffa4f776a53505dd$var$CheckAudioOutputFeedback_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("bbZBv")));
module.exports.CheckAudioOutputFeedback = $ffa4f776a53505dd$var$CheckAudioOutputFeedback_1.default;

const $ffa4f776a53505dd$var$CheckCameraResolutionFeedback_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("iMyKq")));
module.exports.CheckCameraResolutionFeedback = $ffa4f776a53505dd$var$CheckCameraResolutionFeedback_1.default;

const $ffa4f776a53505dd$var$CheckContentShareConnectivityFeedback_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("iqEpI")));
module.exports.CheckContentShareConnectivityFeedback = $ffa4f776a53505dd$var$CheckContentShareConnectivityFeedback_1.default;

const $ffa4f776a53505dd$var$CheckNetworkTCPConnectivityFeedback_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("cDrWL")));
module.exports.CheckNetworkTCPConnectivityFeedback = $ffa4f776a53505dd$var$CheckNetworkTCPConnectivityFeedback_1.default;

const $ffa4f776a53505dd$var$CheckNetworkUDPConnectivityFeedback_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("1boZv")));
module.exports.CheckNetworkUDPConnectivityFeedback = $ffa4f776a53505dd$var$CheckNetworkUDPConnectivityFeedback_1.default;

const $ffa4f776a53505dd$var$CheckVideoConnectivityFeedback_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("9wJVi")));
module.exports.CheckVideoConnectivityFeedback = $ffa4f776a53505dd$var$CheckVideoConnectivityFeedback_1.default;

const $ffa4f776a53505dd$var$CheckVideoInputFeedback_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("fXIZN")));
module.exports.CheckVideoInputFeedback = $ffa4f776a53505dd$var$CheckVideoInputFeedback_1.default;

const $ffa4f776a53505dd$var$CleanRestartedSessionTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("9zRCJ")));
module.exports.CleanRestartedSessionTask = $ffa4f776a53505dd$var$CleanRestartedSessionTask_1.default;

const $ffa4f776a53505dd$var$CleanStoppedSessionTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("8uHHj")));
module.exports.CleanStoppedSessionTask = $ffa4f776a53505dd$var$CleanStoppedSessionTask_1.default;

const $ffa4f776a53505dd$var$ClientMetricReport_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("dyoZi")));
module.exports.ClientMetricReport = $ffa4f776a53505dd$var$ClientMetricReport_1.default;

const $ffa4f776a53505dd$var$ClientMetricReportDirection_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("hRU3k")));
module.exports.ClientMetricReportDirection = $ffa4f776a53505dd$var$ClientMetricReportDirection_1.default;

const $ffa4f776a53505dd$var$ClientMetricReportMediaType_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("aU8Oy")));
module.exports.ClientMetricReportMediaType = $ffa4f776a53505dd$var$ClientMetricReportMediaType_1.default;

const $ffa4f776a53505dd$var$ClientVideoStreamReceivingReport_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("l8Suu")));
module.exports.ClientVideoStreamReceivingReport = $ffa4f776a53505dd$var$ClientVideoStreamReceivingReport_1.default;

const $ffa4f776a53505dd$var$ConnectionHealthData_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("5TTTN")));
module.exports.ConnectionHealthData = $ffa4f776a53505dd$var$ConnectionHealthData_1.default;

const $ffa4f776a53505dd$var$ConnectionHealthPolicyConfiguration_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("gCpm1")));
module.exports.ConnectionHealthPolicyConfiguration = $ffa4f776a53505dd$var$ConnectionHealthPolicyConfiguration_1.default;

const $ffa4f776a53505dd$var$ConsoleLogger_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("3dGmS")));
module.exports.ConsoleLogger = $ffa4f776a53505dd$var$ConsoleLogger_1.default;

const $ffa4f776a53505dd$var$ContentShareConstants_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("g6nnJ")));
module.exports.ContentShareConstants = $ffa4f776a53505dd$var$ContentShareConstants_1.default;

const $ffa4f776a53505dd$var$ContentShareMediaStreamBroker_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("fpi9L")));
module.exports.ContentShareMediaStreamBroker = $ffa4f776a53505dd$var$ContentShareMediaStreamBroker_1.default;

const $ffa4f776a53505dd$var$CreatePeerConnectionTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("gijOb")));
module.exports.CreatePeerConnectionTask = $ffa4f776a53505dd$var$CreatePeerConnectionTask_1.default;

const $ffa4f776a53505dd$var$CreateSDPTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("h2Cf2")));
module.exports.CreateSDPTask = $ffa4f776a53505dd$var$CreateSDPTask_1.default;

const $ffa4f776a53505dd$var$DataMessage_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("bBKjs")));
module.exports.DataMessage = $ffa4f776a53505dd$var$DataMessage_1.default;

const $ffa4f776a53505dd$var$DefaultActiveSpeakerDetector_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("ep2G0")));
module.exports.DefaultActiveSpeakerDetector = $ffa4f776a53505dd$var$DefaultActiveSpeakerDetector_1.default;

const $ffa4f776a53505dd$var$DefaultActiveSpeakerPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("5ulwq")));
module.exports.DefaultActiveSpeakerPolicy = $ffa4f776a53505dd$var$DefaultActiveSpeakerPolicy_1.default;

const $ffa4f776a53505dd$var$DefaultAudioMixController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("3An1L")));
module.exports.DefaultAudioMixController = $ffa4f776a53505dd$var$DefaultAudioMixController_1.default;

const $ffa4f776a53505dd$var$DefaultAudioVideoController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("cJkH6")));
module.exports.DefaultAudioVideoController = $ffa4f776a53505dd$var$DefaultAudioVideoController_1.default;

const $ffa4f776a53505dd$var$DefaultAudioVideoFacade_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("gal60")));
module.exports.DefaultAudioVideoFacade = $ffa4f776a53505dd$var$DefaultAudioVideoFacade_1.default;

const $ffa4f776a53505dd$var$DefaultBrowserBehavior_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("e2TuV")));
module.exports.DefaultBrowserBehavior = $ffa4f776a53505dd$var$DefaultBrowserBehavior_1.default;

const $ffa4f776a53505dd$var$DefaultContentShareController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("buznb")));
module.exports.DefaultContentShareController = $ffa4f776a53505dd$var$DefaultContentShareController_1.default;

const $ffa4f776a53505dd$var$DefaultDeviceController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("d5Rye")));
module.exports.DefaultDeviceController = $ffa4f776a53505dd$var$DefaultDeviceController_1.default;

const $ffa4f776a53505dd$var$DefaultDevicePixelRatioMonitor_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("lVjeU")));
module.exports.DefaultDevicePixelRatioMonitor = $ffa4f776a53505dd$var$DefaultDevicePixelRatioMonitor_1.default;

const $ffa4f776a53505dd$var$DefaultEncodedTransformWorkerManager_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("6CgU1")));
module.exports.DefaultEncodedTransformWorkerManager = $ffa4f776a53505dd$var$DefaultEncodedTransformWorkerManager_1.default;

const $ffa4f776a53505dd$var$DefaultEventController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("2aVcU")));
module.exports.DefaultEventController = $ffa4f776a53505dd$var$DefaultEventController_1.default;

const $ffa4f776a53505dd$var$DefaultMediaDeviceFactory_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("9WXGW")));
module.exports.DefaultMediaDeviceFactory = $ffa4f776a53505dd$var$DefaultMediaDeviceFactory_1.default;

const $ffa4f776a53505dd$var$DefaultMeetingEventReporter_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("559vU")));
module.exports.DefaultMeetingEventReporter = $ffa4f776a53505dd$var$DefaultMeetingEventReporter_1.default;

const $ffa4f776a53505dd$var$DefaultMeetingReadinessChecker_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("bs7yx")));
module.exports.DefaultMeetingReadinessChecker = $ffa4f776a53505dd$var$DefaultMeetingReadinessChecker_1.default;

const $ffa4f776a53505dd$var$DefaultMeetingSession_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("9iu2u")));
module.exports.DefaultMeetingSession = $ffa4f776a53505dd$var$DefaultMeetingSession_1.default;

const $ffa4f776a53505dd$var$DefaultMessagingSession_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("gaXgg")));
module.exports.DefaultMessagingSession = $ffa4f776a53505dd$var$DefaultMessagingSession_1.default;

const $ffa4f776a53505dd$var$DefaultModality_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("4Zce1")));
module.exports.DefaultModality = $ffa4f776a53505dd$var$DefaultModality_1.default;

const $ffa4f776a53505dd$var$DefaultPingPong_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("1IGkK")));
module.exports.DefaultPingPong = $ffa4f776a53505dd$var$DefaultPingPong_1.default;

const $ffa4f776a53505dd$var$DefaultRealtimeController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("epAu8")));
module.exports.DefaultRealtimeController = $ffa4f776a53505dd$var$DefaultRealtimeController_1.default;

const $ffa4f776a53505dd$var$DefaultReconnectController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("4wU9J")));
module.exports.DefaultReconnectController = $ffa4f776a53505dd$var$DefaultReconnectController_1.default;

const $ffa4f776a53505dd$var$DefaultSessionStateController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("3MoWE")));
module.exports.DefaultSessionStateController = $ffa4f776a53505dd$var$DefaultSessionStateController_1.default;

const $ffa4f776a53505dd$var$DefaultSigV4_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("1LB88")));
module.exports.DefaultSigV4 = $ffa4f776a53505dd$var$DefaultSigV4_1.default;

const $ffa4f776a53505dd$var$DefaultSignalingClient_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("hBJoS")));
module.exports.DefaultSignalingClient = $ffa4f776a53505dd$var$DefaultSignalingClient_1.default;

const $ffa4f776a53505dd$var$DefaultSimulcastUplinkPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("gqzKG")));
module.exports.DefaultSimulcastUplinkPolicy = $ffa4f776a53505dd$var$DefaultSimulcastUplinkPolicy_1.default;

const $ffa4f776a53505dd$var$DefaultSimulcastUplinkPolicyForContentShare_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("h4LS3")));
module.exports.DefaultSimulcastUplinkPolicyForContentShare = $ffa4f776a53505dd$var$DefaultSimulcastUplinkPolicyForContentShare_1.default;

const $ffa4f776a53505dd$var$DefaultTransceiverController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("itul0")));
module.exports.DefaultTransceiverController = $ffa4f776a53505dd$var$DefaultTransceiverController_1.default;

const $ffa4f776a53505dd$var$DefaultTranscriptionController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("apXux")));
module.exports.DefaultTranscriptionController = $ffa4f776a53505dd$var$DefaultTranscriptionController_1.default;

const $ffa4f776a53505dd$var$DefaultUserAgentParser_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("lV7ga")));
module.exports.DefaultUserAgentParser = $ffa4f776a53505dd$var$DefaultUserAgentParser_1.default;

const $ffa4f776a53505dd$var$DefaultVideoCaptureAndEncodeParameter_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("68tZD")));
module.exports.DefaultVideoCaptureAndEncodeParameter = $ffa4f776a53505dd$var$DefaultVideoCaptureAndEncodeParameter_1.default;

const $ffa4f776a53505dd$var$DefaultVideoElementResolutionMonitor_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("ikcNO")));
module.exports.DefaultVideoElementResolutionMonitor = $ffa4f776a53505dd$var$DefaultVideoElementResolutionMonitor_1.default;

const $ffa4f776a53505dd$var$DefaultVideoFrameProcessorPipeline_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("01WSM")));
module.exports.DefaultVideoFrameProcessorPipeline = $ffa4f776a53505dd$var$DefaultVideoFrameProcessorPipeline_1.default;

const $ffa4f776a53505dd$var$DefaultVideoFrameProcessorTimer_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("Zhlnq")));
module.exports.DefaultVideoFrameProcessorTimer = $ffa4f776a53505dd$var$DefaultVideoFrameProcessorTimer_1.default;

const $ffa4f776a53505dd$var$DefaultVideoStreamIdSet_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("gVZQM")));
module.exports.DefaultVideoStreamIdSet = $ffa4f776a53505dd$var$DefaultVideoStreamIdSet_1.default;

const $ffa4f776a53505dd$var$DefaultVideoStreamIndex_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("a9cGZ")));
module.exports.DefaultVideoStreamIndex = $ffa4f776a53505dd$var$DefaultVideoStreamIndex_1.default;

const $ffa4f776a53505dd$var$DefaultVideoTile_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("dBfpS")));
module.exports.DefaultVideoTile = $ffa4f776a53505dd$var$DefaultVideoTile_1.default;

const $ffa4f776a53505dd$var$DefaultVideoTileController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("1dk1T")));
module.exports.DefaultVideoTileController = $ffa4f776a53505dd$var$DefaultVideoTileController_1.default;

const $ffa4f776a53505dd$var$DefaultVideoTileFactory_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("8tr2c")));
module.exports.DefaultVideoTileFactory = $ffa4f776a53505dd$var$DefaultVideoTileFactory_1.default;

const $ffa4f776a53505dd$var$DefaultVideoTransformDevice_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("3oXre")));
module.exports.DefaultVideoTransformDevice = $ffa4f776a53505dd$var$DefaultVideoTransformDevice_1.default;

const $ffa4f776a53505dd$var$DefaultVolumeIndicatorAdapter_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("gfunK")));
module.exports.DefaultVolumeIndicatorAdapter = $ffa4f776a53505dd$var$DefaultVolumeIndicatorAdapter_1.default;

const $ffa4f776a53505dd$var$DefaultWebSocketAdapter_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("bXkPl")));
module.exports.DefaultWebSocketAdapter = $ffa4f776a53505dd$var$DefaultWebSocketAdapter_1.default;

const $ffa4f776a53505dd$var$DevicePixelRatioWindowSource_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("bXLxF")));
module.exports.DevicePixelRatioWindowSource = $ffa4f776a53505dd$var$DevicePixelRatioWindowSource_1.default;

const $ffa4f776a53505dd$var$DeviceSelection_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("8vrvX")));
module.exports.DeviceSelection = $ffa4f776a53505dd$var$DeviceSelection_1.default;

const $ffa4f776a53505dd$var$EncodedTransformManager_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("ct5Vx")));
module.exports.EncodedTransformManager = $ffa4f776a53505dd$var$EncodedTransformManager_1.default;

const $ffa4f776a53505dd$var$EncodedTransformWorkerCode_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("iQyKr")));
module.exports.EncodedTransformWorkerCode = $ffa4f776a53505dd$var$EncodedTransformWorkerCode_1.default;

const $ffa4f776a53505dd$var$EventBufferConfiguration_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("aMP28")));
module.exports.EventBufferConfiguration = $ffa4f776a53505dd$var$EventBufferConfiguration_1.default;

const $ffa4f776a53505dd$var$EventIngestionConfiguration_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("dYglD")));
module.exports.EventIngestionConfiguration = $ffa4f776a53505dd$var$EventIngestionConfiguration_1.default;

const $ffa4f776a53505dd$var$FinishGatheringICECandidatesTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("f5dpO")));
module.exports.FinishGatheringICECandidatesTask = $ffa4f776a53505dd$var$FinishGatheringICECandidatesTask_1.default;

const $ffa4f776a53505dd$var$FullJitterBackoff_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("84f4q")));
module.exports.FullJitterBackoff = $ffa4f776a53505dd$var$FullJitterBackoff_1.default;

const $ffa4f776a53505dd$var$FullJitterBackoffFactory_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("eHwtv")));
module.exports.FullJitterBackoffFactory = $ffa4f776a53505dd$var$FullJitterBackoffFactory_1.default;

const $ffa4f776a53505dd$var$FullJitterLimitedBackoff_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("alpwk")));
module.exports.FullJitterLimitedBackoff = $ffa4f776a53505dd$var$FullJitterLimitedBackoff_1.default;

const $ffa4f776a53505dd$var$GetUserMediaError_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("5XVIS")));
module.exports.GetUserMediaError = $ffa4f776a53505dd$var$GetUserMediaError_1.default;

const $ffa4f776a53505dd$var$GlobalMetricReport_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("9ySID")));
module.exports.GlobalMetricReport = $ffa4f776a53505dd$var$GlobalMetricReport_1.default;

const $ffa4f776a53505dd$var$InMemoryJSONEventBuffer_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("7UxXU")));
module.exports.InMemoryJSONEventBuffer = $ffa4f776a53505dd$var$InMemoryJSONEventBuffer_1.default;

const $ffa4f776a53505dd$var$IntervalScheduler_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("4wGp7")));
module.exports.IntervalScheduler = $ffa4f776a53505dd$var$IntervalScheduler_1.default;

const $ffa4f776a53505dd$var$JoinAndReceiveIndexTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("7m5jF")));
module.exports.JoinAndReceiveIndexTask = $ffa4f776a53505dd$var$JoinAndReceiveIndexTask_1.default;

const $ffa4f776a53505dd$var$LeaveAndReceiveLeaveAckTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("boLjf")));
module.exports.LeaveAndReceiveLeaveAckTask = $ffa4f776a53505dd$var$LeaveAndReceiveLeaveAckTask_1.default;

const $ffa4f776a53505dd$var$ListenForVolumeIndicatorsTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("lvAt6")));
module.exports.ListenForVolumeIndicatorsTask = $ffa4f776a53505dd$var$ListenForVolumeIndicatorsTask_1.default;

const $ffa4f776a53505dd$var$Log_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("gMQdX")));
module.exports.Log = $ffa4f776a53505dd$var$Log_1.default;

const $ffa4f776a53505dd$var$LogLevel_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("aSYjG")));
module.exports.LogLevel = $ffa4f776a53505dd$var$LogLevel_1.default;

const $ffa4f776a53505dd$var$MediaDeviceProxyHandler_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("6KG0U")));
module.exports.MediaDeviceProxyHandler = $ffa4f776a53505dd$var$MediaDeviceProxyHandler_1.default;

const $ffa4f776a53505dd$var$MediaMetricsEncodedTransformManager_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("kGlN2")));
module.exports.MediaMetricsEncodedTransformManager = $ffa4f776a53505dd$var$MediaMetricsEncodedTransformManager_1.default;

const $ffa4f776a53505dd$var$MeetingEventsClientConfiguration_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("dgjnv")));
module.exports.MeetingEventsClientConfiguration = $ffa4f776a53505dd$var$MeetingEventsClientConfiguration_1.default;

const $ffa4f776a53505dd$var$MeetingFeatures_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("hQn0x")));
module.exports.MeetingFeatures = $ffa4f776a53505dd$var$MeetingFeatures_1.default;

const $ffa4f776a53505dd$var$MeetingReadinessCheckerConfiguration_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("j2SXI")));
module.exports.MeetingReadinessCheckerConfiguration = $ffa4f776a53505dd$var$MeetingReadinessCheckerConfiguration_1.default;

const $ffa4f776a53505dd$var$MeetingSessionConfiguration_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("dKmza")));
module.exports.MeetingSessionConfiguration = $ffa4f776a53505dd$var$MeetingSessionConfiguration_1.default;

const $ffa4f776a53505dd$var$MeetingSessionCredentials_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("ewCV2")));
module.exports.MeetingSessionCredentials = $ffa4f776a53505dd$var$MeetingSessionCredentials_1.default;

const $ffa4f776a53505dd$var$MeetingSessionLifecycleEvent_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("1b1mZ")));
module.exports.MeetingSessionLifecycleEvent = $ffa4f776a53505dd$var$MeetingSessionLifecycleEvent_1.default;

const $ffa4f776a53505dd$var$MeetingSessionLifecycleEventCondition_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("8wYaz")));
module.exports.MeetingSessionLifecycleEventCondition = $ffa4f776a53505dd$var$MeetingSessionLifecycleEventCondition_1.default;

const $ffa4f776a53505dd$var$MeetingSessionStatus_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("jbMe2")));
module.exports.MeetingSessionStatus = $ffa4f776a53505dd$var$MeetingSessionStatus_1.default;

const $ffa4f776a53505dd$var$MeetingSessionStatusCode_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("9zYoz")));
module.exports.MeetingSessionStatusCode = $ffa4f776a53505dd$var$MeetingSessionStatusCode_1.default;

const $ffa4f776a53505dd$var$MeetingSessionTURNCredentials_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("lEn0X")));
module.exports.MeetingSessionTURNCredentials = $ffa4f776a53505dd$var$MeetingSessionTURNCredentials_1.default;

const $ffa4f776a53505dd$var$MeetingSessionTimingManager_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("7yFRY")));
module.exports.MeetingSessionTimingManager = $ffa4f776a53505dd$var$MeetingSessionTimingManager_1.default;

const $ffa4f776a53505dd$var$MeetingSessionURLs_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("76y6f")));
module.exports.MeetingSessionURLs = $ffa4f776a53505dd$var$MeetingSessionURLs_1.default;

const $ffa4f776a53505dd$var$MeetingSessionVideoAvailability_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("98lxz")));
module.exports.MeetingSessionVideoAvailability = $ffa4f776a53505dd$var$MeetingSessionVideoAvailability_1.default;

const $ffa4f776a53505dd$var$Message_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("hAryZ")));
module.exports.Message = $ffa4f776a53505dd$var$Message_1.default;

const $ffa4f776a53505dd$var$MessagingSessionConfiguration_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("2Q90c")));
module.exports.MessagingSessionConfiguration = $ffa4f776a53505dd$var$MessagingSessionConfiguration_1.default;

const $ffa4f776a53505dd$var$ModelSpecBuilder_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("OchoQ")));
module.exports.ModelSpecBuilder = $ffa4f776a53505dd$var$ModelSpecBuilder_1.default;

const $ffa4f776a53505dd$var$MonitorTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("fpAHb")));
module.exports.MonitorTask = $ffa4f776a53505dd$var$MonitorTask_1.default;

const $ffa4f776a53505dd$var$MultiLogger_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("iIruD")));
module.exports.MultiLogger = $ffa4f776a53505dd$var$MultiLogger_1.default;

const $ffa4f776a53505dd$var$NScaleVideoUplinkBandwidthPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("lHgMc")));
module.exports.NScaleVideoUplinkBandwidthPolicy = $ffa4f776a53505dd$var$NScaleVideoUplinkBandwidthPolicy_1.default;

const $ffa4f776a53505dd$var$NoOpAudioVideoController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("iZoLe")));
module.exports.NoOpAudioVideoController = $ffa4f776a53505dd$var$NoOpAudioVideoController_1.default;

const $ffa4f776a53505dd$var$NoOpDebugLogger_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("etIev")));
module.exports.NoOpDebugLogger = $ffa4f776a53505dd$var$NoOpDebugLogger_1.default;

const $ffa4f776a53505dd$var$NoOpDeviceController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("2Cyhu")));
module.exports.NoOpDeviceController = $ffa4f776a53505dd$var$NoOpDeviceController_1.default;

const $ffa4f776a53505dd$var$NoOpEventReporter_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("aBEoN")));
module.exports.NoOpEventReporter = $ffa4f776a53505dd$var$NoOpEventReporter_1.default;

const $ffa4f776a53505dd$var$NoOpLogger_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("a39G0")));
module.exports.NoOpLogger = $ffa4f776a53505dd$var$NoOpLogger_1.default;

const $ffa4f776a53505dd$var$NoOpMediaStreamBroker_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("lotlQ")));
module.exports.NoOpMediaStreamBroker = $ffa4f776a53505dd$var$NoOpMediaStreamBroker_1.default;

const $ffa4f776a53505dd$var$NoOpTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("aoD3u")));
module.exports.NoOpTask = $ffa4f776a53505dd$var$NoOpTask_1.default;

const $ffa4f776a53505dd$var$NoOpVideoElementFactory_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("ccAef")));
module.exports.NoOpVideoElementFactory = $ffa4f776a53505dd$var$NoOpVideoElementFactory_1.default;

const $ffa4f776a53505dd$var$NoOpVideoFrameProcessor_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("8btv2")));
module.exports.NoOpVideoFrameProcessor = $ffa4f776a53505dd$var$NoOpVideoFrameProcessor_1.default;

const $ffa4f776a53505dd$var$NoVideoDownlinkBandwidthPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("frCEd")));
module.exports.NoVideoDownlinkBandwidthPolicy = $ffa4f776a53505dd$var$NoVideoDownlinkBandwidthPolicy_1.default;

const $ffa4f776a53505dd$var$NoVideoUplinkBandwidthPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("hD2ej")));
module.exports.NoVideoUplinkBandwidthPolicy = $ffa4f776a53505dd$var$NoVideoUplinkBandwidthPolicy_1.default;

const $ffa4f776a53505dd$var$NotFoundError_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("9RUp9")));
module.exports.NotFoundError = $ffa4f776a53505dd$var$NotFoundError_1.default;

const $ffa4f776a53505dd$var$NotReadableError_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("34WPe")));
module.exports.NotReadableError = $ffa4f776a53505dd$var$NotReadableError_1.default;

const $ffa4f776a53505dd$var$OnceTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("57JcA")));
module.exports.OnceTask = $ffa4f776a53505dd$var$OnceTask_1.default;

const $ffa4f776a53505dd$var$OpenSignalingConnectionTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("agKJo")));
module.exports.OpenSignalingConnectionTask = $ffa4f776a53505dd$var$OpenSignalingConnectionTask_1.default;

const $ffa4f776a53505dd$var$OverconstrainedError_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("8y2VG")));
module.exports.OverconstrainedError = $ffa4f776a53505dd$var$OverconstrainedError_1.default;

const $ffa4f776a53505dd$var$POSTLogger_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("27uvx")));
module.exports.POSTLogger = $ffa4f776a53505dd$var$POSTLogger_1.default;

const $ffa4f776a53505dd$var$ParallelGroupTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("aaIQX")));
module.exports.ParallelGroupTask = $ffa4f776a53505dd$var$ParallelGroupTask_1.default;

const $ffa4f776a53505dd$var$PermissionDeniedError_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("3JsdE")));
module.exports.PermissionDeniedError = $ffa4f776a53505dd$var$PermissionDeniedError_1.default;

const $ffa4f776a53505dd$var$PrefetchOn_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("7rVns")));
module.exports.PrefetchOn = $ffa4f776a53505dd$var$PrefetchOn_1.default;

const $ffa4f776a53505dd$var$PrefetchSortBy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("8xcJX")));
module.exports.PrefetchSortBy = $ffa4f776a53505dd$var$PrefetchSortBy_1.default;

const $ffa4f776a53505dd$var$PromiseQueue_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("8nZPg")));
module.exports.PromiseQueue = $ffa4f776a53505dd$var$PromiseQueue_1.default;

const $ffa4f776a53505dd$var$PromoteToPrimaryMeetingTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("ik076")));
module.exports.PromoteToPrimaryMeetingTask = $ffa4f776a53505dd$var$PromoteToPrimaryMeetingTask_1.default;

const $ffa4f776a53505dd$var$RealtimeAttendeePositionInFrame_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("afHhj")));
module.exports.RealtimeAttendeePositionInFrame = $ffa4f776a53505dd$var$RealtimeAttendeePositionInFrame_1.default;

const $ffa4f776a53505dd$var$RealtimeState_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("8aBsU")));
module.exports.RealtimeState = $ffa4f776a53505dd$var$RealtimeState_1.default;

const $ffa4f776a53505dd$var$RealtimeVolumeIndicator_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("gGuUW")));
module.exports.RealtimeVolumeIndicator = $ffa4f776a53505dd$var$RealtimeVolumeIndicator_1.default;

const $ffa4f776a53505dd$var$ReceiveAudioInputTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("4Q8vW")));
module.exports.ReceiveAudioInputTask = $ffa4f776a53505dd$var$ReceiveAudioInputTask_1.default;

const $ffa4f776a53505dd$var$ReceiveRemoteVideoPauseResumeTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("1Bypi")));
module.exports.ReceiveRemoteVideoPauseResumeTask = $ffa4f776a53505dd$var$ReceiveRemoteVideoPauseResumeTask_1.default;

const $ffa4f776a53505dd$var$ReceiveVideoInputTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("e991n")));
module.exports.ReceiveVideoInputTask = $ffa4f776a53505dd$var$ReceiveVideoInputTask_1.default;

const $ffa4f776a53505dd$var$ReceiveVideoStreamIndexTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("eBlvb")));
module.exports.ReceiveVideoStreamIndexTask = $ffa4f776a53505dd$var$ReceiveVideoStreamIndexTask_1.default;

const $ffa4f776a53505dd$var$ReconnectionHealthPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("bogAf")));
module.exports.ReconnectionHealthPolicy = $ffa4f776a53505dd$var$ReconnectionHealthPolicy_1.default;

const $ffa4f776a53505dd$var$RedundantAudioEncodedTransform_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("i7QDG")));
module.exports.RedundantAudioEncodedTransform = $ffa4f776a53505dd$var$RedundantAudioEncodedTransform_1.default;

const $ffa4f776a53505dd$var$RedundantAudioEncodedTransformManager_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("1H5d7")));
module.exports.RedundantAudioEncodedTransformManager = $ffa4f776a53505dd$var$RedundantAudioEncodedTransformManager_1.default;

const $ffa4f776a53505dd$var$RedundantAudioEncoderWorkerCode_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("kD35h")));
module.exports.RedundantAudioEncoderWorkerCode = $ffa4f776a53505dd$var$RedundantAudioEncoderWorkerCode_1.default;

const $ffa4f776a53505dd$var$RedundantAudioRecoveryMetricReport_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("7dTR6")));
module.exports.RedundantAudioRecoveryMetricReport = $ffa4f776a53505dd$var$RedundantAudioRecoveryMetricReport_1.default;

const $ffa4f776a53505dd$var$RunnableTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("ae33M")));
module.exports.RunnableTask = $ffa4f776a53505dd$var$RunnableTask_1.default;

const $ffa4f776a53505dd$var$SDP_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("bry62")));
module.exports.SDP = $ffa4f776a53505dd$var$SDP_1.default;

const $ffa4f776a53505dd$var$SDPCandidateType_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("dVDT1")));
module.exports.SDPCandidateType = $ffa4f776a53505dd$var$SDPCandidateType_1.default;

const $ffa4f776a53505dd$var$SDPMediaSection_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("ji2zS")));
module.exports.SDPMediaSection = $ffa4f776a53505dd$var$SDPMediaSection_1.default;

const $ffa4f776a53505dd$var$SendAndReceiveDataMessagesTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("iOlwL")));
module.exports.SendAndReceiveDataMessagesTask = $ffa4f776a53505dd$var$SendAndReceiveDataMessagesTask_1.default;

const $ffa4f776a53505dd$var$SendingAudioFailureConnectionHealthPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("53rdn")));
module.exports.SendingAudioFailureConnectionHealthPolicy = $ffa4f776a53505dd$var$SendingAudioFailureConnectionHealthPolicy_1.default;

const $ffa4f776a53505dd$var$SerialGroupTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("7gEAZ")));
module.exports.SerialGroupTask = $ffa4f776a53505dd$var$SerialGroupTask_1.default;

const $ffa4f776a53505dd$var$ServerSideNetworkAdaption_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("bRvcN")));
module.exports.ServerSideNetworkAdaption = $ffa4f776a53505dd$var$ServerSideNetworkAdaption_1.default;

const $ffa4f776a53505dd$var$SessionStateControllerAction_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("k20WH")));
module.exports.SessionStateControllerAction = $ffa4f776a53505dd$var$SessionStateControllerAction_1.default;

const $ffa4f776a53505dd$var$SessionStateControllerDeferPriority_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("d0ryC")));
module.exports.SessionStateControllerDeferPriority = $ffa4f776a53505dd$var$SessionStateControllerDeferPriority_1.default;

const $ffa4f776a53505dd$var$SessionStateControllerState_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("hhMm7")));
module.exports.SessionStateControllerState = $ffa4f776a53505dd$var$SessionStateControllerState_1.default;

const $ffa4f776a53505dd$var$SessionStateControllerTransitionResult_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("jl8zM")));
module.exports.SessionStateControllerTransitionResult = $ffa4f776a53505dd$var$SessionStateControllerTransitionResult_1.default;

const $ffa4f776a53505dd$var$SetLocalDescriptionTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("bDOog")));
module.exports.SetLocalDescriptionTask = $ffa4f776a53505dd$var$SetLocalDescriptionTask_1.default;

const $ffa4f776a53505dd$var$SetRemoteDescriptionTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("1k1g9")));
module.exports.SetRemoteDescriptionTask = $ffa4f776a53505dd$var$SetRemoteDescriptionTask_1.default;

const $ffa4f776a53505dd$var$SignalingAndMetricsConnectionMonitor_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("jUS1b")));
module.exports.SignalingAndMetricsConnectionMonitor = $ffa4f776a53505dd$var$SignalingAndMetricsConnectionMonitor_1.default;

const $ffa4f776a53505dd$var$SignalingClientConnectionRequest_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("l831h")));
module.exports.SignalingClientConnectionRequest = $ffa4f776a53505dd$var$SignalingClientConnectionRequest_1.default;

const $ffa4f776a53505dd$var$SignalingClientEvent_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("5kwEl")));
module.exports.SignalingClientEvent = $ffa4f776a53505dd$var$SignalingClientEvent_1.default;

const $ffa4f776a53505dd$var$SignalingClientEventType_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("1lA8I")));
module.exports.SignalingClientEventType = $ffa4f776a53505dd$var$SignalingClientEventType_1.default;

const $ffa4f776a53505dd$var$SignalingClientJoin_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("l5Y18")));
module.exports.SignalingClientJoin = $ffa4f776a53505dd$var$SignalingClientJoin_1.default;

const $ffa4f776a53505dd$var$SignalingClientSubscribe_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("bukCc")));
module.exports.SignalingClientSubscribe = $ffa4f776a53505dd$var$SignalingClientSubscribe_1.default;

const $ffa4f776a53505dd$var$SignalingClientVideoSubscriptionConfiguration_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("ei9ii")));
module.exports.SignalingClientVideoSubscriptionConfiguration = $ffa4f776a53505dd$var$SignalingClientVideoSubscriptionConfiguration_1.default;

const $ffa4f776a53505dd$var$SimulcastContentShareTransceiverController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("5IW3c")));
module.exports.SimulcastContentShareTransceiverController = $ffa4f776a53505dd$var$SimulcastContentShareTransceiverController_1.default;

const $ffa4f776a53505dd$var$SimulcastLayers_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("arWZg")));
module.exports.SimulcastLayers = $ffa4f776a53505dd$var$SimulcastLayers_1.default;

const $ffa4f776a53505dd$var$SimulcastTransceiverController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("hl0rE")));
module.exports.SimulcastTransceiverController = $ffa4f776a53505dd$var$SimulcastTransceiverController_1.default;

const $ffa4f776a53505dd$var$SimulcastVideoStreamIndex_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("h4kXy")));
module.exports.SimulcastVideoStreamIndex = $ffa4f776a53505dd$var$SimulcastVideoStreamIndex_1.default;

const $ffa4f776a53505dd$var$SingleNodeAudioTransformDevice_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("3T0lu")));
module.exports.SingleNodeAudioTransformDevice = $ffa4f776a53505dd$var$SingleNodeAudioTransformDevice_1.default;

const $ffa4f776a53505dd$var$StartEncodedTransformWorkerTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("34pQj")));
module.exports.StartEncodedTransformWorkerTask = $ffa4f776a53505dd$var$StartEncodedTransformWorkerTask_1.default;

const $ffa4f776a53505dd$var$StreamMetricReport_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("RnK9Z")));
module.exports.StreamMetricReport = $ffa4f776a53505dd$var$StreamMetricReport_1.default;

const $ffa4f776a53505dd$var$SubscribeAndReceiveSubscribeAckTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("lVbsX")));
module.exports.SubscribeAndReceiveSubscribeAckTask = $ffa4f776a53505dd$var$SubscribeAndReceiveSubscribeAckTask_1.default;

const $ffa4f776a53505dd$var$TargetDisplaySize_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("arfyn")));
module.exports.TargetDisplaySize = $ffa4f776a53505dd$var$TargetDisplaySize_1.default;

const $ffa4f776a53505dd$var$TaskStatus_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("8wEjJ")));
module.exports.TaskStatus = $ffa4f776a53505dd$var$TaskStatus_1.default;

const $ffa4f776a53505dd$var$TimeoutScheduler_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("gcRqk")));
module.exports.TimeoutScheduler = $ffa4f776a53505dd$var$TimeoutScheduler_1.default;

const $ffa4f776a53505dd$var$TimeoutTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("aiqTT")));
module.exports.TimeoutTask = $ffa4f776a53505dd$var$TimeoutTask_1.default;

const $ffa4f776a53505dd$var$Transcript_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("cvWJI")));
module.exports.Transcript = $ffa4f776a53505dd$var$Transcript_1.default;

const $ffa4f776a53505dd$var$TranscriptAlternative_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("5BsUR")));
module.exports.TranscriptAlternative = $ffa4f776a53505dd$var$TranscriptAlternative_1.default;

const $ffa4f776a53505dd$var$TranscriptEntity_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("fRF88")));
module.exports.TranscriptEntity = $ffa4f776a53505dd$var$TranscriptEntity_1.default;

const $ffa4f776a53505dd$var$TranscriptItem_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("gzZnP")));
module.exports.TranscriptItem = $ffa4f776a53505dd$var$TranscriptItem_1.default;

const $ffa4f776a53505dd$var$TranscriptItemType_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("6ECAu")));
module.exports.TranscriptItemType = $ffa4f776a53505dd$var$TranscriptItemType_1.default;

const $ffa4f776a53505dd$var$TranscriptLanguageWithScore_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("k3aEM")));
module.exports.TranscriptLanguageWithScore = $ffa4f776a53505dd$var$TranscriptLanguageWithScore_1.default;

const $ffa4f776a53505dd$var$TranscriptResult_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("kMOij")));
module.exports.TranscriptResult = $ffa4f776a53505dd$var$TranscriptResult_1.default;

const $ffa4f776a53505dd$var$TranscriptionStatus_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("yPcOn")));
module.exports.TranscriptionStatus = $ffa4f776a53505dd$var$TranscriptionStatus_1.default;

const $ffa4f776a53505dd$var$TranscriptionStatusType_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("1eK7h")));
module.exports.TranscriptionStatusType = $ffa4f776a53505dd$var$TranscriptionStatusType_1.default;

const $ffa4f776a53505dd$var$TypeError_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("9j05g")));
module.exports.TypeError = $ffa4f776a53505dd$var$TypeError_1.default;

const $ffa4f776a53505dd$var$UnusableAudioWarningConnectionHealthPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("aa9Qv")));
module.exports.UnusableAudioWarningConnectionHealthPolicy = $ffa4f776a53505dd$var$UnusableAudioWarningConnectionHealthPolicy_1.default;

const $ffa4f776a53505dd$var$Versioning_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("c0dn0")));
module.exports.Versioning = $ffa4f776a53505dd$var$Versioning_1.default;

const $ffa4f776a53505dd$var$VideoAdaptiveProbePolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("b9KFX")));
module.exports.VideoAdaptiveProbePolicy = $ffa4f776a53505dd$var$VideoAdaptiveProbePolicy_1.default;

const $ffa4f776a53505dd$var$VideoCodecCapability_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("4C1Yl")));
module.exports.VideoCodecCapability = $ffa4f776a53505dd$var$VideoCodecCapability_1.default;

const $ffa4f776a53505dd$var$VideoElementFrameMonitor_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("avwXQ")));
module.exports.VideoElementFrameMonitor = $ffa4f776a53505dd$var$VideoElementFrameMonitor_1.default;

const $ffa4f776a53505dd$var$VideoEncodingConcurrentSendersHealthPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("jk9DA")));
module.exports.VideoEncodingConcurrentSendersHealthPolicy = $ffa4f776a53505dd$var$VideoEncodingConcurrentSendersHealthPolicy_1.default;

const $ffa4f776a53505dd$var$VideoEncodingConnectionHealthPolicyName_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("k4S8T")));
module.exports.VideoEncodingConnectionHealthPolicyName = $ffa4f776a53505dd$var$VideoEncodingConnectionHealthPolicyName_1.default;

const $ffa4f776a53505dd$var$VideoEncodingCpuConnectionHealthPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("iv6ge")));
module.exports.VideoEncodingCpuConnectionHealthPolicy = $ffa4f776a53505dd$var$VideoEncodingCpuConnectionHealthPolicy_1.default;

const $ffa4f776a53505dd$var$VideoEncodingFramerateConnectionHealthPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("eLe4C")));
module.exports.VideoEncodingFramerateConnectionHealthPolicy = $ffa4f776a53505dd$var$VideoEncodingFramerateConnectionHealthPolicy_1.default;

const $ffa4f776a53505dd$var$VideoFxProcessor_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("b1EaC")));
module.exports.VideoFxProcessor = $ffa4f776a53505dd$var$VideoFxProcessor_1.default;

const $ffa4f776a53505dd$var$VideoLogEvent_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("7Ydw6")));
module.exports.VideoLogEvent = $ffa4f776a53505dd$var$VideoLogEvent_1.default;

const $ffa4f776a53505dd$var$VideoOnlyTransceiverController_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("787PM")));
module.exports.VideoOnlyTransceiverController = $ffa4f776a53505dd$var$VideoOnlyTransceiverController_1.default;

const $ffa4f776a53505dd$var$VideoPreference_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("etFBX")));
module.exports.VideoPreference = $ffa4f776a53505dd$var$VideoPreference_1.default;

const $ffa4f776a53505dd$var$VideoPreferences_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("3orkO")));
module.exports.VideoPreferences = $ffa4f776a53505dd$var$VideoPreferences_1.default;

const $ffa4f776a53505dd$var$VideoPriorityBasedPolicy_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("i3DJs")));
module.exports.VideoPriorityBasedPolicy = $ffa4f776a53505dd$var$VideoPriorityBasedPolicy_1.default;

const $ffa4f776a53505dd$var$VideoPriorityBasedPolicyConfig_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("lcZ1l")));
module.exports.VideoPriorityBasedPolicyConfig = $ffa4f776a53505dd$var$VideoPriorityBasedPolicyConfig_1.default;

const $ffa4f776a53505dd$var$VideoQualityAdaptationPreference_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("lGCbE")));
module.exports.VideoQualityAdaptationPreference = $ffa4f776a53505dd$var$VideoQualityAdaptationPreference_1.default;

const $ffa4f776a53505dd$var$VideoQualitySettings_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("3C9sO")));
module.exports.VideoQualitySettings = $ffa4f776a53505dd$var$VideoQualitySettings_1.default;

const $ffa4f776a53505dd$var$VideoSource_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("dGcvr")));
module.exports.VideoSource = $ffa4f776a53505dd$var$VideoSource_1.default;

const $ffa4f776a53505dd$var$VideoStreamDescription_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("6WiTW")));
module.exports.VideoStreamDescription = $ffa4f776a53505dd$var$VideoStreamDescription_1.default;

const $ffa4f776a53505dd$var$VideoTileState_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("EBnSl")));
module.exports.VideoTileState = $ffa4f776a53505dd$var$VideoTileState_1.default;

const $ffa4f776a53505dd$var$VoiceFocusDeviceTransformer_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("6pK00")));
module.exports.VoiceFocusDeviceTransformer = $ffa4f776a53505dd$var$VoiceFocusDeviceTransformer_1.default;

const $ffa4f776a53505dd$var$VoiceFocusTransformDevice_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("2bbQi")));
module.exports.VoiceFocusTransformDevice = $ffa4f776a53505dd$var$VoiceFocusTransformDevice_1.default;

const $ffa4f776a53505dd$var$WaitForAttendeePresenceTask_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("hVjEt")));
module.exports.WaitForAttendeePresenceTask = $ffa4f776a53505dd$var$WaitForAttendeePresenceTask_1.default;

const $ffa4f776a53505dd$var$WebSocketReadyState_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("jJkQN")));
module.exports.WebSocketReadyState = $ffa4f776a53505dd$var$WebSocketReadyState_1.default;

const $ffa4f776a53505dd$var$ZLIBTextCompressor_1 = $ffa4f776a53505dd$var$__importDefault((parcelRequire("28F50")));
module.exports.ZLIBTextCompressor = $ffa4f776a53505dd$var$ZLIBTextCompressor_1.default;

Object.defineProperty(module.exports, "MutableVideoPreferences", {
    enumerable: true,
    get: function() {
        return (parcelRequire("3orkO")).MutableVideoPreferences;
    }
});

var $jfpqH = parcelRequire("jfpqH");
Object.defineProperty(module.exports, "Some", {
    enumerable: true,
    get: function() {
        return $jfpqH.Some;
    }
});
Object.defineProperty(module.exports, "None", {
    enumerable: true,
    get: function() {
        return $jfpqH.None;
    }
});
Object.defineProperty(module.exports, "Maybe", {
    enumerable: true,
    get: function() {
        return $jfpqH.Maybe;
    }
});

var $34lc7 = parcelRequire("34lc7");
Object.defineProperty(module.exports, "isAudioTransformDevice", {
    enumerable: true,
    get: function() {
        return $34lc7.isAudioTransformDevice;
    }
});

var $j8SWf = parcelRequire("j8SWf");
Object.defineProperty(module.exports, "isDestroyable", {
    enumerable: true,
    get: function() {
        return $j8SWf.isDestroyable;
    }
});

var $6ukw3 = parcelRequire("6ukw3");
Object.defineProperty(module.exports, "isVideoTransformDevice", {
    enumerable: true,
    get: function() {
        return $6ukw3.isVideoTransformDevice;
    }
});

});
parcelRegister("gal60", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6ukw3 = parcelRequire("6ukw3");
class $bc4df1b899ec896e$var$DefaultAudioVideoFacade {
    constructor(audioVideoController, videoTileController, realtimeController, audioMixController, deviceController, contentShareController){
        this.audioVideoController = audioVideoController;
        this.videoTileController = videoTileController;
        this.realtimeController = realtimeController;
        this.audioMixController = audioMixController;
        this.deviceController = deviceController;
        this.contentShareController = contentShareController;
    }
    addObserver(observer) {
        this.audioVideoController.addObserver(observer);
        this.trace('addObserver');
    }
    removeObserver(observer) {
        this.audioVideoController.removeObserver(observer);
        this.trace('removeObserver');
    }
    setAudioProfile(audioProfile) {
        this.trace('setAudioProfile', audioProfile);
        this.audioVideoController.setAudioProfile(audioProfile);
    }
    start(options) {
        this.audioVideoController.start(options);
        this.trace('start');
    }
    stop() {
        this.audioVideoController.stop();
        this.trace('stop');
    }
    /**
     * This API will be deprecated in favor of `ClientMetricReport.getRTCStatsReport()`.
     *
     * It makes an additional call to the `getStats` API and therefore may cause slight performance degradation.
     *
     * Please subscribe to `metricsDidReceive(clientMetricReport: ClientMetricReport)` callback,
     * and get the raw `RTCStatsReport` via `clientMetricReport.getRTCStatsReport()`.
     */ getRTCPeerConnectionStats(selector) {
        this.trace('getRTCPeerConnectionStats', selector ? selector.id : null);
        return this.audioVideoController.getRTCPeerConnectionStats(selector);
    }
    bindAudioElement(element) {
        const result = this.audioMixController.bindAudioElement(element);
        this.trace('bindAudioElement', element.id, result);
        return result;
    }
    unbindAudioElement() {
        this.audioMixController.unbindAudioElement();
        this.trace('unbindAudioElement');
    }
    getCurrentMeetingAudioStream() {
        this.trace('getCurrentConferenceStream');
        return this.audioMixController.getCurrentMeetingAudioStream();
    }
    addAudioMixObserver(observer) {
        this.trace('addAudioMixObserver');
        this.audioMixController.addAudioMixObserver(observer);
    }
    removeAudioMixObserver(observer) {
        this.trace('removeAudioMixObserver');
        this.audioMixController.removeAudioMixObserver(observer);
    }
    bindVideoElement(tileId, videoElement) {
        this.videoTileController.bindVideoElement(tileId, videoElement);
        this.trace('bindVideoElement', {
            tileId: tileId,
            videoElementId: videoElement.id
        });
    }
    unbindVideoElement(tileId, cleanUpVideoElement = true) {
        this.videoTileController.unbindVideoElement(tileId, cleanUpVideoElement);
        this.trace('unbindVideoElement', {
            tileId: tileId,
            cleanUpVideoElement: cleanUpVideoElement
        });
    }
    startLocalVideoTile() {
        const result = this.videoTileController.startLocalVideoTile();
        this.trace('startLocalVideoTile', null, result);
        return result;
    }
    stopLocalVideoTile() {
        this.videoTileController.stopLocalVideoTile();
        this.trace('stopLocalVideoTile');
    }
    hasStartedLocalVideoTile() {
        const result = this.videoTileController.hasStartedLocalVideoTile();
        this.trace('hasStartedLocalVideoTile', null, result);
        return result;
    }
    removeLocalVideoTile() {
        this.videoTileController.removeLocalVideoTile();
        this.trace('removeLocalVideoTile');
    }
    getLocalVideoTile() {
        const result = this.videoTileController.getLocalVideoTile();
        this.trace('getLocalVideoTile');
        return result;
    }
    pauseVideoTile(tileId) {
        this.videoTileController.pauseVideoTile(tileId);
        this.trace('pauseVideoTile', tileId);
    }
    unpauseVideoTile(tileId) {
        this.videoTileController.unpauseVideoTile(tileId);
        this.trace('unpauseVideoTile', tileId);
    }
    getVideoTile(tileId) {
        const result = this.videoTileController.getVideoTile(tileId);
        this.trace('getVideoTile', tileId);
        return result;
    }
    getAllRemoteVideoTiles() {
        const result = this.videoTileController.getAllRemoteVideoTiles();
        this.trace('getAllRemoteVideoTiles');
        return result;
    }
    getAllVideoTiles() {
        const result = this.videoTileController.getAllVideoTiles();
        this.trace('getAllVideoTiles');
        return result;
    }
    addVideoTile() {
        const result = this.videoTileController.addVideoTile();
        this.trace('addVideoTile', null, result.state());
        return result;
    }
    removeVideoTile(tileId) {
        this.videoTileController.removeVideoTile(tileId);
        this.trace('removeVideoTile', tileId);
    }
    removeVideoTilesByAttendeeId(attendeeId) {
        const result = this.videoTileController.removeVideoTilesByAttendeeId(attendeeId);
        this.trace('removeVideoTilesByAttendeeId', attendeeId, result);
        return result;
    }
    removeAllVideoTiles() {
        this.videoTileController.removeAllVideoTiles();
        this.trace('removeAllVideoTiles');
    }
    captureVideoTile(tileId) {
        const result = this.videoTileController.captureVideoTile(tileId);
        this.trace('captureVideoTile', tileId);
        return result;
    }
    realtimeSubscribeToAttendeeIdPresence(callback) {
        this.realtimeController.realtimeSubscribeToAttendeeIdPresence(callback);
        this.trace('realtimeSubscribeToAttendeeIdPresence');
    }
    realtimeUnsubscribeToAttendeeIdPresence(callback) {
        this.realtimeController.realtimeUnsubscribeToAttendeeIdPresence(callback);
        this.trace('realtimeUnsubscribeToAttendeeIdPresence');
    }
    realtimeSetCanUnmuteLocalAudio(canUnmute) {
        this.realtimeController.realtimeSetCanUnmuteLocalAudio(canUnmute);
        this.trace('realtimeSetCanUnmuteLocalAudio', canUnmute);
    }
    realtimeSubscribeToSetCanUnmuteLocalAudio(callback) {
        this.realtimeController.realtimeSubscribeToSetCanUnmuteLocalAudio(callback);
        this.trace('realtimeSubscribeToSetCanUnmuteLocalAudio');
    }
    realtimeUnsubscribeToSetCanUnmuteLocalAudio(callback) {
        this.realtimeController.realtimeUnsubscribeToSetCanUnmuteLocalAudio(callback);
        this.trace('realtimeUnsubscribeToSetCanUnmuteLocalAudio');
    }
    realtimeCanUnmuteLocalAudio() {
        const result = this.realtimeController.realtimeCanUnmuteLocalAudio();
        this.trace('realtimeCanUnmuteLocalAudio', null, result);
        return result;
    }
    realtimeMuteLocalAudio() {
        this.realtimeController.realtimeMuteLocalAudio();
        this.trace('realtimeMuteLocalAudio');
    }
    realtimeUnmuteLocalAudio() {
        const result = this.realtimeController.realtimeUnmuteLocalAudio();
        this.trace('realtimeUnmuteLocalAudio');
        return result;
    }
    realtimeSubscribeToMuteAndUnmuteLocalAudio(callback) {
        this.realtimeController.realtimeSubscribeToMuteAndUnmuteLocalAudio(callback);
        this.trace('realtimeSubscribeToMuteAndUnmuteLocalAudio');
    }
    realtimeUnsubscribeToMuteAndUnmuteLocalAudio(callback) {
        this.realtimeController.realtimeUnsubscribeToMuteAndUnmuteLocalAudio(callback);
        this.trace('realtimeUnsubscribeToMuteAndUnmuteLocalAudio');
    }
    realtimeIsLocalAudioMuted() {
        const result = this.realtimeController.realtimeIsLocalAudioMuted();
        this.trace('realtimeIsLocalAudioMuted');
        return result;
    }
    realtimeSubscribeToVolumeIndicator(attendeeId, callback) {
        this.realtimeController.realtimeSubscribeToVolumeIndicator(attendeeId, callback);
        this.trace('realtimeSubscribeToVolumeIndicator', attendeeId);
    }
    realtimeUnsubscribeFromVolumeIndicator(attendeeId, callback) {
        this.realtimeController.realtimeUnsubscribeFromVolumeIndicator(attendeeId, callback);
        this.trace('realtimeUnsubscribeFromVolumeIndicator', attendeeId, callback);
    }
    realtimeSubscribeToLocalSignalStrengthChange(callback) {
        this.realtimeController.realtimeSubscribeToLocalSignalStrengthChange(callback);
        this.trace('realtimeSubscribeToLocalSignalStrengthChange');
    }
    realtimeUnsubscribeToLocalSignalStrengthChange(callback) {
        this.realtimeController.realtimeUnsubscribeToLocalSignalStrengthChange(callback);
        this.trace('realtimeUnsubscribeToLocalSignalStrengthChange');
    }
    realtimeSendDataMessage(topic, data, lifetimeMs) {
        this.realtimeController.realtimeSendDataMessage(topic, data, lifetimeMs);
        this.trace('realtimeSendDataMessage');
    }
    realtimeSubscribeToReceiveDataMessage(topic, callback) {
        this.realtimeController.realtimeSubscribeToReceiveDataMessage(topic, callback);
        this.trace('realtimeSubscribeToReceiveDataMessage');
    }
    realtimeUnsubscribeFromReceiveDataMessage(topic) {
        this.realtimeController.realtimeUnsubscribeFromReceiveDataMessage(topic);
        this.trace('realtimeUnsubscribeFromReceiveDataMessage');
    }
    realtimeSubscribeToFatalError(callback) {
        this.realtimeController.realtimeSubscribeToFatalError(callback);
        this.trace('realtimeSubscribeToFatalError');
    }
    realtimeUnsubscribeToFatalError(callback) {
        this.realtimeController.realtimeUnsubscribeToFatalError(callback);
        this.trace('realtimeUnsubscribeToFatalError');
    }
    subscribeToActiveSpeakerDetector(policy, callback, scoresCallback, scoresCallbackIntervalMs) {
        this.audioVideoController.activeSpeakerDetector.subscribe(policy, callback, scoresCallback, scoresCallbackIntervalMs);
        this.trace('subscribeToActiveSpeakerDetector');
    }
    unsubscribeFromActiveSpeakerDetector(callback) {
        this.audioVideoController.activeSpeakerDetector.unsubscribe(callback);
        this.trace('unsubscribeFromActiveSpeakerDetector');
    }
    async listAudioInputDevices(forceUpdate = false) {
        const result = await this.deviceController.listAudioInputDevices(forceUpdate);
        this.trace('listAudioInputDevices', forceUpdate, result);
        return result;
    }
    async listVideoInputDevices(forceUpdate = false) {
        const result = await this.deviceController.listVideoInputDevices(forceUpdate);
        this.trace('listVideoInputDevices', forceUpdate, result);
        return result;
    }
    async listAudioOutputDevices(forceUpdate = false) {
        const result = await this.deviceController.listAudioOutputDevices(forceUpdate);
        this.trace('listAudioOutputDevices', forceUpdate, result);
        return result;
    }
    async startAudioInput(device) {
        this.trace('startAudioInput', device);
        return this.deviceController.startAudioInput(device);
    }
    async stopAudioInput() {
        this.trace('stopAudioInput');
        return this.deviceController.stopAudioInput();
    }
    async startVideoInput(device) {
        if ((0, $6ukw3.isVideoTransformDevice)(device)) // Don't stringify the device to avoid failures when cyclic object references are present.
        this.trace('startVideoInput with transform device');
        else this.trace('startVideoInput', device);
        return this.deviceController.startVideoInput(device);
    }
    async stopVideoInput() {
        this.trace('stopVideoInput');
        return this.deviceController.stopVideoInput();
    }
    chooseAudioOutput(deviceId) {
        const result = this.deviceController.chooseAudioOutput(deviceId);
        this.trace('chooseAudioOutput', deviceId);
        return result;
    }
    addDeviceChangeObserver(observer) {
        this.deviceController.addDeviceChangeObserver(observer);
        this.trace('addDeviceChangeObserver');
    }
    removeDeviceChangeObserver(observer) {
        this.deviceController.removeDeviceChangeObserver(observer);
        this.trace('removeDeviceChangeObserver');
    }
    createAnalyserNodeForAudioInput() {
        const result = this.deviceController.createAnalyserNodeForAudioInput();
        this.trace('createAnalyserNodeForAudioInput');
        return result;
    }
    startVideoPreviewForVideoInput(element) {
        this.deviceController.startVideoPreviewForVideoInput(element);
        this.trace('startVideoPreviewForVideoInput', element.id);
    }
    stopVideoPreviewForVideoInput(element) {
        this.deviceController.stopVideoPreviewForVideoInput(element);
        this.trace('stopVideoPreviewForVideoInput', element.id);
    }
    setDeviceLabelTrigger(trigger) {
        this.deviceController.setDeviceLabelTrigger(trigger);
        this.trace('setDeviceLabelTrigger');
    }
    mixIntoAudioInput(stream) {
        const result = this.deviceController.mixIntoAudioInput(stream);
        this.trace('mixIntoAudioInput', stream.id);
        return result;
    }
    chooseVideoInputQuality(width, height, frameRate) {
        this.deviceController.chooseVideoInputQuality(width, height, frameRate);
        this.trace('chooseVideoInputQuality', {
            width: width,
            height: height,
            frameRate: frameRate
        });
    }
    setVideoMaxBandwidthKbps(maxBandwidthKbps) {
        this.audioVideoController.setVideoMaxBandwidthKbps(maxBandwidthKbps);
        this.trace('setVideoMaxBandwidthKbps', maxBandwidthKbps);
    }
    setVideoCodecSendPreferences(preferences) {
        this.audioVideoController.setVideoCodecSendPreferences(preferences);
        this.trace('setVideoCodecSendPreferences', preferences);
    }
    getVideoInputQualitySettings() {
        const result = this.deviceController.getVideoInputQualitySettings();
        this.trace('getVideoInputQualitySettings');
        return result;
    }
    setContentAudioProfile(audioProfile) {
        this.trace('setContentAudioProfile', audioProfile);
        this.contentShareController.setContentAudioProfile(audioProfile);
    }
    enableSimulcastForContentShare(enable, encodingParams) {
        this.trace('enableSimulcastForContentShare');
        this.contentShareController.enableSimulcastForContentShare(enable, encodingParams);
    }
    enableSVCForContentShare(enable) {
        this.trace('enableSVCForContentShare');
        this.contentShareController.enableSVCForContentShare(enable);
    }
    startContentShare(stream) {
        const result = this.contentShareController.startContentShare(stream);
        this.trace('startContentShare');
        return result;
    }
    startContentShareFromScreenCapture(sourceId, frameRate) {
        const result = this.contentShareController.startContentShareFromScreenCapture(sourceId, frameRate);
        this.trace('startContentShareFromScreenCapture');
        return result;
    }
    pauseContentShare() {
        this.contentShareController.pauseContentShare();
        this.trace('pauseContentShare');
    }
    unpauseContentShare() {
        this.contentShareController.unpauseContentShare();
        this.trace('unpauseContentShare');
    }
    stopContentShare() {
        this.contentShareController.stopContentShare();
        this.trace('stopContentShare');
    }
    addContentShareObserver(observer) {
        this.contentShareController.addContentShareObserver(observer);
        this.trace('addContentShareObserver');
    }
    removeContentShareObserver(observer) {
        this.contentShareController.removeContentShareObserver(observer);
        this.trace('removeContentShareObserver');
    }
    setContentShareVideoCodecPreferences(preferences) {
        this.contentShareController.setContentShareVideoCodecPreferences(preferences);
        this.trace('setContentShareVideoCodecPreferences');
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    trace(name, input, output) {
        const meetingId = this.audioVideoController.configuration.meetingId;
        const attendeeId = this.audioVideoController.configuration.credentials.attendeeId;
        let s = `API/DefaultAudioVideoFacade/${meetingId}/${attendeeId}/${name}`;
        if (typeof input !== 'undefined') s += ` ${JSON.stringify(input)}`;
        if (typeof output !== 'undefined') s += ` -> ${JSON.stringify(output)}`;
        this.audioVideoController.logger.info(s);
    }
    getRemoteVideoSources() {
        const result = this.audioVideoController.getRemoteVideoSources();
        this.trace('getRemoteVideoSources', null, result);
        return result;
    }
    get transcriptionController() {
        return this.realtimeController.transcriptionController;
    }
    promoteToPrimaryMeeting(credentials) {
        this.audioVideoController.removeObserver(this); // Avoid adding multiple times
        this.audioVideoController.addObserver(this); // See note in `audioVideoWasDemotedFromPrimaryMeeting`
        const result = this.audioVideoController.promoteToPrimaryMeeting(credentials);
        this.trace('promoteToPrimaryMeeting', null, result); // Don't trace credentials
        return result;
    }
    demoteFromPrimaryMeeting() {
        this.trace('demoteFromPrimaryMeeting');
        this.audioVideoController.demoteFromPrimaryMeeting();
    }
    audioVideoWasDemotedFromPrimaryMeeting(_) {
        // `DefaultContentShareController` currently does not respond to the connection ending
        // so `contentShareDidStop` will not be called even if backend cleans up the connection.
        // Thus we try to pre-emptively clean up on client side.
        this.contentShareController.stopContentShare();
        this.audioVideoController.removeObserver(this);
    }
}
module.exports.default = $bc4df1b899ec896e$var$DefaultAudioVideoFacade;

});

parcelRegister("buznb", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $85ddef5b88ef8bfa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $85ddef5b88ef8bfa$var$VideoQualitySettings_1 = $85ddef5b88ef8bfa$var$__importDefault((parcelRequire("3C9sO")));

const $85ddef5b88ef8bfa$var$MeetingSessionConfiguration_1 = $85ddef5b88ef8bfa$var$__importDefault((parcelRequire("dKmza")));

const $85ddef5b88ef8bfa$var$MeetingSessionCredentials_1 = $85ddef5b88ef8bfa$var$__importDefault((parcelRequire("ewCV2")));

const $85ddef5b88ef8bfa$var$DefaultModality_1 = $85ddef5b88ef8bfa$var$__importDefault((parcelRequire("4Zce1")));

const $85ddef5b88ef8bfa$var$AsyncScheduler_1 = $85ddef5b88ef8bfa$var$__importDefault((parcelRequire("4mLYP")));

var $jfpqH = parcelRequire("jfpqH");

const $85ddef5b88ef8bfa$var$NoVideoDownlinkBandwidthPolicy_1 = $85ddef5b88ef8bfa$var$__importDefault((parcelRequire("frCEd")));

const $85ddef5b88ef8bfa$var$DefaultSimulcastUplinkPolicyForContentShare_1 = $85ddef5b88ef8bfa$var$__importDefault((parcelRequire("h4LS3")));

const $85ddef5b88ef8bfa$var$ContentShareConstants_1 = $85ddef5b88ef8bfa$var$__importDefault((parcelRequire("g6nnJ")));
class $85ddef5b88ef8bfa$var$DefaultContentShareController {
    static createContentShareMeetingSessionConfigure(configuration) {
        const contentShareConfiguration = new $85ddef5b88ef8bfa$var$MeetingSessionConfiguration_1.default();
        contentShareConfiguration.meetingId = configuration.meetingId;
        contentShareConfiguration.externalMeetingId = configuration.externalMeetingId;
        contentShareConfiguration.urls = configuration.urls;
        contentShareConfiguration.disablePeriodicKeyframeRequestOnContentSender = configuration.disablePeriodicKeyframeRequestOnContentSender;
        contentShareConfiguration.credentials = new $85ddef5b88ef8bfa$var$MeetingSessionCredentials_1.default();
        contentShareConfiguration.credentials.attendeeId = configuration.credentials.attendeeId + $85ddef5b88ef8bfa$var$ContentShareConstants_1.default.Modality;
        contentShareConfiguration.credentials.externalUserId = configuration.credentials.externalUserId;
        contentShareConfiguration.credentials.joinToken = configuration.credentials.joinToken + $85ddef5b88ef8bfa$var$ContentShareConstants_1.default.Modality;
        contentShareConfiguration.meetingFeatures = configuration.meetingFeatures.clone();
        contentShareConfiguration.videoDownlinkBandwidthPolicy = new $85ddef5b88ef8bfa$var$NoVideoDownlinkBandwidthPolicy_1.default();
        return contentShareConfiguration;
    }
    constructor(mediaStreamBroker, contentAudioVideo, attendeeAudioVideo){
        this.mediaStreamBroker = mediaStreamBroker;
        this.contentAudioVideo = contentAudioVideo;
        this.attendeeAudioVideo = attendeeAudioVideo;
        this.observerQueue = new Set();
        this.destroyed = false;
        this.contentAudioVideo.addObserver(this);
        this.setupContentShareEvents();
    }
    setContentAudioProfile(audioProfile) {
        this.contentAudioVideo.setAudioProfile(audioProfile);
    }
    enableSimulcastForContentShare(enable, encodingParams) {
        if (enable) {
            this.contentAudioVideo.configuration.enableSimulcastForUnifiedPlanChromiumBasedBrowsers = true;
            this.contentAudioVideo.configuration.videoUplinkBandwidthPolicy = new $85ddef5b88ef8bfa$var$DefaultSimulcastUplinkPolicyForContentShare_1.default(this.contentAudioVideo.logger, encodingParams);
        } else {
            this.contentAudioVideo.configuration.enableSimulcastForUnifiedPlanChromiumBasedBrowsers = false;
            this.contentAudioVideo.configuration.videoUplinkBandwidthPolicy = undefined;
        }
    }
    enableSVCForContentShare(enable) {
        if (enable) this.contentAudioVideo.configuration.enableSVC = true;
        else this.contentAudioVideo.configuration.enableSVC = false;
    }
    async startContentShare(stream) {
        if (!stream) return;
        if (this.contentAudioVideo.configuration.meetingFeatures.contentMaxResolution === $85ddef5b88ef8bfa$var$VideoQualitySettings_1.default.VideoDisabled) {
            this.contentAudioVideo.logger.info('Could not start content because max content resolution was set to None');
            return;
        }
        this.mediaStreamBroker.mediaStream = stream;
        for(let i = 0; i < this.mediaStreamBroker.mediaStream.getTracks().length; i++)this.mediaStreamBroker.mediaStream.getTracks()[i].addEventListener('ended', ()=>{
            this.stopContentShare();
        });
        this.contentAudioVideo.start();
    }
    async startContentShareFromScreenCapture(sourceId, frameRate) {
        const mediaStream = await this.mediaStreamBroker.acquireScreenCaptureDisplayInputStream(sourceId, frameRate);
        await this.startContentShare(mediaStream);
        return mediaStream;
    }
    pauseContentShare() {
        if (this.mediaStreamBroker.toggleMediaStream(false)) this.forEachContentShareObserver((observer)=>{
            $jfpqH.Maybe.of(observer.contentShareDidPause).map((f)=>f.call(observer));
        });
    }
    unpauseContentShare() {
        if (this.mediaStreamBroker.toggleMediaStream(true)) this.forEachContentShareObserver((observer)=>{
            $jfpqH.Maybe.of(observer.contentShareDidUnpause).map((f)=>f.call(observer));
        });
    }
    setContentShareVideoCodecPreferences(preferences) {
        this.contentAudioVideo.setVideoCodecSendPreferences(preferences);
    }
    async destroy() {
        // Idempotency.
        /* istanbul ignore if */ if (!this.contentAudioVideo) return;
        this.destroyed = true;
        this.contentAudioVideo.removeObserver(this);
        this.stopContentShare();
        this.observerQueue.clear();
        this.contentAudioVideo = undefined;
        this.attendeeAudioVideo = undefined;
        this.mediaStreamBroker = undefined;
    }
    stopContentShare() {
        this.contentAudioVideo.stop();
        this.mediaStreamBroker.cleanup();
    }
    addContentShareObserver(observer) {
        this.observerQueue.add(observer);
    }
    removeContentShareObserver(observer) {
        this.observerQueue.delete(observer);
    }
    forEachContentShareObserver(observerFunc) {
        for (const observer of this.observerQueue)$85ddef5b88ef8bfa$var$AsyncScheduler_1.default.nextTick(()=>{
            if (this.observerQueue.has(observer)) observerFunc(observer);
        });
    }
    audioVideoDidStart() {
        var _a;
        if (((_a = this.mediaStreamBroker.mediaStream) === null || _a === void 0 ? void 0 : _a.getVideoTracks().length) > 0) this.contentAudioVideo.videoTileController.startLocalVideoTile();
    }
    audioVideoDidStop(_sessionStatus) {
        // If the content attendee got dropped or could not connect, stopContentShare will not be called
        // so make sure to clean up the media stream.
        this.mediaStreamBroker.cleanup();
        if (this.contentShareTile) {
            this.attendeeAudioVideo.videoTileController.removeVideoTile(this.contentShareTile.id());
            this.contentShareTile = null;
        }
        this.forEachContentShareObserver((observer)=>{
            $jfpqH.Maybe.of(observer.contentShareDidStop).map((f)=>f.call(observer));
        });
    }
    setupContentShareEvents() {
        // We use realtimeSubscribeToAttendeeIdPresence instead of audioVideoDidStart because audioVideoDidStart fires
        // before the capacity check in the media backend while when realtimeSubscribeToAttendeeIdPresence fires, we know the
        // content attendee has been able to pass the capacity check and join the call so we can start the local
        // content share video
        this.attendeeAudioVideo.realtimeController.realtimeSubscribeToAttendeeIdPresence((attendeeId, present, _externalUserId, _dropped)=>{
            const isContentAttendee = new $85ddef5b88ef8bfa$var$DefaultModality_1.default(attendeeId).hasModality($85ddef5b88ef8bfa$var$DefaultModality_1.default.MODALITY_CONTENT);
            const isSelfAttendee = new $85ddef5b88ef8bfa$var$DefaultModality_1.default(attendeeId).base() === this.attendeeAudioVideo.configuration.credentials.attendeeId;
            if (!isContentAttendee || !isSelfAttendee || !present || this.contentShareTile) return;
            const stream = this.mediaStreamBroker.mediaStream;
            if (stream === null || stream === void 0 ? void 0 : stream.getVideoTracks().length) {
                this.contentShareTile = this.attendeeAudioVideo.videoTileController.addVideoTile();
                const track = stream.getVideoTracks()[0];
                let width, height;
                if (track.getSettings) {
                    const cap = track.getSettings();
                    width = cap.width;
                    height = cap.height;
                } else {
                    const cap = track.getCapabilities();
                    width = cap.width;
                    height = cap.height;
                }
                this.contentShareTile.bindVideoStream(this.contentAudioVideo.configuration.credentials.attendeeId, false, stream, width, height, null, this.contentAudioVideo.configuration.credentials.externalUserId);
            }
            this.forEachContentShareObserver((observer)=>{
                $jfpqH.Maybe.of(observer.contentShareDidStart).map((f)=>f.call(observer));
            });
        });
    }
}
module.exports.default = $85ddef5b88ef8bfa$var$DefaultContentShareController;

});
parcelRegister("dKmza", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $a021136b49d5739a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $a021136b49d5739a$var$ConnectionHealthPolicyConfiguration_1 = $a021136b49d5739a$var$__importDefault((parcelRequire("gCpm1")));

const $a021136b49d5739a$var$VideoQualitySettings_1 = $a021136b49d5739a$var$__importDefault((parcelRequire("3C9sO")));

var $9UH7r = parcelRequire("9UH7r");

const $a021136b49d5739a$var$MeetingFeatures_1 = $a021136b49d5739a$var$__importDefault((parcelRequire("hQn0x")));

const $a021136b49d5739a$var$MeetingSessionCredentials_1 = $a021136b49d5739a$var$__importDefault((parcelRequire("ewCV2")));

const $a021136b49d5739a$var$MeetingSessionURLs_1 = $a021136b49d5739a$var$__importDefault((parcelRequire("76y6f")));
/**
 * [[MeetingSessionConfiguration]] contains the information necessary to start
 * a session.
 */ class $a021136b49d5739a$var$MeetingSessionConfiguration {
    /**
     * Constructs a MeetingSessionConfiguration optionally with a chime:CreateMeeting and
     * chime:CreateAttendee response. You can pass in either a JSON object containing the
     * responses, or a JSON object containing the information in the Meeting and Attendee
     * root-level fields. Examples:
     *
     * ```
     * const configuration = new MeetingSessionConfiguration({
     *   "Meeting": {
     *      "MeetingId": "...",
     *      "MediaPlacement": {
     *        "AudioHostUrl": "...",
     *        "SignalingUrl": "...",
     *        "TurnControlUrl": "..."
     *      },
     *      "MeetingFeatures":{
     *        "Audio":"...",
     *        "Video":"....",
     *        "Content":"...",
     *        "Attendee":"..."
     *      },
     *    }
     *   }
     * }, {
     *   "Attendee": {
     *     "ExternalUserId": "...",
     *     "AttendeeId": "...",
     *     "JoinToken": "..."
     *   }
     * });
     * ```
     *
     * ```
     * const configuration = new MeetingSessionConfiguration({
     *   "MeetingId": "...",
     *   "MediaPlacement": {
     *     "AudioHostUrl": "...",
     *     "SignalingUrl": "...",
     *     "TurnControlUrl": "..."
     *   }
     * }, {
     *   "ExternalUserId": "...",
     *   "AttendeeId": "...",
     *   "JoinToken": "..."
     * });
     * ```
     */ constructor(createMeetingResponse, createAttendeeResponse){
        var _a, _b;
        /**
         * The id of the meeting the session is joining.
         */ this.meetingId = null;
        /**
         * The external meeting id of the meeting the session is joining.
         */ this.externalMeetingId = null;
        /**
         * The credentials used to authenticate the session.
         */ this.credentials = null;
        /**
         * The URLs the session uses to reach the meeting service.
         */ this.urls = null;
        /**
         * Maximum amount of time in milliseconds to allow for connecting.
         */ this.connectionTimeoutMs = 15000;
        /**
         * Maximum amount of time in milliseconds to wait for the current attendee to be present
         * after initial connection.
         */ this.attendeePresenceTimeoutMs = 0;
        /**
         * Configuration for connection health policies: reconnection, unusable audio warning connection,
         * and signal strength bars connection.
         */ this.connectionHealthPolicyConfiguration = new $a021136b49d5739a$var$ConnectionHealthPolicyConfiguration_1.default();
        /**
         * Maximum amount of time in milliseconds to allow for reconnecting.
         */ this.reconnectTimeoutMs = 120000;
        /**
         * Fixed wait amount in milliseconds between reconnecting attempts.
         */ this.reconnectFixedWaitMs = 0;
        /**
         * The short back-off time in milliseconds between reconnecting attempts.
         */ this.reconnectShortBackOffMs = 1000;
        /**
         * The long back-off time in milliseconds between reconnecting attempts.
         */ this.reconnectLongBackOffMs = 5000;
        /**
         * Feature flag to enable Simulcast
         *
         * @deprecated Simulcast is deprecated in favor of scalable video coding (SVC) using feature flag `enableSVC`
         */ this.enableSimulcastForUnifiedPlanChromiumBasedBrowsers = false;
        /**
         * Feature flag to enable scalable video coding (SVC) on supported browsers, which is determined by `BrowserBehavior.supportsScalableVideoCoding`
         */ this.enableSVC = false;
        /**
         * Video downlink bandwidth policy to determine which remote videos
         * are subscribed to.
         */ this.videoDownlinkBandwidthPolicy = null;
        /**
         * Video uplink bandwidth policy to determine the bandwidth constraints
         * of the local video.
         */ this.videoUplinkBandwidthPolicy = null;
        /**
         * Keep the last frame of the video when a remote video is paused via the pauseVideoTile API.
         * This is done by not clearing the srcObject property of the videoElement.
         */ this.keepLastFrameWhenPaused = false;
        /**
         * The Amazon Chime SDK media backends currently send a keyframe request to content share senders every 10 seconds to help mitigate
         * decoder issues on receivers. This flag requests the backed to disable that feature.
         *
         * Setting this flag to true may or may not lead to issues with content received for your application, as it depends on browsers used
         * and whether they have fixed previous issues leading to the introduction of this periodic keyframe request. It will however
         * reduce CPU consumption on content senders which no longer have to generate as many expensive keyframes.
         */ this.disablePeriodicKeyframeRequestOnContentSender = false;
        /**
         * Additional features in the meeting
         */ this.meetingFeatures = new $a021136b49d5739a$var$MeetingFeatures_1.default();
        if (createMeetingResponse) {
            createMeetingResponse = (0, $9UH7r.toLowerCasePropertyNames)(createMeetingResponse);
            if (createMeetingResponse.meeting) createMeetingResponse = createMeetingResponse.meeting;
            this.meetingId = createMeetingResponse.meetingid;
            this.externalMeetingId = createMeetingResponse.externalmeetingid;
            this.urls = new $a021136b49d5739a$var$MeetingSessionURLs_1.default();
            this.urls.audioHostURL = createMeetingResponse.mediaplacement.audiohosturl;
            this.urls.signalingURL = createMeetingResponse.mediaplacement.signalingurl;
            this.urls.turnControlURL = createMeetingResponse.mediaplacement.turncontrolurl;
            if (createMeetingResponse.mediaplacement.eventingestionurl) this.urls.eventIngestionURL = createMeetingResponse.mediaplacement.eventingestionurl;
            const parseVideoResolution = (resolution, defaultValue)=>{
                switch(resolution){
                    case 'None':
                        return $a021136b49d5739a$var$VideoQualitySettings_1.default.VideoDisabled;
                    case 'HD':
                        return $a021136b49d5739a$var$VideoQualitySettings_1.default.VideoResolutionHD;
                    case 'FHD':
                        return $a021136b49d5739a$var$VideoQualitySettings_1.default.VideoResolutionFHD;
                    case 'UHD':
                        return $a021136b49d5739a$var$VideoQualitySettings_1.default.VideoResolutionUHD;
                    default:
                        return defaultValue;
                }
            };
            if (((_a = createMeetingResponse.meetingfeatures) === null || _a === void 0 ? void 0 : _a.video) !== undefined || ((_b = createMeetingResponse.meetingfeatures) === null || _b === void 0 ? void 0 : _b.content) !== undefined) {
                const videoMaxResolution = createMeetingResponse.meetingfeatures.video === undefined ? 'HD' : createMeetingResponse.meetingfeatures.video.maxresolution;
                const contentMaxResolution = createMeetingResponse.meetingfeatures.content === undefined ? 'FHD' : createMeetingResponse.meetingfeatures.content.maxresolution;
                this.meetingFeatures = new $a021136b49d5739a$var$MeetingFeatures_1.default(parseVideoResolution(videoMaxResolution, $a021136b49d5739a$var$VideoQualitySettings_1.default.VideoResolutionHD), parseVideoResolution(contentMaxResolution, $a021136b49d5739a$var$VideoQualitySettings_1.default.VideoResolutionFHD));
            }
        }
        if (createAttendeeResponse) {
            createAttendeeResponse = (0, $9UH7r.toLowerCasePropertyNames)(createAttendeeResponse);
            if (createAttendeeResponse.attendee) createAttendeeResponse = createAttendeeResponse.attendee;
            this.credentials = new $a021136b49d5739a$var$MeetingSessionCredentials_1.default();
            this.credentials.attendeeId = createAttendeeResponse.attendeeid;
            this.credentials.externalUserId = createAttendeeResponse.externaluserid;
            this.credentials.joinToken = createAttendeeResponse.jointoken;
        }
    }
}
module.exports.default = $a021136b49d5739a$var$MeetingSessionConfiguration;

});
parcelRegister("hQn0x", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $cfd923ddbc512deb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $cfd923ddbc512deb$var$VideoQualitySettings_1 = $cfd923ddbc512deb$var$__importDefault((parcelRequire("3C9sO")));
/**
 * [[MeetingFeatures]] contains information on meeting wide configuration which may impact the
 * client.
 */ class $cfd923ddbc512deb$var$MeetingFeatures {
    constructor(videoMaxResolution = $cfd923ddbc512deb$var$VideoQualitySettings_1.default.VideoResolutionHD, contentMaxResolution = $cfd923ddbc512deb$var$VideoQualitySettings_1.default.VideoResolutionFHD){
        this.videoMaxResolution = videoMaxResolution;
        this.contentMaxResolution = contentMaxResolution;
    }
    /**
     * Returns a deep copy of meeting features.
     */ clone() {
        return new $cfd923ddbc512deb$var$MeetingFeatures(this.videoMaxResolution, this.contentMaxResolution);
    }
}
module.exports.default = $cfd923ddbc512deb$var$MeetingFeatures;

});

parcelRegister("ewCV2", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[MeetingSessionCredentials]] includes the credentials used to authenticate
 * the attendee on the meeting
 */ class $a9323e5b4fd14e51$var$MeetingSessionCredentials {
    constructor(){
        /**
         * The attendee id for these credentials.
         */ this.attendeeId = null;
        /**
         * The external user id associated with the attendee.
         */ this.externalUserId = null;
        /**
         * If set, the session will be authenticated with a join token.
         */ this.joinToken = null;
    }
    /**
     * Overrides JSON serialization so that join token is redacted.
     */ toJSON() {
        return {
            attendeeId: this.attendeeId,
            joinToken: this.joinToken === null ? null : '<redacted>'
        };
    }
}
module.exports.default = $a9323e5b4fd14e51$var$MeetingSessionCredentials;

});

parcelRegister("76y6f", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[MeetingSessionURLs]] contains the URLs that will be used to reach the
 * meeting service.
 */ class $52c38b6d57939590$var$MeetingSessionURLs {
    constructor(){
        /**
         * The audio host URL of the session
         */ this._audioHostURL = null;
        /**
         * The signaling URL of the session
         */ this._signalingURL = null;
        /**
         * The TURN control URL of the session
         */ this._turnControlURL = null;
        /**
         * The event ingestion URL to send the meeting events.
         */ this._eventIngestionURL = null;
        /**
         * Function to transform URLs. Use this to rewrite URLs to traverse proxies.
         * The default implementation returns the original URL unchanged.
         */ this.urlRewriter = (url)=>{
            return url;
        };
        /**
         * Optional function to transform a single URL into multiple URLs. This is currently only used for TURN URI processing.
         *
         * There is not any good reason for a typical application to implement this.
         *
         * When set, this takes precedence over {@link MeetingSessionURLs.urlRewriter} for TURN URI processing.
         * The default is null, meaning {@link MeetingSessionURLs.urlRewriter} will be used instead.
         */ this.urlRewriterMulti = null;
    }
    /**
     * Gets or sets the audio host URL with gets reflecting the result of the {@link MeetingSessionURLs.urlRewriter} function.
     */ get audioHostURL() {
        return this.urlRewriter(this._audioHostURL);
    }
    set audioHostURL(value) {
        this._audioHostURL = value;
    }
    /**
     * Gets or sets the signaling URL with gets reflecting the result of the {@link MeetingSessionURLs.urlRewriter} function.
     */ get signalingURL() {
        return this.urlRewriter(this._signalingURL);
    }
    set signalingURL(value) {
        this._signalingURL = value;
    }
    /**
     * Gets or sets the TURN control URL with gets reflecting the result of the {@link MeetingSessionURLs.urlRewriter} function.
     *
     * This URL is currently unused by the SDK and will be removed in a later release.
     */ get turnControlURL() {
        return this.urlRewriter(this._turnControlURL);
    }
    /**
     * This URL is currently unused by the SDK and will be removed in a later release.
     */ set turnControlURL(value) {
        this._turnControlURL = value;
    }
    /**
     * Gets or sets the events ingestion URL with gets reflecting the result of the {@link MeetingSessionURLs.urlRewriter} function.
     */ get eventIngestionURL() {
        return this.urlRewriter(this._eventIngestionURL);
    }
    set eventIngestionURL(value) {
        this._eventIngestionURL = value;
    }
}
module.exports.default = $52c38b6d57939590$var$MeetingSessionURLs;

});


parcelRegister("frCEd", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $b3e75b413d2da635$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $b3e75b413d2da635$var$DefaultVideoStreamIdSet_1 = $b3e75b413d2da635$var$__importDefault((parcelRequire("gVZQM")));
class $b3e75b413d2da635$var$NoVideoDownlinkBandwidthPolicy {
    reset() {}
    updateIndex(_videoIndex) {}
    updateMetrics(_clientMetricReport) {}
    wantsResubscribe() {
        return false;
    }
    chooseSubscriptions() {
        return new $b3e75b413d2da635$var$DefaultVideoStreamIdSet_1.default();
    }
}
module.exports.default = $b3e75b413d2da635$var$NoVideoDownlinkBandwidthPolicy;

});

parcelRegister("h4LS3", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c6e7f18fc70d6be1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $c6e7f18fc70d6be1$var$SimulcastContentShareTransceiverController_1 = $c6e7f18fc70d6be1$var$__importDefault((parcelRequire("5IW3c")));
/**
 * [[DefaultSimulcastUplinkPolicyForContentShare]] sets the capture and encode
 *  parameters based on constructor input parameters
 *
 * @deprecated Simulcast is deprecated in favor of scalable video coding (SVC).
 */ class $c6e7f18fc70d6be1$var$DefaultSimulcastUplinkPolicyForContentShare {
    constructor(_logger, encodingParams){
        this.encodingParams = encodingParams;
        this.enableUhdContent = false;
        this.defaultHiTargetBitrateKbps = 1200;
        this.defaultLowTargetBitrateKbps = 300;
    }
    updateConnectionMetric(_metrics) {}
    chooseMediaTrackConstraints() {
        return undefined;
    }
    chooseEncodingParameters() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const newMap = new Map();
        const toBps = 1000;
        const nameArr = $c6e7f18fc70d6be1$var$SimulcastContentShareTransceiverController_1.default.NAME_ARR_ASCENDING;
        newMap.set(nameArr[0], {
            rid: nameArr[0],
            active: true,
            scaleResolutionDownBy: ((_b = (_a = this.encodingParams) === null || _a === void 0 ? void 0 : _a.low) === null || _b === void 0 ? void 0 : _b.scaleResolutionDownBy) || 2,
            maxBitrate: (((_d = (_c = this.encodingParams) === null || _c === void 0 ? void 0 : _c.low) === null || _d === void 0 ? void 0 : _d.maxBitrateKbps) || this.defaultLowTargetBitrateKbps) * toBps,
            maxFramerate: ((_f = (_e = this.encodingParams) === null || _e === void 0 ? void 0 : _e.low) === null || _f === void 0 ? void 0 : _f.maxFramerate) || 5
        });
        newMap.set(nameArr[1], {
            rid: nameArr[1],
            active: true,
            scaleResolutionDownBy: ((_h = (_g = this.encodingParams) === null || _g === void 0 ? void 0 : _g.high) === null || _h === void 0 ? void 0 : _h.scaleResolutionDownBy) || 1,
            maxBitrate: (((_k = (_j = this.encodingParams) === null || _j === void 0 ? void 0 : _j.high) === null || _k === void 0 ? void 0 : _k.maxBitrateKbps) || this.defaultHiTargetBitrateKbps) * toBps,
            maxFramerate: (_m = (_l = this.encodingParams) === null || _l === void 0 ? void 0 : _l.high) === null || _m === void 0 ? void 0 : _m.maxFramerate
        });
        return newMap;
    }
    updateIndex(_videoIndex) {}
    wantsResubscribe() {
        return false;
    }
    chooseCaptureAndEncodeParameters() {
        return undefined;
    }
    maxBandwidthKbps() {
        return this.enableUhdContent ? 2000 : 1200;
    }
    setIdealMaxBandwidthKbps(_idealMaxBandwidthKbps) {}
    setHasBandwidthPriority(_hasBandwidthPriority) {}
    setHighResolutionFeatureEnabled(enabled) {
        this.enableUhdContent = enabled;
        this.defaultHiTargetBitrateKbps = enabled ? 2000 : 1200;
        this.defaultLowTargetBitrateKbps = enabled ? 500 : 300;
    }
    addObserver(_observer) {}
    removeObserver(_observer) {}
    forEachObserver(_observerFunc) {}
}
module.exports.default = $c6e7f18fc70d6be1$var$DefaultSimulcastUplinkPolicyForContentShare;

});
parcelRegister("5IW3c", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $42ae1770207762f7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $42ae1770207762f7$var$SimulcastTransceiverController_1 = $42ae1770207762f7$var$__importDefault((parcelRequire("hl0rE")));
/**
 * @deprecated Simulcast is deprecated in favor of scalable video coding (SVC).
 */ class $42ae1770207762f7$var$SimulcastContentShareTransceiverController extends $42ae1770207762f7$var$SimulcastTransceiverController_1.default {
    constructor(logger, browserBehavior, meetingSessionContext, encodedTransformWorkerManager){
        super(logger, browserBehavior, meetingSessionContext, encodedTransformWorkerManager);
        let scale = 2;
        this.videoQualityControlParameterMap = new Map();
        for(let i = 0; i < $42ae1770207762f7$var$SimulcastContentShareTransceiverController.NAME_ARR_ASCENDING.length; i++){
            const ridName = $42ae1770207762f7$var$SimulcastContentShareTransceiverController.NAME_ARR_ASCENDING[i];
            this.videoQualityControlParameterMap.set(ridName, {
                rid: ridName,
                scaleResolutionDownBy: scale,
                maxBitrate: $42ae1770207762f7$var$SimulcastContentShareTransceiverController.BITRATE_ARR_ASCENDING[i] * 1000
            });
            scale = scale / 2;
        }
    }
    // Note: `scaleResolutionDownBy` has only been tested with values 1, 2, and 4.
    async setEncodingParameters(encodingParamMap) {
        if (!this._localCameraTransceiver || this._localCameraTransceiver.direction !== 'sendrecv') return;
        const sender = this._localCameraTransceiver.sender;
        const newEncodingParams = Array.from(encodingParamMap.values());
        if (newEncodingParams.length <= 0) return;
        const oldParam = sender.getParameters();
        if (!oldParam.encodings) oldParam.encodings = newEncodingParams;
        else for(let i = 0; i < oldParam.encodings.length; i++){
            if (oldParam.encodings[i].rid === $42ae1770207762f7$var$SimulcastTransceiverController_1.default.LOW_LEVEL_NAME) this.copyEncodingParams(encodingParamMap.get($42ae1770207762f7$var$SimulcastTransceiverController_1.default.LOW_LEVEL_NAME), oldParam.encodings[i]);
            if (oldParam.encodings[i].rid === $42ae1770207762f7$var$SimulcastTransceiverController_1.default.HIGH_LEVEL_NAME) this.copyEncodingParams(encodingParamMap.get($42ae1770207762f7$var$SimulcastTransceiverController_1.default.HIGH_LEVEL_NAME), oldParam.encodings[i]);
        }
        await sender.setParameters(oldParam);
        this.logVideoTransceiverParameters();
    }
}
$42ae1770207762f7$var$SimulcastContentShareTransceiverController.NAME_ARR_ASCENDING = [
    'low',
    'hi'
];
$42ae1770207762f7$var$SimulcastContentShareTransceiverController.BITRATE_ARR_ASCENDING = [
    300,
    1200
];
module.exports.default = $42ae1770207762f7$var$SimulcastContentShareTransceiverController;

});
parcelRegister("hl0rE", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c9f4be2ea7285fff$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $c9f4be2ea7285fff$var$DefaultTransceiverController_1 = $c9f4be2ea7285fff$var$__importDefault((parcelRequire("itul0")));
/**
 * @deprecated Simulcast is deprecated in favor of scalable video coding (SVC).
 */ class $c9f4be2ea7285fff$var$SimulcastTransceiverController extends $c9f4be2ea7285fff$var$DefaultTransceiverController_1.default {
    constructor(logger, browserBehavior, meetingSessionContext, encodedTransformWorkerManager){
        super(logger, browserBehavior, meetingSessionContext, encodedTransformWorkerManager);
        this.videoQualityControlParameterMap = new Map();
        let scale = 4;
        for(let i = 0; i < $c9f4be2ea7285fff$var$SimulcastTransceiverController.NAME_ARR_ASCENDING.length; i++){
            const ridName = $c9f4be2ea7285fff$var$SimulcastTransceiverController.NAME_ARR_ASCENDING[i];
            this.videoQualityControlParameterMap.set(ridName, {
                rid: ridName,
                scaleResolutionDownBy: scale,
                maxBitrate: $c9f4be2ea7285fff$var$SimulcastTransceiverController.BITRATE_ARR_ASCENDING[i] * 1000
            });
            scale = scale / 2;
        }
    }
    // Note: `scaleResolutionDownBy` has only been tested with values 1, 2, and 4.
    async setEncodingParameters(encodingParamMap) {
        if (!this._localCameraTransceiver || this._localCameraTransceiver.direction !== 'sendrecv') return;
        const sender = this._localCameraTransceiver.sender;
        const newEncodingParams = Array.from(encodingParamMap.values());
        if (newEncodingParams.length <= 0) return;
        const oldParam = sender.getParameters();
        if (!oldParam.encodings) oldParam.encodings = newEncodingParams;
        else for (const encoding of oldParam.encodings){
            if (encoding.rid === $c9f4be2ea7285fff$var$SimulcastTransceiverController.LOW_LEVEL_NAME) this.copyEncodingParams(encodingParamMap.get($c9f4be2ea7285fff$var$SimulcastTransceiverController.LOW_LEVEL_NAME), encoding);
            if (encoding.rid === $c9f4be2ea7285fff$var$SimulcastTransceiverController.MID_LEVEL_NAME) this.copyEncodingParams(encodingParamMap.get($c9f4be2ea7285fff$var$SimulcastTransceiverController.MID_LEVEL_NAME), encoding);
            if (encoding.rid === $c9f4be2ea7285fff$var$SimulcastTransceiverController.HIGH_LEVEL_NAME) this.copyEncodingParams(encodingParamMap.get($c9f4be2ea7285fff$var$SimulcastTransceiverController.HIGH_LEVEL_NAME), encoding);
        }
        await sender.setParameters(oldParam);
        this.logVideoTransceiverParameters();
    }
    async setVideoSendingBitrateKbps(_bitrateKbps) {
        return;
    }
    setupLocalTransceivers() {
        var _a, _b;
        if (!this.useTransceivers()) return;
        if (!this.defaultMediaStream && typeof MediaStream !== 'undefined') this.defaultMediaStream = new MediaStream();
        if (!this._localAudioTransceiver) {
            this._localAudioTransceiver = this.peer.addTransceiver('audio', {
                direction: 'inactive',
                streams: [
                    this.defaultMediaStream
                ]
            });
            if ((_a = this.encodedTransformWorkerManager) === null || _a === void 0 ? void 0 : _a.isEnabled()) {
                this.encodedTransformWorkerManager.setupAudioSenderTransform(this._localAudioTransceiver.sender);
                this.encodedTransformWorkerManager.setupAudioReceiverTransform(this._localAudioTransceiver.receiver);
            } else this.logger.warn('Media transforms not supported, skipping audio transform setup');
        }
        if (!this._localCameraTransceiver) {
            const encodingParams = Array.from(this.videoQualityControlParameterMap.values());
            this._localCameraTransceiver = this.peer.addTransceiver('video', {
                direction: 'inactive',
                streams: [
                    this.defaultMediaStream
                ],
                sendEncodings: encodingParams
            });
            this.configureLocalCameraHeaderExtensions();
            if ((_b = this.encodedTransformWorkerManager) === null || _b === void 0 ? void 0 : _b.isEnabled()) this.encodedTransformWorkerManager.setupVideoSenderTransform(this._localCameraTransceiver.sender);
        }
    }
    logVideoTransceiverParameters() {
        const params = this._localCameraTransceiver.sender.getParameters();
        const encodings = params.encodings;
        let msg = 'simulcast: current encoding parameters \n';
        for (const encodingParam of encodings)msg += `rid=${encodingParam.rid} maxBitrate=${encodingParam.maxBitrate} active=${encodingParam.active} scaleDownBy=${encodingParam.scaleResolutionDownBy} maxFrameRate = ${encodingParam.maxFramerate} \n`;
        this.logger.info(msg);
    }
    copyEncodingParams(fromEncodingParams, toEncodingParams) {
        toEncodingParams.active = fromEncodingParams.active;
        toEncodingParams.maxBitrate = fromEncodingParams.maxBitrate;
        toEncodingParams.scaleResolutionDownBy = fromEncodingParams.scaleResolutionDownBy;
        toEncodingParams.maxFramerate = fromEncodingParams.maxFramerate;
    }
}
$c9f4be2ea7285fff$var$SimulcastTransceiverController.LOW_LEVEL_NAME = 'low';
$c9f4be2ea7285fff$var$SimulcastTransceiverController.MID_LEVEL_NAME = 'mid';
$c9f4be2ea7285fff$var$SimulcastTransceiverController.HIGH_LEVEL_NAME = 'hi';
$c9f4be2ea7285fff$var$SimulcastTransceiverController.NAME_ARR_ASCENDING = [
    'low',
    'mid',
    'hi'
];
$c9f4be2ea7285fff$var$SimulcastTransceiverController.BITRATE_ARR_ASCENDING = [
    200,
    400,
    1100
];
module.exports.default = $c9f4be2ea7285fff$var$SimulcastTransceiverController;

});
parcelRegister("itul0", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $d73277e086005eaf$var$videoLayersAllocationUrl = 'http://www.webrtc.org/experiments/rtp-hdrext/video-layers-allocation00';
const $d73277e086005eaf$var$dependencyDescriptorUrl = 'https://aomediacodec.github.io/av1-rtp-spec/#dependency-descriptor-rtp-header-extension';
class $d73277e086005eaf$var$DefaultTransceiverController {
    constructor(logger, browserBehavior, meetingSessionContext, encodedTransformWorkerManager){
        this.logger = logger;
        this.browserBehavior = browserBehavior;
        this.meetingSessionContext = meetingSessionContext;
        this.encodedTransformWorkerManager = encodedTransformWorkerManager;
        this._localCameraTransceiver = null;
        this._localAudioTransceiver = null;
        this.videoSubscriptions = [];
        this.defaultMediaStream = null;
        this.peer = null;
        this.streamIdToTransceiver = new Map();
        this.groupIdToTransceiver = new Map();
        this.handleTrack = (event)=>{
            var _a;
            // @ts-ignore
            if (!event.receiver.transform) {
                // See note in `addTransceiver`, however the reason it seems to work is because no transform is applied at all.
                // For now this is okay, since we will have video frame render metrics.
                this.logger.info(`Applying video receiver transform to track ${event.track.id} not set after addTransceiver`);
                if (event.track.kind === 'video' && ((_a = this.encodedTransformWorkerManager) === null || _a === void 0 ? void 0 : _a.isEnabled())) this.encodedTransformWorkerManager.setupVideoReceiverTransform(event.receiver);
            }
        };
    }
    async setEncodingParameters(encodingParamMap) {
        if (!this._localCameraTransceiver || this._localCameraTransceiver.direction !== 'sendrecv') return;
        const sender = this._localCameraTransceiver.sender;
        if (!encodingParamMap || encodingParamMap.size === 0) return;
        const newEncodingParams = Array.from(encodingParamMap.values());
        const oldParam = sender.getParameters();
        if (!oldParam.encodings || oldParam.encodings.length === 0) oldParam.encodings = newEncodingParams;
        else {
            for (const existing of oldParam.encodings)for (const changed of newEncodingParams){
                if ((existing.rid || changed.rid) && existing.rid !== changed.rid) continue;
                // Explicitly copy mutable encoding parameters
                if (changed.active !== undefined) existing.active = changed.active;
                if (changed.maxBitrate !== undefined) existing.maxBitrate = changed.maxBitrate;
                if (changed.maxFramerate !== undefined) existing.maxFramerate = changed.maxFramerate;
                if (changed.scaleResolutionDownBy !== undefined) existing.scaleResolutionDownBy = changed.scaleResolutionDownBy;
                if (changed.priority !== undefined) existing.priority = changed.priority;
                if (changed.networkPriority !== undefined) existing.networkPriority = changed.networkPriority;
                // @ts-ignore
                if (changed.scalabilityMode !== undefined) // @ts-ignore
                existing.scalabilityMode = changed.scalabilityMode;
            }
        }
        await sender.setParameters(oldParam);
    }
    localAudioTransceiver() {
        return this._localAudioTransceiver;
    }
    localVideoTransceiver() {
        return this._localCameraTransceiver;
    }
    async setVideoSendingBitrateKbps(bitrateKbps) {
        if (!this._localCameraTransceiver || this._localCameraTransceiver.direction !== 'sendrecv') return;
        const sender = this._localCameraTransceiver.sender;
        if (!sender || bitrateKbps <= 0) return;
        const param = sender.getParameters();
        if (!param.encodings) param.encodings = [
            {}
        ];
        for (const encodeParam of param.encodings)encodeParam.maxBitrate = bitrateKbps * 1000;
        await sender.setParameters(param);
    }
    setPeer(peer) {
        this.peer = peer;
        this.peer.addEventListener('track', this.handleTrack);
    }
    reset() {
        this._localCameraTransceiver = null;
        this._localAudioTransceiver = null;
        this.videoSubscriptions = [];
        this.defaultMediaStream = null;
        if (this.peer) this.peer.removeEventListener('track', this.handleTrack);
        this.peer = null;
    }
    useTransceivers() {
        return !!this.peer && typeof this.peer.getTransceivers !== 'undefined';
    }
    hasVideoInput() {
        if (!this._localCameraTransceiver || this._localCameraTransceiver.direction !== 'sendrecv') return false;
        return true;
    }
    trackIsVideoInput(track) {
        if (!this._localCameraTransceiver) return false;
        return track === this._localCameraTransceiver.sender.track || track === this._localCameraTransceiver.receiver.track;
    }
    setupLocalTransceivers() {
        var _a, _b;
        if (!this.useTransceivers()) return;
        if (!this.defaultMediaStream && typeof MediaStream !== 'undefined') this.defaultMediaStream = new MediaStream();
        if (!this._localAudioTransceiver) {
            this._localAudioTransceiver = this.peer.addTransceiver('audio', {
                direction: 'inactive',
                streams: [
                    this.defaultMediaStream
                ]
            });
            if ((_a = this.encodedTransformWorkerManager) === null || _a === void 0 ? void 0 : _a.isEnabled()) {
                this.encodedTransformWorkerManager.setupAudioSenderTransform(this._localAudioTransceiver.sender);
                this.encodedTransformWorkerManager.setupAudioReceiverTransform(this._localAudioTransceiver.receiver);
            }
        }
        if (!this._localCameraTransceiver) {
            this._localCameraTransceiver = this.peer.addTransceiver('video', {
                direction: 'inactive',
                streams: [
                    this.defaultMediaStream
                ]
            });
            this.configureLocalCameraHeaderExtensions();
            if ((_b = this.encodedTransformWorkerManager) === null || _b === void 0 ? void 0 : _b.isEnabled()) this.encodedTransformWorkerManager.setupVideoSenderTransform(this._localCameraTransceiver.sender);
        }
    }
    /**
     * Returns true if the peer connection supports the header extension negotiation
     * API (`getHeaderExtensionsToNegotiate` / `setHeaderExtensionsToNegotiate`),
     * which allows configuring RTP header extensions without SDP munging.
     */ static canUseHeaderExtensionApi(peer) {
        var _a;
        const transceivers = (_a = peer.getTransceivers) === null || _a === void 0 ? void 0 : _a.call(peer);
        if (!(transceivers === null || transceivers === void 0 ? void 0 : transceivers.length)) return false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const t = transceivers[0];
        return typeof t.getHeaderExtensionsToNegotiate === 'function' && typeof t.setHeaderExtensionsToNegotiate === 'function';
    }
    configureLocalCameraHeaderExtensions() {
        if (!$d73277e086005eaf$var$DefaultTransceiverController.canUseHeaderExtensionApi(this.peer)) return;
        const policy = this.meetingSessionContext ? this.meetingSessionContext.videoUplinkBandwidthPolicy : undefined;
        const wantsDependencyDescriptor = (policy === null || policy === void 0 ? void 0 : policy.wantsVideoDependencyDescriptorRtpHeaderExtension) !== undefined && policy.wantsVideoDependencyDescriptorRtpHeaderExtension();
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const t = this._localCameraTransceiver;
            const extensions = t.getHeaderExtensionsToNegotiate();
            let modified = false;
            for (const extension of extensions)if (extension.direction === 'stopped' && (extension.uri === $d73277e086005eaf$var$videoLayersAllocationUrl || wantsDependencyDescriptor && extension.uri === $d73277e086005eaf$var$dependencyDescriptorUrl)) {
                extension.direction = 'sendrecv';
                modified = true;
            }
            if (modified) t.setHeaderExtensionsToNegotiate(extensions);
        } catch (e) {
            this.logger.warn(`Failed to configure video header extensions: ${e.message}`);
        }
    }
    async replaceAudioTrack(track) {
        if (!this._localAudioTransceiver || this._localAudioTransceiver.direction !== 'sendrecv') {
            this.logger.info(`audio transceiver direction is not set up or not activated`);
            return false;
        }
        await this._localAudioTransceiver.sender.replaceTrack(track);
        return true;
    }
    async setAudioInput(track) {
        await this.setTransceiverInput(this._localAudioTransceiver, track);
        return;
    }
    async setVideoInput(track) {
        await this.setTransceiverInput(this._localCameraTransceiver, track);
        return;
    }
    updateVideoTransceivers(videoStreamIndex, videosToReceive) {
        if (!this.useTransceivers()) return videosToReceive.array();
        // See https://blog.mozilla.org/webrtc/rtcrtptransceiver-explored/ for details on transceivers
        const transceivers = this.peer.getTransceivers();
        // Subscription index 0 is reserved for transmitting camera.
        // We mark inactive slots with 0 in the subscription array.
        this.videoSubscriptions = [
            0
        ];
        videosToReceive = videosToReceive.clone();
        this.updateTransceivers(transceivers, videoStreamIndex, videosToReceive);
        this.logger.debug(()=>{
            return this.debugDumpTransceivers();
        });
        return this.videoSubscriptions;
    }
    updateTransceivers(transceivers, videoStreamIndex, videosToReceive) {
        const videosRemaining = videosToReceive.array();
        if (transceivers.length !== 0 && !transceivers[0].stop) {
            // This function and its usage can be removed once we raise Chrome browser requirements
            // to M88 (when `RTCRtpTransceiver.stop` was added)
            this.logger.info('Updating transceivers without `stop` function');
            this.updateTransceiverWithoutStop(transceivers, videoStreamIndex, videosRemaining);
        } else if (transceivers.length !== 0) this.updateTransceiverWithStop(transceivers, videoStreamIndex, videosRemaining);
        // Add transceivers for the remaining subscriptions
        for (const index of videosRemaining){
            // @ts-ignore
            const transceiver = this.peer.addTransceiver('video', {
                direction: 'recvonly',
                streams: [
                    new MediaStream()
                ]
            });
            this.streamIdToTransceiver.set(index, transceiver);
            this.groupIdToTransceiver.set(videoStreamIndex.groupIdForStreamId(index), transceiver);
            this.videoSubscriptions.push(index);
            this.logger.info(`adding transceiver mid: ${transceiver.mid} subscription: ${index} direction: recvonly`);
        }
    }
    updateTransceiverWithStop(transceivers, videoStreamIndex, videosRemaining) {
        // Begin counting out index in the the subscription array at 1 since the camera.
        // Always occupies position 0 (whether active or not).
        let n = 1;
        // Reset since otherwise there will be stale indexes corresponding to
        // stopped transceivers.
        this.videoSubscriptions = [
            0
        ];
        for (const transceiver of transceivers){
            if (transceiver === this._localCameraTransceiver || !this.transceiverIsVideo(transceiver) || !transceiver.mid) continue;
            let reusingTranceiver = false;
            // See if we want this existing transceiver for a simulcast stream switch
            //
            // By convention with the service backend, msid is equal to the media section mid, prefixed with the string "v_";
            // we use this to get the stream ID for the track
            const streamId = videoStreamIndex.streamIdForTrack('v_' + transceiver.mid);
            if (transceiver.direction !== 'inactive' && streamId !== undefined) {
                for (const [index, recvStreamId] of videosRemaining.entries())// `streamId` may still be the same as `recvStreamId`
                if (videoStreamIndex.StreamIdsInSameGroup(streamId, recvStreamId)) {
                    transceiver.direction = 'recvonly';
                    this.videoSubscriptions[n] = recvStreamId;
                    reusingTranceiver = true;
                    this.streamIdToTransceiver.delete(streamId);
                    this.streamIdToTransceiver.set(recvStreamId, transceiver);
                    videosRemaining.splice(index, 1);
                    break;
                }
            }
            if (!reusingTranceiver) {
                this.videoSubscriptions[n] = 0;
                this.logger.info(`Stopping MID: ${transceiver.mid}, direction: ${transceiver.direction}, current direction: ${transceiver.currentDirection}`);
                // Clean up transceiver and mappings for streams that have been unsubscribed from.  Note we do not try to reuse
                // old inactive transceivers for new streams as Firefox will reuse the last frame from
                // that transceiver, and additionally we simply don't want to risk wiring up a transceiver
                // to the incorrect video stream for no real benefit besides possible a smaller SDP size.
                transceiver.stop(); // Note (as of Firefox 94): Firefox will keep these around forever
                for (const [streamId, previousTransceiver] of this.streamIdToTransceiver.entries())if (transceiver.mid === previousTransceiver.mid) {
                    this.streamIdToTransceiver.delete(streamId);
                    this.groupIdToTransceiver.delete(videoStreamIndex.groupIdForStreamId(streamId));
                }
            }
            n += 1;
        }
    }
    // This function operates similarily to `updateTransceiverWithStop` with the following changes to account
    // for the fact RTCRtpTransceiver.stop is not available on all supported browsers:
    //  * We attempt to reuse inactive transceivers because libwebrtc will not remove them otherwise and
    //    the SDP will grow endlessly.
    //  * We mark unsubscribed transceivers as 'inactive' so that they can be reused. This requires using a
    //    second for loop.
    updateTransceiverWithoutStop(transceivers, videoStreamIndex, videosRemaining) {
        let n = 1;
        for (const transceiver of transceivers){
            if (transceiver === this._localCameraTransceiver || !this.transceiverIsVideo(transceiver)) continue;
            this.videoSubscriptions[n] = 0;
            if (transceiver.direction !== 'inactive') {
                const streamId = videoStreamIndex.streamIdForTrack('v_' + transceiver.mid);
                if (streamId !== undefined) {
                    for (const [index, recvStreamId] of videosRemaining.entries())if (videoStreamIndex.StreamIdsInSameGroup(streamId, recvStreamId)) {
                        transceiver.direction = 'recvonly';
                        this.videoSubscriptions[n] = recvStreamId;
                        this.streamIdToTransceiver.delete(streamId);
                        this.streamIdToTransceiver.set(recvStreamId, transceiver);
                        videosRemaining.splice(index, 1);
                        break;
                    }
                }
            }
            n += 1;
        }
        // Next fill in open slots and remove unused
        n = 1;
        for (const transceiver of transceivers){
            if (transceiver === this._localCameraTransceiver || !this.transceiverIsVideo(transceiver)) continue;
            if (transceiver.direction === 'inactive' && videosRemaining.length > 0) {
                // Fill available slot
                transceiver.direction = 'recvonly';
                const streamId = videosRemaining.shift();
                this.videoSubscriptions[n] = streamId;
                this.streamIdToTransceiver.set(streamId, transceiver);
                this.groupIdToTransceiver.set(videoStreamIndex.groupIdForStreamId(streamId), transceiver);
            } else // Remove if no longer subscribed
            if (this.videoSubscriptions[n] === 0) {
                transceiver.direction = 'inactive';
                for (const [streamId, previousTransceiver] of this.streamIdToTransceiver.entries())if (transceiver === previousTransceiver) {
                    this.streamIdToTransceiver.delete(streamId);
                    this.groupIdToTransceiver.delete(videoStreamIndex.groupIdForStreamId(streamId));
                }
            }
            n += 1;
        }
    }
    getMidForStreamId(streamId) {
        var _a;
        return (_a = this.streamIdToTransceiver.get(streamId)) === null || _a === void 0 ? void 0 : _a.mid;
    }
    setStreamIdForMid(mid, newStreamId) {
        for (const [streamId, transceiver] of this.streamIdToTransceiver.entries())if (transceiver.mid === mid) {
            this.streamIdToTransceiver.delete(streamId);
            this.streamIdToTransceiver.set(newStreamId, transceiver);
            return;
        }
    }
    getMidForGroupId(groupId) {
        var _a, _b;
        return (_b = (_a = this.groupIdToTransceiver.get(groupId)) === null || _a === void 0 ? void 0 : _a.mid) !== null && _b !== void 0 ? _b : undefined;
    }
    transceiverIsVideo(transceiver) {
        return transceiver.receiver && transceiver.receiver.track && transceiver.receiver.track.kind === 'video' || transceiver.sender && transceiver.sender.track && transceiver.sender.track.kind === 'video';
    }
    debugDumpTransceivers() {
        let msg = '';
        let n = 0;
        for (const transceiver of this.peer.getTransceivers()){
            if (!this.transceiverIsVideo(transceiver)) continue;
            msg += `transceiver index=${n} mid=${transceiver.mid} subscription=${this.videoSubscriptions[n]} direction=${transceiver.direction}\n`;
            n += 1;
        }
        return msg;
    }
    async setTransceiverInput(transceiver, track) {
        if (!transceiver) return;
        if (track) transceiver.direction = 'sendrecv';
        else transceiver.direction = 'inactive';
        await transceiver.sender.replaceTrack(track);
    }
    /**
     * @deprecated This method is deprecated and should not be used.
     * Access the encodedTransformWorkerManager directly via the meeting session context instead.
     */ setAudioPayloadTypes(_payloadTypeMap) {
        this.logger.error('setAudioPayloadTypes is deprecated. Access encodedTransformWorkerManager directly via meeting session context.');
    }
    /**
     * @deprecated This method is deprecated and should not be used.
     * Access the encodedTransformWorkerManager directly via the meeting session context instead.
     */ addRedundantAudioRecoveryMetricsObserver(_observer) {
        this.logger.error('addRedundantAudioRecoveryMetricsObserver is deprecated. Access encodedTransformWorkerManager directly via meeting session context.');
    }
    /**
     * @deprecated This method is deprecated and should not be used.
     * Access the encodedTransformWorkerManager directly via the meeting session context instead.
     */ removeRedundantAudioRecoveryMetricsObserver(_observer) {
        this.logger.error('removeRedundantAudioRecoveryMetricsObserver is deprecated. Access encodedTransformWorkerManager directly via meeting session context.');
    }
}
module.exports.default = $d73277e086005eaf$var$DefaultTransceiverController;

});





parcelRegister("lVjeU", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $ff5dd8690d98103c$var$DefaultDevicePixelRatioMonitor {
    constructor(devicePixelRatioSource, logger){
        this.devicePixelRatioSource = devicePixelRatioSource;
        this.observerQueue = new Set();
        this.mediaQueryListener = ()=>{
            this.observerQueue.forEach((tileObserver)=>{
                tileObserver.devicePixelRatioChanged(this.devicePixelRatioSource.devicePixelRatio());
            });
        };
        if (typeof window === 'undefined') return;
        const mediaQueryList = matchMedia(`(resolution: ${this.devicePixelRatioSource.devicePixelRatio()}dppx)`);
        if (typeof mediaQueryList.addEventListener === 'function') {
            mediaQueryList.addEventListener('change', this.mediaQueryListener);
            this.mediaQueryList = mediaQueryList;
        } else if (typeof mediaQueryList.addListener === 'function') {
            mediaQueryList.addListener(this.mediaQueryListener);
            this.mediaQueryList = mediaQueryList;
        } else logger.warn('ignoring DefaultDevicePixelRatioMonitor');
    }
    async destroy() {
        if (this.mediaQueryList) {
            if (typeof this.mediaQueryList.addEventListener === 'function') this.mediaQueryList.removeEventListener('change', this.mediaQueryListener);
            else this.mediaQueryList.removeListener(this.mediaQueryListener);
        }
        delete this.mediaQueryListener;
        this.observerQueue.clear();
    }
    registerObserver(observer) {
        this.observerQueue.add(observer);
        observer.devicePixelRatioChanged(this.devicePixelRatioSource.devicePixelRatio());
    }
    removeObserver(observer) {
        this.observerQueue.delete(observer);
    }
}
module.exports.default = $ff5dd8690d98103c$var$DefaultDevicePixelRatioMonitor;

});

parcelRegister("6CgU1", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $4d13672f273456c9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8iaF3 = parcelRequire("8iaF3");

const $4d13672f273456c9$var$EncodedTransformWorkerCode_1 = $4d13672f273456c9$var$__importDefault((parcelRequire("iQyKr")));

const $4d13672f273456c9$var$MediaMetricsEncodedTransformManager_1 = $4d13672f273456c9$var$__importDefault((parcelRequire("kGlN2")));

const $4d13672f273456c9$var$RedundantAudioEncodedTransformManager_1 = $4d13672f273456c9$var$__importDefault((parcelRequire("1H5d7")));
/**
 * Default implementation of EncodedTransformWorkerManager.
 * Manages a dedicated Web Worker and coordinates individual transform managers.
 */ class $4d13672f273456c9$var$DefaultEncodedTransformWorkerManager {
    constructor(logger){
        this.worker = null;
        this.workerURL = null;
        this.observers = new Set();
        this.disabled = false;
        this.disabledTransforms = {};
        this.redManager = null;
        this.metricsManager = null;
        // @ts-ignore
        this.supportsRTCScriptTransform = !!window.RTCRtpScriptTransform;
        // @ts-ignore
        this.supportsInsertableStreams = // @ts-ignore
        !!RTCRtpSender.prototype.createEncodedStreams;
        this.logger = logger;
        this.logger.info(`[EncodedTransform] API support - RTCRtpScriptTransform: ${this.supportsRTCScriptTransform}, createEncodedStreams: ${this.supportsInsertableStreams}`);
        if (!this.supportsRTCScriptTransform && !this.supportsInsertableStreams) this.disabled = true;
    }
    /**
     * Check if media transforms are enabled
     */ isEnabled() {
        return !this.disabled;
    }
    async start(disabledTransforms) {
        this.disabledTransforms = disabledTransforms || {};
        const worker = await this.createWorker();
        // Create transform managers based on disabled configuration
        if (!(disabledTransforms === null || disabledTransforms === void 0 ? void 0 : disabledTransforms.redundantAudio)) {
            this.redManager = new $4d13672f273456c9$var$RedundantAudioEncodedTransformManager_1.default(worker, this.logger);
            await this.redManager.start();
        }
        this.metricsManager = new $4d13672f273456c9$var$MediaMetricsEncodedTransformManager_1.default(worker, this.logger);
        await this.metricsManager.start();
        this.logger.info('DefaultEncodedTransformManager initialized');
    }
    redundantAudioEncodeTransformManager() {
        return this.redManager || undefined;
    }
    metricsTransformManager() {
        return this.metricsManager || undefined;
    }
    setupAudioSenderTransform(sender) {
        this.setupTransform(sender, 'send', 'audio');
    }
    setupAudioReceiverTransform(receiver) {
        this.setupTransform(receiver, 'receive', 'audio');
    }
    setupVideoSenderTransform(sender) {
        this.setupTransform(sender, 'send', 'video');
    }
    setupVideoReceiverTransform(receiver) {
        this.setupTransform(receiver, 'receive', 'video');
    }
    /**
     * Helper to set up transform on sender or receiver
     */ setupTransform(senderOrReceiver, operation, mediaType) {
        if (operation === 'send' && !(senderOrReceiver instanceof RTCRtpSender)) throw new Error('Operation "send" requires an RTCRtpSender');
        if (operation === 'receive' && !(senderOrReceiver instanceof RTCRtpReceiver)) throw new Error('Operation "receive" requires an RTCRtpReceiver');
        if (!this.worker) throw new Error('Worker not initialized');
        const options = {
            operation: operation,
            mediaType: mediaType,
            disabledTransforms: this.disabledTransforms
        };
        if (this.supportsRTCScriptTransform) // @ts-ignore
        senderOrReceiver.transform = new RTCRtpScriptTransform(this.worker, options);
        else if (this.supportsInsertableStreams) {
            // @ts-ignore - Legacy API
            const streams = senderOrReceiver.createEncodedStreams();
            this.worker.postMessage({
                msgType: 'StartEncodedTransformWorker',
                options: options,
                [mediaType]: {
                    [operation]: streams
                }
            }, [
                streams.readable,
                streams.writable
            ]);
        }
    }
    /**
     * Stop all transform managers and release resources
     */ async stop() {
        var _a, _b;
        await ((_a = this.redManager) === null || _a === void 0 ? void 0 : _a.stop());
        await ((_b = this.metricsManager) === null || _b === void 0 ? void 0 : _b.stop());
        if (this.redManager) this.redManager = null;
        if (this.metricsManager) this.metricsManager = null;
        if (this.worker) {
            this.worker.terminate();
            this.worker = null;
        }
        if (this.workerURL) {
            URL.revokeObjectURL(this.workerURL);
            this.workerURL = null;
        }
        this.logger.info('DefaultEncodedTransformManager stopped');
    }
    /**
     * Add an observer to receive transform manager events
     */ addObserver(observer) {
        this.observers.add(observer);
    }
    /**
     * Remove an observer
     */ removeObserver(observer) {
        this.observers.delete(observer);
    }
    handleWorkerMessage(event) {
        var _a, _b, _c;
        const message = event.data;
        if (message.type === $8iaF3.COMMON_MESSAGE_TYPES.LOG) {
            this.logger.info(`[${message.transformName}] ${(_a = message.message) === null || _a === void 0 ? void 0 : _a.text}`);
            return;
        }
        // Route message to interested transform managers based on transform field
        if ((_b = this.redManager) === null || _b === void 0 ? void 0 : _b.transformNames().includes(message.transformName)) this.redManager.handleWorkerMessage(message);
        if ((_c = this.metricsManager) === null || _c === void 0 ? void 0 : _c.transformNames().includes(message.transformName)) this.metricsManager.handleWorkerMessage(message);
    }
    /**
     * Handle errors from the Web Worker
     * Disables transforms and notifies observers
     */ handleWorkerError(error) {
        this.logger.error(`Web Worker error: ${error.message} at ${error.filename}:${error.lineno}:${error.colno}`);
        this.disable();
        const errorObj = new Error(`Web Worker error: ${error.message}`);
        for (const observer of this.observers)try {
            observer.onEncodedTransformWorkerManagerFailed(errorObj);
        } catch (e) {
            this.logger.error(`Error notifying observer: ${e}`);
        }
    }
    /**
     * Create a new Web Worker instance
     */ async createWorker() {
        try {
            this.workerURL = URL.createObjectURL(new Blob([
                $4d13672f273456c9$var$EncodedTransformWorkerCode_1.default
            ], {
                type: 'application/javascript'
            }));
            this.worker = new Worker(this.workerURL);
            this.worker.onmessage = this.handleWorkerMessage.bind(this);
            this.worker.onerror = this.handleWorkerError.bind(this);
            this.logger.info('Web Worker created');
            return this.worker;
        } catch (error) {
            this.logger.error(`Failed to create Web Worker: ${error}`);
            this.disable();
            if (this.workerURL) {
                URL.revokeObjectURL(this.workerURL);
                this.workerURL = null;
            }
            // Rethrow - initialization failure should be handled by caller
            throw error;
        }
    }
    /**
     * Disable media transforms
     */ async disable() {
        this.disabled = true;
        this.logger.info('Media transforms disabled');
        // Cleanup anything that may have been initialized
        await this.stop();
    }
}
module.exports.default = $4d13672f273456c9$var$DefaultEncodedTransformWorkerManager;

});
parcelRegister("8iaF3", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.COMMON_MESSAGE_TYPES = module.exports.TRANSFORM_NAMES = void 0;
/**
 * Transform name constants to ensure consistency between worker and manager.
 */ module.exports.TRANSFORM_NAMES = {
    REDUNDANT_AUDIO: 'AudioRed',
    AUDIO_SENDER: 'AudioSender',
    AUDIO_RECEIVER: 'AudioReceiver',
    VIDEO_SENDER: 'VideoSender',
    VIDEO_RECEIVER: 'VideoReceiver'
};
/**
 * Common message types used by all transforms.
 */ module.exports.COMMON_MESSAGE_TYPES = {
    LOG: 'Log',
    METRICS: 'Metrics'
};
/**
 * Abstract base class for WebRTC encoded media transforms running in a Web Worker.
 * Provides logging infrastructure and message handling for transform implementations.
 */ class $60984646b0d2a6e5$var$EncodedTransform {
    constructor(){
        this.shouldLog = true;
    }
    transformName() {
        return this.constructor.name;
    }
    /**
     * Handles configuration messages from the main thread. Override in subclasses.
     */ handleMessage(_message) {
    // Default: no-op
    }
    log(message) {
        if (!this.shouldLog) return;
        self.postMessage({
            type: module.exports.COMMON_MESSAGE_TYPES.LOG,
            transformName: this.transformName(),
            message: {
                text: message
            }
        });
    }
}
module.exports.default = $60984646b0d2a6e5$var$EncodedTransform;

});

parcelRegister("iQyKr", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * This file was generated with the `generate-media-transform-worker-code.js` script.
 *
 * The worker code is bundled inline (all classes concatenated) because Web Workers
 * run in isolation and cannot use module imports from the main thread.
 */ /**
 * Encoded transform worker code string.
 */ // eslint-disable-next-line
const $db88099007947cfe$var$EncodedTransformWorkerCode = "// Bundled media transform worker code\n\"use strict\";\n\n// === EncodedTransform.js ===\n// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.\n// SPDX-License-Identifier: Apache-2.0\n/**\n * Transform name constants to ensure consistency between worker and manager.\n */\nconst TRANSFORM_NAMES = {\n    REDUNDANT_AUDIO: 'AudioRed',\n    AUDIO_SENDER: 'AudioSender',\n    AUDIO_RECEIVER: 'AudioReceiver',\n    VIDEO_SENDER: 'VideoSender',\n    VIDEO_RECEIVER: 'VideoReceiver',\n};\n/**\n * Common message types used by all transforms.\n */\nconst COMMON_MESSAGE_TYPES = {\n    LOG: 'Log',\n    METRICS: 'Metrics',\n};\n/**\n * Abstract base class for WebRTC encoded media transforms running in a Web Worker.\n * Provides logging infrastructure and message handling for transform implementations.\n */\nclass EncodedTransform {\n    constructor() {\n        this.shouldLog = true;\n    }\n    transformName() {\n        return this.constructor.name;\n    }\n    /**\n     * Handles configuration messages from the main thread. Override in subclasses.\n     */\n    handleMessage(_message) {\n        // Default: no-op\n    }\n    log(message) {\n        if (!this.shouldLog)\n            return;\n        self.postMessage({\n            type: COMMON_MESSAGE_TYPES.LOG,\n            transformName: this.transformName(),\n            message: { text: message },\n        });\n    }\n}\n//# sourceMappingURL=EncodedTransform.js.map\n\n// === RedundantAudioEncodedTransform.js ===\n// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.\n// SPDX-License-Identifier: Apache-2.0\n/**\n * Message types specific to RedundantAudio transform.\n */\nconst REDUNDANT_AUDIO_MESSAGE_TYPES = {\n    OPUS_PAYLOAD_TYPE: 'OpusPayloadType',\n    RED_PAYLOAD_TYPE: 'RedPayloadType',\n    UPDATE_NUM_REDUNDANT_ENCODINGS: 'UpdateNumRedundantEncodings',\n    ENABLE: 'Enable',\n    DISABLE: 'Disable',\n};\n/**\n * Implements RFC 2198 RED (Redundant Audio Data) encoding/decoding for Opus audio.\n *\n * Sender: Encodes primary + redundant payloads to recover from packet loss.\n * Receiver: Logs packets for loss/recovery statistics (does not decode RED).\n *\n * Dynamically adjusts redundancy level (0-2 encodings) based on packet loss.\n * Supports Opus FEC detection for recovery metrics calculation.\n */\nclass RedundantAudioEncodedTransform extends EncodedTransform {\n    constructor() {\n        super();\n        // Each payload must be less than 1024 bytes to fit the 10 bit block length\n        this.maxRedPacketSizeBytes = 1 << 10;\n        // Limit payload to 1000 bytes to handle small MTU. 1000 is chosen because in Chromium-based browsers, writing audio\n        // payloads larger than 1000 bytes using the WebRTC Insertable Streams API (which is used to enable dynamic audio\n        // redundancy) will cause an error to be thrown and cause audio flow to permanently stop. See\n        // https://crbug.com/1248479.\n        this.maxAudioPayloadSizeBytes = 1000;\n        // Each payload can encode a timestamp delta of 14 bits\n        this.maxRedTimestampOffset = 1 << 14;\n        // 4 byte RED header\n        this.redHeaderSizeBytes = 4;\n        // reduced size for last RED header\n        this.redLastHeaderSizeBytes = 1;\n        // P-Time for Opus 20 msec packets\n        // We do not support other p-times or clock rates\n        this.redPacketizationTime = 960;\n        // distance between redundant payloads, Opus FEC handles a distance of 1\n        this.redPacketDistance = 2;\n        // maximum number of redundant payloads per RTP packet\n        this.maxRedEncodings = 2;\n        // Maximum number of encodings that can be recovered with a single RED packet, assuming the primary and redundant\n        // payloads have FEC.\n        this.redMaxRecoveryDistance = this.redPacketDistance * this.maxRedEncodings + 1;\n        // maximum history of prior payloads to keep\n        // generally we will expire old entries based on timestamp\n        // this limit is in place just to make sure the history does not\n        // grow too large in the case of erroneous timestamp inputs\n        this.maxEncodingHistorySize = 10;\n        // Current number of encodings we want to send\n        // to the remote end. This will be dynamically\n        // updated through the setNumEncodingsFromPacketloss API\n        this.numRedundantEncodings = 0;\n        // Used to enable or disable redundancy\n        // in response to very high packet loss events\n        this.redundancyEnabled = true;\n        // Loss stats reported every 5 seconds (48000 samples/sec * 5 sec)\n        this.lossReportInterval = 48000 * 5;\n        this.maxOutOfOrderPacketDistance = 16;\n        /**\n         * Below are Opus helper methods and constants.\n         */\n        this.OPUS_BAD_ARG = -1;\n        this.OPUS_INVALID_PACKET = -4;\n        // Max number of Opus frames in an Opus packet is 48 (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.5).\n        this.OPUS_MAX_OPUS_FRAMES = 48;\n        // Max number of bytes that any individual Opus frame can have.\n        this.OPUS_MAX_FRAME_SIZE_BYTES = 1275;\n        this.encodingHistory = new Array();\n        this.opusPayloadType = 0;\n        this.redPayloadType = 0;\n        this.initializePacketLogs();\n    }\n    /**\n     * Handle configuration messages from main thread\n     */\n    handleMessage(message) {\n        var _a, _b, _c;\n        try {\n            const msgType = message.type;\n            switch (msgType) {\n                case REDUNDANT_AUDIO_MESSAGE_TYPES.RED_PAYLOAD_TYPE:\n                    this.setRedPayloadType(parseInt(((_a = message.message) === null || _a === void 0 ? void 0 : _a.payloadType) || '0', 10));\n                    break;\n                case REDUNDANT_AUDIO_MESSAGE_TYPES.OPUS_PAYLOAD_TYPE:\n                    this.setOpusPayloadType(parseInt(((_b = message.message) === null || _b === void 0 ? void 0 : _b.payloadType) || '0', 10));\n                    break;\n                case REDUNDANT_AUDIO_MESSAGE_TYPES.UPDATE_NUM_REDUNDANT_ENCODINGS:\n                    this.setNumRedundantEncodings(parseInt(((_c = message.message) === null || _c === void 0 ? void 0 : _c.numRedundantEncodings) || '0', 10));\n                    break;\n                case REDUNDANT_AUDIO_MESSAGE_TYPES.ENABLE:\n                    this.setRedundancyEnabled(true);\n                    break;\n                case REDUNDANT_AUDIO_MESSAGE_TYPES.DISABLE:\n                    this.setRedundancyEnabled(false);\n                    break;\n            }\n        }\n        catch (e) {\n            this.log(`Failed to handle message: ${e}`);\n        }\n    }\n    /** Not used directly - use senderTransform or receivePacketLogTransform. */\n    transform(_frame, _controller) {\n        // Not used - use senderTransform or receivePacketLogTransform\n    }\n    transformName() {\n        return TRANSFORM_NAMES.REDUNDANT_AUDIO;\n    }\n    /**\n     * Set the RED payload type ideally obtained from local offer.\n     */\n    setRedPayloadType(payloadType) {\n        this.redPayloadType = payloadType;\n        this.log(`red payload type set to ${this.redPayloadType}`);\n    }\n    /**\n     * Set the opus payload type ideally obtained from local offer.\n     */\n    setOpusPayloadType(payloadType) {\n        this.opusPayloadType = payloadType;\n        this.log(`opus payload type set to ${this.opusPayloadType}`);\n    }\n    /**\n     * Set the number of redundant encodings\n     */\n    setNumRedundantEncodings(numRedundantEncodings) {\n        this.numRedundantEncodings = numRedundantEncodings;\n        if (this.numRedundantEncodings > this.maxRedEncodings) {\n            this.numRedundantEncodings = this.maxRedEncodings;\n        }\n        this.log(`Updated numRedundantEncodings to ${this.numRedundantEncodings}`);\n    }\n    /**\n     * Enable or disable redundancy in response to\n     * high packet loss event.\n     */\n    setRedundancyEnabled(enabled) {\n        this.redundancyEnabled = enabled;\n        this.log(`redundancy ${this.redundancyEnabled ? 'enabled' : 'disabled'}`);\n    }\n    /**\n     * Helper function to only enqueue audio frames if they do not exceed the audio payload byte limit imposed by\n     * Chromium-based browsers. Chromium will throw an error (https://crbug.com/1248479) if an audio payload larger than\n     * 1000 bytes is enqueued. Any controller that attempts to enqueue an audio payload larger than 1000 bytes will\n     * encounter this error and will permanently stop sending or receiving audio.\n     */\n    enqueueAudioFrameIfPayloadSizeIsValid(frame, controller) {\n        if (frame.data.byteLength > this.maxAudioPayloadSizeBytes)\n            return;\n        controller.enqueue(frame);\n    }\n    /**\n     * Receives encoded frames and modifies as needed before sending to transport.\n     */\n    senderTransform(frame, controller) {\n        const frameMetadata = frame.getMetadata();\n        if (frameMetadata.payloadType !== this.redPayloadType) {\n            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n            return;\n        }\n        const primaryPayloadBuffer = this.getPrimaryPayload(frame.timestamp, frame.data);\n        if (!primaryPayloadBuffer) {\n            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n            return;\n        }\n        const encodedBuffer = this.encode(frame.timestamp, primaryPayloadBuffer);\n        /* istanbul ignore next */\n        if (!encodedBuffer) {\n            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n            return;\n        }\n        frame.data = encodedBuffer;\n        this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n        return;\n    }\n    /**\n     * Get the primary payload from encoding\n     */\n    getPrimaryPayload(primaryTimestamp, frame) {\n        const encodings = this.splitEncodings(primaryTimestamp, frame);\n        if (!encodings || encodings.length < 1)\n            return null;\n        return encodings[encodings.length - 1].payload;\n    }\n    /**\n     * Split up the encoding received into primary and redundant encodings\n     * These will be ordered oldest to newest which is the same ordering\n     * in the RTP red payload.\n     */\n    splitEncodings(primaryTimestamp, frame, getFecInfo = false, primarySequenceNumber = undefined) {\n        // process RED headers (according to RFC 2198)\n        //   0                   1                   2                   3\n        //   0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1\n        //  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+\n        //  |F|   block PT  |  timestamp offset         |   block length    |\n        //  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+\n        //\n        // last header\n        //   0 1 2 3 4 5 6 7\n        //  +-+-+-+-+-+-+-+-+\n        //  |0|   Block PT  |\n        //  +-+-+-+-+-+-+-+-+\n        const payload = new DataView(frame);\n        let payloadSizeBytes = payload.byteLength;\n        let totalPayloadSizeBytes = 0;\n        let totalHeaderSizeBytes = 0;\n        let primaryPayloadSizeBytes = 0;\n        let payloadOffset = 0;\n        let gotLastBlock = false;\n        const encodings = new Array();\n        const redundantEncodingBlockLengths = new Array();\n        const redundantEncodingTimestamps = new Array();\n        while (payloadSizeBytes > 0) {\n            gotLastBlock = (payload.getUint8(payloadOffset) & 0x80) === 0;\n            if (gotLastBlock) {\n                // Bits 1 through 7 are payload type\n                const payloadType = payload.getUint8(payloadOffset) & 0x7f;\n                // Unexpected payload type. This is a bad packet.\n                if (payloadType !== this.opusPayloadType) {\n                    return null;\n                }\n                totalPayloadSizeBytes += this.redLastHeaderSizeBytes;\n                totalHeaderSizeBytes += this.redLastHeaderSizeBytes;\n                // Accumulated block lengths are equal to or larger than the buffer, which means there is no primary block. This\n                // is a bad packet.\n                if (totalPayloadSizeBytes >= payload.byteLength) {\n                    return null;\n                }\n                primaryPayloadSizeBytes = payload.byteLength - totalPayloadSizeBytes;\n                break;\n            }\n            else {\n                if (payloadSizeBytes < this.redHeaderSizeBytes) {\n                    return null;\n                }\n                // Bits 22 through 31 are payload length\n                const blockLength = ((payload.getUint8(payloadOffset + 2) & 0x03) << 8) + payload.getUint8(payloadOffset + 3);\n                redundantEncodingBlockLengths.push(blockLength);\n                const timestampOffset = payload.getUint16(payloadOffset + 1) >> 2;\n                const timestamp = primaryTimestamp - timestampOffset;\n                redundantEncodingTimestamps.push(timestamp);\n                totalPayloadSizeBytes += blockLength + this.redHeaderSizeBytes;\n                totalHeaderSizeBytes += this.redHeaderSizeBytes;\n                payloadOffset += this.redHeaderSizeBytes;\n                payloadSizeBytes -= this.redHeaderSizeBytes;\n            }\n        }\n        // The last block was never found. The packet we received\n        // does not have a good RED payload.\n        if (!gotLastBlock) {\n            // Note that sequence numbers only exist for\n            // incoming audio frames.\n            if (primarySequenceNumber !== undefined) {\n                // This could be a possible padding packet used\n                // for BWE with a good sequence number.\n                // Create a dummy encoding to make sure loss values\n                // are calculated correctly by consuming sequence number.\n                // Note that for the receive side, we process packets only\n                // for loss/recovery calculations and forward the original\n                // packet without changing it even in the error case.\n                encodings.push({\n                    payload: frame,\n                    isRedundant: false,\n                    seq: primarySequenceNumber,\n                });\n                return encodings;\n            }\n            // This is a bad packet.\n            return null;\n        }\n        let redundantPayloadOffset = totalHeaderSizeBytes;\n        for (let i = 0; i < redundantEncodingTimestamps.length; i++) {\n            const redundantPayloadBuffer = new ArrayBuffer(redundantEncodingBlockLengths[i]);\n            const redundantPayloadArray = new Uint8Array(redundantPayloadBuffer);\n            redundantPayloadArray.set(new Uint8Array(payload.buffer, redundantPayloadOffset, redundantEncodingBlockLengths[i]), 0);\n            const encoding = {\n                timestamp: redundantEncodingTimestamps[i],\n                payload: redundantPayloadBuffer,\n                isRedundant: true,\n            };\n            if (getFecInfo) {\n                encoding.hasFec = this.opusPacketHasFec(new DataView(redundantPayloadBuffer), redundantPayloadBuffer.byteLength);\n            }\n            encodings.push(encoding);\n            redundantPayloadOffset += redundantEncodingBlockLengths[i];\n        }\n        const primaryPayloadOffset = payload.byteLength - primaryPayloadSizeBytes;\n        const primaryPayloadBuffer = new ArrayBuffer(primaryPayloadSizeBytes);\n        const primaryArray = new Uint8Array(primaryPayloadBuffer);\n        primaryArray.set(new Uint8Array(payload.buffer, primaryPayloadOffset, primaryPayloadSizeBytes), 0);\n        const encoding = {\n            timestamp: primaryTimestamp,\n            payload: primaryPayloadBuffer,\n            isRedundant: false,\n            seq: primarySequenceNumber,\n        };\n        if (getFecInfo) {\n            encoding.hasFec = this.opusPacketHasFec(new DataView(primaryPayloadBuffer), primaryPayloadBuffer.byteLength);\n        }\n        encodings.push(encoding);\n        return encodings;\n    }\n    /**\n     * Create a new encoding with current primary payload and the older payloads of choice.\n     */\n    encode(primaryTimestamp, primaryPayload) {\n        const primaryPayloadSize = primaryPayload.byteLength;\n        // Payload size needs to be valid.\n        if (primaryPayloadSize === 0 ||\n            primaryPayloadSize >= this.maxRedPacketSizeBytes ||\n            primaryPayloadSize >= this.maxAudioPayloadSizeBytes) {\n            return null;\n        }\n        const numRedundantEncodings = this.numRedundantEncodings;\n        let headerSizeBytes = this.redLastHeaderSizeBytes;\n        let payloadSizeBytes = primaryPayloadSize;\n        let bytesAvailable = this.maxAudioPayloadSizeBytes - primaryPayloadSize - headerSizeBytes;\n        const redundantEncodingTimestamps = new Array();\n        const redundantEncodingPayloads = new Array();\n        // If redundancy is disabled then only send the primary payload\n        if (this.redundancyEnabled) {\n            // Determine how much redundancy we can fit into our packet\n            let redundantTimestamp = this.uint32WrapAround(primaryTimestamp - this.redPacketizationTime * this.redPacketDistance);\n            for (let i = 0; i < numRedundantEncodings; i++) {\n                // Do not add redundant encodings that are beyond the maximum timestamp offset.\n                if (this.uint32WrapAround(primaryTimestamp - redundantTimestamp) >= this.maxRedTimestampOffset) {\n                    break;\n                }\n                let findTimestamp = redundantTimestamp;\n                let encoding = this.encodingHistory.find(e => e.timestamp === findTimestamp);\n                if (!encoding) {\n                    // If not found or not important then look for the previous packet.\n                    // The current packet may have included FEC for the previous, so just\n                    // use the previous packet instead provided that it has voice activity.\n                    findTimestamp = this.uint32WrapAround(redundantTimestamp - this.redPacketizationTime);\n                    encoding = this.encodingHistory.find(e => e.timestamp === findTimestamp);\n                }\n                if (encoding) {\n                    const redundantEncodingSizeBytes = encoding.payload.byteLength;\n                    // Only add redundancy if there are enough bytes available.\n                    if (bytesAvailable < this.redHeaderSizeBytes + redundantEncodingSizeBytes)\n                        break;\n                    bytesAvailable -= this.redHeaderSizeBytes + redundantEncodingSizeBytes;\n                    headerSizeBytes += this.redHeaderSizeBytes;\n                    payloadSizeBytes += redundantEncodingSizeBytes;\n                    redundantEncodingTimestamps.unshift(encoding.timestamp);\n                    redundantEncodingPayloads.unshift(encoding.payload);\n                }\n                redundantTimestamp -= this.redPacketizationTime * this.redPacketDistance;\n                redundantTimestamp = this.uint32WrapAround(redundantTimestamp);\n            }\n        }\n        const redPayloadBuffer = new ArrayBuffer(headerSizeBytes + payloadSizeBytes);\n        const redPayloadView = new DataView(redPayloadBuffer);\n        // Add redundant encoding header(s) to new buffer\n        let redPayloadOffset = 0;\n        for (let i = 0; i < redundantEncodingTimestamps.length; i++) {\n            const timestampDelta = primaryTimestamp - redundantEncodingTimestamps[i];\n            redPayloadView.setUint8(redPayloadOffset, this.opusPayloadType | 0x80);\n            redPayloadView.setUint16(redPayloadOffset + 1, (timestampDelta << 2) | (redundantEncodingPayloads[i].byteLength >> 8));\n            redPayloadView.setUint8(redPayloadOffset + 3, redundantEncodingPayloads[i].byteLength & 0xff);\n            redPayloadOffset += this.redHeaderSizeBytes;\n        }\n        // Add primary encoding header to new buffer\n        redPayloadView.setUint8(redPayloadOffset, this.opusPayloadType);\n        redPayloadOffset += this.redLastHeaderSizeBytes;\n        // Add redundant payload(s) to new buffer\n        const redPayloadArray = new Uint8Array(redPayloadBuffer);\n        for (let i = 0; i < redundantEncodingPayloads.length; i++) {\n            redPayloadArray.set(new Uint8Array(redundantEncodingPayloads[i]), redPayloadOffset);\n            redPayloadOffset += redundantEncodingPayloads[i].byteLength;\n        }\n        // Add primary payload to new buffer\n        redPayloadArray.set(new Uint8Array(primaryPayload), redPayloadOffset);\n        redPayloadOffset += primaryPayload.byteLength;\n        /* istanbul ignore next */\n        // Sanity check that we got the expected total payload size.\n        if (redPayloadOffset !== headerSizeBytes + payloadSizeBytes)\n            return null;\n        this.updateEncodingHistory(primaryTimestamp, primaryPayload);\n        return redPayloadBuffer;\n    }\n    /** Maintains encoding history for redundancy, keeping only recent important packets. */\n    updateEncodingHistory(primaryTimestamp, primaryPayload) {\n        // Remove encodings from the history if they are too old.\n        for (const encoding of this.encodingHistory) {\n            const maxTimestampDelta = this.redPacketizationTime * this.redMaxRecoveryDistance;\n            if (primaryTimestamp - encoding.timestamp >= maxTimestampDelta) {\n                this.encodingHistory.shift();\n            }\n            else {\n                break;\n            }\n        }\n        // Only add an encoding to the history if the encoding is deemed to be important. An encoding is important if it is\n        // a CELT-only packet or contains voice activity.\n        const packet = new DataView(primaryPayload);\n        if (this.opusPacketIsCeltOnly(packet) ||\n            this.opusPacketHasVoiceActivity(packet, packet.byteLength) > 0) {\n            // Check if adding an encoding will cause the length of the encoding history to exceed the maximum history size.\n            // This is not expected to happen but could occur if we get incorrect timestamps. We want to make sure our memory\n            // usage is bounded. In this case, just clear the history and start over from empty.\n            if (this.encodingHistory.length + 1 > this.maxEncodingHistorySize)\n                this.encodingHistory.length = 0;\n            this.encodingHistory.push({ timestamp: primaryTimestamp, payload: primaryPayload });\n        }\n    }\n    /** Initializes packet logs and resets all metric counters. */\n    initializePacketLogs() {\n        // The extra space from the max RED recovery distance is to ensure that we do not incorrectly count recovery for\n        // packets that have already been received but are outside of the max out-of-order distance.\n        const packetLogSize = this.maxOutOfOrderPacketDistance + this.redMaxRecoveryDistance;\n        this.primaryPacketLog = {\n            window: new Array(packetLogSize),\n            index: 0,\n            windowSize: packetLogSize,\n        };\n        this.redRecoveryLog = {\n            window: new Array(packetLogSize),\n            index: 0,\n            windowSize: packetLogSize,\n        };\n        this.fecRecoveryLog = {\n            window: new Array(packetLogSize),\n            index: 0,\n            windowSize: packetLogSize,\n        };\n        this.totalAudioPacketsExpected = 0;\n        this.totalAudioPacketsLost = 0;\n        this.totalAudioPacketsRecoveredRed = 0;\n        this.totalAudioPacketsRecoveredFec = 0;\n        this.lastLossReportTimestamp = 0;\n    }\n    /** Receiver transform: logs packets for loss/recovery stats without modifying frames. */\n    receivePacketLogTransform(frame, controller) {\n        const frameMetadata = frame.getMetadata();\n        if (frameMetadata.payloadType !== this.redPayloadType) {\n            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n            return;\n        }\n        const encodings = this.splitEncodings(frame.timestamp, frame.data, \n        /*getFecInfo*/ true, frameMetadata.sequenceNumber);\n        if (!encodings) {\n            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n            return;\n        }\n        for (let i = encodings.length - 1; i >= 0; i--) {\n            if (this.updateLossStats(encodings[i])) {\n                this.updateRedStats(encodings[i]);\n                this.updateFecStats(encodings[i]);\n            }\n        }\n        this.maybeReportLossStats(frameMetadata.synchronizationSource, encodings[encodings.length - 1].timestamp);\n        this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n    }\n    /** Updates loss stats from primary packets. Returns false if packet is too old. */\n    updateLossStats(encoding) {\n        if (encoding.isRedundant)\n            return true;\n        const timestamp = encoding.timestamp;\n        const seq = encoding.seq;\n        if (this.totalAudioPacketsExpected === 0) {\n            this.totalAudioPacketsExpected = 1;\n            this.newestSequenceNumber = seq;\n            this.addTimestamp(this.primaryPacketLog, timestamp);\n            return true;\n        }\n        const diff = this.int16(seq - this.newestSequenceNumber);\n        if (diff < -this.maxOutOfOrderPacketDistance)\n            return false;\n        if (diff < 0) {\n            if (!this.hasTimestamp(this.primaryPacketLog, timestamp)) {\n                if (this.totalAudioPacketsLost > 0)\n                    this.totalAudioPacketsLost--;\n                this.addTimestamp(this.primaryPacketLog, timestamp);\n                this.removeFromRecoveryWindows(timestamp);\n            }\n        }\n        else if (diff > 1) {\n            this.totalAudioPacketsLost += diff - 1;\n        }\n        if (diff > 0) {\n            this.totalAudioPacketsExpected += diff;\n            this.newestSequenceNumber = encoding.seq;\n            this.addTimestamp(this.primaryPacketLog, timestamp);\n        }\n        return true;\n    }\n    /** Tracks RED recovery for packets not in primary log. */\n    updateRedStats(encoding) {\n        if (!encoding.isRedundant || this.totalAudioPacketsLost === 0)\n            return;\n        const timestamp = encoding.timestamp;\n        if (!this.hasTimestamp(this.primaryPacketLog, timestamp)) {\n            if (!this.hasTimestamp(this.redRecoveryLog, timestamp)) {\n                this.totalAudioPacketsRecoveredRed++;\n                this.addTimestamp(this.redRecoveryLog, timestamp);\n            }\n            if (this.removeTimestamp(this.fecRecoveryLog, timestamp)) {\n                /* istanbul ignore else */\n                if (this.totalAudioPacketsRecoveredFec > 0)\n                    this.totalAudioPacketsRecoveredFec--;\n            }\n        }\n    }\n    /** Tracks FEC recovery for packets not in primary or RED recovery logs. */\n    updateFecStats(encoding) {\n        if (!encoding.hasFec || this.totalAudioPacketsLost === 0)\n            return;\n        const fecTimestamp = encoding.timestamp - this.redPacketizationTime;\n        if (this.hasTimestamp(this.primaryPacketLog, fecTimestamp) ||\n            this.hasTimestamp(this.redRecoveryLog, fecTimestamp) ||\n            this.hasTimestamp(this.fecRecoveryLog, fecTimestamp)) {\n            return;\n        }\n        this.totalAudioPacketsRecoveredFec++;\n        this.addTimestamp(this.fecRecoveryLog, fecTimestamp);\n    }\n    /** Reports loss/recovery metrics to main thread at configured intervals. */\n    maybeReportLossStats(ssrc, timestamp) {\n        if (timestamp === undefined ||\n            timestamp - this.lastLossReportTimestamp < this.lossReportInterval)\n            return;\n        self.postMessage({\n            type: COMMON_MESSAGE_TYPES.METRICS,\n            transformName: TRANSFORM_NAMES.REDUNDANT_AUDIO,\n            message: {\n                ssrc: String(ssrc),\n                metrics: JSON.stringify({\n                    totalAudioPacketsLost: this.totalAudioPacketsLost,\n                    totalAudioPacketsExpected: this.totalAudioPacketsExpected,\n                    totalAudioPacketsRecoveredRed: this.totalAudioPacketsRecoveredRed,\n                    totalAudioPacketsRecoveredFec: this.totalAudioPacketsRecoveredFec,\n                }),\n            },\n        });\n        this.lastLossReportTimestamp = timestamp;\n    }\n    /** Adds a timestamp to a packet log's circular buffer. */\n    addTimestamp(packetLog, timestamp) {\n        if (timestamp === undefined) {\n            return;\n        }\n        packetLog.window[packetLog.index] = timestamp;\n        packetLog.index = (packetLog.index + 1) % packetLog.windowSize;\n    }\n    /** Checks if a timestamp exists in a packet log. */\n    hasTimestamp(packetLog, timestamp) {\n        const element = packetLog.window.find(t => t === timestamp);\n        return !!element;\n    }\n    /**\n     * Removes a timestamp from a packet log\n     *\n     * @param packetLog : The packetlog from which the timestamp should be removed\n     * @param timestamp : The timestamp to be removed\n     * @returns true if timestamp was present in the log and removed, false otherwise\n     */\n    removeTimestamp(packetLog, timestamp) {\n        const index = packetLog.window.indexOf(timestamp);\n        if (index >= 0) {\n            packetLog.window[index] = undefined;\n            return true;\n        }\n        return false;\n    }\n    /**\n     * Removes a timestamp from red and fec recovery windows.\n     *\n     * @param timestamp : The timestamp to be removed\n     */\n    removeFromRecoveryWindows(timestamp) {\n        let removed = this.removeTimestamp(this.redRecoveryLog, timestamp);\n        if (removed) {\n            if (this.totalAudioPacketsRecoveredRed > 0)\n                this.totalAudioPacketsRecoveredRed--;\n        }\n        removed = this.removeTimestamp(this.fecRecoveryLog, timestamp);\n        if (removed) {\n            if (this.totalAudioPacketsRecoveredFec > 0)\n                this.totalAudioPacketsRecoveredFec--;\n        }\n    }\n    /**\n     * Converts the supplied argument to 32-bit unsigned integer\n     */\n    uint32WrapAround(num) {\n        const mod = 4294967296; // 2^32\n        let res = num;\n        if (num >= mod) {\n            res = num - mod;\n        }\n        else if (num < 0) {\n            res = mod + num;\n        }\n        return res;\n    }\n    /**\n     * Converts the supplied argument to 16-bit signed integer\n     */\n    int16(num) {\n        return (num << 16) >> 16;\n    }\n    /**\n     * Determines if an Opus packet is in CELT-only mode.\n     *\n     * @param packet Opus packet.\n     * @returns `true` if the packet is in CELT-only mode.\n     */\n    opusPacketIsCeltOnly(packet) {\n        // TOC byte format (https://www.rfc-editor.org/rfc/rfc6716#section-3.1):\n        //  0\n        //  0 1 2 3 4 5 6 7\n        // +-+-+-+-+-+-+-+-+\n        // | config  |s| c |\n        // +-+-+-+-+-+-+-+-+\n        // Since CELT-only packets are represented using configurations 16 to 31, the highest 'config' bit will always be 1\n        // for CELT-only packets.\n        return !!(packet.getUint8(0) & 0x80);\n    }\n    /**\n     * Gets the number of samples per frame from an Opus packet.\n     *\n     * @param packet Opus packet. This must contain at least one byte of data.\n     * @param sampleRateHz 32-bit integer sampling rate in Hz. This must be a multiple of 400 or inaccurate results will\n     *                     be returned.\n     * @returns Number of samples per frame.\n     */\n    opusPacketGetSamplesPerFrame(packet, sampleRateHz) {\n        // Sample rate must be a 32-bit integer.\n        sampleRateHz = Math.round(sampleRateHz);\n        sampleRateHz = Math.min(Math.max(sampleRateHz, -(2 ** 32)), 2 ** 32 - 1);\n        // TOC byte format (https://www.rfc-editor.org/rfc/rfc6716#section-3.1):\n        //  0\n        //  0 1 2 3 4 5 6 7\n        // +-+-+-+-+-+-+-+-+\n        // | config  |s| c |\n        // +-+-+-+-+-+-+-+-+\n        let numSamples;\n        let frameSizeOption;\n        // Case for CELT-only packet.\n        if (this.opusPacketIsCeltOnly(packet)) {\n            // The lower 3 'config' bits indicate the frame size option.\n            frameSizeOption = (packet.getUint8(0) >> 3) & 0x3;\n            // The frame size options 0, 1, 2, 3 correspond to frame sizes of 2.5, 5, 10, 20 ms. Notice that the frame sizes\n            // can be represented as (2.5 * 2^0), (2.5 * 2^1), (2.5 * 2^2), (2.5 * 2^3) ms. So, the number of samples can be\n            // calculated as follows:\n            // (sample/s) * (1s/1000ms) * (2.5ms) * 2^(frameSizeOption)\n            // = (sample/s) * (1s/400) * 2^(frameSizeOption)\n            // = (sample/s) * 2^(frameSizeOption) * (1s/400)\n            numSamples = (sampleRateHz << frameSizeOption) / 400;\n        }\n        // Case for Hybrid packet. Since Hybrid packets are represented using configurations 12 to 15, bits 1 and 2 in the\n        // above TOC byte diagram will both be 1.\n        else if ((packet.getUint8(0) & 0x60) === 0x60) {\n            // In the case of configuration 13 or 15, bit 4 in the above TOC byte diagram will be 1. Configurations 13 and 15\n            // correspond to a 20ms frame size, so the number of samples is calculated as follows:\n            // (sample/s) * (1s/1000ms) * (20ms)\n            // = (sample/s) * (1s/50)\n            //\n            // In the case of configuration 12 or 14, bit 4 in the above TOC byte diagram will be 0. Configurations 12 and 14\n            // correspond to a 10ms frame size, so the number of samples is calculated as follows:\n            // (sample/s) * (1s/1000ms) * (10ms)\n            // = (sample/s) * (1s/100)\n            numSamples = packet.getUint8(0) & 0x08 ? sampleRateHz / 50 : sampleRateHz / 100;\n        }\n        // Case for SILK-only packet.\n        else {\n            // The lower 3 'config' bits indicate the frame size option for SILK-only packets.\n            frameSizeOption = (packet.getUint8(0) >> 3) & 0x3;\n            if (frameSizeOption === 3) {\n                // Frame size option 3 corresponds to a frame size of 60ms, so the number of samples is calculated as follows:\n                // (sample/s) * (1s/1000ms) * (60ms)\n                // = (sample/s) * (60ms) * (1s/1000ms)\n                numSamples = (sampleRateHz * 60) / 1000;\n            }\n            else {\n                // The frame size options 0, 1, 2 correspond to frame sizes of 10, 20, 40 ms. Notice that the frame sizes can be\n                // represented as (10 * 2^0), (10 * 2^1), (10 * 2^2) ms. So, the number of samples can be calculated as follows:\n                // (sample/s) * (1s/1000ms) * (10ms) * 2^(frameSizeOption)\n                // = (sample/s) * (1s/100) * 2^(frameSizeOption)\n                // = (sample/s) * 2^(frameSizeOption) * (1s/100)\n                numSamples = (sampleRateHz << frameSizeOption) / 100;\n            }\n        }\n        return numSamples;\n    }\n    /**\n     * Gets the number of SILK frames per Opus frame.\n     *\n     * @param packet Opus packet.\n     * @returns Number of SILK frames per Opus frame.\n     */\n    opusNumSilkFrames(packet) {\n        // For computing the frame length in ms, the sample rate is not important since it cancels out. We use 48 kHz, but\n        // any valid sample rate would work.\n        //\n        // To calculate the length of a frame (with a 48kHz sample rate) in ms:\n        // (samples/frame) * (1s/48000 samples) * (1000ms/s)\n        // = (samples/frame) * (1000ms/48000 samples)\n        // = (samples/frame) * (1ms/48 samples)\n        let frameLengthMs = this.opusPacketGetSamplesPerFrame(packet, 48000) / 48;\n        if (frameLengthMs < 10)\n            frameLengthMs = 10;\n        // The number of SILK frames per Opus frame is described in https://www.rfc-editor.org/rfc/rfc6716#section-4.2.2.\n        switch (frameLengthMs) {\n            case 10:\n            case 20:\n                return 1;\n            case 40:\n                return 2;\n            case 60:\n                return 3;\n            // It is not possible to reach the default case since an Opus packet can only encode sizes of 2.5, 5, 10, 20, 40,\n            // or 60 ms, so we ignore the default case for test coverage.\n            /* istanbul ignore next */\n            default:\n                return 0;\n        }\n    }\n    /**\n     * Gets the number of channels from an Opus packet.\n     *\n     * @param packet Opus packet.\n     * @returns Number of channels.\n     */\n    opusPacketGetNumChannels(packet) {\n        // TOC byte format (https://www.rfc-editor.org/rfc/rfc6716#section-3.1):\n        //  0\n        //  0 1 2 3 4 5 6 7\n        // +-+-+-+-+-+-+-+-+\n        // | config  |s| c |\n        // +-+-+-+-+-+-+-+-+\n        // The 's' bit indicates mono or stereo audio, with 0 indicating mono and 1 indicating stereo.\n        return packet.getUint8(0) & 0x4 ? 2 : 1;\n    }\n    /**\n     * Determine the size (in bytes) of an Opus frame.\n     *\n     * @param packet Opus packet.\n     * @param byteOffset Offset (from the start of the packet) to the byte containing the size information.\n     * @param remainingBytes Remaining number of bytes to parse from the Opus packet.\n     * @param sizeBytes Variable to store the parsed frame size (in bytes).\n     * @returns Number of bytes that were parsed to determine the frame size.\n     */\n    opusParseSize(packet, byteOffset, remainingBytes, sizeBytes) {\n        // See https://www.rfc-editor.org/rfc/rfc6716#section-3.2.1 for an explanation of how frame size is represented.\n        // If there are no remaining bytes to parse the size from, then the size cannot be determined.\n        if (remainingBytes < 1) {\n            sizeBytes[0] = -1;\n            return -1;\n        }\n        // If the first byte is in the range 0...251, then this value is the size of the frame.\n        else if (packet.getUint8(byteOffset) < 252) {\n            sizeBytes[0] = packet.getUint8(byteOffset);\n            return 1;\n        }\n        // If the first byte is in the range 252...255, a second byte is needed. If there is no second byte, then the size\n        // cannot be determined.\n        else if (remainingBytes < 2) {\n            sizeBytes[0] = -1;\n            return -1;\n        }\n        // The total size of the frame given two size bytes is:\n        // (4 * secondSizeByte) + firstSizeByte\n        else {\n            sizeBytes[0] = 4 * packet.getUint8(byteOffset + 1) + packet.getUint8(byteOffset);\n            return 2;\n        }\n    }\n    /**\n     * Parse binary data containing an Opus packet into one or more Opus frames.\n     *\n     * @param data Binary data containing an Opus packet to be parsed. The data should begin with the first byte (i.e the\n     *             TOC byte) of an Opus packet. Note that the size of the data does not have to equal the size of the\n     *             contained Opus packet.\n     * @param lenBytes Size of the data (in bytes).\n     * @param selfDelimited Indicates if the Opus packet is self-delimiting\n     *                      (https://www.rfc-editor.org/rfc/rfc6716#appendix-B).\n     * @param tocByte Optional variable to store the TOC (table of contents) byte.\n     * @param frameOffsets Optional variable to store the offsets (from the start of the data) to the first bytes of each\n     *                     Opus frame.\n     * @param frameSizes Required variable to store the sizes (in bytes) of each Opus frame.\n     * @param payloadOffset Optional variable to store the offset (from the start of the data) to the first byte of the\n     *                      payload.\n     * @param packetLenBytes Optional variable to store the length of the Opus packet (in bytes).\n     * @returns Number of Opus frames.\n     */\n    opusPacketParseImpl(data, lenBytes, selfDelimited, tocByte, frameOffsets, frameSizes, payloadOffset, packetLenBytes) {\n        if (!frameSizes || lenBytes < 0)\n            return this.OPUS_BAD_ARG;\n        if (lenBytes === 0)\n            return this.OPUS_INVALID_PACKET;\n        // The number of Opus frames in the packet.\n        let numFrames;\n        // Intermediate storage for the number of bytes parsed to determine the size of a frame.\n        let numBytesParsed;\n        // The number of the padding bytes (excluding the padding count bytes) in the packet.\n        let paddingBytes = 0;\n        // Indicates whether CBR (constant bitrate) framing is used.\n        let cbr = false;\n        // The TOC (table of contents) byte (https://www.rfc-editor.org/rfc/rfc6716#section-3.1).\n        const toc = data.getUint8(0);\n        // Store the TOC byte.\n        if (tocByte)\n            tocByte[0] = toc;\n        // The remaining number of bytes to parse from the packet. Note that the TOC byte has already been parsed, hence the\n        // minus 1.\n        let remainingBytes = lenBytes - 1;\n        // This keeps track of where we are in the packet. This starts at 1 since the TOC byte has already been read.\n        let byteOffset = 1;\n        // The size of the last Opus frame in bytes.\n        let lastSizeBytes = remainingBytes;\n        // Read the `c` bits (i.e. code bits) from the TOC byte.\n        switch (toc & 0x3) {\n            // A code 0 packet (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.2) has one frame.\n            case 0:\n                numFrames = 1;\n                break;\n            // A code 1 packet (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.3) has two CBR (constant bitrate) frames.\n            case 1:\n                numFrames = 2;\n                cbr = true;\n                if (!selfDelimited) {\n                    // Undelimited code 1 packets must be an even number of data bytes, otherwise the packet is invalid.\n                    if (remainingBytes & 0x1)\n                        return this.OPUS_INVALID_PACKET;\n                    // The sizes of both frames are equal (i.e. half of the number of data bytes).\n                    lastSizeBytes = remainingBytes / 2;\n                    // If `lastSizeBytes` is too large, we will catch it later.\n                    frameSizes[0][0] = lastSizeBytes;\n                }\n                break;\n            // A code 2 packet (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.4) has two VBR (variable bitrate) frames.\n            case 2:\n                numFrames = 2;\n                numBytesParsed = this.opusParseSize(data, byteOffset, remainingBytes, frameSizes[0]);\n                remainingBytes -= numBytesParsed;\n                // The parsed size of the first frame cannot be larger than the number of remaining bytes in the packet.\n                if (frameSizes[0][0] < 0 || frameSizes[0][0] > remainingBytes) {\n                    return this.OPUS_INVALID_PACKET;\n                }\n                byteOffset += numBytesParsed;\n                // The size of the second frame is the remaining number of bytes after the first frame.\n                lastSizeBytes = remainingBytes - frameSizes[0][0];\n                break;\n            // A code 3 packet (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.5) has multiple CBR/VBR frames (from 0 to\n            // 120 ms).\n            default:\n                // Code 3 packets must have at least 2 bytes (i.e. at least 1 byte after the TOC byte).\n                if (remainingBytes < 1)\n                    return this.OPUS_INVALID_PACKET;\n                // Frame count byte format:\n                //  0\n                //  0 1 2 3 4 5 6 7\n                // +-+-+-+-+-+-+-+-+\n                // |v|p|     M     |\n                // +-+-+-+-+-+-+-+-+\n                //\n                // Read the frame count byte, which immediately follows the TOC byte.\n                const frameCountByte = data.getUint8(byteOffset++);\n                --remainingBytes;\n                // Read the 'M' bits of the frame count byte, which encode the number of frames.\n                numFrames = frameCountByte & 0x3f;\n                // The number of frames in a code 3 packet must not be 0.\n                if (numFrames <= 0)\n                    return this.OPUS_INVALID_PACKET;\n                const samplesPerFrame = this.opusPacketGetSamplesPerFrame(data, 48000);\n                // A single frame can have at most 2880 samples, which happens in the case where 60ms of 48kHz audio is encoded\n                // per frame. A code 3 packet cannot contain more than 120ms of audio, so the total number of samples cannot\n                // exceed 2880 * 2 = 5760.\n                if (samplesPerFrame * numFrames > 5760)\n                    return this.OPUS_INVALID_PACKET;\n                // Parse padding bytes if the 'p' bit is 1.\n                if (frameCountByte & 0x40) {\n                    let paddingCountByte;\n                    let numPaddingBytes;\n                    // Remove padding bytes (including padding count bytes) from the remaining byte count.\n                    do {\n                        // Sanity check that there are enough bytes to parse and remove the padding.\n                        if (remainingBytes <= 0)\n                            return this.OPUS_INVALID_PACKET;\n                        // Get the next padding count byte.\n                        paddingCountByte = data.getUint8(byteOffset++);\n                        --remainingBytes;\n                        // If the padding count byte has a value in the range 0...254, then the total size of the padding is the\n                        // value in the padding count byte.\n                        //\n                        // If the padding count byte has value 255, then the total size of the padding is 254 plus the value in the\n                        // next padding count byte. Therefore, keep reading padding count bytes while the value is 255.\n                        numPaddingBytes = paddingCountByte === 255 ? 254 : paddingCountByte;\n                        remainingBytes -= numPaddingBytes;\n                        paddingBytes += numPaddingBytes;\n                    } while (paddingCountByte === 255);\n                }\n                // Sanity check that the remaining number of bytes is not negative after removing the padding.\n                if (remainingBytes < 0)\n                    return this.OPUS_INVALID_PACKET;\n                // Read the 'v' bit (i.e. VBR bit).\n                cbr = !(frameCountByte & 0x80);\n                // VBR case\n                if (!cbr) {\n                    lastSizeBytes = remainingBytes;\n                    // Let M be the number of frames. There will be M - 1 frame length indicators (which can be 1 or 2 bytes)\n                    // corresponding to the lengths of frames 0 to M - 2. The size of the last frame (i.e. frame M - 1) is the\n                    // number of data bytes after the end of frame M - 2 and before the start of the padding bytes.\n                    for (let i = 0; i < numFrames - 1; ++i) {\n                        numBytesParsed = this.opusParseSize(data, byteOffset, remainingBytes, frameSizes[i]);\n                        remainingBytes -= numBytesParsed;\n                        // The remaining number of data bytes must be enough to contain each frame.\n                        if (frameSizes[i][0] < 0 || frameSizes[i][0] > remainingBytes) {\n                            return this.OPUS_INVALID_PACKET;\n                        }\n                        byteOffset += numBytesParsed;\n                        lastSizeBytes -= numBytesParsed + frameSizes[i][0];\n                    }\n                    // Sanity check that the size of the last frame is not negative.\n                    if (lastSizeBytes < 0)\n                        return this.OPUS_INVALID_PACKET;\n                }\n                // CBR case\n                else if (!selfDelimited) {\n                    // The size of each frame is the number of data bytes divided by the number of frames.\n                    lastSizeBytes = Math.trunc(remainingBytes / numFrames);\n                    // The number of data bytes must be a non-negative integer multiple of the number of frames.\n                    if (lastSizeBytes * numFrames !== remainingBytes)\n                        return this.OPUS_INVALID_PACKET;\n                    // All frames have equal size in the undelimited CBR case.\n                    for (let i = 0; i < numFrames - 1; ++i) {\n                        frameSizes[i][0] = lastSizeBytes;\n                    }\n                }\n        }\n        // Self-delimited framing uses an extra 1 or 2 bytes, immediately preceding the data bytes, to indicate either the\n        // size of the last frame (for code 0, code 2, and VBR code 3 packets) or the size of all the frames (for code 1 and\n        // CBR code 3 packets). See https://www.rfc-editor.org/rfc/rfc6716#appendix-B.\n        if (selfDelimited) {\n            // The extra frame size byte(s) will always indicate the size of the last frame.\n            numBytesParsed = this.opusParseSize(data, byteOffset, remainingBytes, frameSizes[numFrames - 1]);\n            remainingBytes -= numBytesParsed;\n            // There must be enough data bytes for the last frame.\n            if (frameSizes[numFrames - 1][0] < 0 || frameSizes[numFrames - 1][0] > remainingBytes) {\n                return this.OPUS_INVALID_PACKET;\n            }\n            byteOffset += numBytesParsed;\n            // For CBR packets, the sizes of all the frames are equal.\n            if (cbr) {\n                // There must be enough data bytes for all the frames.\n                if (frameSizes[numFrames - 1][0] * numFrames > remainingBytes) {\n                    return this.OPUS_INVALID_PACKET;\n                }\n                for (let i = 0; i < numFrames - 1; ++i) {\n                    frameSizes[i][0] = frameSizes[numFrames - 1][0];\n                }\n            }\n            // At this point, `lastSizeBytes` contains the size of the last frame plus the size of the extra frame size\n            // byte(s), so sanity check that `lastSizeBytes` is the upper bound for the size of the last frame.\n            else if (!(numBytesParsed + frameSizes[numFrames - 1][0] <= lastSizeBytes)) {\n                return this.OPUS_INVALID_PACKET;\n            }\n        }\n        // Undelimited case\n        else {\n            // Because the size of the last packet is not encoded explicitly, it is possible that the size of the last packet\n            // (or of all the packets, for the CBR case) is larger than maximum frame size.\n            if (lastSizeBytes > this.OPUS_MAX_FRAME_SIZE_BYTES)\n                return this.OPUS_INVALID_PACKET;\n            frameSizes[numFrames - 1][0] = lastSizeBytes;\n        }\n        // Store the offset to the start of the payload.\n        if (payloadOffset)\n            payloadOffset[0] = byteOffset;\n        // Store the offsets to the start of each frame.\n        for (let i = 0; i < numFrames; ++i) {\n            if (frameOffsets)\n                frameOffsets[i][0] = byteOffset;\n            byteOffset += frameSizes[i][0];\n        }\n        // Store the length of the Opus packet.\n        if (packetLenBytes)\n            packetLenBytes[0] = byteOffset + paddingBytes;\n        return numFrames;\n    }\n    /**\n     * Parse a single undelimited Opus packet into one or more Opus frames.\n     *\n     * @param packet Opus packet to be parsed.\n     * @param lenBytes Size of the packet (in bytes).\n     * @param tocByte Optional variable to store the TOC (table of contents) byte.\n     * @param frameOffsets Optional variable to store the offsets (from the start of the packet) to the first bytes of\n     *                     each Opus frame.\n     * @param frameSizes Required variable to store the sizes (in bytes) of each Opus frame.\n     * @param payloadOffset Optional variable to store the offset (from the start of the packet) to the first byte of the\n     *                      payload.\n     * @returns Number of Opus frames.\n     */\n    opusPacketParse(packet, lenBytes, tocByte, frameOffsets, frameSizes, payloadOffset) {\n        return this.opusPacketParseImpl(packet, lenBytes, \n        /* selfDelimited */ false, tocByte, frameOffsets, frameSizes, payloadOffset, null);\n    }\n    /**\n     * This function returns the SILK VAD (voice activity detection) information encoded in the Opus packet. For CELT-only\n     * packets that do not have VAD information, it returns -1.\n     *\n     * @param packet Opus packet.\n     * @param lenBytes Size of the packet (in bytes).\n     * @returns  0: no frame had the VAD flag set.\n     *           1: at least one frame had the VAD flag set.\n     *          -1: VAD status could not be determined.\n     */\n    opusPacketHasVoiceActivity(packet, lenBytes) {\n        if (!packet || lenBytes <= 0)\n            return 0;\n        // In CELT-only mode, we can not determine whether there is VAD.\n        if (this.opusPacketIsCeltOnly(packet))\n            return -1;\n        const numSilkFrames = this.opusNumSilkFrames(packet);\n        // It is not possible for `opusNumSilkFrames()` to return 0, so we ignore the next sanity check for test coverage.\n        /* istanbul ignore next */\n        if (numSilkFrames === 0)\n            return -1;\n        const opusFrameOffsets = new Array(this.OPUS_MAX_OPUS_FRAMES);\n        const opusFrameSizes = new Array(this.OPUS_MAX_OPUS_FRAMES);\n        for (let i = 0; i < this.OPUS_MAX_OPUS_FRAMES; ++i) {\n            opusFrameOffsets[i] = [undefined];\n            opusFrameSizes[i] = [undefined];\n        }\n        // Parse packet to get the Opus frames.\n        const numOpusFrames = this.opusPacketParse(packet, lenBytes, null, opusFrameOffsets, opusFrameSizes, null);\n        // VAD status cannot be determined for invalid packets.\n        if (numOpusFrames < 0)\n            return -1;\n        // Iterate over all Opus frames, which may contain multiple SILK frames, to determine the VAD status.\n        for (let i = 0; i < numOpusFrames; ++i) {\n            if (opusFrameSizes[i][0] < 1)\n                continue;\n            // LP layer header bits format (https://www.rfc-editor.org/rfc/rfc6716#section-4.2.3):\n            //\n            // Mono case:\n            // +-----------------+----------+\n            // | 1 to 3 VAD bits | LBRR bit |\n            // +-----------------+----------+\n            //\n            // Stereo case:\n            // +---------------------+--------------+----------------------+---------------+\n            // | 1 to 3 mid VAD bits | mid LBRR bit | 1 to 3 side VAD bits | side LBRR bit |\n            // +---------------------+--------------+----------------------+---------------+\n            // The upper 1 to 3 bits (dependent on the number of SILK frames) of the LP layer contain VAD bits. If any of\n            // these VAD bits are 1, then voice activity is present.\n            if (packet.getUint8(opusFrameOffsets[i][0]) >> (8 - numSilkFrames))\n                return 1;\n            // In the stereo case, there is a second set of 1 to 3 VAD bits, so also check these VAD bits.\n            const channels = this.opusPacketGetNumChannels(packet);\n            if (channels === 2 &&\n                (packet.getUint8(opusFrameOffsets[i][0]) << (numSilkFrames + 1)) >> (8 - numSilkFrames)) {\n                return 1;\n            }\n        }\n        // No voice activity was detected.\n        return 0;\n    }\n    /**\n     * This method is based on Definition of the Opus Audio Codec\n     * (https://tools.ietf.org/html/rfc6716). Basically, this method is based on\n     * parsing the LP layer of an Opus packet, particularly the LBRR flag.\n     *\n     * @param packet Opus packet.\n     * @param lenBytes Size of the packet (in bytes).\n     * @returns  true: packet has fec encoding about previous packet.\n     *           false: no fec encoding present.\n     */\n    opusPacketHasFec(packet, lenBytes) {\n        if (!packet || lenBytes <= 0)\n            return false;\n        // In CELT-only mode, packets should not have FEC.\n        if (this.opusPacketIsCeltOnly(packet))\n            return false;\n        const opusFrameOffsets = new Array(this.OPUS_MAX_OPUS_FRAMES);\n        const opusFrameSizes = new Array(this.OPUS_MAX_OPUS_FRAMES);\n        for (let i = 0; i < this.OPUS_MAX_OPUS_FRAMES; ++i) {\n            opusFrameOffsets[i] = [undefined];\n            opusFrameSizes[i] = [undefined];\n        }\n        // Parse packet to get the Opus frames.\n        const numOpusFrames = this.opusPacketParse(packet, lenBytes, null, opusFrameOffsets, opusFrameSizes, null);\n        if (numOpusFrames < 0)\n            return false;\n        /* istanbul ignore next */\n        if (opusFrameSizes[0][0] <= 1)\n            return false;\n        const numSilkFrames = this.opusNumSilkFrames(packet);\n        /* istanbul ignore next */\n        if (numSilkFrames === 0)\n            return false;\n        const channels = this.opusPacketGetNumChannels(packet);\n        /* istanbul ignore next */\n        if (channels !== 1 && channels !== 2)\n            return false;\n        // A frame starts with the LP layer. The LP layer begins with two to eight\n        // header bits.These consist of one VAD bit per SILK frame (up to 3),\n        // followed by a single flag indicating the presence of LBRR frames.\n        // For a stereo packet, these first flags correspond to the mid channel, and\n        // a second set of flags is included for the side channel. Because these are\n        // the first symbols decoded by the range coder and because they are coded\n        // as binary values with uniform probability, they can be extracted directly\n        // from the most significant bits of the first byte of compressed data.\n        for (let i = 0; i < channels; i++) {\n            if (packet.getUint8(opusFrameOffsets[0][0]) & (0x80 >> ((i + 1) * (numSilkFrames + 1) - 1)))\n                return true;\n        }\n        return false;\n    }\n}\n//# sourceMappingURL=RedundantAudioEncodedTransform.js.map\n\n// === MediaMetricsEncodedTransform.js ===\n// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.\n// SPDX-License-Identifier: Apache-2.0\n/**\n * Message types specific to MediaMetrics transforms.\n */\nconst MEDIA_METRICS_MESSAGE_TYPES = {\n    NEW_SSRC: 'NewSSRC',\n};\n/**\n * Abstract base class for packet-level metrics collection per SSRC.\n * Tracks packet counts and timestamps, periodically reporting to the main thread.\n */\nclass BaseMetricsTransform extends EncodedTransform {\n    constructor() {\n        super(...arguments);\n        this.metricsMap = new Map();\n        this.reportIntervalMs = 500;\n        this.lastReportTime = 0;\n    }\n    /** Processes frames, collects per-SSRC metrics, and forwards unchanged. */\n    transform(frame, controller) {\n        var _a;\n        const ssrc = ((_a = frame.getMetadata) === null || _a === void 0 ? void 0 : _a.call(frame).synchronizationSource) || 0;\n        // Get or create metrics for this SSRC\n        let metrics = this.metricsMap.get(ssrc);\n        if (!metrics) {\n            metrics = { packetCount: 0, timestamp: 0 };\n            this.metricsMap.set(ssrc, metrics);\n            this.log(`Created metrics for SSRC ${ssrc}`);\n            self.postMessage({\n                type: MEDIA_METRICS_MESSAGE_TYPES.NEW_SSRC,\n                transformName: this.transformName(),\n                message: { ssrc: String(ssrc) },\n            });\n        }\n        // Collect metrics\n        metrics.packetCount++;\n        metrics.timestamp = frame.timestamp;\n        // Forward frame unchanged\n        controller.enqueue(frame);\n        const now = Date.now();\n        if (now - this.lastReportTime >= this.reportIntervalMs) {\n            this.reportMetrics();\n            this.lastReportTime = now;\n        }\n    }\n    /** Posts aggregated metrics to the main thread via postMessage. */\n    reportMetrics() {\n        const metricsObject = {};\n        for (const [ssrc, metrics] of this.metricsMap.entries()) {\n            metricsObject[ssrc] = { ssrc, ...metrics };\n        }\n        self.postMessage({\n            type: COMMON_MESSAGE_TYPES.METRICS,\n            transformName: this.transformName(),\n            message: { metrics: JSON.stringify(metricsObject) },\n        });\n    }\n}\n/** Collects packet-level metrics for outbound audio streams. */\nclass AudioSenderMetricsTransform extends BaseMetricsTransform {\n    transformName() {\n        return TRANSFORM_NAMES.AUDIO_SENDER;\n    }\n}\n/** Collects packet-level metrics for inbound audio streams. */\nclass AudioReceiverMetricsTransform extends BaseMetricsTransform {\n    transformName() {\n        return TRANSFORM_NAMES.AUDIO_RECEIVER;\n    }\n}\n/** Collects packet-level metrics for outbound video streams. */\nclass VideoSenderMetricsTransform extends BaseMetricsTransform {\n    transformName() {\n        return TRANSFORM_NAMES.VIDEO_SENDER;\n    }\n}\n/** Collects packet-level metrics for inbound video streams. */\nclass VideoReceiverMetricsTransform extends BaseMetricsTransform {\n    transformName() {\n        return TRANSFORM_NAMES.VIDEO_RECEIVER;\n    }\n}\n//# sourceMappingURL=MediaMetricsEncodedTransform.js.map\n\n// === EncodedTransformWorker.js ===\n// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.\n// SPDX-License-Identifier: Apache-2.0\n/**\n * Web Worker entry point for WebRTC encoded media transforms.\n *\n * Manages transform pipelines for audio/video sender/receiver streams using either:\n * - RTCRtpScriptTransform API (modern browsers)\n * - createEncodedStreams() API (legacy fallback)\n *\n * Pipelines:\n * - Audio Sender: encoder \u2192 metrics \u2192 RED encode \u2192 network\n * - Audio Receiver: network \u2192 RED decode \u2192 metrics \u2192 decoder\n * - Video Sender/Receiver: encoder/network \u2192 metrics \u2192 network/decoder\n */\nclass EncodedTransformWorker {\n    /**\n     * Initializes the worker, sets up transform instances and event handlers.\n     */\n    static initializeWorker() {\n        EncodedTransformWorker.log('Initializing EncodedTransformWorker');\n        // Initialize transform instances\n        EncodedTransformWorker.redundantAudioEncodedTransform = new RedundantAudioEncodedTransform();\n        EncodedTransformWorker.audioSenderMetricsTransform = new AudioSenderMetricsTransform();\n        EncodedTransformWorker.audioReceiverMetricsTransform = new AudioReceiverMetricsTransform();\n        EncodedTransformWorker.videoSenderMetricsTransform = new VideoSenderMetricsTransform();\n        EncodedTransformWorker.videoReceiverMetricsTransform = new VideoReceiverMetricsTransform();\n        // Check the DedicatedWorkerGlobalScope for existence of RTCRtpScriptTransformer interface. If exists, then\n        // RTCRtpScriptTransform is supported by this browser.\n        // @ts-ignore - RTCRtpScriptTransformer may not be in all TS lib.dom.d.ts versions\n        if (self.RTCRtpScriptTransformer) {\n            // @ts-ignore - onrtctransform may not be in all TS lib.dom.d.ts versions\n            self.onrtctransform = (event) => {\n                const transformer = event.transformer;\n                const options = transformer.options;\n                const disabledTransforms = options.disabledTransforms || {};\n                EncodedTransformWorker.log(`Setting up transform: operation=${options.operation}, mediaType=${options.mediaType}, disabledTransforms=${JSON.stringify(disabledTransforms)}`);\n                if (options.mediaType === 'audio' && options.operation === 'send') {\n                    EncodedTransformWorker.setupAudioSenderPipeline(transformer, disabledTransforms);\n                }\n                else if (options.mediaType === 'audio' && options.operation === 'receive') {\n                    EncodedTransformWorker.setupAudioReceiverPipeline(transformer, disabledTransforms);\n                }\n                else if (options.mediaType === 'video' && options.operation === 'send') {\n                    EncodedTransformWorker.setupVideoSenderPipeline(transformer);\n                }\n                else if (options.mediaType === 'video' && options.operation === 'receive') {\n                    EncodedTransformWorker.setupVideoReceiverPipeline(transformer);\n                }\n            };\n        }\n        // Message handler for configuration updates and legacy createEncodedStreams() API\n        self.onmessage = (event) => {\n            var _a, _b, _c, _d, _e;\n            const message = event.data;\n            EncodedTransformWorker.log(`Received message: ${message.msgType || message.type}`);\n            // Handle legacy createEncodedStreams() API\n            if (message.msgType === 'StartEncodedTransformWorker') {\n                EncodedTransformWorker.log('Setting up legacy encoded streams');\n                const disabledTransforms = ((_a = message.options) === null || _a === void 0 ? void 0 : _a.disabledTransforms) || {};\n                if ((_b = message.audio) === null || _b === void 0 ? void 0 : _b.send) {\n                    EncodedTransformWorker.setupAudioSenderPipeline({\n                        readable: message.audio.send.readable,\n                        writable: message.audio.send.writable,\n                    }, disabledTransforms);\n                }\n                if ((_c = message.audio) === null || _c === void 0 ? void 0 : _c.receive) {\n                    EncodedTransformWorker.setupAudioReceiverPipeline({\n                        readable: message.audio.receive.readable,\n                        writable: message.audio.receive.writable,\n                    }, disabledTransforms);\n                }\n                if ((_d = message.video) === null || _d === void 0 ? void 0 : _d.send) {\n                    EncodedTransformWorker.setupVideoSenderPipeline({\n                        readable: message.video.send.readable,\n                        writable: message.video.send.writable,\n                    });\n                }\n                if ((_e = message.video) === null || _e === void 0 ? void 0 : _e.receive) {\n                    EncodedTransformWorker.setupVideoReceiverPipeline({\n                        readable: message.video.receive.readable,\n                        writable: message.video.receive.writable,\n                    });\n                }\n            }\n            else if (message.transformName === TRANSFORM_NAMES.REDUNDANT_AUDIO &&\n                EncodedTransformWorker.redundantAudioEncodedTransform) {\n                EncodedTransformWorker.redundantAudioEncodedTransform.handleMessage(message);\n            }\n            else {\n                EncodedTransformWorker.log(`Unknown message type: ${message.type}, transformName: ${message.transformName}`);\n            }\n        };\n    }\n    /**\n     * Posts a log message to the main thread.\n     * @param msg The message to log\n     */\n    static log(msg) {\n        self.postMessage({\n            type: COMMON_MESSAGE_TYPES.LOG,\n            transformName: 'EncodedTransformWorker',\n            message: { text: msg },\n        });\n    }\n    /**\n     * Sets up audio sender pipeline: encoder \u2192 metrics \u2192 RED encode \u2192 network.\n     * If RED is disabled: encoder \u2192 metrics \u2192 network.\n     * @param transformer The RTCRtpScriptTransformer or legacy streams object\n     * @param disabledTransforms Configuration for disabled transforms\n     */\n    static setupAudioSenderPipeline(transformer, disabledTransforms) {\n        const metricsTransform = new TransformStream({\n            transform: EncodedTransformWorker.audioSenderMetricsTransform.transform.bind(EncodedTransformWorker.audioSenderMetricsTransform),\n        });\n        if (disabledTransforms.redundantAudio) {\n            transformer.readable.pipeThrough(metricsTransform).pipeTo(transformer.writable);\n        }\n        else {\n            const redEncodeTransform = new TransformStream({\n                transform: EncodedTransformWorker.redundantAudioEncodedTransform.senderTransform.bind(EncodedTransformWorker.redundantAudioEncodedTransform),\n            });\n            transformer.readable\n                .pipeThrough(metricsTransform)\n                .pipeThrough(redEncodeTransform)\n                .pipeTo(transformer.writable);\n        }\n    }\n    /**\n     * Sets up video sender pipeline: encoder \u2192 metrics \u2192 network.\n     * @param transformer The RTCRtpScriptTransformer or legacy streams object\n     */\n    static setupVideoSenderPipeline(transformer) {\n        const metricsTransform = new TransformStream({\n            transform: EncodedTransformWorker.videoSenderMetricsTransform.transform.bind(EncodedTransformWorker.videoSenderMetricsTransform),\n        });\n        transformer.readable.pipeThrough(metricsTransform).pipeTo(transformer.writable);\n    }\n    /**\n     * Sets up audio receiver pipeline: network \u2192 RED decode \u2192 metrics \u2192 decoder.\n     * If RED is disabled: network \u2192 metrics \u2192 decoder.\n     * @param transformer The RTCRtpScriptTransformer or legacy streams object\n     * @param disabledTransforms Configuration for disabled transforms\n     */\n    static setupAudioReceiverPipeline(transformer, disabledTransforms) {\n        const metricsTransform = new TransformStream({\n            transform: EncodedTransformWorker.audioReceiverMetricsTransform.transform.bind(EncodedTransformWorker.audioReceiverMetricsTransform),\n        });\n        if (disabledTransforms.redundantAudio) {\n            transformer.readable.pipeThrough(metricsTransform).pipeTo(transformer.writable);\n        }\n        else {\n            const redDecodeTransform = new TransformStream({\n                transform: EncodedTransformWorker.redundantAudioEncodedTransform.receivePacketLogTransform.bind(EncodedTransformWorker.redundantAudioEncodedTransform),\n            });\n            transformer.readable\n                .pipeThrough(redDecodeTransform)\n                .pipeThrough(metricsTransform)\n                .pipeTo(transformer.writable);\n        }\n    }\n    /**\n     * Sets up video receiver pipeline: network \u2192 metrics \u2192 decoder.\n     * @param transformer The RTCRtpScriptTransformer or legacy streams object\n     */\n    static setupVideoReceiverPipeline(transformer) {\n        const metricsTransform = new TransformStream({\n            transform: EncodedTransformWorker.videoReceiverMetricsTransform.transform.bind(EncodedTransformWorker.videoReceiverMetricsTransform),\n        });\n        transformer.readable.pipeThrough(metricsTransform).pipeTo(transformer.writable);\n    }\n}\n// Singleton transform instances shared across all pipelines\nEncodedTransformWorker.redundantAudioEncodedTransform = null;\nEncodedTransformWorker.audioSenderMetricsTransform = null;\nEncodedTransformWorker.audioReceiverMetricsTransform = null;\nEncodedTransformWorker.videoSenderMetricsTransform = null;\nEncodedTransformWorker.videoReceiverMetricsTransform = null;\nEncodedTransformWorker;\n//# sourceMappingURL=EncodedTransformWorker.js.map\n\n// Initialize worker\nEncodedTransformWorker.initializeWorker();\n";
module.exports.default = $db88099007947cfe$var$EncodedTransformWorkerCode;

});

parcelRegister("kGlN2", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $f0e8a1e6e7200f68$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8iaF3 = parcelRequire("8iaF3");

var $bbxjk = parcelRequire("bbxjk");

const $f0e8a1e6e7200f68$var$IntervalScheduler_1 = $f0e8a1e6e7200f68$var$__importDefault((parcelRequire("4wGp7")));

const $f0e8a1e6e7200f68$var$EncodedTransformManager_1 = $f0e8a1e6e7200f68$var$__importDefault((parcelRequire("ct5Vx")));
/**
 * Manages metrics collection for all media types (audio/video, sender/receiver).
 * Consolidates packet-level metrics from the Web Worker.
 */ class $f0e8a1e6e7200f68$var$MediaMetricsTransformManager extends $f0e8a1e6e7200f68$var$EncodedTransformManager_1.default {
    constructor(worker, logger){
        super(worker, logger);
        this.audioSendMetrics = {};
        this.audioReceiveMetrics = {};
        this.videoSendMetrics = {};
        this.videoReceiveMetrics = {};
        this.observers = new Set();
        this.metricsReportingScheduler = null;
        this.METRICS_REPORTING_INTERVAL_MS = 1000;
    }
    /**
     * Start the metrics transform manager
     */ async start() {
        this.startMetricsReporting();
    }
    /**
     * Get the transform names that this manager handles
     */ transformNames() {
        return [
            $8iaF3.TRANSFORM_NAMES.AUDIO_SENDER,
            $8iaF3.TRANSFORM_NAMES.AUDIO_RECEIVER,
            $8iaF3.TRANSFORM_NAMES.VIDEO_SENDER,
            $8iaF3.TRANSFORM_NAMES.VIDEO_RECEIVER
        ];
    }
    /**
     * Handle metrics messages from the Web Worker
     * Routes messages to the appropriate metrics property
     */ handleWorkerMessage(message) {
        var _a, _b;
        if (message.type === $bbxjk.MEDIA_METRICS_MESSAGE_TYPES.NEW_SSRC) {
            /* istanbul ignore next */ const ssrcStr = (_a = message.message) === null || _a === void 0 ? void 0 : _a.ssrc;
            if (!ssrcStr) {
                this.logger.warn('Received NEW_SSRC message without ssrc, ignoring');
                return;
            }
            const ssrc = parseInt(ssrcStr, 10);
            if (isNaN(ssrc)) {
                this.logger.warn(`Received NEW_SSRC message with invalid ssrc: ${ssrcStr}, ignoring`);
                return;
            }
            let mediaType;
            let direction;
            switch(message.transformName){
                case $8iaF3.TRANSFORM_NAMES.AUDIO_SENDER:
                    mediaType = 'audio';
                    direction = 'send';
                    break;
                case $8iaF3.TRANSFORM_NAMES.AUDIO_RECEIVER:
                    mediaType = 'audio';
                    direction = 'receive';
                    break;
                case $8iaF3.TRANSFORM_NAMES.VIDEO_SENDER:
                    mediaType = 'video';
                    direction = 'send';
                    break;
                case $8iaF3.TRANSFORM_NAMES.VIDEO_RECEIVER:
                    mediaType = 'video';
                    direction = 'receive';
                    break;
            }
            if (mediaType && direction) {
                for (const observer of this.observers)try {
                    (_b = observer.onFirstPacketReceived) === null || _b === void 0 || _b.call(observer, mediaType, direction, ssrc);
                } catch (e) {
                    this.logger.error(`Error notifying first packet observer: ${e}`);
                }
            }
            return;
        }
        if (message.type !== $8iaF3.COMMON_MESSAGE_TYPES.METRICS) return;
        try {
            const metrics = JSON.parse(message.message.metrics);
            switch(message.transformName){
                case $8iaF3.TRANSFORM_NAMES.AUDIO_SENDER:
                    this.audioSendMetrics = metrics;
                    break;
                case $8iaF3.TRANSFORM_NAMES.AUDIO_RECEIVER:
                    this.audioReceiveMetrics = metrics;
                    break;
                case $8iaF3.TRANSFORM_NAMES.VIDEO_SENDER:
                    this.videoSendMetrics = metrics;
                    break;
                case $8iaF3.TRANSFORM_NAMES.VIDEO_RECEIVER:
                    this.videoReceiveMetrics = metrics;
                    break;
            }
        } catch (e) {
            this.logger.warn(`Failed to handle metrics message: ${e}`);
        }
    }
    /**
     * Add an observer to receive media metrics
     */ addObserver(observer) {
        this.observers.add(observer);
    }
    /**
     * Remove an observer
     */ removeObserver(observer) {
        this.observers.delete(observer);
    }
    /**
     * Start periodic metrics reporting to observers
     */ startMetricsReporting() {
        this.metricsReportingScheduler = new $f0e8a1e6e7200f68$var$IntervalScheduler_1.default(this.METRICS_REPORTING_INTERVAL_MS);
        this.metricsReportingScheduler.start(()=>{
            this.reportMetrics();
        });
    }
    /**
     * Report current metrics to all observers
     */ reportMetrics() {
        var _a;
        const metrics = {
            audioSendMetrics: {
                ...this.audioSendMetrics
            },
            audioReceiveMetrics: {
                ...this.audioReceiveMetrics
            },
            videoSendMetrics: {
                ...this.videoSendMetrics
            },
            videoReceiveMetrics: {
                ...this.videoReceiveMetrics
            }
        };
        for (const observer of this.observers)try {
            (_a = observer.encodedTransformMediaMetricsDidReceive) === null || _a === void 0 || _a.call(observer, metrics);
        } catch (e) {
            this.logger.error(`Error notifying media metrics observer: ${e}`);
        }
    }
    /**
     * Stop metrics transform and release resources
     */ async stop() {
        if (this.metricsReportingScheduler) {
            this.metricsReportingScheduler.stop();
            this.metricsReportingScheduler = null;
        }
        this.observers.clear();
        // Reset all metrics to initial state
        this.audioSendMetrics = {};
        this.audioReceiveMetrics = {};
        this.videoSendMetrics = {};
        this.videoReceiveMetrics = {};
    }
}
module.exports.default = $f0e8a1e6e7200f68$var$MediaMetricsTransformManager;

});
parcelRegister("bbxjk", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $824a8f9e05575033$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $824a8f9e05575033$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $824a8f9e05575033$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $824a8f9e05575033$var$__createBinding(result, mod, k[i]);
        }
        $824a8f9e05575033$var$__setModuleDefault(result, mod);
        return result;
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VideoReceiverMetricsTransform = module.exports.VideoSenderMetricsTransform = module.exports.AudioReceiverMetricsTransform = module.exports.AudioSenderMetricsTransform = module.exports.MEDIA_METRICS_MESSAGE_TYPES = void 0;

const $824a8f9e05575033$var$EncodedTransform_1 = $824a8f9e05575033$var$__importStar((parcelRequire("8iaF3")));
/**
 * Message types specific to MediaMetrics transforms.
 */ module.exports.MEDIA_METRICS_MESSAGE_TYPES = {
    NEW_SSRC: 'NewSSRC'
};
/**
 * Abstract base class for packet-level metrics collection per SSRC.
 * Tracks packet counts and timestamps, periodically reporting to the main thread.
 */ class $824a8f9e05575033$var$BaseMetricsTransform extends $824a8f9e05575033$var$EncodedTransform_1.default {
    constructor(){
        super(...arguments);
        this.metricsMap = new Map();
        this.reportIntervalMs = 500;
        this.lastReportTime = 0;
    }
    /** Processes frames, collects per-SSRC metrics, and forwards unchanged. */ transform(frame, controller) {
        var _a;
        const ssrc = ((_a = frame.getMetadata) === null || _a === void 0 ? void 0 : _a.call(frame).synchronizationSource) || 0;
        // Get or create metrics for this SSRC
        let metrics = this.metricsMap.get(ssrc);
        if (!metrics) {
            metrics = {
                packetCount: 0,
                timestamp: 0
            };
            this.metricsMap.set(ssrc, metrics);
            this.log(`Created metrics for SSRC ${ssrc}`);
            self.postMessage({
                type: module.exports.MEDIA_METRICS_MESSAGE_TYPES.NEW_SSRC,
                transformName: this.transformName(),
                message: {
                    ssrc: String(ssrc)
                }
            });
        }
        // Collect metrics
        metrics.packetCount++;
        metrics.timestamp = frame.timestamp;
        // Forward frame unchanged
        controller.enqueue(frame);
        const now = Date.now();
        if (now - this.lastReportTime >= this.reportIntervalMs) {
            this.reportMetrics();
            this.lastReportTime = now;
        }
    }
    /** Posts aggregated metrics to the main thread via postMessage. */ reportMetrics() {
        const metricsObject = {};
        for (const [ssrc, metrics] of this.metricsMap.entries())metricsObject[ssrc] = {
            ssrc: ssrc,
            ...metrics
        };
        self.postMessage({
            type: $824a8f9e05575033$var$EncodedTransform_1.COMMON_MESSAGE_TYPES.METRICS,
            transformName: this.transformName(),
            message: {
                metrics: JSON.stringify(metricsObject)
            }
        });
    }
}
/** Collects packet-level metrics for outbound audio streams. */ class $824a8f9e05575033$var$AudioSenderMetricsTransform extends $824a8f9e05575033$var$BaseMetricsTransform {
    transformName() {
        return $824a8f9e05575033$var$EncodedTransform_1.TRANSFORM_NAMES.AUDIO_SENDER;
    }
}
module.exports.AudioSenderMetricsTransform = $824a8f9e05575033$var$AudioSenderMetricsTransform;
/** Collects packet-level metrics for inbound audio streams. */ class $824a8f9e05575033$var$AudioReceiverMetricsTransform extends $824a8f9e05575033$var$BaseMetricsTransform {
    transformName() {
        return $824a8f9e05575033$var$EncodedTransform_1.TRANSFORM_NAMES.AUDIO_RECEIVER;
    }
}
module.exports.AudioReceiverMetricsTransform = $824a8f9e05575033$var$AudioReceiverMetricsTransform;
/** Collects packet-level metrics for outbound video streams. */ class $824a8f9e05575033$var$VideoSenderMetricsTransform extends $824a8f9e05575033$var$BaseMetricsTransform {
    transformName() {
        return $824a8f9e05575033$var$EncodedTransform_1.TRANSFORM_NAMES.VIDEO_SENDER;
    }
}
module.exports.VideoSenderMetricsTransform = $824a8f9e05575033$var$VideoSenderMetricsTransform;
/** Collects packet-level metrics for inbound video streams. */ class $824a8f9e05575033$var$VideoReceiverMetricsTransform extends $824a8f9e05575033$var$BaseMetricsTransform {
    transformName() {
        return $824a8f9e05575033$var$EncodedTransform_1.TRANSFORM_NAMES.VIDEO_RECEIVER;
    }
}
module.exports.VideoReceiverMetricsTransform = $824a8f9e05575033$var$VideoReceiverMetricsTransform;

});

parcelRegister("ct5Vx", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Abstract base class for managing specific transform types.
 *
 * Each TransformManager handles configuration and lifecycle for a particular transform.
 */ class $913cca6e0d95a4c1$var$EncodedTransformManager {
    /**
     * Creates a new EncodedTransformManager.
     * @param worker The Web Worker instance for encoded transforms
     * @param logger Logger instance for debugging
     */ constructor(worker, logger){
        this.worker = worker;
        this.logger = logger;
    }
    /**
     * Send a message to the Web Worker
     */ postMessage(message) {
        this.worker.postMessage(message);
    }
}
module.exports.default = $913cca6e0d95a4c1$var$EncodedTransformManager;

});


parcelRegister("1H5d7", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $13bdd94b8830b8f4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $13bdd94b8830b8f4$var$RedundantAudioRecoveryMetricReport_1 = $13bdd94b8830b8f4$var$__importDefault((parcelRequire("7dTR6")));

var $8iaF3 = parcelRequire("8iaF3");

var $i7QDG = parcelRequire("i7QDG");

const $13bdd94b8830b8f4$var$EncodedTransformManager_1 = $13bdd94b8830b8f4$var$__importDefault((parcelRequire("ct5Vx")));
/**
 * Manages redundant audio encoding transforms.
 * Handles RED configuration, metrics collection, and observer notifications.
 * Implements AudioVideoObserver to receive metrics directly.
 */ class $13bdd94b8830b8f4$var$RedundantAudioEncodedTransformManager extends $13bdd94b8830b8f4$var$EncodedTransformManager_1.default {
    constructor(){
        super(...arguments);
        this.numRedundantEncodings = 0;
        this.redundancyEnabled = true;
        this.metrics = {
            totalAudioPacketsLost: 0,
            totalAudioPacketsExpected: 0,
            totalAudioPacketsRecoveredRed: 0,
            totalAudioPacketsRecoveredFec: 0
        };
        this.observers = new Set();
        // Audio metrics history for packet loss calculation
        this.audioMetricsHistory = new Array();
        this.currentNumRedundantEncodings = 0;
        this.lastRedHolddownTimerStartTimestampMs = 0;
        this.lastHighPacketLossEventTimestampMs = 0;
        this.lastAudioRedTurnOffTimestampMs = 0;
        this.maxAudioMetricsHistory = 20;
        this.audioRedPacketLossShortEvalPeriodMs = 5000; // 5s
        this.audioRedPacketLossLongEvalPeriodMs = 15000; // 15s
        this.audioRedHoldDownTimeMs = 300000; // 5m
        this.redRecoveryTimeMs = 60000; // 1m
    }
    /**
     * Get the transform names that this manager handles
     */ transformNames() {
        return [
            $8iaF3.TRANSFORM_NAMES.REDUNDANT_AUDIO
        ];
    }
    /**
     * Handle RED metrics messages from the Web Worker
     */ handleWorkerMessage(message) {
        if (message.type !== $8iaF3.COMMON_MESSAGE_TYPES.METRICS) return;
        try {
            const metrics = JSON.parse(message.message.metrics);
            const ssrc = parseInt(message.message.ssrc, 10);
            this.updateMetrics(metrics);
            this.notifyObservers(ssrc);
        } catch (e) {
            this.logger.warn(`Failed to handle RED metrics message: ${e}`);
        }
    }
    /**
     * Set audio payload types from SDP
     */ setAudioPayloadTypes(payloadTypes) {
        const opusPayloadType = payloadTypes.get('opus') || 0;
        const redPayloadType = payloadTypes.get('red') || 0;
        // Send configuration to worker
        const opusMessage = {
            transformName: $8iaF3.TRANSFORM_NAMES.REDUNDANT_AUDIO,
            type: $i7QDG.REDUNDANT_AUDIO_MESSAGE_TYPES.OPUS_PAYLOAD_TYPE,
            message: {
                payloadType: opusPayloadType.toString()
            }
        };
        this.postMessage(opusMessage);
        const redMessage = {
            transformName: $8iaF3.TRANSFORM_NAMES.REDUNDANT_AUDIO,
            type: $i7QDG.REDUNDANT_AUDIO_MESSAGE_TYPES.RED_PAYLOAD_TYPE,
            message: {
                payloadType: redPayloadType.toString()
            }
        };
        this.postMessage(redMessage);
        this.logger.info(`[AudioRed] Set payload types - Opus: ${opusPayloadType}, RED: ${redPayloadType}`);
    }
    /**
     * Update the number of redundant encodings based on packet loss
     */ updateNumRedundantEncodings(packetLossPercent) {
        // Calculate appropriate number of redundant encodings based on packet loss
        let newNumEncodings = 0;
        if (packetLossPercent > 10) newNumEncodings = 2;
        else if (packetLossPercent > 5) newNumEncodings = 1;
        if (newNumEncodings !== this.numRedundantEncodings) {
            this.numRedundantEncodings = newNumEncodings;
            const message = {
                type: $i7QDG.REDUNDANT_AUDIO_MESSAGE_TYPES.UPDATE_NUM_REDUNDANT_ENCODINGS,
                transformName: $8iaF3.TRANSFORM_NAMES.REDUNDANT_AUDIO,
                message: {
                    numRedundantEncodings: newNumEncodings.toString()
                }
            };
            this.postMessage(message);
            this.logger.info(`[AudioRed] Updated redundant encodings to ${newNumEncodings} (packet loss: ${packetLossPercent}%)`);
        }
    }
    /**
     * Enable or disable redundancy
     */ setRedundancyEnabled(enabled) {
        if (this.redundancyEnabled === enabled) return;
        this.redundancyEnabled = enabled;
        const message = {
            type: enabled ? $i7QDG.REDUNDANT_AUDIO_MESSAGE_TYPES.ENABLE : $i7QDG.REDUNDANT_AUDIO_MESSAGE_TYPES.DISABLE,
            transformName: $8iaF3.TRANSFORM_NAMES.REDUNDANT_AUDIO
        };
        this.postMessage(message);
        this.logger.info(`[AudioRed] Redundancy ${enabled ? 'enabled' : 'disabled'}`);
    }
    /**
     * AudioVideoObserver callback - receives metrics from the audio/video controller
     */ metricsDidReceive(clientMetricReport) {
        const { currentTimestampMs: currentTimestampMs } = clientMetricReport;
        const rtcStatsReport = clientMetricReport.getRTCStatsReport();
        let receiverReportReceptionTimestampMs = 0;
        let currentTotalPacketsSent = 0;
        let currentTotalPacketsLost = 0;
        rtcStatsReport.forEach((report)=>{
            /* istanbul ignore else */ if (report.kind === 'audio') {
                /* istanbul ignore else */ if (report.type === 'outbound-rtp') currentTotalPacketsSent = report.packetsSent;
                else if (report.type === 'remote-inbound-rtp') {
                    // Use the timestamp that the receiver report was received on the client side to get a more accurate time
                    // interval for the metrics.
                    receiverReportReceptionTimestampMs = report.timestamp;
                    currentTotalPacketsLost = report.packetsLost;
                }
            }
        });
        // Since the timestamp from the server side is only updated when a new receiver report is generated, only add
        // metrics with new timestamps to our metrics history.
        //
        // Also, make sure that the total packets sent is greater than the most recent value in the history before consuming
        // to avoid divide-by-zero while calculating uplink loss percent.
        if (this.audioMetricsHistory.length === 0 || receiverReportReceptionTimestampMs > this.audioMetricsHistory[this.audioMetricsHistory.length - 1].timestampMs && currentTotalPacketsSent > this.audioMetricsHistory[this.audioMetricsHistory.length - 1].totalPacketsSent) // Note that although the total packets sent is updated anytime we get the WebRTC stats, we are only adding a new
        // metric for total packets sent when we receive a new receiver report. We only care about the total packets that
        // the server was expected to receive at the time that the latest `packetsLost` metric was calculated in order to
        // do our uplink loss calculation. Therefore, we only record the total packets sent when we receive a new receiver
        // report, which will give us an estimate of the number of packets that the server was supposed to receive at the
        // time when the latest `packetsLost` metric was calculated.
        this.audioMetricsHistory.push({
            timestampMs: receiverReportReceptionTimestampMs,
            totalPacketsSent: currentTotalPacketsSent,
            totalPacketsLost: currentTotalPacketsLost
        });
        // Remove the oldest metric report from our list
        if (this.audioMetricsHistory.length > this.maxAudioMetricsHistory) this.audioMetricsHistory.shift();
        // As the minimum RTCP frequency is about 1 every 5 seconds,
        // we are limited to using a minimum timewindow of 5 seconds.
        // This is because the cumulative packetsLost metric remains
        // the same for 5 consecutive client metric reports.
        const lossPercent5sTimewindow = this.lossPercent(this.audioRedPacketLossShortEvalPeriodMs);
        const lossPercent15sTimewindow = this.lossPercent(this.audioRedPacketLossLongEvalPeriodMs);
        // Taking the max loss percent between a short and long time window will allow
        // us to increase the number of encodings fast but will slowly decrease the
        // number of encodings on loss recovery.
        const maxLossPercent = Math.max(lossPercent5sTimewindow, lossPercent15sTimewindow);
        const [newNumRedundantEncodings, shouldTurnOffRed] = $13bdd94b8830b8f4$var$RedundantAudioEncodedTransformManager.getNumRedundantEncodingsForPacketLoss(maxLossPercent);
        if (shouldTurnOffRed) {
            this.lastHighPacketLossEventTimestampMs = currentTimestampMs;
            /* istanbul ignore next */ if (this.redundancyEnabled) {
                this.setRedundancyEnabled(false);
                this.lastAudioRedTurnOffTimestampMs = currentTimestampMs;
            }
            return;
        } else if (!this.redundancyEnabled) {
            const timeSinceRedOff = currentTimestampMs - this.lastAudioRedTurnOffTimestampMs;
            const timeSinceLastHighPacketLossEvent = currentTimestampMs - this.lastHighPacketLossEventTimestampMs;
            if (timeSinceRedOff >= this.audioRedPacketLossLongEvalPeriodMs && timeSinceLastHighPacketLossEvent < this.redRecoveryTimeMs) // This is probably not a transient high packet loss spike.
            // We need to turn off RED for awhile to avoid congestion collapse.
            return;
            else {
                // Enable red as we've completed the recovery wait time.
                this.setRedundancyEnabled(true);
                this.maybeResetHoldDownTimer(currentTimestampMs);
            }
        }
        if (this.shouldUpdateAudioRedWorkerEncodings(currentTimestampMs, newNumRedundantEncodings)) this.updateNumRedundantEncodings(maxLossPercent);
    }
    /**
     * Calculate packet loss percentage for a given time window
     */ lossPercent(timeWindowMs) {
        if (this.audioMetricsHistory.length < 2) return 0;
        const latestReceiverReportTimestampMs = this.audioMetricsHistory[this.audioMetricsHistory.length - 1].timestampMs;
        const currentTotalPacketsSent = this.audioMetricsHistory[this.audioMetricsHistory.length - 1].totalPacketsSent;
        const currentTotalPacketsLost = this.audioMetricsHistory[this.audioMetricsHistory.length - 1].totalPacketsLost;
        // Iterate backwards in the metrics history, from the report immediately preceeding
        // the latest one, until we find the first metric report whose timestamp differs
        // from the latest report by atleast timeWindowMs
        for(let i = this.audioMetricsHistory.length - 2; i >= 0; i--)if (latestReceiverReportTimestampMs - this.audioMetricsHistory[i].timestampMs >= timeWindowMs) {
            const lossDelta = currentTotalPacketsLost - this.audioMetricsHistory[i].totalPacketsLost;
            const sentDelta = currentTotalPacketsSent - this.audioMetricsHistory[i].totalPacketsSent;
            const lossPercent = 100 * (lossDelta / sentDelta);
            return Math.max(0, Math.min(lossPercent, 100));
        }
        // If we are here, we don't have enough entries in history
        // to calculate the loss for the given time window
        return 0;
    }
    /**
     * Returns the number of encodings based on packetLoss value. This is used to
     * determine when to alert the encoder to update the number of encodings. It also determines if we need to
     * turn off red in cases of very high packet loss to avoid congestion collapse.
     */ static getNumRedundantEncodingsForPacketLoss(packetLoss) {
        let recommendedRedundantEncodings = 0;
        let shouldTurnOffRed = false;
        if (packetLoss <= 8) recommendedRedundantEncodings = 0;
        else if (packetLoss <= 18) recommendedRedundantEncodings = 1;
        else if (packetLoss <= 75) recommendedRedundantEncodings = 2;
        else {
            recommendedRedundantEncodings = 0;
            shouldTurnOffRed = true;
        }
        return [
            recommendedRedundantEncodings,
            shouldTurnOffRed
        ];
    }
    /**
     * Check if we should update the worker encodings.
     * If newNumRedundantEncodings is the same as the current then we don't need to send a message to the red worker.
     * If newNumRedundantEncodings is less than the current, check if we've cleared the hold down time and only
     * then allow the update to be sent to the red worker.
     */ shouldUpdateAudioRedWorkerEncodings(currentTimestampMs, newNumRedundantEncodings) {
        if (this.currentNumRedundantEncodings === newNumRedundantEncodings) {
            this.maybeResetHoldDownTimer(currentTimestampMs);
            return false;
        }
        if (newNumRedundantEncodings < this.currentNumRedundantEncodings && currentTimestampMs - this.lastRedHolddownTimerStartTimestampMs < this.audioRedHoldDownTimeMs) {
            this.logger.debug(`[RED] Hold-down active: ${(currentTimestampMs - this.lastRedHolddownTimerStartTimestampMs) / 1000}s / ${this.audioRedHoldDownTimeMs / 1000}s`);
            return false;
        }
        this.currentNumRedundantEncodings = newNumRedundantEncodings;
        this.maybeResetHoldDownTimer(currentTimestampMs);
        return true;
    }
    /**
     * Reset hold down timer if needed
     */ maybeResetHoldDownTimer(currentTimestampMs) {
        if (this.currentNumRedundantEncodings > 0) this.lastRedHolddownTimerStartTimestampMs = currentTimestampMs;
    }
    /**
     * Start the redundant audio transform manager
     */ async start() {
    // No-op for now, manager is ready after construction
    }
    /**
     * Stop transform and reset state
     */ async stop() {
        this.observers.clear();
        this.audioMetricsHistory = [];
    }
    /**
     * Add an observer to receive RED recovery metrics
     */ addObserver(observer) {
        this.observers.add(observer);
    }
    /**
     * Remove an observer
     */ removeObserver(observer) {
        this.observers.delete(observer);
    }
    /**
     * Update metrics from worker message
     */ updateMetrics(newMetrics) {
        this.metrics = {
            ...newMetrics
        };
    }
    /**
     * Notify all observers with updated metrics
     */ notifyObservers(ssrc) {
        if (this.observers.size === 0) return;
        // Create metric report for observers
        const report = new $13bdd94b8830b8f4$var$RedundantAudioRecoveryMetricReport_1.default();
        report.currentTimestampMs = Date.now();
        report.ssrc = ssrc;
        report.totalAudioPacketsLost = this.metrics.totalAudioPacketsLost;
        report.totalAudioPacketsExpected = this.metrics.totalAudioPacketsExpected;
        report.totalAudioPacketsRecoveredRed = this.metrics.totalAudioPacketsRecoveredRed;
        report.totalAudioPacketsRecoveredFec = this.metrics.totalAudioPacketsRecoveredFec;
        for (const observer of this.observers)observer.recoveryMetricsDidReceive(report);
    }
}
module.exports.default = $13bdd94b8830b8f4$var$RedundantAudioEncodedTransformManager;

});
parcelRegister("i7QDG", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $d321b6779e51f72b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d321b6779e51f72b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d321b6779e51f72b$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $d321b6779e51f72b$var$__createBinding(result, mod, k[i]);
        }
        $d321b6779e51f72b$var$__setModuleDefault(result, mod);
        return result;
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.REDUNDANT_AUDIO_MESSAGE_TYPES = void 0;

const $d321b6779e51f72b$var$EncodedTransform_1 = $d321b6779e51f72b$var$__importStar((parcelRequire("8iaF3")));
/**
 * Message types specific to RedundantAudio transform.
 */ module.exports.REDUNDANT_AUDIO_MESSAGE_TYPES = {
    OPUS_PAYLOAD_TYPE: 'OpusPayloadType',
    RED_PAYLOAD_TYPE: 'RedPayloadType',
    UPDATE_NUM_REDUNDANT_ENCODINGS: 'UpdateNumRedundantEncodings',
    ENABLE: 'Enable',
    DISABLE: 'Disable'
};
/**
 * Implements RFC 2198 RED (Redundant Audio Data) encoding/decoding for Opus audio.
 *
 * Sender: Encodes primary + redundant payloads to recover from packet loss.
 * Receiver: Logs packets for loss/recovery statistics (does not decode RED).
 *
 * Dynamically adjusts redundancy level (0-2 encodings) based on packet loss.
 * Supports Opus FEC detection for recovery metrics calculation.
 */ class $d321b6779e51f72b$var$RedundantAudioEncodedTransform extends $d321b6779e51f72b$var$EncodedTransform_1.default {
    constructor(){
        super();
        // Each payload must be less than 1024 bytes to fit the 10 bit block length
        this.maxRedPacketSizeBytes = 1024;
        // Limit payload to 1000 bytes to handle small MTU. 1000 is chosen because in Chromium-based browsers, writing audio
        // payloads larger than 1000 bytes using the WebRTC Insertable Streams API (which is used to enable dynamic audio
        // redundancy) will cause an error to be thrown and cause audio flow to permanently stop. See
        // https://crbug.com/1248479.
        this.maxAudioPayloadSizeBytes = 1000;
        // Each payload can encode a timestamp delta of 14 bits
        this.maxRedTimestampOffset = 16384;
        // 4 byte RED header
        this.redHeaderSizeBytes = 4;
        // reduced size for last RED header
        this.redLastHeaderSizeBytes = 1;
        // P-Time for Opus 20 msec packets
        // We do not support other p-times or clock rates
        this.redPacketizationTime = 960;
        // distance between redundant payloads, Opus FEC handles a distance of 1
        this.redPacketDistance = 2;
        // maximum number of redundant payloads per RTP packet
        this.maxRedEncodings = 2;
        // Maximum number of encodings that can be recovered with a single RED packet, assuming the primary and redundant
        // payloads have FEC.
        this.redMaxRecoveryDistance = this.redPacketDistance * this.maxRedEncodings + 1;
        // maximum history of prior payloads to keep
        // generally we will expire old entries based on timestamp
        // this limit is in place just to make sure the history does not
        // grow too large in the case of erroneous timestamp inputs
        this.maxEncodingHistorySize = 10;
        // Current number of encodings we want to send
        // to the remote end. This will be dynamically
        // updated through the setNumEncodingsFromPacketloss API
        this.numRedundantEncodings = 0;
        // Used to enable or disable redundancy
        // in response to very high packet loss events
        this.redundancyEnabled = true;
        // Loss stats reported every 5 seconds (48000 samples/sec * 5 sec)
        this.lossReportInterval = 240000;
        this.maxOutOfOrderPacketDistance = 16;
        /**
         * Below are Opus helper methods and constants.
         */ this.OPUS_BAD_ARG = -1;
        this.OPUS_INVALID_PACKET = -4;
        // Max number of Opus frames in an Opus packet is 48 (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.5).
        this.OPUS_MAX_OPUS_FRAMES = 48;
        // Max number of bytes that any individual Opus frame can have.
        this.OPUS_MAX_FRAME_SIZE_BYTES = 1275;
        this.encodingHistory = new Array();
        this.opusPayloadType = 0;
        this.redPayloadType = 0;
        this.initializePacketLogs();
    }
    /**
     * Handle configuration messages from main thread
     */ handleMessage(message) {
        var _a, _b, _c;
        try {
            const msgType = message.type;
            switch(msgType){
                case module.exports.REDUNDANT_AUDIO_MESSAGE_TYPES.RED_PAYLOAD_TYPE:
                    this.setRedPayloadType(parseInt(((_a = message.message) === null || _a === void 0 ? void 0 : _a.payloadType) || '0', 10));
                    break;
                case module.exports.REDUNDANT_AUDIO_MESSAGE_TYPES.OPUS_PAYLOAD_TYPE:
                    this.setOpusPayloadType(parseInt(((_b = message.message) === null || _b === void 0 ? void 0 : _b.payloadType) || '0', 10));
                    break;
                case module.exports.REDUNDANT_AUDIO_MESSAGE_TYPES.UPDATE_NUM_REDUNDANT_ENCODINGS:
                    this.setNumRedundantEncodings(parseInt(((_c = message.message) === null || _c === void 0 ? void 0 : _c.numRedundantEncodings) || '0', 10));
                    break;
                case module.exports.REDUNDANT_AUDIO_MESSAGE_TYPES.ENABLE:
                    this.setRedundancyEnabled(true);
                    break;
                case module.exports.REDUNDANT_AUDIO_MESSAGE_TYPES.DISABLE:
                    this.setRedundancyEnabled(false);
                    break;
            }
        } catch (e) {
            this.log(`Failed to handle message: ${e}`);
        }
    }
    /** Not used directly - use senderTransform or receivePacketLogTransform. */ transform(_frame, _controller) {
    // Not used - use senderTransform or receivePacketLogTransform
    }
    transformName() {
        return $d321b6779e51f72b$var$EncodedTransform_1.TRANSFORM_NAMES.REDUNDANT_AUDIO;
    }
    /**
     * Set the RED payload type ideally obtained from local offer.
     */ setRedPayloadType(payloadType) {
        this.redPayloadType = payloadType;
        this.log(`red payload type set to ${this.redPayloadType}`);
    }
    /**
     * Set the opus payload type ideally obtained from local offer.
     */ setOpusPayloadType(payloadType) {
        this.opusPayloadType = payloadType;
        this.log(`opus payload type set to ${this.opusPayloadType}`);
    }
    /**
     * Set the number of redundant encodings
     */ setNumRedundantEncodings(numRedundantEncodings) {
        this.numRedundantEncodings = numRedundantEncodings;
        if (this.numRedundantEncodings > this.maxRedEncodings) this.numRedundantEncodings = this.maxRedEncodings;
        this.log(`Updated numRedundantEncodings to ${this.numRedundantEncodings}`);
    }
    /**
     * Enable or disable redundancy in response to
     * high packet loss event.
     */ setRedundancyEnabled(enabled) {
        this.redundancyEnabled = enabled;
        this.log(`redundancy ${this.redundancyEnabled ? 'enabled' : 'disabled'}`);
    }
    /**
     * Helper function to only enqueue audio frames if they do not exceed the audio payload byte limit imposed by
     * Chromium-based browsers. Chromium will throw an error (https://crbug.com/1248479) if an audio payload larger than
     * 1000 bytes is enqueued. Any controller that attempts to enqueue an audio payload larger than 1000 bytes will
     * encounter this error and will permanently stop sending or receiving audio.
     */ enqueueAudioFrameIfPayloadSizeIsValid(frame, controller) {
        if (frame.data.byteLength > this.maxAudioPayloadSizeBytes) return;
        controller.enqueue(frame);
    }
    /**
     * Receives encoded frames and modifies as needed before sending to transport.
     */ senderTransform(frame, controller) {
        const frameMetadata = frame.getMetadata();
        if (frameMetadata.payloadType !== this.redPayloadType) {
            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);
            return;
        }
        const primaryPayloadBuffer = this.getPrimaryPayload(frame.timestamp, frame.data);
        if (!primaryPayloadBuffer) {
            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);
            return;
        }
        const encodedBuffer = this.encode(frame.timestamp, primaryPayloadBuffer);
        /* istanbul ignore next */ if (!encodedBuffer) {
            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);
            return;
        }
        frame.data = encodedBuffer;
        this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);
        return;
    }
    /**
     * Get the primary payload from encoding
     */ getPrimaryPayload(primaryTimestamp, frame) {
        const encodings = this.splitEncodings(primaryTimestamp, frame);
        if (!encodings || encodings.length < 1) return null;
        return encodings[encodings.length - 1].payload;
    }
    /**
     * Split up the encoding received into primary and redundant encodings
     * These will be ordered oldest to newest which is the same ordering
     * in the RTP red payload.
     */ splitEncodings(primaryTimestamp, frame, getFecInfo = false, primarySequenceNumber) {
        // process RED headers (according to RFC 2198)
        //   0                   1                   2                   3
        //   0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1
        //  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
        //  |F|   block PT  |  timestamp offset         |   block length    |
        //  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
        //
        // last header
        //   0 1 2 3 4 5 6 7
        //  +-+-+-+-+-+-+-+-+
        //  |0|   Block PT  |
        //  +-+-+-+-+-+-+-+-+
        const payload = new DataView(frame);
        let payloadSizeBytes = payload.byteLength;
        let totalPayloadSizeBytes = 0;
        let totalHeaderSizeBytes = 0;
        let primaryPayloadSizeBytes = 0;
        let payloadOffset = 0;
        let gotLastBlock = false;
        const encodings = new Array();
        const redundantEncodingBlockLengths = new Array();
        const redundantEncodingTimestamps = new Array();
        while(payloadSizeBytes > 0){
            gotLastBlock = (payload.getUint8(payloadOffset) & 0x80) === 0;
            if (gotLastBlock) {
                // Bits 1 through 7 are payload type
                const payloadType = payload.getUint8(payloadOffset) & 0x7f;
                // Unexpected payload type. This is a bad packet.
                if (payloadType !== this.opusPayloadType) return null;
                totalPayloadSizeBytes += this.redLastHeaderSizeBytes;
                totalHeaderSizeBytes += this.redLastHeaderSizeBytes;
                // Accumulated block lengths are equal to or larger than the buffer, which means there is no primary block. This
                // is a bad packet.
                if (totalPayloadSizeBytes >= payload.byteLength) return null;
                primaryPayloadSizeBytes = payload.byteLength - totalPayloadSizeBytes;
                break;
            } else {
                if (payloadSizeBytes < this.redHeaderSizeBytes) return null;
                // Bits 22 through 31 are payload length
                const blockLength = ((payload.getUint8(payloadOffset + 2) & 0x03) << 8) + payload.getUint8(payloadOffset + 3);
                redundantEncodingBlockLengths.push(blockLength);
                const timestampOffset = payload.getUint16(payloadOffset + 1) >> 2;
                const timestamp = primaryTimestamp - timestampOffset;
                redundantEncodingTimestamps.push(timestamp);
                totalPayloadSizeBytes += blockLength + this.redHeaderSizeBytes;
                totalHeaderSizeBytes += this.redHeaderSizeBytes;
                payloadOffset += this.redHeaderSizeBytes;
                payloadSizeBytes -= this.redHeaderSizeBytes;
            }
        }
        // The last block was never found. The packet we received
        // does not have a good RED payload.
        if (!gotLastBlock) {
            // Note that sequence numbers only exist for
            // incoming audio frames.
            if (primarySequenceNumber !== undefined) {
                // This could be a possible padding packet used
                // for BWE with a good sequence number.
                // Create a dummy encoding to make sure loss values
                // are calculated correctly by consuming sequence number.
                // Note that for the receive side, we process packets only
                // for loss/recovery calculations and forward the original
                // packet without changing it even in the error case.
                encodings.push({
                    payload: frame,
                    isRedundant: false,
                    seq: primarySequenceNumber
                });
                return encodings;
            }
            // This is a bad packet.
            return null;
        }
        let redundantPayloadOffset = totalHeaderSizeBytes;
        for(let i = 0; i < redundantEncodingTimestamps.length; i++){
            const redundantPayloadBuffer = new ArrayBuffer(redundantEncodingBlockLengths[i]);
            const redundantPayloadArray = new Uint8Array(redundantPayloadBuffer);
            redundantPayloadArray.set(new Uint8Array(payload.buffer, redundantPayloadOffset, redundantEncodingBlockLengths[i]), 0);
            const encoding = {
                timestamp: redundantEncodingTimestamps[i],
                payload: redundantPayloadBuffer,
                isRedundant: true
            };
            if (getFecInfo) encoding.hasFec = this.opusPacketHasFec(new DataView(redundantPayloadBuffer), redundantPayloadBuffer.byteLength);
            encodings.push(encoding);
            redundantPayloadOffset += redundantEncodingBlockLengths[i];
        }
        const primaryPayloadOffset = payload.byteLength - primaryPayloadSizeBytes;
        const primaryPayloadBuffer = new ArrayBuffer(primaryPayloadSizeBytes);
        const primaryArray = new Uint8Array(primaryPayloadBuffer);
        primaryArray.set(new Uint8Array(payload.buffer, primaryPayloadOffset, primaryPayloadSizeBytes), 0);
        const encoding = {
            timestamp: primaryTimestamp,
            payload: primaryPayloadBuffer,
            isRedundant: false,
            seq: primarySequenceNumber
        };
        if (getFecInfo) encoding.hasFec = this.opusPacketHasFec(new DataView(primaryPayloadBuffer), primaryPayloadBuffer.byteLength);
        encodings.push(encoding);
        return encodings;
    }
    /**
     * Create a new encoding with current primary payload and the older payloads of choice.
     */ encode(primaryTimestamp, primaryPayload) {
        const primaryPayloadSize = primaryPayload.byteLength;
        // Payload size needs to be valid.
        if (primaryPayloadSize === 0 || primaryPayloadSize >= this.maxRedPacketSizeBytes || primaryPayloadSize >= this.maxAudioPayloadSizeBytes) return null;
        const numRedundantEncodings = this.numRedundantEncodings;
        let headerSizeBytes = this.redLastHeaderSizeBytes;
        let payloadSizeBytes = primaryPayloadSize;
        let bytesAvailable = this.maxAudioPayloadSizeBytes - primaryPayloadSize - headerSizeBytes;
        const redundantEncodingTimestamps = new Array();
        const redundantEncodingPayloads = new Array();
        // If redundancy is disabled then only send the primary payload
        if (this.redundancyEnabled) {
            // Determine how much redundancy we can fit into our packet
            let redundantTimestamp = this.uint32WrapAround(primaryTimestamp - this.redPacketizationTime * this.redPacketDistance);
            for(let i = 0; i < numRedundantEncodings; i++){
                // Do not add redundant encodings that are beyond the maximum timestamp offset.
                if (this.uint32WrapAround(primaryTimestamp - redundantTimestamp) >= this.maxRedTimestampOffset) break;
                let findTimestamp = redundantTimestamp;
                let encoding = this.encodingHistory.find((e)=>e.timestamp === findTimestamp);
                if (!encoding) {
                    // If not found or not important then look for the previous packet.
                    // The current packet may have included FEC for the previous, so just
                    // use the previous packet instead provided that it has voice activity.
                    findTimestamp = this.uint32WrapAround(redundantTimestamp - this.redPacketizationTime);
                    encoding = this.encodingHistory.find((e)=>e.timestamp === findTimestamp);
                }
                if (encoding) {
                    const redundantEncodingSizeBytes = encoding.payload.byteLength;
                    // Only add redundancy if there are enough bytes available.
                    if (bytesAvailable < this.redHeaderSizeBytes + redundantEncodingSizeBytes) break;
                    bytesAvailable -= this.redHeaderSizeBytes + redundantEncodingSizeBytes;
                    headerSizeBytes += this.redHeaderSizeBytes;
                    payloadSizeBytes += redundantEncodingSizeBytes;
                    redundantEncodingTimestamps.unshift(encoding.timestamp);
                    redundantEncodingPayloads.unshift(encoding.payload);
                }
                redundantTimestamp -= this.redPacketizationTime * this.redPacketDistance;
                redundantTimestamp = this.uint32WrapAround(redundantTimestamp);
            }
        }
        const redPayloadBuffer = new ArrayBuffer(headerSizeBytes + payloadSizeBytes);
        const redPayloadView = new DataView(redPayloadBuffer);
        // Add redundant encoding header(s) to new buffer
        let redPayloadOffset = 0;
        for(let i = 0; i < redundantEncodingTimestamps.length; i++){
            const timestampDelta = primaryTimestamp - redundantEncodingTimestamps[i];
            redPayloadView.setUint8(redPayloadOffset, this.opusPayloadType | 0x80);
            redPayloadView.setUint16(redPayloadOffset + 1, timestampDelta << 2 | redundantEncodingPayloads[i].byteLength >> 8);
            redPayloadView.setUint8(redPayloadOffset + 3, redundantEncodingPayloads[i].byteLength & 0xff);
            redPayloadOffset += this.redHeaderSizeBytes;
        }
        // Add primary encoding header to new buffer
        redPayloadView.setUint8(redPayloadOffset, this.opusPayloadType);
        redPayloadOffset += this.redLastHeaderSizeBytes;
        // Add redundant payload(s) to new buffer
        const redPayloadArray = new Uint8Array(redPayloadBuffer);
        for(let i = 0; i < redundantEncodingPayloads.length; i++){
            redPayloadArray.set(new Uint8Array(redundantEncodingPayloads[i]), redPayloadOffset);
            redPayloadOffset += redundantEncodingPayloads[i].byteLength;
        }
        // Add primary payload to new buffer
        redPayloadArray.set(new Uint8Array(primaryPayload), redPayloadOffset);
        redPayloadOffset += primaryPayload.byteLength;
        /* istanbul ignore next */ // Sanity check that we got the expected total payload size.
        if (redPayloadOffset !== headerSizeBytes + payloadSizeBytes) return null;
        this.updateEncodingHistory(primaryTimestamp, primaryPayload);
        return redPayloadBuffer;
    }
    /** Maintains encoding history for redundancy, keeping only recent important packets. */ updateEncodingHistory(primaryTimestamp, primaryPayload) {
        // Remove encodings from the history if they are too old.
        for (const encoding of this.encodingHistory){
            const maxTimestampDelta = this.redPacketizationTime * this.redMaxRecoveryDistance;
            if (primaryTimestamp - encoding.timestamp >= maxTimestampDelta) this.encodingHistory.shift();
            else break;
        }
        // Only add an encoding to the history if the encoding is deemed to be important. An encoding is important if it is
        // a CELT-only packet or contains voice activity.
        const packet = new DataView(primaryPayload);
        if (this.opusPacketIsCeltOnly(packet) || this.opusPacketHasVoiceActivity(packet, packet.byteLength) > 0) {
            // Check if adding an encoding will cause the length of the encoding history to exceed the maximum history size.
            // This is not expected to happen but could occur if we get incorrect timestamps. We want to make sure our memory
            // usage is bounded. In this case, just clear the history and start over from empty.
            if (this.encodingHistory.length + 1 > this.maxEncodingHistorySize) this.encodingHistory.length = 0;
            this.encodingHistory.push({
                timestamp: primaryTimestamp,
                payload: primaryPayload
            });
        }
    }
    /** Initializes packet logs and resets all metric counters. */ initializePacketLogs() {
        // The extra space from the max RED recovery distance is to ensure that we do not incorrectly count recovery for
        // packets that have already been received but are outside of the max out-of-order distance.
        const packetLogSize = this.maxOutOfOrderPacketDistance + this.redMaxRecoveryDistance;
        this.primaryPacketLog = {
            window: new Array(packetLogSize),
            index: 0,
            windowSize: packetLogSize
        };
        this.redRecoveryLog = {
            window: new Array(packetLogSize),
            index: 0,
            windowSize: packetLogSize
        };
        this.fecRecoveryLog = {
            window: new Array(packetLogSize),
            index: 0,
            windowSize: packetLogSize
        };
        this.totalAudioPacketsExpected = 0;
        this.totalAudioPacketsLost = 0;
        this.totalAudioPacketsRecoveredRed = 0;
        this.totalAudioPacketsRecoveredFec = 0;
        this.lastLossReportTimestamp = 0;
    }
    /** Receiver transform: logs packets for loss/recovery stats without modifying frames. */ receivePacketLogTransform(frame, controller) {
        const frameMetadata = frame.getMetadata();
        if (frameMetadata.payloadType !== this.redPayloadType) {
            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);
            return;
        }
        const encodings = this.splitEncodings(frame.timestamp, frame.data, /*getFecInfo*/ true, frameMetadata.sequenceNumber);
        if (!encodings) {
            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);
            return;
        }
        for(let i = encodings.length - 1; i >= 0; i--)if (this.updateLossStats(encodings[i])) {
            this.updateRedStats(encodings[i]);
            this.updateFecStats(encodings[i]);
        }
        this.maybeReportLossStats(frameMetadata.synchronizationSource, encodings[encodings.length - 1].timestamp);
        this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);
    }
    /** Updates loss stats from primary packets. Returns false if packet is too old. */ updateLossStats(encoding) {
        if (encoding.isRedundant) return true;
        const timestamp = encoding.timestamp;
        const seq = encoding.seq;
        if (this.totalAudioPacketsExpected === 0) {
            this.totalAudioPacketsExpected = 1;
            this.newestSequenceNumber = seq;
            this.addTimestamp(this.primaryPacketLog, timestamp);
            return true;
        }
        const diff = this.int16(seq - this.newestSequenceNumber);
        if (diff < -this.maxOutOfOrderPacketDistance) return false;
        if (diff < 0) {
            if (!this.hasTimestamp(this.primaryPacketLog, timestamp)) {
                if (this.totalAudioPacketsLost > 0) this.totalAudioPacketsLost--;
                this.addTimestamp(this.primaryPacketLog, timestamp);
                this.removeFromRecoveryWindows(timestamp);
            }
        } else if (diff > 1) this.totalAudioPacketsLost += diff - 1;
        if (diff > 0) {
            this.totalAudioPacketsExpected += diff;
            this.newestSequenceNumber = encoding.seq;
            this.addTimestamp(this.primaryPacketLog, timestamp);
        }
        return true;
    }
    /** Tracks RED recovery for packets not in primary log. */ updateRedStats(encoding) {
        if (!encoding.isRedundant || this.totalAudioPacketsLost === 0) return;
        const timestamp = encoding.timestamp;
        if (!this.hasTimestamp(this.primaryPacketLog, timestamp)) {
            if (!this.hasTimestamp(this.redRecoveryLog, timestamp)) {
                this.totalAudioPacketsRecoveredRed++;
                this.addTimestamp(this.redRecoveryLog, timestamp);
            }
            if (this.removeTimestamp(this.fecRecoveryLog, timestamp)) /* istanbul ignore else */ {
                if (this.totalAudioPacketsRecoveredFec > 0) this.totalAudioPacketsRecoveredFec--;
            }
        }
    }
    /** Tracks FEC recovery for packets not in primary or RED recovery logs. */ updateFecStats(encoding) {
        if (!encoding.hasFec || this.totalAudioPacketsLost === 0) return;
        const fecTimestamp = encoding.timestamp - this.redPacketizationTime;
        if (this.hasTimestamp(this.primaryPacketLog, fecTimestamp) || this.hasTimestamp(this.redRecoveryLog, fecTimestamp) || this.hasTimestamp(this.fecRecoveryLog, fecTimestamp)) return;
        this.totalAudioPacketsRecoveredFec++;
        this.addTimestamp(this.fecRecoveryLog, fecTimestamp);
    }
    /** Reports loss/recovery metrics to main thread at configured intervals. */ maybeReportLossStats(ssrc, timestamp) {
        if (timestamp === undefined || timestamp - this.lastLossReportTimestamp < this.lossReportInterval) return;
        self.postMessage({
            type: $d321b6779e51f72b$var$EncodedTransform_1.COMMON_MESSAGE_TYPES.METRICS,
            transformName: $d321b6779e51f72b$var$EncodedTransform_1.TRANSFORM_NAMES.REDUNDANT_AUDIO,
            message: {
                ssrc: String(ssrc),
                metrics: JSON.stringify({
                    totalAudioPacketsLost: this.totalAudioPacketsLost,
                    totalAudioPacketsExpected: this.totalAudioPacketsExpected,
                    totalAudioPacketsRecoveredRed: this.totalAudioPacketsRecoveredRed,
                    totalAudioPacketsRecoveredFec: this.totalAudioPacketsRecoveredFec
                })
            }
        });
        this.lastLossReportTimestamp = timestamp;
    }
    /** Adds a timestamp to a packet log's circular buffer. */ addTimestamp(packetLog, timestamp) {
        if (timestamp === undefined) return;
        packetLog.window[packetLog.index] = timestamp;
        packetLog.index = (packetLog.index + 1) % packetLog.windowSize;
    }
    /** Checks if a timestamp exists in a packet log. */ hasTimestamp(packetLog, timestamp) {
        const element = packetLog.window.find((t)=>t === timestamp);
        return !!element;
    }
    /**
     * Removes a timestamp from a packet log
     *
     * @param packetLog : The packetlog from which the timestamp should be removed
     * @param timestamp : The timestamp to be removed
     * @returns true if timestamp was present in the log and removed, false otherwise
     */ removeTimestamp(packetLog, timestamp) {
        const index = packetLog.window.indexOf(timestamp);
        if (index >= 0) {
            packetLog.window[index] = undefined;
            return true;
        }
        return false;
    }
    /**
     * Removes a timestamp from red and fec recovery windows.
     *
     * @param timestamp : The timestamp to be removed
     */ removeFromRecoveryWindows(timestamp) {
        let removed = this.removeTimestamp(this.redRecoveryLog, timestamp);
        if (removed) {
            if (this.totalAudioPacketsRecoveredRed > 0) this.totalAudioPacketsRecoveredRed--;
        }
        removed = this.removeTimestamp(this.fecRecoveryLog, timestamp);
        if (removed) {
            if (this.totalAudioPacketsRecoveredFec > 0) this.totalAudioPacketsRecoveredFec--;
        }
    }
    /**
     * Converts the supplied argument to 32-bit unsigned integer
     */ uint32WrapAround(num) {
        const mod = 4294967296; // 2^32
        let res = num;
        if (num >= mod) res = num - mod;
        else if (num < 0) res = mod + num;
        return res;
    }
    /**
     * Converts the supplied argument to 16-bit signed integer
     */ int16(num) {
        return num << 16 >> 16;
    }
    /**
     * Determines if an Opus packet is in CELT-only mode.
     *
     * @param packet Opus packet.
     * @returns `true` if the packet is in CELT-only mode.
     */ opusPacketIsCeltOnly(packet) {
        // TOC byte format (https://www.rfc-editor.org/rfc/rfc6716#section-3.1):
        //  0
        //  0 1 2 3 4 5 6 7
        // +-+-+-+-+-+-+-+-+
        // | config  |s| c |
        // +-+-+-+-+-+-+-+-+
        // Since CELT-only packets are represented using configurations 16 to 31, the highest 'config' bit will always be 1
        // for CELT-only packets.
        return !!(packet.getUint8(0) & 0x80);
    }
    /**
     * Gets the number of samples per frame from an Opus packet.
     *
     * @param packet Opus packet. This must contain at least one byte of data.
     * @param sampleRateHz 32-bit integer sampling rate in Hz. This must be a multiple of 400 or inaccurate results will
     *                     be returned.
     * @returns Number of samples per frame.
     */ opusPacketGetSamplesPerFrame(packet, sampleRateHz) {
        // Sample rate must be a 32-bit integer.
        sampleRateHz = Math.round(sampleRateHz);
        sampleRateHz = Math.min(Math.max(sampleRateHz, -(2 ** 32)), 2 ** 32 - 1);
        // TOC byte format (https://www.rfc-editor.org/rfc/rfc6716#section-3.1):
        //  0
        //  0 1 2 3 4 5 6 7
        // +-+-+-+-+-+-+-+-+
        // | config  |s| c |
        // +-+-+-+-+-+-+-+-+
        let numSamples;
        let frameSizeOption;
        // Case for CELT-only packet.
        if (this.opusPacketIsCeltOnly(packet)) {
            // The lower 3 'config' bits indicate the frame size option.
            frameSizeOption = packet.getUint8(0) >> 3 & 0x3;
            // The frame size options 0, 1, 2, 3 correspond to frame sizes of 2.5, 5, 10, 20 ms. Notice that the frame sizes
            // can be represented as (2.5 * 2^0), (2.5 * 2^1), (2.5 * 2^2), (2.5 * 2^3) ms. So, the number of samples can be
            // calculated as follows:
            // (sample/s) * (1s/1000ms) * (2.5ms) * 2^(frameSizeOption)
            // = (sample/s) * (1s/400) * 2^(frameSizeOption)
            // = (sample/s) * 2^(frameSizeOption) * (1s/400)
            numSamples = (sampleRateHz << frameSizeOption) / 400;
        } else if ((packet.getUint8(0) & 0x60) === 0x60) // In the case of configuration 13 or 15, bit 4 in the above TOC byte diagram will be 1. Configurations 13 and 15
        // correspond to a 20ms frame size, so the number of samples is calculated as follows:
        // (sample/s) * (1s/1000ms) * (20ms)
        // = (sample/s) * (1s/50)
        //
        // In the case of configuration 12 or 14, bit 4 in the above TOC byte diagram will be 0. Configurations 12 and 14
        // correspond to a 10ms frame size, so the number of samples is calculated as follows:
        // (sample/s) * (1s/1000ms) * (10ms)
        // = (sample/s) * (1s/100)
        numSamples = packet.getUint8(0) & 0x08 ? sampleRateHz / 50 : sampleRateHz / 100;
        else {
            // The lower 3 'config' bits indicate the frame size option for SILK-only packets.
            frameSizeOption = packet.getUint8(0) >> 3 & 0x3;
            if (frameSizeOption === 3) // Frame size option 3 corresponds to a frame size of 60ms, so the number of samples is calculated as follows:
            // (sample/s) * (1s/1000ms) * (60ms)
            // = (sample/s) * (60ms) * (1s/1000ms)
            numSamples = sampleRateHz * 60 / 1000;
            else // The frame size options 0, 1, 2 correspond to frame sizes of 10, 20, 40 ms. Notice that the frame sizes can be
            // represented as (10 * 2^0), (10 * 2^1), (10 * 2^2) ms. So, the number of samples can be calculated as follows:
            // (sample/s) * (1s/1000ms) * (10ms) * 2^(frameSizeOption)
            // = (sample/s) * (1s/100) * 2^(frameSizeOption)
            // = (sample/s) * 2^(frameSizeOption) * (1s/100)
            numSamples = (sampleRateHz << frameSizeOption) / 100;
        }
        return numSamples;
    }
    /**
     * Gets the number of SILK frames per Opus frame.
     *
     * @param packet Opus packet.
     * @returns Number of SILK frames per Opus frame.
     */ opusNumSilkFrames(packet) {
        // For computing the frame length in ms, the sample rate is not important since it cancels out. We use 48 kHz, but
        // any valid sample rate would work.
        //
        // To calculate the length of a frame (with a 48kHz sample rate) in ms:
        // (samples/frame) * (1s/48000 samples) * (1000ms/s)
        // = (samples/frame) * (1000ms/48000 samples)
        // = (samples/frame) * (1ms/48 samples)
        let frameLengthMs = this.opusPacketGetSamplesPerFrame(packet, 48000) / 48;
        if (frameLengthMs < 10) frameLengthMs = 10;
        // The number of SILK frames per Opus frame is described in https://www.rfc-editor.org/rfc/rfc6716#section-4.2.2.
        switch(frameLengthMs){
            case 10:
            case 20:
                return 1;
            case 40:
                return 2;
            case 60:
                return 3;
            // It is not possible to reach the default case since an Opus packet can only encode sizes of 2.5, 5, 10, 20, 40,
            // or 60 ms, so we ignore the default case for test coverage.
            /* istanbul ignore next */ default:
                return 0;
        }
    }
    /**
     * Gets the number of channels from an Opus packet.
     *
     * @param packet Opus packet.
     * @returns Number of channels.
     */ opusPacketGetNumChannels(packet) {
        // TOC byte format (https://www.rfc-editor.org/rfc/rfc6716#section-3.1):
        //  0
        //  0 1 2 3 4 5 6 7
        // +-+-+-+-+-+-+-+-+
        // | config  |s| c |
        // +-+-+-+-+-+-+-+-+
        // The 's' bit indicates mono or stereo audio, with 0 indicating mono and 1 indicating stereo.
        return packet.getUint8(0) & 0x4 ? 2 : 1;
    }
    /**
     * Determine the size (in bytes) of an Opus frame.
     *
     * @param packet Opus packet.
     * @param byteOffset Offset (from the start of the packet) to the byte containing the size information.
     * @param remainingBytes Remaining number of bytes to parse from the Opus packet.
     * @param sizeBytes Variable to store the parsed frame size (in bytes).
     * @returns Number of bytes that were parsed to determine the frame size.
     */ opusParseSize(packet, byteOffset, remainingBytes, sizeBytes) {
        // See https://www.rfc-editor.org/rfc/rfc6716#section-3.2.1 for an explanation of how frame size is represented.
        // If there are no remaining bytes to parse the size from, then the size cannot be determined.
        if (remainingBytes < 1) {
            sizeBytes[0] = -1;
            return -1;
        } else if (packet.getUint8(byteOffset) < 252) {
            sizeBytes[0] = packet.getUint8(byteOffset);
            return 1;
        } else if (remainingBytes < 2) {
            sizeBytes[0] = -1;
            return -1;
        } else {
            sizeBytes[0] = 4 * packet.getUint8(byteOffset + 1) + packet.getUint8(byteOffset);
            return 2;
        }
    }
    /**
     * Parse binary data containing an Opus packet into one or more Opus frames.
     *
     * @param data Binary data containing an Opus packet to be parsed. The data should begin with the first byte (i.e the
     *             TOC byte) of an Opus packet. Note that the size of the data does not have to equal the size of the
     *             contained Opus packet.
     * @param lenBytes Size of the data (in bytes).
     * @param selfDelimited Indicates if the Opus packet is self-delimiting
     *                      (https://www.rfc-editor.org/rfc/rfc6716#appendix-B).
     * @param tocByte Optional variable to store the TOC (table of contents) byte.
     * @param frameOffsets Optional variable to store the offsets (from the start of the data) to the first bytes of each
     *                     Opus frame.
     * @param frameSizes Required variable to store the sizes (in bytes) of each Opus frame.
     * @param payloadOffset Optional variable to store the offset (from the start of the data) to the first byte of the
     *                      payload.
     * @param packetLenBytes Optional variable to store the length of the Opus packet (in bytes).
     * @returns Number of Opus frames.
     */ opusPacketParseImpl(data, lenBytes, selfDelimited, tocByte, frameOffsets, frameSizes, payloadOffset, packetLenBytes) {
        if (!frameSizes || lenBytes < 0) return this.OPUS_BAD_ARG;
        if (lenBytes === 0) return this.OPUS_INVALID_PACKET;
        // The number of Opus frames in the packet.
        let numFrames;
        // Intermediate storage for the number of bytes parsed to determine the size of a frame.
        let numBytesParsed;
        // The number of the padding bytes (excluding the padding count bytes) in the packet.
        let paddingBytes = 0;
        // Indicates whether CBR (constant bitrate) framing is used.
        let cbr = false;
        // The TOC (table of contents) byte (https://www.rfc-editor.org/rfc/rfc6716#section-3.1).
        const toc = data.getUint8(0);
        // Store the TOC byte.
        if (tocByte) tocByte[0] = toc;
        // The remaining number of bytes to parse from the packet. Note that the TOC byte has already been parsed, hence the
        // minus 1.
        let remainingBytes = lenBytes - 1;
        // This keeps track of where we are in the packet. This starts at 1 since the TOC byte has already been read.
        let byteOffset = 1;
        // The size of the last Opus frame in bytes.
        let lastSizeBytes = remainingBytes;
        // Read the `c` bits (i.e. code bits) from the TOC byte.
        switch(toc & 0x3){
            // A code 0 packet (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.2) has one frame.
            case 0:
                numFrames = 1;
                break;
            // A code 1 packet (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.3) has two CBR (constant bitrate) frames.
            case 1:
                numFrames = 2;
                cbr = true;
                if (!selfDelimited) {
                    // Undelimited code 1 packets must be an even number of data bytes, otherwise the packet is invalid.
                    if (remainingBytes & 0x1) return this.OPUS_INVALID_PACKET;
                    // The sizes of both frames are equal (i.e. half of the number of data bytes).
                    lastSizeBytes = remainingBytes / 2;
                    // If `lastSizeBytes` is too large, we will catch it later.
                    frameSizes[0][0] = lastSizeBytes;
                }
                break;
            // A code 2 packet (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.4) has two VBR (variable bitrate) frames.
            case 2:
                numFrames = 2;
                numBytesParsed = this.opusParseSize(data, byteOffset, remainingBytes, frameSizes[0]);
                remainingBytes -= numBytesParsed;
                // The parsed size of the first frame cannot be larger than the number of remaining bytes in the packet.
                if (frameSizes[0][0] < 0 || frameSizes[0][0] > remainingBytes) return this.OPUS_INVALID_PACKET;
                byteOffset += numBytesParsed;
                // The size of the second frame is the remaining number of bytes after the first frame.
                lastSizeBytes = remainingBytes - frameSizes[0][0];
                break;
            // A code 3 packet (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.5) has multiple CBR/VBR frames (from 0 to
            // 120 ms).
            default:
                // Code 3 packets must have at least 2 bytes (i.e. at least 1 byte after the TOC byte).
                if (remainingBytes < 1) return this.OPUS_INVALID_PACKET;
                // Frame count byte format:
                //  0
                //  0 1 2 3 4 5 6 7
                // +-+-+-+-+-+-+-+-+
                // |v|p|     M     |
                // +-+-+-+-+-+-+-+-+
                //
                // Read the frame count byte, which immediately follows the TOC byte.
                const frameCountByte = data.getUint8(byteOffset++);
                --remainingBytes;
                // Read the 'M' bits of the frame count byte, which encode the number of frames.
                numFrames = frameCountByte & 0x3f;
                // The number of frames in a code 3 packet must not be 0.
                if (numFrames <= 0) return this.OPUS_INVALID_PACKET;
                const samplesPerFrame = this.opusPacketGetSamplesPerFrame(data, 48000);
                // A single frame can have at most 2880 samples, which happens in the case where 60ms of 48kHz audio is encoded
                // per frame. A code 3 packet cannot contain more than 120ms of audio, so the total number of samples cannot
                // exceed 2880 * 2 = 5760.
                if (samplesPerFrame * numFrames > 5760) return this.OPUS_INVALID_PACKET;
                // Parse padding bytes if the 'p' bit is 1.
                if (frameCountByte & 0x40) {
                    let paddingCountByte;
                    let numPaddingBytes;
                    // Remove padding bytes (including padding count bytes) from the remaining byte count.
                    do {
                        // Sanity check that there are enough bytes to parse and remove the padding.
                        if (remainingBytes <= 0) return this.OPUS_INVALID_PACKET;
                        // Get the next padding count byte.
                        paddingCountByte = data.getUint8(byteOffset++);
                        --remainingBytes;
                        // If the padding count byte has a value in the range 0...254, then the total size of the padding is the
                        // value in the padding count byte.
                        //
                        // If the padding count byte has value 255, then the total size of the padding is 254 plus the value in the
                        // next padding count byte. Therefore, keep reading padding count bytes while the value is 255.
                        numPaddingBytes = paddingCountByte === 255 ? 254 : paddingCountByte;
                        remainingBytes -= numPaddingBytes;
                        paddingBytes += numPaddingBytes;
                    }while (paddingCountByte === 255);
                }
                // Sanity check that the remaining number of bytes is not negative after removing the padding.
                if (remainingBytes < 0) return this.OPUS_INVALID_PACKET;
                // Read the 'v' bit (i.e. VBR bit).
                cbr = !(frameCountByte & 0x80);
                // VBR case
                if (!cbr) {
                    lastSizeBytes = remainingBytes;
                    // Let M be the number of frames. There will be M - 1 frame length indicators (which can be 1 or 2 bytes)
                    // corresponding to the lengths of frames 0 to M - 2. The size of the last frame (i.e. frame M - 1) is the
                    // number of data bytes after the end of frame M - 2 and before the start of the padding bytes.
                    for(let i = 0; i < numFrames - 1; ++i){
                        numBytesParsed = this.opusParseSize(data, byteOffset, remainingBytes, frameSizes[i]);
                        remainingBytes -= numBytesParsed;
                        // The remaining number of data bytes must be enough to contain each frame.
                        if (frameSizes[i][0] < 0 || frameSizes[i][0] > remainingBytes) return this.OPUS_INVALID_PACKET;
                        byteOffset += numBytesParsed;
                        lastSizeBytes -= numBytesParsed + frameSizes[i][0];
                    }
                    // Sanity check that the size of the last frame is not negative.
                    if (lastSizeBytes < 0) return this.OPUS_INVALID_PACKET;
                } else if (!selfDelimited) {
                    // The size of each frame is the number of data bytes divided by the number of frames.
                    lastSizeBytes = Math.trunc(remainingBytes / numFrames);
                    // The number of data bytes must be a non-negative integer multiple of the number of frames.
                    if (lastSizeBytes * numFrames !== remainingBytes) return this.OPUS_INVALID_PACKET;
                    // All frames have equal size in the undelimited CBR case.
                    for(let i = 0; i < numFrames - 1; ++i)frameSizes[i][0] = lastSizeBytes;
                }
        }
        // Self-delimited framing uses an extra 1 or 2 bytes, immediately preceding the data bytes, to indicate either the
        // size of the last frame (for code 0, code 2, and VBR code 3 packets) or the size of all the frames (for code 1 and
        // CBR code 3 packets). See https://www.rfc-editor.org/rfc/rfc6716#appendix-B.
        if (selfDelimited) {
            // The extra frame size byte(s) will always indicate the size of the last frame.
            numBytesParsed = this.opusParseSize(data, byteOffset, remainingBytes, frameSizes[numFrames - 1]);
            remainingBytes -= numBytesParsed;
            // There must be enough data bytes for the last frame.
            if (frameSizes[numFrames - 1][0] < 0 || frameSizes[numFrames - 1][0] > remainingBytes) return this.OPUS_INVALID_PACKET;
            byteOffset += numBytesParsed;
            // For CBR packets, the sizes of all the frames are equal.
            if (cbr) {
                // There must be enough data bytes for all the frames.
                if (frameSizes[numFrames - 1][0] * numFrames > remainingBytes) return this.OPUS_INVALID_PACKET;
                for(let i = 0; i < numFrames - 1; ++i)frameSizes[i][0] = frameSizes[numFrames - 1][0];
            } else if (!(numBytesParsed + frameSizes[numFrames - 1][0] <= lastSizeBytes)) return this.OPUS_INVALID_PACKET;
        } else {
            // Because the size of the last packet is not encoded explicitly, it is possible that the size of the last packet
            // (or of all the packets, for the CBR case) is larger than maximum frame size.
            if (lastSizeBytes > this.OPUS_MAX_FRAME_SIZE_BYTES) return this.OPUS_INVALID_PACKET;
            frameSizes[numFrames - 1][0] = lastSizeBytes;
        }
        // Store the offset to the start of the payload.
        if (payloadOffset) payloadOffset[0] = byteOffset;
        // Store the offsets to the start of each frame.
        for(let i = 0; i < numFrames; ++i){
            if (frameOffsets) frameOffsets[i][0] = byteOffset;
            byteOffset += frameSizes[i][0];
        }
        // Store the length of the Opus packet.
        if (packetLenBytes) packetLenBytes[0] = byteOffset + paddingBytes;
        return numFrames;
    }
    /**
     * Parse a single undelimited Opus packet into one or more Opus frames.
     *
     * @param packet Opus packet to be parsed.
     * @param lenBytes Size of the packet (in bytes).
     * @param tocByte Optional variable to store the TOC (table of contents) byte.
     * @param frameOffsets Optional variable to store the offsets (from the start of the packet) to the first bytes of
     *                     each Opus frame.
     * @param frameSizes Required variable to store the sizes (in bytes) of each Opus frame.
     * @param payloadOffset Optional variable to store the offset (from the start of the packet) to the first byte of the
     *                      payload.
     * @returns Number of Opus frames.
     */ opusPacketParse(packet, lenBytes, tocByte, frameOffsets, frameSizes, payloadOffset) {
        return this.opusPacketParseImpl(packet, lenBytes, /* selfDelimited */ false, tocByte, frameOffsets, frameSizes, payloadOffset, null);
    }
    /**
     * This function returns the SILK VAD (voice activity detection) information encoded in the Opus packet. For CELT-only
     * packets that do not have VAD information, it returns -1.
     *
     * @param packet Opus packet.
     * @param lenBytes Size of the packet (in bytes).
     * @returns  0: no frame had the VAD flag set.
     *           1: at least one frame had the VAD flag set.
     *          -1: VAD status could not be determined.
     */ opusPacketHasVoiceActivity(packet, lenBytes) {
        if (!packet || lenBytes <= 0) return 0;
        // In CELT-only mode, we can not determine whether there is VAD.
        if (this.opusPacketIsCeltOnly(packet)) return -1;
        const numSilkFrames = this.opusNumSilkFrames(packet);
        // It is not possible for `opusNumSilkFrames()` to return 0, so we ignore the next sanity check for test coverage.
        /* istanbul ignore next */ if (numSilkFrames === 0) return -1;
        const opusFrameOffsets = new Array(this.OPUS_MAX_OPUS_FRAMES);
        const opusFrameSizes = new Array(this.OPUS_MAX_OPUS_FRAMES);
        for(let i = 0; i < this.OPUS_MAX_OPUS_FRAMES; ++i){
            opusFrameOffsets[i] = [
                undefined
            ];
            opusFrameSizes[i] = [
                undefined
            ];
        }
        // Parse packet to get the Opus frames.
        const numOpusFrames = this.opusPacketParse(packet, lenBytes, null, opusFrameOffsets, opusFrameSizes, null);
        // VAD status cannot be determined for invalid packets.
        if (numOpusFrames < 0) return -1;
        // Iterate over all Opus frames, which may contain multiple SILK frames, to determine the VAD status.
        for(let i = 0; i < numOpusFrames; ++i){
            if (opusFrameSizes[i][0] < 1) continue;
            // LP layer header bits format (https://www.rfc-editor.org/rfc/rfc6716#section-4.2.3):
            //
            // Mono case:
            // +-----------------+----------+
            // | 1 to 3 VAD bits | LBRR bit |
            // +-----------------+----------+
            //
            // Stereo case:
            // +---------------------+--------------+----------------------+---------------+
            // | 1 to 3 mid VAD bits | mid LBRR bit | 1 to 3 side VAD bits | side LBRR bit |
            // +---------------------+--------------+----------------------+---------------+
            // The upper 1 to 3 bits (dependent on the number of SILK frames) of the LP layer contain VAD bits. If any of
            // these VAD bits are 1, then voice activity is present.
            if (packet.getUint8(opusFrameOffsets[i][0]) >> 8 - numSilkFrames) return 1;
            // In the stereo case, there is a second set of 1 to 3 VAD bits, so also check these VAD bits.
            const channels = this.opusPacketGetNumChannels(packet);
            if (channels === 2 && packet.getUint8(opusFrameOffsets[i][0]) << numSilkFrames + 1 >> 8 - numSilkFrames) return 1;
        }
        // No voice activity was detected.
        return 0;
    }
    /**
     * This method is based on Definition of the Opus Audio Codec
     * (https://tools.ietf.org/html/rfc6716). Basically, this method is based on
     * parsing the LP layer of an Opus packet, particularly the LBRR flag.
     *
     * @param packet Opus packet.
     * @param lenBytes Size of the packet (in bytes).
     * @returns  true: packet has fec encoding about previous packet.
     *           false: no fec encoding present.
     */ opusPacketHasFec(packet, lenBytes) {
        if (!packet || lenBytes <= 0) return false;
        // In CELT-only mode, packets should not have FEC.
        if (this.opusPacketIsCeltOnly(packet)) return false;
        const opusFrameOffsets = new Array(this.OPUS_MAX_OPUS_FRAMES);
        const opusFrameSizes = new Array(this.OPUS_MAX_OPUS_FRAMES);
        for(let i = 0; i < this.OPUS_MAX_OPUS_FRAMES; ++i){
            opusFrameOffsets[i] = [
                undefined
            ];
            opusFrameSizes[i] = [
                undefined
            ];
        }
        // Parse packet to get the Opus frames.
        const numOpusFrames = this.opusPacketParse(packet, lenBytes, null, opusFrameOffsets, opusFrameSizes, null);
        if (numOpusFrames < 0) return false;
        /* istanbul ignore next */ if (opusFrameSizes[0][0] <= 1) return false;
        const numSilkFrames = this.opusNumSilkFrames(packet);
        /* istanbul ignore next */ if (numSilkFrames === 0) return false;
        const channels = this.opusPacketGetNumChannels(packet);
        /* istanbul ignore next */ if (channels !== 1 && channels !== 2) return false;
        // A frame starts with the LP layer. The LP layer begins with two to eight
        // header bits.These consist of one VAD bit per SILK frame (up to 3),
        // followed by a single flag indicating the presence of LBRR frames.
        // For a stereo packet, these first flags correspond to the mid channel, and
        // a second set of flags is included for the side channel. Because these are
        // the first symbols decoded by the range coder and because they are coded
        // as binary values with uniform probability, they can be extracted directly
        // from the most significant bits of the first byte of compressed data.
        for(let i = 0; i < channels; i++){
            if (packet.getUint8(opusFrameOffsets[0][0]) & 0x80 >> (i + 1) * (numSilkFrames + 1) - 1) return true;
        }
        return false;
    }
}
module.exports.default = $d321b6779e51f72b$var$RedundantAudioEncodedTransform;

});



parcelRegister("2aVcU", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $1958e419478ae7c5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j8SWf = parcelRequire("j8SWf");

const $1958e419478ae7c5$var$EventIngestionConfiguration_1 = $1958e419478ae7c5$var$__importDefault((parcelRequire("dYglD")));

const $1958e419478ae7c5$var$DefaultMeetingEventReporter_1 = $1958e419478ae7c5$var$__importDefault((parcelRequire("559vU")));

const $1958e419478ae7c5$var$MeetingEventsClientConfiguration_1 = $1958e419478ae7c5$var$__importDefault((parcelRequire("dgjnv")));

const $1958e419478ae7c5$var$AsyncScheduler_1 = $1958e419478ae7c5$var$__importDefault((parcelRequire("4mLYP")));

const $1958e419478ae7c5$var$DefaultUserAgentParser_1 = $1958e419478ae7c5$var$__importDefault((parcelRequire("lV7ga")));

const $1958e419478ae7c5$var$Versioning_1 = $1958e419478ae7c5$var$__importDefault((parcelRequire("c0dn0")));

const $1958e419478ae7c5$var$flattenEventAttributes_1 = $1958e419478ae7c5$var$__importDefault((parcelRequire("4saPh")));
class $1958e419478ae7c5$var$DefaultEventController {
    constructor(configuration, logger, eventReporter){
        this.meetingHistoryStates = [];
        this.observerSet = new Set();
        this.highEntropyUpdated = null;
        this.destroyed = false;
        this.logger = logger;
        this.configuration = configuration;
        this.setupEventReporter(configuration, logger, eventReporter);
        this.userAgentParser = new $1958e419478ae7c5$var$DefaultUserAgentParser_1.default(logger);
        this.parserResult = this.userAgentParser.getParserResult();
    }
    updateAttributesWithHighEntropyValues() {
        if (!this.highEntropyUpdated) this.highEntropyUpdated = (async ()=>{
            await this.userAgentParser.updateWithHighEntropyValues();
            this.parserResult = this.userAgentParser.getParserResult();
        })();
        return this.highEntropyUpdated;
    }
    addObserver(observer) {
        this.observerSet.add(observer);
    }
    removeObserver(observer) {
        this.observerSet.delete(observer);
    }
    forEachObserver(observerFunc) {
        for (const observer of this.observerSet)$1958e419478ae7c5$var$AsyncScheduler_1.default.nextTick(()=>{
            /* istanbul ignore else */ if (this.observerSet.has(observer)) observerFunc(observer);
        });
    }
    async publishEvent(name, attributes) {
        await this.updateAttributesWithHighEntropyValues();
        const timestampMs = Date.now();
        this.meetingHistoryStates.push({
            name: name,
            timestampMs: timestampMs
        });
        // Make a single frozen copy of the event, reusing the object returned by
        // `getAttributes` to avoid copying too much.
        const eventAttributes = Object.freeze(Object.assign(this.getAttributes(timestampMs), attributes));
        // Publishes event to observers
        this.forEachObserver((observer)=>{
            observer.eventDidReceive(name, eventAttributes);
        });
        // Reports event to the ingestion service
        this.reportEvent(name, timestampMs, attributes);
    }
    async reportEvent(name, timestampMs, attributes) {
        var _a;
        let flattenedAttributes;
        try {
            if (attributes) flattenedAttributes = (0, $1958e419478ae7c5$var$flattenEventAttributes_1.default)(attributes);
            await ((_a = this.eventReporter) === null || _a === void 0 ? void 0 : _a.reportEvent(timestampMs, name, flattenedAttributes));
        } catch (error) {
            /* istanbul ignore next */ this.logger.error(`Error reporting event ${error}`);
        }
    }
    setupEventReporter(configuration, logger, eventReporter) {
        if (eventReporter) this._eventReporter = eventReporter;
        else if (configuration.urls) {
            // Attempts to set up a event reporter using the meeting configuration if one is not provided
            const eventIngestionURL = configuration.urls.eventIngestionURL;
            if (eventIngestionURL) {
                this.logger.info(`Event ingestion URL is present in the configuration`);
                const { meetingId: meetingId, credentials: { attendeeId: attendeeId, joinToken: joinToken } } = configuration;
                const meetingEventsClientConfiguration = new $1958e419478ae7c5$var$MeetingEventsClientConfiguration_1.default(meetingId, attendeeId, joinToken);
                const eventIngestionConfiguration = new $1958e419478ae7c5$var$EventIngestionConfiguration_1.default(meetingEventsClientConfiguration, eventIngestionURL);
                this._eventReporter = new $1958e419478ae7c5$var$DefaultMeetingEventReporter_1.default(eventIngestionConfiguration, logger);
            }
        }
    }
    getAttributes(timestampMs) {
        return {
            attendeeId: this.configuration.credentials.attendeeId,
            browserMajorVersion: this.parserResult.browserMajorVersion,
            browserName: this.parserResult.browserName,
            browserVersion: this.parserResult.browserVersion,
            deviceName: this.parserResult.deviceName,
            externalMeetingId: typeof this.configuration.externalMeetingId === 'string' ? this.configuration.externalMeetingId : '',
            externalUserId: this.configuration.credentials.externalUserId,
            meetingHistory: this.meetingHistoryStates,
            meetingId: this.configuration.meetingId,
            osName: this.parserResult.osName,
            osVersion: this.parserResult.osVersion,
            sdkVersion: $1958e419478ae7c5$var$Versioning_1.default.sdkVersion,
            sdkName: $1958e419478ae7c5$var$Versioning_1.default.sdkName,
            timestampMs: timestampMs
        };
    }
    get eventReporter() {
        return this._eventReporter;
    }
    /**
     * Clean up this instance and resources that it created.
     *
     * After calling `destroy`, internal fields like `eventReporter` will be unavailable.
     */ async destroy() {
        if ((0, $j8SWf.isDestroyable)(this.eventReporter)) await this.eventReporter.destroy();
        this.logger = undefined;
        this.configuration = undefined;
        this._eventReporter = undefined;
        this.destroyed = true;
    }
}
module.exports.default = $1958e419478ae7c5$var$DefaultEventController;

});
parcelRegister("j8SWf", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDestroyable = $0398aadc282c1f40$var$isDestroyable;
/**
 * Type guard for `Destroyable`.
 *
 * @param x A value that might implement the `Destroyable` interface.
 * @returns Whether the value implements `Destroyable`.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0398aadc282c1f40$var$isDestroyable(x) {
    return x && 'destroy' in x;
}

});

parcelRegister("dYglD", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $a2bd8f51d650c6a3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $a2bd8f51d650c6a3$var$EventBufferConfiguration_1 = $a2bd8f51d650c6a3$var$__importDefault((parcelRequire("aMP28")));
/**
 * [[EventIngestionConfiguration]] contains necessary information to
 * report events to the ingestion service.
 */ class $a2bd8f51d650c6a3$var$EventIngestionConfiguration {
    constructor(eventsClientConfiguration, ingestionURL, eventBufferConfiguration = new $a2bd8f51d650c6a3$var$EventBufferConfiguration_1.default()){
        this.eventsClientConfiguration = eventsClientConfiguration;
        this.ingestionURL = ingestionURL;
        this.eventBufferConfiguration = eventBufferConfiguration;
    }
}
module.exports.default = $a2bd8f51d650c6a3$var$EventIngestionConfiguration;

});
parcelRegister("aMP28", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[EventBufferConfiguration]] contains necessary information to
 * configure buffer.
 */ class $7da5f942616a8788$var$EventBufferConfiguration {
    constructor(flushIntervalMs = 5000, flushSize = 2, maxBufferCapacityKb = 64, totalBufferItems = 100, retryCountLimit = 15){
        this.flushIntervalMs = flushIntervalMs;
        this.flushSize = flushSize;
        this.maxBufferCapacityKb = maxBufferCapacityKb;
        this.totalBufferItems = totalBufferItems;
        this.retryCountLimit = retryCountLimit;
    }
}
module.exports.default = $7da5f942616a8788$var$EventBufferConfiguration;

});


parcelRegister("559vU", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $3b34cc9cf6f2ccf4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j8SWf = parcelRequire("j8SWf");

const $3b34cc9cf6f2ccf4$var$InMemoryJSONEventBuffer_1 = $3b34cc9cf6f2ccf4$var$__importDefault((parcelRequire("7UxXU")));
class $3b34cc9cf6f2ccf4$var$DefaultMeetingEventReporter {
    constructor(eventIngestionConfiguration, logger){
        this.reportingEvents = false;
        this.importantEvents = [
            'meetingEnded',
            'meetingFailed',
            'meetingStartFailed',
            'audioInputFailed',
            'videoInputFailed',
            'meetingStartSucceeded',
            'deviceLabelTriggerFailed'
        ];
        this.destroyed = false;
        const { eventsClientConfiguration: eventsClientConfiguration, ingestionURL: ingestionURL, eventBufferConfiguration: eventBufferConfiguration } = eventIngestionConfiguration;
        const { eventsToIgnore: eventsToIgnore } = eventsClientConfiguration;
        this.eventBuffer = new $3b34cc9cf6f2ccf4$var$InMemoryJSONEventBuffer_1.default(eventBufferConfiguration, eventsClientConfiguration, ingestionURL, this.importantEvents, logger);
        this.logger = logger;
        this.eventsToIgnore = eventsToIgnore;
        this.start();
    }
    start() {
        if (this.reportingEvents) return;
        try {
            this.eventBuffer.start();
            this.logger.info('Event reporting started');
            this.reportingEvents = true;
        } catch (error) {
            /* istanbul ignore next */ this.logger.error(`Event Reporting - Error starting the event buffer ${error}`);
        }
    }
    stop() {
        if (!this.reportingEvents) return;
        try {
            this.eventBuffer.stop();
            this.logger.info('Event reporting stopped');
            this.reportingEvents = false;
        } catch (error) {
            /* istanbul ignore next */ this.logger.error(`Event Reporting - Error stopping the event buffer ${error}`);
        }
    }
    async reportEvent(ts, name, attributes) {
        this.logger.debug(`Event Reporting - DefaultMeetingEventReporter - event received in reportEvent ${ts}, ${name}, ${JSON.stringify(attributes)}`);
        if (this.eventsToIgnore.includes(name)) {
            this.logger.debug(`Event Reporting - DefaultMeetingEventReporter - ${name} event will be ignored as it is in events to ignore`);
            return;
        }
        try {
            this.logger.debug(`Event Reporting - DefaultMeetingEventReporter - adding item to event buffer`);
            await this.eventBuffer.addItem({
                ts: ts,
                name: name,
                attributes: attributes
            });
        } catch (error) {
            this.logger.error(`Event Reporting - Error adding event to buffer ${error}`);
        }
    }
    async destroy() {
        this.destroyed = true;
        this.stop();
        /* istanbul ignore else */ if ((0, $j8SWf.isDestroyable)(this.eventBuffer)) this.eventBuffer.destroy();
        this.eventBuffer = undefined;
    }
}
module.exports.default = $3b34cc9cf6f2ccf4$var$DefaultMeetingEventReporter;

});
parcelRegister("7UxXU", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $5c281c2f9c48af8e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $5c281c2f9c48af8e$var$FullJitterBackoff_1 = $5c281c2f9c48af8e$var$__importDefault((parcelRequire("84f4q")));

const $5c281c2f9c48af8e$var$IntervalScheduler_1 = $5c281c2f9c48af8e$var$__importDefault((parcelRequire("4wGp7")));

const $5c281c2f9c48af8e$var$DefaultUserAgentParser_1 = $5c281c2f9c48af8e$var$__importDefault((parcelRequire("lV7ga")));

var $9UH7r = parcelRequire("9UH7r");
/**
 * [[InMemoryJSONEventBuffer]] is an in-memory implementation for buffering and
 * sending events. It buffers events based on number of events and its size whichever reaches
 * first. Events are sent out at an scheduled interval where important events are sent immediately.
 * It also retries sending events if failed upto the retry count limit. It implements
 * beaconing mechanism based on 'pagehide' and 'visibilitychange' to beacon all events as a last attempt.
 */ class $5c281c2f9c48af8e$var$InMemoryJSONEventBuffer {
    constructor(eventBufferConfiguration, eventsClientConfiguration, ingestionURL, importantEvents, logger){
        this.buffer = [];
        this.bufferSize = 0;
        this.maxBufferItemCapacityBytes = 0;
        this.ingestionEventSize = 0;
        this.flushIntervalMs = 0;
        this.flushSize = 0;
        this.failedIngestionEvents = [];
        this.retryCountLimit = 15;
        this.lock = false;
        this.highEntropyUpdated = false;
        this.cancellableEvents = new Map();
        this.attributesToFilter = [
            'externalUserId',
            'externalMeetingId',
            'timestampMs'
        ];
        this.deepCopyCurrentIngestionEvent = (event)=>{
            const newEvent = {
                type: event.type,
                v: event.v,
                payloads: [
                    ...event.payloads
                ]
            };
            return newEvent;
        };
        this.sendEvents = async ()=>{
            if (this.lock) return;
            const batch = this.getItems(this.flushSize);
            if (batch.length === 0) return;
            this.lock = true;
            await this.updateMetadataWithHighEntropyValues();
            const body = this.makeRequestBody(batch);
            let failed = false;
            // If a page re-directs, in Safari and Chrome, the network
            // request shows cancelled but the data reaches the ingestion endpoint.
            // In Firefox, the request errors out with 'NS_BINDING_ABORT' state. Hence, add the event
            // to cancellable events to try with `sendBeacon` lastly.
            const timestamp = Date.now();
            if (this.metadata.browserName.toLowerCase() === 'firefox') this.cancellableEvents.set(timestamp, batch);
            try {
                this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - sendEvents - sending body ${body}`);
                const response = await this.send(body);
                this.cancellableEvents.delete(timestamp);
                if (!response.ok) {
                    this.logger.error(`Event Reporting - InMemoryJSONEventBuffer - sendEvents - Failed to send events ${body} with response status ${response.status}`);
                    failed = true;
                } else try {
                    const data = await response.json();
                    this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - sendEvents - send successful events: ${body} message: ${JSON.stringify(data)}`);
                } catch (err) {
                    /* istanbul ignore next */ this.logger.warn(`Event Reporting - InMemoryJSONEventBuffer - sendEvents error reading OK response ${err} for events ${body}`);
                }
            } catch (error) {
                failed = true;
                this.logger.warn(`Event Reporting - InMemoryJSONEventBuffer - sendEvents - Error in sending events ${body} to the ingestion endpoint ${error}`);
            } finally{
                this.lock = false;
            }
            if (failed) {
                this.cancellableEvents.delete(timestamp);
                this.failedIngestionEvents.push(...batch);
            }
        };
        this.userAgentParser = new $5c281c2f9c48af8e$var$DefaultUserAgentParser_1.default(logger);
        const userAgentParserResult = this.userAgentParser.getParserResult();
        const { browserMajorVersion: _browserMajorVersion, ...clientMetadata } = userAgentParserResult;
        const { type: type, v: v, ...rest } = eventsClientConfiguration.toJSON();
        this.authenticationToken = eventsClientConfiguration.getAuthenticationToken();
        this.metadata = {
            ...clientMetadata,
            ...rest
        };
        Object.keys(this.metadata).forEach((key)=>this.attributesToFilter.push(key));
        this.type = type;
        this.v = v;
        this.ingestionURL = ingestionURL;
        this.logger = logger;
        this.importantEvents = new Set(importantEvents);
        const { maxBufferCapacityKb: maxBufferCapacityKb, totalBufferItems: totalBufferItems, flushSize: flushSize, flushIntervalMs: flushIntervalMs, retryCountLimit: retryCountLimit } = eventBufferConfiguration;
        this.maxBufferCapacityBytes = maxBufferCapacityKb * 1024;
        this.totalBufferItems = totalBufferItems;
        this.maxBufferItemCapacityBytes = Math.round(this.maxBufferCapacityBytes / totalBufferItems);
        this.flushIntervalMs = flushIntervalMs;
        this.flushSize = flushSize;
        this.retryCountLimit = retryCountLimit;
        this.currentIngestionEvent = this.initializeAndGetCurrentIngestionEvent();
        this.beaconEventListener = (e)=>this.beaconEventHandler(e);
        this.addEventListeners();
    }
    async updateMetadataWithHighEntropyValues() {
        if (this.highEntropyUpdated) return;
        this.highEntropyUpdated = true;
        await this.userAgentParser.updateWithHighEntropyValues();
        const userAgentParserResult = this.userAgentParser.getParserResult();
        const { browserMajorVersion: _browserMajorVersion, ...clientMetadata } = userAgentParserResult;
        // Update metadata with high entropy values
        this.metadata = {
            ...this.metadata,
            ...clientMetadata
        };
    }
    addEventListeners() {
        if (!this.beaconEventListener || !('window' in $parcel$global) || !window.addEventListener || !('document' in $parcel$global) || !document.addEventListener) return;
        this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - addEventListeners - adding pagehide and visibility change event listeners`);
        window.addEventListener('pagehide', this.beaconEventListener);
        document.addEventListener('visibilitychange', this.beaconEventListener);
    }
    beaconEventHandler(e) {
        /* istanbul ignore else */ if (e.type === 'visibilitychange' && document.visibilityState === 'hidden' || e.type === 'pagehide') {
            this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - beaconEventHandler is triggered calling sendBeacon`);
            this.sendBeacon();
        }
    }
    removeEventListeners() {
        if (!this.beaconEventListener || !('window' in $parcel$global) || !window.removeEventListener || !('document' in $parcel$global) || !document.removeEventListener) return;
        window.removeEventListener('pagehide', this.beaconEventListener);
        document.removeEventListener('visibilitychange', this.beaconEventListener);
        this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - removeEventListeners - removing pagehide and visibility change event listeners`);
    }
    start() {
        var _a;
        this.removeEventListeners();
        this.addEventListeners();
        (_a = this.intervalScheduler) === null || _a === void 0 || _a.stop();
        this.intervalScheduler = new $5c281c2f9c48af8e$var$IntervalScheduler_1.default(this.flushIntervalMs);
        this.intervalScheduler.start(()=>this.sendEvents());
    }
    stop() {
        var _a;
        (_a = this.intervalScheduler) === null || _a === void 0 || _a.stop();
        this.intervalScheduler = undefined;
        this.sendBeacon();
        this.removeEventListeners();
    }
    async addItem(item) {
        this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - addItem - received event ${JSON.stringify(item)}`);
        const { name: name, ts: ts, attributes: attributes } = item;
        // Filter out PII and redundant attributes.
        const filteredAttributes = attributes && this.filterAttributes(attributes, this.attributesToFilter);
        const event = {
            name: name,
            ts: ts,
            ...filteredAttributes
        };
        this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - addItem - event after filtering attributes ${JSON.stringify(event)}`);
        const size = this.getSize(event);
        if (size > $5c281c2f9c48af8e$var$InMemoryJSONEventBuffer.MAX_ITEM_SIZE_BYTES_ALLOWED) throw new Error(`Event Reporting - Item to be added has size ${size} bytes. Item cannot exceed max item size allowed of ${$5c281c2f9c48af8e$var$InMemoryJSONEventBuffer.MAX_ITEM_SIZE_BYTES_ALLOWED} bytes.`);
        if (this.importantEvents.has(name)) {
            // Send immediate events and asyncly retry.
            this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - addItem - sending important event ${JSON.stringify(event)}`);
            this.sendEventImmediately({
                name: name,
                ts: ts,
                attributes: filteredAttributes
            });
            return;
        }
        if (this.isFull()) {
            this.logger.warn('Event Reporting - Event buffer is full');
            throw new Error('Buffer full');
        }
        this.currentIngestionEvent.payloads.push(event);
        this.ingestionEventSize += size;
        if (this.bufferItemThresholdReached(size)) {
            const currentEvent = this.deepCopyCurrentIngestionEvent(this.currentIngestionEvent);
            this.buffer.push(currentEvent);
            this.bufferSize += this.ingestionEventSize;
            this.currentIngestionEvent = this.initializeAndGetCurrentIngestionEvent();
            this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - addItem - buffer item threshold reached updated buffer ${JSON.stringify(this.buffer)}`);
        }
    }
    filterAttributes(attributes, attributesToFilter) {
        const attributesToFilterSet = new Set(attributesToFilter);
        const keysToFilterOut = Object.keys(attributes).filter((key)=>attributesToFilterSet.has(key));
        keysToFilterOut.forEach((key)=>delete attributes[key]);
        return attributes;
    }
    initializeAndGetCurrentIngestionEvent() {
        const bufferItem = {
            type: this.type,
            v: this.v,
            payloads: []
        };
        this.ingestionEventSize = this.getSize(bufferItem);
        return bufferItem;
    }
    bufferItemThresholdReached(size) {
        return size + this.ingestionEventSize >= this.maxBufferItemCapacityBytes || this.currentIngestionEvent.payloads.length === $5c281c2f9c48af8e$var$InMemoryJSONEventBuffer.MAX_PAYLOAD_ITEMS;
    }
    getSize(item) {
        let bytes = 0;
        if (typeof item === 'object') for (const [key, value] of Object.entries(item)){
            bytes += this.getPrimitiveSize(key);
            bytes += this.getSize(value);
        }
        else bytes += this.getPrimitiveSize(item);
        return bytes;
    }
    getPrimitiveSize(item) {
        let bytes = 0;
        /* istanbul ignore else */ if (typeof item === 'string') bytes += item.length * 2;
        else if (typeof item === 'number') bytes += 8;
        return bytes;
    }
    isFull() {
        return this.bufferSize === this.maxBufferCapacityBytes || this.buffer.length === this.totalBufferItems;
    }
    isEmpty() {
        return this.buffer.length === 0 || this.bufferSize === 0;
    }
    getItems(end, start = 0) {
        if (this.isEmpty()) return [];
        end = Math.min(this.buffer.length, end + 1);
        const items = this.buffer.splice(start, end);
        return items;
    }
    makeBeaconRequestBody(batchEvents) {
        const ingestionRecord = {
            metadata: this.metadata,
            events: batchEvents,
            authorization: this.authenticationToken
        };
        return JSON.stringify(ingestionRecord);
    }
    makeRequestBody(batchEvents) {
        const ingestionRecord = {
            metadata: this.metadata,
            events: batchEvents
        };
        return JSON.stringify(ingestionRecord);
    }
    async sendEventImmediately(item) {
        this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - sendEventImmediately - important event received ${JSON.stringify(item)}`);
        await this.updateMetadataWithHighEntropyValues();
        const { name: name, ts: ts, attributes: attributes } = item;
        const event = {
            type: this.type,
            v: this.v,
            payloads: [
                {
                    name: name,
                    ts: ts,
                    ...attributes
                }
            ]
        };
        let failed = false;
        let response = null;
        const body = this.makeRequestBody([
            event
        ]);
        try {
            response = await this.send(body);
            if (response.ok) {
                try {
                    const data = await response.json();
                    this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - sendEventImmediately - send successful event: ${body}, message: ${JSON.stringify(data)}`);
                } catch (err) {
                    /* istanbul ignore next */ this.logger.warn(`Event Reporting - InMemoryJSONEventBuffer - sendEventImmediately - Error reading OK response ${err} for event ${body}`);
                }
                return;
            } else {
                this.logger.error(`Event Reporting - InMemoryJSONEventBuffer - sendEventImmediately - Failed to send an important event ${body} with response status ${response.status}`);
                failed = true;
            }
        } catch (error) {
            this.logger.warn(`Event Reporting - There may be a failure in sending an important event ${body} to the ingestion endpoint ${error}.`);
            failed = true;
            try {
                /**
                 * Important events like meetingEnded, meetingStartFailed may result into page-redirects.
                 * In such a case, Firefox aborts the fetch request with 'NS_BINDING_ABORT' state.
                 * Chrome and Safari show fetch request as cancelled and the fetch failure is catched, but,
                 * events appear at ingestion backend. Chrome and Safari behavior is unreliable, but Firefox consistently fails,
                 * hence, we beacon data as a last resort when using Firefox.
                 * During the page-redirect, we do not have access to check fetch's response to handle Chrome and Safari behavior,
                 * hence, event ingestion may fail.
                 *
                 */ if (this.metadata.browserName.toLowerCase() === 'firefox') {
                    const body = this.makeBeaconRequestBody([
                        event
                    ]);
                    this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - sendEventImmediately - beaconing data out ${body}`);
                    if (!navigator.sendBeacon(`${this.ingestionURL}?beacon=1`, body)) failed = true;
                    else failed = false;
                }
            } catch (error) {
                this.logger.warn(`Event Reporting - Error sending beacon for an important event ${body}`);
                failed = true;
            }
        }
        /* istanbul ignore else */ if (failed) {
            this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - sendEventImmediately - pushing to failed events ${body}`);
            this.failedIngestionEvents.push(event);
        }
    }
    async send(data) {
        const backoff = new $5c281c2f9c48af8e$var$FullJitterBackoff_1.default($5c281c2f9c48af8e$var$InMemoryJSONEventBuffer.RETRY_FIXED_BACKOFF_WAIT_MS, $5c281c2f9c48af8e$var$InMemoryJSONEventBuffer.RETRY_SHORT_BACKOFF_MS, $5c281c2f9c48af8e$var$InMemoryJSONEventBuffer.RETRY_LONG_BACKOFF_MS);
        try {
            let retryCount = 0;
            while(retryCount < this.retryCountLimit){
                const response = await fetch(this.ingestionURL, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${this.authenticationToken}`
                    },
                    body: data
                });
                if (response.ok || !$5c281c2f9c48af8e$var$InMemoryJSONEventBuffer.SENDING_FAILURE_CODES.has(response.status)) return response;
                else {
                    this.logger.warn(`Will retry sending failure for ${data} due to status code ${response.status}.`);
                    retryCount++;
                    /* istanbul ignore else */ if (retryCount < this.retryCountLimit) {
                        const backoffTime = backoff.nextBackoffAmountMs();
                        await (0, $9UH7r.wait)(backoffTime);
                    }
                }
            }
            /* istanbul ignore else */ if (retryCount === this.retryCountLimit) throw new Error(`Retry count limit reached for ${data}`);
        } catch (error) {
            throw error;
        }
    }
    async sendBeacon() {
        // Any pending events from buffer.
        const events = this.buffer;
        this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - sendBeacon - clearing out buffer events ${JSON.stringify(events)}`);
        this.buffer = [];
        // Any pending event in current ingestion event.
        if (this.currentIngestionEvent.payloads.length > 0) {
            const clearCurrenIngestionEvent = this.deepCopyCurrentIngestionEvent(this.currentIngestionEvent);
            events.push(clearCurrenIngestionEvent);
            this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - sendBeacon - clearing out current ingestion event ${JSON.stringify(clearCurrenIngestionEvent)}`);
            this.currentIngestionEvent = this.initializeAndGetCurrentIngestionEvent();
        }
        // Any failed ingestion events which were sent before.
        if (this.failedIngestionEvents.length > 0) {
            const failedRecordsCopy = this.failedIngestionEvents.map((record)=>this.deepCopyCurrentIngestionEvent(record));
            events.push(...failedRecordsCopy);
            this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - sendBeacon - clearing out any failed ingestion event ${JSON.stringify(failedRecordsCopy)}`);
            this.failedIngestionEvents = [];
        }
        // Any cancelled requests due to page-redirects.
        if (this.cancellableEvents.size > 0) {
            this.cancellableEvents.forEach((value)=>{
                events.push(...value);
                this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - sendBeacon - clearing out each cancellable event ${JSON.stringify(value)}`);
            });
            this.cancellableEvents.clear();
        }
        if (events.length === 0) return;
        const beaconData = this.makeBeaconRequestBody(events);
        this.logger.debug(`Event Reporting - InMemoryJSONEventBuffer - sendBeacon - beacon data to send ${beaconData}`);
        try {
            /* istanbul ignore else */ if (!navigator.sendBeacon(`${this.ingestionURL}?beacon=1`, beaconData)) this.logger.warn(`Event Reporting - Browser failed to queue beacon data ${beaconData}`);
        } catch (error) {
            this.logger.warn(`Event Reporting - Sending beacon data ${beaconData} failed with error ${error}`);
        }
    }
    reset() {
        this.maxBufferCapacityBytes = 0;
        this.totalBufferItems = 0;
        this.buffer = [];
        this.bufferSize = 0;
        this.maxBufferItemCapacityBytes = 0;
        this.ingestionEventSize = 0;
        this.flushIntervalMs = 0;
        this.flushSize = 0;
        this.failedIngestionEvents = [];
        this.lock = false;
        this.beaconEventListener = undefined;
        this.cancellableEvents.clear();
    }
    async destroy() {
        this.stop();
        this.reset();
    }
}
$5c281c2f9c48af8e$var$InMemoryJSONEventBuffer.SENDING_FAILURE_CODES = new Set([
    408,
    429,
    500,
    502,
    503,
    504
]);
$5c281c2f9c48af8e$var$InMemoryJSONEventBuffer.RETRY_FIXED_BACKOFF_WAIT_MS = 0;
$5c281c2f9c48af8e$var$InMemoryJSONEventBuffer.RETRY_SHORT_BACKOFF_MS = 1000;
$5c281c2f9c48af8e$var$InMemoryJSONEventBuffer.RETRY_LONG_BACKOFF_MS = 15000;
$5c281c2f9c48af8e$var$InMemoryJSONEventBuffer.MAX_PAYLOAD_ITEMS = 2;
$5c281c2f9c48af8e$var$InMemoryJSONEventBuffer.MAX_ITEM_SIZE_BYTES_ALLOWED = 3000;
module.exports.default = $5c281c2f9c48af8e$var$InMemoryJSONEventBuffer;

});
parcelRegister("84f4q", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Implements the [Full Jitter algorithm](
 * https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/)
 * and also allows for specifying a fixed wait added to the full jitter backoff
 * (which can be zero).
 */ class $5dfa6319197b9d18$var$FullJitterBackoff {
    constructor(fixedWaitMs, shortBackoffMs, longBackoffMs){
        this.fixedWaitMs = fixedWaitMs;
        this.shortBackoffMs = shortBackoffMs;
        this.longBackoffMs = longBackoffMs;
        this.currentRetry = 0;
        if (this.fixedWaitMs < 0) this.fixedWaitMs = 0;
        if (this.shortBackoffMs < 0) this.shortBackoffMs = 0;
        if (this.longBackoffMs < 0) this.longBackoffMs = 0;
        this.reset();
    }
    reset() {
        this.currentRetry = 0;
    }
    nextBackoffAmountMs() {
        const fullJitterMs = Math.random() * Math.min(this.longBackoffMs, this.shortBackoffMs * Math.pow(2.0, this.currentRetry)) + this.fixedWaitMs;
        this.currentRetry += 1;
        return fullJitterMs;
    }
}
module.exports.default = $5dfa6319197b9d18$var$FullJitterBackoff;

});



parcelRegister("dgjnv", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[MeetingEventsClientConfiguration]] contains necessary information to
 * report meeting events metadata to each event while sending events to the ingestion service.
 */ class $9a7bcd153573a225$var$MeetingEventsClientConfiguration {
    constructor(meetingId, attendeeId, authenticationToken, eventsToIgnore = []){
        this.type = 'Meet';
        this.v = 1;
        this.meetingId = meetingId;
        this.attendeeId = attendeeId;
        this.eventsToIgnore = eventsToIgnore;
        this.authenticationToken = authenticationToken;
    }
    getAuthenticationToken() {
        return this.authenticationToken;
    }
    toJSON() {
        const attributes = {};
        attributes.type = this.type;
        attributes.v = this.v;
        attributes.meetingId = this.meetingId;
        attributes.attendeeId = this.attendeeId;
        return attributes;
    }
}
module.exports.default = $9a7bcd153573a225$var$MeetingEventsClientConfiguration;

});

parcelRegister("4saPh", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 *
 * @param attributes Event attributes to flatten.
 * @returns flattened event attributes.
 * Note: This function needs to be extended to support 'Array', 'object'
 * as value types within the event attributes if added later.
 */ const $33e22ccf7fa2e6ba$var$flattenEventAttributes = (attributes)=>{
    const flattenedAttributes = {};
    for (const [key, value] of Object.entries(attributes)){
        if (value === null || value === undefined || value === '') continue;
        else if (typeof value === 'number' || typeof value === 'string') flattenedAttributes[key] = value;
        else throw new TypeError('Unhandled type received while flattening attributes.');
    }
    return flattenedAttributes;
};
module.exports.default = $33e22ccf7fa2e6ba$var$flattenEventAttributes;

});


parcelRegister("bs7yx", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $85682bb19f9777ff$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $85682bb19f9777ff$var$DefaultAudioMixController_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("3An1L")));

const $85682bb19f9777ff$var$DefaultBrowserBehavior_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("e2TuV")));

const $85682bb19f9777ff$var$DefaultDeviceController_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("d5Rye")));

const $85682bb19f9777ff$var$PermissionDeniedError_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("3JsdE")));

const $85682bb19f9777ff$var$BaseTask_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("9wPDz")));

const $85682bb19f9777ff$var$TimeoutTask_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("aiqTT")));

const $85682bb19f9777ff$var$CheckAudioConnectivityFeedback_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("6J1Iy")));

const $85682bb19f9777ff$var$CheckAudioInputFeedback_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("foAfi")));

const $85682bb19f9777ff$var$CheckAudioOutputFeedback_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("bbZBv")));

const $85682bb19f9777ff$var$CheckCameraResolutionFeedback_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("iMyKq")));

const $85682bb19f9777ff$var$CheckContentShareConnectivityFeedback_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("iqEpI")));

const $85682bb19f9777ff$var$CheckNetworkTCPConnectivityFeedback_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("cDrWL")));

const $85682bb19f9777ff$var$CheckNetworkUDPConnectivityFeedback_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("1boZv")));

const $85682bb19f9777ff$var$CheckVideoConnectivityFeedback_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("9wJVi")));

const $85682bb19f9777ff$var$CheckVideoInputFeedback_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("fXIZN")));

const $85682bb19f9777ff$var$MeetingReadinessCheckerConfiguration_1 = $85682bb19f9777ff$var$__importDefault((parcelRequire("j2SXI")));
class $85682bb19f9777ff$var$DefaultMeetingReadinessChecker {
    static async delay(timeoutMs) {
        return new Promise((resolve)=>setTimeout(resolve, timeoutMs));
    }
    constructor(logger, meetingSession, configuration = new $85682bb19f9777ff$var$MeetingReadinessCheckerConfiguration_1.default()){
        this.logger = logger;
        this.meetingSession = meetingSession;
        this.configuration = configuration;
        this.browserBehavior = new $85682bb19f9777ff$var$DefaultBrowserBehavior_1.default();
    }
    async checkAudioInput(audioInputDevice) {
        try {
            await this.meetingSession.audioVideo.startAudioInput(audioInputDevice);
            await this.meetingSession.audioVideo.stopAudioInput();
            return $85682bb19f9777ff$var$CheckAudioInputFeedback_1.default.Succeeded;
        } catch (error) {
            this.logger.error(`MeetingReadinessChecker: Audio input check failed with error ${error}`);
            if (error instanceof $85682bb19f9777ff$var$PermissionDeniedError_1.default) return $85682bb19f9777ff$var$CheckAudioInputFeedback_1.default.PermissionDenied;
            return $85682bb19f9777ff$var$CheckAudioInputFeedback_1.default.Failed;
        }
    }
    async checkAudioOutput(audioOutputDeviceInfo, audioOutputVerificationCallback, audioElement = null) {
        try {
            const audioOutputDeviceId = audioOutputDeviceInfo ? $85682bb19f9777ff$var$DefaultDeviceController_1.default.getIntrinsicDeviceId(audioOutputDeviceInfo) : '';
            await this.playTone(audioOutputDeviceId, this.configuration.audioOutputFrequency, audioElement);
            const userFeedback = await audioOutputVerificationCallback();
            if (userFeedback) return $85682bb19f9777ff$var$CheckAudioOutputFeedback_1.default.Succeeded;
            return $85682bb19f9777ff$var$CheckAudioOutputFeedback_1.default.Failed;
        } catch (error) {
            this.logger.error(`MeetingReadinessChecker: Audio output check failed with error: ${error}`);
            return $85682bb19f9777ff$var$CheckAudioOutputFeedback_1.default.Failed;
        } finally{
            await this.stopTone();
        }
    }
    async playTone(sinkId, frequency, audioElement) {
        const rampSec = 0.1;
        const maxGainValue = this.configuration.audioOutputGain;
        if (this.oscillatorNode) await this.stopTone();
        this.audioContext = $85682bb19f9777ff$var$DefaultDeviceController_1.default.getAudioContext();
        this.gainNode = this.audioContext.createGain();
        this.gainNode.gain.value = 0;
        this.oscillatorNode = this.audioContext.createOscillator();
        this.oscillatorNode.frequency.value = frequency;
        this.oscillatorNode.connect(this.gainNode);
        this.destinationStream = this.audioContext.createMediaStreamDestination();
        this.gainNode.connect(this.destinationStream);
        const currentTime = this.audioContext.currentTime;
        const startTime = currentTime + 0.1;
        this.gainNode.gain.setValueAtTime(0, startTime);
        this.gainNode.gain.linearRampToValueAtTime(maxGainValue, startTime + rampSec);
        this.oscillatorNode.start();
        // Because we always use `DefaultAudioMixController`, and both this class
        // and DAMC use `DefaultBrowserBehavior`, it is not possible for the `bindAudioDevice` call here to throw.
        // Nevertheless, we `catch` here and disable code coverage.
        const audioMixController = new $85682bb19f9777ff$var$DefaultAudioMixController_1.default(this.logger);
        const element = audioElement || new Audio();
        const stream = this.destinationStream.stream;
        this.audioElement = element;
        try {
            if (this.browserBehavior.supportsSetSinkId()) await audioMixController.bindAudioDevice({
                deviceId: sinkId
            });
        } catch (e) {
            /* istanbul ignore next */ this.logger.error(`Failed to bind audio device: ${e}`);
        }
        try {
            await audioMixController.bindAudioElement(element);
        } catch (e) {
            this.logger.error(`Failed to bind audio element: ${e}`);
        }
        await audioMixController.bindAudioStream(stream);
    }
    async stopTone() {
        if (!this.audioContext || !this.gainNode || !this.oscillatorNode || !this.destinationStream) return;
        const cleanup = ()=>{
            if (this.audioElement) {
                this.audioElement.pause();
                this.audioElement.srcObject = null;
            }
            if (this.oscillatorNode && this.gainNode) this.oscillatorNode.disconnect(this.gainNode);
            if (this.gainNode && this.destinationStream) this.gainNode.disconnect(this.destinationStream);
            this.oscillatorNode = null;
            this.gainNode = null;
            this.destinationStream = null;
            this.audioElement = null;
        };
        // Set up event listener BEFORE scheduling stop to avoid race condition
        const stopPromise = new Promise((resolve)=>{
            this.oscillatorNode.addEventListener('ended', ()=>{
                cleanup();
                resolve();
            }, {
                once: true
            });
        });
        // Schedule fade out
        const rampSec = 0.1;
        const maxGainValue = this.configuration.audioOutputGain;
        const currentTime = this.audioContext.currentTime;
        this.gainNode.gain.setValueAtTime(maxGainValue, currentTime);
        this.gainNode.gain.linearRampToValueAtTime(0, currentTime + rampSec);
        // Schedule oscillator stop slightly after fade completes to avoid clicks
        this.oscillatorNode.stop(currentTime + rampSec + 0.1);
        // Wait for oscillator to stop
        await stopPromise;
    }
    async checkVideoInput(videoInputDevice) {
        try {
            await this.meetingSession.audioVideo.startVideoInput(videoInputDevice);
            await this.meetingSession.audioVideo.stopVideoInput();
            return $85682bb19f9777ff$var$CheckVideoInputFeedback_1.default.Succeeded;
        } catch (error) {
            this.logger.error(`MeetingReadinessChecker: Video check failed with error ${error}`);
            if (error instanceof $85682bb19f9777ff$var$PermissionDeniedError_1.default) return $85682bb19f9777ff$var$CheckVideoInputFeedback_1.default.PermissionDenied;
            return $85682bb19f9777ff$var$CheckVideoInputFeedback_1.default.Failed;
        }
    }
    async checkCameraResolution(videoInputDevice, width, height) {
        let stream;
        try {
            const videoInputDeviceId = $85682bb19f9777ff$var$DefaultDeviceController_1.default.getIntrinsicDeviceId(videoInputDevice);
            const videoConstraint = {
                video: this.calculateVideoConstraint(videoInputDeviceId, width, height)
            };
            stream = await navigator.mediaDevices.getUserMedia(videoConstraint);
        } catch (error) {
            this.logger.error(`MeetingReadinessChecker: Camera resolution check with width: ${width} height ${height} failed with error ${error}`);
            if (error && error.name === 'OverconstrainedError') return $85682bb19f9777ff$var$CheckCameraResolutionFeedback_1.default.ResolutionNotSupported;
            if (error && error.name === 'NotAllowedError') return $85682bb19f9777ff$var$CheckCameraResolutionFeedback_1.default.PermissionDenied;
            return $85682bb19f9777ff$var$CheckCameraResolutionFeedback_1.default.Failed;
        } finally{
            if (stream) stream.getTracks().forEach(function(track) {
                track.stop();
            });
        }
        return $85682bb19f9777ff$var$CheckCameraResolutionFeedback_1.default.Succeeded;
    }
    calculateVideoConstraint(videoInputDeviceId, width, height) {
        const dimension = this.browserBehavior.requiresResolutionAlignment(width, height);
        const trackConstraints = {};
        if (this.browserBehavior.requiresNoExactMediaStreamConstraints()) {
            trackConstraints.deviceId = videoInputDeviceId;
            trackConstraints.width = width;
            trackConstraints.height = height;
        } else {
            trackConstraints.deviceId = {
                exact: videoInputDeviceId
            };
            trackConstraints.width = {
                exact: dimension[0]
            };
            trackConstraints.height = {
                exact: dimension[1]
            };
        }
        return trackConstraints;
    }
    async checkContentShareConnectivity(sourceId) {
        let isContentShareStarted = false;
        let isAudioVideoStarted = false;
        const contentShareObserver = {
            contentShareDidStart: ()=>{
                isContentShareStarted = true;
            }
        };
        const observer = {
            audioVideoDidStart: ()=>{
                isAudioVideoStarted = true;
            }
        };
        try {
            this.meetingSession.audioVideo.addObserver(observer);
            this.meetingSession.audioVideo.start();
            this.meetingSession.audioVideo.addContentShareObserver(contentShareObserver);
            await this.meetingSession.audioVideo.startContentShareFromScreenCapture(sourceId);
            await this.executeTimeoutTask(async ()=>{
                return isAudioVideoStarted && isContentShareStarted;
            });
            if (!isAudioVideoStarted) return $85682bb19f9777ff$var$CheckContentShareConnectivityFeedback_1.default.ConnectionFailed;
            await this.stopMeeting();
            return isContentShareStarted ? $85682bb19f9777ff$var$CheckContentShareConnectivityFeedback_1.default.Succeeded : $85682bb19f9777ff$var$CheckContentShareConnectivityFeedback_1.default.TimedOut;
        } catch (error) {
            this.logger.error(`MeetingReadinessChecker: Content share check failed with error ${error}`);
            if (error.name === 'NotAllowedError') return $85682bb19f9777ff$var$CheckContentShareConnectivityFeedback_1.default.PermissionDenied;
            else return $85682bb19f9777ff$var$CheckContentShareConnectivityFeedback_1.default.Failed;
        } finally{
            this.meetingSession.audioVideo.removeObserver(observer);
            this.meetingSession.audioVideo.stopContentShare();
            this.meetingSession.audioVideo.removeContentShareObserver(contentShareObserver);
        }
    }
    async checkAudioConnectivity(audioInputDevice) {
        let audioPresence = false;
        const audioConnectivityMetrics = {
            packetsReceived: 0
        };
        const audioVideo = this.meetingSession.audioVideo;
        const checkAudioConnectivityMetricsObserver = {
            metricsDidReceive (clientMetricReport) {
                clientMetricReport.getRTCStatsReport().forEach((report)=>{
                    // TODO: remove mediaType in next version as it is deprecated
                    // mediaType was deprecated and replaced with kind
                    if (report.type === 'inbound-rtp' && (report.mediaType === 'audio' || report.kind === 'audio')) audioConnectivityMetrics.packetsReceived = report.packetsReceived;
                });
            }
        };
        const attendeePresenceHandler = (attendeeId, present, _externalUserId, _dropped)=>{
            if (attendeeId === this.meetingSession.configuration.credentials.attendeeId && present) audioPresence = true;
        };
        try {
            await audioVideo.startAudioInput(audioInputDevice);
        } catch (error) {
            this.logger.error(`MeetingReadinessChecker: Failed to get audio input device with error ${error}`);
            if (error instanceof $85682bb19f9777ff$var$PermissionDeniedError_1.default) return $85682bb19f9777ff$var$CheckAudioConnectivityFeedback_1.default.AudioInputPermissionDenied;
            return $85682bb19f9777ff$var$CheckAudioConnectivityFeedback_1.default.AudioInputRequestFailed;
        }
        audioVideo.realtimeSubscribeToAttendeeIdPresence(attendeePresenceHandler);
        audioVideo.addObserver(checkAudioConnectivityMetricsObserver);
        if (!await this.startMeeting()) {
            audioVideo.removeObserver(checkAudioConnectivityMetricsObserver);
            audioVideo.realtimeUnsubscribeToAttendeeIdPresence(attendeePresenceHandler);
            await this.meetingSession.audioVideo.stopAudioInput();
            return $85682bb19f9777ff$var$CheckAudioConnectivityFeedback_1.default.ConnectionFailed;
        }
        await this.executeTimeoutTask(async ()=>{
            return this.isAudioConnectionSuccessful(audioPresence, audioConnectivityMetrics);
        });
        audioVideo.removeObserver(checkAudioConnectivityMetricsObserver);
        audioVideo.realtimeUnsubscribeToAttendeeIdPresence(attendeePresenceHandler);
        await this.stopMeeting();
        await this.meetingSession.audioVideo.stopAudioInput();
        return this.isAudioConnectionSuccessful(audioPresence, audioConnectivityMetrics) ? $85682bb19f9777ff$var$CheckAudioConnectivityFeedback_1.default.Succeeded : $85682bb19f9777ff$var$CheckAudioConnectivityFeedback_1.default.AudioNotReceived;
    }
    async checkVideoConnectivity(videoInputDevice) {
        const audioVideo = this.meetingSession.audioVideo;
        let packetsSent = 0;
        const observer = {
            metricsDidReceive (clientMetricReport) {
                const rawStats = clientMetricReport.getRTCStatsReport();
                rawStats.forEach((report)=>{
                    // TODO: remove mediaType in next version as it is deprecated
                    if (report.type === 'outbound-rtp' && (report.mediaType === 'video' || report.kind === 'video')) packetsSent = report.packetsSent;
                });
            }
        };
        try {
            await audioVideo.startVideoInput(videoInputDevice);
        } catch (error) {
            this.logger.error(`MeetingReadinessChecker: Failed to get video input device with error ${error}`);
            if (error instanceof $85682bb19f9777ff$var$PermissionDeniedError_1.default) return $85682bb19f9777ff$var$CheckVideoConnectivityFeedback_1.default.VideoInputPermissionDenied;
            return $85682bb19f9777ff$var$CheckVideoConnectivityFeedback_1.default.VideoInputRequestFailed;
        }
        audioVideo.addObserver(observer);
        if (!await this.startMeeting()) return $85682bb19f9777ff$var$CheckVideoConnectivityFeedback_1.default.ConnectionFailed;
        audioVideo.startLocalVideoTile();
        await this.executeTimeoutTask(async ()=>{
            return packetsSent > 0;
        });
        await audioVideo.stopVideoInput();
        await this.stopMeeting();
        audioVideo.removeObserver(observer);
        if (packetsSent <= 0) return $85682bb19f9777ff$var$CheckVideoConnectivityFeedback_1.default.VideoNotSent;
        return $85682bb19f9777ff$var$CheckVideoConnectivityFeedback_1.default.Succeeded;
    }
    async checkNetworkUDPConnectivity() {
        let candidatePairSucceed = false;
        const observer = {
            metricsDidReceive (clientMetricReport) {
                const rawStats = clientMetricReport.getRTCStatsReport();
                rawStats.forEach((report)=>{
                    if (report.type === 'candidate-pair' && report.state === 'succeeded') candidatePairSucceed = true;
                });
            }
        };
        try {
            this.originalURLRewriter = this.meetingSession.configuration.urls.urlRewriter;
        } catch (error) {
            this.logger.error(`MeetingSessionConfiguration.urls doesn't exist. Error: ${error}`);
            return $85682bb19f9777ff$var$CheckNetworkUDPConnectivityFeedback_1.default.MeetingSessionURLsNotInitialized;
        }
        this.meetingSession.configuration.urls.urlRewriter = (uri)=>{
            const transformedUri = this.originalURLRewriter(uri);
            if (transformedUri.includes('transport=tcp')) return '';
            return transformedUri;
        };
        const audioVideo = this.meetingSession.audioVideo;
        audioVideo.addObserver(observer);
        if (!await this.startMeeting()) {
            this.meetingSession.configuration.urls.urlRewriter = this.originalURLRewriter;
            return $85682bb19f9777ff$var$CheckNetworkUDPConnectivityFeedback_1.default.ConnectionFailed;
        }
        await this.executeTimeoutTask(async ()=>{
            return candidatePairSucceed;
        });
        this.meetingSession.configuration.urls.urlRewriter = this.originalURLRewriter;
        await this.stopMeeting();
        audioVideo.removeObserver(observer);
        if (!candidatePairSucceed) return $85682bb19f9777ff$var$CheckNetworkUDPConnectivityFeedback_1.default.ICENegotiationFailed;
        return $85682bb19f9777ff$var$CheckNetworkUDPConnectivityFeedback_1.default.Succeeded;
    }
    async checkNetworkTCPConnectivity() {
        let candidatePairSucceed = false;
        const observer = {
            metricsDidReceive (clientMetricReport) {
                const rawStats = clientMetricReport.getRTCStatsReport();
                rawStats.forEach((report)=>{
                    if (report.type === 'candidate-pair' && report.state === 'succeeded') candidatePairSucceed = true;
                });
            }
        };
        try {
            this.originalURLRewriter = this.meetingSession.configuration.urls.urlRewriter;
        } catch (error) {
            this.logger.error(`MeetingSessionConfiguration.urls doesn't exist. Error: ${error}`);
            return $85682bb19f9777ff$var$CheckNetworkTCPConnectivityFeedback_1.default.MeetingSessionURLsNotInitialized;
        }
        this.meetingSession.configuration.urls.urlRewriter = (uri)=>{
            const transformedUri = this.originalURLRewriter(uri);
            if (transformedUri.includes('transport=udp')) return '';
            return transformedUri;
        };
        const audioVideo = this.meetingSession.audioVideo;
        audioVideo.addObserver(observer);
        if (!await this.startMeeting()) {
            this.meetingSession.configuration.urls.urlRewriter = this.originalURLRewriter;
            return $85682bb19f9777ff$var$CheckNetworkTCPConnectivityFeedback_1.default.ConnectionFailed;
        }
        await this.executeTimeoutTask(async ()=>{
            return candidatePairSucceed;
        });
        this.meetingSession.configuration.urls.urlRewriter = this.originalURLRewriter;
        await this.stopMeeting();
        audioVideo.removeObserver(observer);
        if (!candidatePairSucceed) return $85682bb19f9777ff$var$CheckNetworkTCPConnectivityFeedback_1.default.ICENegotiationFailed;
        return $85682bb19f9777ff$var$CheckNetworkTCPConnectivityFeedback_1.default.Succeeded;
    }
    async startMeeting() {
        let isStarted = false;
        const observer = {
            audioVideoDidStart: ()=>{
                isStarted = true;
            }
        };
        this.meetingSession.audioVideo.addObserver(observer);
        this.meetingSession.audioVideo.start();
        await this.executeTimeoutTask(async ()=>{
            return isStarted;
        });
        this.meetingSession.audioVideo.removeObserver(observer);
        return isStarted;
    }
    async stopMeeting() {
        let isStopped = false;
        const observer = {
            audioVideoDidStop: (_sessionStatus)=>{
                isStopped = true;
            }
        };
        this.meetingSession.audioVideo.addObserver(observer);
        this.meetingSession.audioVideo.stop();
        await this.executeTimeoutTask(async ()=>{
            return isStopped;
        });
        this.meetingSession.audioVideo.removeObserver(observer);
        return isStopped;
    }
    async executeTimeoutTask(conditionCheck) {
        let isSuccess = false;
        class CheckForConditionTask extends $85682bb19f9777ff$var$BaseTask_1.default {
            constructor(logger, waitDurationMs){
                super(logger);
                this.waitDurationMs = waitDurationMs;
                this.isCancelled = false;
            }
            cancel() {
                this.isCancelled = true;
            }
            async run() {
                while(!this.isCancelled){
                    if (await conditionCheck()) {
                        isSuccess = true;
                        break;
                    }
                    await $85682bb19f9777ff$var$DefaultMeetingReadinessChecker.delay(this.waitDurationMs);
                }
            }
        }
        const timeoutTask = new $85682bb19f9777ff$var$TimeoutTask_1.default(this.logger, new CheckForConditionTask(this.logger, this.configuration.waitDurationMs), this.configuration.timeoutMs);
        await timeoutTask.run();
        return isSuccess;
    }
    isAudioConnectionSuccessful(audioPresence, audioConnectivityMetrics) {
        return audioPresence && audioConnectivityMetrics.packetsReceived > 0;
    }
}
module.exports.default = $85682bb19f9777ff$var$DefaultMeetingReadinessChecker;

});
parcelRegister("aiqTT", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $77f073b19efaa06f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $77f073b19efaa06f$var$TimeoutScheduler_1 = $77f073b19efaa06f$var$__importDefault((parcelRequire("gcRqk")));

const $77f073b19efaa06f$var$BaseTask_1 = $77f073b19efaa06f$var$__importDefault((parcelRequire("9wPDz")));
/**
 * [[TimeoutTask]] runs a subtask until it either succeeds or reaches a
 * timeout, at which point the subtask is canceled.
 */ class $77f073b19efaa06f$var$TimeoutTask extends $77f073b19efaa06f$var$BaseTask_1.default {
    constructor(logger, taskToRunBeforeTimeout, timeoutMs){
        super(logger);
        this.taskToRunBeforeTimeout = taskToRunBeforeTimeout;
        this.timeoutMs = timeoutMs;
        this.taskName = `Timeout${this.timeoutMs}ms`;
        taskToRunBeforeTimeout.setParent(this);
    }
    cancel() {
        this.logger.info(`canceling timeout task ${this.name()} subtask ${this.taskToRunBeforeTimeout}`);
        this.taskToRunBeforeTimeout.cancel();
    }
    async run() {
        const timer = new $77f073b19efaa06f$var$TimeoutScheduler_1.default(this.timeoutMs);
        timer.start(()=>{
            this.logger.info(`timeout reached for task ${this.name()}`);
            this.taskToRunBeforeTimeout.cancel();
        });
        try {
            await this.taskToRunBeforeTimeout.run();
        } finally{
            timer.stop();
        }
        this.logger.info(`timeout task ${this.name()} completed`);
    }
}
module.exports.default = $77f073b19efaa06f$var$TimeoutTask;

});

parcelRegister("j2SXI", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[MeetingReadinessCheckerConfiguration]] includes custom settings used for MeetingReadinessChecker
 */ class $ddd8d691b0698aed$var$MeetingReadinessCheckerConfiguration {
    constructor(){
        /**
         * Specify how long to wait for each check in a test.
         * If null, it will use the default value.
         */ this.timeoutMs = 10000;
        /**
         * Specify the wait time before checking again when a check condition is not met.
         * If null, it will use the default value.
         */ this.waitDurationMs = 3000;
        /**
         * Specify the frequency of oscillation in hertz for the audio output test.
         */ this.audioOutputFrequency = 440;
        /**
         * Specify the gain value from 0 to 1.0 for the audio output test.
         */ this.audioOutputGain = 0.1;
    }
}
module.exports.default = $ddd8d691b0698aed$var$MeetingReadinessCheckerConfiguration;

});


parcelRegister("9iu2u", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $6c4d18ab9c8ae455$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $6c4d18ab9c8ae455$var$DefaultAudioVideoController_1 = $6c4d18ab9c8ae455$var$__importDefault((parcelRequire("cJkH6")));

const $6c4d18ab9c8ae455$var$DefaultAudioVideoFacade_1 = $6c4d18ab9c8ae455$var$__importDefault((parcelRequire("gal60")));

const $6c4d18ab9c8ae455$var$FullJitterBackoff_1 = $6c4d18ab9c8ae455$var$__importDefault((parcelRequire("84f4q")));

const $6c4d18ab9c8ae455$var$DefaultBrowserBehavior_1 = $6c4d18ab9c8ae455$var$__importDefault((parcelRequire("e2TuV")));

const $6c4d18ab9c8ae455$var$ContentShareMediaStreamBroker_1 = $6c4d18ab9c8ae455$var$__importDefault((parcelRequire("fpi9L")));

const $6c4d18ab9c8ae455$var$DefaultContentShareController_1 = $6c4d18ab9c8ae455$var$__importDefault((parcelRequire("buznb")));

const $6c4d18ab9c8ae455$var$CSPMonitor_1 = $6c4d18ab9c8ae455$var$__importDefault((parcelRequire("6l4nm")));

var $j8SWf = parcelRequire("j8SWf");

const $6c4d18ab9c8ae455$var$DefaultEncodedTransformWorkerManager_1 = $6c4d18ab9c8ae455$var$__importDefault((parcelRequire("6CgU1")));

const $6c4d18ab9c8ae455$var$DefaultEventController_1 = $6c4d18ab9c8ae455$var$__importDefault((parcelRequire("2aVcU")));

const $6c4d18ab9c8ae455$var$DefaultReconnectController_1 = $6c4d18ab9c8ae455$var$__importDefault((parcelRequire("4wU9J")));

const $6c4d18ab9c8ae455$var$DefaultWebSocketAdapter_1 = $6c4d18ab9c8ae455$var$__importDefault((parcelRequire("bXkPl")));
class $6c4d18ab9c8ae455$var$DefaultMeetingSession {
    constructor(configuration, logger, deviceController, _eventController){
        this._eventController = _eventController;
        this._configuration = configuration;
        this._logger = logger;
        this.checkBrowserSupportAndFeatureConfiguration();
        $6c4d18ab9c8ae455$var$CSPMonitor_1.default.addLogger(this._logger);
        $6c4d18ab9c8ae455$var$CSPMonitor_1.default.register();
        if (!this._eventController) this._eventController = new $6c4d18ab9c8ae455$var$DefaultEventController_1.default(configuration, logger);
        /* istanbul ignore else */ if (!deviceController.eventController) deviceController.eventController = this.eventController;
        this.encodedTransformWorkerManager = new $6c4d18ab9c8ae455$var$DefaultEncodedTransformWorkerManager_1.default(this._logger);
        this.audioVideoController = new $6c4d18ab9c8ae455$var$DefaultAudioVideoController_1.default(this._configuration, this._logger, new $6c4d18ab9c8ae455$var$DefaultWebSocketAdapter_1.default(this._logger), deviceController, new $6c4d18ab9c8ae455$var$DefaultReconnectController_1.default(this._configuration.reconnectTimeoutMs, new $6c4d18ab9c8ae455$var$FullJitterBackoff_1.default(this._configuration.reconnectFixedWaitMs, this._configuration.reconnectShortBackOffMs, this._configuration.reconnectLongBackOffMs)), this.eventController, this.encodedTransformWorkerManager);
        this._deviceController = deviceController;
        this.logger.info(`MeetingFeatures: ${JSON.stringify(configuration.meetingFeatures)}`);
        this.contentShareEncodedTransformWorkerManager = new $6c4d18ab9c8ae455$var$DefaultEncodedTransformWorkerManager_1.default(this._logger);
        const contentShareMediaStreamBroker = new $6c4d18ab9c8ae455$var$ContentShareMediaStreamBroker_1.default(this._logger);
        this.contentShareController = new $6c4d18ab9c8ae455$var$DefaultContentShareController_1.default(contentShareMediaStreamBroker, new $6c4d18ab9c8ae455$var$DefaultAudioVideoController_1.default($6c4d18ab9c8ae455$var$DefaultContentShareController_1.default.createContentShareMeetingSessionConfigure(this._configuration), this._logger, new $6c4d18ab9c8ae455$var$DefaultWebSocketAdapter_1.default(this._logger), contentShareMediaStreamBroker, new $6c4d18ab9c8ae455$var$DefaultReconnectController_1.default(this._configuration.reconnectTimeoutMs, new $6c4d18ab9c8ae455$var$FullJitterBackoff_1.default(this._configuration.reconnectFixedWaitMs, this._configuration.reconnectShortBackOffMs, this._configuration.reconnectLongBackOffMs)), undefined, this.contentShareEncodedTransformWorkerManager), this.audioVideoController);
        this.audioVideoFacade = new $6c4d18ab9c8ae455$var$DefaultAudioVideoFacade_1.default(this.audioVideoController, this.audioVideoController.videoTileController, this.audioVideoController.realtimeController, this.audioVideoController.audioMixController, this._deviceController, this.contentShareController);
    }
    get configuration() {
        return this._configuration;
    }
    get logger() {
        return this._logger;
    }
    get audioVideo() {
        return this.audioVideoFacade;
    }
    get contentShare() {
        return this.contentShareController;
    }
    get deviceController() {
        return this._deviceController;
    }
    get eventController() {
        return this._eventController;
    }
    /**
     * Clean up this instance and resources that it created.
     *
     * After calling `destroy`, internal fields like `audioVideoController` will be unavailable.
     */ async destroy() {
        var _a, _b;
        if ((0, $j8SWf.isDestroyable)(this.contentShareController)) await this.contentShareController.destroy();
        if ((0, $j8SWf.isDestroyable)(this.audioVideoController)) await this.audioVideoController.destroy();
        if ((0, $j8SWf.isDestroyable)(this.eventController)) await this.eventController.destroy();
        await ((_a = this.encodedTransformWorkerManager) === null || _a === void 0 ? void 0 : _a.stop());
        await ((_b = this.contentShareEncodedTransformWorkerManager) === null || _b === void 0 ? void 0 : _b.stop());
        $6c4d18ab9c8ae455$var$CSPMonitor_1.default.removeLogger(this._logger);
        this._logger = undefined;
        this._configuration = undefined;
        this._deviceController = undefined;
        this.audioVideoFacade = undefined;
        this.audioVideoController = undefined;
        this.contentShareController = undefined;
        this._eventController = undefined;
        this.encodedTransformWorkerManager = undefined;
        this.contentShareEncodedTransformWorkerManager = undefined;
    }
    checkBrowserSupportAndFeatureConfiguration() {
        const browserBehavior = new $6c4d18ab9c8ae455$var$DefaultBrowserBehavior_1.default();
        const browser = `${browserBehavior.name()} ${browserBehavior.majorVersion()} (${browserBehavior.version()})`;
        this.logger.info(`browser is ${browser}`);
        if (!browserBehavior.isSupported()) this.logger.warn("this browser is not currently supported. Stability may suffer. " + `Supported browsers are: ${browserBehavior.supportString()}.`);
        // Validation if a custom video uplink policy is specified
        if (this._configuration.videoUplinkBandwidthPolicy) {
            if (this.isSimulcastUplinkPolicy(this._configuration.videoUplinkBandwidthPolicy)) {
                if (!browserBehavior.hasChromiumWebRTC()) throw new Error('Simulcast is only supported on Chromium-based browsers');
                this._configuration.enableSimulcastForUnifiedPlanChromiumBasedBrowsers = true;
            } else this._configuration.enableSimulcastForUnifiedPlanChromiumBasedBrowsers = false;
        }
        if (this._configuration.enableSimulcastForUnifiedPlanChromiumBasedBrowsers) {
            if (browserBehavior.hasChromiumWebRTC()) this.logger.info(`Simulcast is enabled for ${browserBehavior.name()}`);
            else {
                this._configuration.enableSimulcastForUnifiedPlanChromiumBasedBrowsers = false;
                this.logger.info('Simulcast is only supported on Chromium-based browsers');
            }
            if (this._configuration.enableSVC) {
                this._configuration.enableSVC = false;
                this.logger.info('SVC is not successfully enabled since simulcast is enabled');
            }
        }
        if (this._configuration.enableSVC && !browserBehavior.supportsScalableVideoCoding()) {
            this._configuration.enableSVC = false;
            this.logger.info('SVC is only supported on Chromium-based browsers with version 111 or above');
        }
    }
    isSimulcastUplinkPolicy(policy) {
        return !!(policy && policy.addObserver);
    }
}
module.exports.default = $6c4d18ab9c8ae455$var$DefaultMeetingSession;

});
parcelRegister("4wU9J", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $34c5b603083fc4b7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $34c5b603083fc4b7$var$TimeoutScheduler_1 = $34c5b603083fc4b7$var$__importDefault((parcelRequire("gcRqk")));
class $34c5b603083fc4b7$var$DefaultReconnectController {
    constructor(reconnectTimeoutMs, backoffPolicy){
        this.reconnectTimeoutMs = reconnectTimeoutMs;
        this.backoffPolicy = backoffPolicy;
        this.shouldReconnect = true;
        this.onlyRestartPeerConnection = false;
        this.firstConnectionAttempted = false;
        this.firstConnectionAttemptTimestampMs = 0;
        this.lastActiveTimestampMs = Infinity;
        this._isFirstConnection = true;
        this.backoffTimer = null;
        this.backoffCancel = null;
        this.reset();
    }
    timeSpentReconnectingMs() {
        if (!this.firstConnectionAttempted) return 0;
        return Date.now() - this.firstConnectionAttemptTimestampMs;
    }
    hasPastReconnectDeadline() {
        if (Date.now() - this.lastActiveTimestampMs >= this.reconnectTimeoutMs) return true;
        return this.timeSpentReconnectingMs() >= this.reconnectTimeoutMs;
    }
    reset() {
        this.cancel();
        this.shouldReconnect = true;
        this.onlyRestartPeerConnection = false;
        this.firstConnectionAttempted = false;
        this.firstConnectionAttemptTimestampMs = 0;
        this.lastActiveTimestampMs = Infinity;
        this.backoffPolicy.reset();
    }
    startedConnectionAttempt(isFirstConnection) {
        this._isFirstConnection = isFirstConnection;
        if (!this.firstConnectionAttempted) {
            this.firstConnectionAttempted = true;
            this.firstConnectionAttemptTimestampMs = Date.now();
        }
    }
    hasStartedConnectionAttempt() {
        return this.firstConnectionAttempted;
    }
    isFirstConnection() {
        return this._isFirstConnection;
    }
    disableReconnect() {
        this.shouldReconnect = false;
    }
    enableRestartPeerConnection() {
        this.onlyRestartPeerConnection = true;
    }
    cancel() {
        this.disableReconnect();
        if (this.backoffTimer) {
            this.backoffTimer.stop();
            if (this.backoffCancel) {
                this.backoffCancel();
                this.backoffCancel = null;
            }
        }
    }
    retryWithBackoff(retryFunc, cancelFunc) {
        const willRetry = this.shouldReconnect && !this.hasPastReconnectDeadline();
        if (willRetry) {
            this.backoffCancel = cancelFunc;
            this.backoffTimer = new $34c5b603083fc4b7$var$TimeoutScheduler_1.default(this.backoffPolicy.nextBackoffAmountMs());
            this.backoffTimer.start(()=>{
                this.backoffCancel = null;
                retryFunc();
            });
        }
        return willRetry;
    }
    shouldOnlyRestartPeerConnection() {
        return this.onlyRestartPeerConnection;
    }
    clone() {
        return new $34c5b603083fc4b7$var$DefaultReconnectController(this.reconnectTimeoutMs, this.backoffPolicy);
    }
    setLastActiveTimestampMs(timestampMs) {
        this.lastActiveTimestampMs = timestampMs;
    }
}
module.exports.default = $34c5b603083fc4b7$var$DefaultReconnectController;

});

parcelRegister("bXkPl", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $8b455c3c65a11ef9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $8b455c3c65a11ef9$var$Versioning_1 = $8b455c3c65a11ef9$var$__importDefault((parcelRequire("c0dn0")));

const $8b455c3c65a11ef9$var$WebSocketReadyState_1 = $8b455c3c65a11ef9$var$__importDefault((parcelRequire("jJkQN")));
class $8b455c3c65a11ef9$var$DefaultWebSocketAdapter {
    constructor(logger){
        this.logger = logger;
    }
    create(url, protocols, isSignedUrl) {
        this.connection = new WebSocket(isSignedUrl ? url : $8b455c3c65a11ef9$var$Versioning_1.default.urlWithVersion(url), protocols);
        this.connection.binaryType = 'arraybuffer';
    }
    send(message) {
        if (!this.connection) {
            this.logger.error('WebSocket not yet created or already destroyed.');
            return false;
        }
        try {
            if (message instanceof Uint8Array) this.connection.send(message.buffer);
            else this.connection.send(message);
            return true;
        } catch (err) {
            this.logger.debug(()=>`send error: ${err.message}, websocket state=${$8b455c3c65a11ef9$var$WebSocketReadyState_1.default[this.readyState()]}`);
            return false;
        }
    }
    close(code, reason) {
        var _a;
        (_a = this.connection) === null || _a === void 0 || _a.close(code, reason);
    }
    destroy() {
        this.connection = undefined;
    }
    addEventListener(handler, eventListener) {
        /* istanbul ignore if */ if (!this.connection) {
            this.logger.warn('Cannot add event listener with no WebSocket connection.');
            return;
        }
        this.connection.addEventListener(handler, eventListener);
    }
    removeEventListener(handler, eventListener) {
        var _a;
        (_a = this.connection) === null || _a === void 0 || _a.removeEventListener(handler, eventListener);
    }
    readyState() {
        if (!this.connection) return $8b455c3c65a11ef9$var$WebSocketReadyState_1.default.None;
        switch(this.connection.readyState){
            case WebSocket.CONNECTING:
                return $8b455c3c65a11ef9$var$WebSocketReadyState_1.default.Connecting;
            case WebSocket.OPEN:
                return $8b455c3c65a11ef9$var$WebSocketReadyState_1.default.Open;
            case WebSocket.CLOSING:
                return $8b455c3c65a11ef9$var$WebSocketReadyState_1.default.Closing;
            case WebSocket.CLOSED:
                return $8b455c3c65a11ef9$var$WebSocketReadyState_1.default.Closed;
        }
    }
}
module.exports.default = $8b455c3c65a11ef9$var$DefaultWebSocketAdapter;

});


parcelRegister("gaXgg", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $bc6b8c953eea7b82$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kjyEk = parcelRequire("kjyEk");

const $bc6b8c953eea7b82$var$FullJitterBackoff_1 = $bc6b8c953eea7b82$var$__importDefault((parcelRequire("84f4q")));

const $bc6b8c953eea7b82$var$CSPMonitor_1 = $bc6b8c953eea7b82$var$__importDefault((parcelRequire("6l4nm")));

const $bc6b8c953eea7b82$var$Message_1 = $bc6b8c953eea7b82$var$__importDefault((parcelRequire("hAryZ")));

const $bc6b8c953eea7b82$var$DefaultReconnectController_1 = $bc6b8c953eea7b82$var$__importDefault((parcelRequire("4wU9J")));

const $bc6b8c953eea7b82$var$AsyncScheduler_1 = $bc6b8c953eea7b82$var$__importDefault((parcelRequire("4mLYP")));

const $bc6b8c953eea7b82$var$DefaultSigV4_1 = $bc6b8c953eea7b82$var$__importDefault((parcelRequire("1LB88")));

const $bc6b8c953eea7b82$var$DefaultWebSocketAdapter_1 = $bc6b8c953eea7b82$var$__importDefault((parcelRequire("bXkPl")));

const $bc6b8c953eea7b82$var$WebSocketReadyState_1 = $bc6b8c953eea7b82$var$__importDefault((parcelRequire("jJkQN")));

const $bc6b8c953eea7b82$var$PrefetchOn_1 = $bc6b8c953eea7b82$var$__importDefault((parcelRequire("7rVns")));
class $bc6b8c953eea7b82$var$DefaultMessagingSession {
    constructor(configuration, logger, webSocket, reconnectController, sigV4){
        this.configuration = configuration;
        this.logger = logger;
        this.webSocket = webSocket;
        this.reconnectController = reconnectController;
        this.sigV4 = sigV4;
        this.observerQueue = new Set();
        if (!this.webSocket) this.webSocket = new $bc6b8c953eea7b82$var$DefaultWebSocketAdapter_1.default(this.logger);
        if (!this.reconnectController) this.reconnectController = new $bc6b8c953eea7b82$var$DefaultReconnectController_1.default(configuration.reconnectTimeoutMs, new $bc6b8c953eea7b82$var$FullJitterBackoff_1.default(configuration.reconnectFixedWaitMs, configuration.reconnectShortBackoffMs, configuration.reconnectLongBackoffMs));
        if (!this.sigV4) this.sigV4 = new $bc6b8c953eea7b82$var$DefaultSigV4_1.default(this.configuration.chimeClient);
        $bc6b8c953eea7b82$var$CSPMonitor_1.default.addLogger(this.logger);
        $bc6b8c953eea7b82$var$CSPMonitor_1.default.register();
        this.preBootstrapMessages = [];
    }
    addObserver(observer) {
        this.logger.info('adding messaging observer');
        this.observerQueue.add(observer);
    }
    removeObserver(observer) {
        this.logger.info('removing messaging observer');
        this.observerQueue.delete(observer);
    }
    async start() {
        if (this.isClosed()) await this.startConnecting(false);
        else this.logger.info('messaging session already started');
    }
    stop() {
        if (!this.isClosed()) {
            this.isClosing = true;
            this.webSocket.close();
            $bc6b8c953eea7b82$var$CSPMonitor_1.default.removeLogger(this.logger);
        } else this.logger.info('no existing messaging session needs closing');
    }
    forEachObserver(observerFunc) {
        for (const observer of this.observerQueue)$bc6b8c953eea7b82$var$AsyncScheduler_1.default.nextTick(()=>{
            if (this.observerQueue.has(observer)) observerFunc(observer);
        });
    }
    setUpEventListeners() {
        this.webSocket.addEventListener('open', ()=>{
            this.openEventHandler();
        });
        this.webSocket.addEventListener('message', (event)=>{
            this.receiveMessageHandler(event.data);
        });
        this.webSocket.addEventListener('close', (event)=>{
            this.closeEventHandler(event);
        });
        this.webSocket.addEventListener('error', ()=>{
            this.logger.error(`WebSocket error`);
        });
    }
    async startConnecting(reconnecting) {
        await this.startConnectingInternal(reconnecting);
        return await new Promise((resolve, reject)=>{
            this.bootstrapResolved = resolve;
            this.bootstrapRejected = reject;
        });
    }
    async startConnectingInternal(reconnecting) {
        var _a;
        let endpointUrl = this.configuration.endpointUrl;
        // Moving this reconnect logic can potentially result into an infinite reconnect loop on errors.
        // Check https://github.com/aws/amazon-chime-sdk-js/issues/2372 for details.
        if (!reconnecting) this.reconnectController.reset();
        if (this.reconnectController.hasStartedConnectionAttempt()) this.reconnectController.startedConnectionAttempt(false);
        else this.reconnectController.startedConnectionAttempt(true);
        // reconnect needs to re-resolve endpoint url, which will also refresh credentials on client if they are expired
        if (reconnecting || endpointUrl === undefined) try {
            if (this.configuration.chimeClient.getMessagingSessionEndpoint instanceof Function) {
                const response = await this.configuration.chimeClient.getMessagingSessionEndpoint();
                // Check for aws sdk v3 with v2 style compatibility first
                if ((_a = response.Endpoint) === null || _a === void 0 ? void 0 : _a.Url) endpointUrl = response.Endpoint.Url;
                else {
                    // Make aws sdk v2 call
                    const endpoint = await this.configuration.chimeClient.getMessagingSessionEndpoint().promise();
                    endpointUrl = endpoint.Endpoint.Url;
                }
            } else endpointUrl = (await this.configuration.chimeClient.send(new $kjyEk.GetMessagingSessionEndpointCommand({}))).Endpoint.Url;
            this.logger.debug(`Messaging endpoint resolved to: ${endpointUrl}`);
        } catch (e) {
            // send artificial close code event so the
            // re-connect logic of underlying websocket client is
            // triggered in the close handler
            this.logger.error(`Messaging Session failed to resolve endpoint: ${e}`);
            const closeEvent = new CloseEvent('close', {
                wasClean: false,
                code: 4999,
                reason: 'Failed to get messaging session endpoint URL',
                bubbles: false
            });
            this.closeEventHandler(closeEvent);
            return;
        }
        const signedUrl = await this.prepareWebSocketUrl(endpointUrl);
        this.logger.info(`opening connection to ${signedUrl}`);
        if (!reconnecting) this.reconnectController.reset();
        if (this.reconnectController.hasStartedConnectionAttempt()) this.reconnectController.startedConnectionAttempt(false);
        else this.reconnectController.startedConnectionAttempt(true);
        this.webSocket.create(signedUrl, [], true);
        this.forEachObserver((observer)=>{
            if (observer.messagingSessionDidStartConnecting) observer.messagingSessionDidStartConnecting(reconnecting);
        });
        this.setUpEventListeners();
    }
    async prepareWebSocketUrl(endpointUrl) {
        const queryParams = new Map();
        queryParams.set('userArn', [
            this.configuration.userArn
        ]);
        queryParams.set('sessionId', [
            this.configuration.messagingSessionId
        ]);
        if (this.configuration.prefetchOn === $bc6b8c953eea7b82$var$PrefetchOn_1.default.Connect) queryParams.set('prefetch-on', [
            $bc6b8c953eea7b82$var$PrefetchOn_1.default.Connect
        ]);
        if (this.configuration.prefetchSortBy) queryParams.set('prefetch-sort-by', [
            this.configuration.prefetchSortBy
        ]);
        return await this.sigV4.signURL('GET', 'wss', 'chime', endpointUrl, '/connect', '', queryParams);
    }
    isClosed() {
        return this.webSocket.readyState() === $bc6b8c953eea7b82$var$WebSocketReadyState_1.default.None || this.webSocket.readyState() === $bc6b8c953eea7b82$var$WebSocketReadyState_1.default.Closed;
    }
    openEventHandler() {
        this.reconnectController.reset();
        this.isSessionEstablished = false;
    }
    receiveMessageHandler(data) {
        try {
            const jsonData = JSON.parse(data);
            const messageType = jsonData.Headers['x-amz-chime-event-type'];
            const message = new $bc6b8c953eea7b82$var$Message_1.default(messageType, jsonData.Headers, jsonData.Payload || null);
            if (!this.isSessionEstablished && messageType === 'SESSION_ESTABLISHED') {
                // Backend connects WebSocket and then either
                // (1) Closes with WebSocket error code to reflect failure to authorize or other connection error OR
                // (2) Sends SESSION_ESTABLISHED. SESSION_ESTABLISHED indicates that all messages and events on a channel
                // the app instance user is a member of is guaranteed to be delivered on this WebSocket as long as the WebSocket
                // connection stays opened.
                this.forEachObserver((observer)=>{
                    if (observer.messagingSessionDidStart) observer.messagingSessionDidStart();
                });
                this.bootstrapResolved();
                this.isSessionEstablished = true;
                // Send message and flush the queue.
                const preBootstrapMessageLength = this.preBootstrapMessages.length;
                for(let iter = 0; iter < preBootstrapMessageLength; iter++){
                    const preBootstrapMessage = this.preBootstrapMessages.shift();
                    this.forEachObserver((observer)=>{
                        this.sendMessageToObserver(observer, preBootstrapMessage);
                    });
                }
            } else if (!this.isSessionEstablished) {
                // SESSION_ESTABLISHED is not guaranteed to be the first message, and in rare conditions a message or event from
                // a channel the member is a member of might arrive prior to SESSION_ESTABLISHED.  Because SESSION_ESTABLISHED indicates
                // it is safe to bootstrap the user application without any race conditions in losing events we opt to store messages prior
                // to SESSION_ESTABLISHED being received and send when once SESSION_ESTABLISHED.
                this.preBootstrapMessages.push(message);
                return;
            }
            this.forEachObserver((observer)=>{
                this.sendMessageToObserver(observer, message);
            });
        } catch (error) {
            this.logger.error(`Messaging parsing failed: ${error}`);
        }
    }
    sendMessageToObserver(observer, message) {
        if (observer.messagingSessionDidReceiveMessage) observer.messagingSessionDidReceiveMessage(message);
    }
    retryConnection() {
        return this.reconnectController.retryWithBackoff(async ()=>{
            await this.startConnecting(true);
        }, null);
    }
    closeEventHandler(event) {
        this.logger.info(`WebSocket close: ${event.code} ${event.reason}`);
        if (event.code !== 4999) this.webSocket.destroy();
        if (!this.isClosing && this.canReconnect(event.code) && this.retryConnection()) return;
        this.isClosing = false;
        if (this.isSessionEstablished) this.forEachObserver((observer)=>{
            if (observer.messagingSessionDidStop) observer.messagingSessionDidStop(event);
        });
        else this.bootstrapRejected(event);
    }
    canReconnect(closeCode) {
        // 4003 is Kicked closing event from the back end
        return closeCode === 1001 || closeCode === 1006 || closeCode >= 1011 && closeCode <= 1014 || closeCode > 4000 && closeCode !== 4002 && closeCode !== 4003 && closeCode !== 4401;
    }
}
module.exports.default = $bc6b8c953eea7b82$var$DefaultMessagingSession;

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("hAryZ", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $ccdb2df9bdc90568$var$Message {
    constructor(type, headers, payload){
        this.type = type;
        this.headers = headers;
        this.payload = payload;
    }
}
module.exports.default = $ccdb2df9bdc90568$var$Message;

});

parcelRegister("1LB88", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $1496fb89081db8d3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hJMA1 = parcelRequire("hJMA1");
parcelRequire("gqAgn");
var $lUOK3 = parcelRequire("lUOK3");

const $1496fb89081db8d3$var$Versioning_1 = $1496fb89081db8d3$var$__importDefault((parcelRequire("c0dn0")));
class $1496fb89081db8d3$var$DefaultSigV4 {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    constructor(chimeClient){
        this.chimeClient = chimeClient;
    }
    makeTwoDigits(n) {
        /* istanbul ignore if */ /* istanbul ignore else */ if (n > 9) return n.toString();
        else return '0' + n.toString();
    }
    hmac(data, secret) {
        const hash = new $hJMA1.Sha256(secret);
        hash.update(data);
        return hash.digest();
    }
    getDateTimeString() {
        const d = new Date();
        return d.getUTCFullYear() + this.makeTwoDigits(d.getUTCMonth() + 1) + this.makeTwoDigits(d.getUTCDate()) + 'T' + this.makeTwoDigits(d.getUTCHours()) + this.makeTwoDigits(d.getUTCMinutes()) + this.makeTwoDigits(d.getUTCSeconds()) + 'Z';
    }
    getDateString(dateTimeString) {
        return dateTimeString.substring(0, dateTimeString.indexOf('T'));
    }
    async getSignatureKey(key, date, regionName, serviceName) {
        const kDate = await this.hmac(date, 'AWS4' + key);
        const kRegion = await this.hmac(regionName, kDate);
        const kService = await this.hmac(serviceName, kRegion);
        const kSigning = await this.hmac('aws4_request', kService);
        return kSigning;
    }
    async signURL(method, scheme, serviceName, hostname, path, payload, queryParams) {
        const now = this.getDateTimeString();
        const today = this.getDateString(now);
        const algorithm = 'AWS4-HMAC-SHA256';
        let region = '';
        // in AWS SDK v3 region is a function
        if (this.chimeClient.config.region instanceof Function) region = await this.chimeClient.config.region();
        else region = this.chimeClient.config.region;
        const signedHeaders = 'host';
        const canonicalHeaders = 'host:' + hostname.toLowerCase() + '\n';
        const credentialScope = today + '/' + region + '/' + serviceName + '/' + 'aws4_request';
        let credentials = undefined;
        // in AWS SDK v3 credentials is a function
        if (this.chimeClient.config.credentials instanceof Function) credentials = await this.chimeClient.config.credentials();
        else credentials = this.chimeClient.config.credentials;
        let params = new Map();
        params.set('X-Amz-Algorithm', [
            algorithm
        ]);
        params.set('X-Amz-Credential', [
            encodeURIComponent(credentials.accessKeyId + '/' + credentialScope)
        ]);
        params.set('X-Amz-Date', [
            now
        ]);
        params.set('X-Amz-Expires', [
            '10'
        ]);
        params.set('X-Amz-SignedHeaders', [
            'host'
        ]);
        if (credentials.sessionToken) params.set('X-Amz-Security-Token', [
            encodeURIComponent(credentials.sessionToken)
        ]);
        params.set($1496fb89081db8d3$var$Versioning_1.default.X_AMZN_VERSION, [
            encodeURIComponent($1496fb89081db8d3$var$Versioning_1.default.sdkVersion)
        ]);
        params.set($1496fb89081db8d3$var$Versioning_1.default.X_AMZN_USER_AGENT, [
            encodeURIComponent($1496fb89081db8d3$var$Versioning_1.default.sdkUserAgentLowResolution)
        ]);
        queryParams === null || queryParams === void 0 || queryParams.forEach((values, key)=>{
            const encodedKey = encodeURIComponent(key);
            values.sort().forEach((value)=>{
                if (!params.has(encodedKey)) params.set(encodedKey, []);
                params.get(encodedKey).push(encodeURIComponent(value));
            });
        });
        let canonicalQuerystring = '';
        params = new Map([
            ...params.entries()
        ].sort());
        params.forEach((values, key)=>{
            values.forEach((value)=>{
                if (canonicalQuerystring.length) canonicalQuerystring += '&';
                canonicalQuerystring += key + '=' + value;
            });
        });
        const canonicalRequest = method + '\n' + path + '\n' + canonicalQuerystring + '\n' + canonicalHeaders + '\n' + signedHeaders + '\n' + (0, $lUOK3.toHex)(await this.hmac(payload));
        const hashedCanonicalRequest = (0, $lUOK3.toHex)(await this.hmac(canonicalRequest));
        const stringToSign = 'AWS4-HMAC-SHA256\n' + now + '\n' + today + '/' + region + '/' + serviceName + '/aws4_request\n' + hashedCanonicalRequest;
        const signingKey = await this.getSignatureKey(credentials.secretAccessKey, today, region, serviceName);
        const signature = (0, $lUOK3.toHex)(await this.hmac(stringToSign, signingKey));
        const finalParams = canonicalQuerystring + '&X-Amz-Signature=' + signature;
        return scheme + '://' + hostname + path + '?' + finalParams;
    }
}
module.exports.default = $1496fb89081db8d3$var$DefaultSigV4;

});
parcelRegister("hJMA1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7RlAB = parcelRequire("7RlAB");

$7RlAB.__exportStar((parcelRequire("fBO8x")), module.exports);

});
parcelRegister("7RlAB", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $5b8e3ad7a3e0b6af$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $5b8e3ad7a3e0b6af$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $5b8e3ad7a3e0b6af$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5b8e3ad7a3e0b6af$var$extendStatics = function(d, b) {
    $5b8e3ad7a3e0b6af$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5b8e3ad7a3e0b6af$var$extendStatics(d, b);
};
function $5b8e3ad7a3e0b6af$export$a8ba968b8961cb8a(d, b) {
    $5b8e3ad7a3e0b6af$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5b8e3ad7a3e0b6af$export$18ce0697a983be9b = function() {
    $5b8e3ad7a3e0b6af$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5b8e3ad7a3e0b6af$export$18ce0697a983be9b.apply(this, arguments);
};
function $5b8e3ad7a3e0b6af$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5b8e3ad7a3e0b6af$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5b8e3ad7a3e0b6af$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5b8e3ad7a3e0b6af$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5b8e3ad7a3e0b6af$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5b8e3ad7a3e0b6af$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5b8e3ad7a3e0b6af$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5b8e3ad7a3e0b6af$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5b8e3ad7a3e0b6af$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5b8e3ad7a3e0b6af$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5b8e3ad7a3e0b6af$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5b8e3ad7a3e0b6af$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5b8e3ad7a3e0b6af$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5b8e3ad7a3e0b6af$export$10c90e4f7922046c(v) {
    return this instanceof $5b8e3ad7a3e0b6af$export$10c90e4f7922046c ? (this.v = v, this) : new $5b8e3ad7a3e0b6af$export$10c90e4f7922046c(v);
}
function $5b8e3ad7a3e0b6af$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5b8e3ad7a3e0b6af$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5b8e3ad7a3e0b6af$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5b8e3ad7a3e0b6af$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5b8e3ad7a3e0b6af$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5b8e3ad7a3e0b6af$export$19a8beecd37a4c45 === "function" ? $5b8e3ad7a3e0b6af$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5b8e3ad7a3e0b6af$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5b8e3ad7a3e0b6af$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5b8e3ad7a3e0b6af$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5b8e3ad7a3e0b6af$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5b8e3ad7a3e0b6af$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("fBO8x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $7RlAB = parcelRequire("7RlAB");

var $j96FB = parcelRequire("j96FB");

var $kvbfG = parcelRequire("kvbfG");

var $5EQTp = parcelRequire("5EQTp");
var $b5d133cc7eb11ec0$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $kvbfG.RawSha256();
        if (secret) {
            this.outer = new $kvbfG.RawSha256();
            var inner = $b5d133cc7eb11ec0$var$bufferFromSecret(secret);
            var outer = new Uint8Array($j96FB.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $j96FB.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $5EQTp.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $5EQTp.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return $7RlAB.__awaiter(this, void 0, void 0, function() {
            return $7RlAB.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $b5d133cc7eb11ec0$var$Sha256;
function $b5d133cc7eb11ec0$var$bufferFromSecret(secret) {
    var input = (0, $5EQTp.convertToBuffer)(secret);
    if (input.byteLength > $j96FB.BLOCK_SIZE) {
        var bufferHash = new $kvbfG.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($j96FB.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("j96FB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("kvbfG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $j96FB = parcelRequire("j96FB");
/**
 * @internal
 */ var $eecf6e4c57589d9c$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($j96FB.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $j96FB.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $j96FB.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $j96FB.BLOCK_SIZE >= $j96FB.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $j96FB.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $j96FB.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($j96FB.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($j96FB.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($j96FB.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $j96FB.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($j96FB.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $eecf6e4c57589d9c$var$RawSha256;

});

parcelRegister("5EQTp", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $63HNI = parcelRequire("63HNI");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $63HNI.convertToBuffer;
    }
});

var $emuEd = parcelRequire("emuEd");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $emuEd.isEmptyData;
    }
});

var $lzgJV = parcelRequire("lzgJV");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $lzgJV.numToUint8;
    }
});

var $j1rnC = parcelRequire("j1rnC");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $j1rnC.uint32ArrayFrom;
    }
});

});
parcelRegister("63HNI", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $4694ffd112c4607d$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $iqmfT = parcelRequire("iqmfT");
// Quick polyfill
var $4694ffd112c4607d$var$fromUtf8 = typeof $4694ffd112c4607d$require$Buffer !== "undefined" && $4694ffd112c4607d$require$Buffer.from ? function(input) {
    return $4694ffd112c4607d$require$Buffer.from(input, "utf8");
} : $iqmfT.fromUtf8;
function $4694ffd112c4607d$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $4694ffd112c4607d$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $4694ffd112c4607d$var$convertToBuffer;

});
parcelRegister("iqmfT", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $d69beb215036a813$export$c7c5cef950a4d2fc);

var $krfVd = parcelRequire("krfVd");

var $3lZTG = parcelRequire("3lZTG");
const $d69beb215036a813$export$c7c5cef950a4d2fc = (input)=>typeof TextEncoder === "function" ? (0, $3lZTG.fromUtf8)(input) : (0, $krfVd.fromUtf8)(input);
const $d69beb215036a813$export$b4b216764bb846eb = (input)=>typeof TextDecoder === "function" ? (0, $3lZTG.toUtf8)(input) : (0, $krfVd.toUtf8)(input);

});
parcelRegister("krfVd", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $ee12ae0367269f41$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $ee12ae0367269f41$export$b4b216764bb846eb);
const $ee12ae0367269f41$export$c7c5cef950a4d2fc = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const $ee12ae0367269f41$export$b4b216764bb846eb = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("3lZTG", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $271358b93759ea16$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $271358b93759ea16$export$b4b216764bb846eb);
function $271358b93759ea16$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $271358b93759ea16$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRegister("emuEd", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $a74ae4c40ab0f91f$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $a74ae4c40ab0f91f$var$isEmptyData;

});

parcelRegister("lzgJV", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $fb39da01d44ccc04$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $fb39da01d44ccc04$var$numToUint8;

});

parcelRegister("j1rnC", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $dd93596991a6dfa6$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $dd93596991a6dfa6$var$uint32ArrayFrom;

});




parcelRegister("gqAgn", function(module, exports) {
$parcel$export(module.exports, "toHex", () => (parcelRequire("lUOK3")).toHex);
parcelRequire("lUOK3");

});
parcelRegister("lUOK3", function(module, exports) {

$parcel$export(module.exports, "toHex", () => $ff463032e6a14a0a$export$7ea66e3774a60b67);
const $ff463032e6a14a0a$var$SHORT_TO_HEX = {};
const $ff463032e6a14a0a$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $ff463032e6a14a0a$var$SHORT_TO_HEX[i] = encodedByte;
    $ff463032e6a14a0a$var$HEX_TO_SHORT[encodedByte] = i;
}
function $ff463032e6a14a0a$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $ff463032e6a14a0a$var$HEX_TO_SHORT) out[i / 2] = $ff463032e6a14a0a$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $ff463032e6a14a0a$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $ff463032e6a14a0a$var$SHORT_TO_HEX[bytes[i]];
    return out;
}

});



parcelRegister("7rVns", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Using an enum here to make sure we can expand on future features
var $56c78ff17fd91479$var$PrefetchOn;
(function(PrefetchOn) {
    PrefetchOn["Connect"] = "connect";
})($56c78ff17fd91479$var$PrefetchOn || ($56c78ff17fd91479$var$PrefetchOn = {}));
module.exports.default = $56c78ff17fd91479$var$PrefetchOn;

});


parcelRegister("gqzKG", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $bf5ace9e2983c481$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $bf5ace9e2983c481$var$SimulcastLayers_1 = $bf5ace9e2983c481$var$__importDefault((parcelRequire("arWZg")));

const $bf5ace9e2983c481$var$SimulcastTransceiverController_1 = $bf5ace9e2983c481$var$__importDefault((parcelRequire("hl0rE")));

var $jfpqH = parcelRequire("jfpqH");

const $bf5ace9e2983c481$var$DefaultVideoCaptureAndEncodeParameter_1 = $bf5ace9e2983c481$var$__importDefault((parcelRequire("68tZD")));

const $bf5ace9e2983c481$var$BitrateParameters_1 = $bf5ace9e2983c481$var$__importDefault((parcelRequire("la1Bs")));
/**
 * [[DefaultSimulcastUplinkPolicy]] determines capture and encode
 *  parameters that reacts to estimated uplink bandwidth
 *
 * @deprecated Simulcast is deprecated in favor of scalable video coding (SVC).
 */ class $bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy {
    constructor(selfAttendeeId, logger){
        this.selfAttendeeId = selfAttendeeId;
        this.logger = logger;
        this.numSenders = 0;
        // Simulcast is disabled when there are only 2 or fewer attendees, because in that case the backend will forward REMBs from
        // receiver to sender. Therefore there is no need for simulcast based adaption.
        this.shouldDisableSimulcast = false;
        this.newQualityMap = new Map();
        this.currentQualityMap = new Map();
        this.newActiveStreams = 1 /* ActiveStreams.kHiAndLow */ ;
        this.videoIndex = null;
        this.observerQueue = new Set();
        this.hiTargetBitrateKbps = $bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kHiTargetBitrateKbpsHd;
        this.midTargetBitrateKbps = $bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kMidTargetBitrateKbpsHd;
        this.lowTargetBitrateKbps = $bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kLowTargetBitrateKbpsHd;
        this.enableFhdVideo = false;
        this.optimalParameters = new $bf5ace9e2983c481$var$DefaultVideoCaptureAndEncodeParameter_1.default(0, 0, 0, 0, true);
        this.parametersInEffect = new $bf5ace9e2983c481$var$DefaultVideoCaptureAndEncodeParameter_1.default(0, 0, 0, 0, true);
        this.currentQualityMap = this.fillEncodingParamWithBitrates([
            this.lowTargetBitrateKbps,
            0,
            this.hiTargetBitrateKbps
        ]);
        this.newQualityMap = this.fillEncodingParamWithBitrates([
            this.lowTargetBitrateKbps,
            0,
            this.hiTargetBitrateKbps
        ]);
    }
    updateConnectionMetric(_metrics) {}
    calculateEncodingParameters() {
        // bitrates parameter min is not used for now
        const newBitrates = [
            new $bf5ace9e2983c481$var$BitrateParameters_1.default(),
            new $bf5ace9e2983c481$var$BitrateParameters_1.default(),
            new $bf5ace9e2983c481$var$BitrateParameters_1.default()
        ];
        if (this.shouldDisableSimulcast) {
            // See comment above `shouldDisableSimulcast` for usage.
            //
            // The value of `newActiveStreams` is somewhat irrelevant since in one to one calls
            // we forward REMBs, so this single stream will adapt anywhere from < 100 kbps to 1200 kbps
            // based on both sender and receiver network conditions. E.g. A receiver may calculate it's
            // receive BWE as 300 kbps, send that in a REMB which is forwarded, and on receipt the sender
            // will set its own BWE at 300 kbps, and start sending that as well (again, only for one-to-one
            // calls). Additionally the value `kHi` is only relevant to the send side (via
            // `encodingSimulcastLayersDidChange`) as it is not transmitted in anyform to the receiver.
            //
            // We use middle layer here to work around a bug in Chromium where
            // it seems when a transceiver is created when BWE is low (e.g. on a reconnection),
            // it will never reset the encoder even when `setParameters` is called.  WebRTC bug
            // #12788 seems to call a similar issue out as fixed for VP8, it's not clear if this
            // is the same issue for H.264. Additionally we are not able to force a keyframe
            // request from the backend since it will only be sending padding (which also
            // don't have MID due to #10822). Since we don't scale when simulcast is disabled
            // this doesn't have any end-user effect.
            //
            // Note that this still relies on a little bit (5-6 packets) of padding on reconnect
            // and that technically the browser will still eventually try to send all 3 streams.
            //
            // Also note that due to some uninvestigated logic in bitrate allocation, Chromium
            // will skip the bottom layer if we try setting it to 1200 kbps instead so it will
            // still take a while to recover (as it needs to send padding until it reaches around
            // 1000 kbps).
            this.newActiveStreams = 0 /* ActiveStreams.kHi */ ;
            newBitrates[0].maxBitrateKbps = 0;
            newBitrates[1].maxBitrateKbps = this.hiTargetBitrateKbps;
            newBitrates[2].maxBitrateKbps = 0;
        } else if (this.numSenders <= 4) {
            // E.g., 320x192+ (640x384)  + 1280x768
            this.newActiveStreams = 1 /* ActiveStreams.kHiAndLow */ ;
            newBitrates[0].maxBitrateKbps = this.lowTargetBitrateKbps;
            newBitrates[1].maxBitrateKbps = 0;
            newBitrates[2].maxBitrateKbps = this.hiTargetBitrateKbps;
        } else {
            // E.g., 320x192 + 640x384 + (1280x768)
            this.newActiveStreams = 2 /* ActiveStreams.kMidAndLow */ ;
            // Given the high number of senders, we reduce the low bitrate marginally to
            // make it easier to obtain videos from all remote senders
            newBitrates[0].maxBitrateKbps = this.lowTargetBitrateKbps * 2 / 3;
            newBitrates[1].maxBitrateKbps = this.numSenders <= 6 ? this.midTargetBitrateKbps : this.midTargetBitrateKbps * 0.6;
            newBitrates[2].maxBitrateKbps = 0;
        }
        const bitrates = newBitrates.map((v, _i, _a)=>{
            return v.maxBitrateKbps;
        });
        this.newQualityMap = this.fillEncodingParamWithBitrates(bitrates);
        if (!this.encodingParametersEqual()) this.logger.info(`simulcast: policy:calculateEncodingParameters numSources:${this.numSenders} shouldDisableSimulcast:${this.shouldDisableSimulcast} newQualityMap: ${this.getQualityMapString(this.newQualityMap)}`);
        return this.newQualityMap;
    }
    chooseMediaTrackConstraints() {
        return undefined;
    }
    chooseEncodingParameters() {
        this.currentQualityMap = this.newQualityMap;
        if (this.activeStreamsToPublish !== this.newActiveStreams) {
            this.activeStreamsToPublish = this.newActiveStreams;
            this.publishEncodingSimulcastLayer();
        }
        return this.currentQualityMap;
    }
    updateIndex(videoIndex) {
        // the +1 for self is assuming that we intend to send video, since
        // the context here is VideoUplinkBandwidthPolicy
        const numSenders = videoIndex.numberOfVideoPublishingParticipantsExcludingSelf(this.selfAttendeeId) + 1;
        const numSendersChanged = numSenders !== this.numSenders;
        // See comment above `shouldDisableSimulcast`
        const numParticipants = videoIndex.numberOfParticipants();
        const newShouldDisableSimulcast = numParticipants >= 0 && numParticipants <= 2;
        const shouldDisableSimulcastChanged = this.shouldDisableSimulcast !== newShouldDisableSimulcast;
        this.numSenders = numSenders;
        this.shouldDisableSimulcast = newShouldDisableSimulcast;
        this.optimalParameters = new $bf5ace9e2983c481$var$DefaultVideoCaptureAndEncodeParameter_1.default(this.captureWidth(), this.captureHeight(), this.captureFrameRate(), this.maxBandwidthKbps(), false);
        this.videoIndex = videoIndex;
        if (numSendersChanged || shouldDisableSimulcastChanged) this.newQualityMap = this.calculateEncodingParameters();
    }
    wantsResubscribe() {
        return !this.encodingParametersEqual();
    }
    compareEncodingParameter(encoding1, encoding2) {
        return JSON.stringify(encoding1) === JSON.stringify(encoding2);
    }
    encodingParametersEqual() {
        let different = false;
        for (const ridName of $bf5ace9e2983c481$var$SimulcastTransceiverController_1.default.NAME_ARR_ASCENDING){
            different = different || !this.compareEncodingParameter(this.newQualityMap.get(ridName), this.currentQualityMap.get(ridName));
            if (different) break;
        }
        return !different;
    }
    chooseCaptureAndEncodeParameters() {
        // should deprecate in this policy
        this.parametersInEffect = this.optimalParameters.clone();
        return this.parametersInEffect.clone();
    }
    captureWidth() {
        // should deprecate in this policy
        const width = this.enableFhdVideo ? 1920 : 1280;
        return width;
    }
    captureHeight() {
        // should deprecate in this policy
        const height = this.enableFhdVideo ? 1080 : 768;
        return height;
    }
    captureFrameRate() {
        // should deprecate in this policy
        return 15;
    }
    maxBandwidthKbps() {
        // should deprecate in this policy
        return this.enableFhdVideo ? 2500 : 1400;
    }
    setIdealMaxBandwidthKbps(_idealMaxBandwidthKbps) {}
    setHasBandwidthPriority(_hasBandwidthPriority) {}
    setHighResolutionFeatureEnabled(enabled) {
        this.enableFhdVideo = enabled;
        // Raise the bitrates if we are sending FHD
        this.hiTargetBitrateKbps = enabled ? $bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kHiTargetBitrateKbpsFhd : $bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kHiTargetBitrateKbpsHd;
        this.midTargetBitrateKbps = enabled ? $bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kMidTargetBitrateKbpsFhd : $bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kMidTargetBitrateKbpsHd;
        this.lowTargetBitrateKbps = enabled ? $bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kLowTargetBitrateKbpsFhd : $bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kLowTargetBitrateKbpsHd;
    }
    wantsVideoDependencyDescriptorRtpHeaderExtension() {
        return true;
    }
    fillEncodingParamWithBitrates(bitratesKbps) {
        const newMap = new Map();
        const toBps = 1000;
        const nameArr = $bf5ace9e2983c481$var$SimulcastTransceiverController_1.default.NAME_ARR_ASCENDING;
        const bitrateArr = bitratesKbps;
        // Don't scale the single simulcast stream regardless of its layer.
        let scale = this.shouldDisableSimulcast ? 1 : 4;
        for(let i = 0; i < nameArr.length; i++){
            const ridName = nameArr[i];
            newMap.set(ridName, {
                rid: ridName,
                active: bitrateArr[i] > 0,
                scaleResolutionDownBy: Math.max(scale, 1),
                maxBitrate: bitrateArr[i] * toBps
            });
            scale = scale / 2;
        }
        return newMap;
    }
    getQualityMapString(params) {
        let qualityString = '';
        const localDescriptions = this.videoIndex.localStreamDescriptions();
        if (localDescriptions.length === 3) params.forEach((value)=>{
            qualityString += `{ rid: ${value.rid} active:${value.active} maxBitrate:${value.maxBitrate}}`;
        });
        return qualityString;
    }
    getEncodingSimulcastLayer(activeStreams) {
        switch(activeStreams){
            case 0 /* ActiveStreams.kHi */ :
                return $bf5ace9e2983c481$var$SimulcastLayers_1.default.High;
            case 1 /* ActiveStreams.kHiAndLow */ :
                return $bf5ace9e2983c481$var$SimulcastLayers_1.default.LowAndHigh;
            case 2 /* ActiveStreams.kMidAndLow */ :
                return $bf5ace9e2983c481$var$SimulcastLayers_1.default.LowAndMedium;
        }
    }
    publishEncodingSimulcastLayer() {
        const simulcastLayers = this.getEncodingSimulcastLayer(this.activeStreamsToPublish);
        this.forEachObserver((observer)=>{
            $jfpqH.Maybe.of(observer.encodingSimulcastLayersDidChange).map((f)=>f.bind(observer)(simulcastLayers));
        });
    }
    addObserver(observer) {
        this.logger.info('adding simulcast uplink observer');
        this.observerQueue.add(observer);
    }
    removeObserver(observer) {
        this.logger.info('removing simulcast uplink observer');
        this.observerQueue.delete(observer);
    }
    forEachObserver(observerFunc) {
        for (const observer of this.observerQueue)observerFunc(observer);
    }
}
$bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kHiTargetBitrateKbpsHd = 1200;
$bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kMidTargetBitrateKbpsHd = 600;
$bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kLowTargetBitrateKbpsHd = 300;
$bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kHiTargetBitrateKbpsFhd = 2000;
$bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kMidTargetBitrateKbpsFhd = 1000;
$bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy.kLowTargetBitrateKbpsFhd = 500;
module.exports.default = $bf5ace9e2983c481$var$DefaultSimulcastUplinkPolicy;

});
parcelRegister("arWZg", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimulcastLayers = void 0;
/**
 * [[SimulcastLayers]] represents simulcast layers for selected simulcast video streams.
 *
 * @deprecated Simulcast is deprecated in favor of scalable video coding (SVC).
 */ var $79ba2ea1d1d723e3$var$SimulcastLayers;
(function(SimulcastLayers) {
    /**
     * Low resolution video stream.
     */ SimulcastLayers[SimulcastLayers["Low"] = 0] = "Low";
    /**
     * Low and medium resolution video streams.
     */ SimulcastLayers[SimulcastLayers["LowAndMedium"] = 1] = "LowAndMedium";
    /**
     * Low and high resolution video streams.
     */ SimulcastLayers[SimulcastLayers["LowAndHigh"] = 2] = "LowAndHigh";
    /**
     * Medium resolution video stream.
     */ SimulcastLayers[SimulcastLayers["Medium"] = 3] = "Medium";
    /**
     * Medium and high resolution video streams.
     */ SimulcastLayers[SimulcastLayers["MediumAndHigh"] = 4] = "MediumAndHigh";
    /**
     * High resolution video stream.
     */ SimulcastLayers[SimulcastLayers["High"] = 5] = "High";
})($79ba2ea1d1d723e3$var$SimulcastLayers || (module.exports.SimulcastLayers = $79ba2ea1d1d723e3$var$SimulcastLayers = {}));
module.exports.default = $79ba2ea1d1d723e3$var$SimulcastLayers;

});

parcelRegister("68tZD", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $477ac1721d48fe17$var$DefaultVideoCaptureAndEncodeParameter {
    constructor(cameraWidth, cameraHeight, cameraFrameRate, maxEncodeBitrateKbps, isSimulcast, scaleResolutionDownBy = 1, isSVC = false){
        this.cameraWidth = cameraWidth;
        this.cameraHeight = cameraHeight;
        this.cameraFrameRate = cameraFrameRate;
        this.maxEncodeBitrateKbps = maxEncodeBitrateKbps;
        this.isSimulcast = isSimulcast;
        this.scaleResolutionDownBy = scaleResolutionDownBy;
        this.isSVC = isSVC;
    }
    equal(other) {
        let checkForEqual = other.captureWidth() === this.cameraWidth && other.captureHeight() === this.cameraHeight && other.captureFrameRate() === this.cameraFrameRate && other.encodeBitrates().length === this.encodeBitrates().length && other.encodeScaleResolutionDownBy().length === this.encodeScaleResolutionDownBy().length && other.encodeWidths().length === this.encodeWidths().length && other.encodeHeights().length === this.encodeHeights().length && other.isSVCEncoding() === this.isSVC;
        if (checkForEqual) {
            for(let i = 0; i < other.encodeWidths().length; i++)if (other.encodeWidths()[i] !== this.encodeWidths()[i] || other.encodeHeights()[i] !== this.encodeHeights()[i] || other.encodeBitrates()[i] !== this.encodeBitrates()[i] || other.encodeScaleResolutionDownBy()[i] !== this.encodeScaleResolutionDownBy()[i]) {
                checkForEqual = false;
                return checkForEqual;
            }
        }
        return checkForEqual;
    }
    clone() {
        return new $477ac1721d48fe17$var$DefaultVideoCaptureAndEncodeParameter(this.cameraWidth, this.cameraHeight, this.cameraFrameRate, this.maxEncodeBitrateKbps, this.isSimulcast, this.scaleResolutionDownBy, this.isSVC);
    }
    captureWidth() {
        return this.cameraWidth;
    }
    captureHeight() {
        return this.cameraHeight;
    }
    captureFrameRate() {
        return this.cameraFrameRate;
    }
    encodeBitrates() {
        // TODO: add simulcast layer
        return [
            this.maxEncodeBitrateKbps
        ];
    }
    encodeScaleResolutionDownBy() {
        return [
            this.scaleResolutionDownBy
        ];
    }
    encodeWidths() {
        return [
            this.cameraWidth
        ];
    }
    encodeHeights() {
        return [
            this.cameraHeight
        ];
    }
    isSVCEncoding() {
        return this.isSVC;
    }
}
module.exports.default = $477ac1721d48fe17$var$DefaultVideoCaptureAndEncodeParameter;

});


parcelRegister("ikcNO", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $d5740688b74659cb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $d5740688b74659cb$var$VideoElementFrameMonitor_1 = $d5740688b74659cb$var$__importDefault((parcelRequire("avwXQ")));
class $d5740688b74659cb$var$DefaultVideoElementResolutionMonitor {
    constructor(){
        this.observerQueue = new Set();
        this.element = null;
        this.frameMonitor = new $d5740688b74659cb$var$VideoElementFrameMonitor_1.default();
        this.resizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries){
                const { width: width, height: height } = entry.contentRect;
                for (const observer of this.observerQueue)observer.videoElementResolutionChanged(width, height);
            }
        });
    }
    registerObserver(observer) {
        this.observerQueue.add(observer);
    }
    removeObserver(observer) {
        this.observerQueue.delete(observer);
    }
    bindVideoElement(newElement) {
        if (this.element === newElement) return;
        if (this.element) {
            this.resizeObserver.unobserve(this.element);
            this.frameMonitor.stop();
        }
        this.element = newElement;
        if (this.element) {
            this.resizeObserver.observe(this.element);
            this.frameMonitor.start(this.element, {
                firstVideoElementFrameDidRender: (metadata)=>{
                    var _a;
                    for (const observer of this.observerQueue)(_a = observer.videoElementFirstFrameDidRender) === null || _a === void 0 || _a.call(observer, metadata);
                },
                videoElementFrameMetricsDidReceive: (metrics)=>{
                    var _a;
                    for (const observer of this.observerQueue)(_a = observer.videoElementMetricsDidReceive) === null || _a === void 0 || _a.call(observer, metrics);
                }
            });
        }
    }
}
module.exports.default = $d5740688b74659cb$var$DefaultVideoElementResolutionMonitor;

});
parcelRegister("avwXQ", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Monitors a video element for first-frame rendering and ongoing FPS metrics.
 *
 * Internally uses requestVideoFrameCallback when available (Chrome/Edge) and
 * falls back to the 'resize' event for first-frame detection on other browsers.
 * FPS tracking is only available when requestVideoFrameCallback is supported.
 */ class $7a665ea9396e2726$var$VideoElementFrameMonitor {
    constructor(){
        this.element = null;
        this.observer = null;
        this.firstFrameRendered = false;
        // requestVideoFrameCallback-based tracking
        this.videoFrameCallbackId = null;
        this.metricsCallbackId = null;
        this.frameCount = 0;
        this.metricsWindowStartMs = 0;
        // Resize fallback
        this.resizeListener = null;
    }
    get supportsVideoFrameCallback() {
        return this.element !== null && 'requestVideoFrameCallback' in this.element;
    }
    /**
     * Start monitoring the given element with the given observer.
     * Any previous monitoring is stopped first.
     */ start(element, observer) {
        this.stop();
        this.element = element;
        this.observer = observer;
        this.firstFrameRendered = false;
        this.startFirstFrameDetection();
    }
    /**
     * Stop monitoring and release all resources.
     */ stop() {
        if (!this.element) return;
        this.stopMetricsTracking();
        if (this.videoFrameCallbackId !== null) {
            this.element.cancelVideoFrameCallback(this.videoFrameCallbackId);
            this.videoFrameCallbackId = null;
        }
        if (this.resizeListener) {
            this.element.removeEventListener('resize', this.resizeListener);
            this.resizeListener = null;
        }
        this.element = null;
        this.observer = null;
    }
    startFirstFrameDetection() {
        if (this.supportsVideoFrameCallback) this.videoFrameCallbackId = this.element.requestVideoFrameCallback((_now, metadata)=>{
            this.videoFrameCallbackId = null;
            this.onFirstFrame(metadata);
        });
        else {
            this.resizeListener = ()=>{
                if (this.element.videoWidth > 0 && this.element.videoHeight > 0) {
                    this.element.removeEventListener('resize', this.resizeListener);
                    this.resizeListener = null;
                    this.onFirstFrame();
                }
            };
            this.element.addEventListener('resize', this.resizeListener);
        }
    }
    onFirstFrame(metadata) {
        var _a, _b;
        if (this.firstFrameRendered) return;
        this.firstFrameRendered = true;
        /* istanbul ignore next */ (_b = (_a = this.observer) === null || _a === void 0 ? void 0 : _a.firstVideoElementFrameDidRender) === null || _b === void 0 || _b.call(_a, metadata);
        if (this.supportsVideoFrameCallback) this.startMetricsTracking();
    }
    startMetricsTracking() {
        this.frameCount = 0;
        this.metricsWindowStartMs = Date.now();
        this.scheduleMetricsCallback();
    }
    scheduleMetricsCallback() {
        if (!this.element) return;
        this.metricsCallbackId = this.element.requestVideoFrameCallback(()=>{
            var _a, _b;
            this.frameCount++;
            const now = Date.now();
            const elapsed = now - this.metricsWindowStartMs;
            if (elapsed >= $7a665ea9396e2726$var$VideoElementFrameMonitor.METRICS_INTERVAL_MS) {
                const fps = Math.round(this.frameCount * 1000 / elapsed);
                /* istanbul ignore next */ (_b = (_a = this.observer) === null || _a === void 0 ? void 0 : _a.videoElementFrameMetricsDidReceive) === null || _b === void 0 || _b.call(_a, {
                    fps: fps,
                    timestampMs: now
                });
                this.frameCount = 0;
                this.metricsWindowStartMs = now;
            }
            this.scheduleMetricsCallback();
        });
    }
    stopMetricsTracking() {
        if (this.metricsCallbackId !== null && this.element && 'cancelVideoFrameCallback' in this.element) {
            this.element.cancelVideoFrameCallback(this.metricsCallbackId);
            this.metricsCallbackId = null;
        }
        this.frameCount = 0;
        this.metricsWindowStartMs = 0;
    }
}
$7a665ea9396e2726$var$VideoElementFrameMonitor.METRICS_INTERVAL_MS = 1000;
module.exports.default = $7a665ea9396e2726$var$VideoElementFrameMonitor;

});


parcelRegister("a9cGZ", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $76349717a737d281$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4huDn = parcelRequire("4huDn");

const $76349717a737d281$var$DefaultVideoStreamIdSet_1 = $76349717a737d281$var$__importDefault((parcelRequire("gVZQM")));

const $76349717a737d281$var$VideoStreamDescription_1 = $76349717a737d281$var$__importDefault((parcelRequire("6WiTW")));
/**
 * [[DefaultVideoStreamIndex]] implements [[VideoStreamIndex]] to facilitate video stream subscription
 * and includes query functions for stream id and attendee id.
 */ class $76349717a737d281$var$DefaultVideoStreamIndex {
    constructor(logger){
        this.logger = logger;
        this.currentIndex = null;
        this.indexForSubscribe = null;
        this.indexForLastRemoteVideoUpdate = null;
        this.currentSubscribeAck = null;
        // These are based on the index at the time of the last Subscribe Ack
        this.subscribeTrackToStreamMap = null;
        this.subscribeStreamToAttendeeMap = null;
        this.subscribeStreamToExternalUserIdMap = null;
        this.subscribeSsrcToStreamMap = null;
        this.subscribeSsrcToGroupMap = null;
        // These are based on the most up to date index
        this.streamToAttendeeMap = null;
        this.groupIdToAttendeeMap = null;
        this.streamToExternalUserIdMap = null;
        this.videoStreamDescription = new $76349717a737d281$var$VideoStreamDescription_1.default();
        this.sendVideoStreamId = 0;
        this.videoStreamDescription.trackLabel = 'AmazonChimeExpressVideo';
        this.videoStreamDescription.streamId = 2;
        this.videoStreamDescription.groupId = 2;
    }
    localStreamDescriptions() {
        // localStreamDescriptions are used to construct IndexFrame
        // old behavior for single video is to have streamId and groupId trackLabel fixed as the follows
        return [
            this.videoStreamDescription.clone()
        ];
    }
    convertBpsToKbps(avgBitrateBps) {
        if (avgBitrateBps > 0 && avgBitrateBps < 1000) return 1;
        else return Math.trunc(avgBitrateBps / 1000);
    }
    remoteStreamDescriptions() {
        if (!this.currentIndex || !this.currentIndex.sources) return [];
        const streamInfos = [];
        this.currentIndex.sources.forEach((source)=>{
            const description = new $76349717a737d281$var$VideoStreamDescription_1.default();
            description.attendeeId = source.attendeeId;
            description.groupId = source.groupId;
            description.streamId = source.streamId;
            description.maxBitrateKbps = source.maxBitrateKbps;
            description.avgBitrateKbps = this.convertBpsToKbps(source.avgBitrateBps);
            description.width = source.width;
            description.height = source.height;
            description.maxFrameRate = source.framerate;
            streamInfos.push(description);
        });
        return streamInfos;
    }
    integrateUplinkPolicyDecision(param) {
        if (!!param && param.length) {
            const encodingParam = param[0];
            this.videoStreamDescription.maxBitrateKbps = encodingParam.maxBitrate / 1000;
            this.videoStreamDescription.maxFrameRate = encodingParam.maxFramerate;
        }
    }
    integrateIndexFrame(indexFrame) {
        this.currentIndex = indexFrame;
        if (!indexFrame) return;
        // In the Amazon Chime SDKs, we assume a one to one mapping of group ID to profile ID when creating
        // video tiles (multiple video sources are supported through applying a `Modality` to a given profile/session token)
        //
        // We enforce this here to mitigate any possible duplicate group IDs left from a reconnection where the previous
        // signal channel hasn't been timed out yet.  To guarantee we receive the latest stream we use the highest group ID
        // since they are monotonically increasing.
        const attendeeIdToMainGroupIdMap = new Map();
        // Improve performance by not filtering sources unless
        // we know the list will actually change
        let attendeeWithMultipleGroupIdsExists = false;
        for (const source of indexFrame.sources){
            if (!attendeeIdToMainGroupIdMap.has(source.attendeeId)) {
                // We haven't see this attendee ID so just keep track of it
                attendeeIdToMainGroupIdMap.set(source.attendeeId, source.groupId);
                continue;
            }
            // Otherwise see if we should use the group ID corresponding to this source (we prefer the highest for each attendee)
            const currentGroupId = attendeeIdToMainGroupIdMap.get(source.attendeeId);
            if (currentGroupId < source.groupId) {
                this.logger.warn(`Old group ID ${currentGroupId} found for attendee ID ${source.attendeeId}, replacing with newer group ID ${source.groupId}`);
                attendeeIdToMainGroupIdMap.set(source.attendeeId, source.groupId);
            }
            attendeeWithMultipleGroupIdsExists = true;
        }
        if (attendeeWithMultipleGroupIdsExists) // Only use the sources corresponding to the main group IDs for the given attendee ID
        this.currentIndex.sources = this.currentIndex.sources.filter((source)=>attendeeIdToMainGroupIdMap.get(source.attendeeId) === source.groupId);
        // Null out cached maps, these will be recreated on demand
        this.streamToAttendeeMap = null;
        this.groupIdToAttendeeMap = null;
        this.streamToExternalUserIdMap = null;
    }
    subscribeFrameSent() {
        // This is called just as a Subscribe is being sent.  Save corresponding Index
        this.indexForSubscribe = this.currentIndex;
    }
    remoteVideoUpdateSent() {
        this.indexForLastRemoteVideoUpdate = this.currentIndex;
    }
    integrateSubscribeAckFrame(subscribeAck) {
        this.currentSubscribeAck = subscribeAck;
        // These are valid until the next Subscribe Ack even if the index is updated
        this.subscribeTrackToStreamMap = this.buildTrackToStreamMap(this.currentSubscribeAck);
        this.subscribeSsrcToStreamMap = this.buildSSRCToStreamMap(this.currentSubscribeAck);
        this.subscribeSsrcToGroupMap = this.buildSSRCToGroupMap(this.currentSubscribeAck);
        this.subscribeStreamToAttendeeMap = this.buildStreamToAttendeeMap(this.indexForSubscribe);
        this.subscribeStreamToExternalUserIdMap = this.buildStreamExternalUserIdMap(this.indexForSubscribe);
        this.sendVideoStreamId = 0;
        if (subscribeAck.allocations && subscribeAck.allocations !== undefined && subscribeAck.allocations.length > 0) this.sendVideoStreamId = subscribeAck.allocations[0].streamId;
    }
    integrateBitratesFrame(bitrates) {
        if (this.currentIndex) for (const bitrate of bitrates.bitrates){
            const source = this.currentIndex.sources.find((source)=>source.streamId === bitrate.sourceStreamId);
            if (source !== undefined) source.avgBitrateBps = bitrate.avgBitrateBps;
        }
    }
    allStreams() {
        const set = new $76349717a737d281$var$DefaultVideoStreamIdSet_1.default();
        if (this.currentIndex) for (const source of this.currentIndex.sources)set.add(source.streamId);
        return set;
    }
    allVideoSendingSourcesExcludingSelf(selfAttendeeId) {
        const videoSources = [];
        const attendeeSet = new Set();
        if (this.currentIndex) {
            if (this.currentIndex.sources && this.currentIndex.sources.length) for (const stream of this.currentIndex.sources){
                const { attendeeId: attendeeId, externalUserId: externalUserId, mediaType: mediaType } = stream;
                if (attendeeId !== selfAttendeeId && mediaType === $4huDn.SdkStreamMediaType.VIDEO) {
                    if (!attendeeSet.has(attendeeId)) {
                        videoSources.push({
                            attendee: {
                                attendeeId: attendeeId,
                                externalUserId: externalUserId
                            }
                        });
                        attendeeSet.add(attendeeId);
                    }
                }
            }
        }
        return videoSources;
    }
    streamSelectionUnderBandwidthConstraint(selfAttendeeId, largeTileAttendeeIds, smallTileAttendeeIds, bandwidthKbps) {
        const newAttendees = new Set();
        if (this.currentIndex) for (const stream of this.currentIndex.sources){
            if (stream.attendeeId === selfAttendeeId || stream.mediaType !== $4huDn.SdkStreamMediaType.VIDEO) continue;
            if (!largeTileAttendeeIds.has(stream.attendeeId) && !smallTileAttendeeIds.has(stream.attendeeId)) newAttendees.add(stream.attendeeId);
        }
        const attendeeToStreamDescriptorMap = this.buildAttendeeToSortedStreamDescriptorMapExcludingSelf(selfAttendeeId);
        const selectionMap = new Map();
        let usage = 0;
        attendeeToStreamDescriptorMap.forEach((streams, attendeeId)=>{
            selectionMap.set(attendeeId, streams[0]);
            usage += streams[0].maxBitrateKbps;
        });
        usage = this.trySelectHighBitrateForAttendees(attendeeToStreamDescriptorMap, largeTileAttendeeIds, usage, bandwidthKbps, selectionMap);
        this.trySelectHighBitrateForAttendees(attendeeToStreamDescriptorMap, newAttendees, usage, bandwidthKbps, selectionMap);
        const streamSelectionSet = new $76349717a737d281$var$DefaultVideoStreamIdSet_1.default();
        for (const source of selectionMap.values())streamSelectionSet.add(source.streamId);
        return streamSelectionSet;
    }
    highestQualityStreamFromEachGroupExcludingSelf(selfAttendeeId) {
        const set = new $76349717a737d281$var$DefaultVideoStreamIdSet_1.default();
        if (this.currentIndex) {
            const maxes = new Map();
            for (const source of this.currentIndex.sources){
                if (source.attendeeId === selfAttendeeId || source.mediaType !== $4huDn.SdkStreamMediaType.VIDEO) continue;
                if (!maxes.has(source.groupId) || source.maxBitrateKbps > maxes.get(source.groupId).maxBitrateKbps) maxes.set(source.groupId, source);
            }
            for (const source of maxes.values())set.add(source.streamId);
        }
        return set;
    }
    numberOfVideoPublishingParticipantsExcludingSelf(selfAttendeeId) {
        return this.highestQualityStreamFromEachGroupExcludingSelf(selfAttendeeId).array().length;
    }
    numberOfParticipants() {
        if (this.currentIndex.numParticipants) return this.currentIndex.numParticipants;
        return -1;
    }
    attendeeIdForTrack(trackId) {
        const streamId = this.streamIdForTrack(trackId);
        if (streamId === undefined || !this.subscribeStreamToAttendeeMap) {
            this.logger.warn(`no attendee found for track ${trackId}`);
            return '';
        }
        const attendeeId = this.subscribeStreamToAttendeeMap.get(streamId);
        if (!attendeeId) {
            this.logger.info(`track ${trackId} (stream ${streamId}) does not correspond to a known attendee`);
            return '';
        }
        return attendeeId;
    }
    externalUserIdForTrack(trackId) {
        const streamId = this.streamIdForTrack(trackId);
        if (streamId === undefined || !this.subscribeStreamToExternalUserIdMap) {
            this.logger.warn(`no external user id found for track ${trackId}`);
            return '';
        }
        const externalUserId = this.subscribeStreamToExternalUserIdMap.get(streamId);
        if (!externalUserId) {
            this.logger.info(`track ${trackId} (stream ${streamId}) does not correspond to a known externalUserId`);
            return '';
        }
        return externalUserId;
    }
    attendeeIdForStreamId(streamId) {
        if (!this.streamToAttendeeMap) {
            if (this.currentIndex) this.streamToAttendeeMap = this.buildStreamToAttendeeMap(this.currentIndex);
            else return '';
        }
        const attendeeId = this.streamToAttendeeMap.get(streamId);
        if (!attendeeId) {
            this.logger.info(`stream ID ${streamId} does not correspond to a known attendee`);
            return '';
        }
        return attendeeId;
    }
    attendeeIdForGroupId(groupId) {
        if (!this.groupIdToAttendeeMap) {
            if (this.currentIndex) this.groupIdToAttendeeMap = this.buildGroupIdToAttendeeMap(this.currentIndex);
            else return '';
        }
        const attendeeId = this.groupIdToAttendeeMap.get(groupId);
        if (!attendeeId) {
            this.logger.info(`group ID ${groupId} does not correspond to a known attendee`);
            return '';
        }
        return attendeeId;
    }
    groupIdForStreamId(streamId) {
        if (!this.currentIndex || !this.currentIndex.sources) return undefined;
        for (const source of this.currentIndex.sources){
            if (source.streamId === streamId) return source.groupId;
        }
        // If wasn't found in current index, then it could be in index used in last subscribe
        if (this.indexForSubscribe) for (const source of this.indexForSubscribe.sources){
            if (source.streamId === streamId) return source.groupId;
        }
        // Lastly check if it can be found in the index last used for remote video update
        if (this.indexForLastRemoteVideoUpdate) for (const source of this.indexForLastRemoteVideoUpdate.sources){
            if (source.streamId === streamId) return source.groupId;
        }
        return undefined;
    }
    StreamIdsInSameGroup(streamId1, streamId2) {
        if (this.groupIdForStreamId(streamId1) === this.groupIdForStreamId(streamId2)) return true;
        return false;
    }
    streamIdForTrack(trackId) {
        if (!this.subscribeTrackToStreamMap) return undefined;
        return this.subscribeTrackToStreamMap.get(trackId);
    }
    streamIdForSSRC(ssrcId) {
        if (!this.subscribeSsrcToStreamMap) return undefined;
        return this.subscribeSsrcToStreamMap.get(ssrcId);
    }
    overrideStreamIdMappings(previous, current) {
        if (this.subscribeTrackToStreamMap) {
            for (const [track, streamId] of this.subscribeTrackToStreamMap.entries())if (previous === streamId) {
                this.subscribeTrackToStreamMap.set(track, current);
                break;
            }
        }
        if (this.subscribeSsrcToStreamMap) {
            for (const [ssrc, streamId] of this.subscribeSsrcToStreamMap.entries())if (previous === streamId) {
                this.subscribeSsrcToStreamMap.set(ssrc, current);
                break;
            }
        }
    }
    groupIdForSSRC(ssrcId) {
        if (!this.subscribeSsrcToGroupMap) return undefined;
        return this.subscribeSsrcToGroupMap.get(ssrcId);
    }
    streamsPausedAtSource() {
        const paused = new $76349717a737d281$var$DefaultVideoStreamIdSet_1.default();
        if (this.currentIndex) for (const streamId of this.currentIndex.pausedAtSourceIds)paused.add(streamId);
        return paused;
    }
    sendVideoStreamIdFromRid(_rid) {
        return this.sendVideoStreamId;
    }
    buildTrackToStreamMap(subscribeAck) {
        const map = new Map();
        this.logger.debug(()=>`trackMap ${JSON.stringify(subscribeAck.tracks)}`);
        for (const trackMapping of subscribeAck.tracks)if (trackMapping.trackLabel.length > 0 && trackMapping.streamId > 0) map.set(trackMapping.trackLabel, trackMapping.streamId);
        return map;
    }
    buildSSRCToStreamMap(subscribeAck) {
        const map = new Map();
        this.logger.debug(()=>`ssrcMap ${JSON.stringify(subscribeAck.tracks)}`);
        for (const trackMapping of subscribeAck.tracks)if (trackMapping.trackLabel.length > 0 && trackMapping.streamId > 0) map.set(trackMapping.ssrc, trackMapping.streamId);
        return map;
    }
    buildSSRCToGroupMap(subscribeAck) {
        const map = new Map();
        for (const trackMapping of subscribeAck.tracks)if (trackMapping.trackLabel.length > 0 && trackMapping.streamId > 0) map.set(trackMapping.ssrc, this.groupIdForStreamId(trackMapping.streamId));
        return map;
    }
    buildStreamToAttendeeMap(indexFrame) {
        const map = new Map();
        if (indexFrame) for (const source of indexFrame.sources)map.set(source.streamId, source.attendeeId);
        return map;
    }
    buildGroupIdToAttendeeMap(indexFrame) {
        const map = new Map();
        for (const source of indexFrame.sources)map.set(source.groupId, source.attendeeId);
        return map;
    }
    buildStreamExternalUserIdMap(indexFrame) {
        const map = new Map();
        if (indexFrame) {
            for (const source of indexFrame.sources)if (source.externalUserId) map.set(source.streamId, source.externalUserId);
        }
        return map;
    }
    trySelectHighBitrateForAttendees(attendeeToStreamDescriptorMap, highAttendees, currentUsage, bandwidthKbps, currentSelectionRef) {
        for (const attendeeId of highAttendees){
            if (currentUsage >= bandwidthKbps) break;
            if (attendeeToStreamDescriptorMap.has(attendeeId)) {
                const streams = attendeeToStreamDescriptorMap.get(attendeeId);
                for (const l of streams.reverse())if (currentUsage - currentSelectionRef.get(attendeeId).maxBitrateKbps + l.maxBitrateKbps < bandwidthKbps) {
                    currentUsage = currentUsage - currentSelectionRef.get(attendeeId).maxBitrateKbps + l.maxBitrateKbps;
                    currentSelectionRef.set(attendeeId, l);
                    break;
                }
            }
        }
        return currentUsage;
    }
    buildAttendeeToSortedStreamDescriptorMapExcludingSelf(selfAttendeeId) {
        const attendeeToStreamDescriptorMap = new Map();
        if (this.currentIndex) for (const source of this.currentIndex.sources){
            if (source.attendeeId === selfAttendeeId || source.mediaType !== $4huDn.SdkStreamMediaType.VIDEO) continue;
            if (attendeeToStreamDescriptorMap.has(source.attendeeId)) attendeeToStreamDescriptorMap.get(source.attendeeId).push(source);
            else attendeeToStreamDescriptorMap.set(source.attendeeId, [
                source
            ]);
        }
        attendeeToStreamDescriptorMap.forEach((streams, _attendeeId)=>{
            streams.sort((stream1, stream2)=>{
                if (stream1.maxBitrateKbps > stream2.maxBitrateKbps) return 1;
                else if (stream1.maxBitrateKbps < stream2.maxBitrateKbps) return -1;
                else return 0;
            });
        });
        return attendeeToStreamDescriptorMap;
    }
}
module.exports.default = $76349717a737d281$var$DefaultVideoStreamIndex;

});
parcelRegister("6WiTW", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4huDn = parcelRequire("4huDn");
class $50d6d23e429d8010$var$VideoStreamDescription {
    constructor(attendeeId, groupId, streamId, maxBitrateKbps, avgBitrateKbps){
        this.attendeeId = '';
        this.groupId = 0;
        this.streamId = 0;
        this.ssrc = 0;
        this.trackLabel = '';
        this.maxBitrateKbps = 0;
        // average bitrate is updated every 2 seconds via bitrates messages
        this.avgBitrateKbps = 0;
        this.maxFrameRate = 0;
        this.width = 0;
        this.height = 0;
        this.timeEnabled = 0;
        // Unused, should be removed in a future release
        this.disabledByWebRTC = false;
        this.disabledByUplinkPolicy = false;
        this.rid = '';
        this.attendeeId = attendeeId;
        this.groupId = groupId;
        this.streamId = streamId;
        this.maxBitrateKbps = maxBitrateKbps;
        this.avgBitrateKbps = avgBitrateKbps;
    }
    clone() {
        const newInfo = new $50d6d23e429d8010$var$VideoStreamDescription();
        newInfo.attendeeId = this.attendeeId;
        newInfo.groupId = this.groupId;
        newInfo.streamId = this.streamId;
        newInfo.ssrc = this.ssrc;
        newInfo.trackLabel = this.trackLabel;
        newInfo.maxBitrateKbps = this.maxBitrateKbps;
        newInfo.avgBitrateKbps = this.avgBitrateKbps;
        newInfo.maxFrameRate = this.maxFrameRate;
        newInfo.timeEnabled = this.timeEnabled;
        newInfo.disabledByUplinkPolicy = this.disabledByUplinkPolicy;
        newInfo.width = this.width;
        newInfo.height = this.height;
        return newInfo;
    }
    toStreamDescriptor() {
        const descriptor = $4huDn.SdkStreamDescriptor.create();
        descriptor.mediaType = $4huDn.SdkStreamMediaType.VIDEO;
        descriptor.trackLabel = this.trackLabel;
        descriptor.attendeeId = this.attendeeId;
        descriptor.streamId = this.streamId;
        descriptor.groupId = this.groupId;
        descriptor.framerate = this.maxFrameRate;
        descriptor.maxBitrateKbps = this.disabledByUplinkPolicy ? 0 : this.maxBitrateKbps;
        descriptor.avgBitrateBps = this.avgBitrateKbps;
        return descriptor;
    }
    totalPixels() {
        return this.width * this.height;
    }
}
module.exports.default = $50d6d23e429d8010$var$VideoStreamDescription;

});


parcelRegister("1dk1T", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $0e268ac63e573e38$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $0e268ac63e573e38$var$VideoQualitySettings_1 = $0e268ac63e573e38$var$__importDefault((parcelRequire("3C9sO")));

const $0e268ac63e573e38$var$DefaultDevicePixelRatioMonitor_1 = $0e268ac63e573e38$var$__importDefault((parcelRequire("lVjeU")));

const $0e268ac63e573e38$var$DevicePixelRatioWindowSource_1 = $0e268ac63e573e38$var$__importDefault((parcelRequire("bXLxF")));

var $jfpqH = parcelRequire("jfpqH");

const $0e268ac63e573e38$var$DefaultVideoElementResolutionMonitor_1 = $0e268ac63e573e38$var$__importDefault((parcelRequire("ikcNO")));

const $0e268ac63e573e38$var$DefaultVideoTile_1 = $0e268ac63e573e38$var$__importDefault((parcelRequire("dBfpS")));
class $0e268ac63e573e38$var$DefaultVideoTileController {
    constructor(tileFactory, audioVideoController, logger){
        this.tileFactory = tileFactory;
        this.audioVideoController = audioVideoController;
        this.logger = logger;
        this.tileMap = new Map();
        this.nextTileId = 1;
        this.currentLocalTile = null;
        this.currentPausedTilesByIds = new Set();
        this.resolutionObservers = new Set();
        this.keepLastFrameWhenPaused = false;
        this.keepLastFrameWhenPaused = audioVideoController.configuration.keepLastFrameWhenPaused;
    }
    createDevicePixelRatioMonitorIfNeeded() {
        if (this.devicePixelRatioMonitor) return;
        this.devicePixelRatioMonitor = new $0e268ac63e573e38$var$DefaultDevicePixelRatioMonitor_1.default(new $0e268ac63e573e38$var$DevicePixelRatioWindowSource_1.default(), this.logger);
    }
    async discardDevicePixelRatioMonitorIfNotNeeded() {
        if (this.tileMap.size || !this.devicePixelRatioMonitor) return;
        const monitor = this.devicePixelRatioMonitor;
        this.devicePixelRatioMonitor = undefined;
        return monitor.destroy();
    }
    bindVideoElement(tileId, videoElement) {
        var _a, _b;
        const tile = this.getVideoTile(tileId);
        if (tile === null) {
            this.logger.warn(`Ignoring video element binding for unknown tile id ${tileId}`);
            return;
        }
        tile.bindVideoElement(videoElement);
        if (videoElement && !tile.state().localTile) {
            const groupId = (_a = tile.state().groupId) !== null && _a !== void 0 ? _a : null;
            if (groupId !== null) for (const observer of this.resolutionObservers)(_b = observer.videoTileBound) === null || _b === void 0 || _b.call(observer, groupId);
        }
    }
    unbindVideoElement(tileId, cleanUpVideoElement = true) {
        const tile = this.getVideoTile(tileId);
        if (tile === null) {
            this.logger.warn(`Ignoring video element unbinding for unknown tile id ${tileId}`);
            return;
        }
        this.logger.info('Unbinding the video element');
        for (const observer of this.resolutionObservers)observer.videoTileUnbound(tile.state().boundAttendeeId, tile.state().groupId);
        const videoElement = tile.stateRef().boundVideoElement;
        tile.bindVideoElement(null);
        if (cleanUpVideoElement) {
            this.logger.info('Cleaning up the video element');
            $0e268ac63e573e38$var$DefaultVideoTile_1.default.disconnectVideoStreamFromVideoElement(videoElement, false);
        }
    }
    startLocalVideoTile() {
        if (this.audioVideoController.configuration.meetingFeatures.videoMaxResolution === $0e268ac63e573e38$var$VideoQualitySettings_1.default.VideoDisabled) {
            this.logger.warn('Could not start camera video because max video resolution was set to None');
            return -1;
        }
        const tile = this.findOrCreateLocalVideoTile();
        this.currentLocalTile.stateRef().localTileStarted = true;
        this.audioVideoController.update({
            needsRenegotiation: true
        });
        return tile.id();
    }
    stopLocalVideoTile() {
        if (!this.currentLocalTile) return;
        this.currentLocalTile.stateRef().localTileStarted = false;
        this.currentLocalTile.bindVideoStream(this.audioVideoController.configuration.credentials.attendeeId, true, null, null, null, null, this.audioVideoController.configuration.credentials.externalUserId);
        this.audioVideoController.update({
            needsRenegotiation: true
        });
    }
    hasStartedLocalVideoTile() {
        return !!(this.currentLocalTile && this.currentLocalTile.stateRef().localTileStarted);
    }
    removeLocalVideoTile() {
        if (this.currentLocalTile) this.removeVideoTile(this.currentLocalTile.id());
    }
    getLocalVideoTile() {
        return this.currentLocalTile;
    }
    pauseVideoTile(tileId) {
        const tile = this.getVideoTile(tileId);
        if (tile) {
            if (!this.currentPausedTilesByIds.has(tileId)) {
                this.audioVideoController.pauseReceivingStream(tile.stateRef().streamId);
                this.currentPausedTilesByIds.add(tileId);
            }
            tile.pause();
        }
    }
    unpauseVideoTile(tileId) {
        const tile = this.getVideoTile(tileId);
        if (tile) {
            if (this.currentPausedTilesByIds.has(tileId)) {
                this.audioVideoController.resumeReceivingStream(tile.stateRef().streamId);
                this.currentPausedTilesByIds.delete(tileId);
            }
            tile.unpause();
        }
    }
    getVideoTile(tileId) {
        return this.tileMap.has(tileId) ? this.tileMap.get(tileId) : null;
    }
    getVideoTileArea(tile) {
        const state = tile.state();
        let tileHeight = 0;
        let tileWidth = 0;
        if (state.boundVideoElement) {
            tileHeight = state.boundVideoElement.clientHeight * state.devicePixelRatio;
            tileWidth = state.boundVideoElement.clientWidth * state.devicePixelRatio;
        }
        return tileHeight * tileWidth;
    }
    getAllRemoteVideoTiles() {
        const result = new Array();
        this.tileMap.forEach((tile, tileId)=>{
            if (!this.currentLocalTile || tileId !== this.currentLocalTile.id()) result.push(tile);
        });
        return result;
    }
    getAllVideoTiles() {
        return Array.from(this.tileMap.values());
    }
    addVideoTile(localTile = false) {
        const tileId = this.nextTileId;
        this.nextTileId += 1;
        this.createDevicePixelRatioMonitorIfNeeded();
        const tile = this.tileFactory.makeTile(tileId, localTile, this, this.devicePixelRatioMonitor, this.createResolutionMonitor(tileId));
        this.tileMap.set(tileId, tile);
        return tile;
    }
    removeVideoTile(tileId) {
        if (!this.tileMap.has(tileId)) return;
        const tile = this.tileMap.get(tileId);
        if (this.currentLocalTile === tile) this.currentLocalTile = null;
        tile.destroy();
        this.tileMap.delete(tileId);
        this.audioVideoController.forEachObserver((observer)=>{
            $jfpqH.Maybe.of(observer.videoTileWasRemoved).map((f)=>f.bind(observer)(tileId));
        });
        this.discardDevicePixelRatioMonitorIfNotNeeded();
    }
    removeVideoTilesByAttendeeId(attendeeId) {
        const tilesRemoved = [];
        for (const tile of this.getAllVideoTiles()){
            const state = tile.state();
            if (state.boundAttendeeId === attendeeId) {
                this.removeVideoTile(state.tileId);
                tilesRemoved.push(state.tileId);
            }
        }
        return tilesRemoved;
    }
    removeAllVideoTiles() {
        const tileIds = Array.from(this.tileMap.keys());
        for (const tileId of tileIds)this.removeVideoTile(tileId);
    }
    sendTileStateUpdate(tileState) {
        this.audioVideoController.forEachObserver((observer)=>{
            $jfpqH.Maybe.of(observer.videoTileDidUpdate).map((f)=>f.bind(observer)(tileState));
        });
    }
    haveVideoTilesWithStreams() {
        for (const tile of this.getAllVideoTiles()){
            if (tile.state().boundVideoStream) return true;
        }
        return false;
    }
    haveVideoTileForAttendeeId(attendeeId) {
        return !!this.getVideoTileForAttendeeId(attendeeId);
    }
    getVideoTileForAttendeeId(attendeeId) {
        for (const tile of this.getAllVideoTiles()){
            const state = tile.state();
            if (state.boundAttendeeId === attendeeId) return tile;
        }
        return undefined;
    }
    captureVideoTile(tileId) {
        const tile = this.getVideoTile(tileId);
        if (!tile) return null;
        return tile.capture();
    }
    registerVideoTileResolutionObserver(observer) {
        this.resolutionObservers.add(observer);
    }
    removeVideoTileResolutionObserver(observer) {
        this.resolutionObservers.delete(observer);
    }
    createResolutionMonitor(tileId) {
        const observer = new class {
            constructor(controller, tileId){
                this.controller = controller;
                this.tileId = tileId;
            }
            videoElementResolutionChanged(newWidth, newHeight) {
                this.controller.handleVideoElementResolutionChanged(this.tileId, newWidth, newHeight);
            }
            videoElementFirstFrameDidRender(metadata) {
                this.controller.handleVideoFirstFrameDidRender(this.tileId, metadata);
            }
            videoElementMetricsDidReceive(metrics) {
                this.controller.handleVideoElementFrameMetrics(this.tileId, metrics);
            }
        }(this, tileId);
        const resolutionMonitor = new $0e268ac63e573e38$var$DefaultVideoElementResolutionMonitor_1.default();
        resolutionMonitor.registerObserver(observer);
        return resolutionMonitor;
    }
    handleVideoElementResolutionChanged(tileId, newWidth, newHeight) {
        const tile = this.getVideoTile(tileId);
        if (tile) {
            const attendeeId = tile.state().boundAttendeeId;
            for (const observer of this.resolutionObservers)observer.videoTileResolutionDidChange(attendeeId, newWidth, newHeight);
        }
    }
    handleVideoFirstFrameDidRender(tileId, metadata) {
        var _a, _b;
        const tile = this.getVideoTile(tileId);
        if (!tile) return;
        if (tile.state().localTile) return;
        const groupId = (_a = tile.state().groupId) !== null && _a !== void 0 ? _a : null;
        if (groupId === null) return;
        for (const observer of this.resolutionObservers)(_b = observer.videoTileFirstFrameDidRender) === null || _b === void 0 || _b.call(observer, groupId, metadata);
    }
    handleVideoElementFrameMetrics(tileId, metrics) {
        var _a, _b;
        const tile = this.getVideoTile(tileId);
        if (!tile) return;
        if (tile.state().localTile) return;
        const groupId = (_a = tile.state().groupId) !== null && _a !== void 0 ? _a : null;
        if (groupId === null) return;
        for (const observer of this.resolutionObservers)(_b = observer.videoTileRenderMetricsDidReceive) === null || _b === void 0 || _b.call(observer, groupId, metrics);
    }
    findOrCreateLocalVideoTile() {
        if (this.currentLocalTile) return this.currentLocalTile;
        this.currentLocalTile = this.addVideoTile(true);
        this.currentLocalTile.bindVideoStream(this.audioVideoController.configuration.credentials.attendeeId, true, null, null, null, null, this.audioVideoController.configuration.credentials.externalUserId);
        return this.currentLocalTile;
    }
}
module.exports.default = $0e268ac63e573e38$var$DefaultVideoTileController;

});
parcelRegister("bXLxF", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $8b5a153ed8f0def9$var$DevicePixelRatioWindowSource {
    devicePixelRatio() {
        if (typeof window === 'undefined' || !window || !window.devicePixelRatio) return 1;
        return window.devicePixelRatio;
    }
}
module.exports.default = $8b5a153ed8f0def9$var$DevicePixelRatioWindowSource;

});


parcelRegister("8tr2c", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $62b600ab0646e6e6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $62b600ab0646e6e6$var$DefaultVideoTile_1 = $62b600ab0646e6e6$var$__importDefault((parcelRequire("dBfpS")));
class $62b600ab0646e6e6$var$DefaultVideoTileFactory {
    makeTile(tileId, localTile, tileController, devicePixelRatioMonitor, resolutionMonitor) {
        return new $62b600ab0646e6e6$var$DefaultVideoTile_1.default(tileId, localTile, tileController, devicePixelRatioMonitor, resolutionMonitor);
    }
}
module.exports.default = $62b600ab0646e6e6$var$DefaultVideoTileFactory;

});

parcelRegister("gfunK", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $bd459d48709c2728$var$DefaultVolumeIndicatorAdapter {
    constructor(logger, realtimeController, minVolumeDecibels, maxVolumeDecibels, selfAttendeeId){
        this.logger = logger;
        this.realtimeController = realtimeController;
        this.minVolumeDecibels = minVolumeDecibels;
        this.maxVolumeDecibels = maxVolumeDecibels;
        this.selfAttendeeId = selfAttendeeId;
        this.streamIdToAttendeeId = {};
        this.streamIdToExternalUserId = {};
        this.warnedAboutMissingStreamIdMapping = {};
        this.attendeeIdToStreamId = {};
        this.sessionReconnected = false;
    }
    onReconnect() {
        this.sessionReconnected = true;
    }
    sendRealtimeUpdatesForAudioStreamIdInfo(info) {
        let streamIndex = 0;
        for (const stream of info.streams){
            const hasAttendeeId = !!stream.attendeeId;
            const hasExternalUserId = !!stream.externalUserId;
            const hasMuted = stream.hasOwnProperty('muted');
            const hasDropped = !!stream.dropped;
            if (hasAttendeeId) {
                if (!!this.attendeeIdToStreamId[stream.attendeeId] && this.attendeeIdToStreamId[stream.attendeeId] < stream.audioStreamId) delete this.attendeeIdToStreamId[stream.attendeeId];
                this.streamIdToAttendeeId[stream.audioStreamId] = stream.attendeeId;
                const externalUserId = hasExternalUserId ? stream.externalUserId : stream.attendeeId;
                this.streamIdToExternalUserId[stream.audioStreamId] = externalUserId;
                this.attendeeIdToStreamId[stream.attendeeId] = stream.audioStreamId;
                this.realtimeController.realtimeSetAttendeeIdPresence(stream.attendeeId, true, externalUserId, false, {
                    attendeeIndex: streamIndex++,
                    attendeesInFrame: info.streams.length
                });
            }
            if (hasMuted) {
                const attendeeId = this.streamIdToAttendeeId[stream.audioStreamId];
                const externalUserId = this.streamIdToExternalUserId[stream.audioStreamId];
                this.realtimeController.realtimeUpdateVolumeIndicator(attendeeId, null, stream.muted, null, externalUserId);
            }
            if (!hasAttendeeId && !hasMuted) {
                const attendeeId = this.streamIdToAttendeeId[stream.audioStreamId];
                if (attendeeId) {
                    const externalUserId = this.streamIdToExternalUserId[stream.audioStreamId];
                    delete this.streamIdToAttendeeId[stream.audioStreamId];
                    delete this.streamIdToExternalUserId[stream.audioStreamId];
                    delete this.warnedAboutMissingStreamIdMapping[stream.audioStreamId];
                    if (this.attendeeIdToStreamId[attendeeId] === stream.audioStreamId) delete this.attendeeIdToStreamId[attendeeId];
                    let attendeeHasNewStreamId = false;
                    for (const otherStreamId of Object.keys(this.streamIdToAttendeeId)){
                        const otherStreamIdNumber = parseInt(otherStreamId);
                        if (otherStreamIdNumber > stream.audioStreamId && this.streamIdToAttendeeId[otherStreamIdNumber] === attendeeId) {
                            attendeeHasNewStreamId = true;
                            break;
                        }
                    }
                    if (!attendeeHasNewStreamId) this.realtimeController.realtimeSetAttendeeIdPresence(attendeeId, false, externalUserId, hasDropped, {
                        attendeeIndex: streamIndex++,
                        attendeesInFrame: info.streams.length
                    });
                }
            }
        }
        if (this.sessionReconnected) {
            this.cleanUpState(info);
            this.sessionReconnected = false;
        }
    }
    cleanUpState(info) {
        const localAttendeeIds = Object.values(this.streamIdToAttendeeId);
        const remoteAttendeeIds = info.streams.map((stream)=>stream.attendeeId);
        const deletedAttendeeIds = localAttendeeIds.filter((id)=>{
            return !remoteAttendeeIds.includes(id);
        });
        for (const [index, deletedAttendeeId] of deletedAttendeeIds.entries()){
            const streamId = this.attendeeIdToStreamId[deletedAttendeeId];
            const externalUserId = this.streamIdToExternalUserId[streamId];
            delete this.streamIdToAttendeeId[streamId];
            delete this.streamIdToExternalUserId[streamId];
            delete this.warnedAboutMissingStreamIdMapping[streamId];
            delete this.attendeeIdToStreamId[deletedAttendeeId];
            // During reconnection, the audio info frame might not include self attendee.
            // However, if that happens, there would be another audio info frame with the self attendee after reconnection.
            // So we should not send leave event here for self attendee.
            if (deletedAttendeeId === this.selfAttendeeId) {
                this.logger.warn(`the volume indicator adapter cleans up the current attendee (presence = false) after reconnection`);
                continue;
            }
            // The reconnect event does not have information whether the attendee is dropped/left.
            // Defaulting to attendee leaving the meeting
            this.realtimeController.realtimeSetAttendeeIdPresence(deletedAttendeeId, false, externalUserId, false, {
                attendeeIndex: index,
                attendeesInFrame: deletedAttendeeId.length
            });
        }
    }
    sendRealtimeUpdatesForAudioMetadata(metadata) {
        let volumes = null;
        let signalStrengths = null;
        for (const state of metadata.attendeeStates){
            const attendeeId = this.attendeeIdForStreamId(state.audioStreamId);
            if (state.hasOwnProperty('volume')) {
                if (volumes === null) volumes = {};
                if (attendeeId !== null) // @ts-ignore: TODO fix this protobufjs issue
                volumes[attendeeId] = this.normalizedVolume(state);
            }
            if (state.hasOwnProperty('signalStrength')) {
                if (signalStrengths === null) signalStrengths = {};
                if (attendeeId !== null) // @ts-ignore: TODO fix this protobufjs issue
                signalStrengths[attendeeId] = this.normalizedSignalStrength(state);
            }
        }
        this.applyRealtimeUpdatesForAudioMetadata(volumes, signalStrengths);
    }
    normalizedVolume(state) {
        const dBVolume = -state.volume;
        const normalized = 1.0 - (dBVolume - this.maxVolumeDecibels) / (this.minVolumeDecibels - this.maxVolumeDecibels);
        const clipped = Math.min(Math.max(normalized, 0.0), 1.0);
        return clipped;
    }
    normalizedSignalStrength(state) {
        const normalized = state.signalStrength / $bd459d48709c2728$var$DefaultVolumeIndicatorAdapter.MAX_SIGNAL_STRENGTH_LEVELS;
        const clipped = Math.min(Math.max(normalized, 0.0), 1.0);
        return clipped;
    }
    applyRealtimeUpdatesForAudioMetadata(volumes, signalStrengths) {
        for(const streamId in this.streamIdToAttendeeId){
            const attendeeId = this.streamIdToAttendeeId[streamId];
            const externalUserId = this.streamIdToExternalUserId[streamId];
            let volumeUpdate = null;
            let signalStrengthUpdate = null;
            if (volumes !== null) {
                if (volumes.hasOwnProperty(attendeeId)) volumeUpdate = volumes[attendeeId];
                else volumeUpdate = $bd459d48709c2728$var$DefaultVolumeIndicatorAdapter.IMPLICIT_VOLUME;
            }
            if (signalStrengths !== null) {
                if (signalStrengths.hasOwnProperty(attendeeId)) signalStrengthUpdate = signalStrengths[attendeeId];
                else signalStrengthUpdate = $bd459d48709c2728$var$DefaultVolumeIndicatorAdapter.IMPLICIT_SIGNAL_STRENGTH;
            }
            if (volumeUpdate !== null || signalStrengthUpdate !== null) this.realtimeController.realtimeUpdateVolumeIndicator(attendeeId, volumeUpdate, null, signalStrengthUpdate, externalUserId);
        }
    }
    attendeeIdForStreamId(streamId) {
        if (streamId === 0) return null;
        const attendeeId = this.streamIdToAttendeeId[streamId];
        if (attendeeId) return attendeeId;
        if (!this.warnedAboutMissingStreamIdMapping[streamId]) {
            this.warnedAboutMissingStreamIdMapping[streamId] = true;
            this.logger.warn(`volume indicator stream id ${streamId} seen before being defined`);
        }
        return null;
    }
}
$bd459d48709c2728$var$DefaultVolumeIndicatorAdapter.MAX_SIGNAL_STRENGTH_LEVELS = 2;
$bd459d48709c2728$var$DefaultVolumeIndicatorAdapter.IMPLICIT_VOLUME = 0;
$bd459d48709c2728$var$DefaultVolumeIndicatorAdapter.IMPLICIT_SIGNAL_STRENGTH = 1;
module.exports.default = $bd459d48709c2728$var$DefaultVolumeIndicatorAdapter;

});

parcelRegister("eHwtv", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $ab3e45aa54e68814$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $ab3e45aa54e68814$var$FullJitterBackoff_1 = $ab3e45aa54e68814$var$__importDefault((parcelRequire("84f4q")));

const $ab3e45aa54e68814$var$FullJitterLimitedBackoff_1 = $ab3e45aa54e68814$var$__importDefault((parcelRequire("alpwk")));
class $ab3e45aa54e68814$var$FullJitterBackoffFactory {
    constructor(fixedWaitMs, shortBackoffMs, longBackoffMs){
        this.fixedWaitMs = fixedWaitMs;
        this.shortBackoffMs = shortBackoffMs;
        this.longBackoffMs = longBackoffMs;
    }
    create() {
        return new $ab3e45aa54e68814$var$FullJitterBackoff_1.default(this.fixedWaitMs, this.shortBackoffMs, this.longBackoffMs);
    }
    createWithLimit(limit) {
        return new $ab3e45aa54e68814$var$FullJitterLimitedBackoff_1.default(this.fixedWaitMs, this.shortBackoffMs, this.longBackoffMs, limit);
    }
}
module.exports.default = $ab3e45aa54e68814$var$FullJitterBackoffFactory;

});
parcelRegister("alpwk", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $787fa95e45606770$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $787fa95e45606770$var$FullJitterBackoff_1 = $787fa95e45606770$var$__importDefault((parcelRequire("84f4q")));
class $787fa95e45606770$var$FullJitterLimitedBackoff extends $787fa95e45606770$var$FullJitterBackoff_1.default {
    constructor(fixedWaitMs, shortBackoffMs, longBackoffMs, limit){
        super(fixedWaitMs, shortBackoffMs, longBackoffMs);
        this.limit = limit;
        this.attempts = 0;
    }
    nextBackoffAmountMs() {
        this.attempts++;
        if (this.attempts > this.limit) throw new Error('retry limit exceeded');
        return super.nextBackoffAmountMs();
    }
}
module.exports.default = $787fa95e45606770$var$FullJitterLimitedBackoff;

});


parcelRegister("gMQdX", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $c389a3a26896b366$var$Log {
    constructor(sequenceNumber, message, timestampMs, logLevel){
        this.sequenceNumber = sequenceNumber;
        this.message = message;
        this.timestampMs = timestampMs;
        this.logLevel = logLevel;
    }
}
module.exports.default = $c389a3a26896b366$var$Log;

});

parcelRegister("2Q90c", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9UH7r = parcelRequire("9UH7r");
/**
 * [[MessagingSessionConfiguration]] contains the information necessary to start
 * a messaging session.
 */ /* eslint  @typescript-eslint/no-explicit-any: 0, @typescript-eslint/explicit-module-boundary-types: 0 */ class $21176bbbb68a0876$var$MessagingSessionConfiguration {
    /**
     * Constructs a MessagingSessionConfiguration optionally with userArn, messaging session id, a messaging session
     * endpoint URL, and the chimeClient.
     *
     * endpointUrl is deprecated and should not be used. Internally it is resolved on connect via chimeClient if undefined, and
     * always re-resolved on reconnect.
     *
     * The messaging session id is to uniquely identify this messaging session for the userArn.
     * If messaging session id is passed in as null, it will be automatically generated.
     */ constructor(userArn, messagingSessionId, endpointUrl, chimeClient){
        this.userArn = userArn;
        this.messagingSessionId = messagingSessionId;
        this.endpointUrl = endpointUrl;
        this.chimeClient = chimeClient;
        /**
         * Maximum amount of time in milliseconds to allow for reconnecting.
         */ this.reconnectTimeoutMs = 10000;
        /**
         * Fixed wait amount in milliseconds between reconnecting attempts.
         */ this.reconnectFixedWaitMs = 0;
        /**
         * The short back off time in milliseconds between reconnecting attempts.
         */ this.reconnectShortBackoffMs = 1000;
        /**
         * The long back off time in milliseconds between reconnecting attempts.
         */ this.reconnectLongBackoffMs = 5000;
        /**
         * The enum to indicate if we want to turn on prefetch feature. Prefetch feature will send out CHANNEL_DETAILS event
         * upon websocket connection, which includes information about channel, channel messages, channel memberships etc.
         */ this.prefetchOn = undefined;
        /**
         * The enum to indicate the sorting mechanism to use when deciding which channels to Prefetch. Prefetch feature will send out
         * CHANNEL_DETAILS event upon websocket connection, which includes information about channel, channel messages, channel memberships etc.
         * The first 50 channels matching the PrefetchSortBy will be sent.  If not set, channels will be returned first by those
         * with unread messages and then those with the latest last sent message timestamp.
         */ this.prefetchSortBy = undefined;
        if (!this.messagingSessionId) this.messagingSessionId = this.generateSessionId();
    }
    generateSessionId() {
        const num = new Uint32Array(1);
        (0, $9UH7r.getRandomValues)(num);
        return num[0].toString();
    }
}
module.exports.default = $21176bbbb68a0876$var$MessagingSessionConfiguration;

});

parcelRegister("iIruD", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $da01a9a2dff96138$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $da01a9a2dff96138$var$LogLevel_1 = $da01a9a2dff96138$var$__importDefault((parcelRequire("aSYjG")));
/**
 * MultiLogger writes logs to multiple other loggers
 */ class $da01a9a2dff96138$var$MultiLogger {
    constructor(...loggers){
        this._loggers = loggers;
    }
    info(msg) {
        for (const logger of this._loggers)logger.info(msg);
    }
    warn(msg) {
        for (const logger of this._loggers)logger.warn(msg);
    }
    error(msg) {
        for (const logger of this._loggers)logger.error(msg);
    }
    debug(debugFunction) {
        let message;
        let memoized;
        if (typeof debugFunction === 'string') memoized = debugFunction;
        else if (debugFunction) memoized = ()=>{
            if (!message) message = debugFunction();
            return message;
        };
        else memoized = '' + debugFunction;
        for (const logger of this._loggers)logger.debug(memoized);
    }
    setLogLevel(level) {
        for (const logger of this._loggers)logger.setLogLevel(level);
    }
    getLogLevel() {
        for (const logger of this._loggers)return logger.getLogLevel();
        return $da01a9a2dff96138$var$LogLevel_1.default.OFF;
    }
}
module.exports.default = $da01a9a2dff96138$var$MultiLogger;

});

parcelRegister("lHgMc", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $fcbaa0926c6143a2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $fcbaa0926c6143a2$var$DefaultModality_1 = $fcbaa0926c6143a2$var$__importDefault((parcelRequire("4Zce1")));

const $fcbaa0926c6143a2$var$DefaultVideoCaptureAndEncodeParameter_1 = $fcbaa0926c6143a2$var$__importDefault((parcelRequire("68tZD")));
/** NScaleVideoUplinkBandwidthPolicy implements capture and encode
 *  parameters that are nearly equivalent to those chosen by the
 *  traditional native clients, except for a modification to
 *  maxBandwidthKbps and scaleResolutionDownBy described below. */ class $fcbaa0926c6143a2$var$NScaleVideoUplinkBandwidthPolicy {
    constructor(selfAttendeeId, scaleResolution = true, logger, browserBehavior){
        this.selfAttendeeId = selfAttendeeId;
        this.scaleResolution = scaleResolution;
        this.logger = logger;
        this.browserBehavior = browserBehavior;
        this.numberOfPublishedVideoSources = undefined;
        this.idealMaxBandwidthKbps = 1500;
        this.hasBandwidthPriority = false;
        this.encodingParamMap = new Map();
        this.enableHighResolutionFeature = false;
        this.enableSVC = false;
        this.isUsingSVCCodec = true;
        this.currentScalabilityModeIndex = 0;
        this.numParticipants = 0;
        if (this.isContentShare()) // Only enable temporal scalability for content share since resolution is typically preferred over framerate
        // in such use cases and spatial scalability may cause blurry content due to scaling.
        this.scalabilityModePreferences = [
            'L1T3',
            'L1T1'
        ];
        else // Enable spatial and temporal scalability for camera video.
        this.scalabilityModePreferences = [
            'L3T3',
            'L1T3',
            'L1T1'
        ];
        this.reset();
    }
    reset() {
        // Don't reset `idealMaxBandwidthKbps` or `hasBandwidthPriority` which are set via builder API paths
        this.numberOfPublishedVideoSources = undefined;
        this.optimalParameters = new $fcbaa0926c6143a2$var$DefaultVideoCaptureAndEncodeParameter_1.default(0, 0, 0, 0, false);
        this.parametersInEffect = new $fcbaa0926c6143a2$var$DefaultVideoCaptureAndEncodeParameter_1.default(0, 0, 0, 0, false);
        this.encodingParamMap.set($fcbaa0926c6143a2$var$NScaleVideoUplinkBandwidthPolicy.encodingMapKey, {
            maxBitrate: 0
        });
        this.currentScalabilityModeIndex = 0;
    }
    updateConnectionMetric(_metrics) {
        return;
    }
    chooseMediaTrackConstraints() {
        return {};
    }
    chooseEncodingParameters() {
        return new Map();
    }
    updateIndex(videoIndex) {
        var _a;
        let hasLocalVideo = true;
        if (this.transceiverController) hasLocalVideo = this.transceiverController.hasVideoInput();
        // the +1 for self is assuming that we intend to send video, since
        // the context here is VideoUplinkBandwidthPolicy
        const numberOfPublishedVideoSources = videoIndex.numberOfVideoPublishingParticipantsExcludingSelf(this.selfAttendeeId) + (hasLocalVideo ? 1 : 0);
        const numParticipants = videoIndex.numberOfParticipants();
        if (this.numParticipants === numParticipants && this.numberOfPublishedVideoSources === numberOfPublishedVideoSources) {
            (_a = this.logger) === null || _a === void 0 || _a.debug('Skipping update index; Number of participants has not changed');
            return;
        }
        this.numberOfPublishedVideoSources = numberOfPublishedVideoSources;
        this.numParticipants = numParticipants;
        this.updateOptimalParameters();
    }
    wantsResubscribe() {
        return !this.parametersInEffect.equal(this.optimalParameters);
    }
    chooseCaptureAndEncodeParameters() {
        this.parametersInEffect = this.optimalParameters.clone();
        return this.parametersInEffect.clone();
    }
    updateOptimalParameters() {
        let scale = 1;
        if (this.transceiverController) {
            const settings = this.getStreamCaptureSetting();
            if (settings) {
                const encodingParams = this.calculateEncodingParameters(settings);
                scale = encodingParams.scaleResolutionDownBy;
            }
        }
        this.optimalParameters = new $fcbaa0926c6143a2$var$DefaultVideoCaptureAndEncodeParameter_1.default(this.captureWidth(), this.captureHeight(), this.captureFrameRate(), this.maxBandwidthKbps(), false, scale, this.enableSVC && this.numParticipants > 2 && this.isUsingSVCCodec && this.scalabilityModePreferences[this.currentScalabilityModeIndex] !== 'L1T1');
    }
    captureWidth() {
        let width = 640;
        if (this.getNumberOfPublishedVideoSources() > 4) width = 320;
        return width;
    }
    captureHeight() {
        let height = 384;
        if (this.getNumberOfPublishedVideoSources() > 4) height = 192;
        return height;
    }
    captureFrameRate() {
        return 15;
    }
    maxBandwidthKbps() {
        if (this.hasBandwidthPriority) return Math.trunc(this.idealMaxBandwidthKbps);
        let rate = 0;
        if (this.getNumberOfPublishedVideoSources() <= 2) rate = this.idealMaxBandwidthKbps;
        else if (this.getNumberOfPublishedVideoSources() <= 4) rate = this.idealMaxBandwidthKbps * 2 / 3;
        else rate = (544 / 11 + 14880 / (11 * this.getNumberOfPublishedVideoSources())) / 600 * this.idealMaxBandwidthKbps;
        return Math.trunc(rate);
    }
    setIdealMaxBandwidthKbps(idealMaxBandwidthKbps) {
        this.idealMaxBandwidthKbps = idealMaxBandwidthKbps;
    }
    setHasBandwidthPriority(hasBandwidthPriority) {
        this.hasBandwidthPriority = hasBandwidthPriority;
    }
    setTransceiverController(transceiverController) {
        this.transceiverController = transceiverController;
    }
    setSVCEnabled(enable) {
        var _a;
        this.enableSVC = enable;
        (_a = this.logger) === null || _a === void 0 || _a.info(`setSVCEnabled, enable: ${enable}}`);
    }
    setHighResolutionFeatureEnabled(enabled) {
        this.enableHighResolutionFeature = enabled;
    }
    async updateTransceiverController() {
        const settings = this.getStreamCaptureSetting();
        if (!settings) return;
        const encodingParams = this.calculateEncodingParameters(settings);
        if (this.shouldUpdateEndcodingParameters(encodingParams)) {
            this.encodingParamMap.set($fcbaa0926c6143a2$var$NScaleVideoUplinkBandwidthPolicy.encodingMapKey, encodingParams);
            this.transceiverController.setEncodingParameters(this.encodingParamMap);
        }
    }
    shouldUpdateEndcodingParameters(encoding) {
        var _a, _b;
        const transceiverEncoding = (_b = (_a = this.transceiverController.localVideoTransceiver().sender.getParameters()) === null || _a === void 0 ? void 0 : _a.encodings) === null || _b === void 0 ? void 0 : _b[0];
        /* istanbul ignore next: transceiverEncoding?.scaleResolutionDownBy cannot be covered */ return encoding.maxBitrate !== (transceiverEncoding === null || transceiverEncoding === void 0 ? void 0 : transceiverEncoding.maxBitrate) || encoding.scaleResolutionDownBy !== (transceiverEncoding === null || transceiverEncoding === void 0 ? void 0 : transceiverEncoding.scaleResolutionDownBy) || // @ts-ignore
        (encoding === null || encoding === void 0 ? void 0 : encoding.scalabilityMode) !== (transceiverEncoding === null || transceiverEncoding === void 0 ? void 0 : transceiverEncoding.scalabilityMode);
    }
    calculateEncodingParameters(setting) {
        var _a, _b, _c;
        const maxBitrate = this.maxBandwidthKbps() * 1000;
        let scale = 1;
        let targetHeight = 720;
        if (setting.height !== undefined && setting.width !== undefined && this.scaleResolution && !this.hasBandwidthPriority && this.getNumberOfPublishedVideoSources() > 2) {
            targetHeight = $fcbaa0926c6143a2$var$NScaleVideoUplinkBandwidthPolicy.targetHeightArray[Math.min(this.getNumberOfPublishedVideoSources(), $fcbaa0926c6143a2$var$NScaleVideoUplinkBandwidthPolicy.targetHeightArray.length - 1)][this.enableHighResolutionFeature ? 1 : 0];
            //Workaround for issue https://github.com/aws/amazon-chime-sdk-js/issues/2002
            if (targetHeight === 480 && ((_a = this.browserBehavior) === null || _a === void 0 ? void 0 : _a.disable480pResolutionScaleDown())) targetHeight = 360;
            scale = Math.max(Math.min(setting.height, setting.width) / targetHeight, 1);
            (_b = this.logger) === null || _b === void 0 || _b.info(`Resolution scale factor is ${scale} for capture resolution ${setting.width}x${setting.height}. New dimension is ${setting.width / scale}x${setting.height / scale}`);
        }
        if (this.enableSVC) {
            let scalabilityMode;
            if (this.numParticipants >= 0 && this.numParticipants < 3 || !this.isUsingSVCCodec) scalabilityMode = 'L1T1';
            else // We do not limit the number of layers depending on input resolution, however Chrome will drop anything below around 135p.
            scalabilityMode = this.scalabilityModePreferences[this.currentScalabilityModeIndex];
            (_c = this.logger) === null || _c === void 0 || _c.info(`calculateEncodingParameters: SVC: ${this.enableSVC}    participants: ${this.numParticipants}     publishers: ${this.getNumberOfPublishedVideoSources()}     bitrate: ${maxBitrate}  targetHeight: ${targetHeight}  scalabilityMode: ${scalabilityMode}   isUsingSVCCodec: ${this.isUsingSVCCodec}`);
            return {
                scaleResolutionDownBy: scale,
                maxBitrate: maxBitrate,
                // @ts-ignore
                scalabilityMode: scalabilityMode
            };
        } else return {
            scaleResolutionDownBy: scale,
            maxBitrate: maxBitrate
        };
    }
    getStreamCaptureSetting() {
        var _a, _b, _c, _d;
        return (_d = (_c = (_b = (_a = this.transceiverController) === null || _a === void 0 ? void 0 : _a.localVideoTransceiver()) === null || _b === void 0 ? void 0 : _b.sender) === null || _c === void 0 ? void 0 : _c.track) === null || _d === void 0 ? void 0 : _d.getSettings();
    }
    getNumberOfPublishedVideoSources() {
        var _a;
        /* istanbul ignore next: policy calculation is dependent on index so this is never undefined at time of use */ return (_a = this.numberOfPublishedVideoSources) !== null && _a !== void 0 ? _a : 0;
    }
    isContentShare() {
        return new $fcbaa0926c6143a2$var$DefaultModality_1.default(this.selfAttendeeId).hasModality($fcbaa0926c6143a2$var$DefaultModality_1.default.MODALITY_CONTENT);
    }
    wantsVideoDependencyDescriptorRtpHeaderExtension() {
        return this.enableSVC;
    }
    setMeetingSupportedVideoSendCodecs(meetingSupportedVideoSendCodecPreferences, videoSendCodecPreferences) {
        const codecs = meetingSupportedVideoSendCodecPreferences !== null && meetingSupportedVideoSendCodecPreferences !== void 0 ? meetingSupportedVideoSendCodecPreferences : videoSendCodecPreferences;
        const isUsingSVCCodec = codecs.length > 0 && this.isContentShare() ? $fcbaa0926c6143a2$var$NScaleVideoUplinkBandwidthPolicy.contentSVCCodecNames.includes(codecs[0].codecName) : $fcbaa0926c6143a2$var$NScaleVideoUplinkBandwidthPolicy.videoSVCCodecNames.includes(codecs[0].codecName);
        if (isUsingSVCCodec !== this.isUsingSVCCodec) {
            this.isUsingSVCCodec = isUsingSVCCodec;
            this.updateOptimalParameters();
        }
    }
    degradeScalabilityMode() {
        var _a;
        if (this.isUsingSVCCodec && this.numParticipants >= 3 && this.currentScalabilityModeIndex + 1 < this.scalabilityModePreferences.length) {
            (_a = this.logger) === null || _a === void 0 || _a.info(`Degrading scalability mode from ${this.scalabilityModePreferences[this.currentScalabilityModeIndex]} to ${this.scalabilityModePreferences[this.currentScalabilityModeIndex + 1]}`);
            this.currentScalabilityModeIndex++;
            this.updateOptimalParameters();
            return true;
        }
        return false;
    }
}
$fcbaa0926c6143a2$var$NScaleVideoUplinkBandwidthPolicy.encodingMapKey = 'video';
// 0, 1, 2 have dummy value as we keep the original resolution if we have less than 2 videos.
// For each video cource, we define a target height for low resoultion and high resolution,
// respectively. This is corresponding to the meeting feature specified for the meeting.
$fcbaa0926c6143a2$var$NScaleVideoUplinkBandwidthPolicy.targetHeightArray = [
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        540,
        720
    ],
    [
        540,
        720
    ],
    [
        480,
        540
    ],
    [
        480,
        540
    ],
    [
        480,
        540
    ],
    [
        480,
        540
    ],
    [
        360,
        480
    ],
    [
        360,
        480
    ],
    [
        360,
        480
    ],
    [
        360,
        480
    ],
    [
        270,
        360
    ],
    [
        270,
        360
    ],
    [
        270,
        360
    ],
    [
        270,
        360
    ],
    [
        180,
        270
    ],
    [
        180,
        270
    ],
    [
        180,
        270
    ],
    [
        180,
        270
    ],
    [
        180,
        270
    ],
    [
        180,
        270
    ],
    [
        180,
        270
    ],
    [
        180,
        270
    ],
    [
        180,
        270
    ]
];
// Do not enable SVC for AV1 for camera videos since there is decoder performance issues with multiple AV1 streams with SVC
$fcbaa0926c6143a2$var$NScaleVideoUplinkBandwidthPolicy.videoSVCCodecNames = [
    'VP9'
];
// Do not enable SVC for VP9 in content share since Chrome cannot enable temporal scalability for screen share
// https://bugs.chromium.org/p/chromium/issues/detail?id=1433486
$fcbaa0926c6143a2$var$NScaleVideoUplinkBandwidthPolicy.contentSVCCodecNames = [
    'AV1'
];
module.exports.default = $fcbaa0926c6143a2$var$NScaleVideoUplinkBandwidthPolicy;

});

parcelRegister("iZoLe", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $dd31217d9c2e7567$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $dd31217d9c2e7567$var$FullJitterBackoff_1 = $dd31217d9c2e7567$var$__importDefault((parcelRequire("84f4q")));

const $dd31217d9c2e7567$var$DefaultEventController_1 = $dd31217d9c2e7567$var$__importDefault((parcelRequire("2aVcU")));

const $dd31217d9c2e7567$var$NoOpDebugLogger_1 = $dd31217d9c2e7567$var$__importDefault((parcelRequire("etIev")));

const $dd31217d9c2e7567$var$NoOpMediaStreamBroker_1 = $dd31217d9c2e7567$var$__importDefault((parcelRequire("lotlQ")));

const $dd31217d9c2e7567$var$MeetingSessionConfiguration_1 = $dd31217d9c2e7567$var$__importDefault((parcelRequire("dKmza")));

const $dd31217d9c2e7567$var$MeetingSessionCredentials_1 = $dd31217d9c2e7567$var$__importDefault((parcelRequire("ewCV2")));

const $dd31217d9c2e7567$var$MeetingSessionStatus_1 = $dd31217d9c2e7567$var$__importDefault((parcelRequire("jbMe2")));

const $dd31217d9c2e7567$var$MeetingSessionStatusCode_1 = $dd31217d9c2e7567$var$__importDefault((parcelRequire("9zYoz")));

const $dd31217d9c2e7567$var$MeetingSessionURLs_1 = $dd31217d9c2e7567$var$__importDefault((parcelRequire("76y6f")));

const $dd31217d9c2e7567$var$DefaultReconnectController_1 = $dd31217d9c2e7567$var$__importDefault((parcelRequire("4wU9J")));

const $dd31217d9c2e7567$var$DefaultWebSocketAdapter_1 = $dd31217d9c2e7567$var$__importDefault((parcelRequire("bXkPl")));

const $dd31217d9c2e7567$var$DefaultAudioVideoController_1 = $dd31217d9c2e7567$var$__importDefault((parcelRequire("cJkH6")));
class $dd31217d9c2e7567$var$NoOpAudioVideoController extends $dd31217d9c2e7567$var$DefaultAudioVideoController_1.default {
    constructor(configuration){
        const emptyConfiguration = new $dd31217d9c2e7567$var$MeetingSessionConfiguration_1.default();
        emptyConfiguration.meetingId = '';
        emptyConfiguration.externalMeetingId = '';
        emptyConfiguration.credentials = new $dd31217d9c2e7567$var$MeetingSessionCredentials_1.default();
        emptyConfiguration.credentials.attendeeId = '';
        emptyConfiguration.credentials.joinToken = '';
        emptyConfiguration.urls = new $dd31217d9c2e7567$var$MeetingSessionURLs_1.default();
        emptyConfiguration.urls.turnControlURL = '';
        emptyConfiguration.urls.audioHostURL = '';
        emptyConfiguration.urls.signalingURL = 'wss://localhost/';
        const noOpLogger = new $dd31217d9c2e7567$var$NoOpDebugLogger_1.default();
        super(configuration ? configuration : emptyConfiguration, noOpLogger, new $dd31217d9c2e7567$var$DefaultWebSocketAdapter_1.default(new $dd31217d9c2e7567$var$NoOpDebugLogger_1.default()), new $dd31217d9c2e7567$var$NoOpMediaStreamBroker_1.default(), new $dd31217d9c2e7567$var$DefaultReconnectController_1.default(0, new $dd31217d9c2e7567$var$FullJitterBackoff_1.default(0, 0, 0)), new $dd31217d9c2e7567$var$DefaultEventController_1.default(configuration ? configuration : emptyConfiguration, noOpLogger));
    }
    setAudioProfile(_audioProfile) {}
    start() {}
    stop() {}
    promoteToPrimaryMeeting(_) {
        return Promise.resolve(new $dd31217d9c2e7567$var$MeetingSessionStatus_1.default($dd31217d9c2e7567$var$MeetingSessionStatusCode_1.default.OK));
    }
    demoteFromPrimaryMeeting() {}
}
module.exports.default = $dd31217d9c2e7567$var$NoOpAudioVideoController;

});
parcelRegister("etIev", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $a8a615db0abc9807$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $a8a615db0abc9807$var$LogLevel_1 = $a8a615db0abc9807$var$__importDefault((parcelRequire("aSYjG")));

const $a8a615db0abc9807$var$NoOpLogger_1 = $a8a615db0abc9807$var$__importDefault((parcelRequire("a39G0")));
/**
 * [[NoOpDebugLogger]] does not log any message but does call
 * debug functions by default.
 */ class $a8a615db0abc9807$var$NoOpDebugLogger extends $a8a615db0abc9807$var$NoOpLogger_1.default {
    constructor(){
        super($a8a615db0abc9807$var$LogLevel_1.default.DEBUG);
    }
}
module.exports.default = $a8a615db0abc9807$var$NoOpDebugLogger;

});

parcelRegister("lotlQ", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[NoOpDeviceBroker]] rejects requests to acquire a [[MediaStream]].
 */ class $f9329b6d22571b69$var$NoOpMediaStreamBroker {
    acquireAudioInputStream() {
        return Promise.reject();
    }
    acquireVideoInputStream() {
        return Promise.reject();
    }
    acquireDisplayInputStream(_streamConstraints) {
        return Promise.reject();
    }
    muteLocalAudioInputStream() {}
    unmuteLocalAudioInputStream() {}
    addMediaStreamBrokerObserver(_observer) {}
    removeMediaStreamBrokerObserver(_observer) {}
}
module.exports.default = $f9329b6d22571b69$var$NoOpMediaStreamBroker;

});


parcelRegister("2Cyhu", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $1e89b8e6a417d66f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoOpDeviceControllerWithEventController = void 0;

const $1e89b8e6a417d66f$var$NoOpMediaStreamBroker_1 = $1e89b8e6a417d66f$var$__importDefault((parcelRequire("lotlQ")));

const $1e89b8e6a417d66f$var$VideoQualitySettings_1 = $1e89b8e6a417d66f$var$__importDefault((parcelRequire("3C9sO")));
class $1e89b8e6a417d66f$var$NoOpDeviceController extends $1e89b8e6a417d66f$var$NoOpMediaStreamBroker_1.default {
    constructor(_options){
        super();
        this.destroyed = false;
    }
    async destroy() {
        this.destroyed = true;
    }
    listAudioInputDevices() {
        return Promise.resolve([]);
    }
    listVideoInputDevices() {
        return Promise.resolve([]);
    }
    listAudioOutputDevices() {
        return Promise.resolve([]);
    }
    startAudioInput(_device) {
        return Promise.reject();
    }
    stopAudioInput() {
        return Promise.resolve();
    }
    startVideoInput(_device) {
        return Promise.reject();
    }
    stopVideoInput() {
        return Promise.resolve();
    }
    chooseAudioOutput(_deviceId) {
        return Promise.reject();
    }
    addDeviceChangeObserver(_observer) {}
    removeDeviceChangeObserver(_observer) {}
    createAnalyserNodeForAudioInput() {
        return null;
    }
    startVideoPreviewForVideoInput(_element) {}
    stopVideoPreviewForVideoInput(_element) {}
    setDeviceLabelTrigger(_trigger) {}
    mixIntoAudioInput(_stream) {
        return null;
    }
    chooseVideoInputQuality(_width, _height, _frameRate) {}
    getVideoInputQualitySettings() {
        return $1e89b8e6a417d66f$var$VideoQualitySettings_1.default.VideoDisabled;
    }
}
module.exports.default = $1e89b8e6a417d66f$var$NoOpDeviceController;
class $1e89b8e6a417d66f$var$NoOpDeviceControllerWithEventController extends $1e89b8e6a417d66f$var$NoOpDeviceController {
    constructor(eventController){
        super();
        this.eventController = eventController;
    }
}
module.exports.NoOpDeviceControllerWithEventController = $1e89b8e6a417d66f$var$NoOpDeviceControllerWithEventController;

});

parcelRegister("aBEoN", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $7b8cb2731f9d3166$var$NoOpEventReporter {
    constructor(){}
    reportEvent(_ts, _name, _attributes) {
        return;
    }
    start() {}
    stop() {}
}
module.exports.default = $7b8cb2731f9d3166$var$NoOpEventReporter;

});

parcelRegister("aoD3u", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $791a70d57f603407$var$NoOpTask {
    cancel() {}
    name() {
        return 'NoOpTask';
    }
    run() {
        return Promise.resolve();
    }
    setParent(_parentTask) {}
}
module.exports.default = $791a70d57f603407$var$NoOpTask;

});

parcelRegister("ccAef", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $8e22b5506ca95787$var$NoOpVideoElementFactory {
    create() {
        const element = {
            clientWidth: 400,
            clientHeight: 300,
            width: 400,
            height: 300,
            videoWidth: 400,
            videoHeight: 300,
            style: {
                transform: ''
            },
            hasAttribute: ()=>{
                return false;
            },
            removeAttribute: ()=>{},
            setAttribute: ()=>{},
            addEventListener: ()=>{},
            removeEventListener: ()=>{},
            requestVideoFrameCallback: (_callback)=>{
                return 0;
            },
            cancelVideoFrameCallback: ()=>{},
            srcObject: false,
            paused: true,
            pause: ()=>{
                element.paused = true;
            },
            play: ()=>{
                element.paused = false;
                return Promise.resolve();
            }
        };
        // @ts-ignore
        return element;
    }
}
module.exports.default = $8e22b5506ca95787$var$NoOpVideoElementFactory;

});

parcelRegister("hD2ej", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $cd57cefe7fc039cb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $cd57cefe7fc039cb$var$DefaultVideoCaptureAndEncodeParameter_1 = $cd57cefe7fc039cb$var$__importDefault((parcelRequire("68tZD")));
class $cd57cefe7fc039cb$var$NoVideoUplinkBandwidthPolicy {
    constructor(){}
    updateConnectionMetric(_metrics) {}
    chooseMediaTrackConstraints() {
        return {};
    }
    chooseEncodingParameters() {
        return new Map();
    }
    updateIndex(_videoIndex) {}
    wantsResubscribe() {
        return false;
    }
    chooseCaptureAndEncodeParameters() {
        return new $cd57cefe7fc039cb$var$DefaultVideoCaptureAndEncodeParameter_1.default(0, 0, 0, 0, false);
    }
    maxBandwidthKbps() {
        return 0;
    }
    setIdealMaxBandwidthKbps(_idealMaxBandwidthKbps) {}
    setHasBandwidthPriority(_hasBandwidthPriority) {}
    setHighResolutionFeatureEnabled(_enabled) {}
    wantsVideoDependencyDescriptorRtpHeaderExtension() {
        return false;
    }
}
module.exports.default = $cd57cefe7fc039cb$var$NoVideoUplinkBandwidthPolicy;

});

parcelRegister("27uvx", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $18b3e6687717dbb5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $18b3e6687717dbb5$var$IntervalScheduler_1 = $18b3e6687717dbb5$var$__importDefault((parcelRequire("4wGp7")));

const $18b3e6687717dbb5$var$Log_1 = $18b3e6687717dbb5$var$__importDefault((parcelRequire("gMQdX")));

const $18b3e6687717dbb5$var$LogLevel_1 = $18b3e6687717dbb5$var$__importDefault((parcelRequire("aSYjG")));
/**
 * `POSTLogger` publishes log messages in batches to a URL
 * supplied during its construction.
 *
 * Be sure to call {@link POSTLogger.destroy} when you're done
 * with the logger in order to avoid leaks.
 */ class $18b3e6687717dbb5$var$POSTLogger {
    constructor(options){
        this.logCapture = [];
        this.lock = false;
        this.sequenceNumber = 0;
        const { url: url, batchSize: batchSize = $18b3e6687717dbb5$var$POSTLogger.BATCH_SIZE, intervalMs: intervalMs = $18b3e6687717dbb5$var$POSTLogger.INTERVAL_MS, logLevel: logLevel = $18b3e6687717dbb5$var$LogLevel_1.default.WARN, metadata: metadata, headers: headers } = options;
        this.url = url;
        this.batchSize = batchSize;
        this.intervalMs = intervalMs;
        this.logLevel = logLevel;
        this.metadata = metadata;
        this.headers = headers;
        this.start();
        this.eventListener = ()=>{
            this.stop();
        };
        this.addEventListener();
    }
    addEventListener() {
        if (!this.eventListener || !('window' in $parcel$global) || !window.addEventListener) return;
        window.addEventListener('unload', this.eventListener);
    }
    removeEventListener() {
        if (!this.eventListener || !('window' in $parcel$global) || !window.removeEventListener) return;
        window.removeEventListener('unload', this.eventListener);
    }
    debug(debugFunction) {
        if ($18b3e6687717dbb5$var$LogLevel_1.default.DEBUG < this.logLevel) return;
        if (typeof debugFunction === 'string') this.log($18b3e6687717dbb5$var$LogLevel_1.default.DEBUG, debugFunction);
        else if (debugFunction) this.log($18b3e6687717dbb5$var$LogLevel_1.default.DEBUG, debugFunction());
        else this.log($18b3e6687717dbb5$var$LogLevel_1.default.DEBUG, '' + debugFunction);
    }
    info(msg) {
        this.log($18b3e6687717dbb5$var$LogLevel_1.default.INFO, msg);
    }
    warn(msg) {
        this.log($18b3e6687717dbb5$var$LogLevel_1.default.WARN, msg);
    }
    error(msg) {
        this.log($18b3e6687717dbb5$var$LogLevel_1.default.ERROR, msg);
    }
    setLogLevel(logLevel) {
        this.logLevel = logLevel;
    }
    getLogLevel() {
        return this.logLevel;
    }
    getLogCaptureSize() {
        return this.logCapture.length;
    }
    start() {
        this.addEventListener();
        this.intervalScheduler = new $18b3e6687717dbb5$var$IntervalScheduler_1.default(this.intervalMs);
        this.intervalScheduler.start(async ()=>{
            if (this.lock === true || this.getLogCaptureSize() === 0) return;
            this.lock = true;
            const batch = this.logCapture.slice(0, this.batchSize);
            const body = this.makeRequestBody(batch);
            try {
                const response = await fetch(this.url, {
                    method: 'POST',
                    body: body,
                    ...this.headers ? {
                        headers: this.headers
                    } : {}
                });
                if (response.status === 200) this.logCapture = this.logCapture.slice(batch.length);
            } catch (error) {
                console.warn('[POSTLogger] ' + error.message);
            } finally{
                this.lock = false;
            }
        });
    }
    stop() {
        var _a;
        // Clean up to avoid resource leaks.
        (_a = this.intervalScheduler) === null || _a === void 0 || _a.stop();
        this.intervalScheduler = undefined;
        this.removeEventListener();
        const body = this.makeRequestBody(this.logCapture);
        navigator.sendBeacon(this.url, body);
    }
    /**
     * Permanently clean up the logger. A new logger must be created to
     * resume logging.
     */ async destroy() {
        this.stop();
        this.metadata = undefined;
        this.headers = undefined;
        this.logCapture = [];
        this.sequenceNumber = 0;
        this.lock = false;
        this.batchSize = 0;
        this.intervalMs = 0;
        this.url = undefined;
    }
    makeRequestBody(batch) {
        return JSON.stringify({
            ...this.metadata,
            logs: batch
        });
    }
    log(type, msg) {
        if (type < this.logLevel) return;
        const now = Date.now();
        // Handle undefined.
        this.logCapture.push(new $18b3e6687717dbb5$var$Log_1.default(this.sequenceNumber, msg, now, $18b3e6687717dbb5$var$LogLevel_1.default[type]));
        this.sequenceNumber += 1;
    }
}
$18b3e6687717dbb5$var$POSTLogger.BATCH_SIZE = 85;
$18b3e6687717dbb5$var$POSTLogger.INTERVAL_MS = 2000;
module.exports.default = $18b3e6687717dbb5$var$POSTLogger;

});

parcelRegister("8xcJX", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Using an enum here to make sure we can expand on future features
var $636b49c1ad46a790$var$PrefetchSortBy;
(function(PrefetchSortBy) {
    PrefetchSortBy["Unread"] = "unread";
    PrefetchSortBy["LastMessageTimestamp"] = "last-message-timestamp";
})($636b49c1ad46a790$var$PrefetchSortBy || ($636b49c1ad46a790$var$PrefetchSortBy = {}));
module.exports.default = $636b49c1ad46a790$var$PrefetchSortBy;

});

parcelRegister("afHhj", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[RealtimeAttendeePositionInFrame]] information about the attendee's place in the frame.
 */ class $776ce0463a3506df$var$RealtimeAttendeePositionInFrame {
    constructor(){
        /**
         * Index of attendee update in the frame starting at zero
         */ this.attendeeIndex = null;
        /**
         * Number of total attendee updates in the frame
         */ this.attendeesInFrame = null;
    }
}
module.exports.default = $776ce0463a3506df$var$RealtimeAttendeePositionInFrame;

});

parcelRegister("4Q8vW", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $38629f7b81b132cf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $38629f7b81b132cf$var$BaseTask_1 = $38629f7b81b132cf$var$__importDefault((parcelRequire("9wPDz")));
/**
 * [[ReceiveAudioInputTask]] acquires an audio input.
 */ class $38629f7b81b132cf$var$ReceiveAudioInputTask extends $38629f7b81b132cf$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'ReceiveAudioInputTask';
    }
    async run() {
        var _a, _b;
        if (!((_b = (_a = this.context.meetingSessionConfiguration) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.audioHostURL)) {
            this.context.logger.info('No audio connection: not acquiring audio input');
            return;
        }
        if (this.context.activeAudioInput) {
            this.context.logger.info('an active audio input exists');
            return;
        }
        let audioInput;
        try {
            audioInput = await this.context.mediaStreamBroker.acquireAudioInputStream();
        } catch (error) {
            this.context.logger.warn('could not acquire audio input from current device');
        }
        if (audioInput) this.context.activeAudioInput = audioInput;
        else this.context.logger.warn('an audio input is not available');
    }
}
module.exports.default = $38629f7b81b132cf$var$ReceiveAudioInputTask;

});

parcelRegister("1Bypi", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $12b3efa2734870ec$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $12b3efa2734870ec$var$SignalingClientEventType_1 = $12b3efa2734870ec$var$__importDefault((parcelRequire("1lA8I")));

var $4huDn = parcelRequire("4huDn");

const $12b3efa2734870ec$var$BaseTask_1 = $12b3efa2734870ec$var$__importDefault((parcelRequire("9wPDz")));
/*
 * [[ReceiveRemoteVideoPauseResume]] receives [[SdkPauseFrame]] from the server side (only if
 * `VideoDownlinkBandwidthPolicy.getServerSideNetworkAdaption()` == `BandwidthProbingAndRemoteVideoQualityAdaption`)
 * which indicates remote video sources that have been paused or resumed and updates [[VideoDownlinkBandwidthPolicy]]
 * and [[VideoTileController]]
 *
 */ class $12b3efa2734870ec$var$ReceiveRemoteVideoPauseResume extends $12b3efa2734870ec$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'ReceiveRemoteVideoPauseResume';
        this.serverPausedVideoTileIds = new Set();
    }
    removeObserver() {
        this.context.signalingClient.removeObserver(this);
    }
    async run() {
        this.context.signalingClient.registerObserver(this);
        this.context.removableObservers.push(this);
    }
    updateSubscribedGroupdIds(groupIds) {
        const existingVideoTileIds = new Set();
        for (const groupId of groupIds){
            const attendeeId = this.context.videoStreamIndex.attendeeIdForGroupId(groupId);
            if (attendeeId.length === 0) {
                this.logger.warn(`Could not find attendee ID for newly subscribed group ID ${groupId}`);
                continue;
            }
            let videoTile = this.context.videoTileController.getVideoTileForAttendeeId(attendeeId);
            if (videoTile === undefined) {
                this.logger.info(`No existing video tile for attendee ID ${attendeeId} with new group ID ${groupId}. Creating new one.`);
                videoTile = this.context.videoTileController.addVideoTile();
                videoTile.bindVideoStream(attendeeId, false, null, 0, 0, 0, null);
            }
            existingVideoTileIds.add(videoTile.id());
        }
        this.serverPausedVideoTileIds.forEach((id)=>{
            if (!existingVideoTileIds.has(id)) this.serverPausedVideoTileIds.delete(id);
        });
    }
    handleSignalingClientEvent(event) {
        if (event.type !== $12b3efa2734870ec$var$SignalingClientEventType_1.default.ReceivedSignalFrame || event.message.type !== $4huDn.SdkSignalFrame.Type.PAUSE && event.message.type !== $4huDn.SdkSignalFrame.Type.RESUME) return;
        // @ts-ignore: force cast to SdkPauseFrame
        const pauseResumeFrame = event.message.pause;
        const messageType = event.message.type;
        this.logger.info(`Received new ${messageType === $4huDn.SdkSignalFrame.Type.PAUSE ? 'pause' : 'resume'} frame: ${JSON.stringify(pauseResumeFrame)}`);
        if (!pauseResumeFrame || this.context.videoTileController.getVideoTileForAttendeeId === undefined || this.context.videoDownlinkBandwidthPolicy.forEachObserver === undefined || this.context.videoStreamIndex.attendeeIdForGroupId === undefined) return;
        const tiles = pauseResumeFrame.groupIds.map((groupId)=>{
            const attendeeId = this.context.videoStreamIndex.attendeeIdForGroupId(groupId);
            if (attendeeId.length === 0) {
                this.logger.warn(`Could not find attendee ID for paused group ID ${groupId}`);
                return undefined;
            }
            return this.context.videoTileController.getVideoTileForAttendeeId(attendeeId);
        });
        for (const tile of tiles){
            if (tile === undefined) continue;
            if (messageType === $4huDn.SdkSignalFrame.Type.PAUSE) {
                if (!tile.state().paused) {
                    this.serverPausedVideoTileIds.add(tile.id());
                    this.context.videoDownlinkBandwidthPolicy.forEachObserver((observer)=>{
                        observer.tileWillBePausedByDownlinkPolicy(tile.id());
                    });
                    // This circumvents the tile controller so it will not send
                    // any signaling messages to server side.
                    tile.pause();
                }
            } else // Don't resume user paused video tiles
            if (tile.state().paused && this.serverPausedVideoTileIds.has(tile.id())) {
                this.serverPausedVideoTileIds.delete(tile.id());
                this.context.videoDownlinkBandwidthPolicy.forEachObserver((observer)=>{
                    observer.tileWillBeUnpausedByDownlinkPolicy(tile.id());
                });
                // See comment above.
                tile.unpause();
            }
        }
    }
}
module.exports.default = $12b3efa2734870ec$var$ReceiveRemoteVideoPauseResume;

});

parcelRegister("e991n", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $a4c8e7668448a1b0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $a4c8e7668448a1b0$var$DefaultModality_1 = $a4c8e7668448a1b0$var$__importDefault((parcelRequire("4Zce1")));

var $4huDn = parcelRequire("4huDn");

const $a4c8e7668448a1b0$var$BaseTask_1 = $a4c8e7668448a1b0$var$__importDefault((parcelRequire("9wPDz")));
/**
 * [[ReceiveVideoInputTask]] acquires a video input from [[DeviceController]].
 */ class $a4c8e7668448a1b0$var$ReceiveVideoInputTask extends $a4c8e7668448a1b0$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'ReceiveVideoInputTask';
    }
    async checkAndApplyVideoConstraint(isContentAttendee, mediaStreamTrack, width, height, frameRate) {
        const videoQualitySettings = isContentAttendee ? this.context.meetingSessionConfiguration.meetingFeatures.contentMaxResolution : this.context.meetingSessionConfiguration.meetingFeatures.videoMaxResolution;
        if (!isContentAttendee && width <= videoQualitySettings.videoWidth && height <= videoQualitySettings.videoHeight && frameRate <= videoQualitySettings.videoFrameRate) // Skip applying constraints if the current video track settings are already
        // lower than the limit except for content share. Always apply constraint for
        // content attendees because content share resolution may change.
        return;
        const constraint = {
            // Chrome may scale content share to the maximum possible resolution within
            // max width and height even if input resolution is already under the limits.
            // Adding ideal resizeMode as none to use the original resoluion when possible
            // and avoid unexpected scaling.
            // @ts-ignore - resizeMode is valid but not in all TS lib versions
            resizeMode: {
                ideal: 'none'
            },
            width: {
                max: videoQualitySettings.videoWidth
            },
            height: {
                max: videoQualitySettings.videoHeight
            },
            frameRate: {
                ideal: frameRate,
                max: videoQualitySettings.videoFrameRate
            }
        };
        try {
            await mediaStreamTrack.applyConstraints(constraint);
        } catch (error) {
            this.context.logger.info(`Could not apply constraint for video track (content = ${isContentAttendee})`);
        }
    }
    async run() {
        var _a, _b;
        const receiveEnabled = this.context.videoDuplexMode === $4huDn.SdkStreamServiceType.RX || this.context.videoDuplexMode === $4huDn.SdkStreamServiceType.DUPLEX;
        if (this.context.videoTileController.hasStartedLocalVideoTile()) this.context.videoDuplexMode = receiveEnabled ? $4huDn.SdkStreamServiceType.DUPLEX : $4huDn.SdkStreamServiceType.TX;
        else this.context.videoDuplexMode = $4huDn.SdkStreamServiceType.RX;
        this.context.videoCaptureAndEncodeParameter = this.context.videoUplinkBandwidthPolicy.chooseCaptureAndEncodeParameters();
        if (!this.context.videoTileController.hasStartedLocalVideoTile()) {
            this.context.logger.info('has not started local video tile');
            if (this.context.activeVideoInput) {
                this.context.activeVideoInput = undefined;
                // Indicate to the stream index that we are no longer sending video.  We will
                // no longer be tracking irrelevant local sending bitrates sent via received Bitrate message, nor will
                // we track any spurious allocated stream IDs from the backend.
                this.context.videoStreamIndex.integrateUplinkPolicyDecision([]);
                (_a = this.context.meetingSessionTimingManager) === null || _a === void 0 || _a.onLocalVideoRemoved();
            }
            return;
        }
        // TODO: bind after ICE connection started in case of a failure to resubscribe
        //       or perform error handling to unbind video stream.
        const localTile = this.context.videoTileController.getLocalVideoTile();
        let videoInput = undefined;
        try {
            videoInput = await this.context.mediaStreamBroker.acquireVideoInputStream();
        } catch (error) {
            this.context.logger.warn('could not acquire video input from current device');
            this.context.videoTileController.stopLocalVideoTile();
        }
        if (this.context.enableSimulcast) {
            const encodingParams = this.context.videoUplinkBandwidthPolicy.chooseEncodingParameters();
            this.context.videoStreamIndex.integrateUplinkPolicyDecision(Array.from(encodingParams.values()));
        }
        this.context.activeVideoInput = videoInput;
        if (videoInput) {
            const videoTracks = videoInput.getVideoTracks();
            // There can be a race condition when there are several audioVideo.update calls (e.g., calling
            // startLocalVideoTile and stopLocalVideoTile at the same time)
            // that causes the video stream to not contain any video track.
            // This should recovers in the next update call.
            if (!videoTracks || videoTracks.length === 0) return;
            const attendeeId = this.context.meetingSessionConfiguration.credentials.attendeeId;
            const isContentAttendee = new $a4c8e7668448a1b0$var$DefaultModality_1.default(attendeeId).hasModality($a4c8e7668448a1b0$var$DefaultModality_1.default.MODALITY_CONTENT);
            const trackSettings = videoTracks[0].getSettings();
            this.checkAndApplyVideoConstraint(isContentAttendee, videoTracks[0], trackSettings.width, trackSettings.height, trackSettings.frameRate);
            const externalUserId = this.context.audioVideoController.configuration.credentials.externalUserId;
            localTile.bindVideoStream(attendeeId, true, videoInput, trackSettings.width, trackSettings.height, null, externalUserId);
            for (const track of videoTracks){
                this.logger.info(`Using video device label=${track.label} id=${track.id}`);
                this.context.videoDeviceInformation['current_camera_name'] = track.label;
                this.context.videoDeviceInformation['current_camera_id'] = track.id;
            }
            (_b = this.context.meetingSessionTimingManager) === null || _b === void 0 || _b.onLocalVideoAdded();
        }
    }
}
module.exports.default = $a4c8e7668448a1b0$var$ReceiveVideoInputTask;

});

parcelRegister("eBlvb", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $aa1533354c63e5e4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $aa1533354c63e5e4$var$MeetingSessionVideoAvailability_1 = $aa1533354c63e5e4$var$__importDefault((parcelRequire("98lxz")));

const $aa1533354c63e5e4$var$DefaultModality_1 = $aa1533354c63e5e4$var$__importDefault((parcelRequire("4Zce1")));

const $aa1533354c63e5e4$var$VideoCodecCapability_1 = $aa1533354c63e5e4$var$__importDefault((parcelRequire("4C1Yl")));

const $aa1533354c63e5e4$var$SignalingClientEventType_1 = $aa1533354c63e5e4$var$__importDefault((parcelRequire("1lA8I")));

var $4huDn = parcelRequire("4huDn");

var $jfpqH = parcelRequire("jfpqH");

const $aa1533354c63e5e4$var$BaseTask_1 = $aa1533354c63e5e4$var$__importDefault((parcelRequire("9wPDz")));
/*
 * [[ReceiveVideoStreamIndexTask]] receives [[SdkIndexFrame]] and updates [[VideoUplinkBandwidthPolicy]] and [[VideoDownlinkBandwidthPolicy]].
 */ class $aa1533354c63e5e4$var$ReceiveVideoStreamIndexTask extends $aa1533354c63e5e4$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'ReceiveVideoStreamIndexTask';
        // See comment above invocation of `pauseIngestion` in `DefaultAudioVideoController`
        // for explanation.
        this.isIngestionPaused = false;
        this.pendingIndex = null;
    }
    removeObserver() {
        this.context.signalingClient.removeObserver(this);
    }
    async run() {
        this.handleIndexFrame(this.context.indexFrame);
        this.context.signalingClient.registerObserver(this);
        this.context.removableObservers.push(this);
    }
    handleSignalingClientEvent(event) {
        if (event.type !== $aa1533354c63e5e4$var$SignalingClientEventType_1.default.ReceivedSignalFrame || event.message.type !== $4huDn.SdkSignalFrame.Type.INDEX) return;
        // @ts-ignore: force cast to SdkIndexFrame
        const indexFrame = event.message.index;
        this.context.logger.info(`received new index ${JSON.stringify(indexFrame)}`);
        this.handleIndexFrame(indexFrame);
    }
    pauseIngestion() {
        this.isIngestionPaused = true;
    }
    resumeIngestion() {
        if (!this.isIngestionPaused) // Do not recheck subcribe if it wasn't paused to begin with.
        return;
        this.isIngestionPaused = false;
        if (this.pendingIndex) {
            this.context.logger.info('Resuming index ingestion with pending index');
            this.handleIndexFrame(this.pendingIndex);
        }
    }
    handleIndexFrame(indexFrame) {
        if (!indexFrame) return;
        if (this.isIngestionPaused) {
            this.context.logger.info(`Index ingestion is paused, setting most recent index as pending`);
            this.pendingIndex = indexFrame;
            return;
        } else this.pendingIndex = null;
        // Filter out self content share video
        const selfAttendeeId = this.context.audioVideoController.configuration.credentials.attendeeId;
        indexFrame.sources = indexFrame.sources.filter((source)=>{
            const modality = new $aa1533354c63e5e4$var$DefaultModality_1.default(source.attendeeId);
            return !(modality.base() === selfAttendeeId && modality.hasModality($aa1533354c63e5e4$var$DefaultModality_1.default.MODALITY_CONTENT));
        });
        const { videoStreamIndex: videoStreamIndex, videoDownlinkBandwidthPolicy: videoDownlinkBandwidthPolicy, videoUplinkBandwidthPolicy: videoUplinkBandwidthPolicy } = this.context;
        const oldVideoSources = videoStreamIndex.allVideoSendingSourcesExcludingSelf(selfAttendeeId);
        videoStreamIndex.integrateIndexFrame(indexFrame);
        videoDownlinkBandwidthPolicy.updateIndex(videoStreamIndex);
        videoUplinkBandwidthPolicy.updateIndex(videoStreamIndex);
        this.resubscribe(videoDownlinkBandwidthPolicy, videoUplinkBandwidthPolicy);
        this.updateVideoAvailability(indexFrame);
        this.handleIndexVideosPausedAtSource();
        if (indexFrame.supportedReceiveCodecIntersection.length > 0) this.handleSupportedVideoReceiveCodecIntersection(indexFrame);
        // `forEachObserver`is asynchronous anyways so it doesn't matter (for better or worse) whether we
        // trigger it before or after the policy update + possible resubscribe kickoff
        const newVideoSources = videoStreamIndex.allVideoSendingSourcesExcludingSelf(selfAttendeeId);
        if (!this.areVideoSourcesEqual(oldVideoSources, newVideoSources)) this.context.audioVideoController.forEachObserver((observer)=>{
            $jfpqH.Maybe.of(observer.remoteVideoSourcesDidChange).map((f)=>f.bind(observer)(newVideoSources));
        });
    }
    areVideoSourcesEqual(oldVideoSources, newVideoSources) {
        if (oldVideoSources.length !== newVideoSources.length) return false;
        const compare = (videoSourceA, videoSourceB)=>videoSourceA.attendee.attendeeId.localeCompare(videoSourceB.attendee.attendeeId);
        const sortedOldVideoSources = [
            ...oldVideoSources
        ].sort(compare);
        const sortedNewVideoSources = [
            ...newVideoSources
        ].sort(compare);
        for(let i = 0; i < sortedOldVideoSources.length; i++){
            if (sortedOldVideoSources[i].attendee.attendeeId !== sortedNewVideoSources[i].attendee.attendeeId) return false;
        }
        return true;
    }
    resubscribe(videoDownlinkBandwidthPolicy, videoUplinkBandwidthPolicy) {
        var _a, _b;
        const resubscribeForDownlink = videoDownlinkBandwidthPolicy.wantsResubscribe();
        const resubscribeForUplink = (this.context.videoDuplexMode === $4huDn.SdkStreamServiceType.TX || this.context.videoDuplexMode === $4huDn.SdkStreamServiceType.DUPLEX) && videoUplinkBandwidthPolicy.wantsResubscribe();
        const shouldResubscribe = resubscribeForDownlink || resubscribeForUplink;
        this.logger.info(`should resubscribe: ${shouldResubscribe} (downlink: ${resubscribeForDownlink} uplink: ${resubscribeForUplink})`);
        if (!shouldResubscribe) return;
        const videoSubscriptionIdSet = videoDownlinkBandwidthPolicy.chooseSubscriptions();
        this.context.videosToReceive = videoSubscriptionIdSet.truncate(this.context.videoSubscriptionLimit);
        if (videoSubscriptionIdSet.size() > this.context.videosToReceive.size()) this.logger.warn(`Video receive limit exceeded. Limiting the videos to ${this.context.videosToReceive.size()}. Please consider using AllHighestVideoBandwidthPolicy or VideoPriorityBasedPolicy along with chooseRemoteVideoSources api to select the video sources to be displayed.`);
        this.context.videoCaptureAndEncodeParameter = videoUplinkBandwidthPolicy.chooseCaptureAndEncodeParameters();
        this.logger.info(`trigger resubscribe for up=${resubscribeForUplink} down=${resubscribeForDownlink}; videosToReceive=[${this.context.videosToReceive.array()}] captureParams=${JSON.stringify(this.context.videoCaptureAndEncodeParameter)}`);
        if (resubscribeForDownlink && !this.context.videosToReceive.empty()) this.context.videosToReceive.forEach((streamId)=>{
            var _a;
            const groupId = this.context.videoStreamIndex.groupIdForStreamId(streamId);
            if (groupId !== undefined) (_a = this.context.meetingSessionTimingManager) === null || _a === void 0 || _a.onRemoteVideoAdded(groupId);
        });
        else (_a = this.context.meetingSessionTimingManager) === null || _a === void 0 || _a.clearExpectingRemoteVideo();
        (_b = this.context.meetingSessionTimingManager) === null || _b === void 0 || _b.onResubscribeStart();
        this.context.audioVideoController.update({
            needsRenegotiation: false
        });
    }
    updateVideoAvailability(indexFrame) {
        if (!this.context.videosToReceive) {
            this.logger.error('videosToReceive must be set in the meeting context.');
            return;
        }
        const videoAvailability = new $aa1533354c63e5e4$var$MeetingSessionVideoAvailability_1.default();
        videoAvailability.remoteVideoAvailable = !this.context.videosToReceive.empty();
        videoAvailability.canStartLocalVideo = !indexFrame.atCapacity;
        if (!this.context.lastKnownVideoAvailability || !this.context.lastKnownVideoAvailability.equal(videoAvailability)) {
            this.context.lastKnownVideoAvailability = videoAvailability.clone();
            this.context.audioVideoController.forEachObserver((observer)=>{
                $jfpqH.Maybe.of(observer.videoAvailabilityDidChange).map((f)=>f.bind(observer)(videoAvailability.clone()));
            });
        }
    }
    handleSupportedVideoReceiveCodecIntersection(index) {
        if (this.context.videoSendCodecPreferences === undefined) return;
        // The following list contains the configured send codec preferences filtered to
        // only what is supported by the meeting
        const newMeetingSupportedVideoSendCodecPreferences = [];
        // Will be set to true if we need to force a negotiation to change the codec
        let willNeedUpdate = false;
        // Intersect `this.context.videoSendCodecPreferences` with `index.supportedReceiveCodecIntersection`
        // and filter out any send video codecs we have determined to be degraded
        for (const capability of this.context.videoSendCodecPreferences){
            if (this.context.degradedVideoSendCodecs.some((degradedCapability)=>capability.equals(degradedCapability))) {
                this.logger.info(`Skipping ${capability.codecName} since the codec has been identfied as degraded`);
                continue;
            }
            for (const signaledCapability of index.supportedReceiveCodecIntersection)if (capability.equals($aa1533354c63e5e4$var$VideoCodecCapability_1.default.fromSignaled(signaledCapability))) {
                newMeetingSupportedVideoSendCodecPreferences.push(capability);
                break;
            }
        }
        if (newMeetingSupportedVideoSendCodecPreferences.length > 0) {
            // We need to renegotiate if we are currently sending a codec that is no longer supported in the call, or if we can
            // start sending a higher preference codec again (due to a constrained remote attendee leaving)
            // First we find the first codec from our send preferences that has already been intersected with the
            // codecs supported by the meeting, that we know we can support. This is what we want to send.
            const firstMatchingCodecPreference = newMeetingSupportedVideoSendCodecPreferences.find((capability)=>this.context.prioritizedSendVideoCodecCapabilities.some((prioritizedCapability)=>capability.equals(prioritizedCapability)));
            // If that codec is not what we are sending, trigger an update
            if (this.context.currentVideoSendCodec !== undefined && (firstMatchingCodecPreference === undefined || !this.context.currentVideoSendCodec.equals(firstMatchingCodecPreference))) willNeedUpdate = true;
            this.context.meetingSupportedVideoSendCodecPreferences = newMeetingSupportedVideoSendCodecPreferences;
        } else {
            this.logger.warn('Interesection of meeting receive codec support and send codec preferences has no overlap, falling back to just values provided in `setVideoCodecSendPreferences`');
            this.context.meetingSupportedVideoSendCodecPreferences = undefined;
        }
        if (this.context.videoUplinkBandwidthPolicy.setMeetingSupportedVideoSendCodecs) this.context.videoUplinkBandwidthPolicy.setMeetingSupportedVideoSendCodecs(this.context.meetingSupportedVideoSendCodecPreferences, this.context.videoSendCodecPreferences);
        if (willNeedUpdate) this.context.audioVideoController.update({
            needsRenegotiation: true
        });
    }
    handleIndexVideosPausedAtSource() {
        const streamsPausedAtSource = this.context.videoStreamIndex.streamsPausedAtSource();
        for (const tile of this.context.videoTileController.getAllVideoTiles()){
            const tileState = tile.state();
            if (streamsPausedAtSource.contain(tileState.streamId)) {
                if (tile.markPoorConnection()) this.logger.info(`marks the tile ${tileState.tileId} as having a poor connection`);
            } else if (tile.unmarkPoorConnection()) this.logger.info(`unmarks the tile ${tileState.tileId} as having a poor connection`);
        }
    }
}
module.exports.default = $aa1533354c63e5e4$var$ReceiveVideoStreamIndexTask;

});

parcelRegister("kD35h", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * This file was generated with the `generate-red-worker-code.js` script.
 */ /**
 * Redundant audio worker code string.
 */ // eslint-disable-next-line
const $f049d79913cd91da$var$RedundantAudioEncoderWorkerCode = "class RedundantAudioEncoder {\n    constructor() {\n        // Each payload must be less than 1024 bytes to fit the 10 bit block length\n        this.maxRedPacketSizeBytes = 1 << 10;\n        // Limit payload to 1000 bytes to handle small MTU. 1000 is chosen because in Chromium-based browsers, writing audio\n        // payloads larger than 1000 bytes using the WebRTC Insertable Streams API (which is used to enable dynamic audio\n        // redundancy) will cause an error to be thrown and cause audio flow to permanently stop. See\n        // https://crbug.com/1248479.\n        this.maxAudioPayloadSizeBytes = 1000;\n        // Each payload can encode a timestamp delta of 14 bits\n        this.maxRedTimestampOffset = 1 << 14;\n        // 4 byte RED header\n        this.redHeaderSizeBytes = 4;\n        // reduced size for last RED header\n        this.redLastHeaderSizeBytes = 1;\n        // P-Time for Opus 20 msec packets\n        // We do not support other p-times or clock rates\n        this.redPacketizationTime = 960;\n        // distance between redundant payloads, Opus FEC handles a distance of 1\n        // TODO(https://issues.amazon.com/issues/ChimeSDKAudio-55):\n        // Consider making this dynamic\n        this.redPacketDistance = 2;\n        // maximum number of redundant payloads per RTP packet\n        this.maxRedEncodings = 2;\n        // Maximum number of encodings that can be recovered with a single RED packet, assuming the primary and redundant\n        // payloads have FEC.\n        this.redMaxRecoveryDistance = this.redPacketDistance * this.maxRedEncodings + 1;\n        // maximum history of prior payloads to keep\n        // generally we will expire old entries based on timestamp\n        // this limit is in place just to make sure the history does not\n        // grow too large in the case of erroneous timestamp inputs\n        this.maxEncodingHistorySize = 10;\n        // Current number of encodings we want to send\n        // to the remote end. This will be dynamically\n        // updated through the setNumEncodingsFromPacketloss API\n        this.numRedundantEncodings = 0;\n        // Used to enable or disable redundancy\n        // in response to very high packet loss events\n        this.redundancyEnabled = true;\n        // Loss stats are reported to the main thread every 5 seconds.\n        // Since timestamp differences between 2 consecutive packets\n        // give us the number of samples in each channel, 1 second\n        // is equivalent to 48000 samples:\n        // P-time * (1000ms/1s)\n        // = (960 samples/20ms) * (1000ms/1s)\n        // = 48000 samples/s\n        this.lossReportInterval = 48000 * 5;\n        // Maximum distance of a packet from the most recent packet timestamp\n        // that we will consider for recovery.\n        this.maxOutOfOrderPacketDistance = 16;\n        /**\n         * Below are Opus helper methods and constants.\n         */\n        this.OPUS_BAD_ARG = -1;\n        this.OPUS_INVALID_PACKET = -4;\n        // Max number of Opus frames in an Opus packet is 48 (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.5).\n        this.OPUS_MAX_OPUS_FRAMES = 48;\n        // Max number of bytes that any individual Opus frame can have.\n        this.OPUS_MAX_FRAME_SIZE_BYTES = 1275;\n        this.encodingHistory = new Array();\n        this.opusPayloadType = 0;\n        this.redPayloadType = 0;\n        this.initializePacketLogs();\n    }\n    /**\n     * Creates an instance of RedundantAudioEncoder and sets up callbacks.\n     */\n    static initializeWorker() {\n        RedundantAudioEncoder.log('Initializing RedundantAudioEncoder');\n        const encoder = new RedundantAudioEncoder();\n        // RED encoding is done using WebRTC Encoded Transform\n        // https://github.com/w3c/webrtc-encoded-transform/blob/main/explainer.md\n        // Check the DedicatedWorkerGlobalScope for existence of\n        // RTCRtpScriptTransformer interface. If exists, then\n        // RTCRtpScriptTransform is supported by this browser.\n        // @ts-ignore\n        if (self.RTCRtpScriptTransformer) {\n            // @ts-ignore\n            self.onrtctransform = (event) => {\n                if (event.transformer.options.type === 'SenderTransform') {\n                    encoder.setupSenderTransform(event.transformer.readable, event.transformer.writable);\n                }\n                else if (event.transformer.options.type === 'ReceiverTransform') {\n                    encoder.setupReceiverTransform(event.transformer.readable, event.transformer.writable);\n                }\n                else if (event.transformer.options.type === 'PassthroughTransform') {\n                    encoder.setupPassthroughTransform(event.transformer.readable, event.transformer.writable);\n                }\n            };\n        }\n        self.onmessage = (event) => {\n            if (event.data.msgType === 'StartRedWorker') {\n                encoder.setupSenderTransform(event.data.send.readable, event.data.send.writable);\n                encoder.setupReceiverTransform(event.data.receive.readable, event.data.receive.writable);\n            }\n            else if (event.data.msgType === 'PassthroughTransform') {\n                encoder.setupPassthroughTransform(event.data.send.readable, event.data.send.writable);\n                encoder.setupPassthroughTransform(event.data.receive.readable, event.data.receive.writable);\n            }\n            else if (event.data.msgType === 'RedPayloadType') {\n                encoder.setRedPayloadType(event.data.payloadType);\n            }\n            else if (event.data.msgType === 'OpusPayloadType') {\n                encoder.setOpusPayloadType(event.data.payloadType);\n            }\n            else if (event.data.msgType === 'UpdateNumRedundantEncodings') {\n                encoder.setNumRedundantEncodings(event.data.numRedundantEncodings);\n            }\n            else if (event.data.msgType === 'Enable') {\n                encoder.setRedundancyEnabled(true);\n            }\n            else if (event.data.msgType === 'Disable') {\n                encoder.setRedundancyEnabled(false);\n            }\n        };\n    }\n    /**\n     * Post logs to the main thread\n     */\n    static log(msg) {\n        if (RedundantAudioEncoder.shouldLog) {\n            // @ts-ignore\n            self.postMessage({\n                type: 'REDWorkerLog',\n                log: `[AudioRed] ${msg}`,\n            });\n        }\n    }\n    /**\n     * Returns the number of encodings based on packetLoss value. This is used by `DefaultTransceiverController` to\n     * determine when to alert the encoder to update the number of encodings. It also determines if we need to\n     * turn off red in cases of very high packet loss to avoid congestion collapse.\n     */\n    static getNumRedundantEncodingsForPacketLoss(packetLoss) {\n        let recommendedRedundantEncodings = 0;\n        let shouldTurnOffRed = false;\n        if (packetLoss <= 8) {\n            recommendedRedundantEncodings = 0;\n        }\n        else if (packetLoss <= 18) {\n            recommendedRedundantEncodings = 1;\n        }\n        else if (packetLoss <= 75) {\n            recommendedRedundantEncodings = 2;\n        }\n        else {\n            recommendedRedundantEncodings = 0;\n            shouldTurnOffRed = true;\n        }\n        return [recommendedRedundantEncodings, shouldTurnOffRed];\n    }\n    /**\n     * Sets up a passthrough (no-op) transform for the given streams.\n     */\n    setupPassthroughTransform(readable, writable) {\n        RedundantAudioEncoder.log('Setting up passthrough transform');\n        readable.pipeTo(writable);\n    }\n    /**\n     * Sets up the transform stream and pipes the outgoing encoded audio frames through the transform function.\n     */\n    setupSenderTransform(readable, writable) {\n        RedundantAudioEncoder.log('Setting up sender RED transform');\n        const transformStream = new TransformStream({\n            transform: this.senderTransform.bind(this),\n        });\n        readable.pipeThrough(transformStream).pipeTo(writable);\n        return;\n    }\n    /**\n     * Sets up the transform stream and pipes the received encoded audio frames through the transform function.\n     */\n    setupReceiverTransform(readable, writable) {\n        RedundantAudioEncoder.log('Setting up receiver RED transform');\n        const transformStream = new TransformStream({\n            transform: this.receivePacketLogTransform.bind(this),\n        });\n        readable.pipeThrough(transformStream).pipeTo(writable);\n        return;\n    }\n    /**\n     * Set the RED payload type ideally obtained from local offer.\n     */\n    setRedPayloadType(payloadType) {\n        this.redPayloadType = payloadType;\n        RedundantAudioEncoder.log(`red payload type set to ${this.redPayloadType}`);\n    }\n    /**\n     * Set the opus payload type ideally obtained from local offer.\n     */\n    setOpusPayloadType(payloadType) {\n        this.opusPayloadType = payloadType;\n        RedundantAudioEncoder.log(`opus payload type set to ${this.opusPayloadType}`);\n    }\n    /**\n     * Set the number of redundant encodings\n     */\n    setNumRedundantEncodings(numRedundantEncodings) {\n        this.numRedundantEncodings = numRedundantEncodings;\n        if (this.numRedundantEncodings > this.maxRedEncodings) {\n            this.numRedundantEncodings = this.maxRedEncodings;\n        }\n        RedundantAudioEncoder.log(`Updated numRedundantEncodings to ${this.numRedundantEncodings}`);\n    }\n    /**\n     * Enable or disable redundancy in response to\n     * high packet loss event.\n     */\n    setRedundancyEnabled(enabled) {\n        this.redundancyEnabled = enabled;\n        RedundantAudioEncoder.log(`redundancy ${this.redundancyEnabled ? 'enabled' : 'disabled'}`);\n    }\n    /**\n     * Helper function to only enqueue audio frames if they do not exceed the audio payload byte limit imposed by\n     * Chromium-based browsers. Chromium will throw an error (https://crbug.com/1248479) if an audio payload larger than\n     * 1000 bytes is enqueued. Any controller that attempts to enqueue an audio payload larger than 1000 bytes will\n     * encounter this error and will permanently stop sending or receiving audio.\n     */\n    enqueueAudioFrameIfPayloadSizeIsValid(\n    // @ts-ignore\n    frame, controller) {\n        if (frame.data.byteLength > this.maxAudioPayloadSizeBytes)\n            return;\n        controller.enqueue(frame);\n    }\n    /**\n     * Receives encoded frames and modifies as needed before sending to transport.\n     */\n    senderTransform(\n    // @ts-ignore\n    frame, controller) {\n        const frameMetadata = frame.getMetadata();\n        // @ts-ignore\n        if (frameMetadata.payloadType !== this.redPayloadType) {\n            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n            return;\n        }\n        const primaryPayloadBuffer = this.getPrimaryPayload(frame.timestamp, frame.data);\n        if (!primaryPayloadBuffer) {\n            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n            return;\n        }\n        const encodedBuffer = this.encode(frame.timestamp, primaryPayloadBuffer);\n        /* istanbul ignore next */\n        if (!encodedBuffer) {\n            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n            return;\n        }\n        frame.data = encodedBuffer;\n        this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n        return;\n    }\n    /**\n     * Get the primary payload from encoding\n     */\n    getPrimaryPayload(primaryTimestamp, frame) {\n        const encodings = this.splitEncodings(primaryTimestamp, frame);\n        if (!encodings || encodings.length < 1)\n            return null;\n        return encodings[encodings.length - 1].payload;\n    }\n    /**\n     * Split up the encoding received into primary and redundant encodings\n     * These will be ordered oldest to newest which is the same ordering\n     * in the RTP red payload.\n     */\n    splitEncodings(primaryTimestamp, frame, getFecInfo = false, primarySequenceNumber = undefined) {\n        // process RED headers (according to RFC 2198)\n        //   0                   1                   2                   3\n        //   0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1\n        //  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+\n        //  |F|   block PT  |  timestamp offset         |   block length    |\n        //  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+\n        //\n        // last header\n        //   0 1 2 3 4 5 6 7\n        //  +-+-+-+-+-+-+-+-+\n        //  |0|   Block PT  |\n        //  +-+-+-+-+-+-+-+-+\n        const payload = new DataView(frame);\n        let payloadSizeBytes = payload.byteLength;\n        let totalPayloadSizeBytes = 0;\n        let totalHeaderSizeBytes = 0;\n        let primaryPayloadSizeBytes = 0;\n        let payloadOffset = 0;\n        let gotLastBlock = false;\n        const encodings = new Array();\n        const redundantEncodingBlockLengths = [];\n        const redundantEncodingTimestamps = [];\n        while (payloadSizeBytes > 0) {\n            gotLastBlock = (payload.getUint8(payloadOffset) & 0x80) === 0;\n            if (gotLastBlock) {\n                // Bits 1 through 7 are payload type\n                const payloadType = payload.getUint8(payloadOffset) & 0x7f;\n                // Unexpected payload type. This is a bad packet.\n                if (payloadType !== this.opusPayloadType) {\n                    return null;\n                }\n                totalPayloadSizeBytes += this.redLastHeaderSizeBytes;\n                totalHeaderSizeBytes += this.redLastHeaderSizeBytes;\n                // Accumulated block lengths are equal to or larger than the buffer, which means there is no primary block. This\n                // is a bad packet.\n                if (totalPayloadSizeBytes >= payload.byteLength) {\n                    return null;\n                }\n                primaryPayloadSizeBytes = payload.byteLength - totalPayloadSizeBytes;\n                break;\n            }\n            else {\n                if (payloadSizeBytes < this.redHeaderSizeBytes) {\n                    return null;\n                }\n                // Bits 22 through 31 are payload length\n                const blockLength = ((payload.getUint8(payloadOffset + 2) & 0x03) << 8) + payload.getUint8(payloadOffset + 3);\n                redundantEncodingBlockLengths.push(blockLength);\n                const timestampOffset = payload.getUint16(payloadOffset + 1) >> 2;\n                const timestamp = primaryTimestamp - timestampOffset;\n                redundantEncodingTimestamps.push(timestamp);\n                totalPayloadSizeBytes += blockLength + this.redHeaderSizeBytes;\n                totalHeaderSizeBytes += this.redHeaderSizeBytes;\n                payloadOffset += this.redHeaderSizeBytes;\n                payloadSizeBytes -= this.redHeaderSizeBytes;\n            }\n        }\n        // The last block was never found. The packet we received\n        // does not have a good RED payload.\n        if (!gotLastBlock) {\n            // Note that sequence numbers only exist for\n            // incoming audio frames.\n            if (primarySequenceNumber !== undefined) {\n                // This could be a possible padding packet used\n                // for BWE with a good sequence number.\n                // Create a dummy encoding to make sure loss values\n                // are calculated correctly by consuming sequence number.\n                // Note that for the receive side, we process packets only\n                // for loss/recovery calculations and forward the original\n                // packet without changing it even in the error case.\n                encodings.push({\n                    payload: frame,\n                    isRedundant: false,\n                    seq: primarySequenceNumber,\n                });\n                return encodings;\n            }\n            // This is a bad packet.\n            return null;\n        }\n        let redundantPayloadOffset = totalHeaderSizeBytes;\n        for (let i = 0; i < redundantEncodingTimestamps.length; i++) {\n            const redundantPayloadBuffer = new ArrayBuffer(redundantEncodingBlockLengths[i]);\n            const redundantPayloadArray = new Uint8Array(redundantPayloadBuffer);\n            redundantPayloadArray.set(new Uint8Array(payload.buffer, redundantPayloadOffset, redundantEncodingBlockLengths[i]), 0);\n            const encoding = {\n                timestamp: redundantEncodingTimestamps[i],\n                payload: redundantPayloadBuffer,\n                isRedundant: true,\n            };\n            if (getFecInfo) {\n                encoding.hasFec = this.opusPacketHasFec(new DataView(redundantPayloadBuffer), redundantPayloadBuffer.byteLength);\n            }\n            encodings.push(encoding);\n            redundantPayloadOffset += redundantEncodingBlockLengths[i];\n        }\n        const primaryPayloadOffset = payload.byteLength - primaryPayloadSizeBytes;\n        const primaryPayloadBuffer = new ArrayBuffer(primaryPayloadSizeBytes);\n        const primaryArray = new Uint8Array(primaryPayloadBuffer);\n        primaryArray.set(new Uint8Array(payload.buffer, primaryPayloadOffset, primaryPayloadSizeBytes), 0);\n        const encoding = {\n            timestamp: primaryTimestamp,\n            payload: primaryPayloadBuffer,\n            isRedundant: false,\n            seq: primarySequenceNumber,\n        };\n        if (getFecInfo) {\n            encoding.hasFec = this.opusPacketHasFec(new DataView(primaryPayloadBuffer), primaryPayloadBuffer.byteLength);\n        }\n        encodings.push(encoding);\n        return encodings;\n    }\n    /**\n     * Create a new encoding with current primary payload and the older payloads of choice.\n     */\n    encode(primaryTimestamp, primaryPayload) {\n        const primaryPayloadSize = primaryPayload.byteLength;\n        // Payload size needs to be valid.\n        if (primaryPayloadSize === 0 ||\n            primaryPayloadSize >= this.maxRedPacketSizeBytes ||\n            primaryPayloadSize >= this.maxAudioPayloadSizeBytes) {\n            return null;\n        }\n        const numRedundantEncodings = this.numRedundantEncodings;\n        let headerSizeBytes = this.redLastHeaderSizeBytes;\n        let payloadSizeBytes = primaryPayloadSize;\n        let bytesAvailable = this.maxAudioPayloadSizeBytes - primaryPayloadSize - headerSizeBytes;\n        const redundantEncodingTimestamps = [];\n        const redundantEncodingPayloads = [];\n        // If redundancy is disabled then only send the primary payload\n        if (this.redundancyEnabled) {\n            // Determine how much redundancy we can fit into our packet\n            let redundantTimestamp = this.uint32WrapAround(primaryTimestamp - this.redPacketizationTime * this.redPacketDistance);\n            for (let i = 0; i < numRedundantEncodings; i++) {\n                // Do not add redundant encodings that are beyond the maximum timestamp offset.\n                if (this.uint32WrapAround(primaryTimestamp - redundantTimestamp) >= this.maxRedTimestampOffset) {\n                    break;\n                }\n                let findTimestamp = redundantTimestamp;\n                let encoding = this.encodingHistory.find(e => e.timestamp === findTimestamp);\n                if (!encoding) {\n                    // If not found or not important then look for the previous packet.\n                    // The current packet may have included FEC for the previous, so just\n                    // use the previous packet instead provided that it has voice activity.\n                    findTimestamp = this.uint32WrapAround(redundantTimestamp - this.redPacketizationTime);\n                    encoding = this.encodingHistory.find(e => e.timestamp === findTimestamp);\n                }\n                if (encoding) {\n                    const redundantEncodingSizeBytes = encoding.payload.byteLength;\n                    // Only add redundancy if there are enough bytes available.\n                    if (bytesAvailable < this.redHeaderSizeBytes + redundantEncodingSizeBytes)\n                        break;\n                    bytesAvailable -= this.redHeaderSizeBytes + redundantEncodingSizeBytes;\n                    headerSizeBytes += this.redHeaderSizeBytes;\n                    payloadSizeBytes += redundantEncodingSizeBytes;\n                    redundantEncodingTimestamps.unshift(encoding.timestamp);\n                    redundantEncodingPayloads.unshift(encoding.payload);\n                }\n                redundantTimestamp -= this.redPacketizationTime * this.redPacketDistance;\n                redundantTimestamp = this.uint32WrapAround(redundantTimestamp);\n            }\n        }\n        const redPayloadBuffer = new ArrayBuffer(headerSizeBytes + payloadSizeBytes);\n        const redPayloadView = new DataView(redPayloadBuffer);\n        // Add redundant encoding header(s) to new buffer\n        let redPayloadOffset = 0;\n        for (let i = 0; i < redundantEncodingTimestamps.length; i++) {\n            const timestampDelta = primaryTimestamp - redundantEncodingTimestamps[i];\n            redPayloadView.setUint8(redPayloadOffset, this.opusPayloadType | 0x80);\n            redPayloadView.setUint16(redPayloadOffset + 1, (timestampDelta << 2) | (redundantEncodingPayloads[i].byteLength >> 8));\n            redPayloadView.setUint8(redPayloadOffset + 3, redundantEncodingPayloads[i].byteLength & 0xff);\n            redPayloadOffset += this.redHeaderSizeBytes;\n        }\n        // Add primary encoding header to new buffer\n        redPayloadView.setUint8(redPayloadOffset, this.opusPayloadType);\n        redPayloadOffset += this.redLastHeaderSizeBytes;\n        // Add redundant payload(s) to new buffer\n        const redPayloadArray = new Uint8Array(redPayloadBuffer);\n        for (let i = 0; i < redundantEncodingPayloads.length; i++) {\n            redPayloadArray.set(new Uint8Array(redundantEncodingPayloads[i]), redPayloadOffset);\n            redPayloadOffset += redundantEncodingPayloads[i].byteLength;\n        }\n        // Add primary payload to new buffer\n        redPayloadArray.set(new Uint8Array(primaryPayload), redPayloadOffset);\n        redPayloadOffset += primaryPayload.byteLength;\n        /* istanbul ignore next */\n        // Sanity check that we got the expected total payload size.\n        if (redPayloadOffset !== headerSizeBytes + payloadSizeBytes)\n            return null;\n        this.updateEncodingHistory(primaryTimestamp, primaryPayload);\n        return redPayloadBuffer;\n    }\n    /**\n     * Update the encoding history with the latest primary encoding\n     */\n    updateEncodingHistory(primaryTimestamp, primaryPayload) {\n        // Remove encodings from the history if they are too old.\n        for (const encoding of this.encodingHistory) {\n            const maxTimestampDelta = this.redPacketizationTime * this.redMaxRecoveryDistance;\n            if (primaryTimestamp - encoding.timestamp >= maxTimestampDelta) {\n                this.encodingHistory.shift();\n            }\n            else {\n                break;\n            }\n        }\n        // Only add an encoding to the history if the encoding is deemed to be important. An encoding is important if it is\n        // a CELT-only packet or contains voice activity.\n        const packet = new DataView(primaryPayload);\n        if (this.opusPacketIsCeltOnly(packet) ||\n            this.opusPacketHasVoiceActivity(packet, packet.byteLength) > 0) {\n            // Check if adding an encoding will cause the length of the encoding history to exceed the maximum history size.\n            // This is not expected to happen but could occur if we get incorrect timestamps. We want to make sure our memory\n            // usage is bounded. In this case, just clear the history and start over from empty.\n            if (this.encodingHistory.length + 1 > this.maxEncodingHistorySize)\n                this.encodingHistory.length = 0;\n            this.encodingHistory.push({ timestamp: primaryTimestamp, payload: primaryPayload });\n        }\n    }\n    /**\n     * Initialize packet logs and metric values.\n     */\n    initializePacketLogs() {\n        // The extra space from the max RED recovery distance is to ensure that we do not incorrectly count recovery for\n        // packets that have already been received but are outside of the max out-of-order distance.\n        const packetLogSize = this.maxOutOfOrderPacketDistance + this.redMaxRecoveryDistance;\n        this.primaryPacketLog = {\n            window: new Array(packetLogSize),\n            index: 0,\n            windowSize: packetLogSize,\n        };\n        this.redRecoveryLog = {\n            window: new Array(packetLogSize),\n            index: 0,\n            windowSize: packetLogSize,\n        };\n        this.fecRecoveryLog = {\n            window: new Array(packetLogSize),\n            index: 0,\n            windowSize: packetLogSize,\n        };\n        this.totalAudioPacketsExpected = 0;\n        this.totalAudioPacketsLost = 0;\n        this.totalAudioPacketsRecoveredRed = 0;\n        this.totalAudioPacketsRecoveredFec = 0;\n    }\n    /**\n     * Receives encoded frames from the server\n     * and adds the timestamps to a packet log\n     * to calculate an approximate recovery metric.\n     */\n    receivePacketLogTransform(\n    // @ts-ignore\n    frame, controller) {\n        const frameMetadata = frame.getMetadata();\n        // @ts-ignore\n        if (frameMetadata.payloadType !== this.redPayloadType) {\n            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n            return;\n        }\n        // @ts-ignore\n        const encodings = this.splitEncodings(frame.timestamp, frame.data, \n        /*getFecInfo*/ true, frameMetadata.sequenceNumber);\n        if (!encodings) {\n            this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n            return;\n        }\n        for (let i = encodings.length - 1; i >= 0; i--) {\n            if (this.updateLossStats(encodings[i])) {\n                this.updateRedStats(encodings[i]);\n                this.updateFecStats(encodings[i]);\n            }\n        }\n        this.maybeReportLossStats(frameMetadata.synchronizationSource, encodings[encodings.length - 1].timestamp);\n        this.enqueueAudioFrameIfPayloadSizeIsValid(frame, controller);\n    }\n    /**\n     * Adds a timestamp to the primary packet log.\n     * This also updates totalAudioPacketsLost and totalAudioPacketsExpected by looking\n     * at the difference between timestamps.\n     *\n     * @param encoding : The encoding to be analyzed\n     * @returns false if sequence number was greater than max out of order distance\n     *          true otherwise\n     */\n    updateLossStats(encoding) {\n        if (encoding.isRedundant)\n            return true;\n        const timestamp = encoding.timestamp;\n        const seq = encoding.seq;\n        if (this.totalAudioPacketsExpected === 0) {\n            this.totalAudioPacketsExpected = 1;\n            this.newestSequenceNumber = seq;\n            this.addTimestamp(this.primaryPacketLog, timestamp);\n            return true;\n        }\n        const diff = this.int16(seq - this.newestSequenceNumber);\n        if (diff < -this.maxOutOfOrderPacketDistance)\n            return false;\n        if (diff < 0) {\n            if (!this.hasTimestamp(this.primaryPacketLog, timestamp)) {\n                if (this.totalAudioPacketsLost > 0)\n                    this.totalAudioPacketsLost--;\n                this.addTimestamp(this.primaryPacketLog, timestamp);\n                this.removeFromRecoveryWindows(timestamp);\n            }\n        }\n        else if (diff > 1) {\n            this.totalAudioPacketsLost += diff - 1;\n        }\n        if (diff > 0) {\n            this.totalAudioPacketsExpected += diff;\n            this.newestSequenceNumber = encoding.seq;\n            this.addTimestamp(this.primaryPacketLog, timestamp);\n        }\n        return true;\n    }\n    /**\n     * Adds a timestamp to the red recovery log if it is not present in\n     * the primary packet log and if it's not too old.\n     *\n     * @param encoding : The encoding to be analyzed\n     */\n    updateRedStats(encoding) {\n        if (!encoding.isRedundant || this.totalAudioPacketsLost === 0)\n            return;\n        const timestamp = encoding.timestamp;\n        if (!this.hasTimestamp(this.primaryPacketLog, timestamp)) {\n            if (!this.hasTimestamp(this.redRecoveryLog, timestamp)) {\n                this.totalAudioPacketsRecoveredRed++;\n                this.addTimestamp(this.redRecoveryLog, timestamp);\n            }\n            if (this.removeTimestamp(this.fecRecoveryLog, timestamp)) {\n                /* istanbul ignore else */\n                if (this.totalAudioPacketsRecoveredFec > 0)\n                    this.totalAudioPacketsRecoveredFec--;\n            }\n        }\n    }\n    /**\n     * Adds a timestamp to the fec recovery log if it is not present in\n     * the primary packet log and red recovery log and if it is not too old.\n     *\n     * @param encoding : The encoding to be analyzed\n     */\n    updateFecStats(encoding) {\n        if (!encoding.hasFec || this.totalAudioPacketsLost === 0)\n            return;\n        const fecTimestamp = encoding.timestamp - this.redPacketizationTime;\n        if (this.hasTimestamp(this.primaryPacketLog, fecTimestamp) ||\n            this.hasTimestamp(this.redRecoveryLog, fecTimestamp) ||\n            this.hasTimestamp(this.fecRecoveryLog, fecTimestamp)) {\n            return;\n        }\n        this.totalAudioPacketsRecoveredFec++;\n        this.addTimestamp(this.fecRecoveryLog, fecTimestamp);\n    }\n    /**\n     * Reports loss metrics to DefaultTransceiverController\n     *\n     * @param timestamp : Timestamp of most recent primary packet\n     */\n    maybeReportLossStats(ssrc, timestamp) {\n        if (timestamp === undefined ||\n            timestamp - this.lastLossReportTimestamp < this.lossReportInterval)\n            return;\n        /* istanbul ignore next */\n        if (RedundantAudioEncoder.shouldReportStats) {\n            // @ts-ignore\n            self.postMessage({\n                type: 'RedundantAudioEncoderStats',\n                ssrc,\n                totalAudioPacketsLost: this.totalAudioPacketsLost,\n                totalAudioPacketsExpected: this.totalAudioPacketsExpected,\n                totalAudioPacketsRecoveredRed: this.totalAudioPacketsRecoveredRed,\n                totalAudioPacketsRecoveredFec: this.totalAudioPacketsRecoveredFec,\n            });\n        }\n        this.lastLossReportTimestamp = timestamp;\n    }\n    /**\n     * Adds a timestamp to a packet log\n     *\n     * @param packetLog : The packetlog to add the timestamp to\n     * @param timestamp : The timestamp that should be added\n     */\n    addTimestamp(packetLog, timestamp) {\n        if (timestamp === undefined) {\n            return;\n        }\n        packetLog.window[packetLog.index] = timestamp;\n        packetLog.index = (packetLog.index + 1) % packetLog.windowSize;\n    }\n    /**\n     * Checks if a timestamp is in a packetlog\n     *\n     * @param packetLog : The packetlog to search\n     * @param timestamp : The timestamp to search for\n     * @returns true if timestamp is present, false otherwise\n     */\n    hasTimestamp(packetLog, timestamp) {\n        const element = packetLog.window.find(t => t === timestamp);\n        return !!element;\n    }\n    /**\n     * Removes a timestamp from a packet log\n     *\n     * @param packetLog : The packetlog from which the timestamp should be removed\n     * @param timestamp : The timestamp to be removed\n     * @returns true if timestamp was present in the log and removed, false otherwise\n     */\n    removeTimestamp(packetLog, timestamp) {\n        const index = packetLog.window.indexOf(timestamp);\n        if (index >= 0) {\n            packetLog.window[index] = undefined;\n            return true;\n        }\n        return false;\n    }\n    /**\n     * Removes a timestamp from red and fec recovery windows.\n     *\n     * @param timestamp : The timestamp to be removed\n     */\n    removeFromRecoveryWindows(timestamp) {\n        let removed = this.removeTimestamp(this.redRecoveryLog, timestamp);\n        if (removed) {\n            if (this.totalAudioPacketsRecoveredRed > 0)\n                this.totalAudioPacketsRecoveredRed--;\n        }\n        removed = this.removeTimestamp(this.fecRecoveryLog, timestamp);\n        if (removed) {\n            if (this.totalAudioPacketsRecoveredFec > 0)\n                this.totalAudioPacketsRecoveredFec--;\n        }\n    }\n    /**\n     * Converts the supplied argument to 32-bit unsigned integer\n     */\n    uint32WrapAround(num) {\n        const mod = 4294967296; // 2^32\n        let res = num;\n        if (num >= mod) {\n            res = num - mod;\n        }\n        else if (num < 0) {\n            res = mod + num;\n        }\n        return res;\n    }\n    /**\n     * Converts the supplied argument to 16-bit signed integer\n     */\n    int16(num) {\n        return (num << 16) >> 16;\n    }\n    /**\n     * Determines if an Opus packet is in CELT-only mode.\n     *\n     * @param packet Opus packet.\n     * @returns `true` if the packet is in CELT-only mode.\n     */\n    opusPacketIsCeltOnly(packet) {\n        // TOC byte format (https://www.rfc-editor.org/rfc/rfc6716#section-3.1):\n        //  0\n        //  0 1 2 3 4 5 6 7\n        // +-+-+-+-+-+-+-+-+\n        // | config  |s| c |\n        // +-+-+-+-+-+-+-+-+\n        // Since CELT-only packets are represented using configurations 16 to 31, the highest 'config' bit will always be 1\n        // for CELT-only packets.\n        return !!(packet.getUint8(0) & 0x80);\n    }\n    /**\n     * Gets the number of samples per frame from an Opus packet.\n     *\n     * @param packet Opus packet. This must contain at least one byte of data.\n     * @param sampleRateHz 32-bit integer sampling rate in Hz. This must be a multiple of 400 or inaccurate results will\n     *                     be returned.\n     * @returns Number of samples per frame.\n     */\n    opusPacketGetSamplesPerFrame(packet, sampleRateHz) {\n        // Sample rate must be a 32-bit integer.\n        sampleRateHz = Math.round(sampleRateHz);\n        sampleRateHz = Math.min(Math.max(sampleRateHz, -(2 ** 32)), 2 ** 32 - 1);\n        // TOC byte format (https://www.rfc-editor.org/rfc/rfc6716#section-3.1):\n        //  0\n        //  0 1 2 3 4 5 6 7\n        // +-+-+-+-+-+-+-+-+\n        // | config  |s| c |\n        // +-+-+-+-+-+-+-+-+\n        let numSamples;\n        let frameSizeOption;\n        // Case for CELT-only packet.\n        if (this.opusPacketIsCeltOnly(packet)) {\n            // The lower 3 'config' bits indicate the frame size option.\n            frameSizeOption = (packet.getUint8(0) >> 3) & 0x3;\n            // The frame size options 0, 1, 2, 3 correspond to frame sizes of 2.5, 5, 10, 20 ms. Notice that the frame sizes\n            // can be represented as (2.5 * 2^0), (2.5 * 2^1), (2.5 * 2^2), (2.5 * 2^3) ms. So, the number of samples can be\n            // calculated as follows:\n            // (sample/s) * (1s/1000ms) * (2.5ms) * 2^(frameSizeOption)\n            // = (sample/s) * (1s/400) * 2^(frameSizeOption)\n            // = (sample/s) * 2^(frameSizeOption) * (1s/400)\n            numSamples = (sampleRateHz << frameSizeOption) / 400;\n        }\n        // Case for Hybrid packet. Since Hybrid packets are represented using configurations 12 to 15, bits 1 and 2 in the\n        // above TOC byte diagram will both be 1.\n        else if ((packet.getUint8(0) & 0x60) === 0x60) {\n            // In the case of configuration 13 or 15, bit 4 in the above TOC byte diagram will be 1. Configurations 13 and 15\n            // correspond to a 20ms frame size, so the number of samples is calculated as follows:\n            // (sample/s) * (1s/1000ms) * (20ms)\n            // = (sample/s) * (1s/50)\n            //\n            // In the case of configuration 12 or 14, bit 4 in the above TOC byte diagram will be 0. Configurations 12 and 14\n            // correspond to a 10ms frame size, so the number of samples is calculated as follows:\n            // (sample/s) * (1s/1000ms) * (10ms)\n            // = (sample/s) * (1s/100)\n            numSamples = packet.getUint8(0) & 0x08 ? sampleRateHz / 50 : sampleRateHz / 100;\n        }\n        // Case for SILK-only packet.\n        else {\n            // The lower 3 'config' bits indicate the frame size option for SILK-only packets.\n            frameSizeOption = (packet.getUint8(0) >> 3) & 0x3;\n            if (frameSizeOption === 3) {\n                // Frame size option 3 corresponds to a frame size of 60ms, so the number of samples is calculated as follows:\n                // (sample/s) * (1s/1000ms) * (60ms)\n                // = (sample/s) * (60ms) * (1s/1000ms)\n                numSamples = (sampleRateHz * 60) / 1000;\n            }\n            else {\n                // The frame size options 0, 1, 2 correspond to frame sizes of 10, 20, 40 ms. Notice that the frame sizes can be\n                // represented as (10 * 2^0), (10 * 2^1), (10 * 2^2) ms. So, the number of samples can be calculated as follows:\n                // (sample/s) * (1s/1000ms) * (10ms) * 2^(frameSizeOption)\n                // = (sample/s) * (1s/100) * 2^(frameSizeOption)\n                // = (sample/s) * 2^(frameSizeOption) * (1s/100)\n                numSamples = (sampleRateHz << frameSizeOption) / 100;\n            }\n        }\n        return numSamples;\n    }\n    /**\n     * Gets the number of SILK frames per Opus frame.\n     *\n     * @param packet Opus packet.\n     * @returns Number of SILK frames per Opus frame.\n     */\n    opusNumSilkFrames(packet) {\n        // For computing the frame length in ms, the sample rate is not important since it cancels out. We use 48 kHz, but\n        // any valid sample rate would work.\n        //\n        // To calculate the length of a frame (with a 48kHz sample rate) in ms:\n        // (samples/frame) * (1s/48000 samples) * (1000ms/s)\n        // = (samples/frame) * (1000ms/48000 samples)\n        // = (samples/frame) * (1ms/48 samples)\n        let frameLengthMs = this.opusPacketGetSamplesPerFrame(packet, 48000) / 48;\n        if (frameLengthMs < 10)\n            frameLengthMs = 10;\n        // The number of SILK frames per Opus frame is described in https://www.rfc-editor.org/rfc/rfc6716#section-4.2.2.\n        switch (frameLengthMs) {\n            case 10:\n            case 20:\n                return 1;\n            case 40:\n                return 2;\n            case 60:\n                return 3;\n            // It is not possible to reach the default case since an Opus packet can only encode sizes of 2.5, 5, 10, 20, 40,\n            // or 60 ms, so we ignore the default case for test coverage.\n            /* istanbul ignore next */\n            default:\n                return 0;\n        }\n    }\n    /**\n     * Gets the number of channels from an Opus packet.\n     *\n     * @param packet Opus packet.\n     * @returns Number of channels.\n     */\n    opusPacketGetNumChannels(packet) {\n        // TOC byte format (https://www.rfc-editor.org/rfc/rfc6716#section-3.1):\n        //  0\n        //  0 1 2 3 4 5 6 7\n        // +-+-+-+-+-+-+-+-+\n        // | config  |s| c |\n        // +-+-+-+-+-+-+-+-+\n        // The 's' bit indicates mono or stereo audio, with 0 indicating mono and 1 indicating stereo.\n        return packet.getUint8(0) & 0x4 ? 2 : 1;\n    }\n    /**\n     * Determine the size (in bytes) of an Opus frame.\n     *\n     * @param packet Opus packet.\n     * @param byteOffset Offset (from the start of the packet) to the byte containing the size information.\n     * @param remainingBytes Remaining number of bytes to parse from the Opus packet.\n     * @param sizeBytes Variable to store the parsed frame size (in bytes).\n     * @returns Number of bytes that were parsed to determine the frame size.\n     */\n    opusParseSize(packet, byteOffset, remainingBytes, sizeBytes) {\n        // See https://www.rfc-editor.org/rfc/rfc6716#section-3.2.1 for an explanation of how frame size is represented.\n        // If there are no remaining bytes to parse the size from, then the size cannot be determined.\n        if (remainingBytes < 1) {\n            sizeBytes[0] = -1;\n            return -1;\n        }\n        // If the first byte is in the range 0...251, then this value is the size of the frame.\n        else if (packet.getUint8(byteOffset) < 252) {\n            sizeBytes[0] = packet.getUint8(byteOffset);\n            return 1;\n        }\n        // If the first byte is in the range 252...255, a second byte is needed. If there is no second byte, then the size\n        // cannot be determined.\n        else if (remainingBytes < 2) {\n            sizeBytes[0] = -1;\n            return -1;\n        }\n        // The total size of the frame given two size bytes is:\n        // (4 * secondSizeByte) + firstSizeByte\n        else {\n            sizeBytes[0] = 4 * packet.getUint8(byteOffset + 1) + packet.getUint8(byteOffset);\n            return 2;\n        }\n    }\n    /**\n     * Parse binary data containing an Opus packet into one or more Opus frames.\n     *\n     * @param data Binary data containing an Opus packet to be parsed. The data should begin with the first byte (i.e the\n     *             TOC byte) of an Opus packet. Note that the size of the data does not have to equal the size of the\n     *             contained Opus packet.\n     * @param lenBytes Size of the data (in bytes).\n     * @param selfDelimited Indicates if the Opus packet is self-delimiting\n     *                      (https://www.rfc-editor.org/rfc/rfc6716#appendix-B).\n     * @param tocByte Optional variable to store the TOC (table of contents) byte.\n     * @param frameOffsets Optional variable to store the offsets (from the start of the data) to the first bytes of each\n     *                     Opus frame.\n     * @param frameSizes Required variable to store the sizes (in bytes) of each Opus frame.\n     * @param payloadOffset Optional variable to store the offset (from the start of the data) to the first byte of the\n     *                      payload.\n     * @param packetLenBytes Optional variable to store the length of the Opus packet (in bytes).\n     * @returns Number of Opus frames.\n     */\n    opusPacketParseImpl(data, lenBytes, selfDelimited, tocByte, frameOffsets, frameSizes, payloadOffset, packetLenBytes) {\n        if (!frameSizes || lenBytes < 0)\n            return this.OPUS_BAD_ARG;\n        if (lenBytes === 0)\n            return this.OPUS_INVALID_PACKET;\n        // The number of Opus frames in the packet.\n        let numFrames;\n        // Intermediate storage for the number of bytes parsed to determine the size of a frame.\n        let numBytesParsed;\n        // The number of the padding bytes (excluding the padding count bytes) in the packet.\n        let paddingBytes = 0;\n        // Indicates whether CBR (constant bitrate) framing is used.\n        let cbr = false;\n        // The TOC (table of contents) byte (https://www.rfc-editor.org/rfc/rfc6716#section-3.1).\n        const toc = data.getUint8(0);\n        // Store the TOC byte.\n        if (tocByte)\n            tocByte[0] = toc;\n        // The remaining number of bytes to parse from the packet. Note that the TOC byte has already been parsed, hence the\n        // minus 1.\n        let remainingBytes = lenBytes - 1;\n        // This keeps track of where we are in the packet. This starts at 1 since the TOC byte has already been read.\n        let byteOffset = 1;\n        // The size of the last Opus frame in bytes.\n        let lastSizeBytes = remainingBytes;\n        // Read the `c` bits (i.e. code bits) from the TOC byte.\n        switch (toc & 0x3) {\n            // A code 0 packet (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.2) has one frame.\n            case 0:\n                numFrames = 1;\n                break;\n            // A code 1 packet (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.3) has two CBR (constant bitrate) frames.\n            case 1:\n                numFrames = 2;\n                cbr = true;\n                if (!selfDelimited) {\n                    // Undelimited code 1 packets must be an even number of data bytes, otherwise the packet is invalid.\n                    if (remainingBytes & 0x1)\n                        return this.OPUS_INVALID_PACKET;\n                    // The sizes of both frames are equal (i.e. half of the number of data bytes).\n                    lastSizeBytes = remainingBytes / 2;\n                    // If `lastSizeBytes` is too large, we will catch it later.\n                    frameSizes[0][0] = lastSizeBytes;\n                }\n                break;\n            // A code 2 packet (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.4) has two VBR (variable bitrate) frames.\n            case 2:\n                numFrames = 2;\n                numBytesParsed = this.opusParseSize(data, byteOffset, remainingBytes, frameSizes[0]);\n                remainingBytes -= numBytesParsed;\n                // The parsed size of the first frame cannot be larger than the number of remaining bytes in the packet.\n                if (frameSizes[0][0] < 0 || frameSizes[0][0] > remainingBytes) {\n                    return this.OPUS_INVALID_PACKET;\n                }\n                byteOffset += numBytesParsed;\n                // The size of the second frame is the remaining number of bytes after the first frame.\n                lastSizeBytes = remainingBytes - frameSizes[0][0];\n                break;\n            // A code 3 packet (https://www.rfc-editor.org/rfc/rfc6716#section-3.2.5) has multiple CBR/VBR frames (from 0 to\n            // 120 ms).\n            default:\n                // Code 3 packets must have at least 2 bytes (i.e. at least 1 byte after the TOC byte).\n                if (remainingBytes < 1)\n                    return this.OPUS_INVALID_PACKET;\n                // Frame count byte format:\n                //  0\n                //  0 1 2 3 4 5 6 7\n                // +-+-+-+-+-+-+-+-+\n                // |v|p|     M     |\n                // +-+-+-+-+-+-+-+-+\n                //\n                // Read the frame count byte, which immediately follows the TOC byte.\n                const frameCountByte = data.getUint8(byteOffset++);\n                --remainingBytes;\n                // Read the 'M' bits of the frame count byte, which encode the number of frames.\n                numFrames = frameCountByte & 0x3f;\n                // The number of frames in a code 3 packet must not be 0.\n                if (numFrames <= 0)\n                    return this.OPUS_INVALID_PACKET;\n                const samplesPerFrame = this.opusPacketGetSamplesPerFrame(data, 48000);\n                // A single frame can have at most 2880 samples, which happens in the case where 60ms of 48kHz audio is encoded\n                // per frame. A code 3 packet cannot contain more than 120ms of audio, so the total number of samples cannot\n                // exceed 2880 * 2 = 5760.\n                if (samplesPerFrame * numFrames > 5760)\n                    return this.OPUS_INVALID_PACKET;\n                // Parse padding bytes if the 'p' bit is 1.\n                if (frameCountByte & 0x40) {\n                    let paddingCountByte;\n                    let numPaddingBytes;\n                    // Remove padding bytes (including padding count bytes) from the remaining byte count.\n                    do {\n                        // Sanity check that there are enough bytes to parse and remove the padding.\n                        if (remainingBytes <= 0)\n                            return this.OPUS_INVALID_PACKET;\n                        // Get the next padding count byte.\n                        paddingCountByte = data.getUint8(byteOffset++);\n                        --remainingBytes;\n                        // If the padding count byte has a value in the range 0...254, then the total size of the padding is the\n                        // value in the padding count byte.\n                        //\n                        // If the padding count byte has value 255, then the total size of the padding is 254 plus the value in the\n                        // next padding count byte. Therefore, keep reading padding count bytes while the value is 255.\n                        numPaddingBytes = paddingCountByte === 255 ? 254 : paddingCountByte;\n                        remainingBytes -= numPaddingBytes;\n                        paddingBytes += numPaddingBytes;\n                    } while (paddingCountByte === 255);\n                }\n                // Sanity check that the remaining number of bytes is not negative after removing the padding.\n                if (remainingBytes < 0)\n                    return this.OPUS_INVALID_PACKET;\n                // Read the 'v' bit (i.e. VBR bit).\n                cbr = !(frameCountByte & 0x80);\n                // VBR case\n                if (!cbr) {\n                    lastSizeBytes = remainingBytes;\n                    // Let M be the number of frames. There will be M - 1 frame length indicators (which can be 1 or 2 bytes)\n                    // corresponding to the lengths of frames 0 to M - 2. The size of the last frame (i.e. frame M - 1) is the\n                    // number of data bytes after the end of frame M - 2 and before the start of the padding bytes.\n                    for (let i = 0; i < numFrames - 1; ++i) {\n                        numBytesParsed = this.opusParseSize(data, byteOffset, remainingBytes, frameSizes[i]);\n                        remainingBytes -= numBytesParsed;\n                        // The remaining number of data bytes must be enough to contain each frame.\n                        if (frameSizes[i][0] < 0 || frameSizes[i][0] > remainingBytes) {\n                            return this.OPUS_INVALID_PACKET;\n                        }\n                        byteOffset += numBytesParsed;\n                        lastSizeBytes -= numBytesParsed + frameSizes[i][0];\n                    }\n                    // Sanity check that the size of the last frame is not negative.\n                    if (lastSizeBytes < 0)\n                        return this.OPUS_INVALID_PACKET;\n                }\n                // CBR case\n                else if (!selfDelimited) {\n                    // The size of each frame is the number of data bytes divided by the number of frames.\n                    lastSizeBytes = Math.trunc(remainingBytes / numFrames);\n                    // The number of data bytes must be a non-negative integer multiple of the number of frames.\n                    if (lastSizeBytes * numFrames !== remainingBytes)\n                        return this.OPUS_INVALID_PACKET;\n                    // All frames have equal size in the undelimited CBR case.\n                    for (let i = 0; i < numFrames - 1; ++i) {\n                        frameSizes[i][0] = lastSizeBytes;\n                    }\n                }\n        }\n        // Self-delimited framing uses an extra 1 or 2 bytes, immediately preceding the data bytes, to indicate either the\n        // size of the last frame (for code 0, code 2, and VBR code 3 packets) or the size of all the frames (for code 1 and\n        // CBR code 3 packets). See https://www.rfc-editor.org/rfc/rfc6716#appendix-B.\n        if (selfDelimited) {\n            // The extra frame size byte(s) will always indicate the size of the last frame.\n            numBytesParsed = this.opusParseSize(data, byteOffset, remainingBytes, frameSizes[numFrames - 1]);\n            remainingBytes -= numBytesParsed;\n            // There must be enough data bytes for the last frame.\n            if (frameSizes[numFrames - 1][0] < 0 || frameSizes[numFrames - 1][0] > remainingBytes) {\n                return this.OPUS_INVALID_PACKET;\n            }\n            byteOffset += numBytesParsed;\n            // For CBR packets, the sizes of all the frames are equal.\n            if (cbr) {\n                // There must be enough data bytes for all the frames.\n                if (frameSizes[numFrames - 1][0] * numFrames > remainingBytes) {\n                    return this.OPUS_INVALID_PACKET;\n                }\n                for (let i = 0; i < numFrames - 1; ++i) {\n                    frameSizes[i][0] = frameSizes[numFrames - 1][0];\n                }\n            }\n            // At this point, `lastSizeBytes` contains the size of the last frame plus the size of the extra frame size\n            // byte(s), so sanity check that `lastSizeBytes` is the upper bound for the size of the last frame.\n            else if (!(numBytesParsed + frameSizes[numFrames - 1][0] <= lastSizeBytes)) {\n                return this.OPUS_INVALID_PACKET;\n            }\n        }\n        // Undelimited case\n        else {\n            // Because the size of the last packet is not encoded explicitly, it is possible that the size of the last packet\n            // (or of all the packets, for the CBR case) is larger than maximum frame size.\n            if (lastSizeBytes > this.OPUS_MAX_FRAME_SIZE_BYTES)\n                return this.OPUS_INVALID_PACKET;\n            frameSizes[numFrames - 1][0] = lastSizeBytes;\n        }\n        // Store the offset to the start of the payload.\n        if (payloadOffset)\n            payloadOffset[0] = byteOffset;\n        // Store the offsets to the start of each frame.\n        for (let i = 0; i < numFrames; ++i) {\n            if (frameOffsets)\n                frameOffsets[i][0] = byteOffset;\n            byteOffset += frameSizes[i][0];\n        }\n        // Store the length of the Opus packet.\n        if (packetLenBytes)\n            packetLenBytes[0] = byteOffset + paddingBytes;\n        return numFrames;\n    }\n    /**\n     * Parse a single undelimited Opus packet into one or more Opus frames.\n     *\n     * @param packet Opus packet to be parsed.\n     * @param lenBytes Size of the packet (in bytes).\n     * @param tocByte Optional variable to store the TOC (table of contents) byte.\n     * @param frameOffsets Optional variable to store the offsets (from the start of the packet) to the first bytes of\n     *                     each Opus frame.\n     * @param frameSizes Required variable to store the sizes (in bytes) of each Opus frame.\n     * @param payloadOffset Optional variable to store the offset (from the start of the packet) to the first byte of the\n     *                      payload.\n     * @returns Number of Opus frames.\n     */\n    opusPacketParse(packet, lenBytes, tocByte, frameOffsets, frameSizes, payloadOffset) {\n        return this.opusPacketParseImpl(packet, lenBytes, \n        /* selfDelimited */ false, tocByte, frameOffsets, frameSizes, payloadOffset, null);\n    }\n    /**\n     * This function returns the SILK VAD (voice activity detection) information encoded in the Opus packet. For CELT-only\n     * packets that do not have VAD information, it returns -1.\n     *\n     * @param packet Opus packet.\n     * @param lenBytes Size of the packet (in bytes).\n     * @returns  0: no frame had the VAD flag set.\n     *           1: at least one frame had the VAD flag set.\n     *          -1: VAD status could not be determined.\n     */\n    opusPacketHasVoiceActivity(packet, lenBytes) {\n        if (!packet || lenBytes <= 0)\n            return 0;\n        // In CELT-only mode, we can not determine whether there is VAD.\n        if (this.opusPacketIsCeltOnly(packet))\n            return -1;\n        const numSilkFrames = this.opusNumSilkFrames(packet);\n        // It is not possible for `opusNumSilkFrames()` to return 0, so we ignore the next sanity check for test coverage.\n        /* istanbul ignore next */\n        if (numSilkFrames === 0)\n            return -1;\n        const opusFrameOffsets = new Array(this.OPUS_MAX_OPUS_FRAMES);\n        const opusFrameSizes = new Array(this.OPUS_MAX_OPUS_FRAMES);\n        for (let i = 0; i < this.OPUS_MAX_OPUS_FRAMES; ++i) {\n            opusFrameOffsets[i] = [undefined];\n            opusFrameSizes[i] = [undefined];\n        }\n        // Parse packet to get the Opus frames.\n        const numOpusFrames = this.opusPacketParse(packet, lenBytes, null, opusFrameOffsets, opusFrameSizes, null);\n        // VAD status cannot be determined for invalid packets.\n        if (numOpusFrames < 0)\n            return -1;\n        // Iterate over all Opus frames, which may contain multiple SILK frames, to determine the VAD status.\n        for (let i = 0; i < numOpusFrames; ++i) {\n            if (opusFrameSizes[i][0] < 1)\n                continue;\n            // LP layer header bits format (https://www.rfc-editor.org/rfc/rfc6716#section-4.2.3):\n            //\n            // Mono case:\n            // +-----------------+----------+\n            // | 1 to 3 VAD bits | LBRR bit |\n            // +-----------------+----------+\n            //\n            // Stereo case:\n            // +---------------------+--------------+----------------------+---------------+\n            // | 1 to 3 mid VAD bits | mid LBRR bit | 1 to 3 side VAD bits | side LBRR bit |\n            // +---------------------+--------------+----------------------+---------------+\n            // The upper 1 to 3 bits (dependent on the number of SILK frames) of the LP layer contain VAD bits. If any of\n            // these VAD bits are 1, then voice activity is present.\n            if (packet.getUint8(opusFrameOffsets[i][0]) >> (8 - numSilkFrames))\n                return 1;\n            // In the stereo case, there is a second set of 1 to 3 VAD bits, so also check these VAD bits.\n            const channels = this.opusPacketGetNumChannels(packet);\n            if (channels === 2 &&\n                (packet.getUint8(opusFrameOffsets[i][0]) << (numSilkFrames + 1)) >> (8 - numSilkFrames)) {\n                return 1;\n            }\n        }\n        // No voice activity was detected.\n        return 0;\n    }\n    /**\n     * This method is based on Definition of the Opus Audio Codec\n     * (https://tools.ietf.org/html/rfc6716). Basically, this method is based on\n     * parsing the LP layer of an Opus packet, particularly the LBRR flag.\n     *\n     * @param packet Opus packet.\n     * @param lenBytes Size of the packet (in bytes).\n     * @returns  true: packet has fec encoding about previous packet.\n     *           false: no fec encoding present.\n     */\n    opusPacketHasFec(packet, lenBytes) {\n        if (!packet || lenBytes <= 0)\n            return false;\n        // In CELT-only mode, packets should not have FEC.\n        if (this.opusPacketIsCeltOnly(packet))\n            return false;\n        const opusFrameOffsets = new Array(this.OPUS_MAX_OPUS_FRAMES);\n        const opusFrameSizes = new Array(this.OPUS_MAX_OPUS_FRAMES);\n        for (let i = 0; i < this.OPUS_MAX_OPUS_FRAMES; ++i) {\n            opusFrameOffsets[i] = [undefined];\n            opusFrameSizes[i] = [undefined];\n        }\n        // Parse packet to get the Opus frames.\n        const numOpusFrames = this.opusPacketParse(packet, lenBytes, null, opusFrameOffsets, opusFrameSizes, null);\n        if (numOpusFrames < 0)\n            return false;\n        /* istanbul ignore next */\n        if (opusFrameSizes[0][0] <= 1)\n            return false;\n        const numSilkFrames = this.opusNumSilkFrames(packet);\n        /* istanbul ignore next */\n        if (numSilkFrames === 0)\n            return false;\n        const channels = this.opusPacketGetNumChannels(packet);\n        /* istanbul ignore next */\n        if (channels !== 1 && channels !== 2)\n            return false;\n        // A frame starts with the LP layer. The LP layer begins with two to eight\n        // header bits.These consist of one VAD bit per SILK frame (up to 3),\n        // followed by a single flag indicating the presence of LBRR frames.\n        // For a stereo packet, these first flags correspond to the mid channel, and\n        // a second set of flags is included for the side channel. Because these are\n        // the first symbols decoded by the range coder and because they are coded\n        // as binary values with uniform probability, they can be extracted directly\n        // from the most significant bits of the first byte of compressed data.\n        for (let i = 0; i < channels; i++) {\n            if (packet.getUint8(opusFrameOffsets[0][0]) & (0x80 >> ((i + 1) * (numSilkFrames + 1) - 1)))\n                return true;\n        }\n        return false;\n    }\n}\nRedundantAudioEncoder.shouldLog = true;\nRedundantAudioEncoder.shouldReportStats = true;\nRedundantAudioEncoder.initializeWorker();\n";
module.exports.default = $f049d79913cd91da$var$RedundantAudioEncoderWorkerCode;

});

parcelRegister("ae33M", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $771d95d1fd4e305d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $771d95d1fd4e305d$var$BaseTask_1 = $771d95d1fd4e305d$var$__importDefault((parcelRequire("9wPDz")));
/**
 * [[RunnableTask]] Task wrapper for any Promised-operation
 */ class $771d95d1fd4e305d$var$RunnableTask extends $771d95d1fd4e305d$var$BaseTask_1.default {
    constructor(logger, fn, taskName = 'RunnableTask'){
        super(logger);
        this.fn = fn;
        this.taskName = taskName;
    }
    run() {
        return this.fn().then(()=>{});
    }
}
module.exports.default = $771d95d1fd4e305d$var$RunnableTask;

});

parcelRegister("iOlwL", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $0388bc43cdf5e618$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $0388bc43cdf5e618$var$DataMessage_1 = $0388bc43cdf5e618$var$__importDefault((parcelRequire("bBKjs")));

const $0388bc43cdf5e618$var$SignalingClientEventType_1 = $0388bc43cdf5e618$var$__importDefault((parcelRequire("1lA8I")));

var $4huDn = parcelRequire("4huDn");

const $0388bc43cdf5e618$var$BaseTask_1 = $0388bc43cdf5e618$var$__importDefault((parcelRequire("9wPDz")));
class $0388bc43cdf5e618$var$SendAndReceiveDataMessagesTask extends $0388bc43cdf5e618$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'SendAndReceiveDataMessagesTask';
        this.sendDataMessageHandler = (topic, data, lifetimeMs)=>{
            if (this.context.signalingClient.ready()) {
                let uint8Data;
                if (data instanceof Uint8Array) uint8Data = data;
                else if (typeof data === 'string') uint8Data = new TextEncoder().encode(data);
                else uint8Data = new TextEncoder().encode(JSON.stringify(data));
                this.validateDataMessage(topic, uint8Data, lifetimeMs);
                const message = $4huDn.SdkDataMessagePayload.create();
                message.topic = topic;
                message.lifetimeMs = lifetimeMs;
                message.data = uint8Data;
                const messageFrame = $4huDn.SdkDataMessageFrame.create();
                messageFrame.messages = [
                    message
                ];
                this.context.signalingClient.sendDataMessage(messageFrame);
            } else this.context.logger.error('Cannot send data message because signaling client is not ready');
        };
    }
    async run() {
        this.context.removableObservers.push(this);
        this.context.signalingClient.registerObserver(this);
        this.context.realtimeController.realtimeSubscribeToSendDataMessage(this.sendDataMessageHandler);
    }
    removeObserver() {
        this.context.realtimeController.realtimeUnsubscribeFromSendDataMessage(this.sendDataMessageHandler);
        this.context.signalingClient.removeObserver(this);
    }
    handleSignalingClientEvent(event) {
        if (event.type === $0388bc43cdf5e618$var$SignalingClientEventType_1.default.ReceivedSignalFrame && event.message.type === $4huDn.SdkSignalFrame.Type.DATA_MESSAGE) for (const message of event.message.dataMessage.messages){
            const dataMessage = new $0388bc43cdf5e618$var$DataMessage_1.default(message.ingestTimeNs / 1000000, message.topic, message.data, message.senderAttendeeId, message.senderExternalUserId, message.ingestTimeNs === 0);
            this.context.realtimeController.realtimeReceiveDataMessage(dataMessage);
        }
    }
    validateDataMessage(topic, data, lifetimeMs) {
        if (!$0388bc43cdf5e618$var$SendAndReceiveDataMessagesTask.TOPIC_REGEX.test(topic)) throw new Error('Invalid topic');
        if (data.length > $0388bc43cdf5e618$var$SendAndReceiveDataMessagesTask.DATA_SIZE) throw new Error('Data size has to be less than 2048 bytes');
        if (lifetimeMs && lifetimeMs < 0) throw new Error('The life time of the message has to be non negative');
    }
}
$0388bc43cdf5e618$var$SendAndReceiveDataMessagesTask.TOPIC_REGEX = new RegExp(/^[a-zA-Z0-9_-]{1,36}$/);
$0388bc43cdf5e618$var$SendAndReceiveDataMessagesTask.DATA_SIZE = 2048;
module.exports.default = $0388bc43cdf5e618$var$SendAndReceiveDataMessagesTask;

});

parcelRegister("7gEAZ", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $54a9847bab3ca264$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $54a9847bab3ca264$var$BaseTask_1 = $54a9847bab3ca264$var$__importDefault((parcelRequire("9wPDz")));

const $54a9847bab3ca264$var$TaskStatus_1 = $54a9847bab3ca264$var$__importDefault((parcelRequire("8wEjJ")));
/**
 * [[SerialGroupTask]] runs a set of tasks in series. When canceled, it stops
 * any currently running task and runs no further tasks in the group.
 */ class $54a9847bab3ca264$var$SerialGroupTask extends $54a9847bab3ca264$var$BaseTask_1.default {
    constructor(logger, taskName, tasksToRunSerially){
        super(logger);
        this.taskName = taskName;
        this.tasksToRunSerially = tasksToRunSerially;
        this.currentTask = null;
        for (const task of tasksToRunSerially)task.setParent(this);
    }
    cancel() {
        if (this.currentTask) {
            this.logger.info(`canceling serial group task ${this.name()} subtask ${this.currentTask.name()}`);
            this.currentTask.cancel();
        }
    }
    async run() {
        for (const task of this.tasksToRunSerially){
            if (this.getStatus() === $54a9847bab3ca264$var$TaskStatus_1.default.CANCELED) this.logAndThrow(`serial group task ${this.name()} was canceled`);
            try {
                this.logger.info(`serial group task ${this.name()} running subtask ${task.name()}`);
                this.currentTask = task;
                await task.run();
                this.logger.info(`serial group task ${this.name()} completed subtask ${task.name()}`);
            } catch (err) {
                this.logAndThrow(`serial group task ${this.name()} was canceled due to subtask ` + `${this.currentTask.name()} error: ${err.message}`);
            } finally{
                this.currentTask = null;
            }
        }
        this.logger.info(`serial group task ${this.name()} completed`);
    }
}
module.exports.default = $54a9847bab3ca264$var$SerialGroupTask;

});

parcelRegister("bDOog", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $879a6cb5badd0020$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $879a6cb5badd0020$var$DefaultBrowserBehavior_1 = $879a6cb5badd0020$var$__importDefault((parcelRequire("e2TuV")));

const $879a6cb5badd0020$var$SDP_1 = $879a6cb5badd0020$var$__importDefault((parcelRequire("bry62")));

const $879a6cb5badd0020$var$DefaultTransceiverController_1 = $879a6cb5badd0020$var$__importDefault((parcelRequire("itul0")));

const $879a6cb5badd0020$var$BaseTask_1 = $879a6cb5badd0020$var$__importDefault((parcelRequire("9wPDz")));
/*
 * [[SetLocalDescriptionTask]] asynchronously calls [[setLocalDescription]] on peer connection.
 */ class $879a6cb5badd0020$var$SetLocalDescriptionTask extends $879a6cb5badd0020$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'SetLocalDescriptionTask';
    }
    cancel() {
        // Just in case. The baseCancel behavior should prevent this.
        /* istanbul ignore else */ if (this.cancelPromise) {
            const error = new Error(`canceling ${this.name()}`);
            this.cancelPromise(error);
            delete this.cancelPromise;
        }
    }
    async run() {
        const peer = this.context.peer;
        const sdpOfferInit = this.context.sdpOfferInit;
        let sdp = sdpOfferInit.sdp;
        // When the transceiver header extension API is available (Chrome 117+), extensions
        // are configured via setHeaderExtensionsToNegotiate in the transceiver controller,
        // so SDP munging is not needed.
        const skipHeaderExtensionMunging = $879a6cb5badd0020$var$DefaultTransceiverController_1.default.canUseHeaderExtensionApi(peer);
        if (!skipHeaderExtensionMunging && this.context.browserBehavior.supportsVideoLayersAllocationRtpHeaderExtension()) // This will be negotiatiated with backend, and we will only use it to skip resubscribes
        // if we confirm support/negotiation via `RTCRtpTranceiver.sender.getParams`
        sdp = new $879a6cb5badd0020$var$SDP_1.default(sdp).withVideoLayersAllocationRtpHeaderExtension(this.context.previousSdpOffer).sdp;
        // We will remove the dependency descriptor RTP header extension after set if this branch is not hit, as
        // browsers will not remove it from the send section. We don't do it here, so that we don't lose track of
        // the header extension IDs being used when we store `this.context.previousSdpOffer`.
        if (!skipHeaderExtensionMunging && this.context.browserBehavior.supportsDependencyDescriptorRtpHeaderExtension() && this.context.videoUplinkBandwidthPolicy.wantsVideoDependencyDescriptorRtpHeaderExtension !== undefined && this.context.videoUplinkBandwidthPolicy.wantsVideoDependencyDescriptorRtpHeaderExtension()) sdp = new $879a6cb5badd0020$var$SDP_1.default(sdp).withDependencyDescriptorRtpHeaderExtension(this.context.previousSdpOffer).sdp;
        if (new $879a6cb5badd0020$var$DefaultBrowserBehavior_1.default().requiresDisablingH264Encoding()) sdp = new $879a6cb5badd0020$var$SDP_1.default(sdp).removeH264SupportFromSendSection().sdp;
        // The default start bitrate is 300kbps. While this is a reasonable starting point with respect
        // to network adaptation, the encoding bitrate does not adjust as quickly as the estimate, which
        // can quickly max out on a clear network after a few seconds. Thus it will often take 10-25 seconds
        // for the encode bitrate/resolution to reach the intended value. The network adaptation detects issues quick enough
        // that raising it to 1000kbps is not much concern, on most networks the congestion controller
        // will react to network restrictions before the first keyframe is even generated!
        //
        // Note that this is also important with regards to content share with SVC enabled,
        // as we set content hint to `motion` as a workaround for the issue that Chrome cannot enable temporal
        // scalability for screen share https://bugs.chromium.org/p/chromium/issues/detail?id=1433486
        // As a side effect, content share may start at a low resolution and take a long time to adapt,
        // especially when there is limited motion on screen, if we do not set this slightly higher starting
        // bitrate.
        sdp = new $879a6cb5badd0020$var$SDP_1.default(sdp).withStartingVideoSendBitrate(1000).sdp;
        if (this.context.videoSendCodecPreferences !== undefined && this.context.videoSendCodecPreferences.length > 0) sdp = new $879a6cb5badd0020$var$SDP_1.default(sdp).withVideoSendCodecPreferences(this.context.meetingSupportedVideoSendCodecPreferences !== undefined ? this.context.meetingSupportedVideoSendCodecPreferences : this.context.videoSendCodecPreferences).sdp;
        if (this.context.audioProfile) {
            sdp = new $879a6cb5badd0020$var$SDP_1.default(sdp).withAudioMaxAverageBitrate(this.context.audioProfile.audioBitrateBps).sdp;
            if (this.context.audioProfile.isStereo()) sdp = new $879a6cb5badd0020$var$SDP_1.default(sdp).withStereoAudio().sdp;
            if (this.context.enableAudioRedundancy()) {
                const audioPayloadMap = new $879a6cb5badd0020$var$SDP_1.default(sdp).getAudioPayloadTypes();
                const redManager = this.context.encodedTransformWorkerManager.redundantAudioEncodeTransformManager();
                if (redManager) redManager.setAudioPayloadTypes(audioPayloadMap);
            }
        }
        this.logger.debug(()=>{
            return `local description is >>>${sdp}<<<`;
        });
        const sdpOffer = {
            type: 'offer',
            sdp: sdp,
            toJSON: null
        };
        await new Promise(async (resolve, reject)=>{
            var _a;
            this.cancelPromise = (error)=>{
                reject(error);
            };
            try {
                await peer.setLocalDescription(sdpOffer);
                (_a = this.context.meetingSessionTimingManager) === null || _a === void 0 || _a.onSetLocalDescription();
                resolve();
            } catch (error) {
                reject(error);
            } finally{
                delete this.cancelPromise;
            }
        });
        this.context.logger.info('set local description');
    }
}
module.exports.default = $879a6cb5badd0020$var$SetLocalDescriptionTask;

});

parcelRegister("1k1g9", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $0f68a2ce6ceb8813$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $0f68a2ce6ceb8813$var$DefaultModality_1 = $0f68a2ce6ceb8813$var$__importDefault((parcelRequire("4Zce1")));

const $0f68a2ce6ceb8813$var$SDP_1 = $0f68a2ce6ceb8813$var$__importDefault((parcelRequire("bry62")));

const $0f68a2ce6ceb8813$var$VideoCodecCapability_1 = $0f68a2ce6ceb8813$var$__importDefault((parcelRequire("4C1Yl")));

const $0f68a2ce6ceb8813$var$BaseTask_1 = $0f68a2ce6ceb8813$var$__importDefault((parcelRequire("9wPDz")));
/*
 * [[SetRemoteDescriptionTask]] asynchronously calls [[setRemoteDescription]] on the
 * peer connection and then waits for the tracks to be added and for the ICE connection
 * to complete.
 */ class $0f68a2ce6ceb8813$var$SetRemoteDescriptionTask extends $0f68a2ce6ceb8813$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'SetRemoteDescriptionTask';
    }
    cancel() {
        if (this.cancelICEPromise) this.cancelICEPromise();
    }
    async run() {
        var _a;
        const peer = this.context.peer;
        if (!peer) this.logAndThrow('session does not have peer connection; bypass set remote description');
        let sdp = this.context.sdpAnswer;
        sdp = new $0f68a2ce6ceb8813$var$SDP_1.default(sdp).withoutServerReflexiveCandidates().sdp;
        if (this.context.audioProfile) {
            sdp = new $0f68a2ce6ceb8813$var$SDP_1.default(sdp).withAudioMaxAverageBitrate(this.context.audioProfile.audioBitrateBps).sdp;
            if (this.context.audioProfile.isStereo()) sdp = new $0f68a2ce6ceb8813$var$SDP_1.default(sdp).withStereoAudio().sdp;
        }
        if (this.context.videoSendCodecPreferences !== undefined && this.context.videoSendCodecPreferences.length > 0) sdp = new $0f68a2ce6ceb8813$var$SDP_1.default(sdp).withVideoSendCodecPreferences(this.context.meetingSupportedVideoSendCodecPreferences !== undefined ? this.context.meetingSupportedVideoSendCodecPreferences : this.context.videoSendCodecPreferences).sdp;
        this.context.prioritizedSendVideoCodecCapabilities = new $0f68a2ce6ceb8813$var$SDP_1.default(sdp).prioritizedSendVideoCodecCapabilities();
        this.context.currentVideoSendCodec = this.context.prioritizedSendVideoCodecCapabilities.length > 0 ? this.context.prioritizedSendVideoCodecCapabilities[0] : undefined;
        const mediaStream = this.context.activeVideoInput;
        if (mediaStream !== undefined) {
            const attendeeId = this.context.audioVideoController.configuration.credentials.attendeeId;
            const isContent = new $0f68a2ce6ceb8813$var$DefaultModality_1.default(attendeeId).hasModality($0f68a2ce6ceb8813$var$DefaultModality_1.default.MODALITY_CONTENT);
            const videoTrack = mediaStream.getVideoTracks()[0];
            if (isContent) {
                if (((_a = this.context.currentVideoSendCodec) === null || _a === void 0 ? void 0 : _a.codecName) === $0f68a2ce6ceb8813$var$VideoCodecCapability_1.default.av1Main().codecName) {
                    // Based on our experiments: "text" contentHint gives good coding performance for content share using AV1
                    // @ts-ignore
                    videoTrack.contentHint = 'text';
                    this.logger.info(`Setting content hint to text for AV1, attendee: ${attendeeId}`);
                }
            }
        }
        this.logger.info(`processed remote description is >>>${sdp}<<<`);
        const remoteDescription = {
            type: 'answer',
            sdp: sdp,
            toJSON: null
        };
        try {
            await this.createICEConnectionCompletedPromise(remoteDescription);
        } catch (err) {
            throw err;
        }
    }
    createICEConnectionCompletedPromise(remoteDescription) {
        return new Promise(async (resolve, reject)=>{
            var _a;
            const checkConnectionCompleted = ()=>{
                if (this.context.peer.iceConnectionState === 'connected' || this.context.peer.iceConnectionState === 'completed') {
                    this.context.peer.removeEventListener('iceconnectionstatechange', checkConnectionCompleted);
                    resolve();
                }
            };
            this.cancelICEPromise = ()=>{
                if (this.context.peer) this.context.peer.removeEventListener('iceconnectionstatechange', checkConnectionCompleted);
                reject(new Error(`${this.name()} got canceled while waiting for the ICE connection state`));
            };
            this.context.peer.addEventListener('iceconnectionstatechange', checkConnectionCompleted);
            try {
                await this.context.peer.setRemoteDescription(remoteDescription);
                (_a = this.context.meetingSessionTimingManager) === null || _a === void 0 || _a.onSetRemoteDescription();
                this.logger.info('set remote description, waiting for ICE connection');
                checkConnectionCompleted();
            } catch (err) {
                reject(err);
            }
        });
    }
}
module.exports.default = $0f68a2ce6ceb8813$var$SetRemoteDescriptionTask;

});

parcelRegister("bukCc", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[SignalingClientSubscribe]] contains settings for the Subscribe SignalFrame.
 */ class $85d27cca3936db54$var$SignalingClientSubscribe {
    /** Initializes a SignalingClientSubscribe with the given properties.
     *
     * @param attendeeId Attendee ID of the client
     * @param sdpOffer SDP offer created by WebRTC
     * @param audioHost host
     * @param audioMuted Whether audio from client is muted
     * @param audioCheckin Whether audio is in checked-in state
     * @param receiveStreamIds Which video streams to receive
     * @param localVideoEnabled Whether to send a video stream for the local camera
     * @param videoStreamDescriptions array of local video stream description
     * @param connectionTypeHasVideo Whether connection type has video
     * @param compressedSdpOffer Compressed version of the SDP offer which was created by WebRTC
     */ constructor(attendeeId, sdpOffer, audioHost, audioMuted, audioCheckin, receiveStreamIds, localVideoEnabled, videoStreamDescriptions, connectionTypeHasVideo, compressedSdpOffer){
        this.attendeeId = attendeeId;
        this.sdpOffer = sdpOffer;
        this.audioHost = audioHost;
        this.audioMuted = audioMuted;
        this.audioCheckin = audioCheckin;
        this.receiveStreamIds = receiveStreamIds;
        this.localVideoEnabled = localVideoEnabled;
        this.videoStreamDescriptions = videoStreamDescriptions;
        this.connectionTypeHasVideo = connectionTypeHasVideo;
        this.compressedSdpOffer = compressedSdpOffer;
        this.videoSubscriptionConfiguration = [];
    }
}
module.exports.default = $85d27cca3936db54$var$SignalingClientSubscribe;

});

parcelRegister("h4kXy", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c6d3117eb982be9b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4huDn = parcelRequire("4huDn");

const $c6d3117eb982be9b$var$DefaultVideoStreamIndex_1 = $c6d3117eb982be9b$var$__importDefault((parcelRequire("a9cGZ")));

const $c6d3117eb982be9b$var$VideoStreamDescription_1 = $c6d3117eb982be9b$var$__importDefault((parcelRequire("6WiTW")));
/**
 * [[SimulcastTransceiverController]] implements [[VideoStreamIndex]] to facilitate video stream
 * subscription and includes query functions for stream id and attendee id.
 *
 * @deprecated Simulcast is deprecated in favor of scalable video coding (SVC).
 */ class $c6d3117eb982be9b$var$SimulcastVideoStreamIndex extends $c6d3117eb982be9b$var$DefaultVideoStreamIndex_1.default {
    constructor(){
        super(...arguments);
        this.streamIdToBitrateKbpsMap = new Map();
        this._localStreamInfos = [];
        // Map send rid to stream Id
        this._sendRidToVideoStreamIdMap = new Map();
    }
    localStreamDescriptions() {
        const clonedDescriptions = [];
        this._localStreamInfos.forEach((desc)=>{
            clonedDescriptions.push(desc.clone());
        });
        return clonedDescriptions;
    }
    integrateUplinkPolicyDecision(encodingParams) {
        // Reuse local streams (that might already have stream IDs allocated) until
        // there are no more and then add as many new local streams as needed
        let hasStreamsToReuse = true;
        let localStreamIndex = 0;
        for(let i = 0; i < encodingParams.length; i++){
            const targetMaxBitrateKbps = encodingParams[i].maxBitrate / 1000;
            const targetMaxFrameRate = encodingParams[i].maxFramerate;
            if (!hasStreamsToReuse || i === this._localStreamInfos.length) {
                hasStreamsToReuse = false;
                const newInfo = new $c6d3117eb982be9b$var$VideoStreamDescription_1.default();
                newInfo.maxBitrateKbps = targetMaxBitrateKbps;
                newInfo.maxFrameRate = targetMaxFrameRate;
                newInfo.disabledByUplinkPolicy = targetMaxBitrateKbps === 0 ? true : false;
                newInfo.rid = encodingParams[i].rid;
                if (targetMaxBitrateKbps !== 0) newInfo.timeEnabled = Date.now();
                this._localStreamInfos.push(newInfo);
                localStreamIndex++;
                continue;
            }
            if (this._localStreamInfos[localStreamIndex].maxBitrateKbps === 0 && targetMaxBitrateKbps > 0) this._localStreamInfos[localStreamIndex].timeEnabled = Date.now();
            this._localStreamInfos[localStreamIndex].maxBitrateKbps = targetMaxBitrateKbps;
            this._localStreamInfos[localStreamIndex].maxFrameRate = targetMaxFrameRate;
            this._localStreamInfos[localStreamIndex].disabledByUplinkPolicy = targetMaxBitrateKbps === 0 ? true : false;
            localStreamIndex++;
        }
        if (hasStreamsToReuse) // splice is zero-based, remove stream starting from localStreamIndex
        this._localStreamInfos.splice(localStreamIndex);
    }
    integrateBitratesFrame(bitrateFrame) {
        super.integrateBitratesFrame(bitrateFrame);
        const stillSending = new Set();
        const existingSet = new Set(this.streamIdToBitrateKbpsMap.keys());
        for (const bitrateMsg of bitrateFrame.bitrates){
            stillSending.add(bitrateMsg.sourceStreamId);
            this.streamIdToBitrateKbpsMap.set(bitrateMsg.sourceStreamId, this.convertBpsToKbps(bitrateMsg.avgBitrateBps));
        }
        for (const id of existingSet)if (!stillSending.has(id)) {
            const avgBitrateBps = this.streamIdToBitrateKbpsMap.get(id);
            if (avgBitrateBps === $c6d3117eb982be9b$var$SimulcastVideoStreamIndex.UNSEEN_STREAM_BITRATE) this.streamIdToBitrateKbpsMap.set(id, $c6d3117eb982be9b$var$SimulcastVideoStreamIndex.RECENTLY_INACTIVE_STREAM_BITRATE);
            else this.streamIdToBitrateKbpsMap.set(id, $c6d3117eb982be9b$var$SimulcastVideoStreamIndex.NOT_SENDING_STREAM_BITRATE);
        }
        this.logLocalStreamDescriptions();
    }
    logLocalStreamDescriptions() {
        let msg = '';
        for (const desc of this._localStreamInfos)msg += `streamId=${desc.streamId} maxBitrate=${desc.maxBitrateKbps} disabledByUplink=${desc.disabledByUplinkPolicy}\n`;
        this.logger.debug(()=>{
            return msg;
        });
    }
    integrateIndexFrame(indexFrame) {
        super.integrateIndexFrame(indexFrame);
        const newIndexStreamIdSet = new Set();
        const existingSet = new Set(this.streamIdToBitrateKbpsMap.keys());
        for (const stream of this.currentIndex.sources){
            if (stream.mediaType !== $4huDn.SdkStreamMediaType.VIDEO) continue;
            newIndexStreamIdSet.add(stream.streamId);
            if (!this.streamIdToBitrateKbpsMap.has(stream.streamId)) this.streamIdToBitrateKbpsMap.set(stream.streamId, $c6d3117eb982be9b$var$SimulcastVideoStreamIndex.UNSEEN_STREAM_BITRATE);
        }
        for (const id of existingSet)if (!newIndexStreamIdSet.has(id)) this.streamIdToBitrateKbpsMap.delete(id);
    }
    integrateSubscribeAckFrame(subscribeAck) {
        super.integrateSubscribeAckFrame(subscribeAck);
        if (!subscribeAck.allocations || subscribeAck.allocations === undefined) return;
        let localStreamStartIndex = 0;
        this._sendRidToVideoStreamIdMap.clear();
        for (const allocation of subscribeAck.allocations){
            // track label is what we offered to the server
            if (this._localStreamInfos.length < localStreamStartIndex + 1) {
                this.logger.info('simulcast: allocation has more than number of local streams');
                break;
            }
            this._localStreamInfos[localStreamStartIndex].groupId = allocation.groupId;
            this._localStreamInfos[localStreamStartIndex].streamId = allocation.streamId;
            if (!this.streamIdToBitrateKbpsMap.has(allocation.streamId)) this.streamIdToBitrateKbpsMap.set(allocation.streamId, $c6d3117eb982be9b$var$SimulcastVideoStreamIndex.UNSEEN_STREAM_BITRATE);
            this._sendRidToVideoStreamIdMap.set(this._localStreamInfos[localStreamStartIndex].rid, allocation.streamId);
            localStreamStartIndex++;
        }
    }
    sendVideoStreamIdFromRid(rid) {
        let res = 0;
        if (this._sendRidToVideoStreamIdMap.has(rid)) res = this._sendRidToVideoStreamIdMap.get(rid);
        return res;
    }
}
// First time when the bitrate of a stream id is missing from bitrate message, mark it as UNSEEN
$c6d3117eb982be9b$var$SimulcastVideoStreamIndex.UNSEEN_STREAM_BITRATE = -2;
// Second time when the bitrate is missing, mark it as recently inactive
$c6d3117eb982be9b$var$SimulcastVideoStreamIndex.RECENTLY_INACTIVE_STREAM_BITRATE = -1;
// Third time when bitrate is missing, mark it as not sending
$c6d3117eb982be9b$var$SimulcastVideoStreamIndex.NOT_SENDING_STREAM_BITRATE = 0;
$c6d3117eb982be9b$var$SimulcastVideoStreamIndex.BitratesMsgFrequencyMs = 4000;
module.exports.default = $c6d3117eb982be9b$var$SimulcastVideoStreamIndex;

});

parcelRegister("3T0lu", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * This class simplifies the process of defining a transform device that
 * does not modify its input device constraints, and provides only a single audio node
 * to apply transforms.
 *
 * Subclass `SingleNodeAudioTransformDevice`, implementing `createSingleAudioNode`.
 */ class $2d46c6c7c7fe3d0f$var$SingleNodeAudioTransformDevice {
    constructor(inner){
        this.inner = inner;
    }
    async mute(_muted) {}
    /**
     * `stop` should be called by the application to free any resources associated
     * with the device (e.g., workers).
     *
     * After this is called, the device should be discarded.
     */ async stop() {
        var _a;
        (_a = this.node) === null || _a === void 0 || _a.disconnect();
    }
    /**
     * Return the inner {@link Device} that the device controller should select as part
     * of the application of this `AudioTransformDevice`.
     */ async intrinsicDevice() {
        return this.inner;
    }
    /**
     * Optionally return a pair of `AudioNode`s that should be connected to the applied inner
     * device. The two nodes can be the same, indicating the smallest possible subgraph.
     *
     * @param context The `AudioContext` to use when instantiating the nodes.
     */ async createAudioNode(context) {
        var _a;
        (_a = this.node) === null || _a === void 0 || _a.disconnect();
        this.node = await this.createSingleAudioNode(context);
        return {
            start: this.node,
            end: this.node
        };
    }
}
module.exports.default = $2d46c6c7c7fe3d0f$var$SingleNodeAudioTransformDevice;

});

parcelRegister("34pQj", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $23c5caa42f96d42e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $23c5caa42f96d42e$var$BaseTask_1 = $23c5caa42f96d42e$var$__importDefault((parcelRequire("9wPDz")));
/**
 * [[StartEncodedTransformWorkerTask]] starts the encoded transform worker manager.
 */ class $23c5caa42f96d42e$var$StartEncodedTransformWorkerTask extends $23c5caa42f96d42e$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'StartEncodedTransformWorkerTask';
    }
    async run() {
        var _a, _b, _c, _d;
        if (!((_a = this.context.encodedTransformWorkerManager) === null || _a === void 0 ? void 0 : _a.isEnabled())) {
            this.context.logger.info(`${this.name()} is skipped because the worker manager is not enabled`);
            return;
        }
        // If this fails the manager should disable itself, so that when a reconnect is triggered
        // by the exception, it will disable redundancy
        await this.context.encodedTransformWorkerManager.start({
            redundantAudio: !((_b = this.context.audioProfile) === null || _b === void 0 ? void 0 : _b.hasRedundancyEnabled())
        });
        if ((_c = this.context.audioProfile) === null || _c === void 0 ? void 0 : _c.hasRedundancyEnabled()) {
            const redundantAudioEncodeTransformManager = this.context.encodedTransformWorkerManager.redundantAudioEncodeTransformManager();
            if (redundantAudioEncodeTransformManager) (_d = this.context.audioVideoController) === null || _d === void 0 || _d.addObserver(redundantAudioEncodeTransformManager);
        }
        // Add observers after start() so the managers are initialized
        const metricsTransformManager = this.context.encodedTransformWorkerManager.metricsTransformManager();
        if (metricsTransformManager) {
            if (this.context.statsCollector) metricsTransformManager.addObserver(this.context.statsCollector);
            if (this.context.audioVideoController) metricsTransformManager.addObserver(this.context.audioVideoController);
        }
        const redundantAudioEncodeTransformManager = this.context.encodedTransformWorkerManager.redundantAudioEncodeTransformManager();
        if (redundantAudioEncodeTransformManager && this.context.statsCollector) redundantAudioEncodeTransformManager.addObserver(this.context.statsCollector);
    }
}
module.exports.default = $23c5caa42f96d42e$var$StartEncodedTransformWorkerTask;

});

parcelRegister("lVbsX", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $ff57d0c81a6f8e5d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $ff57d0c81a6f8e5d$var$MeetingSessionStatus_1 = $ff57d0c81a6f8e5d$var$__importDefault((parcelRequire("jbMe2")));

const $ff57d0c81a6f8e5d$var$MeetingSessionStatusCode_1 = $ff57d0c81a6f8e5d$var$__importDefault((parcelRequire("9zYoz")));

const $ff57d0c81a6f8e5d$var$SDP_1 = $ff57d0c81a6f8e5d$var$__importDefault((parcelRequire("bry62")));

const $ff57d0c81a6f8e5d$var$ZLIBTextCompressor_1 = $ff57d0c81a6f8e5d$var$__importDefault((parcelRequire("28F50")));

var $bRvcN = parcelRequire("bRvcN");

const $ff57d0c81a6f8e5d$var$SignalingClientEventType_1 = $ff57d0c81a6f8e5d$var$__importDefault((parcelRequire("1lA8I")));

const $ff57d0c81a6f8e5d$var$SignalingClientSubscribe_1 = $ff57d0c81a6f8e5d$var$__importDefault((parcelRequire("bukCc")));

var $4huDn = parcelRequire("4huDn");

var $3orkO = parcelRequire("3orkO");

const $ff57d0c81a6f8e5d$var$BaseTask_1 = $ff57d0c81a6f8e5d$var$__importDefault((parcelRequire("9wPDz")));
/**
 * [[SubscribeAndReceiveSubscribeAckTask]] sends a subscribe frame with the given settings
 * and receives SdkSubscribeAckFrame.
 */ class $ff57d0c81a6f8e5d$var$SubscribeAndReceiveSubscribeAckTask extends $ff57d0c81a6f8e5d$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'SubscribeAndReceiveSubscribeAckTask';
        this.taskCanceler = null;
        this.textCompressor = new $ff57d0c81a6f8e5d$var$ZLIBTextCompressor_1.default(context.logger);
    }
    cancel() {
        if (this.taskCanceler) {
            this.taskCanceler.cancel();
            this.taskCanceler = null;
        }
    }
    async run() {
        var _a;
        let localSdp = '';
        if (this.context.peer && this.context.peer.localDescription) localSdp = new $ff57d0c81a6f8e5d$var$SDP_1.default(this.context.peer.localDescription.sdp).withUnifiedPlanFormat().sdp;
        if (!this.context.enableSimulcast) {
            // backward compatibility
            let frameRate = 0;
            let maxEncodeBitrateKbps = 0;
            if (this.context.videoCaptureAndEncodeParameter) {
                frameRate = this.context.videoCaptureAndEncodeParameter.captureFrameRate();
                maxEncodeBitrateKbps = this.context.videoCaptureAndEncodeParameter.encodeBitrates()[0];
            }
            const param = {
                rid: 'hi',
                maxBitrate: maxEncodeBitrateKbps * 1000,
                maxFramerate: frameRate,
                active: true
            };
            this.context.videoStreamIndex.integrateUplinkPolicyDecision([
                param
            ]);
        }
        // See comment above `fixUpSubscriptionOrder`
        const videoSubscriptions = this.fixUpSubscriptionOrder(localSdp, this.context.videoSubscriptions);
        const isSendingStreams = this.context.videoDuplexMode === $4huDn.SdkStreamServiceType.TX || this.context.videoDuplexMode === $4huDn.SdkStreamServiceType.DUPLEX;
        let compressedSDPOffer;
        let localSdpOffer = localSdp;
        if (this.context.videoUplinkBandwidthPolicy.wantsVideoDependencyDescriptorRtpHeaderExtension === undefined || !this.context.videoUplinkBandwidthPolicy.wantsVideoDependencyDescriptorRtpHeaderExtension()) // See note above similar code in `SetLocalDescriptionTask`.
        localSdpOffer = new $ff57d0c81a6f8e5d$var$SDP_1.default(localSdpOffer).withoutDependencyDescriptorRtpHeaderExtension().sdp;
        if (this.context.serverSupportsCompression) {
            // If the server supports compression, then send the compressed version of the sdp
            // and exclude the original sdp offer.
            const prevOffer = this.context.previousSdpOffer ? this.context.previousSdpOffer.sdp : '';
            compressedSDPOffer = this.textCompressor.compress(localSdpOffer, prevOffer);
            this.context.logger.info(`Compressed the SDP message from ${localSdpOffer.length} to ${compressedSDPOffer.length} bytes.`);
            localSdp = '';
        }
        this.context.previousSdpOffer = new $ff57d0c81a6f8e5d$var$SDP_1.default(localSdp);
        const subscribe = new $ff57d0c81a6f8e5d$var$SignalingClientSubscribe_1.default(this.context.meetingSessionConfiguration.credentials.attendeeId, localSdp, this.context.meetingSessionConfiguration.urls.audioHostURL, this.context.realtimeController.realtimeIsLocalAudioMuted(), false, videoSubscriptions, isSendingStreams, this.context.videoStreamIndex.localStreamDescriptions(), // TODO: handle check-in mode, or remove this param
        true, compressedSDPOffer);
        if (this.context.videoDownlinkBandwidthPolicy.getServerSideNetworkAdaption !== undefined && !(0, $bRvcN.serverSideNetworkAdaptionIsNoneOrDefault)(this.context.videoDownlinkBandwidthPolicy.getServerSideNetworkAdaption()) && this.context.videoDownlinkBandwidthPolicy.getVideoPreferences !== undefined) // Set initial configuration for the receive streams indicated by the rest of the subscribe
        subscribe.videoSubscriptionConfiguration = (0, $3orkO.convertVideoPreferencesToSignalingClientVideoSubscriptionConfiguration)(this.context, videoSubscriptions.map((streamId)=>{
            return streamId === 0 ? 0 : this.context.videoStreamIndex.groupIdForStreamId(streamId);
        }), this.context.videoDownlinkBandwidthPolicy.getVideoPreferences());
        this.context.logger.info(`sending subscribe: ${JSON.stringify(subscribe)}`);
        this.context.signalingClient.subscribe(subscribe);
        const subscribeAckFrame = await this.receiveSubscribeAck();
        (_a = this.context.meetingSessionTimingManager) === null || _a === void 0 || _a.onSubscribeAckReceived();
        this.context.logger.info(`got subscribe ack: ${JSON.stringify(subscribeAckFrame)}`);
        let decompressedText = '';
        if (subscribeAckFrame.compressedSdpAnswer && subscribeAckFrame.compressedSdpAnswer.length) {
            decompressedText = this.textCompressor.decompress(subscribeAckFrame.compressedSdpAnswer, this.context.previousSdpAnswerAsString);
            if (decompressedText.length === 0) {
                this.context.sdpAnswer = '';
                this.context.previousSdpAnswerAsString = '';
                this.logAndThrow(`Error occurred while trying to decompress the SDP answer.`);
            }
            this.context.logger.info(`Decompressed the SDP message from ${subscribeAckFrame.compressedSdpAnswer.length} to ${decompressedText.length} bytes.`);
            this.context.sdpAnswer = decompressedText;
        } else this.context.sdpAnswer = subscribeAckFrame.sdpAnswer;
        this.context.previousSdpAnswerAsString = this.context.sdpAnswer;
        this.context.videoStreamIndex.integrateSubscribeAckFrame(subscribeAckFrame);
    }
    // Our backends currently expect the video subscriptions passed in subscribe to precisely
    // line up with the media sections, with a zero for any video send or inactive section.
    //
    // Firefox occasionally tosses stopped transceivers at the end of the SDP without reason
    // and in general we don't want to be at the mercy of SDP sections not being in the same
    // order as `getTransceivers`, so we simply recalculate the array here to enforce that
    // expected invarient until we refactor our signaling to simply take a mapping of MID to
    // subscription.
    //
    // This only works on Unified Plan SDPs
    fixUpSubscriptionOrder(sdp, videoSubscriptions) {
        if (this.context.transceiverController.getMidForStreamId === undefined) return videoSubscriptions;
        const midsToStreamIds = new Map();
        for (const streamId of videoSubscriptions){
            // The local description will have been set by the time this task is running, so all
            // of the transceivers should have `mid` set by now (see comment above `getMidForStreamId`)
            const mid = this.context.transceiverController.getMidForStreamId(streamId);
            if (mid === undefined) {
                if (streamId !== 0) // Send section or inactive section
                this.logger.warn(`Could not find MID for stream ID: ${streamId}`);
                continue;
            }
            midsToStreamIds.set(mid, streamId);
        }
        const sections = new $ff57d0c81a6f8e5d$var$SDP_1.default(sdp).mediaSections();
        const newSubscriptions = [];
        for (const section of sections){
            if (section.mediaType !== 'video') continue;
            if (section.direction === 'recvonly') {
                const streamId = midsToStreamIds.get(section.mid);
                if (streamId === undefined) {
                    this.logger.warn(`Could not find stream ID for MID: ${section.mid}`);
                    continue;
                }
                newSubscriptions.push(streamId);
            } else newSubscriptions.push(0);
        }
        this.logger.info(`Fixed up ${JSON.stringify(videoSubscriptions)} to ${JSON.stringify(newSubscriptions)} (may be same))}`);
        return newSubscriptions;
    }
    receiveSubscribeAck() {
        return new Promise((resolve, reject)=>{
            const context = this.context;
            class Interceptor {
                constructor(signalingClient){
                    this.signalingClient = signalingClient;
                }
                cancel() {
                    this.signalingClient.removeObserver(this);
                    reject(new Error(`SubscribeAndReceiveSubscribeAckTask got canceled while waiting for SdkSubscribeAckFrame`));
                }
                handleSignalingClientEvent(event) {
                    if (event.isConnectionTerminated()) {
                        const message = `SubscribeAndReceiveSubscribeAckTask connection was terminated with code ${event.closeCode} and reason: ${event.closeReason}`;
                        context.logger.warn(message);
                        let statusCode = $ff57d0c81a6f8e5d$var$MeetingSessionStatusCode_1.default.TaskFailed;
                        if (event.closeCode >= 4500 && event.closeCode < 4600) statusCode = $ff57d0c81a6f8e5d$var$MeetingSessionStatusCode_1.default.SignalingInternalServerError;
                        context.audioVideoController.handleMeetingSessionStatus(new $ff57d0c81a6f8e5d$var$MeetingSessionStatus_1.default(statusCode), new Error(message));
                        return;
                    }
                    if (event.type !== $ff57d0c81a6f8e5d$var$SignalingClientEventType_1.default.ReceivedSignalFrame || event.message.type !== $4huDn.SdkSignalFrame.Type.SUBSCRIBE_ACK) return;
                    this.signalingClient.removeObserver(this);
                    // @ts-ignore: force cast to SdkSubscribeAckFrame
                    const subackFrame = event.message.suback;
                    resolve(subackFrame);
                }
            }
            const interceptor = new Interceptor(this.context.signalingClient);
            this.context.signalingClient.registerObserver(interceptor);
            this.taskCanceler = interceptor;
        });
    }
}
module.exports.default = $ff57d0c81a6f8e5d$var$SubscribeAndReceiveSubscribeAckTask;

});
parcelRegister("28F50", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ckCqy = parcelRequire("ckCqy");
/**
 * [[ZLIBTextCompressor]] Performs the text compression and decompression using zlib
 */ class $18ec31b3b0b8947a$var$ZLIBTextCompressor {
    /**
     * Constructs an instance of [[ZLIBTextCompressor]]
     * @param logger
     */ constructor(logger){
        this.logger = logger;
    }
    /**
     * Compresses the given text.
     *
     * Note: The dictionary used during compression should be the same as
     * that being used during decompression.
     *
     * @param text - the text that needs to be compressed
     * @param dictionary - that will be used to seed the compression
     *      library to improve compression's performance
     * @returns a compressed text
     */ compress(text, dictionary) {
        if (dictionary.length > 0) {
            const dictionarySize = Math.min(dictionary.length, $18ec31b3b0b8947a$var$ZLIBTextCompressor.MAX_DICTIONARY_SIZE);
            dictionary = dictionary.slice(0, dictionarySize);
        }
        const options = {
            memLevel: $18ec31b3b0b8947a$var$ZLIBTextCompressor.Z_MEM_LEVEL,
            dictionary: dictionary
        };
        const compressedText = $ckCqy.deflateRaw(text, options);
        return compressedText;
    }
    /**
     * Decompresses the given text and returns the original text.
     *
     * Note: The dictionary used during compression should be the same as
     * that being used during decompression.
     *
     * @param compressedText that will be decompressed
     * @param dictionary that will be used to seed the compression library to improve
     *      decompression's performance
     * @returns decompressed string
     */ decompress(compressedText, dictionary) {
        if (dictionary.length > 0) {
            const dictionarySize = Math.min(dictionary.length, $18ec31b3b0b8947a$var$ZLIBTextCompressor.MAX_DICTIONARY_SIZE);
            dictionary = dictionary.slice(0, dictionarySize);
        }
        const options = {
            to: 'string',
            dictionary: dictionary,
            chunkSize: 4096
        };
        let decompressedText = '';
        try {
            decompressedText = $ckCqy.inflateRaw(compressedText, options);
        } catch (ex) {
            this.logger.error(`failed to decompress the string with error: [${ex}]`);
        }
        return decompressedText;
    }
}
// The memory Level parameter specifies how much memory to use for the internal state.
// Smaller values use less memory but are slower, while higher values use more memory
// to gain compression speed.
// Range is between 1 to 9
$18ec31b3b0b8947a$var$ZLIBTextCompressor.Z_MEM_LEVEL = 9;
// 32kB is the maximum dictionary size supported by the zlib format.
$18ec31b3b0b8947a$var$ZLIBTextCompressor.MAX_DICTIONARY_SIZE = 31744; // 31 KB
module.exports.default = $18ec31b3b0b8947a$var$ZLIBTextCompressor;

});
parcelRegister("ckCqy", function(module, exports) {

$parcel$export(module.exports, "deflateRaw", () => $8fa5292818130bae$export$e95d6a8f69fb340a, (v) => $8fa5292818130bae$export$e95d6a8f69fb340a = v);
$parcel$export(module.exports, "inflateRaw", () => $8fa5292818130bae$export$d0f0aa2d05c905c5, (v) => $8fa5292818130bae$export$d0f0aa2d05c905c5 = v);
// Top level file is just a mixin of submodules & constants
var $8fa5292818130bae$export$ae157b6234afe138;
var $8fa5292818130bae$export$2316623ecd1285ab;
var $8fa5292818130bae$export$e95d6a8f69fb340a;
var $8fa5292818130bae$export$69f0ea7cf3a331a8;
var $8fa5292818130bae$export$d1de70a877d6e43c;
var $8fa5292818130bae$export$cae1ce83fe4a1782;
var $8fa5292818130bae$export$d0f0aa2d05c905c5;
var $8fa5292818130bae$export$95adf9d270383091;
var $8fa5292818130bae$export$1a988e7317c65621;
'use strict';

var $2wbN5 = parcelRequire("2wbN5");
var $8fa5292818130bae$require$Deflate = $2wbN5.Deflate;
var $8fa5292818130bae$require$deflate = $2wbN5.deflate;
var $8fa5292818130bae$require$deflateRaw = $2wbN5.deflateRaw;
var $8fa5292818130bae$require$gzip = $2wbN5.gzip;

var $3OYOJ = parcelRequire("3OYOJ");
var $8fa5292818130bae$require$Inflate = $3OYOJ.Inflate;
var $8fa5292818130bae$require$inflate = $3OYOJ.inflate;
var $8fa5292818130bae$require$inflateRaw = $3OYOJ.inflateRaw;
var $8fa5292818130bae$require$ungzip = $3OYOJ.ungzip;

var $hf4Xu = parcelRequire("hf4Xu");
$8fa5292818130bae$export$ae157b6234afe138 = $8fa5292818130bae$require$Deflate;
$8fa5292818130bae$export$2316623ecd1285ab = $8fa5292818130bae$require$deflate;
$8fa5292818130bae$export$e95d6a8f69fb340a = $8fa5292818130bae$require$deflateRaw;
$8fa5292818130bae$export$69f0ea7cf3a331a8 = $8fa5292818130bae$require$gzip;
$8fa5292818130bae$export$d1de70a877d6e43c = $8fa5292818130bae$require$Inflate;
$8fa5292818130bae$export$cae1ce83fe4a1782 = $8fa5292818130bae$require$inflate;
$8fa5292818130bae$export$d0f0aa2d05c905c5 = $8fa5292818130bae$require$inflateRaw;
$8fa5292818130bae$export$95adf9d270383091 = $8fa5292818130bae$require$ungzip;
$8fa5292818130bae$export$1a988e7317c65621 = $hf4Xu;

});
parcelRegister("2wbN5", function(module, exports) {

$parcel$export(module.exports, "Deflate", () => $1d57b756249bc6d3$export$ae157b6234afe138, (v) => $1d57b756249bc6d3$export$ae157b6234afe138 = v);
$parcel$export(module.exports, "deflate", () => $1d57b756249bc6d3$export$2316623ecd1285ab, (v) => $1d57b756249bc6d3$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateRaw", () => $1d57b756249bc6d3$export$e95d6a8f69fb340a, (v) => $1d57b756249bc6d3$export$e95d6a8f69fb340a = v);
$parcel$export(module.exports, "gzip", () => $1d57b756249bc6d3$export$69f0ea7cf3a331a8, (v) => $1d57b756249bc6d3$export$69f0ea7cf3a331a8 = v);
var $1d57b756249bc6d3$export$ae157b6234afe138;
var $1d57b756249bc6d3$export$2316623ecd1285ab;
var $1d57b756249bc6d3$export$e95d6a8f69fb340a;
var $1d57b756249bc6d3$export$69f0ea7cf3a331a8;
var $1d57b756249bc6d3$export$1a988e7317c65621;
'use strict';

var $lGf86 = parcelRequire("lGf86");

var $9CLQF = parcelRequire("9CLQF");

var $iC2HB = parcelRequire("iC2HB");

var $7gAmB = parcelRequire("7gAmB");

var $9WDto = parcelRequire("9WDto");
const $1d57b756249bc6d3$var$toString = Object.prototype.toString;

var $1d57b756249bc6d3$require$Z_NO_FLUSH = (parcelRequire("hf4Xu")).Z_NO_FLUSH;
var $1d57b756249bc6d3$require$Z_SYNC_FLUSH = (parcelRequire("hf4Xu")).Z_SYNC_FLUSH;
var $1d57b756249bc6d3$require$Z_FULL_FLUSH = (parcelRequire("hf4Xu")).Z_FULL_FLUSH;
var $1d57b756249bc6d3$require$Z_FINISH = (parcelRequire("hf4Xu")).Z_FINISH;
var $1d57b756249bc6d3$require$Z_OK = (parcelRequire("hf4Xu")).Z_OK;
var $1d57b756249bc6d3$require$Z_STREAM_END = (parcelRequire("hf4Xu")).Z_STREAM_END;
var $1d57b756249bc6d3$require$Z_DEFAULT_COMPRESSION = (parcelRequire("hf4Xu")).Z_DEFAULT_COMPRESSION;
var $1d57b756249bc6d3$require$Z_DEFAULT_STRATEGY = (parcelRequire("hf4Xu")).Z_DEFAULT_STRATEGY;
var $1d57b756249bc6d3$require$Z_DEFLATED = (parcelRequire("hf4Xu")).Z_DEFLATED;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $1d57b756249bc6d3$var$Deflate(options) {
    this.options = $9CLQF.assign({
        level: $1d57b756249bc6d3$require$Z_DEFAULT_COMPRESSION,
        method: $1d57b756249bc6d3$require$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $1d57b756249bc6d3$require$Z_DEFAULT_STRATEGY
    }, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9WDto();
    this.strm.avail_out = 0;
    let status = $lGf86.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $1d57b756249bc6d3$require$Z_OK) throw new Error($7gAmB[status]);
    if (opt.header) $lGf86.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $iC2HB.string2buf(opt.dictionary);
        else if ($1d57b756249bc6d3$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $lGf86.deflateSetDictionary(this.strm, dict);
        if (status !== $1d57b756249bc6d3$require$Z_OK) throw new Error($7gAmB[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $1d57b756249bc6d3$var$Deflate.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $1d57b756249bc6d3$require$Z_FINISH : $1d57b756249bc6d3$require$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $iC2HB.string2buf(data);
    else if ($1d57b756249bc6d3$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $1d57b756249bc6d3$require$Z_SYNC_FLUSH || _flush_mode === $1d57b756249bc6d3$require$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $lGf86.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $1d57b756249bc6d3$require$Z_STREAM_END) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $lGf86.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $1d57b756249bc6d3$require$Z_OK;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $1d57b756249bc6d3$require$Z_OK) this.result = $9CLQF.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $1d57b756249bc6d3$var$deflate(input, options) {
    const deflator = new $1d57b756249bc6d3$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $7gAmB[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $1d57b756249bc6d3$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $1d57b756249bc6d3$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
$1d57b756249bc6d3$export$ae157b6234afe138 = $1d57b756249bc6d3$var$Deflate;
$1d57b756249bc6d3$export$2316623ecd1285ab = $1d57b756249bc6d3$var$deflate;
$1d57b756249bc6d3$export$e95d6a8f69fb340a = $1d57b756249bc6d3$var$deflateRaw;
$1d57b756249bc6d3$export$69f0ea7cf3a331a8 = $1d57b756249bc6d3$var$gzip;

$1d57b756249bc6d3$export$1a988e7317c65621 = (parcelRequire("hf4Xu"));

});
parcelRegister("lGf86", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", () => $fc8941aa2060205a$export$a65c7b2bde87cb70, (v) => $fc8941aa2060205a$export$a65c7b2bde87cb70 = v);
$parcel$export(module.exports, "deflateSetHeader", () => $fc8941aa2060205a$export$1cd50f7b2515ba19, (v) => $fc8941aa2060205a$export$1cd50f7b2515ba19 = v);
$parcel$export(module.exports, "deflate", () => $fc8941aa2060205a$export$2316623ecd1285ab, (v) => $fc8941aa2060205a$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateEnd", () => $fc8941aa2060205a$export$599854fa319a815f, (v) => $fc8941aa2060205a$export$599854fa319a815f = v);
$parcel$export(module.exports, "deflateSetDictionary", () => $fc8941aa2060205a$export$f55e0b3ab66b5d46, (v) => $fc8941aa2060205a$export$f55e0b3ab66b5d46 = v);
var $fc8941aa2060205a$export$72b35d618fb8ad9b;
var $fc8941aa2060205a$export$a65c7b2bde87cb70;
var $fc8941aa2060205a$export$8f99f0e30bc7dd53;
var $fc8941aa2060205a$export$e78fab288549509;
var $fc8941aa2060205a$export$1cd50f7b2515ba19;
var $fc8941aa2060205a$export$2316623ecd1285ab;
var $fc8941aa2060205a$export$599854fa319a815f;
var $fc8941aa2060205a$export$f55e0b3ab66b5d46;
var $fc8941aa2060205a$export$12b6e1fcadea22f9;
'use strict';

var $hx6dX = parcelRequire("hx6dX");
var $fc8941aa2060205a$require$_tr_init = $hx6dX._tr_init;
var $fc8941aa2060205a$require$_tr_stored_block = $hx6dX._tr_stored_block;
var $fc8941aa2060205a$require$_tr_flush_block = $hx6dX._tr_flush_block;
var $fc8941aa2060205a$require$_tr_tally = $hx6dX._tr_tally;
var $fc8941aa2060205a$require$_tr_align = $hx6dX._tr_align;

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $7gAmB = parcelRequire("7gAmB");

var $hf4Xu = parcelRequire("hf4Xu");
var $fc8941aa2060205a$require$Z_NO_FLUSH = $hf4Xu.Z_NO_FLUSH;
var $fc8941aa2060205a$require$Z_PARTIAL_FLUSH = $hf4Xu.Z_PARTIAL_FLUSH;
var $fc8941aa2060205a$require$Z_FULL_FLUSH = $hf4Xu.Z_FULL_FLUSH;
var $fc8941aa2060205a$require$Z_FINISH = $hf4Xu.Z_FINISH;
var $fc8941aa2060205a$require$Z_BLOCK = $hf4Xu.Z_BLOCK;
var $fc8941aa2060205a$require$Z_OK = $hf4Xu.Z_OK;
var $fc8941aa2060205a$require$Z_STREAM_END = $hf4Xu.Z_STREAM_END;
var $fc8941aa2060205a$require$Z_STREAM_ERROR = $hf4Xu.Z_STREAM_ERROR;
var $fc8941aa2060205a$require$Z_DATA_ERROR = $hf4Xu.Z_DATA_ERROR;
var $fc8941aa2060205a$require$Z_BUF_ERROR = $hf4Xu.Z_BUF_ERROR;
var $fc8941aa2060205a$require$Z_DEFAULT_COMPRESSION = $hf4Xu.Z_DEFAULT_COMPRESSION;
var $fc8941aa2060205a$require$Z_FILTERED = $hf4Xu.Z_FILTERED;
var $fc8941aa2060205a$require$Z_HUFFMAN_ONLY = $hf4Xu.Z_HUFFMAN_ONLY;
var $fc8941aa2060205a$require$Z_RLE = $hf4Xu.Z_RLE;
var $fc8941aa2060205a$require$Z_FIXED = $hf4Xu.Z_FIXED;
var $fc8941aa2060205a$require$Z_DEFAULT_STRATEGY = $hf4Xu.Z_DEFAULT_STRATEGY;
var $fc8941aa2060205a$require$Z_UNKNOWN = $hf4Xu.Z_UNKNOWN;
var $fc8941aa2060205a$require$Z_DEFLATED = $hf4Xu.Z_DEFLATED;
/*============================================================================*/ const $fc8941aa2060205a$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $fc8941aa2060205a$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $fc8941aa2060205a$var$DEF_MEM_LEVEL = 8;
const $fc8941aa2060205a$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $fc8941aa2060205a$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $fc8941aa2060205a$var$L_CODES = $fc8941aa2060205a$var$LITERALS + 1 + $fc8941aa2060205a$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $fc8941aa2060205a$var$D_CODES = 30;
/* number of distance codes */ const $fc8941aa2060205a$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $fc8941aa2060205a$var$HEAP_SIZE = 2 * $fc8941aa2060205a$var$L_CODES + 1;
/* maximum heap size */ const $fc8941aa2060205a$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $fc8941aa2060205a$var$MIN_MATCH = 3;
const $fc8941aa2060205a$var$MAX_MATCH = 258;
const $fc8941aa2060205a$var$MIN_LOOKAHEAD = $fc8941aa2060205a$var$MAX_MATCH + $fc8941aa2060205a$var$MIN_MATCH + 1;
const $fc8941aa2060205a$var$PRESET_DICT = 0x20;
const $fc8941aa2060205a$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const $fc8941aa2060205a$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const $fc8941aa2060205a$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const $fc8941aa2060205a$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const $fc8941aa2060205a$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const $fc8941aa2060205a$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const $fc8941aa2060205a$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const $fc8941aa2060205a$var$FINISH_STATE = 666; /* stream complete */ 
const $fc8941aa2060205a$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $fc8941aa2060205a$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $fc8941aa2060205a$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $fc8941aa2060205a$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $fc8941aa2060205a$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $fc8941aa2060205a$var$err = (strm, errorCode)=>{
    strm.msg = $7gAmB[errorCode];
    return errorCode;
};
const $fc8941aa2060205a$var$rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const $fc8941aa2060205a$var$zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const $fc8941aa2060205a$var$slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let $fc8941aa2060205a$var$HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let $fc8941aa2060205a$var$HASH = $fc8941aa2060205a$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const $fc8941aa2060205a$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $fc8941aa2060205a$var$flush_block_only = (s, last)=>{
    $fc8941aa2060205a$require$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $fc8941aa2060205a$var$flush_pending(s.strm);
};
const $fc8941aa2060205a$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $fc8941aa2060205a$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $fc8941aa2060205a$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $gJUj4(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $5UMyJ(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $fc8941aa2060205a$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
        scan = strend - $fc8941aa2060205a$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $fc8941aa2060205a$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $fc8941aa2060205a$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $fc8941aa2060205a$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $fc8941aa2060205a$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $fc8941aa2060205a$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $fc8941aa2060205a$var$HASH(s, s.ins_h, s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $fc8941aa2060205a$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const $fc8941aa2060205a$var$deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $fc8941aa2060205a$require$Z_FINISH || flush === $fc8941aa2060205a$require$Z_NO_FLUSH || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $fc8941aa2060205a$require$Z_FINISH && len === left + s.strm.avail_in ? 1 : 0;
        $fc8941aa2060205a$require$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $fc8941aa2060205a$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $fc8941aa2060205a$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $fc8941aa2060205a$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $fc8941aa2060205a$require$Z_NO_FLUSH && flush !== $fc8941aa2060205a$require$Z_FINISH && s.strm.avail_in === 0 && s.strstart === s.block_start) return $fc8941aa2060205a$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $fc8941aa2060205a$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $fc8941aa2060205a$require$Z_FINISH) && flush !== $fc8941aa2060205a$require$Z_NO_FLUSH && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $fc8941aa2060205a$require$Z_FINISH && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $fc8941aa2060205a$require$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $fc8941aa2060205a$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $fc8941aa2060205a$var$BS_FINISH_STARTED : $fc8941aa2060205a$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $fc8941aa2060205a$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$require$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $fc8941aa2060205a$var$HASH(s, s.ins_h, s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
        if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $fc8941aa2060205a$require$_tr_tally(s, s.strstart - s.match_start, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $fc8941aa2060205a$var$HASH(s, s.ins_h, s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $fc8941aa2060205a$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $fc8941aa2060205a$require$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$require$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $fc8941aa2060205a$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$require$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $fc8941aa2060205a$var$HASH(s, s.ins_h, s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $fc8941aa2060205a$require$Z_FILTERED || s.match_length === $fc8941aa2060205a$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $fc8941aa2060205a$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $fc8941aa2060205a$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $fc8941aa2060205a$require$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $fc8941aa2060205a$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $fc8941aa2060205a$var$HASH(s, s.ins_h, s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $fc8941aa2060205a$require$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $fc8941aa2060205a$require$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$require$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $fc8941aa2060205a$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH && flush === $fc8941aa2060205a$require$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $fc8941aa2060205a$require$_tr_tally(s, 1, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $fc8941aa2060205a$require$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$require$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $fc8941aa2060205a$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $fc8941aa2060205a$require$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $fc8941aa2060205a$require$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$require$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $fc8941aa2060205a$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $fc8941aa2060205a$var$configuration_table = [
    /*      good lazy nice chain */ new $fc8941aa2060205a$var$Config(0, 0, 0, 0, $fc8941aa2060205a$var$deflate_stored),
    /* 0 store only */ new $fc8941aa2060205a$var$Config(4, 4, 8, 4, $fc8941aa2060205a$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $fc8941aa2060205a$var$Config(4, 5, 16, 8, $fc8941aa2060205a$var$deflate_fast),
    /* 2 */ new $fc8941aa2060205a$var$Config(4, 6, 32, 32, $fc8941aa2060205a$var$deflate_fast),
    /* 3 */ new $fc8941aa2060205a$var$Config(4, 4, 16, 16, $fc8941aa2060205a$var$deflate_slow),
    /* 4 lazy matches */ new $fc8941aa2060205a$var$Config(8, 16, 32, 32, $fc8941aa2060205a$var$deflate_slow),
    /* 5 */ new $fc8941aa2060205a$var$Config(8, 16, 128, 128, $fc8941aa2060205a$var$deflate_slow),
    /* 6 */ new $fc8941aa2060205a$var$Config(8, 32, 128, 256, $fc8941aa2060205a$var$deflate_slow),
    /* 7 */ new $fc8941aa2060205a$var$Config(32, 128, 258, 1024, $fc8941aa2060205a$var$deflate_slow),
    /* 8 */ new $fc8941aa2060205a$var$Config(32, 258, 258, 4096, $fc8941aa2060205a$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $fc8941aa2060205a$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $fc8941aa2060205a$var$configuration_table[s.level].max_lazy;
    s.good_match = $fc8941aa2060205a$var$configuration_table[s.level].good_length;
    s.nice_match = $fc8941aa2060205a$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $fc8941aa2060205a$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $fc8941aa2060205a$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $fc8941aa2060205a$require$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($fc8941aa2060205a$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $fc8941aa2060205a$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $fc8941aa2060205a$var$BL_CODES + 1) * 2);
    $fc8941aa2060205a$var$zero(this.dyn_ltree);
    $fc8941aa2060205a$var$zero(this.dyn_dtree);
    $fc8941aa2060205a$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($fc8941aa2060205a$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $fc8941aa2060205a$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $fc8941aa2060205a$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $fc8941aa2060205a$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $fc8941aa2060205a$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const $fc8941aa2060205a$var$deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== $fc8941aa2060205a$var$INIT_STATE && //#ifdef GZIP
    s.status !== $fc8941aa2060205a$var$GZIP_STATE && //#endif
    s.status !== $fc8941aa2060205a$var$EXTRA_STATE && s.status !== $fc8941aa2060205a$var$NAME_STATE && s.status !== $fc8941aa2060205a$var$COMMENT_STATE && s.status !== $fc8941aa2060205a$var$HCRC_STATE && s.status !== $fc8941aa2060205a$var$BUSY_STATE && s.status !== $fc8941aa2060205a$var$FINISH_STATE) return 1;
    return 0;
};
const $fc8941aa2060205a$var$deflateResetKeep = (strm)=>{
    if ($fc8941aa2060205a$var$deflateStateCheck(strm)) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$require$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $fc8941aa2060205a$require$Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $fc8941aa2060205a$var$GZIP_STATE : //#endif
    s.wrap ? $fc8941aa2060205a$var$INIT_STATE : $fc8941aa2060205a$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $fc8941aa2060205a$require$_tr_init(s);
    return $fc8941aa2060205a$require$Z_OK;
};
const $fc8941aa2060205a$var$deflateReset = (strm)=>{
    const ret = $fc8941aa2060205a$var$deflateResetKeep(strm);
    if (ret === $fc8941aa2060205a$require$Z_OK) $fc8941aa2060205a$var$lm_init(strm.state);
    return ret;
};
const $fc8941aa2060205a$var$deflateSetHeader = (strm, head)=>{
    if ($fc8941aa2060205a$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $fc8941aa2060205a$require$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $fc8941aa2060205a$require$Z_OK;
};
const $fc8941aa2060205a$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return $fc8941aa2060205a$require$Z_STREAM_ERROR;
    let wrap = 1;
    if (level === $fc8941aa2060205a$require$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $fc8941aa2060205a$var$MAX_MEM_LEVEL || method !== $fc8941aa2060205a$require$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $fc8941aa2060205a$require$Z_FIXED || windowBits === 8 && wrap !== 1) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$require$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $fc8941aa2060205a$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $fc8941aa2060205a$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $fc8941aa2060205a$var$MIN_MATCH - 1) / $fc8941aa2060205a$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $fc8941aa2060205a$var$deflateReset(strm);
};
const $fc8941aa2060205a$var$deflateInit = (strm, level)=>{
    return $fc8941aa2060205a$var$deflateInit2(strm, level, $fc8941aa2060205a$require$Z_DEFLATED, $fc8941aa2060205a$var$MAX_WBITS, $fc8941aa2060205a$var$DEF_MEM_LEVEL, $fc8941aa2060205a$require$Z_DEFAULT_STRATEGY);
};
/* ========================================================================= */ const $fc8941aa2060205a$var$deflate = (strm, flush)=>{
    if ($fc8941aa2060205a$var$deflateStateCheck(strm) || flush > $fc8941aa2060205a$require$Z_BLOCK || flush < 0) return strm ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$require$Z_STREAM_ERROR) : $fc8941aa2060205a$require$Z_STREAM_ERROR;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $fc8941aa2060205a$var$FINISH_STATE && flush !== $fc8941aa2060205a$require$Z_FINISH) return $fc8941aa2060205a$var$err(strm, strm.avail_out === 0 ? $fc8941aa2060205a$require$Z_BUF_ERROR : $fc8941aa2060205a$require$Z_STREAM_ERROR);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $fc8941aa2060205a$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $fc8941aa2060205a$require$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $fc8941aa2060205a$var$rank(flush) <= $fc8941aa2060205a$var$rank(old_flush) && flush !== $fc8941aa2060205a$require$Z_FINISH) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$require$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $fc8941aa2060205a$var$FINISH_STATE && strm.avail_in !== 0) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$require$Z_BUF_ERROR);
    /* Write the header */ if (s.status === $fc8941aa2060205a$var$INIT_STATE && s.wrap === 0) s.status = $fc8941aa2060205a$var$BUSY_STATE;
    if (s.status === $fc8941aa2060205a$var$INIT_STATE) {
        /* zlib header */ let header = $fc8941aa2060205a$require$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= $fc8941aa2060205a$require$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $fc8941aa2060205a$var$PRESET_DICT;
        header += 31 - header % 31;
        $fc8941aa2060205a$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
            $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $fc8941aa2060205a$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $fc8941aa2060205a$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $fc8941aa2060205a$require$Z_OK;
        }
    }
    //#ifdef GZIP
    if (s.status === $fc8941aa2060205a$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $fc8941aa2060205a$var$put_byte(s, 31);
        $fc8941aa2060205a$var$put_byte(s, 139);
        $fc8941aa2060205a$var$put_byte(s, 8);
        if (!s.gzhead) {
            $fc8941aa2060205a$var$put_byte(s, 0);
            $fc8941aa2060205a$var$put_byte(s, 0);
            $fc8941aa2060205a$var$put_byte(s, 0);
            $fc8941aa2060205a$var$put_byte(s, 0);
            $fc8941aa2060205a$var$put_byte(s, 0);
            $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$require$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $fc8941aa2060205a$var$put_byte(s, $fc8941aa2060205a$var$OS_CODE);
            s.status = $fc8941aa2060205a$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $fc8941aa2060205a$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $fc8941aa2060205a$require$Z_OK;
            }
        } else {
            $fc8941aa2060205a$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $fc8941aa2060205a$var$put_byte(s, s.gzhead.time & 0xff);
            $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$require$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $fc8941aa2060205a$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $fc8941aa2060205a$var$EXTRA_STATE;
        }
    }
    if (s.status === $fc8941aa2060205a$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $fc8941aa2060205a$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $fc8941aa2060205a$require$Z_OK;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $fc8941aa2060205a$var$NAME_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $fc8941aa2060205a$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $fc8941aa2060205a$require$Z_OK;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $fc8941aa2060205a$var$COMMENT_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $fc8941aa2060205a$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $fc8941aa2060205a$require$Z_OK;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = $fc8941aa2060205a$var$HCRC_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $fc8941aa2060205a$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $fc8941aa2060205a$require$Z_OK;
                }
            }
            $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
            $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $fc8941aa2060205a$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $fc8941aa2060205a$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $fc8941aa2060205a$require$Z_OK;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $fc8941aa2060205a$require$Z_NO_FLUSH && s.status !== $fc8941aa2060205a$var$FINISH_STATE) {
        let bstate = s.level === 0 ? $fc8941aa2060205a$var$deflate_stored(s, flush) : s.strategy === $fc8941aa2060205a$require$Z_HUFFMAN_ONLY ? $fc8941aa2060205a$var$deflate_huff(s, flush) : s.strategy === $fc8941aa2060205a$require$Z_RLE ? $fc8941aa2060205a$var$deflate_rle(s, flush) : $fc8941aa2060205a$var$configuration_table[s.level].func(s, flush);
        if (bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED || bstate === $fc8941aa2060205a$var$BS_FINISH_DONE) s.status = $fc8941aa2060205a$var$FINISH_STATE;
        if (bstate === $fc8941aa2060205a$var$BS_NEED_MORE || bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $fc8941aa2060205a$require$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $fc8941aa2060205a$var$BS_BLOCK_DONE) {
            if (flush === $fc8941aa2060205a$require$Z_PARTIAL_FLUSH) $fc8941aa2060205a$require$_tr_align(s);
            else if (flush !== $fc8941aa2060205a$require$Z_BLOCK) {
                $fc8941aa2060205a$require$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $fc8941aa2060205a$require$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $fc8941aa2060205a$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $fc8941aa2060205a$require$Z_OK;
            }
        }
    }
    if (flush !== $fc8941aa2060205a$require$Z_FINISH) return $fc8941aa2060205a$require$Z_OK;
    if (s.wrap <= 0) return $fc8941aa2060205a$require$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 24 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $fc8941aa2060205a$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $fc8941aa2060205a$require$Z_OK : $fc8941aa2060205a$require$Z_STREAM_END;
};
const $fc8941aa2060205a$var$deflateEnd = (strm)=>{
    if ($fc8941aa2060205a$var$deflateStateCheck(strm)) return $fc8941aa2060205a$require$Z_STREAM_ERROR;
    const status = strm.state.status;
    strm.state = null;
    return status === $fc8941aa2060205a$var$BUSY_STATE ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$require$Z_DATA_ERROR) : $fc8941aa2060205a$require$Z_OK;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $fc8941aa2060205a$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if ($fc8941aa2060205a$var$deflateStateCheck(strm)) return $fc8941aa2060205a$require$Z_STREAM_ERROR;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $fc8941aa2060205a$var$INIT_STATE || s.lookahead) return $fc8941aa2060205a$require$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $gJUj4(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $fc8941aa2060205a$var$fill_window(s);
    while(s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - ($fc8941aa2060205a$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $fc8941aa2060205a$var$HASH(s, s.ins_h, s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $fc8941aa2060205a$var$MIN_MATCH - 1;
        $fc8941aa2060205a$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $fc8941aa2060205a$require$Z_OK;
};
$fc8941aa2060205a$export$72b35d618fb8ad9b = $fc8941aa2060205a$var$deflateInit;
$fc8941aa2060205a$export$a65c7b2bde87cb70 = $fc8941aa2060205a$var$deflateInit2;
$fc8941aa2060205a$export$8f99f0e30bc7dd53 = $fc8941aa2060205a$var$deflateReset;
$fc8941aa2060205a$export$e78fab288549509 = $fc8941aa2060205a$var$deflateResetKeep;
$fc8941aa2060205a$export$1cd50f7b2515ba19 = $fc8941aa2060205a$var$deflateSetHeader;
$fc8941aa2060205a$export$2316623ecd1285ab = $fc8941aa2060205a$var$deflate;
$fc8941aa2060205a$export$599854fa319a815f = $fc8941aa2060205a$var$deflateEnd;
$fc8941aa2060205a$export$f55e0b3ab66b5d46 = $fc8941aa2060205a$var$deflateSetDictionary;
$fc8941aa2060205a$export$12b6e1fcadea22f9 = 'pako deflate (from Nodeca project)'; /* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("hx6dX", function(module, exports) {

$parcel$export(module.exports, "_tr_init", () => $cc3a58b664fcb155$export$4e4fc0157c3cd14d, (v) => $cc3a58b664fcb155$export$4e4fc0157c3cd14d = v);
$parcel$export(module.exports, "_tr_stored_block", () => $cc3a58b664fcb155$export$8959e34c5e020172, (v) => $cc3a58b664fcb155$export$8959e34c5e020172 = v);
$parcel$export(module.exports, "_tr_flush_block", () => $cc3a58b664fcb155$export$44f15b52eef0cf41, (v) => $cc3a58b664fcb155$export$44f15b52eef0cf41 = v);
$parcel$export(module.exports, "_tr_tally", () => $cc3a58b664fcb155$export$b3cbce147289408f, (v) => $cc3a58b664fcb155$export$b3cbce147289408f = v);
$parcel$export(module.exports, "_tr_align", () => $cc3a58b664fcb155$export$bfb360e02ee9b403, (v) => $cc3a58b664fcb155$export$bfb360e02ee9b403 = v);
var $cc3a58b664fcb155$export$4e4fc0157c3cd14d;
var $cc3a58b664fcb155$export$8959e34c5e020172;
var $cc3a58b664fcb155$export$44f15b52eef0cf41;
var $cc3a58b664fcb155$export$b3cbce147289408f;
var $cc3a58b664fcb155$export$bfb360e02ee9b403;
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $cc3a58b664fcb155$var$Z_FIXED = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $cc3a58b664fcb155$var$Z_BINARY = 0;
const $cc3a58b664fcb155$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $cc3a58b664fcb155$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $cc3a58b664fcb155$var$zero(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $cc3a58b664fcb155$var$STORED_BLOCK = 0;
const $cc3a58b664fcb155$var$STATIC_TREES = 1;
const $cc3a58b664fcb155$var$DYN_TREES = 2;
/* The three kinds of block type */ const $cc3a58b664fcb155$var$MIN_MATCH = 3;
const $cc3a58b664fcb155$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $cc3a58b664fcb155$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $cc3a58b664fcb155$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $cc3a58b664fcb155$var$L_CODES = $cc3a58b664fcb155$var$LITERALS + 1 + $cc3a58b664fcb155$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $cc3a58b664fcb155$var$D_CODES = 30;
/* number of distance codes */ const $cc3a58b664fcb155$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $cc3a58b664fcb155$var$HEAP_SIZE = 2 * $cc3a58b664fcb155$var$L_CODES + 1;
/* maximum heap size */ const $cc3a58b664fcb155$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $cc3a58b664fcb155$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $cc3a58b664fcb155$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $cc3a58b664fcb155$var$END_BLOCK = 256;
/* end of block literal code */ const $cc3a58b664fcb155$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $cc3a58b664fcb155$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $cc3a58b664fcb155$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $cc3a58b664fcb155$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $cc3a58b664fcb155$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $cc3a58b664fcb155$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $cc3a58b664fcb155$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $cc3a58b664fcb155$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $cc3a58b664fcb155$var$static_ltree = new Array(($cc3a58b664fcb155$var$L_CODES + 2) * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $cc3a58b664fcb155$var$static_dtree = new Array($cc3a58b664fcb155$var$D_CODES * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $cc3a58b664fcb155$var$_dist_code = new Array($cc3a58b664fcb155$var$DIST_CODE_LEN);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $cc3a58b664fcb155$var$_length_code = new Array($cc3a58b664fcb155$var$MAX_MATCH - $cc3a58b664fcb155$var$MIN_MATCH + 1);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $cc3a58b664fcb155$var$base_length = new Array($cc3a58b664fcb155$var$LENGTH_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $cc3a58b664fcb155$var$base_dist = new Array($cc3a58b664fcb155$var$D_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $cc3a58b664fcb155$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $cc3a58b664fcb155$var$static_l_desc;
let $cc3a58b664fcb155$var$static_d_desc;
let $cc3a58b664fcb155$var$static_bl_desc;
function $cc3a58b664fcb155$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $cc3a58b664fcb155$var$d_code = (dist)=>{
    return dist < 256 ? $cc3a58b664fcb155$var$_dist_code[dist] : $cc3a58b664fcb155$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $cc3a58b664fcb155$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $cc3a58b664fcb155$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $cc3a58b664fcb155$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $cc3a58b664fcb155$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $cc3a58b664fcb155$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $cc3a58b664fcb155$var$send_code = (s, c, tree)=>{
    $cc3a58b664fcb155$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $cc3a58b664fcb155$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $cc3a58b664fcb155$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $cc3a58b664fcb155$var$gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $cc3a58b664fcb155$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $cc3a58b664fcb155$var$gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array($cc3a58b664fcb155$var$MAX_BITS + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $cc3a58b664fcb155$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($cc3a58b664fcb155$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $cc3a58b664fcb155$var$LENGTH_CODES - 1; code++){
        $cc3a58b664fcb155$var$base_length[code] = length;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_lbits[code]; n++)$cc3a58b664fcb155$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $cc3a58b664fcb155$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code]; n++)$cc3a58b664fcb155$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $cc3a58b664fcb155$var$D_CODES; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code] - 7; n++)$cc3a58b664fcb155$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $cc3a58b664fcb155$var$gen_codes($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++){
        $cc3a58b664fcb155$var$static_dtree[n * 2 + 1] = 5;
        $cc3a58b664fcb155$var$static_dtree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $cc3a58b664fcb155$var$static_l_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$extra_lbits, $cc3a58b664fcb155$var$LITERALS + 1, $cc3a58b664fcb155$var$L_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_d_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_dtree, $cc3a58b664fcb155$var$extra_dbits, 0, $cc3a58b664fcb155$var$D_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_bl_desc = new $cc3a58b664fcb155$var$StaticTreeDesc(new Array(0), $cc3a58b664fcb155$var$extra_blbits, 0, $cc3a58b664fcb155$var$BL_CODES, $cc3a58b664fcb155$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $cc3a58b664fcb155$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $cc3a58b664fcb155$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$cc3a58b664fcb155$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $cc3a58b664fcb155$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $cc3a58b664fcb155$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $cc3a58b664fcb155$var$pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $cc3a58b664fcb155$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($cc3a58b664fcb155$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $cc3a58b664fcb155$var$compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $cc3a58b664fcb155$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $cc3a58b664fcb155$var$_length_code[lc];
            $cc3a58b664fcb155$var$send_code(s, code + $cc3a58b664fcb155$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $cc3a58b664fcb155$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $cc3a58b664fcb155$var$base_length[code];
                $cc3a58b664fcb155$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $cc3a58b664fcb155$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $cc3a58b664fcb155$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $cc3a58b664fcb155$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $cc3a58b664fcb155$var$base_dist[code];
                $cc3a58b664fcb155$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $cc3a58b664fcb155$var$build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $cc3a58b664fcb155$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$cc3a58b664fcb155$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $cc3a58b664fcb155$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $cc3a58b664fcb155$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $cc3a58b664fcb155$var$scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$cc3a58b664fcb155$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$cc3a58b664fcb155$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$cc3a58b664fcb155$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $cc3a58b664fcb155$var$send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REP_3_6, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_3_10, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 3);
        } else {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_11_138, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $cc3a58b664fcb155$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $cc3a58b664fcb155$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $cc3a58b664fcb155$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $cc3a58b664fcb155$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $cc3a58b664fcb155$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$cc3a58b664fcb155$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $cc3a58b664fcb155$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $cc3a58b664fcb155$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $cc3a58b664fcb155$var$send_bits(s, dcodes - 1, 5);
    $cc3a58b664fcb155$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $cc3a58b664fcb155$var$send_bits(s, s.bl_tree[$cc3a58b664fcb155$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $cc3a58b664fcb155$var$detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    for(n = 32; n < $cc3a58b664fcb155$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $cc3a58b664fcb155$var$Z_BINARY;
};
let $cc3a58b664fcb155$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $cc3a58b664fcb155$var$_tr_init = (s)=>{
    if (!$cc3a58b664fcb155$var$static_init_done) {
        $cc3a58b664fcb155$var$tr_static_init();
        $cc3a58b664fcb155$var$static_init_done = true;
    }
    s.l_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_ltree, $cc3a58b664fcb155$var$static_l_desc);
    s.d_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_dtree, $cc3a58b664fcb155$var$static_d_desc);
    s.bl_desc = new $cc3a58b664fcb155$var$TreeDesc(s.bl_tree, $cc3a58b664fcb155$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $cc3a58b664fcb155$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $cc3a58b664fcb155$var$_tr_stored_block = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $cc3a58b664fcb155$var$bi_windup(s); /* align on byte boundary */ 
    $cc3a58b664fcb155$var$put_short(s, stored_len);
    $cc3a58b664fcb155$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $cc3a58b664fcb155$var$_tr_align = (s)=>{
    $cc3a58b664fcb155$var$send_bits(s, $cc3a58b664fcb155$var$STATIC_TREES << 1, 3);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, $cc3a58b664fcb155$var$static_ltree);
    $cc3a58b664fcb155$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const $cc3a58b664fcb155$var$_tr_flush_block = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $cc3a58b664fcb155$var$Z_UNKNOWN) s.strm.data_type = $cc3a58b664fcb155$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $cc3a58b664fcb155$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $cc3a58b664fcb155$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $cc3a58b664fcb155$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $cc3a58b664fcb155$var$Z_FIXED || static_lenb === opt_lenb) {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$compress_block(s, $cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$static_dtree);
    } else {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $cc3a58b664fcb155$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $cc3a58b664fcb155$var$init_block(s);
    if (last) $cc3a58b664fcb155$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $cc3a58b664fcb155$var$_tr_tally = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($cc3a58b664fcb155$var$_length_code[lc] + $cc3a58b664fcb155$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$cc3a58b664fcb155$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
$cc3a58b664fcb155$export$4e4fc0157c3cd14d = $cc3a58b664fcb155$var$_tr_init;
$cc3a58b664fcb155$export$8959e34c5e020172 = $cc3a58b664fcb155$var$_tr_stored_block;
$cc3a58b664fcb155$export$44f15b52eef0cf41 = $cc3a58b664fcb155$var$_tr_flush_block;
$cc3a58b664fcb155$export$b3cbce147289408f = $cc3a58b664fcb155$var$_tr_tally;
$cc3a58b664fcb155$export$bfb360e02ee9b403 = $cc3a58b664fcb155$var$_tr_align;

});

parcelRegister("gJUj4", function(module, exports) {
'use strict';
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $c2fc869ba2d0859c$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
module.exports = $c2fc869ba2d0859c$var$adler32;

});

parcelRegister("5UMyJ", function(module, exports) {
'use strict';
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $44e7d98dd6723a9a$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $44e7d98dd6723a9a$var$crcTable = new Uint32Array($44e7d98dd6723a9a$var$makeTable());
const $44e7d98dd6723a9a$var$crc32 = (crc, buf, len, pos)=>{
    const t = $44e7d98dd6723a9a$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
module.exports = $44e7d98dd6723a9a$var$crc32;

});

parcelRegister("7gAmB", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};

});

parcelRegister("hf4Xu", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});


parcelRegister("9CLQF", function(module, exports) {

$parcel$export(module.exports, "assign", () => $701cc75d47025217$export$e6e34fd1f2686227, (v) => $701cc75d47025217$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "flattenChunks", () => $701cc75d47025217$export$fbdba6e30f60d6c7, (v) => $701cc75d47025217$export$fbdba6e30f60d6c7 = v);
var $701cc75d47025217$export$e6e34fd1f2686227;
// Join array of chunks to single array.
var $701cc75d47025217$export$fbdba6e30f60d6c7;
'use strict';
const $701cc75d47025217$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
$701cc75d47025217$export$e6e34fd1f2686227 = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(const p in source)if ($701cc75d47025217$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
$701cc75d47025217$export$fbdba6e30f60d6c7 = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};

});

parcelRegister("iC2HB", function(module, exports) {

$parcel$export(module.exports, "string2buf", () => $d8cddf31faab2448$export$7a4c1b2f775b5a9f, (v) => $d8cddf31faab2448$export$7a4c1b2f775b5a9f = v);
$parcel$export(module.exports, "buf2string", () => $d8cddf31faab2448$export$49a50563f377746, (v) => $d8cddf31faab2448$export$49a50563f377746 = v);
$parcel$export(module.exports, "utf8border", () => $d8cddf31faab2448$export$53dee3f58a714214, (v) => $d8cddf31faab2448$export$53dee3f58a714214 = v);
// String encode/decode helpers
// convert string to array (typed, when possible)
var $d8cddf31faab2448$export$7a4c1b2f775b5a9f;
// convert array to string
var $d8cddf31faab2448$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $d8cddf31faab2448$export$53dee3f58a714214;
'use strict';
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $d8cddf31faab2448$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $d8cddf31faab2448$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$d8cddf31faab2448$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$d8cddf31faab2448$var$_utf8len[254] = $d8cddf31faab2448$var$_utf8len[254] = 1; // Invalid sequence start
$d8cddf31faab2448$export$7a4c1b2f775b5a9f = (str)=>{
    if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $d8cddf31faab2448$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $d8cddf31faab2448$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = '';
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
$d8cddf31faab2448$export$49a50563f377746 = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $d8cddf31faab2448$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $d8cddf31faab2448$var$buf2binstring(utf16buf, out);
};
$d8cddf31faab2448$export$53dee3f58a714214 = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $d8cddf31faab2448$var$_utf8len[buf[pos]] > max ? pos : max;
};

});

parcelRegister("9WDto", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $73d8265e2c50d00b$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $73d8265e2c50d00b$var$ZStream;

});


parcelRegister("3OYOJ", function(module, exports) {

$parcel$export(module.exports, "Inflate", () => $2c8537a6b47169be$export$d1de70a877d6e43c, (v) => $2c8537a6b47169be$export$d1de70a877d6e43c = v);
$parcel$export(module.exports, "inflate", () => $2c8537a6b47169be$export$cae1ce83fe4a1782, (v) => $2c8537a6b47169be$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateRaw", () => $2c8537a6b47169be$export$d0f0aa2d05c905c5, (v) => $2c8537a6b47169be$export$d0f0aa2d05c905c5 = v);
$parcel$export(module.exports, "ungzip", () => $2c8537a6b47169be$export$95adf9d270383091, (v) => $2c8537a6b47169be$export$95adf9d270383091 = v);
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2c8537a6b47169be$export$d1de70a877d6e43c;
var $2c8537a6b47169be$export$cae1ce83fe4a1782;
var $2c8537a6b47169be$export$d0f0aa2d05c905c5;
var $2c8537a6b47169be$export$95adf9d270383091;
var $2c8537a6b47169be$export$1a988e7317c65621;
'use strict';

var $fzvBq = parcelRequire("fzvBq");

var $9CLQF = parcelRequire("9CLQF");

var $iC2HB = parcelRequire("iC2HB");

var $7gAmB = parcelRequire("7gAmB");

var $9WDto = parcelRequire("9WDto");

var $9t6AE = parcelRequire("9t6AE");
const $2c8537a6b47169be$var$toString = Object.prototype.toString;

var $2c8537a6b47169be$require$Z_NO_FLUSH = (parcelRequire("hf4Xu")).Z_NO_FLUSH;
var $2c8537a6b47169be$require$Z_FINISH = (parcelRequire("hf4Xu")).Z_FINISH;
var $2c8537a6b47169be$require$Z_OK = (parcelRequire("hf4Xu")).Z_OK;
var $2c8537a6b47169be$require$Z_STREAM_END = (parcelRequire("hf4Xu")).Z_STREAM_END;
var $2c8537a6b47169be$require$Z_NEED_DICT = (parcelRequire("hf4Xu")).Z_NEED_DICT;
var $2c8537a6b47169be$require$Z_STREAM_ERROR = (parcelRequire("hf4Xu")).Z_STREAM_ERROR;
var $2c8537a6b47169be$require$Z_DATA_ERROR = (parcelRequire("hf4Xu")).Z_DATA_ERROR;
var $2c8537a6b47169be$require$Z_MEM_ERROR = (parcelRequire("hf4Xu")).Z_MEM_ERROR;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2c8537a6b47169be$var$Inflate(options) {
    this.options = $9CLQF.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ''
    }, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9WDto();
    this.strm.avail_out = 0;
    let status = $fzvBq.inflateInit2(this.strm, opt.windowBits);
    if (status !== $2c8537a6b47169be$require$Z_OK) throw new Error($7gAmB[status]);
    this.header = new $9t6AE();
    $fzvBq.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $iC2HB.string2buf(opt.dictionary);
        else if ($2c8537a6b47169be$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $fzvBq.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $2c8537a6b47169be$require$Z_OK) throw new Error($7gAmB[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2c8537a6b47169be$var$Inflate.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $2c8537a6b47169be$require$Z_FINISH : $2c8537a6b47169be$require$Z_NO_FLUSH;
    // Convert data if needed
    if ($2c8537a6b47169be$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $fzvBq.inflate(strm, _flush_mode);
        if (status === $2c8537a6b47169be$require$Z_NEED_DICT && dictionary) {
            status = $fzvBq.inflateSetDictionary(strm, dictionary);
            if (status === $2c8537a6b47169be$require$Z_OK) status = $fzvBq.inflate(strm, _flush_mode);
            else if (status === $2c8537a6b47169be$require$Z_DATA_ERROR) // Replace code with more verbose
            status = $2c8537a6b47169be$require$Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $2c8537a6b47169be$require$Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $fzvBq.inflateReset(strm);
            status = $fzvBq.inflate(strm, _flush_mode);
        }
        switch(status){
            case $2c8537a6b47169be$require$Z_STREAM_ERROR:
            case $2c8537a6b47169be$require$Z_DATA_ERROR:
            case $2c8537a6b47169be$require$Z_NEED_DICT:
            case $2c8537a6b47169be$require$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $2c8537a6b47169be$require$Z_STREAM_END) {
                if (this.options.to === 'string') {
                    let next_out_utf8 = $iC2HB.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $iC2HB.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $2c8537a6b47169be$require$Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $2c8537a6b47169be$require$Z_STREAM_END) {
            status = $fzvBq.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $2c8537a6b47169be$require$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $9CLQF.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $2c8537a6b47169be$var$inflate(input, options) {
    const inflator = new $2c8537a6b47169be$var$Inflate(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $7gAmB[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2c8537a6b47169be$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $2c8537a6b47169be$var$inflate(input, options);
}
$2c8537a6b47169be$export$d1de70a877d6e43c = $2c8537a6b47169be$var$Inflate;
$2c8537a6b47169be$export$cae1ce83fe4a1782 = $2c8537a6b47169be$var$inflate;
$2c8537a6b47169be$export$d0f0aa2d05c905c5 = $2c8537a6b47169be$var$inflateRaw;
$2c8537a6b47169be$export$95adf9d270383091 = $2c8537a6b47169be$var$inflate;

$2c8537a6b47169be$export$1a988e7317c65621 = (parcelRequire("hf4Xu"));

});
parcelRegister("fzvBq", function(module, exports) {

$parcel$export(module.exports, "inflateReset", () => $b562a383a327bea1$export$42de45683a92ba94, (v) => $b562a383a327bea1$export$42de45683a92ba94 = v);
$parcel$export(module.exports, "inflateInit2", () => $b562a383a327bea1$export$6792d92addc5c8a0, (v) => $b562a383a327bea1$export$6792d92addc5c8a0 = v);
$parcel$export(module.exports, "inflate", () => $b562a383a327bea1$export$cae1ce83fe4a1782, (v) => $b562a383a327bea1$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateEnd", () => $b562a383a327bea1$export$224e1a443c3fba76, (v) => $b562a383a327bea1$export$224e1a443c3fba76 = v);
$parcel$export(module.exports, "inflateGetHeader", () => $b562a383a327bea1$export$6d4647cb9e1c75fc, (v) => $b562a383a327bea1$export$6d4647cb9e1c75fc = v);
$parcel$export(module.exports, "inflateSetDictionary", () => $b562a383a327bea1$export$60da749bed98ccf8, (v) => $b562a383a327bea1$export$60da749bed98ccf8 = v);
var $b562a383a327bea1$export$42de45683a92ba94;
var $b562a383a327bea1$export$7633ac2cd30f9650;
var $b562a383a327bea1$export$6710ea52c4ec9d6a;
var $b562a383a327bea1$export$9c140b25e26874f9;
var $b562a383a327bea1$export$6792d92addc5c8a0;
var $b562a383a327bea1$export$cae1ce83fe4a1782;
var $b562a383a327bea1$export$224e1a443c3fba76;
var $b562a383a327bea1$export$6d4647cb9e1c75fc;
var $b562a383a327bea1$export$60da749bed98ccf8;
var $b562a383a327bea1$export$220f6291ca35fd71;
'use strict';

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $6OFFF = parcelRequire("6OFFF");

var $bxjQM = parcelRequire("bxjQM");
const $b562a383a327bea1$var$CODES = 0;
const $b562a383a327bea1$var$LENS = 1;
const $b562a383a327bea1$var$DISTS = 2;

var $hf4Xu = parcelRequire("hf4Xu");
var $b562a383a327bea1$require$Z_FINISH = $hf4Xu.Z_FINISH;
var $b562a383a327bea1$require$Z_BLOCK = $hf4Xu.Z_BLOCK;
var $b562a383a327bea1$require$Z_TREES = $hf4Xu.Z_TREES;
var $b562a383a327bea1$require$Z_OK = $hf4Xu.Z_OK;
var $b562a383a327bea1$require$Z_STREAM_END = $hf4Xu.Z_STREAM_END;
var $b562a383a327bea1$require$Z_NEED_DICT = $hf4Xu.Z_NEED_DICT;
var $b562a383a327bea1$require$Z_STREAM_ERROR = $hf4Xu.Z_STREAM_ERROR;
var $b562a383a327bea1$require$Z_DATA_ERROR = $hf4Xu.Z_DATA_ERROR;
var $b562a383a327bea1$require$Z_MEM_ERROR = $hf4Xu.Z_MEM_ERROR;
var $b562a383a327bea1$require$Z_BUF_ERROR = $hf4Xu.Z_BUF_ERROR;
var $b562a383a327bea1$require$Z_DEFLATED = $hf4Xu.Z_DEFLATED;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $b562a383a327bea1$var$HEAD = 16180; /* i: waiting for magic header */ 
const $b562a383a327bea1$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const $b562a383a327bea1$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
const $b562a383a327bea1$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const $b562a383a327bea1$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const $b562a383a327bea1$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const $b562a383a327bea1$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const $b562a383a327bea1$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const $b562a383a327bea1$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const $b562a383a327bea1$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
const $b562a383a327bea1$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const $b562a383a327bea1$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const $b562a383a327bea1$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const $b562a383a327bea1$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const $b562a383a327bea1$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const $b562a383a327bea1$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const $b562a383a327bea1$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const $b562a383a327bea1$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
const $b562a383a327bea1$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const $b562a383a327bea1$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const $b562a383a327bea1$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
const $b562a383a327bea1$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
const $b562a383a327bea1$var$DIST = 16202; /* i: waiting for distance code */ 
const $b562a383a327bea1$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const $b562a383a327bea1$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
const $b562a383a327bea1$var$LIT = 16205; /* o: waiting for output space to write literal */ 
const $b562a383a327bea1$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
const $b562a383a327bea1$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const $b562a383a327bea1$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
const $b562a383a327bea1$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $b562a383a327bea1$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const $b562a383a327bea1$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $b562a383a327bea1$var$ENOUGH_LENS = 852;
const $b562a383a327bea1$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $b562a383a327bea1$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $b562a383a327bea1$var$DEF_WBITS = $b562a383a327bea1$var$MAX_WBITS;
const $b562a383a327bea1$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $b562a383a327bea1$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $b562a383a327bea1$var$inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < $b562a383a327bea1$var$HEAD || state.mode > $b562a383a327bea1$var$SYNC) return 1;
    return 0;
};
const $b562a383a327bea1$var$inflateResetKeep = (strm)=>{
    if ($b562a383a327bea1$var$inflateStateCheck(strm)) return $b562a383a327bea1$require$Z_STREAM_ERROR;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $b562a383a327bea1$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($b562a383a327bea1$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($b562a383a327bea1$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $b562a383a327bea1$require$Z_OK;
};
const $b562a383a327bea1$var$inflateReset = (strm)=>{
    if ($b562a383a327bea1$var$inflateStateCheck(strm)) return $b562a383a327bea1$require$Z_STREAM_ERROR;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $b562a383a327bea1$var$inflateResetKeep(strm);
};
const $b562a383a327bea1$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if ($b562a383a327bea1$var$inflateStateCheck(strm)) return $b562a383a327bea1$require$Z_STREAM_ERROR;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $b562a383a327bea1$require$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $b562a383a327bea1$var$inflateReset(strm);
};
const $b562a383a327bea1$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $b562a383a327bea1$require$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $b562a383a327bea1$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $b562a383a327bea1$var$HEAD; /* to pass state test in inflateReset2() */ 
    const ret = $b562a383a327bea1$var$inflateReset2(strm, windowBits);
    if (ret !== $b562a383a327bea1$require$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $b562a383a327bea1$var$inflateInit = (strm)=>{
    return $b562a383a327bea1$var$inflateInit2(strm, $b562a383a327bea1$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $b562a383a327bea1$var$virgin = true;
let $b562a383a327bea1$var$lenfix, $b562a383a327bea1$var$distfix; // We have no pointers in JS, so keep tables separate
const $b562a383a327bea1$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($b562a383a327bea1$var$virgin) {
        $b562a383a327bea1$var$lenfix = new Int32Array(512);
        $b562a383a327bea1$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, 288, $b562a383a327bea1$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $bxjQM($b562a383a327bea1$var$DISTS, state.lens, 0, 32, $b562a383a327bea1$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $b562a383a327bea1$var$virgin = false;
    }
    state.lencode = $b562a383a327bea1$var$lenfix;
    state.lenbits = 9;
    state.distcode = $b562a383a327bea1$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $b562a383a327bea1$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $b562a383a327bea1$var$inflate = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($b562a383a327bea1$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $b562a383a327bea1$require$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $b562a383a327bea1$var$TYPE) state.mode = $b562a383a327bea1$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $b562a383a327bea1$require$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $b562a383a327bea1$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $b562a383a327bea1$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $b562a383a327bea1$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $b562a383a327bea1$require$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $b562a383a327bea1$var$DICTID : $b562a383a327bea1$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $b562a383a327bea1$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $b562a383a327bea1$require$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$TIME;
        /* falls through */ case $b562a383a327bea1$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$OS;
        /* falls through */ case $b562a383a327bea1$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$EXLEN;
        /* falls through */ case $b562a383a327bea1$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $b562a383a327bea1$var$EXTRA;
        /* falls through */ case $b562a383a327bea1$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $5UMyJ(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $b562a383a327bea1$var$NAME;
        /* falls through */ case $b562a383a327bea1$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $b562a383a327bea1$var$COMMENT;
        /* falls through */ case $b562a383a327bea1$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $b562a383a327bea1$var$HCRC;
        /* falls through */ case $b562a383a327bea1$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $b562a383a327bea1$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$DICT;
        /* falls through */ case $b562a383a327bea1$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $b562a383a327bea1$require$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $b562a383a327bea1$var$TYPE;
        /* falls through */ case $b562a383a327bea1$var$TYPE:
            if (flush === $b562a383a327bea1$require$Z_BLOCK || flush === $b562a383a327bea1$require$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $b562a383a327bea1$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $b562a383a327bea1$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$LEN_; /* decode codes */ 
                    if (flush === $b562a383a327bea1$require$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $b562a383a327bea1$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $b562a383a327bea1$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$COPY_;
            if (flush === $b562a383a327bea1$require$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$COPY_:
            state.mode = $b562a383a327bea1$var$COPY;
        /* falls through */ case $b562a383a327bea1$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$LENLENS;
        /* falls through */ case $b562a383a327bea1$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$CODELENS;
        /* falls through */ case $b562a383a327bea1$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $b562a383a327bea1$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $b562a383a327bea1$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $bxjQM($b562a383a327bea1$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $b562a383a327bea1$var$LEN_;
            if (flush === $b562a383a327bea1$require$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$LEN_:
            state.mode = $b562a383a327bea1$var$LEN;
        /* falls through */ case $b562a383a327bea1$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $6OFFF(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $b562a383a327bea1$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $b562a383a327bea1$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $b562a383a327bea1$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$LENEXT;
        /* falls through */ case $b562a383a327bea1$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $b562a383a327bea1$var$DIST;
        /* falls through */ case $b562a383a327bea1$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$DISTEXT;
        /* falls through */ case $b562a383a327bea1$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $b562a383a327bea1$var$MATCH;
        /* falls through */ case $b562a383a327bea1$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, put - _out) : $gJUj4(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $b562a383a327bea1$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$LENGTH;
        /* falls through */ case $b562a383a327bea1$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$DONE;
        /* falls through */ case $b562a383a327bea1$var$DONE:
            ret = $b562a383a327bea1$require$Z_STREAM_END;
            break inf_leave;
        case $b562a383a327bea1$var$BAD:
            ret = $b562a383a327bea1$require$Z_DATA_ERROR;
            break inf_leave;
        case $b562a383a327bea1$var$MEM:
            return $b562a383a327bea1$require$Z_MEM_ERROR;
        case $b562a383a327bea1$var$SYNC:
        /* falls through */ default:
            return $b562a383a327bea1$require$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $b562a383a327bea1$var$BAD && (state.mode < $b562a383a327bea1$var$CHECK || flush !== $b562a383a327bea1$require$Z_FINISH)) {
        if ($b562a383a327bea1$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $b562a383a327bea1$var$MEM;
            return $b562a383a327bea1$require$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, strm.next_out - _out) : $gJUj4(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $b562a383a327bea1$var$TYPE ? 128 : 0) + (state.mode === $b562a383a327bea1$var$LEN_ || state.mode === $b562a383a327bea1$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $b562a383a327bea1$require$Z_FINISH) && ret === $b562a383a327bea1$require$Z_OK) ret = $b562a383a327bea1$require$Z_BUF_ERROR;
    return ret;
};
const $b562a383a327bea1$var$inflateEnd = (strm)=>{
    if ($b562a383a327bea1$var$inflateStateCheck(strm)) return $b562a383a327bea1$require$Z_STREAM_ERROR;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $b562a383a327bea1$require$Z_OK;
};
const $b562a383a327bea1$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if ($b562a383a327bea1$var$inflateStateCheck(strm)) return $b562a383a327bea1$require$Z_STREAM_ERROR;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $b562a383a327bea1$require$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $b562a383a327bea1$require$Z_OK;
};
const $b562a383a327bea1$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if ($b562a383a327bea1$var$inflateStateCheck(strm)) return $b562a383a327bea1$require$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $b562a383a327bea1$var$DICT) return $b562a383a327bea1$require$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $b562a383a327bea1$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $gJUj4(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $b562a383a327bea1$require$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $b562a383a327bea1$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $b562a383a327bea1$var$MEM;
        return $b562a383a327bea1$require$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $b562a383a327bea1$require$Z_OK;
};
$b562a383a327bea1$export$42de45683a92ba94 = $b562a383a327bea1$var$inflateReset;
$b562a383a327bea1$export$7633ac2cd30f9650 = $b562a383a327bea1$var$inflateReset2;
$b562a383a327bea1$export$6710ea52c4ec9d6a = $b562a383a327bea1$var$inflateResetKeep;
$b562a383a327bea1$export$9c140b25e26874f9 = $b562a383a327bea1$var$inflateInit;
$b562a383a327bea1$export$6792d92addc5c8a0 = $b562a383a327bea1$var$inflateInit2;
$b562a383a327bea1$export$cae1ce83fe4a1782 = $b562a383a327bea1$var$inflate;
$b562a383a327bea1$export$224e1a443c3fba76 = $b562a383a327bea1$var$inflateEnd;
$b562a383a327bea1$export$6d4647cb9e1c75fc = $b562a383a327bea1$var$inflateGetHeader;
$b562a383a327bea1$export$60da749bed98ccf8 = $b562a383a327bea1$var$inflateSetDictionary;
$b562a383a327bea1$export$220f6291ca35fd71 = 'pako inflate (from Nodeca project)'; /* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ 

});
parcelRegister("6OFFF", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $4f67bc996330e695$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $4f67bc996330e695$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $4f67bc996330e695$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $4f67bc996330e695$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $4f67bc996330e695$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $4f67bc996330e695$var$TYPE;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $4f67bc996330e695$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("bxjQM", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $86622ca50c32b2ec$var$MAXBITS = 15;
const $86622ca50c32b2ec$var$ENOUGH_LENS = 852;
const $86622ca50c32b2ec$var$ENOUGH_DISTS = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $86622ca50c32b2ec$var$CODES = 0;
const $86622ca50c32b2ec$var$LENS = 1;
const $86622ca50c32b2ec$var$DISTS = 2;
const $86622ca50c32b2ec$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $86622ca50c32b2ec$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const $86622ca50c32b2ec$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $86622ca50c32b2ec$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $86622ca50c32b2ec$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $86622ca50c32b2ec$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $86622ca50c32b2ec$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $86622ca50c32b2ec$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $86622ca50c32b2ec$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $86622ca50c32b2ec$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $86622ca50c32b2ec$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $86622ca50c32b2ec$var$LENS) {
        base = $86622ca50c32b2ec$var$lbase;
        extra = $86622ca50c32b2ec$var$lext;
        match = 257;
    } else {
        base = $86622ca50c32b2ec$var$dbase;
        extra = $86622ca50c32b2ec$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
module.exports = $86622ca50c32b2ec$var$inflate_table;

});


parcelRegister("9t6AE", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $6e4bef2851e6b301$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
module.exports = $6e4bef2851e6b301$var$GZheader;

});




parcelRegister("3orkO", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $2788d110bbab46da$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VideoPreferences = module.exports.MutableVideoPreferences = void 0;
module.exports.convertVideoPreferencesToSignalingClientVideoSubscriptionConfiguration = $2788d110bbab46da$var$convertVideoPreferencesToSignalingClientVideoSubscriptionConfiguration;

const $2788d110bbab46da$var$SignalingClientVideoSubscriptionConfiguration_1 = $2788d110bbab46da$var$__importDefault((parcelRequire("ei9ii")));
function $2788d110bbab46da$var$convertVideoPreferencesToSignalingClientVideoSubscriptionConfiguration(context, receiveGroupIds, preferences) {
    if (context.transceiverController.getMidForGroupId === undefined || context.videoStreamIndex.attendeeIdForGroupId === undefined || preferences === undefined) return [];
    const configurations = new Array();
    const attendeeIdToMid = new Map();
    const attendeeIdToGroupId = new Map();
    for (const groupId of receiveGroupIds){
        // The local description will have been set by the time this task is running, so all
        // of the transceivers should have `mid` set by now (see comment above `getMidForStreamId`)
        const mid = context.transceiverController.getMidForGroupId(groupId);
        if (mid === undefined) continue;
        const attendeeId = context.videoStreamIndex.attendeeIdForGroupId(groupId);
        attendeeIdToMid.set(attendeeId, mid);
        attendeeIdToGroupId.set(attendeeId, groupId);
    }
    for (const preference of preferences){
        const configuration = new $2788d110bbab46da$var$SignalingClientVideoSubscriptionConfiguration_1.default();
        const mid = attendeeIdToMid.get(preference.attendeeId);
        if (mid === undefined) continue;
        configuration.mid = mid;
        configuration.attendeeId = preference.attendeeId;
        configuration.groupId = attendeeIdToGroupId.get(preference.attendeeId);
        /* istanbul ignore if */ if (configuration.groupId === undefined) continue;
        // The signaling protocol expects 'higher' values for 'higher' priorities
        configuration.priority = Number.MAX_SAFE_INTEGER - preference.priority;
        configuration.targetBitrateKbps = preference.targetSizeToBitrateKbps(preference.targetSize);
        configuration.qualityAdaptationPreference = preference.degradationPreference;
        configurations.push(configuration);
    }
    return configurations;
}
class $2788d110bbab46da$var$ObjectSet {
    constructor(items = []){
        this.items = items;
    }
    static default() {
        return new $2788d110bbab46da$var$ObjectSet([]);
    }
    // Returns the items in sorted order.
    [Symbol.iterator]() {
        let i = 0;
        const items = this.items;
        return {
            next () {
                if (i < items.length) return {
                    done: false,
                    value: items[i++]
                };
                return {
                    done: true,
                    value: null
                };
            }
        };
    }
    first() {
        return this.items[0];
    }
    add(item) {
        // If this is used elsewhere, there needs to be a duplicate check here
        this.items.push(item);
    }
    replaceFirst(newItem, f) {
        const pos = this.items.findIndex(f);
        if (pos === -1) // If this is used elsewhere, there needs to be a duplicate check here
        this.items.push(newItem);
        else if (!this.has(newItem)) this.items[pos] = newItem;
        else this.items.splice(pos, 1);
    }
    remove(item) {
        this.items = this.items.filter((a)=>!a.equals(item));
    }
    clear() {
        this.items = [];
    }
    isEmpty() {
        return this.items.length === 0;
    }
    equals(other) {
        if (other === this) return true;
        if (other.items.length !== this.items.length) return false;
        // TODO: if we keep the arrays sorted correctly, not just by priority, then
        // we don't need to do this painstaking O(n^2) work.
        for (const item of this.items){
            if (!other.items.some((a)=>a.equals(item))) return false;
        }
        return true;
    }
    has(item) {
        return this.items.some((a)=>a.equals(item));
    }
    some(f) {
        return this.items.some(f);
    }
    clone() {
        return new $2788d110bbab46da$var$ObjectSet([
            ...this.items
        ]);
    }
    sort() {
        this.items.sort((a, b)=>a.partialCompare(b));
    }
    modify() {
        // COW.
        return new $2788d110bbab46da$var$SetBuilder(this);
    }
}
class $2788d110bbab46da$var$SetBuilder {
    constructor(items = new $2788d110bbab46da$var$ObjectSet()){
        this.items = items;
        this.copied = false;
    }
    cow() {
        if (this.copied) return;
        this.items = this.items.clone();
        this.copied = true;
    }
    add(item) {
        // Don't actually need to COW unless the item is there to add.
        if (this.items.has(item)) return;
        this.cow();
        this.items.add(item);
    }
    replaceFirst(newItem, f) {
        // Don't actually need to COW unless the item is already there
        // and there are no items to replace
        if (this.items.has(newItem) && !this.items.some(f)) return;
        this.cow();
        this.items.replaceFirst(newItem, f);
    }
    remove(item) {
        // Don't actually need to COW unless the item is there to remove.
        if (!this.items.has(item)) return;
        this.cow();
        this.items.remove(item);
    }
    some(f) {
        return this.items.some(f);
    }
    clear() {
        if (this.items.isEmpty()) return;
        this.cow();
        this.items.clear();
    }
    build() {
        // Immutable sets are always kept sorted!
        if (this.copied) this.items.sort();
        this.copied = false;
        return this.items;
    }
}
class $2788d110bbab46da$var$MutableVideoPreferences {
    constructor(builder){
        this.builder = builder;
    }
    add(pref) {
        this.builder.add(pref);
    }
    replaceFirst(newPref, f) {
        this.builder.replaceFirst(newPref, f);
    }
    remove(pref) {
        this.builder.remove(pref);
    }
    some(f) {
        return this.builder.some(f);
    }
    clear() {
        this.builder.clear();
    }
    build() {
        return new $2788d110bbab46da$var$VideoPreferences(this.builder.build());
    }
}
module.exports.MutableVideoPreferences = $2788d110bbab46da$var$MutableVideoPreferences;
class $2788d110bbab46da$var$VideoPreferences {
    static prepare() {
        return new $2788d110bbab46da$var$MutableVideoPreferences(new $2788d110bbab46da$var$SetBuilder());
    }
    static default() {
        return new $2788d110bbab46da$var$VideoPreferences($2788d110bbab46da$var$ObjectSet.default());
    }
    /** @internal */ constructor(items){
        this.items = items;
    }
    [Symbol.iterator]() {
        return this.items[Symbol.iterator]();
    }
    highestPriority() {
        var _a;
        return (_a = this.items.first()) === null || _a === void 0 ? void 0 : _a.priority;
    }
    // Our items happen to always be sorted!
    sorted() {
        return this.items[Symbol.iterator]();
    }
    equals(other) {
        return other === this || this.items.equals(other.items);
    }
    modify() {
        return new $2788d110bbab46da$var$MutableVideoPreferences(this.items.modify());
    }
    some(f) {
        return this.items.some(f);
    }
    isEmpty() {
        return this.items.isEmpty();
    }
    clone() {
        const videoPreferences = $2788d110bbab46da$var$VideoPreferences.prepare();
        for (const preference of this.items)videoPreferences.add(preference.clone());
        return videoPreferences.build();
    }
}
module.exports.VideoPreferences = $2788d110bbab46da$var$VideoPreferences;
module.exports.default = $2788d110bbab46da$var$VideoPreferences;

});


parcelRegister("arfyn", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetDisplaySize = void 0;
/**
 * [[TargetDisplaySize]] represents the max resolution that a video stream can have when simulcast is enabled in priority based downlink policy.
 * If there is only one stream being sent, then this field will get ignored.  Its values currently parallel [[SimulcastLayers]].
 */ var $79987d96a60d1991$var$TargetDisplaySize;
(function(TargetDisplaySize) {
    /**
     * Low resolution video stream.
     */ TargetDisplaySize[TargetDisplaySize["Low"] = 0] = "Low";
    /**
     * Medium resolution video stream.
     */ TargetDisplaySize[TargetDisplaySize["Medium"] = 1] = "Medium";
    /**
     * High resolution video stream.
     */ TargetDisplaySize[TargetDisplaySize["High"] = 2] = "High";
    /**
     * Maximum resolution video stream.
     */ TargetDisplaySize[TargetDisplaySize["Maximum"] = 3] = "Maximum";
})($79987d96a60d1991$var$TargetDisplaySize || (module.exports.TargetDisplaySize = $79987d96a60d1991$var$TargetDisplaySize = {}));
module.exports.default = $79987d96a60d1991$var$TargetDisplaySize;

});

parcelRegister("5BsUR", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $4146d690e8dceeda$var$TranscriptAlternative {
}
module.exports.default = $4146d690e8dceeda$var$TranscriptAlternative;

});

parcelRegister("fRF88", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/*
* When redacting personally identifiable information (PII) from a streaming transcription, Amazon Transcribe replaces each identified instance of PII with [PII] in your transcript.
* An additional option available for streaming audio is PII identification.
* When you activate PII Identification, Amazon Transcribe labels the PII in your transcription results under an Entities object.
* PII identification and redaction for streaming jobs is performed only upon complete transcription of the audio segments.
* category refers to whether the entity is a PII or PHI data.
* confidence refers to the confidence that the speech it flagged for redaction/identification is truly PII. Confidence value ranges from 0 to 1 inclusive.
* type refers to the type of PII/PHI data that is identified. The current supported type values are: BANK_ACCOUNT_NUMBER, BANK_ROUTING, CREDIT_DEBIT_NUMBER, CREDIT_DEBIT_CVV, CREDIT_DEBIT_EXPIRY, PIN, EMAIL, ADDRESS, NAME, PHONE, SSN.
* type is only available in case of engine transcribe and not in medical transcribe
* type can be expected to change and grow as Transcribe evolves
* endTimeMs and startTimeMs are epoch timestamps in milliseconds
* Sample Redacted PII Data would look similar to this :
* "Entities": [
                {
                    "Content": "[NAME]",
                    "Category": "PII",
                    "Type": "NAME",
                    "StartTime" : 1636493289421,
                    "EndTime" : 1636493290016,
                    "Confidence": 0.9989
                }
            ]
* Sample PII Identified data would look similar to this :
* "Entities": [
                {
                    "Content": "janet smithy",
                    "Category": "PII",
                    "Type": "NAME",
                    "StartTime" : 1636493289421,
                    "EndTime" : 1636493290016,
                    "Confidence": 0.9989
                }
              ]
*/ class $b8cbb5d93a5c811c$var$TranscriptEntity {
}
module.exports.default = $b8cbb5d93a5c811c$var$TranscriptEntity;

});

parcelRegister("gzZnP", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $c11f87b27d9d18df$var$TranscriptItem {
}
module.exports.default = $c11f87b27d9d18df$var$TranscriptItem;

});

parcelRegister("k3aEM", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/*
* When using automatic language identification for streaming transcription,
* Amazon Transcribe provides the language codes of the identified languages and their associated confidence scores.
* languageCode refers to one of language code from the set of languageOptions provided during start transcription call
* score refers to the confidence score is a value between zero and one; a larger value indicates a higher confidence in the identified language.
* Sample LanguageWithScore would look similar to this :
* "LanguageIdentification": [
                {
                    "LanguageCode": "en-US",
                    "Score": 0.805
                },
                {
                    "LanguageCode": "ja-JP",
                    "Score": 0.195
                }
            ]
*/ class $e98c5aa63bcb3144$var$TranscriptLanguageWithScore {
}
module.exports.default = $e98c5aa63bcb3144$var$TranscriptLanguageWithScore;

});

parcelRegister("kMOij", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $f21f4dbb7adfcd96$var$TranscriptResult {
}
module.exports.default = $f21f4dbb7adfcd96$var$TranscriptResult;

});

parcelRegister("b9KFX", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $81f4bdc8bae6160f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $81f4bdc8bae6160f$var$ContentShareConstants_1 = $81f4bdc8bae6160f$var$__importDefault((parcelRequire("g6nnJ")));

const $81f4bdc8bae6160f$var$ServerSideNetworkAdaption_1 = $81f4bdc8bae6160f$var$__importDefault((parcelRequire("bRvcN")));

const $81f4bdc8bae6160f$var$VideoPreference_1 = $81f4bdc8bae6160f$var$__importDefault((parcelRequire("etFBX")));

var $3orkO = parcelRequire("3orkO");

const $81f4bdc8bae6160f$var$VideoPriorityBasedPolicy_1 = $81f4bdc8bae6160f$var$__importDefault((parcelRequire("i3DJs")));

const $81f4bdc8bae6160f$var$VideoPriorityBasedPolicyConfig_1 = $81f4bdc8bae6160f$var$__importDefault((parcelRequire("lcZ1l")));
/**
 * [[VideoAdaptiveProbePolicy]] wraps [[VideoPriorityBasedPolicy]] with customized behavior to automatically
 * assign a high preference to content share. This is a legacy policy used by default when simulcast is enabled, but
 * all customers should be using `VideoPriorityBasedPolicy` instead, since this policy does not work with
 * server side network adaptation.
 *
 * You can imitate this classes behavior using the `VideoPriorityBasedPolicy` with the following snippet
 * ```
 *   remoteVideoSourcesDidChange(videoSources: VideoSource[]) {
 *     const videoPreferences = VideoPreferences.prepare();
 *     for(const source of videoSources) {
 *        const isContent = source.attendee.attendeeId.endsWith(ContentShareConstants.Modality);
 *        videoPreferences.add(new VideoPreference(source.attendee.attendeeId, isContent ? 2: 1, TargetDisplaySize.High));
 *     }
 *     this.priorityBasedDownlinkPolicy.chooseRemoteVideoSources(videoPreferences.build());
 *   }
 * ```
 */ class $81f4bdc8bae6160f$var$VideoAdaptiveProbePolicy extends $81f4bdc8bae6160f$var$VideoPriorityBasedPolicy_1.default {
    static createConfig() {
        const config = new $81f4bdc8bae6160f$var$VideoPriorityBasedPolicyConfig_1.default();
        config.serverSideNetworkAdaption = $81f4bdc8bae6160f$var$ServerSideNetworkAdaption_1.default.None;
        return config;
    }
    constructor(logger){
        // We use a static function to create config because Typescript requires
        // super(...) calls to be the first line in constructors
        super(logger, $81f4bdc8bae6160f$var$VideoAdaptiveProbePolicy.createConfig());
        this.logger = logger;
        this.shouldPauseTiles = false;
        this.videoPreferences = undefined;
    }
    reset() {
        super.reset();
        this.shouldPauseTiles = false;
        this.videoPreferences = undefined;
    }
    updateIndex(videoIndex) {
        super.updateIndex(videoIndex);
        const newPreferences = $3orkO.VideoPreferences.prepare();
        let containsContent = false;
        const remoteInfos = videoIndex.remoteStreamDescriptions();
        // If there is active content then set that as high priority, and the rest at lower
        for (const info of remoteInfos)// I don't know why we need to do this duplicate check.
        if (!newPreferences.some((preference)=>preference.attendeeId === info.attendeeId)) {
            // For now always subscribe to content even if higher bandwidth then target
            if (info.attendeeId.endsWith($81f4bdc8bae6160f$var$ContentShareConstants_1.default.Modality)) {
                newPreferences.add(new $81f4bdc8bae6160f$var$VideoPreference_1.default(info.attendeeId, 1));
                containsContent = true;
            } else newPreferences.add(new $81f4bdc8bae6160f$var$VideoPreference_1.default(info.attendeeId, 2));
        }
        if (containsContent) {
            this.videoPreferences = newPreferences.build();
            this.videoPreferencesUpdated = true;
        } else this.videoPreferences = undefined;
    }
    /**
     * [[VideoAdaptiveProbePolicy]] does not allow setting video preferences and this function
     * will be a no-op.  Please use [[VideoPriorityBasedPolicy]] directly if you would like to set
     * preferences.
     */ chooseRemoteVideoSources(_preferences) {
        this.logger.error('chooseRemoteVideoSources should not be called by VideoAdaptiveProbePolicy');
        return;
    }
}
module.exports.default = $81f4bdc8bae6160f$var$VideoAdaptiveProbePolicy;

});
parcelRegister("etFBX", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $a8a40d3d6f1c75cf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $a8a40d3d6f1c75cf$var$TargetDisplaySize_1 = $a8a40d3d6f1c75cf$var$__importDefault((parcelRequire("arfyn")));

const $a8a40d3d6f1c75cf$var$VideoQualityAdaptationPreference_1 = $a8a40d3d6f1c75cf$var$__importDefault((parcelRequire("lGCbE")));
class $a8a40d3d6f1c75cf$var$VideoPreference {
    /** Initializes a [[VideoPreference]] with the given properties.
     *
     * @param attendeeId Attendee ID of the client
     * @param priority The relative priority of this attendee against others.
     * @param targetSize The desired maximum simulcast layers to receive.
     * @param degradationPreference The preference on how to select between resolution and framerate on network constraint
     */ constructor(attendeeId, priority, targetSize, degradationPreference){
        this.attendeeId = attendeeId;
        this.priority = priority;
        this.targetSize = targetSize !== undefined ? targetSize : $a8a40d3d6f1c75cf$var$TargetDisplaySize_1.default.Maximum;
        this.degradationPreference = degradationPreference !== undefined ? degradationPreference : $a8a40d3d6f1c75cf$var$VideoQualityAdaptationPreference_1.default.Balanced;
    }
    partialCompare(other) {
        return this.priority - other.priority;
    }
    equals(other) {
        return this.attendeeId === other.attendeeId && this.targetSize === other.targetSize && this.priority === other.priority && this.degradationPreference === other.degradationPreference;
    }
    clone() {
        return new $a8a40d3d6f1c75cf$var$VideoPreference(this.attendeeId, this.priority, this.targetSize, this.degradationPreference);
    }
    targetSizeToBitrateKbps(targetSize) {
        switch(targetSize){
            case $a8a40d3d6f1c75cf$var$TargetDisplaySize_1.default.Maximum:
                return $a8a40d3d6f1c75cf$var$VideoPreference.MAXIMUM_BITRATE_KBPS;
            case $a8a40d3d6f1c75cf$var$TargetDisplaySize_1.default.High:
                return $a8a40d3d6f1c75cf$var$VideoPreference.HIGH_BITRATE_KBPS;
            case $a8a40d3d6f1c75cf$var$TargetDisplaySize_1.default.Medium:
                return $a8a40d3d6f1c75cf$var$VideoPreference.MID_BITRATE_KBPS;
            case $a8a40d3d6f1c75cf$var$TargetDisplaySize_1.default.Low:
                return $a8a40d3d6f1c75cf$var$VideoPreference.LOW_BITRATE_KBPS;
        }
    }
}
$a8a40d3d6f1c75cf$var$VideoPreference.LOW_BITRATE_KBPS = 300;
$a8a40d3d6f1c75cf$var$VideoPreference.MID_BITRATE_KBPS = 600;
$a8a40d3d6f1c75cf$var$VideoPreference.HIGH_BITRATE_KBPS = 1500;
$a8a40d3d6f1c75cf$var$VideoPreference.MAXIMUM_BITRATE_KBPS = 10000;
module.exports.default = $a8a40d3d6f1c75cf$var$VideoPreference;

});

parcelRegister("i3DJs", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $d25753c9fcfe205f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d25753c9fcfe205f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d25753c9fcfe205f$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $d25753c9fcfe205f$var$__createBinding(result, mod, k[i]);
        }
        $d25753c9fcfe205f$var$__setModuleDefault(result, mod);
        return result;
    };
}();
var $d25753c9fcfe205f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $d25753c9fcfe205f$var$Attendee_1 = $d25753c9fcfe205f$var$__importDefault((parcelRequire("brRyw")));

const $d25753c9fcfe205f$var$ClientMetricReportDirection_1 = $d25753c9fcfe205f$var$__importDefault((parcelRequire("hRU3k")));

const $d25753c9fcfe205f$var$ClientMetricReportMediaType_1 = $d25753c9fcfe205f$var$__importDefault((parcelRequire("aU8Oy")));

const $d25753c9fcfe205f$var$ContentShareConstants_1 = $d25753c9fcfe205f$var$__importDefault((parcelRequire("g6nnJ")));

var $aSYjG = parcelRequire("aSYjG");

const $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1 = $d25753c9fcfe205f$var$__importStar((parcelRequire("bRvcN")));

const $d25753c9fcfe205f$var$VideoSource_1 = $d25753c9fcfe205f$var$__importDefault((parcelRequire("dGcvr")));

const $d25753c9fcfe205f$var$DefaultVideoStreamIdSet_1 = $d25753c9fcfe205f$var$__importDefault((parcelRequire("gVZQM")));

const $d25753c9fcfe205f$var$AllHighestVideoBandwidthPolicy_1 = $d25753c9fcfe205f$var$__importDefault((parcelRequire("loTax")));

const $d25753c9fcfe205f$var$TargetDisplaySize_1 = $d25753c9fcfe205f$var$__importDefault((parcelRequire("arfyn")));

const $d25753c9fcfe205f$var$VideoPreference_1 = $d25753c9fcfe205f$var$__importDefault((parcelRequire("etFBX")));

var $3orkO = parcelRequire("3orkO");

const $d25753c9fcfe205f$var$VideoPriorityBasedPolicyConfig_1 = $d25753c9fcfe205f$var$__importDefault((parcelRequire("lcZ1l")));

const $d25753c9fcfe205f$var$VideoQualityAdaptationPreference_1 = $d25753c9fcfe205f$var$__importDefault((parcelRequire("lGCbE")));
/** @internal */ class $d25753c9fcfe205f$var$LinkMediaStats {
    constructor(){
        this.bandwidthEstimateKbps = 0;
        this.usedBandwidthKbps = 0;
        this.packetsLost = 0;
        this.nackCount = 0;
        this.rttMs = 0;
    }
}
class $d25753c9fcfe205f$var$VideoPriorityBasedPolicy {
    constructor(logger, videoPriorityBasedPolicyConfig = $d25753c9fcfe205f$var$VideoPriorityBasedPolicyConfig_1.default.Default){
        this.logger = logger;
        this.videoPriorityBasedPolicyConfig = videoPriorityBasedPolicyConfig;
        this.shouldPauseTiles = true;
        this.observerQueue = new Set();
        this.pausedBwAttendeeIds = new Set();
        this.wantsResubscribeObserver = undefined;
        if (this.videoPriorityBasedPolicyConfig.serverSideNetworkAdaption === $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1.default.Default) this.videoPriorityBasedPolicyConfig.serverSideNetworkAdaption = $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1.default.BandwidthProbingAndRemoteVideoQualityAdaption;
        this.reset();
    }
    reset() {
        // Self-attendee is not actually necessary in 'AllHighestVideoBandwidthPolicy' since it just passes it to
        // `highestQualityStreamFromEachGroupExcludingSelf` which itself doesn't need it as self attendees are not in the
        // index
        this.allHighestPolicy = new $d25753c9fcfe205f$var$AllHighestVideoBandwidthPolicy_1.default('');
        this.optimalReceiveSet = new $d25753c9fcfe205f$var$DefaultVideoStreamIdSet_1.default();
        this.optimalReceiveStreams = [];
        this.optimalNonPausedReceiveStreams = [];
        this.subscribedReceiveSet = new $d25753c9fcfe205f$var$DefaultVideoStreamIdSet_1.default();
        this.subscribedReceiveStreams = [];
        this.videoPreferences = undefined;
        this.defaultVideoPreferences = undefined;
        this.shouldPauseTiles = true;
        this.pausedStreamIds = new $d25753c9fcfe205f$var$DefaultVideoStreamIdSet_1.default();
        this.pausedBwAttendeeIds = new Set();
        this.videoPreferencesUpdated = false;
        this.logCount = 0;
        this.startupPeriod = true;
        this.usingPrevTargetRate = false;
        this.rateProbeState = "Not Probing" /* RateProbeState.NotProbing */ ;
        this.firstEstimateTimestamp = 0;
        this.lastUpgradeRateKbps = 0;
        this.timeBeforeAllowSubscribeMs = $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_SUBSCRIBE_MS;
        this.lastProbeTimestamp = Date.now();
        this.timeBeforeAllowProbeMs = $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_PROBE_MS;
        this.downlinkStats = new $d25753c9fcfe205f$var$LinkMediaStats();
        this.prevDownlinkStats = new $d25753c9fcfe205f$var$LinkMediaStats();
        this.probeFailed = false;
        this.serverSideNetworkAdaption = this.videoPriorityBasedPolicyConfig.serverSideNetworkAdaption;
        this.pendingActionAfterUpdatedPreferences = false;
    }
    bindToTileController(tileController) {
        this.tileController = tileController;
        this.logger.info('tileController bound');
    }
    setWantsResubscribeObserver(observer) {
        this.wantsResubscribeObserver = observer;
    }
    // This function allows setting preferences without the need to inherit from this class
    // which would require not using the internal keyword
    chooseRemoteVideoSources(preferences) {
        var _a;
        if ((_a = this.videoPreferences) === null || _a === void 0 ? void 0 : _a.equals(preferences)) return;
        this.videoPreferences = preferences === null || preferences === void 0 ? void 0 : preferences.clone();
        if (!(0, $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1.serverSideNetworkAdaptionIsNoneOrDefault)(this.serverSideNetworkAdaption)) {
            this.pendingActionAfterUpdatedPreferences = true;
            if (this.wantsResubscribeObserver !== undefined) {
                this.wantsResubscribeObserver();
                this.pendingActionAfterUpdatedPreferences = false;
            }
            if (this.serverSideNetworkAdaption === $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1.default.BandwidthProbingAndRemoteVideoQualityAdaption) {
                const desiredVideoSources = new Array();
                for (const preference of this.videoPreferences){
                    const source = new $d25753c9fcfe205f$var$VideoSource_1.default();
                    source.attendee = new $d25753c9fcfe205f$var$Attendee_1.default();
                    source.attendee.attendeeId = preference.attendeeId;
                    desiredVideoSources.push(source);
                }
                this.allHighestPolicy.chooseRemoteVideoSources(desiredVideoSources);
                return;
            }
        }
        this.videoPreferencesUpdated = true;
        this.logger.info(`bwe: setVideoPreferences bwe: new preferences: ${JSON.stringify(preferences)}`);
        return;
    }
    updateIndex(videoIndex) {
        this.videoIndex = videoIndex;
        if (this.serverSideNetworkAdaption === $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1.default.BandwidthProbingAndRemoteVideoQualityAdaption) this.allHighestPolicy.updateIndex(videoIndex);
        if (!this.videoPreferences) this.updateDefaultVideoPreferences();
    }
    updateDefaultVideoPreferences() {
        const attendeeIds = new Set();
        for (const stream of this.videoIndex.remoteStreamDescriptions())attendeeIds.add(stream.attendeeId);
        const prefs = $3orkO.VideoPreferences.prepare();
        const numAttendees = attendeeIds.size;
        let targetDisplaySize = $d25753c9fcfe205f$var$TargetDisplaySize_1.default.Maximum;
        if (numAttendees > 8) targetDisplaySize = $d25753c9fcfe205f$var$TargetDisplaySize_1.default.Low;
        else if (numAttendees > 4) targetDisplaySize = $d25753c9fcfe205f$var$TargetDisplaySize_1.default.Medium;
        for (const attendeeId of attendeeIds)prefs.add(new $d25753c9fcfe205f$var$VideoPreference_1.default(attendeeId, 1, targetDisplaySize));
        this.defaultVideoPreferences = prefs.build();
    }
    updateMetrics(clientMetricReport) {
        if (!this.videoIndex || this.videoIndex.allStreams().empty()) return;
        this.prevDownlinkStats = this.downlinkStats;
        this.downlinkStats = new $d25753c9fcfe205f$var$LinkMediaStats();
        const metricReport = clientMetricReport.getObservableMetrics();
        // availableIncomingBitrate is the standard stat but is not available in Firefox yet so only Safari for now.
        this.downlinkStats.bandwidthEstimateKbps = metricReport.availableIncomingBitrate / 1000;
        for(const ssrcStr in clientMetricReport.streamMetricReports){
            const ssrc = Number.parseInt(ssrcStr, 10);
            const metrics = clientMetricReport.streamMetricReports[ssrc];
            if (metrics.direction === $d25753c9fcfe205f$var$ClientMetricReportDirection_1.default.DOWNSTREAM && metrics.mediaType === $d25753c9fcfe205f$var$ClientMetricReportMediaType_1.default.VIDEO) {
                // Only use video stream metrics
                if (metrics.currentMetrics.hasOwnProperty('nackCount')) this.downlinkStats.nackCount += clientMetricReport.countPerSecond('nackCount', ssrc);
                if (metrics.currentMetrics.hasOwnProperty('packetsLost')) this.downlinkStats.packetsLost += clientMetricReport.countPerSecond('packetsLost', ssrc);
                if (metrics.currentMetrics.hasOwnProperty('bytesReceived')) this.downlinkStats.usedBandwidthKbps += clientMetricReport.bitsPerSecond('bytesReceived', ssrc) / 1000;
            }
        }
    }
    wantsResubscribe() {
        let wants = false;
        if (!(0, $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1.serverSideNetworkAdaptionIsNoneOrDefault)(this.serverSideNetworkAdaption)) {
            wants || (wants = this.pendingActionAfterUpdatedPreferences);
            if (this.serverSideNetworkAdaption === $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1.default.BandwidthProbingAndRemoteVideoQualityAdaption) return wants || this.allHighestPolicy.wantsResubscribe();
        }
        this.calculateOptimalReceiveSet();
        wants || (wants = !this.subscribedReceiveSet.equal(this.optimalReceiveSet));
        return wants;
    }
    chooseSubscriptions() {
        if (!(0, $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1.serverSideNetworkAdaptionIsNoneOrDefault)(this.serverSideNetworkAdaption)) {
            this.pendingActionAfterUpdatedPreferences = false;
            if (this.serverSideNetworkAdaption === $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1.default.BandwidthProbingAndRemoteVideoQualityAdaption) return this.allHighestPolicy.chooseSubscriptions();
        }
        if (!this.subscribedReceiveSet.equal(this.optimalReceiveSet)) this.lastSubscribeTimestamp = Date.now();
        this.subscribedReceiveSet = this.optimalReceiveSet.clone();
        this.subscribedReceiveStreams = this.optimalReceiveStreams.slice();
        return this.subscribedReceiveSet.clone();
    }
    addObserver(observer) {
        this.observerQueue.add(observer);
    }
    removeObserver(observer) {
        this.observerQueue.delete(observer);
    }
    forEachObserver(observerFunc) {
        for (const observer of this.observerQueue)observerFunc(observer);
    }
    setVideoPriorityBasedPolicyConfigs(config) {
        this.videoPriorityBasedPolicyConfig = config;
    }
    calculateOptimalReceiveStreams() {
        var _a;
        const chosenStreams = [];
        const remoteInfos = this.videoIndex.remoteStreamDescriptions();
        if (remoteInfos.length === 0 || ((_a = this.videoPreferences) === null || _a === void 0 ? void 0 : _a.isEmpty())) {
            this.optimalReceiveStreams = [];
            return;
        }
        const lastProbeState = this.rateProbeState;
        this.cleanBwPausedTiles(remoteInfos);
        this.handleAppPausedStreams(chosenStreams, remoteInfos);
        const attendeeIdToPreference = new Map();
        for (const preference of this.getCurrentVideoPreferences())attendeeIdToPreference.set(preference.attendeeId, preference);
        // We can pre-emptively filter to just remote stream descriptions for remote video sources we already
        // have configuration for. We do not care about streams we aren't going to subscribe to.
        const remoteInfosWithPreference = remoteInfos.filter((stream)=>{
            return attendeeIdToPreference.has(stream.attendeeId);
        });
        const sameStreamChoices = !this.streamsWithPreferenceDidChange(remoteInfosWithPreference);
        const noMajorChange = !this.startupPeriod && sameStreamChoices;
        // If no major changes then don't allow subscribes for the allowed amount of time
        if (noMajorChange && Date.now() - this.lastSubscribeTimestamp < this.timeBeforeAllowSubscribeMs) return;
        // Sort streams by bitrate ascending.
        remoteInfosWithPreference.sort((a, b)=>{
            if (a.maxBitrateKbps === b.maxBitrateKbps) return a.streamId - b.streamId;
            return a.maxBitrateKbps - b.maxBitrateKbps;
        });
        // Convert 0 avg bitrates to max, handle special cases, and remove upgrades that downgrade resolution or framerate
        for (const info of remoteInfosWithPreference)if (info.avgBitrateKbps === 0 || info.avgBitrateKbps > info.maxBitrateKbps) {
            // Content can be a special case
            if (info.attendeeId.endsWith($d25753c9fcfe205f$var$ContentShareConstants_1.default.Modality) && info.maxBitrateKbps < 100) info.maxBitrateKbps = info.avgBitrateKbps;
            else info.avgBitrateKbps = info.maxBitrateKbps;
        }
        const streamIdsToRemove = new Set();
        for (const preference of this.getCurrentVideoPreferences()){
            const streamsForAttendees = remoteInfosWithPreference.filter((description)=>{
                return description.attendeeId === preference.attendeeId;
            });
            if (streamsForAttendees.length < 3) continue;
            let maxFrameRate = 15;
            let maxPixels = 153600;
            streamsForAttendees.forEach((stream)=>{
                maxFrameRate = Math.max(maxFrameRate, stream.maxFrameRate);
                maxPixels = Math.max(maxPixels, stream.totalPixels());
            });
            streamsForAttendees.sort((a, b)=>{
                if (preference.degradationPreference === $d25753c9fcfe205f$var$VideoQualityAdaptationPreference_1.default.MaintainResolution) {
                    // This may seem counter-intuitive but given we want to upgrade resolution first, and framerate
                    // last, we want to sort by framerate first, and resolution only if framerate is close.
                    //
                    // That way, e.g. the first three streams will all contain increases in resolution. We will skip any down
                    // grades in resolution (i.e. to hop to a higher framerate stream) in the section below
                    if (Math.abs(a.maxFrameRate - b.maxFrameRate) < 2) return a.totalPixels() - b.totalPixels();
                    return a.maxFrameRate - b.maxFrameRate;
                } else if (preference.degradationPreference === $d25753c9fcfe205f$var$VideoQualityAdaptationPreference_1.default.MaintainFramerate) {
                    // See note above, but swap resolution for framerate
                    if (a.totalPixels() === b.totalPixels()) return a.maxFrameRate - b.maxFrameRate;
                    return a.totalPixels() - b.totalPixels();
                } else {
                    // In 'balanced' mode, we want a slight preference towards upgrading resolution first
                    // when moving up the bitrate ladder, so we weigh the bitrate by a framerate
                    // and resolution derived value that is tuned to be reasonable in most cases. This attempts to
                    // mimic the diagrams in the guide.
                    //
                    // A higher constant makes the policy prefer resolution to framerate more at lower values
                    const framerateExponentConstant = 5;
                    // A higher constant here makes the policy prefer framerate to resolution more at higher values
                    const resolutionBaseConstant = 2;
                    const weighByFramerate = (stream)=>{
                        return stream.avgBitrateKbps * Math.pow(2, framerateExponentConstant * stream.maxFrameRate / maxFrameRate * Math.pow(resolutionBaseConstant * 2, stream.totalPixels() / maxPixels));
                    };
                    return weighByFramerate(a) - weighByFramerate(b);
                }
            });
            let lastInfo = undefined;
            // Downgrades during recovery are unusual and jarring. Here we will strip out any (these should result in paths that
            // match those in the priority downlink policy guide).
            for (const info of streamsForAttendees){
                if (lastInfo !== undefined) {
                    if (info.maxFrameRate < lastInfo.maxFrameRate && Math.abs(lastInfo.maxFrameRate - info.maxFrameRate) > 2 || info.totalPixels() < lastInfo.totalPixels()) {
                        streamIdsToRemove.add(info.streamId);
                        continue;
                    }
                }
                lastInfo = info;
            }
        }
        const filteredRemoteAttendeesWithPreference = remoteInfosWithPreference.filter((info)=>{
            return !streamIdsToRemove.has(info.streamId);
        });
        this.logger.info(`Filtered to ${JSON.stringify(filteredRemoteAttendeesWithPreference)}`);
        const rates = {
            targetDownlinkBitrate: 0,
            chosenTotalBitrate: 0,
            deltaToNextUpgrade: 0
        };
        rates.targetDownlinkBitrate = this.determineTargetRate();
        const numberOfParticipants = this.subscribedReceiveSet.size();
        const currentEstimated = this.downlinkStats.bandwidthEstimateKbps;
        // Use videoPriorityBasedPolicyConfig to add additional delays based on network conditions
        const dontAllowSubscribe = !this.videoPriorityBasedPolicyConfig.allowSubscribe(numberOfParticipants, currentEstimated);
        // `priorityPolicy` assumes that we have sorted `filteredRemoteAttendeesWithPreference` in order of quality
        if (this.probeFailed) {
            // When probe failed, we set timeBeforeAllowSubscribeMs to 3x longer
            // Since we have passed the subscribe interval now, we will try to probe again
            this.probeFailed = false;
            // For the same reason above, reset time before allow subscribe to default
            this.timeBeforeAllowSubscribeMs = $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_SUBSCRIBE_MS;
            if (noMajorChange && dontAllowSubscribe) return;
        }
        const upgradeStream = this.priorityPolicy(rates, filteredRemoteAttendeesWithPreference, chosenStreams);
        const skipProbe = !(0, $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1.serverSideNetworkAdaptionIsNoneOrDefault)(this.serverSideNetworkAdaption);
        let subscriptionChoice = 0 /* UseReceiveSet.NewOptimal */ ;
        // Look for probing or override opportunities
        if (!skipProbe && !this.startupPeriod && sameStreamChoices) {
            if (this.rateProbeState === "Probing" /* RateProbeState.Probing */ ) subscriptionChoice = this.handleProbe(chosenStreams, rates.targetDownlinkBitrate);
            else if (rates.deltaToNextUpgrade !== 0) subscriptionChoice = this.maybeOverrideOrProbe(chosenStreams, rates, upgradeStream);
        } else {
            // If there was a change in streams to choose from, then cancel any probing or upgrades
            this.setProbeState("Not Probing" /* RateProbeState.NotProbing */ );
            this.lastUpgradeRateKbps = 0;
        }
        this.previousStreamsWithPreference = remoteInfosWithPreference;
        this.videoPreferencesUpdated = false;
        if (subscriptionChoice === 1 /* UseReceiveSet.PreviousOptimal */ ) {
            this.logger.info(`bwe: keepSameSubscriptions stats:${JSON.stringify(this.downlinkStats)}`);
            this.prevTargetRateKbps = rates.targetDownlinkBitrate;
            return;
        }
        if (subscriptionChoice === 2 /* UseReceiveSet.PreProbe */ ) {
            const subscribedRate = this.calculateSubscribeRate(this.preProbeNonPausedReceiveStreams);
            this.optimalReceiveStreams = this.preProbeReceiveStreams.slice();
            this.processBwPausedStreams(remoteInfosWithPreference, this.preProbeNonPausedReceiveStreams);
            this.logger.info('bwe: Use Pre-Probe subscription subscribedRate:' + subscribedRate);
            return;
        }
        this.optimalNonPausedReceiveStreams = chosenStreams.slice();
        const lastNumberPaused = this.pausedBwAttendeeIds.size;
        this.processBwPausedStreams(remoteInfosWithPreference, chosenStreams);
        if (this.logger.getLogLevel() <= $aSYjG.LogLevel.INFO && (this.logCount % 15 === 0 || this.rateProbeState !== lastProbeState || this.optimalReceiveStreams.length !== chosenStreams.length || lastNumberPaused !== this.pausedBwAttendeeIds.size)) {
            this.logger.info(this.policyStateLogStr(remoteInfos, rates.targetDownlinkBitrate));
            this.logCount = 0;
        }
        this.logCount++;
        this.prevTargetRateKbps = rates.targetDownlinkBitrate;
        this.optimalReceiveStreams = chosenStreams.slice();
    }
    calculateOptimalReceiveSet() {
        const streamSelectionSet = new $d25753c9fcfe205f$var$DefaultVideoStreamIdSet_1.default();
        this.calculateOptimalReceiveStreams();
        for (const stream of this.optimalReceiveStreams)streamSelectionSet.add(stream.streamId);
        if (!this.optimalReceiveSet.equal(streamSelectionSet)) {
            const subscribedRate = this.calculateSubscribeRate(this.optimalReceiveStreams);
            this.logger.info(`bwe: new streamSelection: ${JSON.stringify(streamSelectionSet)} subscribedRate:${subscribedRate}`);
        }
        this.optimalReceiveSet = streamSelectionSet;
    }
    determineTargetRate() {
        let targetBitrate = 0;
        const now = Date.now();
        // Startup phase handling.  During this period the estimate can be 0 or
        // could still be slowly hunting for a steady state.  This startup ramp up
        // can cause a series of subscribes which can be distracting. During this
        // time just use our configured default value
        if (this.downlinkStats.bandwidthEstimateKbps !== 0) {
            if (this.firstEstimateTimestamp === 0) this.firstEstimateTimestamp = now;
            // handle startup state where estimator is still converging.
            if (this.startupPeriod) // Drop out of startup period if
            // - estimate is above default
            // - get packet loss and have a valid estimate
            // - startup period has expired and rate is not still increasing
            {
                if (this.downlinkStats.bandwidthEstimateKbps > $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.DEFAULT_BANDWIDTH_KBPS || this.downlinkStats.packetsLost > 0 || now - this.firstEstimateTimestamp > $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.STARTUP_PERIOD_MS && this.downlinkStats.bandwidthEstimateKbps <= this.prevDownlinkStats.bandwidthEstimateKbps) {
                    this.startupPeriod = false;
                    this.prevTargetRateKbps = this.downlinkStats.bandwidthEstimateKbps;
                }
            }
            // If we are in the startup period and we haven't detected any packet loss, then
            // keep it at the default to let the estimation get to a steady state
            if (this.startupPeriod) targetBitrate = $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.DEFAULT_BANDWIDTH_KBPS;
            else // We rely on our target bitrate being above what we are receiving to mark a probe as complete,
            // however in browsers, the estimate can heavily lag behind the actual receive rate, especially when low.
            //
            // To mitigate this we override with the actual estimate plus some buffer if we aren't seeing packet loss.
            if (this.rateProbeState === "Probing" /* RateProbeState.Probing */  && this.downlinkStats.usedBandwidthKbps > this.downlinkStats.bandwidthEstimateKbps && this.downlinkStats.packetsLost < $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.SPURIOUS_PACKET_LOST_THRESHOLD) {
                this.logger.info(`bwe: In probe state, overriding estimate ${this.downlinkStats.bandwidthEstimateKbps} with actual receive bitrate ${this.downlinkStats.usedBandwidthKbps}`);
                targetBitrate = this.downlinkStats.usedBandwidthKbps + $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.USED_BANDWIDTH_OVERRIDE_BUFFER_KBPS;
            } else targetBitrate = this.downlinkStats.bandwidthEstimateKbps;
        } else if (this.firstEstimateTimestamp === 0) targetBitrate = $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.DEFAULT_BANDWIDTH_KBPS;
        else targetBitrate = this.prevTargetRateKbps;
        // Estimated downlink rate can follow actual bandwidth or fall for a short period of time
        // due to the absolute send time estimator incorrectly thinking that a delay in packets is
        // a precursor to packet loss.  We have seen too many false positives on this, so we
        // will ignore largish drops in the estimate if there is no packet loss
        if (!this.startupPeriod && (this.usingPrevTargetRate && this.downlinkStats.bandwidthEstimateKbps < this.prevTargetRateKbps || this.downlinkStats.bandwidthEstimateKbps < this.prevTargetRateKbps * (100 - $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.LARGE_RATE_CHANGE_TRIGGER_PERCENT) / 100 || this.downlinkStats.bandwidthEstimateKbps < this.downlinkStats.usedBandwidthKbps * $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.LARGE_RATE_CHANGE_TRIGGER_PERCENT / 100) && this.downlinkStats.packetsLost === 0) {
            // Set target to be the same as last
            this.logger.debug(()=>{
                return 'bwe: ValidateRate: Using Previous rate ' + this.prevTargetRateKbps;
            });
            this.usingPrevTargetRate = true;
            targetBitrate = this.prevTargetRateKbps;
        } else this.usingPrevTargetRate = false;
        // Cap total receive bitrate at 15000 kbps
        if (targetBitrate > 15000) this.logger.warn('bwe: ' + targetBitrate + ' exceeds maximum limit (15000). Limit TargetDisplaySize with VideoPreferences to avoid this.');
        return Math.min(targetBitrate, 15000);
    }
    setProbeState(newState) {
        if (this.rateProbeState === newState) return false;
        const now = Date.now();
        switch(newState){
            case "Not Probing" /* RateProbeState.NotProbing */ :
                this.probePendingStartTimestamp = 0;
                break;
            case "Probe Pending" /* RateProbeState.ProbePending */ :
                if (this.lastProbeTimestamp === 0 || now - this.lastProbeTimestamp > $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_PROBE_MS) this.probePendingStartTimestamp = now;
                else // Too soon to do a probe again
                return false;
                break;
            case "Probing" /* RateProbeState.Probing */ :
                if (now - this.probePendingStartTimestamp > this.timeBeforeAllowProbeMs) {
                    this.lastProbeTimestamp = now;
                    this.preProbeReceiveStreams = this.subscribedReceiveStreams.slice();
                    this.preProbeNonPausedReceiveStreams = this.optimalNonPausedReceiveStreams;
                    // Increase the time allowed until the next probe
                    this.timeBeforeAllowProbeMs = Math.min(this.timeBeforeAllowProbeMs * 2, $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.MAX_HOLD_BEFORE_PROBE_MS);
                } else // Too soon to do probe
                return false;
                break;
        }
        this.logger.info('bwe: setProbeState to ' + newState + ' from ' + this.rateProbeState);
        this.rateProbeState = newState;
        return true;
    }
    // Upgrade the stream id from the appropriate group or add it if it wasn't already in the list.
    // Return the added amount of bandwidth
    upgradeToStream(chosenStreams, upgradeStream) {
        for(let i = 0; i < chosenStreams.length; i++)if (chosenStreams[i].groupId === upgradeStream.groupId) {
            const diffRate = upgradeStream.avgBitrateKbps - chosenStreams[i].avgBitrateKbps;
            this.logger.info('bwe: upgradeStream from ' + JSON.stringify(chosenStreams[i]) + ' to ' + upgradeStream);
            this.lastUpgradeRateKbps = diffRate;
            chosenStreams[i] = upgradeStream;
            return diffRate;
        }
        // We are adding a stream and not upgrading.
        chosenStreams.push(upgradeStream);
        this.lastUpgradeRateKbps = upgradeStream.avgBitrateKbps;
        return this.lastUpgradeRateKbps;
    }
    // Do specific behavior while we are currently in probing state and metrics
    // indicate environment is still valid to do probing.
    // Return true if the caller should not change from the previous subscriptions.
    handleProbe(chosenStreams, targetDownlinkBitrate) {
        // Don't allow probe to happen indefinitely
        if (Date.now() - this.lastProbeTimestamp > $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.MAX_ALLOWED_PROBE_TIME_MS) {
            this.logger.info(`bwe: Canceling probe due to timeout`);
            this.setProbeState("Not Probing" /* RateProbeState.NotProbing */ );
            return 0 /* UseReceiveSet.NewOptimal */ ;
        }
        if (this.downlinkStats.packetsLost > 0) {
            this.logger.info(`bwe: Probe encountering packets lost:${this.downlinkStats.packetsLost}`);
            // See comment above `VideoPriorityBasedPolicy.SPURIOUS_PACKET_LOST_THRESHOLD`
            if (this.downlinkStats.packetsLost > $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.SPURIOUS_PACKET_LOST_THRESHOLD) {
                this.setProbeState("Not Probing" /* RateProbeState.NotProbing */ );
                this.logger.info(`bwe: Canceling probe due to packets lost:${this.downlinkStats.packetsLost}`);
                this.probeFailed = true;
                this.timeBeforeAllowSubscribeMs = Math.max($d25753c9fcfe205f$var$VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_SUBSCRIBE_MS, this.timeBeforeAllowSubscribeMs) * 3;
                // packet lost indicates bad network and thus slowing down subscribing by extend delay by 3 times
                return 2 /* UseReceiveSet.PreProbe */ ;
            }
        }
        const subscribedRate = this.calculateSubscribeRate(this.optimalReceiveStreams);
        if (this.chosenStreamsSameAsLast(chosenStreams) || targetDownlinkBitrate > subscribedRate) {
            this.logger.info(`bwe: Probe successful`);
            // If target bitrate can sustain probe rate, then probe was successful.
            this.setProbeState("Not Probing" /* RateProbeState.NotProbing */ );
            // Reset the time allowed between probes since this was successful
            this.timeBeforeAllowProbeMs = $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_PROBE_MS;
            return 0 /* UseReceiveSet.NewOptimal */ ;
        }
        return 1 /* UseReceiveSet.PreviousOptimal */ ;
    }
    maybeOverrideOrProbe(chosenStreams, rates, upgradeStream) {
        const sameSubscriptions = this.chosenStreamsSameAsLast(chosenStreams);
        let useLastSubscriptions = 0 /* UseReceiveSet.NewOptimal */ ;
        // We want to minimize thrashing between between low res and high res of different
        // participants due to avg bitrate fluctuations. If there hasn't been much of a change in estimated bandwidth
        // and the number of streams and their max rates are the same, then reuse the previous subscription
        const triggerPercent = rates.targetDownlinkBitrate > $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.LOW_BITRATE_THRESHOLD_KBPS ? $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.TARGET_RATE_CHANGE_TRIGGER_PERCENT : $d25753c9fcfe205f$var$VideoPriorityBasedPolicy.TARGET_RATE_CHANGE_TRIGGER_PERCENT * 2;
        const minTargetBitrateDelta = rates.targetDownlinkBitrate * triggerPercent / 100;
        this.targetRateBaselineForDeltaCheckKbps = this.targetRateBaselineForDeltaCheckKbps !== undefined ? this.targetRateBaselineForDeltaCheckKbps : this.prevTargetRateKbps;
        if (!sameSubscriptions && Math.abs(rates.targetDownlinkBitrate - this.targetRateBaselineForDeltaCheckKbps) < minTargetBitrateDelta) {
            this.logger.info('bwe: MaybeOverrideOrProbe: Reuse last decision based on delta rate. {' + JSON.stringify(this.subscribedReceiveSet) + `}`);
            useLastSubscriptions = 1 /* UseReceiveSet.PreviousOptimal */ ;
        } else this.targetRateBaselineForDeltaCheckKbps = rates.targetDownlinkBitrate;
        // If there has been packet loss, then reset to no probing state
        if (this.downlinkStats.packetsLost > this.prevDownlinkStats.packetsLost) {
            this.setProbeState("Not Probing" /* RateProbeState.NotProbing */ );
            this.lastUpgradeRateKbps = 0;
            return useLastSubscriptions;
        }
        if (sameSubscriptions || useLastSubscriptions === 1 /* UseReceiveSet.PreviousOptimal */ ) // If planned subscriptions are same as last, then either move to probe pending state
        // or move to probing state if enough time has passed.
        switch(this.rateProbeState){
            case "Not Probing" /* RateProbeState.NotProbing */ :
                this.setProbeState("Probe Pending" /* RateProbeState.ProbePending */ );
                break;
            case "Probe Pending" /* RateProbeState.ProbePending */ :
                if (this.setProbeState("Probing" /* RateProbeState.Probing */ )) {
                    this.upgradeToStream(chosenStreams, upgradeStream);
                    useLastSubscriptions = 0 /* UseReceiveSet.NewOptimal */ ;
                }
                break;
        }
        else this.setProbeState("Not Probing" /* RateProbeState.NotProbing */ );
        return useLastSubscriptions;
    }
    // Utility function to find max rate of streams in current decision
    calculateSubscribeRate(streams) {
        let subscribeRate = 0;
        for (const stream of streams)if (!this.pausedStreamIds.contain(stream.streamId) && !this.pausedBwAttendeeIds.has(stream.attendeeId)) subscribeRate += stream.maxBitrateKbps;
        return subscribeRate;
    }
    handleAppPausedStreams(chosenStreams, remoteInfos) {
        if (!this.tileController) {
            this.logger.warn('tileController not found!');
            return;
        }
        this.pausedStreamIds = new $d25753c9fcfe205f$var$DefaultVideoStreamIdSet_1.default();
        const remoteTiles = this.tileController.getAllRemoteVideoTiles();
        for (const tile of remoteTiles){
            const state = tile.state();
            if (state.paused && !this.pausedBwAttendeeIds.has(state.boundAttendeeId)) {
                let j = remoteInfos.length;
                while(j--)if (remoteInfos[j].attendeeId === state.boundAttendeeId) {
                    this.logger.info('bwe: removed paused attendee ' + state.boundAttendeeId + ' streamId: ' + remoteInfos[j].streamId);
                    this.pausedStreamIds.add(remoteInfos[j].streamId);
                    // Add the stream to the selection set to keep the tile around
                    if (this.subscribedReceiveSet.contain(remoteInfos[j].streamId)) chosenStreams.push(remoteInfos[j]);
                    remoteInfos.splice(j, 1);
                }
            }
        }
    }
    processBwPausedStreams(remoteInfos, chosenStreams) {
        if (!this.tileController) {
            this.logger.warn('tileController not found!');
            return;
        }
        const preferences = this.getCurrentVideoPreferences();
        if (preferences && this.shouldPauseTiles) {
            const videoTiles = this.tileController.getAllVideoTiles();
            for (const preference of preferences){
                const videoTile = this.getVideoTileForAttendeeId(preference.attendeeId, videoTiles);
                const paused = (videoTile === null || videoTile === void 0 ? void 0 : videoTile.state().paused) || false;
                if (!chosenStreams.some((stream)=>stream.attendeeId === preference.attendeeId)) {
                    // We cannot rely on the existance of video tile to indicate that the source exists in the call
                    // because tiles will not be added or removed until after a full renegotiation (i.e. it will
                    // be behind the state provided by the index)
                    const streamExists = remoteInfos.some((stream)=>stream.attendeeId === preference.attendeeId);
                    if (videoTile && streamExists) {
                        const info = this.optimalReceiveStreams.find((stream)=>stream.attendeeId === preference.attendeeId);
                        if (info !== undefined) {
                            if (!paused) {
                                this.logger.info(`bwe: pausing streamId ${info.streamId} attendee ${preference.attendeeId} due to bandwidth`);
                                this.forEachObserver((observer)=>{
                                    observer.tileWillBePausedByDownlinkPolicy(videoTile.id());
                                });
                                this.tileController.pauseVideoTile(videoTile.id());
                            }
                            chosenStreams.push(info);
                        }
                        this.pausedBwAttendeeIds.add(preference.attendeeId);
                    } else if (streamExists) {
                        // Create a tile for this participant if one doesn't already exist and mark it as paused
                        // Don't include it in the chosen streams because we don't want to subscribe for it then have to pause it.
                        const newTile = this.tileController.addVideoTile();
                        newTile.bindVideoStream(preference.attendeeId, false, null, 0, 0, 0, null);
                        this.forEachObserver((observer)=>{
                            observer.tileWillBePausedByDownlinkPolicy(newTile.id());
                        });
                        newTile.pause();
                        this.logger.info(`bwe: Created video tile ${newTile.id()} for bw paused attendee ${preference.attendeeId}`);
                        this.pausedBwAttendeeIds.add(preference.attendeeId);
                    }
                } else if (paused && this.pausedBwAttendeeIds.has(preference.attendeeId)) {
                    this.logger.info(`bwe: unpausing attendee ${preference.attendeeId} due to bandwidth`);
                    this.forEachObserver((observer)=>{
                        observer.tileWillBeUnpausedByDownlinkPolicy(videoTile.id());
                    });
                    this.tileController.unpauseVideoTile(videoTile.id());
                    this.pausedBwAttendeeIds.delete(preference.attendeeId);
                }
            }
        }
    }
    cleanBwPausedTiles(remoteInfos) {
        if (!this.tileController) {
            this.logger.warn('tileController not found!');
            return;
        }
        const tiles = this.tileController.getAllRemoteVideoTiles();
        const preferences = this.getCurrentVideoPreferences();
        for (const tile of tiles){
            const state = tile.state();
            if (!state.boundVideoStream) {
                if (!remoteInfos.some((stream)=>stream.attendeeId === state.boundAttendeeId)) {
                    this.tileController.removeVideoTile(state.tileId);
                    this.logger.info(`bwe: Removed video tile ${state.tileId} for bw paused attendee ${state.boundAttendeeId}`);
                } else if (preferences !== undefined && !preferences.some((pref)=>pref.attendeeId === state.boundAttendeeId)) this.tileController.removeVideoTile(state.tileId);
            }
        }
    }
    // `remoteInfos` is assumed to be provided in order of increasing quality
    priorityPolicy(rates, remoteInfos, chosenStreams) {
        let upgradeStream;
        const videoPreferences = this.getCurrentVideoPreferences();
        const highestPriority = videoPreferences.highestPriority();
        let nextPriority;
        let priority = highestPriority;
        while(priority !== -1){
            nextPriority = -1;
            for (const preference of videoPreferences){
                if (preference.priority === priority) // First subscribe to at least low rate
                for (const info of remoteInfos){
                    if (info.attendeeId === preference.attendeeId) {
                        if (!chosenStreams.some((stream)=>stream.groupId === info.groupId)) {
                            if (rates.chosenTotalBitrate + info.avgBitrateKbps <= rates.targetDownlinkBitrate) {
                                chosenStreams.push(info);
                                rates.chosenTotalBitrate += info.avgBitrateKbps;
                            } else if (rates.deltaToNextUpgrade === 0) {
                                // Keep track of step to next upgrade
                                rates.deltaToNextUpgrade = info.avgBitrateKbps;
                                upgradeStream = info;
                            }
                        }
                    }
                }
                else if (preference.priority > priority) {
                    nextPriority = preference.priority;
                    break;
                }
            }
            // Now try to upgrade all attendee's with this priority
            for (const preference of videoPreferences)if (preference.priority === priority) {
                for (const info of remoteInfos)if (info.attendeeId === preference.attendeeId) {
                    const index = chosenStreams.findIndex((stream)=>stream.groupId === info.groupId && stream.maxBitrateKbps <= info.maxBitrateKbps && stream.avgBitrateKbps < info.avgBitrateKbps);
                    if (index !== -1) {
                        const increaseKbps = info.avgBitrateKbps - chosenStreams[index].avgBitrateKbps;
                        if (this.hasSimulcastStreams(remoteInfos, info.attendeeId, info.groupId) && this.canUpgrade(info.avgBitrateKbps, preference.targetSize, preference.targetSizeToBitrateKbps(preference.targetSize), info.attendeeId.endsWith($d25753c9fcfe205f$var$ContentShareConstants_1.default.Modality))) {
                            this.logger.info(`bwe: attendee: ${info.attendeeId} group: ${info.groupId} has simulcast and can upgrade avgBitrate: ${info.avgBitrateKbps} target: ${preference.targetSizeToBitrateKbps(preference.targetSize)} targetTotalBitrate: ${rates.targetDownlinkBitrate}`);
                            if (rates.chosenTotalBitrate + increaseKbps <= rates.targetDownlinkBitrate) {
                                rates.chosenTotalBitrate += increaseKbps;
                                chosenStreams[index] = info;
                            } else if (rates.deltaToNextUpgrade === 0) {
                                // Keep track of step to next upgrade
                                rates.deltaToNextUpgrade = increaseKbps;
                                upgradeStream = info;
                            }
                        } else this.logger.info('bwe: cannot upgrade stream quality beyond target size');
                    }
                }
            } else {
                if (preference.priority > priority) break;
            }
            // If we haven't subscribed to the highest rate of the top priority videos then
            // do not subscribe to any other sources
            if (priority === highestPriority && rates.deltaToNextUpgrade !== 0) break;
            priority = nextPriority;
        }
        return upgradeStream;
    }
    getVideoTileForAttendeeId(attendeeId, videoTiles) {
        for (const tile of videoTiles){
            const state = tile.state();
            if (state.boundAttendeeId === attendeeId) return tile;
        }
        return null;
    }
    canUpgrade(bitrateKbps, targetResolution, targetBitrateKbps, isContent) {
        let canUpgrade = false;
        // For both video and content, we want to interpret `TargetDisplaySize.High` as a request for the best quality
        // video, and should ignore the value of the target bitrate.
        if (targetResolution === $d25753c9fcfe205f$var$TargetDisplaySize_1.default.High) // For both video and content, we want to interpret `TargetDisplaySize.High` as a request for the best quality
        // video, and should ignore the value of the target bitrate.
        canUpgrade = true;
        else if (!isContent && bitrateKbps <= targetBitrateKbps) // For content share, even if the higher quality stream has a high max bitrate of 1200 kbps for example
        // the avg bitrate can be way lower so have to make sure that we do not update to a higher bitrate than the
        // target value (i.e. if `targetResolution === TargetDisplaySize.Low`).
        //
        // This does not apply to video as video uplink bandwidth could change the max bitrate value without resubscribing
        // so the max bitrate value might not be up-to-date on the downlink side. Also in the case of video, the avg
        // bitrate is close to the actual max bitrate.
        canUpgrade = true;
        else if (isContent && targetResolution === $d25753c9fcfe205f$var$TargetDisplaySize_1.default.Medium && bitrateKbps <= targetBitrateKbps) // If the target resolution is medium then fall back to use avg bitrate as video.
        canUpgrade = true;
        if (canUpgrade) {
            this.logger.info(`bwe: canUpgrade: bitrateKbps: ${bitrateKbps} targetBitrateKbps: ${targetBitrateKbps}`);
            return true;
        }
        this.logger.info(`bwe: cannot Upgrade: bitrateKbps: ${bitrateKbps} targetBitrateKbps: ${targetBitrateKbps}`);
        return false;
    }
    hasSimulcastStreams(remoteInfos, attendeeId, groupId) {
        let streamCount = 0;
        for (const info of remoteInfos)if (info.attendeeId === attendeeId && info.groupId === groupId) streamCount++;
        this.logger.info(`bwe: attendeeId: ${attendeeId} groupId: ${groupId} hasSimulcastStreams: streamCount: ${streamCount}`);
        return streamCount > 1;
    }
    streamsWithPreferenceDidChange(remoteInfos) {
        if (this.previousStreamsWithPreference === undefined || remoteInfos.length !== this.previousStreamsWithPreference.length || this.videoPreferencesUpdated === true) return true;
        for (const info of remoteInfos){
            const infoMatch = this.previousStreamsWithPreference.find((prevInfo)=>prevInfo.groupId === info.groupId && prevInfo.streamId === info.streamId && prevInfo.maxBitrateKbps === info.maxBitrateKbps);
            if (infoMatch === undefined) return true;
        }
        return false;
    }
    chosenStreamsSameAsLast(chosenStreams) {
        if (this.optimalNonPausedReceiveStreams.length !== chosenStreams.length) return false;
        for (const lastStream of this.optimalNonPausedReceiveStreams){
            if (!chosenStreams.some((stream)=>stream.streamId === lastStream.streamId)) return false;
        }
        return true;
    }
    policyStateLogStr(remoteInfos, targetDownlinkBitrate) {
        const subscribedRate = this.calculateSubscribeRate(this.optimalReceiveStreams);
        const optimalReceiveSet = {
            targetBitrate: targetDownlinkBitrate,
            subscribedRate: subscribedRate,
            probeState: this.rateProbeState,
            startupPeriod: this.startupPeriod
        };
        // Reduced remote info logging:
        let remoteInfoStr = `remoteInfos: [`;
        for (const info of remoteInfos)remoteInfoStr += `{grpId:${info.groupId} strId:${info.streamId} maxBr:${info.maxBitrateKbps} avgBr:${info.avgBitrateKbps}}, `;
        remoteInfoStr += `]`;
        let logString = `bwe: optimalReceiveSet ${JSON.stringify(optimalReceiveSet)}\n` + `bwe:   prev ${JSON.stringify(this.prevDownlinkStats)}\n` + `bwe:   now  ${JSON.stringify(this.downlinkStats)}\n` + `bwe:   ${remoteInfoStr}\n`;
        if (this.pausedStreamIds.size() > 0 || this.pausedBwAttendeeIds.size > 0) logString += `bwe:   paused: app stream ids ${JSON.stringify(this.pausedStreamIds)}  bw attendees { ${Array.from(this.pausedBwAttendeeIds).join(' ')} }\n`;
        if (this.videoPreferences) logString += `bwe:   preferences: ${JSON.stringify(this.videoPreferences)}`;
        else logString += `bwe:   default preferences: ${JSON.stringify(this.defaultVideoPreferences)}`;
        return logString;
    }
    getCurrentVideoPreferences() {
        return this.videoPreferences || this.defaultVideoPreferences;
    }
    getServerSideNetworkAdaption() {
        return this.serverSideNetworkAdaption;
    }
    setServerSideNetworkAdaption(adaption) {
        this.serverSideNetworkAdaption = adaption;
        this.setProbeState("Not Probing" /* RateProbeState.NotProbing */ ); // In case we were probing
    }
    supportedServerSideNetworkAdaptions() {
        return [
            $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1.default.None,
            $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1.default.BandwidthProbing,
            $d25753c9fcfe205f$var$ServerSideNetworkAdaption_1.default.BandwidthProbingAndRemoteVideoQualityAdaption
        ];
    }
    getVideoPreferences() {
        let preferences = this.getCurrentVideoPreferences();
        if (!preferences) {
            const dummyPreferences = $3orkO.VideoPreferences.prepare();
            // Can't be undefined, occasionally the audio video controller
            // will call this function before the first index is received
            preferences = dummyPreferences.build();
        }
        return preferences;
    }
    wantsAllTemporalLayersInIndex() {
        return true;
    }
}
$d25753c9fcfe205f$var$VideoPriorityBasedPolicy.DEFAULT_BANDWIDTH_KBPS = 2800;
$d25753c9fcfe205f$var$VideoPriorityBasedPolicy.STARTUP_PERIOD_MS = 6000;
$d25753c9fcfe205f$var$VideoPriorityBasedPolicy.LARGE_RATE_CHANGE_TRIGGER_PERCENT = 20;
$d25753c9fcfe205f$var$VideoPriorityBasedPolicy.TARGET_RATE_CHANGE_TRIGGER_PERCENT = 15;
$d25753c9fcfe205f$var$VideoPriorityBasedPolicy.LOW_BITRATE_THRESHOLD_KBPS = 300;
$d25753c9fcfe205f$var$VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_PROBE_MS = 5000;
$d25753c9fcfe205f$var$VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_SUBSCRIBE_MS = 2000;
// We apply exponentional backoff to probe attempts if they do not
// succeed, so we need to set a reasonable maximum.
$d25753c9fcfe205f$var$VideoPriorityBasedPolicy.MAX_HOLD_BEFORE_PROBE_MS = 30000;
$d25753c9fcfe205f$var$VideoPriorityBasedPolicy.MAX_ALLOWED_PROBE_TIME_MS = 60000;
// Occasionally we see that on unpause or upgrade we see a single packet lost
// or two, even in completely unconstrained scenarios. We should look into
// why this occurs on the backend, but for now we require a non-trivial
// amount of packets lost to fail the probe. These could also be from
// other senders given we don't yet use TWCC.
$d25753c9fcfe205f$var$VideoPriorityBasedPolicy.SPURIOUS_PACKET_LOST_THRESHOLD = 2;
// See usage
$d25753c9fcfe205f$var$VideoPriorityBasedPolicy.USED_BANDWIDTH_OVERRIDE_BUFFER_KBPS = 100;
module.exports.default = $d25753c9fcfe205f$var$VideoPriorityBasedPolicy;

});
parcelRegister("dGcvr", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * [[VideoSource]] contains the information of a video source.
 */ class $9f58e60fd7585c89$var$VideoSource {
}
module.exports.default = $9f58e60fd7585c89$var$VideoSource;

});

parcelRegister("lcZ1l", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $f70a0d6d164f1f3d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $f70a0d6d164f1f3d$var$ServerSideNetworkAdaption_1 = $f70a0d6d164f1f3d$var$__importDefault((parcelRequire("bRvcN")));
/**
 * [[VideoPriorityBasedPolicyConfig]] contains the network issue response delay and network issue recovery delay.
 */ class $f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig {
    /** Initializes a [[VideoPriorityBasedPolicyConfig]] with the network event delays.
     *
     * @deprecated These values are not used when server side network adaptation is used, which will
     * become the default in the future. Therefore these constructors
     * will be deprecated and removed in a later releases.
     *
     * @param networkIssueResponseDelayFactor Delays before reducing subscribed video bitrate. Input should be a value between 0 and 1.
     * @param networkIssueRecoveryDelayFactor Delays before starting to increase bitrates after a network event and
     * delays between increasing video bitrates on each individual stream. Input should be a value between 0 and 1.
     */ constructor(networkIssueResponseDelayFactor = 0, networkIssueRecoveryDelayFactor = 0){
        this.networkIssueResponseDelayFactor = networkIssueResponseDelayFactor;
        this.networkIssueRecoveryDelayFactor = networkIssueRecoveryDelayFactor;
        this.currentNetworkEvent = 0 /* NetworkEvent.Stable */ ;
        this.bandwidthDecreaseTimestamp = 0; // the last time bandwidth decreases
        this.referenceBitrate = 0;
        /**
         * Additional server side features to be enabled for network adaption. The only currently
         * recommended value is `ServerSideNetworkAdaption.BandwidthProbingAndRemoteVideoQualityAdaption`
         */ this.serverSideNetworkAdaption = $f70a0d6d164f1f3d$var$ServerSideNetworkAdaption_1.default.BandwidthProbingAndRemoteVideoQualityAdaption;
        if (networkIssueResponseDelayFactor < 0) networkIssueResponseDelayFactor = 0;
        else if (networkIssueResponseDelayFactor > 1) networkIssueResponseDelayFactor = 1;
        this.networkIssueResponseDelayFactor = networkIssueResponseDelayFactor;
        if (networkIssueRecoveryDelayFactor < 0) networkIssueRecoveryDelayFactor = 0;
        else if (networkIssueRecoveryDelayFactor > 1) networkIssueRecoveryDelayFactor = 1;
        this.networkIssueRecoveryDelayFactor = networkIssueRecoveryDelayFactor;
    }
    // determine if subscribe is allowed based on network issue/recovery delays
    allowSubscribe(numberOfParticipants, currentEstimated) {
        let timeBeforeAllowSubscribeMs = 0;
        const previousNetworkEvent = this.currentNetworkEvent;
        if (currentEstimated > this.referenceBitrate) {
            // if bw increases
            this.currentNetworkEvent = 2 /* NetworkEvent.Increase */ ;
            this.referenceBitrate = currentEstimated;
            return true;
        } else if (currentEstimated < this.referenceBitrate) {
            // if bw decreases, we use response delay
            this.currentNetworkEvent = 1 /* NetworkEvent.Decrease */ ;
            timeBeforeAllowSubscribeMs = this.getSubscribeDelay(this.currentNetworkEvent, numberOfParticipants);
            if (previousNetworkEvent !== 1 /* NetworkEvent.Decrease */ ) this.bandwidthDecreaseTimestamp = Date.now();
            else if (Date.now() - this.bandwidthDecreaseTimestamp > timeBeforeAllowSubscribeMs) {
                this.referenceBitrate = currentEstimated;
                return true;
            }
            return false;
        } else {
            this.currentNetworkEvent = 0 /* NetworkEvent.Stable */ ;
            return false;
        }
    }
    // convert network event delay factor to actual delay in ms
    getSubscribeDelay(event, numberOfParticipants) {
        // left and right boundary of the delay
        let subscribeDelay = $f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig.MINIMUM_DELAY_MS;
        const range = $f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig.MAXIMUM_DELAY_MS - $f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig.MINIMUM_DELAY_MS;
        const responseFactor = this.networkIssueResponseDelayFactor;
        switch(event){
            case 1 /* NetworkEvent.Decrease */ :
                // we include number of participants here since bigger size of the meeting will generate higher bitrate
                subscribeDelay += range * responseFactor * (1 + numberOfParticipants / 10);
                subscribeDelay = Math.min($f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig.MAXIMUM_DELAY_MS, subscribeDelay);
                break;
        }
        return subscribeDelay;
    }
}
$f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig.MINIMUM_DELAY_MS = 2000;
$f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig.MAXIMUM_DELAY_MS = 8000;
$f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig.Default = new $f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig(0, 0);
$f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig.UnstableNetworkPreset = new $f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig(0, 1);
$f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig.StableNetworkPreset = new $f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig(1, 0);
module.exports.default = $f70a0d6d164f1f3d$var$VideoPriorityBasedPolicyConfig;

});



parcelRegister("b1EaC", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $806ef2aaba0cf10d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $59RLu = parcelRequire("59RLu");

var $aJA5z = parcelRequire("aJA5z");

var $euItc = parcelRequire("euItc");

const $806ef2aaba0cf10d$var$DefaultBrowserBehavior_1 = $806ef2aaba0cf10d$var$__importDefault((parcelRequire("e2TuV")));

const $806ef2aaba0cf10d$var$NoOpLogger_1 = $806ef2aaba0cf10d$var$__importDefault((parcelRequire("a39G0")));

var $9UH7r = parcelRequire("9UH7r");

const $806ef2aaba0cf10d$var$Versioning_1 = $806ef2aaba0cf10d$var$__importDefault((parcelRequire("c0dn0")));

const $806ef2aaba0cf10d$var$CanvasVideoFrameBuffer_1 = $806ef2aaba0cf10d$var$__importDefault((parcelRequire("ag7ui")));

var $b9o6K = parcelRequire("b9o6K");

var $k8ltF = parcelRequire("k8ltF");

var $2CaPE = parcelRequire("2CaPE");

var $iUrlb = parcelRequire("iUrlb");
/**
 * [[VideoFxProcessor]] Mechanism that drives the data transformation
 * of individual video frames to apply ML-based background blur and
 * background replacement effects on the video stream.
 */ class $806ef2aaba0cf10d$var$VideoFxProcessor {
    /**
     * Initializes a new instance of [[VideoFxProcessor]] with a default NoOp [[VideoFxConfig]].
     * @param logger
     * @param processingBudgetPerFrame throttling constraint for processing
     * @param eventController EventController object to manage events
     */ constructor(logger, processingBudgetPerFrame = $2CaPE.RESOURCE_CONSTRAINTS.DEFAULT_PROCESSING_BUDGET_PER_FRAME, eventController){
        this.logger = logger;
        // Configure the buffer for where output frames will be placed
        this.outputCanvas = document.createElement('canvas');
        this.canvasVideoFrameBuffer = new $806ef2aaba0cf10d$var$CanvasVideoFrameBuffer_1.default(this.outputCanvas);
        this.videoFxSpec = $2CaPE.DEFAULT_VIDEO_FX_SPEC;
        // Validate the inputted resource constraint
        try {
            this.validateProcessingBudgetPerFrame(processingBudgetPerFrame);
        } catch (error) {
            this.logger.error(error);
            throw new Error(`Cannot instantiate VideoFxProcessor due to invalid ` + `processingBudgetPerFrame of ${processingBudgetPerFrame}`);
        }
        if (eventController) this.eventController = eventController;
        // Create a basic effectConfig (noOp)
        this.effectConfig = {
            backgroundBlur: {
                isEnabled: false,
                strength: 'low'
            },
            backgroundReplacement: {
                isEnabled: false,
                backgroundImageURL: null,
                defaultColor: 'black'
            }
        };
        // This promise object will be used to coordinate timing of sending/receiving frames from engine
        this.segmentationRequestPromise = new $b9o6K.DeferredPromise();
        // Configure resource management for the segmentation frequency
        this.segmentationRateManager = new $iUrlb.VideoFxSegmentationRateManager(this.logger, processingBudgetPerFrame);
        // Configure default streamParameters
        this.streamParameters = {
            framerate: $2CaPE.DEFAULT_STREAM_PARAMETERS.FRAMES_PER_SECOND,
            width: $2CaPE.DEFAULT_STREAM_PARAMETERS.WIDTH_IN_PIXEL,
            height: $2CaPE.DEFAULT_STREAM_PARAMETERS.HEIGHT_IN_PIXEL,
            channels: $2CaPE.DEFAULT_STREAM_PARAMETERS.CHANNEL_COUNT
        };
        // Determine if shared array buffer can be used to transfer frame data from
        // main thread to web worker thread
        if ($806ef2aaba0cf10d$var$VideoFxProcessor.isSharedArrayBufferSupported) {
            this.sharedImageBuffer = new SharedArrayBuffer($2CaPE.SEGMENTATION_MODEL.WIDTH_IN_PIXELS * $2CaPE.SEGMENTATION_MODEL.HEIGHT_IN_PIXELS * this.streamParameters.channels);
            this.sharedImageData = new Uint8ClampedArray(this.sharedImageBuffer);
        }
        this.logger.info(`VideoFx supports Shared Array Buffer: ` + `${$806ef2aaba0cf10d$var$VideoFxProcessor.isSharedArrayBufferSupported}`);
        // Determine if filter operations are supported
        this.canvasOpsManager = new $k8ltF.VideoFxCanvasOpsManager(this.streamParameters, this.outputCanvas);
        // Configure the final transformed frame location
        this.outputCanvas.width = this.streamParameters.width;
        this.outputCanvas.height = this.streamParameters.height;
        // Set an empty mask at initialization
        this.segmentationMask = new ImageData(this.streamParameters.width, this.streamParameters.height);
        this.logger.info(`VideoFxProcessor instantiated with a processingBudgetPerFrame of ${processingBudgetPerFrame}`);
    }
    /**
     * Apply the [[VideoFxProcessor]]'s specialized effect onto the frame contained by
     * the buffer parameter.
     * @param buffers
     * @returns buffers
     */ async process(buffers) {
        // Note: Required method through implementation of VideoFrameProcessor.
        return buffers;
    }
    /**
     * Process an input stream and apply the visual effects specified in this effectConfig.
     * @param buffers the input stream
     * @returns an output stream of VideoFrameBuffer
     */ async fxProcess(buffers) {
        // Process our input image into raw input data
        const inputCanvas = buffers[0].asCanvasElement();
        // We must confirm that our incoming stream did not change it's parameters
        if (this.didStreamParametersChange(inputCanvas)) await this.adjustProcessorForNewStreamParameters(inputCanvas);
        // Decide to use the existing segmentation or perform a new segmentation
        try {
            await this.manageSegmentationMask(inputCanvas);
        } catch (error) {
            this.logger.error(error);
            throw new Error(`Video stream could not be processed`);
        }
        // Render a final image using the input canvas and the segmentation mask
        await this.renderer.render(inputCanvas, this.segmentationMask);
        // Send canvas video frame buffer to rest of processor pipeline
        buffers[0] = this.canvasVideoFrameBuffer;
        return buffers;
    }
    /**
     * Perform a process call that just returns the input stream
     * @param buffers the input stream
     * @returns an output stream of VideoFrameBuffer
     */ async noOpProcess(buffers) {
        return buffers;
    }
    /**
     * Check if the stream dimensions/parameters have changed.
     * @param stream frame from current video stream about to be processed
     * @returns boolean representing if the stream parameters changed
     */ didStreamParametersChange(stream) {
        return stream.width !== this.streamParameters.width || stream.height !== this.streamParameters.height;
    }
    /**
     * Adjust the videoFxProcessor to handle new stream parameters.
     * @param stream frame from current video stream about to be processed
     */ async adjustProcessorForNewStreamParameters(stream) {
        // Update the stored streamParameters
        this.streamParameters.width = stream.width;
        this.streamParameters.height = stream.height;
        // Notify the canvas ops manager to reconfigure pipeline dimensions
        await this.canvasOpsManager.configureForStreamParameters(this.streamParameters);
        // Configure the renderer to work with new stream dimensions
        await this.renderer.configure(this.streamParameters.width, this.streamParameters.height, this.effectConfig);
    }
    /**
     * Clean up any excess memory that has been allocated by [[VideoFxProcessor]].
     */ async destroy() {
        // Note: Required method through implementation of VideoFrameProcessor.
        this.canvasVideoFrameBuffer.destroy();
        if (this.fxLibScript && this.fxLibScript.parentNode) this.fxLibScript.parentNode.removeChild(this.fxLibScript);
        if (this.engineWorker) {
            // Post message to destroy all assets
            this.destroyedAssetsPromise = new $b9o6K.DeferredPromise();
            this.engineWorker.postMessage({
                msg: $2CaPE.WORKER_MSG.DESTROY_ASSETS_REQUEST
            });
            // Wait until all the assets are destroyed
            await this.destroyedAssetsPromise.getPromise();
            // Close the engine worker
            this.engineWorker.postMessage({
                msg: $2CaPE.WORKER_MSG.CLOSE_WORKER_REQUEST
            });
        }
        this.logger.info(`VideoFxProcessor destroyed.`);
    }
    /**
     * Manage the segmentation mask that is used to generate a final frame. This function
     * will calculate whether or not to re-generate a segmenation and also monitor
     * how computationally expensive the rate of segmentation are.
     * @param inputCanvas canvas to be used for segmentation
     */ async manageSegmentationMask(inputCanvas) {
        try {
            this.segmentationRateManager.submitFrame();
            if (this.segmentationRateManager.shouldApplySegmentation()) {
                // Perform a segmentation inference on the downsampled current video frame
                this.segmentationRateManager.startSegmentation();
                const inferenceInputImageData = this.canvasOpsManager.getInferenceInputData(inputCanvas);
                this.segmentationMask = await this.generateSegmentationMask(inferenceInputImageData);
                this.segmentationRateManager.completeSegmentation();
            }
        } catch (error) {
            this.logger.error(error.toString());
            throw new Error(`Can not properly manage the returned segmentation mask`);
        }
    }
    /**
     * Generate a segmentation mask from the input frame.
     * @param inferenceImageData
     * @returns image data representing segmenation mask
     */ async generateSegmentationMask(inferenceImageData) {
        if ($806ef2aaba0cf10d$var$VideoFxProcessor.isSharedArrayBufferSupported) {
            this.sharedImageData.set(inferenceImageData.data);
            this.engineWorker.postMessage({
                msg: $2CaPE.WORKER_MSG.PERFORM_SEGMENTATION_SAB_REQUEST,
                payload: this.sharedImageBuffer
            });
        } else this.engineWorker.postMessage({
            msg: $2CaPE.WORKER_MSG.PERFORM_SEGMENTATION_REQUEST,
            payload: inferenceImageData
        }, [
            inferenceImageData.data.buffer
        ]);
        // Wait for input image to be returned from VideoFxEngine
        try {
            const segmentationMask = await this.segmentationRequestPromise.getPromise();
            return segmentationMask;
        } catch (error) {
            this.logger.error(error.toString());
            throw new Error(`Segmentation mask could not be generated`);
        }
    }
    /**
     * Make a deep copy of the VideoFxConfig passed in. Needs to be updated if additional
     * fields are added to VideoFxConfig.
     * @param effectConfig
     * @returns newEffectConfig
     */ cloneConfigFrom(effectConfig) {
        return {
            backgroundBlur: {
                isEnabled: effectConfig.backgroundBlur.isEnabled,
                strength: effectConfig.backgroundBlur.strength
            },
            backgroundReplacement: {
                isEnabled: effectConfig.backgroundReplacement.isEnabled,
                backgroundImageURL: effectConfig.backgroundReplacement.backgroundImageURL,
                defaultColor: effectConfig.backgroundReplacement.defaultColor
            }
        };
    }
    setVideoFxSpec(videoFxSpec) {
        if (videoFxSpec.paths) this.videoFxSpec.paths = videoFxSpec.paths;
    }
    /**
     * Update the [[VideoFxProcessor]] to apply a new set of effects by updating the instance property
     * [[VideoFxConfig]]. If the effectConfig parameter fails validation, an error is thrown and there is
     * no update.
     * @param effectConfig updated [[VideoFxConfig]] with new video effects
     */ async setEffectConfig(effectConfig) {
        if (this.sameVideoFxConfig(effectConfig, this.effectConfig)) return;
        const newEffectConfig = this.cloneConfigFrom(effectConfig);
        // Validate the effect config
        try {
            await this.validateEffectConfig(newEffectConfig);
        } catch (error) {
            this.logger.error(error.toString());
            throw new Error(`Provided effect config is invalid, not updating VideoFxProcessor`);
        }
        // Configure background replacement image/canvas
        if (newEffectConfig.backgroundReplacement.isEnabled) {
            await this.canvasOpsManager.loadReplacementBackground(newEffectConfig);
            await this.renderer.setBackgroundReplacementCanvas(this.canvasOpsManager.getBackgroundReplacementCanvas());
        }
        // Configure the renderer to implement the desired effect configuration
        await this.renderer.configure(this.streamParameters.width, this.streamParameters.height, newEffectConfig);
        // Can now officially set the effect config since the rest of the processor is
        // configured for the new effects
        this.effectConfig = newEffectConfig;
        // If no effects are enabled, run no op process, otherwise run the effect based processing
        if (!this.effectConfig.backgroundBlur.isEnabled && !this.effectConfig.backgroundReplacement.isEnabled) this.process = this.noOpProcess;
        else this.process = this.fxProcess;
        this.logger.info(`VideoFxProcessor effect configuration updated to: ${JSON.stringify(this.effectConfig)}`);
        if (this.eventController) this.publishVideoFxConfigEvent();
    }
    /**
     * Confirm that the config consists of valid values.
     * @param config that will be validated
     */ async validateEffectConfig(config) {
        // We confirm that both blur and replacement are not enabled due to builder error
        if (config.backgroundBlur.isEnabled && config.backgroundReplacement.isEnabled) throw new Error(`Invalid VideoFx configuration: Background Blur and Background Replacement ` + `can not both be enabled`);
        else if (config.backgroundReplacement.isEnabled) await this.validateReplacementConfig(config);
    // backgroundBlur does not need to be validated, as valid blurStrength value
    // is checked at compile time.
    }
    /**
     * Confirm that the config consists of valid values for background replacement.
     * @param config that will be validated for background replacement
     */ async validateReplacementConfig(config) {
        if (config.backgroundReplacement.backgroundImageURL && config.backgroundReplacement.defaultColor) throw new Error(`Invalid VideoFx configuration: Background Replacement can not have both an ` + `image URL and default color`);
        if (!config.backgroundReplacement.backgroundImageURL && !config.backgroundReplacement.defaultColor) throw new Error(`Invalid VideoFx configuration: Background Replacement image URL and default ` + `can not both be null/undefined`);
        // Confirm that the image properly loads
        try {
            if (config.backgroundReplacement.backgroundImageURL) await this.canvasOpsManager.loadImage(config.backgroundReplacement.backgroundImageURL);
        } catch (error) {
            this.logger.error(error.toString());
            throw new Error(`Invalid VideoFx configuration: backgroundImageURL failed to load`);
        }
        const defaultColor = config.backgroundReplacement.defaultColor;
        // Confirm that defaultColor is a valid color for fillStyle. We support black by default.
        if (defaultColor && defaultColor !== 'black' && defaultColor !== '#000000' && defaultColor !== '#000') {
            // First validate hexadecimal color code
            if (defaultColor.includes('#')) {
                const hexRegex = new RegExp(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);
                if (!hexRegex.test(defaultColor)) throw new Error(`Invalid hexadecimal color code for default replacement ` + `background: ${defaultColor}`);
            }
            const testColorCanvas = document.createElement('canvas');
            const testColorCtx = testColorCanvas.getContext('2d');
            // fillStyle is #000000 black by default
            const prevFillStyle = testColorCtx.fillStyle;
            testColorCtx.fillStyle = defaultColor;
            // fillStyle will not change after assignment if invalid value is used
            /* istanbul ignore next */ if (testColorCtx.fillStyle === prevFillStyle) throw new Error(`Invalid color for default replacement background: ${defaultColor}`);
        }
    }
    /**
     * Confirm that the processingBudgePerFrame constraint holds valid values.
     * @param constraint to be validated
     */ validateProcessingBudgetPerFrame(processingBudgetPerFrame) {
        if (processingBudgetPerFrame < $2CaPE.RESOURCE_CONSTRAINTS.MIN_PROCESSING_BUDGET || processingBudgetPerFrame > $2CaPE.RESOURCE_CONSTRAINTS.MAX_PROCESSING_BUDGET) throw new Error(`Invalid resource constraint: cycle percentage must be within ` + `range of ${$2CaPE.RESOURCE_CONSTRAINTS.MIN_PROCESSING_BUDGET} and ` + `${$2CaPE.RESOURCE_CONSTRAINTS.MAX_PROCESSING_BUDGET}`);
    }
    /**
     * Loads all of the assets that are associated with the stored effectConfig.
     */ async loadAssets() {
        this.logger.info(`Loading required assets for the VideoFxProcessor`);
        try {
            const videoFxAssetParams = this.getVideoFxAssetParams();
            await this.loadEngineWorker(videoFxAssetParams);
            await this.buildEngine(videoFxAssetParams);
            await this.loadFxLib(videoFxAssetParams);
            // @ts-ignore
            this.renderer = constructRenderer($2CaPE.SEGMENTATION_MODEL.WIDTH_IN_PIXELS, $2CaPE.SEGMENTATION_MODEL.HEIGHT_IN_PIXELS, this.effectConfig, this.outputCanvas);
        } catch (error) {
            // NOTE: when we update to es2022, throw errors that are chained together
            this.logger.error(error.toString());
            throw new Error(`Failed to load necessary assets for the VideoFxProcessor`);
        }
        this.logger.info(`Finished loading of essential VideoFxProcessor assets.`);
    }
    /**
     * Determines the current set of specifications that define the current SDK version.
     * @returns an [[VideoFxAssetParams]] object defining the parameters of the
     * current SDK
     */ getVideoFxAssetParams() {
        const defaultAssetSpec = (0, $9UH7r.getDefaultAssetSpec)();
        const videoFxAssetParams = {
            assetGroup: defaultAssetSpec.assetGroup,
            revisionID: defaultAssetSpec.revisionID,
            sdk: encodeURIComponent($806ef2aaba0cf10d$var$Versioning_1.default.sdkVersion),
            ua: encodeURIComponent($806ef2aaba0cf10d$var$Versioning_1.default.sdkUserAgentLowResolution)
        };
        return videoFxAssetParams;
    }
    /**
     * Generate a final path to an asset belonging to current version of SDK.
     * @param basePath Base of the path that will be used to generate a final path
     * @param videoFxAssetParams Parameters of the current SDK version
     * @returns A final path specific to an asset belonging to current SDK
     * version
     */ getPathFromVideoFxAssetParams(basePath, videoFxAssetParams) {
        const path = new URL(basePath);
        for (const [key, value] of Object.entries(videoFxAssetParams))if (value !== undefined) {
            // Encode the key and value into uri format
            const uriEncodedKey = encodeURIComponent(key);
            const uriEncodedValue = encodeURIComponent(value);
            // Set encoded key/value as query params
            path.searchParams.set(uriEncodedKey, uriEncodedValue);
        }
        return path.toString();
    }
    /**
     * Fetch and then load the engine worker into a web-worker.
     */ async loadEngineWorker(videoFxAssetParams) {
        // The engine worker will always be a required asset for the VideoFxProcessor
        try {
            // Determine engine worker path from versioning of the SDK worker
            const engineWorkerPath = this.getPathFromVideoFxAssetParams(this.videoFxSpec.paths.cdnBasePath + this.videoFxSpec.paths.workerPath, videoFxAssetParams);
            // Load the worker that will communicate with the VideoFxEngine
            this.engineWorker = await (0, $aJA5z.loadWorker)(engineWorkerPath, 'VideoFxEngineWorker', {}, null);
            this.logger.info(`Successfully loaded the VideoFxProcessor's engine worker`);
            // Configure a handler to deal with messages received form the engine worker
            this.engineWorker.addEventListener('message', (event)=>this.engineWorkerReceiver(event));
        } catch (error) {
            this.logger.error(error.toString());
            throw new Error(`Failed to load the VideoFxProcessor's engine worker`);
        }
    }
    /**
     * Build the videoFxEngine.
     * @param videoFxAssetParams [[VideoFxAssetParams]] defining current version of SDK
     */ async buildEngine(videoFxAssetParams) {
        // Instantiate the deferred promise so we can wait for the worker to
        // return a completion message
        this.buildEnginePromise = new $b9o6K.DeferredPromise();
        // Send a message via the engine worker to instantiate
        // the video fx engine
        this.engineWorker.postMessage({
            msg: $2CaPE.WORKER_MSG.BUILD_ENGINE_REQUEST,
            payload: {
                cdnBasePath: this.videoFxSpec.paths.cdnBasePath,
                sdkVersioningParams: videoFxAssetParams
            }
        });
        // Wait until the engine finishes building
        try {
            await this.buildEnginePromise.getPromise();
        } catch (error) {
            this.logger.error(error.toString());
            throw new Error(`Failed to instantiate the VideoFxEngine`);
        }
    }
    /**
     * Loads the Video Fx library to drive video post-processing, given the versioning
     * of the SDK worker from the VideoFxAssetParams interface passed as a parameter.
     * @param videoFxAssetParams
     */ async loadFxLib(videoFxAssetParams) {
        // Determine engine worker path from versioning of the SDK worker
        const fxLibPath = this.getPathFromVideoFxAssetParams(this.videoFxSpec.paths.cdnBasePath + this.videoFxSpec.paths.fxLibPath, videoFxAssetParams);
        const WORKER_FETCH_OPTIONS = {
            method: 'GET',
            mode: 'cors',
            credentials: 'omit',
            redirect: 'follow',
            referrerPolicy: 'no-referrer'
        };
        try {
            const res = await (0, $59RLu.fetchWithBehavior)(fxLibPath, WORKER_FETCH_OPTIONS, {});
            if (!res.ok) throw new Error('Fetch failed.');
            const blobURL = window.URL.createObjectURL(await res.blob());
            await new Promise((resolve, reject)=>{
                this.fxLibScript = document.createElement('script');
                this.fxLibScript.setAttribute('src', blobURL);
                this.fxLibScript.setAttribute('type', 'module');
                this.fxLibScript.setAttribute('async', 'false');
                this.fxLibScript.addEventListener('load', resolve);
                this.fxLibScript.addEventListener('error', reject);
                document.body.appendChild(this.fxLibScript);
            });
        } catch (error) {
            this.logger.error(error.toString());
            throw new Error(`Failed to load the fxlib`);
        }
    }
    /**
     * Getter for the current [[VideoFxConfig]] maintained as an instance property of
     * [[VideoFxProcessor]].
     * @returns currentEffectConfig
     */ getEffectConfig() {
        return this.cloneConfigFrom(this.effectConfig);
    }
    /**
     * Receives messages from the engine worker and then delegates
     * the proper response to a different function.
     * @param event notification to be received from the engine worker
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    engineWorkerReceiver(event) {
        const msg = event.data;
        switch(msg.msg){
            case $2CaPE.WORKER_MSG.BUILD_ENGINE_RESPONSE:
                this.settleEngineBuildPromise(msg.payload);
                break;
            case $2CaPE.WORKER_MSG.PERFORM_SEGMENTATION_RESPONSE:
                this.settleSegmentationPromise(msg.payload.output);
                break;
            case $2CaPE.WORKER_MSG.PERFORM_SEGMENTATION_SAB_RESPONSE:
                this.settleSegmentationPromiseSAB();
                break;
            case $2CaPE.WORKER_MSG.DESTROY_ASSETS_RESPONSE:
                this.destroyedAssetsPromise.resolvePromise();
                break;
            default:
                this.logger.info(`VideoFx worker received unknown event msg: ${JSON.stringify(msg)}`);
                break;
        }
    }
    /**
     * Handle the message returned from the VideoFX Engine worker to
     * settle (resolve/reject) the promise associated with initializing the engine.
     * @param buildStatus status of the final result of building the engine
     */ settleEngineBuildPromise(buildStatus) {
        // Resolve or reject the engineInstantiatedPromise depending on success
        // of instatiation
        if (buildStatus !== $2CaPE.SEGMENTATION_MODEL.LOAD_SUCCESS) this.buildEnginePromise.rejectPromise(new Error(`Failed to build VideoFxProcessor's engine`));
        else {
            this.logger.info(`Successfully built the VideoFxEngine`);
            this.buildEnginePromise.resolvePromise();
        }
    }
    /**
     * Handle the received segmentation mask and then resolve/reject the promise to notify
     * the main processing function to prepare for the next frame (using ImageData transfer).
     * @param segmentationMask
     */ settleSegmentationPromise(segmentationMask) {
        // Resolve or reject the frameRequestPromise depending on the success of transforming
        // the input image
        if (segmentationMask) // Resolve segmentation promise with mask data
        this.segmentationRequestPromise.resolveAndReplacePromise(segmentationMask);
        else this.segmentationRequestPromise.rejectAndReplacePromise(new Error(`Failed to perform a segmentation on the input image`));
    }
    /**
     * Handle the received segmentation mask and then resolve/reject the promise to notify
     * the main processing function to prepare for the next frame (using shared array buffer).
     */ settleSegmentationPromiseSAB() {
        try {
            // Resolve segmentation promise with mask data
            const transformedImageData = new ImageData(new Uint8ClampedArray(this.sharedImageData), $2CaPE.SEGMENTATION_MODEL.WIDTH_IN_PIXELS, $2CaPE.SEGMENTATION_MODEL.HEIGHT_IN_PIXELS);
            this.segmentationRequestPromise.resolveAndReplacePromise(transformedImageData);
        } catch (_a) {
            this.segmentationRequestPromise.rejectAndReplacePromise(new Error(`Failed to perform a segmentation with a shared ` + `array buffer on the input image`));
        }
    }
    /**
     * Function that will convert the VideoFxProcessor into a NoOp version of itself.
     * Will only return input video stream and not use worker, engine, or segmentation
     * model.
     */ setToNoOpProcess() {
        this.process = this.noOpProcess;
    }
    /**
     * Detect client environment to determine if the [[VideoFxProcessor]] is supported.
     * @param logger to record/report events of checking processor support
     * @param attemptAssetLoad will also fetch and build all relevant components of the
     * processor to ensure end to end feature is supported
     * @returns a boolean promise that will resolve to true if supported and false if not
     */ static async isSupported(logger = new $806ef2aaba0cf10d$var$NoOpLogger_1.default(), attemptAssetLoad = true) {
        // allCheckedPassed represents the state of support and we assume it is true until checkEnv tells us otherwise
        let allCheckedPassed = true;
        // checkEnv evaluates a boolean condition, badPromiseCondition, that when true would cause isSupported to fail.
        // We also log a corresponding error message for each support check so a builder can see what is still needed
        // in their environment.
        const checkEnv = (badPromiseCondition, message)=>{
            if (badPromiseCondition) {
                logger.info(message);
                allCheckedPassed = false;
            }
        };
        // Get context for operating environment
        // could not figure out how to remove globalThis to test failure case
        /* istanbul ignore next */ checkEnv(typeof globalThis === 'undefined', 'Browser does not have globalThis.');
        // Check workers are supported
        checkEnv(!(0, $euItc.supportsWorker)(globalThis, logger), 'Browser does not support web workers.');
        // Check wasm is supported
        checkEnv(!(0, $euItc.supportsWASM)(globalThis, logger), 'Browser does not support wasm.');
        // Check webgl2 is supported
        checkEnv(!document.createElement('canvas').getContext('webgl2'), 'Browser does not support webgl.');
        // Check browser support
        const browserBehavior = new $806ef2aaba0cf10d$var$DefaultBrowserBehavior_1.default();
        checkEnv(!browserBehavior.isVideoFxSupportedBrowser(), 'Browser is unsupported for VideoFxProcessor');
        // checkProcessor first checks if we can load all required assets and then tests VideoFxProcessor.
        const checkProcessor = async ()=>{
            if (attemptAssetLoad) try {
                const testFxProcessor = new $806ef2aaba0cf10d$var$VideoFxProcessor(logger);
                await testFxProcessor.loadAssets();
                await testFxProcessor.destroy(); // destroy assets we just temp loaded
            } catch (_a) {
                logger.info('Browser environment is unable to access the required external assets.');
                return Promise.resolve(false);
            }
            return Promise.resolve(true);
        };
        return Promise.resolve(allCheckedPassed ? await checkProcessor() : false);
    }
    /**
     * Create a [[VideoFxProcessor]] that has loaded its necessary components, ready to instantly
     * process a video stream with the effects specified in the passed [[VideoFxConfig]].
     *
     * ** NOTICE **
     *
     * Amazon Chime background blur 2.0 and background replacement 2.0
     * Copyright 2023 Amazon.com, Inc. or its affiliates. All Rights Reserved.
     *
     * By installing or using this package, you agree to the AWS Customer Agreement, AWS Service Terms, and AWS Privacy Notice.
     * If you already have an AWS Customer Agreement, you agree that the terms of that agreement govern your download and use of this package.
     * This package is provided as AWS Content and subject to the AWS Customer agreement and any other agreement with AWS governing your use of
     * AWS services.
     */ static async create(logger, effectConfig, processingBudgetPerFrame = $2CaPE.RESOURCE_CONSTRAINTS.DEFAULT_PROCESSING_BUDGET_PER_FRAME, spec) {
        // Create the videoFxProcessor
        const videoFxProcessor = new $806ef2aaba0cf10d$var$VideoFxProcessor(logger, processingBudgetPerFrame);
        if (spec) videoFxProcessor.setVideoFxSpec(spec);
        // Load the required assets and set desired effect config
        try {
            await videoFxProcessor.loadAssets();
            await videoFxProcessor.setEffectConfig(effectConfig);
            return videoFxProcessor;
        } catch (error) {
            logger.error(error.toString());
            // If we fail loading an essential asset from above, we overwrite our
            // processor to process with no operations or effects
            videoFxProcessor.setToNoOpProcess();
            throw new Error(`VideoFxProcessor built with support for only NoOp processing`);
        }
    }
    /** @internal */ setEventController(eventController) {
        /*
        if this is a first time we set the eventController, need to publish the current VideoFxConfig.
        Otherwise, just set the eventController.
        */ if (this.eventController) this.eventController = eventController;
        else {
            this.eventController = eventController;
            this.publishVideoFxConfigEvent();
        }
    }
    publishVideoFxConfigEvent() {
        const mediaFXEventAttibutes = {
            backgroundBlurEnabled: this.effectConfig.backgroundBlur.isEnabled.toString(),
            backgroundBlurStrength: this.effectConfig.backgroundBlur.strength,
            backgroundReplacementEnabled: this.effectConfig.backgroundReplacement.isEnabled.toString(),
            backgroundFilterVersion: 2
        };
        this.eventController.publishEvent('backgroundFilterConfigSelected', mediaFXEventAttibutes);
    }
    sameVideoFxConfig(firstConfig, secondConfig) {
        return firstConfig.backgroundBlur.isEnabled === secondConfig.backgroundBlur.isEnabled && firstConfig.backgroundBlur.strength === secondConfig.backgroundBlur.strength && firstConfig.backgroundReplacement.backgroundImageURL === secondConfig.backgroundReplacement.backgroundImageURL && firstConfig.backgroundReplacement.defaultColor === secondConfig.backgroundReplacement.defaultColor && firstConfig.backgroundReplacement.isEnabled === secondConfig.backgroundReplacement.isEnabled;
    }
}
$806ef2aaba0cf10d$var$VideoFxProcessor.isSharedArrayBufferSupported = typeof SharedArrayBuffer !== 'undefined';
module.exports.default = $806ef2aaba0cf10d$var$VideoFxProcessor;

});
parcelRegister("b9o6K", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DeferredPromise = void 0;
/**
 * [[DeferredPromise]] Is a wrapper around a javascript promise that
 * will allow us to resolve and reject the promise from outside of the
 * promise's executor block.
 */ class $81e33c46592f2662$var$DeferredPromise {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Get the promise associated with the DeferredPromise.
     * @returns Promise<T>
     */ getPromise() {
        return this.promise;
    }
    /**
     * Resolve this.promise.
     */ resolvePromise(resolveParameter) {
        this.resolve(resolveParameter);
    }
    /**
     * Resolve this.promise with a resolveParameter. Then,
     * replace the resolved promise with a new promise.
     */ resolveAndReplacePromise(resolveParameter) {
        this.resolve(resolveParameter);
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Reject this.promise.
     */ rejectPromise(rejectError) {
        this.reject(rejectError);
    }
    /**
     * Reject this.promise with a reject parameter. Then,
     * replace the rejected promise with a new promise.
     */ rejectAndReplacePromise(rejectError) {
        this.reject(rejectError);
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
module.exports.DeferredPromise = $81e33c46592f2662$var$DeferredPromise;

});

parcelRegister("k8ltF", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VideoFxCanvasOpsManager = void 0;

var $2CaPE = parcelRequire("2CaPE");
/**
 * [[VideoFxCanvasOpsManager]] Mechanism drives the canvas based operations
 * for the VideoFxProcessor. This includes input stream resizing to segmentation model
 * dimensions and managing the canvas loading for background replacement.
 */ class $ea8536f9c14d798c$var$VideoFxCanvasOpsManager {
    constructor(streamParameters, outputCanvas){
        this.streamParameters = streamParameters;
        this.outputCanvas = outputCanvas;
        this.configureCanvasPipeline();
    }
    /**
     * Generate the raw image data in a format that is directly importable into
     * the segmentation model
     * @param inputCanvas
     * @returns ImageData
     */ getInferenceInputData(inputCanvas) {
        // Resize our full resolution frame into a new canvas scaled to the
        // size of our segmentation model
        this.inferenceCtx.save();
        this.inferenceCtx.scale(this.horizontalResizeScalar, this.verticalResizeScalar);
        this.inferenceCtx.drawImage(inputCanvas, 0, 0);
        this.inferenceCtx.restore();
        // Now we can directly take image data that is the desired size of
        // of our segmentation model linput
        const inferenceInputData = this.inferenceCtx.getImageData(0, 0, $2CaPE.SEGMENTATION_MODEL.WIDTH_IN_PIXELS, $2CaPE.SEGMENTATION_MODEL.HEIGHT_IN_PIXELS);
        return inferenceInputData;
    }
    /**
     * Reconfigure the canvas operations/pipeline to fit the dimensions of the new
     * video stream, and resize background replacement canvas.
     * @param streamParameters an VideoFxStreamParameters object specifying stream dimensions
     */ async configureForStreamParameters(streamParameters) {
        this.streamParameters = streamParameters;
        this.outputCanvas.width = this.streamParameters.width;
        this.outputCanvas.height = this.streamParameters.height;
        // Resize background replacement canvas -- if it exists
        if (this.backgroundReplacementCanvas) {
            const resizedCanvas = document.createElement('canvas');
            resizedCanvas.width = this.streamParameters.width;
            resizedCanvas.height = this.streamParameters.height;
            resizedCanvas.getContext('2d').drawImage(this.backgroundReplacementCanvas, 0, 0, this.streamParameters.width, this.streamParameters.height);
            this.backgroundReplacementCanvas = resizedCanvas;
        }
        this.configureCanvasPipeline();
    }
    /**
     * Configure the inference canvas so that write operations to the canvas
     * result in an image resizing.
     */ configureCanvasPipeline() {
        // Create new inference canvas and context
        this.inferenceCanvas = document.createElement('canvas');
        this.inferenceCtx = this.inferenceCanvas.getContext('2d', {
            willReadFrequently: true
        });
        // Configure the resize operation, which will be utilized by calling scale
        // and then drawing any sized input to the canvas
        this.inferenceCanvas.width = $2CaPE.SEGMENTATION_MODEL.WIDTH_IN_PIXELS;
        this.inferenceCanvas.height = $2CaPE.SEGMENTATION_MODEL.HEIGHT_IN_PIXELS;
        this.horizontalResizeScalar = $2CaPE.SEGMENTATION_MODEL.WIDTH_IN_PIXELS / this.streamParameters.width;
        this.verticalResizeScalar = $2CaPE.SEGMENTATION_MODEL.HEIGHT_IN_PIXELS / this.streamParameters.height;
    }
    /**
     * Return the background replacement canvas
     * @returns HTMLCanvasElement
     */ getBackgroundReplacementCanvas() {
        return this.backgroundReplacementCanvas;
    }
    /**
     * Attempt to load custom replacement background image from URL, or the default background color.
     * The backgroundReplacementCanvas is then set from the loaded image.
     * @param effectConfig
     */ async loadReplacementBackground(effectConfig) {
        const imageURL = effectConfig.backgroundReplacement.backgroundImageURL;
        const defaultColor = effectConfig.backgroundReplacement.defaultColor;
        if (imageURL) try {
            const backgroundImage = await this.loadImage(imageURL);
            this.backgroundReplacementImage = backgroundImage;
            this.resizeAndSetReplacementImage(this.backgroundReplacementImage);
        } catch (error) /* istanbul ignore next */ {
            // The following can only happen due to an intermittent network issue.
            this.logger.error(error);
            throw new Error('Failed to set the replacement image.');
        }
        else this.resizeAndSetReplacementColor(defaultColor);
    }
    /**
     * Draw loaded image on a canvas sized to the stream parameters, which is then set to the
     * backgroundReplacementCanvas member variable.
     * @param backgroundImage
     */ resizeAndSetReplacementImage(backgroundImage) {
        const resizedCanvas = document.createElement('canvas');
        const resizedCtx = resizedCanvas.getContext('2d');
        resizedCanvas.width = this.streamParameters.width;
        resizedCanvas.height = this.streamParameters.height;
        resizedCtx.drawImage(backgroundImage, 0, 0, this.streamParameters.width, this.streamParameters.height);
        this.backgroundReplacementCanvas = resizedCanvas;
    }
    /**
     * Fill default color on a canvas sized to the stream parameters, which is then set to the
     * backgroundReplacementCanvas member variable.
     * @param defaultColor
     */ resizeAndSetReplacementColor(defaultColor) {
        const resizedCanvas = document.createElement('canvas');
        const resizedCtx = resizedCanvas.getContext('2d');
        resizedCanvas.width = this.streamParameters.width;
        resizedCanvas.height = this.streamParameters.height;
        resizedCtx.fillStyle = defaultColor;
        resizedCtx.fillRect(0, 0, this.streamParameters.width, this.streamParameters.height);
        this.backgroundReplacementCanvas = resizedCanvas;
    }
    /**
     * Attempt to load background image from URL.
     * @param backgroundImageURL
     * @returns Promise<HTMLCanvasElement>
     */ async loadImage(backgroundImageURL) {
        // Attempt to fetch the image
        const image = await fetch(backgroundImageURL).catch((error)=>{
            this.logger.error(error.toString());
            // Error returned in unit tests from mock fetch is non-compatible
            /* istanbul ignore next */ throw new Error('Failed to fetch image.');
        });
        // Convert successful fetch into an HTMLImageElement
        const imageBlob = await image.blob();
        const img = new Image();
        img.src = URL.createObjectURL(imageBlob);
        return new Promise((resolve, reject)=>{
            img.onload = ()=>{
                resolve(img);
            };
            img.onerror = (error)=>{
                reject(error);
            };
        });
    }
}
module.exports.VideoFxCanvasOpsManager = $ea8536f9c14d798c$var$VideoFxCanvasOpsManager;

});
parcelRegister("2CaPE", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_VIDEO_FX_SPEC = module.exports.FXLIB_PATH = module.exports.WORKER_PATH = module.exports.CDN_BASE_PATH = module.exports.RESOURCE_CONSTRAINTS = module.exports.SEGMENTATION_MODEL = module.exports.DEFAULT_STREAM_PARAMETERS = module.exports.WORKER_MSG = void 0;
module.exports.WORKER_MSG = {
    BUILD_ENGINE_REQUEST: 'BuildEngineRequest',
    BUILD_ENGINE_RESPONSE: 'BuildEngineResponse',
    PERFORM_SEGMENTATION_REQUEST: 'PerformSegmentationRequest',
    PERFORM_SEGMENTATION_RESPONSE: 'PerformSegmentationResponse',
    PERFORM_SEGMENTATION_SAB_REQUEST: 'PerformSegmentationSABRequest',
    PERFORM_SEGMENTATION_SAB_RESPONSE: 'PerformSegmentationSABResponse',
    DESTROY_ASSETS_REQUEST: 'DestroyAssetsRequest',
    DESTROY_ASSETS_RESPONSE: 'DestroyAssetsResponse',
    CLOSE_WORKER_REQUEST: 'CloseWorkerRequest'
};
module.exports.DEFAULT_STREAM_PARAMETERS = {
    FRAMES_PER_SECOND: 15,
    WIDTH_IN_PIXEL: 960,
    HEIGHT_IN_PIXEL: 540,
    CHANNEL_COUNT: 4
};
// These are constants relating to the status of different processes that get returned
// by the VideoFxEngine
module.exports.SEGMENTATION_MODEL = {
    LOAD_SUCCESS: 2,
    WIDTH_IN_PIXELS: 176,
    HEIGHT_IN_PIXELS: 160
};
// These are constants relating to resource constraints
module.exports.RESOURCE_CONSTRAINTS = {
    DEFAULT_PROCESSING_BUDGET_PER_FRAME: 50,
    // Segmenation throttling constants
    SEGMENTATION_DEFAULT_FRAMES_PER_SEGMENTATION: 1,
    SEGMENTATION_SAMPLING_PERIOD_FRAME_COUNT: 500,
    // Blur throttling constants
    BLUR_DEFAULT_CYCLE_PERCENTAGE: 10,
    BLUR_SAMPLING_PERIOD_FRAME_COUNT: 1000,
    // General constants for throttling blur and segmentation
    MIN_PROCESSING_BUDGET: 0,
    MAX_PROCESSING_BUDGET: 100
};
module.exports.CDN_BASE_PATH = 'https://static.sdkassets.chime.aws';
const $1e778863966f35b4$var$MFX_ASSET_PATH = '/ml_media_fx/otherassets';
module.exports.WORKER_PATH = `${$1e778863966f35b4$var$MFX_ASSET_PATH}/worker.js`;
module.exports.FXLIB_PATH = `${$1e778863966f35b4$var$MFX_ASSET_PATH}/fxlib.js`;
module.exports.DEFAULT_VIDEO_FX_SPEC = {
    paths: {
        cdnBasePath: module.exports.CDN_BASE_PATH,
        workerPath: module.exports.WORKER_PATH,
        fxLibPath: module.exports.FXLIB_PATH
    }
};

});


parcelRegister("iUrlb", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VideoFxSegmentationRateManager = void 0;

var $2CaPE = parcelRequire("2CaPE");
/**
 * [[VideoFxSegmentationRateManager]] Mechanism that can be used to maximize
 * frequency of the segmentation operations while maintaining a target amount
 * of resource utilization.
 */ class $dc42aa392ba1419c$var$VideoFxSegmentationRateManager {
    constructor(logger, targetSegmentationCycleTime){
        this.logger = logger;
        // Max amount of compute we want to offer to action (converted from
        // percentage to decimal)
        this.targetSegmentationCyclePercentage = targetSegmentationCycleTime / 100;
        // Variables for recording timing within cycle
        this.frameCountOverSamplingPeriod = 0;
        this.totalSegmentationDurationOverSamplingPeriod = 0;
        this.samplingPeriodStartTime = performance.now();
        this.framesPerSegmentation = $2CaPE.RESOURCE_CONSTRAINTS.SEGMENTATION_DEFAULT_FRAMES_PER_SEGMENTATION;
    }
    /**
     * Invoked on every frame to increment the running count of frames being processed
     */ submitFrame() {
        this.frameCountOverSamplingPeriod++;
    }
    /**
     * Invoked on every frame to coordinate when the segmentation should be
     * executed so that we are maintaing a segmentation rate of once per every
     * framesPerSegmentation frames.
     * @returns boolean for whether or not we want to perform an action on the current
     * frame
     */ shouldApplySegmentation() {
        return this.frameCountOverSamplingPeriod % this.framesPerSegmentation === 0;
    }
    /**
     * Starts the timing of the current action
     */ startSegmentation() {
        this.frameSegmentationStartTime = performance.now();
    }
    /**
     * Invoked after the action to notify the compute manager. Afterwards the
     * manager will make adjustments to action rates to maintain a value below compute
     * ceiling
     */ completeSegmentation() {
        this.totalSegmentationDurationOverSamplingPeriod += performance.now() - this.frameSegmentationStartTime;
        // Check if the sampling period has ended. If so, check if frames per
        // segmentation needs to be updated
        if (this.frameCountOverSamplingPeriod >= $2CaPE.RESOURCE_CONSTRAINTS.SEGMENTATION_SAMPLING_PERIOD_FRAME_COUNT) this.adjustFramesPerSegmentation(this.totalSegmentationDurationOverSamplingPeriod / (performance.now() - this.samplingPeriodStartTime));
    }
    /**
     * Increase or decrease the frames per segmentation so that we remain as performant as possible,
     * but also below the targetSegmentationCycleTime
     * @param currentSegmentationCycleTime Current ratio of frame processing allocated to a specific action
     */ adjustFramesPerSegmentation(currentSegmentationCycleTime) {
        // Compute is too high -> increase action period (slow down)
        if (currentSegmentationCycleTime > this.targetSegmentationCyclePercentage) {
            this.framesPerSegmentation++;
            this.logger.info(`Segmentation cycle percentage above the configured maximal value. ` + `Decreasing segmentation rate to 1 segmentation per ` + `${this.framesPerSegmentation} frames`);
        // Compute is too low -> decrease action period (speed up)
        } else if (this.framesPerSegmentation > 1 && currentSegmentationCycleTime < this.targetSegmentationCyclePercentage) {
            this.framesPerSegmentation--;
            this.logger.info(`Segmentation cycle percentage below the configured maximal value. ` + `Increasing segmentation rate to 1 segmentation per ` + `${this.framesPerSegmentation} frames`);
        }
        // Reset for next compute sample/cycle
        this.totalSegmentationDurationOverSamplingPeriod = 0;
        this.frameCountOverSamplingPeriod = 0;
        this.samplingPeriodStartTime = performance.now();
    }
}
module.exports.VideoFxSegmentationRateManager = $dc42aa392ba1419c$var$VideoFxSegmentationRateManager;

});


parcelRegister("787PM", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $530f5b7322804710$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $530f5b7322804710$var$DefaultTransceiverController_1 = $530f5b7322804710$var$__importDefault((parcelRequire("itul0")));
class $530f5b7322804710$var$VideoOnlyTransceiverController extends $530f5b7322804710$var$DefaultTransceiverController_1.default {
    constructor(logger, browserBehavior, meetingSessionContext, encodedTransformWorkerManager){
        super(logger, browserBehavior, meetingSessionContext, encodedTransformWorkerManager);
    }
    setupLocalTransceivers() {
        if (!this.useTransceivers()) return;
        if (!this.defaultMediaStream && typeof MediaStream !== 'undefined') this.defaultMediaStream = new MediaStream();
        if (!this._localCameraTransceiver) {
            this._localCameraTransceiver = this.peer.addTransceiver('video', {
                direction: 'inactive',
                streams: [
                    this.defaultMediaStream
                ]
            });
            this.configureLocalCameraHeaderExtensions();
        }
    }
}
module.exports.default = $530f5b7322804710$var$VideoOnlyTransceiverController;

});

parcelRegister("6pK00", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $4ab8c25393d2d9ed$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceFocusDeviceTransformer = void 0;

var $c0r9p = parcelRequire("c0r9p");

var $9UH7r = parcelRequire("9UH7r");

const $4ab8c25393d2d9ed$var$Versioning_1 = $4ab8c25393d2d9ed$var$__importDefault((parcelRequire("c0dn0")));

const $4ab8c25393d2d9ed$var$LoggerAdapter_1 = $4ab8c25393d2d9ed$var$__importDefault((parcelRequire("czi8e")));

const $4ab8c25393d2d9ed$var$VoiceFocusTransformDevice_1 = $4ab8c25393d2d9ed$var$__importDefault((parcelRequire("2bbQi")));

const $4ab8c25393d2d9ed$var$VoiceFocusTransformDeviceDelegate_1 = $4ab8c25393d2d9ed$var$__importDefault((parcelRequire("jpwwn")));
/**
 * `VoiceFocusDeviceTransformer` is used to create {@link VoiceFocusTransformDevice|transform devices}
 * that apply Amazon Voice Focus noise suppression to audio input.
 *
 * This transformer captures relevant configuration. You should check for support, initialize,
 * and then create a device as follows:
 *
 * ```typescript
 * const deviceID = null;
 *
 * // This check for support is cheap and quick, and should be used to gate use
 * // of this feature.
 * if (!(await VoiceFocusDeviceTransformer.isSupported()) {
 *   console.log('Amazon Voice Focus not supported in this browser.');
 *   return deviceID;
 * }
 *
 * let transformer: VoiceFocusDeviceTransformer;
 * try {
 *   // This operation can fail in ways that do not indicate no support,
 *   // but do indicate an inability to apply Amazon Voice Focus. Trying again
 *   // might succeed.
 *   transformer = await VoiceFocusDeviceTransformer.create({});
 * } catch (e) {
 *   // Something went wrong.
 *   console.log('Unable to instantiate Amazon Voice Focus.');
 *   return deviceID;
 * }
 *
 * if (!transformer.isSupported()) {
 *   // The transformer will fall through, but your UI might care.
 *   console.log('Amazon Voice Focus not supported in this browser.');
 * }
 *
 * return await transformer.createTransformDevice(deviceID);
 * ```
 */ class $4ab8c25393d2d9ed$var$VoiceFocusDeviceTransformer {
    /**
     * Quickly check whether Amazon Voice Focus is supported on this platform.
     *
     * This will return `false` if key technologies are absent. A value of `true` does not
     * necessarily mean that adding Amazon Voice Focus will succeed: it is still possible that the
     * configuration of the page or the CPU speed of the device are limiting factors.
     *
     * {@link VoiceFocusDeviceTransformer.create} will return an instance whose
     * `isSupported` method more accurately reflects whether Amazon Voice Focus
     * is supported in the current environment.
     *
     * This method will only reject if you provide invalid inputs.
     *
     * @param spec An optional asset group and URL paths to use when fetching. You can pass
     *             a complete {@link VoiceFocusSpec} here for convenience, matching the signature of {@link VoiceFocusDeviceTransformer.create}.
     * @param options Additional named arguments, including `logger`. Set
     *                `allowIFrame` to false to cause the support check to fail in
     *                an iframe.
     *                Chromium's security model means that audio processing works
     *                poorly in iframes.
     */ static isSupported(spec, options) {
        var _a, _b;
        const fetchBehavior = $4ab8c25393d2d9ed$var$VoiceFocusDeviceTransformer.defaultFetchBehavior();
        const logger = (options === null || options === void 0 ? void 0 : options.logger) ? new $4ab8c25393d2d9ed$var$LoggerAdapter_1.default(options.logger) : undefined;
        const opts = {
            fetchBehavior: fetchBehavior,
            logger: logger
        };
        // This is impossible to test in Node, so Istanbul ignore.
        /* istanbul ignore next */ if ((0, $9UH7r.isIFramed)()) {
            if ((options === null || options === void 0 ? void 0 : options.allowIFrame) === false) {
                (_a = options === null || options === void 0 ? void 0 : options.logger) === null || _a === void 0 || _a.error('Amazon Voice Focus support check inside iframe: not supported.');
                return Promise.resolve(false);
            } else (_b = options === null || options === void 0 ? void 0 : options.logger) === null || _b === void 0 || _b.warn('Amazon Voice Focus support check inside iframe: not recommended.');
        }
        return $c0r9p.VoiceFocus.isSupported($4ab8c25393d2d9ed$var$VoiceFocusDeviceTransformer.augmentSpec(spec), opts);
    }
    /**
     * Create a transformer that can apply Amazon Voice Focus noise suppression to a device.
     *
     * This method will reject if the provided spec is invalid, or if the process of
     * checking for support or estimating fails (e.g., because the network is unreachable).
     *
     * If Amazon Voice Focus is not supported on this device, this call will not reject and
     * `isSupported` will return `false` on the returned instance. That instance will
     * pass through devices unmodified.
     *
     * @param spec A definition of how you want Amazon Voice Focus to behave. See the declaration of
     *             {@link VoiceFocusSpec} for details.
     * @param options Additional named arguments, including `logger` and `preload`.
     */ static async create(spec = {}, options = {}, config, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    createMeetingResponse, // eslint-disable-next-line
    createAttendeeResponse) {
        var _a, _b, _c;
        if (createMeetingResponse) {
            if (createMeetingResponse.Meeting.Meeting) createMeetingResponse = createMeetingResponse.Meeting;
        }
        const meetingFeaturesAllowsES = ((_c = (_b = (_a = createMeetingResponse === null || createMeetingResponse === void 0 ? void 0 : createMeetingResponse.Meeting) === null || _a === void 0 ? void 0 : _a.MeetingFeatures) === null || _b === void 0 ? void 0 : _b.Audio) === null || _c === void 0 ? void 0 : _c.EchoReduction) === 'AVAILABLE';
        const forbiddenConfig = config && config.supported === true && config.model.name === 'ns_es' && !meetingFeaturesAllowsES;
        const forbiddenSpec = spec.name === 'ns_es' && !meetingFeaturesAllowsES;
        if (forbiddenConfig || forbiddenSpec) throw new Error('Echo Reduction requested but not enabled.');
        const transformer = new $4ab8c25393d2d9ed$var$VoiceFocusDeviceTransformer(spec, options, config);
        // This also preps the first `VoiceFocus` instance.
        await transformer.init();
        return transformer;
    }
    /**
     * Given a spec and options, perform the configuration work that is
     * ordinarily performed during creation of a transformer.
     *
     * The computed configuration is not portable between devices or sessions,
     * but is useful for 'moving' transformers between windows.
     *
     * Pass the returned configuration as the third argument to a call to
     * {@link VoiceFocusDeviceTransformer.create} with the matching spec.
     */ static async configure(spec = {}, options = {}) {
        const transformer = new $4ab8c25393d2d9ed$var$VoiceFocusDeviceTransformer(spec, options, undefined);
        return transformer.configure(true);
    }
    /**
     * Return the computed configuration for this transformer.
     */ getConfiguration() {
        return this.configuration;
    }
    /**
     * Return whether this transformer is able to function in this environment.
     * If not, calls to
     * {@link VoiceFocusDeviceTransformer.createTransformDevice|createTransformDevice}
     * will pass through an unmodified device.
     */ isSupported() {
        return this.supported;
    }
    /**
     * Apply Amazon Voice Focus to the selected {@link Device}.
     *
     * If this is a stream, it should be one that does not include other noise suppression features,
     * and you should consider whether to disable automatic gain control (AGC) on the stream, because
     * it can interact with noise suppression.
     *
     * @returns a device promise. This will always resolve to either a
     *          {@link VoiceFocusTransformDevice} or undefined; it will never reject.
     */ async createTransformDevice(device, nodeOptions) {
        if (!this.supported) // Fall back.
        return undefined;
        try {
            const preload = true;
            const [vf, delegate] = await this.allocateVoiceFocus(preload);
            const options = {
                ...nodeOptions,
                es: this.spec.name === 'ns_es'
            };
            return new $4ab8c25393d2d9ed$var$VoiceFocusTransformDevice_1.default(device, vf, delegate, options);
        } catch (e) {
            // Fall back.
            /* istanbul ignore next */ return undefined;
        }
    }
    /**
     * Destroy the Voice Focus instance and worker thread associated with the transformer.
     */ static async destroyVoiceFocus(transformer) {
        var _a;
        /* istanbul ignore next */ (_a = transformer === null || transformer === void 0 ? void 0 : transformer.vf) === null || _a === void 0 || _a.destroy();
    }
    constructor(spec, { preload: preload = true, logger: logger, fetchBehavior: fetchBehavior = $4ab8c25393d2d9ed$var$VoiceFocusDeviceTransformer.defaultFetchBehavior() }, config){
        this.spec = spec;
        this.supported = true;
        this.logger = logger;
        this.vfLogger = logger ? new $4ab8c25393d2d9ed$var$LoggerAdapter_1.default(logger) : undefined;
        this.preload = preload;
        this.fetchBehavior = fetchBehavior;
        // If the user didn't specify one, add the default, which is
        // identified by the major and minor SDK version.
        this.spec = $4ab8c25393d2d9ed$var$VoiceFocusDeviceTransformer.augmentSpec(this.spec);
        if (config) this.configuration = Promise.resolve(config);
    }
    static augmentSpec(spec) {
        if (!spec || !spec.assetGroup && !spec.revisionID) return {
            ...spec,
            assetGroup: $4ab8c25393d2d9ed$var$VoiceFocusDeviceTransformer.currentSDKAssetGroup()
        };
        return spec;
    }
    async configure(preResolve = false) {
        const options = {
            fetchBehavior: this.fetchBehavior,
            preResolve: preResolve,
            logger: this.vfLogger
        };
        return $c0r9p.VoiceFocus.configure(this.spec, options);
    }
    async init() {
        var _a;
        if (!this.configuration) this.configuration = this.configure();
        const config = await this.configuration;
        if (!config.supported) {
            // No need to init: it won't work.
            this.supported = false;
            return;
        }
        // We initialize the first one right now, which makes it easier to detect
        // possible failures.
        // This can throw for malformed input. Pass that up the chain.
        this.pendingVoiceFocus = this.createVoiceFocus(config, this.preload);
        try {
            await this.pendingVoiceFocus;
        } catch (e) {
            (_a = this.logger) === null || _a === void 0 || _a.error(`Unable to initialize Amazon Voice Focus: ${e}`);
            this.supported = false;
        }
    }
    async createVoiceFocus(config, preload) {
        const delegate = new $4ab8c25393d2d9ed$var$VoiceFocusTransformDeviceDelegate_1.default();
        this.vf = await $c0r9p.VoiceFocus.init(config, {
            delegate: delegate,
            preload: preload,
            logger: this.vfLogger
        });
        return [
            this.vf,
            delegate
        ];
    }
    async allocateVoiceFocus(preload) {
        // A little safety.
        /* istanbul ignore next */ if (!this.supported) throw new Error('Not supported.');
        if (this.pendingVoiceFocus) {
            // Use the one we already have, and free the slot for any future execution.
            const vf = this.pendingVoiceFocus;
            this.pendingVoiceFocus = undefined;
            return vf;
        }
        return this.createVoiceFocus(await this.configuration, preload);
    }
    static majorVersion() {
        return $4ab8c25393d2d9ed$var$Versioning_1.default.sdkVersion.match(/^[1-9][0-9]*\.(?:0|[1-9][0-9]*)/)[0];
    }
    static majorMinorVersion() {
        return $4ab8c25393d2d9ed$var$Versioning_1.default.sdkVersion.match(/^[1-9][0-9]*\.(?:0|(?:[1-9][0-9]*))\.(?:0|[1-9][0-9]*)/)[0];
    }
    static currentSDKAssetGroup() {
        // Just on the off chance someone does something silly, handle
        // malformed version strings here.
        const v = this.majorVersion();
        // Just a little safety.
        /* istanbul ignore next */ if (!v) return `stable-v1`;
        return `sdk-${v}`;
    }
    // Note that we use query strings here, not headers, in order to make these requests 'simple' and
    // avoid the need for CORS preflights.
    // Be very, very careful if you choose to add headers here. You should never need to.
    static defaultFetchBehavior() {
        // Just a little safety.
        /* istanbul ignore next */ const version = $4ab8c25393d2d9ed$var$VoiceFocusDeviceTransformer.majorMinorVersion() || 'unknown';
        const ua = $4ab8c25393d2d9ed$var$Versioning_1.default.sdkUserAgentLowResolution;
        return {
            escapedQueryString: `sdk=${encodeURIComponent(version)}&ua=${encodeURIComponent(ua)}`
        };
    }
}
module.exports.VoiceFocusDeviceTransformer = $4ab8c25393d2d9ed$var$VoiceFocusDeviceTransformer;
module.exports.default = $4ab8c25393d2d9ed$var$VoiceFocusDeviceTransformer;

});
parcelRegister("c0r9p", function(module, exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
"use strict";
var $8bda8bb838ae7db6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAudioInput = module.exports.createAudioContext = module.exports.VoiceFocus = void 0;

var $lxOy8 = parcelRequire("lxOy8");

var $59RLu = parcelRequire("59RLu");

var $aJA5z = parcelRequire("aJA5z");

var $euItc = parcelRequire("euItc");

var $bp4SR = parcelRequire("bp4SR");

var $33PEZ = parcelRequire("33PEZ");

var $juQ8L = parcelRequire("juQ8L");
const $8bda8bb838ae7db6$var$DEFAULT_AGC_DISABLED_SETTING = {
    useVoiceFocusAGC: false,
    useBuiltInAGC: true
};
const $8bda8bb838ae7db6$var$DEFAULT_AGC_SETTING = $8bda8bb838ae7db6$var$DEFAULT_AGC_DISABLED_SETTING;
const $8bda8bb838ae7db6$var$DEFAULT_ASSET_GROUP = 'stable-v1';
const $8bda8bb838ae7db6$var$DEFAULT_CDN = 'https://static.sdkassets.chime.aws';
const $8bda8bb838ae7db6$var$DEFAULT_PATHS = {
    processors: `${$8bda8bb838ae7db6$var$DEFAULT_CDN}/processors/`,
    workers: `${$8bda8bb838ae7db6$var$DEFAULT_CDN}/workers/`,
    wasm: `${$8bda8bb838ae7db6$var$DEFAULT_CDN}/wasm/`,
    models: `${$8bda8bb838ae7db6$var$DEFAULT_CDN}/wasm/`
};
const $8bda8bb838ae7db6$var$DEFAULT_CONTEXT_HINT = {
    latencyHint: 0
};
const $8bda8bb838ae7db6$var$BASE_AUDIO_CONSTRAINTS = {
    channelCount: 1,
    echoCancellation: true,
    googEchoCancellation: true,
    noiseSuppression: false,
    googNoiseSuppression: false,
    googHighpassFilter: false,
    googTypingNoiseDetection: false
};
const $8bda8bb838ae7db6$var$DEFAULT_AUDIO_CONSTRAINTS_WITH_BUILTIN_AGC = Object.assign(Object.assign({}, $8bda8bb838ae7db6$var$BASE_AUDIO_CONSTRAINTS), {
    autoGainControl: true,
    googAutoGainControl: true,
    googAutoGainControl2: true
});
const $8bda8bb838ae7db6$var$DEFAULT_AUDIO_CONSTRAINTS_WITHOUT_BUILTIN_AGC = Object.assign(Object.assign({}, $8bda8bb838ae7db6$var$BASE_AUDIO_CONSTRAINTS), {
    autoGainControl: false,
    googAutoGainControl: false,
    googAutoGainControl2: false
});
const $8bda8bb838ae7db6$var$PROCESSORS = {
    'voicefocus-worker-sab-processor': {
        file: 'worklet-worker-sab-processor-v1.js',
        node: $33PEZ.default
    },
    'voicefocus-worker-postMessage-processor': {
        file: 'worklet-worker-postMessage-processor-v1.js',
        node: $juQ8L.default
    },
    'voicefocus-inline-processor': {
        file: 'worklet-inline-processor-v1.js',
        node: $bp4SR.default
    }
};
const $8bda8bb838ae7db6$var$validateAssetSpec = (assetGroup, revisionID)=>{
    if (assetGroup !== undefined && !(0, $59RLu.isValidAssetGroup)(assetGroup)) throw new Error(`Invalid asset group ${assetGroup}`);
    if (revisionID !== undefined && !(0, $59RLu.isValidRevisionID)(revisionID)) throw new Error(`Invalid revision ID ${revisionID}`);
};
const $8bda8bb838ae7db6$var$mungeConstraints = (constraints, agc)=>{
    let defaultConstraints;
    if (agc.useBuiltInAGC) defaultConstraints = $8bda8bb838ae7db6$var$DEFAULT_AUDIO_CONSTRAINTS_WITH_BUILTIN_AGC;
    else defaultConstraints = $8bda8bb838ae7db6$var$DEFAULT_AUDIO_CONSTRAINTS_WITHOUT_BUILTIN_AGC;
    if (!constraints) return {
        audio: defaultConstraints
    };
    if (!constraints.audio) return constraints;
    if (constraints.video) throw new Error('Not adding Voice Focus to multi-device getUserMedia call.');
    return Object.assign(Object.assign({}, constraints), {
        audio: constraints.audio === true ? defaultConstraints : Object.assign(Object.assign({}, constraints.audio), defaultConstraints)
    });
};
const $8bda8bb838ae7db6$var$urlForModel = (model, paths)=>{
    return `${paths.models}${(0, $lxOy8.decideModel)(model)}.wasm`;
};
class $8bda8bb838ae7db6$var$VoiceFocus {
    constructor(worker, processorURL, nodeConstructor, nodeOptions, executionQuanta, logger){
        this.processorURL = processorURL;
        this.nodeConstructor = nodeConstructor;
        this.nodeOptions = nodeOptions;
        this.executionQuanta = executionQuanta;
        this.logger = logger;
        this.internal = {
            worker: worker,
            isDestroyed: false
        };
    }
    getModelMetrics() {
        var _a;
        return (_a = this.internal.voiceFocusNode) === null || _a === void 0 ? void 0 : _a.getModelMetrics();
    }
    reset() {
        var _a, _b, _c;
        (_a = this.internal.voiceFocusNode) === null || _a === void 0 || _a.reset();
        (_b = this.internal.sourceNode) === null || _b === void 0 || _b.disconnect();
        (_c = this.internal.destinationNode) === null || _c === void 0 || _c.disconnect();
    }
    enable() {
        var _a;
        (_a = this.internal.voiceFocusNode) === null || _a === void 0 || _a.enable();
    }
    disable() {
        var _a;
        (_a = this.internal.voiceFocusNode) === null || _a === void 0 || _a.disable();
    }
    setMode(mode) {
        var _a;
        (_a = this.internal.voiceFocusNode) === null || _a === void 0 || _a.setMode(mode);
    }
    destroy() {
        var _a, _b, _c, _d, _e;
        return $8bda8bb838ae7db6$var$__awaiter(this, void 0, void 0, function*() {
            const { worker: worker, isDestroyed: isDestroyed, voiceFocusNode: voiceFocusNode, destinationNode: destinationNode, sourceNode: sourceNode, audioContext: audioContext } = this.internal;
            if (isDestroyed) {
                (_a = this.logger) === null || _a === void 0 || _a.debug("Voice Focus is already destroyed");
                return;
            }
            try {
                worker === null || worker === void 0 || worker.terminate();
                sourceNode === null || sourceNode === void 0 || sourceNode.disconnect();
                destinationNode === null || destinationNode === void 0 || destinationNode.disconnect();
                yield Promise.all([
                    (_b = audioContext === null || audioContext === void 0 ? void 0 : audioContext.close().catch((error)=>error)) !== null && _b !== void 0 ? _b : yield Promise.resolve(),
                    (_c = voiceFocusNode === null || voiceFocusNode === void 0 ? void 0 : voiceFocusNode.stop().catch((error)=>error)) !== null && _c !== void 0 ? _c : yield Promise.resolve()
                ]);
                this.internal.audioContext = undefined;
                this.internal.voiceFocusNode = undefined;
                this.internal.sourceNode = undefined;
                this.internal.destinationNode = undefined;
                (_d = this.logger) === null || _d === void 0 || _d.debug("Voice Focus destroyed successfully");
            } catch (e) {
                (_e = this.logger) === null || _e === void 0 || _e.error("Error while destroying the Voice Focus instance: ", e);
                throw e;
            } finally{
                this.internal.isDestroyed = true;
            }
        });
    }
    static isSupported(spec, options) {
        const { fetchBehavior: fetchBehavior, logger: logger } = options || {};
        if (typeof globalThis === 'undefined') {
            logger === null || logger === void 0 || logger.debug('Browser does not have globalThis.');
            return Promise.resolve(false);
        }
        if (!(0, $euItc.supportsAudioWorklet)(globalThis, logger)) {
            logger === null || logger === void 0 || logger.debug('Browser does not support Audio Worklet.');
            return Promise.resolve(false);
        }
        if (!(0, $euItc.supportsWASM)(globalThis, logger)) {
            logger === null || logger === void 0 || logger.debug('Browser does not support WASM.');
            return Promise.resolve(false);
        }
        if (!(0, $euItc.supportsWASMStreaming)(globalThis, logger)) logger === null || logger === void 0 || logger.debug('Browser does not support streaming WASM compilation.');
        const { assetGroup: assetGroup = $8bda8bb838ae7db6$var$DEFAULT_ASSET_GROUP, revisionID: revisionID, paths: paths = $8bda8bb838ae7db6$var$DEFAULT_PATHS } = spec || {};
        $8bda8bb838ae7db6$var$validateAssetSpec(assetGroup, revisionID);
        const assetConfig = revisionID ? {
            revisionID: revisionID
        } : {
            assetGroup: assetGroup
        };
        const updatedFetchBehavior = (0, $59RLu.addQueryParams)(fetchBehavior, assetConfig);
        const fetchConfig = Object.assign(Object.assign({}, updatedFetchBehavior), {
            paths: paths
        });
        return (0, $euItc.supportsVoiceFocusWorker)(globalThis, fetchConfig, logger);
    }
    static mungeExecutionPreference(preference, logger) {
        const isAuto = preference === undefined || preference === 'auto';
        if ((0, $euItc.isSafari)(globalThis)) {
            if (isAuto || preference === 'inline') return 'inline';
            if (!isAuto) throw new Error(`Unsupported execution preference ${preference}`);
        }
        if (preference === 'worker-sab' && !(0, $euItc.supportsSharedArrayBuffer)(globalThis, globalThis, logger)) throw new Error(`Unsupported execution preference ${preference}`);
        return preference || 'auto';
    }
    static configure(spec, options) {
        return $8bda8bb838ae7db6$var$__awaiter(this, void 0, void 0, function*() {
            const { fetchBehavior: fetchBehavior, preResolve: preResolve, logger: logger } = options || {};
            const { category: category = 'voicefocus', name: name = 'default', variant: variantPreference = 'auto', assetGroup: assetGroup = $8bda8bb838ae7db6$var$DEFAULT_ASSET_GROUP, revisionID: revisionID, simd: simd = 'detect', mode: mode = 'ns', executionPreference: executionPreference = 'auto', executionQuantaPreference: executionQuantaPreference, usagePreference: usagePreference = 'interactivity', estimatorBudget: estimatorBudget = 100, paths: paths = $8bda8bb838ae7db6$var$DEFAULT_PATHS, thresholds: thresholds } = spec || {};
            logger === null || logger === void 0 || logger.debug('Configuring Voice Focus with spec', spec);
            if (category !== undefined && category !== 'voicefocus') throw new Error(`Unrecognized category ${category}`);
            if (name !== undefined && name !== 'default' && name !== 'ns_es') throw new Error(`Unrecognized feature name ${name}`);
            if (variantPreference !== undefined && ![
                'auto',
                'c100',
                'c50',
                'c20',
                'c10'
            ].includes(variantPreference)) throw new Error(`Unrecognized feature variant ${variantPreference}`);
            if (executionQuantaPreference !== undefined && ![
                1,
                2,
                3
            ].includes(executionQuantaPreference)) throw new Error(`Unrecognized execution quanta preference ${executionQuantaPreference}`);
            $8bda8bb838ae7db6$var$validateAssetSpec(assetGroup, revisionID);
            if (simd !== undefined && ![
                'detect',
                'force',
                'disable'
            ].includes(simd)) throw new Error(`Unrecognized SIMD option ${simd}`);
            if (executionPreference !== undefined && ![
                'auto',
                'inline',
                'worker',
                'worker-sab',
                'worker-postMessage'
            ].includes(executionPreference)) throw new Error(`Unrecognized execution preference ${executionPreference}`);
            if (usagePreference !== undefined && ![
                'quality',
                'interactivity'
            ].includes(usagePreference)) throw new Error(`Unrecognized usage preference ${usagePreference}`);
            const executionSpec = {
                executionPreference: this.mungeExecutionPreference(executionPreference, logger),
                usagePreference: usagePreference,
                executionQuantaPreference: executionQuantaPreference,
                variantPreference: variantPreference,
                namePreference: name,
                simdPreference: simd,
                estimatorBudget: estimatorBudget
            };
            const assetConfig = revisionID ? {
                revisionID: revisionID
            } : {
                assetGroup: assetGroup
            };
            const updatedFetchBehavior = (0, $59RLu.addQueryParams)(fetchBehavior, assetConfig);
            const fetchConfig = Object.assign({
                paths: paths
            }, updatedFetchBehavior);
            const executionDefinition = yield (0, $lxOy8.measureAndDecideExecutionApproach)(executionSpec, fetchConfig, logger, thresholds);
            if (executionDefinition.supported === false) return {
                supported: false,
                reason: executionDefinition.reason
            };
            logger === null || logger === void 0 || logger.info('Decided execution approach', executionDefinition);
            const { useSIMD: useSIMD, processor: processor, variant: variant, executionQuanta: executionQuanta } = executionDefinition;
            const model = {
                category: category || 'voicefocus',
                name: name || 'default',
                mode: mode,
                variant: variant,
                simd: useSIMD
            };
            if (preResolve) {
                const startingURL = $8bda8bb838ae7db6$var$urlForModel(model, paths);
                model.url = yield (0, $59RLu.resolveURL)(startingURL, updatedFetchBehavior);
            }
            return {
                fetchConfig: fetchConfig,
                model: model,
                processor: processor,
                executionQuanta: executionQuanta,
                supported: true
            };
        });
    }
    static init(configuration, { delegate: delegate, preload: preload = true, logger: logger }) {
        return $8bda8bb838ae7db6$var$__awaiter(this, void 0, void 0, function*() {
            if (configuration.supported === false) throw new Error('Voice Focus not supported. Reason: ' + configuration.reason);
            const { model: model, processor: processor, fetchConfig: fetchConfig, executionQuanta: executionQuanta } = configuration;
            const { simd: simd, name: name, mode: mode } = model;
            const { paths: paths } = fetchConfig;
            if (processor !== 'voicefocus-inline-processor' && processor !== 'voicefocus-worker-postMessage-processor' && processor !== 'voicefocus-worker-sab-processor') throw new Error(`Unknown processor ${processor}`);
            const modelURL = model.url || $8bda8bb838ae7db6$var$urlForModel(model, paths);
            logger === null || logger === void 0 || logger.debug(`Using model URL ${modelURL}.`);
            const audioBufferURL = `${paths.wasm}audio_buffer-v1${simd ? '_simd' : ''}.wasm`;
            const resamplerURL = `${paths.wasm}resampler-v1${simd ? '_simd' : ''}.wasm`;
            const workerURL = `${paths.workers}worker-v1.js`;
            const { file: file, node: node } = $8bda8bb838ae7db6$var$PROCESSORS[processor];
            const processorURL = `${paths.processors}${file}`;
            const worker = yield (0, $aJA5z.loadWorker)(workerURL, 'VoiceFocusWorker', fetchConfig, logger);
            if (preload) {
                logger === null || logger === void 0 || logger.debug('Preloading', modelURL);
                let message = (0, $euItc.supportsWASMPostMessage)(globalThis) ? 'get-module' : 'get-module-buffer';
                worker.postMessage({
                    message: message,
                    preload: true,
                    key: 'model',
                    fetchBehavior: fetchConfig,
                    path: modelURL
                });
            }
            const numberOfInputs = name === 'ns_es' ? 2 : 1;
            const nodeOptions = {
                processor: processor,
                worker: worker,
                audioBufferURL: audioBufferURL,
                resamplerURL: resamplerURL,
                fetchBehavior: fetchConfig,
                modelURL: modelURL,
                delegate: delegate,
                logger: logger,
                numberOfInputs: numberOfInputs,
                mode: mode
            };
            const factory = new $8bda8bb838ae7db6$var$VoiceFocus(worker, processorURL, node, nodeOptions, executionQuanta, logger);
            return Promise.resolve(factory);
        });
    }
    createNode(context, options) {
        var _a;
        if (this.internal.isDestroyed) throw new Error("Unable to create node because VoiceFocus worker has been destroyed.");
        const { voiceFocusSampleRate: voiceFocusSampleRate = context.sampleRate === 16000 ? 16000 : 48000, enabled: enabled = true, agc: agc = $8bda8bb838ae7db6$var$DEFAULT_AGC_SETTING } = options || {};
        const supportFarendStream = options === null || options === void 0 ? void 0 : options.es;
        const processorOptions = {
            voiceFocusSampleRate: voiceFocusSampleRate,
            enabled: enabled,
            sendBufferCount: 10,
            prefill: 6,
            agc: agc,
            executionQuanta: this.executionQuanta,
            supportFarendStream: supportFarendStream,
            mode: this.nodeOptions.mode
        };
        const url = (0, $59RLu.withQueryString)(this.processorURL, (_a = this.nodeOptions) === null || _a === void 0 ? void 0 : _a.fetchBehavior);
        return context.audioWorklet.addModule(url).then(()=>new this.nodeConstructor(context, Object.assign(Object.assign({}, this.nodeOptions), {
                processorOptions: processorOptions
            })));
    }
    applyToStream(stream, context, options, useExistingNode = false) {
        var _a, _b, _c;
        return $8bda8bb838ae7db6$var$__awaiter(this, void 0, void 0, function*() {
            if (this.internal.isDestroyed) throw new Error("Unable to apply stream because VoiceFocus worker has been destroyed");
            (_a = this.internal.sourceNode) === null || _a === void 0 || _a.disconnect();
            (_b = this.internal.destinationNode) === null || _b === void 0 || _b.disconnect();
            let voiceFocusNode;
            if (useExistingNode && this.internal.voiceFocusNode && this.internal.voiceFocusNode.isEnabled()) {
                (_c = this.logger) === null || _c === void 0 || _c.info("Re-using existing voice focus node");
                voiceFocusNode = this.internal.voiceFocusNode;
            } else voiceFocusNode = yield this.createNode(context, options);
            const source = context.createMediaStreamSource(stream);
            source.connect(voiceFocusNode);
            const destination = context.createMediaStreamDestination();
            voiceFocusNode.connect(destination);
            this.internal = Object.assign(Object.assign({}, this.internal), {
                voiceFocusNode: voiceFocusNode,
                sourceNode: source,
                destinationNode: destination,
                audioContext: context
            });
            return {
                node: voiceFocusNode,
                source: source,
                destination: destination,
                stream: destination.stream
            };
        });
    }
    applyToSourceNode(source, context, options) {
        return $8bda8bb838ae7db6$var$__awaiter(this, void 0, void 0, function*() {
            const node = yield this.createNode(context, options);
            source.connect(node);
            return node;
        });
    }
}
module.exports.VoiceFocus = $8bda8bb838ae7db6$var$VoiceFocus;
const $8bda8bb838ae7db6$var$createAudioContext = (contextHint = $8bda8bb838ae7db6$var$DEFAULT_CONTEXT_HINT)=>{
    return new (window.AudioContext || window.webkitAudioContext)(contextHint);
};
module.exports.createAudioContext = $8bda8bb838ae7db6$var$createAudioContext;
const $8bda8bb838ae7db6$var$getAudioInput = (context, inputOptions, voiceFocusOptions)=>$8bda8bb838ae7db6$var$__awaiter(void 0, void 0, void 0, function*() {
        var _a, _b;
        const { constraints: constraints, spec: spec, delegate: delegate, preload: preload = true, options: options } = inputOptions;
        const { logger: logger } = voiceFocusOptions;
        const config = yield $8bda8bb838ae7db6$var$VoiceFocus.configure(spec, voiceFocusOptions);
        if (!config.supported) {
            (_a = voiceFocusOptions.logger) === null || _a === void 0 || _a.warn('Voice Focus not supported; returning standard stream.');
            return window.navigator.mediaDevices.getUserMedia(constraints);
        }
        const factory = yield $8bda8bb838ae7db6$var$VoiceFocus.init(config, {
            delegate: delegate,
            preload: preload,
            logger: logger
        });
        const agc = ((_b = inputOptions.options) === null || _b === void 0 ? void 0 : _b.agc) || $8bda8bb838ae7db6$var$DEFAULT_AGC_SETTING;
        const input = yield window.navigator.mediaDevices.getUserMedia($8bda8bb838ae7db6$var$mungeConstraints(constraints, agc));
        return factory.applyToStream(input, context, options).then((result)=>result.stream);
    });
module.exports.getAudioInput = $8bda8bb838ae7db6$var$getAudioInput;

});
parcelRegister("lxOy8", function(module, exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
"use strict";
var $faf3e42380ebf698$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decideModel = module.exports.measureAndDecideExecutionApproach = void 0;

var $aJA5z = parcelRequire("aJA5z");

var $euItc = parcelRequire("euItc");
const $faf3e42380ebf698$var$DEFAULT_EXECUTION_QUANTA = 3;
const $faf3e42380ebf698$var$SIMD_SCORE_FIXED_POINT = 2.50;
const $faf3e42380ebf698$var$WASM_SCORE_FIXED_POINT = 2.63;
const $faf3e42380ebf698$var$SINGLE_INLINE_SCORE_MULTIPLIER = 0.6;
const $faf3e42380ebf698$var$QUALITY_MULTIPLE_QUANTA_SCORE_MULTIPLIER = 0.65;
const $faf3e42380ebf698$var$INTERACTIVITY_MULTIPLE_QUANTA_SCORE_MULTIPLIER = 0.5;
const $faf3e42380ebf698$var$WORKER_SCORE_MULTIPLIER = 0.7;
const $faf3e42380ebf698$var$PERFORMANCE_THRESHOLDS = {
    wasm: {
        noSupport: 0.07,
        inline: {
            c100: 1,
            c50: 0.36,
            c20: 0.16,
            c10: 0.07
        },
        worker: {
            c100: 0.5,
            c50: 0.18,
            c20: 0.08,
            c10: 0.06
        }
    },
    simd: {
        noSupport: 0.10,
        inline: {
            c100: 1,
            c50: 0.43,
            c20: 0.3,
            c10: 0.2
        },
        worker: {
            c100: 0.5,
            c50: 0.21,
            c20: 0.15,
            c10: 0.10
        }
    }
};
class $faf3e42380ebf698$var$Estimator {
    constructor(fetchConfig, logger){
        this.fetchConfig = fetchConfig;
        this.logger = logger;
        const workerURL = `${fetchConfig.paths.workers}estimator-v1.js`;
        this.fetchBehavior = {
            headers: fetchConfig.headers,
            escapedQueryString: fetchConfig.escapedQueryString
        };
        this.worker = (0, $aJA5z.loadWorker)(workerURL, 'VoiceFocusEstimator', this.fetchBehavior, logger);
    }
    roundtrip(toSend, receive, expectedKey) {
        return new Promise((resolve, reject)=>{
            this.worker.then((worker)=>{
                let listener;
                listener = (event)=>{
                    const { message: message, key: key } = event.data;
                    if (message === receive && key === expectedKey) {
                        worker.removeEventListener('message', listener);
                        resolve(event.data);
                    }
                };
                worker.addEventListener('message', listener);
                worker.postMessage(toSend);
            }).catch((e)=>{
                var _a;
                (_a = this.logger) === null || _a === void 0 || _a.error('Failed to load worker.', e);
                reject(e);
            });
        });
    }
    supportsSIMD(url) {
        const key = 'simd';
        const path = url || `${this.fetchConfig.paths.wasm}simd-v1.wasm`;
        const toSend = {
            message: 'supports-simd',
            fetchBehavior: this.fetchBehavior,
            path: path,
            key: key
        };
        return this.roundtrip(toSend, 'simd-support', key).then((data)=>data.supports);
    }
    measure(simd, budget) {
        const benchWASM = `${this.fetchConfig.paths.wasm}bench-v1.wasm`;
        const benchSIMD = `${this.fetchConfig.paths.wasm}bench-v1_simd.wasm`;
        const path = simd ? benchSIMD : benchWASM;
        const key = `bench:${simd}`;
        const toSend = {
            message: 'measure',
            fetchBehavior: this.fetchBehavior,
            budget: budget,
            path: path,
            key: key
        };
        return this.roundtrip(toSend, 'measurement', key).then((data)=>{
            if (data.measurement) return data.measurement;
            throw new Error('Failed to measure.');
        });
    }
    stop() {
        this.worker.then((worker)=>{
            var _a;
            (_a = this.logger) === null || _a === void 0 || _a.debug('Stopping estimator worker.');
            worker.terminate();
        }).catch((e)=>{});
    }
}
const $faf3e42380ebf698$var$inlineScoreMultiplier = (executionQuanta, usagePreference)=>{
    if (executionQuanta === 1) return $faf3e42380ebf698$var$SINGLE_INLINE_SCORE_MULTIPLIER;
    if (usagePreference === 'quality') return $faf3e42380ebf698$var$QUALITY_MULTIPLE_QUANTA_SCORE_MULTIPLIER * executionQuanta;
    return $faf3e42380ebf698$var$INTERACTIVITY_MULTIPLE_QUANTA_SCORE_MULTIPLIER * executionQuanta;
};
const $faf3e42380ebf698$var$decideExecutionApproach = ({ supportsSIMD: supportsSIMD, supportsSAB: supportsSAB, duration: duration, executionPreference: executionPreference = 'auto', simdPreference: simdPreference, variantPreference: variantPreference = 'auto', namePreference: namePreference = 'default', usagePreference: usagePreference, executionQuantaPreference: executionQuantaPreference = $faf3e42380ebf698$var$DEFAULT_EXECUTION_QUANTA }, allThresholds = $faf3e42380ebf698$var$PERFORMANCE_THRESHOLDS, logger)=>{
    const forceSIMD = simdPreference === 'force';
    const useSIMD = forceSIMD || simdPreference !== 'disable' && supportsSIMD;
    const checkScores = duration !== -1;
    const baseScore = checkScores ? (useSIMD ? $faf3e42380ebf698$var$SIMD_SCORE_FIXED_POINT : $faf3e42380ebf698$var$WASM_SCORE_FIXED_POINT) / duration : 0;
    const thresholds = useSIMD ? allThresholds.simd : allThresholds.wasm;
    const inlineScore = checkScores ? $faf3e42380ebf698$var$inlineScoreMultiplier(executionQuantaPreference, usagePreference) * baseScore : 0;
    const workerScore = checkScores ? $faf3e42380ebf698$var$WORKER_SCORE_MULTIPLIER * baseScore : 0;
    const name = namePreference;
    const unsupported = (reason)=>{
        return {
            supported: false,
            reason: reason
        };
    };
    if (checkScores) {
        if (baseScore < thresholds.noSupport) return unsupported(`Performance score ${baseScore} worse than threshold ${thresholds.noSupport}.`);
    } else {
        if (executionPreference === 'auto' || variantPreference === 'auto') return unsupported(`Missing explicit execution (${executionPreference}) or variant (${variantPreference}) preference, but no scoring performed.`);
    }
    logger === null || logger === void 0 || logger.debug(`Bench duration ${duration} yields inline score ${inlineScore} and worker score ${workerScore}.`);
    const succeed = (processor, executionApproach, variant)=>{
        return {
            supported: true,
            useSIMD: useSIMD,
            processor: processor,
            executionApproach: executionApproach,
            variant: variant,
            executionQuanta: executionApproach === 'inline' ? executionQuantaPreference : undefined,
            name: name
        };
    };
    const resolveVariant = (score, variant, lookup)=>{
        if (variant !== 'auto') {
            if (!checkScores || score > lookup[variant]) return variant;
            return 'failed';
        }
        if (score > lookup.c100) return 'c100';
        if (score > lookup.c50) return 'c50';
        if (score > lookup.c20) return 'c20';
        if (score > lookup.c10) return 'c10';
        return 'failed';
    };
    const reducePreference = (preference)=>{
        switch(preference || 'auto'){
            case 'auto':
                {
                    let inlineOption = reducePreference('inline');
                    let workerOption = reducePreference('worker');
                    logger === null || logger === void 0 || logger.debug(`Reducing auto preference: ${JSON.stringify(inlineOption)} vs ${JSON.stringify(workerOption)}`);
                    if (inlineOption.supported === false) return workerOption;
                    if (workerOption.supported === false) return workerOption;
                    if (inlineOption.variant === workerOption.variant || inlineOption.variant === 'c50') return inlineOption;
                    return workerOption;
                }
            case 'worker':
                if ((0, $euItc.supportsSharedArrayBuffer)(globalThis, window, logger)) return reducePreference('worker-sab');
                return reducePreference('worker-postMessage');
            case 'inline':
                {
                    const variant = resolveVariant(inlineScore, variantPreference, thresholds.inline);
                    if (variant === 'failed') return unsupported(`Performance score ${inlineScore} not sufficient for inline use with variant preference ${variantPreference}.`);
                    return succeed('voicefocus-inline-processor', 'inline', variant);
                }
            case 'worker-sab':
                {
                    if (!supportsSAB) {
                        const reason = 'Requested worker-sab but no SharedArrayBuffer support.';
                        logger === null || logger === void 0 || logger.warn(reason);
                        return {
                            supported: false,
                            reason: reason
                        };
                    }
                    const variant = resolveVariant(workerScore, variantPreference, thresholds.worker);
                    if (variant === 'failed') return unsupported(`Performance score ${workerScore} not sufficient for worker use with variant preference ${variantPreference}.`);
                    return succeed('voicefocus-worker-sab-processor', 'worker-sab', variant);
                }
            case 'worker-postMessage':
                {
                    const variant = resolveVariant(workerScore, variantPreference, thresholds.worker);
                    if (variant === 'failed') return unsupported(`Performance score ${workerScore} not sufficient for worker use.`);
                    if (name === 'ns_es') {
                        const reason = 'Requested echo suppression but postMessage executor does not support it.';
                        logger === null || logger === void 0 || logger.warn(reason);
                        return {
                            supported: false,
                            reason: reason
                        };
                    }
                    return succeed('voicefocus-worker-postMessage-processor', 'worker-postMessage', variant);
                }
        }
    };
    return reducePreference(executionPreference);
};
const $faf3e42380ebf698$var$featureCheck = (forceSIMD, fetchConfig, logger, estimator)=>$faf3e42380ebf698$var$__awaiter(void 0, void 0, void 0, function*() {
        const supports = {
            supportsSIMD: forceSIMD,
            supportsSAB: (0, $euItc.supportsSharedArrayBuffer)(globalThis, window, logger),
            duration: -1
        };
        if (forceSIMD) {
            logger === null || logger === void 0 || logger.info('Supports SIMD: true (force)');
            return supports;
        }
        const cleanup = !estimator;
        const e = estimator || new $faf3e42380ebf698$var$Estimator(fetchConfig, logger);
        try {
            const useSIMD = !(0, $euItc.isOldChrome)(window, logger) && (yield e.supportsSIMD());
            logger === null || logger === void 0 || logger.info(`Supports SIMD: ${useSIMD} (force: ${forceSIMD})`);
            supports.supportsSIMD = useSIMD;
            return supports;
        } finally{
            if (cleanup) e.stop();
        }
    });
const $faf3e42380ebf698$var$estimateAndFeatureCheck = (forceSIMD, fetchConfig, estimatorBudget, logger)=>$faf3e42380ebf698$var$__awaiter(void 0, void 0, void 0, function*() {
        const estimator = new $faf3e42380ebf698$var$Estimator(fetchConfig, logger);
        try {
            const supports = yield $faf3e42380ebf698$var$featureCheck(forceSIMD, fetchConfig, logger, estimator);
            if (supports.supportsSIMD) try {
                supports.duration = yield estimator.measure(true, estimatorBudget);
                logger === null || logger === void 0 || logger.info('SIMD timing:', supports.duration);
                return supports;
            } catch (e) {
                logger === null || logger === void 0 || logger.warn('Failed SIMD estimation; falling back to non-SIMD.');
                supports.supportsSIMD = false;
            }
            supports.duration = yield estimator.measure(false, estimatorBudget);
            logger === null || logger === void 0 || logger.info('No-SIMD timing:', supports.duration);
            return supports;
        } catch (e) {
            logger === null || logger === void 0 || logger.error('Could not feature check.', e);
            throw e;
        } finally{
            estimator.stop();
        }
    });
const $faf3e42380ebf698$var$measureAndDecideExecutionApproach = (spec, fetchConfig, logger, thresholds = $faf3e42380ebf698$var$PERFORMANCE_THRESHOLDS)=>$faf3e42380ebf698$var$__awaiter(void 0, void 0, void 0, function*() {
        let executionPreference = spec.executionPreference;
        const { usagePreference: usagePreference, variantPreference: variantPreference, namePreference: namePreference, simdPreference: simdPreference, estimatorBudget: estimatorBudget, executionQuantaPreference: executionQuantaPreference } = spec;
        if (usagePreference === 'interactivity' && executionPreference !== 'inline') {
            logger === null || logger === void 0 || logger.debug(`Overriding execution preference ${executionPreference} to reflect interactivity preference.`);
            executionPreference = 'inline';
        }
        const forceSIMD = simdPreference === 'force';
        const knownModel = variantPreference !== 'auto';
        const knownExecution = executionPreference !== 'auto';
        let supports;
        try {
            if (knownModel && knownExecution) supports = yield $faf3e42380ebf698$var$featureCheck(forceSIMD, fetchConfig, logger);
            else supports = yield $faf3e42380ebf698$var$estimateAndFeatureCheck(forceSIMD, fetchConfig, estimatorBudget, logger);
        } catch (e) {
            logger === null || logger === void 0 || logger.error('Could not load estimator.', e);
            throw new Error('Could not load Voice Focus estimator.');
        }
        return $faf3e42380ebf698$var$decideExecutionApproach(Object.assign(Object.assign({}, supports), {
            simdPreference: simdPreference,
            executionPreference: executionPreference,
            variantPreference: variantPreference,
            namePreference: namePreference,
            usagePreference: usagePreference,
            executionQuantaPreference: executionQuantaPreference
        }), thresholds, logger);
    });
module.exports.measureAndDecideExecutionApproach = $faf3e42380ebf698$var$measureAndDecideExecutionApproach;
const $faf3e42380ebf698$var$decideModel = ({ category: category, name: name, variant: variant, simd: simd, url: url })=>{
    return `${category}-${name}-${variant}-v1${simd ? '_simd' : ''}`;
};
module.exports.decideModel = $faf3e42380ebf698$var$decideModel;

});

parcelRegister("bp4SR", function(module, exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
"use strict";
var $84d5d15c8295e23b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $euItc = parcelRequire("euItc");

var $6qNUx = parcelRequire("6qNUx");
const $84d5d15c8295e23b$var$CPU_WARNING_MAX_INTERVAL_MS = 5000;
const $84d5d15c8295e23b$var$METRICS_MAX_INTERVAL_MS = 5000;
class $84d5d15c8295e23b$var$VoiceFocusInlineNode extends $6qNUx.VoiceFocusAudioWorkletNode {
    constructor(context, options){
        super(context, options.processor, options);
        this.cpuWarningCount = 0;
        this.metrics = {
            latencyMillisAverage: 0,
            snr: {
                average: 0,
                averageActive: 0,
                variance: 0,
                varianceActive: 0
            },
            drr: {
                average: 0,
                variance: 0,
                averageActive: 0,
                varianceActive: 0
            },
            vad: {
                average: 0
            },
            cpu: {
                lateInvoke: 0,
                longInvoke: 0
            }
        };
        this.enabled = false;
        this.channelCountMode = 'explicit';
        this.channelCount = 1;
        const { modelURL: modelURL, worker: worker, fetchBehavior: fetchBehavior, logger: logger, delegate: delegate } = options;
        this.logger = logger;
        this.port.onmessage = this.onProcessorMessage.bind(this);
        this.delegate = delegate;
        if (logger) logger.debug('VoiceFocusInlineNode:', modelURL);
        this.worker = worker;
        this.worker.onmessage = this.onWorkerMessage.bind(this);
        const message = (0, $euItc.supportsWASMPostMessage)(globalThis) ? 'get-module' : 'get-module-buffer';
        this.worker.postMessage({
            message: message,
            key: 'model',
            fetchBehavior: fetchBehavior,
            path: modelURL
        });
        this.enabled = true;
    }
    onModuleBufferLoaded(buffer, key) {
        this.port.postMessage({
            message: 'module-buffer',
            buffer: buffer,
            key: key
        });
    }
    onModuleLoaded(module, key) {
        this.port.postMessage({
            message: 'module',
            module: module,
            key: key
        });
    }
    enable() {
        return $84d5d15c8295e23b$var$__awaiter(this, void 0, void 0, function*() {
            this.port.postMessage({
                message: 'enable'
            });
            this.enabled = true;
        });
    }
    disable() {
        return $84d5d15c8295e23b$var$__awaiter(this, void 0, void 0, function*() {
            this.port.postMessage({
                message: 'disable'
            });
            this.enabled = false;
        });
    }
    setMode(mode) {
        return $84d5d15c8295e23b$var$__awaiter(this, void 0, void 0, function*() {
            this.port.postMessage({
                message: 'set-mode',
                mode: mode
            });
        });
    }
    stop() {
        var _a;
        return $84d5d15c8295e23b$var$__awaiter(this, void 0, void 0, function*() {
            this.port.postMessage({
                message: 'stop'
            });
            try {
                (_a = this.worker) === null || _a === void 0 || _a.terminate();
            } catch (e) {
                console.error("failed to terminate worker:", e);
            }
            this.disconnect();
            this.enabled = false;
        });
    }
    reset() {
        this.metrics = {
            latencyMillisAverage: 0,
            snr: {
                average: 0,
                averageActive: 0,
                variance: 0,
                varianceActive: 0
            },
            drr: {
                average: 0,
                variance: 0,
                averageActive: 0,
                varianceActive: 0
            },
            vad: {
                average: 0
            },
            cpu: {
                lateInvoke: 0,
                longInvoke: 0
            }
        };
        this.port.postMessage({
            message: 'reset'
        });
    }
    isEnabled() {
        return this.enabled;
    }
    onProcessorMessage(event) {
        var _a, _b, _c, _d, _e, _f;
        const { data: data } = event;
        const { message: message } = data;
        switch(message){
            case 'cpu':
                const { reason: reason, count: count } = data;
                if (reason && count) this.metrics.cpu = Object.assign(Object.assign({}, this.metrics.cpu), {
                    [reason]: count + this.metrics.cpu[reason]
                });
                this.cpuWarningCount++;
                const now = Date.now();
                const before = this.cpuWarningLastTriggered || now;
                const diff = Math.abs(now - before);
                if (!this.cpuWarningLastTriggered || diff > $84d5d15c8295e23b$var$CPU_WARNING_MAX_INTERVAL_MS) {
                    (_a = this.logger) === null || _a === void 0 || _a.warn(`CPU warning (count: ${this.cpuWarningCount}):`, message);
                    this.cpuWarningCount = 0;
                    this.cpuWarningLastTriggered = now;
                }
                (_b = this.delegate) === null || _b === void 0 || _b.onCPUWarning();
                break;
            case 'metrics':
                const { metrics: metrics } = data;
                if (!metrics) {
                    (_c = this.logger) === null || _c === void 0 || _c.warn("Got metrics message but no metrics payload");
                    break;
                }
                this.metrics = Object.assign(Object.assign({}, this.metrics), metrics);
                if (this.logger) {
                    const now = Date.now();
                    const diff = now - ((_d = this.metricsLastRecorded) !== null && _d !== void 0 ? _d : 0);
                    if (diff > $84d5d15c8295e23b$var$METRICS_MAX_INTERVAL_MS) {
                        (_e = this.logger) === null || _e === void 0 || _e.debug("Contact metrics:", this.metrics);
                        this.metricsLastRecorded = now;
                    }
                }
                break;
            default:
                (_f = this.logger) === null || _f === void 0 || _f.debug('Ignoring processor message.');
        }
    }
    getModelMetrics() {
        return this.metrics;
    }
    onWorkerMessage(event) {
        const data = event.data;
        switch(data.message){
            case 'module-buffer':
                if (!data.buffer || !data.key) return;
                this.onModuleBufferLoaded(data.buffer, data.key);
                break;
            case 'module':
                if (!data.module || !data.key) return;
                this.onModuleLoaded(data.module, data.key);
                break;
            case 'stopped':
                if (this.worker) this.worker.terminate();
                break;
            default:
                return;
        }
    }
}
module.exports.default = $84d5d15c8295e23b$var$VoiceFocusInlineNode;

});
parcelRegister("6qNUx", function(module, exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceFocusAudioWorkletNode = void 0;
class $4aebe307807ae70d$var$VoiceFocusAudioWorkletNode extends (typeof globalThis !== 'undefined' && globalThis['AudioWorkletNode'] || class Sadness {
}) {
}
module.exports.VoiceFocusAudioWorkletNode = $4aebe307807ae70d$var$VoiceFocusAudioWorkletNode;

});


parcelRegister("33PEZ", function(module, exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
"use strict";
var $23a9b987f2e47606$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $euItc = parcelRequire("euItc");

var $6qNUx = parcelRequire("6qNUx");
const $23a9b987f2e47606$var$INDICES = {
    ready: 0,
    enabled: 1
};
const $23a9b987f2e47606$var$STATES = {
    disabled: 0,
    enabled: 1,
    stopped: 2
};
class $23a9b987f2e47606$var$VoiceFocusWorkerBufferNode extends $6qNUx.VoiceFocusAudioWorkletNode {
    constructor(context, options){
        super(context, options.processor, options);
        this.enabled = false;
        this.channelCountMode = 'explicit';
        this.channelCount = 1;
        const { modelURL: modelURL, resamplerURL: resamplerURL, worker: worker, fetchBehavior: fetchBehavior, delegate: delegate } = options;
        this.delegate = delegate;
        this.worker = worker;
        this.worker.onmessage = this.onWorkerMessage.bind(this);
        this.port.onmessage = this.onProcessorMessage.bind(this);
        const { enabled: enabled, supportFarendStream: supportFarendStream } = options.processorOptions;
        this.worker.postMessage({
            message: 'init',
            approach: 'sab',
            frames: context.sampleRate === 16000 ? 160 : 480,
            enabled: enabled,
            model: modelURL,
            supportFarendStream: supportFarendStream
        });
        const message = (0, $euItc.supportsWASMPostMessage)(globalThis) ? 'get-module' : 'get-module-buffer';
        this.worker.postMessage({
            message: message,
            key: 'resampler',
            fetchBehavior: fetchBehavior,
            path: resamplerURL
        });
        this.enabled = true;
    }
    enable() {
        return $23a9b987f2e47606$var$__awaiter(this, void 0, void 0, function*() {
            if (this.state) {
                Atomics.store(this.state, $23a9b987f2e47606$var$INDICES.enabled, $23a9b987f2e47606$var$STATES.enabled);
                Atomics.notify(this.state, $23a9b987f2e47606$var$INDICES.ready, 1);
            } else this.worker.postMessage({
                message: 'enable'
            });
            this.enabled = true;
        });
    }
    disable() {
        return $23a9b987f2e47606$var$__awaiter(this, void 0, void 0, function*() {
            if (this.state) {
                Atomics.store(this.state, $23a9b987f2e47606$var$INDICES.enabled, $23a9b987f2e47606$var$STATES.disabled);
                Atomics.notify(this.state, $23a9b987f2e47606$var$INDICES.ready, 1);
            } else this.worker.postMessage({
                message: 'disable'
            });
            this.enabled = false;
        });
    }
    setMode(mode) {
        return $23a9b987f2e47606$var$__awaiter(this, void 0, void 0, function*() {
            this.port.postMessage({
                message: 'set-mode',
                mode: mode
            });
        });
    }
    stop() {
        return $23a9b987f2e47606$var$__awaiter(this, void 0, void 0, function*() {
            if (this.state) {
                Atomics.store(this.state, $23a9b987f2e47606$var$INDICES.enabled, $23a9b987f2e47606$var$STATES.stopped);
                Atomics.notify(this.state, $23a9b987f2e47606$var$INDICES.ready, 1);
            } else try {
                this.worker.postMessage({
                    message: 'stop'
                });
            } catch (e) {}
            this.disconnect();
            this.enabled = false;
        });
    }
    getModelMetrics() {
        return undefined;
    }
    reset() {}
    isEnabled() {
        return this.enabled;
    }
    onWorkerMessage(event) {
        var _a;
        const data = event.data;
        switch(data.message){
            case 'ready':
                if (!data.shared) throw new Error('No shared state.');
                this.state = new Int32Array(data.shared.state);
                this.port.postMessage(data);
                break;
            case 'stopped':
                this.worker.terminate();
                break;
            case 'module-buffer':
            case 'module':
                this.port.postMessage(data);
                break;
            case 'cpu':
                (_a = this.delegate) === null || _a === void 0 || _a.onCPUWarning();
                break;
            case 'processing':
                this.port.postMessage(data);
                break;
            default:
                return;
        }
    }
    onProcessorMessage(event) {
        var _a;
        const data = event.data;
        switch(data.message){
            case 'cpu':
                (_a = this.delegate) === null || _a === void 0 || _a.onCPUWarning();
                break;
            case 'prepare-for-frames':
                this.worker.postMessage(data);
                break;
            default:
        }
    }
}
module.exports.default = $23a9b987f2e47606$var$VoiceFocusWorkerBufferNode;

});

parcelRegister("juQ8L", function(module, exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
"use strict";
var $e31943a1bda8952e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $euItc = parcelRequire("euItc");

var $6qNUx = parcelRequire("6qNUx");
class $e31943a1bda8952e$var$VoiceFocusWorkerPostMessageNode extends $6qNUx.VoiceFocusAudioWorkletNode {
    constructor(context, options){
        super(context, options.processor, options);
        this.enabled = false;
        this.channelCountMode = 'explicit';
        this.channelCount = 1;
        const { modelURL: modelURL, audioBufferURL: audioBufferURL, worker: worker, fetchBehavior: fetchBehavior, delegate: delegate } = options;
        this.delegate = delegate;
        this.worker = worker;
        this.worker.onmessage = this.onWorkerMessage.bind(this);
        this.port.onmessage = this.onProcessorMessage.bind(this);
        const { enabled: enabled, agc: agc, supportFarendStream: supportFarendStream } = options.processorOptions;
        this.worker.postMessage({
            message: 'init',
            approach: 'postMessage',
            frames: context.sampleRate === 16000 ? 160 : 480,
            enabled: enabled,
            agc: agc,
            fetchBehavior: fetchBehavior,
            model: modelURL,
            supportFarendStream: supportFarendStream
        });
        const message = (0, $euItc.supportsWASMPostMessage)(globalThis) ? 'get-module' : 'get-module-buffer';
        this.worker.postMessage({
            message: message,
            key: 'buffer',
            fetchBehavior: fetchBehavior,
            path: audioBufferURL
        });
        this.enabled = true;
    }
    enable() {
        return $e31943a1bda8952e$var$__awaiter(this, void 0, void 0, function*() {
            this.worker.postMessage({
                message: 'enable'
            });
            this.enabled = true;
        });
    }
    disable() {
        return $e31943a1bda8952e$var$__awaiter(this, void 0, void 0, function*() {
            this.worker.postMessage({
                message: 'disable'
            });
            this.enabled = false;
        });
    }
    setMode(mode) {
        return $e31943a1bda8952e$var$__awaiter(this, void 0, void 0, function*() {
            this.port.postMessage({
                message: 'set-mode',
                mode: mode
            });
        });
    }
    stop() {
        return $e31943a1bda8952e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                this.worker.postMessage({
                    message: 'stop'
                });
            } catch (e) {}
            this.disconnect();
            this.enabled = false;
        });
    }
    getModelMetrics() {
        return undefined;
    }
    reset() {}
    isEnabled() {
        return this.enabled;
    }
    onWorkerMessage(event) {
        var _a;
        const data = event.data;
        switch(data.message){
            case 'ready':
                this.port.postMessage({
                    message: 'ready',
                    shared: data.shared
                }, data.shared ? Object.values(data.shared) : []);
                break;
            case 'data':
                if (!data.buffer) return;
                this.port.postMessage({
                    message: 'data',
                    buffer: data.buffer
                }, [
                    data.buffer
                ]);
                break;
            case 'stopped':
                this.worker.terminate();
                break;
            case 'module-buffer':
            case 'module':
                this.port.postMessage(data);
                break;
            case 'cpu':
                (_a = this.delegate) === null || _a === void 0 || _a.onCPUWarning();
                break;
            case 'processing':
                this.port.postMessage(data);
                break;
            default:
                return;
        }
    }
    onProcessorMessage(event) {
        var _a;
        const data = event.data;
        switch(data.message){
            case 'data':
                if (!data.buffer) return;
                this.worker.postMessage({
                    message: 'data',
                    buffer: data.buffer
                }, [
                    data.buffer
                ]);
                break;
            case 'cpu':
                (_a = this.delegate) === null || _a === void 0 || _a.onCPUWarning();
                break;
            case 'prepare-for-frames':
                this.worker.postMessage(data);
                break;
            default:
                return;
        }
    }
}
module.exports.default = $e31943a1bda8952e$var$VoiceFocusWorkerPostMessageNode;

});


parcelRegister("czi8e", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/** @internal */ function $9266d184db093bd3$var$stringify(args) {
    return args.map((v)=>{
        if (typeof v === 'object') return JSON.stringify(v);
        return `${v}`;
    }).join(' ');
}
/** @internal */ class $9266d184db093bd3$var$LoggerAdapter {
    constructor(base){
        this.base = base;
    }
    debug(...args) {
        this.base.debug($9266d184db093bd3$var$stringify(args));
    }
    info(...args) {
        this.base.info($9266d184db093bd3$var$stringify(args));
    }
    warn(...args) {
        this.base.warn($9266d184db093bd3$var$stringify(args));
    }
    error(...args) {
        this.base.error($9266d184db093bd3$var$stringify(args));
    }
}
module.exports.default = $9266d184db093bd3$var$LoggerAdapter;

});

parcelRegister("2bbQi", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $1965cb8888a61d64$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $1965cb8888a61d64$var$DefaultBrowserBehavior_1 = $1965cb8888a61d64$var$__importDefault((parcelRequire("e2TuV")));
/**
 * A device that augments a {@link Device} to apply Amazon Voice Focus
 * noise suppression to an audio input.
 */ class $1965cb8888a61d64$var$VoiceFocusTransformDevice {
    /** @internal */ constructor(device, voiceFocus, delegate, nodeOptions, failed = false, node, browserBehavior = new $1965cb8888a61d64$var$DefaultBrowserBehavior_1.default(), /** farEndStreams` maps from a stream that could cause echo or interfere with double talkto an `AudioSourceNode` that we use to mix multiple such streams.*/ farEndStreamToAudioSourceNode = new Map(), /** mixDestNode is the Audio Destination Node where farEndStreams got mixed into one stream.*/ mixDestNode, /** mixSourceNode is the Audio Source Node where the stream out of mixDestNode got transferred into Audio Worklet Node for processing.*/ mixSourceNode){
        this.device = device;
        this.voiceFocus = voiceFocus;
        this.delegate = delegate;
        this.nodeOptions = nodeOptions;
        this.failed = failed;
        this.node = node;
        this.browserBehavior = browserBehavior;
        this.farEndStreamToAudioSourceNode = farEndStreamToAudioSourceNode;
        this.mixDestNode = mixDestNode;
        this.mixSourceNode = mixSourceNode;
    }
    /**
     * Return the inner device as provided during construction, or updated via
     * {@link VoiceFocusTransformDevice.chooseNewInnerDevice}. Do not confuse
     * this method with {@link VoiceFocusTransformDevice.intrinsicDevice}.
     */ getInnerDevice() {
        return this.device;
    }
    /**
     * Disable the audio node while muted to reduce CPU usage.
     *
     * @param muted whether the audio device should be muted.
     */ async mute(muted) {
        if (!this.node) return;
        if (muted) await this.node.disable();
        else await this.node.enable();
    }
    /**
     * Dispose of the inner workings of the transform device. After this method is called
     * you will need to create a new device to use Amazon Voice Focus again.
     */ async stop() {
        if (!this.node) return;
        this.node.disconnect();
        await this.node.stop();
    }
    /**
     * If you wish to choose a different inner device, but continue to use Amazon Voice Focus, you
     * can use this method to efficiently create a new device that will reuse
     * the same internal state. Only one of the two devices can be used at a time: switch
     * between them using {@link DeviceController.startAudioInput}.
     *
     * If the same device is passed as is currently in use, `this` is returned.
     *
     * @param inner The new inner device to use.
     */ async chooseNewInnerDevice(inner) {
        // If the new device is 'default', always recreate. Chrome can switch out
        // the real device underneath us.
        if (this.device === inner && !$1965cb8888a61d64$var$isDefaultDevice(inner)) return this;
        return new $1965cb8888a61d64$var$VoiceFocusTransformDevice(inner, this.voiceFocus, this.delegate, this.nodeOptions, this.failed, this.node, this.browserBehavior, this.farEndStreamToAudioSourceNode, this.mixDestNode, this.mixSourceNode);
    }
    async intrinsicDevice() {
        if (this.failed) return this.device;
        const isUsingES = this.nodeOptions.es;
        // Turn the Device into constraints with appropriate AGC settings.
        const trackConstraints = {
            echoCancellation: !isUsingES,
            // @ts-ignore
            googEchoCancellation: !isUsingES,
            // @ts-ignore
            googEchoCancellation2: !isUsingES,
            noiseSuppression: false,
            // @ts-ignore
            googNoiseSuppression: false,
            // @ts-ignore
            googHighpassFilter: false,
            // @ts-ignore
            googNoiseSuppression2: false
        };
        let useBuiltInAGC;
        if (this.nodeOptions && this.nodeOptions.agc !== undefined) useBuiltInAGC = this.nodeOptions.agc.useBuiltInAGC;
        else useBuiltInAGC = true;
        trackConstraints.autoGainControl = useBuiltInAGC;
        // @ts-ignore
        trackConstraints.googAutoGainControl = useBuiltInAGC;
        // @ts-ignore
        trackConstraints.googAutoGainControl2 = useBuiltInAGC;
        // Empty string and null.
        if (!this.device) return trackConstraints;
        // Device ID.
        if (typeof this.device === 'string') {
            /* istanbul ignore if */ if (this.browserBehavior.requiresNoExactMediaStreamConstraints()) trackConstraints.deviceId = this.device;
            else trackConstraints.deviceId = {
                exact: this.device
            };
            return trackConstraints;
        }
        // It's a stream.
        if (this.device.id) // Nothing we can do.
        return this.device;
        // It's constraints.
        return {
            ...this.device,
            ...trackConstraints
        };
    }
    async createAudioNode(context) {
        var _a, _b;
        if (((_a = this.node) === null || _a === void 0 ? void 0 : _a.context) === context) return {
            start: this.node,
            end: this.node
        };
        const agc = {
            useVoiceFocusAGC: false
        };
        const options = {
            enabled: true,
            agc: agc,
            ...this.nodeOptions
        };
        try {
            (_b = this.node) === null || _b === void 0 || _b.disconnect();
            this.node = await this.voiceFocus.createNode(context, options);
            if (this.nodeOptions.es) {
                this.mixDestNode = new MediaStreamAudioDestinationNode(context, {
                    channelCount: 1,
                    channelCountMode: 'explicit'
                });
                for (const stream of this.farEndStreamToAudioSourceNode.keys())this.assignFarEndStreamToAudioSourceNode(stream);
                this.createMixSourceNode();
            }
            const start = this.node;
            const end = this.node;
            return {
                start: start,
                end: end
            };
        } catch (e) {
            // It's better to return some audio stream than nothing.
            this.failed = true;
            this.delegate.onFallback(this, e);
            throw e;
        }
    }
    async observeMeetingAudio(audioVideo) {
        if (!this.nodeOptions.es) return;
        audioVideo.addAudioMixObserver(this);
        const stream = await audioVideo.getCurrentMeetingAudioStream();
        if (stream) this.addFarEndStream(stream);
    }
    async unObserveMeetingAudio(audioVideo) {
        if (!this.nodeOptions.es) return;
        audioVideo.removeAudioMixObserver(this);
        const stream = await audioVideo.getCurrentMeetingAudioStream();
        if (stream) this.removeFarendStream(stream);
    }
    /**
     * Add an observer to receive notifications about Amazon Voice Focus lifecycle events.
     * See {@link VoiceFocusTransformDeviceObserver} for details.
     * If the observer has already been added, this method call has no effect.
     */ addObserver(observer) {
        this.delegate.addObserver(observer);
    }
    /**
     * Remove an existing observer. If the observer has not been previously
     * added via `addObserver`, this method call has no effect.
     */ removeObserver(observer) {
        this.delegate.removeObserver(observer);
    }
    async addFarEndStream(activeStream) {
        if (!this.nodeOptions.es || !activeStream || this.farEndStreamToAudioSourceNode.has(activeStream)) return;
        if (this.node) this.assignFarEndStreamToAudioSourceNode(activeStream);
        else this.farEndStreamToAudioSourceNode.set(activeStream, null);
    }
    async removeFarendStream(inactiveStream) {
        var _a;
        (_a = this.farEndStreamToAudioSourceNode.get(inactiveStream)) === null || _a === void 0 || _a.disconnect();
        this.farEndStreamToAudioSourceNode.delete(inactiveStream);
    }
    async meetingAudioStreamBecameActive(activeStream) {
        this.addFarEndStream(activeStream);
    }
    async meetingAudioStreamBecameInactive(inactiveStream) {
        this.removeFarendStream(inactiveStream);
    }
    assignFarEndStreamToAudioSourceNode(streamToAdd) {
        const streamNodeToAdd = this.node.context.createMediaStreamSource(streamToAdd);
        streamNodeToAdd.channelCount = 1;
        streamNodeToAdd.channelCountMode = 'explicit';
        this.farEndStreamToAudioSourceNode.set(streamToAdd, streamNodeToAdd);
        streamNodeToAdd.connect(this.mixDestNode, 0);
    }
    createMixSourceNode() {
        this.mixSourceNode = this.node.context.createMediaStreamSource(this.mixDestNode.stream);
        this.mixSourceNode.channelCount = 1;
        this.mixSourceNode.channelCountMode = 'explicit';
        this.mixSourceNode.connect(this.node, 0, 1);
    }
}
function $1965cb8888a61d64$var$isDefaultDevice(device) {
    if (device === 'default') return true;
    if (!device || typeof device !== 'object') return false;
    if ('deviceId' in device && device.deviceId === 'default') return true;
    if ('id' in device && device.id === 'default') return true;
    return false;
}
module.exports.default = $1965cb8888a61d64$var$VoiceFocusTransformDevice;

});

parcelRegister("jpwwn", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/** @internal */ class $e2199422b940d898$var$VoiceFocusTransformDeviceDelegate {
    constructor(){
        this.observers = new Set();
    }
    addObserver(observer) {
        this.observers.add(observer);
    }
    removeObserver(observer) {
        this.observers.delete(observer);
    }
    /** @internal */ onFallback(device, e) {
        var _a;
        for (const observer of this.observers)(_a = observer.voiceFocusFellBackToInnerStream) === null || _a === void 0 || _a.call(observer, device, e);
    }
    onCPUWarning() {
        var _a;
        for (const observer of this.observers)(_a = observer.voiceFocusInsufficientResources) === null || _a === void 0 || _a.call(observer);
    }
}
module.exports.default = $e2199422b940d898$var$VoiceFocusTransformDeviceDelegate;

});


parcelRegister("hVjEt", function(module, exports) {
"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $d0c700fdfe9db515$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $d0c700fdfe9db515$var$MeetingSessionStatusCode_1 = $d0c700fdfe9db515$var$__importDefault((parcelRequire("9zYoz")));

const $d0c700fdfe9db515$var$BaseTask_1 = $d0c700fdfe9db515$var$__importDefault((parcelRequire("9wPDz")));
/*
 * [[WaitForAttendeePresenceTask]] waits until an attendee presence event happens.
 */ class $d0c700fdfe9db515$var$WaitForAttendeePresenceTask extends $d0c700fdfe9db515$var$BaseTask_1.default {
    constructor(context){
        super(context.logger);
        this.context = context;
        this.taskName = 'WaitForAttendeePresenceTask';
    }
    cancel() {
        // Just in case. The baseCancel behavior should prevent this.
        /* istanbul ignore else */ if (this.cancelPromise) {
            const error = new Error(`canceling ${this.name()} due to the meeting status code: ${$d0c700fdfe9db515$var$MeetingSessionStatusCode_1.default.NoAttendeePresent}`);
            this.cancelPromise(error);
            delete this.cancelPromise;
        }
    }
    async run() {
        const attendeeId = this.context.meetingSessionConfiguration.credentials.attendeeId;
        return new Promise((resolve, reject)=>{
            const handler = (presentAttendeeId, present, _externalUserId, _dropped, _pos)=>{
                if (attendeeId === presentAttendeeId && present) {
                    this.context.realtimeController.realtimeUnsubscribeToAttendeeIdPresence(handler);
                    resolve();
                    delete this.cancelPromise;
                }
            };
            this.cancelPromise = (error)=>{
                this.context.realtimeController.realtimeUnsubscribeToAttendeeIdPresence(handler);
                reject(error);
            };
            this.context.realtimeController.realtimeSubscribeToAttendeeIdPresence(handler);
        });
    }
}
module.exports.default = $d0c700fdfe9db515$var$WaitForAttendeePresenceTask;

});




parcelRegister("aACZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b5b82c49fa2535e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $7b5b82c49fa2535e$var$DEFAULT_USE_TITLE_OPTIONS = {
    restoreOnUnmount: false
};
function $7b5b82c49fa2535e$var$useTitle(title, options) {
    if (options === void 0) options = $7b5b82c49fa2535e$var$DEFAULT_USE_TITLE_OPTIONS;
    var prevTitleRef = (0, $acw62.useRef)(document.title);
    if (document.title !== title) document.title = title;
    (0, $acw62.useEffect)(function() {
        if (options && options.restoreOnUnmount) return function() {
            document.title = prevTitleRef.current;
        };
        else return;
    }, []);
}
var $7b5b82c49fa2535e$export$2e2bcd8739ae039 = typeof document !== 'undefined' ? $7b5b82c49fa2535e$var$useTitle : function(_title) {};

});


var $ayMG0 = parcelRequire("ayMG0");

var $82f7M = parcelRequire("82f7M");

var $cA8mQ = parcelRequire("cA8mQ");

var $ayMG0 = parcelRequire("ayMG0");

var $kQ0sT = parcelRequire("kQ0sT");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $d423b5e2928192b4$export$ab7c8fab0bc555b6(value) {
    const ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return (0, $acw62.useMemo)(()=>Object.freeze({
            get current () {
                return ref.current;
            }
        }), []);
}


function $d05cb292f945651f$export$f3a192d0cbd30b96(effect) {
    const effectRef = (0, $d423b5e2928192b4$export$ab7c8fab0bc555b6)(effect);
    (0, $acw62.useEffect)(()=>()=>{
            effectRef.current();
        }, []);
}


function $bac39c1edf6c5a62$export$e70e6da722faba05(callback, deps, delay, maxWait = 0) {
    const timeout = (0, $acw62.useRef)();
    const waitTimeout = (0, $acw62.useRef)();
    const lastCall = (0, $acw62.useRef)();
    const clear = ()=>{
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = undefined;
        }
        if (waitTimeout.current) {
            clearTimeout(waitTimeout.current);
            waitTimeout.current = undefined;
        }
    };
    // Cancel scheduled execution on unmount
    (0, $d05cb292f945651f$export$f3a192d0cbd30b96)(clear);
    return (0, $acw62.useMemo)(()=>{
        const execute = ()=>{
            // Barely possible to test this line
            /* istanbul ignore next */ if (!lastCall.current) return;
            const context = lastCall.current;
            lastCall.current = undefined;
            callback.apply(context.this, context.args);
            clear();
        };
        const wrapped = function(...args) {
            if (timeout.current) clearTimeout(timeout.current);
            lastCall.current = {
                args: args,
                this: this
            };
            // Plan regular execution
            timeout.current = setTimeout(execute, delay);
            // Plan maxWait execution if required
            if (maxWait > 0 && !waitTimeout.current) waitTimeout.current = setTimeout(execute, maxWait);
        };
        Object.defineProperties(wrapped, {
            length: {
                value: callback.length
            },
            name: {
                value: `${callback.name || 'anonymous'}__debounced__${delay}`
            }
        });
        return wrapped;
    }, [
        delay,
        maxWait,
        ...deps
    ]);
}


function $063d99a411e6854f$export$44b55d93c84df466(callback, deps, delay, maxWait = 0) {
    (0, $acw62.useEffect)((0, $bac39c1edf6c5a62$export$e70e6da722faba05)(callback, deps, delay, maxWait), deps);
}


var $acw62 = parcelRequire("acw62");

function $0073305fc8893db5$export$ede2eb47b82c13a2(callback, ms) {
    const cbRef = (0, $d423b5e2928192b4$export$ab7c8fab0bc555b6)(callback);
    (0, $acw62.useEffect)(()=>{
        if (!ms && ms !== 0) return;
        const id = setInterval(()=>{
            cbRef.current();
        }, ms);
        return ()=>{
            clearInterval(id);
        };
    }, [
        ms
    ]);
}


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $d8d8414bba8ca771$export$ddbfea47304c9e3() {
    const isFirstMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        isFirstMount.current = false;
    }, []);
    return isFirstMount.current;
}



var $acw62 = parcelRequire("acw62");
const $b0f63a0ae7ba4221$export$8793edee2d425525 = ()=>{};
const $b0f63a0ae7ba4221$export$4e09c449d6c407f7 = typeof window !== 'undefined' && typeof navigator !== 'undefined' && typeof document !== 'undefined';
const $b0f63a0ae7ba4221$export$bbcfc742c65abdc2 = (prev, next)=>prev === next;
const $b0f63a0ae7ba4221$export$756d8210573f3cd1 = (conditions)=>conditions.every(Boolean);
const $b0f63a0ae7ba4221$export$861c6d3c5a798b6c = (conditions)=>conditions.some(Boolean);


const $e9fe926c2cf8bc27$export$700979bc83e7db82 = (0, $b0f63a0ae7ba4221$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);




var $acw62 = parcelRequire("acw62");


function $17b09fa65b177e2a$export$496315a1608d9602(effect, deps) {
    const isFirstMount = (0, $d8d8414bba8ca771$export$ddbfea47304c9e3)();
    (0, $acw62.useEffect)(isFirstMount ? (0, $b0f63a0ae7ba4221$export$8793edee2d425525) : effect, deps);
}



function $d35f63cd7b21a0c6$export$af631764ddc44097(obj, ...args) {
    obj?.addEventListener?.(...args);
}
function $d35f63cd7b21a0c6$export$8c8705df4a2dcec9(obj, ...args) {
    obj?.removeEventListener?.(...args);
}
const $d35f63cd7b21a0c6$export$5a15a386532a5ea4 = (obj, property)=>Object.prototype.hasOwnProperty.call(obj, property);
const $d35f63cd7b21a0c6$export$93ead1fd1cf49e7d = ()=>true;
const $d35f63cd7b21a0c6$export$d47141051f75bbe2 = ()=>false;
const $d35f63cd7b21a0c6$export$fdc1631654156ab = (d1, d2)=>{
    if (d1 === d2) return true;
    if (d1.length !== d2.length) return false;
    for(let i = 0; i < d1.length; i++){
        if (d1[i] !== d2[i]) return false;
    }
    return true;
};


function $2142507703591402$export$efbb6b4f12b20b5e(nextState, prevState) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    if (typeof nextState === 'function') return nextState(prevState);
    return nextState;
}


const $1a6878b7281cb9e3$var$storageListeners = new Map();
const $1a6878b7281cb9e3$var$invokeStorageKeyListeners = (s, key, value, skipListener)=>{
    $1a6878b7281cb9e3$var$storageListeners.get(s)?.get(key)?.forEach((listener)=>{
        if (listener !== skipListener) listener(value);
    });
};
const $1a6878b7281cb9e3$var$storageEventHandler = (evt)=>{
    if (evt.storageArea && evt.key && evt.newValue) $1a6878b7281cb9e3$var$invokeStorageKeyListeners(evt.storageArea, evt.key, evt.newValue);
};
const $1a6878b7281cb9e3$var$addStorageListener = (s, key, listener)=>{
    // In case of first listener added within browser environment we
    // want to bind single storage event handler
    if ((0, $b0f63a0ae7ba4221$export$4e09c449d6c407f7) && $1a6878b7281cb9e3$var$storageListeners.size === 0) (0, $d35f63cd7b21a0c6$export$af631764ddc44097)(window, 'storage', $1a6878b7281cb9e3$var$storageEventHandler, {
        passive: true
    });
    let keys = $1a6878b7281cb9e3$var$storageListeners.get(s);
    if (!keys) {
        keys = new Map();
        $1a6878b7281cb9e3$var$storageListeners.set(s, keys);
    }
    let listeners = keys.get(key);
    if (!listeners) {
        listeners = new Set();
        keys.set(key, listeners);
    }
    listeners.add(listener);
};
const $1a6878b7281cb9e3$var$removeStorageListener = (s, key, listener)=>{
    const keys = $1a6878b7281cb9e3$var$storageListeners.get(s);
    /* istanbul ignore next */ if (!keys) return;
    const listeners = keys.get(key);
    /* istanbul ignore next */ if (!listeners) return;
    listeners.delete(listener);
    if (!listeners.size) keys.delete(key);
    if (!keys.size) $1a6878b7281cb9e3$var$storageListeners.delete(s);
    // Unbind storage event handler in browser environment in case there is no
    // storage keys listeners left
    if ((0, $b0f63a0ae7ba4221$export$4e09c449d6c407f7) && !$1a6878b7281cb9e3$var$storageListeners.size) (0, $d35f63cd7b21a0c6$export$8c8705df4a2dcec9)(window, 'storage', $1a6878b7281cb9e3$var$storageEventHandler);
};
const $1a6878b7281cb9e3$var$DEFAULT_OPTIONS = {
    defaultValue: null,
    initializeWithValue: true
};
function $1a6878b7281cb9e3$export$c9e55b214488f945(storage, key, options) {
    const optionsRef = (0, $d423b5e2928192b4$export$ab7c8fab0bc555b6)({
        ...$1a6878b7281cb9e3$var$DEFAULT_OPTIONS,
        ...options
    });
    const parse = (str, fallback)=>{
        const parseFunction = optionsRef.current.parse ?? $1a6878b7281cb9e3$var$defaultParse;
        return parseFunction(str, fallback);
    };
    const stringify = (data)=>{
        const stringifyFunction = optionsRef.current.stringify ?? $1a6878b7281cb9e3$var$defaultStringify;
        return stringifyFunction(data);
    };
    const storageActions = (0, $d423b5e2928192b4$export$ab7c8fab0bc555b6)({
        fetchRaw: ()=>storage.getItem(key),
        fetch: ()=>parse(storageActions.current.fetchRaw(), optionsRef.current.defaultValue),
        remove () {
            storage.removeItem(key);
        },
        store (val) {
            const stringified = stringify(val);
            if (stringified !== null) storage.setItem(key, stringified);
            return stringified;
        }
    });
    const isFirstMount = (0, $d8d8414bba8ca771$export$ddbfea47304c9e3)();
    const [state, setState] = (0, $acw62.useState)(optionsRef.current?.initializeWithValue && isFirstMount ? storageActions.current.fetch() : undefined);
    const stateRef = (0, $d423b5e2928192b4$export$ab7c8fab0bc555b6)(state);
    const stateActions = (0, $d423b5e2928192b4$export$ab7c8fab0bc555b6)({
        fetch () {
            setState(storageActions.current.fetch());
        },
        setRawVal (val) {
            setState(parse(val, optionsRef.current.defaultValue));
        }
    });
    (0, $17b09fa65b177e2a$export$496315a1608d9602)(()=>{
        stateActions.current.fetch();
    }, [
        key
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!optionsRef.current.initializeWithValue) stateActions.current.fetch();
    }, []);
    (0, $e9fe926c2cf8bc27$export$700979bc83e7db82)(()=>{
        const handler = stateActions.current.setRawVal;
        $1a6878b7281cb9e3$var$addStorageListener(storage, key, handler);
        return ()=>{
            $1a6878b7281cb9e3$var$removeStorageListener(storage, key, handler);
        };
    }, [
        storage,
        key
    ]);
    const actions = (0, $d423b5e2928192b4$export$ab7c8fab0bc555b6)({
        set (val) {
            if (!(0, $b0f63a0ae7ba4221$export$4e09c449d6c407f7)) return;
            const s = (0, $2142507703591402$export$efbb6b4f12b20b5e)(val, stateRef.current);
            const storeVal = storageActions.current.store(s);
            if (storeVal !== null) $1a6878b7281cb9e3$var$invokeStorageKeyListeners(storage, key, storeVal);
        },
        delete () {
            if (!(0, $b0f63a0ae7ba4221$export$4e09c449d6c407f7)) return;
            storageActions.current.remove();
            $1a6878b7281cb9e3$var$invokeStorageKeyListeners(storage, key, null);
        },
        fetch () {
            if (!(0, $b0f63a0ae7ba4221$export$4e09c449d6c407f7)) return;
            $1a6878b7281cb9e3$var$invokeStorageKeyListeners(storage, key, storageActions.current.fetchRaw());
        }
    });
    // Make actions static so developers can pass methods further
    const staticActions = (0, $acw62.useMemo)(()=>({
            set: (v)=>{
                actions.current.set(v);
            },
            remove () {
                actions.current.delete();
            },
            fetch () {
                actions.current.fetch();
            }
        }), []);
    return (0, $acw62.useMemo)(()=>({
            value: state,
            ...staticActions
        }), [
        state
    ]);
}
const $1a6878b7281cb9e3$var$defaultStringify = (data)=>{
    if (data === null) return null;
    try {
        return JSON.stringify(data);
    } catch (error) /* istanbul ignore next */ {
        // I have absolutely no idea how to cover this, since modern JSON.stringify does not throw on
        // cyclic references anymore
        console.warn(error);
        return null;
    }
};
const $1a6878b7281cb9e3$var$defaultParse = (str, fallback)=>{
    if (str === null) return fallback;
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return JSON.parse(str);
    } catch (error) {
        console.warn(error);
        return fallback;
    }
};



let $9364d06eb3906683$var$IS_SESSION_STORAGE_AVAILABLE;
try {
    $9364d06eb3906683$var$IS_SESSION_STORAGE_AVAILABLE = (0, $b0f63a0ae7ba4221$export$4e09c449d6c407f7) && Boolean(window.sessionStorage);
} catch  {
    // No need to test as this flag leads to noop behaviour
    /* istanbul ignore next */ $9364d06eb3906683$var$IS_SESSION_STORAGE_AVAILABLE = false;
}
const $9364d06eb3906683$export$509bc8842db77379 = $9364d06eb3906683$var$IS_SESSION_STORAGE_AVAILABLE ? (key, options)=>{
    return (0, $1a6878b7281cb9e3$export$c9e55b214488f945)(sessionStorage, key, options);
} : (_key, _options)=>{
    return {
        value: undefined,
        set: (0, $b0f63a0ae7ba4221$export$8793edee2d425525),
        remove: (0, $b0f63a0ae7ba4221$export$8793edee2d425525),
        fetch: (0, $b0f63a0ae7ba4221$export$8793edee2d425525)
    };
};


var $acw62 = parcelRequire("acw62");

function $d1809cb5a91ef255$export$7158785e55df0693(callback, deps, delay, noTrailing = false) {
    const timeout = (0, $acw62.useRef)();
    const lastCall = (0, $acw62.useRef)();
    (0, $d05cb292f945651f$export$f3a192d0cbd30b96)(()=>{
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = undefined;
        }
    });
    return (0, $acw62.useMemo)(()=>{
        const execute = (context, args)=>{
            lastCall.current = undefined;
            callback.apply(context, args);
            timeout.current = setTimeout(()=>{
                timeout.current = undefined;
                // If trailing execution is not disabled - call callback with last
                // received arguments and context
                if (!noTrailing && lastCall.current) {
                    execute(lastCall.current.this, lastCall.current.args);
                    lastCall.current = undefined;
                }
            }, delay);
        };
        const wrapped = function(...args) {
            if (timeout.current) {
                // If we cant execute callback immediately - save its arguments and
                // context to execute it when delay is passed
                lastCall.current = {
                    args: args,
                    this: this
                };
                return;
            }
            execute(this, args);
        };
        Object.defineProperties(wrapped, {
            length: {
                value: callback.length
            },
            name: {
                value: `${callback.name || 'anonymous'}__throttled__${delay}`
            }
        });
        return wrapped;
    }, [
        delay,
        noTrailing,
        ...deps
    ]);
}


var $acw62 = parcelRequire("acw62");

const $4d7918fb3900970c$var$cancelTimeout = (id)=>{
    if (id) clearTimeout(id);
};
function $4d7918fb3900970c$export$4ea291cd4ec501ea(callback, ms) {
    const cbRef = (0, $d423b5e2928192b4$export$ab7c8fab0bc555b6)(callback);
    const msRef = (0, $d423b5e2928192b4$export$ab7c8fab0bc555b6)(ms);
    const timeoutIdRef = (0, $acw62.useRef)(null);
    const cancel = (0, $acw62.useCallback)(()=>{
        $4d7918fb3900970c$var$cancelTimeout(timeoutIdRef.current);
    }, []);
    const reset = (0, $acw62.useCallback)(()=>{
        if (msRef.current === undefined) return;
        cancel();
        timeoutIdRef.current = setTimeout(()=>{
            cbRef.current();
        }, msRef.current);
    }, []);
    (0, $acw62.useEffect)(()=>{
        reset();
        return cancel;
    }, [
        ms
    ]);
    return [
        cancel,
        reset
    ];
}



var $fD6Fb = parcelRequire("fD6Fb");

var $lWMVu = parcelRequire("lWMVu");
var $f59d20578343595f$exports = {};
$f59d20578343595f$exports = import.meta.resolve("cSsM3");


var $81cb1647619a2ab5$var$b = new URL($f59d20578343595f$exports).href, $81cb1647619a2ab5$var$A = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$export$896749013ac55a71 = function() {
    function e(e) {
        this.debug = e, this.bitrate = 500, this.quality = .9, this.maxFps = 15, this.currentAdjustment = "quality", this.dataLog = [];
    }
    return e.prototype.increaseBitrate = function() {
        var e = this.bitrate;
        this.bitrate = Math.floor(Math.min(2500, 1.1 * this.bitrate)), e !== this.bitrate && this.debug("Increased bitrate from %d to %d kbps", e, this.bitrate);
    }, e.prototype.decreaseBitrate = function() {
        var e = this.bitrate;
        this.bitrate = Math.floor(Math.max(250, .9 * this.bitrate)), e !== this.bitrate && this.debug("Decreased bitrate from %d to %d kbps", e, this.bitrate);
    }, e.prototype.track = function(e) {
        var t = this.calculateDataSize(e);
        for(this.dataLog.push([
            Date.now(),
            t
        ]); this.dataLog.length > 0 && this.dataLog[0][0] < Date.now() - 5e3;)this.dataLog.shift();
        this.calculateQualityAndMaxFps();
    }, e.prototype.reset = function() {
        this.quality = .9, this.maxFps = 15, this.dataLog = [];
    }, e.prototype.calculateQualityAndMaxFps = function() {
        var e = this.dataLog.reduce(function(e, t) {
            return e + $81cb1647619a2ab5$var$A(t, 2)[1];
        }, 0), t = 1024 * this.bitrate / 8, n = e / 5, o = t - n;
        if (Math.abs(n - t) / t > .2) {
            var r = this.quality, i = this.maxFps;
            "quality" === this.currentAdjustment ? (o > 0 ? this.quality = Math.min(1, this.quality + .02) : 1 === this.maxFps ? this.quality = Math.max(.3, this.quality - .02) : this.quality = Math.max(.9, this.quality - .02), this.currentAdjustment = "fps") : (this.maxFps = o > 0 ? Math.min(15, this.maxFps + 1) : Math.max(1, this.maxFps - 1), this.currentAdjustment = "quality"), this.quality === r && this.maxFps === i || this.debug("Adjusted quality %d%, fps %d; sent: %d max: %d", Math.floor(100 * this.quality), this.maxFps, n, t);
        }
    }, e.prototype.calculateDataSize = function(e) {
        return new Blob([
            e
        ], {
            type: "image/jpeg"
        }).size;
    }, e;
}(), $81cb1647619a2ab5$var$x = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$S = [
    {
        fps: 10,
        maxEdge: 1920,
        quality: .8
    },
    {
        fps: 10,
        maxEdge: 1920,
        quality: .7
    },
    {
        fps: 10,
        maxEdge: 1600,
        quality: .65
    },
    {
        fps: 10,
        maxEdge: 1366,
        quality: .6
    },
    {
        fps: 10,
        maxEdge: 1152,
        quality: .55
    },
    {
        fps: 8,
        maxEdge: 1024,
        quality: .5
    },
    {
        fps: 6,
        maxEdge: 960,
        quality: .5
    },
    {
        fps: 5,
        maxEdge: 960,
        quality: .45
    }
], $81cb1647619a2ab5$var$E = 25e4, $81cb1647619a2ab5$var$I = 75e4, $81cb1647619a2ab5$var$k = function() {
    function e(e) {
        this.options = e, this.step = 2, this.budget = $81cb1647619a2ab5$var$E, this.sent = [], this.lastFrameAt = -1 / 0, this.lastCongestionAt = -1 / 0, this.congested = !1, this.sentSinceAdjust = 0, this.backlogAtAdjust = 0;
        var t = this.now();
        this.lastAdjustAt = t, this.lastStepChangeAt = t, this.lastBudgetChangeAt = t;
    }
    return Object.defineProperty(e.prototype, "quality", {
        get: function() {
            return $81cb1647619a2ab5$var$S[this.step].quality;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "fps", {
        get: function() {
            return $81cb1647619a2ab5$var$S[this.step].fps;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "bytesPerSecond", {
        get: function() {
            return this.budget;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.now = function() {
        var e, t, n;
        return null !== (n = null === (t = (e = this.options).now) || void 0 === t ? void 0 : t.call(e)) && void 0 !== n ? n : performance.now();
    }, e.prototype.accepts = function() {
        var e, t, n, o = this.now();
        o - this.lastAdjustAt >= 1e3 && this.adjust(o);
        var r = 1e3 / this.fps;
        if (o - this.lastFrameAt < .8 * r) return !1;
        var i = Math.max(64e3, .5 * this.budget);
        return (null !== (n = null === (t = (e = this.options).backlogBytes) || void 0 === t ? void 0 : t.call(e)) && void 0 !== n ? n : 0) > i ? (this.congested = !0, !1) : (this.lastFrameAt = o - this.lastFrameAt >= 2 * r ? o : this.lastFrameAt + r, !0);
    }, e.prototype.frameSize = function(e) {
        var t = $81cb1647619a2ab5$var$S[this.step].maxEdge, n = Math.max(e.w, e.h);
        if (n <= t) return e;
        var o = t / n;
        return {
            h: Math.max(1, Math.round(e.h * o)),
            w: Math.max(1, Math.round(e.w * o))
        };
    }, e.prototype.record = function(e) {
        this.sent.push([
            this.now(),
            e
        ]), this.sentSinceAdjust += e;
    }, e.prototype.reset = function() {
        var e = this.now();
        this.step = 2, this.budget = $81cb1647619a2ab5$var$E, this.sent = [], this.lastFrameAt = -1 / 0, this.lastAdjustAt = e, this.lastStepChangeAt = e, this.lastBudgetChangeAt = e, this.lastCongestionAt = -1 / 0, this.congested = !1, this.sentSinceAdjust = 0, this.backlogAtAdjust = 0;
    }, e.prototype.adjust = function(e) {
        var t = e - this.lastAdjustAt;
        for(this.lastAdjustAt = e, this.adjustBudget(e, t); this.sent.length > 0 && this.sent[0][0] < e - 2e3;)this.sent.shift();
        if (!(this.sent.length < 2)) {
            var n = this.sent.reduce(function(e, t) {
                return e + $81cb1647619a2ab5$var$x(t, 2)[1];
            }, 0) / this.sent.length, o = n * this.fps;
            o > 1.1 * this.budget && this.step < $81cb1647619a2ab5$var$S.length - 1 ? this.setStep(this.step + 1, e, o) : o < .6 * this.budget && this.step > 0 && e - this.lastStepChangeAt >= 3e3 && this.setStep(this.step - 1, e, o);
        }
    }, e.prototype.adjustBudget = function(e, t) {
        var n, o, r, i = null !== (r = null === (o = (n = this.options).backlogBytes) || void 0 === o ? void 0 : o.call(n)) && void 0 !== r ? r : 0, a = (this.sentSinceAdjust + this.backlogAtAdjust - i) / t * 1e3;
        if (this.sentSinceAdjust = 0, this.backlogAtAdjust = i, this.congested) {
            this.congested = !1, this.lastCongestionAt = e;
            var c = Math.min(this.budget, .9 * a);
            this.setBudget(Math.min($81cb1647619a2ab5$var$I, Math.max(5e4, c)), e);
        } else this.options.backlogBytes && e - this.lastCongestionAt >= 2e3 && e - this.lastBudgetChangeAt >= 2e3 && this.setBudget(Math.min($81cb1647619a2ab5$var$I, 1.25 * this.budget), e);
    }, e.prototype.setBudget = function(e, t) {
        var n = Math.round(e);
        n !== this.budget && (this.options.debug("Screen JPEG budget changed from %d to %d bytes/s", this.budget, n), this.budget = n, this.lastBudgetChangeAt = t);
    }, e.prototype.setStep = function(e, t, n) {
        this.step = e, this.lastStepChangeAt = t;
        var o = $81cb1647619a2ab5$var$S[e], r = o.fps, i = o.maxEdge, a = o.quality;
        this.options.debug("Screen JPEG set to %d fps, %dpx, quality %d%; needed %d of %d bytes/s", r, i, Math.round(100 * a), Math.round(n), this.budget);
    }, e;
}(), $81cb1647619a2ab5$var$O = [
    "avc1",
    "av01",
    "vp09"
], $81cb1647619a2ab5$var$D = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$z = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$M = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $81cb1647619a2ab5$var$B = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$L = function(e, t, n) {
    if (n || 2 === arguments.length) for(var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
    return e.concat(o || Array.prototype.slice.call(t));
}, $81cb1647619a2ab5$var$F = 8192, $81cb1647619a2ab5$var$P = {
    av01: "av01.0.08M.08",
    avc1: "avc1.640028",
    vp09: "vp09.00.40.08"
};
function $81cb1647619a2ab5$var$V(e) {
    var t = e.h, n = e.w;
    return {
        h: Math.max(2, 2 * Math.floor(t / 2)),
        w: Math.max(2, 2 * Math.floor(n / 2))
    };
}
function $81cb1647619a2ab5$var$T(e) {
    var t = e.h, n = e.w;
    return Math.ceil(n / 16) * Math.ceil(t / 16);
}
function $81cb1647619a2ab5$var$j(e) {
    return $81cb1647619a2ab5$var$P[e];
}
function $81cb1647619a2ab5$var$R(e) {
    return !("undefined" == typeof window || !window.isSecureContext) && "function" == typeof VideoFrame && ("encode" === e ? "function" == typeof VideoEncoder : "function" == typeof VideoDecoder);
}
function $81cb1647619a2ab5$var$X() {
    return $81cb1647619a2ab5$var$D(this, void 0, void 0, function() {
        var e, t, n, o, r, i, a;
        return $81cb1647619a2ab5$var$z(this, function(c) {
            switch(c.label){
                case 0:
                    if (!$81cb1647619a2ab5$var$R("decode")) return [
                        2,
                        []
                    ];
                    e = [], c.label = 1;
                case 1:
                    c.trys.push([
                        1,
                        8,
                        9,
                        10
                    ]), t = $81cb1647619a2ab5$var$M($81cb1647619a2ab5$var$O), n = t.next(), c.label = 2;
                case 2:
                    if (n.done) return [
                        3,
                        7
                    ];
                    o = n.value, c.label = 3;
                case 3:
                    return c.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]), [
                        4,
                        VideoDecoder.isConfigSupported({
                            codec: $81cb1647619a2ab5$var$P[o],
                            codedHeight: 1080,
                            codedWidth: 1920
                        })
                    ];
                case 4:
                    return !0 === c.sent().supported && e.push(o), [
                        3,
                        6
                    ];
                case 5:
                    return c.sent(), [
                        3,
                        6
                    ];
                case 6:
                    return n = t.next(), [
                        3,
                        2
                    ];
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    return r = c.sent(), i = {
                        error: r
                    }, [
                        3,
                        10
                    ];
                case 9:
                    try {
                        n && !n.done && (a = t.return) && a.call(t);
                    } finally{
                        if (i) throw i.error;
                    }
                    return [
                        7
                    ];
                case 10:
                    return [
                        2,
                        e
                    ];
            }
        });
    });
}
function $81cb1647619a2ab5$var$N(e) {
    for(var t = "", n = 0; n < e.length; n += 32768)t += String.fromCharCode.apply(String, $81cb1647619a2ab5$var$L([], $81cb1647619a2ab5$var$B(e.subarray(n, n + 32768)), !1));
    return btoa(t);
}
function $81cb1647619a2ab5$var$U(e) {
    for(var t = atob(e), n = new Uint8Array(t.length), o = 0; o < t.length; o++)n[o] = t.charCodeAt(o);
    return n;
}
function $81cb1647619a2ab5$var$G(e) {
    try {
        return e(), null;
    } catch (e) {
        return e instanceof DOMException ? e : new DOMException(String(e), "OperationError");
    }
}
function $81cb1647619a2ab5$var$H(e) {
    var t;
    return [
        e.codec,
        e.codedWidth,
        e.codedHeight,
        null !== (t = e.description) && void 0 !== t ? t : ""
    ].join("|");
}
var $81cb1647619a2ab5$var$q = function() {
    return $81cb1647619a2ab5$var$q = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $81cb1647619a2ab5$var$q.apply(this, arguments);
}, $81cb1647619a2ab5$var$W = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$Q = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$Y = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $81cb1647619a2ab5$var$Z = {
    lowFps: 4e5,
    max: 25e5,
    min: 3e5,
    start: 12e5
}, $81cb1647619a2ab5$var$K = {
    lowFps: 15e4,
    max: 6e5,
    min: 15e4,
    start: 3e5
}, $81cb1647619a2ab5$var$J = function() {
    function e(e) {
        var t;
        this.options = e, this.state = "idle", this.capturedSize = {
            h: 0,
            w: 0
        }, this.selectionToken = 0, this.restarts = 0, this.softwareOnly = !1, this.lastBitrateCheckAt = 0, this.lastBitrateChangeAt = 0, this.lastNetworkSkipAt = -1 / 0, this.networkSkips = 0, this.keyframeRequested = !1, this.keyframeForced = !0, this.lastKeyframeAt = -1 / 0, this.lastEncodedAt = -1 / 0, this.lastTimestamp = 0, this.transportWasReady = !0, this.latestFrameRepeated = !1, this.bitrates = null !== (t = e.bitrates) && void 0 !== t ? t : $81cb1647619a2ab5$var$Z, this.bitrate = this.bitrates.start;
    }
    return Object.defineProperty(e.prototype, "targetFps", {
        get: function() {
            return this.bitrate <= this.bitrates.lowFps ? 8 : 15;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.now = function() {
        var e, t, n;
        return null !== (n = null === (t = (e = this.options).now) || void 0 === t ? void 0 : t.call(e)) && void 0 !== n ? n : performance.now();
    }, e.prototype.prepare = function(e, t) {
        var n;
        if ("failed" === this.state) return null;
        if (!$81cb1647619a2ab5$var$R("encode")) return this.options.debug("Screen video encoding is not available in this browser, using JPEG frames"), this.state = "failed", null;
        this.capturedSize = t;
        var o = this.options.allowedFamilies(), r = o.join(",");
        if (r !== this.familiesKey && (this.familiesKey = r, "selecting" === this.state && (this.selectionToken++, this.state = "idle"), this.family && !o.includes(this.family) && (this.options.debug("Screen video codec %s is no longer decodable by every viewer", this.family), this.closeEncoder()), "unsupported" === this.state && (this.state = "idle"), 0 === o.length && this.options.debug("Not every viewer can decode screen video, using JPEG frames")), 0 === o.length) return null;
        var i = function(e) {
            var t = $81cb1647619a2ab5$var$V(e);
            if ($81cb1647619a2ab5$var$T(t) <= $81cb1647619a2ab5$var$F) return t;
            var n = Math.sqrt(2097152 / (e.w * e.h));
            for(t = $81cb1647619a2ab5$var$V({
                h: e.h * n,
                w: e.w * n
            }); $81cb1647619a2ab5$var$T(t) > $81cb1647619a2ab5$var$F;)n *= .995, t = $81cb1647619a2ab5$var$V({
                h: e.h * n,
                w: e.w * n
            });
            return t;
        }(e);
        return "idle" === this.state ? (this.select(i, o), null) : "active" === this.state && this.size ? (i.w === this.size.w && i.h === this.size.h ? this.pendingSize = void 0 : (null === (n = this.pendingSize) || void 0 === n ? void 0 : n.size.w) !== i.w || this.pendingSize.size.h !== i.h ? this.pendingSize = {
            since: this.now(),
            size: i
        } : this.now() - this.pendingSize.since >= 500 && (this.pendingSize = void 0, this.resize(i)), this.size) : null;
    }, e.prototype.acceptsFrame = function() {
        if ("active" !== this.state || !this.encoder) return !1;
        if (!this.observeTransport()) return !1;
        var e = this.now();
        return !(e - this.lastEncodedAt < 1e3 / this.targetFps * .8) && !(this.encoder.encodeQueueSize > 1) && (!(this.options.backlogBytes() > this.maxBacklogBytes()) || (e - this.lastKeyframeAt >= 1e3 && (this.networkSkips++, this.lastNetworkSkipAt = e), !1));
    }, e.prototype.offer = function(e) {
        this.acceptsFrame() && this.encode(e);
    }, e.prototype.encode = function(e) {
        this.encoder && this.size && (this.keepLatestFrame(e), this.encodeAt(e, this.now()));
    }, e.prototype.requestKeyframe = function() {
        this.keyframeRequested = !0;
    }, e.prototype.stop = function() {
        this.selectionToken++, this.closeEncoder(), this.state = "idle", this.familiesKey = void 0, this.restarts = 0, this.softwareOnly = !1, this.bitrate = this.bitrates.start, this.transportWasReady = !0;
    }, e.prototype.observeTransport = function() {
        return this.options.transportReady() ? (this.transportWasReady || (this.transportWasReady = !0, this.keyframeForced = !0), !0) : (this.transportWasReady = !1, !1);
    }, e.prototype.maxBacklogBytes = function() {
        return Math.max(32e3, this.bitrate / 8 * .5);
    }, e.prototype.select = function(e, t) {
        return $81cb1647619a2ab5$var$W(this, void 0, void 0, function() {
            var n, o, r, i, a, c, s, l, u, d, f = this;
            return $81cb1647619a2ab5$var$Q(this, function(h) {
                switch(h.label){
                    case 0:
                        this.state = "selecting", n = ++this.selectionToken, o = function(t) {
                            var o, i, a, c;
                            return $81cb1647619a2ab5$var$Q(this, function(s) {
                                switch(s.label){
                                    case 0:
                                        return "av01" === t && r.softwareOnly ? [
                                            2,
                                            "continue"
                                        ] : (o = r.softwareOnly ? "prefer-software" : "av01" === t ? "prefer-hardware" : "no-preference", i = r.buildConfig(t, e, o), [
                                            4,
                                            VideoEncoder.isConfigSupported(i).then(function(e) {
                                                return !0 === e.supported;
                                            }, function(e) {
                                                return f.options.debug("Screen video support check failed for %s: %O", i.codec, e), !1;
                                            })
                                        ]);
                                    case 1:
                                        return a = s.sent(), n !== r.selectionToken ? [
                                            2,
                                            {
                                                value: void 0
                                            }
                                        ] : a ? (c = $81cb1647619a2ab5$var$G(function() {
                                            f.openEncoder(t, i);
                                        })) ? (r.options.debug("Screen video encoder %s could not be configured: %O", i.codec, c), r.closeEncoder(), [
                                            2
                                        ]) : (r.state = "active", r.options.debug("Screen video encoding with %s at %dx%d", i.codec, i.width, i.height), [
                                            2,
                                            {
                                                value: void 0
                                            }
                                        ]) : [
                                            2,
                                            "continue"
                                        ];
                                }
                            });
                        }, r = this, h.label = 1;
                    case 1:
                        h.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]), i = $81cb1647619a2ab5$var$Y(t), a = i.next(), h.label = 2;
                    case 2:
                        return a.done ? [
                            3,
                            5
                        ] : (c = a.value, [
                            5,
                            o(c)
                        ]);
                    case 3:
                        if ("object" == typeof (s = h.sent())) return [
                            2,
                            s.value
                        ];
                        h.label = 4;
                    case 4:
                        return a = i.next(), [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        return l = h.sent(), u = {
                            error: l
                        }, [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            a && !a.done && (d = i.return) && d.call(i);
                        } finally{
                            if (u) throw u.error;
                        }
                        return [
                            7
                        ];
                    case 8:
                        return this.state = "unsupported", this.options.debug("No screen video codec is supported for %s", t.join(",")), [
                            2
                        ];
                }
            });
        });
    }, e.prototype.buildConfig = function(e, t, n) {
        return $81cb1647619a2ab5$var$q({
            bitrate: this.bitrate,
            bitrateMode: "variable",
            codec: $81cb1647619a2ab5$var$j(e),
            framerate: 15,
            hardwareAcceleration: n,
            height: t.h,
            latencyMode: "realtime",
            width: t.w
        }, "avc1" === e ? {
            avc: {
                format: "annexb"
            }
        } : {});
    }, e.prototype.openEncoder = function(e, t) {
        var n, o = this, r = new VideoEncoder({
            error: function(e) {
                o.onEncoderError(r, e);
            },
            output: function(e, t) {
                o.onOutput(r, e, t);
            }
        });
        this.encoder = r, r.configure(t);
        var i = this.now();
        this.config = t, this.family = e, this.size = {
            h: t.height,
            w: t.width
        }, this.decoderConfig = void 0, this.keyframeForced = !0, this.lastBitrateCheckAt = i, this.lastBitrateChangeAt = i, this.networkSkips = 0, null !== (n = this.timer) && void 0 !== n || (this.timer = setInterval(function() {
            o.tick();
        }, 100));
    }, e.prototype.closeEncoder = function() {
        this.encoder && "closed" !== this.encoder.state && this.encoder.close(), this.encoder = void 0, this.config = void 0, this.family = void 0, this.size = void 0, this.pendingSize = void 0, this.decoderConfig = void 0, this.dropLatestFrame(), this.lastEncodedAt = -1 / 0, this.lastKeyframeAt = -1 / 0, this.encoderBusySince = void 0, clearInterval(this.timer), this.timer = void 0, "failed" !== this.state && (this.state = "idle");
    }, e.prototype.onEncoderError = function(e, t) {
        var n, o;
        if (e === this.encoder) {
            if (this.options.debug("Screen video encoder failed: %O", t), this.closeEncoder(), "TimeoutError" === t.name && !this.softwareOnly) return this.options.debug("Screen video encoder stalled, using software encoders for the rest of the share"), void (this.softwareOnly = !0);
            this.restarts++, this.restarts > 2 && (this.state = "failed", null === (o = (n = this.options).onFallback) || void 0 === o || o.call(n, "".concat(t.name, ": ").concat(t.message)));
        }
    }, e.prototype.onOutput = function(e, t, n) {
        var o, r, i;
        if (e === this.encoder && this.config) {
            this.encoderBusySince = void 0;
            var a, c = null == n ? void 0 : n.decoderConfig;
            c && (this.decoderConfig = $81cb1647619a2ab5$var$q({
                codec: c.codec,
                codedHeight: null !== (o = c.codedHeight) && void 0 !== o ? o : this.config.height,
                codedWidth: null !== (r = c.codedWidth) && void 0 !== r ? r : this.config.width
            }, c.description ? {
                description: $81cb1647619a2ab5$var$N((a = c.description, ArrayBuffer.isView(a) ? new Uint8Array(a.buffer, a.byteOffset, a.byteLength) : new Uint8Array(a)))
            } : {}));
            var s = new Uint8Array(t.byteLength);
            t.copyTo(s);
            var l = "key" === t.type ? null !== (i = this.decoderConfig) && void 0 !== i ? i : {
                codec: this.config.codec,
                codedHeight: this.config.height,
                codedWidth: this.config.width
            } : null;
            this.options.onChunk([
                l,
                $81cb1647619a2ab5$var$q({}, this.capturedSize),
                t.type,
                t.timestamp,
                $81cb1647619a2ab5$var$N(s)
            ]);
        }
    }, e.prototype.encodeAt = function(e, t) {
        var n = this.encoder;
        if (n) {
            var o, r = this.keyframeForced || t - this.lastKeyframeAt >= 1e4 || this.keyframeRequested && t - this.lastKeyframeAt >= 1e3, i = Math.max(Math.round(1e3 * t), this.lastTimestamp + 1), a = $81cb1647619a2ab5$var$G(function() {
                o = new VideoFrame(e, {
                    timestamp: i
                }), n.encode(o, {
                    keyFrame: r
                });
            });
            null == o || o.close(), a ? this.onEncoderError(n, a) : (this.lastTimestamp = i, this.lastEncodedAt = t, r && (this.keyframeForced = !1, this.keyframeRequested = !1, this.lastKeyframeAt = t));
        }
    }, e.prototype.keepLatestFrame = function(e) {
        var t, n = $81cb1647619a2ab5$var$G(function() {
            t = e.clone();
        });
        this.dropLatestFrame(), n ? this.options.debug("Screen video frame could not be kept for repeats: %O", n) : (this.latestFrame = t, this.latestFrameRepeated = !1);
    }, e.prototype.dropLatestFrame = function() {
        var e;
        null === (e = this.latestFrame) || void 0 === e || e.close(), this.latestFrame = void 0;
    }, e.prototype.resize = function(e) {
        var t;
        if (this.family && this.config) {
            var n = this.buildConfig(this.family, e, null !== (t = this.config.hardwareAcceleration) && void 0 !== t ? t : "no-preference");
            this.reconfigure(n) && (this.options.debug("Screen video resized to %dx%d", e.w, e.h), this.size = e, this.keyframeForced = !0, this.dropLatestFrame());
        }
    }, e.prototype.reconfigure = function(e) {
        var t = this.encoder;
        if (!t) return !1;
        var n = $81cb1647619a2ab5$var$G(function() {
            t.configure(e);
        });
        return n ? (this.onEncoderError(t, n), !1) : (this.config = e, !0);
    }, e.prototype.tick = function() {
        var e;
        if ("active" === this.state && this.encoder) {
            var t = this.now(), n = this.encoder.encodeQueueSize;
            if (n <= 1) this.encoderBusySince = void 0;
            else if (null !== (e = this.encoderBusySince) && void 0 !== e || (this.encoderBusySince = t), t - this.encoderBusySince >= 3e3) return void this.onEncoderError(this.encoder, new DOMException("The encoder produced no output", "TimeoutError"));
            if (t - this.lastBitrateCheckAt >= 1e3 && this.adjustBitrate(t), this.observeTransport() && this.latestFrame) {
                var o = t - this.lastEncodedAt, r = (this.keyframeForced || this.keyframeRequested && t - this.lastKeyframeAt >= 1e3) && o >= 2e3 / this.targetFps, i = n > 0 && !this.latestFrameRepeated && o >= 150;
                !r && !i && o < 5e3 || this.acceptsFrame() && (this.encodeAt(this.latestFrame, t), this.latestFrameRepeated = !0);
            }
        }
    }, e.prototype.adjustBitrate = function(e) {
        this.lastBitrateCheckAt = e, this.networkSkips > 0 ? this.setBitrate(Math.max(this.bitrates.min, .7 * this.bitrate), e) : e - this.lastNetworkSkipAt >= 5e3 && e - this.lastBitrateChangeAt >= 5e3 && this.setBitrate(Math.min(this.bitrates.max, 1.15 * this.bitrate), e), this.networkSkips = 0;
    }, e.prototype.setBitrate = function(e, t) {
        var n = Math.round(e);
        if (!(Math.abs(n - this.bitrate) / this.bitrate < .05) && this.config) {
            var o = this.bitrate;
            this.reconfigure($81cb1647619a2ab5$var$q($81cb1647619a2ab5$var$q({}, this.config), {
                bitrate: n
            })) && (this.options.debug("Screen video bitrate changed from %d to %d", o, n), this.bitrate = n, this.lastBitrateChangeAt = t);
        }
    }, e;
}(), $81cb1647619a2ab5$var$_ = function() {
    return $81cb1647619a2ab5$var$_ = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $81cb1647619a2ab5$var$_.apply(this, arguments);
}, $81cb1647619a2ab5$var$$ = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$ee = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$te = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$ne = function(e, t, n) {
    if (n || 2 === arguments.length) for(var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
    return e.concat(o || Array.prototype.slice.call(t));
}, $81cb1647619a2ab5$var$oe = 5e3, $81cb1647619a2ab5$var$re = function() {
    function e(e, t, n, o) {
        var r = this;
        this.viewerWidth = 1280, this.viewerHeight = 720, this.streamProvided = !1, this.videoElement = document.createElement("video"), this.canvas = document.createElement("canvas"), this.lastFrameTime = 0, this.lastForcedFrameTime = 0, this.streaming = !1, this.streamingDesired = !1, this.meter = new $81cb1647619a2ab5$export$896749013ac55a71(function(e) {
            for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
            return r.debug.apply(r, $81cb1647619a2ab5$var$ne([
                e
            ], $81cb1647619a2ab5$var$te(t), !1));
        }), this.callbackType = e, this.onFrame = t, this.onStop = n, this.debug = o, this.jpeg = new $81cb1647619a2ab5$var$k({
            debug: function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                r.debug.apply(r, $81cb1647619a2ab5$var$ne([
                    e
                ], $81cb1647619a2ab5$var$te(t), !1));
            }
        });
    }
    return e.prototype.setBacklogSource = function(e) {
        var t = this;
        this.jpeg = new $81cb1647619a2ab5$var$k({
            backlogBytes: e,
            debug: function(e) {
                for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
                t.debug.apply(t, $81cb1647619a2ab5$var$ne([
                    e
                ], $81cb1647619a2ab5$var$te(n), !1));
            }
        });
    }, e.prototype.enableVideo = function(e) {
        "frame" === this.callbackType && (this.video = new $81cb1647619a2ab5$var$J(e));
    }, e.prototype.requestKeyframe = function() {
        var e;
        null === (e = this.video) || void 0 === e || e.requestKeyframe();
    }, e.available = function() {
        return "mediaDevices" in navigator && "function" == typeof navigator.mediaDevices.getDisplayMedia;
    }, e.prototype.request = function() {
        return $81cb1647619a2ab5$var$$(this, arguments, void 0, function(e, t) {
            var n, o, r, i, a, c = this;
            return void 0 === e && (e = "full"), $81cb1647619a2ab5$var$ee(this, function(s) {
                switch(s.label){
                    case 0:
                        this.streamingDesired = !0, this.streamProvided = void 0 !== t, s.label = 1;
                    case 1:
                        return s.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]), n = window.devicePixelRatio || 1, o = this, null == t ? [
                            3,
                            2
                        ] : (r = t, [
                            3,
                            4
                        ]);
                    case 2:
                        return [
                            4,
                            navigator.mediaDevices.getDisplayMedia($81cb1647619a2ab5$var$_({
                                video: {
                                    height: {
                                        ideal: screen.height * n
                                    },
                                    width: {
                                        ideal: screen.width * n
                                    }
                                }
                            }, "currentTab" === e ? {
                                preferCurrentTab: !0,
                                surfaceSwitching: "exclude"
                            } : {}))
                        ];
                    case 3:
                        r = s.sent(), s.label = 4;
                    case 4:
                        return o.stream = r, this.videoElement.srcObject = this.stream, this.videoElement.play(), null === (a = this.stream.getVideoTracks()[0]) || void 0 === a || a.addEventListener("ended", function() {
                            c.stop();
                        }), this.startStreaming(), this.streaming = !0, this.streamingDesired || setTimeout(function() {
                            c.stop();
                        }, 0), [
                            2,
                            !0
                        ];
                    case 5:
                        return i = s.sent(), this.debug("Failed to get display media %O", i), this.streaming = !1, [
                            2,
                            !1
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.startStreaming = function() {
        "frame" === this.callbackType && "undefined" != typeof MediaStreamTrackProcessor ? this.startStreamingWithProcessor() : this.startStreamingWithVideoCallback(), this.debug("Started streaming");
    }, e.prototype.startStreamingWithProcessor = function() {
        var e = this, t = this.stream.getVideoTracks()[0], n = new MediaStreamTrackProcessor({
            track: t
        }).readable.getReader();
        this.processorReader = n;
        $81cb1647619a2ab5$var$$(e, void 0, void 0, function() {
            var e, t, o, r, i, a, c, s, l;
            return $81cb1647619a2ab5$var$ee(this, function(u) {
                switch(u.label){
                    case 0:
                        return [
                            4,
                            n.read()
                        ];
                    case 1:
                        if ((e = u.sent()).done) return [
                            3,
                            2
                        ];
                        t = e.value;
                        try {
                            if (o = performance.now(), r = t.displayWidth, i = t.displayHeight, !r || !i) return [
                                3,
                                0
                            ];
                            if (a = this.computeTargetSize(r, i), c = a.targetWidth, s = a.targetHeight, null === (l = this.video) || void 0 === l ? void 0 : l.prepare({
                                h: s,
                                w: c
                            }, {
                                h: i,
                                w: r
                            })) return this.lastCompressedFrameData = void 0, this.video.offer(t), [
                                3,
                                0
                            ];
                            if (!this.jpeg.accepts()) return [
                                3,
                                0
                            ];
                            this.sendJpegFrame(t, c, s, o, {
                                h: i,
                                w: r
                            });
                        } finally{
                            t.close();
                        }
                        return [
                            3,
                            0
                        ];
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.startStreamingWithVideoCallback = function() {
        var e = this, t = function(n) {
            var o;
            if (e.stream) {
                var r = e.videoElement.videoWidth, i = e.videoElement.videoHeight, a = e.computeTargetSize(r, i), c = a.targetWidth, s = a.targetHeight, l = r && i ? null === (o = e.video) || void 0 === o ? void 0 : o.prepare({
                    h: s,
                    w: c
                }, {
                    h: i,
                    w: r
                }) : null;
                if (l) {
                    if (e.lastCompressedFrameData = void 0, e.video.acceptsFrame()) {
                        e.canvas.width = l.w, e.canvas.height = l.h, e.canvas.getContext("2d").drawImage(e.videoElement, 0, 0, l.w, l.h);
                        var u = new VideoFrame(e.canvas, {
                            timestamp: Math.round(1e3 * n)
                        });
                        e.video.encode(u), u.close();
                    }
                    e.videoFrameCallbackId = e.videoElement.requestVideoFrameCallback(t);
                } else {
                    if ("video" === e.callbackType) {
                        if (n - e.lastFrameTime < 1e3 / e.meter.maxFps) return void (e.videoFrameCallbackId = e.videoElement.requestVideoFrameCallback(t));
                        e.lastFrameTime = n, e.canvas.width = c, e.canvas.height = s, e.canvas.getContext("2d").drawImage(e.videoElement, 0, 0, c, s), e.lastForcedFrameTime = n, e.onFrame(e.videoElement, {
                            w: r,
                            h: i
                        });
                    } else r && i && e.jpeg.accepts() && e.sendJpegFrame(e.videoElement, c, s, n, {
                        h: i,
                        w: r
                    });
                    e.videoFrameCallbackId = e.videoElement.requestVideoFrameCallback(t);
                }
            }
        }, n = function() {
            e.forcedFrameTimeoutId = setTimeout(function() {
                if (e.stream) {
                    var t = performance.now();
                    if (t - e.lastForcedFrameTime >= $81cb1647619a2ab5$var$oe) {
                        var o = e.videoElement.videoWidth, r = e.videoElement.videoHeight;
                        "video" === e.callbackType ? (e.lastForcedFrameTime = t, e.onFrame(e.videoElement, {
                            w: o,
                            h: r
                        })) : e.lastCompressedFrameData && (e.lastForcedFrameTime = t, e.onFrame(e.lastCompressedFrameData, {
                            w: o,
                            h: r
                        }));
                    }
                    n();
                }
            }, $81cb1647619a2ab5$var$oe);
        };
        this.videoFrameCallbackId = this.videoElement.requestVideoFrameCallback(t), n();
    }, e.prototype.sendJpegFrame = function(e, t, n, o, r) {
        var i = this.jpeg.frameSize({
            h: n,
            w: t
        }), a = i.h, c = i.w;
        this.canvas.width = c, this.canvas.height = a, this.canvas.getContext("2d").drawImage(e, 0, 0, c, a);
        var s = this.canvas.toDataURL("image/jpeg", this.jpeg.quality);
        s === this.lastCompressedFrameData && o - this.lastForcedFrameTime < $81cb1647619a2ab5$var$oe || (this.jpeg.record(s.length), this.onFrame(s, r), this.lastCompressedFrameData = s, this.lastForcedFrameTime = o);
    }, e.prototype.computeTargetSize = function(e, t) {
        var n = e / t, o = Math.min(this.viewerWidth, e, 1920), r = Math.min(this.viewerHeight, t, 1920);
        return o >= e && r >= t ? (o = e, r = t) : o / r > n ? o = Math.round(r * n) : r = Math.round(o / n), {
            targetWidth: o,
            targetHeight: r
        };
    }, e.prototype.stop = function() {
        var e, t;
        this.stopStream(), null === (e = this.video) || void 0 === e || e.stop(), clearTimeout(this.forcedFrameTimeoutId), "number" == typeof this.videoFrameCallbackId && this.videoElement.cancelVideoFrameCallback(this.videoFrameCallbackId), null === (t = this.processorReader) || void 0 === t || t.cancel(), this.processorReader = void 0, this.streamingDesired = !1, this.streaming = !1, this.stream = void 0, this.streamProvided = !1, this.lastCompressedFrameData = void 0, this.meter.reset(), this.jpeg.reset(), this.videoElement.srcObject = null, this.onStop(), this.debug("Stopped streaming");
    }, e.prototype.stopStream = function() {
        this.stream && !this.streamProvided && this.stream.getTracks().forEach(function(e) {
            e.stop();
        });
    }, e;
}(), $81cb1647619a2ab5$var$ie = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$ae = function(e, t, n) {
    if (n || 2 === arguments.length) for(var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
    return e.concat(o || Array.prototype.slice.call(t));
};
function $81cb1647619a2ab5$var$ce(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($fD6Fb)))("upscope:".concat(e)), n = (0, (/*@__PURE__*/$parcel$interopDefault($fD6Fb)))("upscope:".concat(e, ":warn")), o = function(n) {
        for(var o, r = [], i = 1; i < arguments.length; i++)r[i - 1] = arguments[i];
        window.__log ? null === (o = window.__log) || void 0 === o || o.call.apply(o, $81cb1647619a2ab5$var$ae([
            window,
            "info",
            e,
            n
        ], $81cb1647619a2ab5$var$ie(r), !1)) : t.apply(void 0, $81cb1647619a2ab5$var$ae([
            n
        ], $81cb1647619a2ab5$var$ie(r), !1));
    };
    return o.local = function(e) {
        for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
        t.apply(void 0, $81cb1647619a2ab5$var$ae([
            e
        ], $81cb1647619a2ab5$var$ie(n), !1));
    }, o.warning = function(t) {
        for(var o, r = [], i = 1; i < arguments.length; i++)r[i - 1] = arguments[i];
        window.__log ? null === (o = window.__log) || void 0 === o || o.call.apply(o, $81cb1647619a2ab5$var$ae([
            window,
            "warn",
            e,
            t
        ], $81cb1647619a2ab5$var$ie(r), !1)) : n.apply(void 0, $81cb1647619a2ab5$var$ae([
            t
        ], $81cb1647619a2ab5$var$ie(r), !1));
    }, o;
}
var $81cb1647619a2ab5$var$se, $81cb1647619a2ab5$var$le, $81cb1647619a2ab5$var$ue = [
    ":blush:",
    ":raised_hands:",
    ":fire:",
    ":rocket:",
    ":partying_face:"
], $81cb1647619a2ab5$var$de = {
    ":blush:": "data:image/png;base64,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",
    ":raised_hands:": "data:image/png;base64,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",
    ":fire:": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAYAAACLz2ctAABNCElEQVR4AezbA5Rc27PH8W/V3getUTD/ZKJrG3/btm3btm3btm3b9v8yTibdR/tV1t1Z/d7l9PMkp9b6nJ6eqR3+Vp1VJxPaWnptefNbbrrtFrd8zo6XvOxww39da4Lm1vZ73/MtOyBsu/o1Prnti1851fBf05qgubXzDrd5dwlhaLYcevg52x/2qAfu+MrXveE/pzVBc2v7Q+/7qpESwsJ8GKWELaJhy93v/fZdb3/POkNrchM0t7Y988mPWVRCOGRTCNfZEMrjLIB7g3j4MT/Z8dZ3X80wmZY2TaC1NP5vfzuj7uQ0uxZhdgX+MgtMX9GjW395wvApj/kwX/36I2X1qsTQWhpdenOrOeyos5peWtTbt8IQ6KxC161h6jIZefLXqeH7X/u86l3veof+/V8bDa0lWHpzq77M5f8ZZvu7mmEJOxbBpZDNIYN5BkfkdI+tKT/3pluNXvjsj9d55+qG1sXTpTe3GEydwdz8GTXAzl0QgDSHzoxZTW+2y+BoqOpfHzd89iM+zDe/9XDZuM4ZWhdOl97cSr74+V2aD86sgLC4G4oCxIPPoTMN3ZXkSZepDaDJXwfDD7/sBfV73vU62bG42tC6IF16c4vDThiG9WvOCkAzGsJwD9QBNIGkA/kU9FaQSZ/pOcEfUjP6xMvvVj3jMZ+ovTvFEEUtnexAi4WFMwGasoDhEOoACEgCvgOdaeivwGufQSJkG2F07vdPK590v4/JH35/O8NYSyc70AprN54TgLpuYDiCqoJGQBSch7QDnQH05vDJgH5QOmuh3v2rtaNnP+St/PB7z25ufMOOoWnh7cLSqy197cvOrbuOJtRQjqAqQTPjwHkIAinQGBQXlN6enehszWK62+/5zJsek0o4LLnBTR8C/IMDvNR//4e0JnD25u3S7dIEYFhAUULTQABwoN4kkHYg70NvDu1M0W08/Q7o+prRJ99w8/LZT/mo/PBHpxoOZDrZgVZ95FHbyf2oCRDqEsoC6gANEGQcQpdAmkPWh+4c0p0hJ2XgIDkERmd//+Thh9700froo29pOFDpZAda5cEbdoXMlQQITQNlBXUDDUYgKIiPIUwhzeMknEV6M2Sa028g2wBl+PPa0ePu+1b5xjce7f/5DzUcaHSyAy3x+VCcr4JAqGow1A2EAACI0RhA432chD2wANKfI/VdeoXQWQnN1NmdPR94xXOq737rJcUtb94zHEi8XVh6tSV/+MOiJnnRAKEOcQLWEIIBJEJBBcRQgWDEKIZk9zak2I1MB4adksXvvu+B6ZPyjcmtbv8A4O8cIKXuF7+itXTMTA9Js2EIEJoATW0ChnHJ+FVcnIQJdg6yLnQHMJjDdwZ0K6XrQTcEys+/9UbVs57yEf/Vr5xoOBDoZAdaodOt8EmFAIG4Ae8VzPnDJ/F1vB3js/issA/dGVw2oFM7egH0UBj+61snDz/49vdXJ5xwFcP+Tic70KKphdAIDoA4/RoTIETAOHxGjbjxs8IkMx3IBzCYRftT5JLQqyHZACP+fmjxrMe9p+n1bmbYn+lkB1qybXtGXWSkMJ6CJjAOXxDD+GMUZN9iEvkUkn0b8gzatRBqSq86L4Tl8I/zxQPv8Wa2b7+LYX+lkx1oNcPFXqgWcxyxxAABI9CYAGZcIfZJpA68h2TfLbkHnWnEQpj580KYbYI6OXOqePRDXslozz0N+yOd7EDL/eGPs6EscvEgCKgRYgU4f4kwLgFxmBjCBJLUZJB1YginyTSjW0B+ENTdc7rFYx/1MhmN7mfY3+iEB1o7dy+wa0dXchA0BkpAMQIOUGJJfJGI+BrPaZQkJoN0rz7kfVJN6ZRCvgma3pa8eNLjX0S3e0/D/kQnO9BqpDgkjArUgSBxsVBIxRADGEkwgEYSaQyhwcUQusRkkOXQGZwXQknIayE9FKrOtqx4zKNeFAaD2xv2FzpBc2v+UqLf/c7xIYnDCw/e5ApdgWwvwBvHeOohEOKrwDiUahyIGy8mLh8vJybFk9eQHQZ1c06/fOhDXtqsnLu+YX+gS29uSWADf/rlqdIBFwD1kKXQibfh3GwEVhmV892GL2QKun0cqILfy4NLIelA2kVMFjy5QnIMVDv+saK5691flXz/+5c1LHe69OaW/ObXV27O/MtG6YELGv9lI4FEQUwA5gSOBNYZNbUR4wQ08kCKEaNGIDFOjTMJJk7CHpLlpI0j95AcBeUZf95QvOENb+DoY442LGe6tMZWdb0b+/C9r92iGRW4DFQ9pDkkHlQNgEAF5OZgs1EgAYKMF5QkBlCNMP5cqudxRnV8S46PaTTJyWol74M/Aoo//f7o8pWvfFV5+qmXMixXurTGlvzip9duvvH56zANiYDGhYHcg45XXxpTGWcODnBQDFwI4AA53205GOKETBQy4x3o+R5YG3Upaa3kK8BvgOLzn76yPOUpz5CyVsNy5O3CxVdb1eqVXX3PWx9cb92d+Hnw4sDnkGeQOVABohoAqGOoNgFq/i7QBFAjF/KQGgUJkAg0Cmb8vYUJ+ByaGh8aAiVhIbBnJxSve83dO/PzvweeyzIsdW94Ha2Llz3nOQ+tP/epa4ZVcVF1CWQ5pA4SHS8UmIrxdKvi63qzMU7AICCMe5T/WGJSgUTjFHTGmzgJfYoPSpIJ6QYICqM3vP6xzWUvd1XDcqMX39ByM/0HVK94yRMrD34WEicgKXiTuXGAxBAgALVAwASojABrIzGB8SsCYohiQMniUiJ7ubgdJ+AzxKUktZBOQ7IJqjP+NR2e/cync/TRKw3Lif5//EUtnnRcd3TsEdOG/ynDy54uhFoNF0Yzt5B/6iMvLp/+jBcW27dmugZ83H5RD14hhXFwAImaGEIMQB1ABBYCzJtwvtCqESIBFLxAer5nhRonoc9QPB4lXQluGoqvf+3y8obXP9CwnHi78P+tukcedjd3zpkLwGP5H6riile9gnvXu+/dnH6ZD0pdfN399EdFeY97r/RnnHG4/PmPV5ZPfeyWi9/+3iFDKnQB3Az4Jm6/SQpdD6kDFIIAxgGpAKYBRMYhq40TWAcUAbZKDF4MrwZoBIgV4mZcmdrgGP9fkwSMr2pCLlRrAqPtUL3zbffRj378E8D3WSblm1vdkv9PVQ36OnjsI28mTd0Mb3VrAQL/zTW65vWl/9jHPrh859tvPvz8x2+hs6v+4pzb7X74g/l6y9nz9dlbfFEF6hlwc5BMQxogaRSyDnT3SsA5EB2HKBXIgBAAGb+KIUADZGad2RO5892WkTFnMlPGEMq/X0oSpC5xIZDMBeo1UP75L6vzl77kocDtWCbl5aUv4f9T6Z3vdIz/9W8u1/wbdWcBJMlx7P1fVsPAzvIey2KW2RaYLZbCzP7Y/JgZZXjMzGBmmRnFTEdi8DEJD3YHuiu/iriKmIyKjReyb3e1Ly9+01fTPVPj09+ZlVXZ1TNTm93mjSPAQRbYspOfcab/+pcuqKagGDzecLsfP8X3oeqC5kAHGqOQdQJNyJ0jlxwp29DqQLOE0oESM1tAgVwhS0uxNCBgQ24HWAc8BNRADtgPufg5H0XdBAYCdYDoDaUAV+AqT54p+UqlegSqyz/zhvKDH7kY+CYsf8vdq169vAR4/XUXu127G/5pR7W7r31DazEEWHzpS6+odm8dZyXkDeism4bGFNrrQ7+HUEFB9GwxEy0KyANlYCyQ58PCU1Eg0BRwmPeJpsNDHY8zCgeBXWqutco1KyjNQD96QolIBuSIVmSVJx9R8hVQ7dhf5p+7/J3/bQToP3c5y8X6f/wn02P/8DdvptPB+bojZT4K7FvYeafOJN/8yiu0AZQgI4ADVs4grRGoFaoqUIMPqA5FVDhoEnDDZMG5OF4LdAIA3qhPSCyez4DVCoeAg8ZzqqlmFTOB3RLoGS8ocUxIhqMic0I+qlQC9Xe/c0n5z//6QuC6ZS/A7M1vYblY46Mf/L/lnXefyVFHwexsy+3a1WaBzT2w81x/z+3PkTGgBXkG9Co4eAikAXkjejuN4dODAE6hQUCjMMxkng+MAiPJjUkakQhmqmYANIE1Cg8FvBG6EBDwxikWQAPoyXDcmTnIM2TgyNSTjYAbh3rHzlG+971XLH8Bggs/lOVA3Tv03Pa//OsvML0ihjcPIguOfu+7b+bgrPPjcb0fB1kDBh56fajiTgcATqDMoBUYzWEkltG7PJARGE6ZTATyAFEc6WqHj97MimoAjAGTw/OJcCMSQ3HsiwDOHB3OC66ArAMeqDfdcUHvN35zPMByxi2HHzH3y7+4uvmP//SXWb//NMJcKs0+qjLwU9P9AAsFbvRZetM158sU0IBCwWmsRh7LYALoKIwALaANjMhhmlFgRA+EgAa8g3GBsYCXKKQI5ugVauI5jcQLpgNFwEexEc+TjA1zoJlUVnMYqYXMBUaADOoNdzy9/P73nhNgOeOe6h9QN7J2533v/fNy/caXcs7xcJRC4fEq++n1Aj0WCvnKV18te34woytBgLwWcAWMB1Y5mBQYB8Y0hlSgyVB4dUCMB9JAG1gp4AK1GGFimd8bqodKoRWYCPiI2utMNp3D8G48E9djn6LgWoER8HseaetDDzw/wHLGPZWd+7HCjf30T/xh83Nf/J+88CRY52L8yJBu9/HmR/5zNsBCIKuOmdCbr30lY6BNyKoAAmMNmMohz0CdCX8aEFADAW9EJoEVDkai4CQC9i+JNwMktjFrw9NAAxhEEUaBRkEOP1cGCkAjuPj7QHwcHbTihl2bNz03wHLGPZWdl1/+6mWNL37jZ3n2MXB8E2qFvoPZHn71mt31aWccCrAQZN/41gVy5/Vn6iqQGvKAyzOYLKFZgM9MFYqAj2gSVq1nmopEcQ4FS7o7gvmcwQsQ328DM4DYWzuTlRFvpmUcVtGH//iACzQBgAceOIVf++2JAMsV91R1nJ39/J9tfvyzv8vTj4YzRsF76Mcw9sQTVKee9IPsoS11gIWA737nTVRdYVSQHuQq0CkCJbgCNAsIYLCCs+KpgA6wEnCxbcd/85oAGjFvYTzeVGAkUJtQjAyFqA4EaCrksT/bpwcBXAMA6l07n8YTj68NsFxxT0nHW+8/v/0nf/E+1k7DswPioQco0K+hp1THHX9ngIVgcO4rzvQ3X3kRa0ErJashKwXGSyiL5Fa2xIspsR2pY1KyNnqiGlBS5aXhNz1v5/yGoi45LEIx572aDFmNF7TTQYF4WgI0gBb4/ftHsxtvWBtguZKHF5bS+hdfsGr0l372993c3ATnHQ9lDV2JS1IOHjuEb3ee0GOPvY0FMvnSV1+r+7dP6NHAAcgVXCeHThNcCcTxH3Zlww3DsJgi0xJYA7SAyni0+VYzVM3RCAtzRIYi9ApjQFvgkFmSC4CYfmL/pUDPhOHorSULNEB93fT33j3DMjYXfiBLSeODH/yJYuPdZ/OC42FSoQdUZgpi7wHq1es20G7eGeCIOfqUNf62a17DNKgK2QDyAujEAk+XDwWoEjDh1CceSmLY7RDD5DyZahQBdXIOwFvxmURDNWCKFSY0TV5Akww5E5MRJ326+D2HDkGjNR5gueKWsjO9+KJTyi986e0cOw3HNKGvAaKXCQw87HmcwSknfb/4/BcOBThS9NbbLpCtt57BSmBWyRVcy0GrgCyP7kIAM+j32NA6FOKKOE7z3obPoffyRNR6vwhAEnZTTxkPjCrkyXSMqA3dIEARL1ABSapqSpBeja5e2wmwXHFL2Vl2xx2vC3V+R/PMFSAKXeMlCmDX49TS3N8/97yvBThSBj/5y7l84TNvovSQC9KH3IFrxw3EXQGSD71fmidgxDUBrEjEoyTLZxjTiDUjSnseAYzY4xjO7LpljnZtGrNkCIoZB2axPTfbCrBccUvVkT//Za38uusvdCsaMNUw4lNwgVrgzu30X/CirzS+8MUbAxwpbNt+jt56xXmsAu0pmY/JR7OErABnxOdMVmnFUgNtYLWHPAmrkoosFaNGSLLfyHwe0gOxJAy1CIBNSiAHCknDM6rGqaNZYNn+cUvW0d69J2f33fcc1k2AOhjYkiMH9+yj9o393Xe8858CLAT6ne+8krlHRugAXcgB18ygKKP3y5K5ugBmzXYQl8jWBFpATbRENBixOUyJvWF+L2gEmYTsFuCM2CofLxeojSBzBWLbRvjYr8z1fYDliluqjrLvfuu0zPcnmehABQBoFN8jA9i8jd4rXvGvjU994uoAR4qMrpiRq755CTPgK3CBPAdpxpL6LBDLmQLgBVC74gFZYFVgLFAlE8yRaOnc4X9t5ryZvI7EvhtR/D51osYT4kECdromNpFIntUBlituqTryM6tWM5iFVgNqBYAM6Arc/CD9Y4+/pfe2t/9lgIVAbr7lpbpj/TNlCrQLmQdXCDRykIAz5fR2EyGbFExFfDKXnCpJIqnZMEsiOuy5QCrMQuI8o4I3okv3pHbDoYAdIiKx+/GJboDliluqjuTgwdVCDWU+/Ierc1i/ncrlj879zm/9qtu5fUeAhYAbrrkUPyfaAKkhy2L2WxSQleDyofhS71ULdBRWAthkAGOmYUf/GiGgpJYkFZH55g0d0GYoPMVgvLEDxPyGABK7aGXI3j0HAixX3FJ1lO3dPSpFBs4BgM9h8z7qLXu0+0u/8N5s29bvB1gIXGfVGtbf+BKZBK3BaZxxyTNw5eEGbojauTmgBFYApRGUErEeS4d4AvYcEbXKiwcrOPN5TEJBoA3kRM9n+wA8ZqeFYamXxq+gAtpt9MDjBwMsV9xSdQQiNIrhjvH3Poq/dzvdt/3Py+S+e/42wELht2w9m0fuO5FxYEAUoECZgws4dxgJqABGfBLD7ijgMZaKy8ZYrLiSLDgxUSCShmmfzCvacaDpxoZh5DAqHvvNeBCkyqZWHAiwXHFL1RFlo6YRb+55cD/+7u303vLq97vu3AcCLCRsXv9iBrOZNkFryFwc/+VRgHajPkkqVUZibZ4k3grSkEvE7ISqyR6AyRGN5zRiQioBq24fyIEG83tQW9CaaXxLh1cOQPKyy4knPRZgueKWrLPR0TmyBmw9RH3XTrpveNX7FHdZgIWk/+Z3jXDHzWcyAerBBbIMpHAg+XA3UmcHT/GQR+/XTOYDNQKJ4CLWuwXideZ8Wt2ceE9nXKf1rg4oY0ytCZhVGOsJXRz3eRP1uyATU08MzjlrT4DlSh5eWArL+wcf5oDiNwXPd9G5H6Dbey+LYbU/mn0PnkbbPKItA3IHmcl+ERCsF4QxE3oVE0+t+OIx0e8w9dQ0HBszH0jDqp1blKgmgFzjOfP9tamotisoInhR8CADyMan9mrtH2YZm5PasxTkW7YcYv8h+i954V9Xr7j0sgCLAes3PpNDu1cwClqBIxBVGBgKMAABEfDR600JZCbrjOGSNEJiJ64DxOucGMxnRAiYvwPOnMPc6UYiakk691F4AZs9K+BFowcE5wNj47vzW26ZDbBsCS8sheV335t1L730u4f+8E8uA5RFsmz9vzyLbhfJYxhygUzAZREHmYBEotCYANrJwv78ZgsEkp3vjYe03s8n9ahR9GRJggGpt7Oedh48+BqtFPVR1Bo9/wDcmtW7uer7fZax5XLV91kKm33Pe76JcEW+/vYnWESTuzccp6PEm3QUF50LuMM4Z7yKgkbhjUfheQGZL37Gtl02c/N5yWRyWo23U4NoPGcFDeBMhpskG/Nl3LUGQJ2g8XfoALIa/Akn7WGZmws/kqXA3Xr7Pe6W2zcEsNSnP0Pc9p2NemaVC3Ak6Jzv6L49R0sjZoQSI69E0YlLx3/ggDGBBqCpUBRr8yYgWcSZc2kGHECix0s/Z9eOSR/7ZTwmmDU2M0asBSoARYVAnHoqA3m5I8APw+DiC07pve3/rgiwFOThhafSymuufVP2qU/8uB8b/UPg2xyB1c89ZyqbfWwtmdnQwIGIM8lHEtLawGgUQh1FZE01nUaBTMwYLoLxZthzxsMhkBHbGo+kntV4aDOplw5EMRtg1hrfibrsgRvpkO/Z9Rg/hB34wG8323/7V3/Pnie2AO9kCcy1/+zPeKoob7vjre1f+6V/L7/7vXPd+hsuCXAkFLfcupruI1O0gCjAAAhm3TfxZmMQr0/W3eJ5F5CI9VzpfN5/5fmc8X52zGi9oaSkZftWyNG8uSGKmIDUIP1Asxj4o9Y8FuDJUm65q5lvu29V/vd/847quWe9IsBi42xjSXn9G5/b/JWf++Os7zscvRJfzbUDHAls3DgjdbdFaZNEwLmAEN3hMMQ1gHFA5imXFyz24TJWkEMykueARAoi8bOZuVYCVqhICrhk2BBAJQIMQDVZl66AZtH3q1YeDPBkaV7xXe927juEB/3MJ3+2euubmgEWE2cbS0X/9W8cKf75735f73/oaDnpROq5HloUdYAjwe/aMY5ogQDR6bn0iUX2LrIO0DSZqK0NTLfMlSTs5gKZRIDcBSSKT4YiyxhSEK93w6MLELDTMRgx18l9xxiqQD+2TEmXepC89HRG+wGeLLppkw727vOsmkGuuuIi9+nL3xxgUbGNpaL1n//8U/qZT1/inrYWmg109gBSlAcCHAlubGyU3iw4QNM60KT+rgBGBbwE0vVZBU1CdUZAIQ9k2HAchUQgngOb6Ji+k+QjEzvNkt5mCd7UIUpaOAEMgFqQ5LkjAuBroTuXB3iy9F9ycd6vqpbLHBmK/7d/eTevetVogMXC2caS8OxnPVf+5W9+1tdQrFkHgwF17ZG8nA1wJDA9PU6/QoVk6UvARQBUoQk0kgI6bCLAsJ37KDys1wtoks0KSMSJEZmYc0aoAiAJVoSBylwjdmMkB3XA/O7osNEsMNdtuv2PTwR4stRPP3Nae7MrKSFfO0V9zRUvlq9//dUBFgtnG4uNHuy68o9+79cH9zywrpxqw+pJtJpFa1ARCXBEzB5oiwM08YCa1Pw5oBMFREAiVrhOIwRSUQHOji2tV5QIw+tzie2ImGsQcGLHdrFtdt/CTCO5uJ6tAR+I58Rm4iXw6GO5xx0T4Mkit978bNmybQ3TbYqjRsGD//AH/0923PGNAIuBs41F59or31x/85NvkhKKiQlY1QR6oCB15QIcCXWzaGkadplnZaMgrnpoUgaVvhfIOUzmA6nQiKTjQZOw5PF8mkFjBKlRXOnSHAI+4JI5zChCCMTyMlEhfhKaUHUhu+XGc3uve5MEeDKwef2Fsr+WbNUEbqrAtaG67qqX6batLw6wGDjbWEwGq4+adv/5dz9XdZVCQNaMwWgGrkYVvPiRAEeCO/BERzMbPtP7NRRqD81A4ZNCVJ+WxkMOFAQUckkyXmyiEgVnrzFicgSMkJzY8JskO8bjehcQEImYZ4bE3fJxGQEcgtOYNDegaoN+8+uXNK675twAKSnZrt1n+ssvf102ATIzCs6TTYPff7Dpb7zh0gCLgbONxST/+Iff7m+54hwpoBgpYPUIFIK0HCIgO3asCnAkuH17O5LZjBck9WwSM19JPJ8ky2pZzGZzIx4TWuM1kUSMJMJDhmvQNgsW832qqQcEH3ERCbg8irCAvISyAUWJOEemQga4EnQC+rv3juR//Id/QmfshAAWS33q0yf5/fe/T7fsXFGePAMjbeh3cWOgDnwQMe9+z2SAhcbZxmIhF73yePnCR97tPeQEVjdhLOCBTo6UwPbtR7s3/O92gB+F/HkXiTz2+AgZqALe5iBRAHavZZ1/ohcBnPF+Vnwu9XaRKDwLRWA00Eo8sYvnyaKgAk6SW0TdYaqA5sQyMnMsAmXcz7oJjREoW2QqOB/12YHBNHRvuul5/v3vu1w3bXytXHN1M4BF9+4+k1/7pY8PvvCZSxtHQ3H0WlA5fNN4E5gAf+fG0+Wee58XYKHJwwuLbe6aq/+v/mDjyZpDXgDTJWRRKWMN3Ajonu0n12NT64D7+BFM9txW+P7cCA7w9kY3M3msDDd49Brf8yCZUaOLc3Zp4mCzabM+i5rOTPHBCNAWmAO6gJr1v/gbSX+fuHgMQLo50nAivXbxGcMBHYrXeaXROwS1Qg6DceiJkF1/1bPyDbd8Uk8741Z/zjm36uo1D8vB/W3ZvPnU6oP/8uJqx87pxkpoHzsDY4FDs9ANOJAp8PcfaOoN158HfIcFtjx8MYtp8rILjueKL/3vGhCBfBpoF8NK4U6LbGUJW7etyW67/qwfVYD18Sc15TtfnUaSghQxmWf6MBlnbgrCrHAUAiUgFiNESb2aEV8u0AaaDEVkPa3des22PbYaJ45XXQz1RsBOAA+1QJGBM0iGywuacwfJqwE9B/1xpS6hf2C2we03v1BuuvmFsS804FowchS0VrSRmXXgBQ48Bt0uIiDt+D/hhmtfph/9RGehn9uS+5/+aRbT8v/4zzfpls0naA55E1xHIM+gANRDo0m+dhLZsge/6fZLgI/xI5i+7fxpN/foWhygaoudh2rJFErMFlLxlB1/5fEaO41i124RrFkhkim0gVYUi5eAEa2aD4iYnQ8iyNDTqoeBWccmilIleulA7kEcaCCLN9y32shchyKE0KI/S1X1qJqeqgA/Gu8VCYiDvCGUowXZxBhMroSyDQceh8cfwff7+DjU1DGoN298VnHNtc8GrllQfWTXXMtiWf2cM2fke198q9c4lJkAyRyUAm0PBGjgVk2RT+5hcM33Lsx/9b3PBDb80AK89Zbj9MDD04zGWzEJ2PXbOA4km2dfFhcgeptCA6n4NJCITcQIOF7bjmM+NR63AnCJ0KP+1XpUie8RcTCI6rRPX3JRpLVA7objyczHJzk1oNGGzgD6PfJ+l7zqgx+A1gGi+nJoNAMtaAayDGYPBg7Aof14X0etx3Hgln0j3HbrSxdcgOFLWSyTqrqIe298tm+AtMC1QXIXvUQFgxqqDCZmKI9t0t+8c5WuX/924Bd+aAGOrnmW7H+s5adBvc0PBCQLuGFVisxD/BC5pNlwkqQkQtSAEMOuYC+kVqiS8npvhJiOF6w4+0DlGO46qQGxY1Ez1aPgI66GLIeyhGY7Vk1H8LY4w1TY1NCbhX6gewAGPTzmrs82eAJ33/ki+dM/L4ABC2RO3/lOFgP/tne5/MuffpP2PFqCGw0Iw+fg5jU0AqLQGqM4ag35JFRfu/ydvOyi8wM8WfR//0whG285X0vQDATiv3EUnwtkZhsOW+cXgHgsrECjCEkEJCQotAMtopCNmryZ54N0SzZbbJoIOwq3Jp0vHB4dAUxG7iI5ZNlh8pj1FdEzls1ACS4DH4VX9aA7Gzh0mF4X9TXeAzWIB0qgDX7T+ufJju0nBlgonGksKNmmTc+Xzdee61ugTZBWACAHnAetoBkoPGQFzKyjeXwb/9juUf3z3/nz/PGHTw7wZMiuveISve07F7MiqRkVgSKHLDNLaWlpvikULYBczNSIS/6Dx3Ni3msJtBPxAEhabJqs6aIgVowYsw+9SdaHU8OEb0lXUtINjTzUNVRVYAC+D3TBB/pzgT4MKnytqAIRshiGd25bJVdccU6AhcKZxsKy/ubz9OFd474JjAznYykAV0M9gLyCRkA8jExSrDuG9tHQv3vDs/of/LuPV6uOfl6AFItK61T/n3/7AZWDubYFrSHPAg4kzp2RFeDMtiCiJuN0UXwRSVc5NB4luUdDomcwD51GhtdBWlI//73BQgrRQw+v9fGo9jsV1ODjCfFAQCPUoAGtoK5hEPADkD643uFjAB1AFahq1BMFaAp7R8DPDYIId5wdYKFwprFg1Ode1GL99RcpQAMkID4gQK6AB18FBocFmNfgHKw4mtax62itg/7m2583+N2f/Ip841Pv5bE9p8mOe4oAEeTAI2O6e9dbqn/8k8/W+zY/S1aDHyhZ1EXmHJRF3AvQRQHmZkUhkAkxhJlavVSAmMIA401yoA1k6V4vABixWPFYAZtiBzQN62bu0YgM05aAGJHhh0KL/76hHb1eBYOAD7j4f/yiDwxAAwRcBVSoejSpTCOGYc3B37X5ufqrvz4eYCHIwwsLbXL7xqfz0Ibn+iZoCQ4QW5quNVQDGASKCpoZzArkDVh1IiODHpI/zOz2+1bPferBy9x13/yJbM1xG/4/dV8B7DiSNJ1dki0/GLplnGOmj5mZmZmZmZmZmZmZmRmOYZlnb2aHHttW19/xlBXK6HiB65n9fl3kqS2N7fVzOgu6qjs95an3+fFj+3bm0RN+1x3P7+98zfOw2J3YDQm5B1rzYfbMEtKEaYl2MiA1JJ1V7ZnQihXeJ+FA1K2aDZWvoanUI5TLCR2jXt5XCJn0RsGEBM2h1lUjustSbVme22dVRT7OXCIsD0RLdDD75QAU2OCPOxI8O1SxdWX+fM9dz5z+138/A8B/riYN81//jVUffs8db4HzhSSnAEzF/TEC3It3PgesYNoMhZf7DTDbAG55Ntbbewp/zmD/sR6Lhx64fnH/A++If/77wfLwddLasKW+YShwmDQJbQGmXAN60pUzSdi0BWkkn/pjDaNfqwgHnWLjGEy3TFMdzUq0LICrn0YiQcx51WnX81pTMCGZVDUJko9vGUQMVQTJytdJPUGFzD3QE16AWMME8EPSS/BtElutA37x3Am85CUvWBkBy4utXgEfvvPNPAMeCV3oPKsqIH2Rzga7uczAwoDZJnDjMzAp0fHkxKPoL25hubvAck5Xh1Y0pkXbaULTMOLrWmAy4fhwop7ka9Q51Bo/ltDLNUVcC5+x03SLyqI2uns91zxeszDlYmqN44Cz/GujYNuBhXTHkVjBENpLEgm8x9IxjvmD59+dRO2pgJlmOnKgcwC99CzzFlhlkx9dIG9feiFWdLTlxbDKI3/Sp98y+fQPeIPMlAh87M/wJg3i0ueBgH3Bcs7EaCpoh7ygp4E4p24GNk6iueYSmu3L6Hb3gMUcWPbjhG9rserVcJ4WBOGmk/FeaoaIeCoNSsbnN1JcACWeadqGMx2SMCbhjt6kBgWpjow5lKbzpD9M9QGZ2pnxcU+gwEUpMwkV+Tw+lxdogoOAJGwf/iGfTwV21jbG501etZU2A/xVr3z25AM+aApg/rgJ2D73easl4F//9XNx/qFb8/pgKrWl1kezQ8d4TnIYkPkltFnKkAB064Mp3TgxbLs6L1gcMI3QjwlVIxG5iziaApNzMqALHzDOEYCIPwiNQJRUiVu3aoFAVcbvCRUDq9xg1vtUVhLAmLjWDrx1rhG4jOtCPigyIe9LwglI1l6iZJenk2uNeifVFLYNKM1fT18++9nXAXjocROwvBBWedg//cPzcflCh1PqGmmpG/NRyyVTAA2ZyvxgooK5VUvRNvTnDFi2BYzqECbLSLakgQZVrBkwSYegwpGsJGHdO5ycY1m6rbOq0UiJ6BUheS+g/eVwVcIRpgQqmLFpfkei5sxzI6RCvA7VLq73vIdQPl7T1I6sPe2QPpe+mqSRZL0/dvb69Nj5W1dBQCsvhFUB3p5MZ+55DgB4Iykx7bNxSYhSBalqBcxFJQYntmDExlxhkKVtgCmnm7qCGc+TyP6HzyfmONmgdC1h0a8BLTIVVFXIayyBgvqHdVU0CLmhZrxOYkPG5kQlwk9i77KmXxCkCzKS9EmJxr2Fr8/AJgmZIM+HBjg8HMlIQlAVvYroZ4DP947bv/zz7QV4vGjL/2FVhx87fhPuuOOprv4fjygOsfBbIj+VGiZCQVI4zZKYyT7JqvB8UV1g0uWLjBxfaoVI/LddGklshI4TASGgM0jpoOrH+1rnJ4Sq1bD+N2biByaqDm8vpVTM2Y13Pf2/i1QrZYZFxFsA8RNPZuBGB04UPCzP1cUtlYDhRfCHlOAj+SQVmqZAPreNfnPz1pUEIeWFsKoj3XLLLWnn3O2uJieIKApIh5kEbAt6qh3NMP1ChruSwkiSmocSoaCqNrYk0Q9N71qSUnglY92rEWeLLjPmButl3QjnQBPJ0LPUBR5l11pE5YvUBjLP6PQDb2KUer7gQPOI4e/xNY9l4BT3tJtSJTeo9HtVMSwSeRvExtFLwunRFiwPzfDTVkLA8kJY2XHTdbeVxN11bqIB6vJQrTw7Unb6K3MAMivhiaamxdElKEf6TkIAEx+uITkYTa4lNZUMQISU+jahmhOmXUwbxHmojwgosST7LorOmRCaQ93GlSSkGnqkXoIw3D/uBpLpUsGuAwcFC6eyZ2Ct4DjGLf372Oaf2OHGNrq4Uf1nZV2jp6psknA+xuvOnloJAfG61RGwue/+azCfz9Aq+cAHEnz1QDKn2oUpTiqTY4I1SViWK9WD+mFOcrgEAfL+G/xitChB1U/zfhDT3aXRPCZlV11EqkcQnOSBibkUM97IBtRNpFakAnpJMxz3DMBxB9apggsUOBVd/iZLaNlX5Pi0oJZmu971UxbZ1HqJKufuU6B53dmTq5kJWSUBWzuVF8vO2e4heaRqw0eZWopE6YwmUM2LGV8kIuKKAKYzFoSpWeQ4GoTaML8m/bymvqAQlwTt1NfTejxVvFRNxRlXwzoqNYNQU/FdnekdG0PlictnJVGy9Jx0/EH1if601z9QJZfaU16vt/0i9BY0ehe0wOLy+dUQsLwQVnXYZnPM0SftkYD6f/yw3icgFHDZA84Is8VAwD7+gPoXN+mdzeIP1uQhdOJ+s2BdWytR+YBHF5miK2jEF4SY6iOPSp0bj6JSIapEsvE5Iw/Yynv08d7Vf1fmuU56IzFgo7JZHQE6iZfpA6pC6hQzB0f2V8t3ube3vhIClhfCqo7cL2ZHL/9cK6AP6awcrOyBRB/twIDd5WhS3UmAZnycScZMU6qEy6qEVL9TVAtzRpyJUMJClsUgSTud9ajMcE3CihPR3ISF3icRoO5DfKOaUtFVzPsCubYUNUyRMiGkqOHoGRiNzHOdPNfnayBypHthe3vdSghoKySgp5wSIKaAPp/FZyYBIy1ljgT5ZVoPbND32S+wVtjtgEtNH/iiPMgU+nHhOzKHdizUL8in6RwnbEyII5rSVVWrCDnGOqsBiSaNZrRxcQdcpu/4njlz+svENIb68brpPnRq6r2KaKMgIS7JNN5SSKrvA31dDsVDQLxc7dPP55OVELC8EFZ1pGS91sG5V9vg9rq9fXysXn71GegKTlDdDnpRG5peV/MgrZTIJF98ySTfdeyG57yv+n7VYpF8HY6nEpVrcFKXx9ffjAk5DBFAqF9a5QQjxxlpF5m31OLXtvbx0kgqSHoqnqc9yovMYKWaw9ZEn47qOEsPF8KvhIBIWNXRTtd3c0roe1oOqwJhqRTyPoIuZSrlca0ZyPYYm7oBIZqFMHDM55s6+ZzCurFgLcgn0Wbro+OfCDVz3Im8Uj5Cr9UBiKqhAy3r+nqSQ+aDhQ31qv2igHpIxfaSjzUwclnHEC6kL9jlcyx8wQCgEueSI3QtbayLbHvuQ7wSArYNVnY86fottE2PHTRA5KMEkoJSc5z6LNFeGhKrs2ZQr0sJ2DYSOkfagoqhxAVr6Ljj0XUObOhazM77RzWaC7Eg1dFJ1a5ewUqeo4fLNFfk4BbyGFJg5z3PorItQBmV95IfWZt4XQMPP1qqEgO6XSqeifLVdpWoyxjrzT0jxeNdN19NENJ1WNWxfNpTztlLJvu2hY1+f4gifRqKL1XjTUICythlelOdaBJtasC1BbMe2DJg0ehPkac0qsOaA8c5CzADYAHnHLAkiE2QiFDatqlIKTMlIDQyhlpVSZsAwKQH2sSIN4++mts4rQZJoBtr+VQlG75nn/ma8uNZVuob7x0+70HBntYPFujfMFVE02S8WnRVPwd8Y31vNQTcWMeqDj/99AexdvIy/LEN9IDvAKkdWyU9E8YzCqL7Cz2ZqmaNGf5T3MtjLwNzxJdHYnG1q80EHHNgo2AaHCHo+zHhTN9PyaepExJVCZhISCWj3kdlpzxMLcnckQhqdoN0WdUr6ZjvqWYyMYID1TLVuS4Jxjg8YNWeSeTMJLQqtcuUtWMYqIV2nacG0K5t7KyEgOWFsKrDHn7dA5g+6cFkd92UAPh+wQRIx+OXFHB4TswtO3yZkKKcPFMprCLBtB8UDjRdaMay9Wn0GjPjr2bXQEjQUTcfQYjYpgJdkVT2WkgBTZWYkkOX0Bij+6mxQkUDdpel2cCAogoyeomElz1VzeRvINt5IUnYKlHvZaqkBkckI90XZRlpx6vqmi5HAqYDADfd8uhKOFNeCKtCvvm2B/z0014LFyd6p+AyuwM1ReNOa5EGi7SAJGmrcvIUT2J1yBpLjDYcWM/064RsQeBGgw+QmDoGkKyaESFMVY6FrY0RLbcimrDlsyDJNYsyMBJ40kQltq4dTTLX7xsKTX9P0RDtUYudB7n4/KkDBwm4WKWJ3PVM9ePXUmUsdH9sLKqa1yeffqgAjxfGwUrg//XPj/rpZ70suQgHAN8ruMwe6F6sTO+cGYkPLIRLUaZLIsYSueZUIN4DeL8vkPJ2XVK3cULTLkpCwYTXYYAJ6SyNC0OmlgjyTQFrBRMB20G7Bpjq+6JSecg1rS+U4GMKUXoSTQnZ8nMaA6ntgh0HTP6WXvuBmjespkvDM5qDisl1d2YAnvL01xTg8aI9HKzyaKb/lU6c2k+7F2bJhGxzktAZ6DI4gRPLsBCSpU+JRIuxA8bH1gi5MlWJ4wnvHT7mc8w4Pmq7LSFGS7Ih1ErLwmRtZlZae1R001NP6MVbj2MJtA2XbFtE1KorZGngyxmeOEfOr56RkaKB3qv5cCrW+R7oq4rpVur/OGWXAXimGKRRAX3BJrosKcwFUL7fXds8vpKFJa28EFaJ/Hpv8BJc/9Q703KcjIBJon8PyFuAF/gBxr3OFvzgQYogIgI9YBASkmwtlU7AFsMBup0+xzyLIrr4f7qSqekuM6P6NS28mcJtMkiSdUAzAw6vHULMMZ8HNkh1BU2SJDqC6DI/Xakh9LGoeKSVdMuIliq5V3BRPnMoIARUPMrdSL55wQEJCD1IwBtueQg33/zaAjxeGAcrg12+cNaf98b/YD2QpsIlmfL0BZD3g4gJvg345UieEqaFkfHHo63mr1xJpc+hCedj8QEVoYQmj1uM/STJiGb06WwSxCMZy9hmyLYGtw6egoxT/rsuSCideWW8VjCzsRdZy/GTXgullmS6BSFdKmmUlLx2oWA/rmsWOXzrAY6Inxx5SfLtF+hEQgIH7JZ4/ov+rf+5n3ykAI8XxsFKkV/8Fn+KjfWePr5mJ2JIq8Xoag/w8wWXIH2prkSqfEIfm29AYhrvGf+97nBkrl+YkFCdeJAQNfEmKCCpWvX/RsLZOtzWgDSDH4LrkTQdnIREkNbYt9xNgbW2IAGzxGognjkegxPxC6l0cp2ElRyi58H3g/RhQy2KQ9s784J1wXOKQ09SJlXA4Z7NgPS2b//XBVgFjIOVYvnWb/u3/ow3+Xfbp/Xh4YSWt+XkcCvYB/JOwdKBOXFQsJRiBaiJLbCeYyexZA29RhS0Jp/m1pIkeyexBUIEIBFUkGwBRNQ7g9v6IQlTWgOagqYDrCMJpwMJGzXHTIxawwUlCybtMPPTsQB2FgQUE83PKEoo6u4BEi6Jn6lz5eFj0u2ZA3mexuVkktAzxVl3HQeapzzrXn/jN/27AqwCxsFKYVuXLuMt3/03DYC1UlGrM1AsbvFENVwyWjYga+nSMhdEGqBn4lZ9uR7QYCNV3V9yv4D36sXHQdVpZT3BiUS0UxkTqTs0v7BhQWhP04IgXkGQM80KqIKNpGhokqXUTPqVocQLogmZwLEouxY/gAWq1vPfgWX+/FHPh7H3zMmmIN+AI/vq85D/s3d89z9JP/2TdxdgFTAOVg5/0Zv8Nm57/h3NArCJ+IKEzqT1NvggvlOQgWxO30TLkOIJHoELyYjav5EghbAAKiUUH3DSyqJFJAgVzxNJmCaMfFv44ePB7MI62qYCHBKRmCHz37iVs824vUKBCdkDyaoZkHqndd6zcDVS3JecIPOiE/7dlghrUpDZ/ETSmdMVchIw/swBKavbBZobr9vG+7zfLxdgVTAOVg6f4N785u/xy2kJNF3V8iHFCFkKfbEL+Ny59xtU2apgQ9dHAZj5qKs8anWQL0473xh4BAEbSS4bfbgCpCHIcJrfgZwbAE3tQMS1AWlKdEiHPuE6XEmYRAmlmb5AfFCIiwBVcdmnjtdRN9Fn4BoMxz7V0MV/hiNT+dzK2I4wvVaVO24D7bu97+/gF3/hHwuwKhgHVwT+du/2c7jlBa+xOZOX1V7LBSQfTe9umOH4RTo8iNZiDEZMkswpzCx4pDhVb4IRXrVMThvd8oBKR3NKJfNowrCW5ndzUMC4jmnBGkk5izQMlTJepyBMsk2D6CShki8p+SQUletyq/5FHx63ZuA2krUXs5NoeruCUw5vxH64iILUBfo20Nx+62Nl06Ef/v9qpyQ/sXGPv8/H/UjiEjCsORUVFH5YwYL5QfdD5GAqnOhJOBJxNFEkYR01a99EjKtGnQYMPvjFM/r1NAlEAprnCVVuk/5dEFaUsVJBknCMki3Mdpj6NlRPlFDmdesfkzT383NoyQrbODPwfADP8mHaMpGIC0ded/hzAb+O7dkeq3PU/Uqc+dgDpu/zwT9hv/Ir/1qAlYKDK4b+Az78Z/Cst/m7tA3YenwqnfIRPxBAvsSFO1MQMZ4ghEMcQUYhloXMqToGKQnFlOY3jbMbQJCiIZLkHZvw9bTchtBMcCvryLXMHYbCtvI+9eLpupI9xsO09lFaMSF+raZaMufJn1/wRjw/3eHPLngjwG9x5IPIRAi3656nx4DJG7zJ/+JjP+4HC7BqGAdXDM3Fs5fzh3/6t6bpNXuNO2wiIiRcQajgVsHOYIY90jRBMJ37VcB1rMrBMwHXggU2nc+AIEeqfD1o6iUI2cGxPhIwqYKJUpKkJCWVkclrDKBySqQ9GQkZc73Q4En82ciLmnzmUH9dBKotuMmB5xa8AZBfVHADJwJ2xX1GRb40lNO165tz+5Kv+Aa/756HCrBqGAdXFNhc+9P0th/6w+nSkCpLpi2qUjBtGPKBF1mrSfKRo0IoSbNoiVHcM13MkdDnRrP32gxogwjTyOGRLF1EvoKuYJ3gPTAvWEAl5LgLQpOMPCfmCW0Nzgh5AIkYVTRtQaemuPob8Jok2YmsJJX1Ax2eWPG8dORtoKcCQkgIj6TzEHh0H/RR32t/+ie/XYArAg6uOPJHfeJ3pdNv/O/pItCsJ6k/IyIQwUBAX5CQcKlNC1JJJbFJh1uSIMW0B0BXjF9yw2ou4UufD8aUSwQKVsBrCP8OM6rfTE0tMSGmcu5GFUwTee31gjW4zQrk9YOEESFPCzobzUXSz1jPc9dTbT6CaaxIo/ZLYHlhIKDX5CPSo0D3Nu/61/kLvvjbCnClYBxcceCak4/4p3/Fl6bZTRdt7mimaoqlEMSAfpvzxAYlqDYv6ZfBxxwHJuTJlKmLloWrGxNgcx3o1hgAUP0KMhj52oxmd8gBOppxtxZsBqkqmIwnxIzoxmuJpOT7ONb4nlQ/IxkjQd0VrNEkw1XN5TFhruVFqpzyd/RhxukCJwSsIl8apkWnp596d/upn/H5zStffr4AVwrGwVWBTe1v8O4f+23pbGQgquaXWCZ2DuTzQJ/DQXZkaBRL6DZW6ow7K6WPp4IGOFFwfAIcWwPW12l2w+cj+cpYHzvJB7RIJJVjjYRqNOggJjEmSEoqod73JCppnFFJqrbxb7noZjcB1gxocyg+kQckKAmp9Jot6MOfHiLec4BvSwCi2Z4LwGT9usv2HT/4+b01LynAlYRxcNXgH/SR34W3+ZBfxTnxB3nkyDsl/kJ3VAVjiq42tzIGxw39HgMXpWwH0jURJGi5VAcXRUIStfIgX0virQmRND1jRBuo/EKSzdmlVeAg2WmC6Q9KQMPXhW5qrYpHEiZJT0mwpgUb7o7efbAuWwVnuI2IdA0AnO3oO0w/60u+2l79yt8rwBUHB1cPf/UnC3zqF3xlc/IZLz30B9dSlVPlHPEu0J+nf6IqSLKNT+JjyIwJNKklE79KEk6veSrQgAMdXEymw3heJwFHciQkJFhBQxjRCBED8fojPMasIXRIwNO0HDfaC13gEvXLGUTlF9KLHkyvFzzCTINVQccBYOeBjXd4729u/uffvq8AVwPGwVVF+8PfcZd/7jd9nnW3nLd9h03T6H+YVAefHYjI0i2qoEaBhLrSGulm1xZMmXsliWgCD8GAwdWUakQbpjeNZKPfJyoYLBFyJt5HqKYGK52MJSlt9CXrLb6odtVnFjCpItfd83ClGdwaf4R3xKX0OWBnUSLej//p5Wd/4dcW4GrBOLjq8Kec/uv0oZ/19c0W0CSHNZIPLPB2mBXJZwp0Dxg/inyajBZFXOocckO00CIDx3Qkg3eaViHZJpxi65BIPiCpEvJxRUYJThJILEiSm0R3TNg6GIqoyel6xf5eVI9jRvhadqVEzHDkpmAP6O8e8n8u7dW+BNJZYPbuH/rb+Ru+4wv7pz59UYCrBePgCcHiIz/p+/Cen/ZjdokFCybNMcbzGSBfcGQpynTIPF6thjprsGRDQzKCBGRCOMjmmBKqTgNhHG3BTLvBlXjV/6wy90HCuNcQrZwn8CBnMnjiddMZmALvB6RMSPbOdDFnwp2lVkPXYX/foIBZl84j+bq3ere/whd/3Wc0585dKMDVhHHwhGHxSV/8tc2z3+yf7fKw41FyqcZt2ZvwIDP3xuuoa+IgyiBfSqxDbbp8r1F5WEKPjtCAQZqPGCyQQDXxQqmIhJRoenVvCp2WQ8NxHS1rMBPPJaAV4Bqy9ZIjJGr1M0f/KNA/zHyqjS+H80D3ojf/9/ZTvuST7NFHzhTgqoODJwyTB+47s/jMb/+cyc1Pf9D26A+qCjacGTlTkCWbX29VBYmCNcG4XEi5EsngLVwjVtRRqxGabI7nB1ThFCT7qIjyOMiWBND5ZLkvt1NssRokI5JXJaR9YAjZzNFfLLiXP2SL4HgIONZvfcYrph/4SR9nD95zTwGeEFyNNzm4Zr1dzJAKcBRy6v+z/6gv+7ppO4H1zsBvgE+oeo8M+ats0Toovo92fHkVDS7nQF5U0TDViyb2yISy+GtJCcNIVwMOJZS+x8giQapJqGNdobXhQ5rfPBfz2+vsDh9LAEK/b7kH9PcAfpmFpzQKdgnYuOkp97fv83GflC4+8soCPFGwq/EmzdbWh3d//Os/ZXe/9k2avf1UgBr5xC0/iff/nJ/osqS8IjHdUf0eAPIlkhCpoE5M1wUJXAB9vlutg2eBo8lHiCoJEmrypRQA6rRPEpLx4FhhUXBByEI6qaDfL1iMhFPzq8rnwz1PGf3cke8rOCdBRwaaLWDz+ht38hf+wOctn/PCfynAEwm7Gm+Sbzz98slr7nj77ms/61/xRz/1C7h05k0LUGPnA7/w2ycvestXdz0to6NASDgveDBSM2p6A/U1muGDHSAfqL82pjqY93E0JKSSS9RKZVkIlZISzPi4JpmSNqBkRJXHE2XzOdDvMOpVAkpS2n0kp2X0S0d/PxPO4TGzJ3tjo0X6kM/7hsmZV/x2AZ5o2NV4k/V/+a3/nn/Ep7x/c/L2O6Y/9RsfYT/65X+Ol/zZz6fdc2/jJ57UFqAA7Sv+/c6Dd/yk72u7hn3h1RYBkZp5qCCKFdTc0jQRYoYPgMXW6NAbeNA/k9SKc0wICVGbzOqxHqmGQI9MOBLHo4mNSH6rYD9ygEE8omfCvR/J1xfc74eI9kqQx7MMNO/4kb938KYf8N0F+L8Au1pvtHzei/97+eGf+CF4xvNf2f7Xw8cmv/+rH9X8xjf9Sfd3P/47k0de8km2OP+CAmBv5zXL6TU7aQGkJgHQ5naWkJ8veNi51Fu9W6Q46lmS0/NLQL8LJCD6EBOcprjy5/TsNcmSoiohriZW6+tHH5pUVr9uqMqYX+B157kPwsm/HXY8z72jvw+FfNJYntPhuDkAutNPvrz/zp/1PWn/0qIA/ydw+aX/hat5NH/61y/wP/jNn23u+O/Xb29aB2ZbSCenwG1POZdmx+5Znjt3au/cvU/HLANdwjL7MGFBpEkaSuY6Q3MasNMJNk1IMec74UpWLdEQrQObtxQ8H96cgqfjAE4iFyBtstJlxqAj0jAd+z4apNGMyrhAqCkJolArJs4zSb+AF8ALcAD4HtfP3UbCFpJfAnAZKZfz8hywf2dBGWe2pC4PwfGyYMHH/6+9cw6z41n6+Kd65mjPbhZx7o2Ta9u2bdu2bdu2bdv42YhXeZPFOaOuerPpmbuTPHv//UX3m6fSPTE+z7e7pvpUF2jq8RcbxQWKT2pdDnqgPaM5A+2b3fsn/Qe88R5AClCsa4pYMhb97bRGdMEF00DOZSyZ/8jruKxlne3bi8994NPRab+7cXvzBoj7+GQ8vLOKwJennqQpFIVhzfqBYsG1IXJC1BLcJojWO1xLAmh1AOvPkQRAl10ZOlc5DKAyDCwDGcToUlU8IEYCgCWUgnBE1aOWcNRltTG4luFrABaY5UAG9EsA+whzwAzYQRwHwQ5A/zxIdoO3xSv2i2oswBfh2XKsH+DzlxhF39DCsATsMOMGfYgTiNZtP9du/ciXyBDT6uau5prRDeLT/3oD+fvEcn/FWz4J+AaXsSR57TM5Fsquf68N+uG3f0R+/707dq64mcbIKD6dRv1+InKyZkG/U6BRrRHBf05LCVFjIcB1HG49uMsLrlUmF8ENa07oFrtntboweH2suR1jCGNZ6YaDJWztACBSztulG5b1XyEA+F875dfh01p2WgQYjwCwcr9eCeABnMxBfin0zoA8ASXA5uvOVz0XWM8vgBf2fYmGvXFqkIAlYS5JWRpPoTnYzqOhlkaZtuI9PbjUk9/6Pr/NHvjExwLncxkrTm9yF46Nsh3ulW9/qP/IunfOfOcjD++sn2Vg81WJOlcE+rT7UzB3IfOSAVBf9QzQqrBRKDYuaAtknSENX6ubUt9ABpCKOUjOgHgEom4JhA9Rq6sagmAESQ0sV+sqJTUQ7eiLGWtR/1rr+7cywrIsKGgf8p1hrO1XwZdzH0I81vfoDkP3GOoVA9BaGAiL5bfBzgCNaKzBTEQx0SPzI6nc+/bvSh79/DcAMxwDxbpuA8dOOm2vfMvjmkW+u//DT78wm/+tDG7aTDy6CroraEsPS3fQq3dvRxABKyHxDijAjYNvQLTWkEjBjr46gVIOsnEk+QcMDGO0EcswKSoIywAra69ii+AL1SQ82SJxSy/JBlarzCx9gqUGVn4x5HvB6rCW8FkNvllFLwWdMEytfroFsdrv4MBi6OTQ6q5AGSUZ34vvrjrd3eFBLwJ+0PjJ1zhWisNvfkyVcdUtL26vfOG+/vc+9vr/O//C7sCaHXSGluEGYtpRE09KBhhHmY2Fb1FnSA7sUzQS3AKEsS6CIhFw1D3A6SVI4x9I89aYtYEUaIQoXQ58DYKohFABh1jd+Yy66lnrkc/1hKQW5hExxO+A7Nzy+wW0BmflhOax/YrfqYdGQzFUanevqIW5AVIz/hxmdu9AbSblNo/+SGPj1d4I7OUYS+Y+93GOF2lr7G7Fu1/43mzyvE3x5aDdFeKm4FtK2mAxGWkKNOoHmyXsC2NB2uDWOGTdwlwQ58qEpByrlrmi0GjA4G3Q6MaYdTEZALq1fV8jPEsLiBZruRLVM+AlIDSsAgerMuASphQsocp+sVlEUsQuQpKfQjYFGgX4tNrraZhnHhs3/C7D5hTLDc1ChISjbG2SlxmwJ3zfQdAkJl551b83r3fflwE/4jiRY2o3x0u43ad/r3Xvx9+rc6Wb/c5PwFzPmDUlqV9ra6DYUm/QQonOg04aOm5YbphTwB+1lOUggE8g+QNi54NYLUHIavutaukzrF4mI4QdjuqLVrF0l1dTLCyjNVcDYQbJ/wzFeGlbxVFLboGliu4N8NEvf8/S7VAp/3rls4XQxLD9EDXXzXZu+ug3tu/9vDu69Zt/dCg4XkJ6X/8sx5v86Jbl/mdfe43/4fufWAxlEStBqm4XrRDB9QgRl9/WlPDtsYR3hiscskaQriDRQrhaB6wohMuhuQHr3B9lC1b1eKEZQtqlKzZrR6rqNd5KVgulXqM1ihrcCRIy4DCX/bjih5D+BXwEaouuZ2G0GcX2KDZtaFr19gvz0E7X0H7VVtewvmEHQGj7aNNNfiQ3e+QbgD9wHCrWWDneJLMXTMt9H/G01opVv3e/+txr8j1nbmU1MFwzssgQFai7Y1n8cIRRDijOC6xyMAagCEffHRtBfjES/RBpPRB0DSZJrYLhAuVEJWdSDgIYlcLTEiDWHLD+SgYUkQJX/AHSv4Kn/Av4MIpC4Q9DZ+OGzhqoIZQ/ZCF00dDxwfE5COJj3JVv/dfoKnd6m8Ttb5HPZRynkt7X3s/xLEsHt/m//fiV2WnfeJDGSSwrwS0DSjeMGgKt8rlZOl/MobF0wkiCey53sHJhLrjFZpAhHOAKaN8Gje+JWrXvq6KDhTfjyJIdxOsI+iWy2zyE5UDlfDlOf4mkX4eiDxrXGnD6sMxOWAAwNaxQyAnzDDRVLCE4YF/xBw3JItyaa58lV7vPe+0qt/sScIDjXDJ32l843iV7piPbde7di3999wX+kt/c2Lo5srxsQtUSpA5gq2o0IEhjIap+QA6GBVmAcJkcfhaRajkOAEYNrH0/1N0Ks9qHyGljVOW66Mil2AA5spWoARKW3RqAGZCGEMPpn3Dpp8BPg7ZAddHCZxTdZzBrWOVsC5GW+7osQKnzis0b5A6Gt13qtt3tI7bltp8A9nGCSOZ//31OFFlz7RB/+ubjin9/9Wl+7twtLDPcMLiOlAAGIMuacZnIVq4Y9oG0BVkuuDGBlkMAohJCSaGxCm09GuMqGFKDsIsxDDSOOqp1tLSMCryijBQhARzOzsRlHwgVD+uAVqe3FQ4E52PeyiU2AEdaZbqK9nwAz0fY0Jadbt3NPsWa63wSuJgTTNL/0Xs54XSwtcGf/6snFTt/+RhN9q52oyAjQFMCgFXJLipdMAAZwgk4kGFBVgky4JAjruxKoHF1tPlI1FYBAnQOh1GW7ESWgNCWBrCegCA4LibK3gfZaaADi40Sc4MpxaYVMkrnq8HXV2y+wPoATWzsmmex9mZfYHDjF+rgnXgA/vRdnKiyS6ev7JOJp+uF330w6Z4RlgHDgmsH6Fy5BNMMY5UhEwUI3YCDakmOSgjFIMqw9h3R+L5hKaZRAtgFRrG6CyJlABhC7VJdfG3pFYQJouyDSPYb0A6oAAp9gwnFZgwKw3yV3SrMZ9Ar3+21Vs7rypv8ytbd8UvSWfMjYIoTXNL/2zc40ZXP6nXl/B8+gUt/eD9L94wxCLIQHYdrLkLoGgsBNAKE4oJjygqBESmNzYHLIe5gnUeg7vqYWXAduhhjQLcOYC2s5oB5OWYIiug8Uf5JJP0W+BiIwRR6ChOGzVowy0whzbC+D07ohtW6287WtXf8nnW3fku7a/4O5Jwkkvkzv8/JIpk6eE3b88eHs+sn96V38SaLMqQDDEiAsRWWYRcBDXcoQFzpiisFRsH955rWHjSvhLYfg7ICxIA2ZsMYK0pXlHpVJMh8LRMugLw01e/ikg+BZqBNUIN+Cd9BhTQNlY5MMDeEdS53qQ1d8xc6ct3vWWfLb4ApTkJJ/7Svc7JJxneuV9J7uH2/vy/Tf7mx5eNtYoN2dbOCII0YaTmIqJwQVgsMCgKIU4g81r4HGt8BEwEJL6lVVgDDgGAIWAmhUFUwEA3uBzGuOJu4/0bILwn7vsJDmsO+DKYVVNB41NvAxvO1e9XfH3K8n9Nc+VtgFye5JP33+zlZpbahRXbgBpZO3y3a97s7urlzrkr/gpgoKRteldEAIsF1I1jjoB0h4kASJN6ADTwClbUYDlyrPEe4EpMWAFgcRl188SyaQ6GgGY3kA8j8N6GQxe1hbxk2O7Jf21tP15Hr/dHaG39n8dDfgHFOIUlyzmc4FZS3bjjqspkbytye27iD59w0mjvtqmSTw67Yibh9mOtBVCAjHsaAZu1z5+27oPHNsLIWGO79GEZtebmXE1BDqoOjRY74HHxMlP0Fl78PLPcWrZm05vpztbH5NLKRv2l8jX9Cej6QcIpK0nM/xqmmtH2XLtHAFaXfu5br77qOyyavItnMNsknVzm/syXRJNKahUYGrg/xOqxxtcUbk6wBFmEMY74DOFAHAuDMxPVx0RRxdImLLrpI+NdZ1rz82dq88nli4zsWgfufJJ34JKe6+vrwljhdS5ZucUm6QUQ3SZFvQG0FRTImOjeI+SbOIsQMpBAnKZGbN9eaIW4cII4nTHQHEu211uAe4miH+AMTQJ//6b/q/wEKlEx10ZXM2gAAAABJRU5ErkJggi5wbmc=",
    ":rocket:": "data:image/png;base64,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",
    ":partying_face:": "data:image/png;base64,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"
}, $81cb1647619a2ab5$var$fe = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $81cb1647619a2ab5$var$he = 1e3 / 60, $81cb1647619a2ab5$var$ve = 119.99999999999999, $81cb1647619a2ab5$var$pe = Math.max(.1, (600 - .0075 * Math.pow($81cb1647619a2ab5$var$ve, 2)) / $81cb1647619a2ab5$var$ve), $81cb1647619a2ab5$var$me = {};
if ("undefined" != typeof document) try {
    for(var $81cb1647619a2ab5$var$ye = $81cb1647619a2ab5$var$fe($81cb1647619a2ab5$var$ue), $81cb1647619a2ab5$var$ge = $81cb1647619a2ab5$var$ye.next(); !$81cb1647619a2ab5$var$ge.done; $81cb1647619a2ab5$var$ge = $81cb1647619a2ab5$var$ye.next()){
        var $81cb1647619a2ab5$var$we = $81cb1647619a2ab5$var$ge.value, $81cb1647619a2ab5$var$be = new Image;
        $81cb1647619a2ab5$var$be.src = $81cb1647619a2ab5$var$de[$81cb1647619a2ab5$var$we], $81cb1647619a2ab5$var$me[$81cb1647619a2ab5$var$we] = $81cb1647619a2ab5$var$be;
    }
} catch (e) {
    $81cb1647619a2ab5$var$se = {
        error: e
    };
} finally{
    try {
        $81cb1647619a2ab5$var$ge && !$81cb1647619a2ab5$var$ge.done && ($81cb1647619a2ab5$var$le = $81cb1647619a2ab5$var$ye.return) && $81cb1647619a2ab5$var$le.call($81cb1647619a2ab5$var$ye);
    } finally{
        if ($81cb1647619a2ab5$var$se) throw $81cb1647619a2ab5$var$se.error;
    }
}
var $81cb1647619a2ab5$var$Ae = new RegExp("^\\p{Extended_Pictographic}$", "u");
function $81cb1647619a2ab5$var$Ce(e, t, n, o) {
    var r, i, a = "host" in e ? e.host : e, c = a.ownerDocument;
    if (null !== (r = c.defaultView) && void 0 !== r || window, !e.__confettiCanvas) {
        var s = c.createElement("canvas");
        s.style.position = t, s.style.inset = "0", s.style.pointerEvents = "none", s.dataset.upscopeViewerDisplay = "none", e.appendChild(s), e.__confettiCanvas = s;
    }
    e.__confettiCanvas.width = a.clientWidth, e.__confettiCanvas.height = a.clientHeight;
    var l = e.__confettiCanvas.getContext("2d");
    null !== (i = e.__confettiEffects) && void 0 !== i || (e.__confettiEffects = []);
    var u, d, f = e.__confettiCanvas.height / 600;
    if (n) {
        var h = (d = n, $81cb1647619a2ab5$var$ue.some(function(e) {
            return e === d;
        }));
        if (!h && (u = n, !$81cb1647619a2ab5$var$Ae.test(u))) return;
        var v = e.__confettiEffects.find(function(e) {
            return e.emoji === n;
        });
        if (!v) {
            var p = 128, m = document.createElement("canvas");
            m.width = p, m.height = p;
            var y = m.getContext("2d");
            if (h) {
                var g = $81cb1647619a2ab5$var$me[n];
                (null == g ? void 0 : g.complete) ? y.drawImage(g, 0, 0, p, p) : g && (g.onload = function() {
                    y.drawImage(g, 0, 0, p, p);
                });
            } else y.font = "".concat(102.4, "px serif"), y.textAlign = "center", y.textBaseline = "middle", y.fillText(n, 64, 64);
            v = {
                emoji: n,
                sprite: m,
                particles: [],
                startTime: 0,
                duration: 4e3,
                spawnDuration: 2e3,
                lastSpawnTime: 0,
                heightScale: f
            }, e.__confettiEffects.push(v);
        }
        v.startTime = Date.now(), v.heightScale = f;
    } else {
        for(var w = e.__confettiCanvas.width / 2, b = e.__confettiCanvas.height / 3, A = [], C = 0; C < 500; C++){
            var x = Math.random() * Math.PI * 2, S = 20 * Math.random(), E = Math.random() + .5, I = 1.8 * Math.random() + .5, k = I * (3 * Math.random() + 2);
            A.push({
                x: w,
                y: b,
                radius: k,
                color: "rgba(".concat(Math.floor(156 * Math.random()) + 100, ", ").concat(Math.floor(156 * Math.random()) + 100, ", ").concat(Math.floor(156 * Math.random()) + 100, ", 1)"),
                velocityX: Math.cos(x) * S * E * f,
                velocityY: (Math.sin(x) * S * E - 20) * f,
                sides: Math.floor(3 * Math.random() + 3),
                gravity: 2 / I * f,
                rotation: 360 * Math.random(),
                rotationSpeed: 10 * Math.random() - 5
            });
        }
        e.__confettiEffects.push({
            emoji: null,
            sprite: null,
            particles: A,
            startTime: Date.now(),
            duration: 1500,
            spawnDuration: 0,
            lastSpawnTime: 0,
            heightScale: f
        });
    }
    var O = function(t) {
        var n = t.heightScale, o = (1.5 * Math.random() + 1) * (4 * Math.random() + 4);
        t.particles.push({
            x: Math.random() * e.__confettiCanvas.width,
            y: -4 * o,
            radius: o,
            color: "",
            velocityX: (Math.random() - .5) * $81cb1647619a2ab5$var$pe * n,
            velocityY: ($81cb1647619a2ab5$var$pe + Math.random() * $81cb1647619a2ab5$var$pe * .5) * n,
            sides: 0,
            gravity: .015 * n,
            rotation: 10 * Math.random() - 5,
            rotationSpeed: 1.8 * Math.random() - .9
        });
    }, D = function(e, t) {
        var n = e.x, o = e.y, r = e.sides, i = e.radius, a = e.color, c = e.rotation;
        if (l.save(), l.translate(n, o), l.rotate(c * Math.PI / 180), t) {
            var s = 4 * i;
            l.drawImage(t, -s / 2, -s / 2, s, s);
        } else {
            l.beginPath(), l.moveTo(i * Math.cos(0), i * Math.sin(0));
            for(var u = 1; u <= r; u += 1)l.lineTo(i * Math.cos(2 * u * Math.PI / r), i * Math.sin(2 * u * Math.PI / r));
            l.closePath(), l.fillStyle = a, l.fill();
        }
        l.restore();
    }, z = -1, M = function(t) {
        var n, o, r, i, a, c;
        z < 0 && (z = t);
        var s = Math.min((t - z) / $81cb1647619a2ab5$var$he, 3);
        z = t, e.__confettiAnimationPending = !1, l.clearRect(0, 0, e.__confettiCanvas.width, e.__confettiCanvas.height);
        var u = Date.now();
        try {
            for(var d = $81cb1647619a2ab5$var$fe(e.__confettiEffects), f = d.next(); !f.done; f = d.next()){
                var h = f.value, v = u - h.startTime;
                if (!(v >= h.duration)) {
                    h.spawnDuration > 0 && v < h.spawnDuration && u - h.lastSpawnTime >= 33 && (O(h), h.lastSpawnTime = u);
                    try {
                        for(var p = (r = void 0, $81cb1647619a2ab5$var$fe(h.particles)), m = p.next(); !m.done; m = p.next()){
                            var y = m.value;
                            y.velocityY += y.gravity * s, y.x += y.velocityX * s, y.y += y.velocityY * s, y.rotation += y.rotationSpeed * s, D(y, h.sprite);
                        }
                    } catch (e) {
                        r = {
                            error: e
                        };
                    } finally{
                        try {
                            m && !m.done && (i = p.return) && i.call(p);
                        } finally{
                            if (r) throw r.error;
                        }
                    }
                }
            }
        } catch (e) {
            n = {
                error: e
            };
        } finally{
            try {
                f && !f.done && (o = d.return) && o.call(d);
            } finally{
                if (n) throw n.error;
            }
        }
        e.__confettiEffects = e.__confettiEffects.filter(function(e) {
            return u - e.startTime < e.duration;
        }), e.__confettiEffects.length > 0 ? (e.__confettiAnimationPending = !0, requestAnimationFrame(M)) : (null === (c = null === (a = e.__confettiCanvas) || void 0 === a ? void 0 : a.parentNode) || void 0 === c || c.removeChild(e.__confettiCanvas), delete e.__confettiCanvas, delete e.__confettiAnimationPending, delete e.__confettiEffects);
    };
    e.__confettiAnimationPending || (e.__confettiAnimationPending = !0, requestAnimationFrame(M));
}
var $81cb1647619a2ab5$var$xe = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$Se = function() {
    function e() {
        this._eventListeners = {};
    }
    return e.prototype._fire = function(e, t) {
        if (this._eventListeners[e]) {
            var n, o = function() {
                var o = r._eventListeners[e][n], i = $81cb1647619a2ab5$var$xe(o, 3), a = i[0];
                i[1];
                var c = i[2];
                setTimeout(function() {
                    return c(t);
                }, 0), a && r._eventListeners[e].splice(n, 1);
            }, r = this;
            for(n = this._eventListeners[e].length - 1; n >= 0; n -= 1)o();
        }
    }, e.prototype.sequenceStart = function() {
        return this.removerSequence = [], this;
    }, e.prototype.sequenceEnd = function() {
        var e = this.removerSequence;
        return this.removerSequence = void 0, function() {
            e.forEach(function(e) {
                return e();
            });
        };
    }, e.prototype.on = function(e, t, n) {
        var o = this;
        return this._eventListeners[e] = this._eventListeners[e] || [], this._eventListeners[e].push([
            !1,
            n,
            t
        ]), this.removerSequence && this.removerSequence.push(function() {
            return o.off(e, t);
        }), this;
    }, e.prototype.once = function(e, t, n) {
        var o = this;
        return this._eventListeners[e] = this._eventListeners[e] || [], this._eventListeners[e].push([
            !0,
            n,
            t
        ]), this.removerSequence && this.removerSequence.push(function() {
            return o.off(e, t);
        }), this;
    }, e.prototype.off = function(e, t) {
        if ("*" === e) {
            for(var n in this._eventListeners)this._eventListeners.hasOwnProperty(n) && this.off(n, t);
            return this;
        }
        var o;
        for(this._eventListeners[e] = this._eventListeners[e] || [], o = 0; o < this._eventListeners[e].length; o += 1){
            var r = this._eventListeners[e][o], i = $81cb1647619a2ab5$var$xe(r, 3);
            i[0];
            var a = i[1];
            i[2] !== t && a !== t || this._eventListeners[e].splice(o, 1);
        }
        return this;
    }, e;
}();
var $81cb1647619a2ab5$var$Ee = "2026.10.9", $81cb1647619a2ab5$var$Ie = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$ke = function(e, t, n) {
    if (n || 2 === arguments.length) for(var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
    return e.concat(o || Array.prototype.slice.call(t));
};
function $81cb1647619a2ab5$var$Oe(e, t) {
    return void 0 === t && (t = "http"), "".concat(t, "s://").concat(e, ".upscope.io");
}
function $81cb1647619a2ab5$var$De() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    return e.filter(Boolean).join(" ");
}
function $81cb1647619a2ab5$var$ze(e, t, n) {
    var o, r = 0;
    return function() {
        for(var i = [], a = 0; a < arguments.length; a++)i[a] = arguments[a];
        clearTimeout(o);
        var c = Date.now();
        c - r > n ? (e.apply(void 0, $81cb1647619a2ab5$var$ke([], $81cb1647619a2ab5$var$Ie(i), !1)), r = c) : o = setTimeout(function() {
            e.apply(void 0, $81cb1647619a2ab5$var$ke([], $81cb1647619a2ab5$var$Ie(i), !1)), r = c;
        }, t);
    };
}
var $81cb1647619a2ab5$var$Me = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$Be = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$Le = $81cb1647619a2ab5$var$ce("viewer:audio-utils");
function $81cb1647619a2ab5$var$Fe() {
    return $81cb1647619a2ab5$var$Me(this, void 0, void 0, function() {
        var e;
        return $81cb1647619a2ab5$var$Be(this, function(t) {
            switch(t.label){
                case 0:
                    if ("function" != typeof window.RTCDataChannel) return [
                        2,
                        !1
                    ];
                    if ("https:" !== location.protocol) return [
                        2,
                        !0
                    ];
                    t.label = 1;
                case 1:
                    return t.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]), [
                        4,
                        navigator.mediaDevices.enumerateDevices()
                    ];
                case 2:
                    return [
                        2,
                        t.sent().some(function(e) {
                            return "audioinput" === e.kind;
                        })
                    ];
                case 3:
                    return e = t.sent(), $81cb1647619a2ab5$var$Le("Error while testing audio support %o", e), [
                        2,
                        !1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
}
var $81cb1647619a2ab5$var$Pe, $81cb1647619a2ab5$var$Ve = ($81cb1647619a2ab5$var$Pe = function(e, t) {
    return $81cb1647619a2ab5$var$Pe = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(e, t) {
        e.__proto__ = t;
    } || function(e, t) {
        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }, $81cb1647619a2ab5$var$Pe(e, t);
}, function(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    function n() {
        this.constructor = e;
    }
    $81cb1647619a2ab5$var$Pe(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
}), $81cb1647619a2ab5$var$Te = function() {
    return $81cb1647619a2ab5$var$Te = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $81cb1647619a2ab5$var$Te.apply(this, arguments);
}, $81cb1647619a2ab5$var$je = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$Re = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$Xe = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$Ne = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $81cb1647619a2ab5$var$Ue = $81cb1647619a2ab5$var$ce("viewer:connection"), $81cb1647619a2ab5$var$Ge = function(e) {
    function t(t, n, o, r, i) {
        var a = e.call(this) || this;
        return a.token = t, a.shortId = n, a.region = o, a.idleDisconnectSeconds = r, a.endpoint = i, a.doNotReconnect = !1, a.connecting = !1, a.connected = !1, a.attemptingReconnect = !1, a.waitBeforeReconnect = 0, a.awaitingPong = !1, a.handshakeComplete = !1, a.dataBouncePromiseResolvers = {}, a.lastActivityAt = new Date, a.idleWarningActive = !1, a.disconnectingDueToInactivity = !1, a.lastSlowBounceLogAt = 0, a.receivedMessages = {}, a.sentMessages = {}, a.logInterval = setInterval(function() {
            0 !== Object.keys(a.receivedMessages).length && 0 !== Object.keys(a.sentMessages).length && ($81cb1647619a2ab5$var$Ue("Received messages %O", a.receivedMessages), $81cb1647619a2ab5$var$Ue("Sent messages %O", a.sentMessages), a.sentMessages = {}, a.receivedMessages = {});
        }, 1e4), a.windowSizeChangeListener = $81cb1647619a2ab5$var$ze(function() {
            return $81cb1647619a2ab5$var$je(a, void 0, void 0, function() {
                return $81cb1647619a2ab5$var$Re(this, function(e) {
                    switch(e.label){
                        case 0:
                            return [
                                4,
                                this.waitForHandshake()
                            ];
                        case 1:
                            return e.sent(), this.emit("viewerUpdate", {
                                windowHeight: window.innerHeight,
                                windowWidth: window.innerWidth
                            }), [
                                2
                            ];
                    }
                });
            });
        }, 500, 1e3), a.connect(), a.startIdleDisconnectWatcher(), a.addNetworkDisconnectListener(), window.addEventListener("resize", a.windowSizeChangeListener), a.stopEventLoopWatchdog = function(e) {
            var t, n = e.intervalMs, o = void 0 === n ? 1e3 : n, r = e.onBackgrounded, i = e.onBlocked, a = e.thresholdMs, c = void 0 === a ? 2e3 : a, s = Date.now() + o, l = "undefined" != typeof document, u = function() {
                if ("hidden" !== document.visibilityState) {
                    if (s = Date.now() + o, void 0 !== t) {
                        var e = Date.now() - t;
                        t = void 0, e > c && (null == r || r(e));
                    }
                } else t = Date.now();
            };
            l && document.addEventListener("visibilitychange", u);
            var d = setInterval(function() {
                var e = Date.now(), t = e - s;
                s = e + o, l && "hidden" === document.visibilityState || t > c && i(t);
            }, o);
            return function() {
                clearInterval(d), l && document.removeEventListener("visibilitychange", u);
            };
        }({
            onBackgrounded: function(e) {
                a.connected && a.emit("debugLog", {
                    ms: e,
                    type: "tab_backgrounded"
                });
            },
            onBlocked: function(e) {
                a.connected && a.emit("debugLog", {
                    ms: e,
                    type: "event_loop_blocked"
                });
            }
        }), a;
    }
    return $81cb1647619a2ab5$var$Ve(t, e), t.prototype.connect = function() {
        var e = this;
        $81cb1647619a2ab5$var$Ue("Initiating connection"), this.connecting = !0, this._fire("connecting");
        var t = this.endpoint ? this.endpoint.replace(/^http/, "ws") : $81cb1647619a2ab5$var$Oe(this.region ? "data--".concat(this.region) : "data", "ws");
        this.socket = new WebSocket(t + "/viewer"), this.socket.addEventListener("open", this.onOpen.bind(this)), this.socket.addEventListener("message", this.onMessage.bind(this));
        var n = !1;
        this.socketCloseHandler = function() {
            e.socketCloseHandler = void 0, n ? $81cb1647619a2ab5$var$Ue("Close event already called") : (n = !0, e.onClose());
        }, this.socket.addEventListener("close", this.socketCloseHandler);
    }, t.prototype.shutdown = function() {
        var e, t, n, o;
        $81cb1647619a2ab5$var$Ue("Shutting connection down"), this.endSession(), this.doNotReconnect = !0, null === (e = this.socket) || void 0 === e || e.close(), null === (t = this.socketCloseHandler) || void 0 === t || t.call(this), this.socket = void 0, clearInterval(this.logInterval), this.idleDisconnectWatcher && (clearInterval(this.idleDisconnectWatcher), this.idleDisconnectWatcher = void 0), window.removeEventListener("resize", this.windowSizeChangeListener), null === (n = this.removeNetworkDisconnectListener) || void 0 === n || n.call(this), null === (o = this.stopEventLoopWatchdog) || void 0 === o || o.call(this), this.stopEventLoopWatchdog = void 0;
    }, t.prototype.onOpen = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            var e, t, n;
            return $81cb1647619a2ab5$var$Re(this, function(o) {
                switch(o.label){
                    case 0:
                        return $81cb1647619a2ab5$var$Ue("Connection with server established"), this.connected = !0, this.connecting = !1, this.waitBeforeReconnect = -20000, this.attemptingReconnect = !1, this.onServerPing(), e = this.emit, t = [
                            "hello"
                        ], n = {}, [
                            4,
                            $81cb1647619a2ab5$var$Fe()
                        ];
                    case 1:
                        return n.audioSupported = o.sent(), n.hasFocus = "visible" === document.visibilityState, n.screenHeight = screen.height, n.screenScale = window.devicePixelRatio, n.screenWidth = screen.width, n.shortId = this.shortId, n.token = this.token, n.version = $81cb1647619a2ab5$var$Ee, [
                            4,
                            $81cb1647619a2ab5$var$X()
                        ];
                    case 2:
                        return e.apply(this, t.concat([
                            (n.videoDecoders = o.sent(), n.windowHeight = window.innerHeight, n.windowWidth = window.innerWidth, n)
                        ])), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.onMessage = function(e) {
        var t, n, o = this, r = JSON.parse(e.data), i = r.c, a = r.d;
        switch([
            "dataBounce",
            "dataBounceBack",
            "ping"
        ].includes(i) || (this.receivedMessages[i] = (null !== (t = this.receivedMessages[i]) && void 0 !== t ? t : 0) + 1), i){
            case "appFrame":
                return void this.onServerAppFrame(a);
            case "audioCallProblem":
                return $81cb1647619a2ab5$var$Ue("Received audio problem event %s", a), void this._fire("audioCallProblem", a);
            case "videoCallProblem":
                return $81cb1647619a2ab5$var$Ue("Received video problem event %s", a), void this._fire("videoCallProblem", a);
            case "authProblem":
                return "session_expired" === a ? this._fire("error", [
                    "connection:expired",
                    void 0
                ]) : "visitor_not_online" === a ? this._fire("error", [
                    "connection:user_not_online",
                    void 0
                ]) : this._fire("error", [
                    "connection:authentication",
                    void 0
                ]), void $81cb1647619a2ab5$var$Ue.warning("Authentication error %o", a);
            case "browserEvent":
                return void this.onServerBrowserEvent(a);
            case "cameraVideo":
                return void this._fire("cameraVideo", a);
            case "confetti":
                return $81cb1647619a2ab5$var$Ue("Received confetti (emoji: %s)", a.emoji), void this.onServerConfetti(a.emoji);
            case "connectionRemoved":
                return $81cb1647619a2ab5$var$Ue("Received a removed connection (%o)", a), void this._fire("connectionRemoved", a);
            case "connectionUpdate":
                return $81cb1647619a2ab5$var$Ue("Received update to connection (%o)", a), void this._fire("connectionUpdate", a);
            case "chimeTokens":
                return $81cb1647619a2ab5$var$Ue("Received chime tokens"), void this._fire("chimeTokens", a);
            case "customMessage":
                return void function(e) {
                    var t = $81cb1647619a2ab5$var$Xe(e, 2), n = t[0], r = t[1];
                    o._fire("customMessage", [
                        n,
                        JSON.parse(r)
                    ]);
                }(a);
            case "dataBounce":
                return void this.onServerDataBounce(a);
            case "dataBounceBack":
                return void this.onServerDataBounceBack(a);
            case "dataError":
                return this._fire("error", [
                    "connection:data",
                    a[1]
                ]), void $81cb1647619a2ab5$var$Ue.warning("Data error %o", a);
            case "doNotReconnect":
                return this.doNotReconnect = !0, void $81cb1647619a2ab5$var$Ue.warning("Was told to not reconnect.");
            case "initialState":
                return $81cb1647619a2ab5$var$Ue("Received initial state %o", a), a.activeConnections.length > 0 && (this.latestConnectionId = null === (n = a.activeConnections[0]) || void 0 === n ? void 0 : n.uniqueConnectionId), this._fire("connected", a), void (this.handshakeComplete = !0);
            case "newConnection":
                return $81cb1647619a2ab5$var$Ue("Received new connection (%o)", a), this.latestConnectionId = a.uniqueConnectionId, void this._fire("newConnection", a);
            case "newJwt":
                return void this.onServerNewJwt(a);
            case "newViewer":
            case "viewerUpdate":
                return void this._fire(i, a);
            case "ping":
                return this.onServerPing(), void this.emit("pong");
            case "pong":
                return $81cb1647619a2ab5$var$Ue("Got a pong, the connection is not broken"), this.awaitingPong = !1, void this.startBrokenConnectionTimeout("check");
            case "requestKeyframe":
                return void this._fire("requestKeyframe", a);
            case "screenFrame":
                return void this.onServerScreenFrame(a);
            case "screenVideo":
                return void this._fire("screenVideo", a);
            case "sessionTerminated":
                return $81cb1647619a2ab5$var$Ue("Received session terminated instruction"), void this._fire("sessionTerminated");
            case "sessionUpdate":
                return $81cb1647619a2ab5$var$Ue("Received update to session (%o)", a), void this._fire("sessionUpdate", a);
            case "visitorUpdate":
                return $81cb1647619a2ab5$var$Ue("Received visitor update (%o)", a), void this._fire("visitorUpdate", a);
            case "videoCallFrame":
                return void this._fire("videoCallFrame", a);
            case "versionNotSupported":
                return void this.onServerVersionNotSupported();
            case "viewerConnectionId":
                return void this._fire("viewerConnectionId", a);
            case "viewerContentVisible":
            case "viewerGone":
            case "viewersCount":
                return void this._fire(i, [
                    a
                ]);
        }
    }, t.prototype.onServerConfetti = function(e) {
        var t = document.getElementById("upscope-viewer-confetti-container");
        t && $81cb1647619a2ab5$var$Ce(t, "absolute", null != e ? e : void 0);
    }, t.prototype.onClose = function() {
        $81cb1647619a2ab5$var$Ue("Disconnected from server"), this.connected && this._fire("disconnected"), this.connected = !1, this.connecting = !1, this.attemptingReconnect = !1, this.handshakeComplete = !1, this.awaitingPong = !1, clearTimeout(this.brokenConnectionTimeout), this.attemptReconnect();
    }, t.prototype.onServerPing = function() {
        this.connected && !this.awaitingPong && this.startBrokenConnectionTimeout("check");
    }, t.prototype.startBrokenConnectionTimeout = function(e) {
        var t = this;
        clearTimeout(this.brokenConnectionTimeout), this.connected && (this.brokenConnectionTimeout = "terminate" === e ? setTimeout(function() {
            var e, n;
            $81cb1647619a2ab5$var$Ue.warning("Disconnecting from server as we haven't received a pong back"), null === (e = t.socket) || void 0 === e || e.close(), null === (n = t.socketCloseHandler) || void 0 === n || n.call(t);
        }, 2e3) : setTimeout(function() {
            $81cb1647619a2ab5$var$Ue("Haven't received a ping in a while, sending one and seeing if we get a pong"), t.checkConnection();
        }, 15e3));
    }, t.prototype.checkConnection = function() {
        this.awaitingPong = !0, this.startBrokenConnectionTimeout("terminate"), this.emit("ping");
    }, t.prototype.addNetworkDisconnectListener = function() {
        var e, t = this;
        if (navigator.connection) {
            var n = function() {
                t.connected && ($81cb1647619a2ab5$var$Ue("Detected network change, sending ping"), t.checkConnection());
            };
            null === (e = navigator.connection) || void 0 === e || e.addEventListener("change", n), this.removeNetworkDisconnectListener = function() {
                var e;
                null === (e = navigator.connection) || void 0 === e || e.removeEventListener("change", n);
            };
        }
    }, t.prototype.onServerVersionNotSupported = function() {
        $81cb1647619a2ab5$var$Ue("Unsupported version of the library"), null === sessionStorage.getItem("cacheCleared") ? ($81cb1647619a2ab5$var$Ue("Clearing cache and reloading"), sessionStorage.setItem("cacheCleared", "1"), location.reload(!0)) : ($81cb1647619a2ab5$var$Ue("Already reloaded."), this._fire("error", [
            "connection:version_not_supported",
            void 0
        ]));
    }, t.prototype.onServerDataBounceBack = function(e) {
        var t = this.dataBouncePromiseResolvers[e];
        t && (t.resolve(), delete this.dataBouncePromiseResolvers[e]);
    }, t.prototype.pruneDataBouncePromiseResolvers = function() {
        var e, t, n = Date.now();
        try {
            for(var o = $81cb1647619a2ab5$var$Ne(Object.keys(this.dataBouncePromiseResolvers)), r = o.next(); !r.done; r = o.next()){
                var i = r.value;
                n - this.dataBouncePromiseResolvers[i].createdAt > 2e4 && (this.dataBouncePromiseResolvers[i].resolve(), delete this.dataBouncePromiseResolvers[i]);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                r && !r.done && (t = o.return) && t.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
    }, t.prototype.onServerBrowserEvent = function(e) {
        this._fire("browserEvent", e);
    }, t.prototype.onServerScreenFrame = function(e) {
        this._fire("screenFrame", e);
    }, t.prototype.onServerAppFrame = function(e) {
        this._fire("appFrame", e);
    }, t.prototype.attemptReconnect = function() {
        var e = this;
        this.waitBeforeReconnect += 1e3, this.attemptingReconnect = !0, this.reconnectTimeout || this.connecting || this.connected || this.doNotReconnect || this.disconnectingDueToInactivity || ($81cb1647619a2ab5$var$Ue("Waiting %dms before reconnecting", this.waitBeforeReconnect), this.reconnectTimeout = setTimeout(function() {
            e.connect(), delete e.reconnectTimeout;
        }, this.waitBeforeReconnect > 0 ? this.waitBeforeReconnect : 1e3));
    }, t.prototype.onServerNewJwt = function(e) {
        this.token = e, this._fire("newJwt", e);
    }, t.prototype.emit = function(e, t) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            var n, o;
            return $81cb1647619a2ab5$var$Re(this, function(r) {
                switch(r.label){
                    case 0:
                        return this.doNotReconnect ? [
                            2
                        ] : (this.sentMessages[e] = (null !== (o = this.sentMessages[e]) && void 0 !== o ? o : 0) + 1, n = JSON.stringify({
                            c: e,
                            d: t
                        }), [
                            "hello",
                            "ping",
                            "pong"
                        ].includes(e) ? (this.socket.send(n), [
                            2
                        ]) : this.handshakeComplete ? [
                            3,
                            2
                        ] : [
                            4,
                            this.waitForHandshake()
                        ]);
                    case 1:
                        r.sent(), r.label = 2;
                    case 2:
                        return this.socket.send(n), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.waitForHandshake = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            var e = this;
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return [
                    2,
                    new Promise(function(t, n) {
                        e.handshakeComplete ? t(void 0) : e.once("connected", function() {
                            t(void 0);
                        });
                    })
                ];
            });
        });
    }, t.prototype.sendVideoCallFrame = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return this.emit("videoCallFrame", e), [
                    2
                ];
            });
        });
    }, t.prototype.sendCustomMessage = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return $81cb1647619a2ab5$var$Ue("Sending custom message %o", e), this.emit("customMessage", JSON.stringify(e)), [
                    2
                ];
            });
        });
    }, t.prototype.requestControl = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(e) {
                return $81cb1647619a2ab5$var$Ue("Requesting control"), this.emit("requestControl"), [
                    2
                ];
            });
        });
    }, t.prototype.relinquishControl = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(e) {
                return $81cb1647619a2ab5$var$Ue("Relinquishing control"), this.emit("relinquishControl"), [
                    2
                ];
            });
        });
    }, t.prototype.endSession = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(e) {
                return $81cb1647619a2ab5$var$Ue("Ending session"), this.emit("endSession"), [
                    2
                ];
            });
        });
    }, t.prototype.beginAudioCall = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(e) {
                return $81cb1647619a2ab5$var$Ue("Starting phone call"), this.emit("beginAudioCall"), [
                    2
                ];
            });
        });
    }, t.prototype.endAudioCall = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(e) {
                return $81cb1647619a2ab5$var$Ue("Ending phone call"), this.emit("endAudioCall"), [
                    2
                ];
            });
        });
    }, t.prototype.beginVisitorVideoCall = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(e) {
                return $81cb1647619a2ab5$var$Ue("Starting visitor video call"), this.emit("beginVisitorVideoCall"), [
                    2
                ];
            });
        });
    }, t.prototype.beginViewerVideoCall = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(e) {
                return $81cb1647619a2ab5$var$Ue("Starting agent video call"), this.emit("beginViewerVideoCall"), [
                    2
                ];
            });
        });
    }, t.prototype.acceptVideoCall = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(e) {
                return $81cb1647619a2ab5$var$Ue("Accepting incoming video call"), this.emit("acceptVideoCall"), [
                    2
                ];
            });
        });
    }, t.prototype.videoCallProblem = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return $81cb1647619a2ab5$var$Ue("Reporting video call problem %s", e), this.emit("videoCallProblem", e), [
                    2
                ];
            });
        });
    }, t.prototype.endViewerVideoCall = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(e) {
                return $81cb1647619a2ab5$var$Ue("Ending agent video call"), this.emit("endViewerVideoCall"), [
                    2
                ];
            });
        });
    }, t.prototype.endVisitorVideoCall = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(e) {
                return $81cb1647619a2ab5$var$Ue("Ending visitor video call"), this.emit("endVisitorVideoCall"), [
                    2
                ];
            });
        });
    }, t.prototype.reportContentVisible = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(e) {
                return $81cb1647619a2ab5$var$Ue("Reporting content visible"), this.emit("contentVisible"), [
                    2
                ];
            });
        });
    }, t.prototype.reportDocumentVisibilityChange = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return $81cb1647619a2ab5$var$Ue("Reporting document visibility %s", JSON.stringify(e)), this.emit("viewerUpdate", {
                    hasFocus: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.audioCallProblem = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return $81cb1647619a2ab5$var$Ue("Reporting audio call problem %s", e), this.emit("audioCallProblem", e), [
                    2
                ];
            });
        });
    }, t.prototype.disablePointer = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return this.emit("controlEvent", {
                    action: "hidePointer",
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.movePointer = function(e, t, n, o) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(r) {
                return this.touchLastActivityAt(), this.emit("controlEvent", $81cb1647619a2ab5$var$Te({
                    action: "movePointer",
                    uniqueConnectionId: e,
                    x: t,
                    y: n
                }, o)), [
                    2
                ];
            });
        });
    }, t.prototype.disableCursor = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return this.emit("controlEvent", {
                    action: "hideCursor",
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.focus = function(e, t) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(n) {
                return this.emit("controlEvent", {
                    action: "focus",
                    elementId: t,
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.blur = function(e, t) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(n) {
                return this.emit("controlEvent", {
                    action: "blur",
                    elementId: t,
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.selectionChange = function(e, t, n) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(o) {
                return this.emit("controlEvent", {
                    action: "selectionChange",
                    iframeId: t,
                    selection: n,
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.keyPress = function(e, t, n, o, r, i, a, c) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(s) {
                return this.touchLastActivityAt(), this.emit("controlEvent", {
                    action: "keyPress",
                    altKey: o,
                    code: n,
                    ctrlKey: r,
                    elementId: t,
                    key: i,
                    metaKey: a,
                    shiftKey: c,
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.submit = function(e, t) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(n) {
                return this.touchLastActivityAt(), this.emit("controlEvent", {
                    action: "submit",
                    elementId: t,
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.moveCursor = function(e, t, n, o, r) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(i) {
                return this.touchLastActivityAt(), this.emit("controlEvent", $81cb1647619a2ab5$var$Te({
                    action: "moveCursor",
                    color: t,
                    uniqueConnectionId: e,
                    x: n,
                    y: o
                }, r)), [
                    2
                ];
            });
        });
    }, t.prototype.drawLine = function(e, t, n) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(o) {
                return this.emit("controlEvent", {
                    action: "drawLine",
                    lineData: t,
                    reference: n,
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.clearDrawings = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return this.touchLastActivityAt(), this.emit("controlEvent", {
                    action: "clearDrawings",
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.confetti = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            var t;
            return $81cb1647619a2ab5$var$Re(this, function(n) {
                return (t = document.getElementById("upscope-viewer-confetti-container")) && $81cb1647619a2ab5$var$Ce(t, "absolute", null != e ? e : void 0), $81cb1647619a2ab5$var$Ue("Sending confetti (emoji: %s)", e), this.emit("confetti", {
                    emoji: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.scroll = function(e, t, n, o, r) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            var i;
            return $81cb1647619a2ab5$var$Re(this, function(a) {
                return this.touchLastActivityAt(), i = {
                    elementId: t,
                    mode: r
                }, this.emit("controlEvent", $81cb1647619a2ab5$var$Te({
                    action: "scroll",
                    uniqueConnectionId: e,
                    x: n,
                    y: o
                }, i)), [
                    2
                ];
            });
        });
    }, t.prototype.requestMode = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return $81cb1647619a2ab5$var$Ue("Requesting mode %s", e), this.emit("requestMode", e), [
                    2
                ];
            });
        });
    }, t.prototype.socketBacklogBytes = function() {
        var e, t;
        return null !== (t = null === (e = this.socket) || void 0 === e ? void 0 : e.bufferedAmount) && void 0 !== t ? t : 0;
    }, t.prototype.sendAgentFrame = function(e, t) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(n) {
                return this.emit("screenFrame", [
                    e,
                    t
                ]), [
                    2
                ];
            });
        });
    }, t.prototype.screenVideoTransportReady = function() {
        var e;
        return (null === (e = this.socket) || void 0 === e ? void 0 : e.readyState) === WebSocket.OPEN && this.handshakeComplete && !this.doNotReconnect;
    }, t.prototype.sendAgentVideo = function(e) {
        this.screenVideoTransportReady() && this.emit("screenVideo", e);
    }, t.prototype.sendCameraVideo = function(e) {
        this.screenVideoTransportReady() && this.emit("cameraVideo", e);
    }, t.prototype.reload = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return $81cb1647619a2ab5$var$Ue("Sending page reload"), this.emit("controlEvent", {
                    action: "reload",
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.fullScreenEnd = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(e) {
                return $81cb1647619a2ab5$var$Ue("Sending fullScreenEnd"), this.emit("fullScreenEnd"), [
                    2
                ];
            });
        });
    }, t.prototype.historyForward = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return $81cb1647619a2ab5$var$Ue("Sending page forward"), this.emit("controlEvent", {
                    action: "historyForward",
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.historyBack = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return $81cb1647619a2ab5$var$Ue("Sending page back"), this.emit("controlEvent", {
                    action: "historyBack",
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.requestFullTab = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return $81cb1647619a2ab5$var$Ue("Requesting full tab"), this.emit("controlEvent", {
                    action: "requestFullTab",
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.stopFullTab = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return $81cb1647619a2ab5$var$Ue("Stopping full tab"), this.emit("controlEvent", {
                    action: "stopFullTab",
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.redirect = function(e, t) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(n) {
                return $81cb1647619a2ab5$var$Ue("Sending redirect %s", t), this.emit("controlEvent", {
                    action: "redirect",
                    uniqueConnectionId: e,
                    url: t
                }), [
                    2
                ];
            });
        });
    }, t.prototype.click = function(e, t, n, o) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(r) {
                return $81cb1647619a2ab5$var$Ue("Remote click for connection %s on element %s", e, t), this.emit("controlEvent", {
                    action: "click",
                    elementId: t,
                    uniqueConnectionId: e,
                    x: n,
                    y: o
                }), [
                    2
                ];
            });
        });
    }, t.prototype.dragStart = function(e, t, n, o) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(r) {
                return this.emit("controlEvent", {
                    action: "dragStart",
                    elementId: t,
                    uniqueConnectionId: e,
                    x: n,
                    y: o
                }), [
                    2
                ];
            });
        });
    }, t.prototype.dragEnd = function(e, t, n) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(o) {
                return this.emit("controlEvent", {
                    action: "dragEnd",
                    uniqueConnectionId: e,
                    x: t,
                    y: n
                }), [
                    2
                ];
            });
        });
    }, t.prototype.cursorDown = function(e, t, n, o) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(r) {
                return this.emit("controlEvent", $81cb1647619a2ab5$var$Te({
                    action: "cursorDown",
                    uniqueConnectionId: e,
                    x: t,
                    y: n
                }, o)), [
                    2
                ];
            });
        });
    }, t.prototype.cursorUp = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return this.emit("controlEvent", {
                    action: "cursorUp",
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.type = function(e, t, n) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(o) {
                return this.touchLastActivityAt(), $81cb1647619a2ab5$var$Ue.local("Remote type for connection %s on element %s: %s", e, t, n), this.emit("controlEvent", {
                    action: "type",
                    elementId: t,
                    newValue: n,
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.valueUpdate = function(e, t, n) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(o) {
                return this.touchLastActivityAt(), $81cb1647619a2ab5$var$Ue.local("Remote valueUpdate for connection %s on element %s: %s", e, t, n), this.emit("controlEvent", {
                    action: "valueUpdate",
                    elementId: t,
                    encodedValue: n,
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.mediaControl = function(e, t, n) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(o) {
                return this.touchLastActivityAt(), $81cb1647619a2ab5$var$Ue.local("Media control for connection %s on element %s: %O", e, t, n), this.emit("controlEvent", $81cb1647619a2ab5$var$Te({
                    action: "mediaControl",
                    elementId: t,
                    uniqueConnectionId: e
                }, n)), [
                    2
                ];
            });
        });
    }, t.prototype.askSnapshot = function(e) {
        return $81cb1647619a2ab5$var$je(this, arguments, void 0, function(e, t) {
            return void 0 === t && (t = !1), $81cb1647619a2ab5$var$Re(this, function(n) {
                return $81cb1647619a2ab5$var$Ue("Asking for snapshot, forceAssets: %s", t), this.emit("controlEvent", {
                    action: "sendSnapshot",
                    forceAssets: t,
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.updateSelfAudioStatus = function(e) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(t) {
                return this.emit("viewerUpdate", {
                    audioStatus: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.remoteConsole = function(e, t) {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$Re(this, function(n) {
                return $81cb1647619a2ab5$var$Ue.local("Executing remote command for connection %s (%s)", e, t), this.emit("controlEvent", {
                    action: "console",
                    command: t,
                    uniqueConnectionId: e
                }), [
                    2
                ];
            });
        });
    }, t.prototype.dataBounce = function() {
        return $81cb1647619a2ab5$var$je(this, void 0, void 0, function() {
            var e, t, n, o = this;
            return $81cb1647619a2ab5$var$Re(this, function(r) {
                switch(r.label){
                    case 0:
                        return this.latestConnectionId ? (e = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
                            var t = 16 * Math.random() | 0;
                            return ("x" === e ? t : 3 & t | 8).toString(16);
                        }).toUpperCase(), t = Date.now(), this.emit("dataBounce", e), [
                            4,
                            new Promise(function(n) {
                                o.pruneDataBouncePromiseResolvers(), o.dataBouncePromiseResolvers[e] = {
                                    createdAt: t,
                                    resolve: n
                                };
                            })
                        ]) : [
                            2,
                            0
                        ];
                    case 1:
                        return r.sent(), (n = Date.now() - t) > 2e3 && Date.now() - this.lastSlowBounceLogAt > 2e4 && (this.lastSlowBounceLogAt = Date.now(), this.emit("debugLog", {
                            ms: n,
                            type: "slow_data_bounce"
                        })), [
                            2,
                            n
                        ];
                }
            });
        });
    }, t.prototype.onServerDataBounce = function(e) {
        this._fire("dataBounce", e);
    }, t.prototype.touchLastActivityAt = function() {
        this.lastActivityAt = new Date;
    }, t.prototype.startIdleDisconnectWatcher = function() {
        var e = this;
        this.idleDisconnectWatcher || null !== this.idleDisconnectSeconds && ("object" == typeof window.parent && window.parent !== window || (this.idleWarningActive = !1, this.touchLastActivityAt(), document.addEventListener("mousemove", this.touchLastActivityAt.bind(this)), document.addEventListener("scroll", this.touchLastActivityAt.bind(this), !0), window.addEventListener("focus", this.touchLastActivityAt.bind(this)), this.idleDisconnectWatcher = setInterval(function() {
            var t, n;
            if (e.connected) {
                var o = (Date.now() - e.lastActivityAt.getTime()) / 1e3 > .8 * e.idleDisconnectSeconds, r = (Date.now() - e.lastActivityAt.getTime()) / 1e3 > e.idleDisconnectSeconds;
                e.disconnectingDueToInactivity = r, r ? (e._fire("agentIdleness", "disconnected"), e.endSession(), null === (t = e.socket) || void 0 === t || t.close(), null === (n = e.socketCloseHandler) || void 0 === n || n.call(e), e.idleWarningActive = !0, $81cb1647619a2ab5$var$Ue("Disconnecting from server due to inactivity")) : o && !e.idleWarningActive ? (e.idleWarningActive = !0, $81cb1647619a2ab5$var$Ue("Disconnecting soon due to inactivity"), e._fire("agentIdleness", "willDisconnect")) : !o && e.idleWarningActive && ($81cb1647619a2ab5$var$Ue("Agent is now active"), e._fire("agentIdleness", "active"), e.idleWarningActive = !1);
            }
        }, 1e3)));
    }, t;
}($81cb1647619a2ab5$var$Se), $81cb1647619a2ab5$var$He = $81cb1647619a2ab5$var$ce("viewer:screenLock");
var $81cb1647619a2ab5$var$qe = function() {
    return $81cb1647619a2ab5$var$qe = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $81cb1647619a2ab5$var$qe.apply(this, arguments);
}, $81cb1647619a2ab5$var$We = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$Qe = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$Ye = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$Ze = function(e, t, n) {
    if (n || 2 === arguments.length) for(var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
    return e.concat(o || Array.prototype.slice.call(t));
}, $81cb1647619a2ab5$var$Ke = $81cb1647619a2ab5$var$ce("viewer:main"), $81cb1647619a2ab5$var$Je = $81cb1647619a2ab5$var$ce("viewer:screenStreamer"), $81cb1647619a2ab5$export$9799878dee66ae0f = (0, $acw62.createContext)({
    activeConnectionId: void 0,
    agentIdleness: "active",
    availableModes: [],
    changeMode: function(e) {},
    connected: !1,
    connecting: !1,
    connections: [],
    connectionsLastLoadCompletedAt: {},
    consoleLogs: {},
    dataBounceSpeed: 0,
    endSession: void 0,
    errorHandler: void 0,
    expectedDisconnectInfo: void 0,
    forceRefresh: void 0,
    latestActiveConnectionId: void 0,
    loadingStagesLeft: [],
    mode: void 0,
    noContentUnknownIframesPresent: [],
    permissions: void 0,
    sendCustomMessage: function(e) {},
    serverConnection: void 0,
    session: void 0,
    setActiveConnectionId: function(e) {},
    setConnectionsLastLoadCompletedAt: function(e) {},
    setConsoleLogs: function(e) {},
    setErrorHandler: function(e) {},
    setLoadingStagesLeft: function(e) {},
    setNoContentUnknownIframesPresent: function(e) {},
    setSizes: function(e) {},
    setWaitingForceRefresh: function(e) {},
    sizes: {},
    videoAudioRelationship: void 0,
    videoCodecFamilies: function() {
        return [];
    },
    videoEnabled: void 0,
    viewerConnectionId: void 0,
    viewers: [],
    viewersCount: 0,
    visitor: void 0,
    waitingForceRefresh: !1
});
function $81cb1647619a2ab5$export$ebb76798b919a705(e) {
    var t = (0, $acw62.useContext)($81cb1647619a2ab5$export$9799878dee66ae0f), n = t.connections, o = t.consoleLogs, r = t.errorHandler, a = t.latestActiveConnectionId, c = t.noContentUnknownIframesPresent, s = t.permissions, u = t.serverConnection, d = t.session, f = t.sizes, h = null != e ? e : a, v = n.find(function(e) {
        return e.uniqueConnectionId === h;
    }), p = (0, $acw62.useCallback)(function() {
        "granted" !== (null == d ? void 0 : d.control) && (null == r || r("remote_control:inactive")), null == u || u.reload(h);
    }, [
        u,
        h,
        r,
        null == d ? void 0 : d.control
    ]), m = (0, $acw62.useCallback)(function() {
        null == u || u.clearDrawings(h);
    }, [
        u,
        h
    ]), y = (0, $acw62.useCallback)(function() {
        null == u || u.confetti(null);
    }, [
        u
    ]), g = (0, $acw62.useCallback)(function(e) {
        null == u || u.confetti(e);
    }, [
        u
    ]), w = (0, $acw62.useCallback)(function() {
        "granted" !== (null == d ? void 0 : d.control) && (null == r || r("remote_control:inactive")), null == u || u.historyForward(h);
    }, [
        u,
        h,
        r,
        null == d ? void 0 : d.control
    ]), b = (0, $acw62.useCallback)(function() {
        null == u || u.requestFullTab(h);
    }, [
        u,
        h
    ]), A = (0, $acw62.useCallback)(function() {
        null == u || u.stopFullTab(h);
    }, [
        u,
        h
    ]), C = (0, $acw62.useCallback)(function() {
        "granted" !== (null == d ? void 0 : d.control) && (null == r || r("remote_control:inactive")), null == u || u.historyBack(h);
    }, [
        u,
        h,
        r,
        null == d ? void 0 : d.control
    ]), x = (0, $acw62.useCallback)(function(e) {
        if ("granted" !== (null == d ? void 0 : d.control) && (null == r || r("remote_control:inactive")), !e.startsWith("http://") && !e.startsWith("https://")) throw new Error("Invalid URL");
        null == u || u.redirect(h, e);
    }, [
        u,
        h,
        r,
        null == d ? void 0 : d.control
    ]), S = (0, $acw62.useCallback)(function(e) {
        "granted" !== (null == d ? void 0 : d.control) && (null == r || r("remote_control:inactive")), null == u || u.remoteConsole(h, e);
    }, [
        u,
        h,
        r,
        null == d ? void 0 : d.control
    ]), E = (0, $acw62.useCallback)(function() {
        null == u || u.requestControl();
    }, [
        u
    ]), I = (0, $acw62.useCallback)(function() {
        null == u || u.relinquishControl();
    }, [
        u
    ]);
    return h ? {
        clearDrawings: "visitor_browser" === (null == d ? void 0 : d.mode) || "visitor_app" === (null == d ? void 0 : d.mode) ? m : void 0,
        confetti: "visitor_browser" === (null == d ? void 0 : d.mode) || "visitor_app" === (null == d ? void 0 : d.mode) ? y : void 0,
        consoleLogs: "visitor_browser" === (null == d ? void 0 : d.mode) && o[h] || [],
        currentUrl: "visitor_browser" === (null == d ? void 0 : d.mode) || "visitor_app" === (null == d ? void 0 : d.mode) ? null == v ? void 0 : v.currentUrl : null,
        emojiConfetti: "visitor_browser" === (null == d ? void 0 : d.mode) || "visitor_app" === (null == d ? void 0 : d.mode) ? g : void 0,
        historyBack: "visitor_browser" === (null == d ? void 0 : d.mode) && (null == v ? void 0 : v.allowAgentRedirect) ? C : void 0,
        historyForward: "visitor_browser" === (null == d ? void 0 : d.mode) && (null == v ? void 0 : v.allowAgentRedirect) ? w : void 0,
        relinquishControl: "visitor_browser" !== (null == d ? void 0 : d.mode) && "visitor_app" !== (null == d ? void 0 : d.mode) || !(null == v ? void 0 : v.requireControlRequest) || "off" === d.control ? void 0 : I,
        reloadPage: "visitor_browser" === (null == d ? void 0 : d.mode) && (null == v ? void 0 : v.allowAgentRedirect) ? p : void 0,
        requestControl: ("visitor_browser" === (null == d ? void 0 : d.mode) || "visitor_app" === (null == d ? void 0 : d.mode)) && (null == v ? void 0 : v.requireControlRequest) && (null == s ? void 0 : s.allowRequestControl) && "off" === d.control ? E : void 0,
        requestFullTab: "visitor_browser" === (null == d ? void 0 : d.mode) && (null == v ? void 0 : v.allowRequestFullTab) && "off" === v.fullTabStatus && c.includes(h) ? b : void 0,
        runConsoleCommand: "visitor_browser" === (null == d ? void 0 : d.mode) && (null == v ? void 0 : v.allowRemoteConsole) ? S : void 0,
        setCurrentUrl: "visitor_browser" === (null == d ? void 0 : d.mode) && (null == v ? void 0 : v.allowAgentRedirect) ? x : void 0,
        size: (null == d ? void 0 : d.mode.startsWith("viewer_screen:")) ? f.viewer_screen : (null == d ? void 0 : d.mode.startsWith("visitor_screen:")) ? f.visitor_screen : f[h],
        stopFullTab: "visitor_browser" === (null == d ? void 0 : d.mode) && (null == v ? void 0 : v.allowRequestFullTab) && "off" !== v.fullTabStatus ? A : void 0
    } : {};
}
function $81cb1647619a2ab5$export$8de61b3b61884207() {
    var e, t, n = (0, $acw62.useContext)($81cb1647619a2ab5$export$9799878dee66ae0f), o = (0, $acw62.useMemo)(function() {
        if (n.serverConnection) return n.serverConnection.on.bind(n.serverConnection);
    }, [
        n.serverConnection
    ]);
    return {
        agentIdleness: n.agentIdleness,
        availableModes: n.availableModes,
        changeMode: n.changeMode,
        connected: n.connected,
        connecting: n.connecting,
        connections: n.connections,
        controlStatus: null === (e = n.session) || void 0 === e ? void 0 : e.control,
        dataBounceSpeed: n.dataBounceSpeed,
        endSession: n.session ? n.endSession : void 0,
        expectedDisconnectInfo: n.expectedDisconnectInfo,
        forceRefresh: n.forceRefresh,
        latestActiveConnectionId: n.latestActiveConnectionId,
        listen: o,
        loadingStagesLeft: n.loadingStagesLeft,
        mode: n.mode,
        sendCustomMessage: n.sendCustomMessage,
        sessionStatus: null === (t = n.session) || void 0 === t ? void 0 : t.status,
        setErrorHandler: n.setErrorHandler,
        videoAudioRelationship: n.videoAudioRelationship,
        videoEnabled: n.videoEnabled,
        viewers: n.viewers,
        viewersCount: n.viewersCount,
        visitor: n.visitor,
        waitingForceRefresh: n.waitingForceRefresh
    };
}
function $81cb1647619a2ab5$var$tt(e, t, n) {
    var r = (0, $acw62.useRef)(n);
    (0, $acw62.useEffect)(function() {
        r.current = n;
    }, [
        n
    ]);
    var i = $81cb1647619a2ab5$var$Ze($81cb1647619a2ab5$var$Ze([], $81cb1647619a2ab5$var$Ye(e.map(function(e) {
        return e.uniqueConnectionId;
    })), !1), $81cb1647619a2ab5$var$Ye(t.map(function(e) {
        return e.connectionId;
    })), !1).join(","), a = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        var e = i ? i.split(",") : [];
        e.some(function(e) {
            return !a.current.includes(e);
        }) && r.current(), a.current = e;
    }, [
        i
    ]);
}
function $81cb1647619a2ab5$export$4763f1e07d062006(t) {
    var n, r, i, u = this, d = t.children, f = t.endpoint, m = t.idleDisconnectSeconds, y = t.region, g = t.shortId, w = t.token, b = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(void 0), 2), A = b[0], C = b[1], x = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)([]), 2), S = x[0], E = x[1], I = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(void 0), 2), k = I[0], D = I[1], z = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(), 2), M = z[0], B = z[1], L = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)([]), 2), F = L[0], P = L[1], V = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(0), 2), T = V[0], j = V[1], R = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(void 0), 2), X = R[0], N = R[1], U = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(!1), 2), G = U[0], H = U[1], q = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(!1), 2), W = q[0], Q = q[1], Y = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(), 2), Z = Y[0], K = Y[1], J = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)({}), 2), _ = J[0], $ = J[1], ee = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)([]), 2), te = ee[0], ne = ee[1], oe = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(void 0), 2), ie = oe[0], ae = oe[1], ce = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(void 0), 2), se = ce[0], le = ce[1], ue = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(void 0), 2), de = ue[0], fe = ue[1], he = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(void 0), 2), ve = he[0], pe = he[1], me = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)([
        "connect",
        "accept",
        "firstFrame",
        "load"
    ]), 2), ye = me[0], ge = me[1], we = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)([]), 2), be = we[0], Ae = we[1], Ce = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)({}), 2), xe = Ce[0], Se = Ce[1], Ee = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(), 2), Ie = Ee[0], ke = Ee[1], Oe = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)("active"), 2), De = Oe[0], ze = Oe[1], Me = (0, $9364d06eb3906683$export$509bc8842db77379)("upscope:viewer-token:".concat(g)), Be = Me.set, Le = Me.value, Fe = (0, $9364d06eb3906683$export$509bc8842db77379)("upscope:viewer-token:".concat(g, ":original")), Pe = Fe.set, Ve = Fe.value, Te = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(!1), 2), je = Te[0], Re = Te[1], Xe = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(), 2), Ne = Xe[0], Ue = Xe[1], $e = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(void 0), 2), et = $e[0], nt = $e[1], ot = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(!1), 2), rt = ot[0], it = ot[1], at = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)(void 0), 2), ct = at[0], st = at[1], lt = (0, $acw62.useRef)(void 0);
    (0, $acw62.useEffect)(function() {
        lt.current = ie;
    }, [
        ie
    ]);
    var ut = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        ut.current = $81cb1647619a2ab5$var$Ze($81cb1647619a2ab5$var$Ze([], $81cb1647619a2ab5$var$Ye(S.filter(function(e) {
            return "active" === e.status;
        })), !1), $81cb1647619a2ab5$var$Ye(F.filter(function(e) {
            return e.connectionId !== Ne;
        })), !1);
    }, [
        S,
        F,
        Ne
    ]);
    var dt = (0, $acw62.useCallback)(function() {
        return function(e) {
            return 0 === e.length ? [] : $81cb1647619a2ab5$var$O.filter(function(t) {
                return e.every(function(e) {
                    var n;
                    return !0 === (null === (n = e.videoDecoders) || void 0 === n ? void 0 : n.includes(t));
                });
            });
        }(ut.current);
    }, []), ft = (0, $acw62.useCallback)(function() {
        var e;
        null === (e = lt.current) || void 0 === e || e.requestKeyframe();
    }, []);
    $81cb1647619a2ab5$var$tt(S, F, ft);
    var ht = (0, $acw62.useRef)(Z);
    (0, $acw62.useEffect)(function() {
        ht.current = Z;
    }, [
        Z
    ]);
    var vt = (0, $acw62.useRef)(Le);
    (0, $acw62.useEffect)(function() {
        vt.current = Le;
    }, [
        Le
    ]);
    var pt = (0, $acw62.useRef)(Be);
    (0, $acw62.useEffect)(function() {
        pt.current = Be;
    }, [
        Be
    ]), (0, $acw62.useEffect)(function() {
        w && Ve !== w && (Pe(w), pt.current(w)), Re(!0);
    }, [
        Ve,
        w,
        Pe
    ]);
    var mt = $81cb1647619a2ab5$var$Ye((0, $acw62.useState)({}), 2), yt = mt[0], gt = mt[1], wt = S.map(function(e) {
        return [
            e,
            new Date(Math.max.apply(Math, $81cb1647619a2ab5$var$Ze([
                0
            ], $81cb1647619a2ab5$var$Ye([
                e.lastMouseMovementAt,
                e.lastFocusAt
            ].filter(Boolean).map(function(e) {
                return e.getTime();
            })), !1)))
        ];
    }), bt = ct ? wt.filter(function(e) {
        return $81cb1647619a2ab5$var$Ye(e, 2)[1].getTime() > ct[1].ts;
    }) : wt, At = (null === (n = bt.filter(function(e) {
        return "active" === $81cb1647619a2ab5$var$Ye(e, 1)[0].status;
    }).sort(function(e, t) {
        var n = $81cb1647619a2ab5$var$Ye(e, 2)[1];
        return $81cb1647619a2ab5$var$Ye(t, 2)[1].getTime() - n.getTime();
    })[0]) || void 0 === n ? void 0 : n[0].uniqueConnectionId) || (null === (r = bt[0]) || void 0 === r ? void 0 : r[0].uniqueConnectionId);
    (0, $4d7918fb3900970c$export$4ea291cd4ec501ea)(function() {
        st(void 0);
    }, "number" == typeof (null === (i = null == ct ? void 0 : ct[1]) || void 0 === i ? void 0 : i.returnTimeSeconds) ? 1e3 * ct[1].returnTimeSeconds : void 0);
    var Ct = At || null == ct ? void 0 : ct[1];
    (0, $063d99a411e6854f$export$44b55d93c84df466)(function() {
        nt(At);
    }, [
        At
    ], 1500, 3e3), (0, $acw62.useEffect)(function() {
        var e;
        if ("wakeLock" in navigator) return navigator.wakeLock.request("screen").then(function(t) {
            e = t, $81cb1647619a2ab5$var$He("Screen wake lock acquired");
        }).catch(function(e) {
            $81cb1647619a2ab5$var$He("Error acquiring wake lock %O", e);
        }), function() {
            e && (e.release(), $81cb1647619a2ab5$var$He("Screen wake lock released"));
        };
    }, []), (0, $acw62.useEffect)(function() {
        S.find(function(e) {
            return e.uniqueConnectionId === et;
        }) || nt(At);
    }, [
        At,
        et,
        S
    ]), (0, $acw62.useEffect)(function() {
        st(function(e) {
            var t = S.find(function(e) {
                return e.expectedDisconnect;
            });
            return t ? [
                t.uniqueConnectionId,
                t.expectedDisconnect
            ] : e;
        });
    }, [
        S
    ]), (0, $acw62.useEffect)(function() {
        if (X && ie) {
            var e = function(e) {
                return "web" === X.sdk ? 1 : e.screenScale;
            }, t = Math.max.apply(Math, $81cb1647619a2ab5$var$Ze([], $81cb1647619a2ab5$var$Ye(S.map(function(t) {
                return t.screenWidth * e(t);
            })), !1)), n = Math.max.apply(Math, $81cb1647619a2ab5$var$Ze([], $81cb1647619a2ab5$var$Ye(S.map(function(t) {
                return t.screenHeight * e(t);
            })), !1));
            "web" === X.sdk ? (lt.current.viewerWidth = t, lt.current.viewerHeight = n) : (lt.current.viewerWidth = Math.max(t, n), lt.current.viewerHeight = Math.max(t, n));
        }
    }, [
        S,
        X,
        ie
    ]), (0, $acw62.useEffect)(function() {
        if (je) {
            var e = new $81cb1647619a2ab5$var$Ge(vt.current, g, y, m, f);
            return C(e), e.on("connected", function(e) {
                N($81cb1647619a2ab5$var$qe($81cb1647619a2ab5$var$qe({}, e.visitor), {
                    _expireAt: e.visitor._expireAt ? new Date(e.visitor._expireAt) : void 0,
                    addedAt: new Date(e.visitor.addedAt),
                    callNameSetAt: e.visitor.callNameSetAt ? new Date(e.visitor.callNameSetAt) : null,
                    lastSeenAt: new Date(e.visitor.lastSeenAt)
                })), E(e.activeConnections.map(function(e) {
                    return $81cb1647619a2ab5$var$qe($81cb1647619a2ab5$var$qe({}, e), {
                        lastFocusAt: e.lastFocusAt ? new Date(e.lastFocusAt) : null
                    });
                })), D(e.session), B(e.permissions), Q(!1), H(!0), ge([
                    e.activeConnections.some(function(e) {
                        return e.requireAuthorizationForSession;
                    }) && "accept",
                    "firstFrame",
                    "load"
                ].filter(Boolean));
            }).on("sessionUpdate", function(e) {
                D(function(t) {
                    return t && $81cb1647619a2ab5$var$qe($81cb1647619a2ab5$var$qe({}, t), e);
                });
            }).on("connecting", function() {
                Q(!0);
            }).on("disconnected", function() {
                H(!1), Q(!1);
            }).on("error", function(e) {
                var t, n = $81cb1647619a2ab5$var$Ye(e, 2), o = n[0], r = n[1];
                null === (t = ht.current) || void 0 === t || t.call(ht, o, r);
            }).on("newJwt", function(e) {
                pt.current(e);
            }).on("viewerConnectionId", function(e) {
                Ue(e);
            }).on("viewersCount", function(e) {
                var t = $81cb1647619a2ab5$var$Ye(e, 1)[0];
                j(t);
            }).on("newViewer", function(e) {
                var t = $81cb1647619a2ab5$var$Ye(e, 2)[1];
                P(function(e) {
                    return $81cb1647619a2ab5$var$Ze($81cb1647619a2ab5$var$Ze([], $81cb1647619a2ab5$var$Ye(e), !1), [
                        t
                    ], !1);
                });
            }).on("viewerGone", function(e) {
                var t = $81cb1647619a2ab5$var$Ye(e, 1)[0];
                P(function(e) {
                    return e.filter(function(e) {
                        return e.connectionId !== t;
                    });
                });
            }).on("viewerUpdate", function(e) {
                var t = $81cb1647619a2ab5$var$Ye(e, 2), n = t[0], o = t[1];
                P(function(e) {
                    return e.map(function(e) {
                        return e.connectionId === n ? $81cb1647619a2ab5$var$qe($81cb1647619a2ab5$var$qe({}, e), o) : e;
                    });
                });
            }).on("newConnection", function(e) {
                E(function(t) {
                    return $81cb1647619a2ab5$var$Ze($81cb1647619a2ab5$var$Ze([], $81cb1647619a2ab5$var$Ye(t.filter(function(t) {
                        return t.uniqueConnectionId !== e.uniqueConnectionId;
                    })), !1), [
                        $81cb1647619a2ab5$var$qe($81cb1647619a2ab5$var$qe({}, e), {
                            lastFocusAt: e.lastFocusAt ? new Date(e.lastFocusAt) : null
                        })
                    ], !1);
                });
            }).on("connectionUpdate", function(e) {
                var t = $81cb1647619a2ab5$var$qe({}, e);
                e.lastFocusAt && (t.lastFocusAt = new Date(e.lastFocusAt)), E(function(n) {
                    return n.map(function(n) {
                        return n.uniqueConnectionId === e.uniqueConnectionId ? $81cb1647619a2ab5$var$qe($81cb1647619a2ab5$var$qe({}, n), t) : n;
                    });
                });
            }).on("browserEvent", function(e) {
                "mouseMove" === e.type && E(function(t) {
                    return t.map(function(t) {
                        return t.uniqueConnectionId === e.uniqueConnectionId ? $81cb1647619a2ab5$var$qe($81cb1647619a2ab5$var$qe({}, t), {
                            lastMouseMovementAt: new Date
                        }) : t;
                    });
                });
            }).on("connectionRemoved", function(e) {
                E(function(t) {
                    return t.filter(function(t) {
                        return t.uniqueConnectionId !== e;
                    });
                });
            }).on("sessionTerminated", function() {
                D(void 0);
            }).on("visitorUpdate", function(e) {
                var t = $81cb1647619a2ab5$var$qe({}, e);
                e.addedAt && (t.addedAt = new Date(e.addedAt)), e.lastSeenAt && (t.lastSeenAt = new Date(e.lastSeenAt)), N(function(e) {
                    return e && $81cb1647619a2ab5$var$qe($81cb1647619a2ab5$var$qe({}, e), t);
                });
            }).on("agentIdleness", function(e) {
                ze(e);
            }).on("requestKeyframe", function(e) {
                var t;
                "screen" === e && (null === (t = lt.current) || void 0 === t || t.requestKeyframe());
            }), function() {
                var t;
                e.shutdown(), pt.current(void 0), C(void 0), null === (t = lt.current) || void 0 === t || t.stop();
            };
        }
    }, [
        je,
        y,
        g,
        m,
        f
    ]);
    var xt = (0, $acw62.useCallback)(function() {
        null == A || A.endSession(), D(void 0);
    }, [
        A
    ]), St = (0, $acw62.useCallback)(function(e) {
        null == A || A.sendCustomMessage(e);
    }, [
        A
    ]), Et = "active" === (null == k ? void 0 : k.status);
    (0, $acw62.useEffect)(function() {
        if (A && Et && G) {
            var e = setInterval(function() {
                A.dataBounce().then(function(e) {
                    ne(function(t) {
                        return $81cb1647619a2ab5$var$Ze($81cb1647619a2ab5$var$Ze([], $81cb1647619a2ab5$var$Ye(t), !1), [
                            e
                        ], !1).slice(-10);
                    });
                });
            }, 1e3);
            return function() {
                clearInterval(e);
            };
        }
    }, [
        A,
        Et,
        G
    ]);
    var It = (0, $acw62.useCallback)(function() {
        Et && it(!0);
    }, [
        Et
    ]);
    (0, $acw62.useEffect)(function() {
        var e = S.find(function(e) {
            return e.uniqueConnectionId === Ie;
        });
        e && (fe(e.cobrowsingVideoEnabled), pe(e.cobrowsingVideoAudioRelationship));
    }, [
        S,
        Ie
    ]), (0, $acw62.useEffect)(function() {
        "active" === (null == k ? void 0 : k.status) && ge(function(e) {
            return e.filter(function(e) {
                return "accept" !== e;
            });
        });
    }, [
        k
    ]);
    var kt = Ie ? xe[Ie] : void 0;
    (0, $acw62.useEffect)(function() {
        kt && (ge(function(e) {
            return e.filter(function(e) {
                return "load" !== e;
            });
        }), it(!1), null == A || A.reportContentVisible());
    }, [
        kt,
        A
    ]);
    var Ot = Math.round(te.reduce(function(e, t) {
        return e + t;
    }, 0) / Math.max(te.length, 1));
    (0, $acw62.useEffect)(function() {
        ie && (Ot < 50 ? ie.meter.increaseBitrate() : Ot > 300 && ie.meter.decreaseBitrate());
    }, [
        Ot,
        ie
    ]);
    var Dt = (0, $acw62.useCallback)(function(e) {
        K(function() {
            return e;
        });
    }, []), zt = (0, $acw62.useMemo)(function() {
        return X ? "web" === X.sdk ? [
            "visitor_browser",
            X.fullScreenSupported ? "visitor_screen" : null,
            (null == M ? void 0 : M.allowShowViewerScreen) && $81cb1647619a2ab5$var$re.available() ? "own_viewer_screen" : null
        ].filter(Boolean) : (X.sdk, [
            "visitor_app",
            X.fullScreenSupported ? "visitor_screen" : null,
            (null == M ? void 0 : M.allowShowViewerScreen) && $81cb1647619a2ab5$var$re.available() ? "own_viewer_screen" : null
        ].filter(Boolean)) : [];
    }, [
        X,
        M
    ]), Mt = (0, $acw62.useCallback)(function() {
        return $81cb1647619a2ab5$var$We(u, void 0, void 0, function() {
            var e, t;
            return $81cb1647619a2ab5$var$Qe(this, function(n) {
                switch(n.label){
                    case 0:
                        return ie ? [
                            2
                        ] : ($81cb1647619a2ab5$var$Ke("Setting up screen streamer"), e = new $81cb1647619a2ab5$var$re("frame", function(e, t) {
                            null == A || A.sendAgentFrame(e, t);
                        }, function() {
                            null == A || A.fullScreenEnd(), $81cb1647619a2ab5$var$Ke("Screen streamer stopped, telling server");
                        }, function(e) {
                            for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                            $81cb1647619a2ab5$var$Je.apply(void 0, $81cb1647619a2ab5$var$Ze([
                                e
                            ], $81cb1647619a2ab5$var$Ye(t), !1));
                        }), A && (e.setBacklogSource(function() {
                            return A.socketBacklogBytes();
                        }), e.enableVideo({
                            allowedFamilies: dt,
                            backlogBytes: function() {
                                return A.socketBacklogBytes();
                            },
                            debug: function(e) {
                                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                                $81cb1647619a2ab5$var$Je.apply(void 0, $81cb1647619a2ab5$var$Ze([
                                    e
                                ], $81cb1647619a2ab5$var$Ye(t), !1));
                            },
                            onChunk: function(e) {
                                A.sendAgentVideo(e);
                            },
                            onFallback: function(e) {
                                $81cb1647619a2ab5$var$Je("Screen video unavailable for the rest of the share, using JPEG frames: %s", e);
                            },
                            transportReady: function() {
                                return A.screenVideoTransportReady();
                            }
                        })), $81cb1647619a2ab5$var$Ke("Screen streamer ready, requesting screen"), [
                            4,
                            e.request()
                        ]);
                    case 1:
                        return t = n.sent(), $81cb1647619a2ab5$var$Ke(t ? "Screen streamer approved" : "Screen streamer denied"), t ? ae(e) : null == A || A.fullScreenEnd(), [
                            2
                        ];
                }
            });
        });
    }, [
        ie,
        A,
        dt
    ]), Bt = [
        "viewer_screen:*",
        "viewer_screen:".concat(Ne)
    ].includes(null == k ? void 0 : k.desiredMode);
    (0, $acw62.useEffect)(function() {
        ie && !Bt ? (ie.stop(), ae(void 0), $81cb1647619a2ab5$var$Ke("Stopping screen streamer")) : !ie && Bt && Mt();
    }, [
        ie,
        k,
        A,
        zt,
        Mt
    ]), (0, $acw62.useEffect)(function() {
        var e;
        k && ("visitor_app" === k.desiredMode || "visitor_browser" === k.desiredMode ? e = k.desiredMode : k.desiredMode.startsWith("visitor_screen:") ? e = "visitor_screen" : "viewer_screen:*" === k.desiredMode || k.desiredMode === "viewer_screen:".concat(Ne) ? e = "own_viewer_screen" : (k.desiredMode, e = "other_viewer_screen"), le(e), $81cb1647619a2ab5$var$Ke("Session desired mode is now %s (%s), actual mode is %s", null == k ? void 0 : k.desiredMode, e, null == k ? void 0 : k.mode));
    }, [
        k
    ]), (0, $acw62.useEffect)(function() {
        if ("active" === (null == k ? void 0 : k.status) && se) switch(se){
            case "other_viewer_screen":
            case "own_viewer_screen":
                return void ge([]);
            case "visitor_app":
            case "visitor_browser":
            case "visitor_screen":
                return void ge([
                    "firstFrame",
                    "load"
                ]);
        }
    }, [
        se,
        null == k ? void 0 : k.status
    ]);
    var Lt = (0, $acw62.useCallback)(function(e) {
        if ((null == k ? void 0 : k.desiredMode) !== e) {
            var t = {
                own_viewer_screen: "viewer_screen:".concat(Ne),
                visitor_app: "visitor_app",
                visitor_browser: "visitor_browser",
                visitor_screen: "visitor_screen:*"
            }[e];
            $81cb1647619a2ab5$var$Ke("Switching mode to %s (%s)", e, t), null == A || A.requestMode(t);
        }
    }, [
        A,
        k,
        Ne
    ]), Ft = (0, $acw62.useMemo)(function() {
        return {
            activeConnectionId: Ie,
            agentIdleness: De,
            availableModes: zt,
            changeMode: Lt,
            connected: G,
            connecting: W,
            connections: S,
            connectionsLastLoadCompletedAt: xe,
            consoleLogs: _,
            dataBounceSpeed: Ot,
            endSession: xt,
            errorHandler: Z,
            expectedDisconnectInfo: Ct,
            forceRefresh: Et ? It : void 0,
            latestActiveConnectionId: et,
            loadingStagesLeft: ye,
            mode: se,
            noContentUnknownIframesPresent: be,
            permissions: M,
            sendCustomMessage: St,
            serverConnection: A,
            session: k,
            setActiveConnectionId: ke,
            setConnectionsLastLoadCompletedAt: Se,
            setConsoleLogs: $,
            setErrorHandler: Dt,
            setLoadingStagesLeft: ge,
            setNoContentUnknownIframesPresent: Ae,
            setSizes: gt,
            setWaitingForceRefresh: it,
            sizes: yt,
            videoAudioRelationship: ve,
            videoCodecFamilies: dt,
            videoEnabled: de,
            viewerConnectionId: Ne,
            viewers: F,
            viewersCount: T,
            visitor: X,
            waitingForceRefresh: rt
        };
    }, [
        Ie,
        De,
        zt,
        Lt,
        G,
        W,
        S,
        xe,
        _,
        Ot,
        xt,
        Z,
        Ct,
        It,
        Et,
        et,
        ye,
        se,
        be,
        M,
        St,
        A,
        k,
        ke,
        Se,
        $,
        Dt,
        ge,
        Ae,
        gt,
        it,
        yt,
        ve,
        dt,
        de,
        Ne,
        F,
        T,
        X,
        rt
    ]);
    return (0, $ayMG0.jsx)($81cb1647619a2ab5$export$9799878dee66ae0f.Provider, {
        value: Ft,
        children: d
    });
}
var $81cb1647619a2ab5$var$ot = function() {
    var e = function(t, n) {
        return e = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(e, t) {
            e.__proto__ = t;
        } || function(e, t) {
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }, e(t, n);
    };
    return function(t, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
        function o() {
            this.constructor = t;
        }
        e(t, n), t.prototype = null === n ? Object.create(n) : (o.prototype = n.prototype, new o);
    };
}(), $81cb1647619a2ab5$var$rt = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$it = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$at = function(e) {
    function t(t) {
        var n = e.call(this) || this;
        return n.audioElement = t, n.started = !1, n.observer = {
            audioVideoDidStartConnecting: function() {
                return n._fire("connecting");
            },
            audioVideoDidStart: function() {
                return n._fire("started");
            },
            audioVideoDidStop: function() {
                return n._fire("ended");
            }
        }, n.errorSubscribed = function(e) {
            return n._fire("error", e);
        }, n;
    }
    return $81cb1647619a2ab5$var$ot(t, e), t.prototype.initiate = function(e) {
        var t = new $lWMVu.ConsoleLogger("Upscope Phone Logs", $lWMVu.LogLevel.INFO);
        this.deviceController = new $lWMVu.DefaultDeviceController(t);
        var n = new $lWMVu.MeetingSessionConfiguration(e.meeting, e.attendee);
        this.meetingSession = new $lWMVu.DefaultMeetingSession(n, t, this.deviceController), this.meetingSession.audioVideo.addObserver(this.observer), this.meetingSession.audioVideo.bindAudioElement(this.audioElement), this.meetingSession.audioVideo.start({
            signalingOnly: !0
        }), this.meetingSession.audioVideo.realtimeSubscribeToFatalError(this.errorSubscribed);
    }, t.prototype.selectInputDevice = function(e) {
        return $81cb1647619a2ab5$var$rt(this, void 0, void 0, function() {
            var t, n;
            return $81cb1647619a2ab5$var$it(this, function(o) {
                switch(o.label){
                    case 0:
                        return [
                            4,
                            null === (t = this.meetingSession) || void 0 === t ? void 0 : t.audioVideo.startAudioInput(e)
                        ];
                    case 1:
                        return o.sent(), this.started || (null === (n = this.meetingSession) || void 0 === n || n.audioVideo.start(), this.started = !0), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.selectOutputDevice = function(e) {
        var t;
        "function" == typeof this.audioElement.setSinkId ? this.audioElement.setSinkId(e) : null === (t = this.meetingSession) || void 0 === t || t.audioVideo.chooseAudioOutput(e);
    }, t.prototype.mute = function() {
        var e;
        null === (e = this.meetingSession) || void 0 === e || e.audioVideo.realtimeMuteLocalAudio();
    }, t.prototype.unmute = function() {
        var e;
        null === (e = this.meetingSession) || void 0 === e || e.audioVideo.realtimeUnmuteLocalAudio();
    }, t.prototype.hangup = function() {
        var e;
        null === (e = this.meetingSession) || void 0 === e || e.audioVideo.stop(), this.started = !1;
    }, t.prototype.destroy = function() {
        return $81cb1647619a2ab5$var$rt(this, void 0, void 0, function() {
            var e, t, n, o, r;
            return $81cb1647619a2ab5$var$it(this, function(i) {
                switch(i.label){
                    case 0:
                        return this.hangup(), [
                            4,
                            null === (e = this.meetingSession) || void 0 === e ? void 0 : e.audioVideo.stopAudioInput()
                        ];
                    case 1:
                        return i.sent(), null === (t = this.meetingSession) || void 0 === t || t.audioVideo.unbindAudioElement(), null === (n = this.meetingSession) || void 0 === n || n.audioVideo.realtimeUnsubscribeToFatalError(this.errorSubscribed), null === (o = this.meetingSession) || void 0 === o || o.audioVideo.removeObserver(this.observer), [
                            4,
                            null === (r = this.deviceController) || void 0 === r ? void 0 : r.destroy()
                        ];
                    case 2:
                        return i.sent(), this.meetingSession = void 0, this.deviceController = void 0, [
                            2
                        ];
                }
            });
        });
    }, t;
}($81cb1647619a2ab5$var$Se), $81cb1647619a2ab5$var$ct = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$st = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$lt = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
};
function $81cb1647619a2ab5$var$ut(e) {
    var t = this, n = e.deviceType, r = e.onAuthorized, i = e.onUnauthorized, a = e.setDevices, c = $81cb1647619a2ab5$var$lt((0, $acw62.useState)(!1), 2), u = c[0], d = c[1], f = (0, $acw62.useCallback)(function() {
        "mediaDevices" in navigator ? navigator.mediaDevices.getUserMedia({
            audio: "audio" === n,
            video: "video" === n
        }).then(function(e) {
            e.getTracks().forEach(function(e) {
                e.stop();
            }), d(!0), r();
        }).catch(function() {
            i();
        }) : i("video" === n ? "no_input" : void 0);
    }, [
        n,
        r,
        i
    ]);
    return (0, $0073305fc8893db5$export$ede2eb47b82c13a2)(f, u ? void 0 : 500), (0, $acw62.useEffect)(function() {
        a(void 0), f();
    }, [
        a,
        f
    ]), (0, $acw62.useEffect)(function() {
        if (u) {
            var e = function() {
                $81cb1647619a2ab5$var$ct(t, void 0, void 0, function() {
                    var e;
                    return $81cb1647619a2ab5$var$st(this, function(t) {
                        switch(t.label){
                            case 0:
                                return "mediaDevices" in navigator ? [
                                    4,
                                    navigator.mediaDevices.enumerateDevices()
                                ] : [
                                    3,
                                    2
                                ];
                            case 1:
                                return e = t.sent(), [
                                    3,
                                    3
                                ];
                            case 2:
                                e = void 0, t.label = 3;
                            case 3:
                                return a(e), [
                                    2
                                ];
                        }
                    });
                });
            };
            return e(), navigator.mediaDevices.addEventListener("devicechange", e), function() {
                navigator.mediaDevices.removeEventListener("devicechange", e);
            };
        }
    }, [
        u,
        a
    ]), null;
}
var $81cb1647619a2ab5$var$dt = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$ft = (0, $acw62.createContext)({
    acceptAudioCall: function() {},
    activeInputDeviceId: void 0,
    activeOutputDeviceId: void 0,
    audioRinging: !1,
    audioState: "off",
    inputDevices: [],
    muted: !1,
    outputDevices: [],
    setInputDevice: function(e) {},
    setMuted: function(e) {},
    setOutputDevice: void 0,
    toggleAudio: void 0,
    viewerAudioAvailable: !1,
    viewerAudioError: void 0,
    visitorAudioAvailable: !1,
    visitorAudioError: void 0,
    visitorAudioStatus: "off"
});
function $81cb1647619a2ab5$export$82270779c4a788ac(r) {
    var u = r.children, d = (0, $acw62.useRef)(null), h = (0, $acw62.useRef)(null), v = (0, $acw62.useContext)($81cb1647619a2ab5$export$9799878dee66ae0f), p = v.serverConnection, m = v.session, y = v.videoAudioRelationship, g = v.visitor, w = $81cb1647619a2ab5$var$dt((0, $acw62.useState)(), 2), A = w[0], C = w[1], x = $81cb1647619a2ab5$var$dt((0, $acw62.useState)(void 0), 2), S = x[0], E = x[1], I = (0, $acw62.useMemo)(function() {
        var e;
        return null !== (e = null == S ? void 0 : S.filter(function(e) {
            return "audioinput" === e.kind;
        })) && void 0 !== e ? e : [];
    }, [
        S
    ]), k = (0, $acw62.useMemo)(function() {
        var e;
        return null !== (e = null == S ? void 0 : S.filter(function(e) {
            return "audiooutput" === e.kind;
        })) && void 0 !== e ? e : [];
    }, [
        S
    ]), O = $81cb1647619a2ab5$var$dt((0, $acw62.useState)(), 2), D = O[0], z = O[1], M = $81cb1647619a2ab5$var$dt((0, $acw62.useState)(void 0), 2), B = M[0], L = M[1], F = $81cb1647619a2ab5$var$dt((0, $acw62.useState)(void 0), 2), P = F[0], V = F[1], T = $81cb1647619a2ab5$var$dt((0, $acw62.useState)(void 0), 2), j = T[0], R = T[1], X = $81cb1647619a2ab5$var$dt((0, $acw62.useState)(void 0), 2), N = X[0], U = X[1], G = $81cb1647619a2ab5$var$dt((0, $acw62.useState)(!1), 2), H = G[0], q = G[1], W = $81cb1647619a2ab5$var$dt((0, $acw62.useState)(!1), 2), Q = W[0], Y = W[1], Z = $81cb1647619a2ab5$var$dt((0, $acw62.useState)(void 0), 2), K = Z[0], J = Z[1], _ = $81cb1647619a2ab5$var$dt((0, $acw62.useState)(!1), 2), $ = _[0], ee = _[1], te = $81cb1647619a2ab5$var$dt((0, $acw62.useState)(), 2), ne = te[0], oe = te[1], re = void 0 === ne && "active" === (null == m ? void 0 : m.audio), ie = (0, $acw62.useCallback)(function(e) {
        var t;
        R(null === (t = I.find(function(t) {
            return t.deviceId === e;
        })) || void 0 === t ? void 0 : t.deviceId);
    }, [
        I
    ]), ae = (0, $acw62.useCallback)(function(e) {
        var t;
        U(null === (t = k.find(function(t) {
            return t.deviceId === e;
        })) || void 0 === t ? void 0 : t.deviceId);
    }, [
        k
    ]), ce = (0, $acw62.useCallback)(function() {
        J(!0);
    }, []), se = (0, $acw62.useCallback)(function() {
        J(!1);
    }, []);
    (0, $acw62.useEffect)(function() {
        var e;
        q("function" == typeof (null === (e = d.current) || void 0 === e ? void 0 : e.setSinkId));
    }, []), (0, $acw62.useEffect)(function() {
        var e, t, n, o, r, i;
        I.some(function(e) {
            return e.deviceId === j;
        }) || R(null !== (t = null === (e = I.find(function(e) {
            return "default" === e.deviceId;
        })) || void 0 === e ? void 0 : e.deviceId) && void 0 !== t ? t : null === (n = I[0]) || void 0 === n ? void 0 : n.deviceId), k.some(function(e) {
            return e.deviceId === N;
        }) || U(null !== (r = null === (o = k.find(function(e) {
            return "default" === e.deviceId;
        })) || void 0 === o ? void 0 : o.deviceId) && void 0 !== r ? r : null === (i = k[0]) || void 0 === i ? void 0 : i.deviceId);
    }, [
        I,
        k,
        j,
        N
    ]), (0, $acw62.useEffect)(function() {
        var e = function(e) {
            var t = $81cb1647619a2ab5$var$dt(e, 2), n = t[0], o = t[1];
            n.startsWith("cobrowsing_viewer_") || L(o);
        }, t = function(e) {
            var t = e.chime;
            z(t);
        };
        return null == p || p.on("audioCallProblem", e).on("chimeTokens", t), function() {
            null == p || p.off("audioCallProblem", e).off("chimeTokens", t);
        };
    }, [
        p
    ]), (0, $acw62.useEffect)(function() {
        "off" === (null == m ? void 0 : m.audio) && z(void 0);
    }, [
        null == m ? void 0 : m.audio
    ]), (0, $acw62.useEffect)(function() {
        "active" === (null == m ? void 0 : m.audio) && L(void 0);
    }, [
        null == m ? void 0 : m.audio
    ]);
    var le = Boolean(S), ue = null == m ? void 0 : m.audio;
    (0, $acw62.useEffect)(function() {
        if (d.current && D && le && "active" === ue) {
            var e = new $81cb1647619a2ab5$var$at(d.current);
            return C(e), e.initiate(D), e.on("error", function(e) {
                $kQ0sT.captureException(e);
            }).on("started", function() {
                Y(!0);
            }), function() {
                e.destroy(), C(void 0), Y(!1);
            };
        }
    }, [
        D,
        le,
        ue
    ]), (0, $acw62.useEffect)(function() {
        $ ? null == A || A.mute() : null == A || A.unmute();
    }, [
        A,
        $
    ]), (0, $acw62.useEffect)(function() {
        j && (null == A || A.selectInputDevice(j)), N && (null == A || A.selectOutputDevice(N));
    }, [
        A,
        j,
        N
    ]), (0, $acw62.useEffect)(function() {
        P && (null == p || p.audioCallProblem(P));
    }, [
        P,
        p
    ]), (0, $acw62.useEffect)(function() {
        "off" === (null == m ? void 0 : m.audio) && oe(void 0);
    }, [
        null == m ? void 0 : m.audio
    ]), (0, $acw62.useEffect)(function() {
        void 0 !== (null == m ? void 0 : m.audio) && ("off" === m.audio ? null == p || p.updateSelfAudioStatus("off") : re ? null == p || p.updateSelfAudioStatus("ringing") : void 0 === K ? null == p || p.updateSelfAudioStatus("authorizing") : K ? Q && (null == p || p.updateSelfAudioStatus("active")) : null == p || p.updateSelfAudioStatus("off"));
    }, [
        p,
        null == m ? void 0 : m.audio,
        re,
        K,
        Q
    ]), (0, $acw62.useEffect)(function() {
        "off" === (null == m ? void 0 : m.audio) && "automatic" === y && "off" !== m.videoViewer && (null == p || p.endViewerVideoCall());
    }, [
        p,
        null == m ? void 0 : m.audio,
        null == m ? void 0 : m.videoViewer,
        y
    ]), (0, $acw62.useEffect)(function() {
        var e = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), t = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (D && void 0 !== K) {
            if (K) {
                if (S) {
                    var n = I.length > 0 || e || t, o = k.length > 0 || e || t;
                    V(n ? o ? void 0 : "no_output" : "no_input");
                }
            } else V("not_authorized");
        }
    }, [
        K,
        I,
        k,
        S,
        D
    ]);
    var de = (0, $acw62.useCallback)(function(e) {
        e ? (null == p || p.beginAudioCall(), oe(!0)) : null == p || p.endAudioCall();
    }, [
        p
    ]), fe = (0, $acw62.useCallback)(function() {
        oe(!0);
    }, []), he = (null == g ? void 0 : g.audioSupported) || !1, ve = "function" == typeof window.RTCDataChannel, pe = (0, $acw62.useMemo)(function() {
        return {
            acceptAudioCall: fe,
            activeInputDeviceId: j,
            activeOutputDeviceId: N,
            audioRinging: re,
            audioState: (null == m ? void 0 : m.audio) || "off",
            inputDevices: I,
            muted: $,
            outputDevices: k,
            setInputDevice: ie,
            setMuted: ee,
            setOutputDevice: H ? ae : void 0,
            toggleAudio: ve && he ? de : void 0,
            viewerAudioAvailable: ve,
            viewerAudioError: P,
            visitorAudioAvailable: he,
            visitorAudioError: B,
            visitorAudioStatus: (null == m ? void 0 : m.visitorAudioStatus) || "off"
        };
    }, [
        fe,
        j,
        N,
        re,
        null == m ? void 0 : m.audio,
        I,
        $,
        k,
        ie,
        ee,
        ae,
        H,
        de,
        ve,
        P,
        he,
        B,
        null == m ? void 0 : m.visitorAudioStatus
    ]);
    return (0, $ayMG0.jsxs)($81cb1647619a2ab5$var$ft.Provider, {
        value: pe,
        children: [
            (0, $1u0KT.createPortal)((0, $ayMG0.jsx)("audio", {
                ref: d
            }, "audio"), document.body),
            (0, $1u0KT.createPortal)((0, $ayMG0.jsx)("audio", {
                loop: !0,
                ref: h,
                src: $81cb1647619a2ab5$var$b
            }), document.body),
            ne && (0, $ayMG0.jsx)($81cb1647619a2ab5$var$ut, {
                deviceType: "audio",
                onAuthorized: ce,
                onUnauthorized: se,
                setDevices: E
            }),
            u
        ]
    });
}
function $81cb1647619a2ab5$export$91047320af7bf70b() {
    return (0, $acw62.useContext)($81cb1647619a2ab5$var$ft);
}
var $81cb1647619a2ab5$var$pt = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$mt = (0, $acw62.createContext)({
    beginVideo: void 0,
    cameraVideo: void 0,
    endVideo: void 0,
    i18n: void 0,
    ownVideoOn: !1,
    reportViewerVideoUnauthorized: function(e) {},
    requestCameraKeyframe: void 0,
    sendVideoCallFrame: void 0,
    setVideoMeter: void 0,
    toggleOwnVideo: void 0,
    videoRequestToVisitor: void 0,
    videoRinging: !1,
    videoViewerState: "off",
    videoVisitorState: "off",
    viewerVideoError: void 0,
    visitorVideoError: void 0
});
function $81cb1647619a2ab5$export$5269023cd97c8c79() {
    return (0, $acw62.useContext)($81cb1647619a2ab5$var$mt);
}
function $81cb1647619a2ab5$export$631ffd47cd58e706(t) {
    var n = t.children, r = t.i18n, u = (0, $acw62.useContext)($81cb1647619a2ab5$export$9799878dee66ae0f), d = u.dataBounceSpeed, f = u.serverConnection, h = u.session;
    u.videoAudioRelationship;
    var v = u.videoCodecFamilies, p = u.videoEnabled, m = u.viewerConnectionId, y = $81cb1647619a2ab5$var$pt((0, $acw62.useState)(void 0), 2), g = y[0], w = y[1], b = $81cb1647619a2ab5$var$pt((0, $acw62.useState)(void 0), 2), A = b[0], C = b[1], x = (null == h ? void 0 : h.videoViewer) === "authorizing:".concat(m) || (null == h ? void 0 : h.videoViewer) === "active:".concat(m), S = (0, $acw62.useCallback)(function(e) {
        C(e || "not_authorized"), null == f || f.endViewerVideoCall();
    }, [
        f
    ]);
    (0, $acw62.useEffect)(function() {
        A && (null == f || f.videoCallProblem(A));
    }, [
        A
    ]);
    var E = (0, $acw62.useCallback)(function() {
        if (p && "disabled" !== p) switch(p){
            case "two_way":
                null == f || f.beginVisitorVideoCall(), null == f || f.beginViewerVideoCall();
                break;
            case "viewer_to_visitor":
                null == f || f.beginViewerVideoCall();
                break;
            case "visitor_to_viewer":
                null == f || f.beginVisitorVideoCall();
        }
    }, [
        p,
        f
    ]), I = (0, $acw62.useCallback)(function() {
        null == f || f.endViewerVideoCall(), null == f || f.endVisitorVideoCall();
    }, [
        f
    ]), k = (0, $acw62.useCallback)(function() {
        "off" === (null == h ? void 0 : h.videoViewer) ? null == f || f.beginViewerVideoCall() : null == f || f.endViewerVideoCall();
    }, [
        f,
        h
    ]), O = (0, $acw62.useCallback)(function(e) {
        null == f || f.sendVideoCallFrame(e);
    }, [
        f
    ]), D = (0, $acw62.useRef)(f);
    (0, $acw62.useEffect)(function() {
        D.current = f;
    }, [
        f
    ]);
    var z = (0, $acw62.useMemo)(function() {
        return {
            allowedFamilies: v,
            backlogBytes: function() {
                var e, t;
                return null !== (t = null === (e = D.current) || void 0 === e ? void 0 : e.socketBacklogBytes()) && void 0 !== t ? t : 0;
            },
            onChunk: function(e) {
                var t;
                null === (t = D.current) || void 0 === t || t.sendCameraVideo(e);
            },
            transportReady: function() {
                var e, t;
                return null !== (t = null === (e = D.current) || void 0 === e ? void 0 : e.screenVideoTransportReady()) && void 0 !== t && t;
            }
        };
    }, [
        v
    ]), M = null == h ? void 0 : h.videoVisitor, B = (0, $acw62.useCallback)(function() {
        if ((null == M ? void 0 : M.startsWith("active:")) || (null == M ? void 0 : M.startsWith("authorizing:"))) {
            var e = M.slice(M.indexOf(":") + 1);
            null == f || f.emit("requestKeyframe", [
                e,
                "camera"
            ]);
        }
    }, [
        f,
        M
    ]), L = (0, $acw62.useCallback)(function() {
        null == f || f.beginVisitorVideoCall();
    }, [
        f
    ]), F = (0, $acw62.useRef)(null), P = (0, $acw62.useCallback)(function(e) {
        F.current = e;
    }, []);
    return (0, $acw62.useEffect)(function() {
        var e = F.current;
        e && (d < 50 ? e.increaseBitrate() : d > 300 && e.decreaseBitrate());
    }, [
        d
    ]), (0, $acw62.useEffect)(function() {
        var e = function(e) {
            var t = $81cb1647619a2ab5$var$pt(e, 2), n = t[0], o = t[1];
            n.startsWith("cobrowsing_viewer_") || w(o);
        };
        return null == f || f.on("videoCallProblem", e), function() {
            null == f || f.off("videoCallProblem", e);
        };
    }, [
        f
    ]), (0, $acw62.useEffect)(function() {
        (null == h ? void 0 : h.videoVisitor.startsWith("active")) && w(void 0);
    }, [
        null == h ? void 0 : h.videoVisitor
    ]), (0, $acw62.useEffect)(function() {
        (null == h ? void 0 : h.videoViewer.startsWith("active")) && C(void 0);
    }, [
        null == h ? void 0 : h.videoViewer
    ]), (0, $ayMG0.jsx)($81cb1647619a2ab5$var$mt.Provider, {
        value: {
            beginVideo: E,
            cameraVideo: z,
            endVideo: I,
            i18n: r,
            ownVideoOn: x,
            reportViewerVideoUnauthorized: S,
            requestCameraKeyframe: B,
            sendVideoCallFrame: O,
            setVideoMeter: P,
            toggleOwnVideo: k,
            videoRequestToVisitor: L,
            videoRinging: "ringing" === (null == h ? void 0 : h.videoViewer),
            videoViewerState: (null == h ? void 0 : h.videoViewer) || "off",
            videoVisitorState: (null == h ? void 0 : h.videoVisitor) || "off",
            viewerVideoError: A,
            visitorVideoError: g
        },
        children: n
    });
}
var $81cb1647619a2ab5$var$wt = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
};
function $81cb1647619a2ab5$export$742905d5f12f43b5(t) {
    var n = t.onAudioRinging, r = t.onVideoRinging, a = $81cb1647619a2ab5$export$91047320af7bf70b(), l = a.acceptAudioCall, u = a.audioRinging, d = a.toggleAudio, h = $81cb1647619a2ab5$export$5269023cd97c8c79().videoRinging, v = (0, $acw62.useContext)($81cb1647619a2ab5$export$9799878dee66ae0f).serverConnection, p = (0, $acw62.useRef)(null), m = (0, $acw62.useRef)(h);
    (0, $acw62.useEffect)(function() {
        m.current = h;
    }, [
        h
    ]);
    var y = $81cb1647619a2ab5$var$wt((0, $acw62.useState)(!1), 2), g = y[0], w = y[1];
    return (0, $acw62.useEffect)(function() {
        u || h || !g || w(!1);
    }, [
        u,
        h,
        g
    ]), (0, $acw62.useEffect)(function() {
        var e, t;
        u || h ? null === (e = p.current) || void 0 === e || e.play() : null === (t = p.current) || void 0 === t || t.pause();
    }, [
        u,
        h
    ]), (0, $acw62.useEffect)(function() {
        if (u && n) return w(!0), n(function(e) {
            e ? (l(), m.current && (null == v || v.acceptVideoCall())) : (null == d || d(!1), m.current && (null == v || v.endViewerVideoCall()));
        });
    }, [
        u,
        n,
        l,
        d,
        v
    ]), (0, $acw62.useEffect)(function() {
        if (h && !u && !g && r) return r(function(e) {
            e ? null == v || v.acceptVideoCall() : null == v || v.endViewerVideoCall();
        });
    }, [
        h,
        u,
        g,
        r,
        v
    ]), (0, $1u0KT.createPortal)((0, $ayMG0.jsx)("audio", {
        loop: !0,
        ref: p,
        src: $81cb1647619a2ab5$var$b
    }), document.body);
}
var $81cb1647619a2ab5$var$At = function() {
    return $81cb1647619a2ab5$var$At = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $81cb1647619a2ab5$var$At.apply(this, arguments);
}, $81cb1647619a2ab5$var$Ct = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$xt = function() {
    function e(e) {
        var t, n, o = this;
        this.options = e, this.waitingForKeyframe = !0, this.lastTimestamp = -1 / 0, this.lastKeyframeRequestAt = -1 / 0, this.closed = !1, this.unsupportedLogged = !1, this.onVisibilityChange = function() {
            o.closed || ("hidden" !== o.doc.visibilityState ? (o.lastKeyframeRequestAt = -1 / 0, o.askForKeyframe()) : o.closeDecoder());
        }, this.pauseWhenHidden = null === (t = e.pauseWhenHidden) || void 0 === t || t, this.doc = null !== (n = e.doc) && void 0 !== n ? n : document, this.pauseWhenHidden && this.doc.addEventListener("visibilitychange", this.onVisibilityChange);
    }
    return e.prototype.now = function() {
        var e, t, n;
        return null !== (n = null === (t = (e = this.options).now) || void 0 === t ? void 0 : t.call(e)) && void 0 !== n ? n : performance.now();
    }, e.prototype.receive = function(e) {
        var t, n, o, r, i = $81cb1647619a2ab5$var$Ct(e, 5), a = i[0], c = i[2], s = i[3], l = i[4];
        if (this.closed) return !1;
        if (!$81cb1647619a2ab5$var$R("decode")) return this.unsupportedLogged || this.options.debug("Screen video decoding is not available, skipping video chunks"), this.unsupportedLogged = !0, !1;
        if (this.pauseWhenHidden && "hidden" === this.doc.visibilityState) return this.closeDecoder(), !1;
        if ("key" === c) {
            var u = (null !== (n = null === (t = this.decoder) || void 0 === t ? void 0 : t.decodeQueueSize) && void 0 !== n ? n : 0) > 15;
            if (("configured" !== (null === (o = this.decoder) || void 0 === o ? void 0 : o.state) || u || null !== a && $81cb1647619a2ab5$var$H(a) !== this.configKey) && (!a || !this.openDecoder(a))) return this.askForKeyframe(), !1;
            this.waitingForKeyframe = !1;
        } else {
            if (this.waitingForKeyframe || "configured" !== (null === (r = this.decoder) || void 0 === r ? void 0 : r.state)) return this.askForKeyframe(), !1;
            if (s <= this.lastTimestamp) return this.options.debug("Screen video chunk %d arrived out of order, waiting for a keyframe", s), this.waitingForKeyframe = !0, this.askForKeyframe(), !1;
            if (this.decoder.decodeQueueSize > 15) return this.options.debug("Screen video decoder is %d chunks behind, waiting for a keyframe", this.decoder.decodeQueueSize), this.waitingForKeyframe = !0, this.askForKeyframe(), !1;
        }
        var d = this.decoder, f = $81cb1647619a2ab5$var$G(function() {
            d.decode(new EncodedVideoChunk({
                data: $81cb1647619a2ab5$var$U(l),
                timestamp: s,
                type: c
            }));
        });
        return f ? (this.options.debug("Screen video chunk could not be decoded: %O", f), this.closeDecoder(), this.askForKeyframe(), !1) : (this.lastTimestamp = s, !0);
    }, e.prototype.close = function() {
        this.closed = !0, this.closeDecoder(), this.doc.removeEventListener("visibilitychange", this.onVisibilityChange);
    }, e.prototype.openDecoder = function(e) {
        var t = this;
        this.closeDecoder();
        var n = new VideoDecoder({
            error: function(e) {
                n === t.decoder && (t.options.debug("Screen video decoder failed: %O", e), t.closeDecoder(), t.askForKeyframe());
            },
            output: function(e) {
                n === t.decoder ? t.options.onFrame(e) : e.close();
            }
        }), o = $81cb1647619a2ab5$var$G(function() {
            n.configure($81cb1647619a2ab5$var$At({
                codec: e.codec,
                codedHeight: e.codedHeight,
                codedWidth: e.codedWidth,
                optimizeForLatency: !0
            }, e.description ? {
                description: $81cb1647619a2ab5$var$U(e.description)
            } : {}));
        });
        return o ? (this.options.debug("Screen video decoder could not be configured for %s: %O", e.codec, o), "closed" !== n.state && n.close(), !1) : (this.decoder = n, this.configKey = $81cb1647619a2ab5$var$H(e), this.lastTimestamp = -1 / 0, !0);
    }, e.prototype.closeDecoder = function() {
        this.decoder && "closed" !== this.decoder.state && this.decoder.close(), this.decoder = void 0, this.configKey = void 0, this.waitingForKeyframe = !0;
    }, e.prototype.askForKeyframe = function() {
        var e = this.now();
        e - this.lastKeyframeRequestAt < 1e3 || (this.lastKeyframeRequestAt = e, this.options.requestKeyframe());
    }, e;
}(), $81cb1647619a2ab5$var$St = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$Et = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
};
function $81cb1647619a2ab5$var$It(e, t) {
    if (e.__masked) return e.style.backgroundImage = "none", void ("VIDEO" === e.tagName && e.removeAttribute("poster"));
    "CANVAS" === e.tagName ? (e.style.backgroundImage = "url(" + t + ")", e.style.backgroundSize = "100% 100%", e.style.backgroundRepeat = "no-repeat", e.style.display || (e.style.display = "block"), !e.style.width && e.width && (e.style.width = "".concat(e.width, "px")), !e.style.height && e.height && (e.style.height = "".concat(e.height, "px"))) : "VIDEO" === e.tagName && (e.poster = t);
}
function $81cb1647619a2ab5$var$kt(e, t) {
    return $81cb1647619a2ab5$var$St(this, void 0, void 0, function() {
        var n, o;
        return $81cb1647619a2ab5$var$Et(this, function(r) {
            return n = $81cb1647619a2ab5$var$Xt(e, t.elementId), o = t.url, n ? (n.__canvasContent = o, $81cb1647619a2ab5$var$It(n, o), [
                2
            ]) : [
                2
            ];
        });
    });
}
var $81cb1647619a2ab5$var$Ot = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$Dt = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$zt = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
};
function $81cb1647619a2ab5$var$Mt(e, t) {
    return $81cb1647619a2ab5$var$Ot(this, void 0, void 0, function() {
        var n;
        return $81cb1647619a2ab5$var$Dt(this, function(o) {
            return (n = $81cb1647619a2ab5$var$Xt(e, t.elementId)) ? (n.__maskedSize = t.size, $81cb1647619a2ab5$var$Bt(n, t.size), [
                2
            ]) : [
                2
            ];
        });
    });
}
function $81cb1647619a2ab5$var$Bt(e, t) {
    var n = $81cb1647619a2ab5$var$zt(t.split("x"), 2), o = n[0], r = n[1];
    e.style.width = "".concat(o, "px"), e.style.height = "".concat(r, "px"), e.style.boxSizing = "border-box", "INPUT" !== e.tagName && "TEXTAREA" !== e.tagName && "SELECT" !== e.tagName && (e.style.opacity = "0.6", e.style.background = "black");
}
var $81cb1647619a2ab5$var$Lt = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$Ft = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $81cb1647619a2ab5$var$Pt = function(e, t, n) {
    if (n || 2 === arguments.length) for(var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
    return e.concat(o || Array.prototype.slice.call(t));
}, $81cb1647619a2ab5$var$Vt = $81cb1647619a2ab5$var$ce("viewer:domUtils"), $81cb1647619a2ab5$var$Tt = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), $81cb1647619a2ab5$var$jt = $81cb1647619a2ab5$var$Tt ? function() {
    var e = [];
    for(var t in HTMLElement.prototype)t.startsWith("on") && e.push(t);
    for(var t in window)t.startsWith("on") && !e.includes(t) && e.push(t);
    return e.sort();
}() : [];
function $81cb1647619a2ab5$var$Rt(e, t, n, o, r, i) {
    var a, c, s, l, u, d, f;
    void 0 === i && (i = !0);
    var h, v, p = e.contentDocument;
    if (!p) throw new Error("iframeNode.contentDocument is null");
    if ("shadowRoot" in o) v = {
        children: o.c,
        shadowRootStyle: o.ss,
        type: "shadowRoot"
    };
    else if ("text" in o) v = {
        content: o.text,
        isCss: o.isCss,
        type: "text"
    };
    else {
        var m = $81cb1647619a2ab5$var$Lt(o.tag.split("#"), 2), y = m[0], g = m[1];
        v = {
            attributes: null !== (d = o.a) && void 0 !== d ? d : {},
            children: $81cb1647619a2ab5$var$cn(o.c),
            id: g,
            iframeContent: o.iframe,
            isLoaded: o.isLoaded,
            isSvg: 1 === o.svg,
            masked: !0 === o.masked,
            name: y,
            remoteControlAllowed: !1 !== o.rc,
            type: "tag"
        };
    }
    if ("tag" === v.type) {
        try {
            h = r || (v.isSvg ? p.createElementNS("http://www.w3.org/2000/svg", v.name) : p.createElement(v.name)), v.isLoaded && (h.__shouldEagerLoad = !0);
        } catch (e) {
            $81cb1647619a2ab5$var$Vt.warning("Error creating element with name %o", v.name);
            var w = v.name.replace(/[^A-Za-z-]/g, "");
            h = v.isSvg ? p.createElementNS("http://www.w3.org/2000/svg", w) : p.createElement(w);
        }
        "LINK" === v.name && "stylesheet" === v.attributes.rel && (h.__loaded = !1, h.addEventListener("load", function() {
            h.__loaded = !0;
        })), "STYLE" === v.name && (h.__loaded = !1, h.addEventListener("load", function() {
            h.__loaded = !0;
        }), (null === (f = e.__currentStylesheetContents) || void 0 === f ? void 0 : f[v.id]) && (h.innerHTML = e.__currentStylesheetContents[v.id])), $81cb1647619a2ab5$var$Ut(t, n, h, v.attributes), [
            "FRAME",
            "IFRAME"
        ].includes(v.name) && (h.__flags = e.__flags, v.iframeContent ? (h.__upscopeViewerIframeContent = v.iframeContent, h.__upscopeViewerIframeContentStatus = "content") : h.__upscopeViewerIframeContentStatus = "no_content:unknown"), h.__elementID = v.id, h.__masked = v.masked, h.__allowRemoteControl = v.remoteControlAllowed, h.setAttribute("upscope-element-id", v.id);
    } else {
        if ("shadowRoot" === v.type) {
            if (i) throw new Error("shadowRoot cannot be root");
            return [
                {
                    isShadowRoot: !0,
                    style: v.shadowRootStyle
                },
                v.children
            ];
        }
        h = p.createTextNode(v.isCss ? $81cb1647619a2ab5$var$on(t, v.content, n) : v.content);
    }
    if (i) {
        if (!("children" in v)) return h;
        for(var b = [
            [
                h,
                v.children
            ]
        ]; b.length > 0;){
            var A = [];
            try {
                for(var C = (a = void 0, $81cb1647619a2ab5$var$Ft(b)), x = C.next(); !x.done; x = C.next()){
                    var S = $81cb1647619a2ab5$var$Lt(x.value, 2), E = S[0], I = S[1];
                    if ("SCRIPT" !== E.nodeName) try {
                        for(var k = (s = void 0, $81cb1647619a2ab5$var$Ft(I)), O = k.next(); !O.done; O = k.next()){
                            var D, z = O.value, M = void 0;
                            if (M = (u = $81cb1647619a2ab5$var$Lt($81cb1647619a2ab5$var$Rt(e, t, n, z, void 0, !1), 2))[0], D = u[1], "isShadowRoot" in M) {
                                var B = M.style;
                                if (M = E.attachShadow({
                                    mode: "open"
                                }), B) {
                                    var L = new p.defaultView.CSSStyleSheet;
                                    L.replace($81cb1647619a2ab5$var$on(t, B, n)), M.adoptedStyleSheets = [
                                        L
                                    ];
                                }
                            } else E.appendChild(M);
                            D && D.length > 0 && A.push([
                                M,
                                D
                            ]);
                        }
                    } catch (e) {
                        s = {
                            error: e
                        };
                    } finally{
                        try {
                            O && !O.done && (l = k.return) && l.call(k);
                        } finally{
                            if (s) throw s.error;
                        }
                    }
                }
            } catch (e) {
                a = {
                    error: e
                };
            } finally{
                try {
                    x && !x.done && (c = C.return) && c.call(C);
                } finally{
                    if (a) throw a.error;
                }
            }
            b = A;
        }
        return h;
    }
    return [
        h,
        "children" in v ? v.children : void 0
    ];
}
function $81cb1647619a2ab5$var$Xt(e, t) {
    if (void 0 === t || !e.contentDocument) return null;
    var n = t.endsWith("-sr");
    n && (t = t.substring(0, t.length - 3));
    var o, r = (e.__elementID ? t.replace(new RegExp("^".concat(e.__elementID, ">")), "") : t).split(">");
    if (1 === r.length) o = e.contentDocument.querySelector('[upscope-element-id="' + String(t) + '"]');
    else for(var i = e.contentDocument, a = e.__elementID ? "".concat(e.__elementID, ">").concat(r.shift()) : r.shift(); o = i.querySelector('[upscope-element-id="' + String(a) + '"]'), 0 !== r.length && o;){
        if (!o.shadowRoot) {
            o = null;
            break;
        }
        i = o.shadowRoot, a = "".concat(a, ">").concat(r.shift());
    }
    if (o) {
        if (n) return o.shadowRoot;
    } else {
        var c = new Error;
        $81cb1647619a2ab5$var$Vt.local("Could not select element %s in iframe %o, error: %o", t, e, c.stack);
    }
    return o;
}
function $81cb1647619a2ab5$var$Nt(e, t) {
    var n = t.endsWith("^") ? "^" : t.endsWith("+") ? "+" : void 0;
    if (!n) return $81cb1647619a2ab5$var$Xt(e, t);
    var o = $81cb1647619a2ab5$var$Xt(e, t.slice(0, -1));
    return o ? "^" === n ? o.childNodes[0] : o.nextSibling : null;
}
function $81cb1647619a2ab5$var$Ut(e, t, n, o) {
    var r, i, a, c, s, l, u, d, f, h, v;
    if ($81cb1647619a2ab5$var$Tt) {
        try {
            for(var p = $81cb1647619a2ab5$var$Ft($81cb1647619a2ab5$var$jt), m = p.next(); !m.done; m = p.next())delete o[m.value];
        } catch (e) {
            r = {
                error: e
            };
        } finally{
            try {
                m && !m.done && (i = p.return) && i.call(p);
            } finally{
                if (r) throw r.error;
            }
        }
        (null === (u = o.href) || void 0 === u ? void 0 : u.trim().startsWith("javascript:")) && delete o.href, (null === (d = o.action) || void 0 === d ? void 0 : d.trim().startsWith("javascript:")) && delete o.action;
    }
    if ("SCRIPT" === n.nodeName.toUpperCase()) delete o.src;
    else if ("LINK" === n.nodeName.toUpperCase()) {
        var y = null !== (h = null === (f = o.rel) || void 0 === f ? void 0 : f.trim().toLowerCase().split(/\s+/)) && void 0 !== h ? h : [];
        y.includes("modulepreload") || y.includes("preload") && "script" === (null === (v = o.as) || void 0 === v ? void 0 : v.trim().toLowerCase()) ? (delete o.href, n.removeAttribute("href")) : void 0 !== o.href && (o.href = $81cb1647619a2ab5$var$ln(e, o.href, void 0 !== o.rel && "stylesheet" === o.rel, $81cb1647619a2ab5$var$Ht(), t)), delete o.integrity, delete o.crossorigin;
    } else if ("IMG" === n.nodeName.toUpperCase() || "SOURCE" === n.nodeName.toUpperCase()) {
        if (void 0 !== o.src && ("IMG" === n.nodeName.toUpperCase() ? (o.src = $81cb1647619a2ab5$var$ln(e, o.src, !1, $81cb1647619a2ab5$var$Ht(), t), o.src.startsWith("blob:") && (delete o.srcset, n.removeAttribute("srcset"))) : o.src = $81cb1647619a2ab5$var$qt(e, o.src)), void 0 !== o.srcset) {
            var g = [], w = function() {
                try {
                    return new RegExp("(?<=\\s\\d+\\w),\\s*");
                } catch (e) {
                    return new RegExp("\\s*");
                }
            }();
            try {
                for(var b = $81cb1647619a2ab5$var$Ft(o.srcset.split(w)), A = b.next(); !A.done; A = b.next()){
                    var C = A.value, x = $81cb1647619a2ab5$var$Lt(C.trim().split(/\s+/), 2), S = x[0], E = x[1];
                    S && g.push($81cb1647619a2ab5$var$ln(e, S, !1, $81cb1647619a2ab5$var$Ht(), t) + (E ? " ".concat(E) : ""));
                }
            } catch (e) {
                a = {
                    error: e
                };
            } finally{
                try {
                    A && !A.done && (c = b.return) && c.call(b);
                } finally{
                    if (a) throw a.error;
                }
            }
            o.srcset = g.join(", ");
        }
        void 0 !== o.loading && n.__shouldEagerLoad && (o.loading = "eager"), n.addEventListener("load", function() {
            n.ownerDocument.defaultView.__lastExpectedScrollAt = Date.now();
        });
    } else "INPUT" === n.nodeName.toUpperCase() && "string" == typeof o.type && "IMAGE" === o.type.toUpperCase() && void 0 !== o.src ? o.src = $81cb1647619a2ab5$var$ln(e, o.src, !1, $81cb1647619a2ab5$var$Ht(), t) : "IMAGE" === n.nodeName.toUpperCase() || "USE" === n.nodeName.toUpperCase() ? void 0 !== o.href ? o.href = $81cb1647619a2ab5$var$ln(e, o.href, !1, $81cb1647619a2ab5$var$Ht(), t) : void 0 !== o["xlink:href"] && (o["xlink:href"] = $81cb1647619a2ab5$var$ln(e, o["xlink:href"], !1, $81cb1647619a2ab5$var$Ht(), t)) : "META" === n.nodeName.toUpperCase() && o["http-equiv"] && [
        "content-security-policy",
        "refresh"
    ].includes(o["http-equiv"].toLowerCase()) ? delete o.content : [
        "FRAME",
        "IFRAME"
    ].includes(n.nodeName.toUpperCase()) && (delete o.src, delete o.srcdoc, delete o.sandbox);
    try {
        for(var I = $81cb1647619a2ab5$var$Ft(Object.keys(o)), k = I.next(); !k.done; k = I.next()){
            var O = k.value, D = void 0;
            try {
                if (O.startsWith("upscope-")) continue;
                D = o[O], "style" === O && (D = $81cb1647619a2ab5$var$on(e, D, t)), "http://www.w3.org/2000/svg" === n.namespaceURI ? O.startsWith("xlink:") ? n.setAttributeNS("http://www.w3.org/1999/xlink", O, D) : O.startsWith("xmlns:") ? n.setAttributeNS("http://www.w3.org/2000/xmlns/", O, D) : O.startsWith("xml:") ? n.setAttributeNS("http://www.w3.org/XML/1998/namespace", O, D) : n.setAttributeNS(null, O, D) : n.setAttribute(O, D);
            } catch (e) {
                $81cb1647619a2ab5$var$Vt.local('Unable to set attribute "%s" to "%s" for element %o', O, D, n);
            }
        }
    } catch (e) {
        s = {
            error: e
        };
    } finally{
        try {
            k && !k.done && (l = I.return) && l.call(I);
        } finally{
            if (s) throw s.error;
        }
    }
    "pointer" !== n.dataset.upscopeRole && "drawing" !== n.dataset.upscopeRole || (n.style.transform = "none"), n.__maskedSize && $81cb1647619a2ab5$var$Bt(n, n.__maskedSize), n.__canvasContent && $81cb1647619a2ab5$var$It(n, n.__canvasContent);
}
function $81cb1647619a2ab5$var$Gt(e) {
    var t, n;
    try {
        for(var o = $81cb1647619a2ab5$var$Ft($81cb1647619a2ab5$var$Pt([], $81cb1647619a2ab5$var$Lt(e.querySelectorAll("iframe,frame")), !1)), r = o.next(); !r.done; r = o.next()){
            var i = r.value, a = "unknown" === i.getAttribute("upscope-iframe-no-content");
            if ("no_content:unknown" !== i.__upscopeViewerIframeContentStatus || a) "no_content:full_tab_image" === i.__upscopeViewerIframeContentStatus ? i.setAttribute("upscope-iframe-no-content", "full_tab_image") : "content" === i.__upscopeViewerIframeContentStatus && i.removeAttribute("upscope-iframe-no-content");
            else {
                i.setAttribute("upscope-iframe-no-content", "unknown");
                var c = i.getBoundingClientRect();
                (c.width < 10 || c.height < 10) && (i.__upscopeViewerIframeIgnorable = !0);
                for(var s = i.parentElement; s && s.scrollWidth === c.width && s.scrollHeight === c.height && 0 !== c.width && 0 !== c.height;)s.setAttribute("upscope-iframe-no-content-unknown-wrapper", "true"), s = s.parentElement;
            }
            if ("no_content:unknown" !== i.__upscopeViewerIframeContentStatus && a) for(var l = i.parentElement; l;)l.removeAttribute("upscope-iframe-no-content-unknown-wrapper"), l = l.parentElement;
        }
    } catch (e) {
        t = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (t) throw t.error;
        }
    }
}
function $81cb1647619a2ab5$var$Ht() {
    var e = Date.now();
    return (3600 * Math.floor(e / 1e3 / 3600)).toString();
}
function $81cb1647619a2ab5$var$qt(e, t) {
    if (!e) return t;
    try {
        return new URL(t, e).href;
    } catch (n) {
        return $81cb1647619a2ab5$var$Vt.warning("Unable to find absolute URL for %s with base url %s", t, e), t;
    }
}
var $81cb1647619a2ab5$var$Wt = {};
function $81cb1647619a2ab5$var$Qt(e, t) {
    if ($81cb1647619a2ab5$var$Zt(e) || $81cb1647619a2ab5$var$$t(e)) return $81cb1647619a2ab5$var$an(e);
    for(var n = e, o = n.parentNode; n;){
        if ($81cb1647619a2ab5$var$Zt(n)) return $81cb1647619a2ab5$var$Qt(n) ? "".concat($81cb1647619a2ab5$var$Qt(n), "+") : null;
        n = n.previousSibling;
    }
    var r = $81cb1647619a2ab5$var$an(o);
    return null === r ? null : "".concat(r, "^");
}
function $81cb1647619a2ab5$var$Yt(e) {
    return null !== e && e.nodeType === Node.COMMENT_NODE;
}
function $81cb1647619a2ab5$var$Zt(e) {
    return null !== e && e.nodeType === Node.ELEMENT_NODE;
}
function $81cb1647619a2ab5$var$Kt(e) {
    return "INPUT" === e.tagName;
}
function $81cb1647619a2ab5$var$Jt(e) {
    return $81cb1647619a2ab5$var$Kt(e) && [
        "color",
        "date",
        "datetime",
        "datetime-local",
        "month",
        "time",
        "week"
    ].includes(e.type);
}
function $81cb1647619a2ab5$var$_t(e) {
    return "SELECT" === e.tagName;
}
function $81cb1647619a2ab5$var$$t(e) {
    return 11 === (null == e ? void 0 : e.nodeType) && !!(null == e ? void 0 : e.host);
}
function $81cb1647619a2ab5$var$en(e) {
    return null !== e && e.nodeType === Node.TEXT_NODE;
}
function $81cb1647619a2ab5$var$tn(e) {
    return "TEXTAREA" === e.tagName;
}
function $81cb1647619a2ab5$var$nn(e) {
    return !!$81cb1647619a2ab5$var$tn(e) || [
        "email",
        "number",
        "password",
        "search",
        "tel",
        "text",
        "url"
    ].includes(e.type);
}
function $81cb1647619a2ab5$var$on(e, t, n) {
    return void 0 === n && (n = {}), t.includes("@charset") && (t = t.replace(/@charset\s+[^;\s]+;/g, "")), t.split("\n").map(function(t) {
        return (function(e, t, n, o) {
            void 0 === o && (o = {});
            var r = t, i = "";
            for(; 0 !== r.length;){
                var a = $81cb1647619a2ab5$var$Lt($81cb1647619a2ab5$var$sn(e, r, n, o), 4);
                i += a[0], i += a[1], i += a[2], r = a[3];
            }
            return i;
        })(e, t, $81cb1647619a2ab5$var$Ht(), n).split("\\\\").join("___upscope___double-escape___").split("\\:").join("___upscope___escaped-colon___").split("(hover:hover").join("___upscope___temporary-hover-replacement___").split(":hover").join("[upscope-status-hover]").split("___upscope___temporary-hover-replacement___").join("(hover:hover").split(":focus-visible").join("[upscope-status-focus-visible]").split(":focus-within").join("[upscope-status-focus-within]").split(":focus").join("[upscope-status-focus]").split(":target").join("[upscope-status-target]").split(":active").join("[upscope-status-active]").split("___upscope___escaped-colon___").join("\\:").split("___upscope___double-escape___").join("\\\\");
    }).join("\n");
}
function $81cb1647619a2ab5$var$rn(e) {
    for(var t = [], n = e; n.parentNode && "#document" !== n.parentNode.nodeName;)t.push(n.parentNode), n = n.parentNode;
    return t;
}
function $81cb1647619a2ab5$var$an(e) {
    return $81cb1647619a2ab5$var$Zt(e) && void 0 !== e.__elementID ? e.__elementID : $81cb1647619a2ab5$var$$t(e) ? "".concat(e.host.__elementID, "-sr") : null;
}
function $81cb1647619a2ab5$var$cn(e) {
    e.every(function(e) {
        return "text" in e && e.isCss;
    }) && (e = [
        {
            isCss: !0,
            text: e.map(function(e) {
                return e.text;
            }).join("")
        }
    ]);
    return e;
}
function $81cb1647619a2ab5$var$sn(e, t, n, o) {
    void 0 === o && (o = {});
    var r = $81cb1647619a2ab5$var$Lt(function(e) {
        var t = /url\((['"]?)(.*?)\1\)|@import\s+(['"]?)(.*?)\3|src\s*:\s*(['"]?)(.*?)\5/gi.exec(e);
        if (t) {
            var n = t.index, o = t[0].length, r = t[2] || t[4] || t[6];
            if (!r) return [
                n,
                n,
                o
            ];
            var i = n + t[0].indexOf(r), a = i + r.length;
            return [
                i,
                a,
                o - (a - n)
            ];
        }
        return [
            void 0,
            void 0,
            void 0
        ];
    }(t), 3), i = r[0], a = r[1], c = r[2];
    if (void 0 === i) return [
        t,
        "",
        "",
        ""
    ];
    var s = t.substring(0, i), l = t.substring(i, a), u = t.substring(a, a + c), d = t.substring(a + c);
    return [
        s,
        0 === l.length ? "" : $81cb1647619a2ab5$var$ln(e, l, !1, n, o),
        u,
        d
    ];
}
function $81cb1647619a2ab5$var$ln(e, t, n, o, r) {
    var i, a;
    if (void 0 === n && (n = !1), void 0 === o && (o = void 0), void 0 === r && (r = {}), t.startsWith("data:")) return t;
    if (t.trim().length < 3) return t;
    if (t.length > 2e3) return t;
    if (t.startsWith("#")) return t;
    t.includes("#") && (i = $81cb1647619a2ab5$var$Lt(t.split("#"), 2), t = i[0], a = i[1]);
    var c = $81cb1647619a2ab5$var$qt(e, t), s = function(e, t) {
        var n;
        if (void 0 !== $81cb1647619a2ab5$var$Wt[e]) return $81cb1647619a2ab5$var$Wt[e];
        if (void 0 !== t[e]) {
            var o = void 0, r = void 0;
            o = (n = $81cb1647619a2ab5$var$Lt([
                t[e].substring(0, t[e].indexOf(":")),
                t[e].substring(t[e].indexOf(":") + 1)
            ], 2))[0], r = n[1];
            try {
                r = atob(r);
            } catch (t) {
                return void $81cb1647619a2ab5$var$Vt.warning("Asset not encoded correctly %s, (%O)", e, t);
            }
            if (o.startsWith("text/css")) r = $81cb1647619a2ab5$var$on(e, r, t);
            else {
                for(var i = r, a = new Array(i.length), c = 0; c < i.length; c++)a[c] = i.charCodeAt(c);
                r = new Uint8Array(a).buffer;
            }
            var s = new Blob([
                r
            ], {
                type: o
            }), l = URL.createObjectURL(s);
            return $81cb1647619a2ab5$var$Wt[e] = l, l;
        }
    }(c, r);
    if (void 0 !== s) return s + ("string" == typeof a ? "#" + a : "");
    var l, u = (l = c, window.btoa(encodeURIComponent(l))), d = "".concat($81cb1647619a2ab5$var$Oe("assets-proxy"), "/proxy/").concat(o ? "".concat(o, "/") : "").concat(c.includes(".css") || n ? "css/" : "https/"), f = encodeURIComponent(new URL(e).origin);
    return d + u + "?origin=".concat(f, "&referer=").concat(f) + ("string" == typeof a ? "#" + a : "");
}
var $81cb1647619a2ab5$var$un = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$dn = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
};
function $81cb1647619a2ab5$var$fn(e, t) {
    return $81cb1647619a2ab5$var$un(this, void 0, void 0, function() {
        var n, o;
        return $81cb1647619a2ab5$var$dn(this, function(r) {
            return (n = $81cb1647619a2ab5$var$Xt(e, t.elementId)) ? ((o = n.__animations && n.__animations[t.animationId]) && o.cancel(), [
                2
            ]) : [
                2
            ];
        });
    });
}
var $81cb1647619a2ab5$var$hn = function() {
    return $81cb1647619a2ab5$var$hn = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $81cb1647619a2ab5$var$hn.apply(this, arguments);
}, $81cb1647619a2ab5$var$vn = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$pn = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
};
function $81cb1647619a2ab5$var$mn(e, t) {
    return $81cb1647619a2ab5$var$vn(this, void 0, void 0, function() {
        var n, o, r;
        return $81cb1647619a2ab5$var$pn(this, function(i) {
            return (n = $81cb1647619a2ab5$var$Xt(e, t.elementId)) && t.options && t.keyframes ? (o = $81cb1647619a2ab5$var$hn($81cb1647619a2ab5$var$hn({}, t.options), {
                iterations: "::infinity::" === t.options.iterations ? 1 / 0 : t.options.iterations
            }), r = n.animate(t.keyframes, o), n.__animations = n.__animations || {}, n.__animations[t.animationId] = r, [
                2
            ]) : [
                2
            ];
        });
    });
}
var $81cb1647619a2ab5$var$yn = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$gn = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$wn = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $81cb1647619a2ab5$var$bn(e, t) {
    return $81cb1647619a2ab5$var$yn(this, void 0, void 0, function() {
        var n, o, r;
        return $81cb1647619a2ab5$var$gn(this, function(i) {
            return (n = $81cb1647619a2ab5$var$Xt(e, t.elementId)) ? (function(e, t) {
                var n, o;
                try {
                    for(var r = $81cb1647619a2ab5$var$Ft($81cb1647619a2ab5$var$rn(t)), i = r.next(); !i.done; i = r.next()){
                        var a = i.value;
                        a instanceof HTMLElement && a.setAttribute(e, "yes");
                    }
                } catch (e) {
                    n = {
                        error: e
                    };
                } finally{
                    try {
                        i && !i.done && (o = r.return) && o.call(r);
                    } finally{
                        if (n) throw n.error;
                    }
                }
            }("upscope-status-focus-within", n), n.setAttribute("upscope-status-focus", "yes"), (null == (o = null === (r = e.contentWindow) || void 0 === r ? void 0 : r.document.activeElement) ? void 0 : o.__beingRemotelyControlled) && o !== n && n.isContentEditable && n.focus(), !$81cb1647619a2ab5$var$_t(n) || n.multiple || n.__beingRemotelyControlled || function(e, t) {
                var n, o, r, i = null === (r = e.contentDocument) || void 0 === r ? void 0 : r.getElementById($81cb1647619a2ab5$var$An(t));
                i && i.parentElement.removeChild(i);
                var a = t.getBoundingClientRect(), c = a.width, s = a.x, l = a.y;
                if (!e.contentDocument) return;
                var u = e.contentDocument.createElement("div");
                u.id = $81cb1647619a2ab5$var$An(t), u.className = "upscope__simulated-dropdown", u.setAttribute("style", "width: ".concat(c, "px !important; top: ").concat(l - 5, "px !important; left: ").concat(s, "px !important")), u.__allowRemoteControl = !1;
                var d = e.contentDocument.createElement("span");
                d.className = "upscope__simulated-dropdown__info-span", d.innerText = "Simulated dropdown", d.__allowRemoteControl = !1, u.appendChild(d);
                try {
                    for(var f = $81cb1647619a2ab5$var$wn(t.options), h = f.next(); !h.done; h = f.next()){
                        var v = h.value, p = e.contentDocument.createElement("div");
                        p.className = $81cb1647619a2ab5$var$De("upscope__simulated-dropdown__option", v.disabled && "upscope__simulated-dropdown__option--disabled", v.selected && "upscope__simulated-dropdown__option--selected"), p.innerText = v.label, p.__allowRemoteControl = !1, u.appendChild(p);
                    }
                } catch (e) {
                    n = {
                        error: e
                    };
                } finally{
                    try {
                        h && !h.done && (o = f.return) && o.call(f);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                e.contentDocument.body.appendChild(u);
            }(e, n), [
                2
            ]) : [
                2
            ];
        });
    });
}
function $81cb1647619a2ab5$var$An(e) {
    return "upscope__simulated-dropdown#" + e.__elementID;
}
var $81cb1647619a2ab5$var$Cn = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$xn = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
};
function $81cb1647619a2ab5$var$Sn(e, t) {
    return $81cb1647619a2ab5$var$Cn(this, void 0, void 0, function() {
        var n, o, r;
        return $81cb1647619a2ab5$var$xn(this, function(i) {
            return (n = $81cb1647619a2ab5$var$Xt(e, t.elementId)) ? (n.removeAttribute("upscope-status-focus"), function(e, t) {
                var n, o;
                try {
                    for(var r = $81cb1647619a2ab5$var$Ft($81cb1647619a2ab5$var$rn(t)), i = r.next(); !i.done; i = r.next()){
                        var a = i.value;
                        a instanceof HTMLElement && a.removeAttribute(e);
                    }
                } catch (e) {
                    n = {
                        error: e
                    };
                } finally{
                    try {
                        i && !i.done && (o = r.return) && o.call(r);
                    } finally{
                        if (n) throw n.error;
                    }
                }
            }("upscope-status-focus-within", n), $81cb1647619a2ab5$var$_t(n) ? ((o = null === (r = e.contentDocument) || void 0 === r ? void 0 : r.getElementById($81cb1647619a2ab5$var$An(n))) && o.parentElement.removeChild(o), [
                2
            ]) : [
                2
            ]) : [
                2
            ];
        });
    });
}
var $81cb1647619a2ab5$var$En = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$In = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$kn = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $81cb1647619a2ab5$var$On = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
};
function $81cb1647619a2ab5$var$Dn(e, t) {
    return $81cb1647619a2ab5$var$En(this, void 0, void 0, function() {
        return $81cb1647619a2ab5$var$In(this, function(n) {
            return $81cb1647619a2ab5$var$zn(e, t.elementId, t.style), [
                2
            ];
        });
    });
}
function $81cb1647619a2ab5$var$zn(e, t, n) {
    var o = function(e) {
        var t = e.contentDocument.querySelector('[upscope-viewer-element="viewer-computed-styles-sheet"]');
        if (t) return t;
        var n = e.contentDocument.createElement("style");
        return n.setAttribute("upscope-viewer-element", "viewer-computed-styles-sheet"), n.type = "text/css", e.contentDocument.head.appendChild(n), n;
    }(e);
    !function(e, t, n) {
        for(var o, r, i = null, a = 0; a < e.cssRules.length; a++){
            var c = e.cssRules[a];
            if (c instanceof CSSStyleRule && c.selectorText === t) {
                i = c;
                break;
            }
        }
        if (i) try {
            for(var s = $81cb1647619a2ab5$var$kn(Object.entries(n)), l = s.next(); !l.done; l = s.next()){
                var u = $81cb1647619a2ab5$var$On(l.value, 2), d = u[0], f = u[1];
                null === f ? i.style.removeProperty(d) : i.style.setProperty(d, f);
            }
        } catch (e) {
            o = {
                error: e
            };
        } finally{
            try {
                l && !l.done && (r = s.return) && r.call(s);
            } finally{
                if (o) throw o.error;
            }
        }
        else {
            var h = Object.entries(n).filter(function(e) {
                return null != $81cb1647619a2ab5$var$On(e, 2)[1];
            }).map(function(e) {
                var t = $81cb1647619a2ab5$var$On(e, 2), n = t[0], o = t[1];
                return "".concat(n, ": ").concat(o, ";");
            }).join(" "), v = "".concat(t, " { ").concat(h, " }");
            e.insertRule(v, e.cssRules.length);
        }
    }(o.sheet, '[upscope-element-id="'.concat(t, '"]'), n);
}
var $81cb1647619a2ab5$var$Mn = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$Bn = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$Ln = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$Fn = function(e, t, n) {
    if (n || 2 === arguments.length) for(var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
    return e.concat(o || Array.prototype.slice.call(t));
};
function $81cb1647619a2ab5$var$Pn(e, t) {
    return $81cb1647619a2ab5$var$Mn(this, void 0, void 0, function() {
        var n, o, r;
        return $81cb1647619a2ab5$var$Bn(this, function(i) {
            return n = $81cb1647619a2ab5$var$Xt(e, t.elementId), o = t.value, null !== (r = e.__latestValues) && void 0 !== r || (e.__latestValues = {}), e.__latestValues[t.elementId] = o, n ? ($81cb1647619a2ab5$var$Vn(n, o), [
                2
            ]) : [
                2
            ];
        });
    });
}
function $81cb1647619a2ab5$var$Vn(e, t) {
    if (!(e.__beingRemotelyControlled || $81cb1647619a2ab5$var$Kt(e) && "radio" === e.type && e.name && $81cb1647619a2ab5$var$Fn([], $81cb1647619a2ab5$var$Ln(e.ownerDocument.querySelectorAll('[name="'.concat(e.name, '"]'))), !1).some(function(e) {
        return e.__beingRemotelyControlled;
    }))) {
        var n = t.substring(0, t.indexOf(":")), o = t.substring(t.indexOf(":") + 1);
        switch(n){
            case "checked":
                var r = "1" === o;
                if (e.checked === r) return;
                e.checked = r;
                break;
            case "value":
                if (e.value === o) return;
                e.value = o;
                break;
            case "selectedIndex":
                if (e.__lastSelectedIndex = parseInt(o, 10), e.selectedIndex === e.__lastSelectedIndex) return;
                e.selectedIndex = e.__lastSelectedIndex;
        }
    }
}
var $81cb1647619a2ab5$var$Tn = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $81cb1647619a2ab5$var$jn(e, t) {
    var n, o = t, r = 0, i = 0, a = 1;
    if ("root" !== e.iframeId) for(var c = e.iframeId.split(">"), s = ""; c.length > 0;){
        var l = c.shift();
        if (!(o = null === (n = o.contentDocument) || void 0 === n ? void 0 : n.querySelector('[upscope-element-id="'.concat(s).concat(l, '"]')))) return null;
        var u = o.getBoundingClientRect();
        r += u.left * a, i += u.top * a, a = u.width / o.offsetWidth * a, s = "".concat(s).concat(l, ">");
    }
    return {
        cursorOffsetX: r,
        cursorOffsetY: i,
        internalScale: a,
        targetIframe: o
    };
}
var $81cb1647619a2ab5$var$Rn = [
    "windowResize",
    "pageLoad",
    "snapShot"
];
var $5d33e70fe34254c5$exports = {};
$5d33e70fe34254c5$exports = import.meta.resolve("4rG6l");


var $7a21ab27cc1cf366$exports = {};
$7a21ab27cc1cf366$exports = import.meta.resolve("1xwh7");


var $81cb1647619a2ab5$var$Xn = {
    default: new URL($5d33e70fe34254c5$exports).href,
    pointer: new URL($7a21ab27cc1cf366$exports).href
};
function $81cb1647619a2ab5$var$Nn(e, t) {
    for(var n = e.length - 1; n >= 0; n--)if (t(e[n], n, e)) return e[n];
}
function $81cb1647619a2ab5$var$Un(e, t) {
    var n, o;
    if (e.__latestValues) {
        var r = t.querySelectorAll("input,textarea,select");
        try {
            for(var i = $81cb1647619a2ab5$var$Tn(r), a = i.next(); !a.done; a = i.next()){
                var c = a.value, s = c.__elementID ? e.__latestValues[c.__elementID] : void 0;
                s && $81cb1647619a2ab5$var$Vn(c, s);
            }
        } catch (e) {
            n = {
                error: e
            };
        } finally{
            try {
                a && !a.done && (o = i.return) && o.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
    }
}
function $81cb1647619a2ab5$var$Gn(e) {
    var t, n, o, r, i, a;
    if (!("number" == typeof (null === (o = e.contentWindow) || void 0 === o ? void 0 : o.__lastAgentScrollAt) && "number" == typeof (null === (r = e.contentWindow) || void 0 === r ? void 0 : r.__lastUserInteractionAt) && (null === (i = e.contentWindow) || void 0 === i ? void 0 : i.__lastAgentScrollAt) > (null === (a = e.contentWindow) || void 0 === a ? void 0 : a.__lastUserInteractionAt)) && e.__currentScrolls) try {
        for(var c = $81cb1647619a2ab5$var$Tn(Object.values(e.__currentScrolls)), s = c.next(); !s.done; s = c.next()){
            var l = s.value;
            null == l || l();
        }
    } catch (e) {
        t = {
            error: e
        };
    } finally{
        try {
            s && !s.done && (n = c.return) && n.call(c);
        } finally{
            if (t) throw t.error;
        }
    }
}
var $81cb1647619a2ab5$var$Hn = "animation: none; animation-delay: 0; animation-direction: normal; animation-duration: 0; animation-fill-mode: none; animation-iteration-count: 1; animation-name: none; animation-play-state: running; animation-timing-function: ease; backface-visibility: visible; background: 0; background-attachment: scroll; background-clip: border-box; background-color: transparent; background-image: none; background-origin: padding-box; background-position: 0 0; background-position-x: 0; background-position-y: 0; background-repeat: repeat; background-size: auto auto; border: 0; border-style: none; border-width: medium; border-color: inherit; border-bottom: 0; border-bottom-color: inherit; border-bottom-left-radius: 0; border-bottom-right-radius: 0; border-bottom-style: none; border-bottom-width: medium; border-collapse: separate; border-image: none; border-left: 0; border-left-color: inherit; border-left-style: none; border-left-width: medium; border-radius: 0; border-right: 0; border-right-color: inherit; border-right-style: none; border-right-width: medium; border-spacing: 0; border-top: 0; border-top-color: inherit; border-top-left-radius: 0; border-top-right-radius: 0; border-top-style: none; border-top-width: medium; bottom: auto; box-shadow: none; box-sizing: content-box; caption-side: top; clear: none; clip: auto; color: inherit; columns: auto; column-count: auto; column-fill: balance; column-gap: normal; column-rule: medium none currentColor; column-rule-color: currentColor; column-rule-style: none; column-rule-width: none; column-span: 1; column-width: auto; content: normal; counter-increment: none; counter-reset: none; cursor: auto; direction: ltr; display: inline; empty-cells: show; float: none; font: normal; font-family: inherit; font-size: medium; font-style: normal; font-variant: normal; font-weight: normal; height: auto; hyphens: none; left: auto; letter-spacing: normal; line-height: normal; list-style: none; list-style-image: none; list-style-position: outside; list-style-type: disc; margin: 0; margin-bottom: 0; margin-left: 0; margin-right: 0; margin-top: 0; max-height: none; max-width: none; min-height: 0; min-width: 0; opacity: 1; orphans: 0; outline: 0; outline-color: invert; outline-style: none; outline-width: medium; overflow: visible; overflow-x: visible; overflow-y: visible; padding: 0; padding-bottom: 0; padding-left: 0; padding-right: 0; padding-top: 0; page-break-after: auto; page-break-before: auto; page-break-inside: auto; perspective: none; perspective-origin: 50% 50%; position: static; right: auto; tab-size: 8; table-layout: auto; text-align: inherit; text-align-last: auto; text-decoration: none; text-decoration-color: inherit; text-decoration-line: none; text-decoration-style: solid; text-indent: 0; text-shadow: none; text-transform: none; top: auto; transform: none; transform-style: flat; transition: none; transition-delay: 0s; transition-duration: 0s; transition-property: none; transition-timing-function: ease; unicode-bidi: normal; vertical-align: baseline; visibility: visible; white-space: normal; widows: 0; width: auto; word-spacing: normal; z-index: auto;".split(";").join(" !important;") + " all: initial !important;", $81cb1647619a2ab5$var$qn = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$Wn = function(e, t, n) {
    if (n || 2 === arguments.length) for(var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
    return e.concat(o || Array.prototype.slice.call(t));
}, $81cb1647619a2ab5$var$Qn = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $81cb1647619a2ab5$var$Yn(e) {
    var t = {
        children: Object.getOwnPropertyDescriptor(e.defaultView.Element.prototype, "children").get,
        childNodes: Object.getOwnPropertyDescriptor(e.defaultView.Node.prototype, "childNodes").get,
        firstChild: Object.getOwnPropertyDescriptor(e.defaultView.Node.prototype, "firstChild").get,
        lastChild: Object.getOwnPropertyDescriptor(e.defaultView.Node.prototype, "lastChild").get,
        innerHTML: Object.getOwnPropertyDescriptor(e.defaultView.Element.prototype, "innerHTML").get,
        textContent: Object.getOwnPropertyDescriptor(e.defaultView.Node.prototype, "textContent").get
    }, n = {
        innerHTML: Object.getOwnPropertyDescriptor(e.defaultView.Element.prototype, "innerHTML").set,
        textContent: Object.getOwnPropertyDescriptor(e.defaultView.Node.prototype, "textContent").set
    };
    e.defaultView.HTMLElement.prototype.attachShadow = function(o) {
        var r = this, i = Object.create(null, {
            nodeType: {
                value: 11
            },
            host: {
                value: this
            },
            ownerDocument: {
                value: e
            },
            mode: {
                value: (null == o ? void 0 : o.mode) || "open"
            },
            adoptedStyleSheets: {
                get: function() {
                    return [];
                },
                set: function() {
                    console.debug("no-op set adoptedStyleSheets");
                }
            },
            children: {
                get: function() {
                    return t.children.call(r);
                }
            },
            childNodes: {
                get: function() {
                    return t.childNodes.call(r);
                }
            },
            firstChild: {
                get: function() {
                    return t.firstChild.call(r);
                }
            },
            lastChild: {
                get: function() {
                    return t.lastChild.call(r);
                }
            },
            innerHTML: {
                get: function() {
                    return t.innerHTML.call(r);
                },
                set: function(e) {
                    var t = n.innerHTML.call(r, e);
                    return i.__updateSlots(), t;
                }
            },
            textContent: {
                get: function() {
                    return t.textContent.call(r);
                },
                set: function(e) {
                    n.textContent.call(r, e);
                }
            }
        }), a = Array.from(this.childNodes);
        return Object.assign(this, {
            __hostChildren: new Set(a),
            appendChild: function(e) {
                var t = HTMLElement.prototype.appendChild.call(this, e);
                return this.__hostChildren.add(e), this.shadowRoot.__updateSlots(), t;
            },
            removeChild: function(e) {
                if (!this.__hostChildren.has(e)) throw new Error("Removing child of shadowRoot");
                var t = HTMLElement.prototype.removeChild.call(e.parentNode, e);
                return this.__hostChildren.delete(e), this.shadowRoot.__updateSlots(), t;
            },
            replaceChild: function(e, t) {
                if (!this.__hostChildren.has(t)) throw new Error("Replacing child of shadowRoot");
                var n = HTMLElement.prototype.replaceChild.call(t.parentNode, e, t);
                return this.__hostChildren.delete(t), this.__hostChildren.add(e), this.shadowRoot.__updateSlots(), n;
            },
            insertBefore: function(e, t) {
                if (t && !this.__hostChildren.has(t)) throw new Error("Inserting before wrong child");
                var n = HTMLElement.prototype.insertBefore.call(this, e, null);
                return this.__hostChildren.add(e), this.shadowRoot.__updateSlots(), n;
            }
        }), Object.assign(i, {
            addEventListener: function(e, t) {
                console.debug("No-op addEventListener on shadow root", e, t);
            },
            append: function() {
                for(var e, t = [], n = 0; n < arguments.length; n++)t[n] = arguments[n];
                var o = (e = HTMLElement.prototype.append).call.apply(e, $81cb1647619a2ab5$var$Wn([
                    this.host
                ], $81cb1647619a2ab5$var$qn(t), !1));
                return this.__updateSlots(), o;
            },
            prepend: function() {
                for(var e, t = [], n = 0; n < arguments.length; n++)t[n] = arguments[n];
                var o = (e = HTMLElement.prototype.prepend).call.apply(e, $81cb1647619a2ab5$var$Wn([
                    this.host
                ], $81cb1647619a2ab5$var$qn(t), !1));
                return this.__updateSlots(), o;
            },
            appendChild: function(e) {
                var t = HTMLElement.prototype.appendChild.call(this.host, e);
                return this.__updateSlots(), t;
            },
            removeChild: function(e) {
                var t = HTMLElement.prototype.removeChild.call(this.host, e);
                return this.__updateSlots(), t;
            },
            replaceChild: function(e, t) {
                var n = HTMLElement.prototype.replaceChild.call(this.host, e, t);
                return this.__updateSlots(), n;
            },
            insertBefore: function(e, t) {
                var n = HTMLElement.prototype.insertBefore.call(this.host, e, t);
                return this.__updateSlots(), n;
            },
            querySelector: function(e) {
                var t = HTMLElement.prototype.querySelector.call(this.host, e);
                return this.__updateSlots(), t;
            },
            querySelectorAll: function(e) {
                var t = HTMLElement.prototype.querySelectorAll.call(this.host, e);
                return this.__updateSlots(), t;
            },
            __updateSlots: function() {
                var e = this;
                $81cb1647619a2ab5$var$Zn(this).forEach(function(t) {
                    var n = t.getAttribute("name") || "default", o = Array.from(e.host.__hostChildren);
                    "default" !== n && (o = o.filter(function(e) {
                        return 1 === e.nodeType && e.getAttribute("slot") === n;
                    })), t.innerHTML = "", (o = o.filter(function(e) {
                        return 1 !== e.nodeType || !e.hasAttribute("upscope-viewer-element");
                    })).forEach(function(e) {
                        return t.appendChild(e);
                    });
                });
            }
        }), Object.defineProperties(this, {
            shadowRoot: {
                value: i,
                writable: !1,
                configurable: !0
            },
            children: {
                get: function() {
                    return Array.from(this.__hostChildren).filter(function(e) {
                        return 1 === e.nodeType;
                    });
                }
            },
            childNodes: {
                get: function() {
                    return Array.from(this.__hostChildren);
                }
            },
            firstChild: {
                get: function() {
                    return this.childNodes[0] || null;
                }
            },
            lastChild: {
                get: function() {
                    return this.childNodes[this.childNodes.length - 1] || null;
                }
            },
            innerHTML: {
                get: function() {
                    return Array.from(this.childNodes).map(function(e) {
                        return "outerHTML" in e ? e.outerHTML : e.textContent;
                    }).join("");
                },
                set: function(e) {
                    throw new Error("no-op set innerHTML on shadow root host");
                }
            },
            textContent: {
                get: function() {
                    return Array.from(this.childNodes).map(function(e) {
                        return e.textContent;
                    }).join("");
                },
                set: function(e) {
                    throw new Error("no-op set textContent on shadow root host");
                }
            }
        }), i;
    };
}
function $81cb1647619a2ab5$var$Zn(e) {
    var t, n, o = [];
    try {
        for(var r = $81cb1647619a2ab5$var$Qn(e.childNodes), i = r.next(); !i.done; i = r.next()){
            var a = i.value;
            "SLOT" === a.nodeName && o.push(a), o.push.apply(o, $81cb1647619a2ab5$var$Wn([], $81cb1647619a2ab5$var$qn($81cb1647619a2ab5$var$Zn(a)), !1));
        }
    } catch (e) {
        t = {
            error: e
        };
    } finally{
        try {
            i && !i.done && (n = r.return) && n.call(r);
        } finally{
            if (t) throw t.error;
        }
    }
    return o;
}
var $81cb1647619a2ab5$var$Kn = function() {
    return $81cb1647619a2ab5$var$Kn = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $81cb1647619a2ab5$var$Kn.apply(this, arguments);
}, $81cb1647619a2ab5$var$Jn = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$_n = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$$n = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $81cb1647619a2ab5$var$eo = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$to = $81cb1647619a2ab5$var$ce("viewer:pageLoad");
function $81cb1647619a2ab5$var$no(e, t) {
    return $81cb1647619a2ab5$var$Jn(this, void 0, void 0, function() {
        var n, o, r, i, a, c, s, l, u, d, f, h, v, p, m, y, g, w, b, A, C, x, S, E, I, k, O, D, z, M, B, L, F, P, V, T, j, R, X, N, U, G, H, q, W, Q, Y, Z, K, J, _, $, ee, te, ne, oe, re, ie, ae, ce, se, le, ue, de, fe, he, ve, pe, me, ye, ge, we, be;
        return $81cb1647619a2ab5$var$_n(this, function(Ae) {
            switch(Ae.label){
                case 0:
                    if (t.assets = t.assets || {}, null !== (ge = e.__flags) && void 0 !== ge || (e.__flags = t.flags), "root" !== (n = e.__elementID || "root") && (e.__upscopeViewerIframeContentStatus = "content", $81cb1647619a2ab5$var$Gt(e.ownerDocument)), $81cb1647619a2ab5$var$to("Starting to load page (%s) into iframe %s", t.url, n), o = e.contentDocument, r = function(t) {
                        return $81cb1647619a2ab5$var$Xt(e, t);
                    }, !o) return $81cb1647619a2ab5$var$to("Missing contentDocument for iframe %s", n), [
                        2
                    ];
                    o.open(), o.write((t.doctype ? t.doctype : "") + '<html><head><base href="' + t.baseUrl + '"/></head><body></body></html>'), o.close(), i = o.getElementsByTagName("html")[0], a = [];
                    try {
                        for(c = $81cb1647619a2ab5$var$$n(i.childNodes), s = c.next(); !s.done; s = c.next())d = s.value, a.push(d);
                    } catch (e) {
                        _ = {
                            error: e
                        };
                    } finally{
                        try {
                            s && !s.done && ($ = c.return) && $.call(c);
                        } finally{
                            if (_) throw _.error;
                        }
                    }
                    e.__baseURL = t.baseUrl, (null === (we = t.flags) || void 0 === we ? void 0 : we.includes("aura_compatibility")) && $81cb1647619a2ab5$var$Yn(o), function(e, t) {
                        var n = e.defaultView.HTMLElement.prototype.attachShadow;
                        e.defaultView.HTMLElement.prototype.attachShadow = function(e) {
                            var o = n.call(this, e);
                            return $81cb1647619a2ab5$var$oo(o, t), o;
                        };
                    }(o, t), $81cb1647619a2ab5$var$Rt(e, t.baseUrl, t.assets, t.html, i, !0);
                    try {
                        for(l = $81cb1647619a2ab5$var$$n(a), u = l.next(); !u.done; u = l.next())d = u.value, i.removeChild(d);
                    } catch (e) {
                        ee = {
                            error: e
                        };
                    } finally{
                        try {
                            u && !u.done && (te = l.return) && te.call(l);
                        } finally{
                            if (ee) throw ee.error;
                        }
                    }
                    return $81cb1647619a2ab5$var$to("Element nodes built and inserted into iframe %s, waiting for page to load", n), [
                        4,
                        $81cb1647619a2ab5$var$ro(e, t.styleSheetsCount || 0)
                    ];
                case 1:
                    Ae.sent(), $81cb1647619a2ab5$var$to("Page loaded for iframe %s", n), e.__latestValues = t.formValues, $81cb1647619a2ab5$var$Un(e, e.contentDocument), (f = t.targetElementId ? r(t.targetElementId) : null) && f.setAttribute("upscope-status-target", "yes"), (h = t.focusElementId ? r(t.focusElementId) : null) && h.setAttribute("upscope-status-focus", "yes");
                    try {
                        for(v = $81cb1647619a2ab5$var$$n(t.popoverElementIds), p = v.next(); !p.done; p = v.next())m = p.value, null === (be = r(m)) || void 0 === be || be.showPopover();
                    } catch (e) {
                        ne = {
                            error: e
                        };
                    } finally{
                        try {
                            p && !p.done && (oe = v.return) && oe.call(v);
                        } finally{
                            if (ne) throw ne.error;
                        }
                    }
                    try {
                        for(y = $81cb1647619a2ab5$var$$n(Object.entries(t.canvases)), g = y.next(); !g.done; g = y.next())w = $81cb1647619a2ab5$var$eo(g.value, 2), b = w[0], A = w[1], (C = r(b)) && (C.__canvasContent = A, $81cb1647619a2ab5$var$It(C, A));
                    } catch (e) {
                        re = {
                            error: e
                        };
                    } finally{
                        try {
                            g && !g.done && (ie = y.return) && ie.call(y);
                        } finally{
                            if (re) throw re.error;
                        }
                    }
                    e.__currentStylesheetContents = t.styleSheetContents;
                    try {
                        for(x = $81cb1647619a2ab5$var$$n(Object.entries(t.styleSheetContents)), S = x.next(); !S.done; S = x.next())E = $81cb1647619a2ab5$var$eo(S.value, 2), I = E[0], k = E[1], (O = r(I)) && (O.innerHTML = $81cb1647619a2ab5$var$on(t.baseUrl, k, t.assets));
                    } catch (e) {
                        ae = {
                            error: e
                        };
                    } finally{
                        try {
                            S && !S.done && (ce = x.return) && ce.call(x);
                        } finally{
                            if (ae) throw ae.error;
                        }
                    }
                    e.__documentAdoptedSheet = void 0, o.adoptedStyleSheets = [], t.adoptedStyleSheets && o.defaultView && ((D = new o.defaultView.CSSStyleSheet).replace($81cb1647619a2ab5$var$on(t.baseUrl, t.adoptedStyleSheets, t.assets)), o.adoptedStyleSheets = [
                        D
                    ], e.__documentAdoptedSheet = D);
                    try {
                        for(z = $81cb1647619a2ab5$var$$n(t.animations), M = z.next(); !M.done; M = z.next())B = M.value, (T = r(B.elementId)) && B.options && B.keyframes && T.animate(B.keyframes, $81cb1647619a2ab5$var$Kn($81cb1647619a2ab5$var$Kn({}, B.options), {
                            iterations: "::infinity::" === B.options.iterations ? 1 / 0 : B.options.iterations
                        }));
                    } catch (e) {
                        se = {
                            error: e
                        };
                    } finally{
                        try {
                            M && !M.done && (le = z.return) && le.call(z);
                        } finally{
                            if (se) throw se.error;
                        }
                    }
                    try {
                        for(L = $81cb1647619a2ab5$var$$n(Object.entries(t.maskedElementsSizes)), F = L.next(); !F.done; F = L.next())P = $81cb1647619a2ab5$var$eo(F.value, 2), K = P[0], V = P[1], (T = r(K)) && (T.__maskedSize = V, $81cb1647619a2ab5$var$Bt(T, V));
                    } catch (e) {
                        ue = {
                            error: e
                        };
                    } finally{
                        try {
                            F && !F.done && (de = L.return) && de.call(L);
                        } finally{
                            if (ue) throw ue.error;
                        }
                    }
                    try {
                        for(j = $81cb1647619a2ab5$var$$n(Object.entries(t.computedStyles)), R = j.next(); !R.done; R = j.next())X = $81cb1647619a2ab5$var$eo(R.value, 2), K = X[0], N = X[1], $81cb1647619a2ab5$var$zn(e, K, N);
                    } catch (e) {
                        fe = {
                            error: e
                        };
                    } finally{
                        try {
                            R && !R.done && (he = j.return) && he.call(j);
                        } finally{
                            if (fe) throw fe.error;
                        }
                    }
                    $81cb1647619a2ab5$var$to("Inserting stylesheets into iframe %s", n), $81cb1647619a2ab5$var$oo(e.contentDocument.head, t), $81cb1647619a2ab5$var$to("Will now perform page load for iframes within %s", n), U = [];
                    try {
                        for(G = $81cb1647619a2ab5$var$$n(o.querySelectorAll("iframe,frame")), H = G.next(); !H.done; H = G.next())void 0 !== (q = H.value).__upscopeViewerIframeContent && (q.__upscopeViewerIframeContent.assets = $81cb1647619a2ab5$var$Kn($81cb1647619a2ab5$var$Kn({}, t.assets), q.__upscopeViewerIframeContent.assets), U.push($81cb1647619a2ab5$var$no(q, q.__upscopeViewerIframeContent))), delete q.__upscopeViewerIframeContent;
                    } catch (e) {
                        ve = {
                            error: e
                        };
                    } finally{
                        try {
                            H && !H.done && (pe = G.return) && pe.call(G);
                        } finally{
                            if (ve) throw ve.error;
                        }
                    }
                    return [
                        4,
                        Promise.all(U)
                    ];
                case 2:
                    Ae.sent(), $81cb1647619a2ab5$var$Gt(e.contentDocument), e.__currentScrolls = {}, e.__currentScrolls.window = function() {
                        e.contentWindow && e.contentWindow.scrollTo(t.scrollPositions.window.x, t.scrollPositions.window.y);
                    }, e.__currentScrolls.window(), W = function(t, n) {
                        e.__currentScrolls[t] = function() {
                            var o = r(t);
                            o ? (o.scrollTop = n.y, o.scrollLeft = n.x, e.__currentScrolls[t].scrolled = !0) : e.__currentScrolls[t].scrolled && delete e.__currentScrolls[t];
                        }, e.__currentScrolls[t]();
                    };
                    try {
                        for(Q = $81cb1647619a2ab5$var$$n(Object.entries(t.scrollPositions.elements)), Y = Q.next(); !Y.done; Y = Q.next())Z = $81cb1647619a2ab5$var$eo(Y.value, 2), K = Z[0], J = Z[1], W(K, J);
                    } catch (e) {
                        me = {
                            error: e
                        };
                    } finally{
                        try {
                            Y && !Y.done && (ye = Q.return) && ye.call(Q);
                        } finally{
                            if (me) throw me.error;
                        }
                    }
                    return $81cb1647619a2ab5$var$to("Iframe %s is ready", n), [
                        2
                    ];
            }
        });
    });
}
function $81cb1647619a2ab5$var$oo(e, t) {
    if (!e.querySelector('[upscope-viewer-element="viewer-adjustment-stylesheet"]')) {
        var n = e.ownerDocument.createElement("style");
        n.setAttribute("upscope-viewer-element", "viewer-adjustment-stylesheet"), n.type = "text/css", n.__loaded = !1, n.addEventListener("load", function() {
            n.__loaded = !0;
        }), n.innerHTML = '\n  iframe[upscope-iframe-no-content="unknown"], [upscope-iframe-no-content-unknown-wrapper="true"] {\n    opacity: 0.6 !important;\n    background: rgba(0, 0, 0, 0.3) !important;\n    border: 2px dashed rgba(0, 0, 0, 0.5) !important;\n    pointer-events: none !important;\n  }\n  iframe[upscope-iframe-no-content="full_tab_image"] {\n    pointer-events: none !important;\n  }\n  [upscope-iframe-no-content-unknown-wrapper="true"] iframe[upscope-iframe-no-content="unknown"] {\n    visibility: hidden !important;\n  }\n  [data-upscope-viewer-display="none"] {\n    display: none !important;\n  }\n  * {\n    scroll-behavior: auto !important;\n  }\n  noscript {\n    display: none !important;\n  }\n  body {\n    -ms-overflow-style: '.concat(0 === t.scrollbarWidth ? "none" : "scrollbar", " !important;\n  }\n  ::-webkit-scrollbar {\n    display: block !important;\n    width: ").concat(t.scrollbarWidth || 0, "px !important;\n    height: ").concat(t.scrollbarWidth || 0, "px !important;\n    background: #e2e2e2 !important;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: #afafaf !important;\n  }\n  .upscope__simulated-dropdown {\n    ").concat($81cb1647619a2ab5$var$Hn, "\n\n    position: fixed !important;\n    z-index: 99999999 !important;\n    overflow: hidden !important;\n    background: #fafafa !important;\n    color: #363636 !important;\n    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05) !important;\n    border: 1px solid #cfcfcf !important;\n    font-family: sans-serif !important;\n    font-size: 14px !important;\n    border-radius: 5px !important;\n    padding: 5px 0 !important;\n    min-width: 300px !important;\n  }\n  .upscope__simulated-dropdown__info-span {\n    position: absolute !important;\n    top: 5px !important;\n    right: 5px !important;\n    text-transform: uppercase !important;\n    font-size: 13px !important;\n    font-family: sans-serif !important;\n    border-radius: 5px !important;\n    letter-spacing: 0.5px !important;\n    font-weight: bolder !important;\n    opacity: 0.8 !important;\n    color: #c60000 !important;\n    background: #fafafa !important;\n  }\n  .upscope__simulated-dropdown__option {\n    padding: 0 10px 0 20px !important;\n    height: 25px !important;\n    line-height: 25px !important;\n    position: relative !important;\n    line-break: no-break !important;\n    overflow: hidden !important;\n  }\n  .upscope__simulated-dropdown__option--disabled {\n    opacity: 0.5 !important;\n  }\n  .upscope__simulated-dropdown__option--selected::before {\n    content: '\u2714' !important;\n    position: absolute !important;\n    left: 6px !important;\n    font-size: 12px !important;\n  }\n  html[upscope-cursor-mode], html[upscope-cursor-mode] * {\n    cursor: none !important;\n  }\n  "), e.appendChild(n);
    }
}
function $81cb1647619a2ab5$var$ro(e, t) {
    return $81cb1647619a2ab5$var$Jn(this, void 0, void 0, function() {
        return $81cb1647619a2ab5$var$_n(this, function(n) {
            switch(n.label){
                case 0:
                    return [
                        4,
                        new Promise(function(n, o) {
                            var r = Date.now(), i = setInterval(function() {
                                if (e.contentDocument) {
                                    var a = Date.now() - r;
                                    "complete" === e.contentDocument.readyState && function(e, t) {
                                        return !!e.contentDocument && e.contentDocument.styleSheets.length >= t;
                                    }(e, t) ? (clearInterval(i), n(!0)) : a > 5e3 && ("interactive" === e.contentDocument.readyState || "complete" === e.contentDocument.readyState) ? (clearInterval(i), $81cb1647619a2ab5$var$to.warning('The page didn\'t load completely but it is in state "interactive" (iframe %o)', e), n(!0)) : a > 2e4 && (clearInterval(i), o(new Error("Failed to load page.")));
                                } else clearInterval(i);
                            }, 100);
                        })
                    ];
                case 1:
                    return n.sent(), [
                        2
                    ];
            }
        });
    });
}
var $81cb1647619a2ab5$var$io = function() {
    return $81cb1647619a2ab5$var$io = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $81cb1647619a2ab5$var$io.apply(this, arguments);
}, $81cb1647619a2ab5$var$ao = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$co = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$so = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $81cb1647619a2ab5$var$lo = $81cb1647619a2ab5$var$ce("viewer:domChange");
function $81cb1647619a2ab5$var$uo(e, t) {
    return $81cb1647619a2ab5$var$ao(this, void 0, void 0, function() {
        var n, o, r, i, a, c, s, l, u, d, f, h, v, p, m, y = this;
        return $81cb1647619a2ab5$var$co(this, function(g) {
            switch(g.label){
                case 0:
                    n = [];
                    try {
                        for(o = $81cb1647619a2ab5$var$so(t.changes), r = o.next(); !r.done; r = o.next()){
                            if (i = r.value, a = $81cb1647619a2ab5$var$fo(e, t, i)) try {
                                for(h = void 0, c = $81cb1647619a2ab5$var$so(a), s = c.next(); !s.done; s = c.next())l = s.value, n.includes(l) || n.push(l);
                            } catch (e) {
                                h = {
                                    error: e
                                };
                            } finally{
                                try {
                                    s && !s.done && (v = c.return) && v.call(c);
                                } finally{
                                    if (h) throw h.error;
                                }
                            }
                            u = null !== (m = null === (p = $81cb1647619a2ab5$var$Xt(e, i.elementId)) || void 0 === p ? void 0 : p.parentElement) && void 0 !== m ? m : e.contentDocument, $81cb1647619a2ab5$var$Un(e, u);
                        }
                    } catch (e) {
                        d = {
                            error: e
                        };
                    } finally{
                        try {
                            r && !r.done && (f = o.return) && f.call(o);
                        } finally{
                            if (d) throw d.error;
                        }
                    }
                    return n.length > 0 ? ($81cb1647619a2ab5$var$lo("Some of the new nodes contained iframe load events, performing now"), [
                        4,
                        Promise.all(n.map(function(e) {
                            return $81cb1647619a2ab5$var$ao(y, void 0, void 0, function() {
                                var t;
                                return $81cb1647619a2ab5$var$co(this, function(n) {
                                    return t = $81cb1647619a2ab5$var$no(e, e.__upscopeViewerIframeContent), delete e.__upscopeViewerIframeContent, [
                                        2,
                                        t
                                    ];
                                });
                            });
                        }))
                    ]) : [
                        3,
                        2
                    ];
                case 1:
                    g.sent(), $81cb1647619a2ab5$var$lo("All new iframes are now fully loaded"), g.label = 2;
                case 2:
                    return $81cb1647619a2ab5$var$Gt(e.contentDocument), [
                        2
                    ];
            }
        });
    });
}
function $81cb1647619a2ab5$var$fo(e, t, n) {
    var o, r, i, a, c, s, l, u, d, f, h, v, p = function(t) {
        var n = $81cb1647619a2ab5$var$Xt(e, t);
        if (!n) throw new Error("Could not select element " + t);
        return n;
    };
    switch(n.type){
        case "attributes":
            if (!0 === (U = p(n.elementId)).__positionUpdated) return;
            var m = [];
            try {
                for(var y = $81cb1647619a2ab5$var$so(U.attributes), g = y.next(); !g.done; g = y.next()){
                    var w = g.value;
                    "yes" === U.getAttribute("upscope-canvas-replacement") && "src" === w.name || (![
                        "FRAME",
                        "IFRAME"
                    ].includes(U.tagName) || "srcdoc" !== w.name && "src" !== w.name) && (w.name.startsWith("upscope-") || void 0 === n.attributes[w.name] && m.push(w.name));
                }
            } catch (e) {
                o = {
                    error: e
                };
            } finally{
                try {
                    g && !g.done && (r = y.return) && r.call(y);
                } finally{
                    if (o) throw o.error;
                }
            }
            try {
                for(var b = $81cb1647619a2ab5$var$so(m), A = b.next(); !A.done; A = b.next()){
                    var C = A.value;
                    U.removeAttribute(C);
                }
            } catch (e) {
                i = {
                    error: e
                };
            } finally{
                try {
                    A && !A.done && (a = b.return) && a.call(b);
                } finally{
                    if (i) throw i.error;
                }
            }
            [
                "FRAME",
                "IFRAME"
            ].includes(U.tagName) && (delete n.attributes.srcdoc, delete n.attributes.src), [
                "INPUT",
                "SELECT",
                "TEXTAREA"
            ].includes(U.tagName) && U.__beingRemotelyControlled && (U.__afterRemoteControlAttributeValue = n.attributes.value, delete n.attributes.value), $81cb1647619a2ab5$var$Ut(e.__baseURL, t.assets, U, n.attributes);
            break;
        case "children":
            var x = p(n.elementId), S = n.before ? p(n.before) : null, E = n.after ? p(n.after) : null, I = [], k = [], O = !S;
            try {
                for(var D = $81cb1647619a2ab5$var$so(x.childNodes), z = D.next(); !z.done; z = D.next())if (!$81cb1647619a2ab5$var$Zt(L = z.value) || !L.hasAttribute("upscope-viewer-element")) {
                    if (O && L !== E) I.push(L);
                    else if (L === S) O = !0;
                    else if (L === E) break;
                }
            } catch (e) {
                c = {
                    error: e
                };
            } finally{
                try {
                    z && !z.done && (s = D.return) && s.call(D);
                } finally{
                    if (c) throw c.error;
                }
            }
            try {
                for(var M = $81cb1647619a2ab5$var$so(I), B = M.next(); !B.done; B = M.next()){
                    var L;
                    if ($81cb1647619a2ab5$var$_t(L = B.value) && L.dataset.upscopeUid) {
                        var F = e.contentDocument.getElementById($81cb1647619a2ab5$var$An(L));
                        F && F.parentElement.removeChild(F);
                    }
                    x.removeChild(L);
                }
            } catch (e) {
                l = {
                    error: e
                };
            } finally{
                try {
                    B && !B.done && (u = M.return) && u.call(M);
                } finally{
                    if (l) throw l.error;
                }
            }
            if (I.length = 0, n.newNodes.length > 0) try {
                for(var P = $81cb1647619a2ab5$var$so(n.newNodes), V = P.next(); !V.done; V = P.next()){
                    var T = V.value, j = $81cb1647619a2ab5$var$Rt(e, e.__baseURL, t.assets, T, void 0, !0);
                    E ? x.insertBefore(j, E) : x.appendChild(j);
                    try {
                        for(var R = (h = void 0, $81cb1647619a2ab5$var$so(x.querySelectorAll("iframe"))), X = R.next(); !X.done; X = R.next()){
                            var N = X.value;
                            void 0 !== N.__upscopeViewerIframeContent && (N.__upscopeViewerIframeContent.assets = $81cb1647619a2ab5$var$io($81cb1647619a2ab5$var$io({}, t.assets), N.__upscopeViewerIframeContent.assets), k.push(N));
                        }
                    } catch (e) {
                        h = {
                            error: e
                        };
                    } finally{
                        try {
                            X && !X.done && (v = R.return) && v.call(R);
                        } finally{
                            if (h) throw h.error;
                        }
                    }
                }
            } catch (e) {
                d = {
                    error: e
                };
            } finally{
                try {
                    V && !V.done && (f = P.return) && f.call(P);
                } finally{
                    if (d) throw d.error;
                }
            }
            return k;
        case "html":
            (U = p(n.elementId)).parentNode.insertBefore($81cb1647619a2ab5$var$Rt(e, e.__baseURL, t.assets, n.html, void 0, !0), U), U.parentNode.removeChild(U);
            break;
        case "text":
            var U = void 0, G = p(n.elementId.slice(0, -1));
            if (!(U = n.elementId.endsWith("^") ? G.childNodes[0] : G.nextSibling) || 1 === U.nodeType) break;
            for(; U && $81cb1647619a2ab5$var$Yt(U);)U = U.nextSibling;
            U && function(e, t) {
                for(var n, o, r, i, a, c = [
                    e
                ], s = e; null !== (s = s.previousSibling) && 3 === s.nodeType;)c.unshift(s);
                for(s = e; null !== (s = s.nextSibling) && 3 === s.nodeType;)c.push(s);
                var l = null === (a = e.ownerDocument.defaultView) || void 0 === a ? void 0 : a.getSelection(), u = null, d = "";
                try {
                    for(var f = $81cb1647619a2ab5$var$so(c), h = f.next(); !h.done; h = f.next()){
                        var v = h.value;
                        (null == l ? void 0 : l.isCollapsed) && l.focusNode === v && (u = d.length + l.focusOffset), d += v.data;
                    }
                } catch (e) {
                    n = {
                        error: e
                    };
                } finally{
                    try {
                        h && !h.done && (o = f.return) && o.call(f);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                var p = t || "";
                if (d !== p) {
                    var m = e.parentNode;
                    try {
                        for(var y = $81cb1647619a2ab5$var$so(c), g = y.next(); !g.done; g = y.next())(v = g.value) !== e && m.removeChild(v);
                    } catch (e) {
                        r = {
                            error: e
                        };
                    } finally{
                        try {
                            g && !g.done && (i = y.return) && i.call(y);
                        } finally{
                            if (r) throw r.error;
                        }
                    }
                    if (e.textContent = p, null !== u && l) {
                        var w = e.ownerDocument.createRange();
                        w.setStart(e, Math.min(function(e, t, n) {
                            for(var o = 0; o < t.length && o < n.length && t[o] === n[o];)o++;
                            for(var r = 0; r < t.length - o && r < n.length - o && t[t.length - 1 - r] === n[n.length - 1 - r];)r++;
                            return e < o ? e : e > t.length - r ? e + n.length - t.length : n.length - r;
                        }(u, d, e.data), e.length)), w.collapse(!0), l.removeAllRanges(), l.addRange(w);
                    }
                }
            }(U, n.text);
    }
}
var $81cb1647619a2ab5$var$ho = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$vo = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$po = $81cb1647619a2ab5$var$ce("viewer:videoStatusChange");
function $81cb1647619a2ab5$var$mo(e, t) {
    return $81cb1647619a2ab5$var$ho(this, void 0, void 0, function() {
        var n;
        return $81cb1647619a2ab5$var$vo(this, function(o) {
            if (!(n = $81cb1647619a2ab5$var$Xt(e, t.elementId))) return [
                2
            ];
            n.__lastExpectedStatusChangeAt = Date.now();
            try {
                "playsInline" in n && (n.playsInline = !0), n.playbackRate = t.playbackRate;
                try {
                    n.muted = t.muted;
                } catch (e) {
                    $81cb1647619a2ab5$var$po("Cannot set muted");
                }
                t.playing ? n.play() : n.pause(), (Math.abs(n.currentTime - t.time) > 5 || !t.playing) && (n.currentTime = t.time);
            } catch (e) {
                $81cb1647619a2ab5$var$po.warning("Error modifying video status %o", e);
            }
            return [
                2
            ];
        });
    });
}
var $81cb1647619a2ab5$var$yo = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$go = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$wo = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $81cb1647619a2ab5$var$bo = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$Ao = function(e, t, n) {
    if (n || 2 === arguments.length) for(var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
    return e.concat(o || Array.prototype.slice.call(t));
};
function $81cb1647619a2ab5$var$Co(e, t) {
    return $81cb1647619a2ab5$var$yo(this, void 0, void 0, function() {
        var n;
        return $81cb1647619a2ab5$var$go(this, function(o) {
            return e.contentDocument ? ((n = $81cb1647619a2ab5$var$Xt(e, t.elementId)) && $81cb1647619a2ab5$var$xo(e, n, "visitor"), [
                2
            ]) : [
                2
            ];
        });
    });
}
function $81cb1647619a2ab5$var$xo(e, t, n) {
    var o;
    null !== (o = e.__debouncedHoverApply) && void 0 !== o || (e.__debouncedHoverApply = {
        agent: $81cb1647619a2ab5$var$ze($81cb1647619a2ab5$var$So.bind(null, "agent"), 100, 200),
        visitor: $81cb1647619a2ab5$var$ze($81cb1647619a2ab5$var$So.bind(null, "visitor"), 100, 200)
    }), e.__debouncedHoverApply[n](e.contentDocument, t);
}
function $81cb1647619a2ab5$var$So(e, t, n) {
    for(var o, r, i, a, c = n, s = []; c;)$81cb1647619a2ab5$var$Zt(c) && s.push(c), c = c.parentNode;
    var l = t.querySelectorAll('[upscope-status-hover*="'.concat(e, '"]'));
    try {
        for(var u = $81cb1647619a2ab5$var$wo(l), d = u.next(); !d.done; d = u.next()){
            var f = d.value;
            s.includes(f) || $81cb1647619a2ab5$var$Io(f, e);
        }
    } catch (e) {
        o = {
            error: e
        };
    } finally{
        try {
            d && !d.done && (r = u.return) && r.call(u);
        } finally{
            if (o) throw o.error;
        }
    }
    try {
        for(var h = $81cb1647619a2ab5$var$wo(s), v = h.next(); !v.done; v = h.next())$81cb1647619a2ab5$var$Eo(v.value, e);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            v && !v.done && (a = h.return) && a.call(h);
        } finally{
            if (i) throw i.error;
        }
    }
}
function $81cb1647619a2ab5$var$Eo(e, t) {
    var n, o, r = null !== (o = null === (n = e.getAttribute("upscope-status-hover")) || void 0 === n ? void 0 : n.split(",")) && void 0 !== o ? o : [];
    0 === r.length ? e.setAttribute("upscope-status-hover", t) : r.includes(t) || e.setAttribute("upscope-status-hover", $81cb1647619a2ab5$var$Ao($81cb1647619a2ab5$var$Ao([], $81cb1647619a2ab5$var$bo(r), !1), [
        t
    ], !1).join(","));
}
function $81cb1647619a2ab5$var$Io(e, t) {
    var n, o, r = null !== (o = null === (n = e.getAttribute("upscope-status-hover")) || void 0 === n ? void 0 : n.split(",")) && void 0 !== o ? o : [];
    if (r.includes(t)) {
        var i = r.filter(function(e) {
            return e !== t;
        });
        0 === i.length ? e.removeAttribute("upscope-status-hover") : e.setAttribute("upscope-status-hover", i.join(","));
    }
}
var $81cb1647619a2ab5$var$ko = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$Oo = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
};
function $81cb1647619a2ab5$var$Do(e, t) {
    return $81cb1647619a2ab5$var$ko(this, void 0, void 0, function() {
        return $81cb1647619a2ab5$var$Oo(this, function(t) {
            return e.contentDocument ? ($81cb1647619a2ab5$var$xo(e, null, "visitor"), [
                2
            ]) : [
                2
            ];
        });
    });
}
var $81cb1647619a2ab5$var$zo = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$Mo = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
};
function $81cb1647619a2ab5$var$Bo(e, t) {
    return $81cb1647619a2ab5$var$zo(this, void 0, void 0, function() {
        var n, o, r, i;
        return $81cb1647619a2ab5$var$Mo(this, function(a) {
            return n = $81cb1647619a2ab5$var$Xt(e, t.elementId), o = t.visible, n ? (o ? null === (r = n.showPopover) || void 0 === r || r.call(n) : null === (i = n.hidePopover) || void 0 === i || i.call(n), [
                2
            ]) : [
                2
            ];
        });
    });
}
var $81cb1647619a2ab5$var$Lo = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$Fo = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
};
function $81cb1647619a2ab5$var$Po(e, t, n, o, r) {
    var i = Math.min(o, e.scrollWidth - e.clientWidth), a = Math.min(r, e.scrollHeight - e.clientHeight);
    return Math.abs(t - i) < 1 && Math.abs(n - a) < 1;
}
function $81cb1647619a2ab5$var$Vo(e, t) {
    return $81cb1647619a2ab5$var$Lo(this, void 0, void 0, function() {
        var n, o, r;
        return $81cb1647619a2ab5$var$Fo(this, function(i) {
            return n = t.elementId || "window", null !== (r = e.__currentScrolls) && void 0 !== r || (e.__currentScrolls = {}), o = function() {
                e.contentWindow && (e.contentWindow.__lastExpectedScrollAt = Date.now());
            }, e.__currentScrolls[n] = function() {
                var r, i;
                if (void 0 === t.elementId) {
                    if (null === (r = e.contentWindow) || void 0 === r ? void 0 : r.__recentAgentScrollTimeout) return;
                    var a = e.contentWindow, c = null == a ? void 0 : a.document.scrollingElement;
                    if (a && c && $81cb1647619a2ab5$var$Po(c, a.scrollX, a.scrollY, t.x, t.y)) return;
                    o(), null === (i = e.contentWindow) || void 0 === i || i.scrollTo(t.x, t.y);
                } else {
                    var s = $81cb1647619a2ab5$var$Xt(e, t.elementId);
                    if (null == s ? void 0 : s.__recentAgentScrollTimeout) return;
                    s ? ($81cb1647619a2ab5$var$Po(s, s.scrollLeft, s.scrollTop, t.x, t.y) || (o(), s.scrollTop = t.y, s.scrollLeft = t.x), e.__currentScrolls[n].scrolled = !0) : e.__currentScrolls[n].scrolled && delete e.__currentScrolls[n];
                }
            }, e.__currentScrolls[n](), [
                2
            ];
        });
    });
}
var $81cb1647619a2ab5$var$To = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$jo = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
};
function $81cb1647619a2ab5$var$Ro(e, t) {
    return $81cb1647619a2ab5$var$To(this, void 0, void 0, function() {
        var n, o, r, i, a, c, s, l, u, d, f, h, v, p, m, y, g, w, b;
        return $81cb1647619a2ab5$var$jo(this, function(A) {
            if (null === (h = e.contentWindow) || void 0 === h ? void 0 : h.__recentAgentSelectionChangeTimeout) return [
                2
            ];
            if (null === (p = null === (v = e.contentWindow) || void 0 === v ? void 0 : v.document.activeElement) || void 0 === p ? void 0 : p.__beingRemotelyControlled) return [
                2
            ];
            if ((n = t.selection).collapsed) {
                if (void 0 === n.caretNodeId) return null === (y = null === (m = e.contentWindow) || void 0 === m ? void 0 : m.getSelection()) || void 0 === y || y.removeAllRanges(), [
                    2
                ];
                if (o = $81cb1647619a2ab5$var$Nt(e, n.caretNodeId), r = null !== (g = n.caretOffset) && void 0 !== g ? g : 0, !o) return [
                    2
                ];
                if ($81cb1647619a2ab5$var$en(o)) {
                    for(; r > o.length && $81cb1647619a2ab5$var$en(o.nextSibling);)r -= o.length, o = o.nextSibling;
                    r = Math.min(r, o.length);
                } else r = Math.min(r, o.childNodes.length);
                return i = null === (w = e.contentWindow) || void 0 === w ? void 0 : w.getSelection(), (a = document.createRange()).setStart(o, r), a.collapse(!0), null == i || i.removeAllRanges(), null == i || i.addRange(a), [
                    2
                ];
            }
            if (c = $81cb1647619a2ab5$var$Nt(e, n.anchorNodeId), s = n.anchorOffset, l = $81cb1647619a2ab5$var$Nt(e, n.focusNodeId), u = n.focusOffset, !c || !l) return [
                2
            ];
            if (d = null === (b = e.contentWindow) || void 0 === b ? void 0 : b.getSelection(), $81cb1647619a2ab5$var$en(c)) for(; s > c.length;)s -= c.length, c = c.nextSibling;
            if ($81cb1647619a2ab5$var$en(l)) for(; u > l.length;)u -= l.length, l = l.nextSibling;
            return (f = document.createRange()).setStart(c, s), f.setEnd(l, u), f.collapsed && ((f = document.createRange()).setStart(l, u), f.setEnd(c, s)), null == d || d.removeAllRanges(), null == d || d.addRange(f), [
                2
            ];
        });
    });
}
var $81cb1647619a2ab5$var$Xo = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$No = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$Uo = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$Go = function(e, t, n) {
    if (n || 2 === arguments.length) for(var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
    return e.concat(o || Array.prototype.slice.call(t));
};
function $81cb1647619a2ab5$var$Ho(e, t) {
    return $81cb1647619a2ab5$var$Xo(this, void 0, void 0, function() {
        var n, o, r, i, a, c, s;
        return $81cb1647619a2ab5$var$No(this, function(l) {
            if (n = t.content, "adopted" in t) {
                if (!(null == (o = e.contentDocument) ? void 0 : o.defaultView)) return [
                    2
                ];
                if (!e.__baseURL) throw new Error("iframeNode.__baseURL is not defined");
                return (r = e.__documentAdoptedSheet) || (r = new o.defaultView.CSSStyleSheet, o.adoptedStyleSheets = $81cb1647619a2ab5$var$Go($81cb1647619a2ab5$var$Go([], $81cb1647619a2ab5$var$Uo(o.adoptedStyleSheets), !1), [
                    r
                ], !1), e.__documentAdoptedSheet = r), r.replace($81cb1647619a2ab5$var$on(e.__baseURL, n, t.assets)), [
                    2
                ];
            }
            if (i = $81cb1647619a2ab5$var$Xt(e, t.elementId), t.shadowRoot) return (a = null == i ? void 0 : i.shadowRoot) ? ((c = a.adoptedStyleSheets[0]) || (c = new e.contentDocument.defaultView.CSSStyleSheet, a.adoptedStyleSheets = [
                c
            ]), c.replace(n), [
                2
            ]) : [
                2
            ];
            if (null !== (s = e.__currentStylesheetContents) && void 0 !== s || (e.__currentStylesheetContents = {}), e.__currentStylesheetContents[t.elementId] = t.content, !i) return [
                2
            ];
            if (!e.__baseURL) throw new Error("iframeNode.__baseURL is not defined");
            return i.innerHTML = $81cb1647619a2ab5$var$on(e.__baseURL, n, t.assets), [
                2
            ];
        });
    });
}
var $81cb1647619a2ab5$var$qo = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$Wo = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
};
function $81cb1647619a2ab5$var$Qo(e, t) {
    return $81cb1647619a2ab5$var$qo(this, void 0, void 0, function() {
        var n, o;
        return $81cb1647619a2ab5$var$Wo(this, function(r) {
            return (n = e.contentDocument.querySelector("[upscope-status-target]")) && n.removeAttribute("upscope-status-target"), (o = $81cb1647619a2ab5$var$Xt(e, t.elementId)) && o.setAttribute("upscope-status-target", "yes"), [
                2
            ];
        });
    });
}
var $81cb1647619a2ab5$var$Yo = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$Zo = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
};
function $81cb1647619a2ab5$var$Ko(e, t) {
    return $81cb1647619a2ab5$var$Yo(this, void 0, void 0, function() {
        return $81cb1647619a2ab5$var$Zo(this, function(n) {
            switch(t.type){
                case "animationCancel":
                    return [
                        2,
                        $81cb1647619a2ab5$var$fn(e, t.data)
                    ];
                case "animationStart":
                    return [
                        2,
                        $81cb1647619a2ab5$var$mn(e, t.data)
                    ];
                case "blur":
                    return [
                        2,
                        $81cb1647619a2ab5$var$Sn(e, t.data)
                    ];
                case "canvasChange":
                    return [
                        2,
                        $81cb1647619a2ab5$var$kt(e, t.data)
                    ];
                case "click":
                case "console":
                case "mouseMove":
                case "preventedScroll":
                case "visualViewportChange":
                case "windowResize":
                    break;
                case "computedStyleChange":
                    return [
                        2,
                        $81cb1647619a2ab5$var$Dn(e, t.data)
                    ];
                case "domChange":
                    return [
                        2,
                        $81cb1647619a2ab5$var$uo(e, t.data)
                    ];
                case "focus":
                    return [
                        2,
                        $81cb1647619a2ab5$var$bn(e, t.data)
                    ];
                case "fullTabFrameContentChange":
                    return function(e, t) {
                        var n = $81cb1647619a2ab5$var$Xt(e, t.elementId);
                        if (n) {
                            var o = n.contentDocument;
                            if (o) {
                                var r = o.querySelector("img[data-upscope-full-tab]");
                                if (!t.url) return null == r || r.remove(), void ("no_content:full_tab_image" === n.__upscopeViewerIframeContentStatus && (n.__upscopeViewerIframeContentStatus = "no_content:unknown", $81cb1647619a2ab5$var$Gt(e.contentDocument)));
                                n.__upscopeViewerIframeContentStatus = "no_content:full_tab_image", $81cb1647619a2ab5$var$Gt(e.contentDocument), r || (o.open(), o.write("<html><head></head><body style='margin:0;overflow:hidden'></body></html>"), o.close(), (r = o.createElement("img")).setAttribute("data-upscope-full-tab", "true"), r.style.width = "100%", r.style.height = "100%", r.style.objectFit = "fill", r.style.display = "block", r.style.border = "none", o.body.appendChild(r)), r.src = t.url;
                            }
                        }
                    }(e, t.data), [
                        2
                    ];
                case "maskedElementSizeChange":
                    return [
                        2,
                        $81cb1647619a2ab5$var$Mt(e, t.data)
                    ];
                case "mediaStatusChange":
                    return [
                        2,
                        $81cb1647619a2ab5$var$mo(e, t.data)
                    ];
                case "mouseEnter":
                    return [
                        2,
                        $81cb1647619a2ab5$var$Co(e, t.data)
                    ];
                case "mouseLeave":
                    return [
                        2,
                        $81cb1647619a2ab5$var$Do(e, t.data)
                    ];
                case "pageLoad":
                case "snapShot":
                    return [
                        2,
                        $81cb1647619a2ab5$var$no(e, t.data)
                    ];
                case "popoverToggle":
                    return [
                        2,
                        $81cb1647619a2ab5$var$Bo(e, t.data)
                    ];
                case "scroll":
                    return [
                        2,
                        $81cb1647619a2ab5$var$Vo(e, t.data)
                    ];
                case "selectionChange":
                    return [
                        2,
                        $81cb1647619a2ab5$var$Ro(e, t.data)
                    ];
                case "styleSheetChange":
                    return [
                        2,
                        $81cb1647619a2ab5$var$Ho(e, t.data)
                    ];
                case "targetChange":
                    return [
                        2,
                        $81cb1647619a2ab5$var$Qo(e, t.data)
                    ];
                case "valueChange":
                    return [
                        2,
                        $81cb1647619a2ab5$var$Pn(e, t.data)
                    ];
            }
            return [
                2
            ];
        });
    });
}
function $81cb1647619a2ab5$var$Jo(e, t, n, o) {
    if (n > e && o > t) return 1;
    var r = o / t, i = n / e;
    return r > i ? i : r;
}
function $81cb1647619a2ab5$var$_o(e, t) {
    var n, o = t.x, r = t.y;
    try {
        for(var i = e, a = !0; i && "contentDocument" in i && (a || "content" === i.__upscopeViewerIframeContentStatus);){
            if (i !== e) {
                var c = i.getBoundingClientRect(), s = c.left, l = c.top;
                o -= s, r -= l;
            }
            i = (null === (n = i.contentDocument) || void 0 === n ? void 0 : n.elementFromPoint(o, r)) || null, a = !1;
        }
        return i;
    } catch (e) {
        if ((null == e ? void 0 : e.message).includes("The provided double value is non-finite")) return null;
        throw e;
    }
}
function $81cb1647619a2ab5$var$$o(e, t, n) {
    var o, r, i, a, c, s = (o = e, r = function(e) {
        var t, n, o, r, i = 0, a = 0;
        return "touches" in e ? (i = null !== (n = null === (t = e.touches[0]) || void 0 === t ? void 0 : t.pageX) && void 0 !== n ? n : 0, a = null !== (r = null === (o = e.touches[0]) || void 0 === o ? void 0 : o.pageY) && void 0 !== r ? r : 0) : (i = e.pageX, a = e.pageY), {
            x: i,
            y: a
        };
    }(n), i = function(e) {
        var t = 0, n = 0;
        if ("offsetParent" in e && e.offsetParent) for(;;){
            t += e.offsetLeft, n += e.offsetTop;
            var o = e.offsetParent;
            if (!o || !$81cb1647619a2ab5$var$Zt(o)) break;
            e = o;
        }
        return {
            x: t,
            y: n
        };
    }(o), a = r.x - i.x, c = r.y - i.y, {
        x: a,
        y: c
    });
    return {
        x: Math.floor(s.x / t),
        y: Math.floor(s.y / t)
    };
}
function $81cb1647619a2ab5$var$er(e) {
    var t = e.getBoundingClientRect();
    return {
        internalScale: t.width / e.offsetWidth,
        isVisible: "checkVisibility" in e ? e.checkVisibility() : t.width > 0 && t.height > 0,
        x: t.left,
        y: t.top
    };
}
function $81cb1647619a2ab5$var$tr(e) {
    if (e && $81cb1647619a2ab5$var$Zt(e) && e.__elementID) {
        var t = e.getBoundingClientRect(), n = t.x, o = t.y;
        return {
            referenceElementId: e.__elementID,
            referenceX: n,
            referenceY: o
        };
    }
    return {
        referenceElementId: void 0,
        referenceX: void 0,
        referenceY: void 0
    };
}
function $81cb1647619a2ab5$var$nr(e, t) {
    var n = null == e ? void 0 : e.__elementID;
    if (!n) throw new Error("Remote ".concat(t, " attempted on an element without an __elementID"));
    return n;
}
var $81cb1647619a2ab5$var$or = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $81cb1647619a2ab5$var$rr = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$ir = function(e, t, n) {
    if (n || 2 === arguments.length) for(var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
    return e.concat(o || Array.prototype.slice.call(t));
}, $81cb1647619a2ab5$var$ar = new Set([
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "Enter",
    "Escape",
    "Tab"
]), $81cb1647619a2ab5$var$cr = new Set([
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "End",
    "Home",
    "PageDown",
    "PageUp"
]);
function $81cb1647619a2ab5$var$sr(e, t, n, o, r, i, a, c, s, l) {
    for(var u, d, f, h, v, p, m, y, g, w, b, A, C, x, S, E, I, k, O, D, z, M, B, L, F, P, V = [], T = o.contentWindow, j = 0, R = !1, X = 0; T && (V.unshift(T.frameElement), T !== n.contentWindow);)T = T.parent;
    function N() {
        var e, t, o, r = 1, i = 0, a = 0;
        if (1 === V.length) return {
            scale: r,
            x: i,
            y: a
        };
        try {
            for(var c = $81cb1647619a2ab5$var$or(V), s = c.next(); !s.done; s = c.next()){
                var l = s.value, u = $81cb1647619a2ab5$var$er(l), d = u.internalScale, f = u.x, h = u.y;
                l !== n && (i += Math.floor(f * r), a += Math.floor(h * r)), null != o || (o = d), r *= d;
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (t = c.return) && t.call(c);
            } finally{
                if (e) throw e.error;
            }
        }
        return {
            scale: r / o,
            x: i = Math.round(i / o),
            y: a = Math.round(a / o)
        };
    }
    var U = $81cb1647619a2ab5$var$ze(function(e, t, n, o) {
        X > e || r.moveCursor(i.current.uniqueConnectionId, c.current, t, n, o);
    }, 100, 100), G = function(t) {
        if (l.current) {
            R && (j = t.timeStamp);
            var r = N(), i = r.scale, a = r.x, c = r.y, s = Math.floor(t.clientX * i) + a, u = Math.floor(t.clientY * i) + c, d = $81cb1647619a2ab5$var$tr(t.target);
            U(t.timeStamp, s, u, d), $81cb1647619a2ab5$var$lr(n, o, e, s, u);
        }
    }, H = 0, q = 0, W = null, Q = $81cb1647619a2ab5$var$ze(function() {
        var e = W && "dataset" in W ? W.__elementID : void 0;
        e && r.scroll(i.current.uniqueConnectionId, e, H, q, "wheel"), H = 0, q = 0, W = null;
    }, 100, 100), Y = $81cb1647619a2ab5$var$ze(function(e, t, n) {
        r.scroll(i.current.uniqueConnectionId, e, t, n, "scroll");
    }, 100, 100), Z = 0, K = function(e) {
        var t, n;
        (null === (t = i.current) || void 0 === t ? void 0 : t.allowRemoteScroll) ? e.target.__clientPreventedScroll || (null === (n = e.target.defaultView) || void 0 === n ? void 0 : n.__clientPreventedScroll) ? (e.preventDefault(), W = e.target, H += e.deltaX, q += e.deltaY, Q()) : Z = e.timeStamp : e.preventDefault();
    }, J = function(e) {
        var t;
        (null === (t = i.current) || void 0 === t ? void 0 : t.allowRemoteScroll) ? e.target.__clientPreventedScroll ? e.preventDefault() : Z = e.timeStamp : e.preventDefault();
    }, _ = function(e) {
        var n, o;
        return R = !0, j = e.timeStamp, (null === (n = i.current) || void 0 === n ? void 0 : n.allowRemoteClick) ? !e.target.__allowRemoteControl || (null === (o = e.target.__upscopeViewerIframeContentStatus) || void 0 === o ? void 0 : o.startsWith("no_content:")) ? (e.preventDefault(), null == t ? void 0 : t("remote_control:element_not_allowed")) : void 0 : (e.preventDefault(), null == t ? void 0 : t("remote_control:click_not_allowed"));
    }, $ = function(e) {
        R = !1;
    }, ee = function(e) {
        var n, o = e.target;
        if ($81cb1647619a2ab5$var$Kt(o) && "file" === o.type || !o.__allowRemoteControl) return e.preventDefault(), null == t ? void 0 : t("remote_control:element_not_allowed");
        $81cb1647619a2ab5$var$Jt(o) || $81cb1647619a2ab5$var$Kt(n = o) && [
            "checkbox",
            "number",
            "radio",
            "range"
        ].includes(n.type) || e.preventDefault();
        var a = N(), c = a.scale, s = a.x, l = a.y, u = Math.floor(e.clientX * c) + s, d = Math.floor(e.clientY * c) + l;
        r.click(i.current.uniqueConnectionId, $81cb1647619a2ab5$var$nr(o, "click"), u, d);
    }, te = 0, ne = function(e) {
        te = e.timeStamp;
        var t, n, o = e.target;
        (null == o ? void 0 : o.__beingRemotelyControlled) ? o.isContentEditable && (!function(e) {
            return null !== e.closest('[role="spinbutton"]');
        }(o) ? (t = e.key, n = e.ctrlKey || e.metaKey, $81cb1647619a2ab5$var$cr.has(t) || n && [
            "a",
            "c"
        ].includes(t.toLowerCase()) ? j = e.timeStamp : (e.ctrlKey || e.metaKey || "Tab" === e.key) && e.preventDefault()) : e.preventDefault(), oe(e)) : e.preventDefault();
    }, oe = function(e) {
        var t;
        if (null === (t = i.current) || void 0 === t ? void 0 : t.allowRemoteType) {
            var n = $81cb1647619a2ab5$var$nr(e.target, "keyPress");
            r.keyPress(i.current.uniqueConnectionId, n, e.code, e.altKey, e.ctrlKey, e.key, e.metaKey, e.shiftKey);
        }
    }, re = function(e) {
        var t = e.target;
        if (!(null == t ? void 0 : t.__beingRemotelyControlled)) return oe(e), void e.preventDefault();
        t.isContentEditable || ($81cb1647619a2ab5$var$Kt(t) || $81cb1647619a2ab5$var$tn(t)) && $81cb1647619a2ab5$var$nn(t) && ($81cb1647619a2ab5$var$ar.has(e.key) && oe(e), r.type(i.current.uniqueConnectionId, $81cb1647619a2ab5$var$nr(t, "type"), t.value));
    }, ie = function(e) {
        var n = e.target;
        if ($81cb1647619a2ab5$var$_t(n) || $81cb1647619a2ab5$var$Kt(n) && !$81cb1647619a2ab5$var$nn(n)) {
            if (n.blur(), !n.__allowRemoteControl) return e.preventDefault(), null == t ? void 0 : t("remote_control:element_not_allowed");
            var o;
            o = $81cb1647619a2ab5$var$_t(n) ? "selectedIndex:".concat(n.selectedIndex) : "checkbox" === n.type || "radio" === n.type ? "checked:".concat(n.checked ? 1 : 0) : "value:".concat(n.value), r.valueUpdate(i.current.uniqueConnectionId, $81cb1647619a2ab5$var$nr(n, "valueUpdate"), o);
        }
    }, ae = function(e) {
        var t, o, a = e.target;
        if ($81cb1647619a2ab5$var$_t(a) || $81cb1647619a2ab5$var$Jt(a)) null === (t = n.contentDocument) || void 0 === t || t.documentElement.removeAttribute("upscope-cursor-mode");
        else {
            e.preventDefault();
            var c = $81cb1647619a2ab5$var$tn(a) || $81cb1647619a2ab5$var$Kt(a) || a.isContentEditable;
            if (!(null === (o = i.current) || void 0 === o ? void 0 : o.allowRemoteType) || !c || !a.__allowRemoteControl) return void (null == a || a.blur());
        }
        a.__beingRemotelyControlled = !0, clearTimeout(a.__recentRemoteControlTimeout), r.focus(i.current.uniqueConnectionId, $81cb1647619a2ab5$var$nr(a, "focus"));
    }, ce = function(e) {
        var t, a;
        null === (t = n.contentDocument) || void 0 === t || t.documentElement.setAttribute("upscope-cursor-mode", "true");
        var c = e.target;
        c.__beingRemotelyControlled && (c.__recentRemoteControlTimeout = setTimeout(function() {
            var e;
            delete c.__beingRemotelyControlled, delete c.__recentRemoteControlTimeout;
            var t = c.__elementID;
            if (t) {
                if (r.blur(i.current.uniqueConnectionId, t), $81cb1647619a2ab5$var$Kt(c) || $81cb1647619a2ab5$var$tn(c) || $81cb1647619a2ab5$var$_t(c)) {
                    var n = null === (e = o.__latestValues) || void 0 === e ? void 0 : e[t];
                    n && $81cb1647619a2ab5$var$Vn(c, n);
                }
                "string" == typeof c.__afterRemoteControlAttributeValue && (c.setAttribute("value", c.__afterRemoteControlAttributeValue), delete c.__afterRemoteControlAttributeValue);
            }
        }, 600 + (null !== (a = s.current) && void 0 !== a ? a : 300)));
    }, se = function(e) {
        var t = e.target, n = N(), o = n.scale, a = n.x, c = n.y, s = Math.floor(e.clientX * o) + a, l = Math.floor(e.clientY * o) + c;
        r.dragStart(i.current.uniqueConnectionId, $81cb1647619a2ab5$var$nr(t, "dragStart"), s, l);
    }, le = function(e) {
        var t = N(), n = t.scale, o = t.x, a = t.y, c = Math.floor(e.clientX * n) + o, s = Math.floor(e.clientY * n) + a;
        r.dragEnd(i.current.uniqueConnectionId, c, s);
    }, ue = function(e) {
        var t;
        if (e.preventDefault(), null === (t = i.current) || void 0 === t ? void 0 : t.allowRemoteType) {
            var n = e.target;
            (null == n ? void 0 : n.__allowRemoteControl) && (e.timeStamp - te > 50 || r.submit(i.current.uniqueConnectionId, $81cb1647619a2ab5$var$nr(n, "submit")));
        }
    }, de = $81cb1647619a2ab5$var$ze(function(e) {
        var t;
        r.selectionChange(i.current.uniqueConnectionId, null !== (t = o.__elementID) && void 0 !== t ? t : "root", e);
    }, 100, 100), fe = function(e) {
        var t;
        (null === (t = i.current) || void 0 === t ? void 0 : t.allowRemoteClick) && $81cb1647619a2ab5$var$xo(o, e.target, "agent");
    }, he = function(e) {
        var t, n = e.target;
        "number" == typeof n.__lastExpectedStatusChangeAt && Date.now() - n.__lastExpectedStatusChangeAt < 100 || (null === (t = i.current) || void 0 === t ? void 0 : t.allowRemoteClick) && r.mediaControl(i.current.uniqueConnectionId, $81cb1647619a2ab5$var$nr(n, "mediaControl"), {
            muted: n.muted,
            playbackRate: n.playbackRate,
            playing: !n.paused,
            time: n.currentTime
        });
    };
    function ve(e) {
        e.addEventListener("mousemove", G), e.addEventListener("wheel", K, {
            passive: !1
        }), e.addEventListener("touchmove", J, {
            passive: !1
        }), e.addEventListener("click", ee), e.addEventListener("keydown", ne), e.addEventListener("keyup", re), e.addEventListener("change", ie), e.addEventListener("focusin", ae), e.addEventListener("focusout", ce), e.addEventListener("dragstart", se), e.addEventListener("dragend", le), e.addEventListener("mousedown", _), e.addEventListener("mouseup", $), e.addEventListener("submit", ue), e.addEventListener("mouseover", fe);
    }
    null === (u = o.contentDocument) || void 0 === u || u.addEventListener("mousemove", G), null === (d = o.contentDocument) || void 0 === d || d.addEventListener("wheel", K, {
        passive: !1
    }), null === (f = o.contentDocument) || void 0 === f || f.addEventListener("touchmove", J, {
        passive: !1
    }), null === (h = o.contentDocument) || void 0 === h || h.addEventListener("scroll", function(e) {
        var t, r, i;
        if (e.target) {
            var a = e.timeStamp - Z < 50, c = "number" == typeof (null === (t = o.contentWindow) || void 0 === t ? void 0 : t.__lastExpectedScrollAt) && Date.now() - o.contentWindow.__lastExpectedScrollAt < 50;
            if ((a || !c) && (o.contentWindow.__lastAgentScrollAt = Date.now(), i = "defaultView" in e.target ? e.target.defaultView : e.target)) {
                if (clearTimeout(i.__recentAgentScrollTimeout), i.__recentAgentScrollTimeout = setTimeout(function() {
                    delete i.__recentAgentScrollTimeout, $81cb1647619a2ab5$var$Gn(o);
                }, 600 + (null !== (r = s.current) && void 0 !== r ? r : 300)), "__elementID" in i) {
                    var l = i.__elementID;
                    l && Y(l, i.scrollLeft, i.scrollTop);
                } else if ("scrollX" in i) {
                    var u = o === n ? null : o.__elementID;
                    void 0 !== u && Y(u, i.scrollX, i.scrollY);
                }
            }
        }
    }, !0), null === (v = o.contentDocument) || void 0 === v || v.addEventListener("click", ee), null === (p = o.contentDocument) || void 0 === p || p.addEventListener("keydown", ne), null === (m = o.contentDocument) || void 0 === m || m.addEventListener("keyup", re), null === (y = o.contentDocument) || void 0 === y || y.addEventListener("change", ie), null === (g = o.contentDocument) || void 0 === g || g.addEventListener("focusin", ae), null === (w = o.contentDocument) || void 0 === w || w.addEventListener("focusout", ce), null === (b = o.contentDocument) || void 0 === b || b.addEventListener("dragstart", se), null === (A = o.contentDocument) || void 0 === A || A.addEventListener("dragend", le), null === (C = o.contentDocument) || void 0 === C || C.addEventListener("mousedown", _), null === (x = o.contentDocument) || void 0 === x || x.addEventListener("mouseup", $), null === (S = o.contentDocument) || void 0 === S || S.addEventListener("submit", ue), null === (E = o.contentDocument) || void 0 === E || E.addEventListener("selectionchange", function(e) {
        var t;
        if (o.contentWindow && !(e.timeStamp - j > 50)) {
            clearTimeout(o.contentWindow.__recentAgentSelectionChangeTimeout), o.contentWindow.__recentAgentSelectionChangeTimeout = setTimeout(function() {
                var e;
                null === (e = o.contentWindow) || void 0 === e || delete e.__recentAgentSelectionChangeTimeout;
            }, 200 + (null !== (t = s.current) && void 0 !== t ? t : 300));
            var n = o.contentWindow.getSelection(), r = (null == n ? void 0 : n.anchorNode) && $81cb1647619a2ab5$var$Qt(n.anchorNode), i = (null == n ? void 0 : n.focusNode) && $81cb1647619a2ab5$var$Qt(n.focusNode);
            if ((null == n ? void 0 : n.anchorNode) && n.focusNode && r && i) {
                var a = $81cb1647619a2ab5$var$ur(n.anchorNode, n.anchorOffset);
                if (n.isCollapsed) {
                    var c = $81cb1647619a2ab5$var$en(n.anchorNode) ? n.anchorNode.parentElement : n.anchorNode;
                    return (null == c ? void 0 : c.isContentEditable) ? void de({
                        caretNodeId: r,
                        caretOffset: a,
                        collapsed: !0
                    }) : void de({
                        collapsed: !0
                    });
                }
                var l = $81cb1647619a2ab5$var$ur(n.focusNode, n.focusOffset);
                de({
                    anchorNodeId: r,
                    anchorOffset: a,
                    collapsed: !1,
                    focusNodeId: i,
                    focusOffset: l
                });
            } else de({
                collapsed: !0
            });
        }
    }), null === (I = o.contentDocument) || void 0 === I || I.addEventListener("mouseover", fe), null === (k = o.contentDocument) || void 0 === k || k.addEventListener("play", he, !0), null === (O = o.contentDocument) || void 0 === O || O.addEventListener("pause", he, !0), null === (D = o.contentDocument) || void 0 === D || D.addEventListener("seeked", he, !0), null === (z = o.contentDocument) || void 0 === z || z.addEventListener("ratechange", he, !0), null === (M = o.contentDocument) || void 0 === M || M.addEventListener("volumechange", he, !0), o === n && (null === (B = o.contentDocument) || void 0 === B || B.addEventListener("mouseleave", function(e) {
        var t;
        r.disableCursor(i.current.uniqueConnectionId), null === (t = o.contentDocument) || void 0 === t || t.documentElement.removeAttribute("upscope-cursor-mode"), $81cb1647619a2ab5$var$xo(o, null, "agent"), X = e.timeStamp;
    }));
    for(var pe = $81cb1647619a2ab5$var$ir([], $81cb1647619a2ab5$var$rr(null !== (F = null === (L = o.contentDocument) || void 0 === L ? void 0 : L.querySelectorAll("*")) && void 0 !== F ? F : []), !1); pe.length > 0;){
        var me = pe.pop();
        me.shadowRoot && (ve(me.shadowRoot), pe.push.apply(pe, $81cb1647619a2ab5$var$ir([], $81cb1647619a2ab5$var$rr(me.shadowRoot.querySelectorAll("*")), !1)));
    }
    var ye = o.contentWindow.HTMLElement.prototype.attachShadow;
    o.contentWindow.HTMLElement.prototype.attachShadow = function(e) {
        var t = ye.call(this, e);
        return ve(t), t;
    }, null === (P = o.contentDocument) || void 0 === P || P.querySelectorAll("iframe,frame").forEach(function(o) {
        $81cb1647619a2ab5$var$sr(e, t, n, o, r, i, a, c, s, l);
    });
}
function $81cb1647619a2ab5$var$lr(e, t, n, o, r) {
    var i, a, c;
    if (e.contentDocument) {
        var s = $81cb1647619a2ab5$var$ir([], $81cb1647619a2ab5$var$rr(e.contentDocument.querySelectorAll("#upscope___remote-control-container")), !1).map(function(e) {
            var t;
            return null !== (t = e.shadowRoot) && void 0 !== t ? t : e;
        });
        try {
            for(var l = $81cb1647619a2ab5$var$or(s), u = l.next(); !u.done; u = l.next()){
                var d = u.value.querySelector("#upscope___cursor__" + n);
                d && (null === (c = t.contentDocument) || void 0 === c || c.documentElement.setAttribute("upscope-cursor-mode", "true"), d.__positionUpdated = !0, d.style.left = "".concat(o, "px"), d.style.top = "".concat(r, "px"), d.style.left === "".concat(o, "px") && d.style.top === "".concat(r, "px") ? d.__positionUpdated = !0 : d.__positionUpdated = !1);
            }
        } catch (e) {
            i = {
                error: e
            };
        } finally{
            try {
                u && !u.done && (a = l.return) && a.call(l);
            } finally{
                if (i) throw i.error;
            }
        }
    }
}
function $81cb1647619a2ab5$var$ur(e, t) {
    if (!$81cb1647619a2ab5$var$en(e)) return t;
    for(var n = t, o = e.previousSibling; o && ($81cb1647619a2ab5$var$en(o) || $81cb1647619a2ab5$var$Yt(o));)$81cb1647619a2ab5$var$en(o) && (n += o.length), o = o.previousSibling;
    return n;
}
var $81cb1647619a2ab5$var$dr = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
};
function $81cb1647619a2ab5$var$fr(t) {
    var n = $81cb1647619a2ab5$var$dr((0, $acw62.useState)(!1), 2), r = n[0], i = n[1], a = (0, $acw62.useRef)(r), l = (0, $acw62.useRef)(null);
    function u(e, n) {
        return $81cb1647619a2ab5$var$tr($81cb1647619a2ab5$var$_o(t.iframeNode, {
            x: e,
            y: n
        }));
    }
    (0, $acw62.useEffect)(function() {
        a.current = r;
    }, [
        r
    ]), (0, $acw62.useEffect)(function() {
        return function() {
            a.current && t.serverConnection.disableCursor(t.uniqueConnectionId);
        };
    }, [
        t.serverConnection,
        t.uniqueConnectionId
    ]);
    var d = (0, $d1809cb5a91ef255$export$7158785e55df0693)(function(e) {
        if (a.current && l.current) {
            var n = $81cb1647619a2ab5$var$$o(l.current, t.scale, e), o = n.x, r = n.y;
            t.serverConnection.moveCursor(t.uniqueConnectionId, t.color, o, r, u(o, r)), $81cb1647619a2ab5$var$lr(t.iframeNode, t.iframeNode, t.viewerConnectionId, o, r);
        }
    }, [
        t.serverConnection,
        t.color,
        t.iframeNode,
        t.viewerConnectionId,
        t.scale
    ], 100);
    function f(e) {
        if (l.current) {
            i(!0);
            var n = $81cb1647619a2ab5$var$$o(l.current, t.scale, e), o = n.x, r = n.y;
            t.serverConnection.moveCursor(t.uniqueConnectionId, t.color, o, r, u(o, r)), $81cb1647619a2ab5$var$lr(t.iframeNode, t.iframeNode, t.viewerConnectionId, o, r);
        }
    }
    function h() {
        r && (i(!1), t.serverConnection.disableCursor(t.uniqueConnectionId));
    }
    return (0, $ayMG0.jsx)("div", {
        onMouseDown: t.onControlAttempt,
        onMouseEnter: f,
        onMouseLeave: h,
        onMouseMove: d,
        onTouchEnd: h,
        onTouchMove: d,
        onTouchStart: f,
        ref: l,
        style: {
            cursor: "none",
            height: t.height,
            left: 0,
            position: "absolute",
            top: 0,
            touchAction: "none",
            transform: "scale(".concat(t.scale, ")"),
            transformOrigin: "top left",
            userSelect: "none",
            width: t.width
        }
    });
}
function $81cb1647619a2ab5$var$hr(e, t, n) {
    if (void 0 === n && (n = !1), e.length <= 1) return e;
    var o = void 0 === t ? 1 : t * t;
    return e = n ? e : function(e, t) {
        if (e.length <= 2) return e;
        for(var n, o = e[0], r = [
            o
        ], i = 1; i < e.length; i++)$81cb1647619a2ab5$var$vr(n = e[i], o) > t && (r.push(n), o = n);
        o !== n && r.push(n);
        return r;
    }(e, o), e = function(e, t) {
        var n, o, r, i, a = e.length, c = new ("undefined" == typeof Uint8Array ? Array : Uint8Array)(a), s = [], l = [], u = 0, d = a - 1;
        c[u] = 1, c[d] = 1;
        for(; d;){
            for(o = 0, n = u + 1; n < d; n++)(r = $81cb1647619a2ab5$var$pr(e[n], e[u], e[d])) > o && (i = n, o = r);
            o > t && (c[i] = 1, s.push(u, i, i, d)), d = s.pop(), u = s.pop();
        }
        for(n = 0; n < a; n++)c[n] && l.push(e[n]);
        return l;
    }(e, o), e;
}
function $81cb1647619a2ab5$var$vr(e, t) {
    var n = e.x - t.x, o = e.y - t.y;
    return n * n + o * o;
}
function $81cb1647619a2ab5$var$pr(e, t, n) {
    var o = t.x, r = t.y, i = n.x - o, a = n.y - r;
    if (0 !== i || 0 !== a) {
        var c = ((e.x - o) * i + (e.y - r) * a) / (i * i + a * a);
        c > 1 ? (o = n.x, r = n.y) : c > 0 && (o += i * c, r += a * c);
    }
    return (i = e.x - o) * i + (a = e.y - r) * a;
}
var $81cb1647619a2ab5$var$mr = "http://www.w3.org/2000/svg";
function $81cb1647619a2ab5$var$yr(e, t) {
    void 0 === t && (t = .3);
    var n = e.length;
    if (0 === n) return null;
    var o = e[0];
    if (1 === n) return "M".concat(o[0], ",").concat(o[1], "Z");
    if (2 === n) {
        var r = e[1];
        return "M".concat(o[0], ",").concat(o[1], "L").concat(r[0], ",").concat(r[1]);
    }
    for(var i = (1 - t) / 6, a = "M".concat(o[0], ",").concat(o[1]), c = 0; c < n - 1; c++){
        var s = e[c], l = e[c + 1], u = 0 === c ? s[0] : s[0] + i * (l[0] - e[c - 1][0]), d = 0 === c ? s[1] : s[1] + i * (l[1] - e[c - 1][1]), f = c === n - 2 ? l[0] : l[0] + i * (s[0] - e[c + 2][0]), h = c === n - 2 ? l[1] : l[1] + i * (s[1] - e[c + 2][1]);
        a += "C".concat(u, ",").concat(d, ",").concat(f, ",").concat(h, ",").concat(l[0], ",").concat(l[1]);
    }
    return a;
}
function $81cb1647619a2ab5$var$gr(e, t, n, r, i, a) {
    (0, $acw62.useEffect)(function() {
        if (t && n) {
            var o = 0, c = 0, s = null, l = $81cb1647619a2ab5$var$ze(function() {
                var e = s && "dataset" in s ? s.__elementID : void 0;
                e && r.scroll(i, e, o, c, "wheel"), o = 0, c = 0, s = null;
            }, 100, 100), u = function(r) {
                if (r.preventDefault(), e) {
                    var i = $81cb1647619a2ab5$var$$o(t, a, r);
                    s = $81cb1647619a2ab5$var$_o(n, i), o += r.deltaX, c += r.deltaY, l();
                }
            };
            return t.addEventListener("wheel", u, {
                passive: !1
            }), function() {
                t.removeEventListener("wheel", u);
            };
        }
    }, [
        e,
        t,
        n,
        r,
        i,
        a
    ]);
}
var $81cb1647619a2ab5$var$wr = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
};
function $81cb1647619a2ab5$var$br(t) {
    var n = $81cb1647619a2ab5$var$wr((0, $acw62.useState)(!1), 2), r = n[0], i = n[1], a = (0, $acw62.useRef)(null), l = (0, $acw62.useRef)(t);
    return (0, $acw62.useEffect)(function() {
        l.current = t;
    }), $81cb1647619a2ab5$var$gr(t.scrollable && !r, a.current, t.iframeNode, t.serverConnection, t.uniqueConnectionId, t.scale), (0, $acw62.useEffect)(function() {
        var e = function(e, t) {
            var n, o, r = !1, i = [], a = e.ownerDocument, c = null !== (n = a.defaultView) && void 0 !== n ? n : window, s = a.createElementNS($81cb1647619a2ab5$var$mr, "svg");
            s.style.position = "absolute", s.style.inset = "0", s.style.width = "100%", s.style.height = "100%", s.style.pointerEvents = "none";
            var l = a.createElementNS($81cb1647619a2ab5$var$mr, "path");
            function u(e) {
                var n;
                r !== e && (r = e, null === (n = t.onDrawingChange) || void 0 === n || n.call(t, e));
            }
            function d() {
                var n, o;
                if (r && 0 !== i.length) {
                    var a = null !== (n = t.previewPoint) && void 0 !== n ? n : function(e) {
                        return [
                            e.x,
                            e.y
                        ];
                    }, c = t.makePath(i.map(function(t) {
                        return a(t, e);
                    }));
                    null !== c ? (l.setAttribute("d", c), l.style.stroke = t.color, l.style.strokeWidth = String(null !== (o = t.strokeWidth) && void 0 !== o ? o : 14)) : l.removeAttribute("d");
                } else l.removeAttribute("d");
            }
            function f(e) {
                return "touches" in e && e.touches.length > 1;
            }
            function h(e) {
                var n, o, r;
                (null === (n = t.guards) || void 0 === n ? void 0 : n.ignoreMultiTouch) && f(e) || (null === (o = t.guards) || void 0 === o ? void 0 : o.ignoreModifierKeys) && (e.metaKey || e.ctrlKey) || (e.preventDefault(), i = [], u(!0), null === (r = t.onStart) || void 0 === r || r.call(t), d());
            }
            function v(n) {
                var o;
                (null === (o = t.guards) || void 0 === o ? void 0 : o.ignoreMultiTouch) && f(n) || (n.preventDefault(), r && (i.push(t.capturePoint(n, e)), d()));
            }
            function p(e) {
                r ? (i.length > 1 && t.onStroke($81cb1647619a2ab5$var$hr(i, t.tolerance)), i = [], u(!1), d()) : e.preventDefault();
            }
            function m(e) {
                1 === e.touches.length && e.preventDefault();
            }
            return l.style.fill = "none", l.style.opacity = "0.3", l.style.strokeLinecap = "round", l.style.strokeLinejoin = "round", s.append(l), e.append(s), e.addEventListener("mousedown", h), e.addEventListener("mousemove", v), e.addEventListener("mouseup", p), e.addEventListener("mouseleave", p), e.addEventListener("touchstart", h, {
                passive: !1
            }), e.addEventListener("touchmove", v, {
                passive: !1
            }), e.addEventListener("touchend", p), e.addEventListener("touchcancel", p), (null === (o = t.guards) || void 0 === o ? void 0 : o.preventTouchScroll) && c.addEventListener("touchmove", m, {
                passive: !1
            }), {
                destroy: function() {
                    var n;
                    e.removeEventListener("mousedown", h), e.removeEventListener("mousemove", v), e.removeEventListener("mouseup", p), e.removeEventListener("mouseleave", p), e.removeEventListener("touchstart", h), e.removeEventListener("touchmove", v), e.removeEventListener("touchend", p), e.removeEventListener("touchcancel", p), (null === (n = t.guards) || void 0 === n ? void 0 : n.preventTouchScroll) && c.removeEventListener("touchmove", m), s.remove();
                }
            };
        }(a.current, {
            capturePoint: function(e, t) {
                return $81cb1647619a2ab5$var$$o(t, l.current.scale, e);
            },
            get color () {
                return l.current.color;
            },
            makePath: $81cb1647619a2ab5$var$yr,
            onDrawingChange: i,
            onStroke: function(e) {
                var t = $81cb1647619a2ab5$var$yr(e.map(function(e) {
                    return [
                        e.x,
                        e.y
                    ];
                })), n = $81cb1647619a2ab5$var$tr(l.current.iframeNode && $81cb1647619a2ab5$var$_o(l.current.iframeNode, e[e.length - 1]));
                l.current.serverConnection.drawLine(l.current.uniqueConnectionId, {
                    color: l.current.color,
                    path: t
                }, n);
            }
        });
        return e.destroy;
    }, []), (0, $ayMG0.jsx)("div", {
        ref: a,
        style: {
            height: t.height,
            left: 0,
            position: "absolute",
            top: 0,
            touchAction: "none",
            transform: "scale(".concat(t.scale, ")"),
            transformOrigin: "top left",
            userSelect: "none",
            width: t.width
        }
    });
}
var $81cb1647619a2ab5$var$Ar = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
};
var $5115beacd0857e59$exports = {};
$5115beacd0857e59$exports = import.meta.resolve("k6HHg");


var $484970fe81816e10$exports = {};
$484970fe81816e10$exports = import.meta.resolve("dte9j");


function $81cb1647619a2ab5$var$Cr(t) {
    var n = $81cb1647619a2ab5$var$Ar((0, $acw62.useState)(!1), 2), o = n[0], r = n[1], i = (0, $acw62.useRef)(o), a = (0, $acw62.useRef)(null);
    function l(e, n) {
        return $81cb1647619a2ab5$var$tr($81cb1647619a2ab5$var$_o(t.iframeNode, {
            x: e,
            y: n
        }));
    }
    function d(e) {
        if (a.current) {
            var n = $81cb1647619a2ab5$var$$o(a.current, t.scale, e), i = n.x, c = n.y;
            if (o) return t.serverConnection.disablePointer(t.uniqueConnectionId), void r(!1);
            (function() {
                var e, n, o = null === (e = t.iframeNode.contentDocument) || void 0 === e ? void 0 : e.getElementById("upscope___overlay");
                return null !== (n = null == o ? void 0 : o.className.includes("upscope___overlay--show")) && void 0 !== n && n;
            })() || (r(!0), t.serverConnection.movePointer(t.uniqueConnectionId, i, c, l(i, c)));
        }
    }
    (0, $acw62.useLayoutEffect)(function() {
        i.current = o;
    }, [
        o
    ]), $81cb1647619a2ab5$var$gr(t.scrollable, a.current, t.iframeNode, t.serverConnection, t.uniqueConnectionId, t.scale);
    var f = (0, $d1809cb5a91ef255$export$7158785e55df0693)(function(e) {
        if (i.current && a.current) {
            var n = $81cb1647619a2ab5$var$$o(a.current, t.scale, e), o = n.x, r = n.y;
            t.serverConnection.movePointer(t.uniqueConnectionId, o, r, l(o, r));
        }
    }, [
        t.serverConnection
    ], 100);
    function h() {
        o && (r(!1), t.serverConnection.disablePointer(t.uniqueConnectionId));
    }
    var v = new URL($5115beacd0857e59$exports).href, p = new URL($484970fe81816e10$exports).href;
    return (0, $ayMG0.jsx)("div", {
        onMouseDown: d,
        onMouseLeave: h,
        onMouseMove: f,
        onTouchEnd: h,
        onTouchMove: f,
        onTouchStart: d,
        ref: a,
        style: {
            cursor: "image-set(url(".concat(v, ") 1x, url(").concat(p, ") 2x) 11 11, auto"),
            height: t.height,
            left: 0,
            position: "absolute",
            top: 0,
            touchAction: "none",
            transform: "scale(".concat(t.scale, ")"),
            transformOrigin: "top left",
            userSelect: "none",
            width: t.width
        }
    });
}
var $81cb1647619a2ab5$var$xr = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
};
function $81cb1647619a2ab5$var$Sr(e) {
    var t = $81cb1647619a2ab5$var$xr(e.split(":"), 2), n = t[0], o = t[1];
    return [
        n,
        parseInt(o)
    ];
}
function $81cb1647619a2ab5$var$Er(e, t) {
    return void 0 === t && (t = !1), "snapShot" === e.type || "pageLoad" === e.type && (t || "root" === e.iframeId);
}
function $81cb1647619a2ab5$var$Ir(e) {
    var t = e.serverConnection;
    return (0, $acw62.useEffect)(function() {
        var e = function() {
            t.reportDocumentVisibilityChange(!document.hidden);
        };
        return document.addEventListener("visibilitychange", e), function() {
            document.removeEventListener("visibilitychange", e);
        };
    }, [
        t
    ]), null;
}
var $81cb1647619a2ab5$var$kr = function() {
    return $81cb1647619a2ab5$var$kr = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $81cb1647619a2ab5$var$kr.apply(this, arguments);
}, $81cb1647619a2ab5$var$Or = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$Dr = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$zr = function(e, t) {
    var n = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;
        for(o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
    }
    return n;
}, $81cb1647619a2ab5$var$Mr = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$Br = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $81cb1647619a2ab5$var$Lr = function(e, t, n) {
    if (n || 2 === arguments.length) for(var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
    return e.concat(o || Array.prototype.slice.call(t));
}, $81cb1647619a2ab5$var$Fr = $81cb1647619a2ab5$var$ce("viewer:connectionFrame");
function $81cb1647619a2ab5$var$Pr(n) {
    var r = this, u = n.setPendingEvents, d = n.uniqueConnectionId, f = $81cb1647619a2ab5$var$zr(n, [
        "setPendingEvents",
        "uniqueConnectionId"
    ]), h = (0, $acw62.useContext)($81cb1647619a2ab5$export$9799878dee66ae0f), m = h.connections, y = h.dataBounceSpeed, g = h.errorHandler, w = h.serverConnection, b = h.session, A = h.setConnectionsLastLoadCompletedAt, C = h.setConsoleLogs, x = h.setNoContentUnknownIframesPresent, S = h.setSizes, E = h.viewerConnectionId, I = h.waitingForceRefresh, k = (0, $acw62.useRef)(null), O = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(), 2), D = O[0], z = O[1], M = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(null), 2), B = M[0], L = M[1], F = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(!1), 2), P = F[0], V = F[1], T = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)({}), 2), j = T[0], R = T[1], X = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)({}), 2), N = X[0], U = X[1], G = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(!1), 2), H = G[0], q = G[1], W = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(!1), 2), Q = W[0], Y = W[1], Z = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(!1), 2), K = Z[0], J = Z[1], _ = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(void 0), 2), $ = _[0], ee = _[1], te = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(void 0), 2), ne = te[0], oe = te[1], re = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(!1), 2), ie = re[0], ae = re[1], ce = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(!1), 2), se = ce[0], le = ce[1], ue = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(!1), 2), de = ue[0], fe = ue[1], he = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(), 2), ve = he[0], pe = he[1], me = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(void 0), 2), ye = me[0], ge = me[1], we = $81cb1647619a2ab5$var$Mr((0, $acw62.useState)(null), 2), be = we[0], Ae = we[1], Ce = (0, $acw62.useRef)(K);
    (0, $acw62.useEffect)(function() {
        Ce.current = K;
    }, [
        K
    ]);
    var xe = m.find(function(e) {
        return e.uniqueConnectionId === d;
    }), Se = (0, $acw62.useRef)(xe);
    (0, $acw62.useEffect)(function() {
        Se.current = xe;
    }, [
        xe
    ]);
    var Ee = (0, $acw62.useRef)(b);
    (0, $acw62.useEffect)(function() {
        Ee.current = b;
    }, [
        b
    ]);
    var Ie = (0, $acw62.useRef)(f.color);
    (0, $acw62.useEffect)(function() {
        Ie.current = f.color;
    });
    var ke = (0, $acw62.useRef)(y);
    (0, $acw62.useEffect)(function() {
        ke.current = y;
    }, [
        y
    ]);
    var Oe = (0, $acw62.useRef)(null !== f.controlTool);
    (0, $acw62.useEffect)(function() {
        Oe.current = null !== f.controlTool;
    });
    var De = (0, $acw62.useMemo)(function() {
        return f.pendingEvents.filter(function(e) {
            return e.uniqueConnectionId === d;
        });
    }, [
        f.pendingEvents,
        d
    ]), ze = De.length > 0, Me = (0, $acw62.useMemo)(function() {
        var e, t = De;
        if (void 0 === $) return $81cb1647619a2ab5$var$Nn(De, function(e) {
            return $81cb1647619a2ab5$var$Er(e);
        });
        t = De.filter(function(e) {
            var t = $81cb1647619a2ab5$var$Mr($81cb1647619a2ab5$var$Sr(e.id), 2), n = t[0], o = t[1];
            return n !== ne ? $81cb1647619a2ab5$var$Er(e) : o > $;
        }), t.sort(function(e, t) {
            return $81cb1647619a2ab5$var$Sr(e.id)[1] - $81cb1647619a2ab5$var$Sr(t.id)[1];
        });
        var n = $81cb1647619a2ab5$var$Nn(t, function(e) {
            return $81cb1647619a2ab5$var$Sr(e.id)[0] !== ne;
        });
        if (n) return n;
        var o = $ + 1;
        if (H) {
            var r = $81cb1647619a2ab5$var$Nn(t, function(e) {
                return $81cb1647619a2ab5$var$Er(e);
            });
            if (r) return r;
        } else "snapShot" === (null === (e = t[0]) || void 0 === e ? void 0 : e.type) && $81cb1647619a2ab5$var$Sr(t[0].id)[0] === ne && (t.shift(), o++);
        return t[0] && $81cb1647619a2ab5$var$Sr(t[0].id)[1] === o ? t[0] : void 0;
    }, [
        De,
        $,
        ne,
        H
    ]), Be = (0, $acw62.useCallback)(function(e, t) {
        return $81cb1647619a2ab5$var$Or(r, void 0, void 0, function() {
            var n;
            return $81cb1647619a2ab5$var$Dr(this, function(o) {
                return (n = j[t]) ? ($81cb1647619a2ab5$var$Fr("Attempting to perform a pageLoad event that was stored from earlier."), R(function(e) {
                    var n = e, o = t;
                    return n[o], $81cb1647619a2ab5$var$zr(n, [
                        "symbol" == typeof o ? o : o + ""
                    ]);
                }), n.data.assets = $81cb1647619a2ab5$var$kr($81cb1647619a2ab5$var$kr({}, n.data.assets), N), U(n.data.assets), [
                    2,
                    $81cb1647619a2ab5$var$Ko(e, n).catch(function(e) {
                        $81cb1647619a2ab5$var$Fr.warning("Error performing a stored pageLoad event %o.", e);
                    })
                ]) : [
                    2
                ];
            });
        });
    }, [
        j,
        N
    ]), Le = (0, $acw62.useCallback)(function(e) {
        var t, n, o, r, i;
        if (!Ce.current) {
            $81cb1647619a2ab5$var$Fr("Checking if the page CSS has loaded correctly");
            var a = null === (o = e.contentDocument) || void 0 === o ? void 0 : o.querySelector('[upscope-viewer-element="viewer-adjustment-stylesheet"]');
            if (a && !1 !== a.__loaded) try {
                for(var c = $81cb1647619a2ab5$var$Br(e.contentDocument.querySelectorAll('link[rel="stylesheet"], style')), s = c.next(); !s.done; s = c.next()){
                    var l = s.value;
                    if (!1 === l.__loaded) {
                        Se.current.assetsProxyConfigured ? $81cb1647619a2ab5$var$Fr.warning("Stylesheet %s hasn't loaded, but the assets to proxy have been pre-configured so we'll ignore it.", null !== (r = l.getAttribute("href")) && void 0 !== r ? r : l.__elementID) : ($81cb1647619a2ab5$var$Fr.warning("Stylesheet %s hasn't loaded. Will request snapshot with assets.", null !== (i = l.getAttribute("href")) && void 0 !== i ? i : l.__elementID), J(!0), q(!0));
                        break;
                    }
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    s && !s.done && (n = c.return) && n.call(c);
                } finally{
                    if (t) throw t.error;
                }
            }
            else $81cb1647619a2ab5$var$Fr.warning("We cannot determine if stylesheets have loaded correctly.");
        }
    }, []), Fe = (0, $acw62.useCallback)(function(e, t) {
        "root" === e.iframeId && (C(function(t) {
            var n, o;
            return $81cb1647619a2ab5$var$kr($81cb1647619a2ab5$var$kr({}, t), ((n = {})[d] = null !== (o = e.data.console) && void 0 !== o ? o : [], n));
        }), "pageLoad" === e.type && J(!1), setTimeout(function() {
            Le(t);
        }, 3e3)), $81cb1647619a2ab5$var$sr(E, g, k.current, t, w, Se, Ee, Ie, ke, Oe), setTimeout(function() {
            $81cb1647619a2ab5$var$Gn(t);
        }, 1e3);
    }, [
        Le,
        g,
        E,
        w,
        C,
        d
    ]), Pe = (0, $acw62.useCallback)(function(e, t) {
        var n, o;
        if ("root" === e.iframeId) {
            var r = $81cb1647619a2ab5$var$Lr([], $81cb1647619a2ab5$var$Mr(null !== (o = null === (n = t.contentDocument) || void 0 === n ? void 0 : n.querySelectorAll("iframe,frame")) && void 0 !== o ? o : []), !1);
            x(function(e) {
                return $81cb1647619a2ab5$var$Lr($81cb1647619a2ab5$var$Lr([], $81cb1647619a2ab5$var$Mr(e.filter(function(e) {
                    return e !== d;
                })), !1), [
                    r.some(function(e) {
                        return !e.__upscopeViewerIframeIgnorable && "no_content:unknown" === e.__upscopeViewerIframeContentStatus;
                    }) ? d : void 0
                ], !1).filter(Boolean);
            });
        }
    }, [
        d,
        x
    ]), Ve = (0, $acw62.useCallback)(function(e) {
        C(function(t) {
            var n, o = t[d] || [];
            return $81cb1647619a2ab5$var$kr($81cb1647619a2ab5$var$kr({}, t), ((n = {})[d] = $81cb1647619a2ab5$var$Lr($81cb1647619a2ab5$var$Lr([], $81cb1647619a2ab5$var$Mr(o), !1), [
                e.data
            ], !1), n));
        });
    }, [
        C,
        d
    ]), Te = (0, $acw62.useCallback)(function(e) {
        if (-1 !== e.data.x || -1 !== e.data.y) {
            k.current.contentWindow.__lastUserInteractionAt = Date.now();
            var t = e.data, n = t.x, o = t.y, r = "string" == typeof e.data.hoverElementId ? $81cb1647619a2ab5$var$Xt(k.current, e.data.hoverElementId) : null;
            r && ge(r);
            var i = $81cb1647619a2ab5$var$jn(e, k.current);
            if (i) {
                var a = i.cursorOffsetX, c = i.cursorOffsetY, s = i.internalScale;
                n = Math.floor(n * s) + a, o = Math.floor(o * s) + c;
            }
            if ("string" == typeof e.data.hoverElementId && r) {
                var l = $81cb1647619a2ab5$var$er(r);
                l.isVisible && (n += l.x - e.data.hoverX, o += l.y - e.data.hoverY);
            }
            L(function(e) {
                var t;
                return {
                    cursorType: null !== (t = null != ve ? ve : null == e ? void 0 : e.cursorType) && void 0 !== t ? t : "default",
                    x: n,
                    y: o
                };
            });
        } else L(null);
    }, [
        ve
    ]), je = (0, $acw62.useCallback)(function(e) {
        "pageLoad" === e.type ? ($81cb1647619a2ab5$var$Fr("A pageLoad event could not be performed because the iframe does not exist. Will store for later."), R(function(t) {
            var n;
            return $81cb1647619a2ab5$var$kr($81cb1647619a2ab5$var$kr({}, t), ((n = {})[e.iframeId] = e, n));
        })) : $81cb1647619a2ab5$var$Fr.warning("Could not find iframe (%s) for event (%o)", e.iframeId, e);
    }, []), Re = (0, $acw62.useCallback)(function(e) {
        return $81cb1647619a2ab5$var$Or(r, void 0, void 0, function() {
            var t, n, o, r, i, a, c, s, l, u, d, f;
            return $81cb1647619a2ab5$var$Dr(this, function(h) {
                switch(h.label){
                    case 0:
                        if ("mouseMove" === e.type) return Te(e), [
                            2
                        ];
                        if ("click" === e.type) return V(!0), [
                            2
                        ];
                        if ("console" === e.type) return Ve(e), [
                            2
                        ];
                        if ("visualViewportChange" === e.type) return t = e.data, n = t.height, o = t.scale, r = t.width, i = t.x, a = t.y, Ae(o > 1 ? {
                            height: n,
                            scale: o,
                            width: r,
                            x: i,
                            y: a
                        } : null), [
                            2
                        ];
                        if ("object" == typeof e.data && "assets" in e.data && (c = $81cb1647619a2ab5$var$kr($81cb1647619a2ab5$var$kr({}, N), e.data.assets), U(c), e.data.assets = c), !(s = $81cb1647619a2ab5$var$jn(e, k.current))) return je(e), [
                            2
                        ];
                        l = s.targetIframe, h.label = 1;
                    case 1:
                        return h.trys.push([
                            1,
                            ,
                            4,
                            5
                        ]), [
                            4,
                            Be(l, e.iframeId)
                        ];
                    case 2:
                        return h.sent(), [
                            4,
                            $81cb1647619a2ab5$var$Ko(l, e)
                        ];
                    case 3:
                        return h.sent(), $81cb1647619a2ab5$var$Rn.includes(e.type) && "root" === e.iframeId && (d = "windowSize" in (u = e).data ? u.data.windowSize : u.data, z({
                            height: d.h,
                            width: d.w
                        }), "visualViewport" in u.data && Ae(null !== (f = u.data.visualViewport) && void 0 !== f ? f : null)), [
                            3,
                            5
                        ];
                    case 4:
                        return $81cb1647619a2ab5$var$Er(e, !0) && Fe(e, l), Pe(e, l), [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    }, [
        Be,
        Ve,
        Fe,
        Pe,
        N,
        Te
    ]), Xe = (0, $acw62.useCallback)(function(e) {
        var t = $81cb1647619a2ab5$var$Mr($81cb1647619a2ab5$var$Sr(e.id), 2), n = t[0], o = t[1], r = $81cb1647619a2ab5$var$Er(e);
        u(function(e) {
            return e.filter(function(e) {
                if (e.uniqueConnectionId !== d) return !0;
                var t = $81cb1647619a2ab5$var$Mr($81cb1647619a2ab5$var$Sr(e.id), 2), i = t[0], a = t[1];
                return (!r || n === i) && a > o;
            });
        }), ee(o), oe(n), ae(!1);
    }, [
        u,
        d
    ]);
    (0, $acw62.useEffect)(function() {
        Me ? ie || (Y(!1), $81cb1647619a2ab5$var$Er(Me) && (q(!1), fe(!0), "root:0" === Me.id && le(!1)), ae(!0), Re(Me).then(function() {
            $81cb1647619a2ab5$var$Er(Me) && (le(!0), A(function(e) {
                var t;
                return $81cb1647619a2ab5$var$kr($81cb1647619a2ab5$var$kr({}, e), ((t = {})[d] = new Date, t));
            }));
        }).catch(function(e) {
            $81cb1647619a2ab5$var$Fr.warning("Error processing event %o", e), [
                "domChange",
                "pageLoad",
                "snapShot"
            ].includes(Me.type) && q(!0);
        }).finally(function() {
            Xe(Me);
        })) : Y(De.length > 0);
    }, [
        De,
        Me,
        ie,
        d,
        A,
        Xe,
        Re
    ]), (0, $acw62.useEffect)(function() {
        I && q(!0);
    }, [
        I
    ]), (0, $acw62.useEffect)(function() {
        H && (null == w || w.askSnapshot(d, K));
    }, [
        H,
        K,
        d,
        w
    ]), (0, $4d7918fb3900970c$export$4ea291cd4ec501ea)(function() {
        $81cb1647619a2ab5$var$Fr("After 5 seconds of the queue being stuck, we request a snapshot"), q(!0);
    }, Q ? 5e3 : void 0), (0, $4d7918fb3900970c$export$4ea291cd4ec501ea)(function() {
        $81cb1647619a2ab5$var$Fr("After 10 seconds of not receiving a snapshot, we request a snapshot"), q(!0);
    }, de ? void 0 : 1e4), (0, $4d7918fb3900970c$export$4ea291cd4ec501ea)(function() {
        $81cb1647619a2ab5$var$Gn(k.current);
    }, ze ? void 0 : 50), (0, $063d99a411e6854f$export$44b55d93c84df466)(function() {
        if (ye && !ve) {
            var e = function(e) {
                var t, n = 1 === e.nodeType ? null === (t = e.ownerDocument.defaultView) || void 0 === t ? void 0 : t.getComputedStyle(e).cursor : "auto";
                return "auto" === n && 1 === e.nodeType && ("A" === e.tagName || "BUTTON" === e.tagName || "INPUT" === e.tagName && "submit" === e.type) || "pointer" === n ? "pointer" : "default";
            }(ye);
            L(function(t) {
                return t ? $81cb1647619a2ab5$var$kr($81cb1647619a2ab5$var$kr({}, t), {
                    cursorType: e
                }) : null;
            });
        }
    }, [
        ye,
        ve
    ], 200), (0, $acw62.useEffect)(function() {
        var e;
        if (se && (null === (e = k.current) || void 0 === e ? void 0 : e.contentDocument)) {
            var t = function(e) {
                var t = e.querySelector("[data-upscope-enlarged-cursor-color]");
                if (null == t ? void 0 : t.dataset.upscopeEnlargedCursorColor) return {
                    svg: "data:image/svg+xml;base64,".concat(btoa('<svg width="29px" height="39px" viewBox="0 0 29 39" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M22.0377359,21.3349459 L16.4085968,21.3349459 L19.3824816,28.4981468 C19.4886918,28.7439431 19.4886918,28.9897387 19.3824816,29.2355351 C19.2762715,29.4813315 19.0992548,29.6568998 18.8514308,29.762241 L16.2492816,30.9209941 C16.0368612,31.0263353 15.8067394,31.0263353 15.5589154,30.9209941 C15.3110914,30.8156529 15.1340748,30.6400845 15.0278646,30.3942882 L12.213295,23.5997815 L7.59315257,28.2874644 C7.30992572,28.603488 6.97359297,28.6737151 6.58415594,28.4981468 C6.19471892,28.3225784 6,28.0241114 6,27.6027467 L6,4.9543911 C6,4.53302635 6.19471892,4.24333808 6.58415594,4.0853263 C6.97359297,3.92731451 7.30992572,3.98876381 7.59315257,4.26967338 L22.728102,19.7021575 C23.0113289,19.9830671 23.0732851,20.3254259 22.9139698,20.7292341 C22.7546546,21.1330423 22.4625766,21.3349459 22.0377359,21.3349459 Z" id="path-1"></path><filter x="-52.9%" y="-25.9%" width="205.9%" height="166.7%" filterUnits="objectBoundingBox" id="filter-2"><feMorphology radius="2" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology><feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset><feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur><feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"></feComposite><feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix></filter></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="m" fill-rule="nonzero"><use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use><path stroke="#FFFFFF" stroke-width="2" d="M17.9064919,22.3349459 L20.3004477,28.1014878 C20.5160364,28.6004131 20.5160364,29.1332688 20.3004477,29.632194 C20.0922256,30.114071 19.7263822,30.4769212 19.2582265,30.6757602 L16.6935608,31.8168825 C16.2094267,32.056969 15.6750953,32.056969 15.1677245,31.8413037 C14.683964,31.6356742 14.3181206,31.272824 14.1039943,30.776994 L11.8665846,25.3757789 L8.33784454,28.9548727 C7.76310634,29.5961637 6.95900423,29.764063 6.17316507,29.4097862 C5.42678447,29.0732984 5,28.4191189 5,27.6027467 L5,4.9543911 C5,4.1262685 5.44118974,3.46989866 6.20818129,3.15869635 C6.96247518,2.85264604 7.72495058,2.99195295 8.30710831,3.56948254 L23.4322983,18.9921522 C24.0074862,19.5626341 24.1463989,20.3302428 23.8441901,21.0962358 C23.5352294,21.8793426 22.8761449,22.3349459 22.0377359,22.3349459 L17.9064919,22.3349459 Z" fill="_CURSOR_COLOR_" fill-rule="evenodd"></path></g></g></svg>'.replace(/_CURSOR_COLOR_/g, t.dataset.upscopeEnlargedCursorColor)))
                };
            }(k.current.contentDocument);
            pe(t);
        }
    }, [
        se
    ]), (0, $4d7918fb3900970c$export$4ea291cd4ec501ea)(function() {
        P && V(!1);
    }, P ? 130 : void 0);
    var Ne = (0, $acw62.useMemo)(function() {
        if (!D) return 1;
        var e = function(e) {
            return 2 * Math.floor(e / 2);
        };
        return $81cb1647619a2ab5$var$Jo(e(D.width), e(D.height), e(f.maxWidth), e(f.maxHeight));
    }, [
        f.maxWidth,
        f.maxHeight,
        D
    ]);
    (0, $acw62.useEffect)(function() {
        D && S(function(e) {
            var t;
            return $81cb1647619a2ab5$var$kr($81cb1647619a2ab5$var$kr({}, e), ((t = {})[d] = {
                height: Math.floor(D.height * Ne),
                width: Math.floor(D.width * Ne)
            }, t));
        });
    }, [
        Ne,
        D,
        d,
        S
    ]);
    var Ue = (0, $acw62.useMemo)(function() {
        return D ? {
            height: "".concat(Math.floor(D.height * Ne), "px"),
            left: f.isActive ? "0px" : "-".concat(Math.floor(D.width * Ne), "px"),
            opacity: f.isActive ? 1 : 0,
            position: "absolute",
            top: f.isActive ? "0px" : "-".concat(Math.floor(D.height * Ne), "px"),
            width: "".concat(Math.floor(D.width * Ne), "px")
        } : {};
    }, [
        D,
        Ne,
        f.isActive
    ]), Ge = (0, $acw62.useMemo)(function() {
        return D ? {
            border: "none",
            height: "".concat(D.height, "px"),
            left: "0px",
            position: "absolute",
            top: "0px",
            transform: "scale(".concat(Ne, ")"),
            transformOrigin: "top left",
            width: "".concat(D.width, "px")
        } : {};
    }, [
        D,
        Ne
    ]), He = (0, $acw62.useCallback)(function() {
        "granted" !== (null == b ? void 0 : b.control) && (null == g || g("remote_control:inactive"));
    }, [
        null == b ? void 0 : b.control,
        g
    ]), qe = xe.allowRemoteClick || xe.allowRemoteScroll, We = "cursor" === f.controlTool && qe && "granted" === (null == b ? void 0 : b.control) && se && "active" === xe.status, Qe = (0, $acw62.useRef)(We);
    (0, $acw62.useEffect)(function() {
        Qe.current && !We && (null == w || w.disableCursor(d)), Qe.current = We;
    }, [
        We,
        w,
        d
    ]);
    var Ye;
    return (0, $ayMG0.jsxs)("div", {
        className: "viewer",
        "data-testid": f.isActive ? "active-viewer-frame" : "viewer-frame",
        id: "viewer-".concat(d),
        style: Ue,
        children: [
            (0, $ayMG0.jsx)($81cb1647619a2ab5$var$Ir, {
                serverConnection: w
            }),
            (0, $ayMG0.jsx)("iframe", {
                ref: k,
                sandbox: "allow-same-origin allow-scripts allow-forms",
                style: $81cb1647619a2ab5$var$kr($81cb1647619a2ab5$var$kr({}, Ge), {
                    background: "white"
                })
            }),
            f.isActive && (0, $ayMG0.jsx)("div", {
                id: "upscope-viewer-confetti-container",
                style: $81cb1647619a2ab5$var$kr($81cb1647619a2ab5$var$kr({}, Ge), {
                    pointerEvents: "none"
                })
            }),
            (0, $ayMG0.jsx)("div", {
                onClick: qe && !We ? He : void 0,
                style: $81cb1647619a2ab5$var$kr($81cb1647619a2ab5$var$kr({}, Ge), {
                    pointerEvents: We ? "none" : "auto",
                    touchAction: "none",
                    userSelect: "none"
                }),
                children: B && (0, $ayMG0.jsxs)("div", {
                    style: {
                        left: "".concat(B.x, "px"),
                        position: "absolute",
                        top: "".concat(B.y, "px"),
                        transform: "translateX(-10px) translateY(-6px)"
                    },
                    children: [
                        (0, $ayMG0.jsx)("div", {
                            style: {
                                backgroundColor: "rgba(0,0,0,0.1)",
                                borderRadius: "50%",
                                height: "60px",
                                left: "-20px",
                                opacity: P ? 1 : 0,
                                position: "absolute",
                                top: "-24px",
                                transform: P ? "scale(1)" : "scale(0)",
                                transformOrigin: "center",
                                transition: P ? "all 0.15s" : "none",
                                width: "60px"
                            }
                        }),
                        "string" == typeof B.cursorType ? (0, $ayMG0.jsx)("img", {
                            src: $81cb1647619a2ab5$var$Xn[B.cursorType]
                        }) : (0, $ayMG0.jsx)("img", {
                            src: B.cursorType.svg,
                            style: {
                                transform: "translateX(8px) translateY(4px)"
                            }
                        })
                    ]
                })
            }),
            be && D && (0, $ayMG0.jsxs)("div", {
                style: $81cb1647619a2ab5$var$kr($81cb1647619a2ab5$var$kr({}, Ge), {
                    pointerEvents: "none",
                    zIndex: 10
                }),
                children: [
                    (0, $ayMG0.jsx)("div", {
                        style: {
                            background: "rgba(0, 0, 0, 0.5)",
                            clipPath: "polygon(evenodd, 0 0, ".concat(D.width, "px 0, ").concat(D.width, "px ").concat(D.height, "px, 0 ").concat(D.height, "px, 0 0, ").concat(be.x, "px ").concat(be.y, "px, ").concat(be.x, "px ").concat(be.y + be.height, "px, ").concat(be.x + be.width, "px ").concat(be.y + be.height, "px, ").concat(be.x + be.width, "px ").concat(be.y, "px, ").concat(be.x, "px ").concat(be.y, "px)"),
                            height: "".concat(D.height, "px"),
                            left: 0,
                            position: "absolute",
                            top: 0,
                            transition: "clip-path 0.15s ease-out",
                            width: "".concat(D.width, "px")
                        }
                    }),
                    f.zoomAreaLabel && (Ye = be.y > 24, (0, $ayMG0.jsx)("span", {
                        style: {
                            background: "rgba(0, 0, 0, 0.7)",
                            borderRadius: Ye ? "4px 4px 0 0" : "0 0 4px 0",
                            color: "white",
                            fontSize: "13px",
                            left: "".concat(be.x, "px"),
                            padding: "3px 8px",
                            position: "absolute",
                            top: "".concat(Ye ? be.y - 24 : be.y, "px"),
                            transition: "left 0.15s ease-out, top 0.15s ease-out",
                            whiteSpace: "nowrap"
                        },
                        children: f.zoomAreaLabel
                    }))
                ]
            }),
            "drawing" === f.controlTool && D && (0, $ayMG0.jsx)($81cb1647619a2ab5$var$br, {
                color: f.color,
                height: D.height,
                iframeNode: k.current,
                scale: Ne,
                scrollable: xe.allowRemoteScroll && "granted" === b.control,
                serverConnection: w,
                uniqueConnectionId: d,
                width: D.width
            }),
            "pointer" === f.controlTool && D && (0, $ayMG0.jsx)($81cb1647619a2ab5$var$Cr, {
                height: D.height,
                iframeNode: k.current,
                scale: Ne,
                scrollable: xe.allowRemoteScroll && "granted" === b.control,
                serverConnection: w,
                uniqueConnectionId: d,
                width: D.width
            }),
            "cursor" === f.controlTool && ("granted" !== (null == b ? void 0 : b.control) || !qe) && D && (0, $ayMG0.jsx)($81cb1647619a2ab5$var$fr, {
                color: f.color,
                height: D.height,
                iframeNode: k.current,
                onControlAttempt: He,
                scale: Ne,
                serverConnection: w,
                uniqueConnectionId: d,
                viewerConnectionId: E,
                width: D.width
            })
        ]
    });
}
var $81cb1647619a2ab5$var$Vr = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$Tr = {
    referenceElementId: void 0,
    referenceX: void 0,
    referenceY: void 0
};
function $81cb1647619a2ab5$var$jr(t) {
    var n = $81cb1647619a2ab5$var$Vr((0, $acw62.useState)(!1), 2), r = n[0], i = n[1], a = (0, $acw62.useRef)(r);
    (0, $acw62.useEffect)(function() {
        a.current = r;
    }, [
        r
    ]);
    var l = $81cb1647619a2ab5$var$Vr((0, $acw62.useState)(!1), 2), u = l[0], d = l[1], f = (0, $acw62.useRef)(u);
    (0, $acw62.useEffect)(function() {
        f.current = u;
    }, [
        u
    ]);
    var h = $81cb1647619a2ab5$var$Vr((0, $acw62.useState)(null), 2), v = h[0], p = h[1];
    (0, $acw62.useEffect)(function() {
        return function() {
            f.current && t.serverConnection.cursorUp(t.uniqueConnectionId), a.current && t.serverConnection.disableCursor(t.uniqueConnectionId);
        };
    }, [
        t.serverConnection,
        t.uniqueConnectionId
    ]);
    var m = (0, $d1809cb5a91ef255$export$7158785e55df0693)(function(e, n) {
        t.serverConnection.moveCursor(t.uniqueConnectionId, t.color, e, n, $81cb1647619a2ab5$var$Tr);
    }, [
        t.serverConnection,
        t.uniqueConnectionId,
        t.color
    ], 100);
    function g(e) {
        if (a.current) {
            var n = $81cb1647619a2ab5$var$$o(e.currentTarget, t.scale, e), o = n.x, r = n.y;
            p({
                x: o,
                y: r
            }), m(o, r);
        }
    }
    function w(e) {
        i(!0);
        var n = $81cb1647619a2ab5$var$$o(e.currentTarget, t.scale, e), o = n.x, r = n.y;
        p({
            x: o,
            y: r
        }), t.serverConnection.moveCursor(t.uniqueConnectionId, t.color, o, r, $81cb1647619a2ab5$var$Tr);
    }
    function b() {
        f.current && (d(!1), t.serverConnection.cursorUp(t.uniqueConnectionId)), a.current && (i(!1), p(null), t.serverConnection.disableCursor(t.uniqueConnectionId));
    }
    function A(e) {
        if (t.controlEnabled) {
            a.current || w(e), d(!0);
            var n = $81cb1647619a2ab5$var$$o(e.currentTarget, t.scale, e), o = n.x, r = n.y;
            p({
                x: o,
                y: r
            }), t.serverConnection.cursorDown(t.uniqueConnectionId, o, r, $81cb1647619a2ab5$var$Tr);
        } else t.onControlAttempt();
    }
    return (0, $ayMG0.jsx)("div", {
        onMouseDown: A,
        onMouseEnter: w,
        onMouseLeave: b,
        onMouseMove: g,
        onMouseUp: function() {
            f.current && (d(!1), t.serverConnection.cursorUp(t.uniqueConnectionId));
        },
        onTouchEnd: b,
        onTouchMove: g,
        onTouchStart: A,
        style: {
            cursor: "none",
            height: t.height,
            left: 0,
            position: "absolute",
            top: 0,
            touchAction: "none",
            transform: "scale(".concat(t.scale, ")"),
            transformOrigin: "top left",
            userSelect: "none",
            width: t.width
        },
        children: v && (0, $ayMG0.jsx)("div", {
            style: {
                backgroundColor: t.color,
                borderRadius: "50%",
                height: 20,
                left: v.x - Math.floor(10),
                opacity: u ? .85 : .45,
                pointerEvents: "none",
                position: "absolute",
                top: v.y - Math.floor(10),
                transition: "opacity 0.1s ease",
                width: 20
            }
        })
    });
}
var $81cb1647619a2ab5$var$Rr = function() {
    return $81cb1647619a2ab5$var$Rr = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $81cb1647619a2ab5$var$Rr.apply(this, arguments);
}, $81cb1647619a2ab5$var$Xr = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$Nr = function(e, t, n) {
    if (n || 2 === arguments.length) for(var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
    return e.concat(o || Array.prototype.slice.call(t));
}, $81cb1647619a2ab5$var$Ur = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $81cb1647619a2ab5$var$Gr = $81cb1647619a2ab5$var$ce("viewer:screenVideo");
function $81cb1647619a2ab5$export$7c6e2c02157bb7d2(n) {
    var r, l = (0, $acw62.useContext)($81cb1647619a2ab5$export$9799878dee66ae0f), u = l.connections, f = l.errorHandler, h = l.latestActiveConnectionId, v = l.serverConnection, p = l.session, m = l.setActiveConnectionId, y = l.setLoadingStagesLeft, g = l.setSizes, w = $81cb1647619a2ab5$var$Xr((0, $acw62.useState)([]), 2), b = w[0], A = w[1], C = $81cb1647619a2ab5$var$Xr((0, $acw62.useState)([]), 2), x = C[0], S = C[1], E = $81cb1647619a2ab5$var$Xr((0, $acw62.useState)({}), 2), I = E[0], k = E[1], O = $81cb1647619a2ab5$var$Xr((0, $acw62.useState)(null), 2), D = O[0], z = O[1], M = $81cb1647619a2ab5$var$Xr((0, $acw62.useState)(null), 2), B = M[0], L = M[1], F = $81cb1647619a2ab5$var$Xr((0, $acw62.useState)(null), 2), P = F[0], V = F[1], T = (0, $acw62.useRef)(null), j = (0, $acw62.useRef)(new Map), R = (0, $acw62.useRef)(null), X = null !== (r = n.activeConnectionId) && void 0 !== r ? r : h, N = (0, $acw62.useRef)(X);
    (0, $acw62.useEffect)(function() {
        R.current = P;
    }, [
        P
    ]), (0, $acw62.useEffect)(function() {
        N.current = X;
    }, [
        X
    ]);
    var U = (null == p ? void 0 : p.mode.startsWith("viewer_screen:")) ? D : "visitor_app" === (null == p ? void 0 : p.mode) ? B : X ? I[X] : void 0;
    (0, $acw62.useEffect)(function() {
        m(function() {
            return X;
        });
    }, [
        X,
        m
    ]);
    var G = (null == p ? void 0 : p.mode.startsWith("visitor_screen:")) ? "cobrowsing_visitor_connection_" : (null == p ? void 0 : p.mode.startsWith("viewer_screen:")) ? "cobrowsing_viewer_connection_" : null;
    (0, $acw62.useEffect)(function() {
        var e, t, n = j.current;
        try {
            for(var o = $81cb1647619a2ab5$var$Ur($81cb1647619a2ab5$var$Nr([], $81cb1647619a2ab5$var$Xr(n.keys()), !1)), r = o.next(); !r.done; r = o.next()){
                var i = r.value;
                G && i.startsWith(G) || $81cb1647619a2ab5$var$qr(n, i);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                r && !r.done && (t = o.return) && t.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
    }, [
        G
    ]);
    var H = (0, $acw62.useMemo)(function() {
        if (!U) return 1;
        var e = function(e) {
            return 2 * Math.floor(e / 2);
        };
        return $81cb1647619a2ab5$var$Jo(e(U.w), e(U.h), e(n.maxWidth), e(n.maxHeight));
    }, [
        n.maxWidth,
        n.maxHeight,
        U
    ]);
    if ((0, $acw62.useEffect)(function() {
        U && g(function(e) {
            var t;
            return $81cb1647619a2ab5$var$Rr($81cb1647619a2ab5$var$Rr({}, e), ((t = {})[(null == p ? void 0 : p.mode.startsWith("viewer_screen:")) ? "viewer_screen" : (null == p ? void 0 : p.mode.startsWith("visitor_screen:")) ? "visitor_screen" : X] = {
                height: Math.floor(U.h * H),
                width: Math.floor(U.w * H)
            }, t));
        });
    }, [
        H,
        U,
        g,
        p,
        X
    ]), (0, $acw62.useEffect)(function() {
        var e;
        if (P && U) {
            var t = window.devicePixelRatio || 1, n = Math.round(U.w * H * t), o = Math.round(U.h * H * t);
            if (P.width === n && P.height === o || (P.setAttribute("width", String(n)), P.setAttribute("height", String(o))), U.video) {
                var r = U.sender ? null === (e = j.current.get(U.sender)) || void 0 === e ? void 0 : e.latestFrame : null;
                r && $81cb1647619a2ab5$var$Wr(P, r);
            } else {
                T.current || (T.current = new Image);
                var i = T.current, a = function() {
                    $81cb1647619a2ab5$var$Wr(P, i);
                };
                i.onload = a, i.src !== U.frame ? i.src = U.frame : i.complete && i.naturalWidth > 0 && a();
            }
        }
    }, [
        P,
        U,
        H
    ]), (0, $acw62.useEffect)(function() {
        var e = function(e) {
            S(function(t) {
                return $81cb1647619a2ab5$var$Nr($81cb1647619a2ab5$var$Nr([], $81cb1647619a2ab5$var$Xr(t), !1), [
                    e
                ], !1);
            });
        }, t = j.current, n = function(e) {
            $81cb1647619a2ab5$var$qr(t, e);
        }, o = function(e) {
            n(), z(null), k({}), $81cb1647619a2ab5$var$Er(e) && y(function(e) {
                return e.filter(function(e) {
                    return "firstFrame" !== e;
                });
            });
            var t = $81cb1647619a2ab5$var$Xr($81cb1647619a2ab5$var$Sr(e.id), 2), o = t[0], r = t[1];
            A(0 === r ? function(t) {
                return $81cb1647619a2ab5$var$Nr($81cb1647619a2ab5$var$Nr([], $81cb1647619a2ab5$var$Xr(t.filter(function(t) {
                    return $81cb1647619a2ab5$var$Sr(t.id)[0] === o || t.uniqueConnectionId !== e.uniqueConnectionId;
                })), !1), [
                    e
                ], !1);
            } : function(t) {
                return $81cb1647619a2ab5$var$Nr($81cb1647619a2ab5$var$Nr([], $81cb1647619a2ab5$var$Xr(t), !1), [
                    e
                ], !1);
            });
        }, r = function(e) {
            var t = $81cb1647619a2ab5$var$Xr(e, 3), o = t[0], r = t[1], i = t[2];
            o.startsWith("cobrowsing_visitor_connection_") ? (n(o), z(null), L(null), k(function(e) {
                var t;
                return $81cb1647619a2ab5$var$Rr($81cb1647619a2ab5$var$Rr({}, e), ((t = {})[o] = $81cb1647619a2ab5$var$Rr({
                    frame: r
                }, i), t));
            }), y(function(e) {
                return e.filter(function(e) {
                    return "firstFrame" !== e && "load" !== e;
                });
            })) : (n(o), k({}), L(null), z($81cb1647619a2ab5$var$Rr({
                frame: r
            }, i)));
        }, i = function(e) {
            var n = $81cb1647619a2ab5$var$Xr(e), o = n[0], r = n.slice(1), i = o.startsWith("cobrowsing_viewer_connection_"), a = t.get(o);
            if (!a) {
                var c = {
                    latestFrame: null,
                    receiver: new $81cb1647619a2ab5$var$xt({
                        debug: $81cb1647619a2ab5$var$Gr,
                        onFrame: function(e) {
                            var t;
                            null === (t = c.latestFrame) || void 0 === t || t.close(), c.latestFrame = e;
                            var n = c.size, r = n.h, a = n.w;
                            L(null), i ? (k({}), z(function(e) {
                                return (null == e ? void 0 : e.sender) === o && e.w === a && e.h === r ? e : {
                                    frame: "",
                                    h: r,
                                    sender: o,
                                    video: !0,
                                    w: a
                                };
                            })) : (z(null), k(function(e) {
                                var t, n = e[o];
                                return (null == n ? void 0 : n.video) && n.w === a && n.h === r ? e : $81cb1647619a2ab5$var$Rr($81cb1647619a2ab5$var$Rr({}, e), ((t = {})[o] = {
                                    frame: "",
                                    h: r,
                                    sender: o,
                                    video: !0,
                                    w: a
                                }, t));
                            })), i || c.shown || (c.shown = !0, y(function(e) {
                                return e.filter(function(e) {
                                    return "firstFrame" !== e && "load" !== e;
                                });
                            }));
                            var s = R.current;
                            s && (i || N.current === o) && $81cb1647619a2ab5$var$Wr(s, e);
                        },
                        requestKeyframe: function() {
                            null == v || v.emit("requestKeyframe", [
                                o,
                                "screen"
                            ]);
                        }
                    }),
                    shown: !1,
                    size: r[1]
                };
                t.set(o, c), a = c;
            }
            a.size = r[1], a.receiver.receive(r);
        }, a = function(e) {
            var t = $81cb1647619a2ab5$var$Xr(e, 3), o = t[1], r = t[2];
            n(), z(null), k({}), L($81cb1647619a2ab5$var$Rr({
                frame: o
            }, r)), y(function(e) {
                return e.filter(function(e) {
                    return "firstFrame" !== e && "load" !== e;
                });
            });
        };
        return null == v || v.on("dataBounce", e).on("browserEvent", o).on("screenFrame", r).on("screenVideo", i).on("appFrame", a), function() {
            null == v || v.off("dataBounce", e).off("browserEvent", o).off("screenFrame", r).off("screenVideo", i).off("appFrame", a), n();
        };
    }, [
        v,
        y
    ]), (0, $acw62.useEffect)(function() {
        A(function(e) {
            return e.filter(function(e) {
                return u.some(function(t) {
                    return t.uniqueConnectionId === e.uniqueConnectionId;
                });
            });
        });
    }, [
        u
    ]), (0, $acw62.useEffect)(function() {
        b.length > 0 || 0 === x.length || (x.forEach(function(e) {
            null == v || v.emit("dataBounceBack", e);
        }), S([]));
    }, [
        b,
        x,
        v
    ]), "active" !== (null == p ? void 0 : p.status)) return null;
    function q() {
        "granted" !== (null == p ? void 0 : p.control) && (null == f || f("remote_control:inactive"));
    }
    if (p.mode.startsWith("visitor_screen:") || p.mode.startsWith("viewer_screen:") || "visitor_app" === p.mode) {
        var W = u.find(function(e) {
            return e.uniqueConnectionId === X;
        }), Q = "visitor_app" === p.mode && (null == W ? void 0 : W.allowRemoteClick);
        return U ? (0, $ayMG0.jsxs)("div", {
            style: {
                position: "relative"
            },
            children: [
                (0, $ayMG0.jsx)("canvas", {
                    onClick: null === n.controlTool && Q ? q : void 0,
                    ref: V,
                    style: {
                        height: Math.round(U.h * H),
                        userSelect: "none",
                        width: Math.round(U.w * H)
                    }
                }),
                (0, $ayMG0.jsx)("div", {
                    id: "upscope-viewer-confetti-container",
                    style: {
                        height: U.h,
                        left: 0,
                        pointerEvents: "none",
                        position: "absolute",
                        top: 0,
                        transform: "scale(".concat(H, ")"),
                        transformOrigin: "top left",
                        width: U.w
                    }
                }),
                "visitor_app" === p.mode && v && X && ("drawing" === n.controlTool ? (0, $ayMG0.jsx)($81cb1647619a2ab5$var$br, {
                    color: n.color,
                    height: U.h,
                    iframeNode: null,
                    scale: H,
                    scrollable: !1,
                    serverConnection: v,
                    uniqueConnectionId: X,
                    width: U.w
                }) : "cursor" === n.controlTool ? (0, $ayMG0.jsx)($81cb1647619a2ab5$var$jr, {
                    color: n.color,
                    controlEnabled: "granted" === p.control,
                    height: U.h,
                    onControlAttempt: q,
                    scale: H,
                    serverConnection: v,
                    uniqueConnectionId: X,
                    width: U.w
                }) : void 0)
            ]
        }) : null;
    }
    return (0, $ayMG0.jsx)("div", {
        style: {
            position: "relative"
        },
        children: u.map(function(e) {
            var t, o;
            return (0, $acw62.createElement)($81cb1647619a2ab5$var$Pr, $81cb1647619a2ab5$var$Rr({}, n, {
                isActive: null !== n.activeConnectionId && e.uniqueConnectionId === (null !== (t = n.activeConnectionId) && void 0 !== t ? t : h),
                isPrimary: e.uniqueConnectionId === (null !== (o = n.activeConnectionId) && void 0 !== o ? o : h),
                key: e.uniqueConnectionId,
                pendingEvents: b,
                setPendingEvents: A,
                uniqueConnectionId: e.uniqueConnectionId
            }));
        })
    });
}
function $81cb1647619a2ab5$var$qr(e, t) {
    var n, o, r;
    try {
        for(var i = $81cb1647619a2ab5$var$Ur(t ? [
            t
        ] : $81cb1647619a2ab5$var$Nr([], $81cb1647619a2ab5$var$Xr(e.keys()), !1)), a = i.next(); !a.done; a = i.next()){
            var c = a.value, s = e.get(c);
            null == s || s.receiver.close(), null === (r = null == s ? void 0 : s.latestFrame) || void 0 === r || r.close(), e.delete(c);
        }
    } catch (e) {
        n = {
            error: e
        };
    } finally{
        try {
            a && !a.done && (o = i.return) && o.call(i);
        } finally{
            if (n) throw n.error;
        }
    }
}
function $81cb1647619a2ab5$var$Wr(e, t) {
    var n = e.getContext("2d");
    n && (n.imageSmoothingQuality = "high", n.clearRect(0, 0, e.width, e.height), n.drawImage(t, 0, 0, e.width, e.height));
}
var $81cb1647619a2ab5$var$Qr = new Set([
    "handshake:done",
    "internal_error"
]);
function $81cb1647619a2ab5$export$994d148b3cc6d8bf(e) {
    return !e || $81cb1647619a2ab5$var$Qr.has(e) || e.startsWith("rate_limit:");
}
var $81cb1647619a2ab5$var$Zr = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
};
function $81cb1647619a2ab5$var$Kr(e, t) {
    return void 0 === t && (t = ""), Object.values(e).some(function(e) {
        return "object" == typeof e;
    }) ? Object.entries(e).map(function(e) {
        var n = $81cb1647619a2ab5$var$Zr(e, 2), o = n[0], r = n[1];
        return "".concat(t).concat(o, " {\n").concat($81cb1647619a2ab5$var$Kr(r), "\n}");
    }).join("\n") : Object.entries(e).map(function(e) {
        var t = $81cb1647619a2ab5$var$Zr(e, 2), n = t[0], o = t[1];
        return "".concat(n, ": ").concat(o, ";\n");
    }).join("");
}
var $81cb1647619a2ab5$var$Jr = function() {
    return $81cb1647619a2ab5$var$Jr = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $81cb1647619a2ab5$var$Jr.apply(this, arguments);
}, $81cb1647619a2ab5$var$_r = function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                s(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, c);
        }
        s((o = o.apply(e, t || [])).next());
    });
}, $81cb1647619a2ab5$var$$r = function(e, t) {
    var n, o, r, i = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = c(0), a.throw = c(1), a.return = c(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function c(c) {
        return function(s) {
            return function(c) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, c[0] && (i = 0)), i;)try {
                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                    switch(o = 0, r && (c = [
                        2 & c[0],
                        r.value
                    ]), c[0]){
                        case 0:
                        case 1:
                            r = c;
                            break;
                        case 4:
                            return i.label++, {
                                value: c[1],
                                done: !1
                            };
                        case 5:
                            i.label++, o = c[1], c = [
                                0
                            ];
                            continue;
                        case 7:
                            c = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                i.label = c[1];
                                break;
                            }
                            if (6 === c[0] && i.label < r[1]) {
                                i.label = r[1], r = c;
                                break;
                            }
                            if (r && i.label < r[2]) {
                                i.label = r[2], i.ops.push(c);
                                break;
                            }
                            r[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    c = t.call(e, i);
                } catch (e) {
                    c = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & c[0]) throw c[1];
                return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                };
            }([
                c,
                s
            ]);
        };
    }
}, $81cb1647619a2ab5$var$ei = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
}, $81cb1647619a2ab5$var$ti = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && o >= e.length && (e = void 0), {
                value: e && e[o++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $81cb1647619a2ab5$var$ni = 192, $81cb1647619a2ab5$var$oi = 192, $81cb1647619a2ab5$var$ri = 16, $81cb1647619a2ab5$var$ii = "upscope/videoPosition", $81cb1647619a2ab5$var$ai = "upscope/videoFacing", $81cb1647619a2ab5$var$ci = "M6 18L18 6M6 6l12 12", $81cb1647619a2ab5$var$si = {
    ".upscope__video": {
        background: "linear-gradient(145deg, #1a1a2e 0%, #0d0d1a 100%)",
        "border-radius": "12px",
        "box-shadow": "0 0 0 1px rgb(0 0 0 / 0.1), 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        cursor: "grab",
        height: "".concat($81cb1647619a2ab5$var$oi, "px"),
        position: "fixed",
        transition: "transform 150ms ease",
        "user-select": "none",
        width: "".concat($81cb1647619a2ab5$var$ni, "px"),
        "z-index": "9999"
    },
    ".upscope__video:hover": {
        transform: "scale(1.05)"
    },
    ".upscope__video[data-dragging='true']": {
        cursor: "grabbing",
        transform: "none"
    },
    ".upscope__video[data-pressing='true']": {
        transform: "scale(0.95)"
    },
    ".upscope__video__outer-content": {
        "border-radius": "12px",
        inset: "0",
        overflow: "hidden",
        position: "absolute"
    },
    ".upscope__video__inner": {
        background: "#0d0d1a",
        "border-radius": "12px",
        display: "none",
        position: "absolute"
    },
    ".upscope__video[data-inner='corner'] .upscope__video__inner": {
        border: "2px solid #ffffff",
        bottom: "8px",
        display: "block",
        height: "".concat(60, "px"),
        right: "8px",
        width: "".concat(60, "px"),
        "z-index": "2"
    },
    ".upscope__video[data-inner='full'] .upscope__video__inner": {
        display: "block",
        inset: "0"
    },
    ".upscope__video__inner-content": {
        "border-radius": "10px",
        inset: "0",
        overflow: "hidden",
        position: "absolute"
    },
    ".upscope__video__inner-x, .upscope__video__outer-x, .upscope__video__flip": {
        "align-items": "center",
        "background-color": "#ef4444",
        border: "none",
        "border-radius": "50%",
        cursor: "pointer",
        display: "none",
        height: "20px",
        "justify-content": "center",
        padding: "0",
        position: "absolute",
        width: "20px"
    },
    ".upscope__video__inner-x:focus-visible, .upscope__video__outer-x:focus-visible, .upscope__video__flip:focus-visible": {
        outline: "2px solid #ffffff"
    },
    ".upscope__video__inner-x": {
        right: "-8px",
        top: "-8px",
        "z-index": "3"
    },
    ".upscope__video__outer-x": {
        right: "-10px",
        top: "-10px",
        "z-index": "4"
    },
    ".upscope__video__flip": {
        "background-color": "rgb(0 0 0 / 0.55)",
        bottom: "4px",
        right: "4px",
        "z-index": "3"
    },
    ".upscope__video[data-show-inner-x='true'] .upscope__video__inner:hover .upscope__video__inner-x, .upscope__video[data-show-inner-x='true'] .upscope__video__inner:focus-within .upscope__video__inner-x": {
        display: "flex"
    },
    ".upscope__video[data-show-outer-x='true']:hover .upscope__video__outer-x, .upscope__video[data-show-outer-x='true']:focus-within .upscope__video__outer-x": {
        display: "flex"
    },
    ".upscope__video[data-show-flip='true'] .upscope__video__inner:hover .upscope__video__flip, .upscope__video[data-show-flip='true'] .upscope__video__inner:focus-within .upscope__video__flip": {
        display: "flex"
    },
    "@media (hover: none), (pointer: coarse)": {
        ".upscope__video[data-show-inner-x='true'] .upscope__video__inner-x": {
            display: "flex"
        },
        ".upscope__video[data-show-outer-x='true'] .upscope__video__outer-x": {
            display: "flex"
        },
        ".upscope__video[data-show-flip='true'] .upscope__video__flip": {
            display: "flex"
        }
    }
}, $81cb1647619a2ab5$var$li = "".concat($81cb1647619a2ab5$var$Kr($81cb1647619a2ab5$var$si), "\n").concat($81cb1647619a2ab5$var$Kr({
    ".upscope__video__remote": {
        background: "#0d0d1a",
        "border-radius": "12px",
        display: "block",
        height: "100%",
        "object-fit": "cover",
        width: "100%"
    },
    ".upscope__video__loading": {
        "align-items": "center",
        background: "#ffffff",
        "border-radius": "12px",
        display: "flex",
        height: "100%",
        "justify-content": "center",
        "pointer-events": "none",
        width: "100%"
    },
    ".upscope__video__loading__spinner": {
        border: "2px solid #d1d5db",
        "border-radius": "9999px",
        "border-top-color": "#6b7280",
        height: "24px",
        width: "24px"
    },
    ".upscope__video__request": {
        "align-items": "center",
        display: "flex",
        height: "100%",
        "justify-content": "center",
        width: "100%"
    },
    ".upscope__video__request__btn": {
        "background-color": "#ffffff",
        border: "none",
        "border-radius": "6px",
        color: "#111111",
        cursor: "pointer",
        "font-family": "system-ui, -apple-system, sans-serif",
        "font-size": "12px",
        "font-weight": "500",
        padding: "8px 14px"
    },
    ".upscope__video__request__btn:hover": {
        "background-color": "#f0f0f0"
    },
    ".upscope__video__own": {
        background: "#0d0d1a",
        "border-radius": "10px",
        display: "block",
        height: "100%",
        "object-fit": "cover",
        width: "100%"
    },
    ".upscope__video__plus": {
        "align-items": "center",
        "background-color": "#f8f8f8",
        "border-radius": "10px",
        cursor: "pointer",
        display: "flex",
        height: "100%",
        "justify-content": "center",
        width: "100%"
    }
})), $81cb1647619a2ab5$var$ui = {
    ownVideoOn: !1,
    remoteFrame: null,
    remoteLoading: !1,
    canRequestRemote: !1,
    canStream: !1,
    isController: !1
};
function $81cb1647619a2ab5$var$di(e, t, n) {
    var o = function(e) {
        "touchstart" === e.type && e.preventDefault(), setTimeout(function() {
            n() || t();
        }, 160);
    };
    e.addEventListener("mousedown", o), e.addEventListener("touchstart", o, {
        passive: !1
    });
}
var $81cb1647619a2ab5$var$fi = function() {
    function e(e, t, n, o, r, i, a) {
        this.doc = e, this.onFrameChange = t, this.showFrameUrlOverlay = n, this.getProvidedStream = o, this.getCamera = r, this.onChange = i, this.video = a, this.stream = null, this.streamProvided = !1, this.videoElement = null, this.raf = null, this.deviceChangeHandler = null, this.lastFrameTime = 0, this.facing = null, this.multipleCameras = !1, this.switching = !1, this.meter = null;
    }
    return e.prototype.requestKeyframe = function() {
        var e;
        null === (e = this.sender) || void 0 === e || e.requestKeyframe();
    }, Object.defineProperty(e.prototype, "element", {
        get: function() {
            return this.videoElement;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "isRunning", {
        get: function() {
            return null !== this.stream;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "canSwitch", {
        get: function() {
            return null !== this.facing && this.multipleCameras;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype._constraints = function(e) {
        var t = "front" === e ? "user" : "back" === e ? "environment" : void 0;
        return {
            audio: !1,
            video: {
                facingMode: t && {
                    ideal: t
                },
                height: $81cb1647619a2ab5$var$oi,
                width: $81cb1647619a2ab5$var$ni
            }
        };
    }, e.prototype._detectFacing = function(e) {
        var t = $81cb1647619a2ab5$var$ei(e.getVideoTracks(), 1)[0];
        if (!t || "function" != typeof t.getSettings) return null;
        var n = t.getSettings().facingMode;
        return "user" === n ? "front" : "environment" === n ? "back" : null;
    }, e.prototype._acquire = function(e) {
        return $81cb1647619a2ab5$var$_r(this, arguments, void 0, function(e, t) {
            return void 0 === t && (t = 0), $81cb1647619a2ab5$var$$r(this, function(n) {
                switch(n.label){
                    case 0:
                        return t > 0 ? [
                            4,
                            new Promise(function(e) {
                                return setTimeout(e, t);
                            })
                        ] : [
                            3,
                            2
                        ];
                    case 1:
                        n.sent(), n.label = 2;
                    case 2:
                        return n.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]), [
                            4,
                            navigator.mediaDevices.getUserMedia(this._constraints(e))
                        ];
                    case 3:
                        return [
                            2,
                            n.sent()
                        ];
                    case 4:
                        return n.sent(), [
                            2,
                            null
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype._replaceStream = function(e) {
        this.stream = e, this.videoElement && (this.videoElement.srcObject = e), this._rememberFacing(e);
    }, e.prototype._rememberFacing = function(e) {
        if (this.facing = this._detectFacing(e), null !== this.facing) try {
            sessionStorage.setItem($81cb1647619a2ab5$var$ai, this.facing);
        } catch (e) {}
    }, e.prototype._storedFacing = function() {
        try {
            var e = sessionStorage.getItem($81cb1647619a2ab5$var$ai);
            return "front" === e || "back" === e ? e : void 0;
        } catch (e) {
            return;
        }
    }, e.prototype._initialCamera = function() {
        var e, t, n = null === (e = this.getCamera) || void 0 === e ? void 0 : e.call(this);
        return "both" === n && null !== (t = this._storedFacing()) && void 0 !== t ? t : n;
    }, e.prototype._countCameras = function() {
        return $81cb1647619a2ab5$var$_r(this, void 0, void 0, function() {
            var e, t, n;
            return $81cb1647619a2ab5$var$$r(this, function(o) {
                switch(o.label){
                    case 0:
                        if ("both" !== (null === (t = this.getCamera) || void 0 === t ? void 0 : t.call(this))) return [
                            2
                        ];
                        o.label = 1;
                    case 1:
                        return o.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 2:
                        return e = o.sent(), this.multipleCameras = e.filter(function(e) {
                            return "videoinput" === e.kind;
                        }).length > 1, [
                            3,
                            4
                        ];
                    case 3:
                        return o.sent(), this.multipleCameras = !1, [
                            3,
                            4
                        ];
                    case 4:
                        return null === (n = this.onChange) || void 0 === n || n.call(this), [
                            2
                        ];
                }
            });
        });
    }, e.prototype._isSwitching = function() {
        return this.switching;
    }, e.prototype._stopTracks = function(e) {
        var t, n;
        try {
            for(var o = $81cb1647619a2ab5$var$ti(e.getTracks()), r = o.next(); !r.done; r = o.next())r.value.stop();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                r && !r.done && (n = o.return) && n.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
    }, e.prototype.switchCamera = function() {
        return $81cb1647619a2ab5$var$_r(this, void 0, void 0, function() {
            var e, t, n, o, r, i, a, c, s;
            return $81cb1647619a2ab5$var$$r(this, function(l) {
                switch(l.label){
                    case 0:
                        if (!this.canSwitch || this.switching || !this.stream) return [
                            2,
                            !0
                        ];
                        this.switching = !0, e = this.stream, t = null !== (a = this.facing) && void 0 !== a ? a : void 0, n = "front" === this.facing ? "back" : "front", l.label = 1;
                    case 1:
                        return l.trys.push([
                            1,
                            ,
                            9,
                            10
                        ]), this._stopTracks(e), [
                            4,
                            this._acquire(n)
                        ];
                    case 2:
                        return null === (c = l.sent()) || void 0 === c ? [
                            3,
                            3
                        ] : (i = c, [
                            3,
                            5
                        ]);
                    case 3:
                        return [
                            4,
                            this._acquire(t)
                        ];
                    case 4:
                        i = l.sent(), l.label = 5;
                    case 5:
                        return null === (s = i) || void 0 === s ? [
                            3,
                            6
                        ] : (r = s, [
                            3,
                            8
                        ]);
                    case 6:
                        return [
                            4,
                            this._acquire(t, 500)
                        ];
                    case 7:
                        r = l.sent(), l.label = 8;
                    case 8:
                        return o = r, this.stream !== e ? (o && this._stopTracks(o), [
                            2,
                            !0
                        ]) : o ? (this._replaceStream(o), [
                            2,
                            !0
                        ]) : (this.stop(), [
                            2,
                            !1
                        ]);
                    case 9:
                        return this.switching = !1, [
                            7
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.start = function() {
        return $81cb1647619a2ab5$var$_r(this, void 0, void 0, function() {
            var e, t, n, o, r, i, a, c, s, l = this;
            return $81cb1647619a2ab5$var$$r(this, function(u) {
                switch(u.label){
                    case 0:
                        if (this.isRunning) return [
                            2,
                            "started"
                        ];
                        if (this.stream = null !== (s = null === (c = this.getProvidedStream) || void 0 === c ? void 0 : c.call(this)) && void 0 !== s ? s : null, this.streamProvided = null !== this.stream, this.stream) return [
                            3,
                            5
                        ];
                        u.label = 1;
                    case 1:
                        return u.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), e = this, [
                            4,
                            navigator.mediaDevices.getUserMedia(this._constraints(this._initialCamera()))
                        ];
                    case 2:
                        return e.stream = u.sent(), [
                            3,
                            4
                        ];
                    case 3:
                        return t = u.sent(), this.stream = null, [
                            2,
                            "NotFoundError" === (n = t instanceof DOMException ? t.name : "") || "OverconstrainedError" === n ? "no_input" : "not_authorized"
                        ];
                    case 4:
                        this._rememberFacing(this.stream), this._countCameras(), u.label = 5;
                    case 5:
                        return (o = this.doc.createElement("video")).className = "upscope__video__own", o.muted = !0, o.autoplay = !0, o.playsInline = !0, o.srcObject = this.stream, this.videoElement = o, this.meter = new $81cb1647619a2ab5$export$896749013ac55a71(function() {}), this.video && (this.sender = new $81cb1647619a2ab5$var$J($81cb1647619a2ab5$var$Jr($81cb1647619a2ab5$var$Jr({}, this.video), {
                            bitrates: $81cb1647619a2ab5$var$K,
                            debug: function() {}
                        }))), (r = this.doc.createElement("canvas")).width = $81cb1647619a2ab5$var$ni, r.height = $81cb1647619a2ab5$var$oi, i = r.getContext("2d"), a = function() {
                            if (l.videoElement && i && l.meter) {
                                l.raf = requestAnimationFrame(a);
                                var e = performance.now();
                                if (l.sender && l.videoElement.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
                                    var t = {
                                        h: l.videoElement.videoHeight,
                                        w: l.videoElement.videoWidth
                                    };
                                    if (l.sender.prepare({
                                        h: $81cb1647619a2ab5$var$oi,
                                        w: $81cb1647619a2ab5$var$ni
                                    }, t)) {
                                        if (!l.sender.acceptsFrame()) return;
                                        l._drawFrame(i);
                                        var n = new VideoFrame(r, {
                                            timestamp: Math.round(1e3 * e)
                                        });
                                        return l.sender.encode(n), void n.close();
                                    }
                                }
                                var o = 1e3 / l.meter.maxFps;
                                if (!(e - l.lastFrameTime < o || l.videoElement.readyState < HTMLMediaElement.HAVE_CURRENT_DATA)) {
                                    l.lastFrameTime = e, l._drawFrame(i);
                                    var c = r.toDataURL("image/jpeg", l.meter.quality);
                                    l.meter.track(c), l.onFrameChange(c);
                                }
                            }
                        }, this.raf = requestAnimationFrame(a), this.deviceChangeHandler = function() {
                            l.stream && l._reacquire();
                        }, navigator.mediaDevices.addEventListener("devicechange", this.deviceChangeHandler), [
                            2,
                            "started"
                        ];
                }
            });
        });
    }, e.prototype._drawFrame = function(e) {
        if (e.drawImage(this.videoElement, 0, 0, $81cb1647619a2ab5$var$ni, $81cb1647619a2ab5$var$oi), this.showFrameUrlOverlay) {
            var t = location.href;
            e.font = "12px monospace";
            var n = e.measureText(t).width;
            e.fillStyle = "rgba(0, 0, 0, 0.6)", e.fillRect(0, 172, Math.min(n + 8, $81cb1647619a2ab5$var$ni), 20), e.fillStyle = "#ffffff", e.fillText(t, 4, 186, 184);
        }
    }, e.prototype.stop = function() {
        var e;
        null !== this.raf && (cancelAnimationFrame(this.raf), this.raf = null), this.stream && (this.streamProvided || this._stopTracks(this.stream), this.stream = null), this.streamProvided = !1, this.videoElement && (this.videoElement.srcObject = null, this.videoElement = null), this.deviceChangeHandler && (navigator.mediaDevices.removeEventListener("devicechange", this.deviceChangeHandler), this.deviceChangeHandler = null), null === (e = this.sender) || void 0 === e || e.stop(), this.sender = void 0, this.meter = null, this.lastFrameTime = 0, this.facing = null, this.multipleCameras = !1, this.switching = !1;
    }, e.prototype._reacquire = function() {
        return $81cb1647619a2ab5$var$_r(this, void 0, void 0, function() {
            var e, t, n, o;
            return $81cb1647619a2ab5$var$$r(this, function(r) {
                switch(r.label){
                    case 0:
                        return this.streamProvided || this.switching ? [
                            2
                        ] : (e = this.stream, [
                            4,
                            this._acquire(null !== (n = this.facing) && void 0 !== n ? n : null === (o = this.getCamera) || void 0 === o ? void 0 : o.call(this))
                        ]);
                    case 1:
                        return (t = r.sent()) ? !e || this.stream !== e || this._isSwitching() ? (this._stopTracks(t), [
                            2
                        ]) : (this._replaceStream(t), this._stopTracks(e), this.requestKeyframe(), this._countCameras(), [
                            2
                        ]) : [
                            2
                        ];
                }
            });
        });
    }, e;
}(), $81cb1647619a2ab5$var$hi = function() {
    function e(e) {
        this.shadowContainer = null, this.container = null, this.outerContentSlot = null, this.innerFrame = null, this.innerContentSlot = null, this.destroyDrag = null, this.presenceInterval = null, this.dragging = !1, this.didDragInPointerCycle = !1, this.dragTimer = void 0, this.doc = e.doc, this.draggable = e.draggable, this.closeButtons = e.closeButtons, this.className = e.className, this.onOuterX = e.onOuterX, this.onInnerX = e.onInnerX, this.onFlip = e.onFlip;
    }
    return Object.defineProperty(e.prototype, "isDragging", {
        get: function() {
            return this.dragging || this.didDragInPointerCycle;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.update = function(e) {
        e.visible ? (this.container || this._build(), this.container && this.outerContentSlot && this.innerContentSlot && (this._mountSlot(this.outerContentSlot, e.outerContent), this._mountSlot(this.innerContentSlot, e.innerContent), this.container.dataset.inner = e.inner, this.container.dataset.showInnerX = this.closeButtons && e.showInnerX ? "true" : "false", this.container.dataset.showOuterX = this.closeButtons && e.showOuterX ? "true" : "false", this.container.dataset.showFlip = e.showFlip ? "true" : "false")) : this._teardown();
    }, e.prototype.destroy = function() {
        this._teardown();
    }, e.prototype._mountSlot = function(e, t) {
        var n = e.firstElementChild;
        n !== t && (n && e.removeChild(n), t && e.appendChild(t));
    }, e.prototype._iconButton = function(e, t, n, o) {
        var r = this, i = function(e, t, n, o, r) {
            var i = e.createElement("button");
            i.type = "button", i.className = t, i.setAttribute("aria-label", o), i.addEventListener("keydown", function(e) {
                "Enter" !== e.key && " " !== e.key || (e.preventDefault(), r());
            });
            var a = e.createElementNS("http://www.w3.org/2000/svg", "svg");
            a.setAttribute("stroke", "#ffffff"), a.setAttribute("fill", "none"), a.setAttribute("stroke-width", "2"), a.setAttribute("viewBox", "0 0 24 24"), a.setAttribute("aria-hidden", "true"), a.setAttribute("width", "12px"), a.setAttribute("height", "12px");
            var c = e.createElementNS("http://www.w3.org/2000/svg", "path");
            return c.setAttribute("stroke-linecap", "round"), c.setAttribute("stroke-linejoin", "round"), c.setAttribute("d", n), a.appendChild(c), i.appendChild(a), i;
        }(this.doc, e, t, n, o);
        return $81cb1647619a2ab5$var$di(i, o, function() {
            return r.isDragging;
        }), i;
    }, e.prototype._build = function() {
        var e = this, t = this._readStoredPosition();
        this.shadowContainer = function(e, t) {
            var n, o, r = e.createElement("div");
            if (t.id && (r.id = t.id), t.className && (r.className = t.className), r.style.all = "initial", r.style.display = "block", t.cssLinkHref) {
                var i = e.createElement("link");
                i.setAttribute("data-upscope-remote-stylesheet", "true"), i.type = "text/css", i.href = t.cssLinkHref, i.rel = "stylesheet", o = i;
            } else {
                var a = e.createElement("style");
                a.textContent = null !== (n = t.cssText) && void 0 !== n ? n : "", o = a;
            }
            if ("attachShadow" in r && r.attachShadow) return r.attachShadow({
                mode: "open"
            }), e.body.append(r), r.shadowRoot.remove = r.remove.bind(r), r.shadowRoot.append(o), r.shadowRoot;
            r.id = r.id || "upscope--" + Math.random().toString(36).slice(2, 10);
            for(var c = e.createElement("style"), s = [], l = e.defaultView.getComputedStyle(e.body), u = 0; u < l.length; u++)s.push(l[u]);
            return c.textContent = "\n  #".concat(r.id, ", #").concat(r.id, " * {\n    ").concat(s.filter(function(e) {
                return ![
                    "d",
                    "stroke"
                ].includes(e);
            }).map(function(e) {
                return "".concat(e, ": initial");
            }).join(";\n"), "\n  }"), e.head.append(c), e.head.querySelector("[data-upscope-remote-stylesheet]") || e.head.append(o), e.body.append(r), r;
        }(this.doc, {
            id: "upscope__video-container",
            cssText: $81cb1647619a2ab5$var$li
        }), ("host" in this.shadowContainer ? this.shadowContainer.host : this.shadowContainer).setAttribute("data-upscope-viewer-display", "none");
        var n = this.doc.createElement("div");
        n.className = this.className ? "upscope__video ".concat(this.className) : "upscope__video", n.setAttribute("data-upscope-viewer-display", "none"), this._applyStoredPosition(n, t), this.container = n;
        var o = this.doc.createElement("div");
        o.className = "upscope__video__outer-content", this.outerContentSlot = o;
        var r = this.doc.createElement("div");
        r.className = "upscope__video__inner", this.innerFrame = r;
        var i = this.doc.createElement("div");
        i.className = "upscope__video__inner-content", this.innerContentSlot = i;
        var a = this._iconButton("upscope__video__inner-x", $81cb1647619a2ab5$var$ci, "Close your video", function() {
            e.onInnerX();
        }), c = this._iconButton("upscope__video__outer-x", $81cb1647619a2ab5$var$ci, "End video call", function() {
            e.onOuterX();
        }), s = this._iconButton("upscope__video__flip", "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99", "Switch camera", function() {
            e.onFlip();
        });
        r.append(i, a, s), n.append(o, r, c), this.shadowContainer.append(n), this.draggable ? this.destroyDrag = this._makeDraggable(n) : n.style.cursor = "default", this.presenceInterval = setInterval(function() {
            var t = e.shadowContainer && "host" in e.shadowContainer ? e.shadowContainer.host : null;
            t && !e.doc.body.contains(t) && e.destroy();
        }, 5e3);
    }, e.prototype._teardown = function() {
        this.destroyDrag && (this.destroyDrag(), this.destroyDrag = null), null !== this.presenceInterval && (clearInterval(this.presenceInterval), this.presenceInterval = null), this._clearDragTimer(), this.shadowContainer && (this.shadowContainer.remove(), this.shadowContainer = null), this.container = null, this.outerContentSlot = null, this.innerFrame = null, this.innerContentSlot = null, this.dragging = !1, this.didDragInPointerCycle = !1;
    }, e.prototype._readStoredPosition = function() {
        try {
            var e = sessionStorage.getItem($81cb1647619a2ab5$var$ii);
            if (!e) return null;
            var t = JSON.parse(e);
            if ("object" != typeof t || null === t) return null;
            if ("corner" in t && "x" in t && "y" in t) {
                var n = t.corner, o = t.x, r = t.y;
                if (("bottom-left" === n || "bottom-right" === n || "top-left" === n || "top-right" === n) && "number" == typeof o && "number" == typeof r) return {
                    corner: n,
                    x: o,
                    y: r
                };
            }
            if ("left" in t && "top" in t) {
                var i = t.left, a = t.top;
                if ("number" == typeof i && "number" == typeof a) return {
                    left: i,
                    top: a
                };
            }
            return null;
        } catch (e) {
            return null;
        }
    }, e.prototype._applyStoredPosition = function(e, t) {
        var n = this.doc.defaultView, o = function() {
            e.style.left = "".concat($81cb1647619a2ab5$var$ri, "px"), e.style.bottom = "".concat($81cb1647619a2ab5$var$ri, "px"), e.style.right = "auto", e.style.top = "auto";
        };
        if (t) {
            if ("corner" in t) {
                var r = function(e, t, n, o) {
                    var r = e.corner, i = e.x, a = e.y;
                    switch(r){
                        case "bottom-left":
                            return {
                                left: i,
                                top: o.innerHeight - n - a
                            };
                        case "bottom-right":
                            return {
                                left: o.innerWidth - t - i,
                                top: o.innerHeight - n - a
                            };
                        case "top-left":
                            return {
                                left: i,
                                top: a
                            };
                        case "top-right":
                            return {
                                left: o.innerWidth - t - i,
                                top: a
                            };
                    }
                }(t, $81cb1647619a2ab5$var$ni, $81cb1647619a2ab5$var$oi, n);
                e.style.left = "".concat(r.left, "px"), e.style.top = "".concat(r.top, "px"), e.style.right = "auto", e.style.bottom = "auto";
            } else e.style.left = "".concat(t.left, "px"), e.style.top = "".concat(t.top, "px"), e.style.right = "auto", e.style.bottom = "auto";
            $81cb1647619a2ab5$var$pi(e, n) && (sessionStorage.removeItem($81cb1647619a2ab5$var$ii), o());
        } else o();
    }, e.prototype._clearDragTimer = function() {
        void 0 !== this.dragTimer && (clearTimeout(this.dragTimer), this.dragTimer = void 0);
    }, e.prototype._makeDraggable = function(e) {
        var t = this, n = this.doc.defaultView, o = 0, r = 0, i = !1, a = function() {
            e.dataset.dragging = t.dragging ? "true" : "false", e.dataset.pressing = i && !t.dragging ? "true" : "false";
        }, c = function(n, i) {
            t.dragging = !0, t.didDragInPointerCycle = !0;
            var c = e.getBoundingClientRect();
            o = n - c.left, r = i - c.top, a();
        }, s = function(i, a) {
            if (t.dragging) {
                var c = function(e) {
                    var t = e.corner, n = e.x, o = e.y;
                    switch(t){
                        case "bottom-left":
                            return {
                                bottom: o,
                                left: n
                            };
                        case "bottom-right":
                            return {
                                bottom: o,
                                right: n
                            };
                        case "top-left":
                            return {
                                left: n,
                                top: o
                            };
                        case "top-right":
                            return {
                                right: n,
                                top: o
                            };
                    }
                }($81cb1647619a2ab5$var$mi(e, a - r, i - o, n));
                e.style.left = "auto", e.style.right = "auto", e.style.top = "auto", e.style.bottom = "auto", "number" == typeof c.left && (e.style.left = "".concat(c.left, "px")), "number" == typeof c.right && (e.style.right = "".concat(c.right, "px")), "number" == typeof c.top && (e.style.top = "".concat(c.top, "px")), "number" == typeof c.bottom && (e.style.bottom = "".concat(c.bottom, "px"));
            }
        }, l = function() {
            if (t._clearDragTimer(), t.dragging) {
                if ($81cb1647619a2ab5$var$pi(e, n)) e.style.left = "".concat($81cb1647619a2ab5$var$ri, "px"), e.style.bottom = "".concat($81cb1647619a2ab5$var$ri, "px"), e.style.right = "auto", e.style.top = "auto", sessionStorage.setItem($81cb1647619a2ab5$var$ii, JSON.stringify({
                    corner: "bottom-left",
                    x: $81cb1647619a2ab5$var$ri,
                    y: $81cb1647619a2ab5$var$ri
                }));
                else {
                    var o = e.getBoundingClientRect(), r = o.left, c = o.top, s = $81cb1647619a2ab5$var$mi(e, c, r, n);
                    sessionStorage.setItem($81cb1647619a2ab5$var$ii, JSON.stringify(s));
                }
            }
            t.dragging = !1, i = !1, a();
        }, u = function(e) {
            e.preventDefault(), t.didDragInPointerCycle = !1, i = !0, a(), t.dragTimer = setTimeout(function() {
                c(e.clientX, e.clientY), t.dragTimer = void 0;
            }, 150);
        }, d = function() {
            t.dragging || (i = !1), a();
        }, f = function(e) {
            s(e.clientX, e.clientY);
        }, h = function() {
            l();
        }, v = function() {
            (i || t.dragging) && l();
        }, p = function(e) {
            if (1 === e.touches.length) {
                e.preventDefault(), t.didDragInPointerCycle = !1, i = !0, a();
                var n = e.touches[0];
                t.dragTimer = setTimeout(function() {
                    c(n.clientX, n.clientY), t.dragTimer = void 0;
                }, 150);
            }
        }, m = function(e) {
            if (1 === e.touches.length) {
                var t = e.touches[0];
                s(t.clientX, t.clientY);
            }
        }, y = function() {
            l();
        };
        return e.addEventListener("mousedown", u), e.addEventListener("mouseleave", d), this.doc.addEventListener("mousemove", f), this.doc.addEventListener("mouseup", h), n.addEventListener("blur", v), e.addEventListener("touchstart", p, {
            passive: !1
        }), this.doc.addEventListener("touchmove", m), this.doc.addEventListener("touchend", y), function() {
            t._clearDragTimer(), e.removeEventListener("mousedown", u), e.removeEventListener("mouseleave", d), t.doc.removeEventListener("mousemove", f), t.doc.removeEventListener("mouseup", h), n.removeEventListener("blur", v), e.removeEventListener("touchstart", p), t.doc.removeEventListener("touchmove", m), t.doc.removeEventListener("touchend", y);
        };
    }, e;
}(), $81cb1647619a2ab5$export$7851b0c44bc6ce90 = function() {
    function e(e) {
        var t, n, o, r, i = this;
        this.state = $81cb1647619a2ab5$var$Jr({}, $81cb1647619a2ab5$var$ui), this.remoteImg = null, this.remoteCanvas = null, this.remoteReceiver = null, this.remoteVideo = !1, this.loadingOverlay = null, this.requestButton = null, this.plusButton = null, this.stallTimer = null, this.remoteStalled = !1, this.startingCamera = !1, this.lastRemoteSrc = null, this.doc = null !== (t = e.doc) && void 0 !== t ? t : document, this.opts = e, this.widget = new $81cb1647619a2ab5$var$hi({
            doc: this.doc,
            draggable: null === (n = e.draggable) || void 0 === n || n,
            closeButtons: null === (o = e.closeButtons) || void 0 === o || o,
            className: e.className,
            onInnerX: function() {
                i.opts.onRequestOwnVideoOff();
            },
            onFlip: function() {
                i._switchCamera();
            },
            onOuterX: function() {
                i.opts.onCloseAll();
            }
        }), this.capturer = new $81cb1647619a2ab5$var$fi(this.doc, e.onFrameChange, null !== (r = e.showFrameUrlOverlay) && void 0 !== r && r, e.getProvidedStream, e.getCamera, function() {
            i._render();
        }, e.video);
    }
    return Object.defineProperty(e.prototype, "meter", {
        get: function() {
            return this.capturer.meter;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.update = function(e) {
        var t = $81cb1647619a2ab5$var$Jr($81cb1647619a2ab5$var$Jr({}, this.state), e), n = void 0 !== e.remoteFrame && e.remoteFrame !== this.state.remoteFrame, o = void 0 !== e.ownVideoOn && e.ownVideoOn !== this.state.ownVideoOn;
        this.state = t, void 0 !== e.remoteFrame && this._closeRemoteVideo(), n && (null !== t.remoteFrame ? this._startRemoteStallTimer() : this._clearRemoteStallTimer()), o && (t.ownVideoOn ? this._startCamera() : this.capturer.stop()), this._render();
    }, e.prototype.receiveRemoteVideo = function(e) {
        var t, n = this;
        null !== (t = this.remoteReceiver) && void 0 !== t || (this.remoteReceiver = new $81cb1647619a2ab5$var$xt({
            debug: function() {},
            doc: this.doc,
            onFrame: function(e) {
                n._drawRemoteFrame(e), e.close();
            },
            requestKeyframe: function() {
                var e, t;
                null === (t = (e = n.opts).onRequestRemoteKeyframe) || void 0 === t || t.call(e);
            }
        })), this.remoteReceiver.receive(e);
    }, e.prototype.requestKeyframe = function() {
        this.capturer.requestKeyframe();
    }, e.prototype.destroy = function() {
        this._closeRemoteVideo(), this.capturer.stop(), this.widget.destroy(), this._clearRemoteStallTimer(), this.state = $81cb1647619a2ab5$var$Jr({}, $81cb1647619a2ab5$var$ui), this.lastRemoteSrc = null;
    }, e.prototype._startCamera = function() {
        return $81cb1647619a2ab5$var$_r(this, void 0, void 0, function() {
            var e;
            return $81cb1647619a2ab5$var$$r(this, function(t) {
                switch(t.label){
                    case 0:
                        if (this.startingCamera || this.capturer.isRunning) return [
                            2
                        ];
                        this.startingCamera = !0, t.label = 1;
                    case 1:
                        return t.trys.push([
                            1,
                            ,
                            4,
                            5
                        ]), [
                            4,
                            this._checkCameraPermission()
                        ];
                    case 2:
                        return t.sent() ? [
                            4,
                            this.capturer.start()
                        ] : (this.opts.onUnauthorized("not_authorized"), [
                            2
                        ]);
                    case 3:
                        return "started" !== (e = t.sent()) ? (this.opts.onUnauthorized(e), [
                            2
                        ]) : (this._render(), [
                            3,
                            5
                        ]);
                    case 4:
                        return this.startingCamera = !1, [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype._switchCamera = function() {
        return $81cb1647619a2ab5$var$_r(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$$r(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.capturer.switchCamera()
                        ];
                    case 1:
                        return e.sent() ? (this._render(), [
                            2
                        ]) : (this.opts.onRequestOwnVideoOff(), [
                            2
                        ]);
                }
            });
        });
    }, e.prototype._checkCameraPermission = function() {
        return $81cb1647619a2ab5$var$_r(this, void 0, void 0, function() {
            return $81cb1647619a2ab5$var$$r(this, function(e) {
                switch(e.label){
                    case 0:
                        if (!("permissions" in navigator) || "function" != typeof navigator.permissions.query) return [
                            2,
                            !0
                        ];
                        e.label = 1;
                    case 1:
                        return e.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4,
                            navigator.permissions.query({
                                name: "camera"
                            })
                        ];
                    case 2:
                        return [
                            2,
                            "denied" !== e.sent().state
                        ];
                    case 3:
                        return e.sent(), [
                            2,
                            !0
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype._drawRemoteFrame = function(e) {
        var t, n = this._ensureRemoteCanvas();
        n.width === e.displayWidth && n.height === e.displayHeight || (n.width = e.displayWidth, n.height = e.displayHeight), null === (t = n.getContext("2d")) || void 0 === t || t.drawImage(e, 0, 0, n.width, n.height);
        var o = !this.remoteVideo || this.remoteStalled;
        this.remoteVideo = !0, this._startRemoteStallTimer(), o && this._render();
    }, e.prototype._closeRemoteVideo = function() {
        var e;
        null === (e = this.remoteReceiver) || void 0 === e || e.close(), this.remoteReceiver = null, this.remoteVideo = !1;
    }, e.prototype._render = function() {
        var e = this.remoteVideo || null !== this.state.remoteFrame;
        if (this.state.ownVideoOn || e || this.state.remoteLoading) {
            var t = e && !this.remoteStalled, n = this.state.remoteLoading || e && this.remoteStalled, o = !t && !n && this.state.canRequestRemote, r = this.state.ownVideoOn && !t && !n && !o, i = null;
            t ? i = this.remoteVideo ? this._ensureRemoteCanvas() : this._ensureRemoteImg() : n ? i = this._ensureLoadingOverlay() : o && (i = this._ensureRequestButton()), t && !this.remoteVideo && (this._ensureRemoteImg(), null !== this.state.remoteFrame && this.state.remoteFrame !== this.lastRemoteSrc && (this.remoteImg.src = this.state.remoteFrame, this.lastRemoteSrc = this.state.remoteFrame));
            var a = "hidden", c = null;
            r ? (a = "full", c = this.capturer.element) : this.state.ownVideoOn && this.capturer.element ? (a = "corner", c = this.capturer.element) : this.state.canStream && (a = "corner", c = this._ensurePlusButton()), this.widget.update({
                visible: !0,
                outerContent: i,
                inner: a,
                innerContent: c,
                showOuterX: this.state.isController,
                showInnerX: this.state.ownVideoOn,
                showFlip: this.state.ownVideoOn && this.capturer.canSwitch
            });
        } else this.widget.update({
            visible: !1,
            outerContent: null,
            inner: "hidden",
            innerContent: null,
            showOuterX: !1,
            showInnerX: !1,
            showFlip: !1
        });
    }, e.prototype._ensureRemoteImg = function() {
        if (!this.remoteImg) {
            var e = this.doc.createElement("img");
            e.className = "upscope__video__remote", this.remoteImg = e;
        }
        return this.remoteImg;
    }, e.prototype._ensureRemoteCanvas = function() {
        if (!this.remoteCanvas) {
            var e = this.doc.createElement("canvas");
            e.className = "upscope__video__remote", this.remoteCanvas = e;
        }
        return this.remoteCanvas;
    }, e.prototype._ensureLoadingOverlay = function() {
        if (!this.loadingOverlay) {
            var e = this.doc.createElement("div");
            e.className = "upscope__video__loading";
            var t = this.doc.createElement("div");
            t.className = "upscope__video__loading__spinner", t.animate([
                {
                    transform: "rotate(0deg)"
                },
                {
                    transform: "rotate(360deg)"
                }
            ], {
                duration: 900,
                iterations: 1 / 0
            }), e.appendChild(t), this.loadingOverlay = e;
        }
        return this.loadingOverlay;
    }, e.prototype._ensureRequestButton = function() {
        var e = this;
        if (!this.requestButton) {
            var t = this.doc.createElement("div");
            t.className = "upscope__video__request";
            var n = this.doc.createElement("button");
            n.type = "button", n.className = "upscope__video__request__btn", $81cb1647619a2ab5$var$di(n, function() {
                e.opts.onRequestRemoteVideo();
            }, function() {
                return e.widget.isDragging;
            }), t.appendChild(n), this.requestButton = t;
        }
        var o = this.requestButton.querySelector("button");
        return o && (o.textContent = this.opts.getI18n().requestVideo), this.requestButton;
    }, e.prototype._ensurePlusButton = function() {
        var e = this;
        if (!this.plusButton) {
            var t = this.doc.createElement("div");
            t.className = "upscope__video__plus", t.appendChild(function(e) {
                var t = e.createElementNS("http://www.w3.org/2000/svg", "svg");
                t.setAttribute("stroke", "currentColor"), t.setAttribute("fill", "none"), t.setAttribute("stroke-width", "1.5"), t.setAttribute("viewBox", "0 0 24 24"), t.setAttribute("aria-hidden", "true"), t.setAttribute("width", "20px");
                var n = e.createElementNS("http://www.w3.org/2000/svg", "path");
                return n.setAttribute("stroke-linecap", "round"), n.setAttribute("stroke-linejoin", "round"), n.setAttribute("d", "M12 4.5v15m7.5-7.5h-15"), t.appendChild(n), t;
            }(this.doc)), $81cb1647619a2ab5$var$di(t, function() {
                e.opts.onRequestOwnVideoOn();
            }, function() {
                return e.widget.isDragging;
            }), this.plusButton = t;
        }
        return this.plusButton;
    }, e.prototype._startRemoteStallTimer = function() {
        var e = this;
        this._clearRemoteStallTimer(), this.remoteStalled = !1, this.stallTimer = setTimeout(function() {
            e.stallTimer = null, e.remoteStalled = !0, e._render();
        }, 2e3);
    }, e.prototype._clearRemoteStallTimer = function() {
        null !== this.stallTimer && (clearTimeout(this.stallTimer), this.stallTimer = null), this.remoteStalled = !1;
    }, e;
}();
function $81cb1647619a2ab5$var$pi(e, t) {
    var n = e.getBoundingClientRect(), o = n.height, r = n.left, i = n.top, a = n.width;
    return i < 0 || r < 0 || i + o > t.innerHeight || r + a > t.innerWidth;
}
function $81cb1647619a2ab5$var$mi(e, t, n, o) {
    var r = e.getBoundingClientRect(), i = r.height, a = r.width, c = [
        {
            corner: "top-left",
            x: n,
            y: t
        },
        {
            corner: "top-right",
            x: o.innerWidth - n - a,
            y: t
        },
        {
            corner: "bottom-left",
            x: n,
            y: o.innerHeight - t - i
        },
        {
            corner: "bottom-right",
            x: o.innerWidth - n - a,
            y: o.innerHeight - t - i
        }
    ];
    return c.reduce(function(e, t) {
        return e.x + e.y < t.x + t.y ? e : t;
    }, c[0]);
}
var $81cb1647619a2ab5$var$yi = function() {
    return $81cb1647619a2ab5$var$yi = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $81cb1647619a2ab5$var$yi.apply(this, arguments);
}, $81cb1647619a2ab5$var$gi = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o, r, i = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
    } catch (e) {
        r = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (r) throw r.error;
        }
    }
    return a;
};
function $81cb1647619a2ab5$export$a95e7ce4f4cf3686(e) {
    var t = e.className, n = e.closeButtons, r = void 0 === n || n, a = e.draggable, s = void 0 === a || a, l = e.pipWindow, u = (0, $acw62.useRef)(null), d = $81cb1647619a2ab5$export$5269023cd97c8c79(), f = d.cameraVideo, h = d.endVideo, v = d.i18n, p = d.ownVideoOn, m = d.reportViewerVideoUnauthorized, y = d.requestCameraKeyframe, g = d.sendVideoCallFrame, w = d.setVideoMeter, b = d.toggleOwnVideo, A = d.videoRequestToVisitor, C = d.videoVisitorState, x = $81cb1647619a2ab5$export$8de61b3b61884207().listen, S = (0, $acw62.useContext)($81cb1647619a2ab5$export$9799878dee66ae0f), E = S.connections, I = S.session, k = S.videoEnabled, O = S.viewers;
    if (!v) throw new Error("VideoFrame must be rendered inside a <VideoProvider i18n={...}>.");
    var D = (0, $acw62.useRef)({
        endVideo: h,
        reportViewerVideoUnauthorized: m,
        requestCameraKeyframe: y,
        sendVideoCallFrame: g,
        toggleOwnVideo: b,
        videoRequestToVisitor: A
    });
    (0, $acw62.useEffect)(function() {
        D.current = {
            endVideo: h,
            reportViewerVideoUnauthorized: m,
            requestCameraKeyframe: y,
            sendVideoCallFrame: g,
            toggleOwnVideo: b,
            videoRequestToVisitor: A
        };
    }, [
        h,
        m,
        y,
        g,
        b,
        A
    ]);
    var z = (0, $acw62.useRef)(v);
    return (0, $acw62.useEffect)(function() {
        z.current = v;
    }, [
        v
    ]), (0, $acw62.useEffect)(function() {
        var e, n = null !== (e = null == l ? void 0 : l.document) && void 0 !== e ? e : document, o = new $81cb1647619a2ab5$export$7851b0c44bc6ce90({
            className: t,
            closeButtons: r,
            doc: n,
            draggable: s,
            getI18n: function() {
                return z.current;
            },
            onCloseAll: function() {
                var e, t;
                return null === (t = (e = D.current).endVideo) || void 0 === t ? void 0 : t.call(e);
            },
            onFrameChange: function(e) {
                var t, n;
                return null === (n = (t = D.current).sendVideoCallFrame) || void 0 === n ? void 0 : n.call(t, e);
            },
            onRequestOwnVideoOff: function() {
                var e, t;
                return null === (t = (e = D.current).toggleOwnVideo) || void 0 === t ? void 0 : t.call(e);
            },
            onRequestOwnVideoOn: function() {
                var e, t;
                return null === (t = (e = D.current).toggleOwnVideo) || void 0 === t ? void 0 : t.call(e);
            },
            onRequestRemoteKeyframe: function() {
                var e, t;
                return null === (t = (e = D.current).requestCameraKeyframe) || void 0 === t ? void 0 : t.call(e);
            },
            onRequestRemoteVideo: function() {
                var e, t;
                return null === (t = (e = D.current).videoRequestToVisitor) || void 0 === t ? void 0 : t.call(e);
            },
            onUnauthorized: function(e) {
                D.current.reportViewerVideoUnauthorized(e);
            },
            showFrameUrlOverlay: false,
            video: f
        });
        return u.current = o, function() {
            o.destroy(), u.current = null;
        };
    }, [
        f,
        t,
        r,
        s,
        l
    ]), $81cb1647619a2ab5$var$tt(E, O, function() {
        var e;
        null === (e = u.current) || void 0 === e || e.requestKeyframe();
    }), (0, $acw62.useEffect)(function() {
        var e, t, n = u.current;
        if (n) {
            var o = "ringing" === C || C.startsWith("authorizing:") || C.startsWith("active:"), r = null !== (t = null === (e = null == I ? void 0 : I.controller) || void 0 === e ? void 0 : e.includes("viewer")) && void 0 !== t && t, i = "off" === C, a = "two_way" === k || "visitor_to_viewer" === k, c = "two_way" === k || "viewer_to_visitor" === k;
            n.update($81cb1647619a2ab5$var$yi({
                canRequestRemote: r && i && a,
                canStream: c,
                isController: r,
                ownVideoOn: p,
                remoteLoading: o
            }, i ? {
                remoteFrame: null
            } : {}));
        }
    }, [
        p,
        null == I ? void 0 : I.controller,
        k,
        C
    ]), (0, $acw62.useEffect)(function() {
        if (p) {
            var e = !1, t = function() {
                var n;
                if (!e) {
                    var o = null === (n = u.current) || void 0 === n ? void 0 : n.meter;
                    o ? null == w || w(o) : requestAnimationFrame(t);
                }
            };
            return t(), function() {
                e = !0, null == w || w(null);
            };
        }
        null == w || w(null);
    }, [
        p,
        w
    ]), (0, $acw62.useEffect)(function() {
        if (x) {
            var e = function(e) {
                var t, n = $81cb1647619a2ab5$var$gi(e, 2), o = n[0], r = n[1];
                o.startsWith("cobrowsing_visitor_") && (null === (t = u.current) || void 0 === t || t.update({
                    remoteFrame: r
                }));
            }, t = function(e) {
                var t, n = $81cb1647619a2ab5$var$gi(e), o = n[0], r = n.slice(1);
                o.startsWith("cobrowsing_visitor_") && (null === (t = u.current) || void 0 === t || t.receiveRemoteVideo(r));
            }, n = function(e) {
                var t;
                "camera" === e && (null === (t = u.current) || void 0 === t || t.requestKeyframe());
            }, o = x("videoCallFrame", e).on("cameraVideo", t).on("requestKeyframe", n);
            return function() {
                o.off("videoCallFrame", e).off("cameraVideo", t).off("requestKeyframe", n);
            };
        }
    }, [
        x
    ]), null;
}



var $acw62 = parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $aACZr = parcelRequire("aACZr");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $dtKoB = parcelRequire("dtKoB");

var $cSimh = parcelRequire("cSimh");

var $gQFmB = parcelRequire("gQFmB");
function $1d14ce0882f62e2d$export$2e2bcd8739ae039({ length: length, onChange: onChange, title: title, subTitle: subTitle }) {
    length ??= 6;
    const [sessionCode, setSessionCode] = (0, $acw62.useState)("");
    const onSessionCodeChange = (e)=>{
        const sessionCode = e.target.value.replace(/[^\d]/g, "").slice(0, length);
        setSessionCode(sessionCode);
    };
    (0, $acw62.useEffect)(()=>{
        if (sessionCode.length !== length) return;
        onChange(sessionCode);
    }, [
        sessionCode,
        onChange,
        length
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gQFmB.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQFmB.default).Title, {
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: subTitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQFmB.default).Footer, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cSimh.default), {
                    className: "text-center text-lg",
                    value: sessionCode,
                    onChange: onSessionCodeChange,
                    placeholder: (0, $dtKoB.default)("%{length}-digit access code", {
                        length: length
                    }),
                    autoFocus: true
                })
            })
        ]
    });
}



var $iL5oi = parcelRequire("iL5oi");

var $jFdmN = parcelRequire("jFdmN");

var $gQFmB = parcelRequire("gQFmB");

var $dtKoB = parcelRequire("dtKoB");

var $jW3HH = parcelRequire("jW3HH");

var $ebuIP = parcelRequire("ebuIP");

var $1PKHz = parcelRequire("1PKHz");

var $5aE2v = parcelRequire("5aE2v");

var $hW7sX = parcelRequire("hW7sX");
const $1786cf0087f5aeff$var$subdomain = location.hostname.split(".")[0];
const $1786cf0087f5aeff$var$accessCode = location.pathname.slice(1) || null;
const $1786cf0087f5aeff$var$canRotate = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || localStorage.getItem("rotate_test") === "true";
if ($1786cf0087f5aeff$var$accessCode && !$1786cf0087f5aeff$var$accessCode.match(/^\d+$/)) location.href = "/";
{
    const errorLogger = (0, $jW3HH.default)("app:errors");
    (0, $jW3HH.setLoggerContext)({
        accessCode: $1786cf0087f5aeff$var$accessCode,
        subdomain: $1786cf0087f5aeff$var$subdomain
    });
    $cA8mQ.init({
        beforeSend: (event, hint)=>{
            const error = hint.originalException ?? hint.syntheticException ?? event.message;
            if (error) errorLogger("%O", error);
            return event;
        },
        dsn: "https://7a39720e837da4dd86d7488c4b521aef@o73137.ingest.us.sentry.io/4512263967997952",
        environment: "production",
        maxValueLength: 2500,
        release: `helloscreen-frontend@${"2026.10.7"}`
    });
    const loggersByNamespace = {};
    window.__log = (level, namespace, message, ...args)=>{
        loggersByNamespace[namespace] ??= (0, $jW3HH.default)(`helloscreen:publicLink:${namespace}`);
        switch(level){
            case "info":
                loggersByNamespace[namespace](message, ...args);
                break;
            case "warn":
                loggersByNamespace[namespace].warning(message, ...args);
                break;
        }
    };
}window.reload = ()=>{
    sessionStorage.setItem("reload", "true");
    location.reload();
};
function $1786cf0087f5aeff$var$PublicLinkAccess({ accessCode: accessCode }) {
    (0, $aACZr.default)("HelloScreen");
    const [error, setError] = (0, $acw62.useState)();
    const [hasEnded, setHasEnded] = (0, $acw62.useState)(false);
    const { endpoint: endpoint, isLoading: isLoading, region: region, shortId: shortId, token: token } = (0, $hW7sX.useApiData)("hs.publicLink.sessions.create", {
        accessCode: accessCode,
        subdomain: $1786cf0087f5aeff$var$subdomain
    }, {
        onError: ({ error: error })=>{
            setError(error);
        },
        refreshStale: false
    });
    const onAccessCode = (0, $acw62.useCallback)((code)=>{
        location.pathname = `/${code}`;
    }, []);
    if (error === "access_code_needed") return /*#__PURE__*/ (0, $ayMG0.jsx)($1786cf0087f5aeff$var$AccessCode, {
        notFound: false,
        onAccessCode: onAccessCode
    });
    if (error === "invalid_access_code") return /*#__PURE__*/ (0, $ayMG0.jsx)($1786cf0087f5aeff$var$AccessCode, {
        notFound: true,
        onAccessCode: onAccessCode
    });
    if (error === "invalid_subdomain") return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gQFmB.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQFmB.default).Title, {
                children: (0, $dtKoB.default)("Incorrect link")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: (0, $dtKoB.default)("The link you entered does not look correct. Please check and try again.")
            })
        ]
    });
    if (error === "user_not_online") return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gQFmB.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQFmB.default).Title, {
                children: (0, $dtKoB.default)("Not online")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: (0, $dtKoB.default)("The link you entered does not have an active presentation. Please try again later.")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQFmB.default).Footer, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iL5oi.default), {
                    onClick: ()=>{
                        window.reload();
                    },
                    variant: "action",
                    children: (0, $dtKoB.default)("Try again")
                })
            })
        ]
    });
    undefined;
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jFdmN.default), {});
    if (hasEnded) return /*#__PURE__*/ (0, $ayMG0.jsx)($1786cf0087f5aeff$var$RenderOnEnded, {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81cb1647619a2ab5$export$4763f1e07d062006), {
        endpoint: endpoint,
        idleDisconnectSeconds: null,
        region: region,
        shortId: shortId,
        token: token,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81cb1647619a2ab5$export$631ffd47cd58e706), {
            i18n: {
                requestVideo: (0, $dtKoB.default)("Request video")
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($1786cf0087f5aeff$var$PublicLinkViewer, {
                setHasEnded: setHasEnded
            })
        })
    });
}
function $1786cf0087f5aeff$var$PublicLinkViewer({ setHasEnded: setHasEnded }) {
    const { height: height, width: width } = (0, $82f7M.useWindowSize)();
    const { connected: connected, listen: listen, loadingStagesLeft: loadingStagesLeft, sendCustomMessage: sendCustomMessage, sessionStatus: sessionStatus } = (0, $81cb1647619a2ab5$export$8de61b3b61884207)();
    const { size: size } = (0, $81cb1647619a2ab5$export$ebb76798b919a705)();
    const { height: divHeight, width: divWidth } = size || {
        height: 0,
        width: 0
    };
    const { openModal: openModal } = (0, $5aE2v.useModal)();
    const onVideoRinging = (0, $acw62.useCallback)((accept)=>{
        return openModal({
            cancelText: (0, $dtKoB.default)("Refuse"),
            confirmText: (0, $dtKoB.default)("Accept"),
            content: (0, $dtKoB.default)("The presenter wants to start a video call. Do you want to accept?"),
            onClick: (option)=>{
                accept(option);
            },
            title: (0, $dtKoB.default)("Incoming video call"),
            type: "info"
        });
    }, [
        openModal
    ]);
    const viewerPortrait = height > width;
    const contentLandscape = divWidth > divHeight;
    const hasValidSize = divWidth > 0 && divHeight > 0;
    const [rotationState, setRotationState] = (0, $acw62.useState)("pending");
    const [allLandscape, setAllLandscape] = (0, $acw62.useState)(undefined);
    const shouldRotate = rotationState === "rotated";
    // Send offer when conditions are first met
    const offerSentRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!hasValidSize || offerSentRef.current) return;
        if (!$1786cf0087f5aeff$var$canRotate || !viewerPortrait || !contentLandscape) {
            setRotationState("normal");
            return;
        }
        offerSentRef.current = true;
        setRotationState("offered");
        sendCustomMessage({
            state: "offer",
            type: "rotateState"
        });
    }, [
        hasValidSize,
        viewerPortrait,
        contentLandscape,
        sendCustomMessage
    ]);
    // Listen for allLandscape broadcast from sharer
    (0, $acw62.useEffect)(()=>{
        if (!listen) return;
        listen("customMessage", ([_from, message])=>{
            if (typeof message.allLandscape === "boolean") setAllLandscape(message.allLandscape);
        });
    }, [
        listen
    ]);
    // Rotate when allLandscape=true AND we offered
    (0, $acw62.useEffect)(()=>{
        if (rotationState !== "offered" || allLandscape !== true) return;
        setRotationState("rotated");
        sendCustomMessage({
            state: "rotated",
            type: "rotateState"
        });
    }, [
        rotationState,
        allLandscape,
        sendCustomMessage
    ]);
    // Unrotate if user physically rotates device to landscape
    (0, $acw62.useEffect)(()=>{
        if (rotationState !== "rotated" || viewerPortrait) return;
        setRotationState("normal");
        sendCustomMessage({
            state: "normal",
            type: "rotateState"
        });
    }, [
        rotationState,
        viewerPortrait,
        sendCustomMessage
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!connected || sessionStatus) return;
        setHasEnded(true);
    }, [
        connected,
        sessionStatus,
        setHasEnded
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            loadingStagesLeft.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jFdmN.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81cb1647619a2ab5$export$742905d5f12f43b5), {
                onVideoRinging: onVideoRinging
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81cb1647619a2ab5$export$a95e7ce4f4cf3686), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "shadow-multi overflow-hidden rounded dark:border dark:border-slate-700",
                style: {
                    height: `${shouldRotate ? divWidth : divHeight}px`,
                    opacity: loadingStagesLeft.length > 0 ? 0 : 1,
                    position: loadingStagesLeft.length > 0 ? "absolute" : "relative",
                    width: `${shouldRotate ? divHeight : divWidth}px`
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "origin-top-right transition-transform",
                    style: shouldRotate ? {
                        left: "100%",
                        position: "absolute",
                        top: "0",
                        transform: "rotate(90deg) translate(-50%, -50%)"
                    } : undefined,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81cb1647619a2ab5$export$7c6e2c02157bb7d2), {
                        activeConnectionId: undefined,
                        color: "red",
                        controlTool: "cursor",
                        maxHeight: (shouldRotate ? width : height) - 20,
                        maxWidth: (shouldRotate ? height : width) - 20
                    })
                })
            })
        ]
    });
}
(0, $dtKoB.initI18n)(navigator.language).then(()=>{
    const root = (0, $aRPiL.createRoot)(document.querySelector("#root"));
    root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebuIP.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1PKHz.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5aE2v.ModalProvider), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex h-screen w-full flex-1 touch-none select-none items-center justify-center text-center",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($1786cf0087f5aeff$var$PublicLinkAccess, {
                        accessCode: $1786cf0087f5aeff$var$accessCode
                    })
                })
            })
        })
    }));
});
function $1786cf0087f5aeff$var$AccessCode({ notFound: notFound, onAccessCode: onAccessCode }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d14ce0882f62e2d$export$2e2bcd8739ae039), {
        onChange: onAccessCode,
        subTitle: notFound ? (0, $dtKoB.default)("Unable to find a session. Please, enter a session code to start a new session.") : (0, $dtKoB.default)("Please enter the code the agent gives you to get started."),
        title: notFound ? (0, $dtKoB.default)("Oops! Session Not Found!") : (0, $dtKoB.default)("Please enter access code")
    });
}
function $1786cf0087f5aeff$var$RenderOnEnded() {
    (0, $acw62.useEffect)(()=>{
        window.close();
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gQFmB.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gQFmB.default).Title, {
                children: (0, $dtKoB.default)("The session has now ended!")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: (0, $dtKoB.default)("Thank you for using HelloScreen.")
            })
        ]
    });
}


//# sourceMappingURL=helloscreen-subdomain.45432547.js.map
